import { NOOP, InfiniteScrollV2, V2, Icon, useTranslation, Filters, DndProvider, HTML5Backend, Tree, ToolTip, Empty, toastify, Spinner, Input, DropDownWithSearchAndPagination, TruncatedText, escapeRegExp, TestCaseResultReader, DropdownButton, DropdownItem, AutoComplete, TextArea, Checkbox, Button, __, Accordion, Modal, ImageViewer, SecondaryButton, Note, Expandable, DrawRectanglesOverImage, DownloadImageBtn, DonutChart, isAllowedAppTypeForHighlight, isStepAddon, hasStepValidXpath, Drawer, DrawerItem, useInternalEvents, RadioGroup, Radio, AutoResizingDebouncedInput, useInputTextValidationSchema, yup, ShimmerLoader, useDebounce, useHighlight, ChipInput, Column, MultiSelect, MultiSelectItem, getOrigin, Table, TableHeader, TableRow, TableCell, TableBody, PrimaryButton, bindActions, InfiniteScroll, generateUniqueId, usePopper, Dropdown, DurationFormat, If, DangerButton, ARIA_LABELS, ErrorToolTip, DynamicValueInput, convertValueToBlock, useToggle, useAnimatedClass, Popover, blocksToText as blocksToText$1, wrapWithTemplate, Label, usePrevious, Unless, DebouncedSearchInput, Divider, InputWithCheckbox, useClickOutside, Calendar } from '@testsigma/atoms';
import { PrivateURLConstants, AutoHealStatus, AutoHealType, StepTypeUI, ResultConstant, APIStepFormKeyType, ApplicationType, SIZE, COLOR, StepLevelScreenshot, STEP_FLAG, RECORDER_APPLICATION_TYPE, STEP_TYPE, CLIENT_EVENT, Integration, LOG, TestStepPriority, RECORDER_STATE, RECORDER_ACTION, DEFAULT_LOCATOR_PRECEDENCE, STEP_PRIORITY, TestPlanLabType, PREFERENCE_TYPE, RECORDER_TYPE, MESSAGE_CONTEXT_ACTION, MESSAGE_CONTEXT, TestStepElementType, FieldDefinitionDetailsType, EntityType, ElementIdentifierLocatorType, TestStepType, TestStepConditionType, ElementIdentifierHostType, stepTypeI18nKeys, TestDataType, KibbutzParameterType, VERIFY_STATUS, Feature, nlpTemplateVsFeatureMapping, ResultIconConstant, BrowserName, OperatingSystem, Screenshot, ExecutionEntityType, WEB_NAVIGATE_NLP_TEMPLATE, SALESFORCE_LOGIN_NLP_TEMPLATE, RECORDER_SOURCE, NLP_BLOCK_TYPE, WIDGET_VIEW, DESKTOP_RECORDER_ACTION_RESPONSES, IMAGE_SUPPORTED_NLPS_MAP, CHROME_EVENT, TEMPLATE_DISPLAY_NAME, COPILOT_MESSAGE_TYPE, COPILOT_STATE, DEBUGGER_COMMANDS, DESKTOP_RECORDER_ACTION_TYPES, REFRESH_VISIBILITY_DELAY, CUSTOM_EVENT, ERROR_CODE, INTERNAL_EVENTS, OPTIONAL_TEMPLATES_LIMIT, StepResultType, EntityCreateType, NLPTemplateType, TEST_DATA_TYPES, dataTypeList, DEBUGGER_ACTION, KEY_EVENT, INPUT_TAGS, TAG_NAME, COPILOT_ACTION, STEPS_PAGE_SIZE, TOAST_TYPE, Preference, AccessibilityTestingType, STEP_LOCATOR, TEST_STEP_PAGE_SIZE, SOURCE, DEFAULT_STEP_WAIT_TIME, IDENTIFIER, STEP_CONDITION_TYPE, TEST_DATA, TEST_DATA_PLAINTEXT, TEST_DATA_UPLOAD, SalesforceObjectFieldType, EVENT_SOURCE, TEST_DATA_RUNTIME, TEST_DATA_PHONE_NUMBER, TEST_DATA_ENVIRONMENT, TEST_DATA_MAILBOX, TEST_DATA_DATAPROFILE, TEST_DATA_FUNCTION, DrawerActionResult, ELEMENT_CONTEXT_TYPE, IDENTIFIER_LOCATOR_TYPES, HOSTS_LOCATOR_TYPES, UPLOAD_NAME_MAX_LEN, ACTION_PARAM_TYPES, IDENTIFIER_FILTER_BY, ElementIdentifierCreateType, TestDataOverRideType, PREFERENCE, SPEICAL_CHAR_REGEX, FOR_LOOP_STEP, CONDITION_STEP_TYPES, SearchOperator, EXCLUDE_CONFIG, FOR_LOOP_TEMPLATE_TYPE, FOR_LOOP_TEST_DATA, ATTRIBUTE, FOR_LOOP_TEST_DATA_MAPPER, NUMBER_REGEX, TEST_DATA_RANDOM, ElementIdentifierStatus } from '@testsigmainc/constants';
import { TestCase, Pageable, QTestProject, MantisIssueModel, MantisProjectModel, BugzillaProjectModel, AzureProjectModel, MondayIssueModel, MondayUserModel, MondayProjectModel, ClickUpTaskModel, ClickUpTeamModel, ClickUpSpaceModel, ClickUpListModel, ClickUpFolderModel, LinearTeamProjectModel, LinearTeamIssueModel, LinearTeamModel, BacklogPriorityModel, BacklogIssueModel, BacklogIssueTypeModel, BacklogProjectModel, YouTrackIssueModel, YouTrackProjectModel, TrelloIssueModel, TrelloIssueTypeModel, TrelloProjectModel, JiraSearchIssueModel, AzureIssueModel, AzureIssueTypeDefaultWorkItemTypeModel, Page, ExternalApplicationConfig, EntityExternalMapping, JiraProject, JiraAssignee, TestStep, StepElementRequest, ForLoopCondition, AutoHealedElement, Template, AlgoliaTemplate, TestStepResultModel, TestDataMapValue, KibbutzNlp, TestCaseResult, ElementIdentifier, CustomStep, StepDetailsDataMap, KibbutzNLPDataModel, ExternalMappingModel, DataGeneratorArguments, TestStepTestDataFunction, UploadVersion, TestStepBulkUpdateRequest, KibbutzUiIdentifierData, KibbutzTestStepTestData, KibbutzTestDataProfile, KibbutzTestDataSet, KibbutzEnvironmentData, ElementIdentifierOverridden, TestStepDataOverRiddenMapping, ForLoopOverRidden, UploadVersionData } from '@testsigmainc/models';
import * as React5 from 'react';
import React5__default, { createContext, memo, useState, useEffect, forwardRef, useCallback, useRef, useMemo, useContext, Fragment as Fragment$1, createElement, useReducer, useLayoutEffect, Suspense } from 'react';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import classNames82 from 'classnames';
import { AiOutlineLoading3Quarters, AiOutlineArrowLeft } from 'react-icons/ai';
import { isEqual } from 'es-toolkit/predicate';
import { cloneDeep as cloneDeep$1 } from 'es-toolkit/object';
import { Client } from 'typesense';
import { createSlice, createSelector, bindActionCreators } from '@reduxjs/toolkit';
import { union, cloneDeep, debounce as debounce$1, uniq, groupBy, partition, pick } from 'es-toolkit';
import { union as union$1, debounce as debounce$2, get as get$1, isEqual as isEqual$1, find as find$1, omit, map as map$1, size, partition as partition$2, findLastIndex } from 'es-toolkit/compat';
import { useDispatch, useSelector } from 'react-redux';
import { Subject, filter, switchMap, of, take, timer, map, race, merge, mergeMap, delay, concatMap } from 'rxjs';
import { QueryClient as QueryClient$1, QueryClientProvider as QueryClientProvider$1, useQuery as useQuery$1, useQueryClient as useQueryClient$1, useMutation, useInfiniteQuery } from 'react-query';
import { Rnd } from 'react-rnd';
import { partition as partition$1 } from 'es-toolkit/array';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import noDataPane from '@images/no-data-pane.svg';
import ReactDOM, { createPortal } from 'react-dom';
import { v4 } from 'uuid';
import autoHealSuccess from '@images/auto-heal-success.svg';
import autoHealFailure from '@images/auto-heal-failure.svg';
import deepDiff from 'deep-diff';
import { debounce, throttle } from 'es-toolkit/function';
import testSigmaLogoDark from '@images/logo-icon-dark.svg';
import { QueryClient, QueryClientProvider, useQueryClient, useQuery, useInfiniteQuery as useInfiniteQuery$1 } from '@tanstack/react-query';
import dayjs2 from 'dayjs';
import axios from 'axios';
import { Dialog, Alert, Button as Button$1, FormControl, InputLabel, Select, MenuItem, FormGroup, FormControlLabel, Checkbox as Checkbox$1 } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import AlertTitle from '@mui/material/AlertTitle';
import Tooltip from '@mui/material/Tooltip';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { FaInfoCircle } from 'react-icons/fa';
import TextField from '@mui/material/TextField';
import noData from '@images/no-data.svg';
import { useReactTable, getCoreRowModel, flexRender } from '@tanstack/react-table';
export { DOMInspector, DOMNodePreview, Inspector, LocatableNodePreview, ObjectInspector, ObjectLabel, ObjectName, ObjectPreview, ObjectRootLabel, ObjectValue, TSDOMNodePreview, TableInspector, TreeNode, TreeView } from '@testsigmainc/react-inspector';

var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var ChromeInfoNote = ({
  isChrome,
  recordBtn,
  isFirefox,
  isEdge
}) => {
  const { t } = useTranslation();
  const getInfoNote = () => {
    if (isEdge) {
      return t("element.recorder.use_extension.message", {
        browserName: "Edge"
      });
    } else if (isFirefox) {
      return t("element.recorder.use_extension.message", {
        browserName: "Firefox"
      });
    } else if (isChrome) {
      return t("element.recorder.use_extension.message", {
        browserName: "Chrome"
      });
    } else {
      return t(
        "element.recorder.use_extension.not_available_inthis_browser.message"
      );
    }
  };
  return /* @__PURE__ */ jsxs("div", { className: "col-span-2 flex items-center gap-x-4", children: [
    !!recordBtn && recordBtn,
    /* @__PURE__ */ jsx("div", { className: "flex items-center gap-x-2", children: /* @__PURE__ */ jsxs("div", { className: " text-2xs font-semibold leading-3 text-unique-600", children: [
      /* @__PURE__ */ jsx("span", { children: getInfoNote() }),
      /* @__PURE__ */ jsx(
        "a",
        {
          className: "text-primary-600",
          href: "https://testsigma.com/docs/elements/web-apps/record-multiple-elements/",
          target: "_blank",
          rel: "noreferrer",
          children: t("common.record.elements")
        }
      ),
      /* @__PURE__ */ jsx("span", { children: t("elemnet.recorder.manually") })
    ] }) })
  ] });
};
var getStatusMessage = (status) => {
  switch (status) {
    case VERIFY_STATUS.NOT_EXIST:
      return __("element.verify.not_exist");
    case VERIFY_STATUS.INVALID_XPATH:
      return __("element.verify.invalid_xpath");
    case VERIFY_STATUS.VALIDATING:
      return __("element.verify.validating");
    case VERIFY_STATUS.FOUND:
      return __("element.verify.found");
    default:
      return "";
  }
};
var VerifyStatusDisplay = ({
  verifyStatus
}) => {
  if (!verifyStatus) {
    return null;
  }
  const statusMessage = getStatusMessage(verifyStatus);
  return /* @__PURE__ */ jsx(
    "span",
    {
      className: classNames82("font-semibold text-small", {
        "text-error-600": verifyStatus === VERIFY_STATUS.NOT_EXIST || verifyStatus === VERIFY_STATUS.INVALID_XPATH,
        "text-secondary-800": verifyStatus === VERIFY_STATUS.VALIDATING || verifyStatus === VERIFY_STATUS.FOUND
      }),
      children: statusMessage
    }
  );
};
var canShowAutoHealCheckBox = (applicationType, hasFeature) => {
  return (applicationType === ApplicationType.AndroidNative || applicationType === ApplicationType.IOSNative || applicationType === ApplicationType.Salesforce || applicationType === ApplicationType.WebApplication) && hasFeature(Feature.AUTO_HEALING);
};
var getAutoHealedElement = (stepResult, elementKey) => {
  const rawHealedElement = stepResult?.autoHealMetadata?.healedElements?.get(
    elementKey || "ui-identifier"
  );
  const autoHealedElement = new AutoHealedElement().deserialize({
    ...rawHealedElement || {}
  }) || new AutoHealedElement();
  const element = stepResult?.fieldDefinitionDetails[elementKey || "ui-identifier"]?.uiIdentifierEntity;
  autoHealedElement.name = element?.name;
  if (!autoHealedElement.status) {
    autoHealedElement.status = stepResult?.result === ResultConstant.SUCCESS ? AutoHealStatus.SUCCESS : AutoHealStatus.FAILURE;
  }
  if (autoHealedElement.elementId) {
    return autoHealedElement;
  }
  autoHealedElement.elementId = element?.id;
  autoHealedElement.healedLocatorValue = stepResult?.selfHealMetadata?.priorityXpaths?.[0];
  autoHealedElement.healedLocatorType = ElementIdentifierLocatorType.xpath;
  autoHealedElement.originalLocatorValue = element?.definition;
  autoHealedElement.originalLocatorType = element?.locatorType;
  return autoHealedElement;
};
var getElementHostTypeI18nKey = (type) => `element.host.type.${type}`;
var getElementTypeI18nKey = (type = ElementIdentifierLocatorType.xpath) => `element.locator_type.${type}`;
var ElementImageViewer = ({
  src,
  errorText,
  updateImageState = null
}) => {
  const { t } = useTranslation();
  const [state, updateState] = useState(
    "loading"
  );
  useEffect(() => updateImageState?.(!src ? "failed" : state), [state, src]);
  if (!src) return errorText;
  return state == "failed" ? errorText : /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      ImageViewer,
      {
        src,
        enablePageFullScreen: true,
        onError: () => updateState("failed"),
        onLoad: () => updateState("done")
      }
    ),
    state != "done" && t("common.loading")
  ] });
};
var ElementImage = ({
  localImageUrls,
  isLoading,
  isSubmited = false
}) => {
  const [imageState, updateImageState] = useState("loading");
  const { t } = useTranslation();
  const hasError = imageState == "failed" && isSubmited;
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col relative", children: [
    /* @__PURE__ */ jsx("div", { className: "flex font-medium text-xs mb-1", children: /* @__PURE__ */ jsxs("div", { className: "flex-grow flex text-secondary-500", children: [
      t("element.screenshot"),
      " ",
      /* @__PURE__ */ jsx("span", { className: "text-error-500 ml-1", children: "*" }),
      hasError && /* @__PURE__ */ jsx("div", { className: "flex-grow text-right text-error-500", children: t("data_generator.empty_input_error", {
        argumentDisplayName: ""
      }) })
    ] }) }),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames82([
          "p-1 w-full flex bg-secondary-50 min-h-[56px] rounded text-secondary-400",
          "font-medium items-center justify-center text-xs border border-transparent",
          { "!border-red-300": hasError }
        ]),
        children: [
          !isLoading && /* @__PURE__ */ jsx(
            ElementImageViewer,
            {
              src: localImageUrls?.elementScreenshot,
              errorText: t("element.image.noimage"),
              updateImageState
            }
          ),
          isLoading && /* @__PURE__ */ jsx("span", { className: "flex justify-center items-center h-5 w-full", children: /* @__PURE__ */ jsx("div", { className: "empty-page-loader" }) })
        ]
      }
    )
  ] });
};
var ElementFullImage = ({
  localImageUrls,
  isLoading
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col relative", children: [
    /* @__PURE__ */ jsx("div", { className: "flex font-medium text-xs mb-1", children: /* @__PURE__ */ jsx("div", { className: "flex-grow flex text-secondary-500", children: t("element.image.on.fullscreen") }) }),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames82([
          "p-1 w-full flex bg-secondary-50 min-h-[56px] rounded text-secondary-400",
          "font-medium items-center justify-center text-xs"
        ]),
        children: [
          !isLoading && /* @__PURE__ */ jsx(
            ElementImageViewer,
            {
              src: localImageUrls?.elementHighlightedPageScreenshot,
              errorText: t("element.image.noimage")
            }
          ),
          isLoading && /* @__PURE__ */ jsx("span", { className: "flex justify-center items-center h-5 w-full", children: /* @__PURE__ */ jsx("div", { className: "empty-page-loader" }) })
        ]
      }
    )
  ] });
};
var ElementScreenshotFields = ({
  occurance,
  handleOccuranceChange,
  occuranceErrorText,
  elementUuid,
  getElementImageUploadUrls: getElementImageUploadUrls2,
  isReadOnly = false,
  localImages = null,
  isSubmited = false
}) => {
  const [localImageUrls, updateLocalImageUrl] = useState(localImages);
  const [isLoading, updateLoading] = useState(false);
  const { t } = useTranslation();
  useEffect(() => {
    (async () => {
      try {
        if (elementUuid) {
          updateLoading(true);
          const uploadUrls = await getElementImageUploadUrls2(elementUuid);
          const urlMap = Object.keys(uploadUrls).reduce((prev, cur) => {
            prev[cur.replace("PresignedUrl", "")] = uploadUrls[cur];
            return prev;
          }, {});
          updateLocalImageUrl(urlMap);
          updateLoading(false);
        }
      } catch (e) {
        updateLoading(false);
      }
    })();
  }, []);
  useEffect(() => {
    updateLocalImageUrl(localImages);
  }, [localImages]);
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-5 col-span-2", children: [
    /* @__PURE__ */ jsx(
      ElementImage,
      {
        localImageUrls,
        isLoading,
        isSubmited
      }
    ),
    /* @__PURE__ */ jsx(
      Input,
      {
        hasError: occuranceErrorText !== "",
        errorText: occuranceErrorText,
        label: t("element.image.occurance"),
        wrapperClassName: "w-1/2",
        isRequired: true,
        value: String(occurance),
        onChange: (value) => handleOccuranceChange(Number(value)),
        type: "number",
        isReadOnly
      }
    ),
    localImageUrls && /* @__PURE__ */ jsx(
      ElementFullImage,
      {
        localImageUrls,
        isLoading
      }
    )
  ] });
};
var hasShadowHostType = (objects) => {
  if (!objects) {
    return false;
  } else {
    for (const obj of objects) {
      if (obj?.hostType === ElementIdentifierHostType.SHADOW) {
        return true;
      }
    }
    return false;
  }
};
var FormData2 = ({
  isSubmited,
  actions,
  values,
  screenNames,
  elementLocatorType,
  screenshot,
  getElementImageUploadUrls: getElementImageUploadUrls2,
  customElementScreenShotFields = null,
  restrictedLocatorTypes = [],
  occuranceErrorText,
  updateOccuranceErrorText,
  isRecorderView
}) => {
  const { t } = useTranslation();
  const isImageType = values?.locatorType?.toLowerCase() == ElementIdentifierLocatorType.IMAGE.toLowerCase();
  const [selectedScreenName, setSelectedScreenName] = useState({});
  useEffect(() => {
    if (values?.["screenNameObj"]?.id) {
      setSelectedScreenName({
        label: values["screenNameObj"].name,
        id: values["screenNameObj"].id,
        disabled: values["screenNameObj"].disabled
      });
    } else if (values?.["screenNameId"]) {
      const valuesScreenName = screenNames.find(
        (screenName) => screenName.id === values["screenNameId"]
      );
      setSelectedScreenName({
        label: valuesScreenName?.name,
        id: valuesScreenName?.id,
        disabled: false
      });
    } else if (values?.["screenName"]) {
      setSelectedScreenName({
        label: values["screenName"],
        id: values["screenName"],
        disabled: false
      });
    } else if (values?.["screenNameId"] === "") {
      setSelectedScreenName({
        label: "",
        id: "",
        disabled: false
      });
    }
  }, [values, screenNames]);
  const isShadowHost = useMemo(
    () => values["isInsideHosts"] && hasShadowHostType(values["hostElements"]),
    [values]
  );
  const isNewItemError = (value) => {
    const isNameLengthSmall = value.label?.length < 4;
    const isNameLengthMax = value.label?.length > 250;
    return isNameLengthSmall || isNameLengthMax;
  };
  const handleSelect = useCallback(
    (args) => {
      if (args?.isNew && isNewItemError(args)) {
        actions.onScreenNameIdChange(null);
        return;
      }
      actions.onScreenNameIdChange(args);
    },
    [actions.onScreenNameIdChange]
  );
  return /* @__PURE__ */ jsxs("div", { className: "col-span-2 grid grid-cols-2 gap-y-6 gap-x-4 w-full", children: [
    /* @__PURE__ */ jsx("div", { className: "col-span-2", children: /* @__PURE__ */ jsx(
      Input,
      {
        hasError: isSubmited ? !!actions.validateName(values["name"]) : false,
        errorText: isSubmited ? actions.validateName(values["name"]) : "",
        label: t("label.name"),
        wrapperClassName: "w-full",
        isRequired: true,
        value: values["name"],
        onChange: (value) => actions.onNameChange(value),
        preventDefaultValue: true
      }
    ) }),
    !values?.technology && /* @__PURE__ */ jsx("div", { className: "row-start-2", children: /* @__PURE__ */ jsx(
      AutoComplete,
      {
        isRequired: true,
        LoadingContent: /* @__PURE__ */ jsx(DropdownItem, { isSelected: false, children: t("common.screenname.loading") }),
        optionsHook: actions.screenNameOptionsHook,
        onSelect: handleSelect,
        value: selectedScreenName,
        showClearButton: false,
        inputClassName: "bg-secondary-50",
        inputContainerClassName: "!bg-secondary-50",
        label: t("elements.screen-name.label"),
        labelClassName: "!text-secondary-500 !text-xs !font-medium !p-1",
        dropdownClass: "max-h-64 !overflow-auto",
        CustomItemWrapper: ({ value }) => {
          return /* @__PURE__ */ jsxs(
            "div",
            {
              className: classNames82("flex gap-y-1 items-center flex-col", {
                "pointer-events-none": isNewItemError(value)
              }),
              children: [
                Boolean(value.errorData !== "true") && /* @__PURE__ */ jsxs("div", { className: "flex gapx-x-2 items-center w-full", children: [
                  /* @__PURE__ */ jsx(TruncatedText, { value: value.label, watchMouseLeave: true }),
                  !!value?.isNew && /* @__PURE__ */ jsx(
                    Button,
                    {
                      type: "primary",
                      size: "sm",
                      className: "shrink-0",
                      isDisabled: isNewItemError(value),
                      children: "+ Add"
                    }
                  )
                ] }),
                (!!value?.isNew && !!isNewItemError(value) || Boolean(value.errorData === "true")) && /* @__PURE__ */ jsx("div", { className: "text-red-500", children: t(
                  value.label.length < 4 ? "common.form.validation.minlength" : "common.form.validation.maxlength",
                  {
                    fieldName: t("label.element_screen_name"),
                    minLength: 4,
                    maxLength: 250
                  }
                ) })
              ]
            }
          );
        },
        selectOnClickOutside: true,
        errorText: isSubmited ? actions.validateScreenNameId(
          values["screenNameId"] || values["screenName"]
        ) : "",
        emptyContent: /* @__PURE__ */ jsx(DropdownItem, { isSelected: false, children: t("element.no_screen_name.available") })
      },
      selectedScreenName?.id
    ) }),
    !values?.technology && /* @__PURE__ */ jsx("div", { className: "row-start-2", children: /* @__PURE__ */ jsx(
      DropdownButton,
      {
        name: values?.["locatorType"] ? t(getElementTypeI18nKey(values["locatorType"])) : "",
        placement: "bottom-start",
        label: t("elements.filter_form.field.element_type.label"),
        disabled: isShadowHost,
        children: elementLocatorType.map((locatorType) => {
          const isSelected = values["locatorType"] === locatorType;
          const isNotSupported = restrictedLocatorTypes.map((i) => i?.toLocaleLowerCase?.() ?? "").includes(
            locatorType.toLocaleLowerCase()
          );
          return /* @__PURE__ */ jsx(
            DropdownItem,
            {
              isDisabled: isNotSupported,
              onClick: () => actions.onLocatorChange(locatorType),
              isSelected,
              children: /* @__PURE__ */ jsx(
                ToolTip,
                {
                  content: isNotSupported && t("element_type.notsupported"),
                  children: /* @__PURE__ */ jsxs("div", { className: "flex justify-between items-center", children: [
                    /* @__PURE__ */ jsx("span", { children: t(
                      getElementTypeI18nKey(
                        locatorType
                      )
                    ) }),
                    locatorType.toLowerCase() == ElementIdentifierLocatorType.IMAGE.toLowerCase() && /* @__PURE__ */ jsx(
                      Icon,
                      {
                        name: "deployed-code-alert",
                        className: "text-base text-secondary-400 hover:text-warning-600",
                        toolTip: t("element.image.experimental.tooltip")
                      }
                    )
                  ] })
                }
              )
            },
            locatorType
          );
        })
      }
    ) }),
    isImageType && (customElementScreenShotFields || /* @__PURE__ */ jsx(
      ElementScreenshotFields,
      {
        occurance: values?.imageLocatorOccurence,
        handleOccuranceChange: (value) => {
          actions?.onElementImageOccuranceChange(value);
          const error = actions?.validateElementImageOccurance(value || 1);
          updateOccuranceErrorText(error);
        },
        occuranceErrorText: isSubmited ? occuranceErrorText : "",
        elementUuid: values?.elementUuid,
        getElementImageUploadUrls: getElementImageUploadUrls2,
        localImages: actions?.localImages || null,
        isSubmited
      }
    )),
    values.technology && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("div", { className: "row-start-2", children: /* @__PURE__ */ jsx(
        Input,
        {
          hideErrorMessage: true,
          label: t("element.list.element_type"),
          wrapperClassName: "w-full",
          value: values.objectClass,
          isReadOnly: true
        }
      ) }),
      /* @__PURE__ */ jsx("div", { className: "row-start-2", children: /* @__PURE__ */ jsx(
        Input,
        {
          hideErrorMessage: true,
          label: t("element.list.technology"),
          wrapperClassName: "w-full",
          value: values.technology,
          isReadOnly: true
        }
      ) }),
      /* @__PURE__ */ jsx("div", { className: "col-span-2", children: /* @__PURE__ */ jsx(
        Input,
        {
          hideErrorMessage: true,
          label: t("element.list.parent_name"),
          wrapperClassName: "w-full",
          value: values.parentElementName,
          isReadOnly: true
        }
      ) }),
      /* @__PURE__ */ jsx("div", { className: "col-span-2", children: /* @__PURE__ */ jsx(
        Input,
        {
          hideErrorMessage: true,
          label: t("element.list.uft_element_name"),
          wrapperClassName: "w-full",
          value: values.uftElementName,
          isReadOnly: true
        }
      ) })
    ] }),
    !values?.technology && !isImageType && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("div", { className: "col-span-2", children: [
        /* @__PURE__ */ jsx(
          TextArea,
          {
            rows: 1,
            isRequired: true,
            hasError: isSubmited ? actions.validateDefinition(
              values["definition"],
              values["locatorType"]
            ) : false,
            errorText: isSubmited ? actions.validateDefinition(
              values["definition"],
              values["locatorType"]
            ) : "",
            label: t("element.enter_value"),
            wrapperClassName: "w-full",
            value: values["definition"],
            onChange: (value) => actions.onDefinitionChange(value),
            inputClassName: "h-[150px]",
            preventDefaultValue: true
          }
        ),
        isRecorderView && (values?.applicationType === ApplicationType.AndroidNative || values?.applicationType === ApplicationType.IOSNative) && /* @__PURE__ */ jsxs("div", { className: "flex mb-2 gap-x-2 items-center mt-2", children: [
          /* @__PURE__ */ jsx(
            Button,
            {
              onClick: () => actions.onVerifyElement?.(),
              color: "secondary",
              variant: "outlined",
              children: t("common.verify")
            }
          ),
          /* @__PURE__ */ jsx(VerifyStatusDisplay, { verifyStatus: actions.verifyStatus })
        ] })
      ] }),
      screenshot ? /* @__PURE__ */ jsxs("div", { className: "col-span-2", children: [
        /* @__PURE__ */ jsx("div", { className: "text-secondary-500 text-xs font-medium p-1", children: t("element.screenshot") }),
        /* @__PURE__ */ jsxs("div", { className: "w-full bg-gray-100 rounded border min-h-[50px] flex justify-center items-center", children: [
          screenshot.message && /* @__PURE__ */ jsx("span", { className: "text-xs leading-6 font-semibold text-secondary-400", children: screenshot.message }),
          screenshot.loading && /* @__PURE__ */ jsx("div", { className: "empty-page-loader" }),
          screenshot.url && /* @__PURE__ */ jsx(ImageViewer, { src: screenshot.url, enablePageFullScreen: true })
        ] })
      ] }) : null
    ] }),
    !!values?.uftElementProperty?.length && /* @__PURE__ */ jsxs("div", { className: "flex flex-col w-full col-span-2 border border-neutral-200 rounded-md overflow-hidden", children: [
      /* @__PURE__ */ jsxs("div", { className: "bg-secondary-50 text-sm text-secondary-600 font-medium w-full flex", children: [
        /* @__PURE__ */ jsx("div", { className: "w-2/5 px-3 py-1", children: t("element.locator.property") }),
        /* @__PURE__ */ jsx("div", { className: "w-3/5 border-l border-l-neutral-200  px-3 py-1", children: t("common.value") })
      ] }),
      values.uftElementProperty.map((property) => /* @__PURE__ */ jsxs(
        "div",
        {
          className: "text-sm text-primary-900 w-full flex border-t border-t-neutral-200",
          children: [
            /* @__PURE__ */ jsx("div", { className: "w-2/5 px-3 py-1", children: property.name }),
            /* @__PURE__ */ jsx("div", { className: "w-3/5 border-l border-l-neutral-200  px-3 py-1", children: property.value })
          ]
        },
        property.name
      ))
    ] })
  ] });
};
var HostParentElementItem = ({
  element,
  elementLocatorType,
  onHostElementValueChange,
  ind,
  onRemove
}) => {
  const { t } = useTranslation();
  const updateHostValue = useCallback(
    (obj) => {
      const newObj = { ...element ?? {}, ...obj ?? {} };
      if (obj?.hostType) {
        if (obj.hostType === ElementIdentifierHostType.SHADOW) {
          newObj.locatorType = ElementIdentifierLocatorType.csspath;
        } else {
          newObj.locatorType = ElementIdentifierLocatorType.xpath;
        }
      }
      onHostElementValueChange(newObj, ind);
    },
    [onHostElementValueChange, element, ind]
  );
  return /* @__PURE__ */ jsxs("div", { className: "col-span-2 grid grid-cols-2 gap-x-4", children: [
    /* @__PURE__ */ jsx("div", { className: "col-span-2 text-secondary-500 text-xs font-medium p-1", children: t("element.host.order.label", { order: ind + 1 }) }),
    /* @__PURE__ */ jsxs("div", { className: "row-start-2 flex gap-x-4", children: [
      /* @__PURE__ */ jsx(Column, { width: 40, className: " shrink-0", children: /* @__PURE__ */ jsx(
        DropdownButton,
        {
          name: element?.hostType ? t(getElementHostTypeI18nKey(element?.hostType)) : "",
          placement: "bottom-start",
          children: Object.keys(ElementIdentifierHostType).map((hostType) => {
            const isSelected = element?.hostType === hostType;
            return /* @__PURE__ */ jsx(
              DropdownItem,
              {
                onClick: () => updateHostValue({ hostType }),
                isSelected,
                className: "truncate",
                children: t(getElementHostTypeI18nKey(hostType))
              },
              hostType
            );
          })
        }
      ) }),
      /* @__PURE__ */ jsx(Column, { className: "flex-1 overflow-hidden w-full", children: /* @__PURE__ */ jsx(
        DropdownButton,
        {
          name: /* @__PURE__ */ jsx(Fragment, { children: element?.hostType === ElementIdentifierHostType.SHADOW ? /* @__PURE__ */ jsx("span", { className: "h-6 flex items-center", children: t(getElementTypeI18nKey(element?.locatorType)) }) : t(getElementTypeI18nKey(element?.locatorType)) }),
          placement: "bottom-start",
          disabled: element?.hostType === ElementIdentifierHostType.SHADOW,
          children: elementLocatorType.map((locatorType) => {
            const isSelected = element?.locatorType === locatorType;
            return /* @__PURE__ */ jsx(
              DropdownItem,
              {
                onClick: () => updateHostValue({ locatorType }),
                isSelected,
                children: t(getElementTypeI18nKey(locatorType))
              },
              locatorType
            );
          })
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "row-start-2 flex items-center gap-x-2", children: [
      /* @__PURE__ */ jsx(
        Input,
        {
          hideErrorMessage: true,
          wrapperClassName: "w-full",
          isRequired: true,
          placeholder: t("elements.filter_form.field.element_value.label"),
          value: element?.definition,
          onChange: (value) => {
            updateHostValue({ definition: value });
          }
        }
      ),
      /* @__PURE__ */ jsx(
        Icon,
        {
          name: "delete",
          className: " text-slate-500 hover:text-error-600 text-xl cursor-pointer",
          onClick: () => {
            onRemove(ind);
          }
        }
      )
    ] })
  ] });
};
var HostElementTrigger = ({
  values,
  actions,
  elementLocatorType,
  hostsLocatorTypes
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("div", { className: "col-span-2 flex items-center gap-x-1", children: [
      /* @__PURE__ */ jsx(
        Checkbox,
        {
          label: t("element.nested_context.label"),
          onChange: (value) => actions.onIsInsideHostsChange(value),
          type: "primary",
          labelClassName: "",
          checked: values["isInsideHosts"] && values?.["hostElements"]
        }
      ),
      /* @__PURE__ */ jsx(
        ToolTip,
        {
          content: t("element.shadow_dom.fild.note_message"),
          className: "flex cursor-pointer items-center",
          children: /* @__PURE__ */ jsx(Icon, { name: "help", className: "text-unique-800 text-lg leading-4.5" })
        }
      )
    ] }),
    values["isInsideHosts"] && /* @__PURE__ */ jsxs(Fragment, { children: [
      values?.["hostElements"]?.map((element, ind) => {
        return /* @__PURE__ */ jsx(
          HostParentElementItem,
          {
            element,
            ind,
            elementLocatorType: hostsLocatorTypes || elementLocatorType,
            onRemove: actions.onRemoveHostElement,
            onHostElementValueChange: actions.onHostElementValueChange
          },
          ind
        );
      }),
      /* @__PURE__ */ jsxs(
        SecondaryButton,
        {
          onClick: () => actions.onAddHostElement(),
          className: "w-fit",
          children: [
            /* @__PURE__ */ jsx(Icon, { name: "add", className: " text-lg leading-4.5 text-unique-600" }),
            t("element.add_host.button")
          ]
        }
      )
    ] })
  ] });
};
var AffectedEntitiesNote = ({
  onViewAffectedEntities = NOOP
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx(
    Note,
    {
      hideIcon: true,
      type: "warning",
      className: "col-span-2 !border-0 rounded !bg-warning-1000",
      content: /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsxs("div", { className: "flex items-center", children: [
          /* @__PURE__ */ jsx(
            Icon,
            {
              name: "info",
              className: "flex text-xl text-secondary-600 p-1  rounded-full"
            }
          ),
          /* @__PURE__ */ jsx("div", { className: "text-sm  text-secondary-600 font-normal items-center", children: t("element.create.record.performance.new.info") })
        ] }),
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: "text-2xs text-primary-600 font-medium ml-8 flex items-center cursor-pointer",
            onClick: onViewAffectedEntities,
            children: [
              t("element.view.affected.entries.new.info"),
              /* @__PURE__ */ jsx(
                Icon,
                {
                  name: "angle-right",
                  className: "text-xl text-primary-600 font-medium"
                }
              )
            ]
          }
        )
      ] })
    }
  );
};
var replaceSpecialChars = (str, replace = "") => str.replaceAll(SPEICAL_CHAR_REGEX, replace);
var capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);
var getRandomString = () => Math.random().toString(36).substring(2, 7);
var isStrHasNumber = (str) => NUMBER_REGEX.test(str);
var clipString = (inputString, maxLength) => {
  if (inputString.length > maxLength) {
    return inputString.substring(0, maxLength);
  } else {
    return inputString;
  }
};
var useIsObjectBased = (input) => {
  return useMemo(() => {
    if (typeof input === "string") {
      return input === ApplicationType.WINDOWS_ADVANCED;
    }
    return input?.applicationType === ApplicationType.WINDOWS_ADVANCED;
  }, [input]);
};
var isObjectBased = (input) => typeof input === "string" ? input === ApplicationType.WINDOWS_ADVANCED : input?.applicationType === ApplicationType.WINDOWS_ADVANCED;
var generateBlock = (type, value, uuid, hasValue = void 0, more_details = void 0, isEncrypted) => {
  return {
    type,
    value: typeof value === "string" ? value?.replace(/\n/g, "\\n") : value,
    isEncrypted,
    uuid,
    ...hasValue == void 0 ? {} : { has_value: hasValue },
    ...more_details == void 0 ? {} : { more_details }
  };
};
var splitTextByTemplate = (value) => {
  if (typeof value != "string") return value;
  if (!value.length) return [];
  return value.match(/(\$|\@|\#){[^{}]+}|[^$@#{}\s][^$@#{}]*/g).filter((i) => i.length);
};
var splitTextByKibbutzTemplate = (value, parameterList) => {
  if (typeof value !== "string") return value;
  if (!value.length) return [];
  parameterList.forEach((item) => {
    value = value.replace(item.reference, `%{${item.reference}}`);
  });
  return value.match(/(\%){[^{}]+}|[^%{}]+/g)?.filter((i) => i.length) || [];
};
var getType = (key, template, dataMap) => {
  if (template.allowedValues?.[key]) {
    return "selectable";
  } else if (dataMap?.parameterType) {
    return dataMap.parameterType;
  } else if (dataMap?.type) {
    return dataMap.type;
  } else if (key == "salesforceObjectForm" && dataMap) {
    return TestDataType.salesforce_object_form;
  } else {
    return TestDataType.raw;
  }
};
var findDataItem = (stepDataList, dataRefKey) => stepDataList?.find((stepData) => stepData?.key === dataRefKey);
var findOverrideDataItem = (stepDataList, dataRefKey) => stepDataList?.find((stepData) => stepData?.referenceKey === dataRefKey);
var getElementType = (uuid) => {
  switch (uuid) {
    case "fromUiIdentifier":
      return TestStepElementType.FROM_UI_ELEMENT;
    case "toUiIdentifier":
      return TestStepElementType.TO_UI_ELEMENT;
    default:
      return TestStepElementType.UI_ELEMENT;
  }
};
var findElementItem = (elements, elementType) => elements.find(
  (element) => element.elementType === getElementType(elementType)
);
var convertDataGeneratorArgumentObjectsToJson = (dataGeneratorArguments) => {
  return Object.fromEntries(
    dataGeneratorArguments?.map((arg) => [
      arg.argumentName,
      arg.argumentValue
    ]) || []
  );
};
var getSystemFunctionTestDataInfo = (dataItem) => {
  return {
    key: dataItem.referenceKey,
    type: dataItem.parameterType,
    testDataFunctionId: dataItem.functionId,
    testDataFunction: {
      testDataFunctionId: dataItem.functionId,
      arguments: dataItem.dataGeneratorArguments
    }
  };
};
var getKibbutzFunctionTestDataInfo = (dataItem) => {
  const overriddenDataGeneratorArgs = convertDataGeneratorArgumentObjectsToJson(
    dataItem?.dataGeneratorArguments
  );
  return {
    ...dataItem,
    isKibbutzFn: true,
    testDataKibbutzFunctionId: dataItem?.dataGeneratorId,
    testDataKibbutzFunction: {
      testDataKibbutzFunctionId: dataItem?.dataGeneratorId,
      arguments: overriddenDataGeneratorArgs
    }
  };
};
var getDataGeneratorTestDataInfo = (dataItem) => {
  if (dataItem?.functionId) {
    return getSystemFunctionTestDataInfo(dataItem);
  } else if (dataItem?.dataGeneratorId) {
    return getKibbutzFunctionTestDataInfo(dataItem);
  } else if (dataItem?.testDataFunctionId || dataItem?.testDataKibbutzFunctionId) {
    return dataItem;
  }
  return null;
};
var findOverrideElementItem = (elements, key) => elements.find((element) => element?.referenceKey === key);
var getDataItem = (overrideDataList, dataList, key) => {
  const overriddenDataItem = findOverrideDataItem(overrideDataList, key);
  const dataItem = findDataItem(dataList, key);
  return overriddenDataItem || dataItem || null;
};
var assignValuesToTextBlock = (textBlocks, template, dataList, overrideDataList, attribute, elements, overrideElementList, stepMapperData, isStepGroupChild) => {
  const dataMap = template?.data?.testData || template?.testData;
  return textBlocks.map((block, idx) => {
    const match = block.match(/[$@#]\{(.*)\}/);
    if (match) {
      const key = match[1].trim();
      let type, value, hasValue;
      const dataItem = getDataItem(overrideDataList, dataList, key);
      const dataMapItem = dataItem || dataMap?.[key] || dataMap?.get?.(key);
      if (block.startsWith("$")) {
        type = getType(key, template, dataMapItem);
        value = dataMapItem?.value == "" ? dataMapItem?.value : dataMapItem?.value || (dataMapItem?.parameterValue == "" ? dataMapItem?.parameterValue : dataMapItem?.parameterValue || dataMapItem);
        hasValue = Boolean(
          dataItem?.value || dataItem?.key || dataItem?.parameterValue
        );
      } else if (block.startsWith("#")) {
        const elementItem = !!overrideElementList?.length ? findOverrideElementItem(overrideElementList, key) : !!elements?.length ? findElementItem(elements, key) : null;
        type = "ui_identifier";
        value = elementItem?.name || elementItem?.elementName || "element";
        hasValue = Boolean(
          elementItem?.name || elementItem?.elementName
        );
      } else if (block.startsWith("@")) {
        type = "attribute";
        value = attribute == "" ? type : attribute || type;
        hasValue = Boolean(attribute);
      }
      const testDataKeyValue = dataMapItem?.value || dataMapItem;
      const parameter = testDataKeyValue == "parameter" || key == "parameter";
      const profile = testDataKeyValue == "test data profile" || key == "testDataProfile";
      const appName = testDataKeyValue == "app-name" || key == "appName";
      const appVersion = testDataKeyValue == "app-version" || key == "appVersion";
      const sessionValue = testDataKeyValue == "session-name" || key == "sessionValue";
      const phoneNumberId = dataItem?.phoneNumberId;
      const moreDetails = {
        templateId: template?.id,
        allowedTypes: template?.allowedTypes?.[key],
        allowedValues: template?.allowedValues?.[key],
        mapper: stepMapperData,
        profile,
        parameter,
        appName,
        appVersion,
        sessionValue,
        testDataInfo: getDataGeneratorTestDataInfo(dataItem),
        data: getMoreDetailsData(
          template?.dataAttributes?.data,
          isStepGroupChild
        ),
        phoneNumberId
      };
      const isEncrypted = dataMapItem?.isEncrypted;
      return generateBlock(
        type,
        value,
        key,
        hasValue,
        moreDetails,
        isEncrypted
      );
    } else {
      return generateBlock("readonly_text" /* readonly_text */, block, idx);
    }
  });
};
var assignValuesToTextBlockForLoop = (textBlocks, step, template) => {
  const dataMap = isEqual(step.forLoopCondition, new ForLoopCondition()) || !step.forLoopCondition ? template?.data?.testData || template?.testData : step.forLoopCondition;
  return textBlocks.map((block, idx) => {
    const match = block.match(/[$@#]\{(.*)\}/);
    if (match) {
      const key = match[1].trim();
      const type = template.allowedValues?.[key] ? "selectable" : dataMap[key]?.type || TestDataType.raw;
      let value = typeof dataMap?.[key] === "string" || typeof dataMap?.[key] === "undefined" ? dataMap?.[key] : (
        // : dataMap?.[key]?.isEncrypted
        // ? '••••••••' // If isEncrypted is true, set value to '••••••••'
        dataMap?.[key]?.value || template?.data?.testData[key]
      );
      const hasValue = Boolean(
        block.startsWith("$") ? dataMap?.[key]?.type && dataMap?.[key]?.value : step.dataMap?.[key]
      );
      const isEncrypted = dataMap[key]?.isEncrypted;
      const testDataKeyValue = template.data?.testData?.[key] || template.testData?.[key];
      const parameter = testDataKeyValue == "parameter";
      const profile = testDataKeyValue == "test data profile";
      const setName = testDataKeyValue == "filterParameter" || testDataKeyValue.includes("set-name");
      const allowedTypes = template.allowedTypes?.[key];
      const allowedValues = template.allowedValues?.[key];
      const loopType = template.loopType;
      const testDataProfile = step.forLoopCondition?.testDataProfile;
      const mapper = step.mapperData;
      if (type == "selectable" && allowedValues.length && !allowedValues.includes(value)) {
        value = allowedValues[0];
      }
      const hasDatagenetor = () => {
        if (step.stepDataList?.length) {
          const dataItem = findDataItem(step.stepDataList, key);
          if (dataItem?.testDataFunctionId) {
            return dataItem;
          } else {
            return null;
          }
        }
        return null;
      };
      const more_details = {
        allowedTypes,
        allowedValues,
        loopType,
        profile,
        parameter,
        setName,
        setNameType: testDataKeyValue,
        testDataProfile,
        mapper,
        testDataInfo: hasDatagenetor(),
        ...profile && step.dataMap?.testData?.testDataProfileId ? { profileId: step.dataMap?.testData?.testDataProfileId?.value } : {},
        data: getMoreDetailsData(
          template?.dataAttributes?.data,
          step?.isStepGroupChild
        ),
        testDataFunction: step?.forLoopCondition?.[key]?.testDataFunction
      };
      return generateBlock(
        type,
        value,
        key,
        hasValue,
        more_details,
        isEncrypted
      );
    }
    return generateBlock("readonly_text" /* readonly_text */, block, idx);
  });
};
function getMoreDetailsData(data, isStepGroupChild) {
  return isStepGroupChild ? data?.map((item) => ({
    ...item,
    canEncrypt: false
  })) : data;
}
function defaultAllowedType() {
  return [
    "raw",
    "parameter",
    "runtime",
    "global",
    "random",
    "function",
    "phone_number",
    "mail_box",
    "upload_path"
  ];
}
function getKibbutzParameterType(type, kibbutzPluginNlpData, key) {
  switch (type) {
    case KibbutzParameterType.ELEMENT:
      return {
        type: "ui_identifier",
        parameterType: KibbutzParameterType.ELEMENT,
        nameKey: "name",
        keyValue: "uiIdentifiers"
      };
    case KibbutzParameterType.TEST_DATA:
      return {
        type: kibbutzPluginNlpData?.testData?.[key]?.type || TestDataType.raw,
        parameterType: KibbutzParameterType.TEST_DATA,
        nameKey: "value",
        keyValue: "testData",
        encryptedVal: "isEncrypted"
      };
    case KibbutzParameterType.ENVIRONMENT_DATA:
      return {
        type: null,
        parameterType: KibbutzParameterType.ENVIRONMENT_DATA,
        nameKey: "name",
        keyValue: "environmentData"
      };
    case KibbutzParameterType.TEST_DATA_PROFILE:
      return {
        type: null,
        parameterType: KibbutzParameterType.TEST_DATA_PROFILE,
        nameKey: "name",
        keyValue: "testDataProfile"
      };
    case KibbutzParameterType.TEST_DATA_SET:
      return {
        type: null,
        parameterType: KibbutzParameterType.TEST_DATA_SET,
        nameKey: "name",
        keyValue: "testDataSet"
      };
  }
}
function getKibbutzBlockValues(kibbutzPluginNlpData, keyValue, key, nameKey, item, encryptedVal) {
  const value = kibbutzPluginNlpData?.[keyValue]?.[key]?.[nameKey] || item.allowedValues?.length ? kibbutzPluginNlpData?.[keyValue]?.[key]?.[nameKey] || item.referenceKey : item.reference;
  const hasValue = kibbutzPluginNlpData?.[keyValue]?.[key]?.[nameKey];
  const isEncrypted = kibbutzPluginNlpData?.[keyValue]?.[key]?.[encryptedVal];
  return { value, hasValue, isEncrypted, overriddenType: null };
}
function getKibbutzTestDataOverriddenValues(testDataOverride) {
  const value = testDataOverride.parameterValue;
  const hasValue = testDataOverride.parameterValue;
  const overriddenType = testDataOverride.parameterType;
  return { value, hasValue, isEncrypted: null, overriddenType };
}
function getKibbutzElementOverriddenValues(elementOverride) {
  const value = elementOverride.elementName || elementOverride.name;
  const hasValue = elementOverride.elementName || elementOverride.name;
  return { value, hasValue, isEncrypted: null, overriddenType: null };
}
function getTestDataOverride(testDataOverriddenMapping, _testDataOverride, parameterType, key) {
  if (parameterType === KibbutzParameterType.TEST_DATA) {
    const testDataOverride = _testDataOverride?.find(
      (item) => item.referenceKey === key
    );
    return testDataOverride ? testDataOverride : testDataOverriddenMapping?.find((item) => item.referenceKey === key);
  }
}
function getElementOverride(elementOverriddenMapping, _elementOverride, parameterType, key) {
  if (parameterType === KibbutzParameterType.ELEMENT) {
    const elementOverride = _elementOverride?.find(
      (item) => item.referenceKey === key
    );
    return elementOverride ? elementOverride : elementOverriddenMapping?.find((item) => item.referenceKey === key);
  }
}
function getKibbutzValue(key, item, kibbutzPluginNlpData, testDataOverriddenMapping, elementOverriddenMapping, _testDataOverride, _elementOverride) {
  const { type, parameterType, nameKey, keyValue, encryptedVal } = getKibbutzParameterType(item.type, kibbutzPluginNlpData, key);
  const testDataOverride = getTestDataOverride(
    testDataOverriddenMapping,
    _testDataOverride,
    parameterType,
    key
  );
  const elementOverride = getElementOverride(
    elementOverriddenMapping,
    _elementOverride,
    parameterType,
    key
  );
  const { value, hasValue, isEncrypted, overriddenType } = testDataOverride ? getKibbutzTestDataOverriddenValues(testDataOverride) : elementOverride ? getKibbutzElementOverriddenValues(elementOverride) : getKibbutzBlockValues(
    kibbutzPluginNlpData,
    keyValue,
    key,
    nameKey,
    item,
    encryptedVal
  );
  return {
    type: overriddenType ? overriddenType : type,
    value,
    hasValue,
    parameterType,
    isEncrypted
  };
}
function extractTemplateComponents(text, parameterList, action) {
  if (typeof text !== "string" || !text.length) return text;
  const parts = splitTextByKibbutzTemplate(text, parameterList);
  const paramParts = parts.filter((part) => part.startsWith("%"));
  if (paramParts.length > 0) {
    const uiElements = paramParts.filter(
      (part) => part.includes("ui-element") || part.includes("element")
    );
    const otherParams = paramParts.filter(
      (part) => !part.includes("ui-element") && !part.includes("element")
    );
    if (otherParams.length === 0) {
      return [...uiElements, action ? ` ${action} ` : " "].join("");
    }
    return [...uiElements, action ? ` ${action} ` : " ", ...otherParams].join(
      ""
    );
  }
  return action;
}
var getStepKibbutzBlocks = (step, template) => {
  const isObjectType = step.applicationType === ApplicationType.WINDOWS_ADVANCED;
  const nlp_text = template?.grammar || step.action || "";
  const grammar = template?.grammar || "";
  const action = template?.displayName || step.action || "";
  const formattedText = extractTemplateComponents(
    grammar,
    template?.parameters || [],
    action
  );
  const dataMap = template?.parameters.reduce((acc, item) => {
    const referenceKey = item.allowedValues?.length ? item.allowedValues.toString().replace(new RegExp(",", "g"), "/") : item.reference;
    if (referenceKey) {
      acc.push({
        ...item,
        referenceKey
      });
    }
    return acc;
  }, []);
  const data = splitTextByKibbutzTemplate(
    isObjectType ? formattedText : nlp_text,
    dataMap
  );
  const blocks = data.map((block, idx) => {
    const match = block.match(/[%]\{(.*)\}/);
    if (match) {
      const key = match[1].trim();
      const currentParameter = dataMap.find((item) => item.reference == key);
      const valueData = getKibbutzValue(
        currentParameter.reference,
        currentParameter,
        step.kibbutzPluginNlpData,
        step.testStepDataOverRiddenMappings,
        step.uiIdentifierOverRiddenMappings,
        step.testdataOverride,
        step.elementOverride
      );
      const type = currentParameter.allowedValues?.length ? "selectable" : valueData.type || TestDataType.raw;
      const value = valueData.value || "";
      const hasValue = valueData.hasValue;
      const isEncrypted = valueData.isEncrypted;
      const dataValue = (dataItem) => {
        if (dataItem.testDataFunctionArguments?.length) {
          return dataItem.testDataFunctionArguments.map(
            (testDataFunctionArguments) => {
              return {
                argumentName: testDataFunctionArguments?.argumentName,
                argumentValue: testDataFunctionArguments?.argumentValue
              };
            }
          );
        } else {
          if (dataItem.testDataFunctionArguments) {
            return Object.keys(dataItem.testDataFunctionArguments).map(
              (item) => {
                return {
                  argumentName: item,
                  argumentValue: dataItem.testDataFunctionArguments[item]
                };
              }
            );
          } else {
            return [];
          }
        }
      };
      const getKibbutzFunctionDataFromOverridenData = (overridenDataItem) => {
        const overriddenDataGeneratorArgs = convertDataGeneratorArgumentObjectsToJson(
          overridenDataItem?.dataGeneratorArguments
        );
        return {
          ...overridenDataItem,
          isKibbutzFn: true,
          testDataKibbutzFunctionId: overridenDataItem?.dataGeneratorId,
          testDataKibbutzFunction: {
            arguments: overriddenDataGeneratorArgs,
            testDataKibbutzFunctionId: overridenDataItem?.dataGeneratorId
          }
        };
      };
      const getSystemFunctionDataFromOverridenData = (overridenDataItem) => {
        return {
          ...overridenDataItem,
          testDataFunctionId: overridenDataItem?.functionId,
          testDataFunction: {
            arguments: overridenDataItem?.dataGeneratorArguments,
            testDataFunctionId: overridenDataItem?.functionId
          }
        };
      };
      const populateKibbutzFunctionData = (dataItem) => {
        return {
          ...dataItem,
          testDataKibbutzFunctionId: dataItem?.testDataFunctionId,
          isKibbutzFn: true,
          testDataKibbutzFunction: {
            testDataKibbutzFunctionId: dataItem?.testDataFunctionId,
            arguments: dataItem?.testDataFunctionArguments
          }
        };
      };
      const populateSystemFunctionData = (dataItem) => {
        return {
          ...dataItem,
          testDataFunction: {
            testDataFunctionId: dataItem.testDataFunctionId,
            arguments: dataValue(dataItem)
          }
        };
      };
      const populateDataItem = (dataItem) => {
        dataItem = dataItem.isKibbutzFn || dataItem.isKibbutzFunction ? populateKibbutzFunctionData(dataItem) : populateSystemFunctionData(dataItem);
        return dataItem;
      };
      const getOverridenDataItem = () => {
        const overridenMap = step?.testdataOverride || step?.testStepDataOverRiddenMappings;
        return overridenMap?.find((mapping) => mapping?.referenceKey === key);
      };
      const getDataGenertorDataIfPresent = () => {
        const overridenDataItem = getOverridenDataItem();
        if (overridenDataItem) {
          if (overridenDataItem.parameterType === TestDataType.function) {
            return overridenDataItem.dataGeneratorId ? getKibbutzFunctionDataFromOverridenData(overridenDataItem) : getSystemFunctionDataFromOverridenData(overridenDataItem);
          }
          return null;
        }
        const dataItem = step?.kibbutzPluginNlpData?.testData?.[key];
        if (dataItem?.testDataFunctionId) {
          return populateDataItem(dataItem);
        }
        return null;
      };
      const more_details = {
        allowedTypes: currentParameter.allowedValues?.length ? currentParameter.allowedValues : defaultAllowedType(),
        allowedValues: currentParameter.allowedValues?.length ? currentParameter.allowedValues : defaultAllowedType(),
        parameterType: valueData.parameterType,
        mapper: step.mapperData,
        testDataInfo: getDataGenertorDataIfPresent(),
        intialTestData: step?.kibbutzPluginNlpData?.testData?.[key]?.uploadVersionData
      };
      return generateBlock(
        type,
        value,
        currentParameter.reference,
        hasValue,
        more_details,
        isEncrypted
      );
    }
    return generateBlock("readonly_text" /* readonly_text */, block, `${idx}`);
  });
  if (isObjectType) {
    const elementName2 = step.testStepElements?.[0]?.name;
    if (step.action == null && blocks[0] && elementName2 && blocks[0].value !== elementName2) {
      const updatedBlocks = cloneDeep$1(blocks);
      updatedBlocks[0].value = elementName2;
      return updatedBlocks;
    }
  }
  return blocks;
};
var isConditionalIf = (step) => step?.conditionType == TestStepConditionType.CONDITION_IF;
var isConditionalElseIf = (step) => step?.conditionType == TestStepConditionType.CONDITION_ELSE_IF;
var isConditionalElse = (step) => step?.conditionType == TestStepConditionType.CONDITION_ELSE;
var isForLoop = (step) => step?.conditionType == TestStepConditionType.LOOP_FOR;
var isWhileLoop = (step) => step?.type == TestStepType.WHILE_LOOP;
var isBreakLoop = (step) => step?.type == TestStepType.BREAK_LOOP;
var isContinueLoop = (step) => step?.type == TestStepType.CONTINUE_LOOP;
var isConditionalWhileLoop = (step) => step?.conditionType == TestStepConditionType.LOOP_WHILE;
var isNlpStep = (step) => step?.type == TestStepType.NLP_TEXT;
var isRestStep = (step) => step?.type == TestStepType.API_STEP;
var isBlock = (step) => step?.type == TestStepType.BLOCK;
var isStepGroup = (step) => step?.type == TestStepType.STEP_GROUP;
var isConditionalStep = (step) => Boolean(step?.conditionType);
var isIfConditionalStep = (step) => Boolean(isConditionalElseIf(step) || isConditionalIf(step));
var isPresentationStep = (step) => Boolean(isBreakLoop(step) || isContinueLoop(step) || isConditionalElse(step));
var isSalesforceApiStep = (step) => {
  const salesforceApiTemplateIds = [60428, 61451];
  return salesforceApiTemplateIds?.includes(step?.templateId);
};
var isSalesforceReadApiStep = (step) => {
  const salesforceReadApiTemplateIds = [80064];
  return salesforceReadApiTemplateIds?.includes(step?.templateId);
};
var isVisualTestingSupportedNLP = (step) => {
  const templatesToIgnore = [60428, 61452, 61451];
  return !templatesToIgnore?.includes(step?.templateId);
};
var getStepUIType = (step) => {
  const isSalesforce = step.applicationType == ApplicationType.Salesforce;
  const isObjectType = isObjectBased(step);
  const isConditionalIfStep = isConditionalIf(step);
  if (step.type == TestStepType.NLP_TEXT && isConditionalIfStep) {
    return StepTypeUI.IF_CONDITION;
  } else if (step.type == TestStepType.STEP_GROUP && isConditionalIfStep) {
    return StepTypeUI.IF_STEP_GROUP;
  } else if (step.type == TestStepType.API_STEP && isConditionalIfStep) {
    return StepTypeUI.IF_REST_API;
  } else if (step.type == TestStepType.CUSTOM_FUNCTION && isConditionalIfStep) {
    return StepTypeUI.IF_CUSTOM_FUNCTION;
  } else if (step.type == TestStepType.STEP_GROUP && !isConditionalIfStep) {
    return StepTypeUI.STEP_GROUP;
  } else if (step.type == TestStepType.API_STEP && !isConditionalIfStep) {
    return StepTypeUI.REST_API;
  } else if (step.type == TestStepType.CUSTOM_FUNCTION && !isConditionalIfStep) {
    return StepTypeUI.CUSTOM_FUNCTION;
  } else if (isWhileLoop(step) || isConditionalWhileLoop(step)) {
    return StepTypeUI.WHILE_LOOP;
  } else if (isForLoop(step)) {
    return StepTypeUI.FOR_LOOP;
  } else if (step.type == TestStepType.BLOCK) {
    return StepTypeUI.BLOCK;
  } else if (step.type == TestStepType.NLP_TEXT && !isConditionalIfStep) {
    if (isObjectType) {
      return null;
    }
    return StepTypeUI.NLP;
  } else if (step.type == TestStepType.SOQL && isSalesforce) {
    return StepTypeUI.SOQL;
  }
  return null;
};
var getIsTestDataChanged = (optionalGrammarTemplates, testStep) => {
  for (const optionalGrammarTemplate of optionalGrammarTemplates) {
    const optionalTemplateTestData = optionalGrammarTemplate?.data?.testData;
    if (optionalTemplateTestData) {
      for (const [key, value] of Object.entries(optionalTemplateTestData)) {
        if (testStep?.stepDataList?.some(
          (dataItem) => dataItem.key === key && dataItem.value !== value
        )) {
          return true;
        }
      }
    }
  }
  return false;
};
function getStepNlpBlocks(step, template, isEditMode, hasFeatureValue2, optionalGrammarTemplates) {
  const localStep = new TestStep().deserialize(step);
  if (template?.isAddon) {
    localStep.kibbutzPluginNlpId = template.id;
    return getStepKibbutzBlocks(localStep, template);
  }
  const nlp_text = template?.grammar || localStep.action || "";
  const nlp_blocks = splitTextByTemplate(nlp_text);
  if (isForLoop(localStep)) {
    return assignValuesToTextBlockForLoop(nlp_blocks, localStep, template);
  }
  if (!isNlpStep(localStep) && !localStep) return;
  const data = assignValuesToTextBlock(
    nlp_blocks,
    template,
    localStep?.stepDataList,
    localStep?.testdataOverride?.length ? localStep?.testdataOverride : localStep?.testStepDataOverRiddenMappings,
    localStep?.attribute,
    localStep?.testStepElements,
    localStep?.elementOverride?.length ? localStep?.elementOverride : localStep?.uiIdentifierOverRiddenMappings,
    localStep?.mapperData,
    localStep?.isStepGroupChild
  );
  if (!optionalGrammarTemplates || optionalGrammarTemplates?.length === 0) {
    return data;
  }
  if (!isEditMode && !getIsTestDataChanged(optionalGrammarTemplates, localStep)) {
    return data;
  }
  if (nlpTemplateVsFeatureMapping[template?.id] && !hasFeatureValue2(nlpTemplateVsFeatureMapping[template?.id])) {
    return data;
  }
  const optionalTemplatesData = optionalGrammarTemplates.flatMap(
    (optionalGrammarTemplate) => {
      const optionalTemplate = new Template().deserialize(
        optionalGrammarTemplate
      );
      return assignValuesToTextBlock(
        splitTextByTemplate(optionalTemplate?.grammar),
        optionalTemplate,
        localStep?.stepDataList,
        localStep?.testdataOverride || localStep?.testStepDataOverRiddenMappings,
        localStep?.attribute,
        localStep?.testStepElements,
        localStep?.elementOverride || localStep?.uiIdentifierOverRiddenMappings,
        localStep?.mapperData,
        localStep?.isStepGroupChild
      );
    }
  );
  return [...data, ...optionalTemplatesData];
}
var addStepNumber = (id, type) => {
  if (id?.includes(" ... ")) {
    id = id.split(" ... ")[1];
  }
  const idArray = (id?.split(".") || []).map((value) => parseInt(value));
  const length = idArray.length;
  {
    if (length > 1) {
      idArray[length - 2]++;
    } else {
      idArray[0]++;
    }
  }
  return idArray.join(".");
};
var populateMapperDataForChangedForLoop = (stepList, parentStep) => {
  if (!parentStep?.isForLoop) {
    return stepList;
  }
  stepList.forEach((step) => {
    const mapperData = step.mapperData || [];
    const newData = {
      id: parentStep.forLoopCondition?.testDataProfile?.id || 0,
      stepNumber: parentStep.stepNumber,
      name: parentStep.forLoopCondition?.testDataProfile?.value || "",
      stepScopeIsTestCase: !parentStep.isStepGroupChild,
      lastLoopStepId: parentStep.id
    };
    const oldData = mapperData.find(
      (item) => item.lastLoopStepId === parentStep.id
    );
    mapperData[mapperData.indexOf(oldData)] = newData;
    step.mapperData = mapperData.length > 0 ? mapperData : void 0;
  });
  return stepList;
};
var updateAllBlockValues = (blocks, step, updateMultiBlockValue) => {
  const testDataDataMap = step?.stepDataList ?? [];
  const updatedBlocks = [];
  blocks.forEach((block, blockIdx) => {
    if (block.type === "readonly_text" /* readonly_text */) return;
    testDataDataMap.find((data) => {
      if (block.uuid === data.key) {
        block.value = data.value;
        block.bulkUpdatedTime = (/* @__PURE__ */ new Date()).getTime();
        updatedBlocks.push(block);
      }
    });
  });
  updateMultiBlockValue(updatedBlocks);
};
var optionsMap = /* @__PURE__ */ new Map([
  ["raw" /* raw */, "datatype.name.plain-text"],
  ["parameter" /* parameter */, "datatype.name.parameter"],
  ["runtime" /* runtime */, "datatype.name.runtime"],
  ["global" /* global */, "datatype.name.environment"],
  ["random" /* random */, "datatype.name.random"],
  ["function" /* function */, "datatype.name.data-generator"],
  ["phone_number" /* phone_number */, "datatype.name.phone-number"],
  ["mail_box" /* mail_box */, "datatype.name.mail-box"],
  ["upload_path" /* upload_path */, "datatype.name.upload_path"]
]);
var getTestDataTypeDisplayNameByType = (type) => {
  return optionsMap.get(type) || type;
};
var getColorPaletteByExecutionStatus = (status) => {
  const colorPalettes = {
    SUCCESS: "primary-500",
    FAILURE: "error-500",
    NOT_EXECUTED: "unique-400",
    RUNNING: "primary-700",
    QUEUED: "unique-200"
  };
  return colorPalettes[status] || "secondary";
};
var getLabelByStatus = (status) => {
  const statusLabels = {
    SUCCESS: "Passed",
    FAILURE: "Failed",
    NOT_EXECUTED: "Not Executed",
    RUNNING: "Running",
    QUEUED: "Queued"
  };
  return statusLabels[status] || "-";
};
var getLabelColorByResultStatus = (status) => ({
  label: getLabelByStatus(status),
  colorPalette: getColorPaletteByExecutionStatus(status)
});
var getLabelStyleByResult = (status) => {
  const labelStyles = {
    [ResultConstant.RUNNING]: {
      textColor: "!text-warning-600",
      icon: "loader",
      border: "!border-warning-500",
      bgColor: "!bg-warning-50"
    },
    [ResultConstant.SUCCESS]: {
      textColor: "!text-primary-700",
      icon: "check-circle-outline",
      border: "!border-primary-500",
      bgColor: "!bg-primary-50"
    },
    [ResultConstant.FAILURE]: {
      textColor: "!text-error-500",
      icon: "cancel-circle-outline",
      border: "!border-error-500",
      bgColor: "!bg-error-100"
    },
    [ResultConstant.ABORTED]: {
      textColor: "text-warning-500",
      icon: "abort-circle-outline",
      border: "!border-warning-500",
      bgColor: "!bg-warning-50"
    },
    [ResultConstant.NOT_EXECUTED]: {
      textColor: "text-unique-400",
      icon: "hide-circle-outline",
      border: "!border-unique-500",
      bgColor: "!bg-unique-400/10"
    },
    [ResultConstant.QUEUED]: {
      textColor: "text-unique-500",
      icon: "queue-circle-outline",
      border: "!border-unique-500",
      bgColor: "!bg-unique-500/10"
    },
    [ResultConstant.STOPPED]: {
      textColor: "!text-unique-800",
      icon: "stop-circle-outline",
      border: "!border-secondary-500",
      bgColor: "!bg-secondary-200"
    },
    [ResultIconConstant.AFTER_SUITE_TEST_CASE_FAILURE]: {
      textColor: "!text-error-500",
      icon: "after-list",
      border: "!border-error-500",
      bgColor: "!bg-error-100"
    },
    [ResultIconConstant.PRE_REQUISITE_FAILURE]: {
      textColor: "text-warning-500",
      icon: "abort-circle-outline",
      border: "!border-warning-500",
      bgColor: "!bg-warning-50"
    },
    [ResultIconConstant.SKIPPED]: {
      textColor: "text-unique-400",
      icon: "hide-circle-outline",
      border: "!border-unique-500",
      bgColor: "!bg-unique-400/10"
    },
    [ResultIconConstant.PAUSED]: {
      textColor: "!text-unique-800",
      icon: "stop-circle-outline",
      border: "!border-secondary-500",
      bgColor: "!bg-secondary-200"
    },
    [ResultIconConstant.AFTER_TEST_CASE_FAILURE]: {
      textColor: "!text-error-500",
      icon: "after-list",
      border: "!border-error-500",
      bgColor: "!bg-error-100"
    }
  };
  return labelStyles[status];
};
var getColorsByStatus = (status) => {
  const colorOptions = {
    [ResultConstant.RUNNING]: {
      textColor: "!text-primary-700",
      icon: "check-circle-outline",
      border: "!border-primary-500",
      bgColor: "!bg-primary-50",
      dotColor: "bg-warning-400"
    },
    [ResultConstant.SUCCESS]: {
      textColor: "!text-primary-700",
      icon: "check-circle-outline",
      border: "border-primary-500",
      bgColor: "!bg-primary-50",
      dotColor: "bg-primary-400"
    },
    [ResultConstant.FAILURE]: {
      textColor: "!text-error-700",
      icon: "cancel-circle-outline",
      border: "!border-error-500",
      bgColor: "!bg-error-50",
      dotColor: "bg-error-500"
    },
    [ResultConstant.ABORTED]: {
      textColor: "text-warning-700",
      icon: "abort-circle-outline",
      border: "!border-warning-500",
      bgColor: "!bg-warning-50",
      dotColor: "bg-warning-700"
    },
    [ResultConstant.NOT_EXECUTED]: {
      textColor: "text-unique-400",
      icon: "hide-circle-outline",
      border: "!border-unique-500",
      bgColor: "!bg-unique-400/10",
      dotColor: "bg-[#9C8AE3]"
    },
    [ResultConstant.QUEUED]: {
      textColor: "text-unique-500",
      icon: "queue-circle-outline",
      border: "!border-unique-500",
      bgColor: "!bg-unique-500/10",
      dotColor: "bg-unique-500"
    },
    [ResultConstant.STOPPED]: {
      textColor: "!text-unique-800",
      icon: "stop-circle-outline",
      border: "!border-secondary-500",
      bgColor: "!bg-secondary-50",
      dotColor: "bg-secondary-400"
    },
    [ResultIconConstant.AFTER_SUITE_TEST_CASE_FAILURE]: {
      textColor: "!text-error-700",
      icon: "cancel-circle-outline",
      border: "!border-error-500",
      bgColor: "!bg-error-50",
      dotColor: "bg-error-700"
    },
    [ResultIconConstant.PRE_REQUISITE_FAILURE]: {
      textColor: "text-warning-700",
      icon: "abort-circle-outline",
      border: "!border-warning-500",
      bgColor: "!bg-warning-50",
      dotColor: "bg-warning-700"
    },
    [ResultIconConstant.SKIPPED]: {
      textColor: "text-unique-400",
      icon: "hide-circle-outline",
      border: "!border-unique-500",
      bgColor: "!bg-unique-400/10",
      dotColor: "bg-unique-400"
    },
    [ResultIconConstant.PAUSED]: {
      textColor: "!text-unique-800",
      icon: "stop-circle-outline",
      border: "!border-secondary-500",
      bgColor: "!bg-secondary-50",
      dotColor: "bg-unique-800"
    },
    [ResultIconConstant.AFTER_TEST_CASE_FAILURE]: {
      textColor: "!text-error-700",
      icon: "cancel-circle-outline",
      border: "!border-error-500",
      bgColor: "!bg-error-50",
      dotColor: "bg-error-700"
    }
  };
  return colorOptions[status] || null;
};
var isStepResultExpanded = (stepResult) => {
  const childResult = stepResult?.childResults?.[0];
  return stepResult?.stepDetails?.isStepGroup ? childResult?.stepGroupResultId === stepResult?.id && !!childResult?.show : !!childResult?.show;
};
var isStepGroupResultExpandedV2 = (stepResult) => {
  const childResult = stepResult?.childResults?.[0];
  return (childResult?.stepGroupResultUuid === stepResult?.uuid || childResult?.resultType === StepResultType.STEP_GROUP_ITERATION) && !!childResult?.show;
};
var isStepResultExpandedV2 = (stepResult) => {
  return stepResult?.isAllStepGroup ? isStepGroupResultExpandedV2(stepResult) : !!stepResult?.childResults?.[0]?.show;
};

// src/utils/common.util.ts
var isObjectEmpty = (object) => {
  return Object.keys(object).length === 0;
};
var isEmbeddedURL = (endpoint = "") => {
  const isIframe = window.location !== window.parent?.location;
  const hasMobileRecorder = window.location.href.includes("mobilerecorder");
  const hasSessionActions = endpoint.includes("session_actions");
  return isIframe && hasMobileRecorder || hasSessionActions;
};
var getBaseUrl = (endpoint = "") => {
  if (isEmbeddedURL(endpoint)) {
    return document.referrer?.slice(0, -1) || "";
  }
  return "";
};
var epochMillisecondsToDate = (timestamp) => {
  if (isNaN(timestamp)) {
    throw new Error("Invalid timestamp provided.");
  }
  const date = new Date(timestamp);
  if (isNaN(date.getTime())) {
    throw new Error("Invalid timestamp conversion.");
  }
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = String(date.getFullYear());
  return `${day}${month}${year}`;
};
var isValidRegex = (pattern) => {
  try {
    new RegExp(pattern);
    return true;
  } catch (e) {
    return false;
  }
};

// src/utils/encode-decode.util.ts
var encodeCustomSpecialCharacters = (value) => {
  const replaceMappings = {
    "'": "ts_single_quote",
    "!": "ts_negation",
    "~": "ts_like",
    " ": "ts_space",
    ":": "ts_colon",
    ";": "ts_semicolon",
    ">": "ts_greater_than",
    "<": "ts_lesser_than",
    "@": "ts_at_sign",
    "%": "ts_percentage",
    $: "ts_dollar_sign",
    "*": "ts_asterisk",
    "[": "ts_array_open",
    "]": "ts_array_close",
    ",": "ts_comma",
    "{": "ts_curly_open",
    "}": "ts_curly_close",
    "|": "ts_pipe",
    '"': "ts_double_quote",
    "?": "ts_question",
    "/": "ts_forward_slash",
    "`": "ts_tick",
    "+": "ts_plus",
    "=": "ts_equal",
    "(": "ts_round_open",
    ")": "ts_round_close"
  };
  return value?.replace(
    /[!~ :;><@%$*\[\],{}|\"?/`+=()']/g,
    (match) => replaceMappings[match] || match
  );
};
var encode = (value) => encodeURIComponent(encodeCustomSpecialCharacters(value));
var byPassSpecialCharacters = (query) => {
  const result = [];
  const keys = /* @__PURE__ */ new Set();
  query?.split(",")?.forEach((item) => {
    const operatorIndex = item.search(/[!~:;><@$]/);
    if (operatorIndex === -1) return;
    const searchKey = item.slice(0, operatorIndex);
    const searchValue = item.slice(operatorIndex + 1);
    if (keys.has(searchKey)) return;
    keys.add(searchKey);
    const encodedItem = `${item.slice(0, operatorIndex + 1)}${encode(
      searchValue
    )}`;
    result.push(encodedItem);
  });
  return result.join(",");
};
var decodeCustomSpecialCharacters = (value) => {
  const decodeMappings = {
    ts_single_quote: "'",
    ts_negation: "!",
    ts_like: "~",
    ts_space: " ",
    ts_colon: ":",
    ts_semicolon: ";",
    ts_greater_than: ">",
    ts_lesser_than: "<",
    ts_at_sign: "@",
    ts_percentage: "%",
    ts_dollar_sign: "$",
    ts_asterisk: "*",
    ts_array_open: "[",
    ts_array_close: "]",
    ts_comma: ",",
    ts_curly_open: "{",
    ts_curly_close: "}",
    ts_pipe: "|",
    ts_double_quote: '"',
    ts_question: "?",
    ts_forward_slash: "/",
    ts_tick: "`",
    ts_plus: "+",
    ts_equal: "=",
    ts_round_open: "(",
    ts_round_close: ")"
  };
  return Object.entries(decodeMappings).reduce(
    (acc, [encoded, original]) => acc.replace(new RegExp(encoded, "g"), original),
    value
  );
};
var decode = (value) => decodeCustomSpecialCharacters(decodeURIComponent(value));
var byPassSpecialCharactersInLikeOperator = (query) => {
  const regexLikeOperator = /:\*([\w\W]*?)\*,/g;
  const regexLikeEnd = /:\*([\w\W]*?)\*$/;
  let result = query;
  let match;
  while ((match = regexLikeOperator.exec(query)) !== null) {
    const [originalMatch, value] = match;
    const encodedValue = encodeCustomSpecialCharacters(value);
    result = result.replace(originalMatch, `:*${encodedValue}*,`);
  }
  if (result.endsWith("*")) {
    const lastIndex = result.lastIndexOf(":*");
    if (lastIndex !== -1) {
      const lastMatch = regexLikeEnd.exec(result.substring(lastIndex));
      if (lastMatch !== null) {
        const encodedValue = encodeCustomSpecialCharacters(lastMatch[1]);
        result = `${result.substring(0, lastIndex)}:*${encodedValue}*`;
      }
    }
  }
  return result;
};
var createTestStep = (testCaseId, stepOrder, stepNumber, indent, onChangeType, applicationType, options3 = {}) => {
  const {
    parentId = null,
    templateId = null,
    action = "",
    isAddedDirect = false,
    isDefaultFirstStep = false,
    isDeleteAfter = false
  } = options3;
  const isRestApplication = applicationType === ApplicationType.Rest;
  onChangeType({
    type: isRestApplication ? TestStepType.API_STEP : TestStepType.NLP_TEXT,
    isConditionalStep: false
  });
  const testStep = new TestStep();
  testStep.testCaseId = parseInt(testCaseId);
  testStep.stepOrder = stepOrder;
  testStep.stepNumber = stepNumber;
  testStep.indent = indent;
  testStep.applicationType = applicationType;
  testStep.waitTime = 30;
  testStep.smartActionsEnabled = true;
  testStep.priority = TestStepPriority.MAJOR;
  testStep.type = isRestApplication ? TestStepType.API_STEP : TestStepType.NLP_TEXT;
  testStep.disabled = false;
  testStep.maxRetries = 0;
  testStep.ignoreStepResult = false;
  if (!isDeleteAfter) testStep.isAddStep = true;
  if (parentId) testStep.parentId = parentId;
  if (templateId) testStep.templateId = templateId;
  if (action) testStep.action = action;
  if (isAddedDirect) testStep.isAddedDirect = isAddedDirect;
  if (isDefaultFirstStep) testStep.isDefaultFirstStep = isDefaultFirstStep;
  return testStep;
};
var _TS_LEVEL_DEBUG = [
  "%c[Testsigma] %cdebug",
  "color:#03a973",
  "color:#42A5F5"
];
var _TS_LEVEL_INFO = [
  "%c[Testsigma] %cinfo ",
  "color:#03a973",
  "color:#42A5F5"
];
var _TS_LEVEL_WARN = [
  "%c[Testsigma] %cwarn ",
  "color:#03a973",
  "color:#FFA000"
];
var _TS_LEVEL_ERROR = [
  "%c[Testsigma] %cerror",
  "color:#03a973",
  "color:#E64A19"
];
var _logIfEnabled = (level, marker, ...args) => {
};
var _logIfDevMode = (level, ...args) => {
  console.log(...level, ...args);
};
var log = {
  debug: (...args) => {
    _logIfDevMode(_TS_LEVEL_DEBUG, ...args);
  },
  info: (...args) => {
    _logIfDevMode(_TS_LEVEL_INFO, ...args);
  },
  warn: (...args) => {
    _logIfDevMode(_TS_LEVEL_WARN, ...args);
  },
  error: (...args) => {
    _logIfDevMode(_TS_LEVEL_ERROR, ...args);
  },
  // use for development only
  d: (marker, ...args) => _logIfEnabled("debug", marker, ...args),
  i: (marker, ...args) => _logIfEnabled("info", marker, ...args),
  w: (marker, ...args) => _logIfEnabled("warn", marker, ...args),
  e: (marker, ...args) => _logIfEnabled("error", marker, ...args),
  time: (label) => {
  },
  timeLog: (label, ...data) => {
  },
  timeEnd: (label) => {
  }
};

// src/utils/date-formatter.ts
var DateFormatter = class {
  static formatTimestamp(timestamp) {
    const date = new Date(timestamp);
    const options3 = {
      timeZone: "Etc/UTC",
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit"
    };
    return new Intl.DateTimeFormat("en-US", options3).format(date);
  }
};

// src/utils/array.util.ts
function moveItem(array, oldIndex, newIndex) {
  if (oldIndex === newIndex) return array;
  const validNewIndex = Math.min(Math.max(newIndex, 0), array.length);
  const item = array[oldIndex];
  const copyArray = [...array];
  copyArray.splice(oldIndex, 1);
  copyArray.splice(validNewIndex, 0, item);
  return copyArray;
}
function findAllChildren(elements, parentKey, parentValue, skipProperty) {
  const result = [];
  const findChildren = (parentId) => {
    const children = elements.filter(
      (element) => !element[skipProperty] && element[parentKey] === parentId
    );
    for (const child of children) {
      result.push(child);
      findChildren(child["id"]);
    }
  };
  findChildren(parentValue);
  return result;
}
function areArraysEqual(array1, array2) {
  if (!array1 || !array2) return false;
  if (array1.length !== array2.length) return false;
  return array1.every((element, index) => Object.is(element, array2[index]));
}
function removeFromArray(array, element) {
  return array.filter((item) => item !== element);
}
function arrayInsertAt(array, index, item) {
  const validIndex = Math.max(index < 0 ? array.length + index : index, 0);
  return [...array.slice(0, validIndex), item, ...array.slice(validIndex)];
}
function findAllParents(elements, parentId) {
  const result = [];
  const findParent = (id) => {
    const parent = elements.find((item) => item?.["id"] === id);
    if (parent) {
      result.push(parent);
      findParent(parent?.["parentId"]);
    }
  };
  findParent(parentId);
  return result;
}

// src/utils/image.util.ts
function cropImage(base64Image, cropCoords, options3) {
  const canvasWidth = options3?.canvasWidth || window.innerWidth;
  const canvasHeight = options3?.canvasHeight || window.innerHeight;
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = base64Image;
    img.onload = () => {
      const { x, y, width, height, devicePixelRatio } = cropCoords;
      const originalWidth = img.naturalWidth;
      const originalHeight = img.naturalHeight;
      const scaleX = canvasWidth ? originalWidth / canvasWidth : 1;
      const scaleY = canvasHeight ? originalHeight / canvasHeight : 1;
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = width;
      canvas.height = height;
      const scaledX = x * scaleX;
      const scaledY = y * scaleY;
      const scaledWidth = width * scaleX;
      const scaledHeight = height * scaleY;
      ctx.drawImage(
        img,
        scaledX,
        scaledY,
        // Source image (x, y)
        scaledWidth,
        scaledHeight,
        // Source image (width, height)
        0,
        0,
        // Destination canvas (x, y)
        width,
        height
        // Destination canvas (width, height)
      );
      const croppedBase64Image = canvas.toDataURL("image/png");
      resolve(croppedBase64Image);
    };
    img.onerror = (err) => {
      reject(err);
    };
  });
}
function highlightImage(base64Image, cropCoords, options3) {
  const canvasWidth = options3?.canvasWidth || window.innerWidth;
  const canvasHeight = options3?.canvasHeight || window.innerHeight;
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = base64Image;
    img.onload = () => {
      const { x, y, width, height, devicePixelRatio } = cropCoords;
      const originalWidth = img.naturalWidth;
      const originalHeight = img.naturalHeight;
      const scaleX = canvasWidth ? originalWidth / canvasWidth : 1;
      const scaleY = canvasHeight ? originalHeight / canvasHeight : 1;
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0, img.width, img.height);
      const scaledX = x * scaleX;
      const scaledY = y * scaleY;
      const scaledCropWidth = width * scaleX;
      const scaledCropHeight = height * scaleY;
      ctx.lineWidth = 4;
      ctx.strokeStyle = "red";
      ctx.strokeRect(scaledX, scaledY, scaledCropWidth, scaledCropHeight);
      const highlightedBase64Image = canvas.toDataURL("image/png");
      resolve(highlightedBase64Image);
    };
    img.onerror = (err) => {
      reject(err);
    };
  });
}
function resizeAndCompressImage(base64Image, quality = 0.8, downBy = 2) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = base64Image;
    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const newWidth = img.width / downBy;
      const newHeight = img.height / downBy;
      canvas.width = newWidth;
      canvas.height = newHeight;
      ctx.drawImage(img, 0, 0, newWidth, newHeight);
      canvas.toBlob(
        (blob) => {
          if (blob) {
            const reader = new FileReader();
            reader.onloadend = () => {
              resolve(reader.result);
            };
            reader.readAsDataURL(blob);
          } else {
            reject(new Error("Image compression failed"));
          }
        },
        "image/jpeg",
        // You can also use 'image/png' if needed
        quality
        // Quality from 0 to 1 (0 being lowest quality, 1 being highest)
      );
    };
    img.onerror = (err) => {
      reject(err);
    };
  });
}
var AlgoliaClient = class _AlgoliaClient {
  typsenseClient = null;
  appType = "WebApplication";
  static config = null;
  constructor({ appType }) {
    this.appType = appType;
    this.initClient();
  }
  initClient() {
    if (!_AlgoliaClient.config) {
      throw new Error("Typesense config is not set");
    }
    this.typsenseClient = new Client({
      apiKey: _AlgoliaClient.config.API_KEY || "",
      // Be sure to use an API key that only allows searches, in production
      nodes: [
        {
          host: _AlgoliaClient.config.HOST || "",
          // Replace with your Typesense host
          port: Number(_AlgoliaClient.config.PORT || 8108),
          // Replace with your Typesense port
          protocol: _AlgoliaClient.config.PROTOCOL || ""
          // Replace with http or https
        }
      ]
    });
  }
  getTemplatesFromAlgolia(searchKey, stepActionType = null, hitsPerPage = 100, action) {
    return new Promise((resolve, reject) => {
      const searchParameters = {
        q: searchKey || "*",
        query_by: "grammar,keywords",
        filter_by: `${stepActionType ? `stepActionType:${stepActionType}&&` : ""}${action ? `action:${action}&&` : ""}applicationType:${this.appType}`,
        per_page: hitsPerPage,
        // Replace with the fields you want to retrieve,
        sort_by: "position:asc"
      };
      this.typsenseClient.collections(_AlgoliaClient.config.COLLECTION_NAME || "").documents().search(searchParameters).then((response) => {
        resolve(
          response?.hits?.map((item) => {
            const typesense = new AlgoliaTemplate().deserialize(
              item.document
            );
            typesense.queryID = response.queryID;
            return typesense;
          }) || []
        );
      }).catch((error) => {
        reject(error);
      });
    });
  }
};
var getAlgoliaInstance = ({ appType }) => new AlgoliaClient({ appType });
var Api = class _Api {
  static baseUrl;
  static authToken;
  static fetch;
  constructor() {
    _Api.fetch = window.fetch.bind(window);
  }
  getAuthToken = async () => {
    const authToken = _Api.authToken;
    if (!authToken) {
      return;
    }
    return { Authorization: `Bearer ${authToken}` };
  };
  getBaseUrl = async () => {
    const baseUrl = _Api.baseUrl;
    return baseUrl || "";
  };
  createPutRequest = (endpoint, data) => {
    return async (baseURL, authHeader) => {
      const response = await _Api.fetch(baseURL + endpoint, {
        method: "PUT",
        body: JSON.stringify(data),
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          ...authHeader
        }
      });
      const content = await response.text();
      log.info("PUT", LOG.API.SUCCESS, endpoint, content);
      const _data = JSON.parse(content === "" ? JSON.stringify({}) : content);
      if (_data.error) {
        log.error("PUT", LOG.API.ERROR, endpoint, data);
        return _data;
      } else {
        log.info("PUT", LOG.API.SUCCESS, endpoint, data);
        return _data;
      }
    };
  };
  get = (endpoint, params, options3) => new Promise(async (resolve, reject) => {
    const baseURL = await this.getBaseUrl();
    const authToken = await this.getAuthToken();
    const {
      headers = {},
      responseParser = void 0,
      shouldIgnoreBaseUrl = false
    } = options3 || {};
    let url = "";
    if (shouldIgnoreBaseUrl) {
      url = endpoint;
    } else {
      url = baseURL + endpoint;
    }
    if (params) {
      if (params?.query && params?.query?.includes(":*")) {
        params.query = byPassSpecialCharactersInLikeOperator2(params?.query);
      }
      url += "?" + new URLSearchParams(params);
    }
    return _Api.fetch(url, {
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        ...authToken,
        ...headers
      }
    }).then((response) => {
      if (response?.status === 401) {
        reject(response);
      }
      if (responseParser) {
        return responseParser(response);
      }
      return response.json();
    }).then((data) => {
      log.info("GET", LOG.API.SUCCESS, endpoint);
      resolve(data);
    }).catch((error) => {
      log.info("GET", LOG.API.ERROR, endpoint, error);
      reject(error);
    });
  });
  post = (endpoint, data, abortSignal) => new Promise(async (resolve, reject) => {
    const baseURL = await this.getBaseUrl();
    const authToken = await this.getAuthToken();
    _Api.fetch(baseURL + endpoint, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        ...authToken
      },
      signal: abortSignal
    }).then(async (response) => {
      const content = await response.text();
      log.info("POST", LOG.API.SUCCESS, endpoint, content, response);
      const parsedData = JSON.parse(content === "" ? JSON.stringify({}) : content);
      if (!response.ok || parsedData.error) {
        throw parsedData;
      }
      return parsedData;
    }).then((data2) => {
      log.info("POST", LOG.API.SUCCESS, endpoint, data2);
      resolve(data2);
    }).catch((error) => {
      log.error("POST", LOG.API.ERROR, endpoint, error);
      reject(error);
    });
  });
  put = async (endpoint, data) => {
    const baseURL = await this.getBaseUrl();
    const authHeader = await this.getAuthToken();
    const putRequest = this.createPutRequest(endpoint, data);
    return putRequest(baseURL, authHeader);
  };
  patch = (endpoint, data, abortSignal) => new Promise(async (resolve, reject) => {
    const baseURL = await this.getBaseUrl();
    const authToken = await this.getAuthToken();
    _Api.fetch(baseURL + endpoint, {
      method: "PATCH",
      body: JSON.stringify(data),
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        ...authToken
      },
      signal: abortSignal
    }).then(async (response) => {
      const content = await response.text();
      log.info("PATCH", LOG.API.SUCCESS, endpoint, content, response);
      return JSON.parse(content === "" ? JSON.stringify({}) : content);
    }).then((data2) => {
      log.info("PATCH", LOG.API.SUCCESS, endpoint, data2);
      resolve(data2);
    }).catch((error) => {
      log.error("PATCH", LOG.API.ERROR, endpoint, error);
      reject(error);
    });
  });
  putForm = async (endpoint, data) => {
    const baseURL = await this.getBaseUrl();
    const authToken = await this.getAuthToken();
    return _Api.fetch(baseURL + endpoint, {
      method: "PUT",
      body: data,
      credentials: "include",
      headers: {
        ...authToken
      }
    }).then(async (response) => {
      const content = await response.text();
      log.info("PUT", LOG.API.SUCCESS, endpoint, content);
      return JSON.parse(content === "" ? JSON.stringify({}) : content);
    }).then((data2) => {
      if (data2.error) {
        log.error("PUT", LOG.API.ERROR, endpoint, data2);
        return data2;
      } else {
        log.info("PUT", LOG.API.SUCCESS, endpoint, data2);
        return data2;
      }
    });
  };
  remove = (endpoint) => new Promise(async (resolve, reject) => {
    const baseURL = await this.getBaseUrl();
    const authToken = await this.getAuthToken();
    _Api.fetch(baseURL + endpoint, {
      method: "DELETE",
      credentials: "include",
      headers: {
        ...authToken
      }
    }).then(() => {
      log.info("DELETE", LOG.API.SUCCESS, endpoint);
      resolve();
    }).catch((error) => {
      log.info("DELETE", LOG.API.ERROR, endpoint, error);
      reject(error);
    });
  });
  postForm = (endpoint, data, abortSignal) => new Promise(async (resolve, reject) => {
    const baseURL = await this.getBaseUrl();
    const authToken = await this.getAuthToken();
    try {
      const response = await _Api.fetch(baseURL + endpoint, {
        method: "POST",
        body: data,
        credentials: "include",
        headers: {
          ...authToken
        },
        signal: abortSignal
      });
      const content = await response.text();
      log.info(
        "POST",
        "RESPONSE",
        endpoint,
        response.status,
        content.substring(0, 200)
      );
      if (!response.ok) {
        let errorMessage = `Request failed with status ${response.status}`;
        try {
          const errorData = JSON.parse(content);
          errorMessage = errorData.detail || errorData.message || errorData.error || errorMessage;
        } catch {
          if (content) {
            errorMessage = content.substring(0, 200);
          }
        }
        const error = new Error(errorMessage);
        error.status = response.status;
        error.statusText = response.statusText;
        log.error(
          "POST",
          LOG.API.ERROR,
          endpoint,
          response.status,
          errorMessage
        );
        reject(error);
        return;
      }
      const parsedData = content === "" ? {} : JSON.parse(content);
      log.info("POST", LOG.API.SUCCESS, endpoint, parsedData);
      if (parsedData.error) {
        reject(parsedData);
      } else {
        resolve(parsedData);
      }
    } catch (error) {
      log.error("POST", LOG.API.ERROR, endpoint, error);
      reject(error);
    }
  });
  getCommonVariables = async () => {
    const baseURL = await this.getBaseUrl();
    const authToken = await this.getAuthToken();
    return { baseURL, authToken };
  };
};
var api = new Api();
var instance_default = api;

// src/components/test-recorder/api/recorder-assets.ts
var namespace = "/recorder_assets";
var taskQueue = [];
var isExecuting = false;
function enqueue(task) {
  taskQueue.push(task);
  if (!isExecuting) {
    executeNextTask();
  }
}
async function executeNextTask(prevResult) {
  if (taskQueue.length === 0) {
    isExecuting = false;
    return;
  }
  isExecuting = true;
  const task = taskQueue.shift();
  if (task) {
    try {
      const result = await task(prevResult);
      executeNextTask(result);
    } catch (error) {
      console.error("Task execution failed:", error);
      executeNextTask();
    }
  }
}
var RecorderAssetsApi = {
  saveLocatorTree: async (elementId, payload) => {
    const { baseURL, authToken } = await instance_default.getCommonVariables();
    const task = async (prevResult) => {
      const lastUuid = prevResult?.lastUuid;
      const body = {};
      if (lastUuid === payload.uuid) {
        body.locatorTreeId = prevResult.locatorTreeId;
      } else {
        body.locatorTree = JSON.stringify(payload.root);
      }
      const request = instance_default.createPutRequest(
        `${namespace}/element/${elementId}/locator_tree`,
        body
      );
      const result = await request(baseURL, authToken);
      return {
        ...result,
        lastUuid: payload.uuid
      };
    };
    enqueue(task);
  },
  getElementScreenshot: async (request) => {
    return await instance_default.get(
      `${namespace}/element/${request.elementId}/element_screenshot?applicationVersionId=${request.applicationVersionId}`
    );
  },
  saveElementScreenshot: (elementId, payload) => {
    const formData = new FormData();
    formData.append("screenshotFile", payload.screenshotFile);
    formData.append(
      "applicationVersionId",
      payload.applicationVersionId.toString()
    );
    return instance_default.putForm(
      `${namespace}/element/${elementId}/element_screenshot`,
      formData
    );
  },
  saveCroppedElementScreenshot: (elementId, payload) => {
    const formData = new FormData();
    formData.append("screenshotFile", payload.screenshotFile);
    formData.append(
      "applicationVersionId",
      payload.applicationVersionId.toString()
    );
    return instance_default.putForm(
      `${namespace}/element/${elementId}/cropped_element_screenshot`,
      formData
    );
  }
};

// src/components/test-recorder/utils/utils.ts
var isNumber = (obj) => obj !== void 0 && obj !== null && typeof obj === "number";
var findAllChildren2 = (elements, parentKey, parentValue) => {
  const result = [];
  function findChildren(parentId) {
    const children = elements.filter(
      (element) => element[parentKey] === parentId
    );
    for (const child of children) {
      result.push(child);
      findChildren(child.id);
    }
  }
  findChildren(parentValue);
  return result;
};
function dataurltoBlob(dataUrl) {
  const byteString = atob(dataUrl.split(",")[1]);
  const mimeString = dataUrl.split(",")[0].split(":")[1].split(";")[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: mimeString });
}
function dataurltoFile(dataUrl, filename = "file") {
  const blob = dataurltoBlob(dataUrl);
  return new File([blob], filename, { type: blob.type });
}
var convertToOrganismStep = (step) => {
  const newStep = { ...step };
  newStep.isWebRecorderStep = true;
  step.stepDataList?.forEach((item) => {
    if (item.uploadIdList === "null") item.uploadIdList = void 0;
  });
  newStep.show = false;
  newStep.level = void 0;
  newStep.seq = void 0;
  newStep.groupSeq = void 0;
  newStep.isAddStep = Boolean(newStep.isAddStep);
  if (step.conditionType === null) {
    newStep.conditionType = void 0;
  }
  if (step.testStepDataOverRiddenMappings === null) {
    newStep.testStepDataOverRiddenMappings = void 0;
  }
  if (step.uiIdentifierOverRiddenMappings === null) {
    newStep.uiIdentifierOverRiddenMappings = void 0;
  }
  if (step.salesforceAPIStep === null) {
    newStep.salesforceAPIStep = void 0;
  }
  if (!step.elementOverride) {
    newStep.elementOverride = [];
  }
  if (!step.testdataOverride) {
    newStep.testdataOverride = [];
  }
  if (!step.forloopOverride) {
    newStep.forloopOverride = [];
  }
  if (step.forLoopCondition === null) {
    newStep.forLoopCondition = void 0;
  }
  if (step.stepGroupId === null) {
    newStep.stepGroupId = void 0;
  }
  newStep.localStep = null;
  if (newStep.restStep === null) {
    delete newStep.restStep;
  }
  return newStep;
};
var convertToOrganismSteps = (stepsList) => {
  const orgsteps = stepsList?.map((step) => convertToOrganismStep(step));
  return orgsteps;
};
var createTestStep2 = (newStep, where, stepOrder, stepNumber, indent, applicationType, testCaseId, parentId) => {
  const testStep = {};
  testStep.testCaseId = testCaseId;
  if (newStep?.conditionType) {
    testStep.conditionType = newStep?.conditionType;
  }
  testStep.stepOrder = stepOrder;
  testStep.waitTime = 30;
  testStep.smartActionsEnabled = true;
  testStep.priority = STEP_PRIORITY.MAJOR;
  testStep.type = applicationType === ApplicationType.Rest ? TestStepType.API_STEP : TestStepType.NLP_TEXT;
  testStep.stepNumber = stepNumber;
  testStep.indent = indent;
  testStep.disabled = false;
  testStep.applicationType = applicationType;
  testStep.maxRetries = 0;
  testStep.ignoreStepResult = false;
  testStep.isAddStep = newStep?.isAddStep;
  if (parentId) {
    testStep.parentId = parentId;
  }
  if (newStep == null) {
    return testStep;
  }
  if (newStep.blockParentId) {
    testStep.blockParentId = newStep.blockParentId;
  } else if (isBlock(newStep) && where === "inside") {
    testStep.blockParentId = newStep.id;
  }
  return testStep;
};
var saveHostElementLocatorTrees = (eventHosts, savedHosts) => {
  const locatorTreeRequests = [];
  eventHosts?.forEach((eventHost, index) => {
    if (eventHost.hostType === ElementIdentifierHostType.IFRAME) {
      const matchingSavedHost = savedHosts?.[index];
      if (matchingSavedHost && eventHost.locatorTree && matchingSavedHost.id) {
        locatorTreeRequests.push({
          elementId: matchingSavedHost.id,
          locatorTree: eventHost.locatorTree
        });
      }
    }
  });
  for (const request of locatorTreeRequests) {
    RecorderAssetsApi.saveLocatorTree(request.elementId, request.locatorTree);
  }
};
var elementName = {
  button: (eventData) => `${eventData.text} ${capitalizeFirstLetter(TAG_NAME.BUTTON)}`,
  input: (eventData) => {
    if (eventData.attrs.name && eventData.attrs.name !== "") {
      return `${capitalizeFirstLetter(eventData.attrs.name.toString())} Field`;
    } else if (eventData.attrs.id && eventData.attrs.id !== "") {
      return `${capitalizeFirstLetter(eventData.attrs.id.toString())} Field`;
    } else {
      return `${capitalizeFirstLetter(
        (eventData.attrs.type || "text").toString()
      )} Field`;
    }
  },
  text: (eventData) => {
    if (eventData.text && eventData.text.trim() !== "") {
      return `${eventData.text?.trim().substring(0, 25)}`;
    } else if (eventData.attrs.id) {
      return `${eventData.attrs.id}`;
    } else {
      return capitalizeFirstLetter(eventData.tag);
    }
  },
  iframe: (eventData) => `Frame ${(eventData.attrs.src || eventData.attrs.name || eventData.attrs.title || "").toString().substring(0, 25)}`,
  select: (eventData) => {
    if (eventData.attrs.name) {
      return `${capitalizeFirstLetter(eventData.attrs.name.toString())} Field`;
    } else {
      return `${capitalizeFirstLetter(eventData.tag)} Field`;
    }
  },
  image: (eventData) => `${eventData.tag} ${eventData.attrs.src.toString().substring(0, 25)}`,
  link: (eventData) => `${(eventData.text || eventData.attrs.href)?.toString().trim()} Link`
};
var getIdentifierName = (eventData) => {
  let identifierName = "";
  switch (eventData.tag) {
    case TAG_NAME.BUTTON:
      identifierName = elementName.button(eventData);
      break;
    case TAG_NAME.INPUT:
      identifierName = elementName.input(eventData);
      break;
    case TAG_NAME.DIV:
    case TAG_NAME.H1:
    case TAG_NAME.H2:
    case TAG_NAME.H3:
    case TAG_NAME.H4:
    case TAG_NAME.H5:
    case TAG_NAME.H6:
    case TAG_NAME.SECTION:
    case TAG_NAME.PARAGRAPH:
    case TAG_NAME.SPAN:
      identifierName = elementName.text(eventData);
      break;
    case TAG_NAME.IFRAME:
      identifierName = elementName.iframe(eventData);
      break;
    case TAG_NAME.SELECT:
      identifierName = elementName.select(eventData);
      break;
    case TAG_NAME.IMG:
      identifierName = elementName.image(eventData);
      break;
    case TAG_NAME.ANCHOR:
      identifierName = elementName.link(eventData);
      break;
    default:
      if (eventData.tag) {
        identifierName += capitalizeFirstLetter(eventData.tag);
      }
      if (eventData.attrs.name) {
        identifierName += " " + eventData.attrs.name;
      }
      if (eventData.text) {
        identifierName += " " + eventData.text.substring(0, 25);
      }
      if (eventData.attrs.hasOwnProperty("position")) {
        identifierName += "position " + eventData.attrs.position;
      }
      break;
  }
  return replaceSpecialChars(identifierName) + " " + getRandomString();
};

// src/components/test-recorder/web-recorder/context/global-context-functions.ts
var globalState = null;
var globalDispatch = null;
var sendToBackground;
var setGlobalGetState = (fn) => {
  globalState = fn;
};
var setGlobalGetDispatch = (fn) => {
  const wrappedDispatch = ((action) => {
    return new Promise((resolve) => {
      fn(action);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          resolve(action);
        });
      });
    });
  });
  globalDispatch = wrappedDispatch;
};
var setSendToBackground = (fn) => {
  sendToBackground = fn;
};
var getGlobalDispatch = () => {
  if (!globalDispatch) {
    throw new Error(
      "dispatch function not initialized. Make sure it is set from the Widget component."
    );
  }
  return globalDispatch;
};
var getGlobalState = () => {
  if (!globalState) {
    throw new Error(
      "getState function not initialized. Make sure it is set from the Widget component."
    );
  }
  return globalState();
};
var getSendToBackground = () => {
  if (!sendToBackground) {
    throw new Error(
      "sendToContent function not initialized. Make sure it is set from the Widget component."
    );
  }
  return sendToBackground;
};
var WidgetSlicePersistKey = "widget-core";
var initialState = {
  recorderState: null,
  enableClickHover: false,
  templates: [],
  locatedElement: null,
  verifyTimeout: null,
  createdElement: null,
  projectId: null,
  testCase: null,
  testSteps: [],
  userStepsData: {
    steps: [],
    cursor: null,
    lastStep: null
  },
  screens: [],
  addonTemplates: [],
  isEnableReorder: false,
  reorderedSteps: [],
  appVersionId: null,
  appVersion: null,
  stepGroups: [],
  dataProfiles: [],
  algoliaTemplates: [],
  recorderPreferences: null,
  isRecorderLoaded: false,
  isShowHelpScreen: false,
  showUsageScreen: false,
  uiIdentifiers: [],
  recorderType: null,
  isMinimized: false,
  applicationId: null,
  enableSaveElement: false,
  recorderSource: "",
  appType: null,
  stepCursor: null,
  isSfOrgChanged: false,
  tenantFeatures: [],
  tenantPreference: {},
  copilotData: null,
  copilotChatHistory: null,
  apiUrl: null,
  loaderMessage: null,
  copilotWindowOpenState: false,
  isExtensionPage: true,
  stepCreationInProgress: 0,
  reconfInProgress: false,
  isDesktopRecorderActionLoading: false,
  modifiedSteps: {}
};
var widgetSlice = createSlice({
  name: WidgetSlicePersistKey,
  initialState,
  reducers: {
    // Recorder state updates
    updateRecorderState(state, action) {
      state.recorderState = action.payload;
    },
    setEnableClickHover(state, action) {
      state.enableClickHover = action.payload;
    },
    setTemplates(state, action) {
      state.templates = action.payload;
    },
    setLocatedElement(state, action) {
      state.locatedElement = action.payload;
    },
    // Test related updates
    updateTestCase(state, action) {
      state.testCase = action.payload;
    },
    updateTestSteps(state, action) {
      state.testSteps = action.payload;
      state.userStepsData.steps = action.payload;
    },
    updateUserStepsData(state, action) {
      state.userStepsData = action.payload;
    },
    updateLastStep(state, action) {
      state.userStepsData.lastStep = action.payload;
    },
    updateUserStepsCursor(state, action) {
      state.userStepsData.cursor = action.payload;
    },
    // UI state updates
    setIsRecorderLoaded(state, action) {
      state.isRecorderLoaded = action.payload;
    },
    setIsMinimized(state, action) {
      state.isMinimized = action.payload;
    },
    // Application state updates
    setScreens(state, action) {
      state.screens = action.payload;
    },
    setAddonTemplates(state, action) {
      state.addonTemplates = action.payload;
    },
    setIsEnableReorder(state, action) {
      state.isEnableReorder = action.payload;
    },
    setReorderedSteps(state, action) {
      state.reorderedSteps = action.payload;
    },
    setAppVersionId(state, action) {
      state.appVersionId = action.payload;
    },
    setAppVersion(state, action) {
      state.appVersion = action.payload;
    },
    setStepGroups(state, action) {
      state.stepGroups = action.payload;
    },
    setDataProfiles(state, action) {
      state.dataProfiles = action.payload;
    },
    setModifiedSteps(state, action) {
      for (const key in action.payload) {
        state.modifiedSteps[key] = state.modifiedSteps[key] || [];
        state.modifiedSteps[key] = union(
          state.modifiedSteps[key],
          action.payload[key] || []
        );
      }
    },
    setAlgoliaTemplates(state, action) {
      state.algoliaTemplates = action.payload;
    },
    setRecorderPreferences(state, action) {
      state.recorderPreferences = action.payload;
    },
    setUiIdentifiers(state, action) {
      state.uiIdentifiers = action.payload;
    },
    setRecorderType(state, action) {
      state.recorderType = action.payload;
    },
    setApplicationId(state, action) {
      state.applicationId = action.payload;
    },
    setEnableSaveElement(state, action) {
      state.enableSaveElement = action.payload;
    },
    setRecorderSource(state, action) {
      state.recorderSource = action.payload;
    },
    setAppType(state, action) {
      state.appType = action.payload;
    },
    setStepCursor(state, action) {
      state.stepCursor = action.payload;
    },
    setIsSfOrgChanged(state, action) {
      state.isSfOrgChanged = action.payload;
    },
    // Features and preferences updates
    setTenantFeatures(state, action) {
      state.tenantFeatures = action.payload;
    },
    setTenantPreference(state, action) {
      state.tenantPreference = action.payload;
    },
    // Copilot related updates
    setCopilotData(state, action) {
      state.copilotData = action.payload;
    },
    setCopilotChatHistory(state, action) {
      state.copilotChatHistory = action.payload;
    },
    setCopilotWindowOpenState(state, action) {
      state.copilotWindowOpenState = action.payload;
    },
    // Other updates
    setApiUrl(state, action) {
      state.apiUrl = action.payload;
    },
    setLoaderMessage(state, action) {
      state.loaderMessage = action.payload;
    },
    setIsExtensionPage(state, action) {
      state.isExtensionPage = action.payload;
    },
    setStepCreationInProgress(state, action) {
      state.stepCreationInProgress = state.stepCreationInProgress + action.payload;
    },
    setVerifyTimeout(state, action) {
      if (action.payload === null) {
        clearTimeout(state.verifyTimeout);
      }
      state.verifyTimeout = action.payload;
    },
    setCreatedElement(state, action) {
      state.createdElement = action.payload;
    },
    setProjectId(state, action) {
      state.projectId = action.payload;
    },
    setIsShowHelpScreen(state, action) {
      state.isShowHelpScreen = action.payload;
    },
    setShowUsageScreen(state, action) {
      state.showUsageScreen = action.payload;
    },
    setReconfInProgress(state, action) {
      state.reconfInProgress = action.payload;
    },
    setIsDesktopRecorderActionLoading(state, action) {
      state.isDesktopRecorderActionLoading = action.payload;
    },
    resetWidgetSliceState(state) {
      Object.assign(state, initialState);
    }
  }
});
var {
  updateRecorderState,
  setEnableClickHover,
  setTemplates,
  setLocatedElement,
  updateTestCase,
  updateTestSteps,
  updateUserStepsData,
  updateLastStep,
  updateUserStepsCursor,
  setIsRecorderLoaded,
  setIsMinimized,
  setScreens,
  setAddonTemplates,
  setIsEnableReorder,
  setReorderedSteps,
  setAppVersionId,
  setAppVersion,
  setStepGroups,
  setDataProfiles,
  setAlgoliaTemplates,
  setRecorderPreferences,
  setUiIdentifiers,
  setRecorderType,
  setApplicationId,
  setEnableSaveElement,
  setRecorderSource,
  setAppType,
  setStepCursor,
  setIsSfOrgChanged,
  setTenantFeatures,
  setTenantPreference,
  setCopilotData,
  setCopilotChatHistory,
  setCopilotWindowOpenState,
  setApiUrl,
  setLoaderMessage,
  setIsExtensionPage,
  setStepCreationInProgress,
  setVerifyTimeout,
  setCreatedElement,
  setProjectId,
  setIsShowHelpScreen,
  setShowUsageScreen,
  setReconfInProgress,
  setIsDesktopRecorderActionLoading,
  resetWidgetSliceState,
  setModifiedSteps
} = widgetSlice.actions;
var widgetReducer = widgetSlice.reducer;

// src/components/test-recorder/utils/element/element.ts
var isDyanamicId = (id) => typeof id === "string" && (isStrHasNumber(id) || EXCLUDE_CONFIG.KEYWORDS.some((key) => id.includes(key)));
var replaceSpecialCharWithDescText = (value) => {
  const replaceMappings = {
    "'": "ts_single_quote",
    "!": "ts_negation",
    "~": "ts_like",
    " ": "ts_space",
    ":": "ts_colon",
    ";": "ts_semicolon",
    ">": "ts_greater_than",
    "<": "ts_lesser_than",
    "@": "ts_at_sign",
    "%": "ts_percentage",
    $: "ts_dollar_sign",
    "*": "ts_asterisk",
    "[": "ts_array_open",
    "]": "ts_array_close",
    ",": "ts_comma",
    "{": "ts_curly_open",
    "}": "ts_curly_close",
    "|": "ts_pipe",
    '"': "ts_double_quote",
    "?": "ts_question",
    "/": "ts_forward_slash",
    "`": "ts_tick",
    "+": "ts_plus",
    "=": "ts_equal"
  };
  const replaceSpecialCharacters = (input) => input?.replace(
    /[!~ :;><@%$*\[\],{}|\"?/`+=']/g,
    (match) => replaceMappings[match]
  );
  return replaceSpecialCharacters(value);
};
var byPassSpecialCharactersInLikeOperator2 = (query) => {
  const regex = /:\*([\w\W]*?)\*,/g;
  let match;
  let result = query;
  while ((match = regex.exec(query)) !== null) {
    const originalMatch = match[0];
    const value = match[1];
    const encodedValue = replaceSpecialCharWithDescText(value);
    result = result.replace(originalMatch, `:*${encodedValue}*,`);
  }
  if (result.endsWith("*")) {
    const lastIndex = result.lastIndexOf(":*");
    if (lastIndex !== -1) {
      const substring = result.substring(lastIndex);
      const regex_end = /:\*([\w\W]*?)\*$/;
      const lastMatch = regex_end.exec(substring);
      if (lastMatch !== null) {
        const value = lastMatch[1];
        const encodedValue = replaceSpecialCharWithDescText(value);
        result = result.substring(0, lastIndex) + `:*${encodedValue}*`;
      }
    }
  }
  return result;
};
var processElementContext = (elementData) => {
  if (elementData.elementContext) {
    elementData.elementContext = elementData.elementContext.map(
      (element, index) => ({
        ...element,
        screenNameId: elementData.screenNameId,
        name: element.name ? element.name : elementData.name + "_" + Math.floor(1e5 + Math.random() * 9e5).toString() + "_Host(" + (index + 1) + ")",
        createdType: elementData.createdType,
        applicationVersionId: elementData.applicationVersionId,
        hostOrder: index + 1
      })
    );
  }
};
var getDifinitionByLocatorType = (newElementData) => {
  let definition = "";
  switch (newElementData.locatorType) {
    case STEP_LOCATOR.XPATH.value:
      definition = newElementData?.xPath || "";
      break;
    case STEP_LOCATOR.CSS_LOCATOR.value:
      definition = newElementData?.cssPath || "";
      break;
    case STEP_LOCATOR.ID.value:
      definition = newElementData?.idSelector || "";
      break;
    case STEP_LOCATOR.LINK_TEXT.value:
      definition = newElementData?.linkText || "";
      break;
    case STEP_LOCATOR.NAME.value:
      definition = newElementData?.nameAttr || "";
      break;
  }
  return definition;
};
var getIdentifierDetails = async (eventData) => {
  const screen = await getScreen(eventData.screenTitle);
  const appVersionId = getGlobalState()?.widget.appVersionId;
  if (!appVersionId) {
    throw new Error("appVersionId unavailable in getIdentifierDetails");
  }
  const flutterCoordinates = eventData.coOrdinates?.clientX ? `${eventData.coOrdinates?.clientX},${eventData.coOrdinates?.clientY}` : void 0;
  const hasDraftScreenShotImages = Object.keys(eventData?.elementImageDraft || {}).length > 0;
  const { definition, locatorType } = await getDefinitionAndLocatorType(
    eventData
  );
  const hostElements = await getHostElements(
    eventData,
    screen.id,
    appVersionId
  );
  return {
    name: eventData.name ? eventData.name : getIdentifierName(eventData),
    definition,
    attrs: eventData.attrs,
    createdType: SOURCE,
    updateType: eventData.updateType || SOURCE,
    locatorType,
    screenShotData: eventData.screenshot,
    screenNameId: screen.id,
    currentElement: {
      textContent: eventData.text,
      tag: eventData.tag
    },
    screenNameObj: screen,
    applicationVersionId: appVersionId,
    parents: eventData.parents,
    isDynamic: eventData.isDynamicElement,
    hostElements,
    flutterCoordinates,
    imageLocatorOccurence: eventData?.imageLocatorOccurence,
    ...hasDraftScreenShotImages ? { elementImageDraft: eventData?.elementImageDraft } : {}
  };
};
var getScreen = async (screenTitle) => {
  const screens = getGlobalState()?.widget.screens || [];
  const screen = screens.find((item) => item.name === screenTitle);
  if (screen) {
    return screen;
  } else {
    const appVersionId = getGlobalState()?.widget.appVersionId;
    if (!appVersionId) {
      throw new Error("appVersionId unavailable, cannot fetch screen");
    }
    const createdScreen = await ScreenApi.create(
      screenTitle,
      appVersionId
    );
    const updatedScreens = [...screens, createdScreen];
    await getGlobalDispatch()(setScreens(updatedScreens));
    return createdScreen;
  }
};
var getDefinitionAndLocatorType = async (eventData, isIframeHost) => {
  const appVersionId = getGlobalState()?.widget.appVersionId;
  const recorderPreferences = getGlobalState()?.widget.recorderPreferences;
  const locatorPrecedence = recorderPreferences?.preferences?.find((item) => item.type === PREFERENCE_TYPE.LOCATOR_ORDER)?.preference?.locator?.reduce((acc, id) => {
    const match = DEFAULT_LOCATOR_PRECEDENCE[ApplicationType.WebApplication].find((pref) => pref.id === id);
    if (match) acc.push(match);
    return acc;
  }, []) ?? [];
  if (!appVersionId) {
    throw new Error("appVersionId unavailable in getIdentifierDetails");
  }
  let definition = "";
  let locatorType = eventData.locatorType || STEP_LOCATOR.XPATH.value;
  const precedenceToUse = locatorPrecedence && locatorPrecedence.length > 0 ? locatorPrecedence : DEFAULT_LOCATOR_PRECEDENCE[ApplicationType.WebApplication];
  for (const locator of precedenceToUse) {
    let value;
    switch (locator?.locator) {
      case STEP_LOCATOR.ID.value:
        value = eventData?.attrs?.id ?? "";
        if (value && canIgnoreId(value)) continue;
        break;
      case STEP_LOCATOR.LINK_TEXT.value:
        value = eventData?.linkText ?? "";
        if (isIframeHost) continue;
        break;
      case STEP_LOCATOR.NAME.value:
        value = eventData?.nameAttr ?? "";
        if (value && (canIgnoreId(value) || isIframeHost)) continue;
        break;
      case STEP_LOCATOR.CSS_LOCATOR.value:
        value = eventData?.cssPath ?? "";
        break;
      case STEP_LOCATOR.XPATH.value:
        value = eventData?.xPath ?? "";
        break;
      default:
        value = eventData?.[locator.key] ?? "";
        break;
    }
    if (value && (eventData?.locatorMatchCount?.[locator.locator] === 1 || isIframeHost) && !eventData?.shadowElement) {
      definition = value;
      locatorType = locator.locator;
      break;
    }
  }
  if (!definition) {
    definition = eventData.xPath;
    if (eventData.locatorType === STEP_LOCATOR.CSS_LOCATOR.value) {
      definition = eventData.cssPath || "";
    } else if (eventData.locatorType === STEP_LOCATOR.ID.value) {
      definition = eventData?.idSelector ?? eventData.definition ?? "";
    } else if (eventData.locatorType === STEP_LOCATOR.LINK_TEXT.value) {
      definition = eventData.linkText || "";
    } else if (eventData.locatorType === STEP_LOCATOR.NAME.value) {
      definition = eventData.nameAttr || "";
    }
  }
  return { definition, locatorType };
};
var getHostElements = async (eventData, screenNameId, applicationVersionId) => {
  if (!eventData?.elementContext) return [];
  const hostElements = await Promise.all(
    eventData.elementContext.map(async (elCtx) => {
      if (elCtx.hostType === ELEMENT_CONTEXT_TYPE.SHADOW) {
        return {
          ...elCtx,
          screenNameId,
          applicationVersionId
        };
      }
      const elCtxCopy = { ...elCtx, locatorType: eventData.locatorType };
      const { definition, locatorType } = await getDefinitionAndLocatorType(
        elCtxCopy,
        true
      );
      return {
        definition: definition || elCtxCopy.xPath,
        locatorType: definition ? locatorType : STEP_LOCATOR.XPATH.value,
        name: elCtxCopy.name,
        createdType: elCtxCopy.createdType,
        hostOrder: elCtxCopy.hostOrder,
        hostType: elCtxCopy.hostType,
        locatorTree: elCtxCopy.locatorTree,
        screenNameId,
        applicationVersionId
      };
    })
  );
  return hostElements;
};
var canIgnoreId = (id) => {
  const xpathPref = getGlobalState()?.widget.recorderPreferences?.preferences?.find(
    (pref) => pref.type === PREFERENCE.XPATH
  );
  const idIgnoreRegex = xpathPref?.IDENTIFIER?.IGNORE_REGEX;
  if (idIgnoreRegex) {
    return new RegExp(idIgnoreRegex).test(id);
  } else {
    return isDyanamicId(id);
  }
};
var getPredefinedFieldDetails = async (fieldId) => {
  const appVersionId = getGlobalState()?.widget.appVersionId;
  if (!appVersionId) {
    throw new Error("appVersionId unavailable, cannot fetch screen");
  }
  return await UiIdentifierApi.getDerivedUiIdentifier(
    appVersionId,
    fieldId
  );
};
var createNewElement = async (currentElement, update_fields_json) => {
  const randomWords = [
    "Alpha",
    "Beta",
    "Gamma",
    "Delta",
    "Epsilon",
    "Zeta",
    "Eta",
    "Theta",
    "Iota",
    "Kappa",
    "Lambda",
    "Mu",
    "Nu",
    "Xi",
    "Omicron",
    "Pi",
    "Rho",
    "Sigma",
    "Tau",
    "Upsilon",
    "Phi",
    "Chi",
    "Psi",
    "Omega"
  ];
  const randomIndex = Math.floor(Math.random() * randomWords.length);
  const randomWord = randomWords[randomIndex];
  const newElement = {
    name: `${update_fields_json?.field_name} ${randomWord}`,
    definition: update_fields_json?.field_definition,
    locatorType: update_fields_json?.locator_type_enum,
    applicationVersionId: currentElement?.applicationVersionId,
    screenNameId: currentElement?.screenNameId,
    createdType: "MANUAL",
    updateType: "MANUAL"
  };
  const createdElement = await UiIdentifierApi.create(newElement);
  return createdElement;
};

// src/components/test-recorder/utils/salesforce/muti-pick-list.ts
function getTemplateDisplayName(details) {
  if (!details?.actionPerformed) {
    return null;
  }
  switch (details.actionPerformed) {
    case "remove" /* REMOVE */:
      return "removeOptionsMultiPicklist";
    case "select" /* SELECT */:
      return "selectOptionsMultiPicklist";
    default:
      return null;
  }
}

// src/components/test-recorder/utils/template.ts
var findTemplateDisplayName = ({
  eventData,
  isMouseOverEnabled
}) => {
  let templateDisplayName;
  const sfPredefinedElementDetails = eventData?.sfPredefinedElementDetails;
  switch (eventData.action) {
    case CLIENT_EVENT.CLICK:
      if (sfPredefinedElementDetails) {
        templateDisplayName = getSalesforceTemplateDisplayName(
          sfPredefinedElementDetails?.predefinedField?.type,
          sfPredefinedElementDetails?.predefinedLocatorName,
          sfPredefinedElementDetails?.compositeElementDetails
        );
      } else if (isMouseOverEnabled) {
        templateDisplayName = TEMPLATE_DISPLAY_NAME.MOUSE_OVER;
      } else {
        templateDisplayName = TEMPLATE_DISPLAY_NAME.CLICK;
      }
      break;
    case CLIENT_EVENT.RIGHT_CLICK:
      templateDisplayName = TEMPLATE_DISPLAY_NAME.RIGHT_CLICK;
      break;
    case CLIENT_EVENT.INPUT:
    case CLIENT_EVENT.CHANGE:
      const inputType = eventData.attrs.type;
      const classValue = eventData?.attrs?.class?.toString();
      const containsSFRichTextArea = classValue?.includes("slds-rich-text-area") || false;
      if (sfPredefinedElementDetails?.predefinedField?.type == "reference") {
        templateDisplayName = TEMPLATE_DISPLAY_NAME.LOOKUP;
      } else if (sfPredefinedElementDetails?.predefinedField?.type == "textarea" && containsSFRichTextArea) {
        templateDisplayName = TEMPLATE_DISPLAY_NAME.RICHTEXTFIELD.toString();
      } else if (INPUT_TAGS.RADIO === eventData.attrs.type) {
        templateDisplayName = isMouseOverEnabled ? TEMPLATE_DISPLAY_NAME.MOUSE_OVER : TEMPLATE_DISPLAY_NAME.CHECK_RADIO;
      } else if (INPUT_TAGS.CHECKBOX === inputType) {
        templateDisplayName = isMouseOverEnabled ? TEMPLATE_DISPLAY_NAME.MOUSE_OVER : eventData.attrs.checked ? TEMPLATE_DISPLAY_NAME.CHECK_CHECKBOX : TEMPLATE_DISPLAY_NAME.UNCHECK_CHECKBOX;
      } else if (INPUT_TAGS.FILE === inputType) {
        templateDisplayName = TEMPLATE_DISPLAY_NAME.FILE_UPLOAD;
      } else if (eventData.tag === TAG_NAME.SELECT) {
        if (eventData?.selectOptionAttrs?.value) {
          templateDisplayName = TEMPLATE_DISPLAY_NAME.SELECT_OPTION_BY_VALUE;
        } else if (eventData?.selectOptionAttrs?.index) {
          templateDisplayName = TEMPLATE_DISPLAY_NAME.SELECT_OPTION_BY_INDEX;
        } else {
          templateDisplayName = TEMPLATE_DISPLAY_NAME.SELECT_OPTION_BY_TEXT;
        }
      } else {
        templateDisplayName = eventData?.attrs?.value || eventData.text ? TEMPLATE_DISPLAY_NAME.ENTER : TEMPLATE_DISPLAY_NAME.CLEAR;
      }
      break;
    case CLIENT_EVENT.DOUBLE_CLICK:
      templateDisplayName = TEMPLATE_DISPLAY_NAME.DBL_CLICK;
      break;
    case CLIENT_EVENT.SCROLL:
      templateDisplayName = TEMPLATE_DISPLAY_NAME.SCROLL_INSIDE;
      break;
    case CLIENT_EVENT.SCROLL_WINDOW:
      templateDisplayName = TEMPLATE_DISPLAY_NAME.SCROLL_WINDOW;
      break;
    case CLIENT_EVENT.SWITCH_FRAME:
      templateDisplayName = TEMPLATE_DISPLAY_NAME.SWITCH_TO_FRAME;
      break;
    case CLIENT_EVENT.SWITCH_PARENT:
      templateDisplayName = TEMPLATE_DISPLAY_NAME.SWITCH_TO_PARENT;
      break;
    case CLIENT_EVENT.KEY_DOWN:
      switch (eventData.tag) {
        case KEY_EVENT.ESC:
          templateDisplayName = TEMPLATE_DISPLAY_NAME.PRESS_ESC;
          break;
        case KEY_EVENT.ENTER:
          templateDisplayName = TEMPLATE_DISPLAY_NAME.PRESS_ENTER;
          break;
        case KEY_EVENT.TAB:
          templateDisplayName = TEMPLATE_DISPLAY_NAME.PRESS_TAB;
          break;
      }
      break;
    case CHROME_EVENT.NAVIGATE_TO_URL:
      templateDisplayName = TEMPLATE_DISPLAY_NAME.NAVIGATE_TO;
      break;
    case CLIENT_EVENT.DRAG_START:
      templateDisplayName = TEMPLATE_DISPLAY_NAME.DRAG_DROP;
      break;
    case CHROME_EVENT.NAVIGATE_BACKWARD:
    case CHROME_EVENT.RELOAD_PAGE:
    case CHROME_EVENT.NAVIGATE_FORWARD:
      templateDisplayName = TEMPLATE_DISPLAY_NAME.BROWSER_NAVIGATE_BUTTONS;
      break;
    case CHROME_EVENT.TAB.CREATE:
      templateDisplayName = TEMPLATE_DISPLAY_NAME.NEW_TAB;
      break;
    case CHROME_EVENT.TAB.SWITCH_BY_INDEX:
      templateDisplayName = TEMPLATE_DISPLAY_NAME.TAB_SWITCH_BY_INDEX;
      break;
    case CHROME_EVENT.TAB.SWITCH_BY_TITLE:
      templateDisplayName = TEMPLATE_DISPLAY_NAME.SWITCH_WINDOW_BY_TITLE;
      break;
    case CHROME_EVENT.TAB.CLOSE:
      templateDisplayName = TEMPLATE_DISPLAY_NAME.TAB_CLOSE_BY_INDEX;
      break;
    case CHROME_EVENT.TAB.CLOSE_ALL:
      templateDisplayName = TEMPLATE_DISPLAY_NAME.TAB_CLOSE_ALL;
      break;
    case CLIENT_EVENT.MOVE:
      templateDisplayName = TEMPLATE_DISPLAY_NAME.MOVE_ELEMENT_TO_OFFSET;
      break;
    case CLIENT_EVENT.UPLOAD:
      templateDisplayName = TEMPLATE_DISPLAY_NAME.UPLOAD_FILE;
      break;
  }
  return templateDisplayName;
};
var parseTemplateGrammer = (grammar, testDataKeyMap, identifier) => {
  let templateGrammer = grammar;
  testDataKeyMap?.forEach((testData2) => {
    templateGrammer = templateGrammer.replace(
      TEST_DATA.composePatternByApiKey(testData2.key),
      testData2.value
    );
  });
  if (identifier && identifier !== "") {
    templateGrammer = templateGrammer.replace(
      IDENTIFIER.composePatternByApiKey(IDENTIFIER.apiKey),
      identifier
    );
  }
  return templateGrammer;
};
var parseDragDropTemplateGrammer = (grammar, identifier1, identifier2) => {
  return grammar.replace(IDENTIFIER.fromIdentifier.apiPattern, identifier1).replace(IDENTIFIER.toIdentifier.apiPattern, identifier2).replace(/#{from-ui-identifier}/g, identifier1).replace(/#{to-ui-identifier}/g, identifier2);
};
function getSalesforceTemplateDisplayName(fieldType, locatorName, compositeElementDetails) {
  if (!fieldType) return null;
  if (locatorName === "undo") {
    return TEMPLATE_DISPLAY_NAME.UNDO;
  }
  if (fieldType === "multipicklist") {
    return getTemplateDisplayName(compositeElementDetails) || void 0;
  }
  switch (fieldType) {
    case "picklist":
      return TEMPLATE_DISPLAY_NAME.PICKLIST;
    case "reference":
      return TEMPLATE_DISPLAY_NAME.LOOKUP;
    default:
      return null;
  }
}
var getTemplate = async (displayName) => {
  const templates = getGlobalState()?.widget.templates;
  if (templates && templates.length) {
    return templates.find((template) => {
      if (template.displayName.toLowerCase() === displayName.toLowerCase()) {
        return template.displayName.toLowerCase() === displayName.toLowerCase();
      }
    });
  }
};

// src/components/test-recorder/utils/date.ts
var getCurrentDateTime = () => {
  const now = /* @__PURE__ */ new Date();
  const year = now.getFullYear();
  const month = (now.getMonth() + 1).toString().padStart(2, "0");
  const day = now.getDate().toString().padStart(2, "0");
  const hours = now.getHours().toString().padStart(2, "0");
  const minutes = now.getMinutes().toString().padStart(2, "0");
  const seconds = now.getSeconds().toString().padStart(2, "0");
  const formattedDateTime = year + month + day + "-" + hours + minutes + seconds;
  return formattedDateTime;
};

// src/components/test-recorder/utils/file.ts
var cleanFileName = (path) => {
  if (path.substring(0, 12) === "C:\\fakepath\\") {
    return path.substring(12);
  }
  let x = path.lastIndexOf("/");
  if (x >= 0)
    return path.substring(x + 1);
  x = path.lastIndexOf("\\");
  if (x >= 0)
    return path.substring(x + 1);
  return path;
};
var deserialize = async ({
  dataURL,
  type,
  name
}) => {
  if (dataURL) {
    const res = await fetch(dataURL);
    const blob = await res.blob();
    return new File([blob], name, { type });
  }
  return null;
};
var fileEventHandler = async (eventData) => {
  try {
    if (eventData.file) {
      getSendToBackground()({
        context: MESSAGE_CONTEXT.STATE,
        action: MESSAGE_CONTEXT_ACTION.UPDATE,
        value: RECORDER_STATE.HOLD
      });
      const rawFile = await deserialize(eventData.file);
      if (rawFile) {
        const applicationId = getGlobalState()?.widget.applicationId;
        if (!applicationId) {
          throw new Error("applicationId unavailable, aborting upload");
        }
        const dateTimeSuffix = "-" + getCurrentDateTime();
        const fileName = clipString(
          eventData.file.name,
          UPLOAD_NAME_MAX_LEN - dateTimeSuffix.length
        ) + dateTimeSuffix;
        const res = await UploadApi.create({
          file: rawFile,
          name: fileName,
          applicationId,
          version: fileName
        });
        eventData.attrs.value = `${res.name} / ${res.latestVersion.name}`;
        eventData.attrs.uploadId = res.id;
        eventData.attrs.uploadIdList = `${res.id},${res.latestVersion.id}`;
      }
      getSendToBackground()({
        context: MESSAGE_CONTEXT.STATE,
        action: MESSAGE_CONTEXT_ACTION.UPDATE,
        value: RECORDER_STATE.RUNNING
      });
      return new Promise((resolve) => resolve(eventData));
    }
    return new Promise((resolve) => resolve(eventData));
  } catch (_) {
    log.error(`[WIDGET] -- fileEventHandler error`, _);
    return new Promise((resolve) => resolve(eventData));
  }
};
var nameSpace = PrivateURLConstants.STEP;
var show = (id) => instance_default.get(`${nameSpace}/${id}`);
var create = (data, addlast = false, applicationVersionId) => instance_default.post(`${nameSpace}?applicationVersionId=${applicationVersionId}`, data);
var update = (step, applicationVersionId) => instance_default.put(
  `${nameSpace}/${step.id}?applicationVersionId:${applicationVersionId}`,
  step
);
var updateById = (data, id) => instance_default.put(`${nameSpace}/${id}`, data);
var reorder = (data, applicationVersionId) => {
  return instance_default.patch(
    `${nameSpace}/reorder?applicationVersionId:${applicationVersionId}`,
    data
  ).then((res) => console.log(res)).catch((e) => Promise.reject(e));
};
var getAll = (query, sort = "stepOrder,id", size2 = STEPS_PAGE_SIZE, page, stepGroupStepId, indent, lastStepNumber, enableCopilotBlockFix) => {
  const params = {
    query,
    sort,
    size: size2,
    page
  };
  if (stepGroupStepId) params.stepGroupStepId = stepGroupStepId;
  if (typeof indent === "number") params.indent = indent;
  if (lastStepNumber) params.lastStepNumber = lastStepNumber;
  if (enableCopilotBlockFix) params.enableCopilotBlockFix = true;
  return instance_default.get(nameSpace, params);
};
var deleteOne = (id, applicationVersionId) => instance_default.remove(`${nameSpace}/${id}?applicationVersionId=${applicationVersionId}`);
var deleteMany = (ids, applicationVersionId) => instance_default.remove(
  `${nameSpace}/bulk_delete?${ids.map((id) => `ids%5B%5D=${id}`).join("&")}&applicationVersionId:${applicationVersionId}`
);
var bulkUpdateProperties = (data, applicationVersionId) => {
  return instance_default.patch(
    nameSpace + `/bulk_update_properties?applicationVersionId=${applicationVersionId}`,
    data
  );
};
var StepApi = {
  create,
  update,
  updateById,
  getAll,
  reorder,
  deleteOne,
  deleteMany,
  bulkUpdateProperties,
  show
};
var WidgetV2SliceKey = "widgetV2";
var WidgetV2InitialState = {
  // for step creation
  isScrollRecordingEnabled: false,
  maxFetchedPageNumber: -1,
  lastEventData: null,
  lastPageFetched: false,
  ignoreSwitchTab: false,
  lastSavedLocatorTreeId: "",
  lastLocatorTreeUuid: "",
  isLastStepNameClear: false,
  // for screenshots
  elementScreenshotMap: {},
  croppedElementScreenshotMap: {}
};
var selectWidgetV2State = (state) => state[WidgetV2SliceKey];
var selectIsScrollRecordingEnabled = createSelector(
  selectWidgetV2State,
  (widgetV2State) => widgetV2State.isScrollRecordingEnabled
);
var selectMaxFetchedPageNumber = createSelector(
  selectWidgetV2State,
  (widgetV2State) => widgetV2State.maxFetchedPageNumber
);
var selectLastEventData = createSelector(
  selectWidgetV2State,
  (widgetV2State) => widgetV2State.lastEventData
);
createSelector(
  selectWidgetV2State,
  (widgetV2State) => widgetV2State.lastPageFetched
);
var selectIgnoreSwitchTab = createSelector(
  selectWidgetV2State,
  (widgetV2State) => widgetV2State.ignoreSwitchTab
);
createSelector(
  selectWidgetV2State,
  (widgetV2State) => widgetV2State.lastSavedLocatorTreeId
);
createSelector(
  selectWidgetV2State,
  (widgetV2State) => widgetV2State.lastLocatorTreeUuid
);
var selectIsLastStepNameClear = createSelector(
  selectWidgetV2State,
  (widgetV2State) => widgetV2State.isLastStepNameClear
);
var selectElementScreenshotMap = createSelector(
  [selectWidgetV2State, (state, key) => key],
  (widgetV2State, key) => widgetV2State.elementScreenshotMap?.[key] || null
);
var selectCroppedElementScreenshotMap = createSelector(
  [selectWidgetV2State, (state, key) => key],
  (widgetV2State, key) => widgetV2State.croppedElementScreenshotMap?.[key] || null
);
var widgetV2Reducers = {
  updateIsScrollRecordingEnabled: (state, action) => {
    console.log("TCL ~ :7 ~ action:", action);
    state.isScrollRecordingEnabled = action.payload;
  },
  updateMaxFetchedPageNumber: (state, action) => {
    state.maxFetchedPageNumber = action.payload;
  },
  updateLastEventData: (state, action) => {
    state.lastEventData = action.payload;
  },
  updateLastPageFetched: (state, action) => {
    state.lastPageFetched = action.payload;
  },
  updateIgnoreSwitchTab: (state, action) => {
    state.ignoreSwitchTab = action.payload;
  },
  updateLastSavedLocatorTreeId: (state, action) => {
    state.lastSavedLocatorTreeId = action.payload;
  },
  updateLastLocatorTreeUuid: (state, action) => {
    state.lastLocatorTreeUuid = action.payload;
  },
  updateIsLastStepNameClear: (state, action) => {
    state.isLastStepNameClear = action.payload;
  },
  updateElementScreenshotMap: (state, action) => {
    state.elementScreenshotMap[action.payload.key] = action.payload.value;
    setTimeout(() => {
      const newState = {
        ...state,
        elementScreenshotMap: { ...state.elementScreenshotMap },
        croppedElementScreenshotMap: { ...state.croppedElementScreenshotMap }
      };
      delete newState.elementScreenshotMap[action.payload.key];
      delete newState.croppedElementScreenshotMap[action.payload.key];
      Object.assign(state, newState);
    }, 2e4);
  },
  updateCroppedElementScreenshotMap: (state, action) => {
    state.croppedElementScreenshotMap[action.payload.key] = action.payload.value;
  },
  resetWidgetV2State: (state) => {
    state = {
      ...WidgetV2InitialState,
      isScrollRecordingEnabled: state.isScrollRecordingEnabled
    };
  }
};
var { reducer, actions: widgetV2Actions } = createSlice({
  name: WidgetV2SliceKey,
  initialState: WidgetV2InitialState,
  reducers: widgetV2Reducers
});
var widgetV2Reducer = reducer;
var {
  updateIsScrollRecordingEnabled,
  updateMaxFetchedPageNumber,
  updateLastEventData,
  updateLastPageFetched,
  updateIgnoreSwitchTab,
  updateLastSavedLocatorTreeId,
  updateLastLocatorTreeUuid,
  updateIsLastStepNameClear,
  updateElementScreenshotMap,
  updateCroppedElementScreenshotMap,
  resetWidgetV2State
} = widgetV2Actions;
var actionCreators = {
  ...widgetV2Actions
  // ...thunks,
};
var useWidgetV2Actions = () => {
  const dispatch = useDispatch();
  return bindActionCreators(actionCreators, dispatch);
};

// src/components/test-recorder/utils/step/step-page.ts
var refreshPageContainingStep = async (step, refetchNextPages = false, isDebugger = false, options3) => {
  const res = await getPageFromStep(step);
  if (!options3?.preserveLastProcessedData) {
    clearLastProcessedData();
  }
  const updatedSteps = structuredClone(getGlobalState()?.widget.testSteps) || [];
  const maxFetchedPageNumber = selectMaxFetchedPageNumber(getGlobalState());
  const maxPage = refetchNextPages ? maxFetchedPageNumber : res.page;
  for (let i = res.page; i <= maxPage; i++) {
    const newPage = (await getAllTestSteps(i, false))?.content || [];
    if (isDebugger) {
      const flattenedTestSteps = flatTestSteps({
        teststeps: newPage,
        applicationType: getGlobalState()?.widget.appType,
        page: 0
      });
      replaceNthPage(updatedSteps, i, flattenedTestSteps);
    } else {
      replaceNthPage(updatedSteps, i, newPage);
    }
  }
  return updatedSteps;
};
var getPageFromStep = async (step) => {
  if (step.stepNumber) {
    const parentStepNumber = parseInt(step.stepNumber);
    const isLastStepInPage = parentStepNumber % STEPS_PAGE_SIZE === 0;
    return {
      isLastStepInPage,
      page: parentStepNumber === 0 ? 0 : Math.floor((parentStepNumber - 1) / STEPS_PAGE_SIZE)
    };
  }
  log.error("[WIDGET] No step number, finding page from step stepOrder");
  throw new Error("No step number, finding page from step stepOrder");
};
var getAllTestSteps = async (page = 0, updateStepsList = true) => {
  const steps = await fetchTestSteps(
    page,
    STEPS_PAGE_SIZE,
    "",
    void 0,
    updateStepsList
  );
  return { content: steps };
};
var fetchTestSteps = async (page = 0, size2 = STEPS_PAGE_SIZE, customQuery = "", actionParam, updateStepsList = true, enableCopilotBlockFix = false) => {
  log.info(
    "[WIDGET] fetchTestSteps",
    `page=${page}`,
    `size=${size2}`,
    `customQuery=${customQuery}`,
    `actionParam=${actionParam}`,
    `forceFetch=${updateStepsList}`
  );
  if (page === 0 && updateStepsList) {
    log.info("[WIDGET] Reset maxFetchedPageNumber");
    await getGlobalDispatch()(updateMaxFetchedPageNumber(-1));
  }
  if (page != null && page !== void 0 && !actionParam?.type && updateStepsList) {
    const maxFetchedPageNumber = selectMaxFetchedPageNumber(getGlobalState());
    if (maxFetchedPageNumber >= page) {
      log.info(
        `[WIDGET] maxFetchedPageNumber ${maxFetchedPageNumber} >= page ${page}, no need to fetch`
      );
      return [];
    }
    await getGlobalDispatch()(updateMaxFetchedPageNumber(page));
  }
  const testCaseId = getGlobalState()?.widget?.testCase?.id;
  if (testCaseId) {
    const stepList = structuredClone(getGlobalState()?.widget.testSteps);
    const lastStepNumber = !updateStepsList ? `${page * size2}` : page !== 0 && stepList?.length && !actionParam?.type ? stepList[stepList?.length - 1]?.stepNumber : actionParam?.type && ACTION_PARAM_TYPES.includes(actionParam.type) ? actionParam.data[actionParam.data.length - 1]?.stepNumber : null;
    const query = customQuery ? customQuery : `testCaseId:${testCaseId}`;
    const newSteps = await StepApi.getAll(
      query,
      "stepOrder,id",
      size2,
      page,
      void 0,
      void 0,
      lastStepNumber ? parseInt(lastStepNumber).toFixed() : void 0,
      enableCopilotBlockFix || void 0
    ).then(async (res) => {
      const pageData = res;
      const flattenedStepResponse = flatTestSteps({
        teststeps: pageData.content,
        applicationType: getGlobalState()?.widget.appType,
        page
      });
      setConditionalStepsData(flattenedStepResponse);
      const newList = flattenedStepResponse;
      newList?.forEach((step) => step.pagenumber = page);
      if (!updateStepsList) {
        return newList;
      }
      updateStepListContent(
        newList,
        page === 0 ? [] : stepList,
        actionParam
      );
      await getGlobalDispatch()(updateLastPageFetched(pageData.last));
      return null;
    }).catch((error) => {
      log.error("[WIDGET] Error fetching steps", error);
    }) || [];
    const returnSteps = updateStepsList ? structuredClone(getGlobalState()?.widget.testSteps) : newSteps;
    log.info(
      `[WIDGET] Returning ${returnSteps?.length} steps, stepQ updated? ${updateStepsList}`
    );
    return returnSteps;
  }
};
var setConditionalStepsData = (steps) => {
  steps.forEach((step) => {
    if (step.conditionType === STEP_CONDITION_TYPE.IF || step.conditionType === STEP_CONDITION_TYPE.ELSE_IF) {
      const childs = findAllChildren2(steps, "parentId", step.id);
      step.presentationMetaInfo = step.presentationMetaInfo || {};
      if (childs.filter(
        (item) => (item.conditionType === STEP_CONDITION_TYPE.ELSE_IF || item.conditionType === STEP_CONDITION_TYPE.ELSE) && item.indent === step.indent
      )?.length) {
        step.presentationMetaInfo["isHaveElse"] = true;
      } else {
        step.presentationMetaInfo["isHaveElse"] = false;
      }
    }
  });
};
var updateStepListContent = async (fetchedList = [], storedList = [], actionParam) => {
  const sortedFetchedList = fetchedList.sort(
    (a, b) => isNumber(a?.stepOrder) && isNumber(b?.stepOrder) ? a.stepOrder - b.stepOrder : 0
  );
  if (!actionParam) {
    const newSteps = [...storedList || [], ...sortedFetchedList || []];
    await getGlobalDispatch()(updateTestSteps(newSteps));
  } else if (actionParam.type === "DELETE" || actionParam.type === "INSERT" || actionParam.type === "BLOCK" || actionParam.type === "RECORD" || actionParam.type === "REORDER" || actionParam.type === "RESTSTEP") {
    await getGlobalDispatch()(
      updateTestSteps([...actionParam.data, ...sortedFetchedList])
    );
  } else if (actionParam.type === "ADD" || actionParam.type === "UPDATE") {
    await getGlobalDispatch()(updateTestSteps([...actionParam.data]));
  }
};
var replaceNthPage = (list, n, newPage) => {
  let lastPageNumber = 0;
  for (const step of list) {
    if (isNumber(step.pagenumber)) {
      lastPageNumber = step.pagenumber || 0;
      continue;
    }
    if (step.stepNumber) {
      const parentStepNumber = parseInt(step.stepNumber);
      step.pagenumber = parentStepNumber === 0 ? 0 : Math.floor((parentStepNumber - 1) / STEPS_PAGE_SIZE);
      lastPageNumber = step.pagenumber;
    } else {
      console.warn(`Setting page number ${lastPageNumber} to step ${step}`);
      step.pagenumber = lastPageNumber;
    }
  }
  const startIndex = list.findIndex((step) => step.pagenumber === n);
  const endIndex = findLastIndex(list, (step) => step.pagenumber === n);
  let numToRemove = endIndex - startIndex + 1;
  if (startIndex < 0) {
    newPage?.forEach((item) => list.push(item));
    return;
  } else if (endIndex < 0) {
    numToRemove = list.length - startIndex;
  }
  list.splice(startIndex, numToRemove, ...newPage);
  console.debug(
    `Replaced ${numToRemove}->${newPage?.length} items in page ${n}`
  );
};
var refreshTestSteps = async (page = 0) => {
  clearLastProcessedData();
  if (page === -1) {
    const steps2 = await getAllTestSteps(0);
    return steps2.content;
  }
  const newPage = (await getAllTestSteps(page, false))?.content || [];
  const steps = structuredClone(getGlobalState()?.widget.testSteps);
  replaceNthPage(steps, page, newPage);
  return steps;
};
var getAllPagesTestSteps = async (enableCopilotBlockFix = false) => {
  let allFetched = false;
  let steps = [];
  let page = 0;
  const processFetchedSteps = async (status, fetchedSteps, page2) => {
    if (status === "fulfilled") {
      if (!fetchedSteps?.length) {
        allFetched = true;
      } else {
        await getGlobalDispatch()(updateMaxFetchedPageNumber(page2));
        steps = steps.concat(fetchedSteps);
      }
    }
  };
  while (!allFetched) {
    const [steps0, steps1] = await Promise.allSettled([
      fetchTestSteps(page, STEPS_PAGE_SIZE, "", void 0, false, enableCopilotBlockFix),
      fetchTestSteps(page + 1, STEPS_PAGE_SIZE, "", void 0, false, enableCopilotBlockFix)
    ]);
    await processFetchedSteps(
      steps0.status,
      steps0.value,
      page
    );
    await processFetchedSteps(
      steps1.status,
      steps1.value,
      page + 1
    );
    page += 2;
  }
  const stepById = new Map(steps.map((s) => [s.id, s]));
  for (const step of steps) {
    if (step.parentId && !step.blockParentId) {
      const parent = stepById.get(step.parentId);
      if (parent) {
        if (parent.type === STEP_TYPE.BLOCK) {
          step.blockParentId = parent.id;
          step.indent = (step.indent || 0) + 1;
        } else if (parent.blockParentId) {
          step.blockParentId = parent.blockParentId;
          step.indent = (step.indent || 0) + 1;
        }
      }
    }
  }
  await getGlobalDispatch()(updateLastPageFetched(true));
  return { content: steps };
};
var reloadTestSteps = async () => {
  const dispatch = getGlobalDispatch();
  const updatedSteps = await refreshTestSteps();
  await dispatch(updateTestSteps(updatedSteps));
};
var save_locator_tree_default = new Subject();
var dragDropEventToStep = async (dragEventData) => {
  const templateDisplayName = TEMPLATE_DISPLAY_NAME.DRAG_DROP;
  const template = await getTemplate(templateDisplayName);
  const fromIdentifierDetails = await getIdentifierDetails(
    dragEventData.from
  );
  const toIdentifierDetails = await getIdentifierDetails(
    dragEventData.to
  );
  const stepDetails = await getDragDropTestStep(
    fromIdentifierDetails.name,
    toIdentifierDetails.name,
    template
  );
  return createEventStep({
    stepDetails,
    dragDropIdentifiers: {
      from: fromIdentifierDetails,
      to: toIdentifierDetails
    },
    dragDropLocatorTrees: {
      from: dragEventData.from.locatorTree,
      to: dragEventData.to.locatorTree
    },
    screenshotRetrievalId: dragEventData.from.screenshotRetrievalId
  });
};
var processStepAndIdentifier = async ({
  sfPredefinedFieldDetails,
  eventData,
  template,
  templateDisplayName
}) => {
  let identifierDetails;
  if (sfPredefinedFieldDetails) {
    identifierDetails = await getPredefinedFieldDetails(
      sfPredefinedFieldDetails?.id
    );
  } else {
    identifierDetails = await getIdentifierDetails(eventData);
  }
  const lastEventData = selectLastEventData(getGlobalState());
  const shouldUpdataSalesForceExistingStep = () => (lastEventData.action === eventData.action && sfPredefinedFieldDetails?.type == SalesforceObjectFieldType.PICKLIST.toString() || eventData.action === CLIENT_EVENT.CLICK && sfPredefinedFieldDetails?.type == SalesforceObjectFieldType.REFERENCE.toString() || eventData.action === CLIENT_EVENT.INPUT) && lastStep?.elementRequest?.salesforceObjectField?.id == identifierDetails?.salesforceObjectField?.id && eventData?.sfPredefinedElementDetails?.predefinedLocatorName != "undo";
  const lastStep = getGlobalState()?.widget.userStepsData.lastStep;
  const isLastStepNameClear = selectIsLastStepNameClear(getGlobalState());
  if (lastEventData?.action && (sfPredefinedFieldDetails && shouldUpdataSalesForceExistingStep() || lastEventData.action === eventData.action && eventData.action === CLIENT_EVENT.INPUT && !isLastStepNameClear && templateDisplayName !== TEMPLATE_DISPLAY_NAME.CLEAR && lastStep?.elementRequest && lastStep?.elementRequest.definition === identifierDetails.definition && sfPredefinedFieldDetails == null && JSON.stringify(lastStep?.elementRequest.hostElements) === JSON.stringify(identifierDetails.hostElements))) {
    const stepDetails = await getTestStepDetails(
      eventData,
      lastStep ? lastStep.testStepElements.find(
        (item) => item.elementType == "UIElement"
      ) : identifierDetails,
      template
    );
    await getGlobalDispatch()(updateLastEventData(eventData));
    await getGlobalDispatch()(
      updateIsLastStepNameClear(
        isLastStepNameClear || templateDisplayName === TEMPLATE_DISPLAY_NAME.CLEAR
      )
    );
    return eventStepUpdate(
      {
        ...stepDetails,
        id: lastStep.id,
        stepNumber: lastStep.stepNumber
      },
      lastStep?.elementRequest
    );
  } else {
    const stepDetails = await getTestStepDetails(
      eventData,
      identifierDetails,
      template
    );
    await getGlobalDispatch()(updateLastEventData(eventData));
    await getGlobalDispatch()(
      updateIsLastStepNameClear(
        templateDisplayName === TEMPLATE_DISPLAY_NAME.CLEAR
      )
    );
    return createEventStep({
      stepDetails: {
        ...stepDetails,
        timestamp: (/* @__PURE__ */ new Date()).getTime()
      },
      identifierDetails,
      locatorTree: eventData.locatorTree,
      screenshotRetrievalId: eventData.screenshotRetrievalId
    });
  }
};
var createEventStep = async ({
  identifierDetails,
  stepDetails,
  dragDropIdentifiers,
  dragDropLocatorTrees,
  locatorTree,
  screenshotRetrievalId
}) => {
  let steps = structuredClone(getGlobalState()?.widget.testSteps);
  const stepCursor = getGlobalState()?.widget.stepCursor;
  if (stepCursor) {
    log.info(
      "[WIDGET] [STEP CREATION] Using stepCursor for position",
      stepCursor
    );
    const isInterimStep = !stepCursor.id;
    if (isInterimStep) {
      log.info("[WIDGET] [STEP CREATION] Using interim step position directly");
      stepDetails.parentId = stepCursor.parentId;
      stepDetails.stepOrder = stepCursor.stepOrder;
      stepDetails.stepNumber = stepCursor.stepNumber;
      stepDetails.indent = stepCursor.indent;
    } else {
      log.info(
        "[WIDGET] [STEP CREATION] Calculating position after clicked step"
      );
      const clickedStepIndex = steps.findIndex(
        (step) => step.id === stepCursor.id
      );
      const nextStep = clickedStepIndex >= 0 ? steps[clickedStepIndex + 1] : null;
      stepDetails.parentId = stepCursor.parentId;
      stepDetails.indent = stepCursor.indent;
      if (nextStep && nextStep.parentId === stepCursor.parentId) {
        stepDetails.stepOrder = (stepCursor.stepOrder + nextStep.stepOrder) / 2;
        stepDetails.stepNumber = getStepNumber(
          stepCursor.stepNumber || "-",
          "below"
        );
      } else if (nextStep && stepCursor.parentId && nextStep.parentId !== stepCursor.parentId) {
        stepDetails.stepOrder = (stepCursor.stepOrder + nextStep.stepOrder) / 2;
        stepDetails.stepNumber = getStepNumber(
          stepCursor.stepNumber || "-",
          "below"
        );
      } else {
        stepDetails.stepOrder = stepCursor.stepOrder + 1e3;
        stepDetails.stepNumber = getStepNumber(
          stepCursor.stepNumber || "-",
          "below"
        );
      }
    }
  } else {
    const lastStep = steps[steps.length - 1];
    let baseOrder = 0;
    if (lastStep?.stepOrder) {
      baseOrder = lastStep.stepOrder;
    } else if (Number.isInteger(lastStep?.stepNumber) && (Number(lastStep?.stepNumber) - 1) * 1e3 !== 1e3) {
      baseOrder = (Number(lastStep.stepNumber) - 1) * 1e3;
    }
    stepDetails.stepOrder = baseOrder + 1e3;
    log.debug(
      "[WIDGET] [STEP CREATION]",
      "createEventStep No stepCursor",
      stepDetails.stepOrder
    );
  }
  if (!stepCursor) {
    const lastStepNumber = steps?.length > 0 ? steps[steps.length - 1].stepNumber || "0" : "0";
    stepDetails.stepNumber = addStepNumber2(
      `${parseInt(lastStepNumber)}`);
    stepDetails.indent = 0;
    log.info("[WIDGET] [STEP CREATION] Adding event step at the end");
  }
  if (identifierDetails) {
    const { step, identifier } = await createStepWithIdentifier(
      stepDetails,
      identifierDetails
    );
    const elementSS = selectElementScreenshotMap(
      getGlobalState(),
      screenshotRetrievalId
    );
    const croppedELementSS = selectCroppedElementScreenshotMap(
      getGlobalState(),
      screenshotRetrievalId
    );
    if (locatorTree && step.testStepElements?.length) {
      save_locator_tree_default.next({
        elementId: step?.testStepElements[0]?.elementId,
        locatorTree
      });
    } else {
      log.warn(
        "[WIDGET] [STEP CREATION] Locator tree not available for element"
      );
    }
    if (identifierDetails.hostElements && identifierDetails.hostElements.length > 0) {
      saveHostElementLocatorTrees(
        identifierDetails.hostElements,
        step?.elementRequest?.hostElements
      );
    }
    const appVersionId = getGlobalState().widget.appVersionId;
    if (elementSS && step.testStepElements?.length) {
      RecorderAssetsApi.saveElementScreenshot(
        step.testStepElements[0].elementId,
        {
          screenshotFile: dataurltoFile(elementSS),
          applicationVersionId: appVersionId
        }
      );
    }
    if (croppedELementSS && step.testStepElements?.length) {
      RecorderAssetsApi.saveCroppedElementScreenshot(
        step.testStepElements[0].elementId,
        {
          screenshotFile: dataurltoFile(croppedELementSS),
          applicationVersionId: appVersionId
        }
      );
    }
    await getGlobalDispatch()(
      updateLastStep({
        ...step,
        elementRequest: identifierDetails
      })
    );
    log.info("[WIDGET] [STEP CREATION] STEP CREATED", step, identifier);
    if (stepCursor) {
      steps = await refreshPageContainingStep(step, true, false, {
        preserveLastProcessedData: true
      });
    } else {
      steps = await pushStep(step, steps);
    }
    await getGlobalDispatch()(updateTestSteps(steps));
    const hadCursor = !!stepCursor;
    if (hadCursor) {
      const createdStepFromServer = steps.find(
        (s) => step.id && s.id === step.id || s.stepOrder === step.stepOrder && s.stepNumber === step.stepNumber && s.parentId === step.parentId
      );
      if (createdStepFromServer) {
        log.info(
          "[WIDGET] [STEP CREATION] Setting cursor to newly created step from server",
          createdStepFromServer
        );
        await getGlobalDispatch()(updateUserStepsCursor(createdStepFromServer));
      } else {
        log.warn(
          "[WIDGET] [STEP CREATION] Could not find created step in refreshed steps, clearing cursor"
        );
        await getGlobalDispatch()(updateUserStepsCursor(null));
      }
    } else {
      log.info(
        "[WIDGET] [STEP CREATION] No cursor - clearing user steps cursor"
      );
      await getGlobalDispatch()(updateUserStepsCursor(null));
    }
    return step;
  } else if (dragDropIdentifiers) {
    const createdFrom = await UiIdentifierApi.create(dragDropIdentifiers.from);
    const createdTo = await UiIdentifierApi.create(dragDropIdentifiers.to);
    const fromElement = Object.assign(new StepElementRequest(), {
      elementType: TestStepElementType.FROM_UI_ELEMENT,
      name: createdFrom.name,
      elementId: createdFrom.id
    });
    const toElement = Object.assign(new StepElementRequest(), {
      elementType: TestStepElementType.TO_UI_ELEMENT,
      name: createdTo.name,
      elementId: createdTo.id
    });
    const stepWithElements = {
      ...stepDetails,
      testStepElements: [fromElement, toElement]
    };
    const step = await createStep(stepWithElements);
    if (dragDropLocatorTrees?.from && createdFrom.id) {
      save_locator_tree_default.next({
        elementId: createdFrom.id,
        locatorTree: dragDropLocatorTrees.from
      });
    }
    if (dragDropLocatorTrees?.to && createdTo.id) {
      save_locator_tree_default.next({
        elementId: createdTo.id,
        locatorTree: dragDropLocatorTrees.to
      });
    }
    if (dragDropIdentifiers.from.hostElements?.length && createdFrom?.hostElements) {
      saveHostElementLocatorTrees(
        dragDropIdentifiers.from.hostElements,
        createdFrom.hostElements
      );
    }
    if (dragDropIdentifiers.to.hostElements?.length && createdTo?.hostElements) {
      saveHostElementLocatorTrees(
        dragDropIdentifiers.to.hostElements,
        createdTo.hostElements
      );
    }
    if (screenshotRetrievalId) {
      const elementSS = selectElementScreenshotMap(
        getGlobalState(),
        screenshotRetrievalId
      );
      const croppedElementSS = selectCroppedElementScreenshotMap(
        getGlobalState(),
        screenshotRetrievalId
      );
      const appVersionId = getGlobalState().widget.appVersionId;
      if (elementSS) {
        RecorderAssetsApi.saveElementScreenshot(createdFrom.id, {
          screenshotFile: dataurltoFile(elementSS),
          applicationVersionId: appVersionId
        });
      }
      if (croppedElementSS) {
        RecorderAssetsApi.saveCroppedElementScreenshot(createdFrom.id, {
          screenshotFile: dataurltoFile(croppedElementSS),
          applicationVersionId: appVersionId
        });
      }
    }
    await getGlobalDispatch()(updateLastStep(step));
    log.info("[WIDGET] [STEP CREATION] STEP CREATED", step);
    if (stepCursor) {
      steps = await refreshPageContainingStep(step, true, false, {
        preserveLastProcessedData: true
      });
    } else {
      steps = await pushStep(step, steps);
    }
    await getGlobalDispatch()(updateTestSteps(steps));
    const hadCursor = !!stepCursor;
    if (hadCursor) {
      const createdStepFromServer = steps.find(
        (s) => step.id && s.id === step.id || s.stepOrder === step.stepOrder && s.stepNumber === step.stepNumber && s.parentId === step.parentId
      );
      if (createdStepFromServer) {
        log.info(
          "[WIDGET] [STEP CREATION] Setting cursor to newly created step from server",
          createdStepFromServer
        );
        await getGlobalDispatch()(updateUserStepsCursor(createdStepFromServer));
      } else {
        log.warn(
          "[WIDGET] [STEP CREATION] Could not find created step in refreshed steps, clearing cursor"
        );
        await getGlobalDispatch()(updateUserStepsCursor(null));
      }
    } else {
      const nextCursor = moveStepCursorToNext(
        step,
        getStepInterimOrder(steps, step)
      );
      await getGlobalDispatch()(updateUserStepsCursor(nextCursor));
    }
    return step;
  } else {
    const step = await createStep(stepDetails);
    await getGlobalDispatch()(updateLastStep(step));
    log.info("[WIDGET] [STEP CREATION] STEP CREATED", step);
    if (stepCursor) {
      steps = await refreshPageContainingStep(step, true, false, {
        preserveLastProcessedData: true
      });
    } else {
      steps = await pushStep(step, steps);
    }
    await getGlobalDispatch()(updateTestSteps(steps));
    const hadCursor = !!stepCursor;
    if (hadCursor) {
      const createdStepFromServer = steps.find(
        (s) => step.id && s.id === step.id || s.stepOrder === step.stepOrder && s.stepNumber === step.stepNumber && s.parentId === step.parentId
      );
      if (createdStepFromServer) {
        log.info(
          "[WIDGET] [STEP CREATION] Setting cursor to newly created step from server",
          createdStepFromServer
        );
        await getGlobalDispatch()(updateUserStepsCursor(createdStepFromServer));
      } else {
        log.warn(
          "[WIDGET] [STEP CREATION] Could not find created step in refreshed steps, clearing cursor"
        );
        await getGlobalDispatch()(updateUserStepsCursor(null));
      }
    } else {
      log.info(
        "[WIDGET] [STEP CREATION] No cursor - clearing user steps cursor"
      );
      await getGlobalDispatch()(updateUserStepsCursor(null));
    }
    return step;
  }
};
var createStepWithIdentifier = async (step, identifier, addLast = false) => {
  step.isStepRecorder = true;
  step.elementRequest = identifier;
  const stepData = await createStep(step, addLast);
  return {
    step: stepData,
    identifier
  };
};
var createStep = async (step, addLast = false) => {
  log.info("[WIDGET] [STEP CREATION] createStep", step);
  const startTime = performance.now();
  let newStep = await StepApi.create(
    { ...step, id: void 0 },
    addLast,
    getGlobalState().widget.appVersionId
  );
  const endTime = performance.now();
  const duration = endTime - startTime;
  log.info(
    `[WIDGET] [STEP CREATION] StepApi.create took ${duration.toFixed(2)}ms`
  );
  newStep.stepNumber = step.stepNumber;
  newStep.indent = step.indent;
  newStep = setPresentationValue(step, newStep);
  newStep.applicationType = getApplicationType();
  return newStep;
};
var getApplicationType = () => {
  return getGlobalState()?.widget.appType || ApplicationType.WebApplication;
};
var setPresentationValue = (step, responsevalue) => {
  responsevalue.mapperData = step.mapperData;
  responsevalue.stepGroupParentStep = step.stepGroupParentStep;
  responsevalue.parentStepGroupIds = step.parentStepGroupIds;
  responsevalue.isStepGroupChild = step.isStepGroupChild;
  responsevalue.blockParentId = step.blockParentId;
  responsevalue.blockId = responsevalue?.blockId ?? step?.blockId;
  responsevalue.applicationType = step.applicationType;
  responsevalue.forLoopCondition = step.forLoopCondition;
  return responsevalue;
};
var clearLastProcessedData = async () => {
  await getGlobalDispatch()(updateLastStep(null));
  await getGlobalDispatch()(updateLastEventData(null));
};
var moveStepCursorToNext = (step, nextOrder = 1e3, movePos = 1e3, moveNext = false) => {
  const cursorStep = {};
  cursorStep.stepOrder = !moveNext && nextOrder ? nextOrder : (step?.stepOrder || 0) + movePos;
  cursorStep.indent = step?.indent || 0;
  cursorStep.stepNumber = step?.stepNumber ? getStepNumber(step.stepNumber, "below") : "-";
  cursorStep.parentId = step?.parentId;
  switch (step?.conditionType) {
    case STEP_CONDITION_TYPE.IF:
    case STEP_CONDITION_TYPE.ELSE_IF:
    case STEP_CONDITION_TYPE.ELSE:
    case STEP_CONDITION_TYPE.LOOP_FOR:
    case STEP_CONDITION_TYPE.LOOP_WHILE:
      cursorStep.parentId = step.id;
      cursorStep.indent = 1 + (step.indent || 0);
      cursorStep.stepNumber = step.stepNumber ? getStepNumber(step.stepNumber, "inside") : "-";
      break;
  }
  if (step?.blockParentId) {
    cursorStep.blockParentId = step.blockParentId;
  }
  log.info(
    "[WIDGET] [STEP CREATION] Moving step cursor to stepOrder=",
    cursorStep.stepOrder,
    "stepNumber=",
    cursorStep.stepNumber,
    "indent=",
    cursorStep.indent,
    "parentId=",
    cursorStep.parentId
  );
  return cursorStep;
};
var eventStepUpdate = async (step, identifierDetails) => {
  let steps = structuredClone(getGlobalState()?.widget.testSteps);
  let updatableStep = steps.find(({ id }) => id === step.id);
  if (!updatableStep) {
    updatableStep = steps.find(({ stepOrder }) => stepOrder === step.stepOrder);
  }
  if (updatableStep) {
    await getGlobalDispatch()(
      updateLastStep({
        ...updatableStep,
        elementRequest: identifierDetails
      })
    );
    updatableStep.timestamp = step?.timestamp;
    step.testStepElements = updatableStep.testStepElements;
    const updatedStep = await updateStep({
      ...step,
      id: updatableStep.id
    });
    if (updatedStep) {
      const nextCursor = moveStepCursorToNext(
        updatedStep,
        updatedStep?.stepOrder,
        1e3,
        true
      );
      await getGlobalDispatch()(updateUserStepsCursor(nextCursor));
    } else {
      await getGlobalDispatch()(updateUserStepsCursor(null));
    }
  } else {
    const createdStep = await createStep(step);
    await getGlobalDispatch()(
      updateLastStep({
        ...step,
        elementRequest: identifierDetails
      })
    );
    steps = await pushStep(step, steps);
    await getGlobalDispatch()(updateTestSteps(steps));
    const nextCursor = moveStepCursorToNext(
      createdStep,
      getStepInterimOrder(steps, step)
    );
    await getGlobalDispatch()(updateUserStepsCursor(nextCursor));
  }
};

// src/components/test-recorder/utils/step/step.ts
var formatTestDataByType = (type, value) => {
  switch (type) {
    case TEST_DATA_ENVIRONMENT.apiKey:
      return TEST_DATA_ENVIRONMENT.format(value);
    case TEST_DATA_DATAPROFILE.apiKey:
      return TEST_DATA_DATAPROFILE.format(value);
    case TEST_DATA_FUNCTION.apiKey:
      return TEST_DATA_FUNCTION.format(value);
    case TEST_DATA_MAILBOX.apiKey:
      return TEST_DATA_MAILBOX.format(value);
    case TEST_DATA_PHONE_NUMBER.apiKey:
      return TEST_DATA_PHONE_NUMBER.format(value);
    case TEST_DATA_RUNTIME.apiKey:
      return TEST_DATA_RUNTIME.format(value);
    case TEST_DATA_RANDOM.apiKey:
      return TEST_DATA_RANDOM.format(value);
    case TEST_DATA_UPLOAD.apiKey:
      return TEST_DATA_UPLOAD.format(value);
  }
  return value;
};
var getHighlightedStepAction = ({
  step,
  template,
  isStaticView,
  dataProfiles
}) => {
  let highlightedText = template?.grammar || step.action || "";
  step.stepDataList?.forEach((item) => {
    const testDataValue = item.isEncrypted ? "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022" : item.value;
    let allowedValues = null;
    if (template?.allowedValues) {
      const nlpTemplate = template;
      allowedValues = nlpTemplate.allowedValues ? nlpTemplate.allowedValues[item.key] : void 0;
    }
    highlightedText = highlightedText.replace(
      template ? TEST_DATA.getPatternByData(item.key) : item.value,
      TEST_DATA.highlightPlaceholder(
        formatTestDataByType(
          item.type,
          !isStaticView ? TEST_DATA.actionableSpan({
            text: testDataValue,
            stepId: step.id,
            dataKey: item.key,
            dataType: item.type,
            isPredefinedValue: !!allowedValues
          }) : testDataValue
        ),
        allowedValues ? "text-purple-700" : ""
      )
    );
  });
  step.testStepElements?.forEach((item) => {
    const patterns = template && item.elementType === TestStepElementType.FROM_UI_ELEMENT ? [IDENTIFIER.fromIdentifier.apiPattern, "#{from-ui-identifier}"] : template && item.elementType === TestStepElementType.TO_UI_ELEMENT ? [IDENTIFIER.toIdentifier.apiPattern, "#{to-ui-identifier}"] : template ? [IDENTIFIER.apiPattern] : [item.name];
    const dataMapKey = item.elementType === TestStepElementType.FROM_UI_ELEMENT ? IDENTIFIER.fromIdentifier.apiKey : item.elementType === TestStepElementType.TO_UI_ELEMENT ? IDENTIFIER.toIdentifier.apiKey : "element";
    const displayName = item.name || "element";
    const placeholder = IDENTIFIER.highlightPlaceholder(
      displayName,
      step.id,
      dataMapKey,
      isStaticView
    );
    const patternToReplace = patterns.find(
      (p) => highlightedText.includes(p)
    );
    if (patternToReplace) {
      highlightedText = highlightedText.replace(
        patternToReplace,
        placeholder
      );
    }
  });
  if (step[ATTRIBUTE.apiKey]) {
    const attrData = step[ATTRIBUTE.apiKey];
    highlightedText = highlightedText.replace(
      template ? ATTRIBUTE.apiPattern : attrData,
      ATTRIBUTE.highlightPlaceholder(attrData)
    );
  }
  if (step.kibbutzPluginNlpData?.testData) {
    Object.keys(step.kibbutzPluginNlpData?.testData).map((reference) => {
      const referenceValue = step.kibbutzPluginNlpData?.testData[reference].value;
      highlightedText = highlightedText.replace(
        template ? reference : referenceValue,
        TEST_DATA.highlightPlaceholder(
          formatTestDataByType(
            step.kibbutzPluginNlpData?.testData[reference].type,
            !isStaticView ? TEST_DATA.actionableSpan({
              text: referenceValue,
              stepId: step.id,
              dataKey: reference,
              dataType: step.kibbutzPluginNlpData?.testData[reference].type,
              isPredefinedValue: false
            }) : referenceValue
          )
        )
      );
    });
  }
  if (step.kibbutzPluginNlpData?.uiIdentifiers) {
    Object.keys(step.kibbutzPluginNlpData?.uiIdentifiers).map((reference) => {
      const referenceValue = step.kibbutzPluginNlpData?.uiIdentifiers[reference].name;
      highlightedText = highlightedText.replace(
        template ? reference : referenceValue,
        IDENTIFIER.highlightPlaceholder(
          referenceValue,
          step.id,
          reference,
          isStaticView
        )
      );
    });
  }
  if (step.forLoopCondition && template) {
    const forLoopDataMap = step.forLoopCondition;
    const tempalateTestData = template.data.testData;
    const nlpTemplate = template;
    const allowedValues = nlpTemplate.allowedValues;
    if (tempalateTestData) {
      Object.keys(tempalateTestData).forEach((testDataKey) => {
        const isPredefinedItem = allowedValues && !!allowedValues[testDataKey];
        let stepTestDataValue = forLoopDataMap[testDataKey]?.value || tempalateTestData[testDataKey];
        const stepTestDataType = forLoopDataMap[testDataKey]?.type || TEST_DATA_PLAINTEXT.apiKey;
        switch (testDataKey) {
          case "leftData":
            stepTestDataValue = stepTestDataValue === "-1" ? "start" : stepTestDataValue;
            break;
          case "rightData":
            stepTestDataValue = stepTestDataValue === "-1" ? "end" : stepTestDataValue;
            break;
          case "testDataProfile":
            stepTestDataValue = dataProfiles.find(
              ({ id }) => id === forLoopDataMap[FOR_LOOP_TEST_DATA_MAPPER[testDataKey].apiKey.value]?.id
            )?.testDataName || stepTestDataValue;
            break;
          case "operator":
            stepTestDataValue = forLoopDataMap[testDataKey] === "NONE" ? tempalateTestData[testDataKey] : forLoopDataMap[testDataKey];
            break;
        }
        highlightedText = highlightedText.replace(
          template ? TEST_DATA.getPatternByData(testDataKey) : stepTestDataValue,
          TEST_DATA.highlightPlaceholder(
            formatTestDataByType(
              stepTestDataType,
              !isStaticView ? TEST_DATA.actionableSpan({
                text: stepTestDataValue,
                stepId: step.id,
                dataKey: testDataKey,
                dataType: stepTestDataType,
                isPredefinedValue: isPredefinedItem
              }) : stepTestDataValue
            ),
            isPredefinedItem ? "text-purple-700" : ""
          )
        );
      });
    }
  }
  return highlightedText;
};
var getFormattedForLoopStep = (profileName, start, end, isHighlight = true, isStepResult) => {
  if (isHighlight) {
    return `<span><span class='step-type-lable shrink-0 mr-1.5'>FOR</span>[ <span class="border-dotted border-t-0 border-x-0 border-blue-700 text-blue-700 break-all">${profileName}</span> ] [ From <span class="border-dotted border-t-0 border-x-0 border-blue-700 text-blue-700 break-all">${start}</span> To <span class="border-dotted border-t-0 border-x-0 border-blue-700 text-blue-700 break-all">${end}</span>]</span>`;
  } else {
    return `FOR [ ${profileName} ] [${start} ...${end}]`;
  }
};
var getDummyStep = () => ({
  type: STEP_TYPE.NLP_TEXT,
  action: null,
  isMandatory: true,
  dataMap: {},
  disabled: STEP_FLAG.DISABLED.DEFAULT,
  ignoreStepResult: STEP_FLAG.IGNORE_STEP_RESULT.DEFAULT,
  waitTime: STEP_FLAG.WAIT_TIME.DEFAULT,
  visualEnabled: STEP_FLAG.VISUAL_TESTING.DEFAULT,
  highlightElement: STEP_FLAG.HIGHLIGHT_ELEMENT.DEFAULT,
  priority: STEP_PRIORITY.MAJOR,
  maxIterations: STEP_FLAG.MAX_ITERATION.DEFAULT,
  forLoopCondition: null
});
var isConditionalTestStepType = (stepType) => {
  return CONDITION_STEP_TYPES.includes(stepType);
};
var isKibbutzStep = (step) => {
  return step.kibbutzPluginNlpId || step.kibbutzPluginNlpId == 0 || step.kibbutzPluginNlpId == -1;
};
var fetchAllParentDataProfiles = (steps, step, testCase, idx) => {
  const parentDataProfiles = [];
  let _idx = idx;
  let parentId = step.parentId;
  if (testCase?.testCaseDataDrivenCondition?.testDataProfileId || testCase?.testDataId) {
    parentDataProfiles.push({
      dataProfileId: testCase?.testCaseDataDrivenCondition?.testDataProfileId || testCase?.testDataId
    });
  }
  if (step.conditionType === STEP_CONDITION_TYPE.LOOP_FOR) {
    parentDataProfiles.push({
      stepId: step.id,
      dataProfileId: step.forLoopCondition?.testDataProfile?.id || step.dataMap?.forLoop?.testDataId,
      stepSeq: step.seq,
      stepNumber: step.stepNumber
    });
  }
  while (_idx >= 0) {
    const parentStep = steps[_idx];
    if (!parentStep) {
      return parentDataProfiles;
    }
    if (step.groupSeq !== parentStep.groupSeq) {
      break;
    } else if (parentStep.conditionType === STEP_CONDITION_TYPE.LOOP_FOR && parentId === parentStep.id) {
      parentDataProfiles.push({
        stepId: parentStep.id,
        dataProfileId: parentStep.forLoopCondition?.testDataProfile?.id || parentStep.dataMap?.forLoop?.testDataId,
        stepSeq: parentStep.seq,
        stepNumber: parentStep.stepNumber
      });
      parentId = parentStep.parentId;
    }
    _idx--;
  }
  return parentDataProfiles;
};
var incrementIndentForBlockChild = (childStep, parentStep) => {
  if (parentStep.type == STEP_TYPE.BLOCK || parentStep.blockParentId) {
    childStep.blockParentId = parentStep.type == STEP_TYPE.BLOCK ? parentStep.id : parentStep.blockParentId;
    childStep.indent += 1;
  }
};
var flatTestSteps = ({
  teststeps,
  applicationType,
  stepGroup,
  stepGroupTestCase,
  page
}) => {
  const result = [];
  teststeps.forEach((item) => {
    item.pagenumber = page;
    let parentStep;
    if (item.parentId) {
      parentStep = teststeps.find((step) => step.id === item.parentId);
    }
    if (stepGroup) {
      item.indent = (item.indent || 0) + (stepGroup.indent || 0) + 1;
      item.stepNumber = `${stepGroup.stepNumber}.${item.stepNumber}`;
      item.isStepGroupChild = true;
      item.parentStepGroupIds = [...stepGroup.parentStepGroupIds || []];
      if (stepGroup.id) {
        item.parentStepGroupIds.push(stepGroup.id);
      }
      if (stepGroupTestCase?.testCaseDataDrivenCondition?.testDataProfileId) {
        item = setMapperData(
          stepGroup,
          item,
          stepGroupTestCase?.testCaseDataDrivenCondition
        );
      }
      item.hostTestCaseStepId = stepGroup?.id;
      item.isStepGroupSpotEdit = true;
    }
    if (parentStep) {
      item = setMapperData(parentStep, item, void 0);
      incrementIndentForBlockChild(item, parentStep);
    }
    item.applicationType = applicationType;
    result.push(item);
  });
  return result;
};
var setMapperData = (parentStep, childStep, sgTDP) => {
  const mapperData = [
    ...parentStep.mapperData || childStep.mapperData || []
  ];
  if (sgTDP) {
    mapperData.push({
      id: sgTDP.testDataProfileId,
      stepNumber: parentStep.stepNumber,
      name: sgTDP.testDataProfile.testDataName,
      stepScopeIsTestCase: false
    });
  } else if (parentStep.isForLoop) {
    mapperData.push({
      id: parentStep.forLoopCondition?.testDataProfile?.id || 0,
      stepNumber: parentStep.stepNumber,
      name: parentStep.forLoopCondition?.testDataProfile?.value || "",
      stepScopeIsTestCase: !parentStep.isStepGroupChild,
      lastLoopStepId: parentStep.id
    });
  }
  childStep.mapperData = mapperData.length > 0 ? mapperData : void 0;
  return setAdditionalData(parentStep, childStep);
};
var setAdditionalData = (parentStep, childStep) => {
  childStep.presentationMetaInfo = {
    isInsideLoop: parentStep.isInsideLoop || parentStep.isConditionalWhileLoop || parentStep.isForLoop,
    isInsideIf: parentStep.isInsideIf || parentStep.isConditionalIf || parentStep.isConditionalElse || parentStep.isConditionalElseIf,
    isInsideWhileLoop: parentStep.isInsideWhileLoop || parentStep.isConditionalWhileLoop,
    isInsideForLoop: parentStep.isInsideForLoop || parentStep.isForLoop
  };
  return childStep;
};
var addStepNumber2 = (id, type) => {
  if (id.includes(" ... ")) {
    id = id.split(" ... ")[1];
  }
  const idArray = id.split(".").map((value) => parseInt(value));
  const length = idArray.length;
  {
    if (length > 1) {
      idArray[length - 2]++;
    } else {
      idArray[0]++;
    }
  }
  return idArray.join(".");
};
var getStepNumber = (stepNumber, where) => {
  if (stepNumber === "-") {
    return stepNumber;
  }
  if (where === "inside") {
    return stepNumber + ".1";
  } else if (where === "above") {
    return stepNumber;
  } else if (where === "below") {
    const parts = stepNumber.split(".");
    const lastPart = parseInt(parts[parts.length - 1]);
    parts[parts.length - 1] = (lastPart + 1).toString();
    return parts.join(".");
  } else {
    return stepNumber;
  }
};
var getPageNumber = (stepNumber, fallback) => {
  if (!stepNumber) {
    return fallback;
  }
  const parentStepNumber = parseInt(stepNumber);
  return parentStepNumber === 0 ? 0 : Math.floor((parentStepNumber - 1) / STEPS_PAGE_SIZE);
};
var getTestStepDetails = async (eventData, identifierName, template) => {
  const stepTestData = getTestData(eventData, template);
  const templateGrammer = parseTemplateGrammer(
    template.grammar,
    stepTestData,
    identifierName.name
  );
  let stepData = {
    testCaseId: getGlobalState()?.widget?.testCase?.id,
    type: STEP_TYPE.NLP_TEXT,
    action: templateGrammer,
    templateId: template.id,
    waitTime: STEP_FLAG.WAIT_TIME.DEFAULT,
    stepDataList: Object.keys(stepTestData)?.length ? stepTestData : null,
    attribute: template.data?.attribute || void 0,
    disabled: STEP_FLAG.DISABLED.DEFAULT,
    isMandatory: true,
    ignoreStepResult: STEP_FLAG.IGNORE_STEP_RESULT.DEFAULT,
    preRequisiteStepId: null,
    visualEnabled: STEP_FLAG.VISUAL_TESTING.DEFAULT,
    highlightElement: STEP_FLAG.HIGHLIGHT_ELEMENT.DEFAULT,
    priority: "MAJOR",
    maxIterations: STEP_FLAG.MAX_ITERATION.DEFAULT,
    timestamp: eventData?.timestamp
  };
  if (eventData.step) {
    stepData = {
      ...stepData,
      parentId: eventData.step.parentId,
      stepSeq: eventData.step.stepSeq
    };
  }
  return stepData;
};
var getTestData = (eventData, template) => {
  let testData2 = TEST_DATA.label;
  const templateTestData = template?.data.testData;
  const templateTestDataKey = templateTestData ? Object.keys(templateTestData)[0] : TEST_DATA.apiKey;
  if (!templateTestDataKey) {
    return [];
  }
  if (eventData.action === CLIENT_EVENT.SCROLL || eventData.action === CLIENT_EVENT.SCROLL_WINDOW) {
    if (templateTestData) {
      const scrollTestData = [];
      const isHorizontalScroll = eventData.attrs.horizontal > 0;
      Object.keys(templateTestData).forEach((templateTestDataKey2) => {
        let value = eventData.attrs.horizontal;
        if (templateTestDataKey2 === TEST_DATA.apiKey) {
          value = isHorizontalScroll ? value : eventData.attrs.vertical;
        } else {
          value = isHorizontalScroll ? TEST_DATA.SCROLL.HORIZONTALLY : TEST_DATA.SCROLL.VERTICALLY;
        }
        scrollTestData.push({
          value: value?.toString() || "",
          key: templateTestDataKey2,
          type: TEST_DATA_PLAINTEXT.apiKey
        });
      });
      return scrollTestData;
    }
  } else if (eventData.action === CHROME_EVENT.RELOAD_PAGE) {
    testData2 = TEST_DATA.BROWSER_NAVIGATE_BUTTONS.REFRESH;
  } else if (eventData.action === CHROME_EVENT.NAVIGATE_BACKWARD) {
    testData2 = TEST_DATA.BROWSER_NAVIGATE_BUTTONS.BACK;
  } else if (eventData.action === CHROME_EVENT.NAVIGATE_FORWARD) {
    testData2 = TEST_DATA.BROWSER_NAVIGATE_BUTTONS.FORWARD;
  } else if (eventData.action === CLIENT_EVENT.MOVE) {
    if (templateTestData) {
      const sliderTestData = [];
      Object.keys(templateTestData).forEach((templateTestDataKey2, idx) => {
        const value = idx === 0 ? eventData.attrs.x : eventData.attrs.y;
        sliderTestData.push({
          value: (typeof value === "number" ? Math.round(value) : value)?.toString() || "",
          type: TEST_DATA_PLAINTEXT.apiKey,
          key: templateTestDataKey2
        });
      });
      return sliderTestData;
    }
  } else if (eventData.action === CLIENT_EVENT.UPLOAD) {
    return [
      {
        value: `${cleanFileName(eventData.attrs.value || "")}`,
        type: TEST_DATA_UPLOAD.apiKey,
        key: templateTestDataKey,
        uploadVersionData: {
          uploadId: eventData.attrs.uploadId
        },
        uploadIdList: eventData.attrs.uploadIdList
      }
    ];
  } else if (eventData.attrs.value) {
    testData2 = eventData.attrs.value.toString();
  } else if (eventData.action == CLIENT_EVENT.CLICK && template.displayName == TEMPLATE_DISPLAY_NAME.PICKLIST) {
    testData2 = eventData?.text || "";
  } else if (eventData?.action == CLIENT_EVENT.CLICK && template.displayName == TEMPLATE_DISPLAY_NAME.SELECT_MULTISELECT_OPTIONS) {
    testData2 = eventData?.sfPredefinedElementDetails?.compositeElementDetails?.optionsToSelect?.join(
      ","
    ) || "";
  } else if (eventData?.action == CLIENT_EVENT.CLICK && template.displayName == TEMPLATE_DISPLAY_NAME.REMOVE_MULTISELECT_OPTIONS) {
    log.info("[WIDGET] TestData", eventData?.sfPredefinedElementDetails);
    testData2 = eventData?.sfPredefinedElementDetails?.compositeElementDetails?.optionsToRemove?.join(
      ","
    ) || "";
  } else if (eventData.action == CLIENT_EVENT.CLICK && template.displayName == TEMPLATE_DISPLAY_NAME.LOOKUP) {
    testData2 = eventData?.text || "";
  } else if (eventData.action === CLIENT_EVENT.INPUT && eventData.tag !== TAG_NAME.INPUT) {
    testData2 = eventData.text || testData2;
  } else if (eventData.tag === TAG_NAME.SELECT && !!eventData.selectOptionAttrs?.index) {
    testData2 = `${eventData.selectOptionAttrs.index}`;
  }
  return [
    {
      value: testData2?.toString(),
      type: TEST_DATA_PLAINTEXT.apiKey,
      key: templateTestDataKey
    }
  ];
};
var pushStep = async (step, steps) => {
  let maxFetchedPageNumber = selectMaxFetchedPageNumber(getGlobalState());
  const extensibleStep = { ...step };
  if (!isNumber(extensibleStep.pagenumber)) {
    extensibleStep.pagenumber = getPageNumber(
      extensibleStep.stepNumber,
      maxFetchedPageNumber
    );
  }
  if (isNumber(extensibleStep.pagenumber)) {
    maxFetchedPageNumber = Math.max(
      maxFetchedPageNumber,
      extensibleStep.pagenumber
    );
    await getGlobalDispatch()(updateMaxFetchedPageNumber(maxFetchedPageNumber));
  }
  return [...steps, extensibleStep];
};
var getStepInterimOrder = (stepList, currentStep) => {
  const [firstHalf, secondHalf] = partition$2(
    stepList,
    (item) => item.stepOrder <= currentStep.stepOrder
  );
  let newStepOrder = secondHalf[0]?.stepOrder ? (secondHalf[0]?.stepOrder + currentStep?.stepOrder) / 2 : currentStep?.stepOrder + 1e3;
  newStepOrder = newStepOrder == currentStep.stepOrder ? newStepOrder + 1e3 : newStepOrder;
  return newStepOrder;
};
var getDragDropTestStep = async (fromIdentifier, toIdentifier, template) => {
  return {
    testCaseId: getGlobalState()?.widget?.testCase?.id,
    type: STEP_TYPE.NLP_TEXT,
    action: parseDragDropTemplateGrammer(
      template.grammar,
      fromIdentifier,
      toIdentifier
    ),
    templateId: template.id,
    waitTime: DEFAULT_STEP_WAIT_TIME,
    dataMap: {
      [IDENTIFIER.fromIdentifier.apiKey]: fromIdentifier,
      [IDENTIFIER.toIdentifier.apiKey]: toIdentifier,
      "from-ui-identifier": fromIdentifier,
      "to-ui-identifier": toIdentifier
    },
    disabled: STEP_FLAG.DISABLED.DEFAULT,
    isMandatory: true,
    ignoreStepResult: STEP_FLAG.IGNORE_STEP_RESULT.DEFAULT,
    preRequisiteStepId: null,
    visualEnabled: STEP_FLAG.VISUAL_TESTING.DEFAULT,
    highlightElement: STEP_FLAG.HIGHLIGHT_ELEMENT.DEFAULT,
    priority: STEP_FLAG.PRIORITY.DEFAULT,
    maxIterations: STEP_FLAG.MAX_ITERATION.DEFAULT
  };
};
var updateStep = async (step) => {
  if (step.type === STEP_TYPE.WHILE_LOOP) {
    step.type = STEP_TYPE.NLP_TEXT;
  }
  delete step.seq;
  delete step.groupSeq;
  delete step.level;
  delete step.subType;
  delete step.parentDataProfileIds;
  if (step.forLoopCondition) {
    delete step.forLoopCondition.testDataProfileId;
  }
  if (step?.forLoopOverRiddenMapping || step?.testStepDataOverRiddenMappings || step?.uiIdentifierOverRittenMappings || step?.isStepGroupChild) {
    delete step.stepOrder;
  }
  const steps = structuredClone(getGlobalState()?.widget.testSteps);
  let updatedStep = await StepApi.update(
    step,
    getGlobalState()?.widget.appVersionId
  );
  updatedStep.stepNumber = step.stepNumber;
  updatedStep.indent = step.indent;
  updatedStep = setPresentationValue(step, updatedStep);
  const stepIdx = await getTestStepDetailsIndex({
    steps,
    stepId: updatedStep.id
  });
  const isDisableChanged = steps.find((s) => s.id === step.id)?.disabled !== step.disabled;
  const updatedSteps = isDisableChanged ? recursiveStepReplace(steps, step) : steps.map((step2, idx) => idx === stepIdx ? updatedStep : step2);
  await getGlobalDispatch()(updateTestSteps(updatedSteps));
  return updatedStep;
};
var getTestStepDetailsIndex = async ({
  steps,
  stepId,
  pos
}) => {
  return steps.findIndex(
    ({ id, stepOrder }) => id === stepId || stepOrder === pos
  );
};
var recursiveStepReplace = (stepsList, stepData) => {
  const updatedSteps = stepReplace(stepsList, stepData)?.map((item) => {
    if (item.parentId === stepData.id) {
      item.disabled = stepData.disabled;
      recursiveStepReplace(stepsList, item);
    }
    return item;
  });
  return updatedSteps;
};
var stepReplace = (steps, newStep) => {
  const index = steps.findIndex((step) => step.id === newStep.id || !step.id);
  const updatedSteps = [...steps];
  if (index !== -1) {
    updatedSteps[index] = newStep;
  }
  return updatedSteps;
};
var deleteTestStep = async (ids) => {
  if (!ids) return;
  let idList = [];
  if (typeof ids === "number") {
    idList = [ids];
    await StepApi.deleteOne(ids, getGlobalState()?.widget.appVersionId);
  } else {
    idList = ids;
    await StepApi.deleteMany(ids, getGlobalState()?.widget.appVersionId);
  }
  const deletedSteps = structuredClone(
    getGlobalState()?.widget.testSteps
  ).filter((step) => step.id && idList.includes(step.id));
  const minObject = deletedSteps.reduce(
    (min, obj) => isNumber(obj?.pagenumber) && isNumber(min.pagenumber) && obj.pagenumber < min.pagenumber ? obj : min,
    deletedSteps[0]
  );
  const updatedSteps = await refreshPageContainingStep(minObject, true);
  await getGlobalDispatch()(updateTestSteps(updatedSteps));
  return;
};
var getManualStep = (data) => {
  if (data.forLoopCondition && data.forLoopCondition.iterationType === FOR_LOOP_TEMPLATE_TYPE.INDEX) {
    if (!data.forLoopCondition.leftData) {
      data.forLoopCondition = {
        ...data.forLoopCondition,
        ...FOR_LOOP_TEST_DATA.INDEX
      };
    }
    if (data.forLoopCondition?.leftData?.value === "start") {
      data.forLoopCondition.leftData.value = "-1";
    }
    if (data.forLoopCondition?.rightData?.value === "end") {
      data.forLoopCondition.rightData.value = "-1";
    }
  }
  if (data.forLoopCondition) {
    delete data.forLoopCondition.testDataProfileId;
  }
  return {
    testCaseId: getGlobalState()?.widget?.testCase?.id,
    stepOrder: data.stepOrder,
    type: data.type,
    action: data.action,
    templateId: data.templateId,
    waitTime: data.waitTime,
    disabled: data.disabled,
    stepDataList: data.stepDataList,
    attribute: data.attribute,
    testStepElements: data.testStepElements,
    ignoreStepResult: data.type === STEP_TYPE.FOR_LOOP ? true : data.ignoreStepResult,
    preRequisiteStepId: data.preRequisiteStepId,
    visualEnabled: data.visualEnabled,
    highlightElement: data.highlightElement,
    kibbutzPluginNlpData: data.kibbutzPluginNlpData,
    kibbutzPluginNlpId: data.kibbutzPluginNlpId,
    testComponentId: data.testComponentId,
    priority: data.priority,
    conditionType: data.conditionType,
    parentId: data.parentId,
    testStepDataOverRiddenMappings: data.testStepDataOverRiddenMappings,
    maxIterations: data.maxIterations,
    forLoopCondition: data.forLoopCondition,
    indent: data.indent,
    stepNumber: data.stepNumber,
    stepGroupId: data.stepGroupId,
    blockParentId: data.blockParentId,
    salesforceAPIStep: data?.salesforceAPIStep
  };
};
var handleCreateInterimStep = async (value) => {
  const createdStep = await createInterimStep(value);
  const nextCursor = moveStepCursorToNext(
    createdStep,
    value["intermediateStepOrder"]
  );
  getGlobalDispatch()(updateUserStepsCursor(nextCursor));
};
var createInterimStep = async (value) => {
  if (value.type === STEP_TYPE.WHILE_LOOP) {
    return await createManualInterimWhileStep(value);
  }
  const stepDetails = await getManualStep(value);
  return await createManualInterimStep(value, stepDetails);
};
var createManualInterimWhileStep = async (value) => {
  log.debug("[WIDGET] INTERIM WHILE STEP REQUEST", value);
  const stepDetails = getManualStep(value);
  stepDetails.type = STEP_TYPE.NLP_TEXT;
  stepDetails.parentId = value.parentId || void 0;
  return await createManualInterimStep(value, stepDetails);
};
var createManualInterimStep = async (value, stepDetails) => {
  const dispatch = getGlobalDispatch();
  const step = await createStep({
    ...stepDetails,
    stepOrder: value.stepOrder
  });
  log.info("[WIDGET] INTERIM STEP CREATED", step);
  const updatedSteps = await refreshPageContainingStep(step, true);
  await dispatch(updateTestSteps(updatedSteps));
  return step;
};
var updateTestStep = async (step) => {
  updateStep(step);
  await getGlobalDispatch()(updateUserStepsCursor(null));
};
var processDebuggerResult = (_result) => {
  const result = cloneDeep(_result);
  if (result?.childStepResults) {
    result.childResults = result.childStepResults;
  }
  switch (result?.result?.id) {
    case 0:
      result.result = ResultConstant.SUCCESS;
      break;
    case 1:
      result.result = ResultConstant.FAILURE;
      break;
    case 3:
      result.result = ResultConstant.NOT_EXECUTED;
      break;
    case 5:
      result.result = ResultConstant.QUEUED;
      break;
    case 6:
      result.result = ResultConstant.STOPPED;
      break;
    case 7:
      result.result = ResultConstant.PAUSED;
      break;
    case 9:
      result.result = ResultConstant.RUNNING;
      break;
  }
  switch (result?.priority?.id) {
    case 1:
      result.priority = TestStepPriority.MAJOR;
      break;
    case 2:
      result.priority = TestStepPriority.MINOR;
      break;
    case 3:
      result.priority = TestStepPriority.MEDIUM;
      break;
  }
  if (result && typeof result.resultType === "object") {
    delete result.resultType;
  }
  if (result.autoHealMetadata) {
    processAutoHealResult(result);
  }
  result.stepId = result?.metadata?.testStep?.id;
  result.id = result?.uuid ?? result.id;
  return result;
};
var processAutoHealResult = (result) => {
  result.autoHealMetadata.status = processAutoHealStatus(
    result.autoHealMetadata.status
  );
  if (result.autoHealMetadata.healedElements) {
    const entries = result.autoHealMetadata.healedElements instanceof Map ? Array.from(result.autoHealMetadata.healedElements.entries()) : Object.entries(result.autoHealMetadata.healedElements);
    result.autoHealMetadata.healedElements = new Map(
      entries.map(([key, value]) => [
        key,
        processAutoHealElement(value)
      ])
    );
  }
};
var processAutoHealElement = (element) => {
  element.status = processAutoHealStatus(element.status);
  element.originalLocatorType = processElementLocatorType(
    element.originalLocatorType
  );
  element.healedLocatorType = processElementLocatorType(
    element.healedLocatorType
  );
  if (element.hostElements?.length > 0) {
    element.hostElements = processHostElements(element.hostElements);
  }
  return element;
};
var processHostElements = (hostElements) => {
  return hostElements.map((hostElement) => {
    hostElement.originalLocatorType = processElementLocatorType(
      hostElement.originalLocatorType
    );
    hostElement.healedLocatorType = processElementLocatorType(
      hostElement.healedLocatorType
    );
    hostElement.hostType = processHostType(hostElement.hostType);
    return hostElement;
  });
};
var processHostType = (hostType) => {
  switch (hostType?.id) {
    case 0:
      hostType = ElementIdentifierHostType.IFRAME;
      break;
    case 1:
      hostType = ElementIdentifierHostType.SHADOW;
      break;
  }
  return hostType;
};
var processAutoHealStatus = (status) => {
  switch (status?.id) {
    case 0:
      status = AutoHealStatus.SUCCESS;
      break;
    case 1:
      status = AutoHealStatus.FAILURE;
      break;
  }
  return status;
};
var processElementLocatorType = (locatorType) => {
  switch (locatorType?.id) {
    case 1:
      return ElementIdentifierLocatorType.xpath;
    case 2:
      return ElementIdentifierLocatorType.csspath;
    case 3:
      return ElementIdentifierLocatorType.id_value;
    case 4:
      return ElementIdentifierLocatorType.name;
    case 5:
      return ElementIdentifierLocatorType.link_text;
    case 6:
      return ElementIdentifierLocatorType.partial_link_text;
    case 7:
      return ElementIdentifierLocatorType.class_name;
    case 8:
      return ElementIdentifierLocatorType.tag_name;
    case 9:
      return ElementIdentifierLocatorType.accessibility_id;
    case 10:
      return ElementIdentifierLocatorType.flutter_key;
    case 11:
      return ElementIdentifierLocatorType.flutter_text;
    case 12:
      return ElementIdentifierLocatorType.flutter_text_containing;
    case 13:
      return ElementIdentifierLocatorType.flutter_type;
    case 14:
      return ElementIdentifierLocatorType.flutter_semantics_label;
  }
};

// src/components/test-recorder/utils/debugger-stream/result-constant-mapper.ts
var RESULT_CONSTANT_MAP = {
  0: "SUCCESS",
  1: "FAILURE",
  3: "NOT_EXECUTED",
  4: "QUEUED",
  5: "STOPPED",
  6: "PAUSED",
  7: "RUNNING"
};
function resultConstantToStatus(value) {
  if (value === void 0 || value === null) {
    return void 0;
  }
  return RESULT_CONSTANT_MAP[value];
}
var RESULT_CONSTANT_FIELDS = [
  "result",
  "dataDrivenAfterParentResult",
  "afterSuiteHostSuiteResult",
  "afterSuiteHostCaseResult"
];
function convertResultConstantsInObject(obj) {
  if (!obj || typeof obj !== "object") {
    return obj;
  }
  const result = { ...obj };
  for (const key of Object.keys(result)) {
    const value = result[key];
    if (RESULT_CONSTANT_FIELDS.includes(key) && typeof value === "number") {
      const status = resultConstantToStatus(value);
      result[key] = status;
    }
    if (value && typeof value === "object" && !Array.isArray(value)) {
      result[key] = convertResultConstantsInObject(
        value
      );
    }
  }
  return result;
}
var DEBUGGER_STREAM_TYPE = {
  STEP_STATUS: "ts_debug_status_1",
  TESTCASE_RESULT: "ts_24"
};
var DEBUGGER_SOURCE = "testsigma_web";
var AUTO_HEAL_STATUS_MAP = {
  0: AutoHealStatus.SUCCESS,
  1: AutoHealStatus.FAILURE
};
var LOCATOR_TYPE_MAP = {
  0: "xpath",
  1: "csspath",
  2: "id_value",
  3: "name",
  4: "link_text",
  5: "partial_link_text",
  6: "class_name",
  7: "tag_name",
  8: "accessibility_id",
  9: "ios_predicate_string",
  10: "ios_class_chain",
  11: "js_path",
  12: "resource_id",
  13: "IMAGE",
  14: "flutter_key",
  15: "flutter_text",
  16: "flutter_text_containing",
  17: "flutter_type",
  18: "flutter_semantics_label"
};
var HOST_TYPE_MAP = {
  0: "IFRAME",
  1: "SHADOW"
};
var AUTO_HEAL_TYPE_MAP = {
  0: AutoHealType.BACKUP_LOCATOR_HEAL,
  1: AutoHealType.GEN_AI_AUTOHEAL,
  2: AutoHealType.LEGACY_AUTOHEAL,
  3: "SAVED_LOCATOR_HEAL",
  4: AutoHealType.IMAGE_AUTOHEAL
};
var AUTO_HEAL_ACTION_TYPE_MAP = {
  0: "DATA_FETCH",
  1: "DATA_VALIDATION",
  2: "PERFORMED"
};
function mapNumericEnum(value, enumMap) {
  if (typeof value === "number" && value in enumMap) {
    return enumMap[value];
  }
  return value;
}
function convertHealedElement(element) {
  return {
    ...element,
    status: mapNumericEnum(element.status, AUTO_HEAL_STATUS_MAP),
    healType: mapNumericEnum(element.healType, AUTO_HEAL_TYPE_MAP),
    actionType: mapNumericEnum(element.actionType, AUTO_HEAL_ACTION_TYPE_MAP),
    originalLocatorType: mapNumericEnum(
      element.originalLocatorType,
      LOCATOR_TYPE_MAP
    ),
    healedLocatorType: mapNumericEnum(
      element.healedLocatorType,
      LOCATOR_TYPE_MAP
    ),
    hostElements: Array.isArray(element.hostElements) ? element.hostElements.map((he) => ({
      ...he,
      originalLocatorType: mapNumericEnum(
        he.originalLocatorType,
        LOCATOR_TYPE_MAP
      ),
      healedLocatorType: mapNumericEnum(
        he.healedLocatorType,
        LOCATOR_TYPE_MAP
      ),
      hostType: mapNumericEnum(he.hostType, HOST_TYPE_MAP)
    })) : element.hostElements
  };
}
function convertAutoHealEnums(stepResult) {
  const meta = stepResult.autoHealMetadata;
  if (!meta) return stepResult;
  const healedElements = meta.healedElements;
  const convertedElements = healedElements ? new Map(
    Object.entries(healedElements).map(([key, el]) => [
      key,
      convertHealedElement(el)
    ])
  ) : healedElements;
  return {
    ...stepResult,
    autoHealMetadata: {
      ...meta,
      status: mapNumericEnum(meta.status, AUTO_HEAL_STATUS_MAP),
      healedElements: convertedElements
    }
  };
}
function parseTestStepNotification(notification) {
  const liveStepResults = notification.liveStepResults?.map(
    (step) => convertAutoHealEnums(step)
  );
  return {
    liveStepResults,
    debugPoints: notification.debugPoints,
    testCaseId: notification.testCaseId,
    from: DEBUGGER_SOURCE,
    type: DEBUGGER_STREAM_TYPE.STEP_STATUS,
    isDifferentTab: notification.isDifferentTab ?? false
  };
}
function parseTestCaseNotification(notification) {
  const enrichedTestCaseResult = notification.testCaseResult ? convertResultConstantsInObject(notification.testCaseResult) : notification.testCaseResult;
  return {
    testCaseResult: enrichedTestCaseResult
  };
}
function isTestStepNotification(notification) {
  return notification.liveStepResults !== void 0;
}
function isTestCaseNotification(notification) {
  return notification.testCaseResult !== void 0;
}

// src/components/test-recorder/utils/debugger-stream/bigint-converter.ts
function convertBigIntToNumber(value) {
  if (value === null || value === void 0) {
    return value;
  }
  if (typeof value === "bigint") {
    return Number(value);
  }
  if (Array.isArray(value)) {
    return value.map((item) => convertBigIntToNumber(item));
  }
  if (value instanceof Map) {
    const result = {};
    for (const [key, val] of value.entries()) {
      result[key] = convertBigIntToNumber(val);
    }
    return result;
  }
  if (value instanceof Date) {
    return value;
  }
  if (typeof value === "object") {
    const result = {};
    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        result[key] = convertBigIntToNumber(value[key]);
      }
    }
    const protoValue = value;
    if (protoValue.$typeName) {
      result.$typeName = protoValue.$typeName;
    }
    return result;
  }
  return value;
}
function containsBigInt(value) {
  if (value === null || value === void 0) {
    return false;
  }
  if (typeof value === "bigint") {
    return true;
  }
  if (Array.isArray(value)) {
    return value.some((item) => containsBigInt(item));
  }
  if (value instanceof Map) {
    for (const [, val] of value.entries()) {
      if (containsBigInt(val)) {
        return true;
      }
    }
    return false;
  }
  if (typeof value === "object") {
    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        if (containsBigInt(value[key])) {
          return true;
        }
      }
    }
  }
  return false;
}

// src/components/test-recorder/utils/index.ts
var isDyanamicId2 = (id, checkForNumbers = true) => checkForNumbers && isStrHasNumber(id) || EXCLUDE_CONFIG.KEYWORDS.some((key) => id.includes(key));
var canIgnoreId2 = (id, checkForNumbers = true) => {
  if (!id) {
    return true;
  }
  return isDyanamicId2(id, checkForNumbers);
};

// src/components/test-recorder/api/element-image.ts
var uploadElementImage = async ({ presignedUploadUrl, base64_image }) => {
  const myHeaders = new Headers({ "Content-Type": "image/*" });
  await Api.fetch(presignedUploadUrl, {
    method: "PUT",
    headers: myHeaders,
    body: dataurltoFile(base64_image)
  });
};
var nameSpace2 = PrivateURLConstants.ELEMENTS;
var create2 = async (data) => {
  const res = await instance_default.post(nameSpace2, data);
  handleElementImage(
    res["imageLocator"] || {},
    data?.["elementImageDraft"] || {}
  );
  return res;
};
var handleElementImage = (uploadUrls, elementImageDraft) => {
  Object.keys(elementImageDraft || {}).map(
    (key) => uploadElementImage({
      presignedUploadUrl: uploadUrls[`${key}PresignedUrl`],
      base64_image: elementImageDraft[key]
    })
  );
};
var getAll2 = ({
  offset,
  param,
  appVersionId,
  sort = "createdDate,desc"
}) => {
  const query = `applicationVersionId:${appVersionId}${param ? "," + param : ""}`;
  const completeQuery = {
    query,
    page: offset,
    size: 50,
    sort
  };
  return instance_default.get(nameSpace2, completeQuery);
};
var deleteOne2 = (id) => instance_default.remove(`${nameSpace2}/${id}`);
var update2 = async (uiIdentifier) => {
  const res = await instance_default.put(
    `${nameSpace2}/${uiIdentifier.id}`,
    uiIdentifier
  );
  handleElementImage(
    res["imageLocator"] || {},
    uiIdentifier?.["elementImageDraft"] || {}
  );
  if (uiIdentifier.locatorTree) {
    RecorderAssetsApi.saveLocatorTree(
      uiIdentifier.id,
      uiIdentifier.locatorTree
    );
  }
  if (uiIdentifier.hostElements?.length > 0) {
    saveHostElementLocatorTrees(uiIdentifier.hostElements, res?.hostElements);
  }
  return res;
};
var get = (id) => instance_default.get(`${nameSpace2}/${id}`);
var getOne = ({
  name,
  appVersionId
}) => instance_default.get(
  nameSpace2 + `?query=applicationVersionId:${appVersionId}${name ? "&uiIdentifierName=" + encodeURIComponent(name) : ""}`
);
var getPredefinedSFLocators = ({
  objectName,
  appVersionID
}) => instance_default.get(
  nameSpace2 + `/salesforce_derived_locators?appVersionId=${appVersionID}&objectName=${objectName}`
);
var getDerivedUiIdentifier = (appVersionID, salesforceObjectFieldId) => instance_default.get(
  nameSpace2 + `/derived_element?appVersionId=${appVersionID}&salesforce_object_field_id=${salesforceObjectFieldId}`
);
var getElementImageUploadUrls = async ({ applicationVersionId, uuid }) => instance_default.get(
  `${nameSpace2}/image_locator/upload_urls/${applicationVersionId}/${uuid}`
);
var acceptHealedElement = (elementId, element) => {
  return instance_default.patch(`${nameSpace2}/${elementId}/accept_auto_healed_locator`, element).then((res) => res).catch((e) => Promise.reject(e));
};
var UiIdentifierApi = {
  create: create2,
  getAll: getAll2,
  deleteOne: deleteOne2,
  update: update2,
  getOne,
  get,
  getPredefinedSFLocators,
  getDerivedUiIdentifier,
  getElementImageUploadUrls,
  acceptHealedElement
};
var nameSpace3 = PrivateURLConstants.CASE;
var getOne2 = (id) => instance_default.get(`${nameSpace3}/${id}`);
var validateUrl = (testCaseId, url) => instance_default.get(`${nameSpace3}/validateUrls/${testCaseId}?currentUrl=${url}`);
var getAllGroup = ({
  offset,
  appVersionId,
  param
}) => instance_default.get(nameSpace3, {
  query: `isManual:false,applicationVersionId:${appVersionId},isStepGroup:true,status:READY,deleted:false${param ? "," + param : ""}`,
  page: offset !== void 0 ? `${offset}` : "",
  size: 20,
  sort: "createdDate,desc"
});
var copy = (copyRequest) => instance_default.post(nameSpace3 + "/copy", copyRequest);
var createAlphaTestCase = (payload) => instance_default.post(nameSpace3 + "/create_alpha_test_case", payload);
var findAll = (query, size2) => {
  return instance_default.get(nameSpace3, {
    query,
    size: size2
  }).then((res) => {
    return new Page().deserialize(res, TestCase);
  }).catch((e) => Promise.reject(e));
};
var TestCaseApi = {
  getOne: getOne2,
  validateUrl,
  getAllGroup,
  copy,
  createAlphaTestCase,
  findAll
};
var nameSpace4 = PrivateURLConstants.ELEMENTS_SCREEN_NAME;
var getAll3 = (applicationVersionId, query) => {
  let filterQuery = `?query=applicationVersionId:${applicationVersionId}`;
  if (query) {
    filterQuery += `,name:*${query}*`;
  }
  return instance_default.get(nameSpace4, {
    query: filterQuery
  });
};
var create3 = (screenTitle, applicationVersionId) => instance_default.post(nameSpace4, { name: screenTitle, applicationVersionId });
var ScreenApi = {
  getAll: getAll3,
  create: create3
};
var nameSpace5 = PrivateURLConstants.VARIABLES;
var getVariables = (projectId, page, search = "", size2 = 20) => instance_default.get(nameSpace5, {
  query: `projectId:${projectId}${search ? `,key:*${search}*` : ""}`,
  sort: "updatedAtEpoch,desc",
  size: size2,
  page
});
var updateVariables = (projectId, payload) => instance_default.put(`nameSpace?projectId=${projectId}`, payload);
var EnvironmentApi = {
  getVariables,
  updateVariables
};
var nameSpace6 = PrivateURLConstants.TEST_DATA;
var dataSetNamespace = PrivateURLConstants.TEST_DATA_SETS;
var findAll2 = (query, sort, size2, page) => {
  return instance_default.get(`${nameSpace6}`, {
    query,
    size: size2,
    sort,
    page
  }).then((res) => {
    res.content.forEach((item) => item.name = item.testDataName);
    return res.content;
  }).catch((e) => {
    throw e;
  });
};
var getOne3 = (dataProfileId) => instance_default.get(nameSpace6 + `/${dataProfileId}`);
var getAll4 = (appVersionId) => instance_default.get(`${nameSpace6}?query=versionId:${appVersionId}`);
var getAllDataSet = (dataProfileId) => instance_default.get(
  `${dataSetNamespace}?query=testDataProfileId:${dataProfileId}&sort=position`
);
var DataProfileApi = {
  getOne: getOne3,
  getAll: getAll4,
  getAllDataSet,
  findAll: findAll2
};
var nameSpace7 = PrivateURLConstants.DATA_GENERATORS;
var testDataNamespace = PrivateURLConstants.KIBBUTZ;
var getAll5 = ({
  searchTerm,
  offset
}) => instance_default.get(nameSpace7, {
  query: searchTerm && searchTerm !== "" ? ",term:*" + searchTerm + "*" : "",
  page: offset,
  size: 20
});
var getAllAddonFunc = (searchTerm) => instance_default.get(`${testDataNamespace}/test_data_functions`, {
  query: searchTerm && searchTerm !== "" ? "displayName:*" + searchTerm + "*" : "",
  page: 0,
  size: 20
});
var getDefaultCategories = () => instance_default.get(`${nameSpace7}/functions/DefaultTestData`);
var FunctionApi = {
  getAll: getAll5,
  getAllAddonFunc,
  getDefaultCategories
};
var nameSpace8 = PrivateURLConstants.PHONENUMBER;
var getAll6 = (searchKey) => instance_default.get(nameSpace8, {
  ...searchKey ? { query: "phoneNumber:*" + searchKey + "*" } : {},
  page: 0,
  size: 100
});
var findAll3 = (query, size2, page, sort) => {
  return instance_default.get(nameSpace8, {
    query,
    size: size2,
    page,
    sort
  }).then((res) => res).catch((e) => {
    throw e;
  });
};
var PhoneNumberApi = {
  getAll: getAll6,
  findAll: findAll3
};
var nameSpace9 = PrivateURLConstants.MAIL_BOX;
var getAll7 = (searchKey) => instance_default.get(nameSpace9, {
  query: searchKey ? "email:*" + searchKey + "*" : ""
});
var findAll4 = (query, size2, page, sort) => {
  return instance_default.get(nameSpace9, {
    query,
    size: size2,
    page,
    sort
  }).then((res) => res).catch((e) => {
    throw e;
  });
};
var MailboxApi = {
  getAll: getAll7,
  findAll: findAll4
};

// src/components/test-recorder/api/runtime-variable.ts
var namespace2 = "/run_time_data/app_version";
var nameSpaceV2 = "/private/step_runtime_variables";
var getAll8 = (appVersionId) => instance_default.get(`${namespace2}/${appVersionId}`);
var findAll5 = (query, size2, page) => {
  return instance_default.get(nameSpaceV2, {
    query,
    size: size2,
    page
  });
};
var RuntimeVariableApi = {
  getAll: getAll8,
  findAll: findAll5
};
var nameSpace10 = PrivateURLConstants.PROJECTS;
var getAll9 = (filterQuery) => instance_default.get(nameSpace10, {
  query: filterQuery
});
var ProjectApi = {
  getAll: getAll9
};
var nameSpace11 = PrivateURLConstants.APPLICATIONS;
var getAll10 = (filterQuery) => instance_default.get(nameSpace11, {
  query: filterQuery
});
var ProjectApplicationApi = {
  getAll: getAll10
};
var nameSpace12 = PrivateURLConstants.VERSIONS;
var getAll11 = (query) => instance_default.get(nameSpace12, { query });
var getOne4 = (id) => instance_default.get(nameSpace12 + `/${id}`);
var ApplicationVersionApi = {
  getAll: getAll11,
  getOne: getOne4
};
var nameSpace13 = PrivateURLConstants.UPLOADS;
var getOne5 = (id) => instance_default.get(nameSpace13 + id);
var create4 = ({
  file,
  name,
  applicationId,
  version
}) => {
  const formData = new FormData();
  formData.append("fileContent", file);
  formData.append("name", name);
  formData.append("applicationId", `${applicationId}`);
  formData.append("version", version);
  formData.append("uploadType", "Attachment");
  return instance_default.postForm(nameSpace13, formData).then((res) => res).catch((err) => {
    throw err;
  });
};
var getAll12 = ({
  applicationId
}) => instance_default.get(
  `${nameSpace13}?query=applicationId:${applicationId}&sort=name,asc&page=0&size=1000`
);
var UploadApi = {
  getOne: getOne5,
  create: create4,
  getAll: getAll12
};

// src/components/test-recorder/api/step-result.ts
var resultEndpointNamespace = "/private/test_step_results";
var get2 = (resultId) => instance_default.get(`${resultEndpointNamespace}/${resultId}`);
var updateAnalyzerMessage = (payload) => {
  return instance_default.put(`${resultEndpointNamespace}/analyzer_message`, payload).then((res) => {
    return res;
  }).catch((error) => Promise.reject(error));
};
var StepResultApi = {
  get: get2,
  updateAnalyzerMessage
};

// src/components/test-recorder/api/salesforce/salesforce-application.ts
var namespace3 = "/salesforce_applications";
var getAll13 = (query) => {
  const params = {
    query
  };
  return instance_default.get(namespace3, params);
};
var SalesforceApplicationApi = {
  getAll: getAll13
};

// src/components/test-recorder/api/salesforce/salesforce-connection.ts
var namespace4 = "/salesforce_connections";
var getAll14 = (query) => {
  const params = {
    query
  };
  return instance_default.get(namespace4, params);
};
var SalesforceConnectionApi = {
  getAll: getAll14
};

// src/components/test-recorder/api/salesforce/salesforce-metadata-object.ts
var namespace5 = "/salesforce_metadata_object";
var getOne6 = ({ id }) => instance_default.get(namespace5 + `/${id}`);
var getAll15 = (query) => {
  const params = {
    query
  };
  return instance_default.get(namespace5, params);
};
var SalesforceMetadataObjectApi = {
  getOne: getOne6,
  getAll: getAll15
};

// src/components/test-recorder/api/salesforce/salesforce-tabs.ts
var namespace6 = "/salesforce_tabs";
var getAll16 = (query) => {
  const params = {
    query
  };
  return instance_default.get(namespace6, params);
};
var SalesforceTabApi = {
  getAll: getAll16
};

// src/components/test-recorder/api/salesforce/salesforce-object-field.ts
var namespace7 = "/salesforce_object_fields";
var getOne7 = ({ id }) => instance_default.get(namespace7 + `/${id}`);
var SalesforceObjectFieldApi = {
  getOne: getOne7
};
var namespace8 = "/sessions";
var SessionApi = {
  get: () => {
    return instance_default.get(namespace8).then((res) => {
      return pick(res, ["features", "tenantPreference"]);
    });
  }
};
var find = async (applicationType, searchKey, objectTypeId, element, applicationVersionId) => {
  try {
    if (element && !objectTypeId) {
      const elementQuery = `applicationVersionId:${applicationVersionId},name:${element}`;
      try {
        const elementResponse = await instance_default.get(PrivateURLConstants.ELEMENTS, {
          query: elementQuery
        });
        if (elementResponse && typeof elementResponse === "object" && "content" in elementResponse && Array.isArray(elementResponse.content) && elementResponse.content[0]) {
          objectTypeId = elementResponse.content[0].objectTypeId;
        }
      } catch {
        objectTypeId = void 0;
      }
    }
    const query = `applicationType:${applicationType || ApplicationType.WINDOWS_ADVANCED},objectTypeId:${objectTypeId || "null"}${searchKey ? `,displayName:*${searchKey}*` : ""}`;
    const response = await instance_default.get(
      PrivateURLConstants.NLP_TEMPLATE,
      {
        query
      }
    );
    if (!response.content || response.content.length === 0) {
      return [];
    }
    const filteredItems = response.content.filter(
      (item) => !item.stepActionType
    );
    return filteredItems.map((item) => ({
      action: item.displayName || "",
      templateId: item.id
    }));
  } catch {
    return [];
  }
};
var useQueryDesktopActions = ({
  applicationType,
  searchKey,
  objectTypeId,
  element,
  applicationVersionId,
  enabled = true
}) => {
  return useQuery$1(
    [
      "desktop-actions",
      applicationType,
      searchKey,
      objectTypeId,
      element,
      applicationVersionId
    ],
    () => find(
      applicationType,
      searchKey,
      objectTypeId,
      element,
      applicationVersionId
    ),
    {
      enabled: enabled && !!applicationVersionId
    }
  );
};
var DesktopActionsApi = {
  find,
  useQueryDesktopActions
};
var MessagingContext = createContext(null);
function useMessaging() {
  const messaging = useContext(MessagingContext);
  if (!messaging) {
    throw new Error("useMessaging must be used within a MessagingProvider");
  }
  return messaging;
}

// src/components/test-recorder/web-recorder/CreateElement/Body/hooks.tsx
var useElementImageHandler = (applicationType, updateElementImageDraft, updateLocalImageUrl) => {
  const isCanvas = applicationType === ApplicationType.AndroidNative || applicationType === ApplicationType.IOSNative;
  const messaging = isCanvas ? null : useMessaging();
  const updateImages = useCallback(
    (data) => {
      const imageData = data ?? null;
      updateElementImageDraft(imageData);
      updateLocalImageUrl(imageData);
    },
    [updateElementImageDraft, updateLocalImageUrl]
  );
  const webHandler = useCallback(
    (eventName, data) => {
      if (data?.action === MESSAGE_CONTEXT_ACTION.DONE) {
        updateImages(data?.data);
      } else {
        messaging?.sendToContentWindow(
          MESSAGE_CONTEXT.CAPTURE_ELEMENT_IMAGE,
          data,
          {}
        );
      }
    },
    [messaging, updateImages]
  );
  const canvasHandler = (eventName, data) => {
    updateImages(data);
  };
  const handler = isCanvas ? canvasHandler : webHandler;
  const publishEvents = useInternalEvents(
    isCanvas ? [INTERNAL_EVENTS.CAPTURE_ELEMENT_IMAGE_CAPTURE_SCREENSHOT_DONE] : [MESSAGE_CONTEXT.CAPTURE_ELEMENT_IMAGE],
    handler
  );
  const handleCaptureElement = useCallback(() => {
    if (isCanvas) {
      publishEvents(INTERNAL_EVENTS.CAPTURE_ELEMENT_IMAGE_INITIATE);
    } else {
      messaging?.sendToBackground({
        context: MESSAGE_CONTEXT.CAPTURE_ELEMENT_IMAGE,
        action: MESSAGE_CONTEXT_ACTION.INITIATE,
        value: {}
      });
    }
  }, [isCanvas, messaging]);
  return { handleCaptureElement };
};
function ActionDropdown({
  localImageUrls,
  updateLocalImageUrl,
  handleCaptureElement,
  handleUpload,
  disableCapture,
  updateElementImageDraft
}) {
  const hasImage = !!localImageUrls?.elementScreenshot;
  const hasStoredImage = localImageUrls?.elementScreenshot?.startsWith("http");
  return hasImage ? /* @__PURE__ */ jsxs(
    DropdownButton,
    {
      fillWidth: false,
      className: "min-w-[60px] text-right",
      variant: "no-bg",
      name: "Update Image",
      children: [
        !disableCapture ? /* @__PURE__ */ jsx(DropdownItem, { onClick: () => handleCaptureElement(), children: "Capture" }) : /* @__PURE__ */ jsx(Fragment, {}),
        /* @__PURE__ */ jsx(
          DropdownItem,
          {
            onClick: () => (
              //@ts-expect-error ignore
              document.querySelector(".element-image-uploader input")?.click?.()
            ),
            children: "Upload"
          }
        ),
        !hasStoredImage ? /* @__PURE__ */ jsx(
          DropdownItem,
          {
            onClick: () => {
              updateLocalImageUrl(null);
              updateElementImageDraft(null);
            },
            className: "!text-red-600",
            children: "Remove"
          }
        ) : /* @__PURE__ */ jsx(Fragment, {})
      ]
    }
  ) : /* @__PURE__ */ jsx(Fragment, {});
}
function ImageUploader({ onChange, isHidden = false }) {
  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      const base64 = await convertToBase64(file);
      onChange(base64);
    } else {
      alert("Please upload a valid image file.");
    }
  };
  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };
  return /* @__PURE__ */ jsxs("div", { className: classNames82("element-image-uploader", { hidden: isHidden }), children: [
    /* @__PURE__ */ jsx(
      "input",
      {
        type: "file",
        accept: "image/*",
        id: "fileUpload",
        style: { display: "none" },
        onChange: handleFileUpload
      }
    ),
    /* @__PURE__ */ jsx(
      "span",
      {
        className: "text-primary-600 cursor-pointer",
        onClick: () => document.getElementById("fileUpload").click(),
        children: "Upload"
      }
    )
  ] });
}
var Image2 = ({ src, errorText, updateImageState = null }) => {
  const [state, updateState] = useState(
    "loading"
  );
  useEffect(() => updateImageState?.(!src ? "failed" : state), [state, src]);
  if (!src) return errorText;
  return state == "failed" ? errorText : /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      ImageViewer,
      {
        src,
        enablePageFullScreen: true,
        onError: () => updateState("failed"),
        onLoad: () => updateState("done"),
        imageClass: "!object-contain"
      }
    ),
    state != "done" && "Loading..."
  ] });
};
var ElementImage2 = ({
  updateElementImageDraft,
  updateLocalImageUrl,
  localImageUrls,
  isLoading,
  disableCapture,
  isSubmited,
  applicationType
}) => {
  const { t } = useTranslation();
  const [imageState, updateImageState] = useState("loading");
  const { handleCaptureElement } = useElementImageHandler(
    applicationType,
    updateElementImageDraft,
    updateLocalImageUrl
  );
  const handleUpload = (elementScreenshot) => {
    const uploadData = { elementScreenshot };
    updateElementImageDraft(uploadData);
    updateLocalImageUrl(uploadData);
  };
  const emptyState = /* @__PURE__ */ jsxs("div", { className: "flex item-center justify-center gap-1.5", children: [
    /* @__PURE__ */ jsxs(Fragment, { children: [
      disableCapture ? /* @__PURE__ */ jsx("span", { className: "text-secondary-400 cursor-not-allowed", children: "Capture" }) : /* @__PURE__ */ jsx(
        "span",
        {
          className: "text-primary-600 cursor-pointer",
          onClick: handleCaptureElement,
          children: "Capture"
        }
      ),
      "or"
    ] }),
    /* @__PURE__ */ jsx(ImageUploader, { onChange: handleUpload }),
    " element image"
  ] });
  const hasError = imageState == "failed" && isSubmited;
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex font-medium text-xs mb-1", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex-grow flex text-secondary-500", children: [
        "Element Image ",
        /* @__PURE__ */ jsx("span", { className: "text-error-500 ml-1", children: "*" }),
        hasError && /* @__PURE__ */ jsx("div", { className: "flex-grow text-right text-error-500", children: t("data_generator.empty_input_error", {
          argumentDisplayName: ""
        }) })
      ] }),
      /* @__PURE__ */ jsx(
        ActionDropdown,
        {
          localImageUrls,
          updateLocalImageUrl,
          handleCaptureElement,
          handleUpload,
          disableCapture,
          updateElementImageDraft
        }
      ),
      /* @__PURE__ */ jsx(ImageUploader, { onChange: handleUpload, isHidden: true })
    ] }),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames82(
          "p-1 w-full flex bg-secondary-50 min-h-[56px] rounded text-secondary-400 font-medium items-center justify-center text-xs border border-transparent",
          { "!border-red-300": hasError }
        ),
        children: [
          !isLoading && /* @__PURE__ */ jsx(
            Image2,
            {
              src: localImageUrls?.elementScreenshot,
              errorText: emptyState,
              updateImageState
            }
          ),
          isLoading && /* @__PURE__ */ jsx("span", { className: "flex justify-center items-center h-5 w-full", children: /* @__PURE__ */ jsx(AiOutlineLoading3Quarters, { className: "animate-spin h-5 w-5" }) })
        ]
      }
    )
  ] });
};
var ElementFullImage2 = ({ localImageUrls, isLoading }) => {
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx("div", { className: "flex font-medium text-xs mb-1", children: /* @__PURE__ */ jsx("div", { className: "flex-grow flex text-secondary-500", children: "Element location on fullscreen" }) }),
    /* @__PURE__ */ jsxs("div", { className: "p-1 w-full flex bg-secondary-50 min-h-[56px] rounded text-secondary-400 font-medium items-center justify-center text-xs", children: [
      !isLoading && /* @__PURE__ */ jsx(
        Image2,
        {
          src: localImageUrls?.elementHighlightedPageScreenshot,
          errorText: "The element image has not been captured yet."
        }
      ),
      isLoading && /* @__PURE__ */ jsx("span", { className: "flex justify-center items-center h-5 w-full", children: /* @__PURE__ */ jsx(AiOutlineLoading3Quarters, { className: "animate-spin h-5 w-5" }) })
    ] })
  ] });
};
var ScreenShotFields = ({
  applicationType,
  occurance,
  handleOccuranceChange,
  occuranceErrorText,
  updateElementImageDraft,
  getElementImageUploadUrls: getElementImageUploadUrls2,
  elementUuid,
  isUpdate,
  uiIdentifier,
  disableCapture,
  isSubmited
}) => {
  const { t } = useTranslation();
  const [localImageUrls, updateLocalImageUrl] = useState(uiIdentifier?.elementImageDraft || null);
  const [isLoading, updateLoading] = useState(false);
  useEffect(() => {
    const fetchAndUpdateUrls = async () => {
      if (!isUpdate || !elementUuid || !uiIdentifier?.id) return;
      updateLoading(true);
      try {
        const uploadUrls = uiIdentifier?.imageLocator || elementUuid && await getElementImageUploadUrls2(elementUuid) || uiIdentifier?.id && (await UiIdentifierApi.get(uiIdentifier.id))?.imageLocator;
        const urlMap = Object.keys(uploadUrls).reduce((prev, cur) => {
          prev[cur.replace("PresignedUrl", "")] = uploadUrls[cur];
          return prev;
        }, {});
        updateLocalImageUrl(urlMap);
        updateElementImageDraft(urlMap);
      } catch (e) {
      } finally {
        updateLoading(false);
      }
    };
    fetchAndUpdateUrls();
  }, [isUpdate, elementUuid, uiIdentifier?.id, uiIdentifier?.imageLocator]);
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-5 col-span-2", children: [
    /* @__PURE__ */ jsx(
      Input,
      {
        isRequired: true,
        showOutline: true,
        type: "number",
        label: "Occurrence",
        value: occurance,
        onChange: (value) => handleOccuranceChange(value),
        hasError: isSubmited ? !!occuranceErrorText : false,
        errorText: isSubmited ? occuranceErrorText : ""
      },
      "ocurance"
    ),
    /* @__PURE__ */ jsx(
      ElementImage2,
      {
        localImageUrls,
        updateElementImageDraft,
        updateLocalImageUrl,
        isLoading,
        disableCapture,
        isSubmited,
        applicationType
      }
    ),
    localImageUrls ? /* @__PURE__ */ jsx(
      ElementFullImage2,
      {
        localImageUrls,
        isLoading
      }
    ) : /* @__PURE__ */ jsx(
      Note,
      {
        type: "info",
        heading: /* @__PURE__ */ jsx("span", { children: t("element.image.upload.note") })
      }
    )
  ] });
};
var AutoHealCheckbox = ({ onChange, checked }) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs("div", { className: "col-span-2 flex items-center gap-x-1", children: [
    /* @__PURE__ */ jsx(
      Checkbox,
      {
        label: t("element.auto_heal.label"),
        onChange,
        type: "primary",
        checked
      }
    ),
    /* @__PURE__ */ jsx(
      Icon,
      {
        name: "help",
        className: "text-unique-800 text-lg ml-1 items-center cursor-pointer",
        toolTip: t("element.auto_heal.tooltip"),
        tooltipAlignment: "center"
      }
    )
  ] });
};
var ElementCreateUpdateForm = ({
  values,
  actions,
  isEdit,
  hasFeature,
  isSubmited,
  isRecorderView,
  applicationType,
  screenNames,
  isChrome,
  isMobileNative,
  recordBtn,
  isFirefox,
  isEdge,
  screenshot,
  getElementImageUploadUrls: getElementImageUploadUrls2,
  restrictedLocatorTypes = []
}) => {
  const [selectedLocatorType, setLocatorType] = useState();
  const [occuranceErrorText, updateOccuranceErrorText] = useState("");
  const { t } = useTranslation();
  const isImageType = values?.locatorType?.toLowerCase() == ElementIdentifierLocatorType.IMAGE.toLowerCase();
  const elementLocatorType = useMemo(
    () => new ElementIdentifier().locatorTypes(applicationType),
    [applicationType]
  );
  const _canShowAutoHealCheckBox = useMemo(() => {
    return canShowAutoHealCheckBox(applicationType, hasFeature);
  }, [hasFeature, applicationType]);
  const customElementScreenShotFields = applicationType === ApplicationType.AndroidNative || applicationType === ApplicationType.IOSNative ? /* @__PURE__ */ jsx(
    ScreenShotFields,
    {
      applicationType,
      occurance: values?.imageLocatorOccurence,
      handleOccuranceChange: (value) => {
        actions?.onElementImageOccuranceChange(value);
        const error = actions?.validateElementImageOccurance(value || 0);
        updateOccuranceErrorText(error);
      },
      getElementImageUploadUrls: getElementImageUploadUrls2,
      occuranceErrorText,
      elementUuid: values?.elementUuid,
      isSubmited,
      updateElementImageDraft: actions?.updateElementImageDraft,
      isUpdate: isEdit,
      uiIdentifier: values,
      disableCapture: !isRecorderView
    }
  ) : null;
  useEffect(() => {
    if (elementLocatorType?.[0]) {
      setLocatorType(elementLocatorType[0]);
    }
  }, [elementLocatorType]);
  const canShowWebContent = () => applicationType === ApplicationType.MobileWeb || applicationType === ApplicationType.WebApplication || applicationType === ApplicationType.Salesforce;
  return /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-2 gap-y-6 gap-x-4", children: [
    isEdit && /* @__PURE__ */ jsx(
      AffectedEntitiesNote,
      {
        onViewAffectedEntities: actions.onViewAffectedEntities
      }
    ),
    canShowWebContent() && /* @__PURE__ */ jsx(
      ChromeInfoNote,
      {
        isChrome,
        recordBtn,
        isFirefox,
        isEdge
      }
    ),
    isMobileNative && /* @__PURE__ */ jsx("div", { className: "flex", children: recordBtn }),
    /* @__PURE__ */ jsx(
      FormData2,
      {
        actions,
        isSubmited,
        values,
        elementLocatorType,
        screenNames,
        screenshot,
        getElementImageUploadUrls: getElementImageUploadUrls2,
        restrictedLocatorTypes,
        customElementScreenShotFields,
        occuranceErrorText,
        updateOccuranceErrorText,
        isRecorderView
      },
      values?.["locatorType"]
    ),
    _canShowAutoHealCheckBox && /* @__PURE__ */ jsx(
      AutoHealCheckbox,
      {
        onChange: actions.onAutoHealingEnabledChange,
        checked: values?.autoHealingEnabled
      }
    ),
    canShowWebContent() && !isImageType && /* @__PURE__ */ jsx(
      HostElementTrigger,
      {
        values,
        actions,
        elementLocatorType
      }
    )
  ] });
};
var ElementForm = ({
  applicationType,
  isChrome,
  screenNames,
  values,
  actions,
  isEdit,
  hasFeature,
  isSubmited,
  isRecorderView,
  recordBtn,
  isMobileNative,
  isEdge,
  isFirefox,
  screenshot,
  getElementImageUploadUrls: getElementImageUploadUrls2 = NOOP,
  restrictedLocatorTypes = []
}) => {
  return /* @__PURE__ */ jsx(
    ElementCreateUpdateForm,
    {
      screenNames,
      isChrome,
      values,
      actions,
      isSubmited,
      isRecorderView,
      isEdit,
      hasFeature,
      applicationType,
      recordBtn,
      isMobileNative,
      isFirefox,
      isEdge,
      screenshot,
      getElementImageUploadUrls: getElementImageUploadUrls2,
      restrictedLocatorTypes
    }
  );
};
var ElementMoreDetailsTableAccordian = ({ element, title, className, style: style2 }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: style2,
      className: classNames82(
        "border-b w-full",
        isOpen ? "border-b-secondary-100" : "border-white",
        className
      ),
      children: [
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: classNames82(
              "flex px-1.5 py-3 hover:bg-secondary-50 border-b items-center gap-x-1 cursor-pointer border-secondary-100"
            ),
            onClick: () => setIsOpen(!isOpen),
            children: [
              /* @__PURE__ */ jsx(
                Icon,
                {
                  name: "angle-top",
                  className: classNames82(
                    " text-base text-secondary-600 shrink-0 duration-300 transition",
                    !isOpen ? "rotate-180" : ""
                  )
                }
              ),
              /* @__PURE__ */ jsxs("span", { className: "flex-grow text-unique-600 text-xs leading-3 font-semibold", children: [
                title,
                "-",
                element?.tag
              ] })
            ]
          }
        ),
        isOpen && /* @__PURE__ */ jsxs("ol", { className: "list-decimal pb-2", children: [
          /* @__PURE__ */ jsxs("div", { className: "flex items-center w-full px-3 py-2 text-small leading-4 text-unique-600 border-b border-b-secondary-100", children: [
            /* @__PURE__ */ jsx(Column, { width: 50, className: " font-semibold", children: t("element.attribute") }),
            /* @__PURE__ */ jsx(Column, { width: 50, className: " font-semibold", children: t("common.value") })
          ] }),
          element?.attribute && Object.keys(element.attribute)?.map((key, index) => {
            let value = element.attribute?.[key];
            value = JSON.stringify(value);
            return /* @__PURE__ */ jsxs(
              "div",
              {
                className: "flex items-center w-full px-3 py-2 text-small leading-4 text-unique-600 border-b border-b-secondary-100 last:border-0",
                children: [
                  /* @__PURE__ */ jsx(Column, { width: 50, className: "flex", children: /* @__PURE__ */ jsx(TruncatedText, { value: key }) }),
                  /* @__PURE__ */ jsx(Column, { width: 50, className: "flex", children: /* @__PURE__ */ jsx(TruncatedText, { value: value || "-" }) })
                ]
              },
              `${key}_${index}`
            );
          })
        ] })
      ]
    }
  );
};
var TargetElementDetailsTableAccordian = ({ targetAttributes, className, style: style2 }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  return /* @__PURE__ */ jsxs("div", { style: style2, className: classNames82("w-full", className), children: [
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames82(
          "flex py-3 px-1.5 hover:bg-secondary-50 border-b items-center gap-x-1 cursor-pointer",
          isOpen ? "border-b-secondary-100" : "border-white"
        ),
        onClick: () => setIsOpen(!isOpen),
        children: [
          /* @__PURE__ */ jsx(
            Icon,
            {
              name: "angle-top",
              className: classNames82(
                "text-base text-secondary-600 shrink-0 duration-300 transition",
                !isOpen ? "rotate-180" : ""
              )
            }
          ),
          /* @__PURE__ */ jsx("span", { className: "flex-grow text-unique-600 text-xs leading-3 font-semibold", children: t("element.target-element") })
        ]
      }
    ),
    isOpen && /* @__PURE__ */ jsxs("ol", { className: "list-decimal pb-2", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex items-center w-full p-4 text-small leading-4 text-unique-600 border-b border-secondary-100", children: [
        /* @__PURE__ */ jsx(Column, { width: 50, className: " font-semibold", children: t("element.attribute") }),
        /* @__PURE__ */ jsx(Column, { width: 50, className: " font-semibold", children: t("common.value") })
      ] }),
      targetAttributes && Object.keys(targetAttributes)?.map((key, index) => {
        let value = targetAttributes?.[key];
        value = JSON.stringify(value);
        return /* @__PURE__ */ jsxs(
          "div",
          {
            className: "flex items-center w-full p-4 text-small leading-4 text-unique-600 border-b border-secondary-100 last:border-0",
            children: [
              /* @__PURE__ */ jsx(Column, { width: 50, className: "flex", children: /* @__PURE__ */ jsx(TruncatedText, { value: key }) }),
              /* @__PURE__ */ jsx(Column, { width: 50, className: "flex", children: /* @__PURE__ */ jsx(TruncatedText, { value: value || "-" }) })
            ]
          },
          `${value}_${index}`
        );
      })
    ] })
  ] });
};
var MoreTargetElementDetails = ({ element, className }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  let parentIndent = 0;
  return /* @__PURE__ */ jsx(
    Expandable,
    {
      isExpanded: isOpen,
      wrapperClassName: classNames82(
        "pt-6 rounded flex flex-col gap-y-2 overflow-x-auto",
        className
      ),
      className: classNames82(
        "flex py-3 cursor-pointer items-center gap-x-1 text-unique-600"
      ),
      onChange: () => setIsOpen(!isOpen),
      iconClassName: "text-xl",
      labelClassName: "flex-grow text-small leading-5 leading-6 font-semibold",
      expandLabel: t("element.few_more_target_element_details"),
      collapseLabel: t("element.few_more_target_element_details"),
      children: /* @__PURE__ */ jsxs(Fragment, { children: [
        element?.metadata?.firstLevelChildren?.map(
          (parentElement, ind) => {
            parentIndent = ind;
            return /* @__PURE__ */ jsx(
              ElementMoreDetailsTableAccordian,
              {
                element: parentElement,
                title: t("element.form.child_first_level", {
                  index: (element?.metadata).firstLevelChildren.length - ind
                }),
                style: {
                  marginLeft: `${parentIndent * 6}px`
                }
              },
              `${ind}`
            );
          }
        ),
        element?.metadata?.secondLevelChildren?.map(
          (parentElement, ind) => {
            parentIndent = ind;
            return /* @__PURE__ */ jsx(
              ElementMoreDetailsTableAccordian,
              {
                element: parentElement,
                title: t("element.form.child_second_level", {
                  index: (element?.metadata).secondLevelChildren.length - ind
                }),
                style: {
                  marginLeft: `${parentIndent * 6}px`
                }
              },
              `${ind}`
            );
          }
        ),
        element?.metadata?.followingSiblings?.map(
          (parentElement, ind) => {
            parentIndent = ind;
            return /* @__PURE__ */ jsx(
              ElementMoreDetailsTableAccordian,
              {
                element: parentElement,
                title: t("element.form.following-sibling", {
                  index: (element?.metadata).followingSiblings.length - ind
                }),
                style: {
                  marginLeft: `${parentIndent * 6}px`
                }
              },
              `${ind}`
            );
          }
        ),
        element?.metadata?.precedingSiblings?.map(
          (parentElement, ind) => {
            parentIndent = ind;
            return /* @__PURE__ */ jsx(
              ElementMoreDetailsTableAccordian,
              {
                element: parentElement,
                title: t("element.form.preceding-sibling", {
                  index: (element?.metadata).precedingSiblings.length - ind
                }),
                style: {
                  marginLeft: `${parentIndent * 6}px`
                }
              },
              `${ind}`
            );
          }
        ),
        element?.parents?.map((parentElement, ind) => {
          parentIndent = ind;
          return /* @__PURE__ */ jsx(
            ElementMoreDetailsTableAccordian,
            {
              element: parentElement,
              title: t("element.form.parent", {
                index: element.parents.length - ind
              }),
              style: {
                marginLeft: `${parentIndent * 6}px`
              }
            },
            `${ind}`
          );
        }),
        element?.attrs && /* @__PURE__ */ jsx(
          TargetElementDetailsTableAccordian,
          {
            targetAttributes: element?.attrs,
            style: { marginLeft: `${(parentIndent + 1) * 6}px` }
          }
        )
      ] })
    }
  );
};
var ScreenshotAreaSelection = ({
  actionsComponent,
  isMobileCanvas = false,
  handleEscapeKey
}) => {
  const { t } = useTranslation();
  const [isSelecting, setIsSelecting] = React5__default.useState(false);
  const [startPosition, setStartPosition] = React5__default.useState({ x: 0, y: 0 });
  const [selectionArea, setSelectionArea] = React5__default.useState(null);
  const [initialized, setInitialized] = React5__default.useState(false);
  const [mousePosition, setMousePosition] = React5__default.useState({ x: 0, y: 0 });
  const [canShowActions, setCanShowActions] = React5__default.useState(true);
  const handleMouseMove = React5__default.useCallback(
    (e) => {
      const parent = e.target.closest(".screenshot-container");
      const parentRect = parent.getBoundingClientRect();
      const currentX = e.clientX - parentRect.left;
      const currentY = e.clientY - parentRect.top;
      setMousePosition({ x: currentX, y: currentY });
      if (!isSelecting) return;
      const newWidth = Math.abs(currentX - startPosition.x);
      const newHeight = Math.abs(currentY - startPosition.y);
      const newX = Math.min(currentX, startPosition.x);
      const newY = Math.min(currentY, startPosition.y);
      setSelectionArea({
        width: newWidth,
        height: newHeight,
        x: newX,
        y: newY
      });
    },
    [isSelecting, startPosition]
  );
  const handleDrag = React5__default.useCallback((e, d) => {
    setSelectionArea((prevState) => ({
      ...prevState,
      x: d.x,
      y: d.y
    }));
    setCanShowActions(false);
  }, []);
  const handleResize = React5__default.useCallback(
    (e, direction, ref, delta, position) => {
      setSelectionArea({
        width: ref.offsetWidth,
        height: ref.offsetHeight,
        x: position.x,
        y: position.y
      });
      setCanShowActions(false);
    },
    []
  );
  const handleMouseDown = (e) => {
    setIsSelecting(true);
    const parent = e.target.closest(".screenshot-container");
    const parentRect = parent.getBoundingClientRect();
    setStartPosition({
      x: e.clientX - parentRect.left,
      y: e.clientY - parentRect.top
    });
  };
  const handleMouseUp = () => {
    setIsSelecting(false);
    setInitialized(!!selectionArea);
  };
  const showActions = () => setCanShowActions(true);
  const handleTouchStart = (e) => {
    e.preventDefault();
    setIsSelecting(true);
    const parent = e.target.closest(".screenshot-container");
    const parentRect = parent.getBoundingClientRect();
    const touch = e.touches[0];
    setStartPosition({
      x: touch.clientX - parentRect.left,
      y: touch.clientY - parentRect.top
    });
  };
  const handleTouchMove = (e) => {
    e.preventDefault();
    if (!isSelecting) return;
    const parent = e.target.closest(".screenshot-container");
    const parentRect = parent.getBoundingClientRect();
    const touch = e.touches[0];
    const currentX = touch.clientX - parentRect.left;
    const currentY = touch.clientY - parentRect.top;
    setMousePosition({ x: currentX, y: currentY });
    const newWidth = Math.abs(currentX - startPosition.x);
    const newHeight = Math.abs(currentY - startPosition.y);
    const newX = Math.min(currentX, startPosition.x);
    const newY = Math.min(currentY, startPosition.y);
    setSelectionArea({
      width: newWidth,
      height: newHeight,
      x: newX,
      y: newY
    });
  };
  const handleTouchEnd = () => {
    setIsSelecting(false);
    setInitialized(!!selectionArea);
  };
  const eventHandlers = !initialized ? {
    onMouseDown: handleMouseDown,
    onMouseMove: handleMouseMove,
    onMouseUp: handleMouseUp,
    onTouchStart: handleTouchStart,
    onTouchMove: handleTouchMove,
    onTouchEnd: handleTouchEnd
  } : {};
  useEffect(() => {
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [handleEscapeKey]);
  const Actions2 = () => {
    const parent = document.querySelector(".screenshot-container");
    const parentRect = parent?.getBoundingClientRect();
    const isOutOfBoundsX = parentRect && (selectionArea.x + selectionArea.width + 90 > parentRect.width || selectionArea.x < 0);
    const isOutOfBoundsY = parentRect && (selectionArea.y + selectionArea.height + 60 > parentRect.height || selectionArea.y < 0);
    return actionsComponent({
      canShowActions,
      selectionArea,
      yPosition: selectionArea.y > 60 ? "top" : isOutOfBoundsY ? "overflow" : "bottom",
      xPosition: selectionArea.x > 90 ? "right" : isOutOfBoundsX ? "overflow" : "left"
    });
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      tabIndex: -1,
      className: classNames82("screenshot-container", {
        "selection-active": !selectionArea,
        mobile: isMobileCanvas
      }),
      ...eventHandlers,
      children: [
        !selectionArea && /* @__PURE__ */ jsx(
          "div",
          {
            className: "ts-tooltip",
            style: {
              left: `${mousePosition.x + 10}px`,
              top: `${mousePosition.y + 10}px`
            },
            children: t("element.image.capture.tooltip")
          }
        ),
        selectionArea && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            "div",
            {
              className: "ts-overlay-top",
              style: {
                height: `${selectionArea.y}px`,
                width: `calc(100vw - ${selectionArea.x}px)`,
                marginLeft: `${selectionArea.x}px`
              }
            }
          ),
          /* @__PURE__ */ jsx(
            "div",
            {
              className: "ts-overlay-left",
              style: {
                width: `${selectionArea.x}px`,
                height: `${selectionArea.height + selectionArea.y}px`
              }
            }
          ),
          /* @__PURE__ */ jsx(
            "div",
            {
              className: "ts-overlay-right",
              style: {
                left: `${selectionArea.x + selectionArea.width}px`,
                top: `${selectionArea.y}px`,
                height: `${selectionArea.height}px`
              }
            }
          ),
          /* @__PURE__ */ jsx(
            "div",
            {
              className: "ts-overlay-bottom",
              style: {
                top: `${selectionArea.y + selectionArea.height}px`
              }
            }
          ),
          /* @__PURE__ */ jsx(
            Rnd,
            {
              className: "selection-area",
              size: { width: selectionArea.width, height: selectionArea.height },
              position: { x: selectionArea.x, y: selectionArea.y },
              onResize: handleResize,
              onDrag: handleDrag,
              onDragStop: showActions,
              onResizeStop: showActions,
              bounds: "parent",
              minWidth: 16,
              minHeight: 16,
              maxWidth: "100%",
              maxHeight: "100%",
              resizeHandleStyles: {
                bottomRight: { cursor: "nwse-resize" },
                bottomLeft: { cursor: "nesw-resize" },
                topRight: { cursor: "nesw-resize" },
                topLeft: { cursor: "nwse-resize" }
              },
              children: /* @__PURE__ */ jsx(Actions2, {})
            }
          )
        ] })
      ]
    }
  );
};
var SearchNotFound = ({ textElementClass = "" }) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", { className: "flex items-center flex-col justify-center text-small leading-[18px] basis-full mt-10", children: [
    /* @__PURE__ */ jsx(
      Icon,
      {
        name: "search",
        className: "inline-block cursor-pointer text-primary-500 text-5xl"
      }
    ),
    /* @__PURE__ */ jsx(
      "div",
      {
        className: classNames82(
          "font-semibold text-secondary-500 py-6 basis-full text-center",
          textElementClass
        ),
        children: t("common.search_not_found")
      }
    )
  ] }) });
};
var ElementSearchByDropdown = ({
  setSearchBy,
  isSearchByScreenName
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs(
    DropdownButton,
    {
      name: `${!isSearchByScreenName ? t("suggestion_popup.element.label") : t("suggestion_popup.screen.label")}`,
      fillWidth: false,
      children: [
        /* @__PURE__ */ jsx(DropdownItem, { onClick: () => setSearchBy(false), children: t("suggestion_popup.element.label") }),
        /* @__PURE__ */ jsx(DropdownItem, { onClick: () => setSearchBy(true), children: t("suggestion_popup.screen.label") })
      ]
    }
  );
};
var element_searchby_dropdown_default = ElementSearchByDropdown;
var ElementSelectorFilterDropDown = ({
  itemsToShow,
  selectedItems,
  isItemSelected,
  onItemChange,
  onSearch,
  name
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx(
    MultiSelect,
    {
      fillWidth: false,
      variant: "select-fill-plain",
      name: `${name} ${selectedItems?.length ? `(${selectedItems?.length})` : ""}`,
      className: classNames82(
        "!text-unique-600 !text-2xs max-w-52 !leading-3.5 !font-medium bg-white border-white hover:bg-secondary-50 hover:border-secondary-50"
      ),
      searchPlaceholder: t("common.search"),
      dropdownClassName: "!min-w-72 !max-w-72 w-72",
      hideSearch: false,
      placement: "bottom-start",
      dropdownIconClassName: "h-2 !text-xl",
      onSearch: (key) => onSearch(key),
      updatePositionOnLeftMove: false,
      children: itemsToShow?.map((option) => /* @__PURE__ */ jsx(
        MultiSelectItem,
        {
          className: "!cursor-default",
          children: /* @__PURE__ */ jsxs("div", { className: "flex gap-x-2", children: [
            /* @__PURE__ */ jsx(
              Checkbox,
              {
                type: "primary",
                size: "small",
                checked: isItemSelected(option?.id || option),
                className: "!cursor-pointer",
                onChange: () => onItemChange(option)
              }
            ),
            /* @__PURE__ */ jsx("span", { className: "font-normal text-unique-600 text-small leading-5", children: option?.displayName || option })
          ] })
        },
        option?.id || option
      ))
    }
  );
};
var ElementTableRow = ({
  item,
  onClick,
  onOpenForm,
  previousStepElementName,
  nlpId,
  imageSupportedNlps
}) => {
  const { t } = useTranslation();
  const isNlpSupportedNLP = !nlpId || item?.locatorType?.toLowerCase() != ElementIdentifierLocatorType.IMAGE.toLowerCase() || imageSupportedNlps.includes(Number(nlpId));
  return /* @__PURE__ */ jsx(Fragment$1, { children: /* @__PURE__ */ jsx(ToolTip, { content: isNlpSupportedNLP ? "" : t("element.notsupported"), children: /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames82(
        "hover:!bg-secondary-50 cursor-pointer border-b-[0.5px] border-b-secondary-200 group w-full flex h-full py-2",
        {
          "bg-primary-50": previousStepElementName == item?.name,
          "opacity-50 cursor-prevent": !isNlpSupportedNLP
        }
      ),
      onClick: () => isNlpSupportedNLP ? onClick(item) : NOOP(),
      role: "row",
      children: [
        /* @__PURE__ */ jsx(
          Column,
          {
            className: classNames82("px-2 flex items-center ", {
              "pointer-events-none": !isNlpSupportedNLP
            }),
            width: 48,
            role: "gridcell",
            children: /* @__PURE__ */ jsx(
              ErrorToolTip,
              {
                content: item?.errorMessage && (item.technology ? t("element.uft.deleted") : item.errorMessage),
                className: "w-full flex",
                children: /* @__PURE__ */ jsx(
                  TruncatedText,
                  {
                    value: item?.name,
                    className: classNames82("text-xs leading-5 break-all", {
                      "text-primary-600": previousStepElementName == item?.name,
                      "text-secondary-1000": previousStepElementName !== item?.name,
                      "underline decoration-wavy decoration-[#E97C74] underline-offset-2 break-all": item?.errorMessage
                    })
                  }
                )
              }
            )
          }
        ),
        /* @__PURE__ */ jsxs(
          Column,
          {
            className: classNames82("pl-2 pr-5 flex items-center", {
              "pointer-events-none": !isNlpSupportedNLP
            }),
            width: 48,
            role: "gridcell",
            children: [
              /* @__PURE__ */ jsx(
                TruncatedText,
                {
                  value: item?.technology ? item?.parentElementName : item?.screenNameObj?.name,
                  className: classNames82(
                    "!text-xs !leading-5 !text-secondary-1000",
                    {
                      "!text-primary-600": previousStepElementName == item?.name
                    }
                  )
                }
              ),
              /* @__PURE__ */ jsx(
                "span",
                {
                  className: "flex shrink-0 cursor-pointer",
                  onClick: (e) => onOpenForm(e, item),
                  children: item?.isSfField ? /* @__PURE__ */ jsx(
                    Icon,
                    {
                      name: "description",
                      className: "invisible group-hover:visible  text-secondary-700",
                      toolTip: t("common.view.details"),
                      tootTipClassName: "flex",
                      hideTooltipOnClick: true
                    }
                  ) : /* @__PURE__ */ jsx(
                    Icon,
                    {
                      name: "edit-square",
                      className: "invisible group-hover:visible text-xl text-secondary-700",
                      toolTip: t("common.edit"),
                      tootTipClassName: "flex",
                      hideTooltipOnClick: true
                    }
                  )
                }
              )
            ]
          }
        )
      ]
    },
    item.id
  ) }) }, item.id);
};
var ElemetTable = ({
  elementList: elementList2,
  onClick,
  onOpenForm,
  hasNextPage,
  fetchNextPage,
  previousStepElementName,
  nlpId,
  applicationType,
  isFetching
}) => {
  const { t } = useTranslation();
  const [hasScroll, setHasScroll] = useState(false);
  const IMAGE_SUPPORTED_NLPS = IMAGE_SUPPORTED_NLPS_MAP[applicationType] || [];
  const { VirtualizedInfiniteLoader: VirtualizedInfiniteLoader9 } = InfiniteScrollV2;
  const handelOpenForm = useCallback(
    (e, item) => {
      e.stopPropagation();
      onOpenForm(item);
    },
    [onOpenForm]
  );
  const tableContainerRef = useRef(null);
  useEffect(() => {
    const scrollContainerHeight = document.querySelector(
      ".element-table .ReactVirtualized__Grid__innerScrollContainer"
    )?.clientHeight;
    if (scrollContainerHeight > tableContainerRef?.current?.clientHeight) {
      setHasScroll(true);
    }
  }, [tableContainerRef?.current]);
  const rowRenderer = (index) => {
    const item = elementList2?.[index];
    return /* @__PURE__ */ jsx(
      ElementTableRow,
      {
        item,
        onClick,
        onOpenForm: handelOpenForm,
        previousStepElementName,
        nlpId,
        imageSupportedNlps: IMAGE_SUPPORTED_NLPS
      },
      item.id
    );
  };
  return /* @__PURE__ */ jsxs("div", { className: "rounded h-full max-h-full flex flex-col", children: [
    /* @__PURE__ */ jsxs("div", { className: "bg-secondary-100 rounded flex", children: [
      /* @__PURE__ */ jsx(
        Column,
        {
          className: "px-2 h-8 border-neutral-100 flex items-center",
          width: 48,
          children: /* @__PURE__ */ jsx("span", { className: "text-xs text-neutral-800", children: t("label.element_title") })
        }
      ),
      /* @__PURE__ */ jsx(
        Column,
        {
          className: classNames82(
            "h-8 border-neutral-100 flex items-center",
            hasScroll ? "pr-2" : "px-2"
          ),
          width: 48,
          children: /* @__PURE__ */ jsx("span", { className: "text-xs text-neutral-800", children: t(
            elementList2?.[0]?.parentElementName && elementList2?.[0]?.technology ? "label.element_parent_name" : "label.element_screen_name"
          ) })
        }
      )
    ] }),
    /* @__PURE__ */ jsx("div", { className: "w-full h-full element-table", ref: tableContainerRef, children: /* @__PURE__ */ jsx(
      VirtualizedInfiniteLoader9,
      {
        rowHeight: 37,
        rowRenderer,
        items: elementList2,
        loadMore: fetchNextPage,
        hasMore: hasNextPage,
        rowCount: elementList2?.length,
        isLoading: isFetching,
        className: "max-h-full"
      }
    ) })
  ] });
};
var know_more = "https://testsigma.com/docs/elements/overview/";
var EmptyElement = ({
  isSearch,
  onOpenForm,
  isRecorderView,
  RecordButton,
  isWindowsAdvanced = false
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", { className: "flex items-center flex-wrap justify-center text-xs px-4 mt-6", children: [
    /* @__PURE__ */ jsx(
      Icon,
      {
        name: isSearch ? "search" : "error",
        className: "cursor-pointer text-primary-500 text-5xl"
      }
    ),
    /* @__PURE__ */ jsx("div", { className: "font-semibold text-secondary-700 py-6 basis-full text-center", children: t(
      isSearch ? "suggestion_popup.element.search_not_found" : `suggestion_popup.element.empty_info${isWindowsAdvanced ? ".import" : ""}`
    ) }),
    !isWindowsAdvanced && /* @__PURE__ */ jsx("div", { className: "text-secondary-700 basis-full text-center", children: t(
      isRecorderView ? "suggestion_popup.element.create_info" : "suggestion_popup.element.recorder_info"
    ) }),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames82("flex p-lg w-full justify-center", {
          "my-8": !isWindowsAdvanced
        }),
        children: [
          !isRecorderView && RecordButton,
          !isWindowsAdvanced && /* @__PURE__ */ jsx(
            Button,
            {
              type: "primary",
              className: classNames82("ml-4 flex-grow justify-center", {
                "max-w-[50%]": isRecorderView
              }),
              onClick: onOpenForm,
              children: t("common.create")
            }
          )
        ]
      }
    ),
    !isSearch && !isWindowsAdvanced && /* @__PURE__ */ jsx("div", { className: "flex p-lg basis-full justify-center", children: /* @__PURE__ */ jsx(
      Button,
      {
        type: "secondary",
        onClick: () => window.open(know_more, "_blank"),
        children: t("common.know_more")
      }
    ) })
  ] }) });
};
var ElementSelector = ({
  onClick,
  applicationType,
  elementList: elementList2,
  isFetching,
  onChangeSearch,
  onOpenForm,
  isRecorderView,
  RecordButton,
  hasNextPage,
  fetchNextPage,
  previousStepElementName,
  elementService,
  filterOptionsComponent,
  isDesktopUft,
  nlpId
}) => {
  const { t } = useTranslation();
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearchByScreenName, _setSearchBy] = useState(false);
  const [isFilterFetching, setIsFilterFetching] = useState(false);
  const [canShowElementFilters, setCanShowElementFilters] = useState(false);
  const [technologies, setTechnologies] = useState();
  const [objectTypes, setObjectTypes] = useState();
  const [selectedTechnologies, setSelectedTechnologies] = useState(
    []
  );
  const [selectedObjectTypes, setSelectedObjectTypes] = useState([]);
  const [technologiesToShow, setTechnologiesToShow] = useState();
  const [objectTypesToShow, setObjectTypesToShow] = useState();
  const updateSearchQuery = useCallback(
    debounce$1((value) => {
      setSearchQuery(value);
      onChangeSearch(
        value,
        isSearchByScreenName,
        selectedTechnologies,
        selectedObjectTypes
      );
    }, 500),
    [
      onChangeSearch,
      isSearchByScreenName,
      selectedTechnologies,
      selectedObjectTypes
    ]
  );
  const setSearchBy = useCallback(
    (res) => {
      _setSearchBy(res);
      onChangeSearch(
        searchQuery,
        res,
        selectedTechnologies,
        selectedObjectTypes?.map((type) => type?.id)
      );
    },
    [
      _setSearchBy,
      searchQuery,
      onChangeSearch,
      setSearchQuery,
      selectedTechnologies,
      selectedObjectTypes,
      setSelectedObjectTypes,
      setSelectedTechnologies
    ]
  );
  const handleTechnologySearch = (searchTerm) => {
    if (!searchTerm) {
      setTechnologiesToShow(technologies);
      return;
    }
    setTechnologiesToShow(
      technologies.filter((technology) => {
        return technology.toLowerCase?.()?.includes?.(searchTerm.toLowerCase());
      })
    );
  };
  const handleObjectTypeSearch = (searchTerm) => {
    if (!searchTerm) {
      setObjectTypesToShow([
        ...objectTypes?.filter(
          (type) => !selectedTechnologies?.length || selectedTechnologies?.includes(type.technology)
        )
      ]);
      return;
    }
    setObjectTypesToShow(
      objectTypes.filter(({ className, displayName }) => {
        return className.toLowerCase?.()?.includes?.(searchTerm.toLowerCase()) || displayName.toLowerCase?.()?.includes?.(searchTerm.toLowerCase());
      })
    );
  };
  const handleTechnologySelect = (item) => {
    setSelectedTechnologies((previousSelectedItems) => {
      const itemInd = previousSelectedItems.findIndex(
        (option) => option == item
      );
      if (itemInd > -1) {
        previousSelectedItems = [
          ...previousSelectedItems.filter((i) => i != item)
        ];
      } else {
        previousSelectedItems = [...previousSelectedItems, item];
      }
      const objectTypesForTechnology = [
        ...objectTypes?.filter(
          (type) => !previousSelectedItems?.length || previousSelectedItems?.includes(type.technology)
        )
      ];
      setObjectTypesToShow(objectTypesForTechnology);
      const selectedObjectTypesForTechnology = [
        ...selectedObjectTypes?.filter((type) => type.technology == item)
      ];
      setSelectedObjectTypes(selectedObjectTypesForTechnology);
      onChangeSearch(
        searchQuery,
        isSearchByScreenName,
        previousSelectedItems,
        selectedObjectTypesForTechnology?.map((objectType) => objectType?.id)
      );
      return previousSelectedItems;
    });
  };
  const handleObjectTypeSelect = (item) => {
    setSelectedObjectTypes((previousSelectedItems) => {
      const itemInd = previousSelectedItems.findIndex(
        (option) => option.id == item.id
      );
      if (itemInd > -1) {
        previousSelectedItems = [
          ...previousSelectedItems.filter((i) => i.id != item.id)
        ];
      } else {
        previousSelectedItems = [...previousSelectedItems, item];
      }
      onChangeSearch(
        searchQuery,
        isSearchByScreenName,
        selectedTechnologies,
        previousSelectedItems?.map((objectType) => objectType?.id)
      );
      return previousSelectedItems;
    });
  };
  const filterReset = () => {
    setSelectedObjectTypes([]);
    setSelectedTechnologies([]);
    setObjectTypesToShow(objectTypes);
    setTechnologiesToShow(technologies);
    onChangeSearch(searchQuery, isSearchByScreenName, [], []);
  };
  const isObjectTypeSelected = (objectTypeId) => {
    return selectedObjectTypes?.filter((objectType) => objectType.id == objectTypeId).length != 0;
  };
  useEffect(() => {
    if (!isDesktopUft) {
      return;
    }
    elementService.getObjectTypes().then((res) => {
      const response = res;
      const technologiesResponse = response?.map(
        (objectType) => objectType?.technology
      );
      const technologiesWithoutDuplicates = [...new Set(technologiesResponse)];
      setTechnologies([...technologiesWithoutDuplicates]);
      setTechnologiesToShow([...technologiesWithoutDuplicates]);
      const objectTypesResponse = response?.map((objectType) => ({
        id: objectType.id,
        className: objectType?.objectClassName,
        technology: objectType?.technology,
        displayName: objectType?.technology + " " + objectType?.objectClassName
      }));
      setObjectTypes(objectTypesResponse);
      setObjectTypesToShow(objectTypesResponse);
      if (!selectedTechnologies?.length) {
        setSelectedTechnologies([]);
      }
      if (!selectedObjectTypes?.length) {
        setSelectedObjectTypes([]);
      }
    });
  }, []);
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-y-4 h-full overflow-hidden w-full", children: [
    Boolean(
      elementList2.length || searchQuery || selectedTechnologies?.length || selectedObjectTypes?.length
    ) && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("div", { className: "flex w-full space-x-6 items-center", children: [
        /* @__PURE__ */ jsx("div", { className: "flex-1", children: /* @__PURE__ */ jsx(
          Input,
          {
            wrapperClassName: "w-full",
            onChange: updateSearchQuery,
            prefix: /* @__PURE__ */ jsx("div", { className: "flex flex-col justify-center ml-3 text-secondary-600", children: /* @__PURE__ */ jsx(Icon, { name: "search", className: "text-2xl" }) }),
            placeholder: isSearchByScreenName ? t("suggestion_popup.element.placeholder_screen_name") : t("suggestion_popup.element.placeholder"),
            suffix: !elementList2[0]?.technology && /* @__PURE__ */ jsx(
              element_searchby_dropdown_default,
              {
                setSearchBy,
                isSearchByScreenName
              }
            ),
            labelClassName: "align-left"
          },
          "search-input"
        ) }),
        isDesktopUft && /* @__PURE__ */ jsx("div", { className: "flex-shrink-0 w-9 h-9", children: /* @__PURE__ */ jsx(
          Button,
          {
            type: "secondary",
            onClick: () => setCanShowElementFilters(!canShowElementFilters),
            className: "!px-0 w-full h-full justify-center bg-white border rounded-lg border-secondary-200",
            "aria-label": t("element.toggle_filters"),
            children: /* @__PURE__ */ jsx(Icon, { name: "filter", className: "text-xl" })
          }
        ) })
      ] }),
      canShowElementFilters && /* @__PURE__ */ jsxs("div", { className: "flex", children: [
        /* @__PURE__ */ jsx("div", { className: "flex-col", children: /* @__PURE__ */ jsx(
          ElementSelectorFilterDropDown,
          {
            name: `Technology`,
            itemsToShow: technologiesToShow,
            selectedItems: selectedTechnologies,
            isItemSelected: (key) => selectedTechnologies?.includes(key),
            onItemChange: (item) => handleTechnologySelect(item),
            onSearch: (key) => handleTechnologySearch(key)
          }
        ) }),
        /* @__PURE__ */ jsx("div", { className: "flex-col", children: /* @__PURE__ */ jsx(
          ElementSelectorFilterDropDown,
          {
            name: `Element Type`,
            itemsToShow: objectTypesToShow,
            selectedItems: selectedObjectTypes,
            isItemSelected: (key) => isObjectTypeSelected(key),
            onItemChange: (item) => handleObjectTypeSelect(item),
            onSearch: (key) => handleObjectTypeSearch(key)
          }
        ) }),
        /* @__PURE__ */ jsx(
          "span",
          {
            onClick: () => filterReset(),
            className: "text-2xs font-medium leading-3.5 text-unique-600 py-1.5 px-3 rounded cursor-pointer border border-white hover:bg-secondary-50 hover:border-secondary-200",
            children: t("common.reset")
          }
        )
      ] })
    ] }),
    isFetching && !elementList2.length ? /* @__PURE__ */ jsx("div", { className: "h-48 basis-full", children: /* @__PURE__ */ jsx("div", { className: "empty-page-loader mt-[25%] mx-auto" }) }) : elementList2.length ? /* @__PURE__ */ jsx(
      ElemetTable,
      {
        elementList: elementList2 || [],
        onClick,
        onOpenForm,
        hasNextPage,
        fetchNextPage,
        previousStepElementName,
        nlpId,
        applicationType,
        isFetching
      }
    ) : searchQuery.length || selectedTechnologies?.length || selectedObjectTypes?.length ? /* @__PURE__ */ jsx(SearchNotFound, {}) : /* @__PURE__ */ jsx(
      EmptyElement,
      {
        isSearch: void 0,
        onOpenForm,
        isRecorderView,
        RecordButton,
        isWindowsAdvanced: isDesktopUft
      }
    )
  ] });
};
var stepContext = {
  steps: [],
  nlActions: [],
  algoliaTemplate: [],
  kibbutzActions: [],
  openElementListDrawer: () => {
  },
  openElementFormDrawer: () => {
  },
  openStepGroupsListDrawer: () => {
  },
  openCustomFunctionParameterDrawer: (customFunction, customStepValue, isReadOnly) => Promise.resolve({ action: "DISCARDED" }),
  onOpenSalesforceAPIFormDrawer: () => {
  },
  openTestStepSettingsDrawer: (testStep, testStepsList) => {
  },
  openRestStep: (testStep) => {
  },
  openSOQLStep: (testStep) => {
  },
  openVisualFigmaViewModal: (testStep, template) => Promise.resolve({ action: "DISCARDED" }),
  stepsInfo: {
    isStepTypeSwitchOpened: false,
    nlpContainerWidth: null
  },
  activeStepIdx: null,
  updateActiveStepIdx: (idx) => {
  },
  updateStepsInfo: (key, value) => {
  },
  isRecorderView: false,
  isWebRecorder: false,
  stepToggleUtils: {
    toggleStepExpand: () => {
    },
    isStepExpanded: {},
    cachedStepBlockChildren: { current: {} },
    cachedStepGroupChildren: { current: {} },
    isExpanding: [],
    updateExpandedData: (stepGroupStepId, updatedStep) => {
    }
  },
  updateStepGroupChildren: () => {
  },
  testCaseId: null,
  onChangeType: () => {
  },
  applicationType: null,
  versionId: null,
  onAddStep: () => {
  },
  scrollToLastItem: () => {
  },
  scrollToNextItem: () => {
  },
  freezeScrollOnEdit: () => {
  },
  userPreference: null,
  testCase: TestCase,
  validateUrl: null,
  fetchDataProfile: null,
  updateChildStep: () => {
  },
  isViewOnlySingle: false,
  isNoWrapSteps: false,
  currentExecutingStep: {},
  hasFeatureValue: () => false,
  customFunctionActions: null,
  lastUpdatedStepId: null,
  fetchObjectActions: NOOP,
  openActionsListDrawer: () => new Promise((r) => r(null)),
  kibbutzTemplate: [],
  isDebugMode: false,
  openExternalUrl: void 0,
  getTdpBaseUrl: void 0,
  updateGlobalStepsInfo: NOOP,
  selectedIterationByStepId: {},
  setSelectedIterationByStepId: NOOP,
  debugExecutionStatus: ""
};
var StepContext = createContext(stepContext);
var useStepContext = () => {
  const context = useContext(StepContext);
  if (!context) {
    throw new Error("useStepContext must be used within a StepContextProvider");
  }
  return context;
};
var _defaultData = {
  steps: [],
  afterTestSteps: [],
  stepGroupSteps: [],
  visualResults: [],
  nlActions: [],
  stepResults: [],
  mainStepResults: [],
  afterStepResults: [],
  loadStepGroupResults: null,
  loadStepRetryResults: null,
  testCaseResult: null,
  stepResultsCount: 0,
  afterTestStepResultsCount: 0,
  initialStepResultsFetched: false,
  loadRetryResultStep: null,
  hasFeatureValue: null
};
var StepResultContext = createContext(_defaultData);
var getParentStep = (localStep, insert_type = null) => {
  if (insert_type == "above") {
    return localStep.parentId;
  } else if (insert_type == "after" && (isConditionalIf(localStep) || isConditionalElseIf(localStep) || isConditionalElse(localStep) || isForLoop(localStep) || isBlock(localStep) || isConditionalWhileLoop(localStep))) {
    return localStep.parentId;
  } else if (isConditionalIf(localStep) || isConditionalElseIf(localStep) || isConditionalElse(localStep) || isForLoop(localStep) || isBlock(localStep) || isConditionalWhileLoop(localStep)) {
    return localStep.id;
  } else {
    return localStep.parentId;
  }
};
var getPreviousStepElement = (lastStep, steps, isAbove) => {
  for (let i = lastStep?.stepOrder - (isAbove ? 1 : 0); i >= 0; i--) {
    let elementName2 = steps[i]?.testStepElements?.[0]?.element?.name || null;
    if (!elementName2 && steps[i]?.kibbutzPluginNlpData && steps[i]?.kibbutzPluginNlpData?.uiIdentifiers) {
      Object.keys(steps[i]?.kibbutzPluginNlpData?.uiIdentifiers)?.forEach(
        (params) => {
          elementName2 = steps[i]?.kibbutzPluginNlpData?.uiIdentifiers?.[params]?.name;
        }
      );
    }
    if (elementName2 && elementName2 != "element" && elementName2 != "element-locator") {
      return elementName2;
    }
  }
};
var initStep = (isConditional, localStep, steps, parentId, type, target) => {
  const testStep = new TestStep();
  testStep.ignoreStepResult = false;
  if (isConditional) {
    testStep.conditionType = isConditional;
    testStep.ignoreStepResult = true;
  }
  if (parentId) {
    testStep.parentId = parentId;
  }
  testStep.testCaseId = localStep.testCaseId;
  testStep.stepOrder = localStep.stepOrder;
  testStep.waitTime = 30;
  testStep.smartActionsEnabled = true;
  testStep.disabled = false;
  testStep.priority = isConditional ? TestStepPriority.MINOR : TestStepPriority.MAJOR;
  testStep.type = type ? type : localStep.applicationType == ApplicationType.Rest ? TestStepType.API_STEP : TestStepType.NLP_TEXT;
  testStep.stepNumber = "-";
  testStep.indent = localStep.indent;
  testStep.mapperData = localStep.mapperData || [];
  if (isForLoop(localStep) && localStep.isForLoop && target == "inside") {
    const mapper = {};
    mapper["id"] = localStep?.forLoopCondition?.testDataProfile["id"];
    mapper["stepNumber"] = localStep?.stepNumber;
    mapper["lastLoopStepId"] = localStep?.id;
    mapper["name"] = localStep?.forLoopCondition?.testDataProfile["value"];
    mapper["stepScopeIsTestCase"] = steps.find((item) => item.id === localStep?.id) && localStep?.isForLoop;
    testStep.mapperData = [...testStep?.mapperData, mapper];
    testStep.presentationMetaInfo = {
      ...testStep.presentationMetaInfo,
      isInsideForLoop: true
    };
  }
  testStep.applicationType = localStep.applicationType;
  if (localStep.blockParentId) {
    testStep.blockParentId = localStep.blockParentId;
  } else if (isBlock(localStep) && target == "inside") {
    testStep.blockParentId = localStep.id;
  }
  testStep.isRefetch = true;
  testStep.pagenumber = localStep.pagenumber;
  testStep.perviousStepElement = localStep && steps?.length ? getPreviousStepElement(localStep, steps, target == "above") : null;
  return testStep;
};
var addElseStep = (localStep, steps) => {
  const parentId = getParentStep(localStep);
  return {
    step: initStep(
      TestStepConditionType.CONDITION_ELSE,
      localStep,
      steps,
      parentId
    ),
    type: "else",
    localStep
  };
};
var addBreakStep = (localStep, steps, target = "inside") => {
  const parentId = getParentStep(localStep, target);
  return {
    step: initStep(
      null,
      localStep,
      steps,
      parentId,
      TestStepType.BREAK_LOOP,
      target
    ),
    type: `break_${target}_inside`,
    localStep
  };
};
var addContinueStep = (localStep, steps, target = "inside") => {
  const parentId = getParentStep(localStep, target);
  return {
    step: initStep(
      null,
      localStep,
      steps,
      parentId,
      TestStepType.CONTINUE_LOOP,
      target
    ),
    type: `continue_${target}_inside`,
    localStep
  };
};
var addElseIf = (localStep, steps) => {
  const parentId = getParentStep(localStep);
  const step = initStep(
    TestStepConditionType.CONDITION_ELSE_IF,
    localStep,
    steps,
    parentId
  );
  return {
    step,
    type: "elseif",
    localStep
  };
};
var updateStepOrder = (localStep, steps) => {
  steps?.filter((step) => {
    if (step?.id == localStep?.id) {
      localStep.stepOrder = step.stepOrder;
    }
  });
};
var addBelowStep = (localStep, steps) => {
  const parentId = getParentStep(localStep);
  updateStepOrder(localStep, steps);
  return {
    step: initStep(null, localStep, steps, parentId),
    type: "below",
    localStep
  };
};
var addAboveStep = (localStep, steps) => {
  const parentId = getParentStep(localStep, "above");
  updateStepOrder(localStep, steps);
  return {
    step: initStep(null, localStep, steps, parentId, null, "above"),
    type: "above",
    localStep
  };
};
var addInside = (localStep, steps) => {
  const parentId = getParentStep(localStep);
  return {
    step: initStep(null, localStep, steps, parentId, null, "inside"),
    type: "inside",
    localStep
  };
};
var addAfter = (localStep, steps) => {
  const parentId = getParentStep(localStep, "after");
  updateStepOrder(localStep, steps);
  return {
    step: initStep(null, localStep, steps, parentId),
    type: "after",
    localStep
  };
};
var addMore = () => {
  return { step: null, type: "more" };
};
var useChipsClick = (ref, isEdit, step, setStepState) => {
  const isProcessingRef = useRef(false);
  useEffect(() => {
    const handleClick = (event) => {
      event.stopImmediatePropagation();
      event.preventDefault();
      if (isProcessingRef.current) {
        return;
      }
      isProcessingRef.current = true;
      setStepState(isEdit(step));
      setTimeout(() => {
        isProcessingRef.current = false;
      }, 500);
    };
    const element = ref.current;
    element?.addEventListener("click", handleClick);
    return () => {
      element?.removeEventListener("click", handleClick);
    };
  }, [ref, isEdit, step, setStepState]);
};
var CHIP_TYPES = {
  ABOVE: "above"};
var useGetStepChipTypeBased = (step, steps, isDebugMode) => {
  const { t } = useTranslation();
  const aboveLabels = [
    {
      label: t("step.add_above"),
      callBack: (localStep) => addAboveStep(localStep, steps),
      type: CHIP_TYPES.ABOVE
    }
  ];
  const belowLabels = [];
  const addLabels = (keyName, labels) => {
    if ((isConditionalStep(step) || isBlock(step)) && !(isConditionalElse(step) || isConditionalElseIf(step))) {
      const afterLabel = {
        label: t(`step.add_after_${keyName}`),
        callBack: (localStep) => addAfter(localStep, steps)
      };
      belowLabels.push(afterLabel);
    }
    const insideLabel = {
      label: t(`step.add_inside_${keyName}`),
      callBack: (localStep) => addInside(localStep, steps)
    };
    belowLabels.push(insideLabel);
    if (labels) {
      const conditionalLabels = labels.map((label) => ({
        label: t(`step.conditional.type.${label}`),
        callBack: (localStep) => "elseif" === label ? addElseIf(localStep, steps) : addElseStep(localStep, steps)
      }));
      belowLabels.push(...conditionalLabels);
      if (!isDebugMode && (step.canShowBreakContinueLoop || step.canShowBelowBreakContinueLoop)) {
        belowLabels.push({
          label: t("common.more"),
          callBack: () => addMore()
        });
      }
    }
  };
  if (isBlock(step)) {
    addLabels("block");
  } else if (isConditionalElse(step)) {
    addLabels("else");
  } else if (isConditionalElseIf(step)) {
    const labels = ["elseif"];
    if (step.canShowElse) {
      labels.push("else");
    }
    addLabels("else_if", labels);
  } else if (isConditionalIf(step)) {
    const labels = ["elseif"];
    if (step.canShowElse) {
      labels.push("else");
    }
    addLabels("if", labels);
  } else if (isConditionalWhileLoop(step) || isForLoop(step)) {
    addLabels("loop");
  } else {
    belowLabels.push({
      label: t("step.add_below"),
      callBack: (localStep) => addBelowStep(localStep, steps)
    });
  }
  return {
    below: belowLabels || [],
    above: aboveLabels || []
  };
};
var AddStep = ({
  steps,
  testCaseId,
  onChangeType,
  applicationType,
  hasAddStepButton,
  onAddStep,
  isRecorderView,
  isDebugMode
}) => {
  const { steps: refSteps } = useContext(StepContext);
  const lastStep = refSteps.slice(-1)?.pop();
  const nestedLastSteps = steps.filter((step) => step.indent == 0).slice(-1)?.pop();
  const handleAddStep = useCallback(
    (template = null) => {
      const templateId = template?.id;
      const step = createTestStep(
        testCaseId,
        (lastStep?.stepOrder || 0) + 1e3,
        addStepNumber(nestedLastSteps?.stepNumber || "0"),
        0,
        onChangeType,
        applicationType,
        { templateId }
      );
      step.isAddStep = true;
      step.isAddedDirect = Boolean(templateId);
      step.screenshotStrategy = template?.screenshotStrategy;
      step.perviousStepElement = lastStep && steps?.length ? getPreviousStepElement(lastStep, steps) : null;
      onAddStep(step);
    },
    [testCaseId, lastStep, nestedLastSteps]
  );
  const internalEventHandler = useCallback(
    (eventName, template = null) => {
      if (eventName == "add-help-action-step") {
        hasAddStepButton && handleAddStep(template);
      }
    },
    [testCaseId, lastStep, nestedLastSteps]
  );
  useInternalEvents(["add-help-action-step"], internalEventHandler);
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames82("my-2 flex items-center bg-white", {
        "pl-[60px]": !isRecorderView,
        "pl-[29px]": isRecorderView,
        "pl-[37px]": isDebugMode
      }),
      role: "row",
      children: /* @__PURE__ */ jsxs(
        "div",
        {
          role: "gridcell",
          className: "cursor-pointer inline-flex items-center add-step-action-btn",
          onClick: () => handleAddStep(),
          children: [
            /* @__PURE__ */ jsx("span", { className: "flex items-center justify-center rounded bg-neutral-50 w-[18px] h-[18px]", children: /* @__PURE__ */ jsx(Icon, { name: "add", className: "text-secondary-400" }) }),
            /* @__PURE__ */ jsx("span", { className: "ml-3.5 text-secondary-400 text-xs", children: t("add.new.step") })
          ]
        }
      )
    }
  );
};
var Indent = ({ position, showLine, indent }) => {
  const indentSize = indent;
  return /* @__PURE__ */ jsx(
    "div",
    {
      style: {
        marginLeft: `${indentSize + position * 2}px`
      },
      className: classNames82("border-l self-stretch", {
        "border-l-neutral-200": showLine,
        "border-l-transparent": !showLine
      })
    }
  );
};
var IndentResult = ({
  size: size2,
  showLine = false,
  stepResult,
  adjustSize = 0,
  marginLeft
}) => {
  return /* @__PURE__ */ jsx(Fragment, { children: Array(size2 || 0).fill(1).map((_, position) => /* @__PURE__ */ jsx(
    Indent,
    {
      position,
      showLine,
      indent: marginLeft || 30 + adjustSize - (position === 0 && stepResult?.isStepGroupChild ? 15 : 0)
    },
    position
  )) });
};
var StepTypeIndicatorTextWrapper = ({
  label,
  step,
  isResultBlock
}) => {
  const hasLongAction = step?.action?.length > 150;
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames82(
        "outline-none whitespace-nowrap overflow-hidden flex items-center relative",
        "text-small leading-5"
      ),
      children: /* @__PURE__ */ jsx(
        "span",
        {
          className: classNames82(
            "text-xs leading-4 whitespace-nowrap mr-1",
            isResultBlock ? "!text-[#F18D13]" /* STEP_INDICATOR_BLOCK */ : "text-warning-500",
            { "!mt-3": hasLongAction && !isResultBlock }
          ),
          children: label
        }
      )
    }
  );
};
var StepTypeIndicatorText = ({
  step,
  isResultBlock
}) => {
  const { t } = useTranslation();
  const getLabelForStep = () => {
    if (step.conditionType) {
      return t(stepTypeI18nKeys[step.conditionType] || "");
    }
    if (step.type) {
      return t(stepTypeI18nKeys[step.type] || "");
    }
    return null;
  };
  const label = getLabelForStep();
  if (label) {
    return /* @__PURE__ */ jsx(
      StepTypeIndicatorTextWrapper,
      {
        label,
        step,
        isResultBlock
      }
    );
  }
  return null;
};
var step_type_indicator_text_component_default = StepTypeIndicatorText;
var AIStepIndicator = () => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "4",
      height: "4",
      viewBox: "0 0 4 4",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M1.40905 0.692832C1.52921 0.341192 2.01508 0.330542 2.15754 0.660883L2.1696 0.693033L2.33175 1.16725C2.36892 1.276 2.42897 1.37552 2.50786 1.45909C2.58675 1.54266 2.68265 1.60835 2.78909 1.65171L2.83269 1.66798L3.3069 1.82994C3.65854 1.9501 3.66919 2.43596 3.33905 2.57843L3.3069 2.59049L2.83269 2.75264C2.7239 2.78978 2.62434 2.84982 2.54073 2.92871C2.45712 3.00761 2.39141 3.10352 2.34803 3.20998L2.33175 3.25338L2.1698 3.72779C2.04964 4.07943 1.56377 4.09008 1.42151 3.75994L1.40905 3.72779L1.24709 3.25358C1.20996 3.14479 1.14991 3.04523 1.07102 2.96162C0.992126 2.87801 0.896215 2.8123 0.78976 2.76892L0.746358 2.75264L0.272145 2.59069C-0.0796963 2.47053 -0.0903459 1.98466 0.239995 1.8424L0.272145 1.82994L0.746358 1.66798C0.855112 1.63082 0.954631 1.57077 1.0382 1.49187C1.12178 1.41298 1.18746 1.31708 1.23082 1.21065L1.24709 1.16725L1.40905 0.692832ZM3.39692 3.63069e-08C3.43451 -4.74156e-08 3.47135 0.0105449 3.50325 0.0304363C3.53515 0.0503278 3.56083 0.078768 3.57737 0.112525L3.58701 0.136035L3.65734 0.342197L3.8637 0.412525C3.90137 0.425323 3.9344 0.449018 3.95859 0.480605C3.98278 0.512193 3.99705 0.550251 3.99959 0.589957C4.00213 0.629662 3.99282 0.669228 3.97285 0.70364C3.95288 0.738052 3.92315 0.76576 3.88741 0.783254L3.8637 0.792899L3.65754 0.863227L3.58721 1.06959C3.57439 1.10725 3.55068 1.14026 3.51908 1.16443C3.48748 1.1886 3.44942 1.20285 3.40971 1.20537C3.37001 1.20789 3.33045 1.19856 3.29605 1.17857C3.26165 1.15859 3.23396 1.12884 3.21648 1.0931L3.20684 1.06959L3.13651 0.863428L2.93015 0.7931C2.89247 0.780301 2.85945 0.756607 2.83526 0.725019C2.81107 0.693432 2.7968 0.655374 2.79426 0.615668C2.79172 0.575962 2.80102 0.536396 2.82099 0.501985C2.84096 0.467573 2.8707 0.439864 2.90644 0.422371L2.93015 0.412726L3.13631 0.342397L3.20664 0.136035C3.22018 0.0963345 3.24582 0.0618704 3.27994 0.0374746C3.31407 0.0130788 3.35497 -2.51737e-05 3.39692 3.63069e-08Z",
            fill: "url(#paint0_linear_3612_1233)"
          }
        ),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "paint0_linear_3612_1233",
            x1: "1.95722",
            y1: "-1.37493",
            x2: "6.69926",
            y2: "1.27062",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#E58086" }),
              /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#5C27F5" })
            ]
          }
        ) })
      ]
    }
  );
};
var StepNumber = ({
  number,
  className = "",
  variant = "default",
  showAiIcon = false
}) => {
  const variants = {
    default: "text-secondary-400",
    highlight: "bg-primary-100 text-primary-700"
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames82(
        "rounded h-5 px-1 min-w-5 inline-flex items-center justify-center text-xxs flex-shrink-0",
        className,
        variants[variant],
        {
          "!bg-[linear-gradient(119.16deg,#E58086_19.1%,#5C27F5_118.88%)] !text-transparent !bg-clip-text": showAiIcon
        }
      ),
      children: [
        number,
        showAiIcon && /* @__PURE__ */ jsx("sup", { children: /* @__PURE__ */ jsx(AIStepIndicator, {}) })
      ]
    }
  );
};
var FormattedApiStep = ({
  step,
  stepsInfo,
  isResultBlock
}) => {
  const { openRestStep, isRecorderView } = useContext(StepContext);
  const { t } = useTranslation();
  const handleStepClick = useCallback(() => {
    if (!isRecorderView && !step?.isStepGroupChild) {
      try {
        openRestStep(step);
      } catch (error) {
        throw new Error("Failed to open rest step", error);
      }
    }
  }, [isRecorderView, step, openRestStep]);
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames82(
        "outline-none whitespace-nowrap overflow-hidden flex items-center relative",
        "text-small leading-5"
      ),
      children: /* @__PURE__ */ jsx(
        "span",
        {
          className: classNames82(
            "dynamic-ipt break-all !max-w-[350px] inline-block  text-small leading-5 cursor-pointer px-1 overflow-hidden",
            isResultBlock ? `flex items-center ${"!text-[#091E42]" /* READ_ONLY_BLOCK */}` : "text-secondary-700"
          ),
          onClick: handleStepClick,
          children: step.isStepCreated || stepsInfo?.isStepResult ? /* @__PURE__ */ jsx(
            TruncatedText,
            {
              className: classNames82(
                "inline-block",
                { "grayscale opacity-50": step.disabled }
                // Add grayscale effect if step is disabled
              ),
              value: step.action,
              tooltipClassName: "w-[400px]"
            }
          ) : /* @__PURE__ */ jsxs("span", { className: "text-secondary-500", children: [
            t("api.step.title.place_holder"),
            " "
          ] })
        }
      )
    }
  );
};
var api_step_default = FormattedApiStep;
var FormattedSOQLStep = ({
  step,
  stepsInfo,
  isResultBlock
}) => {
  const { openSOQLStep, isRecorderView } = useContext(StepContext);
  const { t } = useTranslation();
  const handleStepClick = useCallback(() => {
    if (!isRecorderView && !step?.isStepGroupChild) {
      try {
        openSOQLStep(step);
      } catch (error) {
        throw new Error("Failed to open SOQL step", error);
      }
    }
  }, [isRecorderView, step, openSOQLStep]);
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames82(
        "outline-none whitespace-nowrap overflow-hidden flex items-center relative",
        "text-small leading-5"
      ),
      children: /* @__PURE__ */ jsx(
        "span",
        {
          className: classNames82(
            "dynamic-ipt break-all !max-w-[350px] inline-block  text-small leading-5 cursor-pointer px-1 overflow-hidden",
            isResultBlock ? `flex items-center ${"!text-[#091E42]" /* READ_ONLY_BLOCK */}` : "text-secondary-700"
          ),
          onClick: handleStepClick,
          children: step.isStepCreated || stepsInfo?.isStepResult ? /* @__PURE__ */ jsx(
            TruncatedText,
            {
              className: classNames82(
                "inline-block",
                { "grayscale opacity-50": step.disabled }
                // Add grayscale effect if step is disabled
              ),
              value: step.action,
              tooltipClassName: "w-[400px]"
            }
          ) : /* @__PURE__ */ jsxs("span", { className: "text-secondary-500", children: [
            t("soql.step.title.place_holder"),
            " "
          ] })
        }
      )
    }
  );
};
var soql_step_default = FormattedSOQLStep;
var cleanInputBlocks = (blocks) => {
  return blocks.map((item) => {
    return {
      type: !item.type ? "readonly_text" /* readonly_text */ : item.type,
      value: item.value || "",
      uuid: item.uuid || generateUniqueId(),
      more_details: item.more_details || {},
      isEncrypted: item.isEncrypted,
      has_value: item.has_value
    };
  });
};
var blocksToText = (blocks) => blocks.reduce((prev, block) => prev + block.value.trim(), "");
var boundedIncrementDecrement = (number, lowerBound, upperBound, increment) => {
  if (number === void 0 || number === null) return 0;
  let result = number + increment;
  if (result > upperBound) {
    result = lowerBound;
  } else if (result < lowerBound) {
    result = upperBound;
  }
  return result;
};
var setCaret = (el, position) => {
  try {
    const range = document.createRange();
    const sel = window.getSelection();
    if (!el.textContent) return;
    range.setStart(
      el.nodeType == el.TEXT_NODE ? el.parentElement : el,
      position
    );
    range.collapse(true);
    sel.removeAllRanges();
    sel.addRange(range);
  } catch (e) {
  }
};
var getCaretPosition = (element) => {
  if (!element) {
    return;
  }
  const selection = window.getSelection();
  const range = selection.getRangeAt(0);
  const clonedRange = range.cloneRange();
  clonedRange.selectNodeContents(element);
  clonedRange.setEnd(range.endContainer, range.endOffset);
  const cursorPosition = clonedRange.toString().length;
  return cursorPosition;
};
var getTestDataSymbol = (testDataType) => {
  const map3 = {
    ["function" /* function */]: "!" /* DATA_GENERATOR */,
    ["global" /* global */]: "*" /* ENVIRONMENT */,
    ["parameter" /* parameter */]: "@" /* PARAMETER */,
    ["phone_number" /* phone_number */]: "%" /* PHONE_NUMBER */,
    ["mail_box" /* mail_box */]: "&" /* EMAIL */,
    ["runtime" /* runtime */]: "$" /* RUNTIME_VARIABLE */,
    ["random" /* random */]: "~" /* RANDOM */,
    ["raw" /* raw */]: "" /* RAW */,
    ["upload_path" /* upload_path */]: "^" /* UPLOAD */
  };
  return map3[testDataType];
};
var getTestDataSymbolTooltip = (testDataType) => {
  const { t } = useTranslation();
  const map3 = {
    ["function" /* function */]: t("test.data.type.tooltip.function"),
    ["global" /* global */]: t("test.data.type.tooltip.global"),
    ["parameter" /* parameter */]: t("test.data.type.tooltip.parameter"),
    ["phone_number" /* phone_number */]: t("test.data.type.tooltip.phone_number"),
    ["mail_box" /* mail_box */]: t("test.data.type.tooltip.mail_box"),
    ["runtime" /* runtime */]: t("test.data.type.tooltip.runtime"),
    ["random" /* random */]: t("test.data.type.tooltip.random"),
    ["raw" /* raw */]: t("test.data.type.tooltip.raw"),
    ["upload_path" /* upload_path */]: t("test.data.type.tooltip.upload_path")
  };
  return map3[testDataType];
};
var getModalName = (testDataType) => {
  const map3 = {
    ["function" /* function */]: "OPEN_DATA_GENERATOR" /* DATA_GENERATOR */,
    ["global" /* global */]: "OPEN_ENVIRONMENT" /* ENVIRONMENT */,
    ["parameter" /* parameter */]: "OPEN_PARAMETER" /* PARAMETER */,
    ["phone_number" /* phone_number */]: "OPEN_PHONE_NUMBER" /* PHONE_NUMBER */,
    ["mail_box" /* mail_box */]: "OPEN_MAILBOX" /* MAILBOX */,
    ["runtime" /* runtime */]: "OPEN_RUNTIME_VARIABLE" /* RUNTIME_VARIABLE */,
    ["upload_path" /* upload_path */]: "OPEN_UPLOAD" /* UPLOAD */
  };
  return map3[testDataType];
};
var getTestDataOverrideType = (testDataType) => {
  const map3 = {
    ["function" /* function */]: TestDataOverRideType.STEP_GROUP_STEP_OVERRIDES_DATA_GENARATOR,
    ["global" /* global */]: TestDataOverRideType.STEP_GROUP_STEP_OVERRIDES_GLOBAL,
    ["phone_number" /* phone_number */]: TestDataOverRideType.STEP_GROUP_STEP_OVERRIDES_PHONE_NUMBER,
    ["mail_box" /* mail_box */]: TestDataOverRideType.STEP_GROUP_STEP_OVERRIDES_MAIL_BOX,
    ["runtime" /* runtime */]: TestDataOverRideType.STEP_GROUP_STEP_OVERRIDES_RUNTIME,
    ["upload_path" /* upload_path */]: TestDataOverRideType.STEP_GROUP_STEP_OVERRIDES_UPLOAD_PATH,
    ["raw" /* raw */]: TestDataOverRideType.STEP_GROUP_STEP_OVERRIDES_RAW,
    ["random" /* random */]: TestDataOverRideType.STEP_GROUP_STEP_OVERRIDES_RANDOM
  };
  return map3[testDataType];
};
var BlockContext = createContext({
  blocks: [],
  updateActiveBlockIndex: null,
  setBlockRef: null,
  updateBlockValue: null,
  getTestData: null,
  onSearch: null,
  isFetching: false,
  isCommand: false,
  isCommandCombine: false,
  isResultBlock: false,
  isReadOnly: true,
  isDisabled: true,
  isFocused: false,
  blocksRef: null,
  activeBlockIdx: null,
  disableAllowActiveIndexUpdate: null,
  isActiveIndexUpdateDisabled: null,
  saveHandler: () => {
  },
  dataParameterList: [],
  dataProfileList: [],
  dataSetList: [],
  updateSelectedDataProfile: null,
  isStepResult: false,
  step: null,
  isNoWrap: false,
  isNoWrapSteps: false,
  fetchConnections: () => {
  },
  actionCallback: () => {
  },
  salesforceActions: {},
  uploadActions: {},
  sessionActions: {},
  updateLocalStep: null,
  isNestedStepGroupStep: false,
  updateMultiBlockValue: null
});
var RecorderContext = React5__default.createContext({
  actions: {
    findStateByAction: (action) => action,
    getAppVersionId: () => Promise.resolve(0),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    triggerDebuggerCommand: (_input) => {
    }
  },
  isDebugger: false,
  isExitModalOpen: false,
  isAiAtomsWidget: false,
  isDesktopStepRecorderWidgetActive: false
});
var useRecorderContext = () => React5__default.useContext(RecorderContext);

// src/components/test-authoring/nlp-input/hooks.tsx
var isGenericElementName = (name) => {
  if (!name) return true;
  return /^element\d*$/i.test(name.trim());
};
var ApiTestDataToTestDataMapping = {
  RAW: "raw",
  PARAMETER: "parameter",
  RUNTIME_VARIABLE: "runtime",
  ENVIRONMENT_VARIABLE: "global",
  RANDOM: "random",
  DATA_GENERATOR: "function"
};
var getReleventTestDataType = (type = "raw") => {
  const stepTestDataType = ApiTestDataToTestDataMapping[type?.toUpperCase()];
  return stepTestDataType ?? type?.toLowerCase();
};
var useKeyNavigation = (templateId, nlpInputRef, isFocused, isReadOnly, isDisabled, blocksRef, updateStepFocused, inputAutoFocusEnabled, localBlocks) => {
  const [activeBlockIdx, _updateActiveIndex] = useState(null);
  const [isActiveIndexUpdateDisabled, _disableAllowActiveIndexUpdate] = useState(false);
  const disableAllowActiveIndexUpdate = (state) => {
    _disableAllowActiveIndexUpdate(state);
  };
  const updateActiveIndex = useCallback(
    (value) => {
      if (!isReadOnly && !isActiveIndexUpdateDisabled)
        _updateActiveIndex(value);
    },
    [isReadOnly, _updateActiveIndex, isActiveIndexUpdateDisabled]
  );
  const handleKeydown = useCallback(
    (event) => {
      const dynamicBlocks = Object.keys(blocksRef.current).map(Number).map((idx) => blocksRef.current[idx]);
      const getBlockIndex = (increment) => dynamicBlocks[activeBlockIdx == null ? 0 : boundedIncrementDecrement(
        dynamicBlocks.indexOf(activeBlockIdx),
        0,
        dynamicBlocks.length ? dynamicBlocks.length - 1 : 0,
        increment
      )] || 0;
      const caretPosition = getCaretPosition(
        blocksRef?.current?.[activeBlockIdx]
      );
      const isCaretPositionAtEndOfText = caretPosition === blocksRef?.current?.[activeBlockIdx]?.textContent?.length;
      if ((event.code == "Tab" || event.code == "ArrowRight") && isCaretPositionAtEndOfText) {
        const index = getBlockIndex(1);
        event.preventDefault();
        updateActiveIndex(index);
        setCaret(blocksRef.current[index], 1);
      } else if ((event.code == "Tab" && event.shiftKey || event.code == "ArrowLeft") && isCaretPositionAtEndOfText) {
        const index = getBlockIndex(-1);
        event.preventDefault();
        updateActiveIndex(index);
        setCaret(blocksRef.current[index], 1);
      }
    },
    [isFocused, isReadOnly, isDisabled, blocksRef, activeBlockIdx]
  );
  useEffect(() => {
    if (isReadOnly || isDisabled || !isFocused) {
      return;
    }
    Object.keys(blocksRef.current).map(
      (key) => blocksRef.current[key]?.addEventListener("keydown", handleKeydown)
    );
    return () => {
      Object.keys(blocksRef.current).map(
        (key) => blocksRef.current[key]?.removeEventListener("keydown", handleKeydown)
      );
    };
  }, [
    isFocused,
    isReadOnly,
    isDisabled,
    handleKeydown,
    nlpInputRef,
    blocksRef
  ]);
  useEffect(() => {
    updateStepFocused?.(activeBlockIdx != null);
  }, [activeBlockIdx]);
  useEffect(() => {
    if (isReadOnly || isDisabled || !isFocused) updateActiveIndex(null);
  }, [isReadOnly, isDisabled, isFocused]);
  const hasAutoFocusedRef = useRef(false);
  const prevHadUnfilledSelectableRef = useRef(false);
  useEffect(() => {
    if (!isFocused) {
      hasAutoFocusedRef.current = false;
      prevHadUnfilledSelectableRef.current = false;
    }
  }, [isFocused]);
  useEffect(() => {
    const dynamicBlocks = Object.keys(blocksRef.current).map(Number).filter((idx) => blocksRef.current[idx]);
    if (inputAutoFocusEnabled && isFocused && dynamicBlocks.length) {
      const unfilledSelectableIndex = localBlocks.findIndex(
        (block) => block.type === "selectable" && !block.more_details?.allowedValues?.includes(block.value)
      );
      const hasMandatorySelectableUnfilled = unfilledSelectableIndex !== -1;
      const justFilledMandatorySelectable = prevHadUnfilledSelectableRef.current && !hasMandatorySelectableUnfilled;
      if (justFilledMandatorySelectable) {
        hasAutoFocusedRef.current = false;
      }
      prevHadUnfilledSelectableRef.current = hasMandatorySelectableUnfilled;
      if (hasMandatorySelectableUnfilled) {
        updateActiveIndex(unfilledSelectableIndex);
        setCaret(blocksRef.current[unfilledSelectableIndex], 1);
        hasAutoFocusedRef.current = true;
      } else if (!hasAutoFocusedRef.current) {
        const index = localBlocks.findIndex(
          (block) => !(block?.more_details?.isReadOnly || block?.has_value)
        );
        updateActiveIndex(dynamicBlocks[index]);
        setCaret(blocksRef.current[dynamicBlocks[index]], 1);
        hasAutoFocusedRef.current = true;
      }
    }
  }, [isFocused, blocksRef, templateId, inputAutoFocusEnabled, localBlocks]);
  return {
    activeBlockIdx,
    updateActiveIndex,
    disableAllowActiveIndexUpdate,
    isActiveIndexUpdateDisabled
  };
};
var usePreventInput = (blockRef, isEnabled = true) => {
  const handleKeydown = useCallback(
    (event) => {
      if (isEnabled) event.preventDefault();
    },
    [isEnabled]
  );
  useEffect(() => {
    blockRef?.current?.addEventListener("keydown", handleKeydown);
    return () => blockRef?.current?.removeEventListener("keydown", handleKeydown);
  }, [blockRef]);
};
var useTestDataValueChange = (block, getTestData2, updateBlockValue, blockIdx, updateWaiting = () => {
}, updateSelectedDataProfile) => {
  const { updateActiveBlockIndex, blocks } = useContext(BlockContext);
  const MAILBOX2 = "Mail box";
  const PHONENUMBER2 = "Phone Number";
  const setOrClearDataGeneratorId = (block2, type, response) => {
    block2.more_details.testdataOverride.mailBoxId = null;
    block2.more_details.testdataOverride.phoneNumberId = null;
    if (type === TestDataType.function) {
      if (response.selected.text.includes("PhoneNumberFunctions")) {
        block2.more_details.testdataOverride.phoneNumberId = response?.selected?.more_details?.arguments?.find(
          (item) => item.argumentDisplayName === PHONENUMBER2
        )?.argumentValue;
      }
      if (response.selected.text.includes("MailBoxFunctions")) {
        block2.more_details.testdataOverride.mailBoxId = response?.selected?.more_details?.arguments?.find(
          (item) => item.argumentDisplayName === MAILBOX2
        )?.argumentValue;
      }
    }
  };
  const nextIndex = blocks.findIndex(
    (item, idx) => idx > blockIdx && item.type != "readonly_text" /* readonly_text */
  );
  const getOverriddenKibbutzDataGeneratorArguments = (moreDetails) => {
    if ((moreDetails?.isKibbutzFunction || moreDetails?.isKibbutzFn) && Boolean(moreDetails?.arguments)) {
      return Object.entries(moreDetails.arguments).map(([key, value]) => {
        const argument = new DataGeneratorArguments();
        argument.argumentName = key;
        argument.argumentValue = value;
        return argument;
      });
    }
    return moreDetails?.arguments;
  };
  return useCallback(
    async (type, enableActiveIndexUpdate = true, isStepGroupChild = false, writeNLPData) => {
      const localBlock = Object.assign({}, block);
      localBlock.type = type;
      updateWaiting?.(true);
      if (!["raw" /* raw */, "random" /* random */].includes(type)) {
        await getTestData2({
          modal: getModalName(type),
          data: localBlock.more_details.mapper,
          uuid: localBlock.uuid,
          testData: localBlock.more_details?.testDataInfo?.testDataFunctionId || localBlock.more_details?.testDataInfo?.testDataKibbutzFunctionId || localBlock.more_details?.testDataInfo?.dataGeneratorId ? localBlock.more_details.testDataInfo : null
        }).then((response) => {
          localBlock.more_details.testdataOverride = localBlock.more_details.testdataOverride || {};
          switch (type) {
            case "global" /* global */:
              localBlock.more_details.variableId = response?.selected?.data?.id;
              break;
            case "mail_box" /* mail_box */:
              localBlock.more_details.mailBoxId = response?.selected?.data?.id;
              break;
            case "phone_number" /* phone_number */:
              localBlock.more_details.phoneNumberId = response?.selected?.data?.id;
              break;
          }
          if (response?.selected?.text) {
            localBlock.value = response?.selected?.text;
            localBlock.more_details.testdataOverride.referenceKey = localBlock.uuid;
            localBlock.more_details.testdataOverride.parameterValue = response?.selected?.text;
            localBlock.more_details.testdataOverride.parameterType = type;
            if (type == "upload_path") {
              localBlock.more_details.testdataOverride.uploadId = response?.selected?.data?.id;
              localBlock.more_details.testdataOverride.uploadVersionId = response?.selected?.data?.latestVersion?.id;
              localBlock.value = `${response?.selected?.text},${response?.selected?.data?.latestVersion?.name}`;
            }
            localBlock.more_details.testDataProfile = response?.selected?.tdp;
            localBlock.more_details.testdataOverride.tdpDetails = response?.selected?.tdp;
            localBlock.more_details.testdataOverride.overrideType = getTestDataOverrideType(type);
          }
          if (response?.selected?.more_details) {
            if (response?.selected?.more_details?.testDataInfo?.isKibbutzFn || response?.selected?.more_details?.testDataInfo?.isKibbutzFunction) {
              localBlock.more_details.testdataOverride.dataGeneratorId = response?.selected?.more_details?.id;
            } else {
              localBlock.more_details.testdataOverride.functionId = response?.selected?.more_details?.id;
            }
            setOrClearDataGeneratorId(localBlock, type, response);
            localBlock.more_details.testdataOverride.dataGeneratorArguments = getOverriddenKibbutzDataGeneratorArguments(
              response?.selected?.more_details
            );
            localBlock.more_details.functionId = response?.selected?.more_details?.id;
            localBlock.more_details.testDataInfo = response?.selected?.more_details?.testDataInfo;
            localBlock.more_details = Object.assign(
              {},
              localBlock.more_details,
              response?.selected?.more_details
            );
          }
          updateActiveBlockIndex(null);
        });
        localBlock.isEncrypted = false;
      } else if (["raw" /* raw */, "random" /* random */].includes(type)) {
        if (writeNLPData != null) {
          if (block.more_details.profile) {
            localBlock.value = writeNLPData?.name;
            localBlock.more_details.profileId = writeNLPData.id;
            updateSelectedDataProfile(writeNLPData);
            if (nextIndex == -1) updateActiveBlockIndex(null);
          } else if (block.more_details.setName) {
            localBlock.value = writeNLPData?.name;
            localBlock.more_details.dataSetId = writeNLPData.id;
          } else if (block.more_details.parameter) {
            localBlock.value = writeNLPData;
          }
        }
        localBlock.more_details.testdataOverride = localBlock.more_details.testdataOverride || {};
        localBlock.more_details.testdataOverride.referenceKey = localBlock.uuid;
        localBlock.more_details.testdataOverride.overrideType = getTestDataOverrideType(type);
        if (type === "random" /* random */ && !isStepGroupChild) {
          localBlock.more_details.testdataOverride.parameterValue = "test data";
          localBlock.value = "test data";
        } else if (writeNLPData != null) {
          if (block.more_details.parameter) {
            localBlock.more_details.testdataOverride.parameterValue = writeNLPData;
            localBlock.value = writeNLPData;
          } else {
            localBlock.more_details.testdataOverride.parameterValue = writeNLPData?.name;
            localBlock.value = writeNLPData?.name;
          }
        } else {
          localBlock.more_details.testdataOverride.parameterValue = block.value;
          localBlock.value = block.value;
        }
        localBlock.more_details.testdataOverride.parameterType = type;
      }
      updateWaiting?.(false);
      updateBlockValue(localBlock, blockIdx);
      window.setTimeout(() => {
        if (nextIndex >= 0 && enableActiveIndexUpdate)
          updateActiveBlockIndex(nextIndex);
      }, 250);
    },
    [block, blockIdx, updateBlockValue, updateWaiting]
  );
};
var useForLoopValueChange = (block, blockIdx, updateBlockValue, updateSelectedDataProfile) => {
  const { updateActiveBlockIndex, disableAllowActiveIndexUpdate, blocks } = useContext(BlockContext);
  return useCallback(
    async (data) => {
      const nextIndex = blocks.findIndex(
        (item, idx) => idx > blockIdx && item.type != "readonly_text" /* readonly_text */
      );
      const localBlock = Object.assign({}, block);
      localBlock.type = "raw" /* raw */;
      disableAllowActiveIndexUpdate?.(true);
      localBlock.more_details.forloopOverride = localBlock.more_details.forloopOverride || {};
      if (block.more_details.profile) {
        localBlock.value = data?.name;
        localBlock.more_details.profileId = data.id;
        localBlock.more_details.forloopOverride.testDataId = data.id;
        updateSelectedDataProfile(data);
        if (nextIndex == -1) updateActiveBlockIndex(null);
      } else if (block.more_details.setName) {
        localBlock.value = data?.name;
        localBlock.more_details.dataSetId = data.id;
        localBlock.more_details.forloopOverride.testDataId = data.testDataProfileId;
      } else if (block.more_details.parameter) {
        localBlock.value = data;
        localBlock.more_details.forloopOverride.testDataId = data?.testDataProfileId || block?.more_details?.testDataProfile?.id;
      }
      disableAllowActiveIndexUpdate?.(false);
      updateBlockValue(localBlock, blockIdx);
      (window.getSelection ? window.getSelection() : document["selection"]).empty();
      window.setTimeout(() => {
        if (nextIndex >= 0) {
          updateActiveBlockIndex(nextIndex);
        }
      }, 250);
    },
    [block, blockIdx, updateBlockValue]
  );
};
var useElemntValueChange = (block, blockIdx, updateBlockValue, openElementListDrawer, openElementFormDrawer) => {
  const {
    updateActiveBlockIndex,
    disableAllowActiveIndexUpdate,
    step: activeStep,
    blocks,
    activeStepIdx
  } = useContext(BlockContext);
  const { applicationType, isRecorderView } = useContext(StepContext);
  const { isAiAtomsWidget, isDebugger } = useRecorderContext();
  const isActivated = useRef(false);
  const nextIndex = blocks.findIndex(
    (item, idx) => idx > blockIdx && item.type != "readonly_text" /* readonly_text */
  );
  const { steps } = useContext(StepContext);
  return useCallback(
    async (type, isEdit) => {
      let wasCancelled = false;
      if (isActivated.current) return;
      const localBlock = Object.assign({}, block);
      disableAllowActiveIndexUpdate?.(true);
      isActivated.current = true;
      if (type === "CAPTURE_ELEMENT" /* CAPTURE_ELEMENT */) {
        const mobileAppTypes = [
          ApplicationType.AndroidNative?.toString(),
          ApplicationType.IOSNative?.toString()
        ];
        if (mobileAppTypes.includes(applicationType)) {
          const mobileDirectCapturePromise = new Promise((resolve) => {
            window.mobileDirectCaptureResolver = resolve;
            window.dispatchEvent(
              new CustomEvent("element-capture-start", {
                detail: {
                  stepId: activeStep?.id,
                  blockUuid: localBlock.uuid
                }
              })
            );
            window.dispatchEvent(
              new CustomEvent("trigger-mobile-direct-capture", {
                detail: {
                  uuid: localBlock.uuid,
                  nlpId: activeStep?.templateId || activeStep?.kibbutzPluginNlpId,
                  applicationType,
                  stepId: activeStep?.id,
                  name: localBlock.value
                }
              })
            );
          });
          await mobileDirectCapturePromise.then(async (response) => {
            if (response?.action === "DISCARDED") {
              wasCancelled = true;
              window.dispatchEvent(
                new CustomEvent("element-capture-end", {
                  detail: {
                    stepId: activeStep?.id,
                    blockUuid: localBlock.uuid
                  }
                })
              );
              updateActiveBlockIndex(null);
              return;
            }
            if (response?.action === "SELECTED" && response?.details?.name) {
              if (response?.details?.rawElementData && window.createMobileElement) {
                try {
                  const createdElement = await window.createMobileElement(
                    response.details.rawElementData
                  );
                  if (!createdElement) {
                    toastify(`Mobile element creation failed`, {
                      type: "error",
                      position: "top-center",
                      autoClose: 3e3,
                      hideProgressBar: true
                    });
                    wasCancelled = true;
                    return;
                  }
                  const finalElementName = isGenericElementName(
                    localBlock.value
                  ) ? createdElement.name : localBlock.value;
                  localBlock.value = finalElementName;
                  localBlock.more_details.elementOverride = {
                    referenceKey: localBlock.uuid,
                    id: createdElement.id,
                    name: finalElementName
                  };
                  if (response.autoSave) {
                    disableAllowActiveIndexUpdate?.(false);
                    updateBlockValue(localBlock, blockIdx);
                    setTimeout(() => {
                      window.dispatchEvent(
                        new CustomEvent("trigger-auto-save", {
                          detail: {
                            stepId: activeStep?.id,
                            blockUuid: localBlock.uuid
                          }
                        })
                      );
                      disableAllowActiveIndexUpdate?.(false);
                      updateBlockValue(localBlock, blockIdx);
                      toastify(`Element captured and saved`, {
                        type: "success",
                        position: "top-center",
                        autoClose: 3e3,
                        hideProgressBar: true
                      });
                    }, 100);
                    setTimeout(() => {
                      window.dispatchEvent(
                        new CustomEvent("element-capture-end", {
                          detail: {
                            stepId: activeStep?.id,
                            blockUuid: localBlock.uuid
                          }
                        })
                      );
                    }, 500);
                  }
                } catch (error) {
                  console.error("Mobile element creation failed:", error);
                  toastify(
                    `Mobile element creation failed: ${error.message}`,
                    {
                      type: "error",
                      position: "top-center",
                      autoClose: 3e3,
                      hideProgressBar: true
                    }
                  );
                  wasCancelled = true;
                }
              } else {
                console.warn(
                  "window.createMobileElement function not available - mobile inspector context required"
                );
                toastify(
                  `Mobile element creation requires mobile inspector context`,
                  {
                    type: "error",
                    position: "top-center",
                    autoClose: 3e3,
                    hideProgressBar: true
                  }
                );
                wasCancelled = true;
              }
            }
          }).catch((error) => {
            console.error("Mobile direct capture failed:", error);
            window.dispatchEvent(
              new CustomEvent("element-capture-end", {
                detail: {
                  stepId: activeStep?.id,
                  blockUuid: localBlock.uuid
                }
              })
            );
            toastify(`Mobile element capture failed`, {
              type: "error",
              position: "top-center",
              autoClose: 3e3,
              hideProgressBar: true
            });
          });
        } else {
          const directCapturePromise = new Promise((resolve, reject) => {
            if (window["__directCaptureResolver"]) {
              window["__directCaptureResolver"].resolve({
                action: "DISCARDED"
              });
              delete window["__directCaptureResolver"];
              window.dispatchEvent(
                new CustomEvent("element-capture-end", {
                  detail: {
                    stepId: null,
                    blockUuid: null
                  }
                })
              );
            }
            window["__directCaptureResolver"] = { resolve, reject };
            window.dispatchEvent(
              new CustomEvent("element-capture-start", {
                detail: {
                  stepId: activeStep?.id,
                  blockUuid: localBlock.uuid
                }
              })
            );
            window.dispatchEvent(
              new CustomEvent("trigger-direct-capture", {
                detail: {
                  uuid: localBlock.uuid,
                  nlpId: activeStep?.templateId || activeStep?.kibbutzPluginNlpId,
                  name: localBlock.value
                }
              })
            );
          });
          await directCapturePromise.then((response) => {
            if (response?.action === "DISCARDED") {
              wasCancelled = true;
              updateActiveBlockIndex(null);
              return;
            }
            if (response?.action === "SELECTED" && response?.details?.name) {
              const finalElementName = isGenericElementName(localBlock.value) ? response.details.name : localBlock.value;
              localBlock.value = finalElementName;
              localBlock.more_details.elementOverride = {
                referenceKey: localBlock.uuid,
                id: response.details.id,
                name: finalElementName
              };
              if (response.autoSave) {
                disableAllowActiveIndexUpdate?.(false);
                updateBlockValue(localBlock, blockIdx);
                setTimeout(() => {
                  window.dispatchEvent(
                    new CustomEvent("trigger-auto-save", {
                      detail: {
                        stepId: activeStep?.id,
                        blockUuid: localBlock.uuid
                      }
                    })
                  );
                  disableAllowActiveIndexUpdate?.(false);
                  updateBlockValue(localBlock, blockIdx);
                  toastify(`Element captured and saved`, {
                    type: "success",
                    position: "top-center",
                    autoClose: 3e3,
                    hideProgressBar: true
                  });
                }, 100);
                setTimeout(() => {
                  window.dispatchEvent(
                    new CustomEvent("element-capture-end", {
                      detail: {
                        stepId: activeStep?.id,
                        blockUuid: localBlock.uuid
                      }
                    })
                  );
                }, 500);
              }
              if (!response.autoSave) {
                window.dispatchEvent(
                  new CustomEvent("element-capture-end", {
                    detail: {
                      stepId: activeStep?.id,
                      blockUuid: localBlock.uuid
                    }
                  })
                );
              }
            }
          }).catch((error) => {
            console.error("Direct capture failed:", error);
            window.dispatchEvent(
              new CustomEvent("element-capture-end", {
                detail: {
                  stepId: activeStep?.id,
                  blockUuid: localBlock.uuid
                }
              })
            );
            toastify(`Element capture failed`, {
              type: "error",
              position: "top-center",
              autoClose: 3e3,
              hideProgressBar: true
            });
          }).finally(() => {
            if (window["__directCaptureResolver"]) {
              delete window["__directCaptureResolver"];
            }
            window.dispatchEvent(
              new CustomEvent("element-capture-end", {
                detail: {
                  stepId: activeStep?.id ?? null,
                  blockUuid: localBlock.uuid
                }
              })
            );
          });
        }
      } else if (type == "OPEN_ELEMENT_FORM") {
        const isEditForm = isEdit == "edit";
        const mobileNativeAppTypes = [
          ApplicationType.AndroidNative?.toString(),
          ApplicationType.IOSNative?.toString()
        ];
        if (mobileNativeAppTypes.includes(applicationType) && !isRecorderView) {
          try {
            const pathTestCaseId = window.location.pathname.match(
              /td\/([^/]+)\/(cases|step-groups)(?:\/filters)?\/([0-9]+)/
            )?.[3];
            if (pathTestCaseId && activeStep) {
              const stepCopy = JSON.parse(JSON.stringify(activeStep));
              const elementValue = localBlock.value || "--ELEMENT--";
              if (stepCopy.action && typeof stepCopy.action === "string") {
                stepCopy.action = stepCopy.action.replaceAll(
                  elementValue,
                  "--ELEMENT--"
                );
              }
              if (stepCopy.uiMap?.objectBlocks) {
                stepCopy.uiMap.objectBlocks = stepCopy.uiMap.objectBlocks.map(
                  (block2) => {
                    if (block2.value === elementValue) {
                      return {
                        ...block2,
                        value: "--ELEMENT--",
                        has_value: false
                      };
                    }
                    return block2;
                  }
                );
              }
              window["stepElementCloned"] = {
                testCaseId: pathTestCaseId,
                expires: Date.now() + 2 * 60 * 1e3,
                // 2 minutes expiry
                step: stepCopy,
                originalStep: { localStep: activeStep },
                originalValue: localBlock.value,
                elementBlockUuid: localBlock.uuid
                // Store the block uuid for element type determination
              };
            }
          } catch (error) {
            console.error(
              "Failed to preserve step state for mobile element capture:",
              error
            );
          }
        }
        await openElementFormDrawer({
          modal: type,
          uuid: localBlock.uuid,
          name: isEditForm ? localBlock.value : void 0,
          id: isEditForm ? activeStep.uiIdentifierOverRiddenMappings?.find(
            (item) => item.elementName == localBlock.value
          )?.elementId || activeStep?.testStepElements?.find(
            (item) => item.name == localBlock.value
          )?.elementId || null : null,
          nlpId: activeStep?.templateId || activeStep?.kibbutzPluginNlpId
        }).then((response) => {
          if (response?.details?.name) {
            localBlock.value = response?.details?.name;
            if (isEdit != "edit") {
              localBlock.more_details.elementOverride = {
                referenceKey: localBlock.uuid,
                id: response?.details?.id,
                name: response?.details?.name
              };
            }
          }
          updateActiveBlockIndex(null);
        }).finally(() => {
          isActivated.current = false;
        });
      } else {
        console.log(
          " Taking default path (openElementListDrawer) - this opens Select Element drawer"
        );
        await openElementListDrawer({
          modal: type,
          uuid: localBlock.uuid,
          ...localBlock.has_value ? {
            previousStepElementName: activeStep.perviousStepElement || localBlock.value
          } : {},
          nlpId: activeStep?.templateId || activeStep?.kibbutzPluginNlpId
        }).then((response) => {
          if (response?.details?.name) {
            localBlock.value = response?.details?.name;
            localBlock.more_details.elementOverride = {
              referenceKey: localBlock.uuid,
              id: response?.details?.id,
              name: response?.details?.name,
              objectTypeId: response?.details?.objectTypeId
            };
          }
          updateActiveBlockIndex(null);
        }).finally(() => {
          isActivated.current = false;
        });
      }
      disableAllowActiveIndexUpdate?.(false);
      if (!wasCancelled) {
        updateBlockValue(localBlock, blockIdx);
        if (!(isEdit === "edit" && localBlock.value != block.value))
          window.setTimeout(() => {
            if (nextIndex >= 0) updateActiveBlockIndex(nextIndex);
          }, 250);
      }
      isActivated.current = false;
    },
    [
      steps,
      blocks,
      blockIdx,
      activeStep,
      activeStepIdx,
      block,
      disableAllowActiveIndexUpdate,
      updateBlockValue,
      openElementFormDrawer,
      updateActiveBlockIndex,
      openElementListDrawer,
      nextIndex,
      applicationType,
      isRecorderView,
      isAiAtomsWidget,
      isDebugger
    ]
  );
};
var useSalesforceAPIFormValueChange = (block, blockIdx, updateBlockValue, step, onOpenSalesforceAPIFormDrawer, updateLocalStep) => {
  const {
    updateActiveBlockIndex,
    disableAllowActiveIndexUpdate,
    step: activeStep,
    blocks,
    updateMultiBlockValue
  } = useContext(BlockContext);
  const isActivated = useRef(false);
  const nextIndex = blocks.findIndex(
    (item, idx) => idx > blockIdx && item.type != "readonly_text" /* readonly_text */
  );
  const { activeStepIdx, steps } = useContext(StepContext);
  return useCallback(
    async (type, isEdit) => {
      let canSkipUpdate = false;
      if (isActivated.current) return;
      const localBlock = Object.assign({}, block);
      disableAllowActiveIndexUpdate?.(true);
      if (type == "OPEN_SALESFORCE_API_FORM") {
        await onOpenSalesforceAPIFormDrawer({
          modal: type,
          uuid: localBlock.uuid,
          name: isEdit == "edit" ? localBlock.value : void 0,
          testStep: step,
          mapperData: localBlock?.more_details?.mapper
        }).then((response) => {
          if (response?.details?.salesforceAPIStepDetails?.salesforceObject) {
            localBlock.value = response.details.salesforceAPIStepDetails.salesforceObject;
            if (response?.details) {
              if (step) {
                step.apiStep = response?.details ? response.details : step.apiStep;
                step.stepDataList.forEach((item) => {
                  if (item?.key === "salesforceObjectForm") {
                    item.value = response?.details?.salesforceAPIStepDetails?.salesforceObject;
                  } else if (item?.key === "testData") {
                    item.value = response?.details?.salesforceAPIStepDetails?.recordId;
                    item.type = getReleventTestDataType(
                      response?.details?.salesforceAPIStepDetails?.recordIdType
                    );
                  } else if (item?.key === "salesforceConnection") {
                    item.value = response?.details?.salesforceAPIStepDetails?.connectionName;
                    item.type = getReleventTestDataType(
                      response?.details?.salesforceAPIStepDetails?.connectionType
                    );
                  }
                });
                updateAllBlockValues(blocks, step, updateMultiBlockValue);
                canSkipUpdate = true;
                updateLocalStep?.(new TestStep().deserialize(step));
              }
            }
          } else {
            if (response?.details?.salesforceObject) {
              localBlock.value = response?.details?.salesforceObject;
            }
            if (response?.details) {
              if (step) {
                step.salesforceAPIStep = response?.details ? response?.details : step.salesforceAPIStep;
                updateLocalStep?.(new TestStep().deserialize(step));
              }
            }
          }
          updateActiveBlockIndex(null);
        }).finally(() => {
          isActivated.current = false;
        });
      }
      disableAllowActiveIndexUpdate?.(false);
      !canSkipUpdate && updateBlockValue(localBlock, blockIdx);
      window.setTimeout(() => {
        if (nextIndex >= 0) updateActiveBlockIndex(nextIndex);
      }, 250);
      isActivated.current = false;
    },
    [
      steps,
      blocks,
      blockIdx,
      activeStep,
      activeStepIdx,
      block,
      disableAllowActiveIndexUpdate,
      updateBlockValue,
      onOpenSalesforceAPIFormDrawer,
      updateActiveBlockIndex,
      nextIndex
    ]
  );
};
var useHandleEnter = (blockRef, isTestDataDropdownOpened, saveHandler) => {
  const handleKeydown = useCallback(
    (event) => {
      if (isTestDataDropdownOpened || event.code != "Enter") return;
      event.preventDefault();
      setTimeout(() => {
        saveHandler?.();
      }, 500);
    },
    [isTestDataDropdownOpened, saveHandler]
  );
  useEffect(() => {
    blockRef?.current?.addEventListener("keydown", handleKeydown);
    return () => blockRef?.current?.removeEventListener("keydown", handleKeydown);
  }, [blockRef, handleKeydown]);
};
var useFormattedPaste = (element) => {
  const handlePaste = useCallback((e) => {
    e.preventDefault();
    const text = e.clipboardData.getData("text/plain");
    document.execCommand("insertText", false, text);
  }, []);
  useEffect(() => {
    element.current?.addEventListener("paste", handlePaste);
    return () => element.current?.removeEventListener("paste", handlePaste);
  }, [element]);
};
var StepTypeShortCodesDropDownItem = ({
  name,
  command,
  onClick,
  icon,
  isSelected,
  currenHovering,
  isDisabled = false
}) => {
  const ref = useRef(null);
  const { t } = useTranslation();
  const { isWebRecorder } = useContext(StepContext);
  const { isDebugger } = useRecorderContext();
  useEffect(() => {
    if (currenHovering && ref.current)
      ref.current?.scrollIntoView({ behavior: "instant", block: "center" });
  }, [currenHovering]);
  return /* @__PURE__ */ jsx(
    ToolTip,
    {
      content: isDisabled ? isDebugger ? t("operation.not.allowed.in.debugger") : t("operation.not.allowed.in.recorder") : "",
      children: /* @__PURE__ */ jsxs(
        "div",
        {
          ref: (el) => ref.current = el,
          className: classNames82(
            "px-4 py-2 flex items-center hover:bg-secondary-50 cursor-pointer",
            {
              "bg-secondary-50": isSelected || currenHovering,
              "pointer-events-none opacity-40 cursor-not-allowed": isDisabled
            }
          ),
          onClick,
          children: [
            !!icon && /* @__PURE__ */ jsx(Icon, { name: icon, className: "mr-2 text-lg text-secondary-300" }),
            /* @__PURE__ */ jsx(
              "div",
              {
                className: classNames82("text-unique-600 text-small leading-5", {
                  "flex-grow": !isSelected,
                  "text-small": !isWebRecorder,
                  "text-2xs": isWebRecorder
                }),
                children: name
              }
            ),
            !isSelected && /* @__PURE__ */ jsx(
              "div",
              {
                className: classNames82(
                  { "text-small": !isWebRecorder, "text-2xs": isWebRecorder },
                  "leading-5 text-secondary-300"
                ),
                children: command
              }
            ),
            isSelected && /* @__PURE__ */ jsx(
              Icon,
              {
                name: "check-circle",
                className: "ml-2 text-base text-primary-600"
              }
            )
          ]
        }
      )
    }
  );
};
var StepTypeShortCodeCommands = ({ onChange, updateShortCode, currentSelection, step, toggleDropdown }) => {
  const { t } = useTranslation();
  const { isRecorderView } = useContext(StepContext);
  const isSalesforce = step.applicationType == ApplicationType.Salesforce;
  const isWindowsAdvanced = isObjectBased(step);
  const handleItemClick = useCallback(
    (stepType) => {
      onChange(stepType);
      if (stepType !== StepTypeUI.FOR_LOOP) {
        toggleDropdown();
      }
    },
    [onChange, toggleDropdown]
  );
  const { blocks } = useContext(BlockContext);
  const commandList = [
    ...isWindowsAdvanced ? [
      {
        name: t("step.switch.elements"),
        command: "/elements",
        stepType: StepTypeUI.ELEMENT
      },
      {
        name: t("step.switch.actions"),
        command: "/actions",
        stepType: StepTypeUI.ACTION
      }
    ] : [
      {
        name: t("step.switch.nlp"),
        command: "/nlp",
        stepType: StepTypeUI.NLP
      }
    ],
    ,
    {
      name: t("step.switch.group"),
      command: "/stepgroup",
      stepType: StepTypeUI.STEP_GROUP
    },
    ...!step?.blockParentId ? [
      {
        name: t("step.switch.block"),
        command: "/blocks",
        stepType: StepTypeUI.BLOCK
      }
    ] : [],
    {
      name: t("step.switch.for"),
      command: "/forloop",
      stepType: StepTypeUI.FOR_LOOP
    },
    {
      name: t("step.switch.while"),
      command: "/whileloop",
      stepType: StepTypeUI.WHILE_LOOP
    },
    ...isSalesforce ? [
      {
        name: t("step.switch.soql"),
        command: "/soql",
        stepType: StepTypeUI.SOQL
      }
    ] : [],
    ,
    {
      name: t("step.switch.function"),
      command: "/function",
      stepType: StepTypeUI.CUSTOM_FUNCTION
    },
    {
      name: t("step.switch.rest"),
      command: "/api",
      stepType: StepTypeUI.REST_API
    },
    {
      name: t("step.switch.if.nlp"),
      command: "/if",
      stepType: StepTypeUI.IF_CONDITION
    },
    {
      name: t("step.switch.if.group"),
      command: "/if stepgroup",
      stepType: StepTypeUI.IF_STEP_GROUP
    },
    {
      name: t("step.switch.if.function"),
      command: "/if function",
      stepType: StepTypeUI.IF_CUSTOM_FUNCTION
    },
    {
      name: t("step.switch.if.rest"),
      command: "/if api",
      stepType: StepTypeUI.IF_REST_API
    }
  ];
  const [filteredList, updateFilterList] = useState(commandList);
  useEffect(() => {
    const escapedInput = blocks[0].value.replace(/\//g, "").toLowerCase();
    const listData = commandList.filter(
      (item) => item.command.toLowerCase().includes(escapedInput) || item.name.toLowerCase().includes(escapedInput)
    );
    updateFilterList(listData);
    updateShortCode(listData);
  }, [blocks[0]]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    filteredList.map((command, idx) => /* @__PURE__ */ jsx(
      StepTypeShortCodesDropDownItem,
      {
        name: command.name,
        command: command.command,
        currenHovering: Boolean(currentSelection == idx),
        onClick: () => handleItemClick(command.stepType),
        isSelected: step?.uiMap?.type == command.stepType,
        isDisabled: [
          StepTypeUI.IF_REST_API,
          StepTypeUI.REST_API,
          StepTypeUI.SOQL
        ].includes(command.stepType) ? isRecorderView : false
      },
      `${command}_${idx}`
    )),
    Boolean(!filteredList.length) && /* @__PURE__ */ jsx("div", { className: "p-4 text-secondary-500 w-[560px]", children: t("common.search_not_found") })
  ] });
};
var ListItem = ({
  onClick,
  template,
  getBlockFn,
  isAddonIcon,
  currenHovering,
  blocks,
  isWebRecorder
}) => {
  const ref = useRef(null);
  const { hasFeatureValue: hasFeatureValue2 } = useContext(StepContext);
  const isLaunchNlp = !!(template?.grammar?.startsWith("Launch App") || template?.grammar?.startsWith("Navigate to"));
  return /* @__PURE__ */ jsx(Fragment, { children: Boolean(template.grammar || blocks) && /* @__PURE__ */ jsx(
    DropdownItem,
    {
      onClick,
      className: classNames82(
        "flex items-center !px-4 hover:!bg-secondary-50",
        currenHovering ? "bg-secondary-50" : "",
        { "navigate-launch-action": isLaunchNlp },
        isWebRecorder ? "!py-1" : "!py-0.5"
      ),
      children: /* @__PURE__ */ jsxs(
        "div",
        {
          ref: (el) => ref.current = el,
          className: classNames82(
            isAddonIcon ? "flex items-baseline" : "flex-col"
          ),
          children: [
            isAddonIcon && /* @__PURE__ */ jsx(Icon, { name: "addons" }),
            /* @__PURE__ */ jsx(
              NlpInput,
              {
                blocks: blocks ? blocks : getBlockFn({}, template, false, hasFeatureValue2),
                isReadOnly: true
              }
            )
          ]
        },
        template.id
      )
    }
  ) });
};
var StepSuggestionDropDown = ({
  currentSelection,
  onSelect,
  filteredOptions,
  blocks,
  isWebRecorder
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    map$1(filteredOptions, (template, idx) => /* @__PURE__ */ jsx(
      ListItem,
      {
        onClick: () => onSelect(template),
        template,
        getBlockFn: template["isAddon"] ? getStepKibbutzBlocks : getStepNlpBlocks,
        currenHovering: Boolean(currentSelection === idx),
        isAddonIcon: template["isAddon"],
        isWebRecorder,
        blocks: blocks ? [
          {
            value: t("step.type.custom_function_value", {
              className: template?.className,
              methodName: template?.functionName
            }) || "",
            type: "readonly_text" /* readonly_text */,
            canEncrypt: false,
            isEncrypted: false
          }
        ] : null
      },
      `${template.id}_${idx}`
    )),
    Boolean(!size(filteredOptions)) && /* @__PURE__ */ jsx("div", { className: "p-4 text-secondary-500 w-[560px]", children: t("common.search_not_found") })
  ] });
};
var recorderOffset = [0, 15];
var modifier = [
  {
    name: "offset",
    options: {
      offset: [0, 3]
    }
  }
];
var StepDropDownWrapper = ({
  node,
  onChange,
  onChangeCunstomFunction,
  activeBlockIdx,
  onChangeType,
  onDropdownToggle,
  buttonRef = null,
  step,
  dataProfileList,
  customFunctionList
}) => {
  const ignoredTemplateIds = [
    "1068",
    "1069",
    "10172",
    "10173",
    "20142",
    "20143",
    "30134",
    "30135",
    "60362",
    "60363"
  ];
  const blockRef = node;
  const { isFocused, isFetching, isCommand, isCommandCombine } = useContext(BlockContext);
  const {
    userPreference,
    fetchDataProfile,
    algoliaTemplate,
    kibbutzActions,
    isRecorderView,
    isWebRecorder,
    isDebugMode = false,
    openExternalUrl,
    getTdpBaseUrl,
    versionId: contextVersionId
  } = useContext(StepContext);
  const [canShow, updateCanShow] = useState(true);
  const { t } = useTranslation();
  const onSelect = useCallback(
    (template2) => {
      updateCanShow(false);
      onChange(template2);
    },
    [onChange]
  );
  const onCustomFunctionSelect = useCallback(
    (customBlock) => {
      updateCanShow(false);
      onChangeCunstomFunction(customBlock);
    },
    [onChangeCunstomFunction]
  );
  const [dropdownRef, setDropdownRef] = useState(null);
  const _modifier = useMemo(() => {
    const newModifier = [...modifier];
    if (isRecorderView) {
      newModifier[0].options.offset = recorderOffset;
    }
    return newModifier;
  }, [isRecorderView]);
  const { styles, attributes } = usePopper(blockRef.current, dropdownRef, {
    placement: "bottom-start",
    strategy: "fixed",
    modifiers: _modifier
  });
  const canShowDropdown = Boolean(isFocused && canShow && !activeBlockIdx) && ![StepTypeUI.ACTION, StepTypeUI.ELEMENT].includes(step.uiMap?.type);
  const [currentSelection, updateCurrentSelection] = useState(0);
  const [shortCodeList, updateShortCodeList] = useState([]);
  const [showTDPRefresh, setShowTDPRefresh] = useState(false);
  let filteredOptions = [];
  const filteredAlgoliaTemplate = algoliaTemplate?.filter(
    (template2) => !ignoredTemplateIds.includes(template2?.id?.toString()) && template2?.deprecated?.toString() === "false" && template2.type !== NLPTemplateType.OPTIONAL
  );
  const nonDeprecatedKibbutzActions = kibbutzActions.filter(
    (action) => !action.deprecated
  );
  if (isCommand) {
    filteredOptions = [...shortCodeList];
  } else if (isCommandCombine) {
    filteredOptions = [
      ...shortCodeList,
      ...filteredAlgoliaTemplate,
      ...nonDeprecatedKibbutzActions
    ];
  } else {
    filteredOptions = [
      ...filteredAlgoliaTemplate,
      ...nonDeprecatedKibbutzActions
    ];
  }
  const toggleDropdown = useCallback(() => {
    if (isRecorderView) {
      updateCanShow(false);
    }
    onDropdownToggle();
  }, [onDropdownToggle, isRecorderView]);
  const handleKeyMovements = useCallback(
    (event) => {
      if (!canShowDropdown) {
        return;
      }
      if (event.code == "ArrowUp" || event.code == "ArrowRight") {
        updateCurrentSelection(
          boundedIncrementDecrement(
            currentSelection,
            0,
            filteredOptions.length - 1,
            -1
          )
        );
        event.preventDefault();
      } else if (event.code == "ArrowDown" || event.code == "ArrowLeft") {
        updateCurrentSelection(
          boundedIncrementDecrement(
            currentSelection,
            0,
            filteredOptions.length - 1,
            1
          )
        );
        event.preventDefault();
      } else if (event.code == "Escape") {
        toggleDropdown();
        event.preventDefault();
      } else if (event.code == "Enter") {
        if (step.type === TestStepType.CUSTOM_FUNCTION && customFunctionList[currentSelection]) {
          onCustomFunctionSelect(customFunctionList[currentSelection]);
        } else if (step.type !== TestStepType.CUSTOM_FUNCTION && filteredOptions[currentSelection]?.grammar) {
          onSelect(filteredOptions[currentSelection]);
        } else {
          onChangeType(filteredOptions[currentSelection].stepType);
        }
        event.preventDefault();
      }
    },
    [currentSelection, filteredOptions, step, customFunctionList]
  );
  useEffect(() => {
    blockRef.current?.addEventListener("keydown", handleKeyMovements);
    return () => blockRef.current?.removeEventListener("keydown", handleKeyMovements);
  }, [blockRef, handleKeyMovements]);
  const handleInputClick = useCallback(() => {
    if (!canShow) {
      updateCanShow(isFocused);
      updateCurrentSelection(0);
    }
  }, [canShow, isFocused]);
  useEffect(() => {
    blockRef.current?.addEventListener("click", handleInputClick);
  }, [blockRef, handleInputClick]);
  const isInVisible = document.body.classList.contains(
    "invisible-nlp-suggestion"
  );
  const isTdpAvailable = isForLoop(step) ? Boolean(dataProfileList?.length) : true;
  const createTDPClickHandler = () => {
    setShowTDPRefresh(true);
    const versionIdForTdp = contextVersionId ?? userPreference?.preference?.projectPreference?.versionId;
    if (versionIdForTdp == null || versionIdForTdp === "") {
      return;
    }
    const baseURL = getTdpBaseUrl?.() ?? getBaseUrl();
    const tdpUrl = `${baseURL}/ui/td/${versionIdForTdp}/data/new`;
    if (openExternalUrl) {
      Promise.resolve(openExternalUrl(tdpUrl)).catch(() => {
      });
    } else {
      window.open(tdpUrl, "_blank");
    }
  };
  const isStepCommand = Boolean(!step?.isCustomFunction) && Boolean(!step?.id) && Boolean(isCommandCombine || isCommand);
  const isWindowsAdvanced = isObjectBased(step);
  const template = canShowDropdown && /* @__PURE__ */ jsxs(
    Dropdown,
    {
      role: "region",
      "aria-label": t("nlp.suggestions") || "Step suggestions",
      className: classNames82(
        "nlp-suggestion-dropdown min-w-[90px] !z-[21] text-sm h-[40vh]",
        isFetching ? "" : "!overflow-auto",
        isTdpAvailable ? "" : "!overflow-hidden",
        isWebRecorder ? "" : "w-[78%]",
        {
          "!max-w-[450px] !max-h-[160px]": isRecorderView && !isWebRecorder && isTdpAvailable,
          "opacity-0": isInVisible,
          "max-w-[400px] max-h-[240px]": isRecorderView && !isTdpAvailable,
          "max-h-[300px] !max-w-[50%]": !isRecorderView,
          "!max-w-[240px]": isWindowsAdvanced && !step?.uiMap?.type,
          "!max-w-[465px] !max-h-[160px] !rounded-lg w-full": isWebRecorder
        }
      ),
      toggleDropdown,
      setRef: setDropdownRef,
      style: styles.popper,
      attributes: attributes.popper,
      buttonRef,
      children: [
        isTdpAvailable && /* @__PURE__ */ jsxs(Fragment, { children: [
          Boolean(isFetching) && /* @__PURE__ */ jsx(
            "div",
            {
              className: classNames82(
                "absolute backdrop-blur-sm h-full w-full z-10 max-h-full !overflow-auto"
              )
            }
          ),
          /* @__PURE__ */ jsxs(
            "div",
            {
              className: classNames82(
                "nlp-container max-h-full !overflow-auto min-w-[220px]"
              ),
              children: [
                isStepCommand && /* @__PURE__ */ jsx(
                  StepTypeShortCodeCommands,
                  {
                    toggleDropdown,
                    onChange: onChangeType,
                    updateShortCode: updateShortCodeList,
                    currentSelection,
                    step
                  }
                ),
                Boolean(!step?.isCustomFunction) && Boolean(!isCommand || step?.id) && /* @__PURE__ */ jsx(
                  StepSuggestionDropDown,
                  {
                    updateCurrentSelection,
                    onSelect,
                    filteredOptions,
                    currentSelection,
                    isWebRecorder
                  }
                ),
                Boolean(step?.isCustomFunction) && /* @__PURE__ */ jsx(
                  StepSuggestionDropDown,
                  {
                    updateCurrentSelection,
                    onSelect: onCustomFunctionSelect,
                    filteredOptions: customFunctionList,
                    currentSelection,
                    blocks: true,
                    isWebRecorder
                  }
                )
              ]
            }
          )
        ] }),
        !isTdpAvailable && (isWebRecorder && !isDebugMode ? /* @__PURE__ */ jsx("span", { className: "flex p-2.5 text-amber-600 w-full font-normal text-small whitespace-normal", children: t("step.for_loop.no_data_profile.web_recorder") }) : /* @__PURE__ */ jsx(
          Empty,
          {
            description: /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx("div", { className: "mb-2 text-xs", children: t("nlp.tdp.empty") }),
              /* @__PURE__ */ jsx(PrimaryButton, { onClick: createTDPClickHandler, className: "mr-2", children: t("nlp.tdp.create") }),
              showTDPRefresh && /* @__PURE__ */ jsx(SecondaryButton, { onClick: fetchDataProfile, children: /* @__PURE__ */ jsx(Icon, { name: "refresh" }) })
            ] }),
            shouldShowImage: !(isDebugMode && isWebRecorder),
            imageClassName: "w-2/5",
            className: "p-5 whitespace-normal",
            imageSource: noDataPane
          }
        ))
      ]
    },
    "drop-down"
  );
  return createPortal(
    template,
    document.querySelector("#mi-authoring-portal") || document.body
  );
};
var ActionsDropdown = ({
  blockRef,
  onSelect,
  toggleDropdown,
  fetchObjectActions,
  applicationType,
  objectTypeId,
  kibbutzTemplate,
  currentSelectedAction
}) => {
  const [dropdownRef, setDropdownRef] = useState(null);
  const [actions, setAction] = useState([]);
  const [searchTerm, setSearchTerm] = useState(null);
  const [loading, setLoading] = useState(false);
  const { styles, attributes } = usePopper(blockRef.current, dropdownRef, {
    placement: "bottom-start",
    strategy: "fixed"
  });
  const { t } = useTranslation();
  const { blocks } = useContext(BlockContext);
  const { testCase } = useContext(StepContext);
  const debouncedTerm = useDebounce(searchTerm, 500);
  const filteredActions = useCallback((Template2, search) => {
    const DropdownData = [];
    if (Template2?.content) {
      Template2.content.forEach((item) => {
        const hasUiElement = item.parameters?.some(
          (param) => param.type === "ELEMENT"
        );
        const matchesSearch = !search || item.displayName?.toLowerCase().includes(search.toLowerCase());
        if (hasUiElement && matchesSearch) {
          DropdownData.push({
            action: item.displayName,
            templateId: item.id,
            parameters: item.parameters
          });
        }
      });
    }
    return DropdownData;
  }, []);
  const fetchActions = () => {
    const element = blocks[0]?.type == "ui_identifier" /* ui_identifier */ && blocks[0]?.has_value && blocks[0]?.value;
    fetchObjectActions(
      applicationType,
      encodeCustomSpecialCharacters(searchTerm) || "",
      objectTypeId,
      element && encodeCustomSpecialCharacters(element),
      testCase.applicationVersionId
    ).then((res) => {
      const regularActions = (res || []).map((action) => ({
        ...action,
        isAddonTemplate: false
      }));
      const templateActions = filteredActions(
        kibbutzTemplate,
        searchTerm
      ).map((action) => ({
        ...action,
        isAddonTemplate: true
      }));
      setAction([...regularActions, ...templateActions]);
    }).catch((err) => {
      throw new Error(err);
    }).finally(() => setLoading(false));
  };
  useEffect(() => {
    setLoading(true);
    fetchActions();
  }, [debouncedTerm]);
  return /* @__PURE__ */ jsxs(
    Dropdown,
    {
      className: "w-[260px] min-w-[100px] z-[1000]  max-h-80 overflow-y-scroll overflow-x-hidden",
      toggleDropdown,
      setRef: setDropdownRef,
      style: styles.popper,
      attributes: attributes.popper,
      children: [
        /* @__PURE__ */ jsx(
          Input,
          {
            value: searchTerm,
            onChange: setSearchTerm,
            placeholder: t("search"),
            suffix: /* @__PURE__ */ jsx(Icon, { name: "search", className: "text-secondary-500 text-base pr-2" }),
            wrapperClassName: "w-full border-b border-b-secondary-200",
            className: "!bg-white"
          }
        ),
        loading && /* @__PURE__ */ jsx("div", { className: "empty-page-loader left-1/2 top-1/2 absolute my-10" }),
        !loading && actions?.map((item, idx) => {
          const isCurrentlySelected = item.templateId === currentSelectedAction;
          return /* @__PURE__ */ jsxs(
            DropdownItem,
            {
              onClick: () => {
                if (!isCurrentlySelected) {
                  onSelect(item);
                  toggleDropdown(false);
                }
              },
              className: `w-[260px] max-w-[260px] flex items-center px-2 ${isCurrentlySelected ? "opacity-50 cursor-not-allowed bg-secondary-50" : "cursor-pointer hover:bg-secondary-50"}`,
              isDisabled: isCurrentlySelected,
              children: [
                item.isAddonTemplate && /* @__PURE__ */ jsx(Icon, { name: "extension", className: "text-sm mr-2 flex-shrink-0" }),
                /* @__PURE__ */ jsx(
                  TruncatedText,
                  {
                    value: item.action,
                    className: `text-small ${isCurrentlySelected ? "text-secondary-400" : "text-unique-600"} flex-1 truncate`
                  }
                ),
                isCurrentlySelected && /* @__PURE__ */ jsx(
                  Icon,
                  {
                    name: "check-circle",
                    className: "text-success-500 text-sm ml-2 flex-shrink-0"
                  }
                )
              ]
            },
            `${item.templateId}_${idx}`
          );
        }),
        !loading && actions?.length == 0 && /* @__PURE__ */ jsx(DropdownItem, { className: "flex items-center", children: /* @__PURE__ */ jsx("span", { className: "text-small text-secondary-500", children: t("step.no_match_found") }) })
      ]
    },
    "drop-down"
  );
};
var actions_dropdown_default = ActionsDropdown;
var ActionBlock = ({
  block,
  blockIdx
}) => {
  const blockRef = useRef(null);
  const {
    isDisabled,
    isReadOnly,
    activeBlockIdx,
    setBlockRef,
    isFocused,
    updateActiveBlockIndex,
    updateBlockValue,
    saveHandler,
    blocks,
    step
  } = useContext(BlockContext);
  const { fetchObjectActions, applicationType, kibbutzTemplate } = useContext(StepContext);
  const isInitialFocusActivated = useRef(false);
  const isActiveBlock = activeBlockIdx == blockIdx;
  const [showDropdown, toggleShowTestDataDropdown] = useState(false);
  const toggleDropdown = useCallback(
    (state) => {
      updateActiveBlockIndex(state ? blockIdx : null);
      toggleShowTestDataDropdown(false);
    },
    [blockIdx, updateActiveBlockIndex]
  );
  const handleValueChange = useCallback(
    (value) => {
      const nextIndex = blocks.findIndex(
        (item, idx) => idx > blockIdx && item.type != "readonly_text" /* readonly_text */
      );
      block.value = value.action;
      block.more_details.templateId = value.templateId;
      updateBlockValue({ ...block }, blockIdx);
      toggleShowTestDataDropdown(false);
      if (nextIndex != -1)
        window.setTimeout(() => updateActiveBlockIndex(nextIndex), 250);
    },
    [block, blockIdx, updateBlockValue]
  );
  const toggleActiveBlock = useCallback(() => {
    if (!isActiveBlock) {
      updateActiveBlockIndex(blockIdx);
    }
    toggleShowTestDataDropdown(true);
  }, [activeBlockIdx]);
  usePreventInput(blockRef);
  useHandleEnter(blockRef, false, saveHandler);
  useFormattedPaste(blockRef);
  useEffect(() => {
    if (activeBlockIdx == blockIdx && !showDropdown) {
      blockRef.current?.click();
      blockRef.current?.focus();
    }
  }, [activeBlockIdx]);
  useEffect(() => {
    if (!block.has_value && !isActiveBlock && !isInitialFocusActivated.current) {
      updateActiveBlockIndex(blockIdx);
      isInitialFocusActivated.current = true;
    }
  }, [block, isActiveBlock]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      "span",
      {
        ...isReadOnly || isDisabled ? {} : { contentEditable: true, suppressContentEditableWarning: true },
        spellCheck: false,
        className: classNames82(
          "text-secondary-600 px-1 py-0.5 rounded outline-none caret-transparent cursor-pointer",
          {
            "bg-warning-200": activeBlockIdx == blockIdx,
            "all-small-caps": !block.has_value
          }
        ),
        ref: (el) => {
          setBlockRef(blockIdx, el);
          blockRef.current = el;
        },
        onClick: toggleActiveBlock,
        children: block.value
      }
    ),
    isFocused && isActiveBlock && showDropdown && /* @__PURE__ */ jsx(
      actions_dropdown_default,
      {
        blockRef,
        onSelect: handleValueChange,
        toggleDropdown,
        fetchObjectActions,
        applicationType,
        objectTypeId: step.uiMap.objectTypeId,
        kibbutzTemplate,
        currentSelectedAction: block.more_details.templateId
      }
    )
  ] });
};
var useFocusActivator = (isActiveBlock, blockRef) => {
  useEffect(() => {
    if (document.querySelector('[data-focus-trap="true"]')) return;
    if (document.getElementById("ts-widget")) return;
    isActiveBlock && blockRef.current?.focus();
  }, [blockRef, isActiveBlock]);
};
var AttributeBlock = ({
  block,
  blockIdx
}) => {
  const blockRef = useRef(null);
  const {
    activeBlockIdx,
    isReadOnly,
    isDisabled,
    setBlockRef,
    updateBlockValue,
    updateActiveBlockIndex,
    saveHandler,
    isNoWrapSteps
  } = useContext(BlockContext);
  const [localBlock] = useState(Object.assign({}, block));
  const isActiveBlock = activeBlockIdx == blockIdx;
  const handleInput = useCallback(
    (event) => {
      updateBlockValue(
        Object.assign({}, block, { value: event.target.textContent }),
        blockIdx
      );
    },
    [block, blockIdx, updateBlockValue]
  );
  useFocusActivator(isActiveBlock, blockRef);
  useFormattedPaste(blockRef);
  useHandleEnter(blockRef, null, saveHandler);
  return /* @__PURE__ */ jsx(
    "span",
    {
      ...isReadOnly || isDisabled ? {} : { contentEditable: true, suppressContentEditableWarning: true },
      spellCheck: false,
      className: classNames82(
        "text-warning-700 px-1 py-0.5 rounded outline-none cursor-pointer",
        { "bg-warning-200": activeBlockIdx == blockIdx },
        { "whitespace-nowrap": isNoWrapSteps }
      ),
      ref: (el) => {
        setBlockRef(blockIdx, el);
        blockRef.current = el;
      },
      onInput: handleInput,
      onClick: () => !isActiveBlock && updateActiveBlockIndex(blockIdx),
      children: localBlock.value
    }
  );
};
var stepMsgWeb = [
  "Navigate to https://www.google.com/",
  "Enter admin in the userName field",
  "Enter 12345 in the password field",
  "Click on LoginButton",
  "Verify that the current page displays text Welcome"
];
var stepMsgMobileWeb = [
  "Navigate to https://www.google.com/",
  "Enter admin in the userName field",
  "Enter 12345 in the password field",
  "Tap on LoginButton",
  "Verify that the current page displays text Welcome"
];
var stepMsgMobile = [
  "Launch App",
  "Tap on Login button",
  "Enter userName@gmail.com in the Enter Email field",
  "Enter password123 in the Password field",
  "Tap on next login",
  "Verify that the current page displays text This email address is not registered on WordPress.com"
];
var placeholderMap = {
  "mobile-web": stepMsgMobileWeb,
  web: stepMsgWeb,
  mobile: stepMsgMobile
};
var usePlaceholderText = (block, interval = 3e3) => {
  const [index, setIndex] = useState(0);
  const isAllowed = useMemo(
    () => !!block?.more_details?.placeholder_type && !block?.value?.trim(),
    [block]
  );
  const SampleStepMsg = useMemo(
    () => placeholderMap[block?.more_details?.placeholder_type] || [],
    [block]
  );
  useEffect(() => {
    if (isAllowed) {
      const timerId = setInterval(() => {
        setIndex((index2) => (index2 + 1) % SampleStepMsg.length);
      }, interval);
      return () => clearInterval(timerId);
    }
  }, [interval, block, isAllowed]);
  return isAllowed ? SampleStepMsg[index] : "";
};
var EditableTextBlock = ({
  block,
  blockIdx
}) => {
  const { t } = useTranslation();
  const blockRef = useRef(null);
  const {
    isReadOnly,
    isDisabled,
    setBlockRef,
    updateBlockValue,
    onSearch,
    activeBlockIdx,
    step,
    isResultBlock,
    isNoWrapSteps,
    isFocused,
    updateActiveBlockIndex
  } = useContext(BlockContext);
  const [localBlock, setLocalBlock] = useState(Object.assign({}, block));
  const isActiveBlock = activeBlockIdx == blockIdx;
  const isBlock2 = block?.isBlock || false;
  const placeholderText = usePlaceholderText(block);
  const { isDebugMode } = useContext(StepContext);
  const isBlockStep = useMemo(() => {
    return !block?.more_details?.placeholder_type;
  }, [block]);
  const handleInput = useCallback(
    (event) => {
      onSearch?.(event.target.textContent, step?.isCustomFunction || false);
      updateBlockValue(
        Object.assign({}, block, { value: event.target.textContent }),
        blockIdx
      );
    },
    [block, blockIdx, step]
  );
  const toggleActiveBlock = useCallback(() => {
    if (!isActiveBlock) {
      updateActiveBlockIndex(blockIdx);
    }
  }, [blockIdx, updateActiveBlockIndex, isActiveBlock]);
  useFocusActivator(isActiveBlock, blockRef);
  useFormattedPaste(blockRef);
  const localBlockName = useMemo(() => {
    return localBlock.value.trim();
  }, [localBlock.value]);
  useEffect(() => {
    if (!isActiveBlock) {
      setLocalBlock(Object.assign({}, block));
    }
  }, [isFocused, isActiveBlock, block]);
  const blockText = "text-primary-100 font-semibold";
  const isTruncatedText = !isActiveBlock && isBlockStep;
  const isPlaceholderText = !isBlockStep && !blockRef?.current?.innerText;
  return /* @__PURE__ */ jsx(
    "span",
    {
      ...isReadOnly || isDisabled ? {} : {
        contentEditable: !isBlockStep || isActiveBlock,
        suppressContentEditableWarning: true
      },
      spellCheck: false,
      className: classNames82(
        "text-secondary-800 px-1 py-0.5 rounded outline-none cursor-pointer flex",
        {
          "max-w-[350px] min-w-full": !isActiveBlock && !isResultBlock,
          "whitespace-nowrap": isNoWrapSteps,
          "nlp-placeholder-input": isPlaceholderText,
          "animate-none": isDebugMode,
          "whitespace-normal break-all !max-h-[100px] overflow-y-auto": isBlockStep,
          [blockText]: !isTruncatedText && !isPlaceholderText && isDebugMode && isBlock2
        }
      ),
      onInput: handleInput,
      onClick: toggleActiveBlock,
      ref: (el) => {
        setBlockRef(blockIdx, el);
        blockRef.current = el;
      },
      "data-placeholder-text": isDebugMode ? t("live-editor.nlp.step.placeholder") : placeholderText,
      children: isTruncatedText ? /* @__PURE__ */ jsx(
        TruncatedText,
        {
          value: localBlockName,
          tooltipClassName: "w-[400px]",
          className: classNames82("!text-secondary-800 inline-block", {
            [blockText]: isDebugMode && isBlock2 && !isPlaceholderText
          })
        }
      ) : localBlockName
    }
  );
};
var useElementRename = ({
  blockRef,
  elementName: elementName2,
  elementMeta,
  onUpdateElement,
  onError
}) => {
  const [isRenaming, setIsRenaming] = useState(false);
  const [originalName, setOriginalName] = useState("");
  const { isRecorderView, isDebugMode } = useContext(StepContext);
  const { step } = useContext(BlockContext);
  const startRename = () => {
    setOriginalName(elementName2);
    setIsRenaming(true);
    setTimeout(() => {
      if (blockRef.current) {
        blockRef.current.focus();
        const range = document.createRange();
        range.selectNodeContents(blockRef.current);
        const selection = window.getSelection();
        selection?.removeAllRanges();
        selection?.addRange(range);
      }
    }, 0);
  };
  const handleInlineRename = async (newName) => {
    if (!newName || newName === originalName) {
      if (blockRef.current) {
        blockRef.current.textContent = originalName;
      }
      return;
    }
    try {
      const currentElement = await UiIdentifierApi.get(elementMeta?.id);
      if (!currentElement) throw new Error("Element not found");
      const response = await UiIdentifierApi.update({
        ...currentElement,
        name: newName
      });
      if (response.error) throw new Error(response.error);
      onUpdateElement(newName);
      setTimeout(() => {
        window.dispatchEvent(
          new CustomEvent("trigger-auto-save", {
            detail: {
              stepId: step?.id,
              // Use the actual step ID from context
              blockUuid: null,
              skipDialog: true
              // Skip the Update/Cancel dialog
            }
          })
        );
        toastify(`Element renamed to "${newName}"`, {
          type: "success",
          position: "top-center",
          autoClose: 3e3,
          hideProgressBar: true
        });
      }, 100);
      if (isRecorderView || isDebugMode) {
        window.parent.postMessage(
          {
            type: "ELEMENT_RENAMED",
            payload: {
              elementId: elementMeta?.id,
              oldName: originalName,
              newName,
              elementOverride: {
                referenceKey: "ELEMENT_NAME",
                id: elementMeta?.id,
                name: newName,
                objectTypeId: elementMeta?.objectTypeId
              }
            }
          },
          "*"
        );
      }
    } catch (error) {
      toastify(error.message || "Rename failed", { type: "error" });
      if (blockRef.current) {
        blockRef.current.textContent = originalName;
      }
      if (onError) {
        onError(originalName);
      }
    }
  };
  const handleRenameKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      blockRef.current?.blur();
    } else if (event.key === "Escape") {
      event.preventDefault();
      if (blockRef.current) {
        blockRef.current.textContent = originalName;
      }
      setIsRenaming(false);
    }
  };
  const handleRenameBlur = () => {
    const newName = blockRef.current?.textContent?.trim() || "";
    setIsRenaming(false);
    handleInlineRename(newName);
  };
  return {
    isRenaming,
    startRename,
    handleRenameKeyDown,
    handleRenameBlur
  };
};
var options = [
  {
    name: "element_drop_down.rename",
    icon: "edit-pencil",
    canShow: "edit",
    type: "RENAME_ELEMENT" /* RENAME_ELEMENT */
  },
  {
    name: "capture_element",
    icon: "ai-capture",
    canShow: "create edit",
    type: "CAPTURE_ELEMENT" /* CAPTURE_ELEMENT */
  },
  {
    name: "element_drop_down.select",
    icon: "select-check-box",
    canShow: "create",
    type: "OPEN_ELEMENT_LIST" /* ELEMENT_LIST */
  },
  {
    name: "element_drop_down.change",
    icon: "swap-horiz",
    canShow: "edit",
    type: "OPEN_ELEMENT_LIST" /* ELEMENT_LIST */
  },
  {
    name: "element_drop_down.create",
    icon: "category",
    canShow: "create edit",
    type: "OPEN_ELEMENT_FORM" /* ELEMENT_FORM */
  },
  {
    name: "element_drop_down.edit",
    icon: "edit-square",
    canShow: "edit",
    type: "OPEN_ELEMENT_FORM" /* ELEMENT_FORM */
  }
];
var desktopUftoptions = [
  {
    name: "element_drop_down.select",
    icon: "select-check-box",
    canShow: "create",
    type: "OPEN_ELEMENT_LIST" /* ELEMENT_LIST */
  },
  {
    name: "element_drop_down.change",
    icon: "swap-horiz",
    canShow: "edit",
    type: "OPEN_ELEMENT_LIST" /* ELEMENT_LIST */
  }
];
var salesforceOptions = [
  {
    name: "element_drop_down.rename",
    icon: "edit-pencil",
    canShow: "edit",
    type: "RENAME_ELEMENT" /* RENAME_ELEMENT */
  },
  {
    name: "capture_element",
    icon: "ai-capture",
    canShow: "create edit",
    type: "CAPTURE_ELEMENT" /* CAPTURE_ELEMENT */
  },
  {
    name: "element_drop_down.select",
    icon: "select-check-box",
    canShow: "create",
    type: "OPEN_ELEMENT_LIST" /* ELEMENT_LIST */
  },
  {
    name: "element_drop_down.change",
    icon: "swap-horiz",
    canShow: "edit",
    type: "OPEN_ELEMENT_LIST" /* ELEMENT_LIST */
  },
  {
    name: "element_drop_down.create",
    icon: "category",
    canShow: "create edit",
    type: "OPEN_ELEMENT_FORM" /* ELEMENT_FORM */
  },
  {
    name: "element_drop_down.edit",
    icon: "edit-square",
    canShow: "edit",
    type: "OPEN_ELEMENT_FORM" /* ELEMENT_FORM */
  }
];
var ListItem2 = ({ onClick, name, icon }) => {
  return /* @__PURE__ */ jsxs(
    DropdownItem,
    {
      onClick,
      className: "flex items-center !text-unique-600",
      children: [
        icon && /* @__PURE__ */ jsx(Icon, { name: icon, className: "mr-2 text-base !text-unique-800" }),
        name
      ]
    }
  );
};
var ElementDropDown = ({
  selectedType,
  onSelect,
  toggleDropdown,
  blockRef,
  isEdit,
  isPrelearntElement = false
}) => {
  const { t } = useTranslation();
  const [currentSelection, updateCurrentSelection] = useState(
    () => options.findIndex((item) => item.type == selectedType)
  );
  const [dropdownRef, setDropdownRef] = useState(null);
  const { styles, attributes } = usePopper(blockRef.current, dropdownRef, {
    placement: "bottom-start",
    strategy: "fixed"
  });
  const { applicationType, isRecorderView } = useContext(StepContext);
  const { isAiAtomsWidget, isDebugger } = useRecorderContext();
  const baseFilteredOptions = applicationType == ApplicationType.Salesforce?.toString() ? salesforceOptions.filter(
    (item) => isEdit ? item.canShow.includes("edit") : item.canShow.includes("create")
  ) : (isObjectBased(applicationType) ? desktopUftoptions : options).filter(
    (item) => isEdit ? item.canShow.includes("edit") : item.canShow.includes("create")
  );
  const filteredOptions = baseFilteredOptions.filter((item) => {
    if (item.type === "CAPTURE_ELEMENT" /* CAPTURE_ELEMENT */) {
      if (isPrelearntElement) {
        return false;
      }
      return isAiAtomsWidget || isDebugger || isRecorderView;
    }
    return true;
  });
  const handleKeyMovemenets = useCallback(
    (event) => {
      if (event.code == "ArrowUp") {
        event.preventDefault();
        updateCurrentSelection(
          boundedIncrementDecrement(
            currentSelection,
            0,
            filteredOptions.length - 1,
            -1
          )
        );
      } else if (event.code == "ArrowDown") {
        event.preventDefault();
        updateCurrentSelection(
          boundedIncrementDecrement(
            currentSelection,
            0,
            filteredOptions.length - 1,
            1
          )
        );
      } else if (event.code == "Escape") {
        event.preventDefault();
        toggleDropdown(false);
      } else if (event.code == "Enter") {
        event.preventDefault();
        onSelect(
          filteredOptions[currentSelection]?.type,
          filteredOptions[currentSelection]?.type
        );
      }
    },
    [currentSelection, filteredOptions]
  );
  useEffect(() => {
    blockRef.current?.addEventListener("keydown", handleKeyMovemenets);
    return () => blockRef.current?.removeEventListener("keydown", handleKeyMovemenets);
  }, [blockRef, handleKeyMovemenets]);
  return /* @__PURE__ */ jsx(
    Dropdown,
    {
      className: "w-[160px] min-w-[90px] z-[1000]",
      toggleDropdown,
      setRef: setDropdownRef,
      style: styles.popper,
      attributes: attributes.popper,
      children: filteredOptions.map((item) => /* @__PURE__ */ jsx(
        ListItem2,
        {
          onClick: () => {
            onSelect(item.type, item.canShow);
            if (item.type === "CAPTURE_ELEMENT" /* CAPTURE_ELEMENT */) {
              toggleDropdown(false);
            }
          },
          name: t(item.name),
          icon: item?.icon
        },
        item.name
      ))
    },
    "drop-down"
  );
};
var ElementBlock = ({
  block,
  blockIdx,
  isEdit
}) => {
  const blockRef = useRef(null);
  const { t } = useTranslation();
  const {
    isDisabled,
    isResultBlock,
    isReadOnly,
    activeBlockIdx,
    setBlockRef,
    isFocused,
    updateActiveBlockIndex,
    updateBlockValue,
    isActiveIndexUpdateDisabled,
    step,
    blocks
  } = useContext(BlockContext);
  const {
    openElementListDrawer,
    openElementFormDrawer,
    applicationType,
    testCase,
    isDebugMode
  } = useContext(StepContext);
  const hasUnfilledSelectable = blocks?.some(
    (b) => b.type === "selectable" && !b.more_details?.allowedValues?.includes(b.value)
  );
  const [captureMode, setCaptureMode] = useState(
    "normal"
  );
  const toggleDropdown = useCallback(
    (state) => {
      if (!isActiveIndexUpdateDisabled)
        updateActiveBlockIndex(state ? blockIdx : null);
    },
    [blockIdx, updateActiveBlockIndex, isActiveIndexUpdateDisabled]
  );
  const isActiveBlock = activeBlockIdx == blockIdx;
  const handleValueChange = useElemntValueChange(
    block,
    blockIdx,
    updateBlockValue,
    openElementListDrawer,
    openElementFormDrawer
  );
  const currentElement = step?.testStepElements?.find(
    (el) => el?.name === block.value || el?.element?.name === block.value
  );
  const elementMeta = {
    id: currentElement?.elementId || currentElement?.element?.id,
    objectTypeId: currentElement?.objectTypeId || currentElement?.element?.objectTypeId
  };
  const { isRenaming, startRename, handleRenameKeyDown, handleRenameBlur } = useElementRename({
    blockRef,
    elementName: block.value,
    elementMeta,
    onUpdateElement: (newName) => {
      updateBlockValue(
        {
          ...block,
          value: newName,
          more_details: {
            ...block.more_details,
            elementOverride: {
              referenceKey: block.uuid,
              id: elementMeta?.id,
              name: newName,
              objectTypeId: elementMeta?.objectTypeId
            }
          }
        },
        blockIdx
      );
    },
    onError: (originalName) => {
      updateBlockValue({ ...block, value: originalName }, blockIdx);
    }
  });
  const elementIsEdit = isEdit ? block?.value === "element" ? false : !(block?.more_details?.parameterType === KibbutzParameterType.ELEMENT && block?.uuid === block?.value) : isEdit;
  const handlePreventInput = useCallback(
    (event) => {
      if (!isRenaming) {
        event.preventDefault();
      }
    },
    [isRenaming]
  );
  useEffect(() => {
    if (!blockRef.current) return;
    blockRef.current.addEventListener("keydown", handlePreventInput);
    return () => {
      if (blockRef.current) {
        blockRef.current.removeEventListener("keydown", handlePreventInput);
      }
    };
  }, [blockRef, handlePreventInput]);
  useFormattedPaste(blockRef);
  useEffect(() => {
    if (!isRenaming && blockRef.current && blockRef.current.textContent !== block.value) {
      blockRef.current.textContent = block.value;
    }
  }, [block.value, isRenaming, block.uuid]);
  const isWindowsAdvanced = isObjectBased(step);
  const hasWindowsAIElement = () => {
    return !!step?.testStepElements?.some(
      (el) => el?.element?.definition == "AI_WINDOWS_ELEMENT"
    );
  };
  const errorMessage = () => {
    if (isWindowsAdvanced && hasWindowsAIElement()) {
      return t("element.windowsAI.notSupported");
    }
    return step?.dataMapError?.[block?.uuid] && (isWindowsAdvanced ? t("element.uft.deleted") : step?.dataMapError?.[block?.uuid]);
  };
  const handleElementClick = useCallback(() => {
    if (!isActiveBlock && !block.more_details.isReadOnly) {
      updateActiveBlockIndex(blockIdx);
      if (isDebugMode) {
        logEvent(
          analytics_constants_default.AMPLITUDE.LIVE_EDITOR_STEP_ELEMENT_DROPDOWN_ANCHOR_CLICK,
          { applicationType }
        );
      }
    }
  }, [
    isActiveBlock,
    block.more_details.isReadOnly,
    updateActiveBlockIndex,
    blockIdx,
    isDebugMode,
    applicationType
  ]);
  useEffect(() => {
    const handleCaptureStart = (event) => {
      const { stepId, blockUuid } = event.detail;
      if (!step || !block) return;
      if (stepId === step.id && blockUuid === block.uuid) {
        setCaptureMode("capturing");
      } else {
        setCaptureMode("normal");
      }
    };
    const handleCaptureEnd = (event) => {
      const { stepId, blockUuid } = event.detail;
      if (!step || !block) return;
      setCaptureMode("normal");
    };
    window.addEventListener("element-capture-start", handleCaptureStart);
    window.addEventListener("element-capture-end", handleCaptureEnd);
    return () => {
      window.removeEventListener("element-capture-start", handleCaptureStart);
      window.removeEventListener("element-capture-end", handleCaptureEnd);
    };
  }, [step, block]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      ToolTip,
      {
        content: hasUnfilledSelectable ? t("element.select_condition_tooltip") : "",
        placement: "top",
        children: /* @__PURE__ */ jsx(
          "span",
          {
            ...isReadOnly || isDisabled || block.more_details.isReadOnly ? {} : {
              contentEditable: isRenaming,
              suppressContentEditableWarning: true
            },
            spellCheck: false,
            className: classNames82(
              "flex py-0.5 px-1 rounded outline-none truncate max-w-[240px] transition-all duration-200",
              isResultBlock ? "!text-[#1F845A]" /* ELEMENT_BLOCK */ : "text-primary-700",
              {
                "underline decoration-wavy decoration-[#E97C74]": !isActiveBlock && errorMessage(),
                "bg-warning-200": isActiveBlock,
                "element-capture-waiting": captureMode === "capturing",
                "cursor-pointer": !hasUnfilledSelectable,
                "cursor-not-allowed opacity-50": hasUnfilledSelectable
              }
            ),
            ref: (el) => {
              setBlockRef(blockIdx, el);
              blockRef.current = el;
            },
            onClick: isRenaming || hasUnfilledSelectable ? void 0 : handleElementClick,
            onKeyDown: isRenaming ? handleRenameKeyDown : void 0,
            onBlur: isRenaming ? handleRenameBlur : void 0,
            children: /* @__PURE__ */ jsx(
              ErrorToolTip,
              {
                content: !isActiveBlock && errorMessage(),
                className: "flex max-w-[240px]",
                children: block?.value?.length > 30 ? /* @__PURE__ */ jsx(
                  TruncatedText,
                  {
                    className: classNames82("inline-block", "!text-primary-700 ", {
                      "underline decoration-wavy decoration-[#E97C74] underline-offset-1": !isActiveBlock && errorMessage()
                    }),
                    value: block.value
                  }
                ) : block?.value
              }
            )
          }
        )
      }
    ),
    isFocused && isActiveBlock && !isRenaming && /* @__PURE__ */ jsx(
      ElementDropDown,
      {
        blockRef,
        selectedType: "OPEN_ELEMENT_FORM" /* ELEMENT_FORM */,
        onSelect: (type, isEdit2) => {
          if (type === "RENAME_ELEMENT" /* RENAME_ELEMENT */) {
            startRename();
          } else {
            handleValueChange(type, isEdit2);
          }
        },
        toggleDropdown,
        isEdit: elementIsEdit,
        isPrelearntElement: currentElement?.element?.definition === "SALESFORCE_FIELD" || false
      }
    )
  ] });
};
var TestDataSymbol = ({ type }) => {
  const symbol = getTestDataSymbol(type);
  const tooltip = getTestDataSymbolTooltip(type);
  const { isNestedStepGroupStep } = useContext(BlockContext);
  return symbol && /* @__PURE__ */ jsx(ToolTip, { content: isNestedStepGroupStep ? "" : tooltip, children: /* @__PURE__ */ jsx("span", { className: "bg-neutral-100 rounded w-5 h-5 mx-1 inline-flex item-center justify-center flex-shrink-0 text-secondary-700", children: symbol }) });
};
var options2 = [
  { name: "datatype.name.plain-text", type: "raw" /* raw */ },
  { name: "datatype.name.parameter", type: "parameter" /* parameter */ },
  { name: "datatype.name.runtime", type: "runtime" /* runtime */ },
  { name: "datatype.name.environment", type: "global" /* global */ },
  { name: "datatype.name.random", type: "random" /* random */ },
  { name: "datatype.name.data-generator", type: "function" /* function */ },
  { name: "datatype.name.phone-number", type: "phone_number" /* phone_number */ },
  { name: "datatype.name.mail-box", type: "mail_box" /* mail_box */ },
  { name: "datatype.name.upload_path", type: "upload_path" /* upload_path */ }
];
var ListItem3 = ({
  block,
  onClick,
  type,
  name,
  selectedType,
  currentSelection,
  onEncryptChange
}) => {
  const { t } = useTranslation();
  const [isEncrypt, setIsEncrypt] = useState(false);
  const [iconClicked, setIconClicked] = useState(false);
  const isSelected = type == selectedType;
  const isPlainText = type == "raw" /* raw */;
  const { isWebRecorder } = useContext(StepContext);
  const handleLockClick = (event) => {
    event.stopPropagation();
    setIsEncrypt((prevIsEncrypt) => {
      const newIsEncrypt = !prevIsEncrypt;
      onEncryptChange(newIsEncrypt);
      return newIsEncrypt;
    });
  };
  const canShowLockIcon = () => {
    const blockItem = block?.more_details?.data?.find(
      (item) => item.displayName === block.uuid
    );
    return blockItem ? blockItem.canEncrypt : false;
  };
  return /* @__PURE__ */ jsxs(
    DropdownItem,
    {
      onClick,
      className: classNames82("flex items-center", {
        "!text-2xs": isWebRecorder,
        "text-primary-500": isSelected,
        "bg-secondary-100": currentSelection
      }),
      children: [
        /* @__PURE__ */ jsx(TestDataSymbol, { type }),
        " ",
        /* @__PURE__ */ jsxs("span", { className: classNames82({ "ml-1": isPlainText }), children: [
          name,
          " "
        ] }),
        isSelected && /* @__PURE__ */ jsx(Icon, { name: "check-circle", className: "ml-2 text-base" }),
        isPlainText && canShowLockIcon() === "true" && /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
          ToolTip,
          {
            className: "ml-auto",
            content: isEncrypt || block.isEncrypted ? t("testdata.plaintext.after.encryption") : t("testdata.plaintext.before.encryption"),
            placement: "top",
            children: /* @__PURE__ */ jsx(
              Icon,
              {
                name: isEncrypt || block.isEncrypted ? "lock" : "decrypt",
                className: classNames82(
                  "leading-4.5 shrink-0 cursor-pointer text-lg hover:bg-secondary-100 rounded",
                  { "text-warning-600": !(isEncrypt || block.isEncrypted) },
                  {
                    "opacity-50": isEncrypt || block.isEncrypted,
                    "pointer-events-none": isEncrypt || block.isEncrypted
                  }
                ),
                onClick: (event) => {
                  if (!iconClicked) {
                    onClick(event);
                    handleLockClick(event);
                    setIconClicked(true);
                  }
                }
              }
            )
          }
        ) })
      ]
    }
  );
};
var TestDataDropdown = ({
  block,
  selectedType,
  onSelect,
  toggleDropdown,
  blockRef,
  allowedTypes,
  onEncryptChange
}) => {
  const { t } = useTranslation();
  const [currentSelection, updateCurrentSelection] = useState(
    () => options2.findIndex((item) => item.type == selectedType)
  );
  const [dropdownRef, setDropdownRef] = useState(null);
  const { styles, attributes } = usePopper(blockRef.current, dropdownRef, {
    placement: "bottom-start",
    strategy: "fixed"
  });
  const filteredOptions = options2.filter(
    (item) => allowedTypes?.includes(item.type)
  );
  const handleKeyMovements = useCallback(
    (event) => {
      if (event.code == "ArrowUp") {
        event.preventDefault();
        updateCurrentSelection(
          boundedIncrementDecrement(
            currentSelection,
            0,
            filteredOptions.length - 1,
            -1
          )
        );
      } else if (event.code == "ArrowDown") {
        event.preventDefault();
        updateCurrentSelection(
          boundedIncrementDecrement(
            currentSelection,
            0,
            filteredOptions.length - 1,
            1
          )
        );
      } else if (event.code == "Escape") {
        event.preventDefault();
        toggleDropdown(false);
      } else if (event.code == "Enter") {
        event.preventDefault();
        if (!(filteredOptions[currentSelection]?.type == selectedType && selectedType?.type == "random" /* random */))
          onSelect(filteredOptions[currentSelection]?.type);
      }
    },
    [currentSelection, filteredOptions]
  );
  useEffect(() => {
    blockRef.current?.addEventListener("keydown", handleKeyMovements);
    return () => blockRef.current?.removeEventListener("keydown", handleKeyMovements);
  }, [blockRef, handleKeyMovements]);
  return /* @__PURE__ */ jsx(
    Dropdown,
    {
      className: "w-[180px] min-w-[90px] z-[1000]",
      toggleDropdown,
      setRef: setDropdownRef,
      style: styles.popper,
      attributes: attributes.popper,
      buttonRef: blockRef,
      children: filteredOptions.map((item, idx) => /* @__PURE__ */ jsx(
        ListItem3,
        {
          block,
          onClick: () => {
            if (!(selectedType == item?.type && item?.type == "random" /* random */))
              onSelect(item.type);
          },
          type: item.type,
          name: t(item.name),
          selectedType,
          currentSelection: currentSelection == idx,
          onEncryptChange
        },
        item.type
      ))
    },
    "drop-down"
  );
};
var RandomBlock = ({ block, blockIdx }) => {
  const blockRef = useRef(null);
  const {
    isDisabled,
    isResultBlock,
    isReadOnly,
    activeBlockIdx,
    setBlockRef,
    isFocused,
    updateActiveBlockIndex,
    getTestData: getTestData2,
    updateBlockValue,
    disableAllowActiveIndexUpdate,
    isActiveIndexUpdateDisabled,
    saveHandler,
    isStepResult,
    step
  } = useContext(BlockContext);
  const [localBlock, updateLocalBlock] = useState(Object.assign({}, block));
  const { isViewOnlySingle } = useContext(StepContext);
  const [showTestDataDropdown, toggleShowTestDataDropdown] = useState(true);
  const [isTestDataModified, setIsTestDataModified] = useState(false);
  const isActiveBlock = activeBlockIdx == blockIdx;
  const toggleDropdown = useCallback(
    (state) => {
      if (!isActiveIndexUpdateDisabled)
        updateActiveBlockIndex(state ? blockIdx : null);
    },
    [blockIdx, updateActiveBlockIndex, isActiveIndexUpdateDisabled]
  );
  const handleDataTypeChange = useTestDataValueChange(
    block,
    getTestData2,
    updateBlockValue,
    blockIdx,
    disableAllowActiveIndexUpdate
  );
  const handleInput = useCallback(
    (event) => {
      block.isEncrypted = false;
      updateBlockValue(
        Object.assign({}, block, { value: event.target.textContent }),
        blockIdx
      );
      toggleShowTestDataDropdown(false);
      setIsTestDataModified(true);
    },
    [block, blockIdx, updateBlockValue]
  );
  const handleTestDataDisplay = () => {
    block.isEncrypted = false;
    updateBlockValue(
      Object.assign({}, block, { value: "test-data" }),
      blockIdx
    );
    toggleShowTestDataDropdown(false);
    setIsTestDataModified(true);
  };
  const getContent = () => {
    if (localBlock.isEncrypted) {
      handleTestDataDisplay();
      return "test-data";
    } else {
      return localBlock.has_value ? localBlock.value : "";
    }
  };
  const debouncedOnChange = useCallback(
    debounce$2((event) => {
      handleInput(event);
    }, 500),
    []
  );
  const toggleActiveBlock = useCallback(() => {
    if (!isActiveBlock) {
      updateActiveBlockIndex(blockIdx);
    }
    toggleShowTestDataDropdown(true);
  }, [activeBlockIdx]);
  useFocusActivator(isActiveBlock, blockRef);
  useHandleEnter(blockRef, showTestDataDropdown, saveHandler);
  useFormattedPaste(blockRef);
  useEffect(() => {
    if (isTestDataModified && step?.isStepGroupChild) {
      handleDataTypeChange(block.type, null, true);
      setIsTestDataModified(false);
    }
  }, [isTestDataModified]);
  useEffect(() => {
    if (document.querySelector('[data-focus-trap="true"]')) return;
    if (blockRef.current && isActiveBlock) {
      window.getSelection().selectAllChildren(blockRef.current);
    }
  }, [blockRef, isActiveBlock]);
  const content = getContent();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("span", { className: "flex items-center justify-center cursor-pointer", children: [
      /* @__PURE__ */ jsx(TestDataSymbol, { type: block.type }),
      /* @__PURE__ */ jsx(
        "span",
        {
          ...isReadOnly || isDisabled ? {} : { contentEditable: true, suppressContentEditableWarning: true },
          spellCheck: false,
          className: classNames82(
            "pr-1 py-0.5 rounded outline-none",
            {
              "bg-warning-200": isActiveBlock,
              "whitespace-normal": !isViewOnlySingle
            },
            isResultBlock ? "!text-[#0055CC]" /* RANDOM_BLOCK */ : "text-unique-500"
          ),
          ref: (el) => {
            setBlockRef(blockIdx, el);
            blockRef.current = el;
          },
          onKeyDown: (e) => {
            if (isNaN(parseInt(e.key)) && e.key.length === 1) {
              e.preventDefault();
            }
          },
          onInput: (e) => {
            debouncedOnChange(e);
          },
          onClick: toggleActiveBlock,
          children: content.length > 50 ? /* @__PURE__ */ jsxs(
            ToolTip,
            {
              placement: "auto",
              content,
              className: "inline-flex",
              children: [
                content.slice(0, 50),
                "..."
              ]
            }
          ) : content
        }
      )
    ] }),
    isFocused && isActiveBlock && showTestDataDropdown && /* @__PURE__ */ jsx(
      TestDataDropdown,
      {
        block,
        blockRef,
        selectedType: "random" /* random */,
        onSelect: handleDataTypeChange,
        toggleDropdown,
        allowedTypes: block.more_details?.allowedTypes || []
      }
    )
  ] });
};
var ListItem4 = ({ onClick, name, selectedValue, currentSelection }) => {
  const isSelected = name == selectedValue;
  return /* @__PURE__ */ jsx(
    DropdownItem,
    {
      onClick,
      className: classNames82(
        "flex items-center text-secondary-800 whitespace-normal w-[200px] break-words",
        {
          "!text-primary-500": isSelected,
          "bg-secondary-100": currentSelection
        }
      ),
      children: /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsxs("span", { className: "w-full", children: [
          name,
          " "
        ] }),
        isSelected && /* @__PURE__ */ jsx(Icon, { name: "check-circle", className: "ml-2 text-base" })
      ] })
    }
  );
};
var DataProfileDropDown = ({
  selectedValue,
  onSelect,
  toggleDropdown,
  blockRef,
  allowedValue,
  step
}) => {
  const [currentSelection, updateCurrentSelection] = useState(
    () => allowedValue.findIndex((item) => item == allowedValue)
  );
  const [dropdownRef, setDropdownRef] = useState(null);
  const { styles, attributes } = usePopper(blockRef.current, dropdownRef, {
    placement: "bottom-start",
    strategy: "fixed"
  });
  const [searchQuery, setSearchQuery] = useState("");
  const { t } = useTranslation();
  const inputRef = useRef(null);
  const filteredOptions = allowedValue.filter(
    (item) => item.name.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const handleKeyMovements = useCallback(
    (event) => {
      event.preventDefault();
      if (event.code == "ArrowUp") {
        event.preventDefault();
        updateCurrentSelection(
          boundedIncrementDecrement(
            currentSelection,
            0,
            filteredOptions.length - 1,
            -1
          )
        );
      } else if (event.code == "ArrowDown") {
        event.preventDefault();
        updateCurrentSelection(
          boundedIncrementDecrement(
            currentSelection,
            0,
            filteredOptions.length - 1,
            1
          )
        );
      } else if (event.code == "Escape") {
        event.preventDefault();
        toggleDropdown(false);
      } else if (event.code == "Enter") {
        event.preventDefault();
        onSelect(filteredOptions[currentSelection]);
        toggleDropdown();
      }
    },
    [currentSelection, filteredOptions, onSelect]
  );
  const handleSearchInputChange = (val) => {
    setSearchQuery(val);
    updateCurrentSelection(-1);
  };
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [toggleDropdown]);
  useEffect(() => {
    blockRef.current?.addEventListener("keydown", handleKeyMovements);
    return () => blockRef.current?.removeEventListener("keydown", handleKeyMovements);
  }, [blockRef, handleKeyMovements]);
  return /* @__PURE__ */ jsxs(
    Dropdown,
    {
      className: "min-w-[90px] z-[1000] max-h-80 overflow-y-scroll",
      toggleDropdown,
      setRef: setDropdownRef,
      style: styles.popper,
      attributes: attributes.popper,
      children: [
        /* @__PURE__ */ jsx(
          Input,
          {
            value: searchQuery,
            onChange: handleSearchInputChange,
            placeholder: t("search.tdp"),
            wrapperClassName: "outline-none bg-white p-md w-[200px] sticky top-0",
            ref: inputRef
          }
        ),
        filteredOptions.length ? /* @__PURE__ */ jsx(Fragment, { children: filteredOptions?.map((item, idx) => /* @__PURE__ */ jsx(
          ListItem4,
          {
            onClick: () => step?.isWriteNLPStep ? onSelect(
              "raw" /* raw */,
              step?.enableActiveIndexUpdate,
              step?.isStepGroupChild,
              item
            ) : onSelect(item),
            selectedValue,
            name: item.name,
            currentSelection: currentSelection == idx
          },
          item.id
        )) }) : /* @__PURE__ */ jsx(SearchNotFound, { textElementClass: "whitespace-normal px-2 w-[200px]" })
      ]
    },
    "drop-down"
  );
};
var ListItem5 = ({ onClick, name, selectedValue, currentSelection }) => {
  const isSelected = name == selectedValue;
  return /* @__PURE__ */ jsxs(
    DropdownItem,
    {
      onClick: () => onClick(name),
      className: classNames82("flex items-center text-secondary-800", {
        "!text-primary-500": isSelected,
        "bg-secondary-100": currentSelection
      }),
      children: [
        name,
        " ",
        isSelected && /* @__PURE__ */ jsx(Icon, { name: "check-circle", className: "ml-2 text-base" })
      ]
    }
  );
};
var DataParameterDropDown = ({
  selectedValue,
  onSelect,
  toggleDropdown,
  blockRef,
  allowedValue,
  step
}) => {
  const [currentSelection, updateCurrentSelection] = useState(
    () => allowedValue?.findIndex((item) => item == allowedValue)
  );
  const [dropdownRef, setDropdownRef] = useState(null);
  const { styles, attributes } = usePopper(blockRef.current, dropdownRef, {
    placement: "bottom-start",
    strategy: "fixed"
  });
  const [searchQuery, setSearchQuery] = useState("");
  const { t } = useTranslation();
  const inputRef = useRef(null);
  const filteredOptions = allowedValue.filter(
    (item) => item.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const handleKeyMovements = useCallback(
    (event) => {
      event.preventDefault();
      if (event.code == "ArrowUp") {
        updateCurrentSelection(
          boundedIncrementDecrement(
            currentSelection,
            0,
            filteredOptions.length - 1,
            -1
          )
        );
      } else if (event.code == "ArrowDown") {
        updateCurrentSelection(
          boundedIncrementDecrement(
            currentSelection,
            0,
            filteredOptions.length - 1,
            1
          )
        );
      } else if (event.code == "Escape") {
        toggleDropdown(false);
      } else if (event.code == "Enter") {
        onSelect(filteredOptions[currentSelection]);
        toggleDropdown();
      }
    },
    [currentSelection, filteredOptions, onSelect]
  );
  const handleSearchInputChange = (val) => {
    setSearchQuery(val);
    updateCurrentSelection(-1);
  };
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [toggleDropdown]);
  useEffect(() => {
    blockRef.current?.addEventListener("keydown", handleKeyMovements);
    return () => blockRef.current?.removeEventListener("keydown", handleKeyMovements);
  }, [blockRef, handleKeyMovements]);
  return /* @__PURE__ */ jsxs(
    Dropdown,
    {
      className: "min-w-[90px] z-[1000] max-h-80 overflow-y-scroll",
      toggleDropdown,
      setRef: setDropdownRef,
      style: styles.popper,
      attributes: attributes.popper,
      children: [
        /* @__PURE__ */ jsx(
          Input,
          {
            value: searchQuery,
            onChange: handleSearchInputChange,
            placeholder: t("search.parameter"),
            wrapperClassName: "outline-none bg-white p-md w-[200px]",
            ref: inputRef
          }
        ),
        filteredOptions.length ? /* @__PURE__ */ jsx(Fragment, { children: filteredOptions?.map((item, idx) => /* @__PURE__ */ jsx(
          ListItem5,
          {
            onClick: () => {
              step?.isWriteNLPStep ? onSelect(
                "raw" /* raw */,
                step?.enableActiveIndexUpdate,
                step?.isStepGroupChild,
                item
              ) : onSelect(item);
              toggleDropdown(false);
            },
            selectedValue,
            name: item,
            currentSelection: currentSelection == idx
          },
          `${item}_${idx}`
        )) }) : /* @__PURE__ */ jsx(SearchNotFound, { textElementClass: "whitespace-normal px-2 w-[200px]" })
      ]
    },
    "drop-down"
  );
};
var ListItem6 = ({ onClick, name, selectedValue, currentSelection }) => {
  const isSelected = name == selectedValue;
  return /* @__PURE__ */ jsx(
    DropdownItem,
    {
      onClick: () => onClick(name),
      className: classNames82(
        "flex items-center text-secondary-800 whitespace-normal w-[200px] break-words",
        {
          "!text-primary-500": isSelected,
          "bg-secondary-100": currentSelection
        }
      ),
      children: /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsxs("span", { className: "w-full", children: [
          name,
          " "
        ] }),
        isSelected && /* @__PURE__ */ jsx(Icon, { name: "check-circle", className: "ml-2 text-base" })
      ] })
    }
  );
};
var DataSetDropDown = ({
  selectedValue,
  onSelect,
  toggleDropdown,
  blockRef,
  allowedValue,
  setNameType,
  isLoading = false
}) => {
  const [currentSelection, updateCurrentSelection] = useState(-1);
  const [dropdownRef, setDropdownRef] = useState(null);
  const { styles, attributes } = usePopper(blockRef.current, dropdownRef, {
    placement: "bottom-start",
    strategy: "fixed"
  });
  const [searchQuery, setSearchQuery] = useState("");
  const { t } = useTranslation();
  const inputRef = useRef(null);
  const filteredOptions = allowedValue.filter(
    (item) => item.name.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const handleKeyMovements = useCallback(
    (event) => {
      event.preventDefault();
      if (event.code == "ArrowUp") {
        updateCurrentSelection(
          boundedIncrementDecrement(
            currentSelection,
            0,
            filteredOptions?.length - 1,
            -1
          )
        );
      } else if (event.code == "ArrowDown") {
        updateCurrentSelection(
          boundedIncrementDecrement(
            currentSelection,
            0,
            filteredOptions?.length - 1,
            1
          )
        );
      } else if (event.code == "Escape") {
        toggleDropdown(false);
      } else if (event.code == "Enter") {
        onSelect(filteredOptions[currentSelection]);
        toggleDropdown();
      }
    },
    [currentSelection, filteredOptions, onSelect]
  );
  const handleSearchInputChange = (val) => {
    setSearchQuery(val);
    updateCurrentSelection(-1);
  };
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [toggleDropdown]);
  useEffect(() => {
    blockRef.current?.addEventListener("keydown", handleKeyMovements);
    return () => blockRef.current?.removeEventListener("keydown", handleKeyMovements);
  }, [blockRef, handleKeyMovements]);
  useEffect(() => {
    updateCurrentSelection(-1);
    setSearchQuery("");
  }, [allowedValue]);
  return /* @__PURE__ */ jsxs(
    Dropdown,
    {
      className: "min-w-[90px] z-[1000] max-h-80 overflow-y-scroll",
      toggleDropdown,
      setRef: setDropdownRef,
      style: styles.popper,
      attributes: attributes.popper,
      children: [
        /* @__PURE__ */ jsx(
          Input,
          {
            value: searchQuery,
            onChange: handleSearchInputChange,
            placeholder: t("search.set"),
            wrapperClassName: "outline-none w-[200px] bg-white p-md sticky top-0",
            ref: inputRef
          }
        ),
        isLoading ? /* @__PURE__ */ jsx("div", { className: "flex flex-col justify-center items-center h-10", children: /* @__PURE__ */ jsx("span", { className: "w-8", children: /* @__PURE__ */ jsx(
          Spinner,
          {
            size: 6,
            thickness: 80,
            speed: 140,
            color: "#03A973",
            secondaryColor: "rgba(172, 57, 57, 0)"
          }
        ) }) }) : filteredOptions?.length > 0 ? filteredOptions?.map((item, idx) => /* @__PURE__ */ jsx(
          ListItem6,
          {
            onClick: () => onSelect(item),
            selectedValue,
            name: item.name,
            currentSelection: currentSelection == idx
          },
          item.type
        )) : /* @__PURE__ */ jsx(SearchNotFound, { textElementClass: "whitespace-normal px-2 w-[200px]" })
      ]
    },
    "drop-down"
  );
};
var AppNameDropdown = ({
  blockRef,
  onSelect,
  toggleDropdown,
  uploadActions,
  applicationType,
  isFirstTime
}) => {
  const [dropdownRef, setDropdownRef] = useState(null);
  const [uploadedApps, setUploadedApps] = useState([]);
  const [searchTerm, setSearchTerm] = useState(null);
  const [loading, setLoading] = useState(false);
  const { styles, attributes } = usePopper(blockRef.current, dropdownRef, {
    placement: "bottom-start",
    strategy: "fixed"
  });
  const { t } = useTranslation();
  const debouncedTerm = useDebounce(searchTerm, 500);
  const fetchUploads = (selectFirstValue = false) => {
    uploadActions.fetchUploads(
      `uploadType:${applicationType === ApplicationType.AndroidNative ? "APK" : ""},${debouncedTerm ? `name:*${debouncedTerm}*` : ""}`
    ).then((res) => {
      setUploadedApps(res?.content || []);
      if (selectFirstValue && res?.content?.length > 0) {
        onSelect(res?.content[0], false);
      }
    }).catch((err) => {
      throw new Error(err);
    }).finally(() => setLoading(false));
  };
  useEffect(() => {
    setLoading(true);
    fetchUploads(isFirstTime);
  }, []);
  useEffect(() => {
    setLoading(true);
    fetchUploads();
  }, [debouncedTerm]);
  return /* @__PURE__ */ jsxs(
    Dropdown,
    {
      className: "w-[200px] min-w-[100px] z-[1000] max-h-80 overflow-scroll",
      toggleDropdown,
      setRef: setDropdownRef,
      style: styles.popper,
      attributes: attributes.popper,
      children: [
        /* @__PURE__ */ jsx(
          Input,
          {
            value: searchTerm,
            onChange: setSearchTerm,
            placeholder: t("search"),
            suffix: /* @__PURE__ */ jsx(Icon, { name: "search", className: "text-secondary-500 text-base pr-2" }),
            wrapperClassName: "w-full border-b border-b-secondary-200",
            className: "!bg-white"
          }
        ),
        loading && /* @__PURE__ */ jsx("div", { className: "empty-page-loader left-1/2 top-1/2 absolute my-10" }),
        !loading && uploadedApps?.map((item, idx) => /* @__PURE__ */ jsx(
          DropdownItem,
          {
            onClick: () => {
              onSelect(item);
              toggleDropdown(false);
            },
            className: "w-[200px] truncate max-w-[200px]",
            children: /* @__PURE__ */ jsx(
              TruncatedText,
              {
                value: item.name,
                className: "text-small text-unique-600"
              }
            )
          },
          `${item}_${idx}`
        )),
        !loading && uploadedApps?.length == 0 && /* @__PURE__ */ jsx(DropdownItem, { className: "flex items-center", children: /* @__PURE__ */ jsx("span", { className: "text-small text-secondary-500", children: t("step.no_match_found") }) })
      ]
    },
    "drop-down"
  );
};
var app_name_default = AppNameDropdown;
var AppVersionsDropdown = ({
  blockRef,
  onSelect,
  toggleDropdown,
  uploadActions,
  isFirstTime
}) => {
  const [dropdownRef, setDropdownRef] = useState(null);
  const [uploadedVersion, setUploadedVersions] = useState([]);
  const [searchTerm, setSearchTerm] = useState(null);
  const [loading, setLoading] = useState(false);
  const { styles, attributes } = usePopper(blockRef.current, dropdownRef, {
    placement: "bottom-start",
    strategy: "fixed"
  });
  const { t } = useTranslation();
  const debouncedTerm = useDebounce(searchTerm, 500);
  const fetchUploadsVersions = (selectFirstValue = false) => {
    uploadActions.fetchUploadVersions(
      uploadActions?.uploadedApp?.id,
      debouncedTerm ? `name:*${debouncedTerm}*,status:SUCCESS` : ""
    ).then((res) => {
      const latestVersion = new UploadVersion();
      latestVersion.name = "Latest";
      latestVersion.id = uploadActions?.uploadedApp?.id;
      latestVersion.path = "LATEST";
      res.content = [latestVersion, ...res.content];
      setUploadedVersions(res?.content || []);
      if (selectFirstValue && res?.content?.length > 0) {
        onSelect(res?.content[0], false);
      }
    }).catch((err) => {
      throw new Error(err);
    }).finally(() => setLoading(false));
  };
  useEffect(() => {
    if (uploadActions?.uploadedApp?.id) {
      setLoading(true);
      fetchUploadsVersions(isFirstTime);
    }
  }, []);
  useEffect(() => {
    if (uploadActions?.uploadedApp?.id) {
      setLoading(true);
      fetchUploadsVersions();
    }
  }, [debouncedTerm]);
  return /* @__PURE__ */ jsxs(
    Dropdown,
    {
      className: "w-[200px] min-w-[100px] z-[1000] max-h-80 overflow-scroll",
      toggleDropdown,
      setRef: setDropdownRef,
      style: styles.popper,
      attributes: attributes.popper,
      children: [
        /* @__PURE__ */ jsx(
          Input,
          {
            value: searchTerm,
            onChange: setSearchTerm,
            placeholder: t("search"),
            suffix: /* @__PURE__ */ jsx(Icon, { name: "search", className: "text-secondary-500 text-base pr-2" }),
            wrapperClassName: "w-full border-b border-b-secondary-200",
            className: "!bg-white"
          }
        ),
        loading && /* @__PURE__ */ jsx("div", { className: "empty-page-loader left-1/2 top-1/2 absolute my-10" }),
        !loading && uploadedVersion?.map((item, idx) => /* @__PURE__ */ jsx(
          DropdownItem,
          {
            onClick: () => {
              onSelect(item);
              toggleDropdown(false);
            },
            className: "w-[200px] truncate max-w-[200px]",
            children: /* @__PURE__ */ jsx(
              TruncatedText,
              {
                value: item.name,
                className: "text-small text-unique-600"
              }
            )
          },
          `${item}_${idx}`
        )),
        !loading && uploadedVersion?.length == 0 && /* @__PURE__ */ jsx(DropdownItem, { className: "flex items-center", children: /* @__PURE__ */ jsx("span", { className: "text-small text-secondary-500", children: t("step.no_match_found") }) })
      ]
    },
    "drop-down"
  );
};
var app_versions_default = AppVersionsDropdown;
var SessionNameDropdown = ({
  blockRef,
  onSelect,
  toggleDropdown,
  sessionActions
}) => {
  const [dropdownRef, setDropdownRef] = useState(null);
  const [sessionItemList, setSessionItemList] = useState([]);
  const [searchTerm, setSearchTerm] = useState(null);
  const [loading, setLoading] = useState(false);
  const { styles, attributes } = usePopper(blockRef.current, dropdownRef, {
    placement: "bottom-start",
    strategy: "fixed"
  });
  const { t } = useTranslation();
  const debouncedTerm = useDebounce(searchTerm, 500);
  const fetchSessionItems = (selectFirstValue = false) => {
    sessionActions.fetchSessions(1e3, 0, null).then((res) => {
      const sessionList = [];
      res?.content?.map((item) => {
        sessionList.push(
          ...item?.stepDataList.filter(
            (stepData) => stepData?.key === "sessionName" && stepData?.value !== "default"
          ).map((stepData) => stepData?.value)
        );
      });
      sessionList.push("default");
      setSessionItemList(sessionList);
      if (selectFirstValue && sessionList.length > 0) {
        onSelect(sessionList[0], false);
      }
    }).catch((err) => {
      throw new Error(err);
    }).finally(() => setLoading(false));
  };
  const filterSessions = () => {
    if (searchTerm?.length) {
      setSessionItemList(
        sessionItemList.filter((item) => item.includes(searchTerm))
      );
    } else {
      fetchSessionItems();
    }
    setLoading(false);
  };
  useEffect(() => {
    setLoading(true);
    fetchSessionItems(true);
  }, []);
  useEffect(() => {
    setLoading(true);
    filterSessions();
  }, [debouncedTerm]);
  return /* @__PURE__ */ jsxs(
    Dropdown,
    {
      className: "w-[200px] min-w-[100px] z-[1000] max-h-80 overflow-scroll",
      toggleDropdown,
      setRef: setDropdownRef,
      style: styles.popper,
      attributes: attributes.popper,
      children: [
        /* @__PURE__ */ jsx(
          Input,
          {
            value: searchTerm,
            onChange: setSearchTerm,
            placeholder: t("search"),
            suffix: /* @__PURE__ */ jsx(Icon, { name: "search", className: "text-secondary-500 text-base pr-2" }),
            wrapperClassName: "w-full border-b border-b-secondary-200",
            className: "!bg-white"
          }
        ),
        loading && /* @__PURE__ */ jsx("div", { className: "empty-page-loader left-1/2 top-1/2 absolute my-10" }),
        !loading && sessionItemList?.map((item, idx) => /* @__PURE__ */ jsx(
          DropdownItem,
          {
            onClick: () => {
              onSelect(item);
              toggleDropdown(false);
            },
            className: "w-[200px] truncate max-w-[200px]",
            children: /* @__PURE__ */ jsx(
              TruncatedText,
              {
                value: item,
                className: "text-small text-unique-600"
              }
            )
          },
          `${item}_${idx}`
        )),
        !loading && sessionItemList?.length == 0 && /* @__PURE__ */ jsx(DropdownItem, { className: "flex items-center", children: /* @__PURE__ */ jsx("span", { className: "text-small text-secondary-500", children: t("step.no_match_found") }) })
      ]
    },
    "drop-down"
  );
};
var session_default = SessionNameDropdown;
var customDropDownUuids = [
  "salesforceConnection",
  "salesforceApplication",
  "salesforceTab",
  "salesforceObject"
];
var useSlashDropdown = (block, isActiveBlock, blockRef) => {
  const [isSlashDropdownVisible, setSlashDropdownVisible] = useState(false);
  const isSlashable = useCallback((block2) => {
    return customDropDownUuids.includes(block2?.uuid);
  }, []);
  const handleKeyDown = useCallback((event) => {
    if (event.key === "/") {
      setSlashDropdownVisible(true);
    }
  }, []);
  const handleInput = useCallback((event) => {
    const textContent = event?.target?.textContent?.trim();
    if (textContent == "") {
      setSlashDropdownVisible(false);
    }
  }, []);
  useEffect(() => {
    if (!isSlashable(block)) {
      return;
    }
    const currentBlockRef = blockRef?.current;
    if (currentBlockRef && isActiveBlock) {
      currentBlockRef.addEventListener("keydown", handleKeyDown);
      currentBlockRef.addEventListener("input", handleInput);
    }
    return () => {
      if (currentBlockRef && !isActiveBlock) {
        currentBlockRef.removeEventListener("keydown", handleKeyDown);
        currentBlockRef.removeEventListener("input", handleInput);
      }
    };
  }, [blockRef, isActiveBlock, block]);
  return isSlashDropdownVisible;
};
var use_slashable_default = useSlashDropdown;
var DropdownLoader = (props) => {
  const { loading, className } = props;
  if (!loading) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames82("empty-page-loader", "my-10 mx-auto", className)
    }
  );
};
var modifier2 = [
  {
    name: "offset",
    options: {
      offset: [0, 10]
    }
  }
];
var ConnectionsDropdown = ({
  block,
  blockIdx,
  blockRef,
  toggleDropdown,
  updateLocalBlock,
  salesforceActions,
  selectedType = "raw" /* raw */
}) => {
  const [dropdownRef, setDropdownRef] = useState(null);
  const [searchTerm, setSearchTerm] = useState(null);
  const [loading, setLoading] = useState(false);
  const [connectionsList, setConnectionsList] = useState(null);
  const {
    updateActiveBlockIndex,
    updateBlockValue,
    actionCallback,
    disableAllowActiveIndexUpdate,
    blocks
  } = useContext(BlockContext);
  const { isWebRecorder } = useContext(StepContext);
  const { t } = useTranslation();
  const { styles, attributes } = usePopper(blockRef.current, dropdownRef, {
    placement: "bottom-start",
    strategy: "fixed",
    modifiers: modifier2
  });
  const nextIndex = blocks?.findIndex(
    (item, idx) => idx > blockIdx && item.type != "readonly_text" /* readonly_text */
  );
  const debouncedTerm = useDebounce(searchTerm, 500);
  useEffect(() => {
    setLoading(true);
    salesforceActions.fetchConnections(`${debouncedTerm ? `name:*${debouncedTerm}*` : ""}`).then((res) => {
      if (res?.content) {
        setConnectionsList(res?.content);
      }
      setLoading(false);
    }).catch((err) => {
      throw new Error(err);
    }).finally(() => setLoading(false));
  }, [debouncedTerm]);
  const onSelect = useCallback(
    (connection) => {
      const localBlock = Object.assign({}, block);
      localBlock.value = connection.name;
      localBlock.type = selectedType;
      updateLocalBlock(localBlock);
      updateBlockValue(localBlock, blockIdx);
      updateActiveBlockIndex(null);
      disableAllowActiveIndexUpdate?.(false);
      window.setTimeout(() => {
        if (nextIndex >= 0) updateActiveBlockIndex(nextIndex);
      }, 250);
    },
    [block, blockIdx, updateBlockValue, updateLocalBlock, nextIndex]
  );
  const handleKeyMovements = useCallback(
    (event) => {
      event.preventDefault();
      if (event.code == "Escape") {
        event.preventDefault();
        toggleDropdown(false);
      }
    },
    [onSelect, connectionsList]
  );
  useEffect(() => {
    blockRef.current?.addEventListener("keydown", handleKeyMovements);
    return () => blockRef.current?.removeEventListener("keydown", handleKeyMovements);
  }, [blockRef, handleKeyMovements]);
  const renderInput = () => {
    return /* @__PURE__ */ jsx(
      Input,
      {
        value: searchTerm,
        onChange: setSearchTerm,
        placeholder: t("search"),
        suffix: /* @__PURE__ */ jsx(Icon, { name: "search", className: "text-secondary-500 text-base pr-2" }),
        wrapperClassName: "w-full border-b border-b-secondary-200",
        className: "!bg-white"
      }
    );
  };
  const renderAddConnection = () => {
    return /* @__PURE__ */ jsxs(
      DropdownItem,
      {
        className: "flex items-center",
        onClick: () => {
          actionCallback(onSelect);
          disableAllowActiveIndexUpdate?.(true);
        },
        children: [
          /* @__PURE__ */ jsx(Icon, { name: "add", className: "text-base text-primary-600 mr-1.5" }),
          /* @__PURE__ */ jsx("span", { className: "text-small text-primary-600", children: t("step.add_connection") })
        ]
      }
    );
  };
  const renderDropdownItems = () => {
    if (!connectionsList || connectionsList.length === 0) {
      return null;
    }
    return connectionsList.map((entity) => /* @__PURE__ */ jsx(DropdownItem, { onClick: () => onSelect(entity), children: entity?.name }, entity.id));
  };
  const renderNoMatchFound = () => {
    return /* @__PURE__ */ jsx(DropdownItem, { className: "flex items-center", children: /* @__PURE__ */ jsx("span", { className: "text-small text-secondary-500", children: t("step.no_match_found") }) });
  };
  return /* @__PURE__ */ jsxs(
    Dropdown,
    {
      className: "w-[200px] min-w-[90px] shadow-md z-[1000] max-h-80 overflow-y-auto",
      toggleDropdown,
      setRef: setDropdownRef,
      style: styles.popper,
      attributes: attributes.popper,
      children: [
        renderInput(),
        !loading && renderDropdownItems(),
        /* @__PURE__ */ jsx(DropdownLoader, { loading }),
        !loading && !connectionsList?.length && renderNoMatchFound(),
        !isWebRecorder && renderAddConnection()
      ]
    },
    "drop-down"
  );
};
var connections_dropdown_default = ConnectionsDropdown;
var { VirtualizedInfiniteLoader } = InfiniteScrollV2;
var modifier3 = [
  {
    name: "offset",
    options: {
      offset: [0, 10]
    }
  }
];
var defaultPagable = new Pageable();
defaultPagable.pageNumber = 0;
var MetadataObjectsDropDown = ({
  block,
  blockIdx,
  blockRef,
  toggleDropdown,
  updateLocalBlock,
  salesforceActions,
  selectedType = "raw" /* raw */
}) => {
  const [dropdownRef, setDropdownRef] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [hasMore, setHasMore] = useState(false);
  const [pageable, setPageable] = useState(defaultPagable);
  const [listItems, setListItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [isInitialFetchDone, setIsInitialFetchDone] = useState(false);
  const {
    updateActiveBlockIndex,
    updateBlockValue,
    disableAllowActiveIndexUpdate,
    blocks
  } = useContext(BlockContext);
  const { t } = useTranslation();
  const { styles, attributes } = usePopper(blockRef.current, dropdownRef, {
    placement: "bottom-start",
    strategy: "fixed",
    modifiers: modifier3
  });
  const nextIndex = blocks?.findIndex(
    (item, idx) => idx > blockIdx && item.type != "readonly_text" /* readonly_text */
  );
  useEffect(() => {
    const fetchConnectionAndObjects = async () => {
      const connection = await salesforceActions.fetchConnections();
      const defaultConnection = connection?.content[0];
      if (!defaultConnection?.id) {
        throw new Error("Connection ID not found");
      }
      setLoading(true);
      setIsInitialFetchDone(true);
      salesforceActions.fetchMetadataObjects(
        `${searchTerm ? `name:*${searchTerm}*` : ""}`,
        defaultConnection?.id,
        void 0,
        pageable?.pageNumber,
        void 0
      ).then((res) => {
        if (!res?.content) {
          return;
        }
        let results = [];
        if (pageable.pageNumber > 0) {
          results = [...listItems, ...res?.content];
        } else {
          results = res?.content;
        }
        setListItems(results);
        setHasMore(!res.last);
        setTotalPages(res?.totalPages);
      }).catch((err) => {
        throw new Error(err);
      }).finally(() => setLoading(false));
    };
    fetchConnectionAndObjects();
  }, [pageable.pageNumber, salesforceActions, searchTerm]);
  const loadMore = useCallback(() => {
    const newPageable = new Pageable();
    newPageable.pageNumber = pageable?.pageNumber + 1;
    setPageable(newPageable);
  }, [pageable?.pageNumber]);
  const onSelect = useCallback(
    (entity) => {
      const localBlock = Object.assign({}, block);
      localBlock.value = entity?.name;
      localBlock.type = selectedType;
      updateLocalBlock(localBlock);
      updateBlockValue(localBlock, blockIdx);
      updateActiveBlockIndex(null);
      disableAllowActiveIndexUpdate?.(false);
      window.setTimeout(() => {
        if (nextIndex >= 0) updateActiveBlockIndex(nextIndex);
      }, 250);
    },
    [block, blockIdx, updateBlockValue, updateLocalBlock, nextIndex]
  );
  const handleKeyMovements = useCallback(
    (event) => {
      if (event.code === "Escape") {
        toggleDropdown(false);
      }
    },
    [toggleDropdown]
  );
  useEffect(() => {
    blockRef.current?.addEventListener("keydown", handleKeyMovements);
    return () => blockRef.current?.removeEventListener("keydown", handleKeyMovements);
  }, [blockRef, handleKeyMovements]);
  const ToolTipContent = ({ entity }) => {
    return /* @__PURE__ */ jsxs("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ jsx("span", { className: "font-semibold", children: t("label.api.name") }),
      /* @__PURE__ */ jsx("span", { className: "leading-4 font-normal text-sm", children: entity?.name })
    ] });
  };
  const rowRenderer = (index) => {
    const item = listItems?.[index];
    return /* @__PURE__ */ jsx(
      DropdownItem,
      {
        onClick: () => onSelect(item),
        className: "group/metaitem",
        children: /* @__PURE__ */ jsxs("div", { className: "flex flex-row justify-between items-center", children: [
          /* @__PURE__ */ jsx("div", { className: "max-w-[150px] flex items-center", children: /* @__PURE__ */ jsx(
            TruncatedText,
            {
              value: item?.label,
              className: "inline-block",
              watchMouseLeave: true
            }
          ) }),
          item?.name && /* @__PURE__ */ jsx(
            ToolTip,
            {
              className: "invisible group-hover/metaitem:!visible flex items-center",
              content: /* @__PURE__ */ jsx(ToolTipContent, { entity: item }),
              placement: "right",
              watchMouseLeave: true,
              children: /* @__PURE__ */ jsx(
                Icon,
                {
                  name: "info",
                  className: "inline-flex text-[#B3B9C4] text-[16px]"
                }
              )
            }
          )
        ] })
      },
      item?.id
    );
  };
  const renderDropdownItems = () => {
    if (!listItems || listItems.length === 0) {
      return null;
    }
    return /* @__PURE__ */ jsx(
      VirtualizedInfiniteLoader,
      {
        rowHeight: 42,
        className: "!h-full !w-full",
        loadMore,
        rowCount: listItems?.length,
        rowRenderer,
        hasMore,
        items: listItems,
        totalPages,
        isLoading: loading,
        LoadingComponent: /* @__PURE__ */ jsx("div", { className: "flex flex-col absolute-center py-10 items-center", children: /* @__PURE__ */ jsx("div", { className: "w-[36px]", children: /* @__PURE__ */ jsx(
          Spinner,
          {
            size: 48,
            thickness: 80,
            speed: 140,
            color: "#093B4D",
            secondaryColor: "rgba(172, 57, 57, 0)"
          }
        ) }) })
      }
    );
  };
  const renderInput = () => {
    return /* @__PURE__ */ jsx(
      DebouncedSearchInput,
      {
        value: searchTerm,
        onChange: (value) => {
          const newPageable = new Pageable();
          newPageable.pageNumber = 0;
          setPageable(newPageable);
          setSearchTerm(value);
        },
        placeholder: t("search"),
        suffix: /* @__PURE__ */ jsx(Icon, { name: "search", className: "text-secondary-500 text-base pr-2" }),
        wrapperClassName: "w-full border-b border-b-secondary-200",
        className: "!bg-white sticky top-0"
      }
    );
  };
  const renderNoMatchFound = () => {
    return /* @__PURE__ */ jsx(DropdownItem, { className: "flex items-center", children: /* @__PURE__ */ jsx("span", { className: "text-small text-secondary-500", children: t("step.no_match_found") }) });
  };
  return /* @__PURE__ */ jsx(
    Dropdown,
    {
      className: "w-[200px] min-w-[90px] shadow-md z-[1000] !min-h-[240px] !max-h-[240px] overflow-hidden",
      toggleDropdown,
      setRef: setDropdownRef,
      style: styles.popper,
      attributes: attributes.popper,
      children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col !min-h-[240px] !max-h-[240px] overflow-hidden", children: [
        renderInput(),
        /* @__PURE__ */ jsxs("div", { className: "flex flex-col justify-center items-center !min-h-[190px] !max-h-[190px]", children: [
          /* @__PURE__ */ jsx(DropdownLoader, { loading: loading && pageable?.pageNumber === 0 }),
          !loading && !listItems?.length && isInitialFetchDone && renderNoMatchFound(),
          renderDropdownItems()
        ] })
      ] })
    },
    "drop-down"
  );
};
var metadata_objects_dropdown_default = MetadataObjectsDropDown;
var { VirtualizedInfiniteLoader: VirtualizedInfiniteLoader2 } = InfiniteScrollV2;
var modifier4 = [
  {
    name: "offset",
    options: {
      offset: [0, 10]
    }
  }
];
var defaultPagable2 = new Pageable();
defaultPagable2.pageNumber = 0;
var ApplicationsDropDown = ({
  block,
  blockIdx,
  blockRef,
  toggleDropdown,
  updateLocalBlock,
  salesforceActions,
  selectedType = "raw" /* raw */
}) => {
  const [dropdownRef, setDropdownRef] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [hasMore, setHasMore] = useState(false);
  const [pageable, setPageable] = useState(defaultPagable2);
  const [listItems, setListItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [isInitialFetchDone, setIsInitialFetchDone] = useState(false);
  const {
    updateActiveBlockIndex,
    updateBlockValue,
    disableAllowActiveIndexUpdate,
    blocks
  } = useContext(BlockContext);
  const { t } = useTranslation();
  const { styles, attributes } = usePopper(blockRef.current, dropdownRef, {
    placement: "bottom-start",
    strategy: "fixed",
    modifiers: modifier4
  });
  const nextIndex = blocks?.findIndex(
    (item, idx) => idx > blockIdx && item.type != "readonly_text" /* readonly_text */
  );
  useEffect(() => {
    const fetchConnectionAndApplications = async () => {
      const connection = await salesforceActions.fetchConnections();
      const defaultConnection = connection?.content[0];
      if (!defaultConnection?.id) {
        throw new Error("Connection ID not found");
      }
      setLoading(true);
      setIsInitialFetchDone(true);
      salesforceActions.fetchApplications(
        `${searchTerm ? `label:*${searchTerm}*` : ""}`,
        defaultConnection?.id,
        void 0,
        pageable?.pageNumber,
        void 0
      ).then((res) => {
        if (!res?.content) {
          return;
        }
        let results = [];
        if (pageable.pageNumber > 0) {
          results = [...listItems, ...res?.content];
        } else {
          results = res?.content;
        }
        setListItems(results);
        setHasMore(!res.last);
        setTotalPages(res?.totalPages);
      }).catch((err) => {
        throw new Error(err);
      }).finally(() => setLoading(false));
    };
    fetchConnectionAndApplications();
  }, [pageable.pageNumber, salesforceActions, searchTerm]);
  const loadMore = useCallback(() => {
    const newPageable = new Pageable();
    newPageable.pageNumber = pageable?.pageNumber + 1;
    setPageable(newPageable);
  }, [pageable?.pageNumber]);
  const onSelect = useCallback(
    (entity) => {
      const localBlock = Object.assign({}, block);
      localBlock.value = entity.Label;
      localBlock.type = selectedType;
      updateLocalBlock(localBlock);
      updateBlockValue(localBlock, blockIdx);
      updateActiveBlockIndex(null);
      disableAllowActiveIndexUpdate?.(false);
      window.setTimeout(() => {
        if (nextIndex >= 0) updateActiveBlockIndex(nextIndex);
      }, 250);
    },
    [block, blockIdx, updateBlockValue, updateLocalBlock, nextIndex]
  );
  const handleKeyMovements = useCallback(
    (event) => {
      if (event.code === "Escape") {
        toggleDropdown(false);
      }
    },
    [toggleDropdown]
  );
  useEffect(() => {
    blockRef.current?.addEventListener("keydown", handleKeyMovements);
    return () => blockRef.current?.removeEventListener("keydown", handleKeyMovements);
  }, [blockRef, handleKeyMovements]);
  const rowRenderer = (index) => {
    const entity = listItems?.[index];
    return /* @__PURE__ */ jsx(DropdownItem, { onClick: () => onSelect(entity), children: entity?.Label }, entity?.id);
  };
  const renderDropdownItems = () => {
    if (!listItems || listItems.length === 0) {
      return null;
    }
    return /* @__PURE__ */ jsx(
      VirtualizedInfiniteLoader2,
      {
        rowHeight: 42,
        className: "!h-full !w-full",
        loadMore,
        rowCount: listItems?.length,
        rowRenderer,
        hasMore,
        items: listItems,
        totalPages,
        isLoading: loading,
        LoadingComponent: /* @__PURE__ */ jsx("div", { className: "flex flex-col absolute-center py-10 items-center", children: /* @__PURE__ */ jsx("div", { className: "w-[36px]", children: /* @__PURE__ */ jsx(
          Spinner,
          {
            size: 48,
            thickness: 80,
            speed: 140,
            color: "#093B4D",
            secondaryColor: "rgba(172, 57, 57, 0)"
          }
        ) }) })
      }
    );
  };
  const renderInput = () => {
    return /* @__PURE__ */ jsx(
      DebouncedSearchInput,
      {
        value: searchTerm,
        onChange: (value) => {
          const newPageable = new Pageable();
          newPageable.pageNumber = 0;
          setPageable(newPageable);
          setSearchTerm(value);
        },
        placeholder: t("search"),
        suffix: /* @__PURE__ */ jsx(Icon, { name: "search", className: "text-secondary-500 text-base pr-2" }),
        wrapperClassName: "w-full border-b border-b-secondary-200 sticky top-0",
        className: "!bg-white"
      }
    );
  };
  const renderNoMatchFound = () => {
    return /* @__PURE__ */ jsx(DropdownItem, { className: "flex items-center", children: /* @__PURE__ */ jsx("span", { className: "text-small text-secondary-500", children: t("step.no_match_found") }) });
  };
  return /* @__PURE__ */ jsx(
    Dropdown,
    {
      className: "w-[200px] min-w-[90px] shadow-md z-[1000] !min-h-[240px] !max-h-[240px] overflow-hidden",
      toggleDropdown,
      setRef: setDropdownRef,
      style: styles.popper,
      attributes: attributes.popper,
      children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col !min-h-[240px] !max-h-[240px] overflow-hidden", children: [
        renderInput(),
        /* @__PURE__ */ jsxs("div", { className: "flex flex-col justify-center items-center !min-h-[190px] !max-h-[190px]", children: [
          /* @__PURE__ */ jsx(DropdownLoader, { loading: loading && pageable?.pageNumber === 0 }),
          !loading && !listItems?.length && isInitialFetchDone && renderNoMatchFound(),
          renderDropdownItems()
        ] })
      ] })
    },
    "drop-down"
  );
};
var applications_dropdown_default = ApplicationsDropDown;
var { VirtualizedInfiniteLoader: VirtualizedInfiniteLoader3 } = InfiniteScrollV2;
var modifier5 = [
  {
    name: "offset",
    options: {
      offset: [0, 10]
    }
  }
];
var defaultPagable3 = new Pageable();
defaultPagable3.pageNumber = 0;
var TabsDropDown = ({
  block,
  blockIdx,
  blockRef,
  toggleDropdown,
  updateLocalBlock,
  salesforceActions,
  selectedType = "raw" /* raw */
}) => {
  const [dropdownRef, setDropdownRef] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [hasMore, setHasMore] = useState(false);
  const [pageable, setPageable] = useState(defaultPagable3);
  const [listItems, setListItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [isInitialFetchDone, setIsInitialFetchDone] = useState(false);
  const { isDebugger = false } = useRecorderContext();
  const {
    updateActiveBlockIndex,
    updateBlockValue,
    disableAllowActiveIndexUpdate,
    blocks
  } = useContext(BlockContext);
  const { t } = useTranslation();
  const nextIndex = blocks?.findIndex(
    (item, idx) => idx > blockIdx && item.type != "readonly_text" /* readonly_text */
  );
  const { styles, attributes } = usePopper(blockRef.current, dropdownRef, {
    placement: "bottom-start",
    strategy: "fixed",
    modifiers: modifier5
  });
  useEffect(() => {
    const fetchConnectionAndTabs = async () => {
      const connection = await salesforceActions.fetchConnections();
      const defaultConnection = connection?.content[0];
      if (!defaultConnection?.id) {
        throw new Error("Connection ID not found");
      }
      setLoading(true);
      setIsInitialFetchDone(true);
      salesforceActions.fetchTabs(
        `${searchTerm ? `label:*${searchTerm}*` : ""}`,
        defaultConnection?.id,
        void 0,
        pageable?.pageNumber,
        void 0
      ).then((res) => {
        if (!res?.content) {
          return;
        }
        let results = [];
        if (pageable.pageNumber > 0) {
          results = [...listItems, ...res?.content];
        } else {
          results = res?.content;
        }
        setListItems(results);
        setHasMore(!res.last);
        setTotalPages(res?.totalPages);
      }).catch((err) => {
        throw new Error(err);
      }).finally(() => setLoading(false));
    };
    fetchConnectionAndTabs();
  }, [pageable.pageNumber, salesforceActions, searchTerm]);
  const loadMore = useCallback(() => {
    const newPageable = new Pageable();
    newPageable.pageNumber = pageable?.pageNumber + 1;
    setPageable(newPageable);
  }, [pageable?.pageNumber]);
  const onSelect = useCallback(
    (entity) => {
      const localBlock = Object.assign({}, block);
      localBlock.value = entity?.label;
      localBlock.type = selectedType;
      updateLocalBlock(localBlock);
      updateBlockValue(localBlock, blockIdx);
      updateActiveBlockIndex(null);
      disableAllowActiveIndexUpdate?.(false);
      window.setTimeout(() => {
        if (nextIndex >= 0) updateActiveBlockIndex(nextIndex);
      }, 250);
    },
    [block, blockIdx, updateBlockValue, updateLocalBlock, nextIndex]
  );
  const handleKeyMovements = useCallback(
    (event) => {
      if (event.code === "Escape") {
        toggleDropdown(false);
      }
    },
    [toggleDropdown]
  );
  useEffect(() => {
    blockRef.current?.addEventListener("keydown", handleKeyMovements);
    return () => blockRef.current?.removeEventListener("keydown", handleKeyMovements);
  }, [blockRef, handleKeyMovements]);
  const ToolTipContent = ({ entity }) => {
    return /* @__PURE__ */ jsxs("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ jsx("span", { className: "font-semibold", children: t("label.api.name") }),
      /* @__PURE__ */ jsx("span", { className: "leading-4 font-normal text-sm", children: entity?.name })
    ] });
  };
  const rowRenderer = (index) => {
    const entity = listItems?.[index];
    return /* @__PURE__ */ jsx(DropdownItem, { onClick: () => onSelect(entity), children: /* @__PURE__ */ jsxs("div", { className: "flex flex-row justify-between items-center", children: [
      /* @__PURE__ */ jsx("div", { className: "max-w-[150px]", children: /* @__PURE__ */ jsx(
        TruncatedText,
        {
          value: entity?.label,
          className: "inline-block",
          watchMouseLeave: true
        }
      ) }),
      entity?.name && /* @__PURE__ */ jsx(
        ToolTip,
        {
          content: /* @__PURE__ */ jsx(ToolTipContent, { entity }),
          placement: "right",
          watchMouseLeave: true,
          children: /* @__PURE__ */ jsx(
            Icon,
            {
              name: "info",
              className: "inline-flex text-[#B3B9C4] text-[16px]"
            }
          )
        }
      )
    ] }) }, entity?.id);
  };
  const renderDropdownItems = () => {
    if (!listItems || listItems.length === 0) {
      return null;
    }
    return /* @__PURE__ */ jsx(
      VirtualizedInfiniteLoader3,
      {
        rowHeight: 42,
        className: "!h-full !w-full",
        loadMore,
        rowCount: listItems?.length,
        rowRenderer,
        hasMore,
        items: listItems,
        totalPages,
        isLoading: loading,
        LoadingComponent: /* @__PURE__ */ jsx("div", { className: "flex flex-col absolute-center py-10 items-center", children: /* @__PURE__ */ jsx("div", { className: "w-[36px]", children: /* @__PURE__ */ jsx(
          Spinner,
          {
            size: 48,
            thickness: 80,
            speed: 140,
            color: "#093B4D",
            secondaryColor: "rgba(172, 57, 57, 0)"
          }
        ) }) })
      }
    );
  };
  const renderInput = () => {
    return /* @__PURE__ */ jsx(
      DebouncedSearchInput,
      {
        value: searchTerm,
        onChange: (value) => {
          const newPageable = new Pageable();
          newPageable.pageNumber = 0;
          setPageable(newPageable);
          setSearchTerm(value);
        },
        placeholder: t("search"),
        suffix: /* @__PURE__ */ jsx(Icon, { name: "search", className: "text-secondary-500 text-base pr-2" }),
        wrapperClassName: "w-full border-b border-b-secondary-200",
        className: "!bg-white sticky top-0"
      }
    );
  };
  const renderNoMatchFound = () => {
    return /* @__PURE__ */ jsx(DropdownItem, { className: "flex items-center", children: /* @__PURE__ */ jsx("span", { className: "text-small text-secondary-500", children: t("step.no_match_found") }) });
  };
  return /* @__PURE__ */ jsx(
    Dropdown,
    {
      className: "w-[200px] min-w-[90px] shadow-md z-[1000] !min-h-[240px] !max-h-[240px] overflow-hidden",
      toggleDropdown,
      setRef: setDropdownRef,
      style: styles.popper,
      attributes: attributes.popper,
      children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col !min-h-[240px] !max-h-[240px] overflow-hidden", children: [
        renderInput(),
        /* @__PURE__ */ jsxs("div", { className: "flex flex-col justify-center relative top-0 left-0 items-center !min-h-[190px] !max-h-[190px]", children: [
          /* @__PURE__ */ jsx(
            DropdownLoader,
            {
              loading: loading && pageable?.pageNumber === 0,
              className: classNames82("absolute", {
                "top-[20px] left-[81px]": isDebugger,
                "top-[80px] left-0 !my-0 !mx-0": !isDebugger && listItems?.length > 0,
                "top-0 left-0": !isDebugger && listItems?.length === 0
              })
            }
          ),
          !loading && !listItems?.length && isInitialFetchDone && renderNoMatchFound(),
          renderDropdownItems()
        ] })
      ] })
    },
    "drop-down"
  );
};
var tabs_dropdown_default = TabsDropDown;
var DropdownFactory = ({
  block,
  blockRef,
  toggleDropdown,
  salesforceActions,
  blockIdx,
  updateLocalBlock
}) => {
  switch (block?.uuid) {
    case "salesforceObject":
      return /* @__PURE__ */ jsx(
        metadata_objects_dropdown_default,
        {
          blockRef,
          toggleDropdown,
          salesforceActions,
          block,
          blockIdx,
          updateLocalBlock
        }
      );
    case "salesforceConnection":
      return /* @__PURE__ */ jsx(
        connections_dropdown_default,
        {
          blockRef,
          toggleDropdown,
          salesforceActions,
          block,
          blockIdx,
          updateLocalBlock
        }
      );
    case "salesforceApplication":
      return /* @__PURE__ */ jsx(
        applications_dropdown_default,
        {
          blockRef,
          toggleDropdown,
          salesforceActions,
          block,
          blockIdx,
          updateLocalBlock
        }
      );
    case "salesforceTab":
      return /* @__PURE__ */ jsx(
        tabs_dropdown_default,
        {
          blockRef,
          toggleDropdown,
          salesforceActions,
          block,
          blockIdx,
          updateLocalBlock
        }
      );
    default:
      return null;
  }
};
var dropdown_factory_default = DropdownFactory;
function isCoordinateStep(templateId) {
  const template_ids = [1060, 10164, 20091, 20139, 20164, 30090, 30128, 30162];
  return template_ids.includes(templateId);
}
function formatCoordinates(coordinates) {
  const defaultValues = ["test data", "start swipe", "end swipe"];
  if (defaultValues.includes(coordinates)) return coordinates;
  return (coordinates || "").split(/\s*,\s*/).map((num) => parseFloat(num).toFixed(2)).join(", ");
}
function safeStringValue(value) {
  if (value === null || value === void 0) return "";
  if (typeof value === "string") return value;
  return String(value);
}
var RawBlock = ({ block, blockIdx }) => {
  const blockRef = useRef(null);
  const {
    isDisabled,
    isResultBlock,
    isReadOnly,
    activeBlockIdx,
    setBlockRef,
    isFocused,
    updateActiveBlockIndex,
    getTestData: getTestData2,
    updateBlockValue,
    disableAllowActiveIndexUpdate,
    isActiveIndexUpdateDisabled,
    saveHandler,
    dataParameterList,
    dataProfileList,
    dataSetList,
    updateSelectedDataProfile,
    step,
    uploadActions,
    sessionActions,
    blocks,
    salesforceActions,
    isNoWrapSteps
  } = useContext(BlockContext);
  const { applicationType, isViewOnlySingle } = useContext(StepContext);
  const isInitialFocusActivated = useRef(false);
  const [isEncrypted, setIsEncrypted] = useState(false);
  const [isIConClicked, setISISconClicked] = useState(false);
  const [shouldAdvance, setShouldAdvance] = useState(false);
  const [localBlock, updateLocalBlock] = useState(Object.assign({}, block));
  const [showTestDataDropdown, toggleShowTestDataDropdown] = useState(true);
  const [isTestDataModified, setIsTestDataModified] = useState(false);
  const [tdpIdAndRefetchFlag, setTdpIdAndRefetchFlag] = useState({ id: void 0, isRefetchNeeded: true });
  const [isTDPSetLoading, setIsTDPSetLoading] = useState(false);
  const isActiveBlock = activeBlockIdx == blockIdx;
  const toggleDropdown = useCallback(
    (state) => {
      if (!isActiveIndexUpdateDisabled)
        updateActiveBlockIndex(state ? blockIdx : null);
    },
    [blockIdx, updateActiveBlockIndex, isActiveIndexUpdateDisabled]
  );
  useEffect(() => {
    if (!shouldAdvance) return;
    const nextIndex = blocks.findIndex(
      (item, idx) => idx > blockIdx && item.type !== "readonly_text" /* readonly_text */
    );
    if (nextIndex >= 0) {
      updateActiveBlockIndex(nextIndex);
      const updatedNextBlock = { ...blocks[nextIndex], value: "app-version" };
      updateBlockValue(updatedNextBlock, nextIndex);
    }
    setShouldAdvance(false);
  }, [shouldAdvance, blocks]);
  const handleDataTypeChange = useTestDataValueChange(
    block,
    getTestData2,
    updateBlockValue,
    blockIdx,
    disableAllowActiveIndexUpdate,
    updateSelectedDataProfile
  );
  const handleForLoopDataChange = useForLoopValueChange(
    block,
    blockIdx,
    updateBlockValue,
    updateSelectedDataProfile
  );
  const handleInput = useCallback(
    (event) => {
      const textContent = event.target.textContent;
      const updatedValue = block.uuid != "exePath" ? textContent?.replace(/\\n/g, "\n") : textContent;
      block.isEncrypted = isEncrypted;
      updateBlockValue(
        Object.assign({}, block, { value: updatedValue }),
        blockIdx
      );
      if (updatedValue?.trim() == "") {
        updateLocalBlock(Object.assign({}, block, { value: updatedValue }));
      }
      if (!customDropDownUuids?.includes(block?.uuid)) {
        toggleShowTestDataDropdown(false);
      }
      setIsTestDataModified(true);
    },
    [block, blockIdx, updateBlockValue]
  );
  const debouncedOnChange = useCallback(
    debounce$2((event) => {
      handleInput(event);
    }, 250),
    [handleInput]
  );
  const handleAppNameChange = useCallback(
    (app, isToggleDropdown = true) => {
      uploadActions.setUploadedApp(app);
      const modifiedBlockValue = Object.assign({}, block);
      modifiedBlockValue.value = app.name;
      updateBlockValue(modifiedBlockValue, blockIdx);
      if (isToggleDropdown) {
        window.setTimeout(() => {
          setShouldAdvance((prev) => !prev);
        }, 250);
      }
    },
    [
      block,
      blockIdx,
      updateBlockValue,
      updateActiveBlockIndex,
      localBlock,
      blocks
    ]
  );
  const handleAppVersionChange = useCallback(
    (appVersion, isToggleDropdown = true) => {
      const modifiedBlockValue = Object.assign({}, block);
      modifiedBlockValue.value = appVersion.name;
      modifiedBlockValue.more_details.appUploadId = appVersion.id;
      modifiedBlockValue.more_details.appPath = appVersion.path;
      updateBlockValue(modifiedBlockValue, blockIdx);
      isToggleDropdown && updateActiveBlockIndex(null);
    },
    [block, blockIdx, updateBlockValue, updateActiveBlockIndex, localBlock]
  );
  const handleSessionNameChange = useCallback(
    (name, isToggleDropdown = true) => {
      const modifiedBlockValue = Object.assign({}, block);
      modifiedBlockValue.value = name;
      updateBlockValue(modifiedBlockValue, blockIdx);
      isToggleDropdown && updateActiveBlockIndex(null);
      updateLocalBlock(modifiedBlockValue);
    },
    [block, blockIdx, updateBlockValue, updateActiveBlockIndex, localBlock]
  );
  const onIconClick = (value) => {
    setISISconClicked(true);
    updateBlockValue(
      Object.assign({}, block, { isEncrypted: value }),
      blockIdx
    );
  };
  const formattedValue = useMemo(() => {
    if (["INDEX", "SET_NAME"].includes(localBlock?.more_details?.["loopType"])) {
      if ((localBlock.uuid == "leftData" || localBlock.uuid == "rightData") && localBlock?.isEncrypted && safeStringValue(localBlock.value).length) {
        localBlock.value = "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022";
      }
      if (localBlock.uuid == "leftData" && localBlock.value == "-1")
        return "start";
      if (localBlock.uuid == "rightData" && localBlock.value == "-1")
        return "end";
      return safeStringValue(localBlock.value).split("\\n").join(" ");
    }
    if (localBlock?.isEncrypted && safeStringValue(localBlock.value).length) {
      localBlock.value = "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022";
    }
    if (localBlock?.value instanceof Object && !localBlock?.value?.value) {
      localBlock.value = localBlock.uuid ?? "";
    }
    const stringValue = safeStringValue(localBlock.value);
    return isCoordinateStep(localBlock?.more_details?.templateId) && !isFocused ? formatCoordinates(stringValue.split("\\n").join(" ")) : stringValue.split("\\n").join(" ");
  }, [localBlock, isFocused]);
  const isProfile = localBlock.more_details?.["profile"];
  const isParameter = localBlock.more_details?.["parameter"];
  const isSetName = localBlock.more_details?.["setName"] && (!localBlock?.more_details.allowedTypes || localBlock?.more_details.allowedTypes?.includes("set_name"));
  const isAppName = localBlock.more_details?.["appName"];
  const isAppVersion = localBlock.more_details?.["appVersion"];
  const isSession = localBlock.more_details?.["sessionValue"];
  const isRawBlock = !(isProfile || isParameter || isSetName || isAppName || isAppVersion || isSession);
  const toggleActiveBlock = useCallback(
    (event) => {
      if (!isActiveBlock) {
        updateActiveBlockIndex(blockIdx);
      }
      if (block?.isEncrypted) {
        if (event.code == "Backspace" || event.code == "Delete") {
          block.value = "";
          updateLocalBlock(Object.assign({}, block));
        }
      }
      toggleShowTestDataDropdown(true);
    },
    [block, blockIdx, updateActiveBlockIndex, isActiveBlock]
  );
  useFocusActivator(isActiveBlock, blockRef);
  useHandleEnter(blockRef, showTestDataDropdown, saveHandler);
  useFormattedPaste(blockRef);
  const updateTDPIdAndRefetchFlag = (newId, refetchNeeded) => {
    setTdpIdAndRefetchFlag({
      id: newId,
      isRefetchNeeded: refetchNeeded
    });
  };
  useEffect(() => {
    if (localBlock.more_details?.["profile"] || localBlock.more_details?.["parameter"] || localBlock.more_details?.["setName"] && localBlock.more_details?.setNameType != "filterParameter" || localBlock.more_details?.["appName"] || localBlock.more_details?.["appVersion"] || localBlock.more_details?.["sessionName"]) {
      if (block?.more_details?.profileId) {
        updateTDPIdAndRefetchFlag(block?.more_details?.profileId, true);
      }
      updateLocalBlock(Object.assign({}, block));
    }
  }, [block]);
  useEffect(() => {
    if (isTestDataModified && step?.isStepGroupChild) {
      handleDataTypeChange(block?.type, false);
      setIsTestDataModified(false);
    }
  }, [isTestDataModified]);
  useEffect(() => {
    if ((localBlock.more_details?.["setName"] || localBlock.more_details?.["parameter"]) && isFocused && tdpIdAndRefetchFlag?.isRefetchNeeded && dataProfileList && localBlock.more_details.testDataProfile?.id) {
      setIsTDPSetLoading(true);
      const tdpId = tdpIdAndRefetchFlag?.id || localBlock?.more_details?.testDataProfile?.id;
      const selectedProfile = dataProfileList.find((item) => item.id === tdpId);
      if (selectedProfile) {
        updateSelectedDataProfile(selectedProfile, null, () => {
          setIsTDPSetLoading(false);
        });
      } else {
        setIsTDPSetLoading(false);
      }
      updateTDPIdAndRefetchFlag(tdpId, false);
    }
  }, [localBlock, dataProfileList, isFocused]);
  const isSlashableDropDown = customDropDownUuids?.includes(block?.uuid);
  const isSlashDropdownVisible = use_slashable_default(
    block,
    isActiveBlock,
    blockRef
  );
  const filteredDataParameterList = useMemo(() => {
    const isRightDataBlock = block?.uuid === "rightData" || localBlock?.uuid === "rightData";
    if (!isRightDataBlock) {
      return dataParameterList;
    }
    const leftData = blocks?.find(
      (item) => item.uuid === "leftData" && item.has_value && item.value != "-1"
    );
    if (leftData && leftData.value) {
      const selectedDataParameter = dataParameterList?.find(
        (item) => item.name?.trim() === leftData.value?.trim()
      );
      if (selectedDataParameter && selectedDataParameter.position != null) {
        const filteredData = dataParameterList.filter(
          (item) => item.position != null && item.position >= selectedDataParameter.position
        );
        return filteredData;
      }
    }
    return dataParameterList;
  }, [dataParameterList, blocks, block, localBlock]);
  useEffect(() => {
    if (document.querySelector('[data-focus-trap="true"]')) return;
    if (formattedValue == "test data" && blockRef.current && isActiveBlock) {
      window.getSelection().selectAllChildren(blockRef.current);
    }
  }, [blockRef, formattedValue, isActiveBlock]);
  useEffect(() => {
    if (!step?.id || !isProfile || !block?.more_details?.profileId || !isFocused)
      return;
    updateSelectedDataProfile(
      { id: block.more_details.profileId },
      true
    );
  }, [isFocused]);
  useEffect(() => {
    if (!isActiveBlock) {
      updateLocalBlock(Object.assign({}, block));
    }
  }, [isFocused, isActiveBlock, block]);
  useEffect(() => {
    if (!block.has_value && !isActiveBlock && !isInitialFocusActivated.current) {
      updateActiveBlockIndex(blockIdx);
      isInitialFocusActivated.current = true;
    }
  }, [block, isActiveBlock]);
  useEffect(() => {
    if (!isActiveBlock && blockRef.current) {
      const currentContent = blockRef.current.textContent;
      if (currentContent !== formattedValue && formattedValue !== void 0) {
        blockRef.current.textContent = formattedValue;
      }
    }
  }, [isActiveBlock, formattedValue]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      "span",
      {
        ...isReadOnly || isDisabled ? {} : { contentEditable: true, suppressContentEditableWarning: true },
        spellCheck: false,
        className: classNames82(
          "px-1 py-0.5 rounded outline-none cursor-pointer flex",
          isActiveBlock ? "bg-warning-200" : " max-w-[350px] min-w-full",
          isResultBlock ? "!text-[#0055CC]" /* RAW_BLOCK */ : "text-unique-500",
          {
            "!max-h-[100px] overflow-y-auto": !isReadOnly && isActiveBlock,
            "whitespace-normal": !isViewOnlySingle
          },
          { "whitespace-nowrap": isNoWrapSteps }
        ),
        ref: (el) => {
          setBlockRef(blockIdx, el);
          blockRef.current = el;
        },
        onClick: toggleActiveBlock,
        onInput: debouncedOnChange,
        children: isIConClicked ? "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022" : (
          // when we input test data we only update the block value and don't update the local block
          formattedValue?.length > 50 && !isActiveBlock && !block?.isEncrypted ? /* @__PURE__ */ jsx(
            TruncatedText,
            {
              value: formattedValue,
              tooltipClassName: "w-[400px]",
              className: classNames82(
                isResultBlock ? "!text-[#0055CC]" /* RAW_BLOCK */ : "!text-unique-500",
                "inline-block"
              )
            }
          ) : formattedValue
        )
      }
    ),
    isFocused && isActiveBlock && showTestDataDropdown && isRawBlock && !isSlashableDropDown && /* @__PURE__ */ jsx(
      TestDataDropdown,
      {
        block,
        blockRef,
        selectedType: "raw" /* raw */,
        onSelect: handleDataTypeChange,
        toggleDropdown,
        allowedTypes: localBlock.more_details?.allowedTypes || [],
        onEncryptChange: (isEncrypted2) => {
          onIconClick(isEncrypted2);
        }
      }
    ),
    isFocused && isActiveBlock && isRawBlock && isSlashableDropDown && !isSlashDropdownVisible && /* @__PURE__ */ jsx(
      dropdown_factory_default,
      {
        blockRef,
        toggleDropdown,
        salesforceActions,
        block,
        blockIdx,
        updateLocalBlock
      }
    ),
    isFocused && isActiveBlock && showTestDataDropdown && isRawBlock && isSlashableDropDown && isSlashDropdownVisible && /* @__PURE__ */ jsx(
      TestDataDropdown,
      {
        block,
        blockRef,
        selectedType: "raw" /* raw */,
        onSelect: handleDataTypeChange,
        toggleDropdown,
        allowedTypes: localBlock.more_details?.allowedTypes || [],
        onEncryptChange: (isEncrypted2) => {
          onIconClick(isEncrypted2);
        }
      }
    ),
    isProfile && isFocused && isActiveBlock && showTestDataDropdown && /* @__PURE__ */ jsx(
      DataProfileDropDown,
      {
        blockRef,
        onSelect: step?.isWriteNLPStep ? handleDataTypeChange : handleForLoopDataChange,
        toggleDropdown,
        selectedValue: "",
        allowedValue: dataProfileList,
        step
      }
    ),
    isSetName && isFocused && isActiveBlock && showTestDataDropdown && Boolean(filteredDataParameterList?.length) && /* @__PURE__ */ jsx(
      DataSetDropDown,
      {
        blockRef,
        onSelect: handleForLoopDataChange,
        toggleDropdown,
        selectedValue: "",
        allowedValue: filteredDataParameterList || [],
        setNameType: localBlock.more_details?.setNameType,
        isLoading: isTDPSetLoading
      }
    ),
    isParameter && isFocused && isActiveBlock && showTestDataDropdown && Boolean(dataSetList?.length) && /* @__PURE__ */ jsx(
      DataParameterDropDown,
      {
        blockRef,
        onSelect: step?.isWriteNLPStep ? handleDataTypeChange : handleForLoopDataChange,
        toggleDropdown,
        selectedValue: "",
        allowedValue: dataSetList || [],
        step
      }
    ),
    isAppName && isFocused && isActiveBlock && showTestDataDropdown && /* @__PURE__ */ jsx(
      app_name_default,
      {
        blockRef,
        onSelect: handleAppNameChange,
        toggleDropdown,
        uploadActions,
        applicationType,
        isFirstTime: block.value == "app-name"
      }
    ),
    isAppVersion && isFocused && isActiveBlock && showTestDataDropdown && uploadActions?.uploadedApp?.id && /* @__PURE__ */ jsx(
      app_versions_default,
      {
        blockRef,
        onSelect: handleAppVersionChange,
        toggleDropdown,
        uploadActions,
        isFirstTime: block.value == "app-version"
      }
    ),
    isSession && isFocused && isActiveBlock && showTestDataDropdown && /* @__PURE__ */ jsx(
      session_default,
      {
        blockRef,
        onSelect: handleSessionNameChange,
        toggleDropdown,
        sessionActions
      }
    )
  ] });
};
var ReadOnlyBlock = ({
  block,
  blockIdx
}) => {
  const { isResultBlock } = useContext(BlockContext);
  return /* @__PURE__ */ jsx(
    "span",
    {
      className: classNames82(
        "px-1 py-0.5 rounded",
        isResultBlock ? "!text-[#091E42]" /* READ_ONLY_BLOCK */ : "text-unique-600"
      ),
      children: block.value
    }
  );
};
var SalesforceFormBlock = ({
  block,
  blockIdx,
  isEdit
}) => {
  const blockRef = useRef(null);
  const {
    isDisabled,
    isReadOnly,
    activeBlockIdx,
    setBlockRef,
    updateActiveBlockIndex,
    updateBlockValue,
    step,
    updateLocalStep
  } = useContext(BlockContext);
  const { onOpenSalesforceAPIFormDrawer, isRecorderView } = useContext(StepContext);
  const isActiveBlock = activeBlockIdx == blockIdx;
  const handleValueChange = useSalesforceAPIFormValueChange(
    block,
    blockIdx,
    updateBlockValue,
    step,
    onOpenSalesforceAPIFormDrawer,
    updateLocalStep
  );
  usePreventInput(blockRef);
  useFormattedPaste(blockRef);
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    "span",
    {
      ...isReadOnly || isDisabled || isRecorderView ? {} : { contentEditable: true, suppressContentEditableWarning: true },
      className: classNames82(
        "text-primary-700 flex py-0.5 px-1 rounded outline-none truncate max-w-[240px] cursor-pointer",
        { "bg-warning-200": isActiveBlock }
      ),
      ref: (el) => {
        setBlockRef(blockIdx, el);
        blockRef.current = el;
      },
      onClick: () => {
        if (!isReadOnly && !isRecorderView) {
          updateActiveBlockIndex(blockIdx);
          handleValueChange(
            "OPEN_SALESFORCE_API_FORM" /* SALESFORCE_API_FORM */,
            "create edit"
          );
        }
      },
      children: block?.value?.length > 30 ? /* @__PURE__ */ jsx(
        TruncatedText,
        {
          className: classNames82("inline-block", "!text-primary-700 "),
          value: block.value
        }
      ) : block.value
    }
  ) });
};
var ListItem7 = ({ onClick, name, selectedValue, currentSelection }) => {
  const isSelected = name == selectedValue;
  return /* @__PURE__ */ jsxs(
    DropdownItem,
    {
      onClick: () => onClick(name),
      className: classNames82(
        "flex items-center text-secondary-800 all-small-caps  uppercase !py-1",
        {
          "!text-primary-500": isSelected,
          "bg-secondary-100": currentSelection
        }
      ),
      children: [
        name,
        " ",
        isSelected && /* @__PURE__ */ jsx(Icon, { name: "check-circle", className: "ml-2 text-base" })
      ]
    }
  );
};
var SelectableValueDropdown = ({
  selectedValue,
  onSelect,
  toggleDropdown,
  blockRef,
  allowedValue
}) => {
  const [currentSelection, updateCurrentSelection] = useState(
    () => allowedValue.findIndex((item) => item == allowedValue)
  );
  const [dropdownRef, setDropdownRef] = useState(null);
  const { styles, attributes } = usePopper(blockRef.current, dropdownRef, {
    placement: "bottom-start",
    strategy: "fixed"
  });
  const filteredOptions = allowedValue;
  const handleKeyMovements = useCallback(
    (event) => {
      event.preventDefault();
      if (event.code == "ArrowUp") {
        updateCurrentSelection(
          boundedIncrementDecrement(
            currentSelection,
            0,
            filteredOptions.length - 1,
            -1
          )
        );
      } else if (event.code == "ArrowDown") {
        updateCurrentSelection(
          boundedIncrementDecrement(
            currentSelection,
            0,
            filteredOptions.length - 1,
            1
          )
        );
      } else if (event.code == "Escape") {
        toggleDropdown(false);
      } else if (event.code == "Enter") {
        onSelect(filteredOptions[currentSelection]);
        toggleDropdown();
      }
    },
    [currentSelection, filteredOptions, onSelect]
  );
  useEffect(() => {
    blockRef.current?.addEventListener("keydown", handleKeyMovements);
    return () => blockRef.current?.removeEventListener("keydown", handleKeyMovements);
  }, [blockRef, handleKeyMovements]);
  return /* @__PURE__ */ jsx(
    Dropdown,
    {
      className: "w-[160px] min-w-[90px] z-[1000]",
      toggleDropdown,
      setRef: setDropdownRef,
      style: styles.popper,
      attributes: attributes.popper,
      children: filteredOptions.map((item, idx) => /* @__PURE__ */ jsx(
        ListItem7,
        {
          onClick: () => onSelect(item),
          selectedValue,
          name: item,
          currentSelection: currentSelection == idx
        },
        `${item.type}_${idx}`
      ))
    },
    "drop-down"
  );
};
var SelectableBlock = ({
  block,
  blockIdx
}) => {
  const blockRef = useRef(null);
  const {
    isDisabled,
    isResultBlock,
    isReadOnly,
    activeBlockIdx,
    setBlockRef,
    isFocused,
    updateActiveBlockIndex,
    updateBlockValue,
    saveHandler,
    blocks,
    step
  } = useContext(BlockContext);
  const isActiveBlock = activeBlockIdx == blockIdx;
  const [showDropdown, toggleShowTestDataDropdown] = useState(false);
  const toggleDropdown = useCallback(
    (state) => {
      updateActiveBlockIndex(state ? blockIdx : null);
      toggleShowTestDataDropdown(false);
    },
    [blockIdx, updateActiveBlockIndex]
  );
  const handleValueChange = useCallback(
    (value) => {
      const nextIndex = blocks.findIndex(
        (item, idx) => idx > blockIdx && item.type != "readonly_text" /* readonly_text */
      );
      updateBlockValue({ ...block, value, has_value: !!value }, blockIdx);
      toggleShowTestDataDropdown(false);
      if (nextIndex != -1)
        window.setTimeout(() => updateActiveBlockIndex(nextIndex), 250);
    },
    [block, blockIdx, updateBlockValue]
  );
  const toggleActiveBlock = useCallback(() => {
    if (!isActiveBlock) {
      updateActiveBlockIndex(blockIdx);
    }
    toggleShowTestDataDropdown(true);
  }, [blockIdx, updateActiveBlockIndex, isActiveBlock]);
  usePreventInput(blockRef);
  useHandleEnter(blockRef, false, saveHandler);
  useFormattedPaste(blockRef);
  useEffect(() => {
    if (activeBlockIdx == blockIdx && !showDropdown) {
      blockRef.current?.click();
      blockRef.current?.focus();
    }
  }, [activeBlockIdx]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      "span",
      {
        ...isReadOnly || isDisabled ? {} : { contentEditable: true, suppressContentEditableWarning: true },
        spellCheck: false,
        className: classNames82(
          "px-1 py-0.5 rounded outline-none all-small-caps caret-transparent cursor-pointer uppercase",
          isResultBlock ? "!text-[#6E5DC6]" /* SELECTABLE_BLOCK */ : "text-violet-700",
          { "bg-warning-200": activeBlockIdx == blockIdx }
        ),
        ref: (el) => {
          setBlockRef(blockIdx, el);
          blockRef.current = el;
        },
        onClick: toggleActiveBlock,
        children: block.value
      }
    ),
    isFocused && isActiveBlock && showDropdown && !step?.isStepGroupChild && /* @__PURE__ */ jsx(
      SelectableValueDropdown,
      {
        selectedValue: block.value,
        blockRef,
        onSelect: handleValueChange,
        allowedValue: block.more_details.allowedValues,
        toggleDropdown
      }
    )
  ] });
};
var TestDataBlock = ({
  block,
  blockIdx
}) => {
  const blockRef = useRef(null);
  const {
    isDisabled,
    isReadOnly,
    isResultBlock,
    activeBlockIdx,
    setBlockRef,
    isFocused,
    updateActiveBlockIndex,
    getTestData: getTestData2,
    updateBlockValue,
    disableAllowActiveIndexUpdate,
    isActiveIndexUpdateDisabled
  } = useContext(BlockContext);
  const { isRecorderView } = useContext(StepContext);
  const isActiveBlock = activeBlockIdx == blockIdx;
  const toggleDropdown = useCallback(
    (state) => {
      updateActiveBlockIndex(
        state && !isActiveIndexUpdateDisabled ? blockIdx : null
      );
    },
    [blockIdx, updateActiveBlockIndex, isActiveIndexUpdateDisabled]
  );
  const handleValueChange = useTestDataValueChange(
    block,
    getTestData2,
    updateBlockValue,
    blockIdx,
    disableAllowActiveIndexUpdate
  );
  const toggleActiveBlock = useCallback(() => {
    if (!isActiveBlock) {
      updateActiveBlockIndex(blockIdx);
    }
  }, [activeBlockIdx, updateActiveBlockIndex, blockIdx]);
  usePreventInput(blockRef);
  useFormattedPaste(blockRef);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("span", { className: "flex items-center justify-center cursor-pointer", children: [
      /* @__PURE__ */ jsx(TestDataSymbol, { type: block.type }),
      /* @__PURE__ */ jsx(
        "span",
        {
          ...isReadOnly || isDisabled ? {} : { contentEditable: true, suppressContentEditableWarning: true },
          spellCheck: false,
          className: classNames82(
            "flex pr-1 py-0.5 rounded outline-none max-w-[350px]",
            {
              "bg-warning-200": isActiveBlock,
              "caret-[#fde68a]": block?.type !== "raw" && block?.type !== "random",
              "!max-w-[200px]": isRecorderView
            },
            isResultBlock ? "!text-[#0055CC]" /* TEST_DATA_BLOCK */ : "!text-unique-500"
          ),
          ref: (el) => {
            setBlockRef(blockIdx, el);
            blockRef.current = el;
          },
          onClick: toggleActiveBlock,
          children: /* @__PURE__ */ jsx(
            TruncatedText,
            {
              value: block.value,
              tooltipClassName: "w-[400px]",
              className: classNames82(
                isResultBlock ? "!text-[#0055CC]" /* TEST_DATA_BLOCK */ : "!text-unique-500",
                "inline-block"
              )
            }
          )
        }
      )
    ] }),
    isFocused && isActiveBlock && /* @__PURE__ */ jsx(
      TestDataDropdown,
      {
        block,
        blockRef,
        selectedType: block?.type || "raw" /* raw */,
        onSelect: handleValueChange,
        toggleDropdown,
        allowedTypes: block.more_details?.allowedTypes || []
      }
    )
  ] });
};
var BlockWrapper = ({
  block,
  blockIdx,
  isEdit
}) => {
  const testDataBlockTypes = [
    "global" /* global */,
    "runtime" /* runtime */,
    "mail_box" /* mail_box */,
    "phone_number" /* phone_number */,
    "function" /* function */,
    "parameter" /* parameter */,
    "upload_path" /* upload_path */
  ];
  const { isResultBlock } = useContext(BlockContext);
  const resultBlockKey = {
    ...isResultBlock ? { key: `${block?.value}-${blockIdx}` } : {}
  };
  switch (block.type) {
    case "raw" /* raw */:
      return /* @__PURE__ */ jsx(RawBlock, { block, blockIdx, ...resultBlockKey });
    case "salesforce_object_form" /* salesforce_object_form */:
      return /* @__PURE__ */ jsx(
        SalesforceFormBlock,
        {
          block,
          blockIdx,
          isEdit,
          ...resultBlockKey
        }
      );
    case "random" /* random */:
      return /* @__PURE__ */ jsx(RandomBlock, { block, blockIdx, ...resultBlockKey });
    case "ui_identifier" /* ui_identifier */:
      return /* @__PURE__ */ jsx(
        ElementBlock,
        {
          block,
          blockIdx,
          isEdit,
          ...resultBlockKey
        }
      );
    case "attribute" /* attribute */:
      return /* @__PURE__ */ jsx(AttributeBlock, { block, blockIdx, ...resultBlockKey });
    case "selectable" /* selectable */:
      return /* @__PURE__ */ jsx(
        SelectableBlock,
        {
          block,
          blockIdx,
          ...resultBlockKey
        }
      );
    case "editable_text" /* editable_text */:
      return /* @__PURE__ */ jsx(
        EditableTextBlock,
        {
          block,
          blockIdx,
          ...resultBlockKey
        }
      );
    case "action" /* action */:
      return /* @__PURE__ */ jsx(ActionBlock, { block, blockIdx, ...resultBlockKey });
    default:
      if (testDataBlockTypes.includes(block.type)) {
        return /* @__PURE__ */ jsx(
          TestDataBlock,
          {
            block,
            blockIdx,
            ...resultBlockKey
          }
        );
      }
      return /* @__PURE__ */ jsx(ReadOnlyBlock, { block, blockIdx, ...resultBlockKey });
  }
};
var isGenericElementName2 = (name) => {
  if (!name) return true;
  return /^element\d*$/i.test(name.trim());
};
function MobileDirectElementCapture({
  onClose,
  onElementCaptured,
  nlpId = null,
  uuid,
  stepId,
  applicationType,
  elementName: elementName2,
  versionId
}) {
  const [capturedElementData, setCapturedElementData] = useState();
  const [isProcessing, setIsProcessing] = useState(false);
  const [appDisplayName, setAppDisplayName] = useState(
    window.mobileInspectorState?.appDisplayName || null
  );
  useEffect(() => {
    const handler = (e) => {
      const name = e.detail;
      setAppDisplayName(name);
      window.mobileInspectorState = {
        ...window.mobileInspectorState,
        appDisplayName: name
      };
    };
    window.addEventListener("APP_NAME_SELECTED", handler);
    return () => window.removeEventListener("APP_NAME_SELECTED", handler);
  }, []);
  const processedRef = useRef(false);
  const generateElementName2 = (elementData) => {
    if (elementName2) {
      if (isGenericElementName2(elementName2)) {
        if (elementData?.text && elementData.text.trim()) {
          return elementData.text.trim().substring(0, 50).replace(/\s+/g, " ");
        }
        if (elementData?.name && elementData.name.trim()) {
          return elementData.name.trim().substring(0, 50).replace(/\s+/g, " ");
        }
        if (elementData?.type) {
          return elementData.type;
        }
        if (elementData?.contentDesc) {
          return elementData.contentDesc;
        }
        if (elementData?.name) {
          return elementData.name;
        }
        if (elementData?.tag) {
          return `${elementData.tag} element`;
        }
        return `captured element ${Date.now()}`;
      } else {
        return elementName2;
      }
    }
    if (elementData?.text && elementData.text.trim()) {
      return elementData.text.trim().substring(0, 50).replace(/\s+/g, " ");
    }
    if (elementData?.name && elementData.name.trim()) {
      return elementData.name.trim().substring(0, 50).replace(/\s+/g, " ");
    }
    if (elementData?.type) {
      return elementData.type;
    }
    if (elementData?.contentDesc) {
      return elementData.contentDesc;
    }
    if (elementData?.tag) {
      return `${elementData.tag} element`;
    }
    return `captured element ${Date.now()}`;
  };
  const processElementData = useCallback(
    (elementData) => {
      const processedData = {
        ...elementData,
        name: generateElementName2(elementData),
        definition: elementData.definition,
        locatorType: elementData.locatorType,
        screenName: appDisplayName ? `${appDisplayName} Screen` : elementData.screenName || "Mobile Screen",
        screenTitle: elementData.screenTitle || "Default Screen",
        elementUuid: uuid || v4(),
        applicationType,
        versionId
      };
      return processedData;
    },
    [uuid, elementName2, applicationType, versionId, appDisplayName]
  );
  const handleMobileElementSelection = useCallback(
    async (event, data) => {
      const hasUniquenessCounts = Object.keys(data || {}).some(
        (key) => key.endsWith("ElementCount")
      );
      if (!hasUniquenessCounts) return;
      if (processedRef.current || isProcessing) return;
      processedRef.current = true;
      setIsProcessing(true);
      try {
        setCapturedElementData(data);
        const processedData = processElementData(data);
        if (window.mobileDirectCaptureResolver) {
          window.mobileDirectCaptureResolver({
            action: "SELECTED",
            details: {
              // Use the processed name (which should be "TabOverviewButton")
              name: processedData.name,
              // Return the raw data so parent context can create the element
              rawElementData: {
                ...data,
                // Ensure the raw data also has the correct name
                name: processedData.name
              },
              processedData: {
                ...processedData,
                // Ensure the processed data also has the correct name
                name: processedData.name
              }
            },
            autoSave: true
          });
        }
        if (onElementCaptured) {
          onElementCaptured({
            name: processedData.name,
            ...data
          });
        }
        onClose();
      } catch (error) {
        console.error("Mobile element capture failed:", error);
        if (window.mobileDirectCaptureResolver) {
          window.mobileDirectCaptureResolver({
            action: "DISCARDED",
            error: error.message
          });
        }
        toastify("Failed to capture element", {
          type: "error",
          position: "top-center",
          autoClose: 3e3,
          hideProgressBar: true
        });
        onClose();
      } finally {
        setIsProcessing(false);
      }
    },
    [onElementCaptured, onClose, processElementData, isProcessing, elementName2]
  );
  useInternalEvents(
    ["mi-selected-element-detail"],
    handleMobileElementSelection
  );
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Escape") {
        if (window.mobileDirectCaptureResolver) {
          window.mobileDirectCaptureResolver({
            action: "DISCARDED"
          });
        }
        onClose();
      }
    };
    document.addEventListener("keydown", handleKeyPress);
    return () => document.removeEventListener("keydown", handleKeyPress);
  }, [onClose]);
  useEffect(() => {
    window.mobileDirectCaptureActive = true;
    return () => {
      window.mobileDirectCaptureActive = false;
      processedRef.current = false;
      setIsProcessing(false);
    };
  }, []);
  return null;
}
var findFirstNonReadOnlyTextIndex = (data, step) => {
  for (let i = 0; i < data.length; i++) {
    if (data[i].type !== "readonly_text" && (!isObjectBased(step) || !data[i]?.more_details?.isReadOnly && !data[i]?.has_value)) {
      return i;
    }
  }
  return -1;
};
var NlpInput = ({
  blocks,
  onChange,
  className,
  getTestData: getTestData2,
  isResultBlock = false,
  isReadOnly = false,
  isNoWrap = false,
  isDisabled = false,
  isFocused = false,
  updateStepFocused = () => {
  },
  step,
  updateLocalStep,
  isEdit,
  isNlpSuggestionAllowed = false,
  onSearch,
  isFetching,
  isCommand,
  isCommandCombine,
  onChangeType,
  saveHandler = NOOP,
  onDropdownToggle = NOOP,
  dataParameterList,
  dataProfileList,
  dataSetList,
  customFunctionList,
  inputAutoFocusEnabled = true,
  updateSelectedDataProfile,
  isStepResult = false,
  fetchConnections = NOOP,
  actionCallback,
  salesforceActions,
  uploadActions,
  sessionActions,
  flexGrow,
  setStepAndBlockValues,
  isNestedStepGroupStep,
  optionalGrammarTemplates,
  prevLocalBlocks
}) => {
  const isMounted = useRef(false);
  const nlpInputRef = useRef(null);
  const blocksRef = useRef({});
  const node = useRef(null);
  const nlpContainerRef = useRef(null);
  const { t } = useTranslation();
  const [localBlocks, updateLocalBlocks] = useState(
    () => cleanInputBlocks(blocks)
  );
  const [templateId, updateTemplateId] = useState(
    blocks.find((block) => block.more_details)?.more_details?.templateId
  );
  const [showMobileDirectCapture, setShowMobileDirectCapture] = useState(false);
  const [mobileDirectCaptureDetail, setMobileDirectCaptureDetail] = useState(null);
  const { applicationType, versionId } = useContext(StepContext);
  const { isDebugger } = useRecorderContext();
  const getUpdatedLocalBlockValues = (block, block_idx) => {
    let blocks2 = [...localBlocks];
    if (prevLocalBlocks?.length == localBlocks?.length) {
      blocks2 = localBlocks.map((currBlock, idx) => {
        const prevBlock = prevLocalBlocks[idx];
        const blockKeysToPreserve = ["variableId", "templateId"];
        blockKeysToPreserve.forEach((key) => {
          if (currBlock?.more_details?.[key] === void 0 && prevBlock?.more_details?.[key] !== void 0) {
            currBlock.more_details[key] = prevBlock?.more_details?.[key];
          }
        });
        return currBlock;
      });
    }
    if (block?.more_details?.onChangeClearNextBlocks)
      blocks2 = blocks2.slice(0, block_idx + 1);
    blocks2[block_idx] = block;
    return blocks2;
  };
  const updateBlockValue = (block, block_idx) => {
    const updatedBlock = getUpdatedLocalBlockValues(block, block_idx);
    onChange(updatedBlock);
    updateLocalBlocks(updatedBlock);
  };
  const updateMultiBlockValue = useCallback(
    (_blocks) => {
      updateLocalBlocks((prevBlocks) => {
        let blocks2 = [...prevBlocks];
        blocks2 = blocks2.map((block) => {
          if (block.type == NLP_BLOCK_TYPE.readonly_text) return block;
          const _block = _blocks.find((b) => b.uuid == block.uuid);
          return _block || block;
        });
        onChange(blocks2);
        return blocks2;
      });
    },
    [localBlocks, updateLocalBlocks, onChange]
  );
  const setBlockRef = useCallback(
    (blockIdx, ref) => {
      blocksRef.current[blockIdx] = ref;
      blocksRef.current = Object.assign({}, blocksRef.current);
    },
    [blocksRef]
  );
  const customFunctionData = useCallback(
    (customFunction, data) => {
      const { step: stepValue, tempBlocks } = setStepAndBlockValues(
        customFunction,
        data
      );
      updateLocalStep?.(stepValue);
      updateLocalBlocks([...tempBlocks]);
      onChange(tempBlocks);
    },
    [setStepAndBlockValues, updateLocalStep, onChange]
  );
  const {
    openCustomFunctionParameterDrawer,
    isRecorderView,
    isWebRecorder,
    hasFeatureValue: hasFeatureValue2,
    isNoWrapSteps
  } = useContext(StepContext);
  const onUpdateCustomFunctionBlock = (customFunction) => {
    if (Object.keys(customFunction?.arguments?.arg_types)?.length) {
      openCustomFunctionParameterDrawer(
        customFunction,
        step?.stepDetail?.customStep,
        step?.isStepGroupChild
      ).then((res) => {
        if (res?.action !== "DISCARDED") {
          customFunctionData(customFunction, res);
        }
      });
    } else {
      customFunctionData(customFunction);
    }
  };
  const onUpdateBlock = useCallback(
    (template) => {
      let tempBlocks;
      if (template.isAddon) {
        step.kibbutzPluginNlpData = step.kibbutzPluginNlpData || new KibbutzNLPDataModel();
        step.kibbutzPluginNlpData.uiIdentifiers = step.kibbutzPluginNlpData.uiIdentifiers || /* @__PURE__ */ new Map();
        step.kibbutzPluginNlpData.testData = step.kibbutzPluginNlpData.testData || /* @__PURE__ */ new Map();
        step.kibbutzPluginNlpId = template.id;
        tempBlocks = getStepKibbutzBlocks(step, template);
      } else {
        step.templateId = template.id;
        step.screenshotStrategy = template?.screenshotStrategy;
        tempBlocks = getStepNlpBlocks(
          step,
          template,
          null,
          hasFeatureValue2,
          optionalGrammarTemplates
        );
        step.kibbutzPluginNlpData = null;
        step.kibbutzPluginNlpId = null;
      }
      updateLocalStep?.(step);
      updateLocalBlocks([...tempBlocks]);
      onChange(tempBlocks);
    },
    [
      step,
      updateLocalStep,
      onChange,
      hasFeatureValue2,
      optionalGrammarTemplates
    ]
  );
  useEffect(() => {
    const currentTemplateId = blocks.find((block) => block.more_details)?.more_details?.templateId;
    if (templateId != currentTemplateId) updateTemplateId(currentTemplateId);
  }, [step, templateId]);
  const {
    activeBlockIdx,
    updateActiveIndex,
    disableAllowActiveIndexUpdate,
    isActiveIndexUpdateDisabled
  } = useKeyNavigation(
    templateId,
    nlpInputRef,
    isFocused,
    isReadOnly,
    isDisabled,
    blocksRef,
    updateStepFocused,
    inputAutoFocusEnabled,
    localBlocks
  );
  useEffect(() => {
    if (localBlocks?.length > 1 && !step?.id && !isMounted.current) {
      const editableIndex = findFirstNonReadOnlyTextIndex(localBlocks, step);
      editableIndex != -1 && updateActiveIndex(editableIndex);
      isMounted.current = true;
    }
  }, [localBlocks, step, isMounted]);
  useEffect(() => {
    if (JSON.stringify(blocks) != JSON.stringify(localBlocks))
      updateLocalBlocks(() => blocks);
  }, [blocks]);
  const handleMobileDirectCaptureEvent = useCallback(
    (event) => {
      setMobileDirectCaptureDetail(event.detail);
      setShowMobileDirectCapture(true);
      if (isDebugger) {
        logEvent(
          analytics_constants_default.AMPLITUDE.LIVE_EDITOR_ELEMENT_CAPTURE_START,
          { applicationType }
        );
      }
    },
    [isDebugger, applicationType]
  );
  const handleCloseMobileDirectCapture = useCallback(() => {
    setShowMobileDirectCapture(false);
    setMobileDirectCaptureDetail(null);
    if (isDebugger) {
      logEvent(
        analytics_constants_default.AMPLITUDE.LIVE_EDITOR_ELEMENT_CAPTURE_STOP,
        {
          applicationType
        }
      );
    }
  }, [isDebugger, applicationType]);
  const handleMobileElementCaptured = useCallback((elementData) => {
    console.log("Mobile element captured:", elementData);
    handleCloseMobileDirectCapture();
  }, []);
  useEffect(() => {
    const mobileAppTypes = [
      ApplicationType.AndroidNative?.toString(),
      ApplicationType.IOSNative?.toString()
    ];
    if (mobileAppTypes.includes(applicationType)) {
      window.addEventListener(
        "trigger-mobile-direct-capture",
        handleMobileDirectCaptureEvent
      );
      return () => {
        window.removeEventListener(
          "trigger-mobile-direct-capture",
          handleMobileDirectCaptureEvent
        );
      };
    }
  }, [applicationType, handleMobileDirectCaptureEvent]);
  return /* @__PURE__ */ jsxs(
    BlockContext.Provider,
    {
      value: {
        blocks: localBlocks,
        isDisabled,
        isFocused,
        isResultBlock,
        isReadOnly,
        getTestData: getTestData2,
        activeBlockIdx,
        setBlockRef,
        updateActiveBlockIndex: updateActiveIndex,
        blocksRef,
        updateBlockValue,
        onSearch,
        isFetching,
        isCommand,
        isCommandCombine,
        disableAllowActiveIndexUpdate,
        isActiveIndexUpdateDisabled,
        saveHandler,
        dataParameterList,
        dataProfileList,
        dataSetList,
        updateSelectedDataProfile,
        isStepResult,
        step,
        isNoWrap,
        isNoWrapSteps,
        fetchConnections,
        actionCallback,
        salesforceActions,
        uploadActions,
        sessionActions,
        updateLocalStep,
        isNestedStepGroupStep,
        updateMultiBlockValue
      },
      children: [
        /* @__PURE__ */ jsxs(
          "div",
          {
            "data-nlpinput": true,
            ref: (el) => {
              nlpInputRef.current = el;
              node.current = el;
            },
            className: classNames82(
              "outline-none whitespace-nowrap flex items-center relative",
              "text-small leading-5",
              { "grayscale opacity-50": isDisabled },
              { "overflow-hidden": !isNoWrapSteps },
              {
                "flex-grow": !flexGrow,
                "py-[3.2px]": !isStepResult && !isRecorderView && !isWebRecorder && !isResultBlock
              },
              className
            ),
            children: [
              /* @__PURE__ */ jsx(
                "div",
                {
                  className: classNames82(
                    "w-full flex items-center relative text-small leading-5 flex-grow",
                    { "flex-wrap": !isNoWrap && !isNoWrapSteps }
                  ),
                  ref: (el) => nlpContainerRef.current = el,
                  style: { maxWidth: "100%" },
                  children: localBlocks.map((block, block_idx) => /* @__PURE__ */ jsx(
                    ToolTip,
                    {
                      content: isNestedStepGroupStep && !(block.type == NLP_BLOCK_TYPE.readonly_text) ? t("common.nested_step_can_not_editable") : "",
                      className: block.type === NLP_BLOCK_TYPE.editable_text ? "w-full" : "max-w-full",
                      children: /* @__PURE__ */ jsx(
                        BlockWrapper,
                        {
                          block,
                          blockIdx: block_idx,
                          isEdit
                        },
                        `${block_idx}_${block?.uuid}${block?.bulkUpdatedTime ? `_${block?.bulkUpdatedTime}` : ""}`
                      )
                    },
                    block_idx
                  ))
                }
              ),
              isNlpSuggestionAllowed && /* @__PURE__ */ jsx(
                StepDropDownWrapper,
                {
                  node,
                  onChange: onUpdateBlock,
                  onChangeCunstomFunction: onUpdateCustomFunctionBlock,
                  activeBlockIdx,
                  onChangeType,
                  onDropdownToggle,
                  buttonRef: nlpContainerRef,
                  step,
                  dataProfileList,
                  customFunctionList
                }
              )
            ]
          }
        ),
        showMobileDirectCapture && /* @__PURE__ */ jsx(
          MobileDirectElementCapture,
          {
            onClose: handleCloseMobileDirectCapture,
            onElementCaptured: handleMobileElementCaptured,
            nlpId: mobileDirectCaptureDetail?.nlpId,
            uuid: mobileDirectCaptureDetail?.uuid,
            stepId: mobileDirectCaptureDetail?.stepId,
            applicationType: mobileDirectCaptureDetail?.applicationType,
            versionId: versionId?.toString(),
            elementName: mobileDirectCaptureDetail?.name
          }
        )
      ]
    }
  );
};
var FormattedBlockStep = ({
  step,
  isViewOnly,
  isFocused,
  updateFocused,
  updateLocalStep,
  isResultBlock
}) => {
  const handleValueChange = useCallback(
    (blocks) => {
      if (!updateLocalStep) return;
      try {
        const updatedAction = blocksToText(blocks);
        const updatedStep = new TestStep().deserialize({
          ...step,
          action: updatedAction
        });
        updateLocalStep(updatedStep);
      } catch (error) {
        throw new Error("Failed to update step action", error);
      }
    },
    [step, updateLocalStep]
  );
  const containerClassNames = classNames82(
    "text-secondary-700 text-small leading-5 flex items-center",
    {
      "grayscale opacity-50": step.disabled
      // Add grayscale effect if the step is disabled
    },
    {
      "w-full": isResultBlock
    }
  );
  return /* @__PURE__ */ jsx("div", { className: containerClassNames, children: /* @__PURE__ */ jsx(
    NlpInput,
    {
      blocks: [
        {
          value: step.action || "",
          type: "editable_text" /* editable_text */,
          isBlock: isBlock(step)
        }
      ],
      onChange: handleValueChange,
      isReadOnly: isViewOnly,
      isDisabled: step.disabled || step?.isParentStepGroupDisabled,
      isFocused,
      updateFocused,
      isResultBlock
    }
  ) });
};
var block_default = FormattedBlockStep;
var FormattedCustomFunctionStep = ({
  step,
  isFocused,
  updateFocused,
  customFunctionList,
  onChange,
  openCustomFunctionParameterDrawer,
  updateLocalStep,
  onSearch,
  isViewOnly
}) => {
  const { t } = useTranslation();
  const { customFunctionActions } = useContext(StepContext);
  const blockValue = step?.stepDetail?.customStep?.className && step?.stepDetail?.customStep?.functionName ? t("step.type.custom_function_value", {
    className: step.stepDetail.customStep.className,
    methodName: step.stepDetail.customStep.functionName
  }) : "";
  const setStepAndBlockValues = useCallback(
    (customFunction, data) => {
      const customStepData = new CustomStep().deserialize(customFunction);
      customStepData.className = customFunction.className;
      customStepData.functionName = customFunction.name;
      customStepData.type = 3;
      const argumentsValue = data?.details?.reduce((acc, item) => {
        acc[item.argumentName] = item.argumentValue;
        return acc;
      }, {}) || {};
      customStepData.arguments = argumentsValue;
      customStepData.argumentTypes = customFunction.arguments.arg_types;
      step.stepDetail = new StepDetailsDataMap();
      step.stepDetail.customStep = customStepData;
      step.action = customFunction.className;
      step.stepDetail.customFunctionId = customFunction.id;
      const value = customStepData.className && customStepData.functionName ? t("step.type.custom_function_value", {
        className: customStepData.className,
        methodName: customStepData.functionName
      }) : "";
      const tempBlocks = [
        {
          value: value || "",
          type: "editable_text" /* editable_text */,
          canEncrypt: false,
          isEncrypted: false
        }
      ];
      return { step, tempBlocks };
    },
    [step, t]
  );
  const handleParameterDrawerClick = async () => {
    let customFunction = customFunctionList?.find(
      (item) => item.id === step?.stepDetail?.customStep?.id
    );
    if (!customFunction) {
      const customFunctions = await customFunctionActions?.fetchCustomFunctions(
        step?.stepDetail?.customStep?.functionName
      );
      customFunction = customFunctions?.content?.find(
        (item) => item.id === step?.stepDetail?.customStep.id
      );
    }
    if (customFunction && openCustomFunctionParameterDrawer) {
      openCustomFunctionParameterDrawer(
        customFunction,
        step?.stepDetail?.customStep,
        step?.isStepGroupChild
      ).then((res) => {
        if (res?.action !== "DISCARDED") {
          const { step: modifiedStep, tempBlocks } = setStepAndBlockValues(
            customFunction,
            res
          );
          updateLocalStep(modifiedStep);
          onChange(tempBlocks);
        }
      });
    }
  };
  const generateBlockValue = () => [
    generateBlock(
      isViewOnly ? "readonly_text" /* readonly_text */ : "editable_text" /* editable_text */,
      blockValue || "",
      "customfunction-block",
      false,
      {},
      false
    )
  ];
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames82(
        "text-secondary-700 text-small leading-5 flex-grow flex items-center",
        { "grayscale opacity-50": step.disabled }
      ),
      children: [
        /* @__PURE__ */ jsx(
          NlpInput,
          {
            blocks: generateBlockValue(),
            isDisabled: step.disabled,
            isFocused,
            updateFocused,
            isNlpSuggestionAllowed: true,
            step,
            customFunctionList,
            openCustomFunctionParameterDrawer,
            onChange,
            updateLocalStep,
            onSearch,
            setStepAndBlockValues
          }
        ),
        step?.stepDetail?.customStep?.className && !isViewOnly && /* @__PURE__ */ jsx(
          "div",
          {
            className: "cursor-pointer text-button-link-text-default text-sm",
            onClick: handleParameterDrawerClick,
            children: t("step.view.parameters")
          }
        )
      ]
    }
  );
};
var custom_function_default = FormattedCustomFunctionStep;
var FormattedNlpStep = ({
  step,
  getTestData: getTestData2,
  onChange,
  isResultBlock,
  isViewOnly,
  isFocused,
  updateFocused,
  updateWatchFocusOut,
  updateLocalStep,
  onSearch,
  isFetching,
  isCommand,
  isCommandCombine,
  onChangeType,
  onSave,
  dataParameterList,
  dataProfileList,
  customFunctionList,
  dataSetList,
  updateSelectedDataProfile,
  template,
  stepsInfo,
  updateStepsInfo,
  isViewOnlySingle = false,
  isStepResult = false,
  fetchConnections = NOOP,
  actionCallback,
  salesforceActions,
  uploadActions,
  sessionActions,
  isNestedStepGroupStep,
  prevLocalBlocks
}) => {
  const isMobile = step.isAndroidApp || step.isIOSApp;
  const { hasFeatureValue: hasFeatureValue2, nlActions } = useContext(StepContext);
  const { hasFeatureValue: hasFeatureResultValue, nlActions: resultNlActions } = useContext(StepResultContext);
  const hasFeature = (name) => {
    return hasFeatureValue2?.(name) || hasFeatureResultValue?.(name);
  };
  const getOptionalTemplates = (initialTemplate, nlpActions) => {
    const templatesList = [];
    let currentTemplate = initialTemplate;
    while (currentTemplate?.optionalTemplateId && templatesList.length < OPTIONAL_TEMPLATES_LIMIT) {
      const optionalTemplate = nlpActions?.find(
        (action) => action?.id === currentTemplate.optionalTemplateId
      );
      if (optionalTemplate) {
        templatesList.push(optionalTemplate);
        currentTemplate = optionalTemplate;
      } else {
        break;
      }
    }
    return templatesList;
  };
  const optionalGrammarTemplates = useMemo(() => {
    return getOptionalTemplates(
      template,
      nlActions?.length > 0 ? nlActions : resultNlActions
    );
  }, [nlActions, resultNlActions, template]);
  const setSmartActionsSupported = () => {
    updateLocalStep?.(
      Object.assign({}, step, {
        smartActionsSupported: template?.smartActionsSupported
      })
    );
  };
  useEffect(() => {
    setSmartActionsSupported();
  }, []);
  const dataValue = useMemo(() => {
    return template ? template.isAddon ? getStepKibbutzBlocks(step, template) : getStepNlpBlocks(
      step,
      template,
      isFocused,
      hasFeature,
      optionalGrammarTemplates
    ) : step.id && template ? [
      {
        type: "editable_text" /* editable_text */,
        value: step.action || "",
        more_details: {}
      }
    ] : [
      {
        type: "editable_text" /* editable_text */,
        value: step.action || "",
        more_details: {
          placeholder_type: isMobile ? "mobile" : step.isMobileApp ? "mobile-web" : isObjectBased(step) ? "windows_advanced" : "web"
        }
      }
    ];
  }, [template, step, isFocused, isMobile]);
  const updateNlpContainerWidth = useCallback(
    (width, stepId) => {
      const localNlpContainerWidth = Object.assign(
        {},
        stepsInfo?.nlpContainerWidth
      );
      if (localNlpContainerWidth) {
        localNlpContainerWidth[stepId] = width;
      }
      if (updateStepsInfo)
        updateStepsInfo(`nlpContainerWidth`, localNlpContainerWidth);
    },
    [stepsInfo, updateStepsInfo]
  );
  const handleSetTemplate = useCallback(
    (templateText) => {
      if (isFocused) {
        step.templateId = templateText?.id;
        updateLocalStep?.(step);
        onChange(getStepNlpBlocks(step, templateText, isFocused, hasFeature));
        return step;
      }
    },
    [step, onChange, updateLocalStep]
  );
  const internalEventHandler = useCallback(
    (eventName, templateText = null) => {
      if (eventName == "add-help-action-step") {
        handleSetTemplate(templateText);
      }
    },
    [handleSetTemplate]
  );
  useInternalEvents(["add-help-action-step"], internalEventHandler);
  return /* @__PURE__ */ jsx(
    NlpInput,
    {
      blocks: dataValue,
      onChange,
      getTestData: getTestData2,
      updateStepFocused: (focussed) => !stepsInfo?.isStepTypeSwitchOpened && updateWatchFocusOut?.(!focussed),
      isResultBlock,
      isReadOnly: isViewOnly,
      isNoWrap: isViewOnlySingle,
      isDisabled: step.disabled || step.isParentStepGroupDisabled,
      isFocused,
      updateFocused,
      onSearch,
      onDropdownToggle: () => updateWatchFocusOut(true),
      onChangeType,
      isFetching,
      isCommand,
      isCommandCombine,
      updateLocalStep,
      step,
      isNlpSuggestionAllowed: Boolean(
        !step.templateId && !step.kibbutzPluginNlpId || step?.isCustomFunction
      ),
      inputAutoFocusEnabled: !step.id,
      isEdit: Boolean(step.id),
      saveHandler: onSave,
      dataParameterList,
      dataProfileList,
      customFunctionList,
      dataSetList,
      updateSelectedDataProfile,
      containerWidth: stepsInfo?.nlpContainerWidth?.[step.id],
      updateNlpContainerWidth: (width) => updateNlpContainerWidth(width, step.id),
      isStepResult,
      fetchConnections,
      actionCallback,
      salesforceActions,
      uploadActions,
      sessionActions,
      isNestedStepGroupStep,
      optionalGrammarTemplate: optionalGrammarTemplates,
      prevLocalBlocks
    },
    template?.id
  );
};
var nlp_default = FormattedNlpStep;
var createTestDataMapValue = (value, key, type = TestDataType.raw) => {
  const testData2 = new TestDataMapValue();
  testData2.value = typeof value === "string" ? value?.replace(/\\n/g, "\n") : value;
  testData2.type = type;
  testData2.key = key;
  return testData2;
};
var handleUploadData = (testData2, block) => {
  if (!testData2?.uploadVersionData) {
    testData2.uploadVersionData = new UploadVersionData();
  }
  if (block.more_details?.testdataOverride) {
    testData2.uploadVersionData.uploadId = block.more_details?.testdataOverride?.["uploadId"];
  }
  return testData2;
};
var findDataIndex = (stepDataList = [], dataRefKey) => stepDataList?.findIndex((stepData) => stepData.key === dataRefKey);
var handleTestData = (testStep, block) => {
  if (!testStep.stepDataList) {
    testStep.stepDataList = [];
  }
  let testData2 = createTestDataMapValue(
    block.value || "",
    block.uuid,
    block.type
  );
  testData2.isEncrypted = block.isEncrypted;
  testData2.mailboxId = block?.more_details?.mailBoxId;
  testData2.phoneNumberId = block?.more_details?.phoneNumberId;
  testData2.variableId = block?.more_details?.variableId;
  if (block.more_details?.testDataInfo) {
    if (block.more_details?.testDataInfo.isKibbutzFunction || block.more_details?.testDataInfo.isKibbutzFn) {
      testData2.isKibbutzFn = true;
      testData2.testDataKibbutzFunctionId = block.more_details?.testDataInfo.testDataKibbutzFunctionId ?? block.more_details?.testDataInfo.testDataFunctionId;
      testData2.testDataKibbutzFunction = new KibbutzTestStepTestData();
      testData2.testDataKibbutzFunction.arguments = block.more_details?.testDataInfo.arguments || block.more_details?.testDataInfo?.testDataKibbutzFunction?.arguments;
    } else {
      testData2.isKibbutzFn = false;
      testData2.testDataFunctionId = block.more_details?.testDataInfo.testDataFunctionId;
      testData2.testDataFunction = new TestStepTestDataFunction();
      testData2.testDataFunction.arguments = block.more_details?.testDataInfo.arguments || block.more_details?.testDataInfo?.testDataFunction?.arguments;
    }
  }
  if (block.type == "raw" /* raw */ && [1104, 10218, 20180, 40054, 50005, 60398, 40111].includes(
    block.more_details?.templateId
  ) && block.uuid == "testDataProfile" && block.more_details?.profileId) {
    const testDataProfileId = createTestDataMapValue(
      `${block.more_details?.profileId}`,
      "testDataProfileId",
      TestDataType.raw
    );
    findAndUpdateTestDataStepList(testStep, testDataProfileId);
  }
  if (block.type === "upload_path") {
    const currentStepData = testStep.stepDataList.find(
      (item) => item?.key === block.uuid
    );
    testData2.uploadVersionData = currentStepData?.uploadVersionData;
    testData2.uploadIdList = currentStepData?.uploadIdList;
    testData2 = handleUploadData(testData2, block);
    if (block.more_details?.testdataOverride) {
      testData2.uploadIdList = `${block.more_details?.testdataOverride?.["uploadId"]},${block.more_details?.testdataOverride?.["uploadVersionId"]}`;
    }
  } else if (block.type === "parameter") {
    testData2.testDataProfileId = block?.more_details?.testDataProfile?.id;
  } else {
    delete testData2.uploadVersionData;
  }
  findAndUpdateTestDataStepList(testStep, testData2);
};
var findAndUpdateTestDataStepList = (testStep, testData2) => {
  const itemFoundIndex = findDataIndex(testStep.stepDataList, testData2.key);
  if (itemFoundIndex > -1) {
    testData2.id = testStep.stepDataList[itemFoundIndex].id;
    testStep.stepDataList[itemFoundIndex] = testData2;
  } else {
    testStep.stepDataList.push(testData2);
  }
};
var handleForLoopTestData = (testStep, block) => {
  const trimValue = typeof block.value === "string" ? block.value?.toLowerCase()?.trim() : block.value;
  if (!testStep.forLoopCondition) {
    testStep.forLoopCondition = new ForLoopCondition();
  }
  if (block.uuid == "testDataProfile") {
    testStep.forLoopCondition.testDataProfile = {};
    testStep.forLoopCondition[block.uuid]["value"] = block.value;
    testStep.forLoopCondition[block.uuid]["id"] = block.more_details["profileId"] || block.more_details?.testDataProfile?.id;
    testStep.forLoopCondition[block.uuid]["type"] = block.type;
  } else if (block.uuid == "leftData") {
    testStep.forLoopCondition[block.uuid] = {};
    testStep.forLoopCondition[block.uuid]["value"] = typeof block.value === "string" ? block.value?.replace(/\\n/g, "\n") : block.value;
    testStep.forLoopCondition[block.uuid]["type"] = block.type;
    testStep.forLoopCondition[block.uuid]["isEncrypted"] = block.isEncrypted ?? false;
    testStep.forLoopCondition[block.uuid]["testDataFunction"] = block?.type === "function" /* function */ ? block.more_details?.testDataFunction : null;
  } else if (block.uuid == "operator") {
    testStep.forLoopCondition[block.uuid] = SearchOperator[block.value] || SearchOperator.CONTAINS;
  } else if (block.uuid == "rightData") {
    testStep.forLoopCondition[block.uuid] = {};
    testStep.forLoopCondition[block.uuid]["value"] = typeof block.value === "string" ? block.value?.replace(/\\n/g, "\n") : block.value;
    testStep.forLoopCondition[block.uuid]["type"] = block.type;
    testStep.forLoopCondition[block.uuid]["isEncrypted"] = block.isEncrypted ?? false;
    testStep.forLoopCondition[block.uuid]["testDataFunction"] = block?.type === "function" /* function */ ? block.more_details?.testDataFunction : null;
  }
  if (block?.more_details?.["loopType"] == "INDEX" && block.type == "raw" /* raw */ && (trimValue == "start" || trimValue == "end")) {
    testStep.forLoopCondition[block.uuid]["value"] = -1;
  }
  testStep.forLoopCondition.iterationType = block?.more_details?.["loopType"];
  handleTestData(testStep, block);
};
var handleAttribute = (testStep, block) => {
  testStep[block.uuid] = block.value;
};
var createStepElementRequest = (blockValue, type, blockDetails) => {
  return {
    elementType: type,
    name: blockValue,
    elementId: blockDetails?.elementOverride?.id,
    objectTypeId: blockDetails?.elementOverride?.objectTypeId
  };
};
var getElementType2 = (uuid) => {
  switch (uuid) {
    case "fromUiIdentifier":
      return TestStepElementType.FROM_UI_ELEMENT;
    case "toUiIdentifier":
      return TestStepElementType.TO_UI_ELEMENT;
    default:
      return TestStepElementType.UI_ELEMENT;
  }
};
var findElementIndex = (elements, elementType) => elements.findIndex((element) => element.elementType === elementType);
var addOrUpdateTestStepElements = (testStep, elementItem, elementType) => {
  const itemFoundIndex = findElementIndex(
    testStep.testStepElements,
    elementType
  );
  if (itemFoundIndex > -1) {
    elementItem.id = testStep.testStepElements[itemFoundIndex].id;
    if (elementItem.elementId == null) {
      elementItem.elementId = testStep.testStepElements[itemFoundIndex].elementId;
    }
    testStep.testStepElements[itemFoundIndex] = elementItem;
  } else {
    testStep.testStepElements.push(elementItem);
  }
};
var handleElement = (testStep, block) => {
  if (block?.more_details?.elementOverride?.id || block?.more_details?.elementOverride?.objectTypeId || !testStep?.testStepElements?.find((item) => item?.name === block?.value)) {
    if (!testStep.testStepElements) {
      testStep.testStepElements = [];
    }
    const elementType = getElementType2(block.uuid);
    const elementItem = createStepElementRequest(
      block.value,
      elementType,
      block.more_details
    );
    addOrUpdateTestStepElements(testStep, elementItem, elementType);
  }
};
var sanitizeString = (str) => {
  if (!str) return "";
  return str.replace(/[\n\r\s]+/g, ",").replace(/^,|,$/g, "");
};
var handleKibbutzUploadData = (testData2, block) => {
  if (!testData2?.uploadVersionData) {
    testData2["uploadVersionData"] = new UploadVersionData();
  }
  if (block.more_details?.testdataOverride) {
    testData2["uploadVersionData"].uploadId = block.more_details?.testdataOverride?.["uploadId"];
    testData2["uploadVersionData"].uploadVersionId = block.more_details?.testdataOverride?.["uploadVersionId"];
  } else if (block.more_details?.intialTestData) {
    testData2["uploadVersionData"].uploadId = block.more_details?.intialTestData?.["uploadId"];
    testData2["uploadVersionData"].uploadVersionId = block.more_details?.intialTestData?.["uploadVersionId"];
  }
  return testData2;
};
var handleKibbutzData = (teststep, block) => {
  if (block.more_details?.parameterType == KibbutzParameterType.ELEMENT) {
    teststep.kibbutzPluginNlpData.uiIdentifiers = teststep.kibbutzPluginNlpData.uiIdentifiers || /* @__PURE__ */ new Map();
    teststep.kibbutzPluginNlpData.uiIdentifiers[block.uuid] = new KibbutzUiIdentifierData();
    teststep.kibbutzPluginNlpData.uiIdentifiers[block.uuid].name = block.value;
  } else if (block.more_details?.parameterType == KibbutzParameterType.TEST_DATA) {
    teststep.kibbutzPluginNlpData.testData = teststep.kibbutzPluginNlpData.testData || /* @__PURE__ */ new Map();
    const testDataEntry = teststep?.kibbutzPluginNlpData?.testData?.[block?.uuid] || new KibbutzTestStepTestData();
    testDataEntry.value = block?.value;
    testDataEntry.type = block?.type === "selectable" ? TestDataType.raw : block?.type;
    testDataEntry.isEncrypted = block?.isEncrypted;
    if (block?.type === "upload_path") {
      handleKibbutzUploadData(testDataEntry, block);
      const uploadId = block?.more_details?.testdataOverride?.["uploadId"] || testDataEntry.uploadVersionData.uploadId;
      const uploadVersionId = block?.more_details?.testdataOverride?.["uploadVersionId"] || testDataEntry.uploadVersionData.uploadVersionId;
      testDataEntry["uploadIdList"] = sanitizeString(
        `${uploadId},${uploadVersionId}`
      );
    }
    teststep.kibbutzPluginNlpData.testData[block.uuid] = testDataEntry;
    if (block.type === "function" && block.more_details?.testDataInfo) {
      const isKibbutzFn = block.more_details?.testDataInfo.isKibbutzFunction || block.more_details?.testDataInfo.isKibbutzFn;
      teststep.kibbutzPluginNlpData.testData[block.uuid].isKibbutzFn = isKibbutzFn;
      teststep.kibbutzPluginNlpData.testData[block.uuid].testDataFunctionId = block.more_details?.testDataInfo.testDataFunctionId || block.more_details?.testDataInfo.testDataKibbutzFunctionId;
      const _arguments = block.more_details?.testDataInfo.arguments || block.more_details?.testDataInfo?.testDataFunction?.arguments || block.more_details?.testDataInfo?.testDataFunctionArguments;
      teststep.kibbutzPluginNlpData.testData[block.uuid].testDataFunctionArguments = isKibbutzFn ? _arguments : convertDataGeneratorArgumentObjectsToJson(_arguments);
    }
  } else if (block?.more_details?.parameterType == KibbutzParameterType.TEST_DATA_PROFILE) {
    teststep.kibbutzPluginNlpData.testDataProfile = /* @__PURE__ */ new Map();
    teststep.kibbutzPluginNlpData.testData[block.uuid] = new KibbutzTestDataProfile();
    teststep.kibbutzPluginNlpData.testDataProfile[block.uuid].value = block.value;
    teststep.kibbutzPluginNlpData.testDataProfile[block.uuid].type = block.type;
  } else if (block?.more_details?.parameterType == KibbutzParameterType.TEST_DATA_SET) {
    teststep.kibbutzPluginNlpData.testDataSet = /* @__PURE__ */ new Map();
    teststep.kibbutzPluginNlpData.testData[block.uuid] = new KibbutzTestDataSet();
    teststep.kibbutzPluginNlpData.testDataSet[block.uuid].value = block.value;
    teststep.kibbutzPluginNlpData.testDataSet[block.uuid].type = block.type;
  } else if (block?.more_details?.parameterType == KibbutzParameterType.ENVIRONMENT_DATA) {
    teststep.kibbutzPluginNlpData.environmentData = /* @__PURE__ */ new Map();
    teststep.kibbutzPluginNlpData.testData[block.uuid] = new KibbutzEnvironmentData();
    teststep.kibbutzPluginNlpData.environmentData[block.uuid].value = block.value;
    teststep.kibbutzPluginNlpData.environmentData[block.uuid].type = block.type;
  }
};
var handleSelectableData = (testStep, block) => {
  const localBlock = Object.assign({}, block);
  localBlock.type = "raw" /* raw */;
  if (isForLoop(testStep)) {
    handleForLoopTestData(testStep, localBlock);
  } else if (!isForLoop(testStep)) {
    handleTestData(testStep, localBlock);
  }
};
var bindBlockWithTestStep = (blocks, testStep) => {
  testStep = new TestStep().deserialize(testStep);
  if (!testStep.isStepGroupSpotEdit) {
    testStep.action = blocks.map(({ value = "" }) => typeof value === "string" ? value.trim() : "").join(" ").split("\\n").join(" ").replaceAll(/\s+/g, " ");
  }
  for (let i = 0; i < blocks.length; i++) {
    switch (blocks[i].type) {
      case "attribute":
        if (testStep.isKibbutz) {
          handleKibbutzData(testStep, blocks[i]);
        } else {
          handleAttribute(testStep, blocks[i]);
        }
        break;
      case "ui_identifier":
        if (testStep.isKibbutz) {
          handleKibbutzData(testStep, blocks[i]);
        } else if (!testStep?.isStepGroupSpotEdit) {
          handleElement(testStep, blocks[i]);
        }
        break;
      case "global":
      case "mail_box":
      case "phone_number":
      case "function":
      case "random":
      case "raw":
      case "runtime":
      case "parameter":
      case "upload_path":
      case "salesforce_connection":
      case "salesforce_object":
      case "salesforce_application":
      case "salesforce_tab":
      case "salesforce_object_form":
        if (testStep.isKibbutz) {
          handleKibbutzData(testStep, blocks[i]);
        } else if (isForLoop(testStep)) {
          handleForLoopTestData(testStep, blocks[i]);
        } else if (!isForLoop(testStep) && !testStep?.isStepGroupSpotEdit) {
          handleTestData(testStep, blocks[i]);
        }
        break;
      case "selectable":
        if (testStep.isKibbutz) {
          handleKibbutzData(testStep, blocks[i]);
        } else {
          handleSelectableData(testStep, blocks[i]);
        }
        break;
    }
  }
  return testStep;
};
var stepLabelMapping = {
  [StepTypeUI.NLP]: "step.type.label.nlp",
  [StepTypeUI.STEP_GROUP]: "step.type.label.group",
  [StepTypeUI.BLOCK]: "step.type.label.block",
  [StepTypeUI.FOR_LOOP]: "step.type.label.for",
  [StepTypeUI.WHILE_LOOP]: "step.type.label.while",
  [StepTypeUI.REST_API]: "step.type.label.rest",
  [StepTypeUI.IF_CONDITION]: "step.type.label.if.nlp",
  [StepTypeUI.IF_STEP_GROUP]: "step.type.label.if.group",
  [StepTypeUI.IF_REST_API]: "step.type.label.if.rest",
  [StepTypeUI.IF_CUSTOM_FUNCTION]: "step.type.label.custom_function",
  [StepTypeUI.SOQL]: "step.type.label.soql"
};
var getStepLabelText = (testStep, t) => {
  if (testStep.disabled) {
    return t("step.disabled");
  }
  if (testStep.ignoreStepResult && !isConditionalStep(testStep)) {
    return t("step.result.ignored");
  }
  const labelKey = stepLabelMapping[testStep?.uiMap?.type];
  if (labelKey) {
    return t(labelKey);
  }
  return null;
};
var getStepTypeIcon = (testStep) => {
  const isWindowsAdvanced = isObjectBased(testStep);
  const stepTypeIcons = {
    [StepTypeUI.ACTION]: "ads-click",
    [StepTypeUI.ELEMENT]: "category",
    [StepTypeUI.NLP]: "step-type-switch",
    [StepTypeUI.STEP_GROUP]: "ballot",
    [StepTypeUI.BLOCK]: "view-agenda",
    [StepTypeUI.FOR_LOOP]: "for-loop",
    [StepTypeUI.WHILE_LOOP]: "while-loop",
    [StepTypeUI.CUSTOM_FUNCTION]: "extension-off",
    [StepTypeUI.REST_API]: "rest-api",
    [StepTypeUI.IF_CONDITION]: "if-condition",
    [StepTypeUI.IF_STEP_GROUP]: "if-condition",
    [StepTypeUI.IF_REST_API]: "if-condition",
    [StepTypeUI.IF_CUSTOM_FUNCTION]: "if-condition",
    [StepTypeUI.SOQL]: "soql"
  };
  const icon = stepTypeIcons[testStep?.uiMap?.type];
  return icon ?? (isWindowsAdvanced ? "question-mark-light" : "step-type-switch");
};

// src/components/test-authoring/formatted-step/object-authoring.utils.ts
var constructElementStep = ({ step, elementDetails }) => {
  const elementStep = new TestStep().deserialize(step);
  const more_details = {
    isObjectBased: true,
    elementOverride: {
      referenceKey: "ELEMENT_NAME",
      id: elementDetails?.id,
      name: elementDetails.name,
      objectTypeId: elementDetails.objectTypeId
    },
    isReadOnly: false,
    onChangeClearNextBlocks: true
  };
  elementStep.uiMap.objectBlocks = [
    {
      value: elementDetails?.name || "",
      type: "ui_identifier" /* ui_identifier */,
      uuid: "ELEMENT_NAME",
      has_value: true,
      more_details,
      canEncrypt: false,
      isEncrypted: false
    },
    getReadOnlyActionBlock({
      displayName: "action",
      has_value: false,
      templateId: null
    })
  ];
  elementStep.uiMap.element = elementDetails?.name;
  elementStep.uiMap.objectTypeId = elementDetails?.objectTypeId;
  elementStep.uiMap.elementId = elementDetails?.id;
  elementStep.uiMap.templateId = null;
  elementStep.dataMap = new StepDetailsDataMap();
  elementStep.action = null;
  elementStep.templateId = null;
  if (!elementStep.testStepElements) {
    elementStep.testStepElements = [];
  }
  const elementItem = createStepElementRequest(
    elementDetails?.name,
    TestStepElementType.UI_ELEMENT,
    more_details
  );
  addOrUpdateTestStepElements(
    elementStep,
    elementItem,
    TestStepElementType.UI_ELEMENT
  );
  return elementStep;
};
var constructActionStep = ({ step, template, isActiveStep }) => {
  const actionStep = new TestStep().deserialize(step);
  actionStep.uiMap.element = null;
  actionStep.uiMap.objectTypeId = null;
  actionStep.uiMap.elementId = null;
  actionStep.uiMap.templateId = template.id;
  actionStep.dataMap = new StepDetailsDataMap();
  actionStep.action = null;
  actionStep.templateId = template.id;
  const dataBlocks = getStepNlpBlocks(
    actionStep,
    template,
    isActiveStep
  )?.filter((block) => block.type != "readonly_text" /* readonly_text */);
  actionStep.uiMap.objectBlocks = [
    getReadOnlyActionBlock({
      displayName: template.displayName,
      templateId: template.id
    }),
    ...dataBlocks
  ];
  return actionStep;
};
var getReadOnlyActionBlock = ({
  displayName = "action",
  has_value = true,
  templateId
}) => {
  return {
    value: displayName,
    type: "action" /* action */,
    uuid: "ACTION_NAME",
    has_value,
    more_details: {
      isObjectBased: true,
      templateId,
      onChangeClearNextBlocks: true
    },
    canEncrypt: false,
    isEncrypted: false
  };
};
var getInitialUIMap = (step) => {
  if (!step) {
    return {
      applicationType: null,
      type: null,
      objectBlocks: null,
      templateId: null,
      isValid: false,
      element: null,
      isObjectBased: false,
      objectTypeId: null,
      elementId: null
    };
  }
  return {
    applicationType: step.applicationType,
    type: getStepUIType(step),
    objectBlocks: null,
    templateId: step.templateId || null,
    isValid: false,
    element: null,
    isObjectBased: isObjectBased(step),
    objectTypeId: null,
    elementId: null
  };
};
var reconstructObjectSteps = (localStep, nlActions, isFocused, uiMap, step, testStep) => {
  if (!localStep) {
    return;
  }
  const handleElement2 = (element, template, dataBlocks) => {
    element.more_details.isReadOnly = false;
    element.more_details.onChangeClearNextBlocks = true;
    uiMap.objectTypeId = localStep?.testStepElements?.[0]?.element?.objectTypeId;
    uiMap.element = element?.value;
    uiMap.type = StepTypeUI.ELEMENT;
    if (!uiMap?.objectBlocks?.length) {
      uiMap.objectBlocks = [
        element,
        getReadOnlyActionBlock({
          displayName: template.displayName,
          templateId: template.id
        }),
        ...dataBlocks
      ];
    }
  };
  const handleAction = (template, dataBlocks) => {
    uiMap.type = StepTypeUI.ACTION;
    if (!uiMap?.objectBlocks?.length) {
      uiMap.objectBlocks = [
        getReadOnlyActionBlock({
          displayName: template.displayName,
          templateId: template.id
        }),
        ...dataBlocks
      ];
    }
  };
  if (localStep.templateId && localStep.type == TestStepType.NLP_TEXT && (!localStep.isConditionalStep || localStep.isIfConditionalStep)) {
    const template = nlActions.find(
      (t) => t.id == localStep.templateId
    );
    const blocks = getStepNlpBlocks(
      localStep,
      template,
      isFocused
    );
    const element = blocks.find(
      (block) => block.type == "ui_identifier" /* ui_identifier */
    );
    const dataBlocks = blocks.filter(
      (block) => !["ui_identifier" /* ui_identifier */, "readonly_text" /* readonly_text */].includes(
        block.type
      )
    );
    if (template?.hasObjectTypeId) {
      handleElement2(element, template, dataBlocks);
    } else if (!template?.hasObjectTypeId && step.isIfConditionalStep) {
      testStep.uiMap.objectBlocks = dataBlocks;
    } else if (!template?.hasObjectTypeId) {
      handleAction(template, dataBlocks);
    }
  }
};
var constructStepUiMap = (localStep, nlActions) => {
  if (!localStep) {
    return null;
  }
  if (!localStep.uiMap && nlActions.length) {
    let testStep = new TestStep().deserialize(localStep);
    let uiMap = getInitialUIMap(localStep);
    testStep.uiMap = uiMap;
    if (isObjectBased(localStep)) {
      reconstructObjectSteps(
        localStep,
        nlActions,
        false,
        uiMap,
        testStep,
        testStep
      );
    }
    return testStep;
  } else return localStep;
};
var useUIMap = (localStep, step, updateLocalStep, isFocused, nlActions) => {
  useEffect(() => {
    if (localStep && !localStep.uiMap && nlActions.length) {
      let testStep = new TestStep().deserialize(localStep);
      let uiMap = getInitialUIMap(localStep);
      testStep.uiMap = uiMap;
      if (isObjectBased(localStep)) {
        reconstructObjectSteps(
          localStep,
          nlActions,
          isFocused,
          uiMap,
          step,
          testStep
        );
      }
      if (testStep) {
        updateLocalStep(testStep);
      }
    }
  }, [step, localStep, nlActions]);
};
var makeObjectIfStep = (nlActions, blockStep) => {
  const template = nlActions.find(
    (t) => t.stepActionType == "IF_CONDITION" && t.action == "verify"
  );
  const blocks = getStepNlpBlocks(blockStep, template, true).filter(
    (block) => !["readonly_text" /* readonly_text */].includes(block.type)
  );
  blocks[1].value = "condition";
  blockStep.type = TestStepType.NLP_TEXT;
  blockStep.action = template.action;
  blockStep.templateId = template.id;
  if (!blockStep.uiMap) blockStep.uiMap = {};
  blockStep.uiMap.objectBlocks = blocks;
  blockStep.uiMap.templateId = template.id;
};
var FormattedObjectStep = ({
  step,
  getTestData: getTestData2,
  onChange,
  isViewOnly,
  isFocused,
  updateFocused,
  updateWatchFocusOut,
  updateLocalStep,
  onSearch,
  isFetching,
  onChangeType,
  onSave,
  dataParameterList,
  dataProfileList,
  customFunctionList,
  dataSetList,
  updateSelectedDataProfile,
  stepsInfo,
  updateStepsInfo,
  isViewOnlySingle = false,
  isStepResult = false
}) => {
  const { nlActions } = useContext(StepContext);
  const dataValue = step.uiMap.objectBlocks;
  const [key, setKey] = useState(Date.now());
  const currentBlocsk = useRef(step?.uiMap?.objectBlocks || []);
  const updateNlpContainerWidth = useCallback(
    (width, stepId) => {
      const localNlpContainerWidth = Object.assign(
        {},
        stepsInfo?.nlpContainerWidth
      );
      if (localNlpContainerWidth) {
        localNlpContainerWidth[stepId] = width;
      }
      if (updateStepsInfo)
        updateStepsInfo(`nlpContainerWidth`, localNlpContainerWidth);
    },
    [stepsInfo, updateStepsInfo]
  );
  const handleBlockChange = (updatedBlocks) => {
    if (step.uiMap.type == StepTypeUI.ELEMENT && updatedBlocks.length == 1 && updatedBlocks[0]?.more_details?.elementOverride) {
      const elementStep = constructElementStep({
        step,
        elementDetails: updatedBlocks[0]?.more_details?.elementOverride
      });
      elementStep.templateId = null;
      elementStep.kibbutzPluginNlpId = null;
      elementStep.kibbutzPluginNlpData = null;
      updateLocalStep(elementStep);
      setKey(Date.now());
      return;
    }
    if (step.uiMap.type == StepTypeUI.ACTION && updatedBlocks.length == 1) {
      const template = nlActions.find(
        (t) => t.id == updatedBlocks[0].more_details.templateId
      );
      const actionStep = constructActionStep({
        step,
        template,
        isActiveStep: true
      });
      updateLocalStep(actionStep);
      setKey(Date.now());
      return;
    }
    if (step.uiMap.type == StepTypeUI.ELEMENT && (!step.uiMap.templateId || step.uiMap.templateId != updatedBlocks[1]?.more_details?.templateId || updatedBlocks.length === 1 && updatedBlocks[0]?.more_details?.templateId)) {
      const actionStep = new TestStep().deserialize(step);
      const templateId = updatedBlocks[1]?.more_details?.templateId || updatedBlocks[0]?.more_details?.templateId;
      const template = nlActions.find(
        (action) => action.id == templateId
      );
      const isCurrentlyAddon = Boolean(step.kibbutzPluginNlpId);
      const isTargetAddon = Boolean(template?.isAddon);
      if (isCurrentlyAddon !== isTargetAddon) {
        actionStep.kibbutzPluginNlpId = null;
        actionStep.kibbutzPluginNlpData = null;
        actionStep.templateId = null;
        actionStep.action = null;
        actionStep.stepDataList = [];
        actionStep.uiMap = {
          ...actionStep.uiMap,
          type: StepTypeUI.ELEMENT,
          templateId: null,
          objectBlocks: []
        };
      }
      actionStep.dataMap = new StepDetailsDataMap();
      if (template?.isAddon) {
        actionStep.kibbutzPluginNlpId = template.id;
        actionStep.templateId = null;
      } else {
        actionStep.templateId = templateId;
        actionStep.action = template?.action;
      }
      const allBlocks = template?.isAddon ? getStepKibbutzBlocks(actionStep, template) : getStepNlpBlocks(actionStep, template, isFocused);
      const dataBlocks = allBlocks?.filter(
        (block) => ![
          "readonly_text" /* readonly_text */,
          "ui_identifier" /* ui_identifier */
        ].includes(block.type)
      );
      const uiIdentifierElement = allBlocks?.find(
        (block) => block.type === "ui_identifier" /* ui_identifier */
      );
      const readOnlyElement = allBlocks?.find(
        (block) => block.type === "readonly_text" /* readonly_text */
      );
      const element = uiIdentifierElement || readOnlyElement;
      if (element?.type === "readonly_text" /* readonly_text */) {
        element.value = actionStep?.uiMap?.element;
        element.has_value = true;
      } else if (element?.type === "ui_identifier" /* ui_identifier */) {
        element.value = actionStep?.uiMap?.element;
        element.has_value = true;
        element.more_details = element.more_details || {};
        element.more_details.elementOverride = {
          referenceKey: element.uuid,
          id: step.uiMap.elementId,
          name: step.uiMap.element
        };
        element.more_details.onChangeClearNextBlocks = true;
      }
      actionStep.uiMap.templateId = templateId;
      actionStep.uiMap.objectBlocks = [
        ...element ? [element] : [],
        getReadOnlyActionBlock({
          displayName: template?.displayName || template.action,
          templateId
        }),
        ...dataBlocks
      ];
      if (element) {
        actionStep.dataMap[element.uuid] = element.value;
      }
      if (template?.isAddon) {
        const uiIdentifiersMap = /* @__PURE__ */ new Map();
        if (element) {
          uiIdentifiersMap.set("ELEMENT_NAME", {
            id: step.uiMap.elementId,
            name: step.uiMap.element,
            type: "ui_identifier" /* ui_identifier */
          });
        }
        const testDataMap = /* @__PURE__ */ new Map();
        actionStep.stepDataList?.forEach((data) => {
          testDataMap.set(data.id, {
            id: data.id,
            value: data.value,
            type: data.type
          });
        });
        const nlpData = new KibbutzNLPDataModel();
        nlpData.uiIdentifiers = uiIdentifiersMap;
        nlpData.testData = testDataMap;
        nlpData.environmentData = /* @__PURE__ */ new Map();
        nlpData.testDataProfile = /* @__PURE__ */ new Map();
        nlpData.testDataSet = /* @__PURE__ */ new Map();
        nlpData.uploadVersionData = null;
        actionStep.kibbutzPluginNlpData = nlpData;
      }
      updateLocalStep(actionStep);
      setKey(Date.now());
    } else {
      onChange(updatedBlocks);
    }
  };
  useEffect(() => {
    if (step?.uiMap?.objectBlocks?.[0]?.uuid != currentBlocsk.current?.[0]?.uuid)
      setKey(Date.now());
  }, [step]);
  return /* @__PURE__ */ jsx(
    NlpInput,
    {
      blocks: dataValue,
      onChange: handleBlockChange,
      getTestData: getTestData2,
      updateStepFocused: (focussed) => !stepsInfo?.isStepTypeSwitchOpened && updateWatchFocusOut?.(!focussed),
      isReadOnly: isViewOnly,
      isNoWrap: isViewOnlySingle,
      isDisabled: step.disabled || step.isParentStepGroupDisabled,
      isFocused,
      updateFocused,
      onSearch,
      onDropdownToggle: () => updateWatchFocusOut(true),
      onChangeType,
      isFetching,
      isCommand: false,
      isCommandCombine: false,
      updateLocalStep,
      step,
      isNlpSuggestionAllowed: false,
      inputAutoFocusEnabled: !step.id,
      isEdit: Boolean(step.id),
      saveHandler: onSave,
      dataParameterList,
      dataProfileList,
      customFunctionList,
      dataSetList,
      updateSelectedDataProfile,
      containerWidth: stepsInfo?.nlpContainerWidth?.[step.id],
      updateNlpContainerWidth: (width) => updateNlpContainerWidth(width, step.id),
      isStepResult
    },
    key
  );
};
var object_step_default = FormattedObjectStep;
var FormattedStepGroupStep = ({
  step,
  updateFocused,
  openStepGroupsListDrawer,
  updateWatchFocusOut,
  setExpandStepGroup,
  hideOpenLink = false,
  stepResult,
  isResultBlock,
  updateLocalStep
}) => {
  const { isDebugMode } = useContext(StepContext);
  const handleStepClick = useCallback(async () => {
    if (step?.isStepGroupChild && step.isStepGroup) {
      return false;
    }
    updateWatchFocusOut(false);
    const cloneStep = cloneDeep$1(step);
    const { action, details } = await openStepGroupsListDrawer(
      step?.testCaseId
    );
    if (action == "SELECTED") {
      updateFocused(true);
      cloneStep.stepGroupId = details.id;
      cloneStep.action = details.name;
      setExpandStepGroup(null, true);
    }
    updateWatchFocusOut(true);
    updateLocalStep(cloneStep);
  }, [step]);
  const { t } = useTranslation();
  const handleOpenStepGroup = useCallback(
    (event) => {
      event.preventDefault();
      event.stopPropagation();
      const baseURL = getOrigin();
      window.open(
        `${baseURL}/ui/td/step-groups/${step?.stepGroupId}`,
        "_blank"
      );
    },
    [step]
  );
  const trimmedStepGroupName = step?.action?.trim();
  const boldText = "text-primary-100 font-semibold";
  const isTruncatedText = step?.action?.length > 50;
  return /* @__PURE__ */ jsxs(
    "span",
    {
      onClick: handleStepClick,
      className: classNames82(
        "text-secondary-700 text-small leading-5 px-1 break-all flex items-center",
        {
          "grayscale opacity-50": step.disabled || step.isParentStepGroupDisabled
        },
        isTruncatedText && (isResultBlock ? "w-full" : "w-1/2"),
        !isTruncatedText && isDebugMode && boldText
      ),
      children: [
        isTruncatedText ? /* @__PURE__ */ jsx(
          TruncatedText,
          {
            value: trimmedStepGroupName,
            tooltipClassName: "w-[400px]",
            className: classNames82("inline-block !w-fit", {
              [boldText]: isDebugMode
            })
          }
        ) : trimmedStepGroupName,
        !hideOpenLink && /* @__PURE__ */ jsxs(Fragment, { children: [
          step?.isReusableStepGroup && /* @__PURE__ */ jsx(
            Icon,
            {
              name: "reusable-step-group",
              className: "text-primary-600 pl-1 text-base flex",
              tootTipClassName: "inline-block align-text-top",
              onClick: handleOpenStepGroup,
              toolTip: t("step.group.open.in.new.tab")
            }
          ),
          /* @__PURE__ */ jsx(
            Icon,
            {
              name: "open-in-new",
              className: "text-primary-600 pl-1 text-base flex",
              tootTipClassName: "inline-block align-text-top",
              onClick: handleOpenStepGroup,
              toolTip: t("step.group.open.in.new.tab")
            }
          )
        ] }),
        stepResult?.["stepGroupDataDriven"] ? /* @__PURE__ */ jsx("div", { className: "px-3 py-0.5 border rounded-full bg-secondary-50 border-secondary-200 pl-1 text-10px", children: /* @__PURE__ */ jsx("span", { children: `SET NAME : ${stepResult?.["stepGroupDataDriven"]?.["testDataSetName"]}` }) }) : null
      ]
    }
  );
};
var step_group_default = FormattedStepGroupStep;
var StepItemWrapper = ({
  step,
  getTestData: getTestData2,
  onChange,
  isResultBlock,
  isViewOnly,
  isFocused,
  updateFocused,
  updateWatchFocusOut,
  updateLocalStep,
  onSearch,
  isFetching,
  isCommand,
  isCommandCombine,
  onChangeType,
  onSave,
  dataParameterList,
  dataProfileList,
  dataSetList,
  customFunctionList,
  updateSelectedDataProfile,
  isNumbered,
  template,
  stepsInfo,
  updateStepsInfo,
  openStepGroupsListDrawer,
  openCustomFunctionParameterDrawer,
  isViewOnlySingle = false,
  isStepResult = false,
  setExpandStepGroup,
  isWebRecorder,
  fetchConnections,
  actionCallback,
  salesforceActions,
  uploadActions,
  stepResult,
  sessionActions,
  isNestedStepGroupStep,
  prevLocalBlocks,
  isAiGenStep = false
}) => {
  let stepComponent = null;
  const isWindowsAdvanced = isObjectBased(step);
  const constructObjectBasedUIMap = () => {
    if (isAiGenStep && isWindowsAdvanced && template) {
      const reconstructedStep = constructStepUiMap(step, [template]);
      if (reconstructedStep) {
        step = reconstructedStep;
      }
    }
  };
  constructObjectBasedUIMap();
  switch (step.type) {
    case TestStepType.NLP_TEXT:
      if (isConditionalElse(step)) {
        stepComponent = /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames82(
              "text-secondary-700 text-small leading-5 flex-grow",
              {
                "grayscale opacity-50": step.disabled
              }
            )
          }
        );
      } else {
        stepComponent = /* @__PURE__ */ jsx(
          nlp_default,
          {
            step,
            template,
            getTestData: getTestData2,
            onChange,
            isResultBlock,
            isViewOnly,
            updateWatchFocusOut,
            isFocused,
            updateFocused,
            updateLocalStep,
            onSearch,
            isFetching,
            isCommand,
            isCommandCombine,
            onChangeType,
            onSave,
            dataParameterList,
            dataProfileList,
            dataSetList,
            customFunctionList,
            updateSelectedDataProfile,
            stepsInfo,
            updateStepsInfo,
            isViewOnlySingle,
            isStepResult,
            fetchConnections,
            actionCallback,
            salesforceActions,
            uploadActions,
            sessionActions,
            isNestedStepGroupStep,
            prevLocalBlocks
          }
        );
      }
      break;
    case TestStepType.BLOCK:
      stepComponent = /* @__PURE__ */ jsx(
        block_default,
        {
          step,
          isResultBlock,
          isViewOnly,
          isFocused,
          updateFocused,
          updateLocalStep
        }
      );
      break;
    case TestStepType.API_STEP:
      stepComponent = /* @__PURE__ */ jsx(
        api_step_default,
        {
          step,
          stepsInfo,
          isResultBlock
        }
      );
      break;
    case TestStepType.SOQL:
      stepComponent = /* @__PURE__ */ jsx(
        soql_step_default,
        {
          step,
          stepsInfo,
          isResultBlock
        }
      );
      break;
    case TestStepType.STEP_GROUP:
      stepComponent = /* @__PURE__ */ jsx(
        step_group_default,
        {
          step,
          isResultBlock,
          isViewOnly,
          isFocused,
          updateFocused,
          openStepGroupsListDrawer,
          updateWatchFocusOut,
          setExpandStepGroup,
          hideOpenLink: isWebRecorder,
          stepResult,
          updateLocalStep
        }
      );
      break;
    case TestStepType.BREAK_LOOP:
    case TestStepType.CONTINUE_LOOP:
      stepComponent = /* @__PURE__ */ jsx(
        "div",
        {
          className: classNames82(
            "text-secondary-700 text-small leading-5 flex-grow",
            {
              "grayscale opacity-50": step.disabled
            }
          )
        }
      );
      break;
    case TestStepType.CUSTOM_FUNCTION:
      stepComponent = /* @__PURE__ */ jsx(
        custom_function_default,
        {
          step,
          isFocused,
          updateFocused,
          customFunctionList,
          openCustomFunctionParameterDrawer,
          onChange,
          updateLocalStep,
          onSearch,
          isViewOnly
        }
      );
      break;
    default:
      stepComponent = /* @__PURE__ */ jsx(
        nlp_default,
        {
          step,
          template,
          getTestData: getTestData2,
          onChange,
          isResultBlock,
          isViewOnly,
          updateWatchFocusOut,
          isFocused,
          updateFocused,
          onSearch,
          isFetching,
          isCommand,
          isCommandCombine,
          onChangeType,
          onSave,
          dataParameterList,
          dataProfileList,
          dataSetList,
          customFunctionList,
          updateSelectedDataProfile,
          stepsInfo,
          updateStepsInfo,
          isViewOnlySingle,
          prevLocalBlocks
        }
      );
  }
  if (isWindowsAdvanced && step?.uiMap?.type == null && step.type == TestStepType.NLP_TEXT) {
    stepComponent = /* @__PURE__ */ jsx(
      nlp_default,
      {
        step,
        template,
        getTestData: getTestData2,
        onChange,
        isResultBlock,
        isViewOnly,
        updateWatchFocusOut,
        isFocused,
        updateFocused,
        updateLocalStep,
        onSearch,
        isFetching,
        isCommand: true,
        isCommandCombine: false,
        onChangeType,
        onSave,
        dataParameterList,
        dataProfileList,
        dataSetList,
        customFunctionList,
        updateSelectedDataProfile,
        stepsInfo,
        updateStepsInfo,
        isViewOnlySingle,
        isStepResult,
        fetchConnections,
        actionCallback,
        salesforceActions,
        uploadActions,
        sessionActions,
        prevLocalBlocks
      }
    );
  }
  if (!!step?.uiMap?.objectBlocks?.length) {
    stepComponent = /* @__PURE__ */ jsx(
      object_step_default,
      {
        step,
        template,
        getTestData: getTestData2,
        onChange,
        isViewOnly,
        updateWatchFocusOut,
        isFocused,
        updateFocused,
        updateLocalStep,
        onSearch,
        isFetching,
        isCommand: true,
        isCommandCombine: false,
        onChangeType,
        onSave,
        dataParameterList,
        dataProfileList,
        dataSetList,
        customFunctionList,
        updateSelectedDataProfile,
        stepsInfo,
        updateStepsInfo,
        isViewOnlySingle,
        isStepResult
      }
    );
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    isNumbered && /* @__PURE__ */ jsx("div", { className: "group flex", children: /* @__PURE__ */ jsx(
      StepNumber,
      {
        number: step.stepNumber,
        className: classNames82("mx-2", {
          "grayscale opacity-50": step.disabled
        })
      }
    ) }),
    stepComponent
  ] });
};
var getToolTipMessage = (stepResult, step, onStepResultRowClicked) => {
  if (isStepGroup(step) && !stepResult?.hasCompleted) {
    if (!stepResult?.result)
      return "step_group.running.msg-queued";
    else
      return "step_group.running.msg-running";
  } else if (isStepGroup(step) && onStepResultRowClicked && stepResult?.hasCompleted && stepResult?.result === ResultConstant.SUCCESS && stepResult?.childResults?.length === 0) {
    return "step_group.empty";
  } else if (isBlock(step) && onStepResultRowClicked && stepResult?.hasCompleted && stepResult?.result === ResultConstant.SUCCESS && stepResult?.childResults?.length === 0) {
    return "step.empty.block";
  } else if (stepResult?.isLoopTitleV2 && stepResult?.hasCompleted && stepResult?.childResults?.length === 0)
    return "step.while-loop.iteration.no-steps";
  return "";
};
var StepResultParentIndicator = ({
  stepResult,
  step,
  showLoader,
  className,
  hideExpand,
  onStepResultRowClicked
}) => {
  const { t } = useTranslation();
  const isExpanded = useMemo(
    () => isStepResultExpandedV2(stepResult) || !stepResult?.isStepGroup && !stepResult?.hasCompleted,
    [stepResult]
  );
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames82(
        "flex justify-center items-center w-[15px]",
        className
      ),
      children: !hideExpand && /* @__PURE__ */ jsx(
        "div",
        {
          className: classNames82(
            "flex items-center justify-center text-secondary-600 w-full"
          ),
          children: showLoader ? /* @__PURE__ */ jsx(
            Spinner,
            {
              size: 14,
              thickness: 80,
              speed: 140,
              color: "#5E6C84",
              secondaryColor: "rgba(172, 57, 57, 0)"
            }
          ) : /* @__PURE__ */ jsx(
            Icon,
            {
              name: isExpanded ? "chevron-down" : "chevron-right",
              className: classNames82("text-xl inline-flex", {
                "!inline-flex": isExpanded
              }),
              toolTip: t(
                getToolTipMessage(stepResult, step, onStepResultRowClicked)
              ),
              tootTipClassName: "!z-5 !max-w-[400px] !text-left flex items-center justify-center",
              toolTipPlacement: "bottom"
            }
          )
        }
      )
    }
  );
};
var stepExecutionResultIcon = (status, isDebuggerMode = false) => {
  switch (status) {
    case "SUCCESS":
      return {
        icon: /* @__PURE__ */ jsx(
          Icon,
          {
            name: "check-fill",
            className: "text-xxs leading-3.5 text-execution-success flex items-center"
          }
        ),
        bgColor: "bg-primary-50"
      };
    case "FAILURE":
      return {
        icon: /* @__PURE__ */ jsx(
          Icon,
          {
            name: "close-fill",
            className: "text-xxs leading-3.5 text-error-500 flex items-center"
          }
        ),
        bgColor: classNames82("!bg-[#FFF4E5]", {
          "relative before:absolute before:top-0 before:left-0 before:w-[2px] before:h-full before:bg-[#F87462]": isDebuggerMode
        }),
        stepNumberColor: "bg-error-200"
      };
    case "NOT_EXECUTED":
      return {
        icon: /* @__PURE__ */ jsx(
          Icon,
          {
            name: "hide-circle-outline",
            className: "text-base text-unique-400 flex items-center"
          }
        ),
        bgColor: "bg-unique-400/10"
      };
    case "STOPPED":
      return {
        icon: /* @__PURE__ */ jsx(
          Icon,
          {
            name: "stop-circle-outline",
            className: "text-base text-secondary-800 flex items-center"
          }
        ),
        bgColor: "bg-secondary-100"
      };
    case "QUEUED":
      return {
        icon: /* @__PURE__ */ jsx(
          Icon,
          {
            name: "pending-solid",
            className: "text-base text-unique-500 flex items-center"
          }
        ),
        bgColor: "bg-unique-100"
      };
    case "ABORTED":
    case "PAUSED":
      return {
        icon: /* @__PURE__ */ jsx("span", { className: "w-2 h-2 rounded-sm bg-execution-debug rotate-45" }),
        bgColor: "bg-[#E9F2FF]"
      };
    case "RUNNING":
      return {
        icon: /* @__PURE__ */ jsx(
          Icon,
          {
            name: "loader",
            className: "text-xl animate-spin text-warning-500"
          }
        ),
        bgColor: "bg-orange-50"
      };
  }
};
var execution_icon_default = stepExecutionResultIcon;
var RowActions = ({
  stepResult,
  debuggerActions,
  nextStep
}) => {
  const { t } = useTranslation();
  const { openStepResultDetails } = debuggerActions;
  const { result, uuid } = stepResult || {};
  const isPaused = result === ResultConstant.PAUSED;
  const options3 = [
    {
      shouldShow: !isPaused && Boolean(uuid),
      name: t("liveEditor.stepOption.viewResult"),
      icon: "step-result",
      onClick: () => openStepResultDetails(stepResult)
    }
  ].filter(({ shouldShow }) => shouldShow);
  return /* @__PURE__ */ jsx(row_actions_dropdown_default, { options: options3 });
};
var row_actions_default = RowActions;
var StepWrapper = ({
  containerProps,
  column1Props,
  column2Props,
  column3Props,
  mainContainerParentProps,
  mainContentProps,
  column4Props
}) => {
  const {
    className = "",
    dragHandleProps,
    containerRef,
    restContent
  } = containerProps || {};
  const { content: column1Content, className: column1ClassName = "" } = column1Props || {};
  const { content: column2Content, className: column2ClassName = "" } = column2Props || {};
  const { content: column3Content, className: column3ClassName = "" } = column3Props || {};
  const { content: mainContent, className: mainContentClassName = "" } = mainContentProps || {};
  const { content: column4Content, className: column4ClassName } = column4Props || {};
  const { className: mainContainerParentClassName } = mainContainerParentProps || {};
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames82(
        "flex flex-col items-start w-full min-h-[28px] py-1",
        className
      ),
      ...dragHandleProps,
      ref: containerRef,
      children: [
        /* @__PURE__ */ jsxs("div", { className: "flex items-start w-full", children: [
          /* @__PURE__ */ jsx(
            "div",
            {
              className: classNames82(
                "flex-shrink-0 w-5 h-5 ml-2 flex items-center justify-center pt-1",
                column1ClassName
              ),
              children: column1Content
            }
          ),
          !!column2Content && /* @__PURE__ */ jsx(
            "div",
            {
              className: classNames82(
                "flex-shrink-0 w-5 h-5 ml-2 flex items-center justify-center pt-1",
                column2ClassName
              ),
              children: column2Content
            }
          ),
          /* @__PURE__ */ jsx(
            "div",
            {
              className: classNames82(
                "flex-shrink-0 h-5 flex items-center justify-center pt-1",
                column3ClassName
              ),
              children: column3Content
            }
          ),
          /* @__PURE__ */ jsxs(
            "div",
            {
              className: classNames82(
                "flex flex-grow items-center break-all",
                mainContainerParentClassName
              ),
              children: [
                /* @__PURE__ */ jsx(
                  "div",
                  {
                    className: classNames82(
                      "flex flex-grow gap-x-1 items-center break-all",
                      mainContentClassName
                    ),
                    children: mainContent
                  }
                ),
                /* @__PURE__ */ jsx(
                  "div",
                  {
                    className: classNames82(
                      "flex-shrink-0 flex items-center mr-2",
                      column4ClassName
                    ),
                    children: column4Content
                  }
                )
              ]
            }
          )
        ] }),
        restContent
      ]
    }
  );
};
var step_wrapper_default = StepWrapper;
var ExecutionStatusIcon = ({
  isExecuting: isExecuting2 = false,
  stepResult
}) => {
  const { icon } = execution_icon_default(stepResult) || {};
  if (isExecuting2) {
    return /* @__PURE__ */ jsx(Icon, { name: "loader", className: "text-xxs animate-spin text-warning-500" });
  }
  return /* @__PURE__ */ jsx(ToolTip, { placement: "right", content: stepResult, className: "inline-flex", children: icon });
};
var execution_status_icon_default = ExecutionStatusIcon;

// src/utils/debugger.util.ts
var findStepById = (steps, stepId) => {
  for (const step of steps) {
    if (step.id === stepId) {
      return step;
    }
    if (step.childSteps) {
      const foundStep = findStepById(step.childSteps, stepId);
      if (foundStep) {
        return foundStep;
      }
    }
  }
  return void 0;
};
var isMobileDebugger = () => {
  return window.location.pathname.includes("/debugrun");
};
var ExecutedStep = ({
  step,
  stepResult,
  isActive = false,
  debuggerActions,
  isExecuting: isExecuting2,
  nextStep,
  collapsedStepResults,
  updateCollapsedStepResults,
  measure,
  isViewOnly,
  // New optional props for context values
  nlActions: propNlActions,
  isWebRecorder: propIsWebRecorder,
  currentExecutingStep: propCurrentExecutingStep,
  isStepResultDetails,
  containerClassName = ""
}) => {
  const { t } = useTranslation();
  const [template, setTemplate] = useState(null);
  const [testStep, setTestStep] = useState(null);
  const [globalStepsInfo, updateGlobalStepsInfo] = useState({
    activeStepIdx: null,
    selectedSteps: [],
    updateSelectedSteps: null,
    nlpContainerWidth: {},
    isReorderState: false,
    isStepTypeSwitchOpened: true,
    isStepResult: true
  });
  const { result } = stepResult || {};
  const {
    nlActions: nlActionsFromContext,
    isWebRecorder: isWebRecorderFromContext,
    currentExecutingStep: currentExecutingStepFromContext
  } = useContext(StepContext);
  const currentExecutingStep = useMemo(
    () => propCurrentExecutingStep ?? currentExecutingStepFromContext ?? {},
    [propCurrentExecutingStep, currentExecutingStepFromContext]
  );
  const showBcgColorForRunningStep = useMemo(() => {
    const stepId = isMobileDebugger() ? stepResult?.metadata?.testStep.id : stepResult?.stepId;
    const isRunning = isMobileDebugger() ? stepResult?.result === ResultConstant.RUNNING : currentExecutingStep?.result === ResultConstant.RUNNING;
    return stepId === currentExecutingStep?.stepId && isRunning;
  }, [stepResult, currentExecutingStep]);
  const shouldShowSuccessColor = !isMobileDebugger() ? currentExecutingStep?.stepId === (stepResult.stepId || stepResult?.metadata?.testStep.id) && currentExecutingStep?.result === ResultConstant.SUCCESS : false;
  const { bgColor, stepNumberColor } = execution_icon_default(result) || {};
  const divRef = useRef(null);
  const nlActions = useMemo(
    () => propNlActions ?? nlActionsFromContext ?? [],
    [propNlActions, nlActionsFromContext]
  );
  const isWebRecorder = propIsWebRecorder ?? isWebRecorderFromContext ?? false;
  useEffect(() => {
    if (!divRef.current || !measure) return;
    const resizeObserver = new ResizeObserver(() => {
      measure();
    });
    resizeObserver.observe(divRef.current);
    return () => {
      resizeObserver.disconnect();
    };
  }, [measure]);
  const updateStepsInfo = useCallback(
    (key, value) => {
      if (globalStepsInfo[key] != value) {
        const tempGlobalStepInfo = Object.assign({}, globalStepsInfo);
        tempGlobalStepInfo[key] = value;
        updateGlobalStepsInfo(tempGlobalStepInfo);
      }
    },
    [globalStepsInfo]
  );
  const toggleExpandStep = useCallback((_stepResult, expand) => {
    if (!_stepResult?.childResults?.length) return;
    if (expand === void 0) {
      expand = !_stepResult?.childResults?.[0].show;
    }
    if (expand) {
      _stepResult.childResults.forEach(
        (childResult) => childResult.show = expand
      );
    } else {
      _stepResult.childResults.forEach((childResult) => {
        childResult.show = false;
        toggleExpandStep(childResult, false);
      });
    }
  }, []);
  useEffect(() => {
    const nlpTemplate = nlActions.find((nlpAction) => {
      if (nlpAction.isAddon) {
        return nlpAction.id === step?.kibbutzPluginNlpId;
      } else if (!nlpAction.isAddon) {
        return nlpAction.id === step?.templateId;
      }
    });
    setTemplate(nlpTemplate);
  }, [nlActions, step, stepResult]);
  useEffect(() => {
    if (step) {
      setTestStep(
        step instanceof TestStep ? step : new TestStep().deserialize(step)
      );
    }
  }, [step]);
  const canRender = useMemo(
    () => !!testStep && (template || testStep?.isPresentationStep || testStep?.isStepGroup || testStep?.isRestStep || testStep?.isBlock || testStep?.isSoqlStep || isBlock(testStep)),
    [testStep, template]
  );
  const showActiveHighlight = useMemo(
    () => isStepResultDetails || isActive && !stepResult?.metadata?.stepGroup || stepResult.result == ResultConstant.FAILURE,
    [stepResult, isActive]
  );
  const iteration = useMemo(() => {
    if (!stepResult?.metadata?.forLoop && !stepResult?.metadata?.stepGroup) {
      return null;
    }
    if (step?.conditionType == TestStepConditionType.LOOP_WHILE) {
      return stepResult?.metadata?.forLoop?.["iteration"];
    } else if (step?.conditionType == TestStepConditionType.LOOP_FOR) {
      return stepResult?.metadata?.forLoop?.["index"] + 1;
    } else if (step?.type === TestStepType.STEP_GROUP) {
      return stepResult?.metadata?.["stepGroup"]?.["iteration"];
    } else {
      return null;
    }
  }, [step, stepResult]);
  const isFailedLoopStep = useMemo(
    () => stepResult?.metadata?.forLoop?.["testdata"] && !stepResult?.metadata?.forLoop?.["isLoopTitle"] && stepResult.result === ResultConstant.FAILURE,
    [stepResult]
  );
  const isExpaned = !collapsedStepResults?.includes(stepResult.uuid);
  const isExecutionCompleted = useMemo(
    () => [
      ResultConstant.SUCCESS,
      ResultConstant.FAILURE,
      ResultConstant.ABORTED,
      ResultConstant.STOPPED
    ].includes(currentExecutingStep?.result),
    [currentExecutingStep]
  );
  const indent = useMemo(
    () => stepResult?.indent ?? step?.indent,
    [stepResult?.indent, step?.indent]
  );
  const stepNumber = step?.stepNumber ?? stepResult?.stepNumber ?? "";
  const className = classNames82(
    `group hover:${bgColor || "bg-secondary-50"}`,
    {
      [bgColor]: showActiveHighlight,
      "animation-step-success-color-in-out": shouldShowSuccessColor,
      "!bg-secondary-100 relative before:absolute before:top-0 before:left-0 before:w-[2px] before:h-full before:bg-[#FAA53D]": showBcgColorForRunningStep
    },
    containerClassName
  );
  const expandIconClassName = useMemo(
    () => classNames82("cursor-not-allowed", {
      "opacity-100 cursor-pointer": isExecutionCompleted && !isViewOnly
    }),
    [isExecutionCompleted, isViewOnly]
  );
  const currentExecutingStepId = (stepResult?.stepId || stepResult?.metadata?.testStep.id) === currentExecutingStep?.stepId ? currentExecutingStep?.stepId : "";
  const column1Content = /* @__PURE__ */ jsx(execution_status_icon_default, { isExecuting: isExecuting2, stepResult: result });
  const column2Content = /* @__PURE__ */ jsx("div", { className: "w-2 h-2 rounded-sm border-secondary-100 rotate-45 border-[0.5px] group-hover:border-none bg-secondary-50" });
  const column3Content = /* @__PURE__ */ jsxs(Fragment, { children: [
    !isViewOnly && indent > 0 && /* @__PURE__ */ jsx(IndentResult, { size: indent, marginLeft: 26 }),
    /* @__PURE__ */ jsx(
      StepResultParentIndicator,
      {
        stepResult,
        step: testStep,
        className: "!w-fit",
        hideExpand: true
      }
    ),
    /* @__PURE__ */ jsx(
      StepNumber,
      {
        number: stepNumber,
        className: `${stepNumberColor} text-center !min-w-6`
      }
    ),
    (isStepGroup(step) || isBlock(step)) && /* @__PURE__ */ jsx(
      Icon,
      {
        name: !isExpaned ? "angle-right" : "angle-bottom",
        onClickCapture: () => {
          if (!isExecutionCompleted || isViewOnly) return;
          const collapsedSteps = isExpaned ? [...collapsedStepResults, stepResult.uuid] : collapsedStepResults.filter((id) => id !== stepResult.uuid);
          updateCollapsedStepResults(collapsedSteps);
        },
        className: expandIconClassName
      }
    ),
    (testStep?.isPresentationStep || testStep?.isConditionalElseIf || testStep?.isConditionalIf) && /* @__PURE__ */ jsx("span", { className: "pl-1 flex", children: /* @__PURE__ */ jsx(step_type_indicator_text_component_default, { step: testStep }) }),
    (testStep?.isKibbutz || testStep?.isCustomFunction) && /* @__PURE__ */ jsx(
      Icon,
      {
        name: "addons",
        className: classNames82({ "!mt-3": step?.action?.length > 150 })
      }
    )
  ] });
  const mainContent = /* @__PURE__ */ jsxs(Fragment, { children: [
    canRender && (stepResult.metadata?.forLoop?.["isLoopTitle"] || [
      StepResultType.FOR_LOOP_HEADER,
      StepResultType.WHILE_LOOP_HEADER
    ].includes(stepResult.resultType) || !stepResult?.metadata?.forLoop || stepResult?.metadata?.forLoop && !stepResult?.metadata?.forLoop?.["iteration"]) && /* @__PURE__ */ jsx(
      StepItemWrapper,
      {
        step: testStep,
        template,
        stepsInfo: globalStepsInfo,
        updateStepsInfo,
        isWebRecorder,
        isStepResult: true,
        isViewOnly: true
      }
    ),
    stepResult?.metadata?.["stepGroup"] && /* @__PURE__ */ jsxs("div", { className: "flex gap-x-3 text-small leading-4 text-unique-800 pl-2", children: [
      /* @__PURE__ */ jsx("span", { className: "px-3 py-0.5 border rounded-full bg-secondary-50 border-secondary-200", children: `SET NAME : ${stepResult?.metadata?.["stepGroup"]?.["setName"]}` }),
      /* @__PURE__ */ jsx("span", { className: "px-3 py-0.5 border rounded-full bg-secondary-50 border-secondary-200", children: `ETF : ${stepResult?.metadata?.["stepGroup"]?.["etf"] ? t("common.yes") : t("common.no")}` })
    ] }),
    stepResult?.metadata?.forLoop?.["iteration"] ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("div", { className: "flex gap-x-3  text-small leading-4 text-unique-800 pl-0.5", children: /* @__PURE__ */ jsx("span", { className: "py-0.5", children: "Iteration" }) }),
      Boolean(iteration) && /* @__PURE__ */ jsx("div", { className: "flex shrink-0 items-center justify-end text-secondary-600", children: /* @__PURE__ */ jsxs("span", { className: "text-2xs leading-3", children: [
        "#",
        iteration
      ] }) }),
      /* @__PURE__ */ jsx("div", { className: "flex gap-x-3  text-small leading-4 text-unique-800 pl-0.5", children: /* @__PURE__ */ jsx("span", { children: `(Set : ${stepResult?.metadata?.["forLoop"]?.["iteration"] || 1})` }) })
    ] }) : isFailedLoopStep ? /* @__PURE__ */ jsx("div", { className: "flex gap-x-3  text-small leading-4 text-unique-800 pl-0.5", children: /* @__PURE__ */ jsx("span", { className: "py-0.5", children: "Iteration not executed" }) }) : null,
    stepResult?.["stepGroupDataDriven"] ? /* @__PURE__ */ jsx("div", { className: "px-3 py-0.5 border rounded-full bg-secondary-50 border-secondary-200 pl-1 text-10px", children: /* @__PURE__ */ jsx("span", { children: `SET NAME : ${stepResult?.["stepGroupDataDriven"]?.["testDataSetName"]}` }) }) : null
  ] });
  const column4Content = !isExecuting2 && stepResult?.result !== ResultConstant.RUNNING ? /* @__PURE__ */ jsxs(Fragment, { children: [
    stepResult?.autoHealMetadata && /* @__PURE__ */ jsx("div", { className: "!visible", children: /* @__PURE__ */ jsx(
      AutoHealIcon,
      {
        result: stepResult.autoHealMetadata.status,
        className: "ml-3",
        showTooltip: true
      }
    ) }),
    !isViewOnly && debuggerActions && /* @__PURE__ */ jsx(
      row_actions_default,
      {
        stepResult,
        debuggerActions,
        nextStep
      }
    )
  ] }) : null;
  const containerProps = {
    className,
    dragHandleProps: {
      ...currentExecutingStepId ? { id: currentExecutingStepId } : {}
    },
    containerRef: divRef
  };
  const column1Props = { content: column1Content };
  const column2Props = { content: isStepResultDetails ? null : column2Content };
  const column3Props = { content: column3Content };
  const mainContentProps = { content: mainContent };
  const column4Props = {
    content: column4Content,
    className: "invisible group-hover:visible"
  };
  return /* @__PURE__ */ jsx(
    step_wrapper_default,
    {
      containerProps,
      column1Props,
      column2Props,
      column3Props,
      mainContentProps,
      column4Props
    }
  );
};
var executed_step_default = ExecutedStep;
var IndentUI = ({ showLine, step }) => {
  const ref = useRef(null);
  const [height, setHeight] = useState(0);
  const { isRecorderView } = useContext(StepContext);
  useEffect(() => {
    if (step) {
      const totalHeight = ref.current?.parentElement?.clientHeight;
      setHeight(totalHeight);
    }
  }, [ref, step]);
  return /* @__PURE__ */ jsx(
    "div",
    {
      ref,
      style: {
        marginLeft: `${isRecorderView ? 34 : 38}px`,
        height: `${height}px`
      },
      className: classNames82("min-w-[8px] border-l h-full", {
        "border-l-neutral-200": showLine,
        "border-l-transparent": !showLine
      })
    }
  );
};
var Indent2 = ({ size: size2, showLine = false, step }) => /* @__PURE__ */ jsx(Fragment, { children: Array(size2 || 0).fill(1).map((_, position) => /* @__PURE__ */ jsx(IndentUI, { showLine, step }, position)) });
var useModal = () => {
  const [modalState, setModalState] = useState({
    show: false,
    data: void 0
  });
  const openModal = useCallback(
    (data) => {
      setModalState({
        show: true,
        data
      });
    },
    [setModalState]
  );
  const closeModal = useCallback(() => {
    setModalState({
      show: false,
      data: void 0
    });
  }, [setModalState]);
  return {
    state: modalState,
    openModal,
    closeModal
  };
};
var useTenantInfo = () => {
  const { tenantFeatures = [], tenantPreference = {} } = useSelector((state) => state.widget) || {};
  const hasFeature = useCallback(
    (feature) => tenantFeatures.includes(feature),
    [tenantFeatures]
  );
  const hasTenantPreference = useCallback(
    (preference) => {
      return Boolean(tenantPreference[preference]);
    },
    [tenantPreference]
  );
  return {
    hasFeature,
    hasTenantPreference
  };
};
var BrokenScreenshotCard = () => {
  return /* @__PURE__ */ jsxs("div", { className: "bg-secondary-100 flex flex-col items-center gap-y-3.5 p-10", children: [
    /* @__PURE__ */ jsx(Icon, { name: "broken-image", className: "text-5xl" }),
    /* @__PURE__ */ jsxs("span", { className: "text-small leading-5", children: [
      "Failed to load image. ",
      /* @__PURE__ */ jsx("a", { className: "text-unique-500", children: "Click here" }),
      " to refresh the page"
    ] })
  ] });
};
var { Button: ButtonV2, BUTTON_VARIANTS } = V2;
var ImgPreview = ({
  src,
  name,
  onShowScreenshot,
  alt,
  coordinates,
  shouldDrawRectangle,
  showOnlyScreenshot,
  className,
  wrapperClassName,
  showScreenshotAndDownloadButton = true
}) => {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    setLoaded(shouldDrawRectangle);
  }, [src, shouldDrawRectangle, setLoaded]);
  return /* @__PURE__ */ jsxs("div", { className: classNames82("relative", wrapperClassName), children: [
    shouldDrawRectangle && /* @__PURE__ */ jsx(
      DrawRectanglesOverImage,
      {
        src,
        coordinates,
        className
      }
    ),
    !shouldDrawRectangle && /* @__PURE__ */ jsxs(Fragment, { children: [
      !loaded && /* @__PURE__ */ jsx("div", { className: "relative animate-shimmer-result h-[250px] w-full" }),
      src && /* @__PURE__ */ jsx(
        "img",
        {
          referrerPolicy: "no-referrer",
          src,
          className: classNames82(className, { hidden: !loaded }),
          alt,
          style: {
            cursor: "pointer",
            ...shouldDrawRectangle && { display: "none" }
          },
          onLoad: () => {
            setLoaded(true);
          }
        }
      )
    ] }),
    loaded && showScreenshotAndDownloadButton && /* @__PURE__ */ jsxs("div", { className: "absolute right-4 top-4 z-20 flex items-center gap-x-2", children: [
      !showOnlyScreenshot && /* @__PURE__ */ jsx(
        ButtonV2,
        {
          variant: BUTTON_VARIANTS.SECONDARY,
          className: "flex items-center justify-center !h-8 !w-8 !p-0 rounded-md !stroke-none",
          onClick: () => onShowScreenshot("screenshot"),
          children: /* @__PURE__ */ jsx(
            Icon,
            {
              name: "open-in-full",
              className: "!text-secondary-unique-800 !text-base"
            }
          )
        }
      ),
      /* @__PURE__ */ jsx(
        DownloadImageBtn,
        {
          src,
          name,
          className: "flex items-center justify-center !h-8 !w-8 !stroke-none !p-0",
          type: BUTTON_VARIANTS.SECONDARY,
          children: /* @__PURE__ */ jsx(
            Icon,
            {
              name: "download-underline",
              className: "!text-2xl !text-secondary-unique-800 !flex items-center"
            }
          )
        }
      )
    ] }),
    loaded && /* @__PURE__ */ jsx(
      "span",
      {
        className: `w-full h-full absolute top-0 z-10 cursor-pointer ${className}`,
        onClick: () => onShowScreenshot("screenshot"),
        style: {
          background: "linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))"
        }
      }
    )
  ] });
};
var StepResultScrenshot = ({
  source,
  name,
  onShowScreenshot,
  stepResult,
  visualResult,
  testCaseVisualResult,
  stepResultsCarouselProps,
  isDebugger
}) => {
  const { t } = useTranslation();
  const [enable, setEnable] = useState();
  const canShowVisualResultIcon = useMemo(() => {
    return stepResult?.metadata?.testStep?.visualEnabled || visualResult && (visualResult?.result === ResultConstant.SUCCESS || visualResult?.result === ResultConstant.FAILURE || visualResult?.result === ResultConstant.RUNNING);
  }, [visualResult, stepResult]);
  const getTooltip = useMemo(() => {
    if (!stepResult?.metadata?.testStep?.visualEnabled) {
      setEnable(false);
      return "visual-testing.disabled";
    }
    if (stepResult?.metadata?.testStep?.visualEnabled) {
      if (stepResult?.result === ResultConstant.FAILURE) {
        setEnable(false);
        return "visual_test.not_permformed.entity.failed";
      }
      if (stepResult?.result == ResultConstant.NOT_EXECUTED) {
        setEnable(false);
        return "visual_test.hint.no_rerun";
      }
    }
    if (canShowVisualResultIcon) {
      if (visualResult?.result == ResultConstant.FAILURE) {
        setEnable(true);
        return "visual_test.hint.differences";
      }
      if (visualResult?.result == ResultConstant.SUCCESS) {
        setEnable(true);
        return "visual_test.hint.no_differences";
      }
      if (stepResult?.result == ResultConstant.SUCCESS && !visualResult?.result && testCaseVisualResult?.[1] === ResultConstant.RUNNING || stepResult?.result == ResultConstant.RUNNING) {
        setEnable(false);
        return "visual_test.hint.running";
      }
    }
    if (visualResult?.result == ResultConstant.NOT_EXECUTED || testCaseVisualResult?.[0] === ResultConstant.NOT_EXECUTED || !testCaseVisualResult?.[0]) {
      setEnable(false);
      return `visual_test.hint.base_image_captured`;
    }
    if (visualResult?.result) {
      return `execution.result.${visualResult?.result}`;
    }
    return "";
  }, [stepResult, visualResult]);
  return /* @__PURE__ */ jsxs("div", { className: "pb-3", children: [
    /* @__PURE__ */ jsx("div", { className: "rounded-lg overflow-hidden shadow mt-3", children: source ? /* @__PURE__ */ jsx(
      ImgPreview,
      {
        src: source,
        name,
        onShowScreenshot,
        ...stepResultsCarouselProps,
        showScreenshotAndDownloadButton: !isDebugger
      }
    ) : /* @__PURE__ */ jsx(BrokenScreenshotCard, {}) }),
    !isDebugger && /* @__PURE__ */ jsx(
      ToolTip,
      {
        placement: "bottom",
        content: t(getTooltip),
        tooltipClassName: "text-center !max-w-xs",
        children: /* @__PURE__ */ jsx(
          "div",
          {
            className: `flex result-item !h-7 !justify-center gap-2 mt-3 ${!enable ? "!cursor-not-allowed opacity-50" : "!cursor-pointer"}`,
            onClick: () => enable && onShowScreenshot("visual_diff"),
            children: /* @__PURE__ */ jsxs("span", { className: "flex items-center gap-x-1", children: [
              /* @__PURE__ */ jsx(
                Icon,
                {
                  name: "visual-difference",
                  className: "text-xl text-secondary-600 flex items-center"
                }
              ),
              /* @__PURE__ */ jsx("span", { className: "text-2xs", children: "Visual Difference" })
            ] })
          }
        )
      }
    )
  ] });
};
var labelOptions = [
  {
    result: ResultConstant.RUNNING,
    color: "text-warning-600 bg-warning-1000",
    icon: "loader"
  },
  {
    result: ResultConstant.SUCCESS,
    color: "text-primary-600 bg-primary-100",
    icon: "check-circle"
  },
  {
    result: ResultConstant.FAILURE,
    color: "text-error-600 bg-error-100",
    icon: "cancel"
  },
  {
    result: ResultConstant.ABORTED,
    color: "text-warning-600 bg-warning-100",
    icon: "abort-circle-outline"
  },
  {
    result: ResultConstant.NOT_EXECUTED,
    color: "text-unique-400 bg-unique-400/10",
    icon: "hide-source"
  },
  {
    result: ResultConstant.QUEUED,
    color: "text-unique-500 bg-unique-500/10",
    icon: "queue-circle-outline"
  },
  {
    result: ResultConstant.STOPPED,
    color: "text-unique-800 bg-secondary-100",
    icon: "stop-circle"
  }
];
var getVisualTestClass = (visualTestResult) => {
  return visualTestResult && visualTestResult === ResultConstant.SUCCESS ? "text-[#1AA874]" : "text-error-700";
};
var ExecutionResultChip = ({
  result,
  visualTestResult = null,
  className
}) => {
  const { t } = useTranslation();
  const labelOpt = labelOptions.find((p) => p.result == result) || labelOptions.find((p) => p.result == ResultConstant.FAILURE);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames82(
          "flex items-center justify-center font-normal rounded-full text-2xs leading-3 py-1.5",
          result == ResultConstant.NOT_EXECUTED ? "w-[120px]" : "w-[80px]",
          labelOpt.color,
          className
        ),
        children: [
          /* @__PURE__ */ jsx(
            Icon,
            {
              name: labelOpt.icon,
              className: classNames82("text-xs", {
                "animate-spin": result == ResultConstant.RUNNING
              })
            }
          ),
          /* @__PURE__ */ jsx("span", { className: "ml-1 text-2xs", children: t("execution.result." + result) })
        ]
      }
    ),
    visualTestResult && /* @__PURE__ */ jsx(
      Icon,
      {
        name: "photo-camera",
        className: classNames82(
          "text-small leading-5 ml-2",
          getVisualTestClass(visualTestResult)
        )
      }
    )
  ] });
};
var StepResultHead = ({
  stepNumber,
  status
}) => {
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between py-2", children: [
    /* @__PURE__ */ jsxs("span", { className: "text-secondary-700 text-[15px] leading-5 pr-4 font-semibold", children: [
      "Step #",
      stepNumber
    ] }),
    /* @__PURE__ */ jsx(ExecutionResultChip, { result: ResultConstant[status] })
  ] }) });
};
var StepResultMetaCard = ({
  label,
  value,
  isInline,
  wrapperClassName,
  valueClassName = "",
  additionalValue,
  labelClassName,
  valueContainerClassName = ""
}) => /* @__PURE__ */ jsx(
  "div",
  {
    className: classNames82(
      "bg-white w-full py-2 text-unique-600",
      wrapperClassName
    ),
    children: /* @__PURE__ */ jsxs("div", { className: `${isInline ? "flex gap-x-4" : "flex flex-col gap-y-1"}`, children: [
      /* @__PURE__ */ jsx("div", { className: "w-11/12 flex items-center", children: /* @__PURE__ */ jsx(
        TruncatedText,
        {
          className: classNames82(
            labelClassName,
            "inline-block !font-normal !text-xs !text-secondary-500"
          ),
          value: label
        }
      ) }),
      /* @__PURE__ */ jsxs(
        "div",
        {
          className: classNames82(
            "flex items-center",
            additionalValue?.length > 0 ? "w-full" : "w-11/12",
            valueContainerClassName
          ),
          children: [
            /* @__PURE__ */ jsx(
              "div",
              {
                className: classNames82(
                  "flex items-center justify-between",
                  additionalValue?.length > 0 ? "w-1/2 " : "w-full"
                ),
                children: /* @__PURE__ */ jsx(
                  TruncatedText,
                  {
                    className: classNames82(
                      valueClassName,
                      "!font-medium inline-block !text-small"
                    ),
                    value
                  }
                )
              }
            ),
            additionalValue?.length > 0 && /* @__PURE__ */ jsx("div", { className: "w-1/2 flex items-center text-end", children: /* @__PURE__ */ jsx(
              TruncatedText,
              {
                className: "!font-medium !text-small !text-end",
                tootlipContainerClassName: "text-end",
                value: additionalValue
              }
            ) })
          ]
        }
      )
    ] })
  }
);
var statusWiseColor = {
  running: "#FCD34D",
  passed: "#1DBF84",
  failed: "#EF4444",
  notExecuted: "#9C8AE3",
  queued: "#6196DC",
  stopped: "#A0ABBB"
};
var ExecutionResultChartCard = ({
  size: size2 = "md",
  runningCount = 0,
  passedCount = 0,
  failedCount = 0,
  notExecutedCount = 0,
  queuedCount = 0,
  stoppedCount = 0,
  totalCount = 0
}) => {
  const { t } = useTranslation();
  const colorCodes = [];
  const count = [];
  const labels = [];
  const isSpacingRequired = useMemo(() => {
    const counts = [
      runningCount,
      passedCount,
      failedCount,
      notExecutedCount,
      queuedCount,
      stoppedCount
    ];
    const nonZeroCounts = counts.filter((count2) => count2 > 0);
    return nonZeroCounts.length >= 2;
  }, [
    runningCount,
    passedCount,
    failedCount,
    notExecutedCount,
    queuedCount,
    stoppedCount
  ]);
  if (runningCount) {
    colorCodes.push(statusWiseColor.running);
    count.push(runningCount);
    labels.push(ResultConstant.RUNNING);
  }
  if (passedCount) {
    colorCodes.push(statusWiseColor.passed);
    count.push(passedCount);
    labels.push(ResultConstant.SUCCESS);
  }
  if (failedCount) {
    colorCodes.push(statusWiseColor.failed);
    count.push(failedCount);
    labels.push(ResultConstant.FAILURE);
  }
  if (notExecutedCount) {
    colorCodes.push(statusWiseColor.notExecuted);
    count.push(notExecutedCount);
    labels.push(ResultConstant.NOT_EXECUTED);
  }
  if (queuedCount) {
    colorCodes.push(statusWiseColor.queued);
    count.push(queuedCount);
    labels.push(ResultConstant.QUEUED);
  }
  if (stoppedCount) {
    colorCodes.push(statusWiseColor.stopped);
    count.push(stoppedCount);
    labels.push(ResultConstant.STOPPED);
  }
  const customTooltips = {};
  const externalTooltipHandler = (context) => {
    const { chart, tooltip } = context;
    const chartId = chart.canvas.id;
    const dataPoint = tooltip?.dataPoints?.[0];
    const dataIndex = dataPoint?.dataIndex;
    const borderColor = dataPoint?.dataset?.backgroundColor?.[dataIndex];
    let customTooltip = customTooltips[chartId];
    if (!customTooltip) {
      customTooltip = document.createElement("div");
      customTooltip.id = `custom-tooltip-${chartId}`;
      customTooltip.style.position = "absolute";
      customTooltip.style.backgroundColor = "rgba(255, 255, 255, 1)";
      customTooltip.style.usePointerStyle = true;
      customTooltip.style.borderRadius = "3px";
      customTooltip.style.zIndex = 9999;
      chart.canvas.parentNode.appendChild(customTooltip);
      customTooltips[chartId] = customTooltip;
    }
    let tooltipHideTimeout;
    let isCursorOverChart = false;
    chart.canvas.addEventListener("mouseleave", () => {
      tooltipHideTimeout = setTimeout(() => {
        if (!isCursorOverChart) {
          customTooltip.style.display = "none";
        }
      }, 300);
    });
    chart.canvas.addEventListener("mouseenter", () => {
      isCursorOverChart = true;
      if (tooltipHideTimeout) {
        clearTimeout(tooltipHideTimeout);
      }
    });
    chart.canvas.addEventListener("mousemove", () => {
      isCursorOverChart = true;
    });
    chart.canvas.addEventListener("mouseout", () => {
      isCursorOverChart = false;
    });
    customTooltip.style.borderColor = borderColor;
    chart.canvas.addEventListener("mousemove", (event) => {
      const canvasPosition = chart.canvas.getBoundingClientRect();
      const offsetX = event.clientX - canvasPosition.left;
      const offsetY = event.clientY - canvasPosition.top;
      customTooltip.style.left = `${offsetX + 10}px`;
      customTooltip.style.top = `${offsetY + 10}px`;
    });
    customTooltip.style.display = "block";
    customTooltip.style.pointStyle = "circle";
    const content = `<div class="min-w-[90px] w-[100px] min-h-[48px] p-1 rounded shadow-mi">
        <div>
          <span style="
            height: 8px;
            width: 8px;
            background-color: ${borderColor};
            border-radius: 50%;
            display: inline-block;
            margin-left: 10px">
          </span>
          <span style="font-size:12px;" class="text-secondary-500 truncate w-[75px] ml-1">
            ${dataPoint?.label}
          </span>
        </div>
        <div>
          <span class="text-md text-secondary-700 truncate">
            <span class="font-semibold text-secondary-900 pl-7">${tooltip.dataPoints?.[0]?.parsed}</span>
          </span>
        </div>
        </div>`;
    customTooltip.innerHTML = content;
  };
  const options3 = {
    cutout: "60",
    layout: {
      padding: 0
    },
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        enabled: false,
        position: "nearest",
        external: externalTooltipHandler
      }
    }
  };
  const data = {
    datasets: [
      {
        backgroundColor: colorCodes,
        data: count,
        borderColor: colorCodes,
        spacing: isSpacingRequired ? 1 : 0,
        borderWidth: 0
      }
    ],
    labels: labels.map((result) => t(`execution.result.${result}`))
  };
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    DonutChart,
    {
      data,
      title: size2 !== "sm" ? `<div class="flex flex-col">
            <span class="text-unique-600 font-semibold text-lg"></span>
            <span>${totalCount}</span><span class="text-secondary-500 font-normal text-xs">${t(
        "execution.chart.total_steps"
      )}</span>
            </div>` : "",
      backgroundColor: "#fff",
      options: options3
    }
  ) });
};
var BrowserIcon = ({
  browser,
  className
}) => {
  switch (browser.toLowerCase()) {
    case BrowserName.Chrome.toLowerCase():
    case BrowserName.GoogleChrome.toLowerCase():
      return /* @__PURE__ */ jsx(
        Icon,
        {
          name: "chrome",
          className: classNames82(
            "text-small leading-5 text-secondary-500",
            className
          )
        }
      );
    case BrowserName.Edge.toLowerCase():
    case BrowserName.MicrosoftEdge.toLowerCase():
      return /* @__PURE__ */ jsx(
        Icon,
        {
          name: "edge",
          className: classNames82(
            "text-small leading-5 text-secondary-500",
            className
          )
        }
      );
    case BrowserName.Firefox.toLowerCase():
    case BrowserName.MozillaFirefox.toLowerCase():
      return /* @__PURE__ */ jsx(
        Icon,
        {
          name: "firefox",
          className: classNames82(
            "text-small leading-5 text-secondary-500",
            className
          )
        }
      );
    case BrowserName.Safari.toLowerCase():
      return /* @__PURE__ */ jsx(
        Icon,
        {
          name: "safari",
          className: classNames82(
            "text-small leading-5 text-secondary-500",
            className
          )
        }
      );
  }
};
var OsIcon = ({
  os,
  className = ""
}) => {
  switch (os) {
    case OperatingSystem.Mac:
      return /* @__PURE__ */ jsx(
        Icon,
        {
          name: "apple",
          className: classNames82("text-lg text-secondary-500", className)
        }
      );
    case OperatingSystem.Android:
      return /* @__PURE__ */ jsx(
        Icon,
        {
          name: "android",
          className: classNames82("text-md text-secondary-500", className)
        }
      );
    case OperatingSystem.Linux:
      return /* @__PURE__ */ jsx(
        Icon,
        {
          name: "linux",
          className: classNames82("text-md text-secondary-500", className)
        }
      );
    case OperatingSystem.Windows:
      return /* @__PURE__ */ jsx(
        Icon,
        {
          name: "windows",
          className: classNames82("text-md text-secondary-500", className)
        }
      );
    case OperatingSystem.iOS:
      return /* @__PURE__ */ jsx(
        Icon,
        {
          name: "ios",
          className: classNames82("text-md text-secondary-500", className)
        }
      );
  }
};
var LabIcon = ({ lab }) => {
  switch (lab) {
    case TestPlanLabType.TestsigmaLab:
      return /* @__PURE__ */ jsx(Icon, { name: "testsigma-logo", className: "text-lg" });
    case TestPlanLabType.SauceLabs:
      return /* @__PURE__ */ jsx(Icon, { name: "saucelabs-logo", className: "text-md" });
    case TestPlanLabType.BrowserStack:
      return /* @__PURE__ */ jsx(Icon, { name: "browserstack-logo", className: "text-md" });
    case TestPlanLabType.LambdaTest:
      return /* @__PURE__ */ jsx(Icon, { name: "lambdatest-logo", className: "text-md" });
    case TestPlanLabType.Hybrid:
      return /* @__PURE__ */ jsx(Icon, { name: "local-device", className: "text-md" });
  }
};
var ResultIcon = ({
  result,
  className
}) => {
  switch (result) {
    case ResultIconConstant.ABORTED:
      return /* @__PURE__ */ jsx(
        Icon,
        {
          name: "remove",
          className: classNames82("text-lg text-secondary-500", className)
        }
      );
    case ResultIconConstant.FAILURE:
      return /* @__PURE__ */ jsx(
        Icon,
        {
          name: "close",
          className: classNames82("text-lg text-secondary-500", className)
        }
      );
    case ResultIconConstant.NOT_EXECUTED:
      return /* @__PURE__ */ jsx(
        Icon,
        {
          name: "blur-off",
          className: classNames82("text-lg text-secondary-500", className)
        }
      );
    case ResultIconConstant.PAUSED:
      return /* @__PURE__ */ jsx(
        Icon,
        {
          name: "windows",
          className: classNames82("text-lg text-secondary-500", className)
        }
      );
    case ResultIconConstant.QUEUED:
      return /* @__PURE__ */ jsx(
        Icon,
        {
          name: "more-horizontal",
          className: classNames82("text-lg text-secondary-500", className)
        }
      );
    case ResultIconConstant.RUNNING:
      return /* @__PURE__ */ jsx(
        Icon,
        {
          name: "loader",
          className: classNames82(
            "text-lg text-secondary-500 animate-spin",
            className
          )
        }
      );
    case ResultIconConstant.STOPPED:
      return /* @__PURE__ */ jsx(
        Icon,
        {
          name: "square",
          className: classNames82("text-10px text-secondary-500", className)
        }
      );
    case ResultIconConstant.SUCCESS:
      return /* @__PURE__ */ jsx(
        Icon,
        {
          name: "check",
          className: classNames82("text-xs text-secondary-500", className)
        }
      );
    case ResultIconConstant.AFTER_SUITE_TEST_CASE_FAILURE:
      return /* @__PURE__ */ jsx(
        Icon,
        {
          name: "after-list",
          className: classNames82("text-lg text-secondary-500", className)
        }
      );
  }
};
var labelOptions2 = [
  {
    result: ResultConstant.RUNNING,
    color: "text-warning-600 !bg-warning-1000",
    icon: "loader"
  },
  {
    result: ResultConstant.SUCCESS,
    color: "text-primary-600 !bg-primary-50",
    icon: "check-circle"
  },
  {
    result: ResultConstant.FAILURE,
    color: "text-error-600 !bg-error-100",
    icon: "cancel"
  },
  {
    result: ResultConstant.NOT_EXECUTED,
    color: "text-secondary-unique-400 !bg-secondary-unique-1100/7",
    icon: "hide-source"
  },
  {
    result: ResultConstant.QUEUED,
    color: "text-unique-500 !bg-secondary-unique-1200/7",
    icon: "queue-circle-fill"
  },
  {
    result: ResultConstant.STOPPED,
    color: "text-secondary-600 !bg-secondary-100",
    icon: "stop-circle"
  },
  {
    result: "no-run",
    color: "text-neutral-600 !bg-transparent border-[0.5px] border-secondary-300",
    icon: null
  },
  {
    result: ResultConstant.SKIPPED,
    color: "text-neutral-700 !bg-neutral-100",
    icon: null
  }
];
var getVisualTestClass2 = (visualTestResult) => visualTestResult && visualTestResult === ResultConstant.SUCCESS ? "text-[#1AA874]" : "text-error-700";
var ResultLabel = ({
  result,
  visualTestResult = null,
  className,
  fixedWidth = true,
  iconClassName = ""
}) => {
  const { t } = useTranslation();
  const isNoResult = !result;
  const labelOpt = isNoResult ? labelOptions2.find((p) => p.result == "no-run") : labelOptions2.find((p) => p.result == result) || labelOptions2.find((p) => p.result == ResultConstant.FAILURE);
  const getTooltipContent = (result2) => {
    if (result2 == ResultConstant.NOT_EXECUTED)
      return t("execution.result.NOT_EXECUTED");
    else if (result2 == ResultConstant.PRE_REQUISITE_FAILURE)
      return t("execution.result.PRE_REQUISITE_FAILURE");
    else return null;
  };
  return /* @__PURE__ */ jsxs(ToolTip, { content: getTooltipContent(result), children: [
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames82(
          "flex items-center justify-center font-normal rounded-full text-2xs leading-3 py-1.5 w-[90px]",
          // isNoResult || (result == ResultConstant.NOT_EXECUTED && !fixedWidth) ? "w-[120px]" : "w-[80px]",
          labelOpt.color,
          className
        ),
        children: [
          !isNoResult && /* @__PURE__ */ jsx(
            Icon,
            {
              name: labelOpt.icon,
              className: classNames82(
                "text-xs",
                {
                  "animate-spin": result === ResultConstant.RUNNING
                },
                iconClassName
              )
            }
          ),
          /* @__PURE__ */ jsx("span", { className: "ml-1 text-2xs", children: t(
            "execution.result." + (isNoResult ? "no-run" : result) + (result == ResultConstant.NOT_EXECUTED || result == ResultConstant.PRE_REQUISITE_FAILURE ? ".truncated" : "")
          ) })
        ]
      }
    ),
    visualTestResult && /* @__PURE__ */ jsx(
      Icon,
      {
        name: "photo-camera",
        className: classNames82(
          "text-small leading-5 ml-2",
          getVisualTestClass2(visualTestResult),
          iconClassName
        )
      }
    )
  ] });
};
var VisualTestingResultIcon = ({
  resultEntity,
  onClick,
  className = "",
  isVisualTestingEnabled = false
}) => {
  const { t } = useTranslation();
  const visualResult = resultEntity?.consolidatedVisualResult;
  const canShowVisualResultIcon = useMemo(
    () => isVisualTestingEnabled || visualResult,
    [isVisualTestingEnabled, visualResult]
  );
  const visualTestResultHint = useMemo(() => {
    if (isVisualTestingEnabled) {
      if (resultEntity.result === ResultConstant.FAILURE) {
        return "visual_test.not_permformed.entity.failed";
      }
      if (resultEntity.result == ResultConstant.NOT_EXECUTED) {
        return "visual_test.hint.no_rerun";
      }
    }
    if (canShowVisualResultIcon) {
      if (visualResult == ResultConstant.FAILURE)
        return "visual_test.hint.differences";
      if (visualResult == ResultConstant.SUCCESS)
        return "visual_test.hint.no_differences";
      if (resultEntity.result == ResultConstant.SUCCESS && !visualResult || resultEntity.result == ResultConstant.RUNNING)
        return "visual_test.hint.running";
    }
    if (visualResult == ResultConstant.NOT_EXECUTED) {
      return `visual_test.hint.base_image_captured`;
    }
    if (visualResult) {
      return `execution.result.${visualResult}`;
    }
    return "";
  }, [
    resultEntity,
    visualResult,
    canShowVisualResultIcon,
    isVisualTestingEnabled
  ]);
  const visualTestResultIconColor = useMemo(() => {
    if (canShowVisualResultIcon) {
      if (resultEntity.result == ResultConstant.FAILURE)
        return `text-error-500`;
      return `text-${getColorPaletteByExecutionStatus(visualResult)}`;
    }
    return "";
  }, [visualResult, canShowVisualResultIcon, resultEntity]);
  return /* @__PURE__ */ jsx(Fragment, { children: canShowVisualResultIcon ? /* @__PURE__ */ jsx(
    Icon,
    {
      name: visualTestResultHint == "visual_test.hint.running" ? "visual-difference-loading" : "visual-difference",
      toolTip: t(visualTestResultHint),
      toolTipPlacement: "top",
      className: classNames82(
        `text-xl ${visualTestResultHint == "visual_test.hint.running" ? "text-warning-500 !opacity-100" : visualTestResultHint == "visual_test.not_permformed.entity.failed" ? "text-error-500 !opacity-100" : visualTestResultHint == "visual_test.hint.base_image_captured" ? "text-secondary" : visualTestResultHint == "visual_test.hint.no_rerun" ? "text-unique-400" : visualTestResultIconColor} flex items-center`,
        className
      ),
      onClick: () => onClick?.(),
      tootTipClassName: "!max-w-xs !text-center"
    }
  ) : /* @__PURE__ */ jsx(Fragment, {}) });
};

// src/utils/result-chip.utils.ts
var backGroundColor = [
  "bg-error-100",
  "bg-secondary-100",
  "bg-warning-100",
  "bg-secondary-100"
];
var textColor = [
  "text-error-800",
  "text-secondary-600",
  "text-warning-800",
  "text-secondary-unique-500"
];
var impactColorMap = {
  ["critical" /* Critical */]: backGroundColor[0],
  ["minor" /* Minor */]: backGroundColor[1],
  ["serious" /* Serious */]: backGroundColor[2],
  ["moderate" /* Moderate */]: backGroundColor[3]
};
var impactTextMap = {
  ["critical" /* Critical */]: textColor[0],
  ["minor" /* Minor */]: textColor[1],
  ["serious" /* Serious */]: textColor[2],
  ["moderate" /* Moderate */]: textColor[3]
};
var impactResultMap = {
  ["critical" /* Critical */]: "Critical",
  ["minor" /* Minor */]: "Minor",
  ["serious" /* Serious */]: "Serious",
  ["moderate" /* Moderate */]: "Moderate"
};
var ResultChip = ({
  result,
  className
}) => {
  const normalizedResult = result.toLowerCase();
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames82(
        "flex items-center justify-center font-semibold rounded-full text-2xs leading-3 py-1.5",
        normalizedResult === ResultConstant.NOT_EXECUTED ? "w-[120px]" : "w-[80px]",
        impactColorMap[normalizedResult],
        impactTextMap[normalizedResult],
        className
      ),
      children: /* @__PURE__ */ jsx("span", { className: "text-xs justify-center", children: impactResultMap[normalizedResult] })
    }
  );
};
var labelOptions3 = [
  {
    result: ResultConstant.RUNNING,
    color: "text-warning-700",
    icon: "loader"
  },
  {
    result: ResultConstant.SUCCESS,
    color: "text-primary-400",
    icon: "check-circle"
  },
  {
    result: ResultConstant.FAILURE,
    color: "text-error-500",
    icon: "cancel"
  },
  {
    result: ResultConstant.NOT_EXECUTED,
    color: "text-unique-400",
    icon: "hide-source"
  },
  {
    result: ResultConstant.QUEUED,
    color: "text-unique-500 ",
    icon: "queue-circle-fill"
  },
  {
    result: ResultConstant.STOPPED,
    color: "text-secondary-400",
    icon: "stop-circle"
  },
  {
    result: "no-run",
    color: "text-neutral-600 !bg-transparent",
    icon: null
  },
  {
    result: ResultConstant.SKIPPED,
    color: "text-neutral-700",
    icon: null
  }
];
var ResultLabelV2 = ({
  result,
  className,
  iconClassName,
  showResultText = false,
  resultTextClassName = ""
}) => {
  const { t } = useTranslation();
  const isNoResult = !result;
  const labelOpt = isNoResult ? labelOptions3.find((p) => p.result == "no-run") : labelOptions3.find((p) => p.result == result) || labelOptions3.find((p) => p.result == ResultConstant.FAILURE);
  return /* @__PURE__ */ jsx(ToolTip, { content: t("execution.result." + (isNoResult ? "no-run" : result)), children: /* @__PURE__ */ jsxs("div", { className: classNames82("flex items-center", className, labelOpt.color), children: [
    /* @__PURE__ */ jsx(
      Icon,
      {
        name: labelOpt.icon,
        className: classNames82(
          "text-lg",
          {
            "animate-spin": result === ResultConstant.RUNNING
          },
          iconClassName
        )
      }
    ),
    showResultText && /* @__PURE__ */ jsx(
      "p",
      {
        className: classNames82(
          "ml-1 text-2xs w-max font-semibold",
          resultTextClassName
        ),
        children: t("execution.result." + (isNoResult ? "no-run" : result))
      }
    )
  ] }) });
};
var AutoHealIcon = ({
  result,
  showTooltip = false,
  className = ""
}) => {
  const { t } = useTranslation();
  switch (result) {
    case AutoHealStatus.FAILURE:
      return /* @__PURE__ */ jsx(ToolTip, { content: showTooltip ? t("auto_heal.failed") : void 0, children: /* @__PURE__ */ jsx(
        "img",
        {
          className,
          src: autoHealFailure,
          alt: t("auto_heal.failed")
        }
      ) });
    case AutoHealStatus.SUCCESS:
      return /* @__PURE__ */ jsx(ToolTip, { content: showTooltip ? t("auto_heal.success") : void 0, children: /* @__PURE__ */ jsx(
        "img",
        {
          className,
          src: autoHealSuccess,
          alt: t("auto_heal.success")
        }
      ) });
    default:
      return /* @__PURE__ */ jsx(Fragment, {});
  }
};
var DataDrivenResultCard = ({
  dataDrivenResult,
  onSelect,
  active
}) => {
  const labelOpt = getLabelStyleByResult(
    dataDrivenResult.iterationResult.testCaseResultMetric.latestResult
  );
  const { t } = useTranslation();
  const etfText = useMemo(
    () => dataDrivenResult?.lastRunTestData?.expectedToFail ?? dataDrivenResult?.testData?.expectedToFail ? t("common.yes") : t("common.no"),
    [dataDrivenResult]
  );
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames82(
        "p-3 rounded border border-transparent cursor-pointer h-fit",
        labelOpt.bgColor,
        {
          [`${labelOpt.border}`]: active,
          "hover:border-primary-500": dataDrivenResult.iterationResult?.testCaseResultMetric.latestResult == ResultConstant.SUCCESS,
          "hover:border-error-600": dataDrivenResult.iterationResult?.testCaseResultMetric.latestResult == ResultConstant.FAILURE
        }
      ),
      onClick: onSelect,
      children: [
        /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-x-3", children: [
          /* @__PURE__ */ jsx(
            TruncatedText,
            {
              value: dataDrivenResult.testDataName?.replace(/\\n/g, " ")?.replace(/\n/g, " ") || "",
              className: "text-small flex-grow leading-[18px]"
            }
          ),
          /* @__PURE__ */ jsxs("span", { className: "bg-white p-1 text-2xs rounded text-[#808B9E]  whitespace-nowrap", children: [
            "ETF: ",
            etfText?.toUpperCase()
          ] })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "flex items-center mt-2", children: [
          /* @__PURE__ */ jsx(
            Icon,
            {
              name: labelOpt.icon,
              className: classNames82("text-base", labelOpt.textColor, {
                "animate-spin": dataDrivenResult?.iterationResult?.testCaseResultMetric.latestResult == ResultConstant.RUNNING
              })
            }
          ),
          /* @__PURE__ */ jsx("span", { className: classNames82("ml-1 text-small", labelOpt.textColor), children: t(
            "execution.result." + dataDrivenResult.iterationResult.testCaseResultMetric.latestResult
          ) }),
          /* @__PURE__ */ jsx("span", { className: "pl-2", children: dataDrivenResult?.iterationResult?.consolidatedVisualResult !== ResultConstant.NOT_EXECUTED && /* @__PURE__ */ jsx(
            VisualTestingResultIcon,
            {
              resultEntity: dataDrivenResult.iterationResult,
              className: "!text-base"
            }
          ) }),
          /* @__PURE__ */ jsxs("span", { className: "flex items-center gap-x-1 ml-auto text-secondary-500", children: [
            !!dataDrivenResult?.iterationResult?.lastReRunResult && /* @__PURE__ */ jsxs("span", { className: "font-normal text-xs flex px-0.5", children: [
              /* @__PURE__ */ jsx(Icon, { name: "replay", className: `pr-1.5 !flex items-center` }),
              t("common.rerun")
            ] }),
            /* @__PURE__ */ jsx(
              Icon,
              {
                name: "hourglass-top",
                className: `text-2xs !flex items-center`
              }
            ),
            /* @__PURE__ */ jsx("span", { className: " text-2xs", children: /* @__PURE__ */ jsx(
              DurationFormat,
              {
                milliseconds: dataDrivenResult?.iterationResult?.lastReRunResult?.duration || dataDrivenResult?.iterationResult?.testCaseResultMetric?.duration,
                format: "mm:ss.SSS"
              }
            ) })
          ] })
        ] })
      ]
    }
  );
};
var AutoHealDetailsFeedback = ({
  item,
  onFeedback,
  autoHealFeedback,
  isSuccess,
  customText,
  textClassName = "text-secondary-700 text-sm",
  screenType = "element"
}) => {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleFeedback = async (isPositive) => {
    if (isSubmitting) return;
    const finalFeedback = autoHealFeedback === isPositive ? null : isPositive;
    setIsSubmitting(true);
    try {
      await onFeedback?.(item, finalFeedback, screenType);
    } catch (err) {
      toastify(t("auto_heal.element.feedback.error"), {
        type: "error"
      });
      throw err;
    } finally {
      setIsSubmitting(false);
    }
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("span", { className: textClassName, children: customText || t(`auto_heal.feedback.${item.status}`) }),
    /* @__PURE__ */ jsx("div", { className: "flex gap-2", children: isSuccess ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          onClick: () => handleFeedback(false),
          "aria-label": t("auto_heal.give_negative_feedback"),
          isDisabled: isSubmitting,
          className: "flex items-center justify-center !w-7 !px-2 !text-md result-item cursor-pointer",
          children: /* @__PURE__ */ jsx(
            Icon,
            {
              name: autoHealFeedback === false ? "thumbs-down-filled" : "thumbs-down",
              className: `w-4 h-4 ${autoHealFeedback === false ? "text-error-500" : "text-secondary-800"}`
            }
          )
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          onClick: () => handleFeedback(true),
          "aria-label": t("auto_heal.give_positive_feedback"),
          isDisabled: isSubmitting,
          className: "flex items-center justify-center !w-7 !px-2 !text-md result-item cursor-pointer",
          children: /* @__PURE__ */ jsx(
            Icon,
            {
              name: autoHealFeedback ? "thumbs-up-filled" : "thumbs-up",
              className: `w-4 h-4 ${autoHealFeedback === true ? "text-legacy-primary-100" : "text-secondary-800"}`
            }
          )
        }
      )
    ] }) : /* @__PURE__ */ jsx(
      Button,
      {
        type: "light",
        onClick: () => handleFeedback(false),
        isDisabled: isSubmitting,
        className: "flex items-center justify-center result-item cursor-pointer",
        children: t("auto_heal.give_feedback")
      }
    ) })
  ] });
};

// src/components/test-recorder/api/auto-heal.ts
var namespace9 = "/private/auto_heal";
var submitElementFeedback = (payload) => {
  return instance_default.post(`${namespace9}/element_feedback`, payload).then((res) => res).catch((e) => Promise.reject(e));
};
var AutoHealApi = {
  submitElementFeedback
};
var { Button: ButtonV22, BUTTON_VARIANTS: BUTTON_VARIANTS2 } = V2;
var ElementItemRendered = ({
  item,
  idx,
  elementHeader,
  stepResult,
  onShowAutoHeal,
  onShowAutoHealComparisonModal,
  onShowAffectedInstance,
  application,
  onShowAffectedList,
  onViewSource,
  isDebugger = false,
  onAutoHealFeedback,
  autoHealFeedback,
  tenantId,
  testCaseResultId,
  elementKey,
  stepResultUuid,
  onElementFeedback
}) => {
  const [expandUiIdentifierDetails, toggleExpandStepDetails] = useState(false);
  const { t } = useTranslation();
  const isWindowsAdvanced = isObjectBased(application?.applicationType);
  const isMobileApp = application?.isWebMobile || application?.isMobileNative;
  const isAutoHealPerformed = stepResult?.autoHealMetadata || stepResult?.selfHealMetadata;
  const autoHealStatus = stepResult?.autoHealMetadata?.healedElements?.get(
    item.elementKey || FieldDefinitionDetailsType.UI_ELEMENT
  )?.status || (isAutoHealPerformed ? stepResult?.result : null);
  const AutoHealDetails2 = () => {
    return /* @__PURE__ */ jsxs("div", { className: "flex justify-between gap-x-2.5 py-2 pt-3 w-full", children: [
      /* @__PURE__ */ jsxs(
        Button,
        {
          type: "light",
          className: "gap-x-1 !px-2 result-item !h-8 flex-1 justify-center items-center min-w-0",
          onClick: () => onShowAutoHeal(item.elementKey),
          children: [
            /* @__PURE__ */ jsx(
              AutoHealIcon,
              {
                result: autoHealStatus,
                className: "min-h-4 min-w-4 flex-shrink-0"
              }
            ),
            /* @__PURE__ */ jsx(
              TruncatedText,
              {
                className: "!w-fit !text-center truncate",
                value: t("run_result.auto.heal")
              }
            )
          ]
        }
      ),
      isMobileApp && !isDebugger && /* @__PURE__ */ jsx(
        ToolTip,
        {
          content: t("run_result.compare.tooltip"),
          tooltipClassName: "!max-w-60 text-center",
          placement: "bottom",
          children: /* @__PURE__ */ jsxs(
            Button,
            {
              type: "light",
              className: "gap-x-1 !px-2 result-item !h-8 flex-[0.7] justify-center items-center min-w-0",
              onClick: () => onShowAutoHealComparisonModal(item.elementKey),
              children: [
                /* @__PURE__ */ jsx(Icon, { name: "compare", className: "min-w-4 flex-shrink-0" }),
                /* @__PURE__ */ jsx(
                  TruncatedText,
                  {
                    className: "!w-fit !text-center truncate",
                    value: t("run_result.compare")
                  }
                )
              ]
            }
          )
        }
      ),
      !isDebugger && /* @__PURE__ */ jsxs(
        Button,
        {
          type: "light",
          className: "gap-x-1 !px-2 result-item !h-8 flex-1 justify-center items-center min-w-0",
          onClick: onShowAffectedInstance,
          children: [
            /* @__PURE__ */ jsx(
              Icon,
              {
                name: "warning",
                className: "text-lg text-primary-600 items-center flex-shrink-0"
              }
            ),
            /* @__PURE__ */ jsx(
              TruncatedText,
              {
                className: "!w-fit !text-center truncate",
                value: t("run_result.affected.testcases")
              }
            )
          ]
        }
      )
    ] });
  };
  const healedElement = isAutoHealPerformed ? stepResult?.autoHealMetadata?.healedElements?.get(
    item.elementKey || FieldDefinitionDetailsType.UI_ELEMENT
  ) : null;
  const autoHealFeedbackBlock = healedElement ? /* @__PURE__ */ jsx("div", { className: "bg-secondary-50 border border-secondary-200 rounded-lg px-4 py-3 flex items-center justify-between shadow-sm mb-3", children: /* @__PURE__ */ jsx(
    AutoHealDetailsFeedback,
    {
      item: healedElement,
      onFeedback: async (autoHealedElement, isPositive) => {
        if (elementKey && stepResultUuid && onElementFeedback) {
          onElementFeedback(`${stepResultUuid}_${elementKey}`, isPositive);
        }
        if (onAutoHealFeedback) {
          await onAutoHealFeedback(autoHealedElement, isPositive);
        } else if (isPositive !== null) {
          if (!tenantId || !testCaseResultId) {
            throw new Error(t("auto_heal.element.feedback.error"));
          }
          try {
            await AutoHealApi.submitElementFeedback({
              tenantId,
              elementId: autoHealedElement.elementId,
              elementName: item?.uiIdentifierName || null,
              stepNumber: stepResult?.stepNumber || null,
              stepResultUuid: stepResult?.uuid || null,
              testCaseResultId,
              isPositive,
              screen: "STEP_INSIDE",
              createdAtEpoch: Date.now()
            });
            toastify(t("auto_heal.element.feedback.success"), {
              type: "success"
            });
          } catch (error) {
            throw error;
          }
        }
      },
      autoHealFeedback,
      isSuccess: autoHealStatus === ResultConstant.SUCCESS,
      screenType: "element"
    }
  ) }) : null;
  return /* @__PURE__ */ jsxs("div", { className: "bg-white rounded-[5px] border-secondary-200 border-0.5 px-5", children: [
    /* @__PURE__ */ jsx(
      Expandable,
      {
        isExpanded: expandUiIdentifierDetails,
        onChange: () => toggleExpandStepDetails(!expandUiIdentifierDetails),
        expandLabel: elementHeader(item, idx, autoHealStatus),
        collapseLabel: elementHeader(item, idx, autoHealStatus),
        className: "text-unique-600 font-medium flex-row-reverse justify-between",
        iconClassName: classNames82(
          `text-xl ${expandUiIdentifierDetails ? "rotate-180" : "rotate-90"}`
        ),
        labelClassName: "w-full !p-0 max-w-10/12",
        children: /* @__PURE__ */ jsx("div", { children: isWindowsAdvanced ? /* @__PURE__ */ jsxs(
          "div",
          {
            role: "button",
            onClick: () => onShowAffectedList(item),
            className: " flex justify-center gap-2 py-2 border border-secondary-200 rounded-lg my-3",
            children: [
              /* @__PURE__ */ jsx(Icon, { name: "warning", className: "text-primary-600 " }),
              /* @__PURE__ */ jsx("span", { className: "text-sm font-normal text-secondary-700", children: t("common.affected.cases") })
            ]
          }
        ) : /* @__PURE__ */ jsxs("div", { children: [
          autoHealFeedbackBlock,
          isAutoHealPerformed && /* @__PURE__ */ jsx(AutoHealDetails2, {}),
          /* @__PURE__ */ jsx(
            StepResultMetaCard,
            {
              label: t("label.element_title"),
              value: item?.uiIdentifierName,
              labelClassName: isDebugger ? "!font-semibold" : ""
            }
          ),
          /* @__PURE__ */ jsx(FadeInOutLine, {}),
          /* @__PURE__ */ jsx(
            StepResultMetaCard,
            {
              label: t("label.element_locator_type"),
              value: t(`element.locator_type.${[item?.locatorStrategyName]}`),
              labelClassName: isDebugger ? "!font-semibold" : ""
            }
          ),
          /* @__PURE__ */ jsx(FadeInOutLine, {}),
          item?.locatorStrategyName != "IMAGE" && /* @__PURE__ */ jsx(
            StepResultMetaCard,
            {
              label: t("label.element_locator_value"),
              labelClassName: isDebugger ? "!font-semibold" : "",
              valueContainerClassName: isDebugger ? "!w-[80vw]" : "",
              value: item?.uiIdentifierDefinition ? item?.uiIdentifierDefinition : "-"
            }
          ),
          item?.locatorStrategyName == "IMAGE" && /* @__PURE__ */ jsx(
            StepResultMetaCard,
            {
              label: t("element.image.occurance"),
              value: item?.imageLocator?.imageLocatorOccurence,
              labelClassName: isDebugger ? "!font-semibold" : ""
            }
          ),
          item?.locatorStrategyName == "IMAGE" && /* @__PURE__ */ jsx(
            StepResultMetaCard,
            {
              label: t("captured.element.image"),
              value: /* @__PURE__ */ jsx(
                ElementImageViewer,
                {
                  src: item?.imageLocator?.elementScreenshotPresignedUrl,
                  errorText: t("element.image.noimage")
                }
              )
            }
          ),
          application?.isWebMobile && !isAutoHealPerformed && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(FadeInOutLine, {}),
            /* @__PURE__ */ jsx(
              StepResultMetaCard,
              {
                label: `${t("label.view_source")} (${t(
                  "label.view_recordered_source"
                )})`,
                value: /* @__PURE__ */ jsx(
                  ButtonV22,
                  {
                    className: "p-0 !text-primary-600",
                    variant: BUTTON_VARIANTS2.LINK,
                    onClick: () => onViewSource("recorder"),
                    children: t("label.view_recordered_source_action")
                  }
                )
              }
            )
          ] }),
          stepResult.result === ResultConstant.FAILURE && application?.isWebMobile && !isAutoHealPerformed && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(FadeInOutLine, {}),
            /* @__PURE__ */ jsx(
              StepResultMetaCard,
              {
                label: `${t("label.view_source")} (${t(
                  "label.view_execution_source"
                )})`,
                value: /* @__PURE__ */ jsx(
                  ButtonV22,
                  {
                    className: "p-0 !text-primary-600",
                    variant: BUTTON_VARIANTS2.LINK,
                    onClick: () => onViewSource("execution"),
                    children: t("label.view_execution_source_action")
                  }
                )
              }
            )
          ] })
        ] }) })
      }
    ),
    !expandUiIdentifierDetails && isAutoHealPerformed && /* @__PURE__ */ jsx(AutoHealDetails2, {}),
    !expandUiIdentifierDetails && autoHealFeedbackBlock
  ] });
};
var element_render_default = ElementItemRendered;

// src/components/test-execution/step-result-panel/helper.ts
var getScreenshotUrl = (stepResult, hasDbStepResults, shouldReturnScreenShotUrl) => {
  if (hasDbStepResults) {
    return stepResult.screenShotURL;
  }
  const {
    screenshotFilePathForHighlighting,
    screenshotName,
    stepGroupHostCaseResultId,
    testCaseResultId
  } = stepResult;
  const tcrId = stepGroupHostCaseResultId || testCaseResultId;
  const name = screenshotFilePathForHighlighting || screenshotName || "";
  return tcrId && name && shouldReturnScreenShotUrl ? `/private/test_step_results/step_result_asset/${tcrId}/${name}/STEP` : null;
};
var { Button: ButtonV23, BUTTON_VARIANTS: BUTTON_VARIANTS3, BUTTON_SIZE } = V2;
var FadeInOutLine = ({ className }) => /* @__PURE__ */ jsx(
  "div",
  {
    className: classNames82("h-[1px]", className),
    style: {
      background: (
        // eslint-disable-next-line max-len
        "linear-gradient(90deg, #F1F4F6 0%, #F1F4F6 100%)"
      )
    }
  }
);
var StepResultDetails = ({
  stepResult,
  screenshotFileName,
  onShowAutoHeal,
  onShowAutoHealComparisonModal,
  onShowAffectedInstance,
  onShowScreenshot,
  className,
  onEditElement,
  variant = "step-result-view",
  testCaseResult,
  visualResult,
  OpenSalesforceApiResultModal,
  application,
  onViewSource,
  isHideHeader,
  openApiResultModal,
  hasFeatureValue: hasFeatureValue2,
  triggerAiAnalyzer,
  canAnalyze,
  DebuggerButton,
  onShowAffectedList,
  isDebugger,
  isScreenshotUrlProvided,
  screenshotUrl: screenshotUrlFromProps,
  applicationType: applicationTypeFromProps,
  stepNumber,
  tenantId,
  testCaseResultId,
  versionId,
  elementFeedbackMap,
  onElementFeedback
}) => {
  const { t } = useTranslation();
  const salesforceTestDataTypes = [
    TestDataType.salesforce_connection,
    TestDataType.salesforce_application,
    TestDataType.salesforce_object,
    TestDataType.salesforce_object_form,
    TestDataType.salesforce_tab
  ];
  const getSalesforceTestDataTypeDisplayName = (type) => {
    switch (type) {
      case TestDataType.salesforce_connection:
        return "Salesforce Connection";
      case TestDataType.salesforce_application:
        return "Salesforce Application";
      case TestDataType.salesforce_object:
        return "Salesforce Object";
      case TestDataType.salesforce_object_form:
        return "Salesforce Object Form";
      case TestDataType.salesforce_tab:
        return "Salesforce Tab";
      default:
        return "";
    }
  };
  const isSalesforcePrelearnedElement = applicationTypeFromProps === ApplicationType.Salesforce && get$1(
    stepResult,
    ["fieldDefinitionDetails", "ui-identifier", "isSfField"],
    false
  );
  const salesforceCustomeTestData = (testDataJson) => {
    const testDataList = [];
    if (!testDataJson) return testDataList;
    Object.keys(testDataJson)?.forEach((key) => {
      const testDataObject = testDataJson[key];
      if (!testDataObject?.isSalesforceApiStepData && salesforceTestDataTypes.includes(testDataObject?.testDataType)) {
        testDataList.push([
          getSalesforceTestDataTypeDisplayName(testDataObject?.testDataType),
          testDataObject?.testDataName
        ]);
      }
    });
    return testDataList;
  };
  const screenshotUrl = useMemo(() => {
    if (isScreenshotUrlProvided) {
      return screenshotUrlFromProps;
    }
    return getScreenshotUrl(
      stepResult,
      testCaseResult?.hasDbStepResults,
      stepResult?.canShowScreenshot
    );
  }, [
    stepResult,
    testCaseResult?.hasDbStepResults,
    isScreenshotUrlProvided,
    screenshotUrlFromProps
  ]);
  const stepResultsCarouselProps = useMemo(() => {
    const {
      screenshotFilePathForHighlighting,
      screenshotName,
      elementPositions: coordinates
    } = stepResult || {};
    const name = screenshotFilePathForHighlighting || screenshotName || "";
    const shouldDrawRectangle = isAllowedAppTypeForHighlight(application?.applicationType) && name && !!coordinates?.length;
    return {
      ...shouldDrawRectangle && {
        shouldDrawRectangle,
        coordinates
      }
    };
  }, [stepResult, application]);
  const onEditElementAction = (item) => {
    const elementId = item?.uiIdentifierEntity?.id || item?.salesforceObjectField?.id;
    onEditElement(
      item?.uiIdentifierEntity?.id ? { elementId } : { elementId, elementType: "salesforceObjectField" }
    );
  };
  const handleShowAffectedList = (item) => {
    onShowAffectedList({
      element: item?.["uiIdentifierEntity"]
    });
  };
  const elementData = useMemo(() => {
    if (!stepResult?.fieldDefinitionDetails) {
      return [];
    }
    const uniqueSalesforceObjectFieldIds = /* @__PURE__ */ new Set();
    const uniqueElementIds = /* @__PURE__ */ new Set();
    return Object.keys(stepResult?.fieldDefinitionDetails).reduce(
      (acc, item) => {
        const element = stepResult?.fieldDefinitionDetails?.[item];
        const elementWithKey = { ...element, elementKey: item };
        const elementId = element?.["uiIdentifierEntity"]?.id;
        const salesforceObjectFieldId = element?.["salesforceObjectField"]?.id;
        if (salesforceObjectFieldId && !uniqueSalesforceObjectFieldIds.has(salesforceObjectFieldId)) {
          uniqueSalesforceObjectFieldIds.add(salesforceObjectFieldId);
          acc.push(elementWithKey);
        } else if (elementId && !uniqueElementIds.has(elementId)) {
          uniqueElementIds.add(elementId);
          acc.push(elementWithKey);
        }
        return acc;
      },
      []
    );
  }, [stepResult]);
  const isResultTypeEligibleForAnalysis = () => {
    return stepResult?.resultType == StepResultType.NLP_TEXT || stepResult?.resultType == StepResultType.CONDITION_IF || stepResult?.resultType == StepResultType.CONDITION_ELSE_IF;
  };
  const showAnalyzerButton = canAnalyze && hasFeatureValue2?.("ANALYZER_BUG_REPORT_AGENT") && stepResult.result === ResultConstant.FAILURE && isResultTypeEligibleForAnalysis();
  const elementHeader = (item, idx, autoHealStatus) => /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames82("flex gap-y-2 items-center py-3 w-full", {
        "max-w-80": isDebugger
      }),
      children: [
        autoHealStatus && /* @__PURE__ */ jsx(
          AutoHealIcon,
          {
            result: autoHealStatus,
            className: "max-w-7 max-h-4 px-1 flex-shrink-0"
          }
        ),
        /* @__PURE__ */ jsx(
          "span",
          {
            className: classNames82(
              "text-unique-600  text-small leading-5 text-nowrap flex items-center",
              {
                "!font-medium": !isDebugger,
                "!font-semibold": isDebugger
              }
            ),
            children: t("run_result.element.head-default", {
              index: elementData?.length > 1 ? `#${idx + 1}` : ""
            })
          }
        ),
        /* @__PURE__ */ jsxs(
          "span",
          {
            className: "flex items-center w-fit pl-1 overflow-hidden",
            onClick: () => {
              if (isSalesforcePrelearnedElement && isDebugger) {
                return;
              }
              onEditElementAction(item);
            },
            children: [
              /* @__PURE__ */ jsx(
                TruncatedText,
                {
                  className: classNames82("!text-xs !font-semibold inline-block !w-fit", {
                    "!text-primary-600": stepResult?.result !== ResultConstant.FAILURE,
                    "!text-error-500": stepResult?.result === ResultConstant.FAILURE,
                    "!text-secondary-unique-700 cursor-not-allowed": isSalesforcePrelearnedElement && isDebugger
                  }),
                  value: item?.uiIdentifierName
                }
              ),
              !(isSalesforcePrelearnedElement && isDebugger) && /* @__PURE__ */ jsx(
                Icon,
                {
                  name: "edit-pencil",
                  className: "text-base text-secondary-600 cursor-pointer pl-2"
                }
              )
            ]
          }
        )
      ]
    }
  );
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames82("flex flex-col gap-3 mb-3 mt-3.5", {
        "mt-0": isDebugger
      }),
      children: [
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: classNames82(
              "text-unique-600 py-3 px-5 bg-white !mt-0 rounded-[5px] border-secondary-200 border-0.5",
              className
            ),
            children: [
              !isHideHeader && /* @__PURE__ */ jsx(
                StepResultHead,
                {
                  stepNumber: stepNumber ?? stepResult?.stepNumber ?? "-",
                  status: stepResult.result
                }
              ),
              variant == "step-result-view" && !isMobileDebugger() && screenshotUrl && isVisualTestingSupportedNLP(
                stepResult?.metadata?.testStep
              ) && /* @__PURE__ */ jsx(
                StepResultScrenshot,
                {
                  source: screenshotUrl,
                  name: screenshotFileName,
                  onShowScreenshot,
                  stepResult,
                  visualResult,
                  testCaseVisualResult: [
                    testCaseResult?.visualTestResult,
                    testCaseResult?.result
                  ],
                  stepResultsCarouselProps,
                  isDebugger
                }
              ),
              /* @__PURE__ */ jsxs("div", { className: "pb-3", children: [
                /* @__PURE__ */ jsx(
                  "div",
                  {
                    className: classNames82("text-small text-unique-600", {
                      "font-medium": !isDebugger,
                      "font-semibold": isDebugger
                    }),
                    children: stepResult.result === ResultConstant.FAILURE ? /* @__PURE__ */ jsxs(Fragment, { children: [
                      t("run_result.step.error-message"),
                      stepResult.errorCode ? " - #" + stepResult.errorCode : ""
                    ] }) : /* @__PURE__ */ jsx(Fragment, { children: t("run_result.step.message") })
                  }
                ),
                stepResult.message?.toLowerCase().includes("<html") ? /* @__PURE__ */ jsxs(Fragment, { children: [
                  /* @__PURE__ */ jsx(
                    "div",
                    {
                      className: "mt-1.5 text-secondary-unique-800 text-2xs break-words error-message",
                      dangerouslySetInnerHTML: {
                        __html: stepResult.message.split("<html>")[0] ?? ""
                      }
                    }
                  ),
                  /* @__PURE__ */ jsx(ToolTip, { content: stepResult.message, children: /* @__PURE__ */ jsx("pre", { className: "text-secondary-unique-800 text-2xs break-words error-message whitespace-pre-wrap", children: (() => {
                    const htmlContent = stepResult.message.split("<html>")[1] ?? "";
                    const lines = htmlContent.split("\n");
                    const maxLines = 10;
                    return lines.length > maxLines ? lines.slice(0, maxLines).join("\n") + "\n..." : htmlContent;
                  })() }) })
                ] }) : /* @__PURE__ */ jsx(
                  "div",
                  {
                    className: "mt-1.5 text-secondary-unique-800 text-2xs break-words error-message",
                    dangerouslySetInnerHTML: {
                      __html: stepResult.message ?? ""
                    }
                  }
                ),
                visualResult?.message && /* @__PURE__ */ jsxs(Fragment, { children: [
                  /* @__PURE__ */ jsx(
                    "div",
                    {
                      className: classNames82("text-unique-600 text-small pt-5", {
                        "font-medium": !isDebugger,
                        "font-semibold": isDebugger
                      }),
                      children: /* @__PURE__ */ jsx(Fragment, { children: t("run_result.step.visual-testing-result") })
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    "div",
                    {
                      className: "mt-1.5 text-secondary-unique-800 text-2xs break-words error-message",
                      dangerouslySetInnerHTML: {
                        __html: visualResult?.message
                      }
                    }
                  )
                ] })
              ] }),
              showAnalyzerButton && /* @__PURE__ */ jsxs("div", { className: "flex", children: [
                /* @__PURE__ */ jsxs(
                  ButtonV23,
                  {
                    onClick: () => triggerAiAnalyzer(stepResult?.stepNumber || "-"),
                    size: BUTTON_SIZE.SMALLEST,
                    variant: BUTTON_VARIANTS3.SECONDARY,
                    className: "!bg-ai-analyzer-gradient !text-white !w-1/2",
                    children: [
                      /* @__PURE__ */ jsx(Icon, { name: "ai-analyzer-agent", className: "text-lg" }),
                      /* @__PURE__ */ jsx("span", { children: "Analyze with Agent" })
                    ]
                  }
                ),
                DebuggerButton
              ] })
            ]
          }
        ),
        elementData?.map((item, idx) => /* @__PURE__ */ jsx(
          element_render_default,
          {
            item,
            idx,
            elementHeader,
            stepResult,
            onShowAutoHeal: () => onShowAutoHeal(item.elementKey),
            onShowAutoHealComparisonModal: () => onShowAutoHealComparisonModal(item.elementKey),
            onShowAffectedInstance,
            application,
            onViewSource,
            onShowAffectedList: handleShowAffectedList,
            isDebugger,
            versionId,
            tenantId,
            testCaseResultId,
            autoHealFeedback: elementFeedbackMap?.get(
              `${stepResult?.uuid}_${item.elementKey}`
            ),
            onElementFeedback,
            elementKey: item.elementKey,
            stepResultUuid: stepResult?.uuid
          },
          `element-item-${idx}`
        )),
        (salesforceCustomeTestData(stepResult?.testDataDetails)?.length || isSalesforceApiStep(stepResult?.metadata?.testStep)) && /* @__PURE__ */ jsxs("div", { className: "bg-white rounded-[5px] border-secondary-200 border-0.5 px-5 py-3", children: [
          /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-y-3", children: [
            salesforceCustomeTestData(stepResult.testDataDetails)?.map(
              (arr, seq) => /* @__PURE__ */ jsxs(
                "div",
                {
                  className: "flex justify-between gap-x-4 text-unique-600",
                  children: [
                    /* @__PURE__ */ jsx("span", { className: "font-medium text-small leading-5", children: /* @__PURE__ */ jsx(TruncatedText, { value: arr?.[0] }) }),
                    /* @__PURE__ */ jsx("span", { className: "text-small leading-5 break-all", children: /* @__PURE__ */ jsx(TruncatedText, { value: arr?.[1] }) })
                  ]
                },
                seq
              )
            ),
            isSalesforceReadApiStep(
              stepResult?.stepDetails
            ) && /* @__PURE__ */ jsx("div", { className: "flex flex-col gap-y-3", children: /* @__PURE__ */ jsxs("div", { className: "flex justify-between gap-x-4 text-unique-600", children: [
              /* @__PURE__ */ jsx("span", { className: "font-medium text-small leading-5", children: t("runresult.salesforce_api.requested_fields") }),
              /* @__PURE__ */ jsx(
                "span",
                {
                  className: "text-primary-600 font-medium text-sm cursor-pointer border-b-[0.5px] border-transparent hover:border-primary-500",
                  onClick: openApiResultModal,
                  children: t("runresult.salesforce_api.view_fields")
                }
              )
            ] }) })
          ] }),
          isSalesforceApiStep(stepResult?.metadata?.testStep) && /* @__PURE__ */ jsx("div", { className: "flex flex-col gap-y-3", children: /* @__PURE__ */ jsxs("div", { className: "flex justify-between gap-x-4 text-unique-600", children: [
            /* @__PURE__ */ jsx("span", { className: "font-medium text-small leading-5", children: t("common.request.body") }),
            /* @__PURE__ */ jsx(
              "span",
              {
                className: " text-primary-600 text-sm cursor-pointer font-medium",
                onClick: OpenSalesforceApiResultModal,
                children: t("common.view.json")
              }
            )
          ] }) })
        ] })
      ]
    }
  );
};

// src/components/test-execution/step-result-panel/utils.ts
var parseLogs = (logs) => {
  if (!logs) return [];
  return logs?.split("\n")?.filter((log2) => log2 !== "").map((log2) => {
    const parts = log2.split(" ");
    const head = parts.slice(0, 3).join(" ");
    const content = parts.slice(3).join(" ");
    return { head, content };
  });
};
var getLogs = (stepResult, isNlpAddon) => {
  if (isNlpAddon) {
    return stepResult?.kibbutzNlpLogs || "";
  }
  return Object?.values(stepResult?.kibbutzTDFLogs).join("\n") || "";
};
var decodeParameterisedSOQLQuery = (query) => {
  const parameterisedQueryRegex = /@\|(.*?)\||\$\|(.*?)\||\*\|(.*?)\||~\|(.*?)\||!\|(.*?)\||%\|(.*?)\||&\|(.*?)\||((?:[^@$*~!%&]|%(?!\|)|!(?!\|)|&(?!\|)|[$*~](?!\|))+)/g;
  if (!query) return "";
  return query.replace(parameterisedQueryRegex, (match, ...groups) => {
    const specialPatterns = groups.slice(0, 7);
    const isSpecialPattern = specialPatterns.some((g) => g !== void 0);
    const replacer = createCharReplacer(["%"], "");
    return isSpecialPattern ? match : decodeURIComponent(replacer(match));
  });
};
function createCharReplacer(charsToReplace, replacement = "_") {
  const pattern = new RegExp(`[${charsToReplace.join("")}]`, "g");
  return function(inputString) {
    return inputString.replaceAll(pattern, replacement);
  };
}
var StepResultMeta = ({
  stepResult,
  testCaseResult,
  className,
  onViewStepResult,
  dataDrivenResult,
  application,
  nlActions,
  isDebugger = false
}) => {
  const [expandStepDetails, toggleExpandStepDetails] = useState(false);
  const [expandStepData, toggleExpandStepData] = useState(false);
  const [expandMetadata, toggleExpandMetadata] = useState(false);
  const [expandMainTestData, toggleExpandMainTestData] = useState(false);
  const [expandTestData, toggleExpandTestData] = useState(false);
  const [expandAdditionalData, toglleAdditionalData] = useState(false);
  const { isElgibleForHighlight } = stepResult || {};
  const currentStepTemplateGrammar = useMemo(() => {
    return nlActions?.find((item) => {
      if (item.isAddon) {
        return item.id == stepResult?.metadata?.testStep?.kibbutzPluginNlpEntity?.id;
      }
      return item.id == stepResult?.metadata?.testStep?.templateId;
    })?.grammar;
  }, [nlActions, stepResult]);
  const { t } = useTranslation();
  const getStatusByState = (value, type) => {
    if (stepResult?.testDataDetails && Object.keys(stepResult?.testDataDetails).length == 1) {
      const key = Object.keys(stepResult?.testDataDetails)[0];
      value = stepResult?.testDataDetails[key]?.hasPassword;
    }
    switch (value) {
      case 1:
      case true:
      case "1":
        return "True" ;
      case false:
      case 0:
      case "0":
        return "False" ;
      default:
        return "No";
    }
  };
  const getTestDataValueForMetadata = useMemo(() => {
    let returnKey = stepResult?.metadata?.testDataValue;
    if (Object.keys(stepResult?.testDataDetails || {})?.length == 1) {
      const key = Object.keys(stepResult?.testDataDetails)[0];
      returnKey = stepResult?.testDataDetails[key]?.testDataValue;
    }
    return returnKey;
  }, [stepResult]);
  const getStepLevelScreenshotValue = (screenshotOption) => {
    switch (screenshotOption) {
      case StepLevelScreenshot.ALWAYS:
        return "step.settings.screenshot.ALWAYS";
      case StepLevelScreenshot.NO_SCREENSHOT:
        return "dry_run.screenshot_capture.NONE";
      case StepLevelScreenshot.STEP_FAILURE:
        return "step.settings.screenshot.STEP_FAILURE";
    }
  };
  const showHighlight = useMemo(
    () => isAllowedAppTypeForHighlight(application?.applicationType) && isElgibleForHighlight && !isStepAddon(stepResult?.metadata?.testStep) && hasStepValidXpath(stepResult?.stepDetails),
    [application, stepResult, isElgibleForHighlight]
  );
  const testStepContent = [
    {
      canShow: !stepResult?.isApiStep,
      label: t("test_step_details.maximum_wait_time"),
      value: `${stepResult?.metadata?.testStep?.waitTime || "30"} seconds`
    },
    {
      canShow: true,
      label: t("test_step_details.prerequisite"),
      value: stepResult?.prerequisiteResult ? /* @__PURE__ */ jsx(
        "span",
        {
          className: "text-primary-600 cursor-pointer font-medium",
          onClick: () => onViewStepResult(stepResult?.prerequisiteResult),
          children: `Step ${stepResult?.prerequisiteResult?.stepNumber}`
        }
      ) : "-"
    },
    {
      canShow: stepResult?.executionSettingEntity?.screenshot === Screenshot.HONOR_STEP_LEVEL_SETTINGS,
      label: t("dry_run.screenshot_capture"),
      value: t(
        getStepLevelScreenshotValue(
          stepResult?.metadata?.testStep?.stepLevelScreenshot
        )
      )
    },
    {
      canShow: true,
      label: t("test_step_details.stop_test_case_execution"),
      value: stepResult?.metadata?.testStep?.priority == TestStepPriority.MAJOR || stepResult?.metadata?.stepDetails?.priority == TestStepPriority.MAJOR || stepResult?.stepDetails?.priority == TestStepPriority.MAJOR ? t("common.yes") : t("common.no")
    },
    {
      canShow: !stepResult?.isAllConditionalStep && !(stepResult?.metadata?.testStep?.conditionType === TestStepConditionType.LOOP_WHILE),
      label: t("test_step_details.ignore_this_step"),
      value: stepResult?.metadata?.testStep?.ignoreStepResult || stepResult?.metadata?.stepDetails?.ignoreStepResult || stepResult?.stepDetails?.ignoreStepResult ? t("common.yes") : t("common.no")
    },
    {
      canShow: !stepResult?.isApiStep,
      label: t("test_step_details.enable_visual_testing"),
      value: stepResult?.metadata?.testStep?.visualEnabled ? t("common.yes") : t("common.no")
    },
    {
      canShow: true,
      label: t("test_step_details.enable_smart_execution"),
      value: stepResult?.metadata?.testStep?.smartActionsEnabled ? t("common.yes") : t("common.no")
    },
    {
      canShow: !stepResult?.isApiStep && application?.isAccessibilitySupported && testCaseResult?.environmentResult?.executionResult?.execution?.entityType != ExecutionEntityType.ADHOC_EXECUTION,
      label: t("test_step_details.enable_accessibility_testing"),
      value: stepResult?.metadata?.testStep?.accessibilityEnabled ? t("common.yes") : t("common.no")
    },
    {
      canShow: showHighlight,
      label: t("test_step_details.highlight_enabled"),
      value: stepResult?.metadata?.testStep?.highlightElement || stepResult?.metadata?.stepDetails?.highlightElement ? t("common.yes") : t("common.no")
    },
    {
      canShow: stepResult?.metadata?.testStep?.conditionType === TestStepConditionType.LOOP_WHILE,
      label: t("test_step_details.maximum_iteration"),
      value: String(stepResult?.metadata?.testStep?.maxIterations || "-")
    },
    {
      canShow: stepResult?.stepDetails?.retriedOrder,
      label: t("test_step_details.number_of_retry"),
      value: stepResult?.stepDetails?.retriedOrder || "-"
    },
    {
      canShow: stepResult?.isCustomFunction,
      label: t("test_step_details.className.label"),
      value: stepResult?.stepDetails?.dataMap?.customStep?.className || ""
    },
    {
      canShow: stepResult?.isCustomFunction,
      label: t("test_step_details.functionName.label"),
      value: stepResult?.stepDetails?.dataMap?.customStep?.functionName || ""
    },
    ...stepResult?.isCustomFunction && stepResult?.stepDetails?.dataMap?.customStep?.arguments ? Object.entries(
      stepResult?.stepDetails.dataMap.customStep.arguments
    ).map(([key, value]) => ({
      canShow: true,
      label: key,
      value
    })) : []
  ];
  const stepDetailsContent = [
    {
      canShow: true,
      label: t("run_result.step.type"),
      value: stepResult?.metadata?.testStep?.type || stepResult?.stepDetails?.type
    },
    {
      canShow: true,
      label: t("run_result.step.action"),
      value: stepResult?.metadata?.testStep?.action || stepResult?.stepDetails?.action
    },
    {
      canShow: true,
      label: t("run_result.step.priority"),
      value: stepResult?.metadata?.testStep?.priority || stepResult?.stepDetails?.priority
    }
  ];
  const metaDataHeaderContent = [
    {
      canShow: !!stepResult?.metadata,
      label: t("run_result.meta.id"),
      value: String(stepResult?.metadata?.testStep?.id || stepResult?.stepId)
    },
    {
      canShow: !!stepResult?.metadata,
      label: t("run_result.meta.action"),
      value: stepResult?.metadata?.testStep?.action || stepResult?.stepDetail?.action
    },
    {
      canShow: !!stepResult?.metadata,
      label: t("run_result.meta.has-password"),
      value: getStatusByState(
        stepResult?.metadata?.testStep?.hasPassword)
    },
    {
      canShow: !!stepResult?.metadata && !!stepResult?.metadata?.testDataValue,
      label: t("run_result.meta.test-data-value"),
      value: getTestDataValueForMetadata
    }
  ];
  const metaDataFooterContent = [
    {
      canShow: !!dataDrivenResult,
      label: t("run_result.meta.expected-to-fail"),
      value: dataDrivenResult?.testData?.expectedToFail ? t("common.yes") : t("common.no")
    },
    {
      canShow: true,
      label: t("run_result.meta.migrated"),
      value: stepResult?.metadata?.testStep?.additionalData?.["migrated"] ? t("common.yes") : t("common.no")
    },
    {
      canShow: !!stepResult?.metadata?.testStep?.dataMap?.["uiIdentifier"],
      label: t("run_result.meta.element"),
      value: stepResult?.metadata?.testStep?.dataMap?.["uiIdentifier"]
    }
  ];
  function getforLoopKey(testDatakey) {
    if (testDatakey === "test-data-profile") {
      return "testDataProfile";
    }
    if (testDatakey === "left-data") {
      return "leftData";
    }
    if (testDatakey === "right-data") {
      return "rightData";
    }
    return testDatakey;
  }
  const getTestDataMainContentData = () => {
    if (!stepResult?.testDataDetails) {
      return [];
    }
    return Object?.keys(stepResult?.testDataDetails)?.map((testData2) => {
      let testDataName = stepResult?.testDataDetails?.[testData2]?.overriddenMappingEntity?.parameterValue || stepResult?.testDataDetails?.[testData2]?.testDataName;
      let testDataValue = stepResult?.testDataDetails?.[testData2]?.testDataValue;
      let testDataType = stepResult?.testDataDetails?.[testData2]?.overriddenMappingEntity?.parameterType || stepResult?.testDataDetails?.[testData2]?.testDataType;
      testDataType = t(getTestDataTypeDisplayNameByType(testDataType));
      if (stepResult?.metadata?.testStep?.conditionType === TestStepConditionType.LOOP_FOR) {
        if (getforLoopKey(testData2) === "testDataProfile") {
          testDataName = stepResult?.metadata?.forLoop?.forLoopConditions?.testDataProfile?.value;
          testDataType = "Test Data Profile";
        }
        testDataValue = stepResult?.metadata?.forLoop?.forLoopConditions?.[getforLoopKey(testData2)]?.value;
        if (getforLoopKey(testData2) === "rightData" && testDataName == "-1") {
          testDataName = "end";
        }
        if (getforLoopKey(testData2) === "leftData" && testDataName == "-1") {
          testDataName = "start";
        }
      }
      if (testDataType === NLP_BLOCK_TYPE.raw) {
        testDataValue = "";
      }
      if (stepResult?.testDataDetails?.[testData2]?.hasPassword) {
        testDataName = stepResult?.testDataDetails?.[testData2]?.testDataValue;
        testDataValue = "";
      }
      return {
        canShow: true,
        key: testData2.replaceAll("-", "").toLowerCase(),
        testDataName,
        testDataType,
        testDataValue: testDataName === testDataValue ? "" : testDataValue
      };
    });
  };
  const testDataMainContent = useMemo(() => {
    let result = stepResult.testDataDetails ? getTestDataMainContentData() : [];
    const matches = currentStepTemplateGrammar?.match(/\{([^}]+)\}/g);
    if (matches) {
      const dataKeyInOrder = matches.map(
        (match) => match.slice(1, -1).toLowerCase()
      );
      result = dataKeyInOrder.map((key) => {
        return result.find((item) => item.key == key);
      });
    }
    return result.filter((item) => !!item);
  }, [stepResult, currentStepTemplateGrammar]);
  return /* @__PURE__ */ jsxs("div", { className: classNames82("flex gap-3 flex-col", className), children: [
    stepResult?.stepDetails?.type === "SOQL" && /* @__PURE__ */ jsxs("div", { className: "bg-white px-5 py-3 rounded-[5px] border-secondary-200 border-0.5", children: [
      /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          StepResultMetaCard,
          {
            label: t("soql.query"),
            value: decodeParameterisedSOQLQuery(
              stepResult?.apiStepResult?.salesforceAPIStepParameterDetails[0]?.parameterValue
            )?.replace(/([*~@$!%&])\|(.*?)\|/g, "$1{$2}"),
            additionalValue: "",
            valueClassName: "!text-unique-800 !font-normal !text-small",
            labelClassName: "capitalize"
          },
          92
        ),
        /* @__PURE__ */ jsx(FadeInOutLine, { className: "mb-1" })
      ] }),
      /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("p", { className: "font-light !text-sm text-slate-500", children: t("soql.parameter") }),
        /* @__PURE__ */ jsx(
          StepResultMetaCard,
          {
            label: t("soql.connection"),
            value: stepResult?.apiStepResult?.salesforceAPIStepDetails?.connectionName,
            additionalValue: "",
            valueClassName: "!font-semibold 10 !text-small !text-end text-black",
            labelClassName: "capitalize",
            wrapperClassName: "justify-between",
            isInline: true
          },
          90
        ),
        /* @__PURE__ */ jsx(FadeInOutLine, { className: "mb-1" })
      ] })
    ] }),
    testDataMainContent?.length > 0 && /* @__PURE__ */ jsx(
      Expandable,
      {
        isExpanded: expandMainTestData,
        onChange: () => toggleExpandMainTestData(!expandMainTestData),
        expandLabel: t("run_result.meta.test-data"),
        collapseLabel: t("run_result.meta.test-data"),
        className: classNames82(
          "text-unique-600 flex-row-reverse justify-between",
          {
            "font-medium": !isDebugger,
            "font-semibold": isDebugger
          }
        ),
        iconClassName: `text-xl ${expandMainTestData ? "rotate-180" : "rotate-90"}`,
        labelClassName: "!p-0",
        wrapperClassName: "bg-white px-5 py-3 rounded-[5px] border-secondary-200 border-0.5",
        children: /* @__PURE__ */ jsx("div", { children: testDataMainContent?.map(
          (item, index) => item?.canShow && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(
              StepResultMetaCard,
              {
                label: item?.testDataType,
                value: item?.testDataName?.replace(/\\n/g, " ")?.replace(/\n/g, " ") || "",
                additionalValue: item?.testDataValue?.replace(/\\n/g, " ")?.replace(/\n/g, " ") || "",
                valueClassName: "!text-unique-800 !font-normal !text-small",
                labelClassName: "capitalize"
              },
              index
            ),
            /* @__PURE__ */ jsx(FadeInOutLine, {})
          ] })
        ) })
      }
    ),
    /* @__PURE__ */ jsx(
      Expandable,
      {
        isExpanded: expandStepDetails,
        onChange: () => toggleExpandStepDetails(!expandStepDetails),
        expandLabel: t("step.test_details"),
        collapseLabel: t("step.test_details"),
        className: classNames82(
          "text-unique-600 flex-row-reverse justify-between",
          {
            "font-medium": !isDebugger,
            "font-semibold 8": isDebugger
          }
        ),
        iconClassName: `text-xl ${expandStepDetails ? "rotate-180" : "rotate-90"}`,
        labelClassName: "!p-0",
        wrapperClassName: "bg-white px-5 py-3 rounded-[5px] border-secondary-200 border-0.5",
        children: /* @__PURE__ */ jsx("div", { children: testStepContent?.map(
          (item, index) => item?.canShow && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(
              StepResultMetaCard,
              {
                label: item?.label,
                value: item?.value,
                valueClassName: classNames82({
                  "!font-semibold 7": isDebugger
                })
              },
              index
            ),
            /* @__PURE__ */ jsx(FadeInOutLine, {})
          ] })
        ) })
      }
    ),
    /* @__PURE__ */ jsxs(
      Expandable,
      {
        isExpanded: expandMetadata,
        onChange: () => toggleExpandMetadata(!expandMetadata),
        expandLabel: t("common.metadata"),
        collapseLabel: t("common.metadata"),
        className: classNames82(
          "text-unique-600 flex-row-reverse justify-between",
          {
            "font-medium": !isDebugger,
            "font-semibold 6": isDebugger
          }
        ),
        iconClassName: `text-xl ${expandMetadata ? "rotate-180" : "rotate-90"}`,
        labelClassName: "!p-0",
        wrapperClassName: "bg-white px-5 py-3 rounded-[5px] border-secondary-200 border-0.5",
        children: [
          /* @__PURE__ */ jsx(Fragment, { children: metaDataHeaderContent?.map(
            (item, index) => item?.canShow && /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(
                StepResultMetaCard,
                {
                  label: item?.label,
                  value: item?.value,
                  valueClassName: classNames82({
                    "!font-semibold 5": isDebugger
                  })
                },
                index
              ),
              /* @__PURE__ */ jsx(FadeInOutLine, {})
            ] })
          ) }),
          stepResult?.metadata && /* @__PURE__ */ jsxs("div", { children: [
            getTestDataMainContentData()?.length > 0 && /* @__PURE__ */ jsx(
              Expandable,
              {
                isExpanded: expandAdditionalData,
                onChange: () => toglleAdditionalData(!expandAdditionalData),
                expandLabel: t("run_result.additional.data"),
                collapseLabel: t("run_result.additional.data"),
                className: classNames82("text-unique-600 py-3", {
                  "font-medium": !isDebugger,
                  "font-semibold 4": isDebugger
                }),
                iconClassName: "text-xl ml-[-5px]",
                labelClassName: "!p-0",
                children: /* @__PURE__ */ jsx("div", { className: "bg-white pt-3 pl-3 ml-1 border-l border-secondary-200", children: /* @__PURE__ */ jsx(
                  Expandable,
                  {
                    isExpanded: expandTestData,
                    onChange: () => toggleExpandTestData(!expandTestData),
                    expandLabel: t("run_result.meta.test-data"),
                    collapseLabel: t("run_result.meta.test-data"),
                    className: classNames82("text-unique-600", {
                      "font-medium": !isDebugger,
                      "font-semibold 3": isDebugger
                    }),
                    iconClassName: "text-xl flex items-center justify-center ml-[-5px]",
                    labelClassName: "!p-0",
                    children: /* @__PURE__ */ jsx("div", { className: "pl-1", children: getTestDataMainContentData()?.map(
                      (item, index) => item?.canShow && /* @__PURE__ */ jsxs(Fragment, { children: [
                        /* @__PURE__ */ jsx(
                          StepResultMetaCard,
                          {
                            label: item?.testDataType,
                            value: item?.testDataName?.replace(/\\n/g, " ")?.replace(/\n/g, " ") || "",
                            additionalValue: item?.testDataValue?.replace(/\\n/g, " ")?.replace(/\n/g, " ") || "",
                            valueClassName: "!text-unique-800 !font-normal !text-small",
                            labelClassName: "capitalize",
                            wrapperClassName: "border-l border-secondary-200 pl-3"
                          },
                          index
                        ),
                        /* @__PURE__ */ jsx(FadeInOutLine, {})
                      ] })
                    ) })
                  }
                ) })
              }
            ),
            metaDataFooterContent?.length > 0 && /* @__PURE__ */ jsx("div", { className: "border-t border-secondary-200", children: metaDataFooterContent?.map(
              (item, index) => item?.canShow && /* @__PURE__ */ jsxs(Fragment, { children: [
                /* @__PURE__ */ jsx(
                  StepResultMetaCard,
                  {
                    label: item?.label,
                    value: item?.value,
                    valueClassName: classNames82({
                      "!font-semibold 1": isDebugger
                    })
                  },
                  index
                ),
                /* @__PURE__ */ jsx(FadeInOutLine, {})
              ] })
            ) })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      Expandable,
      {
        isExpanded: expandStepData,
        onChange: () => toggleExpandStepData(!expandStepData),
        expandLabel: t("run_result.step.details"),
        collapseLabel: t("run_result.step.details"),
        className: classNames82(
          "text-unique-600 flex-row-reverse justify-between",
          {
            "font-medium": !isDebugger,
            "font-semibold": isDebugger
          }
        ),
        iconClassName: `text-xl ${expandStepData ? "rotate-180" : "rotate-90"}`,
        labelClassName: "!p-0",
        wrapperClassName: "bg-white px-5 py-3 rounded-[5px] border-secondary-200 border-0.5",
        children: /* @__PURE__ */ jsx("div", { children: stepDetailsContent?.map(
          (item, index) => item?.canShow && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(
              StepResultMetaCard,
              {
                label: item?.label,
                value: item?.value,
                valueClassName: classNames82({
                  "!font-semibold !text-small": isDebugger
                })
              },
              index
            ),
            /* @__PURE__ */ jsx(FadeInOutLine, {})
          ] })
        ) })
      }
    )
  ] });
};
var AutoHealDetailsHeader = ({ onClose }) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: "grid items-center h-12 bg-secondary-50 gap-x-2 px-3",
      style: { gridTemplateColumns: "1fr auto" },
      children: [
        /* @__PURE__ */ jsx("span", { className: "text-secondary-700 font-semibold text-lg", children: t("run_result.auto.heal") }),
        /* @__PURE__ */ jsx("span", { onClick: onClose, children: /* @__PURE__ */ jsx(
          Icon,
          {
            name: "close",
            className: "text-secondary-600 text-xl font-semibold cursor-pointer"
          }
        ) })
      ]
    }
  );
};
var AutoHealDetailsBody = ({
  item,
  isDetailsPage = false,
  autoHealFeedback,
  tenantId,
  testCaseResultId,
  elementName: elementName2,
  stepNumber,
  stepResultUuid,
  onElementFeedback
}) => {
  const { t } = useTranslation();
  const formatDuration = (duration) => {
    const seconds = Math.floor(duration / 1e3);
    const milliseconds = duration % 1e3;
    return `${seconds}s ${milliseconds}ms`;
  };
  const isSuccess = item.status === AutoHealStatus.SUCCESS;
  const getHeader = () => {
    if (isSuccess) {
      return t("auto_heal.card.title", {
        locatorType: t(getElementTypeI18nKey(item.healedLocatorType))
      });
    }
    return t("auto_heal.current_locator");
  };
  const getElementDetails = (originalValue, healedValue) => {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
        "span",
        {
          className: classNames82(
            "text-warning-500 text-md font-mono break-all",
            {
              "line-through": isSuccess
            }
          ),
          children: originalValue
        }
      ) }),
      isSuccess && /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx("span", { className: "text-primary-600 text-md font-mono break-all", children: healedValue }) })
    ] });
  };
  const getHostElementDetails = () => {
    return /* @__PURE__ */ jsx(Fragment, { children: item.hostElements.map((hostElement, index) => /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsxs("span", { className: "text-secondary-600 text-md", children: [
        "Host #",
        index + 1,
        ":",
        " ",
        t(getElementHostTypeI18nKey(hostElement.hostType))
      ] }),
      getElementDetails(
        `${hostElement.originalLocatorValue} (${t(
          getElementTypeI18nKey(hostElement.originalLocatorType)
        )})`,
        `${hostElement.healedLocatorValue} (${t(
          getElementTypeI18nKey(hostElement.healedLocatorType)
        )})`
      )
    ] }, index)) });
  };
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsx("p", { className: "text-md text-secondary-600", children: t(`auto_heal.message.${item.status}`) }),
    /* @__PURE__ */ jsxs("div", { className: "bg-white border border-gray-200 rounded-lg shadow-sm mt-3", children: [
      /* @__PURE__ */ jsx(
        "div",
        {
          className: `
            p-3 pt-2 border-b border-gray-200 rounded-t-lg
            ${isSuccess ? "" : "bg-gray-50"}
          `,
          style: isSuccess ? {
            background: "linear-gradient(90.11deg, rgba(29, 192, 132, 0.2) 0%, rgba(126, 118, 222, 0.2) 99.93%)"
          } : void 0,
          children: /* @__PURE__ */ jsxs("div", { className: "flex justify-between items-center", children: [
            /* @__PURE__ */ jsx("span", { className: "font-normal text-md text-gray-800", children: getHeader() }),
            item.healDuration != 0 && /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 text-gray-800", children: [
              /* @__PURE__ */ jsx(Icon, { name: "pace", className: "w-4 h-4 text-gray-800" }),
              /* @__PURE__ */ jsx("span", { className: "text-sm", children: formatDuration(item.healDuration) })
            ] })
          ] })
        }
      ),
      /* @__PURE__ */ jsxs("div", { className: "px-4 py-3 pb-2 space-y-2", children: [
        getElementDetails(
          `${item.originalLocatorValue} (${t(
            getElementTypeI18nKey(item.originalLocatorType)
          )})`,
          item.healedLocatorValue
        ),
        item?.hostElements?.length > 0 && getHostElementDetails()
      ] })
    ] }),
    isDetailsPage && /* @__PURE__ */ jsx("div", { className: "bg-white border border-gray-200 rounded-lg px-4 py-3 mt-3 flex items-center justify-between shadow-sm", children: /* @__PURE__ */ jsx(
      AutoHealDetailsFeedback,
      {
        item,
        onFeedback: async (autoHealedElement, isPositive) => {
          if (onElementFeedback) {
            onElementFeedback(isPositive);
          }
          if (isPositive !== null && tenantId && testCaseResultId) {
            try {
              await AutoHealApi.submitElementFeedback({
                tenantId,
                elementId: autoHealedElement.elementId,
                elementName: elementName2 || autoHealedElement.name || null,
                stepNumber: stepNumber || null,
                stepResultUuid: stepResultUuid || null,
                testCaseResultId,
                isPositive,
                screen: "STEP_OUTSIDE",
                createdAtEpoch: Date.now()
              });
              toastify(t("auto_heal.element.feedback.success"), {
                type: "success"
              });
            } catch (error) {
              throw error;
            }
          }
        },
        autoHealFeedback,
        isSuccess,
        screenType: "element"
      }
    ) })
  ] });
};
var AutoHealDetails = ({
  stepResult,
  onClose,
  elementKey,
  onAutoHealElementUpdate,
  fetchElement,
  autoHealElementToUpdate,
  tenantId,
  testCaseResultId,
  autoHealFeedback,
  onElementFeedback,
  stepResultUuid
}) => {
  const autoHealedElement = useMemo(
    () => getAutoHealedElement(stepResult, elementKey),
    [stepResult, elementKey]
  );
  const { t } = useTranslation();
  const [element, setElement] = useState(null);
  useEffect(() => {
    if (autoHealedElement.elementId && (!autoHealElementToUpdate || !element)) {
      fetchElement(autoHealedElement.elementId).then((_element) => {
        setElement(_element);
      });
    }
  }, [autoHealedElement, autoHealElementToUpdate]);
  const showUpdateIgnoreButtons = useMemo(() => {
    return stepResult?.autoHealMetadata && element?.hasHealedElement && autoHealedElement.status === AutoHealStatus.SUCCESS;
  }, [stepResult?.autoHealMetadata, element, autoHealedElement]);
  const handleAutoHealElementUpdate = () => {
    const updatedElement = {
      ...element,
      hasHealedElement: false,
      definition: autoHealedElement.healedLocatorValue,
      locatorType: autoHealedElement.healedLocatorType
    };
    if (autoHealedElement?.hostElements?.length > 0) {
      if (updatedElement.hostElements) {
        updatedElement.hostElements = updatedElement.hostElements.map(
          (hostElement, index) => {
            const autoHealedHostElement = autoHealedElement.hostElements[index];
            if (autoHealedHostElement) {
              return {
                ...hostElement,
                definition: autoHealedHostElement.healedLocatorValue,
                locatorType: autoHealedHostElement.healedLocatorType
              };
            }
            return hostElement;
          }
        );
      }
    }
    onAutoHealElementUpdate(updatedElement);
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: "grid h-full overflow-y-auto",
      style: { gridTemplateRows: "auto auto 1fr" },
      children: [
        /* @__PURE__ */ jsx(AutoHealDetailsHeader, { onClose }),
        /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx("div", { className: "mx-auto p-4 max-w-[600px]", children: /* @__PURE__ */ jsxs(
          "div",
          {
            className: `rounded-lg border p-3  ${autoHealedElement.status === AutoHealStatus.SUCCESS ? "border-green-500 bg-green-50" : "border-gray-300 bg-[#F7F8F9]"}`,
            children: [
              /* @__PURE__ */ jsxs("div", { className: "flex gap-2 items-start", children: [
                /* @__PURE__ */ jsx("div", { className: "flex-shrink-0 flex flex-col items-center gap-3", children: /* @__PURE__ */ jsx(
                  AutoHealIcon,
                  {
                    result: autoHealedElement.status,
                    className: "h-7 w-7"
                  }
                ) }),
                /* @__PURE__ */ jsx(
                  TruncatedText,
                  {
                    className: "!text-base !font-semibold text-gray-800 flex-1 !min-w-0 mt-0.5",
                    value: autoHealedElement.name
                  }
                )
              ] }),
              showUpdateIgnoreButtons && /* @__PURE__ */ jsxs("div", { className: "rounded-lg p-4 max-w-md", children: [
                /* @__PURE__ */ jsx("p", { className: "text-secondary-500 text-md mb-4 font-normal", children: t("auto_heal.update_element") }),
                /* @__PURE__ */ jsxs("div", { className: "flex gap-3", children: [
                  /* @__PURE__ */ jsx(Button, { type: "primary", onClick: handleAutoHealElementUpdate, children: t("common.update") }),
                  /* @__PURE__ */ jsx(
                    Button,
                    {
                      type: "light",
                      onClick: () => {
                        setElement(null);
                      },
                      children: t("common.ignore")
                    }
                  )
                ] })
              ] })
            ]
          }
        ) }) }),
        /* @__PURE__ */ jsx("div", { className: "mt-4 px-8", children: /* @__PURE__ */ jsx(
          AutoHealDetailsBody,
          {
            item: autoHealedElement,
            isDetailsPage: true,
            autoHealFeedback,
            tenantId,
            testCaseResultId,
            elementName: autoHealedElement.name,
            stepNumber: stepResult?.stepNumber,
            stepResultUuid: stepResult?.uuid,
            onElementFeedback: (isPositive) => {
              if (elementKey && stepResultUuid && onElementFeedback) {
                onElementFeedback(`${stepResultUuid}_${elementKey}`, isPositive);
              }
            }
          }
        ) })
      ]
    }
  );
};
var ListItemSkeleton = ({
  wrapperClassName,
  className
}) => {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames82(
        "flex justify-center relative top-[18px]",
        wrapperClassName
      ),
      children: /* @__PURE__ */ jsx("div", { className: classNames82("empty-page-loader", className) })
    }
  );
};
var DependencyModal = ({
  isOpen,
  heading,
  description,
  dependencyList,
  warningNote,
  showDeleteConfirmation,
  actions,
  className,
  onClose,
  showCloseIcon,
  iconClassName,
  iconWrapperClassName,
  descriptionClassName,
  actionWrapperClassName,
  showIndex = true,
  iconName = "error"
}) => {
  const { t } = useTranslation();
  const [deleteText, setDeleteText] = useState(null);
  const { VirtualizedInfiniteLoader: VirtualizedInfiniteLoader9 } = InfiniteScrollV2;
  const itemRendered = (dependencies, idx) => {
    const dependencyItem = dependencies.items[idx];
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: "flex justify-between items-center mt-3 cursor-pointer",
        role: "row",
        children: [
          /* @__PURE__ */ jsx(
            TruncatedText,
            {
              role: "gridcell",
              value: `${showIndex ? `${idx + 1}. ${dependencyItem.name}` : `${dependencyItem.name}`}`,
              className: "text-small leading-5 text-unique-800"
            }
          ),
          dependencies.urlPath && /* @__PURE__ */ jsx(ToolTip, { content: dependencies.urlPathTooltip || "View", children: /* @__PURE__ */ jsx(
            "a",
            {
              href: (dependencies.baseUrl || "") + dependencies.urlPath.replace("{{id}}", dependencyItem.id.toString()).replaceAll(
                "{{versionId}}",
                dependencyItem.applicationVersionId
              ),
              target: "_blank",
              rel: "noreferrer",
              "aria-label": dependencies.urlPathTooltip || t("common.view_details"),
              children: /* @__PURE__ */ jsx(
                Icon,
                {
                  name: "open-in-new",
                  className: "ml-3 mr-1 text-base w-4 h-4 text-primary-500 hover:text-primary-800",
                  "aria-hidden": "true"
                }
              )
            }
          ) })
        ]
      },
      idx
    );
  };
  return /* @__PURE__ */ jsxs(
    Modal,
    {
      isOpen,
      className: classNames82(
        "!rounded-xl !p-8 !pb-6 overflow-y-scroll overflow-x-hidden max-h-[90vh]",
        {
          relative: showCloseIcon
        },
        className
      ),
      closeOnEscape: true,
      closeOnOutsideClick: true,
      onClose,
      showCloseButton: showCloseIcon,
      children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames82(
              "h-12 w-12 rounded-full border-spacing-2.5 bg-error-50 flex items-center justify-center",
              iconWrapperClassName
            ),
            children: /* @__PURE__ */ jsx(
              Icon,
              {
                name: iconName,
                className: classNames82(
                  "flex text-2xl text-error-600 p-1 bg-error-100 rounded-full",
                  iconClassName
                )
              }
            )
          }
        ),
        /* @__PURE__ */ jsx("div", { className: "mt-6 h-7 font-medium text-lg text-unique-600", children: heading }),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames82(
              "mt-4 max-w-md text-small leading-5 text-unique-800",
              descriptionClassName
            ),
            children: description.map((text, index) => /* @__PURE__ */ jsx("div", { className: "mb-2 leading-5", children: text }, index))
          }
        ),
        /* @__PURE__ */ jsx("div", { className: "max-w-md", children: dependencyList.map((dependencies, index) => /* @__PURE__ */ jsxs("div", { className: "mt-7", children: [
          /* @__PURE__ */ jsx("div", { className: "text-small leading-5 text-unique-800 font-medium h-5 flex items-center", children: dependencies.name }),
          /* @__PURE__ */ jsx("div", { className: "mt-2 border-b border-b-neutral-100 font-semibold" }),
          /* @__PURE__ */ jsx("div", { className: "mt-2 ml-1 h-full w-full", children: /* @__PURE__ */ jsx("div", { className: "h-[120px]", children: /* @__PURE__ */ jsx(
            VirtualizedInfiniteLoader9,
            {
              loadMore: dependencies?.infiniteScroll?.loadMore || NOOP,
              hasMore: dependencies?.infiniteScroll?.hasMore,
              rowHeight: 40,
              rowRenderer: (idx) => itemRendered(dependencies, idx),
              items: dependencies.items,
              rowCount: dependencies.items.length || 0,
              LoadingComponent: /* @__PURE__ */ jsx("div", { className: "mb-4", children: /* @__PURE__ */ jsx(ListItemSkeleton, {}) }),
              isLoading: dependencies?.infiniteScroll?.isLoading
            }
          ) }) })
        ] }, index)) }),
        warningNote?.length > 0 && /* @__PURE__ */ jsx("div", { className: "mt-4 max-w-md text-small leading-5 text-unique-800", children: warningNote?.map((text, index) => /* @__PURE__ */ jsx("div", { className: "mb-2 leading-5", children: text }, index)) }),
        showDeleteConfirmation && /* @__PURE__ */ jsxs("div", { className: "mt-8", children: [
          /* @__PURE__ */ jsx("div", { className: "text-small leading-5 text-unique-600 font-medium", children: t("common.delete.confirm") }),
          /* @__PURE__ */ jsx("div", { className: "mt-4", children: /* @__PURE__ */ jsx(
            Input,
            {
              id: "input",
              value: deleteText,
              onChange: setDeleteText,
              type: "text",
              wrapperClassName: "w-full mt-4"
            }
          ) })
        ] }),
        actions?.length && /* @__PURE__ */ jsx("div", { className: classNames82("mt-8 flex gap-2", actionWrapperClassName), children: actions.map((item, idx) => /* @__PURE__ */ jsx(
          Button,
          {
            type: item.type,
            onClick: item.handler,
            className: item.classNames,
            isDisabled: (!!item.enableOnConfirm ? deleteText !== "DELETE" : false) || item?.isDisabled,
            children: item?.canShowLoader ? /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(Icon, { name: "loader", className: "text-base animate-spin mr-2" }),
              item?.loadingText
            ] }) : item.name
          },
          idx
        )) })
      ]
    }
  );
};
var AutoHealElementUpdateModal = ({
  onElementUpdate,
  onClose,
  applicationVersionId,
  elementName: elementName2,
  fetchTestCases,
  baseUrl
}) => {
  const { t } = useTranslation();
  const [testCases, setTestCases] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isUpdating, setIsUpdating] = useState(false);
  const { isDebugger } = useRecorderContext() || {};
  const handleUpdate = useCallback(async () => {
    setIsUpdating(true);
    await onElementUpdate();
    setIsUpdating(false);
  }, [onElementUpdate]);
  const actions = useMemo(
    () => [
      {
        name: t("common.update"),
        type: "primary",
        handler: () => handleUpdate(),
        isDisabled: isLoading || isUpdating,
        canShowLoader: isUpdating,
        loadingText: t("common.updating")
      },
      {
        name: t("common.cancel"),
        type: "secondary",
        handler: () => onClose()
      }
    ],
    [isUpdating, isLoading, onClose, handleUpdate]
  );
  const dependencies = useMemo(() => {
    if (!testCases?.length) return [];
    return [
      {
        moduleName: t("common.test_case"),
        name: t("auto_heal.linked.test_cases"),
        urlPath: `/ui/td/${applicationVersionId}/cases/filters/{{id}}`,
        urlPathTooltip: t("test_case.view"),
        items: testCases,
        baseUrl
      }
    ];
  }, [testCases, baseUrl, applicationVersionId]);
  const fetchLinkedTestCases = async () => {
    const encodedName = encodeCustomSpecialCharacters(elementName2);
    const baseQuery = `applicationVersionId:${applicationVersionId}`;
    setIsLoading(true);
    await fetchTestCases(
      `${baseQuery},uiIdentifier:${encodedName},isStepGroup:false`,
      1e3
    ).then((res) => {
      setTestCases(res.content);
    }).catch((e) => {
      console.error(e);
      setTestCases([]);
    }).finally(() => setIsLoading(false));
  };
  useEffect(() => {
    if (elementName2) {
      fetchLinkedTestCases();
    }
  }, [elementName2]);
  return /* @__PURE__ */ jsx(
    DependencyModal,
    {
      isOpen: true,
      heading: t("element.update.element.label"),
      description: testCases?.length ? [t("auto_heal.element.update.description")] : [],
      warningNote: [t("auto_heal.element.update.warning")],
      actions,
      dependencyList: dependencies,
      className: classNames82({ "w-[70%]": isDebugger })
    }
  );
};
var getImageDataUri = async (src) => {
  try {
    const response = await instance_default.get(
      src,
      {},
      {
        headers: { redirect: "follow" },
        responseParser: (response2) => {
          return Promise.resolve({ url: response2.url });
        }
      }
    );
    return response.url;
  } catch (error) {
    console.error(`Failed to fetch image data from ${src}:`, error);
    throw error;
  }
};
var DebugStepResultPanel = ({
  stepResult,
  testCaseResult,
  onEditElement,
  uploadVersion,
  nlActions,
  onShowAffectedList,
  tenantId,
  testCaseResultId,
  fetchElement,
  fetchTestCases,
  acceptHealedElement: acceptHealedElement2,
  versionId,
  fullWidth = false,
  baseUrl,
  appType,
  stepNumber
}) => {
  const [autoHealElementKey, setAutoHealElementKey] = useState(null);
  const [screenshotUrl, setScreenshotUrl] = useState(null);
  const [autoHealElementUpdateState, setAutoHealElementUpdateState] = useState({
    isOpen: false,
    element: null
  });
  const [autoHealFeedback, setAutoHealFeedback] = useState(
    null
  );
  const { t } = useTranslation();
  const handleAutoHealElementUpdate = async () => {
    await acceptHealedElement2(
      autoHealElementUpdateState.element?.id,
      autoHealElementUpdateState.element
    ).then(() => {
      setAutoHealElementUpdateState({
        isOpen: false,
        element: null
      });
    }).catch(() => {
      toastify(t("auto_heal.element.update.error"), {
        type: "error"
      });
      setAutoHealElementUpdateState({
        ...autoHealElementUpdateState,
        isOpen: false
      });
    });
  };
  useEffect(() => {
    if (!isMobileDebugger()) {
      const screenshotUrl2 = getScreenshotUrl(
        stepResult,
        testCaseResult?.hasDbStepResults,
        true
      );
      setScreenshotUrl(screenshotUrl2);
      async function fetchAndSetImageDataUri() {
        if (screenshotUrl2) {
          const imageDataUri = await getImageDataUri(screenshotUrl2);
          setScreenshotUrl(imageDataUri);
        }
      }
      fetchAndSetImageDataUri();
    }
  }, [stepResult, testCaseResult?.hasDbStepResults]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("div", { className: "pl-6 pr-6 pt-2 pb-6", children: [
      /* @__PURE__ */ jsx(
        StepResultDetails,
        {
          stepResult,
          onShowAutoHeal: setAutoHealElementKey,
          onEditElement,
          variant: "step-result-view",
          testCaseResult,
          onShowAffectedList,
          isDebugger: true,
          canAnalyze: false,
          screenshotUrl,
          isScreenshotUrlProvided: true,
          applicationType: appType,
          stepNumber
        }
      ),
      (!isObjectEmpty(stepResult?.metadata || {}) || stepResult?.apiStepResultId != null) && /* @__PURE__ */ jsx(
        StepResultMeta,
        {
          stepResult,
          testCaseResult,
          className: "mt-5",
          uploadVersion,
          onViewStepResult: () => {
          },
          nlActions,
          isDebugger: true
        }
      )
    ] }),
    autoHealElementKey && /* @__PURE__ */ jsx(Drawer, { isOpen: !!autoHealElementKey, children: /* @__PURE__ */ jsx(
      DrawerItem,
      {
        direction: "right",
        ...fullWidth ? { className: "!w-full" } : { width: 600 },
        children: /* @__PURE__ */ jsx(
          AutoHealDetails,
          {
            stepResult,
            onClose: () => setAutoHealElementKey(null),
            elementKey: autoHealElementKey,
            onAutoHealElementUpdate: (element) => {
              setAutoHealElementUpdateState({
                isOpen: true,
                element
              });
            },
            tenantId,
            testCaseResultId,
            fetchElement,
            autoHealElementToUpdate: autoHealElementUpdateState.element
          }
        )
      }
    ) }),
    autoHealElementUpdateState.isOpen && /* @__PURE__ */ jsx(
      AutoHealElementUpdateModal,
      {
        elementName: autoHealElementUpdateState.element?.name,
        applicationVersionId: versionId,
        onClose: () => setAutoHealElementUpdateState({
          ...autoHealElementUpdateState,
          isOpen: false
        }),
        onElementUpdate: handleAutoHealElementUpdate,
        fetchTestCases,
        baseUrl
      }
    )
  ] });
};

// src/components/test-recorder/api/alpha.ts
var persistNamespace = "/alpha";
var post = (data, files, signal) => new Promise((resolve, reject) => {
  const formData = new FormData();
  formData.append(
    "data",
    new Blob([JSON.stringify(data)], { type: "application/json" })
  );
  files = files || [];
  for (const f of files) {
    formData.append("files", f);
  }
  return instance_default.postForm(`${persistNamespace}/generation/generate`, formData, signal).then((res) => resolve(res)).catch((err) => reject(err));
});
var getUsage = () => instance_default.get(`${persistNamespace}/usage`);
var PERSIST_TIMEOUT_MS = 6e4;
var persist = (data) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), PERSIST_TIMEOUT_MS);
  log.info("[AlphaApi.persist] Calling", `${persistNamespace}/persist`);
  log.info("[AlphaApi.persist] Data:", data);
  return instance_default.post(`${persistNamespace}/persist`, data, controller.signal).then((res) => {
    clearTimeout(timeoutId);
    log.info("[AlphaApi.persist] Success:", res);
    return res;
  }).catch((err) => {
    clearTimeout(timeoutId);
    log.error("[AlphaApi.persist] Error:", err);
    if (err?.name === "AbortError") {
      throw new Error("Save request timed out. Please try again.");
    }
    throw err;
  });
};
var getInteractionByUUID = (interaction_uuid) => {
  return instance_default.get(`${persistNamespace}/interaction/${interaction_uuid}`);
};
var saveFeedback = (interaction_uuid, feedback) => {
  return instance_default.patch(
    `${persistNamespace}/interaction/${interaction_uuid}/feedback`,
    feedback
  );
};
var AlphaApi = {
  post,
  getUsage,
  persist,
  getInteractionByUUID,
  saveFeedback
};

// src/components/test-recorder/api/testcase-results.ts
var resultEndpointNamespace2 = "/private/test_case_results";
var findById = (resultId) => instance_default.get(`${resultEndpointNamespace2}/${resultId}`);
var markAsFixed = (resultId, testStep) => instance_default.put(`${resultEndpointNamespace2}/${resultId}/mark_as_fixed`, testStep);
var TestcaseResultApi = {
  findById,
  markAsFixed
};
var DebuggingSlicePersistKey = "widget-debugging";
var initialState2 = {
  executionStatusList: [],
  debugExecutionStatus: null,
  testCaseResult: null,
  stepResultDetails: null,
  isStepResultLoading: false,
  currentExecutionStatus: null,
  executedStepIds: [],
  isPreRequisiteRunning: false,
  isPreRequisiteFailed: false,
  currentResumedStepResultId: null,
  stepResultModalOpen: false,
  stepResultModelData: null
};
var debuggingSlice = createSlice({
  name: DebuggingSlicePersistKey,
  initialState: initialState2,
  reducers: {
    setExecutionStatusList(state, action) {
      state.executionStatusList = action.payload;
    },
    setDebugExecutionStatus(state, action) {
      state.debugExecutionStatus = action.payload;
    },
    setTestCaseResult(state, action) {
      state.testCaseResult = action.payload;
    },
    setStepResultDetails(state, action) {
      state.stepResultDetails = action.payload;
    },
    setIsStepResultLoading(state, action) {
      state.isStepResultLoading = action.payload;
    },
    setCurrentExecutionStatus(state, action) {
      state.currentExecutionStatus = action.payload;
    },
    setExecutedStepIds(state, action) {
      state.executedStepIds = action.payload;
    },
    setIsPreRequisiteRunning(state, action) {
      state.isPreRequisiteRunning = action.payload;
    },
    setIsPreRequisiteFailed(state, action) {
      state.isPreRequisiteFailed = action.payload;
    },
    setCurrentResumedStepResultId(state, action) {
      state.currentResumedStepResultId = action.payload;
    },
    setStepResultModel(state, action) {
      state.stepResultModalOpen = action.payload.open;
      state.stepResultModelData = action.payload.data ? {
        stepResult: action.payload.data.stepResult
      } : null;
    },
    resetDebuggingSliceState(state) {
      Object.assign(state, initialState2);
    }
  }
});
var {
  setExecutionStatusList,
  setDebugExecutionStatus,
  setTestCaseResult,
  setStepResultDetails,
  setIsStepResultLoading,
  setCurrentExecutionStatus,
  setExecutedStepIds,
  setIsPreRequisiteRunning,
  setIsPreRequisiteFailed,
  setCurrentResumedStepResultId,
  setStepResultModel,
  resetDebuggingSliceState
} = debuggingSlice.actions;
var debuggingReducer = debuggingSlice.reducer;
var lastExecution = createSelector(
  [(state) => state.debugging.currentExecutionStatus],
  (currentExecutionStatus) => {
    return currentExecutionStatus?.liveStepResults?.[currentExecutionStatus?.liveStepResults?.length - 1] || {};
  }
);
var stepResultIds = createSelector(
  [(state) => state.debugging.currentExecutionStatus],
  (currentExecutionStatus) => {
    return currentExecutionStatus?.liveStepResults?.map((status) => status.uuid).filter((id) => !!id) || [];
  }
);
var selectStepResults = createSelector(
  [
    (state) => state.debugging.currentExecutionStatus,
    (state) => state.debugging.currentResumedStepResultId
  ],
  (currentExecutionStatus, currentResumedStepResultId) => {
    const modifiedStepResultArray = currentExecutionStatus?.liveStepResults?.map((executionItem) => {
      const processedStepResult = processDebuggerResult(executionItem);
      return Object.assign({}, processedStepResult);
    }) || [];
    const lastItem = modifiedStepResultArray?.[modifiedStepResultArray?.length - 1];
    if (lastItem?.uuid && lastItem.uuid === currentResumedStepResultId && (lastItem?.result === ResultConstant.PAUSED || lastItem?.isEligibleForDebug)) {
      modifiedStepResultArray[modifiedStepResultArray.length - 1].result = ResultConstant.RUNNING;
    }
    return modifiedStepResultArray;
  }
);
var selectCurrentExecutingStep = createSelector(
  [lastExecution, stepResultIds],
  (_lastExecution) => {
    const processedStepResult = processDebuggerResult(_lastExecution);
    return {
      isWebDebuggerExecutionModel: true,
      stepId: processedStepResult?.stepId,
      result: processedStepResult?.result,
      stepResultIds
    };
  }
);
var useWebDebugger = () => {
  const dispatch = useDispatch();
  const { sendToContentWindow, sendToBackground: sendToBackground2 } = useMessaging();
  const {
    actions,
    isDebugger,
    testCaseId,
    versionId,
    projectId,
    applicationType,
    tenantId,
    serverUrl
  } = useRecorderContext();
  const pendingRelaunchRef = useRef(false);
  const { currentExecutionStatus, testCaseResult } = useSelector(
    (state) => state.debugging
  );
  const testSteps = useSelector(
    (state) => state.widget?.testSteps || []
  );
  const stepResults = useSelector(selectStepResults);
  const currentExecutingStep = useSelector(selectCurrentExecutingStep);
  const updateDebugStepIds = useCallback(
    (stepId) => {
      if (stepId) {
        const updatedDebugPoints = currentExecutionStatus?.debugPoints?.includes(stepId) ? currentExecutionStatus.debugPoints.filter(
          (debugId) => debugId !== stepId
        ) : [...currentExecutionStatus?.debugPoints || [], stepId];
        dispatch(
          setCurrentExecutionStatus({
            ...currentExecutionStatus,
            debugPoints: updatedDebugPoints
          })
        );
      }
    },
    [currentExecutionStatus, dispatch]
  );
  const resumeExecution = useCallback(
    (stepResultId) => {
      if (!isDebugger) {
        dispatch(setCurrentResumedStepResultId(stepResultId));
        sendToContentWindow(
          MESSAGE_CONTEXT.RECORDER_DEBUGGER,
          DEBUGGER_ACTION.RESUME,
          stepResultId
        );
        sendToContentWindow(
          MESSAGE_CONTEXT.DEBUGGING,
          MESSAGE_CONTEXT_ACTION.UPDATE,
          "RESUME"
        );
      } else {
        actions.triggerDebuggerCommand?.({
          command: DEBUGGER_COMMANDS.RESUME_EVENT_COMMAND,
          payload: {
            last_executed_step_id: stepResultId
          }
        });
      }
    },
    [isDebugger, actions, sendToContentWindow, dispatch]
  );
  const removeDebugPointAndResume = (stepResultId) => {
    if (!isDebugger) {
      dispatch(setCurrentResumedStepResultId(stepResultId));
      sendToContentWindow(
        MESSAGE_CONTEXT.RECORDER_DEBUGGER,
        DEBUGGER_ACTION.RESUME_REMOVE_DEBUG_POINT,
        stepResultId
      );
      sendToContentWindow(
        MESSAGE_CONTEXT.DEBUGGING,
        MESSAGE_CONTEXT_ACTION.UPDATE,
        "RESUME_REMOVE_DEBUG_POINT"
      );
    } else {
      actions.triggerDebuggerCommand?.({
        command: DEBUGGER_COMMANDS.REMOVE_DEBUG_POINT_EVENT_COMMAND,
        payload: {
          stepId: stepResultId
        }
      });
    }
  };
  const rerunExecution = (stepResultId) => {
    if (!isDebugger) {
      dispatch(setCurrentResumedStepResultId(stepResultId));
      sendToContentWindow(
        MESSAGE_CONTEXT.RECORDER_DEBUGGER,
        DEBUGGER_ACTION.RUN_STEP,
        stepResultId
      );
      sendToContentWindow(
        MESSAGE_CONTEXT.DEBUGGING,
        MESSAGE_CONTEXT_ACTION.UPDATE,
        "RERUN"
      );
    } else {
      actions.triggerDebuggerCommand?.({
        command: DEBUGGER_COMMANDS.RERUN_EVENT_COMMAND,
        payload: {
          stepId: stepResultId
        }
      });
    }
  };
  const stepOverExecution = useCallback(
    (stepResultId, stepResult, nextStep) => {
      const stepOverSteps = "" + nextStep?.id;
      if (!isDebugger) {
        dispatch(setCurrentResumedStepResultId(stepResultId));
        sendToContentWindow(
          MESSAGE_CONTEXT.STEP_OVER_POINTS,
          MESSAGE_CONTEXT_ACTION.UPDATE,
          stepOverSteps
        );
      } else {
        actions.triggerDebuggerCommand?.({
          command: DEBUGGER_COMMANDS.STEP_OVER_EVENT_COMMAND,
          payload: {
            // step_over_points: [nextStep?.id],
            last_executed_step_id: stepResultId
          }
        });
      }
    },
    [isDebugger, actions, sendToContentWindow, dispatch]
  );
  const skipOverExecution = useCallback(
    (stepResultId, stepResult, nextStep) => {
      const skipOverSteps = "" + nextStep?.id;
      if (!isDebugger) {
        dispatch(setCurrentResumedStepResultId(stepResultId));
        sendToContentWindow(
          MESSAGE_CONTEXT.SKIP_OVER_POINTS,
          MESSAGE_CONTEXT_ACTION.UPDATE,
          skipOverSteps
        );
      } else {
        actions.triggerDebuggerCommand?.({
          command: DEBUGGER_COMMANDS.SKIP_OVER_EVENT_COMMAND,
          payload: {
            // skip_over_points: [nextStep?.id],
            last_executed_step_id: stepResultId
          }
        });
      }
    },
    [isDebugger, actions, sendToContentWindow, dispatch]
  );
  const relaunchRecorderAfterRestart = useCallback(() => {
    sendToBackground2({
      context: MESSAGE_CONTEXT.RECORDER,
      action: MESSAGE_CONTEXT_ACTION.LAUNCH,
      value: {
        type: RECORDER_TYPE.STEP,
        isNewUI: true,
        isInitialLoad: true,
        source: RECORDER_SOURCE.CLOUD,
        content: "Start Recording",
        isDebugMode: true,
        serverUrl,
        testCaseId,
        appVersionId: versionId,
        projectId,
        applicationType,
        tenantId
      }
    });
  }, [sendToBackground2, testCaseId, versionId, projectId, applicationType, tenantId, serverUrl]);
  const restartSession = useCallback(async () => {
    if (!isDebugger) {
      dispatch(setCurrentResumedStepResultId(null));
      const firstStep = testSteps[0];
      if (firstStep?.id) {
        sendToContentWindow(
          MESSAGE_CONTEXT.RECORDER_DEBUGGER,
          "debugger_run_from_here",
          firstStep.id
        );
        sendToContentWindow(
          MESSAGE_CONTEXT.DEBUGGING,
          MESSAGE_CONTEXT_ACTION.UPDATE,
          "RESTART"
        );
      }
    } else {
      pendingRelaunchRef.current = true;
      await actions.triggerDebuggerCommand?.({
        command: "restart_session_event_command"
      });
    }
  }, [isDebugger, actions, dispatch, testSteps, sendToContentWindow]);
  const runFromStep = useCallback(
    (stepId) => {
      if (!isDebugger) {
        dispatch(setCurrentResumedStepResultId(null));
        sendToContentWindow(
          MESSAGE_CONTEXT.RECORDER_DEBUGGER,
          "debugger_run_from_here",
          stepId
        );
        sendToContentWindow(
          MESSAGE_CONTEXT.DEBUGGING,
          MESSAGE_CONTEXT_ACTION.UPDATE,
          "RESTART"
        );
      } else {
        actions.triggerDebuggerCommand?.({
          command: "restart_session_event_command",
          payload: { run_from_step_id: stepId }
        });
      }
    },
    [isDebugger, actions, dispatch, sendToContentWindow]
  );
  const openStepResultDetails = useCallback(
    (stepResult) => {
      dispatch(
        setStepResultModel({
          open: true,
          data: { stepResult }
        })
      );
      dispatch(setIsStepResultLoading(true));
      dispatch(setStepResultDetails(stepResult));
    },
    [dispatch]
  );
  const closeStepResultDetails = useCallback(() => {
    dispatch(setStepResultModel({ open: false }));
    dispatch(setIsStepResultLoading(false));
  }, [dispatch]);
  const onToggleDebug = (stepId) => {
    updateDebugStepIds(stepId);
    if (!isDebugger) {
      sendToContentWindow(
        MESSAGE_CONTEXT.DEBUG_POINTS,
        MESSAGE_CONTEXT_ACTION.UPDATE,
        stepId
      );
    } else {
      actions.triggerDebuggerCommand?.({
        command: DEBUGGER_COMMANDS.INSERT_DEBUG_POINT_EVENT_COMMAND,
        payload: {
          new_debug_point: stepId
        }
      });
    }
  };
  useEffect(() => {
    const _executedStepIds = currentExecutionStatus?.liveStepResults?.filter((stepExecution) => {
      const resultId = stepExecution?.result?.id;
      return resultId !== 3 && resultId !== 5;
    })?.map(
      (stepExecution) => stepExecution.metadata?.testStep?.id
    ).filter((id) => !!id) || [];
    dispatch(setExecutedStepIds(_executedStepIds));
  }, [currentExecutionStatus?.liveStepResults, dispatch]);
  useEffect(() => {
    if (testCaseResult?.result === "PAUSED") {
      dispatch(setCurrentResumedStepResultId(null));
      if (pendingRelaunchRef.current) {
        pendingRelaunchRef.current = false;
        relaunchRecorderAfterRestart();
      }
    }
  }, [testCaseResult?.result, dispatch, relaunchRecorderAfterRestart]);
  const baseActions = { resumeExecution, restartSession, runFromStep };
  const fullActions = isDebugger ? {
    ...baseActions,
    rerunExecution,
    stepOverExecution,
    skipOverExecution,
    openStepResultDetails,
    onToggleDebug,
    removeDebugPointAndResume
  } : baseActions;
  return {
    // Core debugging state
    currentExecutingStep,
    stepResults,
    debugPoints: currentExecutionStatus?.debugPoints || [],
    // Actions
    debuggerActions: fullActions,
    // Modal related
    closeStepResultDetails
  };
};
var use_web_debugger_default = useWebDebugger;
var MemorizedIcon = memo(
  ({
    name,
    className,
    onClick = NOOP
  }) => {
    return /* @__PURE__ */ jsx(Icon, { name, className, onClick });
  }
);
MemorizedIcon.displayName = "MemorizedIcon";

// src/components/test-authoring/formatted-step/anlayzer/types/index.tsx
var CHAT_ACTIONS = {
  REPORT_BUG: "REPORT_BUG",
  FIX_USING_HEALER_AGENT: "FIX_USING_HEALER_AGENT"
};
var { Button: ButtonV24, BUTTON_SIZE: BUTTON_SIZE2, BUTTON_VARIANTS: BUTTON_VARIANTS4 } = V2;
var APPLY_FIX_AND_REPORT_BUG_RENDERER = (selectedSuggestionIndex, isLatestRun, latestTestCaseResultId) => {
  const APPLY_FIX_AND_REPORT_BUG = (onClickMessage) => {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("div", { className: "flex gap-x-3", children: [
        /* @__PURE__ */ jsx(
          ButtonV24,
          {
            variant: BUTTON_VARIANTS4.PRIMARY,
            className: "!px-2 !py-0.5 gap-x-4 !font-normal",
            size: BUTTON_SIZE2.NORMAL,
            disabled: !isLatestRun || selectedSuggestionIndex === null,
            onClick: () => onClickMessage({
              action: CHAT_ACTIONS.FIX_USING_HEALER_AGENT
            }),
            children: "Apply Fix"
          }
        ),
        /* @__PURE__ */ jsx(
          ButtonV24,
          {
            variant: BUTTON_VARIANTS4.SECONDARY,
            className: "!px-2 !py-0.5 gap-x-4 !font-normal",
            size: BUTTON_SIZE2.NORMAL,
            onClick: () => {
              onClickMessage({
                action: CHAT_ACTIONS.REPORT_BUG
              });
            },
            "aria-label": __("common.report-bug"),
            children: __("common.report-bug")
          }
        )
      ] }),
      !isLatestRun && /* @__PURE__ */ jsx(
        Note,
        {
          type: "warning",
          heading: /* @__PURE__ */ jsxs("span", { children: [
            __("analyzer.fix.latest_run_note"),
            " ",
            /* @__PURE__ */ jsx(
              "a",
              {
                href: `/ui/td/dry_run/${latestTestCaseResultId}/step_results`,
                target: "_blank",
                rel: "noreferrer",
                className: "text-primary-600",
                children: __("analyzer.fix.go_to_latest")
              }
            ),
            __("analyzer.fix.run_to_apply")
          ] }),
          className: "mt-2"
        }
      )
    ] });
  };
  return APPLY_FIX_AND_REPORT_BUG;
};
var ConvertAnalyzerDataToUI = ({
  jsonData,
  currentExecutionScreenshot,
  elementSourceScreenshot,
  onClickSuggestion,
  selectedSuggestionIndex,
  isLatestRun
}) => {
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", { className: "text-xs text-secondary-600", children: [
    /* @__PURE__ */ jsxs("div", { className: "mb-4", children: [
      /* @__PURE__ */ jsxs("span", { className: "font-medium text-primary-600", children: [
        __("analyzer.main_result.error_type"),
        " "
      ] }),
      /* @__PURE__ */ jsx("span", { className: "bg-red-100 text-red-800 px-2 py-1 rounded", children: jsonData?.classified_error })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "mb-4", children: [
      /* @__PURE__ */ jsx("span", { className: "font-medium text-primary-600", children: __("analyzer.main_result.root_cause") }),
      /* @__PURE__ */ jsx("p", { className: "mt-1 text-secondary-700 text-sm font-medium", children: jsonData?.root_cause })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "mb-4", children: [
      /* @__PURE__ */ jsxs("span", { className: "font-medium text-primary-600", children: [
        __("analyzer.main_result.visual_evidence"),
        " "
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "flex w-full overflow-hidden rounded-lg mt-2", children: [
        elementSourceScreenshot && /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx("span", { children: __("common.recorded.state") }),
          /* @__PURE__ */ jsx("div", { className: "mt-2 h-40 w-60 flex items-center justify-center bg-gray-100", children: /* @__PURE__ */ jsx(
            ImageViewer,
            {
              src: elementSourceScreenshot,
              enablePageFullScreen: true,
              className: "!rounded-lg",
              imageClass: "!h-fit !w-fit"
            }
          ) })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: classNames82({ "ml-8": !!elementSourceScreenshot }), children: [
          /* @__PURE__ */ jsx("span", { children: __("common.executed.state") }),
          /* @__PURE__ */ jsx("div", { className: "mt-2 h-40 w-60 flex items-center justify-center bg-gray-100", children: /* @__PURE__ */ jsx(
            ImageViewer,
            {
              src: currentExecutionScreenshot,
              enablePageFullScreen: true,
              className: "!rounded-lg",
              imageClass: "!h-fit !w-fit"
            }
          ) })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx("span", { className: "font-medium text-primary-600", children: "Suggestions:" }),
      /* @__PURE__ */ jsxs("div", { children: [
        __("analyzer.main_result.suggestions_intro"),
        " "
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "text-sm text-secondary-500", children: [
        /* @__PURE__ */ jsx("span", { className: "font-bold", children: "Select any one" }),
        " to apply the fix."
      ] }),
      /* @__PURE__ */ jsx(
        RadioGroup,
        {
          name: "screenshot_capture",
          className: "w-full flex flex-col",
          onChange: (ev) => onClickSuggestion(Number(ev.target.value)),
          children: jsonData?.suggestions?.map(
            (suggestion, index) => /* @__PURE__ */ jsx(
              Radio,
              {
                value: index,
                name: "suggestion",
                disabled: !isLatestRun || !suggestion.category,
                checked: index === selectedSuggestionIndex,
                className: "my-2 !items-start",
                size: "small",
                labelTextClassName: "w-11/12",
                children: /* @__PURE__ */ jsxs("div", { className: "flex items-start gap-x-2", children: [
                  /* @__PURE__ */ jsxs("div", { className: "text-secondary-400 mr-2", children: [
                    "#",
                    index + 1
                  ] }),
                  /* @__PURE__ */ jsx("div", { className: "text-secondary-700", children: suggestion.suggestion })
                ] })
              },
              index
            )
          )
        }
      )
    ] })
  ] }) });
};

// src/images/atto-white-action.svg
var atto_white_action_default = 'data:image/svg+xml,<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<path d="M12.043 9.59198C11.1608 11.3737 9.32499 12.5996 7.20215 12.5998L6.92383 12.593C4.91958 12.4913 3.20401 11.2962 2.36035 9.59296C2.5499 9.72308 2.75738 9.83221 2.98145 9.91132C3.32014 10.0308 3.66342 10.1349 4.00879 10.2248C4.81074 11.0708 5.94446 11.5997 7.20215 11.5998C8.45962 11.5996 9.59282 11.0707 10.3945 10.2248C10.7396 10.135 11.0825 10.0308 11.4209 9.91132C11.6455 9.83202 11.8531 9.72251 12.043 9.59198ZM7.47949 1.80682C9.55032 1.91181 11.3119 3.18447 12.123 4.9787C11.7223 4.70987 11.2403 4.5567 10.7275 4.56757C9.9253 3.49475 8.64469 2.80018 7.20215 2.79999C5.7591 2.80005 4.47724 3.49422 3.6748 4.56757C3.1629 4.55668 2.68164 4.70883 2.28125 4.97675C3.12895 3.10386 5.01281 1.80007 7.20215 1.79999L7.47949 1.80682Z" fill="white"/>%0A<path d="M10.8535 5.40918C11.7881 5.31158 12.6016 6.0447 12.6016 6.98438C12.6014 7.94452 11.9533 8.78337 11.0244 9.02637L10.5312 9.15527C8.3482 9.72601 6.05512 9.726 3.87207 9.15527L3.37891 9.02637C2.44992 8.78343 1.80196 7.94458 1.80176 6.98438C1.80176 6.04464 2.61516 5.31146 3.5498 5.40918L4.82617 5.54199C6.40506 5.7071 7.99728 5.70709 9.57617 5.54199L10.8535 5.40918ZM9.04492 6.60059V6.8584H8.85449V7.96191H9.04492V8.22461H9.42676V7.96191H9.61816V7.68652H9.71289V7.13477H9.61816V6.8584H9.42676V6.60059H9.04492ZM5.10352 6.85742H4.9043V7.96094H5.10352V8.22363H5.50293V7.96094H5.70312V7.68555H5.80176V7.13281H5.70312V6.85742H5.50293V6.59961H5.10352V6.85742ZM8.75684 7.13477V7.68652H8.85254V7.13477H8.75684ZM4.80176 7.68555H4.90234V7.13379H4.80176V7.68555Z" fill="white"/>%0A</svg>%0A';
var AttoLogo = ({
  className = "w-8 h-8",
  disabled = false
}) => {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames82(
        "flex items-center justify-center rounded-full",
        className,
        {
          "bg-[linear-gradient(119deg,_#E58086_19.1%,_#5C27F5_118.88%)]": !disabled,
          "bg-[linear-gradient(119deg,_#EDB6B6_19.1%,_#B7A2ED_118.88%)]": disabled
        }
      ),
      children: [
        /* @__PURE__ */ jsx(Icon, { name: "atto-white-action", className: "text-xl text-white m-0 p-0" }),
        /* @__PURE__ */ jsx(
          "img",
          {
            src: atto_white_action_default,
            className: "w-5 h-5 text-white m-0 p-0",
            alt: "Atto logo"
          }
        )
      ]
    }
  );
};
var AttoLogo_default = React5__default.memo(AttoLogo);
var { Button: ButtonV25, BUTTON_SIZE: BUTTON_SIZE3 } = V2;
var MESSAGE_TYPES = {
  SYSTEM: "SYSTEM",
  USER: "USER",
  SYSTEM_BUTTON: "SYSTEM_BUTTON",
  ANALYZER_MAIN: "ANALYZER_MAIN",
  ANALYZER_ACTIONS: "ANALYZER_ACTIONS",
  LOADING: "LOADING",
  HEALER_AGENT_RESPONSE: "HEALER_AGENT_RESPONSE"
};
var Chat = ({
  messages = [],
  onClickMessage = NOOP,
  selectedSuggestionIndex = null,
  onSelectSuggestion = NOOP
}) => {
  const bottomRef = useRef(null);
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);
  const renderSystemMessage = ({ content }) => {
    return /* @__PURE__ */ jsx("div", { className: "text-sm text-button-secondary-text-default", children: content });
  };
  const renderUserMessage = ({ content }) => {
    return /* @__PURE__ */ jsxs("div", { className: "flex flex-col items-end justify-end", children: [
      /* @__PURE__ */ jsx("div", { className: "text-xs font-semibold text-secondary-text mb-1", children: "You" }),
      /* @__PURE__ */ jsx(
        "div",
        {
          className: classNames82(
            "block !max-w-[80%] rounded-md bg-secondary-50",
            " border-[0.5px] border-secondary-50 text-[#1E293B] text-small leading-5",
            " py-1.5 px-3 ml-auto text-left break-words cursor-text whitespace-pre-wrap"
          ),
          children: content
        }
      )
    ] });
  };
  const renderSystemButton = (message) => {
    const { content } = message;
    return /* @__PURE__ */ jsx(
      ButtonV25,
      {
        size: BUTTON_SIZE3.SMALLEST,
        onClick: () => onClickMessage(message),
        children: content
      }
    );
  };
  const renderLoadingMessage = ({ content }) => {
    return /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-x-2 mt-100", children: [
      /* @__PURE__ */ jsx(AttoLogo_default, { className: "w-6 h-6" }),
      /* @__PURE__ */ jsx("div", { className: "text-sm text-secondary-600", children: content })
    ] });
  };
  const renderContent = (message) => {
    const {
      content,
      type,
      analyzerOutput,
      elementSourceScreenshot,
      currentExecutionScreenshot,
      isLatestRun,
      latestTestCaseResultId
    } = message;
    switch (type) {
      case MESSAGE_TYPES.SYSTEM:
        return renderSystemMessage({ content });
      case MESSAGE_TYPES.USER:
        return renderUserMessage({ content });
      case MESSAGE_TYPES.SYSTEM_BUTTON:
        return renderSystemButton(message);
      case MESSAGE_TYPES.LOADING:
        return renderLoadingMessage({ content });
      case MESSAGE_TYPES.ANALYZER_MAIN:
        return /* @__PURE__ */ jsx(
          ConvertAnalyzerDataToUI,
          {
            jsonData: analyzerOutput,
            currentExecutionScreenshot,
            elementSourceScreenshot,
            onClickSuggestion: (index) => onSelectSuggestion(index),
            selectedSuggestionIndex,
            isLatestRun
          }
        );
      case MESSAGE_TYPES.ANALYZER_ACTIONS:
        return APPLY_FIX_AND_REPORT_BUG_RENDERER(
          selectedSuggestionIndex,
          isLatestRun,
          latestTestCaseResultId
        )(onClickMessage);
      case MESSAGE_TYPES.HEALER_AGENT_RESPONSE:
        const HealerComponent = content;
        return /* @__PURE__ */ jsx(HealerComponent, {});
      default:
        return content(onClickMessage);
    }
  };
  return /* @__PURE__ */ jsxs("div", { children: [
    messages.map((message, index) => /* @__PURE__ */ jsx("div", { className: "mb-3", children: renderContent(message) }, index)),
    /* @__PURE__ */ jsx("div", { ref: bottomRef })
  ] });
};
var chat_default = Chat;
var { Button: ButtonV26, BUTTON_SIZE: BUTTON_SIZE4 } = V2;
var ChatMessageInput = ({
  onSubmit,
  isLoading
}) => {
  const { t } = useTranslation();
  const [value, setValue] = useState("");
  const _onSubmit = (value2) => {
    onSubmit(value2);
    setValue("");
  };
  const renderButtons = () => {
    return /* @__PURE__ */ jsx("div", { className: "flex justify-end w-full", children: /* @__PURE__ */ jsx(
      ButtonV26,
      {
        size: BUTTON_SIZE4.SMALLEST,
        onClick: () => {
          _onSubmit(value);
        },
        disabled: isLoading || !value.trim(),
        iconLeft: "arrow-upwardthick",
        iconStyles: "text-sm",
        className: "!h-6 px-2 shadow-ai-button",
        "aria-label": t("common.send_message"),
        children: __("common.analyze")
      }
    ) });
  };
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames82("flex-shrink-0 max-h-[250px] min-h-[100px] p-4"),
      children: /* @__PURE__ */ jsx(
        "div",
        {
          className: classNames82(`relative rounded-lg bg-white`, {
            "atoms-prompt-glow": isLoading
          }),
          children: /* @__PURE__ */ jsxs(
            "div",
            {
              className: classNames82(
                `border bg-white rounded-lg flex flex-col w-full h-full p-2`
              ),
              children: [
                /* @__PURE__ */ jsx("div", { className: classNames82("flex flex-col gap-3 flex-grow"), children: /* @__PURE__ */ jsx(
                  "textarea",
                  {
                    className: classNames82(
                      "resize-none border-none flex-grow h-14 px-1 outline-none text-xs placeholder-placeholder pt-2",
                      { "cursor-not-allowed !bg-white": isLoading }
                    ),
                    placeholder: isLoading ? __("common.thinking") : __("common.debug_with_analyzer"),
                    onChange: (e) => setValue(e.target.value),
                    value,
                    disabled: isLoading,
                    "aria-label": isLoading ? __("common.thinking") : __("common.debug_with_analyzer"),
                    onKeyDown: (e) => {
                      if (e.key === "Enter" && !e.shiftKey) {
                        e.preventDefault();
                        if (!isLoading) _onSubmit(value);
                      }
                    }
                  }
                ) }),
                /* @__PURE__ */ jsx("div", { className: "flex pt-2", children: renderButtons() })
              ]
            }
          )
        }
      )
    }
  );
};
var nameSpace14 = PrivateURLConstants.NLP_TEMPLATE;
var kibbutzNamespace = PrivateURLConstants.KIBBUTZ;
var getAll17 = async (applicationType) => {
  return instance_default.get(
    nameSpace14 + `?query=deprecated:false,applicationType:${applicationType}`
  );
};
var getAllFromAddon = async (applicationType) => {
  return instance_default.get(
    `${kibbutzNamespace}/nlps?query=applicationType:${applicationType}`
  );
};
var findAll6 = (query) => instance_default.get(nameSpace14, { query });
var TemplateApi = {
  getAll: getAll17,
  getAllFromAddon,
  findAll: findAll6
};
var getStepById = async (stepId) => {
  return await StepApi.show(Number(stepId));
};
var extractStepId = (suggestion) => {
  return suggestion.output?.step_id || suggestion.output?.stepId;
};
var extractTestCaseResultId = (suggestion) => {
  return Number(
    suggestion.output?.testCaseResultId || suggestion.output?.test_case_result_id
  );
};
var withLoadingState = async (setLoading, operation) => {
  setLoading(true);
  try {
    return await operation();
  } catch (error) {
    console.error("Error:", error);
    return void 0;
  } finally {
    setLoading(false);
  }
};
var populateUpdatedStepAction = (testStep, template) => {
  const blocks = getStepNlpBlocks(testStep, template);
  const newAction = blocks.map(({ value = "" }) => typeof value === "string" ? value.trim() : "").join(" ").replaceAll(/\s+/g, " ");
  testStep.action = newAction;
  return testStep;
};
var refreshStepAction = async (step) => {
  const isAddonTemplate = step.kibbutzPluginNlpId !== null;
  if (!isAddonTemplate) {
    const nlpTemplate = await TemplateApi.findAll(`id:${step.templateId}`);
    populateUpdatedStepAction(
      step,
      nlpTemplate.content[0]
    );
  }
};
var updateStep2 = async (step) => {
  await StepApi.updateById(step, step.id);
};
var updateStepProperty = async (stepId, propertyUpdater) => {
  const step = await getStepById(stepId);
  propertyUpdater(step);
  await updateStep2(step);
  return step;
};
var updateStepWithActionRefresh = async (stepId, stepModifier) => {
  try {
    const step = await getStepById(stepId);
    await stepModifier(step);
    await refreshStepAction(step);
    await updateStep2(step);
    return step;
  } catch (error) {
    console.error("Error updating step:", error);
    toastify("Something went wrong", { type: "error" });
  }
};
var createNewElement2 = async (currentElement, aiElement) => {
  const newElement = new ElementIdentifier();
  newElement.name = aiElement["name"];
  newElement.definition = aiElement["definition"];
  newElement.locatorType = ElementIdentifierLocatorType.xpath;
  newElement.applicationVersionId = currentElement?.applicationVersionId;
  newElement.screenNameId = currentElement?.screenNameId;
  newElement.createdType = ElementIdentifierCreateType.ANALYZER;
  newElement.status = ElementIdentifierStatus.READY;
  return await UiIdentifierApi.create(
    newElement
  );
};
var handleUpdateStepTimeout = async (suggestion, setLoading) => {
  const stepId = extractStepId(suggestion);
  const newTimeout = suggestion.output?.new_timeout;
  if (!stepId) {
    console.error("Step ID not found in suggestion");
    return void 0;
  }
  return await withLoadingState(setLoading, async () => {
    const step = await updateStepProperty(stepId, (step2) => {
      step2.waitTime = newTimeout;
    });
    return step;
  });
};
var handleIgnoreStepResult = async (suggestion, setLoading) => {
  const stepId = extractStepId(suggestion);
  if (!stepId) {
    console.error("Step ID not found in suggestion");
    return void 0;
  }
  return await withLoadingState(setLoading, async () => {
    return await updateStepProperty(stepId, (step) => {
      step.ignoreStepResult = true;
      step.priority = TestStepPriority.MINOR;
    });
  });
};
var handleDisableStep = async (suggestion, setLoading) => {
  const stepId = extractStepId(suggestion);
  if (!stepId) {
    console.error("Step ID not found in suggestion");
    return void 0;
  }
  return await withLoadingState(setLoading, async () => {
    return await updateStepProperty(stepId, (step) => {
      step.disabled = true;
    });
  });
};
var handleUpdateStepTestData = async (suggestion, setLoading) => {
  const stepId = extractStepId(suggestion);
  const newStepDataList = suggestion.output?.stepDataList;
  if (!stepId) {
    console.error("Step ID not found in suggestion");
    return void 0;
  }
  if (!newStepDataList || !Array.isArray(newStepDataList)) {
    console.error("Step data list not found or not an array in suggestion");
    return void 0;
  }
  return await withLoadingState(setLoading, async () => {
    return await updateStepWithActionRefresh(stepId, async (step) => {
      const updatedValuesMap = new Map(
        newStepDataList.map((item) => [item.key, item])
      );
      step.stepDataList = step.stepDataList.map((stepData) => {
        const updatedItem = updatedValuesMap.get(stepData.key);
        if (updatedItem) {
          stepData.value = updatedItem.value;
          if (updatedItem.type !== void 0) {
            stepData.type = updatedItem.type;
          }
        }
        return stepData;
      });
    });
  });
};
var handleUpdateStepElement = async (suggestion, setLoading) => {
  const stepId = extractStepId(suggestion);
  const newElement = suggestion.output?.new_element || suggestion.output?.newElement;
  if (!stepId) {
    console.error("Step ID not found in suggestion");
    return void 0;
  }
  if (!newElement) {
    console.error("New element not found in suggestion");
    return void 0;
  }
  return await withLoadingState(setLoading, async () => {
    return await updateStepWithActionRefresh(stepId, async (step) => {
      const stepElement = step.testStepElements?.[0];
      if (!stepElement?.elementId) {
        throw new Error("Step element or elementId not found");
      }
      const currentElement = await UiIdentifierApi.get(
        stepElement.elementId
      );
      const createdElement = await createNewElement2(currentElement, newElement);
      step.testStepElements[0].elementId = createdElement?.id;
      step.testStepElements[0].name = createdElement?.name;
    });
  });
};
var handleAddStepNlp = async (suggestion, setLoading) => {
  const steps = suggestion.output?.steps;
  const testCaseResultId = extractTestCaseResultId(suggestion);
  const testCaseId = suggestion.output?.testcase_id;
  if (!steps || !Array.isArray(steps)) {
    console.error("Steps array not found in suggestion");
    return;
  }
  await withLoadingState(setLoading, async () => {
    steps.forEach((step) => {
      if (step.elementRequest) {
        step.elementRequest.createdType = ElementIdentifierCreateType.CHROME;
      }
      step.isStepRecorder = true;
    });
    const request = {
      testCaseId: testCaseId ? Number(testCaseId) : void 0,
      feature: "ANALYZER_TEST_STEP",
      testSteps: steps,
      testCaseResultId
    };
    try {
      const response = await AlphaApi.persist(request);
      return response;
    } catch (error) {
      console.error("Error persisting steps:", error);
      throw error;
    }
  });
};
var getSubCategoryHandler = (subCategory) => {
  switch (subCategory) {
    case "UPDATE_STEP_TIMEOUT":
      return handleUpdateStepTimeout;
    case "IGNORE_STEP_RESULT":
      return handleIgnoreStepResult;
    case "DISABLE_STEP":
      return handleDisableStep;
    case "UPDATE_STEP_ELEMENT":
      return handleUpdateStepElement;
    case "UPDATE_STEP_TESTDATA":
      return handleUpdateStepTestData;
    case "ADD_STEP_NLP":
      return handleAddStepNlp;
    default:
      return async () => {
        console.log("Unknown sub-category:", subCategory);
        return void 0;
      };
  }
};
var getSubCategoryDisplayName = (subCategory, isCompleted = false) => {
  const subCategoryConfig = [
    {
      key: "UPDATE_STEP_TIMEOUT",
      display: "Update Step Settings",
      completed: "Updated Step Settings"
    },
    {
      key: "IGNORE_STEP_RESULT",
      display: "Update Step Settings",
      completed: "Updated Step Settings"
    },
    {
      key: "DISABLE_STEP",
      display: "Update Step Settings",
      completed: "Updated Step Settings"
    },
    {
      key: "UPDATE_STEP_ELEMENT",
      display: "Update Test Step",
      completed: "Updated Test Step"
    },
    {
      key: "UPDATE_STEP_TESTDATA",
      display: "Update Test Step",
      completed: "Updated Test Step"
    },
    {
      key: "ADD_STEP_NLP",
      display: "Add Test Step",
      completed: "Test Step Added"
    }
  ];
  const config = subCategoryConfig.find((item) => item.key === subCategory);
  return config ? isCompleted ? config.completed : config.display : subCategory;
};

// src/components/test-authoring/formatted-step/anlayzer/utils/step-display-utils.ts
var getStepNumberFromResults = (stepId, allStepResults) => {
  const stepResult = allStepResults.find(
    (result) => result.metadata?.testStep?.id === stepId || result.stepDetails?.id === stepId
  );
  return stepResult?.stepNumber || null;
};
var extractStepId2 = (output) => {
  return output?.step_id || output?.stepId;
};
var findTemplate = (step, nlActions) => {
  if (step.templateId) {
    return nlActions.find((t) => t.id === step.templateId) || null;
  }
  if (step.kibbutzPluginNlpId) {
    return nlActions.find((t) => t.id === step.kibbutzPluginNlpId) || null;
  }
  return null;
};
var AddStepDisplay = ({
  suggestion,
  nlActions
}) => {
  const output = suggestion.output;
  const steps = output?.steps || [];
  if (steps.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsx("div", { className: "space-y-2", children: steps.map((step, index) => /* @__PURE__ */ jsxs(
    "div",
    {
      className: "bg-primary-50 rounded-lg border border-primary-200 px-3 py-2 flex items-center gap-2 h-10",
      children: [
        step.stepNumber && /* @__PURE__ */ jsx(StepNumber, { number: step.stepNumber }),
        /* @__PURE__ */ jsx("div", { className: "flex-1 overflow-hidden", children: /* @__PURE__ */ jsx(
          StepItemWrapper,
          {
            step,
            isViewOnly: true,
            template: findTemplate(step, nlActions),
            isAiGenStep: true,
            isStepResult: true
          }
        ) })
      ]
    },
    step.id || index
  )) });
};
var useStepDisplay = ({
  suggestion,
  nlActions = [],
  allStepResults = []
}) => {
  const output = suggestion.output;
  const stepId = extractStepId2(output);
  const { data: step, isLoading } = useQuery$1(
    ["test-step", stepId],
    () => StepApi.show(Number(stepId)),
    {
      enabled: !!stepId
    }
  );
  const stepNumber = (stepId ? getStepNumberFromResults(Number(stepId), allStepResults) : null) || step?.stepNumber || null;
  const template = step ? findTemplate(step, nlActions) : null;
  return {
    stepId,
    step,
    isLoading,
    stepNumber,
    template,
    output
  };
};
var StepDisplayItem = ({
  step,
  stepNumber,
  template,
  alignItems = "start",
  containerClassName
}) => {
  const flexClassName = classNames82("flex gap-2", {
    "items-center h-6": alignItems === "center",
    "items-start": alignItems === "start"
  });
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames82(
        "w-full h-full overflow-auto flex",
        flexClassName,
        containerClassName
      ),
      children: [
        stepNumber && /* @__PURE__ */ jsx(
          StepNumber,
          {
            number: stepNumber,
            className: classNames82({
              "grayscale opacity-50": step.disabled
            })
          }
        ),
        /* @__PURE__ */ jsx("div", { className: "flex-1", children: /* @__PURE__ */ jsx(
          StepItemWrapper,
          {
            step,
            template,
            isViewOnly: true,
            isResultBlock: true,
            isStepResult: true
          }
        ) })
      ]
    }
  );
};
var DisableStepDisplay = ({
  suggestion,
  nlActions = [],
  allStepResults = []
}) => {
  const { stepId, step, isLoading, stepNumber, template } = useStepDisplay({
    suggestion,
    nlActions,
    allStepResults
  });
  if (!stepId) {
    return /* @__PURE__ */ jsx("div", { className: "mt-3 p-3 bg-white rounded border border-secondary-200", children: /* @__PURE__ */ jsx("pre", { className: "text-xs text-secondary-700 font-mono overflow-x-auto", children: JSON.stringify(suggestion.output, null, 2) }) });
  }
  if (isLoading) {
    return /* @__PURE__ */ jsx("div", { className: "mt-3 p-3 bg-white rounded border border-secondary-200", children: /* @__PURE__ */ jsx("div", { className: "text-xs text-secondary-500", children: __("step.details.loading") }) });
  }
  if (!step) {
    return /* @__PURE__ */ jsx("div", { className: "mt-3 p-3 bg-white rounded border border-secondary-200", children: /* @__PURE__ */ jsx("div", { className: "text-xs text-secondary-500", children: __("step.not_found", { stepId }) }) });
  }
  return /* @__PURE__ */ jsx("div", { className: "mt-3 space-y-3", children: step && /* @__PURE__ */ jsxs("div", { className: "text-xs text-secondary-500 mt-2", children: [
    /* @__PURE__ */ jsxs("div", { className: "font-medium text-secondary-500", children: [
      __("common.step"),
      ":"
    ] }),
    /* @__PURE__ */ jsx("div", { className: "bg-secondary-50 rounded-lg border border-secondary-200 p-3", children: /* @__PURE__ */ jsx(
      StepDisplayItem,
      {
        step,
        stepNumber,
        template,
        alignItems: "center"
      }
    ) }),
    /* @__PURE__ */ jsx(
      Checkbox,
      {
        label: __("step.settings.disabled"),
        checked: true,
        isReadOnly: true,
        className: "mt-4",
        inputClassName: "!h-4 !w-4"
      }
    )
  ] }) });
};
var IgnoreStepResultDisplay = ({ suggestion, nlActions = [], allStepResults = [] }) => {
  const { stepId, step, isLoading, stepNumber, template } = useStepDisplay({
    suggestion,
    nlActions,
    allStepResults
  });
  if (!stepId) {
    return /* @__PURE__ */ jsx("div", { className: "mt-3 p-3 bg-white rounded border border-secondary-200", children: /* @__PURE__ */ jsx("pre", { className: "text-xs text-secondary-700 font-mono overflow-x-auto", children: JSON.stringify(suggestion.output, null, 2) }) });
  }
  if (isLoading) {
    return /* @__PURE__ */ jsx("div", { className: "mt-3 p-3 bg-white rounded border border-secondary-200", children: /* @__PURE__ */ jsx("div", { className: "text-xs text-secondary-500", children: __("step.details.loading") }) });
  }
  if (!step) {
    return /* @__PURE__ */ jsx("div", { className: "mt-3 p-3 bg-white rounded border border-secondary-200", children: /* @__PURE__ */ jsx("div", { className: "text-xs text-secondary-500", children: __("step.not_found", { stepId }) }) });
  }
  const ignoredStep = new TestStep().deserialize(step);
  ignoredStep.ignoreStepResult = true;
  ignoredStep.priority = TestStepPriority.MINOR;
  return /* @__PURE__ */ jsx("div", { className: "mt-3 space-y-3", children: step && /* @__PURE__ */ jsxs("div", { className: "text-xs text-secondary-500 mt-2", children: [
    /* @__PURE__ */ jsxs("div", { className: "font-medium text-secondary-500", children: [
      __("common.step"),
      ":"
    ] }),
    /* @__PURE__ */ jsx("div", { className: "bg-secondary-50 rounded-lg border border-secondary-200 p-3", children: /* @__PURE__ */ jsx(
      StepDisplayItem,
      {
        step,
        stepNumber,
        template,
        alignItems: "center"
      }
    ) }),
    /* @__PURE__ */ jsx(
      Checkbox,
      {
        label: __("test_step_details.ignore_this_step"),
        checked: true,
        isReadOnly: true,
        className: "mt-4",
        inputClassName: "!h-4 !w-4"
      }
    )
  ] }) });
};
var TestDataDisplay = ({
  suggestion,
  nlActions = [],
  allStepResults = []
}) => {
  const { stepId, step, isLoading, stepNumber, template, output } = useStepDisplay({
    suggestion,
    nlActions,
    allStepResults
  });
  if (!stepId) {
    return /* @__PURE__ */ jsx("div", { className: "mt-3 p-3 bg-white rounded border border-secondary-200", children: /* @__PURE__ */ jsx("pre", { className: "text-xs text-secondary-700 font-mono overflow-x-auto", children: JSON.stringify(suggestion.output, null, 2) }) });
  }
  if (isLoading) {
    return /* @__PURE__ */ jsx("div", { className: "mt-3 p-3 bg-white rounded border border-secondary-200", children: /* @__PURE__ */ jsx("div", { className: "text-xs text-secondary-500", children: __("step.details.loading") }) });
  }
  if (!step) {
    return /* @__PURE__ */ jsx("div", { className: "mt-3 p-3 bg-white rounded border border-secondary-200", children: /* @__PURE__ */ jsx("div", { className: "text-xs text-secondary-500", children: __("step.not_found", { stepId }) }) });
  }
  const updatedTestDataList = output?.stepDataList;
  let modifiedStep = null;
  if (updatedTestDataList?.length && step.stepDataList) {
    const clonedStep = new TestStep().deserialize(step);
    const updatedValuesMap = new Map(
      updatedTestDataList.map((item) => [item.key, item.value])
    );
    const modifiedStepDataList = step.stepDataList.map((dataItem) => {
      if (updatedValuesMap.has(dataItem.key)) {
        return {
          ...dataItem,
          value: updatedValuesMap.get(dataItem.key)
        };
      }
      return dataItem;
    });
    clonedStep.stepDataList = modifiedStepDataList;
    modifiedStep = clonedStep;
  }
  return /* @__PURE__ */ jsxs("div", { className: "space-y-3", children: [
    /* @__PURE__ */ jsx("div", { className: "bg-secondary-50 rounded-lg border border-secondary-200 p-3", children: /* @__PURE__ */ jsx(
      StepDisplayItem,
      {
        step,
        stepNumber,
        template,
        alignItems: "start"
      }
    ) }),
    modifiedStep && /* @__PURE__ */ jsx("div", { className: "bg-primary-50 rounded-lg border border-primary-200 p-3", children: /* @__PURE__ */ jsx(
      StepDisplayItem,
      {
        step: modifiedStep,
        stepNumber,
        template,
        alignItems: "start"
      }
    ) })
  ] });
};
var TimeoutDisplay = ({
  suggestion,
  allStepResults = [],
  nlActions = []
}) => {
  const { stepId, step, isLoading, stepNumber, template, output } = useStepDisplay({
    suggestion,
    nlActions,
    allStepResults
  });
  const newTimeout = output?.new_timeout;
  const afterTimeout = newTimeout ?? "N/A";
  if (!stepId) {
    return /* @__PURE__ */ jsx("div", { className: "mt-3 p-3 bg-white rounded border border-secondary-200", children: /* @__PURE__ */ jsx("pre", { className: "text-xs text-secondary-700 font-mono overflow-x-auto", children: JSON.stringify(suggestion.output, null, 2) }) });
  }
  if (isLoading) {
    return /* @__PURE__ */ jsx("div", { className: "mt-3 p-3 bg-white rounded border border-secondary-200", children: /* @__PURE__ */ jsx("div", { className: "text-xs text-secondary-500", children: __("step.details.loading") }) });
  }
  return /* @__PURE__ */ jsx("div", { className: "mt-3 space-y-3", children: step && /* @__PURE__ */ jsxs("div", { className: "text-xs text-secondary-500 mt-2", children: [
    /* @__PURE__ */ jsxs("div", { className: "font-medium text-secondary-500", children: [
      __("common.step"),
      ":"
    ] }),
    /* @__PURE__ */ jsx("div", { className: "bg-secondary-50 rounded-lg border border-secondary-200 p-3", children: /* @__PURE__ */ jsx(
      StepDisplayItem,
      {
        step,
        stepNumber,
        template,
        alignItems: "center"
      }
    ) }),
    /* @__PURE__ */ jsx(
      Input,
      {
        label: __("step_result.max.waitTime"),
        value: afterTimeout?.toString(),
        isDisabled: true,
        wrapperClassName: "w-full mt-4",
        isRequired: true
      }
    )
  ] }) });
};
var UpdateStepElementDisplay = ({ suggestion, nlActions = [], allStepResults = [] }) => {
  const { stepId, step, isLoading, stepNumber, template, output } = useStepDisplay({
    suggestion,
    nlActions,
    allStepResults
  });
  const newElement = output?.new_element || output?.newElement;
  if (!stepId) {
    return /* @__PURE__ */ jsx("div", { className: "mt-3 p-3 bg-white rounded border border-secondary-200", children: /* @__PURE__ */ jsx("pre", { className: "text-xs text-secondary-700 font-mono overflow-x-auto", children: JSON.stringify(suggestion.output, null, 2) }) });
  }
  if (isLoading) {
    return /* @__PURE__ */ jsx("div", { className: "mt-3 p-3 bg-white rounded border border-secondary-200", children: /* @__PURE__ */ jsx("div", { className: "text-xs text-secondary-500", children: __("step.details.loading") }) });
  }
  if (!step) {
    return /* @__PURE__ */ jsx("div", { className: "mt-3 p-3 bg-white rounded border border-secondary-200", children: /* @__PURE__ */ jsx("div", { className: "text-xs text-secondary-500", children: __("step.not_found", { stepId }) }) });
  }
  if (!newElement) {
    return /* @__PURE__ */ jsx("div", { className: "mt-3 p-3 bg-white rounded border border-secondary-200", children: /* @__PURE__ */ jsx("pre", { className: "text-xs text-secondary-700 font-mono overflow-x-auto", children: JSON.stringify(suggestion.output, null, 2) }) });
  }
  let modifiedStep = null;
  const elementName2 = newElement.name || __("element.name.unnamed");
  if (step.testStepElements && step.testStepElements.length > 0) {
    const clonedStep = new TestStep().deserialize(step);
    const updatedElements = step.testStepElements.map(
      (element, index) => {
        if (index === 0 && element.elementType === TestStepElementType.UI_ELEMENT) {
          return {
            ...element,
            name: elementName2
            // Note: elementId would be set when the element is actually created
          };
        }
        return element;
      }
    );
    clonedStep.testStepElements = updatedElements;
    modifiedStep = clonedStep;
  }
  return /* @__PURE__ */ jsxs("div", { className: "space-y-3", children: [
    /* @__PURE__ */ jsx("div", { className: "bg-secondary-50 rounded-lg border border-secondary-200 p-3", children: /* @__PURE__ */ jsx(
      StepDisplayItem,
      {
        step,
        stepNumber,
        template,
        alignItems: "start"
      }
    ) }),
    modifiedStep && /* @__PURE__ */ jsx("div", { className: "bg-primary-50 rounded-lg border border-primary-200 p-3", children: /* @__PURE__ */ jsx(
      StepDisplayItem,
      {
        step: modifiedStep,
        stepNumber,
        template,
        alignItems: "start"
      }
    ) })
  ] });
};
var HealerResponseRenderer = ({
  suggestion,
  nlActions,
  allStepResults = []
}) => {
  if (suggestion.sub_category === "UPDATE_STEP_ELEMENT") {
    return /* @__PURE__ */ jsx(
      UpdateStepElementDisplay,
      {
        suggestion,
        nlActions,
        allStepResults
      }
    );
  }
  if (suggestion.sub_category === "UPDATE_STEP_TESTDATA") {
    return /* @__PURE__ */ jsx(
      TestDataDisplay,
      {
        suggestion,
        nlActions,
        allStepResults
      }
    );
  }
  if (suggestion.sub_category === "DISABLE_STEP") {
    return /* @__PURE__ */ jsx(
      DisableStepDisplay,
      {
        suggestion,
        nlActions,
        allStepResults
      }
    );
  }
  if (suggestion.sub_category === "UPDATE_STEP_TIMEOUT") {
    return /* @__PURE__ */ jsx(
      TimeoutDisplay,
      {
        suggestion,
        allStepResults,
        nlActions
      }
    );
  }
  if (suggestion.sub_category === "IGNORE_STEP_RESULT") {
    return /* @__PURE__ */ jsx(
      IgnoreStepResultDisplay,
      {
        suggestion,
        nlActions,
        allStepResults
      }
    );
  }
  if (suggestion.sub_category === "ADD_STEP_NLP") {
    return /* @__PURE__ */ jsx(AddStepDisplay, { suggestion, nlActions });
  }
  return /* @__PURE__ */ jsx("div", { className: "mt-3 p-3 bg-white rounded border border-secondary-200", children: /* @__PURE__ */ jsx("pre", { className: "text-xs text-secondary-700 font-mono overflow-x-auto", children: JSON.stringify(suggestion.output, null, 2) }) });
};
var getButtonText = (subCategory) => {
  const buttonTextMap = {
    ADD_STEP_NLP: "Add Step",
    UPDATE_STEP_ELEMENT: "Update Step",
    UPDATE_STEP_TESTDATA: "Update Step",
    UPDATE_STEP_TIMEOUT: "Update Step Settings",
    DISABLE_STEP: "Update Step Settings",
    IGNORE_STEP_RESULT: "Update Step Settings"
  };
  return buttonTextMap[subCategory] || "Apply";
};
var SuggestionItem = ({
  suggestion,
  onApply,
  nlActions,
  allStepResults = [],
  isFixed
}) => {
  const buttonText = getButtonText(suggestion.sub_category);
  const [loading, setLoading] = useState(false);
  const [showApplyButton, setShowApplyButton] = useState(!isFixed);
  const setIsFixed = (isFixed2) => {
    setShowApplyButton(!isFixed2);
  };
  return /* @__PURE__ */ jsxs("div", { className: "bg-white rounded-lg border border-secondary-200 p-4", children: [
    /* @__PURE__ */ jsxs("h3", { className: "text-base font-semibold text-secondary-800 mb-3", children: [
      !showApplyButton && /* @__PURE__ */ jsx(
        Icon,
        {
          name: "check-fill",
          className: "text-primary-500 text-2xs mr-1.5"
        }
      ),
      getSubCategoryDisplayName(suggestion.sub_category, !showApplyButton)
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "mb-4", children: [
      suggestion?.description && /* @__PURE__ */ jsx("div", { className: "text-sm text-secondary-700 mb-2", children: suggestion?.description }),
      /* @__PURE__ */ jsx(
        HealerResponseRenderer,
        {
          suggestion,
          nlActions,
          allStepResults
        }
      )
    ] }),
    /* @__PURE__ */ jsx("div", { className: "flex justify-end", children: showApplyButton && /* @__PURE__ */ jsx(
      Button,
      {
        type: "primary",
        size: "sm",
        onClick: () => onApply(suggestion, setLoading, setIsFixed),
        isLoading: loading,
        disabled: loading,
        children: buttonText
      }
    ) })
  ] });
};
var CategorySection = ({
  response,
  onApply,
  nlActions,
  allStepResults = [],
  isFixed,
  messageKey
}) => {
  return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
    SuggestionItem,
    {
      suggestion: {
        sub_category: response.sub_category,
        description: response.output?.description || "",
        output: response.output,
        messageKey
      },
      onApply,
      nlActions,
      allStepResults,
      isFixed
    }
  ) });
};

// src/components/test-authoring/formatted-step/anlayzer/utils/index.tsx
var convertMessagesToPayloadFormat = (messages) => {
  const allowedMessageTypes = [
    MESSAGE_TYPES.USER,
    MESSAGE_TYPES.SYSTEM,
    MESSAGE_TYPES.HEALER_AGENT_RESPONSE
  ];
  const data = [];
  const filteredMessages = messages.filter(
    (message) => allowedMessageTypes.includes(message.type)
  );
  for (let i = 0; i < filteredMessages.length - 1; i += 2) {
    if (filteredMessages[i + 1].type !== MESSAGE_TYPES.HEALER_AGENT_RESPONSE) {
      data.push({
        user_reply: filteredMessages[i].content,
        llm_reply: filteredMessages[i + 1].content
      });
    }
  }
  return data;
};
var { Button: Button9, BUTTON_SIZE: BUTTON_SIZE5, BUTTON_VARIANTS: BUTTON_VARIANTS5 } = V2;
var NegativeFeedback = ({
  onClose,
  onSubmit
}) => {
  const [textMessage, setTextMessage] = useState("");
  const handleTextMessageChange = (value) => {
    setTextMessage(value);
  };
  const handleSubmit = () => {
    onSubmit(textMessage);
    onClose();
  };
  return /* @__PURE__ */ jsx(Modal, { isOpen: true, onClose, children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col  justify-center gap-4", children: [
    /* @__PURE__ */ jsx("h1", { className: "text-lg font-medium", children: __("ai_journey.manual.negative_feedback_title") }),
    /* @__PURE__ */ jsx(
      TextArea,
      {
        id: "feedback",
        wrapperClassName: "w-full",
        inputClassName: "!py-2 !resize-none !placeholder-secondary-300",
        rows: 7,
        label: "Feedback",
        value: textMessage,
        onChange: handleTextMessageChange,
        placeholder: "Enter your feedback here",
        isRequired: true
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: "flex flex-row items-center justify-end gap-4", children: [
      /* @__PURE__ */ jsx(
        Button9,
        {
          variant: BUTTON_VARIANTS5.SECONDARY,
          size: BUTTON_SIZE5.SMALL,
          onClick: onClose,
          "aria-label": __("common.cancel"),
          children: __("common.cancel")
        }
      ),
      /* @__PURE__ */ jsx(
        Button9,
        {
          variant: BUTTON_VARIANTS5.PRIMARY,
          size: BUTTON_SIZE5.SMALL,
          onClick: handleSubmit,
          disabled: !textMessage.trim().length,
          "aria-label": __("common.submit"),
          children: __("common.submit")
        }
      )
    ] })
  ] }) });
};
var negative_feedback_modal_default = NegativeFeedback;
var AIFeedback = ({
  handlePositiveFeedback,
  handleNegativeFeedback,
  handleTryAgain = NOOP
}) => {
  const [isPositiveFeedbackProvided, setIsPositiveFeedbackProvided] = useState(false);
  const [isNegativeFeedbackProvided, setIsNegativeFeedbackProvided] = useState(false);
  const disableFeedback = isPositiveFeedbackProvided || isNegativeFeedbackProvided;
  const negativeFeedbackModal = useModal();
  const feedbackModal = useModal();
  const { t } = useTranslation();
  const handlePositiveFeedbackClick = () => {
    if (disableFeedback) return;
    setIsPositiveFeedbackProvided(true);
    handlePositiveFeedback();
  };
  const handleNegativeFeedbackClick = (textMessage) => {
    if (disableFeedback) return;
    setIsNegativeFeedbackProvided(true);
    handleNegativeFeedback(textMessage);
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("div", { className: "flex flex-row items-center justify-start w-80% gap-2 ml-6 text-secondary-500", children: [
      /* @__PURE__ */ jsx(
        "div",
        {
          role: "button",
          className: classNames82(
            "flex flex-row items-center text-md justify-center cursor-pointer ",
            {
              "opacity-50  !cursor-not-allowed": disableFeedback,
              "hover:text-secondary-400": !disableFeedback
            }
          ),
          onClick: handlePositiveFeedbackClick,
          children: /* @__PURE__ */ jsx(
            Icon,
            {
              name: isPositiveFeedbackProvided ? "thumbs-up-filled" : "thumbs-up"
            }
          )
        }
      ),
      /* @__PURE__ */ jsx(
        "div",
        {
          role: "button",
          className: classNames82(
            "flex flex-row text-md items-center",
            "justify-center cursor-pointer text-secondary-500",
            {
              "opacity-50  !cursor-not-allowed": disableFeedback,
              "hover:text-secondary-400": !disableFeedback
            }
          ),
          onClick: () => {
            if (!disableFeedback) {
              negativeFeedbackModal.openModal();
            }
          },
          children: /* @__PURE__ */ jsx(
            Icon,
            {
              name: isNegativeFeedbackProvided ? "thumbs-down-filled" : "thumbs-down"
            }
          )
        }
      ),
      /* @__PURE__ */ jsxs(
        "div",
        {
          role: "button",
          className: "flex flex-row items-center justify-center text-md text-secondary-500 cursor-pointer gap-1 hover:text-secondary-400",
          onClick: () => feedbackModal.openModal(),
          children: [
            /* @__PURE__ */ jsx(Icon, { name: "chart" }),
            /* @__PURE__ */ jsx("span", { className: "text-3xs font-normal leading-3.5", children: t("ai_journey.manual.give_feedback") })
          ]
        }
      )
    ] }),
    negativeFeedbackModal.state.show && /* @__PURE__ */ jsx(
      negative_feedback_modal_default,
      {
        onClose: negativeFeedbackModal.closeModal,
        onSubmit: handleNegativeFeedbackClick
      }
    ),
    feedbackModal.state.show && /* @__PURE__ */ jsx(
      negative_feedback_modal_default,
      {
        onClose: feedbackModal.closeModal,
        onSubmit: (textMessage) => {
          handleNegativeFeedbackClick(textMessage);
          feedbackModal.closeModal();
        }
      }
    )
  ] });
};
var AIFeedback_default = AIFeedback;
var TestStepFailureAnalyzerDrawer = ({
  onClose,
  stepResult,
  testStep,
  appVersionId,
  updateLocalStep,
  orignalTestStep
}) => {
  const [messages, setMessages] = useState([]);
  const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(null);
  const [isChatLoading, setIsChatLoading] = useState(false);
  const interactionIdRef = useRef(null);
  const healerChatMessages = useRef([]);
  const bugReportDrawer = useModal();
  const dispatch = getGlobalDispatch();
  const isInitialMount = useRef(true);
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    if (orignalTestStep && updateLocalStep) {
      updateLocalStep(new TestStep().deserialize(orignalTestStep));
    }
  }, [orignalTestStep, updateLocalStep]);
  const { data: testCaseResult, isLoading: isTestCaseResultLoading } = useQuery$1(
    {
      queryKey: ["test-case-result", stepResult?.testCaseResultId],
      queryFn: () => TestcaseResultApi.findById(
        stepResult?.testCaseResultId
      ),
      enabled: Boolean(stepResult?.testCaseResultId)
    }
  );
  const { data: analyzedResult, isLoading: isAnalyzerResultLoading } = useQuery$1(
    {
      queryKey: ["analyzer-result", stepResult?.id, testStep?.id],
      queryFn: () => triggerAnalyzer(),
      enabled: Boolean(stepResult && testStep),
      refetchOnMount: true
    }
  );
  const isInitialLoading = isTestCaseResultLoading || isAnalyzerResultLoading;
  const { data: interactionData } = useQuery$1(
    ["interaction", interactionIdRef.current],
    async () => {
      return await AlphaApi.getInteractionByUUID(interactionIdRef.current);
    },
    {
      enabled: Boolean(interactionIdRef.current),
      staleTime: Infinity,
      cacheTime: Infinity
    }
  );
  const { data: nlActions } = useQuery$1({
    queryKey: ["nl-actions"],
    queryFn: async () => (await TemplateApi.getAll(ApplicationType.WebApplication)).content,
    staleTime: Infinity,
    cacheTime: Infinity
  });
  const showFeedback = interactionData?.feedback_score == null;
  const getAnalyzerData = (received_messages) => {
    return {
      analysis: analyzedResult,
      previous_chat_context: convertMessagesToPayloadFormat(received_messages)
    };
  };
  const allStepResults = useSelector(
    selectStepResults
  );
  const handlePositiveFeedback = () => {
    const analyzerData = getAnalyzerData(messages);
    logEvent(
      analytics_constants_default.AMPLITUDE.ANALYZER_POSITIVE_FEEDBACK,
      analyzerData
    );
    AlphaApi.saveFeedback(interactionIdRef.current, {
      score: 10,
      feedback: "Positive Feedback"
    });
  };
  const handleNegativeFeedback = (textMessage) => {
    const analyzerData = getAnalyzerData(messages);
    const feedbackData = {
      ...analyzerData,
      user_feedback: textMessage
    };
    logEvent(
      analytics_constants_default.AMPLITUDE.ANALYZER_NEGATIVE_FEEDBACK,
      feedbackData
    );
    AlphaApi.saveFeedback(interactionIdRef.current, {
      score: 0,
      feedback: textMessage
    });
  };
  const buildAnalyzerMessages = (output, elementScreenshotUrl, screenshotDataURL) => {
    const messages2 = [
      {
        type: MESSAGE_TYPES.ANALYZER_MAIN,
        analyzerOutput: output,
        elementSourceScreenshot: elementScreenshotUrl,
        currentExecutionScreenshot: screenshotDataURL,
        isLatestRun: true
      },
      {
        type: MESSAGE_TYPES.ANALYZER_ACTIONS,
        isLatestRun: true,
        latestTestCaseResultId: stepResult?.testCaseResultId
      }
    ];
    return messages2;
  };
  const loadPreviousMessages = (analyzerChatMessages) => {
    const messageList = [];
    for (const analyzerChatMessage of analyzerChatMessages) {
      if (analyzerChatMessage.type == "user") {
        messageList.push({
          type: MESSAGE_TYPES.USER,
          content: analyzerChatMessage.content
        });
      } else if (analyzerChatMessage.type == "error") {
        messageList.push({
          type: MESSAGE_TYPES.SYSTEM,
          content: analyzerChatMessage.content
        });
      } else {
        messageList.push(buildHealerResponseMessage(analyzerChatMessage));
      }
    }
    setMessages((prev) => [...prev, ...messageList]);
  };
  const triggerAnalyzer = async () => {
    const payload = {
      action: "atto-analyzer",
      context: {
        test_case_result_id: stepResult?.stepGroupHostCaseResultId || stepResult?.testCaseResultId,
        test_case_id: testStep.testCaseId || stepResult.testCaseId,
        step_to_analyze_uuid: stepResult?.uuid,
        debugger_failed_step: stepResult,
        application_type: ApplicationType.WebApplication,
        is_debugger: true
      }
    };
    const res = await AlphaApi.post(payload);
    const { output: outputFromResponse, messages: analyzerChatMessages } = res;
    const { output, interactionId: interactionIdFromResponse } = outputFromResponse;
    interactionIdRef.current = interactionIdFromResponse;
    const elementId = stepResult?.fieldDefinitionDetails?.["ui-identifier"]?.uiIdentifierEntity?.id;
    let elementScreenshotUrl = null;
    if (elementId) {
      try {
        const screenshotRes = await RecorderAssetsApi.getElementScreenshot({
          elementId: String(elementId),
          applicationVersionId: Number(appVersionId)
        });
        elementScreenshotUrl = screenshotRes.elementScreenshotPresignedUrl;
      } catch (error) {
      }
    }
    const screenshotUrl = getScreenshotUrl(stepResult, false, true);
    const screenshotDataURL = await getImageDataUri(screenshotUrl);
    const newMessages = buildAnalyzerMessages(
      output,
      elementScreenshotUrl,
      screenshotDataURL
    );
    setMessages((prev) => [...prev, ...newMessages]);
    if (analyzerChatMessages && analyzerChatMessages.length > 0) {
      healerChatMessages.current = analyzerChatMessages;
      loadPreviousMessages(analyzerChatMessages);
    }
    return output;
  };
  const getHealerAgentPayload = (query, suggestion) => {
    const stepMetadata = stepResult?.metadata?.testStep;
    return {
      action: "atto-analyzer-healer",
      context: {
        data: {
          test_case_id: testCaseResult?.testCaseId,
          test_case_result_id: stepResult?.testCaseResultId,
          version_id: appVersionId,
          analysis: analyzedResult,
          run_id: testCaseResult?.executionResultId,
          application_type: ApplicationType.WebApplication,
          query,
          selected_suggestion: suggestion,
          chat_history: convertMessagesToPayloadFormat(messages),
          step_metadata: {
            step_id: stepMetadata?.id,
            wait_time: stepMetadata?.waitTime,
            is_step_result_ignored: stepMetadata?.ignoreStepResult
          },
          step_results: allStepResults.map((step) => {
            return {
              step_number: step.stepNumber,
              assertName: step.screenshotName,
              step_id: step.uuid,
              wait_time: step.stepDetail?.waitTime,
              message: step.message
            };
          }) || []
        }
      }
    };
  };
  const handleChatMessageUpdate = async (suggestion) => {
    const messageKey = suggestion.messageKey;
    const healerChatMessage = healerChatMessages.current.find(
      (message) => message.key === messageKey
    );
    const healerResponse = healerChatMessage.content;
    healerResponse.isFixed = true;
    const meta = healerResponse.meta;
    const testCaseResultId = meta?.testcase_result_id;
    const testStepUUID = meta?.step_result_uuid;
    const payload = {
      content: healerResponse,
      key: messageKey,
      testCaseResultId,
      testStepUUID
    };
    await StepResultApi.updateAnalyzerMessage(payload);
  };
  const buildHealerAgentMessages = (response, isFixed = false, messageKey = null) => {
    function HealerAgentResponseRenderer() {
      const handleApply = useCallback(
        async (suggestion, setLoading, setIsFixed) => {
          try {
            const handler = getSubCategoryHandler(suggestion.sub_category);
            const updatedTestStep = await handler(suggestion, setLoading);
            const testCaseResultId = suggestion.output?.test_case_result_id;
            if (testCaseResultId) {
              try {
                await TestcaseResultApi.markAsFixed(
                  Number(testCaseResultId),
                  updatedTestStep
                );
                toastify(
                  __("common.message.update.success", {
                    fieldName: "Test step"
                  }),
                  {
                    type: "success"
                  }
                );
              } catch (error) {
                console.error("Error marking step as fixed:", error);
                toastify(
                  __("common.message.update.failure", {
                    fieldName: "Test step"
                  }),
                  {
                    type: "error"
                  }
                );
              }
            } else if (updatedTestStep) {
              toastify(
                __("common.message.update.success", {
                  fieldName: "Test step"
                }),
                {
                  type: "success"
                }
              );
            }
            if (suggestion.sub_category == "ADD_STEP_NLP") {
              logEvent(
                analytics_constants_default.AMPLITUDE.AI_ANALYZER_ADD_STEP,
                {
                  session_id: interactionIdRef.current,
                  added_test_steps: updatedTestStep
                }
              );
            } else {
              logEvent(
                analytics_constants_default.AMPLITUDE.AI_ANALYZER_UPDATE_STEP,
                {
                  session_id: interactionIdRef.current,
                  updated_test_steps: updatedTestStep
                }
              );
            }
            const updatedSteps = await refreshPageContainingStep(
              testStep,
              true
            );
            await dispatch(updateTestSteps(updatedSteps));
            await handleChatMessageUpdate(suggestion);
            setIsFixed(true);
          } catch (error) {
            console.error("Error applying suggestion:", error);
            toastify(__("common.error.analyzer_failed"), {
              type: "error"
            });
          }
        },
        []
      );
      return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
        CategorySection,
        {
          response,
          onApply: handleApply,
          nlActions,
          allStepResults,
          isFixed,
          messageKey
        }
      ) });
    }
    HealerAgentResponseRenderer.displayName = "HealerAgentResponseRenderer";
    return HealerAgentResponseRenderer;
  };
  const buildHealerResponseMessage = (analyzerChatMessage) => {
    const healerResponse = analyzerChatMessage.content;
    const messageType = healerResponse.is_fix_required ? MESSAGE_TYPES.HEALER_AGENT_RESPONSE : MESSAGE_TYPES.SYSTEM;
    const messageContent = healerResponse.is_fix_required ? buildHealerAgentMessages(
      healerResponse.content,
      healerResponse.isFixed || false,
      analyzerChatMessage.key
    ) : healerResponse.content;
    return {
      type: messageType,
      content: messageContent
    };
  };
  const triggerHealerAgent = (suggestion = null) => {
    setIsChatLoading(true);
    const query = typeof suggestion === "string" ? suggestion : `Generate fix as per Suggestion #${activeSuggestionIndex + 1} - ${suggestion?.suggestion}`;
    setMessages((prev) => [
      ...prev,
      {
        type: MESSAGE_TYPES.USER,
        content: query
      },
      {
        type: MESSAGE_TYPES.LOADING,
        content: __("common.loading")
      }
    ]);
    const selectedSuggestion = typeof suggestion === "string" ? null : suggestion;
    const payload = getHealerAgentPayload(query, selectedSuggestion);
    AlphaApi.post(payload).then((res) => {
      const { output } = res;
      const convertedResponse = output;
      healerChatMessages.current.push(convertedResponse);
      const healerResponseMessage = convertedResponse.type == "error" ? {
        type: MESSAGE_TYPES.SYSTEM,
        content: convertedResponse.content
      } : buildHealerResponseMessage(convertedResponse);
      setMessages((prev) => [
        ...prev.slice(0, prev.length - 1),
        // Remove the loading message
        healerResponseMessage
      ]);
    }).catch(() => {
      setMessages((prev) => [
        ...prev.slice(0, prev.length - 1),
        // Remove the loading message
        {
          type: MESSAGE_TYPES.SYSTEM,
          content: __("common.error.analyzer_failed")
        }
      ]);
    }).finally(() => {
      setIsChatLoading(false);
    });
  };
  const onClickMessage = (clickedMessage) => {
    switch (clickedMessage.action) {
      case CHAT_ACTIONS.REPORT_BUG:
        bugReportDrawer.openModal();
        break;
      case CHAT_ACTIONS.FIX_USING_HEALER_AGENT:
        const suggestion = analyzedResult?.suggestions?.[activeSuggestionIndex];
        triggerHealerAgent(suggestion);
        break;
    }
  };
  return /* @__PURE__ */ jsx(
    Drawer,
    {
      isOpen: true,
      closeOnEscape: true,
      onClose,
      overlayClassName: "!backdrop-blur-0",
      children: /* @__PURE__ */ jsx(DrawerItem, { direction: "right", width: window.innerWidth, children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col h-full p-4", children: [
        /* @__PURE__ */ jsxs("div", { className: "pb-2 text-secondary-700 font-semibold flex w-full justify-between border-b-2 mb-4 px-5 pt-2", children: [
          /* @__PURE__ */ jsxs("div", { className: "flex", children: [
            /* @__PURE__ */ jsx(MemorizedIcon, { name: "ai-analyzer-agent", className: "text-xl" }),
            /* @__PURE__ */ jsx("span", { className: "pl-2", children: "Analyzer Agent" })
          ] }),
          /* @__PURE__ */ jsx(
            MemorizedIcon,
            {
              name: "close",
              className: "text-2xl cursor-pointer",
              onClick: onClose
            }
          )
        ] }),
        /* @__PURE__ */ jsx("div", { className: "overflow-hidden max-h-[calc(100vh-100px)]", children: isInitialLoading ? /* @__PURE__ */ jsxs("div", { className: "h-[calc(100vh-100px)] flex-1 flex flex-col justify-center items-center gap-3", children: [
          /* @__PURE__ */ jsx(
            MemorizedIcon,
            {
              name: "loader",
              className: "text-4xl text-secondary-500 animate-spin"
            }
          ),
          /* @__PURE__ */ jsx("div", { className: "text-sm text-gray-500", children: __("common.analyzing") })
        ] }) : /* @__PURE__ */ jsxs("div", { className: "!h-full !overflow-hidden flex flex-col justify-between", children: [
          /* @__PURE__ */ jsxs("div", { className: "overflow-auto px-6 pb-10", children: [
            /* @__PURE__ */ jsx(
              chat_default,
              {
                messages,
                onClickMessage,
                selectedSuggestionIndex: activeSuggestionIndex,
                onSelectSuggestion: setActiveSuggestionIndex
              }
            ),
            showFeedback && !isChatLoading && /* @__PURE__ */ jsx("div", { className: "ml-[-24px]", children: /* @__PURE__ */ jsx(
              AIFeedback_default,
              {
                handlePositiveFeedback,
                handleNegativeFeedback
              },
              messages?.length
            ) })
          ] }),
          /* @__PURE__ */ jsx(
            ChatMessageInput,
            {
              onSubmit: triggerHealerAgent,
              isLoading: isChatLoading
            }
          )
        ] }) }),
        bugReportDrawer.state.show && /* @__PURE__ */ jsx(
          bug_report_drawer_default,
          {
            isOpen: bugReportDrawer.state.show,
            setShowBugReport: bugReportDrawer.closeModal,
            isAiBugReporter: true,
            testCaseResult,
            stepResults: allStepResults,
            stepToAnalyzeUuid: stepResult?.uuid
          }
        )
      ] }) })
    }
  );
};
var StepActionIcon = ({
  title,
  icon,
  isStepFocused,
  onClick,
  setRef = NOOP,
  isDisabled = false,
  iconClassName,
  onClickCapture = null
}) => {
  return /* @__PURE__ */ jsx(ToolTip, { content: title, className: "flex items-center", children: /* @__PURE__ */ jsx(
    Icon,
    {
      setRef,
      name: icon,
      ...onClickCapture ? { onClickCapture: !isDisabled ? onClickCapture : () => {
      } } : { onClick: !isDisabled ? onClick : () => {
      } },
      className: classNames82(
        "text-unique-800 rounded p-0.5 border border-transparent ml-3 cursor-pointer",
        {
          "hover:bg-primary-100": isStepFocused,
          "hover:border-primary-200": !isStepFocused,
          "opacity-40 cursor-not-allowed pointer-events-none": isDisabled
        },
        iconClassName
      )
    }
  ) });
};
var MoreOptionsDropdownItem = ({
  name,
  icon,
  isDisabled = false,
  onClick = null,
  toggleDropdown
}) => {
  const { isWebRecorder } = useContext(StepContext);
  const handleClick = useCallback(() => {
    if (!isDisabled) {
      toggleDropdown();
      onClick();
    }
  }, [onClick, isDisabled]);
  return /* @__PURE__ */ jsxs(
    DropdownItem,
    {
      onClick: handleClick,
      className: classNames82("py-1.5 flex item-center hover:!bg-secondary-50", {
        "opacity-40 cursor-not-allowed": isDisabled,
        "!text-2xs": isWebRecorder
      }),
      children: [
        /* @__PURE__ */ jsx(
          Icon,
          {
            name: icon,
            className: classNames82(
              { "text-xl": !isWebRecorder, "text-lg": !isWebRecorder },
              "text-unique-800"
            )
          }
        ),
        " ",
        /* @__PURE__ */ jsx("span", { className: "ml-2 text-unique-600", children: name })
      ]
    }
  );
};
var useHandleSettings = (testStep, steps, openTestStepSettingsDrawer, updateWatchFocusOut, updateLocalStep, saveStep, nlActions, kibbutzActions, stepResult) => {
  const { t } = useTranslation();
  const handleSettings = useCallback(async () => {
    updateWatchFocusOut(false);
    const { testStep: localStep } = await openTestStepSettingsDrawer(
      testStep,
      steps,
      nlActions,
      kibbutzActions,
      stepResult
    );
    if (!localStep) return;
    updateLocalStep(localStep);
    updateWatchFocusOut(true);
    if (localStep.id) {
      saveStep(localStep);
      toastify(t("step.setting.updated"), {
        type: "success",
        position: "top-center",
        autoClose: 2500
      });
    }
  }, [testStep, steps]);
  return handleSettings;
};
var MoreOptionsDropdown = ({
  testStep,
  orignalTestStep,
  buttonRef,
  toggleDropdown,
  stepContext: stepContext2,
  updateLocalStep,
  saveStep,
  updateWatchFocusOut,
  handleChange,
  onRemoveStep,
  onNestedCreateStep,
  cloneStep = () => {
  },
  isRecorderView,
  debuggerActions,
  stepResult,
  isDebuggerPointPlaced = false,
  isDebugMode,
  onOpenChange,
  hasFeature: hasFeatureFromProps
}) => {
  const { t } = useTranslation();
  const [dropdownRef, setDropdownRef] = useState(null);
  const { styles, attributes } = usePopper(buttonRef.current, dropdownRef, {
    placement: "bottom-end",
    strategy: "fixed"
  });
  const { hasFeature: tenantHasFeature, hasTenantPreference } = useTenantInfo();
  const hasFeature = !!hasFeatureFromProps ? hasFeatureFromProps : tenantHasFeature;
  const analyzerDrawer = useModal();
  const hasAnalyzerEnabled = useMemo(() => {
    return hasFeature?.(Feature.ANALYZER_BUG_REPORT_AGENT) && hasTenantPreference?.("agenticAiAnalyzeMode");
  }, [hasFeature, hasTenantPreference]);
  const canAnalyze = useMemo(() => {
    const ELIGIBLE_RESULT_TYPES = [
      StepResultType.NLP_TEXT,
      StepResultType.CONDITION_IF,
      StepResultType.CONDITION_ELSE_IF
    ];
    return hasAnalyzerEnabled && stepResult?.result === ResultConstant.FAILURE && ELIGIBLE_RESULT_TYPES.includes(stepResult?.resultType);
  }, [hasAnalyzerEnabled, stepResult]);
  const { steps, openTestStepSettingsDrawer, nlActions, kibbutzActions } = stepContext2;
  const { above, below } = useGetStepChipTypeBased(
    testStep,
    steps,
    isDebugMode
  );
  const { openStepResultDetails } = debuggerActions ?? {};
  const handleSettings = useHandleSettings(
    testStep,
    steps,
    openTestStepSettingsDrawer,
    updateWatchFocusOut,
    updateLocalStep,
    saveStep,
    nlActions,
    kibbutzActions,
    stepResult
  );
  const handleBreakStep = useCallback(
    (isBelow) => {
      const step = addBreakStep(testStep, steps, isBelow ? "below" : "above");
      onNestedCreateStep(step);
    },
    [steps, testStep, onNestedCreateStep]
  );
  const handleContinueStep = useCallback(
    (isBelow) => {
      const step = addContinueStep(
        testStep,
        steps,
        isBelow ? "below" : "above"
      );
      onNestedCreateStep(step);
    },
    [steps, testStep, onNestedCreateStep]
  );
  const generateStepChipsOptions = useCallback(() => {
    const allOptions = [...above, ...below];
    return allOptions.map(({ label, callBack, type }) => {
      const isPausedAndStepAbove = stepResult?.result === ResultConstant.PAUSED && type === CHIP_TYPES.ABOVE;
      return {
        name: label,
        icon: "add",
        // All step chip options use the add icon
        onClick: () => {
          const result = callBack(testStep);
          onNestedCreateStep(result);
        },
        isDisabled: isPausedAndStepAbove,
        tooltipContent: isPausedAndStepAbove ? t("live-editor.step.add_above_paused") : null
      };
    });
  }, [above, below, testStep, onNestedCreateStep]);
  const renderToggleDisabledItem = () => {
    const isDisabled = testStep.disabled;
    const name = isDisabled ? t("step.enable") : t("step.disable");
    const icon = isDisabled ? "task-alt" : "block";
    return /* @__PURE__ */ jsx(
      MoreOptionsDropdownItem,
      {
        toggleDropdown,
        name,
        icon,
        onClick: () => handleChange("disabled", !isDisabled),
        isDisabled: !testStep.id
      }
    );
  };
  const renderBreakContinueOptions = () => {
    if (!testStep.canShowBreakContinueLoop) return null;
    const items = [
      {
        name: t("step.add_above_break"),
        onClick: () => handleBreakStep(false)
      },
      {
        name: t("step.add_above_continue"),
        onClick: () => handleContinueStep(false)
      },
      {
        name: t("step.add_below_break"),
        onClick: () => handleBreakStep(true)
      },
      {
        name: t("step.add_below_continue"),
        onClick: () => handleContinueStep(true)
      }
    ];
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      !testStep.canShowBelowBreakContinueLoop && items.slice(0, 2).map((item, index) => /* @__PURE__ */ jsx(
        MoreOptionsDropdownItem,
        {
          toggleDropdown,
          name: item.name,
          icon: "add",
          onClick: item.onClick
        },
        index
      )),
      !testStep.canShowBelowBreakContinueLoop && /* @__PURE__ */ jsx(Divider, {}),
      items.slice(2).map((item, index) => /* @__PURE__ */ jsx(
        MoreOptionsDropdownItem,
        {
          toggleDropdown,
          name: item.name,
          icon: "add",
          onClick: item.onClick
        },
        index
      )),
      /* @__PURE__ */ jsx(Divider, {})
    ] });
  };
  const renderVisualTestingOptions = () => {
    if (testStep.isStepGroup || testStep.isRestStep || !testStep.isVisualTestingSupportedNLP || testStep.applicationType === ApplicationType.Rest || testStep.isConditionalLoop || testStep.isSoqlStep) {
      return null;
    }
    const isVisualEnabled = testStep.visualEnabled;
    const name = isVisualEnabled ? t("step.disable.visual.testing") : t("step.enable.visual.testing");
    const icon = isVisualEnabled ? "no-photography" : "visual-difference";
    const onClick = () => handleChange("visualEnabled", !isVisualEnabled);
    return /* @__PURE__ */ jsx(
      MoreOptionsDropdownItem,
      {
        toggleDropdown,
        name,
        icon,
        onClick
      }
    );
  };
  if (isDebugMode) {
    const { result } = stepResult || {};
    const {
      disabled,
      id: stepId,
      canShowBreakContinueLoop,
      canShowBelowBreakContinueLoop,
      ignoreStepResult,
      isStepGroup: isStepGroup2,
      isRestStep: isRestStep2,
      isVisualTestingSupportedNLP: isVisualTestingSupportedNLP2,
      applicationType,
      isConditionalLoop,
      isSoqlStep,
      visualEnabled,
      isPresentationStep: isPresentationStep2,
      isForLoop: isForLoop2,
      isConditionalWhileLoop: isConditionalWhileLoop2,
      action,
      isConditionalStep: isConditionalStep2,
      isStepGroupChild
    } = testStep;
    const options3 = [
      // Step chips options - Add above/below/inside steps
      ...isRecorderView && !isStepGroupChild ? generateStepChipsOptions().map((option) => ({
        shouldShow: true,
        ...option
      })) : [],
      // Analyzer option
      ...canAnalyze ? [
        {
          shouldShow: true,
          name: __("analyzer.main_result.analyze_with_agent"),
          icon: "ai-analyzer-agent",
          onClick: () => analyzerDrawer.openModal()
        }
      ] : [],
      // Only show additional options if it's not a presentation step
      ...!isPresentationStep2 && !isBlock(testStep) ? [
        // Debugger options
        ...!!stepResult && result && result !== ResultConstant.PAUSED ? [
          {
            shouldShow: true,
            name: t("liveEditor.stepOption.viewResult"),
            icon: "step-result",
            onClick: () => openStepResultDetails(stepResult)
          }
        ] : [],
        // Break/Continue options
        ...canShowBreakContinueLoop && !canShowBelowBreakContinueLoop ? [
          {
            shouldShow: true,
            name: t("step.add_above_break"),
            icon: "add",
            onClick: () => handleBreakStep(false)
          },
          {
            shouldShow: true,
            name: t("step.add_above_continue"),
            icon: "add",
            onClick: () => handleContinueStep(false)
          }
        ] : [],
        ...canShowBreakContinueLoop ? [
          {
            shouldShow: true,
            name: t("step.add_below_break"),
            icon: "add",
            onClick: () => handleBreakStep(true)
          },
          {
            shouldShow: true,
            name: t("step.add_below_continue"),
            icon: "add",
            onClick: () => handleContinueStep(true)
          }
        ] : [],
        // Toggle disabled item
        ...isRecorderView ? [
          {
            shouldShow: true,
            name: disabled ? t("step.enable") : t("step.disable"),
            icon: disabled ? "task-alt" : "block",
            onClick: () => handleChange("disabled", !disabled),
            isDisabled: !stepId
          }
        ] : [],
        // Ignore step result option
        {
          shouldShow: true,
          name: ignoreStepResult ? t("step.dont.ignore.result") : t("step.ignore.result"),
          icon: ignoreStepResult ? "fact-check-tick" : "fact-check-cross",
          onClick: () => handleChange("ignoreStepResult", !ignoreStepResult),
          isDisabled: disabled
        },
        // Visual testing option
        ...isStepGroup2 || isRestStep2 || !isVisualTestingSupportedNLP2 || applicationType === ApplicationType.Rest || isConditionalLoop || isSoqlStep ? [] : [
          {
            shouldShow: true,
            name: visualEnabled ? t("step.disable.visual.testing") : t("step.enable.visual.testing"),
            icon: visualEnabled ? "no-photography" : "visual-difference",
            onClick: () => handleChange("visualEnabled", !visualEnabled)
          }
        ],
        // Settings option
        {
          shouldShow: true,
          name: t("step.settings"),
          icon: "settings",
          onClick: handleSettings
        },
        // Clone option
        ...!isForLoop2 && !isConditionalWhileLoop2 && Boolean(action?.length) && !isConditionalStep2 && !isBlock(testStep) && isRecorderView ? [
          {
            shouldShow: true,
            name: t("step.clone"),
            icon: "clone",
            onClick: cloneStep,
            isDisabled: !stepId
          }
        ] : [],
        // Delete option
        ...isRecorderView ? [
          {
            shouldShow: true,
            name: isBlock(testStep) ? t("step.delete.block") : t("step.delete"),
            icon: "delete",
            onClick: () => onRemoveStep(testStep, true)
          }
        ] : []
      ] : [],
      ...isBreakLoop(testStep) || isContinueLoop(testStep) || isConditionalElse(testStep) ? [
        {
          shouldShow: true,
          name: t("step.delete"),
          icon: "delete",
          onClick: () => onRemoveStep(testStep, true)
        }
      ] : []
    ].filter(({ shouldShow }) => shouldShow);
    if (analyzerDrawer.state.show) {
      return /* @__PURE__ */ jsx(
        TestStepFailureAnalyzerDrawer,
        {
          onClose: analyzerDrawer.closeModal,
          stepResult,
          testStep,
          orignalTestStep,
          appVersionId: Number(stepContext2.versionId),
          updateLocalStep
        }
      );
    }
    return /* @__PURE__ */ jsx(
      row_actions_dropdown_default,
      {
        options: options3,
        dropdownClassName: "!w-48",
        onOpenChange
      }
    );
  }
  return /* @__PURE__ */ jsxs(
    Dropdown,
    {
      className: "w-[200px] py-1 gap-0.5 text-small leading-5 text-secondary-700 z-10",
      toggleDropdown,
      setRef: setDropdownRef,
      style: styles.popper,
      attributes: attributes.popper,
      isAnimationEnabled: false,
      buttonRef,
      children: [
        renderBreakContinueOptions(),
        isRecorderView && !stepResult && renderToggleDisabledItem(),
        /* @__PURE__ */ jsx(
          MoreOptionsDropdownItem,
          {
            toggleDropdown,
            name: testStep.ignoreStepResult ? t("step.dont.ignore.result") : t("step.ignore.result"),
            icon: testStep.ignoreStepResult ? "fact-check-tick" : "fact-check-cross",
            isDisabled: testStep.disabled,
            onClick: () => handleChange("ignoreStepResult", !testStep.ignoreStepResult)
          }
        ),
        renderVisualTestingOptions(),
        !stepResult?.result && /* @__PURE__ */ jsx(
          MoreOptionsDropdownItem,
          {
            toggleDropdown,
            name: t("step.settings"),
            icon: "settings",
            onClick: handleSettings
          }
        ),
        !testStep.isPresentationStep && !testStep.isForLoop && !testStep.isConditionalWhileLoop && Boolean(testStep.action?.length) && !testStep.isConditionalStep && !testStep.isBlock && isRecorderView && /* @__PURE__ */ jsx(
          MoreOptionsDropdownItem,
          {
            toggleDropdown,
            name: t("step.clone"),
            icon: "clone",
            onClick: cloneStep,
            isDisabled: !testStep.id
          }
        ),
        isRecorderView && !isDebuggerPointPlaced && !stepResult && stepResult?.result !== ResultConstant.PAUSED && /* @__PURE__ */ jsx(
          MoreOptionsDropdownItem,
          {
            toggleDropdown,
            name: isBlock(testStep) ? t("step.delete.block") : t("step.delete"),
            icon: "delete",
            onClick: () => onRemoveStep(testStep, true)
          }
        )
      ]
    }
  );
};
var useIsStepPaused = (stepResult) => {
  return useMemo(
    () => stepResult?.result === ResultConstant.PAUSED,
    [stepResult]
  );
};
var StepActionIcons = ({
  isStepFocused,
  testStep,
  orignalTestStep,
  updateLocalStep,
  saveStep,
  updateWatchFocusOut,
  onCreateStep,
  onRemoveStep,
  onOpenMore = false,
  onToggleMoreOptions,
  onCloseMoreOptions,
  onOpenMoreChange,
  onNestedCreateStep,
  isDebugMode,
  debuggerActions,
  stepResult,
  nextStep,
  isIterationStepChild,
  executedStepIds,
  hasFeature
}) => {
  const { t } = useTranslation();
  const moreIconRef = useRef(null);
  const stepContext2 = useContext(StepContext);
  const { steps, isRecorderView } = stepContext2;
  const [isCloning, setIsCloning] = useState(false);
  const handleChange = useCallback(
    (key, value) => {
      const step = new TestStep().deserialize(testStep);
      step[key] = value;
      if (key === "ignoreStepResult") {
        step.priority = value ? TestStepPriority.MINOR : TestStepPriority.MAJOR;
      }
      updateLocalStep(step);
    },
    [testStep, updateLocalStep]
  );
  const cloneStep = useCallback(async () => {
    setIsCloning(true);
    const step = new TestStep().deserialize(orignalTestStep);
    const currentIndex = steps.findIndex((item) => item.id === step.id);
    step.stepOrder = steps[currentIndex + 1] ? (steps[currentIndex + 1].stepOrder + orignalTestStep.stepOrder) / 2 : orignalTestStep.stepOrder + 1e3;
    step.copiedFrom = testStep.id;
    delete step.id;
    step.isRefetch = true;
    await onCreateStep(
      step,
      true,
      () => setTimeout(() => setIsCloning(false), 150)
    );
  }, [testStep, steps, orignalTestStep, onCreateStep]);
  const isStepPaused = useIsStepPaused(stepResult);
  const applyIconsInvisible = !isStepFocused && !onOpenMore;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames82("inline-flex flex-shrink-0 text-xl relative", {
        "invisible group-hover:visible": applyIconsInvisible,
        "m-2": !isRecorderView
      }),
      children: [
        testStep.id && !testStep.isPresentationStep && !testStep.isForLoop && !testStep.isConditionalWhileLoop && Boolean(testStep.action?.length) && !testStep.isConditionalStep && !testStep.isStepGroupChild && !testStep.isBlock && !isRecorderView && /* @__PURE__ */ jsx(
          StepActionIcon,
          {
            isStepFocused,
            icon: "clone",
            title: t("step.clone"),
            onClick: cloneStep,
            isDisabled: isCloning
          }
        ),
        testStep.id && !testStep.isPresentationStep && !testStep.isForLoop && !testStep.isConditionalWhileLoop && !testStep.isStepGroupChild && !testStep.disabled && Boolean(testStep.action?.length) && !isRecorderView && /* @__PURE__ */ jsx(
          StepActionIcon,
          {
            isStepFocused,
            icon: "block",
            title: t("step.disable"),
            onClick: () => handleChange("disabled", true),
            isDisabled: !testStep.id
          }
        ),
        testStep.id && !testStep.isPresentationStep && !testStep.isForLoop && !testStep.isConditionalWhileLoop && !testStep.isStepGroupChild && testStep.disabled && Boolean(testStep.action?.length) && !isRecorderView && /* @__PURE__ */ jsx(
          StepActionIcon,
          {
            isStepFocused,
            icon: "task-alt",
            title: t("step.enable"),
            onClick: () => handleChange("disabled", false)
          }
        ),
        testStep.id && Boolean(testStep.action?.length) && !isRecorderView && !testStep.isStepGroupChild && !testStep.isPresentationStep && /* @__PURE__ */ jsx(
          StepActionIcon,
          {
            isStepFocused,
            icon: "delete",
            title: testStep.isBlock ? t("step.delete.block") : t("step.delete"),
            onClickCapture: (event) => {
              event.stopPropagation();
              event.preventDefault();
              onRemoveStep(testStep, true);
            }
          }
        ),
        (testStep.id && Boolean(testStep.action?.length) && !testStep.isPresentationStep || isStepPaused) && !isDebugMode && /* @__PURE__ */ jsx(
          StepActionIcon,
          {
            isStepFocused,
            icon: "more-vertical",
            title: t("step.more.options"),
            onClick: onToggleMoreOptions,
            setRef: moreIconRef
          }
        ),
        (onOpenMore || isDebugMode) && /* @__PURE__ */ jsx(
          MoreOptionsDropdown,
          {
            isDebugMode,
            handleChange,
            testStep,
            orignalTestStep,
            buttonRef: moreIconRef,
            toggleDropdown: onCloseMoreOptions,
            onOpenChange: (open) => {
              if (!open) onCloseMoreOptions();
              onOpenMoreChange?.(open);
            },
            onNestedCreateStep,
            stepContext: stepContext2,
            updateLocalStep,
            saveStep,
            updateWatchFocusOut,
            onRemoveStep,
            isStepFocused,
            cloneStep,
            isRecorderView,
            debuggerActions,
            stepResult,
            nextStep,
            isIterationStepChild,
            executedStepIds,
            hasFeature
          }
        )
      ]
    }
  );
};
var StepLabel = ({
  labelType = "solid",
  content,
  className = ""
}) => {
  const styles = {
    solid: "bg-secondary-50",
    "primary-outline": ""
  };
  return !!content && /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames82(
        "px-3 h-5 items-center text-secondary-500 text-small inline-flex rounded-2xl border-[0.5px] border-secondary-100",
        styles[labelType],
        className
      ),
      children: content
    }
  );
};
var UrlValidationUI = ({
  urlValidation
}) => {
  const { message, state } = urlValidation || {};
  const validationClass = classNames82(
    "flex items-center ml-9 mr-8 my-3 px-3 rounded-lg text-small max-h-16 overflow-y-auto break-all",
    {
      "text-error-500 bg-error-50 border border-error-100": state === "invalid",
      "text-primary-500 bg-green-50 border border-green-100": state === "valid",
      "text-blue-500 bg-blue-50 border border-blue-100": state === "loading"
    }
  );
  const validationIcon = state === "invalid" ? "error-fill" : state === "valid" ? "task-alt" : null;
  if (!message) return null;
  return /* @__PURE__ */ jsxs("div", { className: validationClass, children: [
    validationIcon && /* @__PURE__ */ jsx(Icon, { name: validationIcon, className: "mr-1" }),
    /* @__PURE__ */ jsx("div", { className: "max-h-16", children: message })
  ] });
};
var { Button: Button10, BUTTON_SIZE: BUTTON_SIZE6, BUTTON_VARIANTS: BUTTON_VARIANTS6 } = V2;
var Overlay = () => {
  return /* @__PURE__ */ jsx("div", { className: "absolute inset-0 h-full w-full z-[1001] top-0 left-0" });
};
var NonExecutedStep = ({
  step,
  localStep,
  isEdit,
  getTestData: getTestData2,
  onCreateStep,
  onNestedCreateStep,
  onRemoveStep,
  onSearch,
  isFetching,
  isCommand,
  isCommandCombine,
  isViewOnly,
  isViewOnlySingle,
  dataProfileList,
  dataSetList,
  dataParameterList,
  updateSelectedDataProfile,
  provided,
  onToggleDebug,
  debugPoints,
  debuggerActions,
  stepResult,
  nextStep,
  fetchConnections,
  actionCallback,
  salesforceActions,
  uploadActions,
  isIterationStepChild,
  isEligibleForDebug,
  sessionActions,
  executedStepIds,
  customFunctionList,
  // Additional props
  isFocused,
  updateFocused,
  isDragMode,
  stepHighlightByStatus,
  isBulkActionMode,
  onChange,
  onCancel,
  onSave,
  errorOnSave,
  isSaving,
  onMouseOverStepValidate,
  urlValidation,
  onStepTypeChange,
  isStepValueChanged,
  isStepDisabled,
  handleSelectionChange,
  isSelected,
  toggleStep,
  isNestedStepGroupStep,
  isDebuggerPointPlaced,
  isDesktopSkipClear,
  onClear,
  onOpenMore,
  toggleMoreOptions,
  closeMoreOptions,
  onOpenMoreChange,
  updateWatchFocusOut,
  updateLocalStep,
  stepsInfo,
  template,
  updateStepsInfo,
  openStepGroupsListDrawer,
  openCustomFunctionParameterDrawer,
  isWebRecorder,
  isRecorderView,
  localBlocks,
  isStepInvalid,
  isShow,
  setLastFocusedStepNumber,
  hasFeatureValue: hasFeatureValue2,
  openVisualFigmaViewModal,
  stopPropagation,
  handleToggleDebug,
  isGroupExpanding,
  isExpaned,
  className: classNameProps,
  iterationItems = [],
  selectedIterationIndex,
  onIterationChange,
  debugExecutionStatus
  // isToggleDisabled,
}) => {
  const { t } = useTranslation();
  const {
    isInvalid: stepIsInvalid,
    isForLoop: isForLoop2,
    isConditionalWhileLoop: isConditionalWhileLoop2,
    isBlock: stepIsBlock,
    isConditionalElse: isConditionalElse2,
    isStepGroup: stepIsStepGroup,
    disabled: stepDisabled,
    action
  } = step || {};
  const {
    indent,
    stepNumber,
    createType,
    disabled: localStepDisabled,
    isStepGroupChild,
    isNlpStep: isNlpStep2,
    templateId,
    isConditionalElse: localStepIsConditionalElse,
    kibbutzPluginNlpId,
    isKibbutz,
    isCustomFunction,
    uiMap,
    applicationType,
    type: localStepType,
    isConditionalLoop,
    visualEnabled,
    id: localStepId
  } = localStep || {};
  const { result } = stepResult || {};
  const stepDebugId = step?.debugStepId || "";
  const { dragHandleProps: dragHandlePropsProvided } = provided || {};
  const className = classNames82(
    classNameProps ?? stepHighlightByStatus?.bgColor ?? {
      "bg-white": !stepIsInvalid || isStepValueChanged,
      "bg-secondary-unique-900": stepIsInvalid && !isStepValueChanged
    },
    {
      "shadow-y-sm": isFocused,
      "hover:bg-secondary-50 cursor-pointer": !isFocused && !stepIsInvalid && !isViewOnly
    }
  );
  const idObject = stepDebugId ? { id: stepDebugId } : {};
  const shouldShowOverlay = !debugExecutionStatus || debugExecutionStatus === ResultConstant.RUNNING || debugExecutionStatus === ResultConstant.QUEUED;
  const dragHandleProps = isRecorderView && dragHandlePropsProvided ? { ...dragHandlePropsProvided, ...idObject } : { ...idObject };
  const shouldShowDebugPointIndicator = !isEligibleForDebug && !isForLoop2 && !isConditionalWhileLoop2 && !stepIsBlock && !isConditionalElse2 && !stepIsStepGroup && !stepDisabled;
  const column1Content = /* @__PURE__ */ jsx(Fragment, { children: !!result && result !== ResultConstant.PAUSED && result !== ResultConstant.ABORTED ? /* @__PURE__ */ jsx(execution_status_icon_default, { stepResult: result }) : /* @__PURE__ */ jsx("div", { className: "w-5" }) });
  const column2Content = /* @__PURE__ */ jsx(Fragment, { children: shouldShowDebugPointIndicator && /* @__PURE__ */ jsx(
    ToolTip,
    {
      content: !!stepHighlightByStatus ? result : !isDebuggerPointPlaced ? t("debug_run.place_debug_point") : t("debug_run.remove_debug_point"),
      children: /* @__PURE__ */ jsx("div", { className: "group w-4 h-4 flex items-center justify-center", children: /* @__PURE__ */ jsx(
        "div",
        {
          className: classNames82(
            "w-2 h-2 231 rounded-sm border-secondary-100 rotate-45 border-[0.5px] group-hover:border-none cursor-pointer",
            {
              "bg-execution-debug": !!stepHighlightByStatus || isDebuggerPointPlaced,
              "bg-secondary-50": !isDebuggerPointPlaced,
              "group-hover:bg-secondary-400": !isDebuggerPointPlaced
            }
          ),
          onMouseDown: stopPropagation,
          onMouseUp: stopPropagation,
          onClick: handleToggleDebug
        }
      ) })
    }
  ) });
  const column3Content = /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(IndentResult, { size: indent, marginLeft: 26 }),
    /* @__PURE__ */ jsxs("div", { className: "group flex relative items-center", children: [
      /* @__PURE__ */ jsx(
        StepNumber,
        {
          number: stepNumber,
          showAiIcon: createType === EntityCreateType.AI,
          className: classNames82("text-center !min-w-6", {
            "grayscale opacity-50": localStepDisabled,
            "ml-3.5": !isEdit && !isRecorderView,
            "group-hover:invisible": isEdit && !isViewOnly && !isStepGroupChild && !isDragMode && !isBulkActionMode && !(isNlpStep2 && !templateId) && (result !== ResultConstant.PAUSED || !stepResult?.isEligibleForDebug) && !stepHighlightByStatus,
            invisible: isSelected
          })
        }
      ),
      isEdit && !isViewOnly && !isStepGroupChild && !isDragMode && (!isNlpStep2 || localStepIsConditionalElse || templateId || kibbutzPluginNlpId) && (result !== ResultConstant.PAUSED || !stepResult?.isEligibleForDebug) && /* @__PURE__ */ jsx(
        Checkbox,
        {
          size: "small",
          className: classNames82(
            `group-hover:inline-block absolute left-1`,
            { hidden: !isSelected }
          ),
          checked: isSelected,
          onChange: handleSelectionChange,
          isDisabled: isStepDisabled,
          ariaLabel: `${t("common.select")} ${t("common.test_step")}`
        }
      ),
      isEdit && !isViewOnlySingle && (isStepGroup(localStep) || isBlock(localStep)) && (isGroupExpanding ? /* @__PURE__ */ jsx("div", { className: "empty-page-loader !min-w-3 !max-w-3 !min-h-3 !max-h-3 !border-2 mb-1" }) : /* @__PURE__ */ jsx(
        Icon,
        {
          name: isExpaned ? "angle-bottom" : "angle-right",
          onClickCapture: (event) => toggleStep(event, isExpaned)
        }
      ))
    ] }),
    (isPresentationStep(localStep) || isConditionalElseIf(localStep) || isConditionalIf(localStep)) && /* @__PURE__ */ jsx(step_type_indicator_text_component_default, { step: localStep }),
    isKibbutz && /* @__PURE__ */ jsx(
      Icon,
      {
        name: "addons",
        className: classNames82({ "!mt-3": action?.length > 150 })
      }
    ),
    shouldShowOverlay && /* @__PURE__ */ jsx(Overlay, {})
  ] });
  const mainContent = /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      StepItemWrapper,
      {
        step: localStep,
        getTestData: getTestData2,
        onChange,
        isViewOnly: isViewOnly || isPresentationStep(localStep) || isDragMode || isNestedStepGroupStep,
        isFocused,
        updateFocused,
        updateWatchFocusOut,
        updateLocalStep,
        onSearch,
        isFetching,
        isCommand,
        isCommandCombine,
        onChangeType: onStepTypeChange,
        dataParameterList,
        dataProfileList,
        customFunctionList,
        dataSetList,
        updateSelectedDataProfile,
        onSave,
        stepsInfo,
        template,
        updateStepsInfo,
        openStepGroupsListDrawer,
        openCustomFunctionParameterDrawer,
        isViewOnlySingle,
        setExpandStepGroup: toggleStep,
        isWebRecorder,
        fetchConnections,
        actionCallback,
        salesforceActions,
        uploadActions,
        stepResult,
        sessionActions,
        isNestedStepGroupStep,
        prevLocalBlocks: localBlocks
      }
    ),
    shouldShowOverlay && /* @__PURE__ */ jsx(Overlay, {})
  ] });
  const column4Content = /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center flex-shrink-0", children: [
      isConditionalLoop && iterationItems.length > 0 && /* @__PURE__ */ jsx(
        DropdownButton,
        {
          variant: "light",
          className: "flex items-center px-1.5 py-1 rounded-[5px] border-[0.5px] border-slate-200",
          wrapperClassName: "shadow-[0_4px_4px_-1px_rgba(0,0,0,0.02),0_1px_1px_0_rgba(0,0,0,0.06)]",
          dropdownClassName: "p-1",
          nameClassName: "text-secondary-500 fs-xxs leading-[1.2] font-normal pr-1 border-r border-[#DCDFE4]",
          dropdownIconClassName: "!ml-1",
          name: `#Iteration ${selectedIterationIndex + 1}`,
          children: iterationItems.map((option, index) => /* @__PURE__ */ jsxs(
            DropdownItem,
            {
              onClick: () => {
                if (onIterationChange) {
                  onIterationChange({
                    stepId: localStepId,
                    iterationIndex: index
                  });
                }
              },
              isSelected: index === selectedIterationIndex,
              className: "fs-xxs leading-[1.2] font-normal mr-1 p-2 text-unique-600",
              children: [
                "#Iteration ",
                index + 1
              ]
            },
            option.id
          ))
        }
      ),
      /* @__PURE__ */ jsxs(
        "div",
        {
          className: classNames82("flex items-center flex-shrink-0", {
            // Never hide actions on hover-out for presentation/ELSE steps so context menu stays usable; otherwise hide when not focused/hovered unless menu open
            "group-hover:visible invisible": isRecorderView && !isFocused && !onOpenMore && !isPresentationStep(localStep)
          }),
          children: [
            isFocused && !isDesktopSkipClear && (templateId || kibbutzPluginNlpId || isCustomFunction || !!uiMap?.objectBlocks?.length) && !localStepDisabled && !isDragMode && !isViewOnly && !isBulkActionMode && !isStepGroupChild && !isCustomFunction && !(applicationType === ApplicationType.WINDOWS_ADVANCED && isConditionalIf(localStep) && [
              TestStepType.NLP_TEXT,
              TestStepType.STEP_GROUP,
              TestStepType.API_STEP
            ].includes(localStepType)) && /* @__PURE__ */ jsx(
              Icon,
              {
                className: "text-error-600 cursor-pointer whitespace-nowrap text-base",
                onClick: () => onClear(localStep),
                name: "erase",
                toolTip: t("step.clear.step")
              }
            ),
            !isConditionalLoop && visualEnabled && /* @__PURE__ */ jsx(
              Icon,
              {
                name: "visual-difference",
                onClick: () => openVisualFigmaViewModal?.(localStep, template),
                className: classNames82(
                  "ml-2 text-warning-500 text-xl invisible group-hover:visible",
                  {
                    "cursor-pointer": hasFeatureValue2(
                      Feature.DESIGN_ASSET_VISUAL_ANALYSIS
                    )
                  }
                )
              }
            ),
            isFocused && !isRecorderView && !isPresentationStep(localStep) && /* @__PURE__ */ jsx(
              StepLabel,
              {
                className: classNames82("flex-shrink-0 ml-2"),
                content: getStepLabelText(localStep, t)
              }
            ),
            !isFocused && !isRecorderView && !isPresentationStep(localStep) && !isViewOnly && /* @__PURE__ */ jsx(
              StepLabel,
              {
                labelType: "primary-outline",
                className: classNames82(
                  "flex-shrink-0 ml-2",
                  "invisible group-hover:visible"
                ),
                content: getStepLabelText(localStep, t)
              }
            ),
            stepResult?.autoHealMetadata && /* @__PURE__ */ jsx("div", { className: "!visible", children: /* @__PURE__ */ jsx(
              AutoHealIcon,
              {
                result: stepResult.autoHealMetadata.status,
                className: "ml-3",
                showTooltip: true
              }
            ) }),
            !isViewOnly && !isDragMode && !isBulkActionMode && localStepId !== void 0 && /* @__PURE__ */ jsx(
              StepActionIcons,
              {
                isStepFocused: isFocused,
                onNestedCreateStep,
                testStep: localStep,
                orignalTestStep: step,
                updateLocalStep,
                saveStep: onSave,
                updateWatchFocusOut,
                onCreateStep,
                onRemoveStep,
                onOpenMore,
                onToggleMoreOptions: toggleMoreOptions,
                onCloseMoreOptions: closeMoreOptions,
                onOpenMoreChange,
                updateStepsInfo,
                isDebugMode: true,
                onToggleDebug,
                debugPoints,
                debuggerActions,
                stepResult,
                nextStep,
                executedStepIds,
                isIterationStepChild,
                isEligibleForDebug
              }
            )
          ]
        }
      )
    ] }),
    shouldShowOverlay && /* @__PURE__ */ jsx(Overlay, {})
  ] });
  const restContent = /* @__PURE__ */ jsx(Fragment, { children: isFocused && !isPresentationStep(localStep) && (isStepValueChanged || !localStepId || isStepInvalid) && /* @__PURE__ */ jsxs("div", { className: "flex pr-2.5 pl-0.5 bg-transparent w-full", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex-grow flex", children: [
      !isRecorderView && !isViewOnly && !isStepGroupChild && /* @__PURE__ */ jsx("span", { className: "min-w-[28px]" }),
      /* @__PURE__ */ jsx(Indent2, { size: indent, step: localStep }),
      errorOnSave && /* @__PURE__ */ jsxs("div", { className: "bg-error-50 border border-error-100 flex items-center ml-9 my-3 px-3 rounded-lg text-error-500 text-small h-fit", children: [
        /* @__PURE__ */ jsx(Icon, { name: "error-fill", className: "mr-1" }),
        errorOnSave
      ] }),
      !isWebRecorder && /* @__PURE__ */ jsx(UrlValidationUI, { urlValidation })
    ] }),
    isShow() && /* @__PURE__ */ jsxs(
      "div",
      {
        className: "flex-shrink-0 pt-3 inline-flex",
        onMouseEnter: () => onMouseOverStepValidate(),
        children: [
          /* @__PURE__ */ jsx(
            Button10,
            {
              variant: BUTTON_VARIANTS6.SECONDARY,
              size: BUTTON_SIZE6.SMALLEST,
              onClick: () => {
                delete window["nonIframeStep"];
                delete window["stepElementCloned"];
                setLastFocusedStepNumber(null);
                onCancel();
              },
              className: "px-2 !py-0 text-2xs font-medium !h-6 text-unique-800",
              disabled: isSaving,
              children: t("common.cancel")
            }
          ),
          /* @__PURE__ */ jsxs(
            Button10,
            {
              variant: BUTTON_VARIANTS6.PRIMARY,
              size: BUTTON_SIZE6.SMALLEST,
              className: "ml-2 inline-flex justify-center items-center !h-6 !py-0 text-2xs font-medium gap-1.5",
              onClick: () => {
                delete window["nonIframeStep"];
                delete window["stepElementCloned"];
                onSave();
              },
              disabled: Boolean(
                !isStepValueChanged || isStepInvalid || errorOnSave || isSaving
              ),
              children: [
                !isSaving && t(isEdit ? "step.update" : "step.create"),
                isSaving ? /* @__PURE__ */ jsx("span", { className: "w-6", children: /* @__PURE__ */ jsx(
                  Spinner,
                  {
                    size: 18,
                    thickness: 80,
                    speed: 140,
                    color: "#5E6C84",
                    secondaryColor: "rgba(172, 57, 57, 0)"
                  }
                ) }) : /* @__PURE__ */ jsx(
                  Icon,
                  {
                    name: "recorder-enter",
                    className: classNames82(
                      "text-2xs font-normal leading-4  text-accent-8",
                      {
                        "text-white": !isStepValueChanged || isStepInvalid || errorOnSave || isSaving
                      }
                    )
                  }
                )
              ]
            }
          )
        ]
      }
    )
  ] }) });
  const column1Props = {
    content: column1Content
  };
  const column2Props = { content: column2Content };
  const column3Props = {
    content: column3Content,
    className: classNames82({
      relative: shouldShowOverlay
    })
  };
  const mainContentProps = {
    content: mainContent,
    className: classNames82({
      relative: shouldShowOverlay
    })
  };
  const column4Props = {
    content: column4Content,
    className: classNames82({
      relative: shouldShowOverlay
    })
  };
  const mainContainerParentProps = isConditionalLoop ? {
    className: "border-b border-dashed border-slate-200 pb-[10px]"
  } : {};
  const containerProps = {
    className,
    dragHandleProps,
    containerRef: null,
    restContent
  };
  return /* @__PURE__ */ jsx(
    step_wrapper_default,
    {
      containerProps,
      column1Props,
      column2Props,
      column3Props,
      mainContentProps,
      column4Props,
      mainContainerParentProps
    }
  );
};
var non_executed_step_default = NonExecutedStep;
var RowActionsDropdown = ({
  options: options3,
  dropdownClassName = "",
  buttonClassName = "",
  onOpenChange
}) => {
  return /* @__PURE__ */ jsx(
    DropdownButton,
    {
      name: /* @__PURE__ */ jsx(
        Button,
        {
          type: "light",
          className: classNames82(
            "!p-0 !text-slate-600 !h-5 !w-5 items-center text-center flex justify-center hover:!border-secondary-300 ml-2",
            buttonClassName
          ),
          "aria-label": ARIA_LABELS.MORE_OPTIONS,
          children: /* @__PURE__ */ jsx(Icon, { name: "more-vertical", className: "text-base" })
        }
      ),
      fillWidth: false,
      variant: "no-bg",
      className: "!text-unique-600 !text-small !leading-4 !font-semibold",
      dropdownIconClassName: "!hidden",
      dropdownClassName: classNames82(
        "!p-1 border boder-secondary-300 !w-40",
        dropdownClassName
      ),
      wrapperClassName: "flex items-center gap-x-1.5 shrink-0",
      setIsOpen: onOpenChange,
      children: options3.map(
        ({
          name,
          icon,
          onClick,
          children,
          isDisabled = false,
          className = "",
          iconClassName = "",
          tooltipContent
        }) => {
          const dropdownItem = /* @__PURE__ */ jsxs(
            DropdownItem,
            {
              onClick: !isDisabled ? onClick : () => {
              },
              className: classNames82(
                "!h-7 rounded px-3 py-1.5 hover:!bg-secondary-50 !text-xs !leading-4 !font-normal flex items-center gap-x-2",
                className
              ),
              isDisabled,
              children: [
                /* @__PURE__ */ jsx(
                  Icon,
                  {
                    name: icon,
                    className: classNames82(
                      "text-base font-normal flex",
                      iconClassName
                    )
                  }
                ),
                name
              ]
            }
          );
          return children || (tooltipContent ? /* @__PURE__ */ jsx(ToolTip, { content: tooltipContent, children: dropdownItem }, name) : /* @__PURE__ */ jsx("div", { children: dropdownItem }, name));
        }
      )
    }
  );
};
var row_actions_dropdown_default = RowActionsDropdown;
var { Button: Button12, BUTTON_VARIANTS: BUTTON_VARIANTS7, BUTTON_SIZE: BUTTON_SIZE7 } = V2;
var Header = ({
  onClose,
  title,
  headerActions,
  icon
}) => {
  return /* @__PURE__ */ jsxs("div", { className: "h-10 py-2 px-3 bg-secondary-50 flex flex-row items-center my-[1px]", children: [
    /* @__PURE__ */ jsx(
      Button12,
      {
        onClick: onClose,
        iconLeft: "arrow-left-alt",
        variant: BUTTON_VARIANTS7.SECONDARY,
        size: BUTTON_SIZE7.SMALLEST,
        className: "h-6 w-6 bg-white rounded border-[0.5px] !border-secondary-100 shadow-subtle-sm",
        iconStyles: "w-[10px]",
        "aria-label": ARIA_LABELS.GO_BACK
      }
    ),
    /* @__PURE__ */ jsxs("span", { className: "flex flex-1 text-sm font-semibold text-secondary-700 truncate ml-2", children: [
      !!icon && /* @__PURE__ */ jsx(Icon, { name: icon, className: "mr-[6px]" }),
      /* @__PURE__ */ jsx("span", { className: "text-sm font-semibold truncate", children: title })
    ] }),
    /* @__PURE__ */ jsx("span", { className: "flex-shrink-0", children: headerActions })
  ] });
};
var header_default = Header;
var StepChip = ({
  content,
  onNestedStepCreate,
  step,
  callBack,
  onOpen
}) => {
  const ref = useRef(null);
  const { scrollToNextItem, nlActions } = useContext(StepContext);
  const isProcessingRef = useRef(false);
  const setStepData2 = useCallback(
    (res) => {
      if (res?.type === "else") {
        if (isProcessingRef.current) {
          return;
        }
        isProcessingRef.current = true;
      }
      if (isObjectBased(res.step) && res?.step?.isConditionalElseIf) {
        makeObjectIfStep(nlActions, res.step);
      }
      if (res?.type == "more") {
        onOpen(true);
      } else {
        onNestedStepCreate(res);
        if (res?.type === "else") {
          window.setTimeout(() => {
            isProcessingRef.current = false;
          }, 3e3);
        }
      }
      window.setTimeout(() => {
        scrollToNextItem();
      }, 100);
    },
    [onNestedStepCreate, onOpen, nlActions, scrollToNextItem]
  );
  useChipsClick(ref, callBack, step, setStepData2);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ref: (el) => ref.current = el,
      className: "hover:border-unique-800 border-secondary-100 border rounded flex justify-center items-center px-2 h-[22px] bg-white text-10px z-10 invisible group-hover:visible leading-none text-unique-800",
      children: [
        /* @__PURE__ */ jsx(Icon, { className: "mr-1 text-xs", name: "add" }),
        " ",
        content
      ]
    }
  );
};
var StepChips = ({
  step,
  isAbove,
  onNestedCreateStep,
  onOpen
}) => {
  const { steps } = useContext(StepContext);
  const { above, below } = useGetStepChipTypeBased(step, steps);
  const items = [];
  const contentList = isAbove ? above : below;
  for (let i = 0; i < contentList?.length; i++) {
    if (contentList[i]?.label) {
      items.push(
        /* @__PURE__ */ jsx(
          StepChip,
          {
            content: contentList[i].label,
            onNestedStepCreate: onNestedCreateStep,
            step,
            callBack: contentList[i].callBack,
            onOpen
          },
          i
        )
      );
    }
  }
  return /* @__PURE__ */ jsx(Fragment, { children: Boolean(items.length) && /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames82(
        "absolute flex items-center content-center justify-center w-full gap-9",
        { "-top-3": isAbove },
        { "bottom-[-12px]": !isAbove }
      ),
      children: items
    }
  ) });
};
var modifier6 = [
  {
    name: "flip",
    options: {
      padding: { bottom: 25 }
    }
  }
];
var StepTypeShortCodesDropDown = ({
  stepType,
  onChange,
  buttonRef,
  toggleDropdown,
  localStep,
  className = "",
  isBlockChild
}) => {
  const isSalesforceApplication = localStep.applicationType == ApplicationType.Salesforce;
  const isWindowsAdvanced = isObjectBased(localStep);
  const { isRecorderView, isWebRecorder, hasFeatureValue: hasFeatureValue2 } = useContext(StepContext);
  const { t } = useTranslation();
  const [dropdownRef, setDropdownRef] = useState(null);
  const handleItemClick = useCallback(
    (stepType2) => {
      onChange(stepType2);
      toggleDropdown();
    },
    [onChange]
  );
  const { styles, attributes } = usePopper(buttonRef?.current, dropdownRef, {
    placement: "bottom-start",
    strategy: "fixed",
    modifiers: modifier6
  });
  return createPortal(
    /* @__PURE__ */ jsxs(
      Dropdown,
      {
        className: classNames82(
          "z-30 py-1 h-[366px] overflow-y-auto",
          { "w-[250px]": !isWebRecorder, "w-[230px]": isWebRecorder },
          className
        ),
        toggleDropdown,
        setRef: setDropdownRef,
        style: {
          ...styles.popper,
          overflowY: "auto"
        },
        attributes: attributes.popper,
        isAnimationEnabled: false,
        buttonRef,
        children: [
          !isWindowsAdvanced && /* @__PURE__ */ jsx(
            StepTypeShortCodesDropDownItem,
            {
              name: t("step.switch.nlp"),
              command: "/nlp",
              icon: "step-type-switch",
              isSelected: localStep.uiMap?.type == StepTypeUI.NLP,
              onClick: () => handleItemClick(StepTypeUI.NLP)
            }
          ),
          isWindowsAdvanced && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(
              StepTypeShortCodesDropDownItem,
              {
                name: t("step.switch.elements"),
                command: "/elements",
                icon: "category",
                isSelected: localStep.uiMap?.type == StepTypeUI.ELEMENT,
                onClick: () => handleItemClick(StepTypeUI.ELEMENT)
              }
            ),
            /* @__PURE__ */ jsx(
              StepTypeShortCodesDropDownItem,
              {
                name: t("step.switch.actions"),
                command: "/actions",
                icon: "ads-click",
                isSelected: localStep.uiMap?.type == StepTypeUI.ACTION,
                onClick: () => handleItemClick(StepTypeUI.ACTION)
              }
            )
          ] }),
          /* @__PURE__ */ jsx(
            StepTypeShortCodesDropDownItem,
            {
              name: t("step.switch.group"),
              command: "/stepgroup",
              icon: "ballot",
              isSelected: localStep.uiMap?.type == StepTypeUI.STEP_GROUP,
              onClick: () => handleItemClick(StepTypeUI.STEP_GROUP)
            }
          ),
          !isBlockChild && /* @__PURE__ */ jsx(
            StepTypeShortCodesDropDownItem,
            {
              name: t("step.switch.block"),
              command: "/blocks",
              icon: "view-agenda",
              isSelected: localStep.uiMap?.type == StepTypeUI.BLOCK,
              onClick: () => handleItemClick(StepTypeUI.BLOCK)
            }
          ),
          /* @__PURE__ */ jsx(
            StepTypeShortCodesDropDownItem,
            {
              name: t("step.switch.for"),
              command: "/forloop",
              icon: "for-loop",
              isSelected: localStep.uiMap?.type == StepTypeUI.FOR_LOOP,
              onClick: () => handleItemClick(StepTypeUI.FOR_LOOP)
            }
          ),
          /* @__PURE__ */ jsx(
            StepTypeShortCodesDropDownItem,
            {
              name: t("step.switch.while"),
              command: "/whileloop",
              icon: "while-loop",
              isSelected: localStep.uiMap?.type == StepTypeUI.WHILE_LOOP,
              onClick: () => handleItemClick(StepTypeUI.WHILE_LOOP)
            }
          ),
          isSalesforceApplication && /* @__PURE__ */ jsx(
            StepTypeShortCodesDropDownItem,
            {
              name: t("step.switch.soql"),
              command: "/soql",
              icon: "soql",
              isSelected: localStep.uiMap?.type == StepTypeUI.SOQL,
              onClick: () => handleItemClick(StepTypeUI.SOQL)
            }
          ),
          Boolean(hasFeatureValue2?.("CUSTOM_FUNCTIONS_LEAP_UI")) && /* @__PURE__ */ jsx(
            StepTypeShortCodesDropDownItem,
            {
              name: t("step.switch.function"),
              command: "/function",
              icon: "extension-off",
              isSelected: localStep.uiMap?.type == StepTypeUI.CUSTOM_FUNCTION,
              onClick: () => handleItemClick(StepTypeUI.CUSTOM_FUNCTION)
            }
          ),
          /* @__PURE__ */ jsx(
            StepTypeShortCodesDropDownItem,
            {
              name: t("step.switch.rest"),
              command: "/api",
              icon: "rest-api",
              isDisabled: isRecorderView,
              isSelected: localStep.uiMap?.type == StepTypeUI.REST_API,
              onClick: () => handleItemClick(StepTypeUI.REST_API)
            }
          ),
          /* @__PURE__ */ jsx("div", { className: "text-2xs text-secondary-400 text-center py-2 relative flex items-center", children: /* @__PURE__ */ jsx("div", { className: "bg-white z-10 px-2 capitalize", children: t("step.switch.cond.types") }) }),
          /* @__PURE__ */ jsx(
            StepTypeShortCodesDropDownItem,
            {
              name: t("step.switch.if.nlp"),
              command: "/if",
              icon: "if-condition",
              isSelected: localStep.uiMap?.type == StepTypeUI.IF_CONDITION,
              onClick: () => handleItemClick(StepTypeUI.IF_CONDITION)
            }
          ),
          /* @__PURE__ */ jsx(
            StepTypeShortCodesDropDownItem,
            {
              name: t("step.switch.if.group"),
              command: "/if stepgroup",
              icon: "if-condition",
              isSelected: localStep.uiMap?.type == StepTypeUI.IF_STEP_GROUP,
              onClick: () => handleItemClick(StepTypeUI.IF_STEP_GROUP)
            }
          ),
          Boolean(hasFeatureValue2?.("CUSTOM_FUNCTIONS_LEAP_UI")) && /* @__PURE__ */ jsx(
            StepTypeShortCodesDropDownItem,
            {
              name: t("step.switch.if.function"),
              command: "/if function",
              icon: "if-condition",
              isSelected: localStep.uiMap?.type == StepTypeUI.IF_CUSTOM_FUNCTION,
              onClick: () => handleItemClick(StepTypeUI.IF_CUSTOM_FUNCTION)
            }
          ),
          /* @__PURE__ */ jsx(
            StepTypeShortCodesDropDownItem,
            {
              name: t("step.switch.if.rest"),
              command: "/if api",
              icon: "if-condition",
              isSelected: localStep.uiMap.type == StepTypeUI.IF_REST_API,
              onClick: () => handleItemClick(StepTypeUI.IF_REST_API),
              isDisabled: isRecorderView
            }
          )
        ]
      },
      "drop-down"
    ),
    document.body
  );
};
var StepTypeSwitch = ({
  isVisible,
  handleTypeSwitch,
  iconName,
  localStep
}) => {
  const buttonRef = useRef(null);
  const [showDropdown, toggleDropdown] = useState(false);
  const { updateStepsInfo } = useContext(StepContext);
  const handleClick = useCallback(() => {
    toggleDropdown(!showDropdown);
  }, [toggleDropdown, showDropdown]);
  const setRefference = useCallback(
    (el) => {
      buttonRef.current = el;
    },
    [buttonRef]
  );
  useEffect(() => {
    if (!isVisible) toggleDropdown(false);
  }, [isVisible, toggleDropdown]);
  useEffect(() => {
    updateStepsInfo("isStepTypeSwitchOpened", showDropdown);
  }, [showDropdown]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames82("relative overflow-hidden flex items-center", {
        invisible: !isVisible
      }),
      children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            ref: setRefference,
            onClick: handleClick,
            className: "inline-flex items-center justify-center w-7 h-7 text-xl rounded text-unique-900 cursor-pointer ml-3 bg-button-pressed border border-primary-400",
            children: iconName
          }
        ),
        showDropdown && /* @__PURE__ */ jsx(
          StepTypeShortCodesDropDown,
          {
            toggleDropdown: () => toggleDropdown(false),
            buttonRef,
            stepType: localStep?.type,
            onChange: handleTypeSwitch,
            isConditionalStep: Boolean(isIfConditionalStep(localStep)),
            localStep,
            isBlockChild: Boolean(localStep.blockParentId)
          }
        )
      ]
    }
  );
};
var DeleteStepButton = ({
  onRemoveStep,
  localStep,
  isFocused,
  children
}) => {
  const { t } = useTranslation();
  const handleDelete = useCallback(() => {
    if (!localStep || typeof localStep.id !== "number") {
      return;
    }
    onRemoveStep(localStep);
  }, [localStep, onRemoveStep]);
  const tooltipContent = localStep.stepType === TestStepType.BLOCK ? t("step.delete.block") : t("step.delete");
  return /* @__PURE__ */ jsx(Fragment, { children: children ? React5__default.cloneElement(children, {
    onClick: handleDelete
  }) : /* @__PURE__ */ jsx(
    ToolTip,
    {
      content: tooltipContent,
      className: "flex items-center invisible group-hover:visible",
      children: /* @__PURE__ */ jsx(
        Icon,
        {
          onClickCapture: handleDelete,
          name: "delete",
          className: classNames82(
            "text-unique-800 rounded p-0.5 border border-transparent ml-3 cursor-pointer",
            {
              "hover:bg-primary-100": isFocused,
              "hover:border-primary-200": !isFocused
            }
          )
        }
      )
    }
  ) });
};
var ApiTestDataMapping = {
  raw: APIStepFormKeyType.RAW,
  parameter: APIStepFormKeyType.PARAMETER,
  runtime: APIStepFormKeyType.RUNTIME_VARIABLE,
  global: APIStepFormKeyType.ENVIRONMENT_VARIABLE,
  random: APIStepFormKeyType.RANDOM,
  function: APIStepFormKeyType.DATA_GENERATOR
};
var modifyTestDataType = (salesforceAPIStepDetails) => {
  const connectionType = salesforceAPIStepDetails?.connectionType;
  const recordIdType = salesforceAPIStepDetails?.recordIdType;
  salesforceAPIStepDetails.connectionType = ApiTestDataMapping[connectionType?.toLowerCase()] ?? connectionType;
  salesforceAPIStepDetails.recordIdType = ApiTestDataMapping[recordIdType?.toLowerCase()] ?? recordIdType;
  return salesforceAPIStepDetails;
};
var handleWhileStepSwitch = (localStep, updateLocalStep) => {
  const whileStep = new TestStep().deserialize(localStep);
  whileStep.conditionType = TestStepConditionType.LOOP_WHILE;
  whileStep.type = TestStepType.NLP_TEXT;
  updateLocalStep(whileStep);
};
var handleActionStepSwitch = (stepContext2, localStep, updateLocalStep, prevUiType) => {
  const { openActionsListDrawer, nlActions, activeStepIdx } = stepContext2;
  const actionStep = new TestStep().deserialize(localStep);
  openActionsListDrawer().then((response) => {
    if (response?.action == "SELECTED" && response?.details?.action) {
      const template = nlActions.find(
        (nlpTemplate) => nlpTemplate.id == response?.details?.templateId
      );
      const isObjectType = template?.isAddon && localStep.applicationType === ApplicationType.WINDOWS_ADVANCED;
      if (isObjectType) {
        actionStep.kibbutzPluginNlpId = template.id;
        actionStep.templateId = null;
        const nlpData = new KibbutzNLPDataModel();
        nlpData.testData = /* @__PURE__ */ new Map();
        nlpData.uiIdentifiers = /* @__PURE__ */ new Map();
        nlpData.environmentData = /* @__PURE__ */ new Map();
        nlpData.testDataProfile = /* @__PURE__ */ new Map();
        nlpData.testDataSet = /* @__PURE__ */ new Map();
        if (actionStep.uiMap.elementId && actionStep.uiMap.element) {
          nlpData.uiIdentifiers.set("ELEMENT_NAME", {
            id: actionStep.uiMap.elementId,
            name: actionStep.uiMap.element
          });
        }
        actionStep.kibbutzPluginNlpData = nlpData;
      } else {
        actionStep.templateId = response?.details?.templateId;
        actionStep.kibbutzPluginNlpId = null;
        actionStep.kibbutzPluginNlpData = null;
      }
      const dataBlocks = isObjectType ? getStepKibbutzBlocks(actionStep, template) : getStepNlpBlocks(
        actionStep,
        template,
        activeStepIdx == actionStep.id
      )?.filter((block) => block.type != "readonly_text" /* readonly_text */);
      if (!isObjectType) {
        actionStep.uiMap.objectBlocks = [
          getReadOnlyActionBlock({
            displayName: response?.details?.action || "",
            templateId: template.id
          }),
          ...dataBlocks
        ];
      }
      actionStep.uiMap.templateId = isObjectType ? null : response?.details?.templateId;
      updateLocalStep(actionStep);
    } else {
      actionStep.uiMap.type = prevUiType;
      updateLocalStep(actionStep);
    }
  });
};
var handleElementStepSwitch = async (stepContext2, localStep, updateLocalStep, prevUiType) => {
  const { openElementListDrawer } = stepContext2;
  let actionStep = new TestStep().deserialize(localStep);
  openElementListDrawer({}).then((response) => {
    if (response?.details?.name) {
      actionStep = constructElementStep({
        step: actionStep,
        elementDetails: response?.details
      });
      updateLocalStep(actionStep);
    } else {
      actionStep.uiMap.type = prevUiType;
      updateLocalStep(actionStep);
    }
  });
};
var handleObjectIfConditionStepSwitch = (stepContext2, localStep, updateLocalStep) => {
  const { nlActions } = stepContext2;
  const blockStep = new TestStep().deserialize(localStep);
  makeObjectIfStep(nlActions, blockStep);
  updateLocalStep(blockStep);
};
var handleApiStepSwitch = (localStep, updateLocalStep, stepContext2) => {
  const restStep = new TestStep().deserialize(localStep);
  restStep.type = TestStepType.API_STEP;
  restStep.action = "";
  restStep.priority = TestStepPriority.MAJOR;
  updateLocalStep(restStep);
  stepContext2.openRestStep(restStep);
};
var handleSOQLStepSwitch = (localStep, updateLocalStep, stepContext2) => {
  const soqlStep = new TestStep().deserialize(localStep);
  soqlStep.type = TestStepType.SOQL;
  soqlStep.action = "";
  soqlStep.priority = TestStepPriority.MAJOR;
  updateLocalStep(soqlStep);
  stepContext2.openSOQLStep(soqlStep);
};
var handleForLoopSwitch = (localStep, updateLocalStep, isEmptyTestdata, t) => {
  const forLoopStep = new TestStep().deserialize(localStep);
  forLoopStep.forLoopCondition = new ForLoopCondition();
  forLoopStep.conditionType = TestStepConditionType.LOOP_FOR;
  forLoopStep.type = TestStepType.NLP_TEXT;
  const blocks = [
    {
      type: isEmptyTestdata ? "readonly_text" /* readonly_text */ : "editable_text" /* editable_text */,
      value: isEmptyTestdata ? t("step.for_loop.no_data_profile") : "",
      uuid: null
    }
  ];
  updateLocalStep(bindBlockWithTestStep(blocks, forLoopStep));
};
var handleStepGroupStepSwitch = async (localStep, updateLocalStep, stepContext2, updateWatchFocusOut) => {
  updateWatchFocusOut(false);
  const previousStepType = localStep.type;
  const previousStepTypeUI = localStep.uiMap?.type;
  localStep.type = TestStepType.STEP_GROUP;
  updateLocalStep(new TestStep().deserialize(localStep));
  const { openStepGroupsListDrawer, stepToggleUtils } = stepContext2;
  const { action, details } = await openStepGroupsListDrawer();
  if (action == "SELECTED") {
    const stepGroup = new TestStep().deserialize(localStep);
    stepGroup.uiMap.type = StepTypeUI.STEP_GROUP;
    stepGroup.stepGroupId = details.id;
    stepGroup.action = details.name;
    stepToggleUtils.toggleStepExpand({
      step: stepGroup,
      isExpand: false,
      setIsGroupExpanding: false
    });
    updateLocalStep(stepGroup);
    updateWatchFocusOut(true);
  } else {
    localStep.type = previousStepType;
    localStep.uiMap.type = previousStepTypeUI;
    updateLocalStep(new TestStep().deserialize(localStep));
  }
};
var handleBlockStepSwitch = (localStep, updateLocalStep) => {
  const blockStep = new TestStep().deserialize(localStep);
  blockStep.priority = TestStepPriority.MINOR;
  blockStep.type = TestStepType.BLOCK;
  blockStep.action = "";
  updateLocalStep(blockStep);
};
var handleNplStepSwitch = (localStep, updateLocalStep) => {
  const blockStep = new TestStep().deserialize(localStep);
  blockStep.type = TestStepType.NLP_TEXT;
  blockStep.action = "";
  updateLocalStep(blockStep);
};
var handleCunstomFunctionStepSwitch = (localStep, updateLocalStep) => {
  const blockStep = new TestStep().deserialize(localStep);
  blockStep.type = TestStepType.CUSTOM_FUNCTION;
  blockStep.action = "";
  updateLocalStep(blockStep);
};
var useStepFocused = (ref, isEdit, isDisableFocus, isViewOnly) => {
  const [isFocused, _updateFocused] = useState(!isEdit);
  const updateFocused = useMemo(
    () => throttle(
      (value) => {
        _updateFocused(value);
      },
      500,
      { leading: true, trailing: false }
    ),
    [_updateFocused]
  );
  const handler = useCallback(() => {
    if (!isDisableFocus) {
      updateFocused(true);
    }
  }, [isDisableFocus, updateFocused]);
  useEffect(() => {
    if (!isViewOnly) {
      ref.current?.addEventListener("click", handler);
      return () => ref.current?.removeEventListener("click", handler);
    }
  }, [ref, handler]);
  return [isFocused, updateFocused];
};
var useStepCancel = (updateFocused, step, updateLocalStep, updateUUID, isEdit, removeStep, measure, isMounted) => {
  return useCallback(() => {
    updateFocused(false);
    updateLocalStep(new TestStep().deserialize(step));
    updateUUID(generateUniqueId());
    setTimeout(() => isMounted?.current && measure?.(), 300);
    if (!isEdit) removeStep(step, false);
    setTimeout(() => updateFocused(false), 500);
  }, [
    updateFocused,
    updateLocalStep,
    step,
    updateUUID,
    measure,
    isEdit,
    removeStep,
    isMounted?.current
  ]);
};
var validateBlockName = (blockName, t) => {
  let errorMessage = "";
  if (blockName.trim().length < 4) {
    errorMessage = t("common.form.validation.minlength", {
      fieldName: "Block Name",
      minLength: "4"
    });
  } else if (blockName.trim().length > 250) {
    errorMessage = t("common.form.validation.maxlength", {
      fieldName: "Block Name",
      maxLength: "250"
    });
  }
  return errorMessage;
};
var useStepSave = (localStep, updateUUID, createStep2, isEdit, updateStep3, updateFocused, template, updateChildStep, updateLocalStep, currentStep, measure, isRecorderView, isMounted) => {
  const [errorOnSave, updateError] = useState(false);
  const { t } = useTranslation();
  const [urlValidation, updateUrlvalidation] = useState({
    message: "",
    state: ""
  });
  const cachedUrls = useRef({});
  const isStepInvalid = useIsStepInvalid(template, localStep);
  const {
    onAddStep,
    scrollToNextItem,
    validateUrl: validateUrl2,
    testCase,
    stepToggleUtils
  } = useContext(StepContext);
  const [isLoading, setIsLoading] = useState(false);
  const onSave = useCallback(
    (passedStep = null) => {
      if (isStepInvalid) {
        updateError(isStepInvalid);
        return;
      }
      if (localStep?.isBlock) {
        const errorMessage = validateBlockName(localStep?.action, t);
        if (errorMessage) {
          toastify(errorMessage, {
            type: "error"
          });
          return;
        }
      }
      setIsLoading(true);
      let step = passedStep || localStep;
      step = useOverrideData(step, testCase?.id);
      step.testStepElements = step?.testStepElements?.filter(
        (item) => !!item?.elementId || !!item?.id
      ) || [];
      step.uiIdentifierOverRiddenMappings = step?.uiIdentifierOverRiddenMappings?.filter(
        (item) => !!item?.elementId
      ) || [];
      if (!step.uiIdentifierOverRiddenMappings) {
        delete step.uiIdentifierOverRiddenMappings;
      }
      const isMismatch = localStep?.testStepElements?.some((element) => {
        return !currentStep?.testStepElements?.some((currentElement) => {
          return element.name === currentElement.name;
        });
      });
      if (isEdit) {
        updateStep3(
          step,
          (updatedStep) => {
            updateFocused(false);
            setIsLoading(false);
            updateLocalStep(updatedStep);
            setTimeout(
              () => {
                updateFocused(false);
                if (measure && isMounted?.current) {
                  measure();
                }
              },
              isRecorderView ? 750 : 250
            );
            if (step?.isStepGroupChild) {
              if (updatedStep?.dataMapError) {
                step.dataMapError = updatedStep.dataMapError;
              }
              updateChildStep(step);
              stepToggleUtils?.updateExpandedData(
                step?.hostTestCaseStepId,
                step
              );
            } else {
              updateChildStep(null);
            }
          },
          isMismatch
        );
      } else {
        createStep2(step, false, () => {
          if (step.isAddStep) {
            window.setTimeout(
              () => {
                document.querySelector(".add-step-action-btn")?.click?.();
                if (measure && isMounted?.current) {
                  measure();
                }
              },
              isRecorderView ? 1e3 : 500
            );
          }
          if (step.isConditionalStep || step.isBlock) {
            if (measure && isMounted?.current) {
              window.setTimeout(
                () => {
                  measure();
                },
                isRecorderView ? 1e3 : 500
              );
            }
            return;
          }
          setTimeout(() => {
            const newStep = isConditionalStep(step) || isBlock(step) ? addInside(step)?.step : addBelowStep(step)?.step;
            newStep.stepOrder = (newStep?.stepOrder || 1e3) + 1e3;
            if (isConditionalStep(step) || isBlock(step))
              onAddStep(newStep, null, null, true);
          }, 1e3);
          setTimeout(
            () => {
              scrollToNextItem();
              if (measure && isMounted?.current) {
                measure();
              }
            },
            isRecorderView ? 700 : 200
          );
          updateFocused(false);
          updateUUID(generateUniqueId());
        });
      }
    },
    [
      isStepInvalid,
      localStep,
      isEdit,
      testCase?.id,
      updateStep3,
      createStep2,
      t,
      currentStep?.testStepElements,
      updateFocused,
      updateChildStep,
      stepToggleUtils,
      updateUUID,
      onAddStep,
      scrollToNextItem,
      measure
    ]
  );
  const onMouseOverStepValidate = useCallback(async () => {
    const NAVIGATE_NLPS = [1044, 10116, 60338];
    const type = localStep.stepDataList?.["testData"]?.type;
    const url = localStep.stepDataList?.["testData"]?.value;
    if (!NAVIGATE_NLPS.includes(Number(localStep.templateId)) || type !== TestDataType.raw)
      return;
    updateUrlvalidation({
      message: t("nlp.step.message.localUrl.processing", {
        URL: url,
        interpolation: { escapeValue: true }
      }),
      state: "loading"
    });
    const response = cachedUrls.current[url] || await validateUrl2({
      testCaseId: testCase?.id,
      url
    });
    const isInValidUrl = (response || []).includes(url);
    updateUrlvalidation({
      message: t(
        `nlp.step.message.localUrl.${isInValidUrl ? "failure" : "success"}`,
        {
          URL: url,
          LINK: "https://testsigma.com/docs/troubleshooting/web-apps/url-not-accessible/",
          interpolation: { escapeValue: true }
        }
      ),
      state: isInValidUrl ? "invalid" : "valid"
    });
    cachedUrls.current[url] = response;
  }, [localStep, cachedUrls]);
  useEffect(() => {
    if (errorOnSave && !isStepInvalid) updateError(isStepInvalid);
  }, [isStepInvalid, errorOnSave]);
  return [
    onSave,
    errorOnSave,
    isLoading,
    onMouseOverStepValidate,
    urlValidation
  ];
};
var useOverrideData = (step, testCaseId) => {
  step = useElmentOverride(step, testCaseId);
  step = useTestdataOverride(step);
  step = useForloopOverride(step, testCaseId);
  step = useSalesForceAPIOverride(step);
  return step;
};
var findOverrideDataIndex = (overrideMappings, key) => overrideMappings.findIndex((data) => data.referenceKey === key);
var useElmentOverride = (step, testCaseId) => {
  if (step.elementOverride?.length) {
    step.uiIdentifierOverRiddenMappings = step.uiIdentifierOverRiddenMappings || [];
    step.elementOverride.forEach((data) => {
      const overrideData = new ElementIdentifierOverridden();
      overrideData.elementName = data["name"];
      overrideData.referenceKey = data["referenceKey"];
      overrideData.elementId = data["id"];
      overrideData.stepGroupId = step.testCaseId;
      overrideData.testCaseId = testCaseId ?? parseInt(step.testCaseIdValue);
      overrideData.testCaseStepId = step?.parentStepGroupIds?.[0];
      overrideData.stepGroupStepId = step.id;
      const index = findOverrideDataIndex(
        step.uiIdentifierOverRiddenMappings,
        overrideData.referenceKey
      );
      if (index > -1) step.uiIdentifierOverRiddenMappings[index] = overrideData;
      else step.uiIdentifierOverRiddenMappings.push(overrideData);
    });
  }
  return step;
};
var useSalesForceAPIOverride = (step) => {
  if (step.templateId == 80064) {
    const salesforceConnection = step?.stepDataList?.find(
      (item) => item.key === "salesforceConnection"
    );
    const recordId = step?.stepDataList?.find(
      (item) => item.key === "testData"
    );
    step.apiStep.salesforceAPIStepDetails.connectionName;
    if (salesforceConnection.value != step.apiStep.salesforceAPIStepDetails.connectionName) {
      step.apiStep.salesforceAPIStepDetails.connectionName = salesforceConnection.value;
      step.apiStep.salesforceAPIStepDetails.connectionType = salesforceConnection.type?.toUpperCase() ?? "RAW";
    }
    if (recordId.value != step.apiStep.salesforceAPIStepDetails.recordId) {
      step.apiStep.salesforceAPIStepDetails.recordId = recordId.value;
      step.apiStep.salesforceAPIStepDetails.recordIdType = recordId.type?.toUpperCase() ?? "RAW";
    }
    step.apiStep.salesforceAPIStepDetails = modifyTestDataType(
      step?.apiStep?.salesforceAPIStepDetails
    );
  }
  return step;
};
var useTestdataOverride = (step, testCaseId) => {
  if (step.testdataOverride?.length) {
    step.testStepDataOverRiddenMappings = step.testStepDataOverRiddenMappings || [];
    step.testdataOverride.forEach((data) => {
      const overrideData = new TestStepDataOverRiddenMapping();
      overrideData.parameterValue = data["parameterValue"];
      overrideData.referenceKey = data["referenceKey"];
      overrideData.parameterType = data["parameterType"];
      overrideData.testCaseId = parseInt(step.testCaseIdValue) || step.testCaseId;
      overrideData.overrideType = data["overrideType"];
      if (data["overrideType"]?.toLowerCase()?.includes("step_group")) {
        overrideData.testCaseStepId = step?.parentStepGroupIds?.[0];
        overrideData.stepGroupId = step.testCaseId;
        overrideData.stepGroupStepId = step.id;
      } else {
        overrideData.testCaseStepId = step?.id;
        overrideData.testCaseId = step?.testCaseId;
      }
      if (data["uploadId"]) {
        overrideData.uploadId = data["uploadId"];
      }
      if (data["functionId"]) {
        overrideData.functionId = data["functionId"];
      }
      if (data["dataGeneratorId"]) {
        overrideData.dataGeneratorId = data["dataGeneratorId"];
      }
      overrideData.dataGeneratorArguments = data["dataGeneratorArguments"];
      if (data["testDataProfileStepId"]) {
        overrideData.testDataProfileStepId = data["testDataProfileStepId"];
      }
      const index = findOverrideDataIndex(
        step.testStepDataOverRiddenMappings,
        overrideData.referenceKey
      );
      if (index > -1) step.testStepDataOverRiddenMappings[index] = overrideData;
      else step.testStepDataOverRiddenMappings.push(overrideData);
    });
  }
  return step;
};
var useForloopOverride = (step, testCaseId) => {
  if (step.forloopOverride?.length) {
    step.forloopOverride.forEach((data) => {
      const overrideData = new ForLoopOverRidden();
      overrideData.stepGroupId = step.testCaseId;
      overrideData.testCaseId = testCaseId ?? parseInt(step.testCaseIdValue);
      overrideData.testCaseStepId = step?.parentStepGroupIds?.[0];
      overrideData.stepGroupStepId = step.id;
      overrideData.testDataId = data["testDataId"];
      overrideData.loopStart = data["loopStart"];
      overrideData.loopEnd = data["loopEnd"];
      step.forLoopOverRiddenMapping = overrideData;
    });
  }
  return step;
};
var updateOrPushTestData = (stepDataList, key, value) => {
  const existingIndex = stepDataList.findIndex((item) => item.key === key);
  if (existingIndex > -1) {
    stepDataList[existingIndex].value = value;
  } else {
    const testDataMapValue = createTestDataMapValue(value, key);
    stepDataList.push(testDataMapValue);
  }
};
var useSetAppUploadData = (localStep, blocks) => {
  blocks.forEach((block) => {
    if (!localStep.stepDataList) {
      localStep.stepDataList = [];
    }
    if (block.more_details?.appUploadId) {
      updateOrPushTestData(
        localStep.stepDataList,
        "appUploadId",
        block.more_details?.appUploadId
      );
    }
    if (block.more_details?.appPath) {
      updateOrPushTestData(
        localStep.stepDataList,
        "appPath",
        block.more_details?.appPath
      );
    }
    if (block.more_details?.sessionValue) {
      updateOrPushTestData(
        localStep.stepDataList,
        "sessionValue",
        block?.value
      );
    }
  });
  return localStep;
};
var useStepNlpValueChange = (localStep, updateLocalStep, step, setLocalBlocks, testCase) => useCallback(
  (blocks) => {
    setLocalBlocks(blocks);
    let localStepClone = cloneDeep$1(localStep);
    localStepClone = useSetDataGeneratorValue(blocks, localStepClone);
    localStepClone = useSetOverrideData(
      localStepClone,
      step,
      blocks,
      testCase
    );
    localStepClone = useSetAppUploadData(localStepClone, blocks);
    const updatedStep = bindBlockWithTestStep(blocks, localStepClone);
    if (localStep?.uiMap?.objectBlocks?.length) {
      updatedStep.uiMap.objectBlocks = blocks;
    }
    updateLocalStep(updatedStep);
  },
  [localStep, updateLocalStep, step, testCase]
);
var handleStepData = (stepDataList, testDataValue, referenceKey) => {
  const itemFoundIndex = referenceKey ? findDataIndex(stepDataList, referenceKey) : -1;
  if (itemFoundIndex > -1) {
    stepDataList[itemFoundIndex] = testDataValue;
  } else {
    stepDataList.push(testDataValue);
  }
};
var handleKibbutzData2 = (localStep, referenceKey, testDataValue) => {
  if (referenceKey) {
    localStep.kibbutzPluginNlpData.testData[referenceKey] = testDataValue;
  }
};
var useSetDataGeneratorValue = (blocks, localStep) => {
  if (!blocks || localStep?.isStepGroupSpotEdit) return localStep;
  let hasMailBoxFunction = false;
  let hasPhoneNumberFunction = false;
  blocks.forEach((block) => {
    if (block?.type !== TestDataType.function) return;
    if (block.value?.includes("MailBoxFunctions")) {
      hasMailBoxFunction = true;
    }
    if (block.value?.includes("PhoneNumberFunctions")) {
      hasPhoneNumberFunction = true;
    }
    const {
      more_details: {
        arguments: blockArgs,
        testDataFunctionId,
        isKibbutzFunction,
        testdataOverride
      } = {}
    } = block || {};
    const referenceKey = testdataOverride?.referenceKey;
    if (!referenceKey) {
      return;
    }
    if (!isKibbutzFunction) {
      blockArgs?.forEach((data) => {
        data.argumentValueType = "RAW";
      });
    }
    const argumentsData = {
      value: block.value,
      testDataFunctionId,
      arguments: blockArgs,
      isKibbutzFunction
    };
    const testDataValue = createTestDataMapValue(
      block.value,
      referenceKey,
      "function" /* function */
    );
    localStep.stepDataList = localStep.stepDataList || [];
    const itemFoundIndex = findDataIndex(localStep.stepDataList, referenceKey);
    if (itemFoundIndex > -1) {
      testDataValue.id = localStep.stepDataList[itemFoundIndex].id;
    }
    if (localStep.isKibbutz) {
      handleKibbutzData2(localStep, referenceKey, testDataValue);
    } else {
      handleStepData(localStep.stepDataList, testDataValue, referenceKey);
    }
    if (testdataOverride?.mailBoxId) {
      localStep.mailBoxId = testdataOverride.mailBoxId;
    }
    if (testdataOverride?.phoneNumberId) {
      localStep.phoneNumberId = testdataOverride.phoneNumberId;
    }
    if (referenceKey) {
      const itemFoundIndex2 = findDataIndex(
        localStep.stepDataList,
        referenceKey
      );
      if (itemFoundIndex2 > -1) {
        localStep.stepDataList[itemFoundIndex2].testDataFunction = new TestStepTestDataFunction();
        localStep.stepDataList[itemFoundIndex2].testDataFunction.arguments = argumentsData;
      }
    }
  });
  if (!hasMailBoxFunction) {
    localStep.mailBoxId = null;
  }
  if (!hasPhoneNumberFunction) {
    localStep.phoneNumberId = null;
  }
  return localStep;
};
var useSetOverrideData = (localStep, step, blocks, testCase) => {
  localStep = useSetTestdataOverrideData(localStep, step, blocks, testCase);
  localStep = useElementChangedOrNot(localStep, step, blocks);
  localStep = useForloopOverrideData(localStep, step, blocks);
  return localStep;
};
var useSetTestdataOverrideData = (localStep, step, blocks, testCase) => {
  localStep.testdataOverride = localStep.testdataOverride || [];
  blocks.forEach((block) => {
    if (!block?.more_details?.isKibbutzFunction && !block?.more_details?.isKibbutzFn) {
      const blockArgs = block?.more_details?.arguments || [];
      blockArgs?.forEach((data) => {
        data.argumentValueType = "RAW";
      });
    }
    const dataProfileIndex = step?.mapperData?.findIndex(
      (item) => item["stepNumber"] == block?.more_details?.testdataOverride?.tdpDetails?.stepNumber
    );
    if ((dataProfileIndex > -1 && dataProfileIndex != step.mapperData.length - 1 || step.isStepGroupChild) && block?.more_details?.testdataOverride && Object.keys(block.more_details.testdataOverride).length > 0) {
      const data = block?.more_details?.testdataOverride;
      if (dataProfileIndex > -1) {
        data.testDataProfileStepId = step.mapperData[dataProfileIndex]["lastLoopStepId"];
        data.overrideType = testCase?.["isStepGroup"] || step.isStepGroupChild ? step.mapperData[dataProfileIndex]["stepScopeIsTestCase"] ? TestDataOverRideType.STEP_GROUP_STEP_OVERRIDES_TEST_CASE_PARENT_STEP_TDP : TestDataOverRideType.STEP_GROUP_STEP_OVERRIDES_STEP_GROUP_PARENT_STEP_TDP : TestDataOverRideType.STEP_OVERRIDES_PARENT_STEP_TDP;
      } else if (step.isStepGroupChild) {
        data.overrideType = block.type == TestDataType.parameter && block?.more_details?.testdataOverride?.tdpDetails?.id ? TestDataOverRideType.STEP_GROUP_STEP_OVERRIDES_TEST_CASE_TDP : getTestDataOverrideType(block?.type) || TestDataOverRideType.STEP_GROUP_STEP_OVERRIDES_STEP_GROUP_PARENT_STEP_TDP;
      }
      localStep = addOrUpdateDataOverride(localStep, block.uuid, data);
      if (block?.uuid == "testDataProfile") {
        localStep = addOrUpdateDataOverride(localStep, "testDataProfileId", {
          overrideType: data.overrideType,
          parameterType: TestDataType.raw,
          referenceKey: "testDataProfileId",
          parameterValue: block.more_details.profileId
        });
      }
    } else if (block?.more_details?.testdataOverride?.tdpDetails && !block?.more_details?.testdataOverride?.tdpDetails?.stepNumber && (step?.isInsideForLoop || localStep?.isInsideForLoop)) {
      const data = block?.more_details?.testdataOverride;
      data.overrideType = testCase?.["isStepGroup"] ? TestDataOverRideType.STEP_GROUP_STEP_OVERRIDES_STEP_GROUP_TDP : TestDataOverRideType.STEP_OVERRIDES_TEST_CASE_TDP;
      localStep = addOrUpdateDataOverride(localStep, block.uuid, data);
    }
  });
  if (localStep.testdataOverride.length === 0)
    delete localStep.testdataOverride;
  return localStep;
};
var addOrUpdateDataOverride = (localStep, reference, data) => {
  const itemIndex = localStep.testdataOverride.findIndex(
    (item) => item.referenceKey === reference
  );
  if (itemIndex > -1) {
    localStep.testdataOverride[itemIndex] = data;
  } else {
    localStep.testdataOverride.push(data);
  }
  return localStep;
};
var useElementChangedOrNot = (localStep, step, blocks) => {
  localStep.elementOverride = localStep.elementOverride || [];
  blocks.forEach((block) => {
    const newElementOverride = block?.more_details?.elementOverride;
    if (step.isStepGroupChild && newElementOverride && Object.keys(newElementOverride).length > 0) {
      const existingIndex = localStep.elementOverride.findIndex(
        (item) => item.referenceKey === newElementOverride.referenceKey
      );
      if (existingIndex !== -1) {
        localStep.elementOverride[existingIndex] = newElementOverride;
      } else {
        localStep.elementOverride.push(newElementOverride);
      }
    }
    if (step.isStepGroupChild && block?.type === "ui_identifier" /* ui_identifier */) {
      let element = null;
      if (localStep?.kibbutzPluginNlpData) {
        Object.keys(localStep.kibbutzPluginNlpData.uiIdentifiers).forEach(
          (key) => {
            if (key === block.uuid) {
              element = localStep.kibbutzPluginNlpData.uiIdentifiers[key];
            }
          }
        );
      } else if (localStep?.testStepElements) {
        element = localStep?.testStepElements.find(
          (element2) => element2.elementType === getElementType2(block.uuid)
        );
      }
      if (block.value !== element?.name) {
        element.name = block.value;
      }
    }
  });
  if (localStep.elementOverride.length === 0) delete localStep.elementOverride;
  return localStep;
};
var useForloopOverrideData = (localStep, step, blocks) => {
  localStep.forloopOverride = localStep.forloopOverride || [];
  blocks.forEach((block) => {
    if (step.isStepGroupChild && block?.more_details?.forloopOverride && Object.keys(block.more_details.forloopOverride).length > 0) {
      localStep.forloopOverride.push(block?.more_details?.forloopOverride);
    }
  });
  if (localStep.forloopOverride.length === 0) delete localStep.forloopOverride;
  return localStep;
};
var adaptTestStepTypeToStepUiType = (stepType, isConditional) => {
  const type = stepType;
  if (isConditional) {
    if (type == TestStepType.API_STEP) stepType = StepTypeUI.IF_REST_API;
    else if (type == TestStepType.NLP_TEXT) stepType = StepTypeUI.IF_CONDITION;
    else if (type == TestStepType.CUSTOM_FUNCTION)
      stepType = StepTypeUI.IF_CUSTOM_FUNCTION;
    else if (type == TestStepType.STEP_GROUP)
      stepType = StepTypeUI.IF_STEP_GROUP;
  } else {
    if (type == TestStepType.API_STEP) stepType = StepTypeUI.REST_API;
    else if (type == TestStepType.SOQL) stepType = StepTypeUI.SOQL;
    else if (type == TestStepType.NLP_TEXT) stepType = StepTypeUI.NLP;
    else if (type == TestStepType.CUSTOM_FUNCTION)
      stepType = StepTypeUI.CUSTOM_FUNCTION;
    else if (type == TestStepType.STEP_GROUP) stepType = StepTypeUI.STEP_GROUP;
    else if (type == TestStepType.BLOCK) stepType = StepTypeUI.BLOCK;
    else if (type == TestStepType.FOR_LOOP) stepType = StepTypeUI.FOR_LOOP;
    else if (type == TestStepType.WHILE_LOOP) stepType = StepTypeUI.WHILE_LOOP;
  }
  return stepType;
};
var adaptStepUiTypeToTestStepType = (stepUiType) => {
  let stepType;
  let isConditional = false;
  switch (stepUiType) {
    case StepTypeUI.IF_REST_API:
      stepType = TestStepType.API_STEP;
      isConditional = true;
      break;
    case StepTypeUI.IF_CONDITION:
      stepType = TestStepType.NLP_TEXT;
      isConditional = true;
      break;
    case StepTypeUI.IF_CUSTOM_FUNCTION:
      stepType = TestStepType.CUSTOM_FUNCTION;
      isConditional = true;
      break;
    case StepTypeUI.IF_STEP_GROUP:
      stepType = TestStepType.STEP_GROUP;
      isConditional = true;
      break;
    case StepTypeUI.REST_API:
      stepType = TestStepType.API_STEP;
      break;
    case StepTypeUI.NLP:
      stepType = TestStepType.NLP_TEXT;
      break;
    case StepTypeUI.CUSTOM_FUNCTION:
      stepType = TestStepType.CUSTOM_FUNCTION;
      break;
    case StepTypeUI.STEP_GROUP:
      stepType = TestStepType.STEP_GROUP;
      break;
    case StepTypeUI.BLOCK:
      stepType = TestStepType.BLOCK;
      break;
    case StepTypeUI.FOR_LOOP:
      stepType = TestStepType.FOR_LOOP;
      break;
    case StepTypeUI.WHILE_LOOP:
      stepType = TestStepType.WHILE_LOOP;
      break;
    case StepTypeUI.SOQL:
      stepType = TestStepType.SOQL;
      break;
    default:
      stepType = TestStepType.NLP_TEXT;
  }
  return { type: stepType, isConditionalStep: isConditional };
};
var useStepTypeChange = (localStep, updateLocalStep, updateUUID, updateWatchFocusOut, onChangeType, isEmptyTestdata, t) => {
  const stepContext2 = useContext(StepContext);
  return useCallback(
    (stepType, isConditional = null) => {
      const prevUiType = localStep?.uiMap?.type;
      if (typeof isConditional == "boolean") {
        stepType = adaptTestStepTypeToStepUiType(
          stepType,
          isConditional
        );
      }
      const isConditionalStep2 = [
        StepTypeUI.IF_CONDITION,
        StepTypeUI.IF_CUSTOM_FUNCTION,
        StepTypeUI.IF_REST_API,
        StepTypeUI.IF_STEP_GROUP
      ].includes(stepType);
      localStep.resetStep();
      if (isConditionalStep2) {
        localStep.conditionType = isConditionalElseIf(localStep) ? TestStepConditionType.CONDITION_ELSE_IF : TestStepConditionType.CONDITION_IF;
      } else {
        localStep.conditionType = null;
      }
      localStep.priority = TestStepPriority.MAJOR;
      if (![StepTypeUI.STEP_GROUP, StepTypeUI.IF_STEP_GROUP].includes(stepType))
        localStep.uiMap.type = stepType;
      if (isConditionalStep2 || stepType == StepTypeUI.FOR_LOOP || stepType == StepTypeUI.WHILE_LOOP) {
        localStep.priority = TestStepPriority.MINOR;
        localStep.ignoreStepResult = true;
      }
      if (stepType == StepTypeUI.IF_CONDITION && isObjectBased(localStep)) {
        handleObjectIfConditionStepSwitch(
          stepContext2,
          localStep,
          updateLocalStep
        );
      } else if (stepType == StepTypeUI.ACTION) {
        handleActionStepSwitch(
          stepContext2,
          localStep,
          updateLocalStep,
          prevUiType
        );
      } else if (stepType == StepTypeUI.ELEMENT) {
        handleElementStepSwitch(
          stepContext2,
          localStep,
          updateLocalStep,
          prevUiType
        );
      } else if (stepType == StepTypeUI.WHILE_LOOP) {
        handleWhileStepSwitch(localStep, updateLocalStep);
      } else if ([StepTypeUI.STEP_GROUP, StepTypeUI.IF_STEP_GROUP].includes(stepType)) {
        handleStepGroupStepSwitch(
          localStep,
          updateLocalStep,
          stepContext2,
          updateWatchFocusOut
        );
      } else if (stepType == StepTypeUI.BLOCK) {
        handleBlockStepSwitch(localStep, updateLocalStep);
      } else if (stepType == StepTypeUI.FOR_LOOP) {
        handleForLoopSwitch(localStep, updateLocalStep, isEmptyTestdata, t);
      } else if ([StepTypeUI.REST_API, StepTypeUI.IF_REST_API].includes(stepType)) {
        handleApiStepSwitch(localStep, updateLocalStep, stepContext2);
      } else if (stepType == StepTypeUI.SOQL) {
        handleSOQLStepSwitch(localStep, updateLocalStep, stepContext2);
      } else if ([StepTypeUI.NLP, StepTypeUI.IF_CONDITION].includes(stepType)) {
        handleNplStepSwitch(localStep, updateLocalStep);
      } else if ([StepTypeUI.CUSTOM_FUNCTION, StepTypeUI.IF_CUSTOM_FUNCTION].includes(
        stepType
      )) {
        handleCunstomFunctionStepSwitch(localStep, updateLocalStep);
      }
      updateUUID(generateUniqueId());
      onChangeType(adaptStepUiTypeToTestStepType(stepType));
    },
    [
      localStep,
      updateLocalStep,
      updateUUID,
      stepContext2,
      updateWatchFocusOut,
      t
    ]
  );
};
var clearStep = (localStep, updateLocalStep, updateUUID, onChangeType) => useCallback(
  (receivedStep) => {
    const step = cloneDeep$1(receivedStep);
    const blocks = [
      {
        type: "editable_text" /* editable_text */,
        value: "",
        uuid: null
      }
    ];
    step.resetStep();
    if (isObjectBased(step.uiMap)) {
      step.uiMap.element = null;
      step.uiMap.elementId = null;
      step.uiMap.isObjectBased = true;
      step.uiMap.objectBlocks = [];
      step.uiMap.objectTypeId = null;
      step.uiMap.templateId = null;
      if ([StepTypeUI.ACTION, StepTypeUI.ELEMENT].includes(step.uiMap.type)) {
        step.uiMap.type = null;
        step.type = TestStepType.NLP_TEXT;
      }
    }
    let typeForStep;
    if (isForLoop(step)) {
      typeForStep = TestStepType.FOR_LOOP;
    } else if (isConditionalWhileLoop(step)) {
      typeForStep = TestStepType.WHILE_LOOP;
    } else if (isObjectBased(step.uiMap)) {
      typeForStep = adaptStepUiTypeToTestStepType(step.uiMap.type);
    } else {
      typeForStep = step.type;
    }
    onChangeType({
      type: typeForStep,
      isConditionalStep: isIfConditionalStep(step)
    });
    updateLocalStep(bindBlockWithTestStep(blocks, step));
    updateUUID(generateUniqueId());
  },
  [localStep, updateLocalStep]
);
var getDifferenceOfSteps = (step1, step2, isRemoveDatagenerators = false) => {
  const json1 = JSON.stringify(step1, (key, value) => {
    if (isRemoveDatagenerators && key === "dataGenerators" && value && !Object.keys(value).length) {
      return void 0;
    }
    return value;
  });
  const json2 = JSON.stringify(step2, (key, value) => {
    if (isRemoveDatagenerators && key === "dataGenerators" && value && !Object.keys(value).length) {
      return void 0;
    }
    return value;
  });
  const obj1 = JSON.parse(json1);
  const obj2 = JSON.parse(json2);
  const differences = deepDiff.diff(obj1, obj2);
  return differences;
};
var getStepForComparison = (step) => {
  return omit(new TestStep().deserialize(step), [
    "uiMap",
    "childSteps",
    "reOrderIndex"
  ]);
};
var useIsTestStepChanged = (testStep, localStep) => {
  const isDirty = useMemo(() => {
    localStep = getStepForComparison(localStep);
    testStep = getStepForComparison(testStep);
    const differences = getDifferenceOfSteps(
      localStep,
      testStep,
      !(testStep?.isWebRecorderStep || localStep?.isWebRecorderStep)
    );
    return !!differences?.length || testStep?.isAddedDirect;
  }, [localStep, testStep]);
  const mustHaveTemplate = useMemo(
    () => [
      TestStepType.FOR_LOOP,
      TestStepType.NLP_TEXT,
      TestStepType.WHILE_LOOP
    ].includes(localStep.type),
    [localStep]
  );
  const stepGroupChanged = localStep.type == TestStepType.STEP_GROUP && testStep.type == TestStepType.STEP_GROUP && localStep.stepGroupId != testStep.stepGroupId;
  const iframeElementChanged = window["nonIframeStep"] != null;
  return (isDirty || iframeElementChanged) && (!mustHaveTemplate || localStep.templateId || localStep.kibbutzPluginNlpId) || stepGroupChanged;
};
var useStepDisabled = (localStep) => useMemo(() => {
  if (!localStep) {
    return false;
  }
  const isRestStepInvalid = localStep.type == TestStepType.API_STEP && !localStep.action;
  const isBlockStepInvalid = localStep.type == TestStepType.BLOCK && !localStep.action;
  const isNlpStepInvalid = localStep.type == TestStepType.NLP_TEXT && !localStep.action && !localStep.kibbutzPluginNlpData?.testData && !localStep.templateId;
  const isStepGroupInvalid = localStep.type == TestStepType.STEP_GROUP && !localStep.action;
  const isCustomFunctionStepInvalid = [StepTypeUI.CUSTOM_FUNCTION, StepTypeUI.IF_CUSTOM_FUNCTION].includes(
    localStep?.type
  ) && !localStep.action;
  let isObjectInvalid = false;
  if (localStep?.uiMap?.objectBlocks?.length) {
    const hasTestData = localStep.uiMap.objectBlocks.find(
      (block) => block.uuid == "testData"
    );
    if (hasTestData) {
      isObjectInvalid = localStep?.stepDataList?.some(
        (stepData) => !stepData?.value
      );
    }
  }
  return isRestStepInvalid || isBlockStepInvalid || isNlpStepInvalid || isStepGroupInvalid || isCustomFunctionStepInvalid || isObjectInvalid;
}, [localStep]);
var useIsStepInvalid = (template, testStep) => {
  const { t } = useTranslation();
  const { hasFeatureValue: hasFeatureValue2 } = useContext(StepContext);
  const isMobile = testStep?.isAndroidApp || testStep?.isIOSApp;
  const getInitialBlocks = (templateValue, testStepValue, hasFeature) => {
    if (templateValue) {
      if (templateValue.isAddon) {
        return getStepKibbutzBlocks(testStepValue, templateValue);
      } else {
        return getStepNlpBlocks(testStepValue, templateValue, null, hasFeature);
      }
    } else {
      return [
        {
          type: "editable_text" /* editable_text */,
          value: "",
          more_details: {
            placeholder_type: isMobile ? "mobile" : testStep?.isMobileApp ? "mobile-web" : isObjectBased(testStep) ? "windows_advanced" : "web"
          }
        }
      ];
    }
  };
  const blocks = useMemo(
    () => getInitialBlocks(template, testStep, hasFeatureValue2),
    [template, testStep]
  );
  const testDataTypes = [
    "function" /* function */,
    "global" /* global */,
    "mail_box" /* mail_box */,
    "parameter" /* parameter */,
    "phone_number" /* phone_number */,
    "random" /* random */,
    "raw" /* raw */,
    "runtime" /* runtime */,
    "upload_path" /* upload_path */
  ];
  const isSelectableNotSelected = useMemo(
    () => blocks.filter(
      (block) => block.type == "selectable" && !block.more_details?.allowedValues.includes(block.value)
    ).length > 0,
    [blocks]
  );
  const isTestDataEmpty = useMemo(
    () => blocks.filter(
      (block) => testDataTypes.includes(block.type) && !String(block.value).trim() && block.type != "function" /* function */
    ).length > 0,
    [blocks]
  );
  const isSalesforceFormObjectEmpty = useMemo(
    () => blocks.filter(
      (block) => block.type == "salesforce_object_form" /* salesforce_object_form */ && block?.value == "Salesforce Object Form"
    ).length > 0,
    [blocks]
  );
  if (isSalesforceFormObjectEmpty) {
    return t("salesforce-object-from.not-empty");
  }
  if (isTestDataEmpty) {
    return t("test.data.not_empty");
  }
  if (isSelectableNotSelected) {
    return t("selectable_option.not_selected");
  }
  return false;
};
var getStep = (step, isDebugMode) => {
  step = isDebugMode ? step : new TestStep().deserialize(step);
  if (step && step?.id == -1 && isDebugMode) {
    step.id = void 0;
  }
  return step;
};
var FormattedStep = ({
  step: stepData,
  isEdit = false,
  getTestData: getTestData2,
  onCreateStep = NOOP,
  onUpdateStep = NOOP,
  onRemoveStep = NOOP,
  isViewOnly,
  isViewOnlySingle,
  onChangeType = NOOP,
  onNestedCreateStep = NOOP,
  onSearch = NOOP,
  isFetching,
  isCommand,
  isCommandCombine,
  hasAddStepButton = false,
  dataParameterList,
  dataProfileList,
  dataSetList,
  updateSelectedDataProfile,
  isExpaned,
  index,
  provided,
  isDebugMode,
  onToggleDebug,
  debugPoints,
  debuggerActions,
  stepResult,
  nextStep,
  measure,
  fetchConnections,
  actionCallback,
  salesforceActions,
  uploadActions,
  isIterationStepChild,
  isEligibleForDebug,
  sessionActions,
  customFunctionList,
  executedStepIds,
  iterationItems = [],
  selectedIterationIndex,
  onIterationChange
}) => {
  const { t } = useTranslation();
  const ref = useRef(null);
  const skipCancel = useRef(false);
  const [localBlocks, setLocalBlocks] = useState([]);
  const {
    stepsInfo,
    activeStepIdx,
    updateActiveStepIdx,
    updateStepsInfo,
    isRecorderView,
    nlActions,
    openStepGroupsListDrawer,
    openCustomFunctionParameterDrawer,
    openVisualFigmaViewModal,
    steps,
    stepToggleUtils,
    testCase,
    isWebRecorder,
    updateChildStep,
    currentExecutingStep,
    lastUpdatedStepId,
    hasFeatureValue: hasFeatureValue2,
    updateStepGroupChildren,
    lastFocusedStepNumber,
    setLastFocusedStepNumber,
    debugExecutionStatus
  } = useContext(StepContext);
  const [onOpenMore, _updateOnOpenMore] = useState(false);
  const isScrollAligned = useRef(false);
  const step = useMemo(
    () => getStep(stepData, isDebugMode),
    [stepData, isDebugMode]
  );
  const [isGroupExpanding, setIsGroupExpanding] = useState(false);
  const [localStep, _updateLocalStep] = useState(
    constructStepUiMap(step, nlActions)
  );
  const [isHovered, setIsHovered] = useState(false);
  const [isFocused, updateFocused] = useStepFocused(
    ref,
    isEdit,
    Boolean(stepsInfo?.selectedSteps?.length),
    isViewOnly
  );
  const updateLocalStep = (_step) => {
    if (!_step) return;
    const hydratedStep = _step instanceof TestStep ? _step : new TestStep().deserialize(_step);
    _updateLocalStep(
      !hydratedStep?.uiMap ? constructStepUiMap(hydratedStep, nlActions) : hydratedStep
    );
  };
  const template = nlActions.find((nlpAction) => {
    if (nlpAction?.isAddon) {
      return nlpAction.id == localStep?.kibbutzPluginNlpId;
    } else if (!nlpAction.isAddon) {
      return nlpAction.id == localStep?.templateId;
    }
  });
  const stepId = isMobileDebugger() ? stepResult?.metadata?.testStep.id : stepResult?.stepId;
  const stepDebugId = step?.debugStepId || "";
  const isCurrentExecutingStep = currentExecutingStep?.stepId === stepId;
  const isRunning = stepResult?.result === ResultConstant.RUNNING;
  const isSuccess = isMobileDebugger() ? currentExecutingStep?.result === ResultConstant.SUCCESS : false;
  const showBcgColorForRunningStep = isCurrentExecutingStep && isRunning;
  const shouldShowSuccessColor = isSuccess && isCurrentExecutingStep;
  const showBcgColorForFailedStep = isDebugMode && stepResult?.result === ResultConstant.FAILURE && isCurrentExecutingStep;
  const isDragMode = useMemo(() => stepsInfo?.isReorderState, [stepsInfo]);
  const stepHighlightByStatus = execution_icon_default(stepResult?.result);
  const className = classNames82({
    "animation-step-success-color-in-out": isDebugMode && shouldShowSuccessColor,
    "!bg-secondary-100 relative before:absolute before:top-0 before:left-0 before:w-[2px] before:h-full before:bg-[#FAA53D]": isDebugMode && showBcgColorForRunningStep,
    ["!bg-[#FFF4E5] relative before:absolute before:top-0 before:left-0 before:w-[2px] before:h-full before:bg-[#F87462]"]: isDebugMode && showBcgColorForFailedStep
  });
  const isBulkActionMode = useMemo(
    () => stepsInfo?.isBulkActionState,
    [stepsInfo]
  );
  const isMounted = useRef(true);
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);
  const updateOnOpenMore = useCallback(
    (res) => {
      _updateOnOpenMore(res);
      updateFocused(res);
    },
    [_updateOnOpenMore]
  );
  const toggleMoreOptions = useCallback(() => {
    _updateOnOpenMore(!onOpenMore);
  }, [onOpenMore]);
  const closeMoreOptions = useCallback(() => {
    _updateOnOpenMore(false);
  }, []);
  useEffect(() => {
    if (!isFocused && onOpenMore) {
      closeMoreOptions();
    }
  }, [isFocused, onOpenMore, closeMoreOptions]);
  const onChange = useStepNlpValueChange(
    localStep,
    updateLocalStep,
    step,
    setLocalBlocks,
    testCase
  );
  const onCancel = useStepCancel(
    updateFocused,
    step,
    updateLocalStep,
    NOOP,
    isEdit,
    onRemoveStep,
    measure,
    isMounted
  );
  const [
    onSave,
    errorOnSave,
    isSaving,
    onMouseOverStepValidate,
    urlValidation
  ] = useStepSave(
    localStep,
    NOOP,
    onCreateStep,
    isEdit,
    onUpdateStep,
    updateFocused,
    template,
    updateChildStep,
    updateLocalStep,
    step,
    measure,
    isRecorderView,
    isMounted
  );
  const onStepTypeChange = useStepTypeChange(
    localStep,
    updateLocalStep,
    NOOP,
    NOOP,
    onChangeType,
    Boolean(!dataProfileList?.length),
    t
  );
  const internalEventHandler = useCallback(
    (eventName) => {
      if (eventName === "rest-step") {
        measure?.();
        updateFocused(false);
      }
    },
    [measure]
  );
  useInternalEvents(["rest-step"], internalEventHandler);
  useEffect(() => {
    const handleAutoSave = (event) => {
      const { stepId: stepId2 } = event.detail;
      if (stepId2 === step.id) {
        delete window["nonIframeStep"];
        delete window["stepElementCloned"];
        onSave();
        setTimeout(() => {
          updateFocused(false);
        }, 100);
      }
    };
    window.addEventListener("trigger-auto-save", handleAutoSave);
    return () => {
      window.removeEventListener("trigger-auto-save", handleAutoSave);
    };
  }, [step.id, onSave, updateFocused]);
  const onClear = clearStep(localStep, updateLocalStep, NOOP, onChangeType);
  useEffect(() => {
    if (!isFocused) {
      updateLocalStep(new TestStep().deserialize(step));
      if (isMounted.current) {
        measure?.();
      }
    }
  }, [step, isFocused]);
  useEffect(() => {
    if (isFocused) {
      updateActiveStepIdx(step.id);
      skipCancel.current = true;
      if (window["nonIframeStep"] && window["nonIframeStep"]?.id != step?.id) {
        delete window["nonIframeStep"];
      }
    } else {
      if (activeStepIdx) {
        onCancel();
      }
      skipCancel.current = false;
    }
  }, [isFocused, skipCancel]);
  useEffect(() => {
    if (activeStepIdx != step.id && !skipCancel.current) {
      updateFocused(false);
    }
    if (skipCancel.current) skipCancel.current = false;
  }, [activeStepIdx, skipCancel]);
  useEffect(() => {
    if (isBulkActionMode || isDragMode) {
      onCancel();
    }
  }, [isBulkActionMode, isDragMode]);
  const isStepValueChanged = useIsTestStepChanged(step, localStep);
  const isStepInvalid = useStepDisabled(localStep);
  const handleSelectionChange = useCallback(
    (checked) => {
      const children = findAllChildren(steps, "parentId", step.id);
      const childrenIds = children.map((childStep) => childStep.id);
      const parentStep = steps.find((item) => item.id === step?.parentId);
      const parentStepIds = parentStep?.id ? findAllParents(steps, parentStep?.id).map((item) => item.id) : [];
      const withoutCurrentStep = stepsInfo.selectedSteps.filter((item) => {
        const filterStepsCondition = item.id != step.id && !childrenIds.includes(item.id);
        if ((parentStep ? !parentStepIds.includes(item.id) : true) && filterStepsCondition) {
          return true;
        }
        return false;
      });
      stepsInfo.updateSelectedSteps(
        checked ? [...withoutCurrentStep, step, ...children] : withoutCurrentStep
      );
      updateStepsInfo(
        "selectedSteps",
        checked ? [...withoutCurrentStep, step] : withoutCurrentStep
      );
    },
    [stepsInfo, step, updateStepsInfo, steps]
  );
  const isSelected = useMemo(
    () => stepsInfo?.selectedSteps?.map((item) => item.id).includes(localStep?.id),
    [localStep, stepsInfo]
  );
  const isStepDisabled = useMemo(
    () => (
      // disable the checkbox incase of following conditions
      //  1. action text is empty
      //  2. step is a custom function
      !localStep || localStep.action === ""
    ),
    [localStep]
  );
  const setExpandStepGroup = useCallback(
    (_isExpaned, _step) => {
      setIsGroupExpanding(isStepGroup(_step) && !_isExpaned);
      stepToggleUtils.toggleStepExpand({
        step: _step,
        isExpand: !_isExpaned,
        setIsGroupExpanding
      });
    },
    [stepToggleUtils]
  );
  const toggleStep = useCallback(
    (event, _isExpaned) => {
      if (event) {
        event?.nativeEvent?.stopImmediatePropagation();
        event?.preventDefault();
      }
      setExpandStepGroup(_isExpaned, step);
    },
    [stepToggleUtils, step, setExpandStepGroup]
  );
  const nestedStep = useCallback(
    (data) => {
      if (data.type === "inside" && isBlock(data.localStep)) {
        stepToggleUtils.toggleStepExpand({
          step: data.localStep,
          isExpand: true
        });
      }
      onNestedCreateStep(data);
    },
    [onNestedCreateStep, stepToggleUtils]
  );
  const isNestedStepGroupStep = useMemo(() => {
    return localStep?.parentStepGroupIds?.length > 1 || localStep?.parentStepGroupIds?.length == 1 && testCase?.isStepGroup;
  }, [localStep]);
  const scrollToCenterHandler = useCallback(
    (el, stepNumber) => {
      if (!isEdit && el && !isScrollAligned.current && isRecorderView) {
        isScrollAligned.current = true;
        setLastFocusedStepNumber(stepNumber);
        el?.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest"
        });
      }
    },
    [isEdit, isRecorderView]
  );
  const isDebuggerPointPlaced = useMemo(() => {
    return localStep?.id && debugPoints?.length && debugPoints?.indexOf(localStep?.id) !== -1;
  }, [localStep?.id, debugPoints]);
  useEffect(() => {
    if (step.isDefaultFirstStep) {
      updateLocalStep?.(step);
      onChange(
        getStepNlpBlocks(step, template, null, hasFeatureValue2)
      );
    }
  }, []);
  useEffect(() => {
    if (step.localStep) {
      updateLocalStep(step.localStep);
      window.setTimeout(() => {
        document.querySelector(`.test-step-item[index="${index}"]`)?.click();
      }, 2e3);
      step.localStep = null;
    }
  }, [step]);
  useEffect(() => {
    updateLocalStep(step);
  }, [step?.disabled, step?.isParentStepGroupDisabled, step?.mapperData]);
  useEffect(() => {
    let isStepModified = false;
    if (isFocused && !localStep.isPresentationStep && (isStepValueChanged || !localStep?.id || isStepInvalid)) {
      isStepModified = true;
      if (!isShow()) {
        onSave();
        updateStepGroupChildren();
      }
    }
    if (measure && isMounted.current && (isStepModified || localStep?.isBlock)) {
      measure();
    }
  }, [isFocused, localStep, isStepValueChanged, isStepInvalid]);
  const isShow = () => {
    const isMismatch = localStep?.testStepElements?.some((element) => {
      return element?.id && step.testStepElements?.some((currentElement) => {
        return element.elementId === currentElement.elementId && element.name !== currentElement.name;
      });
    });
    if (!isEdit || !!localStep?.uiMap?.objectBlocks?.length) {
      return true;
    } else if (isEdit) {
      if (localStep.action == "") {
        return true;
      }
      if (localStep.templateId == step.templateId && isMismatch) {
        return localBlocks.filter((item) => item.type == "ui_identifier" /* ui_identifier */).some((item) => item.more_details.elementOverride);
      }
      if (isNestedStepGroupStep) {
        return false;
      }
      if (isStepValueChanged) {
        return true;
      }
    }
    return false;
  };
  const canHighlightActiveStep = useMemo(() => {
    const hasCreateField = steps.findIndex((_step) => !_step.id) != -1;
    if (!isRecorderView) return false;
    if (!activeStepIdx) {
      if (step.id) return lastUpdatedStepId == step.id && !hasCreateField;
      else if (!step.id && hasCreateField) return true;
    } else if (activeStepIdx == step.id) return true;
    return false;
  }, [lastUpdatedStepId, step, activeStepIdx, steps]);
  const isDesktopSkipClear = isObjectBased(localStep) && [StepTypeUI.ACTION, StepTypeUI.ELEMENT, StepTypeUI.IF_CONDITION].includes(
    localStep?.uiMap?.type
  ) && isEdit;
  useUIMap(localStep, step, updateLocalStep, isFocused, nlActions);
  const stopPropagation = (event) => {
    event.stopPropagation();
    event.preventDefault();
  };
  const handleToggleDebug = (event) => {
    event.stopPropagation();
    event.preventDefault();
    onToggleDebug(step.id);
  };
  const isDragDisabled = useMemo(() => {
    return isConditionalStep(localStep) || localStep.isStepGroupChild || [TestStepType.BREAK_LOOP, TestStepType.CONTINUE_LOOP].includes(
      localStep.type
    ) || // Disable dragging for step groups when expanded (only allow dragging when collapsed)
    isExpaned && [TestStepType.BLOCK, TestStepType.STEP_GROUP].includes(localStep.type);
  }, [localStep, isExpaned]);
  const nonExecutedProps = {
    // Basic props
    step,
    localStep,
    isEdit,
    debugExecutionStatus,
    getTestData: getTestData2,
    onCreateStep,
    onNestedCreateStep,
    onRemoveStep,
    onSearch,
    isFetching,
    isCommand,
    isCommandCombine,
    isViewOnly,
    isViewOnlySingle,
    hasAddStepButton,
    // Data props
    dataProfileList,
    dataSetList,
    dataParameterList,
    updateSelectedDataProfile,
    customFunctionList,
    // Layout props
    provided,
    // Debug props
    onToggleDebug,
    debugPoints,
    debuggerActions,
    stepResult,
    nextStep,
    isIterationStepChild,
    isEligibleForDebug,
    executedStepIds,
    // Connection props
    fetchConnections,
    actionCallback,
    salesforceActions,
    uploadActions,
    sessionActions,
    // State and computed values
    isFocused,
    updateFocused,
    isDragMode,
    stepHighlightByStatus,
    isBulkActionMode,
    onChange,
    onCancel,
    onSave,
    errorOnSave,
    isSaving,
    onMouseOverStepValidate,
    urlValidation,
    onStepTypeChange,
    isStepValueChanged: Boolean(isStepValueChanged),
    isStepDisabled,
    handleSelectionChange,
    isSelected,
    toggleStep,
    isNestedStepGroupStep,
    isDebuggerPointPlaced,
    canHighlightActiveStep,
    isDesktopSkipClear,
    onClear,
    onOpenMore,
    toggleMoreOptions,
    closeMoreOptions,
    onOpenMoreChange: (open) => _updateOnOpenMore(open),
    updateWatchFocusOut: NOOP,
    updateLocalStep,
    isGroupExpanding,
    isExpaned,
    // Context props
    stepsInfo,
    template,
    updateStepsInfo,
    openStepGroupsListDrawer,
    openCustomFunctionParameterDrawer,
    isWebRecorder,
    isRecorderView,
    localBlocks,
    isStepInvalid,
    isShow,
    setLastFocusedStepNumber,
    hasFeatureValue: hasFeatureValue2,
    openVisualFigmaViewModal,
    stopPropagation,
    handleToggleDebug,
    className,
    stepId,
    iterationItems,
    selectedIterationIndex,
    onIterationChange
  };
  useEffect(() => {
    if (isRunning && isCurrentExecutingStep && stepDebugId && isDebugMode) {
      setTimeout(() => {
        document.getElementById(stepDebugId)?.scrollIntoView({ behavior: "smooth", block: "end" });
      }, 0);
    }
  }, [isRunning, isCurrentExecutingStep, stepDebugId, isDebugMode]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ref: (el) => {
        if (lastFocusedStepNumber !== localStep.stepNumber)
          scrollToCenterHandler(el, localStep?.stepNumber);
        ref.current = el;
        if (window["nonIframeStep"] && ref?.current && step?.id === window["nonIframeStep"]?.id) ;
      },
      role: step.id ? "gridcell" : "row",
      className: classNames82(
        "flex flex-col group lead select-none test-step-item bg-transparent",
        {
          "transition-all duration-500": !isEdit,
          "relative z-[1]": isFocused,
          "mt-3": index < 1 && !isViewOnlySingle && !isDebugMode,
          "!bg-white": isDebugMode && (!step.isInvalid || isStepValueChanged),
          "!bg-secondary-unique-900": isDebugMode && step.isInvalid && !isStepValueChanged
        }
      ),
      onMouseOver: () => setIsHovered(true),
      onMouseLeave: () => setIsHovered(false),
      children: [
        isDebugMode && /* @__PURE__ */ jsx(non_executed_step_default, { ...nonExecutedProps }),
        !isDebugMode && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsxs(
            "div",
            {
              role: step.id ? void 0 : "gridcell",
              ...isRecorderView && provided?.dragHandleProps && !isDragDisabled ? provided.dragHandleProps : {},
              className: classNames82(
                "min-h-[40px] pr-2.5 pl-0.5 flex relative",
                stepHighlightByStatus?.bgColor ?? {
                  "bg-white": !step.isInvalid || isStepValueChanged,
                  "bg-secondary-unique-900": step.isInvalid && !isStepValueChanged
                },
                {
                  "shadow-y-sm": isFocused,
                  "hover:bg-secondary-50 cursor-pointer": !isFocused && !step.isInvalid && !isViewOnly
                }
              ),
              children: [
                !isRecorderView && !isViewOnly && provided && (isEdit ? /* @__PURE__ */ jsx(
                  "div",
                  {
                    role: step.id ? void 0 : "gridcell",
                    ...isDragDisabled ? {} : provided.dragHandleProps,
                    "aria-label": t("step.reorder_step", { stepNumber: index + 1 }),
                    className: `flex items-center relative`,
                    children: /* @__PURE__ */ jsx(
                      ToolTip,
                      {
                        content: isDragDisabled ? t("reorder.drag.icon.text") : "",
                        children: /* @__PURE__ */ jsx(
                          Icon,
                          {
                            name: "reorder",
                            className: classNames82(
                              "cursor-grab min-w-[28px] text-xl justify-center text-unique-800 pt-1",
                              {
                                "group-hover:visible": !isFocused,
                                visible: isFocused || isDragMode && !isBulkActionMode,
                                invisible: !isFocused && !isDragMode || isBulkActionMode,
                                "opacity-50 cursor-not-allowed": isDragDisabled
                              }
                            )
                          }
                        )
                      }
                    )
                  }
                ) : /* @__PURE__ */ jsx(
                  "span",
                  {
                    className: "min-w-[28px]",
                    role: step.id ? void 0 : "gridcell"
                  }
                )),
                canHighlightActiveStep && /* @__PURE__ */ jsx(
                  "span",
                  {
                    className: "active-step absolute left-0 top-3",
                    role: step.id ? void 0 : "gridcell"
                  }
                ),
                isHovered && !isDragMode && hasAddStepButton && !isViewOnly && !isBulkActionMode && !localStep.isStepGroupChild && /* @__PURE__ */ jsx(
                  StepChips,
                  {
                    step: localStep,
                    onNestedCreateStep: nestedStep,
                    onOpen: updateOnOpenMore
                  }
                ),
                isHovered && !isDragMode && hasAddStepButton && !isViewOnly && !isBulkActionMode && !localStep.isStepGroupChild && /* @__PURE__ */ jsx(
                  StepChips,
                  {
                    step: localStep,
                    isAbove: true,
                    onNestedCreateStep
                  }
                ),
                (isFocused || isSaving) && !isEdit && /* @__PURE__ */ jsx(
                  StepTypeSwitch,
                  {
                    isVisible: isFocused && !isEdit,
                    localStep,
                    iconName: /* @__PURE__ */ jsx(Icon, { name: getStepTypeIcon(localStep) }),
                    handleTypeSwitch: onStepTypeChange
                  }
                ),
                localStep.indent > 0 && !isViewOnlySingle && /* @__PURE__ */ jsx(
                  Indent2,
                  {
                    size: localStep.indent,
                    showLine: !isFocused,
                    step: localStep
                  }
                ),
                isDebugMode && stepHighlightByStatus ? /* @__PURE__ */ jsx(
                  ToolTip,
                  {
                    placement: "bottom",
                    content: stepResult?.result,
                    className: classNames82(
                      "inline-flex absolute left-2",
                      {
                        "top-3": stepResult?.result && stepResult?.result !== ResultConstant.PAUSED
                      },
                      { "top-4": stepResult?.result === ResultConstant.PAUSED }
                    ),
                    children: stepHighlightByStatus?.icon
                  }
                ) : null,
                isEdit && !isViewOnlySingle && /* @__PURE__ */ jsxs("div", { className: "relative", role: step.id ? void 0 : "gridcell", children: [
                  /* @__PURE__ */ jsx(
                    "div",
                    {
                      className: classNames82(
                        "inline-flex items-center justify-center text-secondary-600 text-lg min-w-[28px]",
                        {
                          "group-hover:invisible": isEdit && !isFocused,
                          invisible: isFocused,
                          "h-9": isStepGroup(localStep)
                        }
                      ),
                      children: isStepGroup(localStep) && isGroupExpanding ? /* @__PURE__ */ jsx(
                        "div",
                        {
                          className: "empty-page-loader !min-w-[16px] !max-w-[16px] !min-h-[16px] !max-h-[16px] !border-2",
                          title: "Loading..."
                        }
                      ) : localStep.showIcon && // !isDebuggerPointPlaced &&
                      isRecorderView && /* @__PURE__ */ jsx(
                        Icon,
                        {
                          name: getStepTypeIcon(localStep),
                          className: classNames82("text-unique-800 h-9", {
                            "!mt-3": step?.action?.length > 150
                          })
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    "div",
                    {
                      className: classNames82(
                        "inline-flex items-center justify-center text-lg min-w-[18px] absolute left-0 z-10",
                        { "text-primary-600": isExpaned },
                        {
                          "text-secondary-600": !isExpaned,
                          "invisible group-hover:visible": !isFocused,
                          "h-9": isBlock(localStep) || isStepGroup(localStep)
                        }
                      ),
                      children: isGroupExpanding ? /* @__PURE__ */ jsx(
                        "div",
                        {
                          className: "empty-page-loader !min-w-[16px] !max-w-[16px] !min-h-[16px] !max-h-[16px] !border-2",
                          title: "Loading..."
                        }
                      ) : /* @__PURE__ */ jsx(Fragment, { children: (isBlock(localStep) || isStepGroup(localStep)) && /* @__PURE__ */ jsx(
                        ToolTip,
                        {
                          className: "flex",
                          content: isDragMode && t("step.drag_mode.disable_block_collapse"),
                          children: /* @__PURE__ */ jsx(
                            Icon,
                            {
                              name: isExpaned ? "angle-bottom" : "angle-right",
                              onClickCapture: (event) => isDragMode ? stopPropagation(event) : toggleStep(event, isExpaned)
                            }
                          )
                        }
                      ) })
                    }
                  )
                ] }),
                isDebugMode && (isWebRecorder ? !isEligibleForDebug && !step.isForLoop && !step.isConditionalWhileLoop && !step.isBlock && !step.isConditionalElse && !step.isStepGroup : true) && !step?.disabled && (!stepResult?.result || stepResult?.result !== ResultConstant.PAUSED) ? /* @__PURE__ */ jsx(
                  "div",
                  {
                    className: classNames82(
                      "flex items-center flex-shrink-0 text-xl relative min-w-[15px]",
                      {
                        "group-hover:visible": isRecorderView,
                        invisible: !isDebuggerPointPlaced,
                        visible: isDebuggerPointPlaced
                      }
                    ),
                    children: /* @__PURE__ */ jsx(
                      ToolTip,
                      {
                        className: "flex",
                        content: !isDebuggerPointPlaced ? t("debug_run.place_debug_point") : t("debug_run.remove_debug_point"),
                        children: /* @__PURE__ */ jsx(
                          "span",
                          {
                            className: classNames82(
                              "w-2 h-2 rounded-sm rotate-45 cursor-pointer",
                              {
                                "bg-execution-debug": isDebuggerPointPlaced,
                                "bg-secondary-400": !isDebuggerPointPlaced
                              }
                            ),
                            onMouseDown: stopPropagation,
                            onMouseUp: stopPropagation,
                            onClick: handleToggleDebug
                          }
                        )
                      }
                    )
                  }
                ) : null,
                /* @__PURE__ */ jsxs("div", { className: "group flex relative items-center self-baseline mt-2.5", children: [
                  step?.isStepGroupChild ? /* @__PURE__ */ jsx(ToolTip, { content: t("common.module.name.step_group"), children: /* @__PURE__ */ jsx(
                    Icon,
                    {
                      name: "ballot",
                      className: "text-secondary-400 text-xs mr-2"
                    }
                  ) }) : null,
                  /* @__PURE__ */ jsx(
                    StepNumber,
                    {
                      number: localStep.stepNumber,
                      showAiIcon: localStep.createType === EntityCreateType.AI,
                      className: classNames82("mr-2", {
                        "grayscale opacity-50": localStep.disabled,
                        "ml-3.5": !isEdit && !isRecorderView,
                        "group-hover:invisible": isEdit && !isViewOnly && !localStep.isStepGroupChild && !isDragMode && !isBulkActionMode && !(localStep.isNlpStep && !localStep.templateId) && (stepResult?.result !== ResultConstant.PAUSED || !stepResult?.isEligibleForDebug) && !stepHighlightByStatus,
                        invisible: isSelected
                      })
                    }
                  ),
                  isEdit && !isViewOnly && !localStep.isStepGroupChild && !isDragMode && (!localStep.isNlpStep || localStep.isConditionalElse || localStep.templateId || localStep.kibbutzPluginNlpId) && (stepResult?.result !== ResultConstant.PAUSED || !stepResult?.isEligibleForDebug) && !stepHighlightByStatus && /* @__PURE__ */ jsx(
                    Checkbox,
                    {
                      size: "small",
                      className: classNames82(
                        `mr-2.5 group-hover:inline-block absolute left-0`,
                        { hidden: !isSelected }
                      ),
                      checked: isSelected,
                      onChange: handleSelectionChange,
                      isDisabled: isStepDisabled,
                      ariaLabel: t("common.select") + " " + (localStep?.naturalLanguageActionValue || t("common.test_step"))
                    }
                  )
                ] }),
                (isPresentationStep(localStep) || isConditionalElseIf(localStep) || isConditionalIf(localStep)) && /* @__PURE__ */ jsx(step_type_indicator_text_component_default, { step: localStep }),
                localStep.isKibbutz && /* @__PURE__ */ jsx(
                  Icon,
                  {
                    name: "addons",
                    className: classNames82({ "!mt-3": step?.action?.length > 150 })
                  }
                ),
                /* @__PURE__ */ jsx(
                  StepItemWrapper,
                  {
                    step: localStep,
                    getTestData: getTestData2,
                    onChange,
                    isViewOnly: isViewOnly || isPresentationStep(localStep) || isDragMode || isNestedStepGroupStep,
                    isFocused,
                    updateFocused,
                    updateWatchFocusOut: NOOP,
                    updateLocalStep,
                    onSearch,
                    isFetching,
                    isCommand,
                    isCommandCombine,
                    onChangeType: onStepTypeChange,
                    dataParameterList,
                    dataProfileList,
                    customFunctionList,
                    dataSetList,
                    updateSelectedDataProfile,
                    onSave,
                    stepsInfo,
                    template,
                    updateStepsInfo,
                    openStepGroupsListDrawer,
                    openCustomFunctionParameterDrawer,
                    isViewOnlySingle,
                    setExpandStepGroup: toggleStep,
                    isWebRecorder,
                    fetchConnections,
                    actionCallback,
                    salesforceActions,
                    uploadActions,
                    stepResult,
                    sessionActions,
                    isNestedStepGroupStep,
                    prevLocalBlocks: localBlocks
                  }
                ),
                /* @__PURE__ */ jsxs(
                  "div",
                  {
                    className: classNames82("flex items-center ml-auto flex-shrink-0", {
                      "absolute right-0 bg-secondary-50": isRecorderView && !isFocused,
                      // Never hide on hover-out for presentation/ELSE steps so context menu stays usable; otherwise hide when not focused unless menu open
                      "group-hover:visible invisible": isRecorderView && !isFocused && !onOpenMore && !isPresentationStep(localStep),
                      "m-2": isRecorderView
                    }),
                    children: [
                      isFocused && !isDesktopSkipClear && (localStep.templateId || localStep.kibbutzPluginNlpId || localStep.isCustomFunction || !!localStep.uiMap?.objectBlocks?.length) && !localStep.disabled && !isDragMode && !isViewOnly && !isBulkActionMode && !localStep.isStepGroupChild && !localStep.isCustomFunction && !(localStep.applicationType === ApplicationType.WINDOWS_ADVANCED && (isConditionalIf(localStep) || isConditionalElseIf(localStep)) && [
                        TestStepType.NLP_TEXT,
                        TestStepType.STEP_GROUP,
                        TestStepType.API_STEP
                      ].includes(localStep.type)) && /* @__PURE__ */ jsx(
                        Icon,
                        {
                          className: "text-error-600 cursor-pointer whitespace-nowrap text-base mr-1",
                          onClick: () => onClear(localStep),
                          name: "erase",
                          toolTip: t("step.clear.step")
                        }
                      ),
                      !localStep.isConditionalLoop && localStep.visualEnabled && /* @__PURE__ */ jsx(
                        Icon,
                        {
                          name: "visual-difference",
                          onClick: () => openVisualFigmaViewModal?.(localStep, template),
                          className: classNames82(
                            "ml-2 text-warning-500 text-xl invisible group-hover:visible",
                            {
                              "cursor-pointer": hasFeatureValue2(
                                Feature.DESIGN_ASSET_VISUAL_ANALYSIS
                              )
                            }
                          )
                        }
                      ),
                      isFocused && !isRecorderView && !isPresentationStep(localStep) && /* @__PURE__ */ jsx(
                        StepLabel,
                        {
                          className: classNames82("flex-shrink-0 ml-2"),
                          content: getStepLabelText(localStep, t)
                        }
                      ),
                      !isFocused && !isRecorderView && !isPresentationStep(localStep) && !isViewOnly && /* @__PURE__ */ jsx(
                        StepLabel,
                        {
                          labelType: "primary-outline",
                          className: classNames82(
                            "flex-shrink-0 ml-2",
                            "invisible group-hover:visible"
                          ),
                          content: getStepLabelText(localStep, t)
                        }
                      ),
                      (!isViewOnly && !isPresentationStep(localStep) && !isBlock(localStep) && !isDragMode && !isBulkActionMode || isDebugMode) && /* @__PURE__ */ jsx(
                        StepActionIcons,
                        {
                          isStepFocused: isFocused,
                          onNestedCreateStep,
                          testStep: localStep,
                          orignalTestStep: step,
                          updateLocalStep,
                          saveStep: onSave,
                          updateWatchFocusOut: NOOP,
                          onCreateStep,
                          onRemoveStep,
                          onOpenMore,
                          onToggleMoreOptions: toggleMoreOptions,
                          onCloseMoreOptions: closeMoreOptions,
                          onOpenMoreChange: (open) => _updateOnOpenMore(open),
                          updateStepsInfo,
                          isDebugMode,
                          onToggleDebug,
                          debugPoints,
                          debuggerActions,
                          stepResult,
                          nextStep,
                          executedStepIds,
                          isIterationStepChild,
                          isEligibleForDebug,
                          hasFeature: hasFeatureValue2
                        }
                      ),
                      (isPresentationStep(localStep) && !localStep.isStepGroupChild || isBlock(localStep) && !localStep.isStepGroupChild) && /* @__PURE__ */ jsx(
                        DeleteStepButton,
                        {
                          onRemoveStep,
                          localStep,
                          isFocused
                        }
                      )
                    ]
                  }
                )
              ]
            }
          ),
          isFocused && !isPresentationStep(localStep) && (isStepValueChanged || !localStep.id || isStepInvalid) && /* @__PURE__ */ jsxs(
            "div",
            {
              className: "flex pr-2.5 pl-0.5 bg-white border-b border-secondary-50",
              role: step.id ? void 0 : "gridcell",
              children: [
                /* @__PURE__ */ jsxs("div", { className: "flex-grow flex", children: [
                  !isRecorderView && !isViewOnly && !localStep.isStepGroupChild && /* @__PURE__ */ jsx("span", { className: "min-w-[28px]" }),
                  /* @__PURE__ */ jsx(
                    Indent2,
                    {
                      size: localStep.indent,
                      showLine: isFocused,
                      step: localStep
                    }
                  ),
                  errorOnSave && /* @__PURE__ */ jsxs("div", { className: "bg-error-50 border border-error-100 flex items-center ml-9 my-3 px-3 rounded-lg text-error-500 text-small h-fit", children: [
                    /* @__PURE__ */ jsx(Icon, { name: "error-fill", className: "mr-1" }),
                    errorOnSave
                  ] }),
                  !isWebRecorder && /* @__PURE__ */ jsx(UrlValidationUI, { urlValidation })
                ] }),
                isShow() ? /* @__PURE__ */ jsxs(
                  "div",
                  {
                    className: "flex-shrink-0 py-3 inline-flex",
                    onMouseEnter: () => onMouseOverStepValidate(),
                    children: [
                      /* @__PURE__ */ jsx(
                        Button,
                        {
                          type: "secondary",
                          onClick: () => {
                            delete window["nonIframeStep"];
                            delete window["stepElementCloned"];
                            setLastFocusedStepNumber(null);
                            onCancel();
                          },
                          className: "text-unique-800",
                          isDisabled: isSaving,
                          children: t("common.cancel")
                        }
                      ),
                      /* @__PURE__ */ jsxs(
                        Button,
                        {
                          type: "primary",
                          className: "ml-2 inline-flex justify-center items-center w-28",
                          onClick: () => {
                            delete window["nonIframeStep"];
                            delete window["stepElementCloned"];
                            onSave();
                          },
                          isDisabled: Boolean(
                            !isStepValueChanged || isStepInvalid || errorOnSave || isSaving
                          ),
                          children: [
                            !isSaving && t(isEdit ? "step.update" : "step.create"),
                            isSaving && /* @__PURE__ */ jsx("span", { className: "w-6", children: /* @__PURE__ */ jsx(
                              Spinner,
                              {
                                size: 18,
                                thickness: 80,
                                speed: 140,
                                color: "#5E6C84",
                                secondaryColor: "rgba(172, 57, 57, 0)"
                              }
                            ) })
                          ]
                        }
                      )
                    ]
                  }
                ) : null
              ]
            }
          )
        ] })
      ]
    },
    step.id
  );
};
var formatted_step_default = FormattedStep;

// src/components/test-authoring/live-editor.ts
var LIVE_EDITOR_STEP_UNIQUE_KEY_SEPARATOR = "_";

// src/components/test-authoring/helper.ts
var DEFAULT_LOOP_INDEX = -1;
var isLoopParent = (result) => {
  return result.isLoopHeader || result.isLoopTitleV2;
};
var isParent = (result) => {
  return result.isExpandable || result.isAllConditionalStep || isLoopParent(result);
};
var getParentUuid = (result) => {
  return result.parentResultUuid || result.stepGroupResultUuid;
};
var calculateStepResultsTree = (_stepResults) => {
  if (!_stepResults?.length) return [];
  const mainResults = _stepResults.map((result) => {
    const processedResult = new TestStepResultModel().deserialize(result);
    processedResult.autoHealMetadata = result.autoHealMetadata;
    return processedResult;
  });
  const expandableResults = /* @__PURE__ */ new Map();
  mainResults.forEach((result) => {
    if (isParent(result)) {
      expandableResults.set(result.uuid, result);
    }
  });
  mainResults.forEach((result) => {
    const parentUuid = getParentUuid(result);
    const resultStepId = result.stepId || result.metadata.testStep.id;
    const parentResultsByStepId = [resultStepId];
    const debugStepId = [resultStepId].join(
      LIVE_EDITOR_STEP_UNIQUE_KEY_SEPARATOR
    );
    result.parentResultsByStepId = parentResultsByStepId;
    result.debugStepId = debugStepId;
    if (!parentUuid) return;
    const expandableParent = expandableResults.get(parentUuid);
    if (expandableParent) {
      result.expandParentResultUuid = parentUuid;
      const childResults = expandableParent.childResults || [];
      result.parentResultsByStepId = union$1(
        expandableParent?.parentResultsByStepId || [],
        [resultStepId]
      );
      result.debugStepId = result.parentResultsByStepId.join(
        LIVE_EDITOR_STEP_UNIQUE_KEY_SEPARATOR
      );
      childResults.push(result);
      expandableParent.childResults = childResults;
    }
  });
  return mainResults.map(
    (res) => expandableResults.get(res.uuid) || res
  );
};
function linkChildAndParent(steps) {
  if (!steps?.length) return [];
  const newSteps = steps.map((item) => new TestStep().deserialize(item));
  const itemMap = new Map(newSteps.map((item) => [item?.id, item]));
  const traceParentChain = (step) => {
    const parentByIds = [];
    let current = step;
    while (current.parentId) {
      const parent = itemMap.get(current.parentId);
      if (!parent) break;
      parentByIds.push(parent.id);
      current = parent;
    }
    return parentByIds.reverse();
  };
  for (const item of newSteps) {
    let parentByIds = traceParentChain(item);
    if (item.isStepGroupChild) {
      parentByIds = uniq([...item.parentStepGroupIds || [], ...parentByIds]);
    }
    item.debugStepId = uniq([
      ...parentByIds || [],
      item.id
    ]).join(LIVE_EDITOR_STEP_UNIQUE_KEY_SEPARATOR);
    if (parentByIds.length > 0) {
      item.parentByIds = parentByIds;
    }
  }
  return newSteps;
}
function linkChildAndParentPage(steps, appType) {
  if (!steps?.length) return [];
  const flattenedStepResponse = flatTestSteps({
    teststeps: steps.map(
      (item) => new TestStep().deserialize(item)
    ),
    applicationType: appType,
    page: 0
  });
  return linkChildAndParent(flattenedStepResponse);
}
function getLoopAndResultForAStep({
  step,
  stepResultTree,
  state = {}
}) {
  const parentStepIds = [...step?.parentByIds || [], step?.id];
  const processStepId = (acc, stepId) => {
    const item = find$1(
      acc.stepResultTree,
      (result2) => result2.metadata.testStep.id === stepId
    );
    if (!item?.childResults?.length) {
      return {
        childLoops: [],
        result: item,
        stepResultTree: []
      };
    }
    if (isLoopParent(item)) {
      const childResultLength = item.childResults.length;
      const dataToShow = state[stepId] ?? childResultLength + DEFAULT_LOOP_INDEX;
      return {
        childLoops: item.childResults,
        result: item.childResults[dataToShow],
        stepResultTree: item.childResults[dataToShow]?.childResults || []
      };
    }
    return {
      childLoops: [],
      result: item,
      stepResultTree: item.childResults
    };
  };
  const { childLoops, result } = parentStepIds.reduce(processStepId, {
    childLoops: [],
    result: void 0,
    stepResultTree
  });
  return { childLoops, result };
}
var LiveEditorTestStepContainer = ({
  data,
  fetchPage,
  hasNextPage,
  isViewOnly,
  hasAddStepButton,
  isReorderState,
  isRecorderView,
  applicationType,
  onAddStep,
  clientHeight,
  isBulkActionState,
  isWebRecorder,
  props,
  stepResults = [],
  debuggerActions,
  isDebugMode,
  debugPoints,
  stepCreationInProgress = 0,
  cursorStepId,
  modifiedSteps = {},
  selectedIterationByStepId = {},
  setSelectedIterationByStepId = NOOP
}) => {
  const { lastUpdatedStepId, isNoWrapSteps } = useContext(StepContext);
  const listRef = useRef();
  const lastFocusedRowIndex = useRef();
  const previousUpdatedStepId = useRef();
  const linkedSteps = useMemo(() => {
    return linkChildAndParentPage(data, applicationType);
  }, [data, applicationType]);
  const { debugExecutionStatus } = useStepContext();
  const resultTree = useMemo(() => {
    return calculateStepResultsTree(stepResults);
  }, [stepResults]);
  const handleLoadMore = (skipHasNextPage = false) => {
    const pageNumber = parseInt((data.length / TEST_STEP_PAGE_SIZE).toFixed());
    if (hasNextPage || skipHasNextPage)
      fetchPage(pageNumber, TEST_STEP_PAGE_SIZE);
  };
  const isResetPage = () => {
    return data.length === TEST_STEP_PAGE_SIZE;
  };
  const handleIterationChange = useCallback(
    ({
      stepId,
      iterationIndex
    }) => {
      setSelectedIterationByStepId((prev) => ({
        ...prev,
        [stepId]: iterationIndex
      }));
    },
    [setSelectedIterationByStepId]
  );
  function onDragEnd(result) {
    if (!result.destination) {
      return;
    }
    if (result.source.index === result.destination.index) {
      return;
    }
    props.onDrop({
      addedIndex: result.destination.index,
      removedIndex: result.source.index,
      resultId: result.draggableId
    });
  }
  function onDragStart(data2) {
    props.onDragStart(data2);
  }
  const renderStepsList = useMemo(() => {
    const loadingSteps = stepCreationInProgress > 0 ? Array(stepCreationInProgress).fill(null).map((_, idx) => ({ id: `stepLoading-${idx + 1}` })) : [];
    let steps;
    if (loadingSteps.length > 0 && cursorStepId) {
      const cursorIndex = linkedSteps.findIndex(
        (step) => step.id === cursorStepId
      );
      if (cursorIndex >= 0) {
        steps = [
          ...linkedSteps.slice(0, cursorIndex + 1),
          ...loadingSteps,
          ...linkedSteps.slice(cursorIndex + 1)
        ];
      } else {
        steps = [...linkedSteps, ...loadingSteps];
      }
    } else {
      steps = [
        ...linkedSteps,
        ...stepCreationInProgress > 0 ? loadingSteps : [{ id: "addstep" }]
      ];
    }
    steps.push(
      ...Array(5).fill(1).map((i, idx) => ({
        id: `filter-${idx}`
      }))
    );
    return steps;
  }, [linkedSteps, stepCreationInProgress, cursorStepId]);
  const isInbetweenAddStepPresent = useMemo(() => {
    return renderStepsList.some((step) => step.id === void 0);
  }, [renderStepsList]);
  const isCopilotBatch = useMemo(() => {
    const hasAI = renderStepsList.some(
      (step) => step?.createType === EntityCreateType.AI
    );
    return hasAI;
  }, [renderStepsList]);
  const scrollToStepIndex = useMemo(() => {
    return isRecorderView && lastUpdatedStepId ? renderStepsList.findIndex((step) => step?.id === lastUpdatedStepId) : -1;
  }, [lastUpdatedStepId, renderStepsList, isRecorderView]);
  useEffect(() => {
    if (isCopilotBatch) return;
    if (listRef?.current && scrollToStepIndex != -1 && lastUpdatedStepId !== previousUpdatedStepId.current && (!!lastFocusedRowIndex.current && lastFocusedRowIndex.current > scrollToStepIndex || !isInbetweenAddStepPresent)) {
      lastFocusedRowIndex.current = scrollToStepIndex;
      previousUpdatedStepId.current = lastUpdatedStepId;
      listRef.current.scrollToRow(scrollToStepIndex);
    }
  }, [
    isCopilotBatch,
    scrollToStepIndex,
    listRef.current,
    isInbetweenAddStepPresent,
    lastUpdatedStepId
  ]);
  useInternalEvents(["test-steps-loadmore"], () => handleLoadMore(true));
  const getIsEdit = (step) => {
    if (!step) {
      return false;
    }
    if (isDebugMode && step?.id === -1) {
      return false;
    }
    return Boolean(step?.id);
  };
  const getStepResult = useCallback(
    (step) => {
      const { childLoops, result } = getLoopAndResultForAStep({
        step,
        stepResultTree: resultTree,
        state: selectedIterationByStepId
      });
      let iterationProps = {};
      if (step.isConditionalLoop && childLoops.length > 0) {
        iterationProps = {
          iterationItems: childLoops,
          selectedIterationIndex: selectedIterationByStepId[step.id] ?? childLoops.length - 1,
          onIterationChange: handleIterationChange
        };
      }
      const isModified = (modifiedSteps[step.id] || []).includes(result?.uuid);
      return {
        stepResult: !isModified ? result : {},
        ...iterationProps
      };
    },
    [
      resultTree,
      selectedIterationByStepId,
      modifiedSteps,
      handleIterationChange
    ]
  );
  const disableAddStep = !debugExecutionStatus || debugExecutionStatus === ResultConstant.RUNNING || debugExecutionStatus === ResultConstant.QUEUED;
  const getStepItemKey = useCallback((step, index = 0) => {
    if (!step) return `unknown-${index}`;
    return `${step.id ?? "idless"}-${step.stepNumber ?? "n"}-${index}`;
  }, []);
  return props.isViewOnlySingle ? /* @__PURE__ */ jsx(
    formatted_step_default,
    {
      step: data[0],
      isViewOnly: props.isViewOnly,
      isViewOnlySingle: props.isViewOnlySingle,
      hasAddStepButton: props.hasAddStepButton,
      getTestData: props.getTestData,
      onCreateStep: props.getTestData,
      onUpdateStep: props.onUpdateStep,
      onRemoveStep: props.onRemoveStep,
      onChangeType: props.onChangeType,
      onNestedCreateStep: props.onNestedCreateStep,
      onSearch: props.onSearch,
      isFetching: props.isFetching,
      isCommand: props.isCommand,
      isCommandCombine: props.isCommandCombine,
      dataParameterList: props.dataParameterList,
      dataProfileList: props.dataProfileList,
      dataSetList: props.dataSetList,
      isExpaned: props.stepToggleUtils.isStepExpanded(data[0]),
      updateSelectedDataProfile: props.updateSelectedDataProfile,
      index: 0,
      isEdit: getIsEdit(data[0]),
      isDebugMode,
      ...getStepResult(data[0])
    }
  ) : /* @__PURE__ */ jsx("div", { className: "pt-2 h-full !static", children: /* @__PURE__ */ jsx(DragDropContext, { onDragEnd, onDragStart, children: /* @__PURE__ */ jsx(
    Droppable,
    {
      droppableId: "droppable",
      mode: "virtual",
      renderClone: (provided, snapshot, rubric) => /* @__PURE__ */ createElement(
        "div",
        {
          ref: provided.innerRef,
          ...provided.draggableProps,
          key: rubric.source.index
        },
        /* @__PURE__ */ jsx(
          formatted_step_default,
          {
            step: data[rubric.source.index],
            isViewOnly: props.isViewOnly,
            isViewOnlySingle: props.isViewOnlySingle,
            hasAddStepButton: props.hasAddStepButton,
            getTestData: props.getTestData,
            onCreateStep: props.onCreateStep,
            onUpdateStep: props.onUpdateStep,
            onRemoveStep: props.onRemoveStep,
            onChangeType: props.onChangeType,
            onNestedCreateStep: props.onNestedCreateStep,
            onSearch: props.onSearch,
            isFetching: props.isFetching,
            isCommand: props.isCommand,
            isCommandCombine: props.isCommandCombine,
            dataParameterList: props.dataParameterList,
            dataProfileList: props.dataProfileList,
            customFunctionList: props.customFunctionList,
            dataSetList: props.dataSetList,
            isExpaned: props.stepToggleUtils.isStepExpanded(
              data[rubric.source.index]
            ),
            updateSelectedDataProfile: props.updateSelectedDataProfile,
            index: rubric.source.index,
            provided,
            fetchConnections: props.fetchConnections,
            actionCallback: props.actionCallback,
            salesforceActions: props.salesforceActions,
            uploadActions: props.uploadActions,
            sessionActions: props.sessionActions,
            isEdit: getIsEdit(data[rubric.source.index]),
            isDebugMode,
            ...getStepResult(data[rubric.source.index])
          }
        )
      ),
      children: (droppableProvided) => /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
        InfiniteScroll,
        {
          minHeight: isDebugMode ? 28 : 40,
          className: classNames82({
            "step-group-list-items": isNoWrapSteps
          }),
          getItemKey: getStepItemKey,
          itemRender: ({ item, index, measure }) => {
            return /* @__PURE__ */ jsx(Fragment$1, { children: !item?.id?.startsWith?.("filter") && (item.id === "addstep" ? /* @__PURE__ */ jsx(Fragment, { children: !disableAddStep && hasAddStepButton && !isViewOnly && !isReorderState && !isBulkActionState ? /* @__PURE__ */ jsx(
              AddStep,
              {
                isRecorderView,
                isDebugMode,
                steps: data,
                testCaseId: props?.testCaseId,
                applicationType,
                hasAddStepButton,
                onChangeType: props?.onChangeType,
                onAddStep
              }
            ) : isViewOnly ? null : /* @__PURE__ */ jsx("div", { className: "my-3" }) }) : item?.id?.startsWith?.("stepLoading") ? /* @__PURE__ */ jsxs("div", { className: "my-2 flex items-center pl-[29px]", children: [
              /* @__PURE__ */ jsx(ShimmerLoader, { className: "w-[18px] rounded-lg mr-3.5 !h-4" }),
              /* @__PURE__ */ jsx(
                ShimmerLoader,
                {
                  className: `rounded-md !h-4 w-4/5`
                }
              )
            ] }) : /* @__PURE__ */ jsx(
              Draggable,
              {
                draggableId: `draggable-step-${item?.id}`,
                index,
                isDragDisabled: disableAddStep || item.id === "-" || item.id === void 0 || props.stepToggleUtils.isStepExpanded(item) && (item.isBlock || item.isStepGroup) || item.isStepGroupChild || isConditionalStep(item) || [
                  TestStepType.BREAK_LOOP,
                  TestStepType.CONTINUE_LOOP
                ].includes(item?.type),
                children: (provided) => /* @__PURE__ */ createElement(
                  "div",
                  {
                    ref: provided.innerRef,
                    ...provided.draggableProps,
                    key: getStepItemKey(item, index)
                  },
                  /* @__PURE__ */ jsx(
                    formatted_step_default,
                    {
                      measure,
                      step: item,
                      isViewOnly: props.isViewOnly,
                      isViewOnlySingle: props.isViewOnlySingle,
                      hasAddStepButton: props.hasAddStepButton,
                      getTestData: props.getTestData,
                      onCreateStep: props.onCreateStep,
                      onUpdateStep: props.onUpdateStep,
                      onRemoveStep: props.onRemoveStep,
                      onChangeType: props.onChangeType,
                      onNestedCreateStep: props.onNestedCreateStep,
                      onSearch: props.onSearch,
                      isFetching: props.isFetching,
                      isCommand: props.isCommand,
                      isCommandCombine: props.isCommandCombine,
                      debuggerActions,
                      dataParameterList: props.dataParameterList,
                      dataProfileList: props.dataProfileList,
                      customFunctionList: props.customFunctionList,
                      dataSetList: props.dataSetList,
                      isExpaned: props.stepToggleUtils.isStepExpanded(
                        item
                      ),
                      updateSelectedDataProfile: props.updateSelectedDataProfile,
                      index,
                      provided,
                      isDebugMode,
                      onToggleDebug: debuggerActions?.onToggleDebug,
                      debugPoints,
                      fetchConnections: props.fetchConnections,
                      actionCallback: props.actionCallback,
                      salesforceActions: props.salesforceActions,
                      uploadActions: props.uploadActions,
                      sessionActions: props.sessionActions,
                      isEdit: getIsEdit(item),
                      ...getStepResult(item)
                    },
                    getStepItemKey(item, index)
                  )
                )
              },
              getStepItemKey(item, index)
            )) }, getStepItemKey(item, index));
          },
          items: renderStepsList,
          loadMore: () => handleLoadMore(),
          hasMore: hasNextPage,
          LoadingComponent: /* @__PURE__ */ jsx(
            ShimmerLoader,
            {
              type: "line",
              size: "lg",
              className: "!h-2 rounded w-full px-4"
            }
          ),
          listHeight: isWebRecorder ? window.innerHeight - 115 : isRecorderView ? window.innerHeight - 180 : props.isAfterTestCase || props.afterTestCaseId ? clientHeight - 115 : clientHeight - 10,
          listRef: (ref) => {
            if (!ref) return;
            listRef.current = ref;
            const scrollContainer = ref?.Grid?.scrollingContainer || ref?.Grid?._scrollingContainer;
            if (scrollContainer instanceof HTMLElement) {
              droppableProvided.innerRef(scrollContainer);
            }
          },
          isDynamicHeight: isDebugMode,
          isDynamicHeightList: true,
          disableHeight: true,
          resetPage: isResetPage()
        }
      ) })
    }
  ) }) });
};
var live_editor_test_step_container_default = LiveEditorTestStepContainer;
var TestStepContainer = ({
  data,
  fetchPage,
  hasNextPage,
  isViewOnly,
  hasAddStepButton,
  isReorderState,
  isRecorderView,
  applicationType,
  onAddStep,
  clientHeight,
  isBulkActionState,
  isWebRecorder,
  props,
  executedStepIds,
  stepResults = [],
  debuggerActions,
  resumedStepResultId,
  currentExecutingStep,
  isDebugMode,
  debugPoints,
  isExecutingRun,
  stepCreationInProgress = 0,
  cursorStepId
}) => {
  const [collapsedStepResults, updateCollapsedStepResults] = useState([]);
  const { lastUpdatedStepId, isNoWrapSteps } = useContext(StepContext);
  const listRef = useRef();
  const lastFocusedRowIndex = useRef();
  const previousUpdatedStepId = useRef();
  const handleLoadMore = (skipHasNextPage = false) => {
    const pageNumber = parseInt((data.length / TEST_STEP_PAGE_SIZE).toFixed());
    if (hasNextPage || skipHasNextPage)
      fetchPage(pageNumber, TEST_STEP_PAGE_SIZE);
  };
  const isResetPage = () => {
    return data.length === TEST_STEP_PAGE_SIZE;
  };
  function onDragEnd(result) {
    if (!result.destination) {
      return;
    }
    if (result.source.index === result.destination.index) {
      return;
    }
    props.onDrop({
      addedIndex: result.destination.index,
      removedIndex: result.source.index,
      resultId: result.draggableId
    });
  }
  function onDragStart(data2) {
    props.onDragStart(data2);
  }
  const findIsThisIterationChild = useCallback(
    (uuid) => {
      const currentStep = stepResults.find((step) => step.uuid === uuid);
      if (currentStep?.parentResultUuid) {
        const parentStep = stepResults.find(
          (step) => step.uuid === currentStep.parentResultUuid
        );
        if (!!parentStep?.metadata?.forLoop?.iteration) {
          return true;
        } else if (parentStep?.parentResultUuid) {
          return findIsThisIterationChild(parentStep.parentResultUuid);
        }
      }
      return false;
    },
    [stepResults]
  );
  const dataWithReOrderIndex = useMemo(() => {
    return data?.map((item, index) => {
      return {
        ...item,
        reOrderIndex: index
      };
    });
  }, [data]);
  const notExecutedSteps = useMemo(() => {
    if (stepResults.length == 0) return dataWithReOrderIndex;
    const lastStepResult = stepResults.slice(-1).pop();
    const lastIndex = dataWithReOrderIndex.findLastIndex(
      (step) => step.id == lastStepResult?.metadata?.testStep?.id
    );
    const queuedSteps = dataWithReOrderIndex.slice(lastIndex + 1);
    if (queuedSteps.length == dataWithReOrderIndex.length && stepResults.length > 0)
      return [];
    return queuedSteps;
  }, [dataWithReOrderIndex, stepResults]);
  const nextStep = useMemo(() => {
    for (const step of notExecutedSteps || []) {
      if (!step?.disabled && !step?.isForLoop && step?.conditionType !== TestStepConditionType.LOOP_FOR && step?.conditionType !== TestStepConditionType.LOOP_WHILE && !step?.isConditionalWhileLoop && !step?.isBlock) {
        return step;
      }
    }
    return null;
  }, [notExecutedSteps]);
  const isExecutionCompleted = useMemo(() => {
    const completeStatus = [
      ResultConstant.SUCCESS,
      ResultConstant.ABORTED,
      ResultConstant.STOPPED
    ];
    if (!isWebRecorder) {
      completeStatus.push(ResultConstant.FAILURE);
    }
    return completeStatus.includes(currentExecutingStep?.result);
  }, [currentExecutingStep, isWebRecorder]);
  const _stepResults = useCallback(() => {
    const childCollapsedList = [...collapsedStepResults];
    stepResults.forEach((result) => {
      if (isBlock(result?.testStep) && result.uuid && childCollapsedList.includes(result.parentResultUuid)) {
        childCollapsedList.push(result.uuid);
      }
      if (isStepGroup(result?.testStep) && result.uuid && childCollapsedList.includes(result.stepGroupResultUuid)) {
        childCollapsedList.push(result.uuid);
      }
    });
    let processedStepResults = stepResults.filter((result) => {
      if (result.stepGroupResultUuid && childCollapsedList.includes(result.stepGroupResultUuid))
        return false;
      if (result.parentResultUuid && childCollapsedList.includes(result.parentResultUuid))
        return false;
      return true;
    });
    const lastIndex = processedStepResults?.length - 1;
    const lastResult = processedStepResults?.[lastIndex];
    const step = findStepById(data, lastResult?.metadata?.testStep?.id);
    if (lastResult?.metadata?.testStep?.id && [ResultConstant.PAUSED, ResultConstant.FAILURE].includes(
      lastResult?.result
    ) && step && !isExecutionCompleted && !isWebRecorder) {
      const newResultObj = {
        ...lastResult || {}
      };
      newResultObj.result = isExecutingRun ? ResultConstant.RUNNING : ResultConstant.PAUSED;
      newResultObj.stepId = step?.id;
      newResultObj.uuid = "new";
      newResultObj.id = "new";
      newResultObj.metadata.testStep = step;
      newResultObj.canShowRerun = lastResult?.metadata?.testStep?.id === step?.id && lastResult?.result === ResultConstant.PAUSED;
      if (lastResult?.result == ResultConstant.PAUSED) {
        processedStepResults[lastIndex] = newResultObj;
      } else {
        processedStepResults = [
          ...processedStepResults,
          newResultObj
        ];
      }
    }
    const stepMap = data.reduce((prev, cur) => {
      prev[cur?.id] = cur;
      return prev;
    }, []);
    return processedStepResults.map((_stepResult) => {
      const stepResult = cloneDeep(_stepResult);
      const nextStepId = stepResult?.metadata?.testStep?.id + 1;
      const nextStepResult = stepMap[nextStepId];
      if (stepResult?.metadata?.testStep?.id && stepMap[stepResult?.metadata?.testStep?.id]) {
        stepResult.metadata.testStep = stepMap[stepResult?.metadata?.testStep?.id];
      } else if (nextStepId && nextStepResult) {
        stepResult.metadata.testStep = nextStepResult;
      }
      return stepResult;
    });
  }, [
    collapsedStepResults,
    stepResults,
    data,
    isExecutionCompleted,
    isWebRecorder,
    isExecutingRun
  ]);
  useEffect(() => {
    window["stepReorderState"] = isReorderState;
    return () => {
      window["stepReorderState"] = false;
    };
  }, [isReorderState]);
  const getRenderedSteps = useCallback(() => {
    return [..._stepResults(), ...notExecutedSteps];
  }, [_stepResults, notExecutedSteps]);
  const renderStepsList = useMemo(() => {
    const allSteps = getRenderedSteps();
    const loadingSteps = stepCreationInProgress > 0 ? Array(stepCreationInProgress).fill(null).map((_, idx) => ({ id: `stepLoading-${idx + 1}` })) : [];
    let steps;
    if (loadingSteps.length > 0 && cursorStepId) {
      const cursorIndex = allSteps.findIndex(
        (step) => step.id === cursorStepId
      );
      if (cursorIndex >= 0) {
        steps = [
          ...allSteps.slice(0, cursorIndex + 1),
          ...loadingSteps,
          ...allSteps.slice(cursorIndex + 1)
        ];
      } else {
        steps = [...allSteps, ...loadingSteps];
      }
    } else {
      steps = [
        ...allSteps,
        ...stepCreationInProgress > 0 ? loadingSteps : [{ id: "addstep" }]
      ];
    }
    steps.push(
      ...Array(5).fill(1).map((i, idx) => ({
        id: `filter-${idx}`
      }))
    );
    return steps;
  }, [getRenderedSteps, stepCreationInProgress, cursorStepId]);
  const isInbetweenAddStepPresent = useMemo(() => {
    return renderStepsList.some((step) => step.id === void 0);
  }, [renderStepsList]);
  const isCopilotBatch = useMemo(() => {
    const hasAI = renderStepsList.some(
      (step) => step?.createType === EntityCreateType.AI
    );
    return hasAI;
  }, [renderStepsList]);
  const lastExecutedStepResultIndex = useMemo(() => {
    if (isDebugMode) {
      return stepResults?.length ? stepResults.length - 1 : null;
    }
    return null;
  }, [stepResults, isDebugMode]);
  const scrollToStepIndex = useMemo(() => {
    return lastExecutedStepResultIndex !== null ? lastExecutedStepResultIndex : isRecorderView && lastUpdatedStepId ? renderStepsList.findIndex((step) => step?.id === lastUpdatedStepId) : -1;
  }, [lastUpdatedStepId, renderStepsList, lastExecutedStepResultIndex]);
  useEffect(() => {
    if (isCopilotBatch) return;
    if (listRef?.current && scrollToStepIndex != -1 && lastUpdatedStepId !== previousUpdatedStepId.current && (!!lastFocusedRowIndex.current && lastFocusedRowIndex.current > scrollToStepIndex || !isInbetweenAddStepPresent)) {
      lastFocusedRowIndex.current = scrollToStepIndex;
      previousUpdatedStepId.current = lastUpdatedStepId;
      listRef.current.scrollToRow(scrollToStepIndex);
    }
  }, [
    isCopilotBatch,
    scrollToStepIndex,
    listRef.current,
    isInbetweenAddStepPresent,
    lastUpdatedStepId
  ]);
  useInternalEvents(["test-steps-loadmore"], () => handleLoadMore(true));
  const getIsEdit = (step) => {
    if (!step) {
      return false;
    }
    if (isDebugMode && step?.id === -1) {
      return false;
    }
    return Boolean(step?.id);
  };
  return props.isViewOnlySingle ? /* @__PURE__ */ jsx(
    formatted_step_default,
    {
      step: data[0],
      isViewOnly: props.isViewOnly,
      isViewOnlySingle: props.isViewOnlySingle,
      hasAddStepButton: props.hasAddStepButton,
      getTestData: props.getTestData,
      onCreateStep: props.onCreateStep,
      onUpdateStep: props.onUpdateStep,
      onRemoveStep: props.onRemoveStep,
      onChangeType: props.onChangeType,
      onNestedCreateStep: props.onNestedCreateStep,
      onSearch: props.onSearch,
      isFetching: props.isFetching,
      isCommand: props.isCommand,
      isCommandCombine: props.isCommandCombine,
      dataParameterList: props.dataParameterList,
      dataProfileList: props.dataProfileList,
      dataSetList: props.dataSetList,
      isExpaned: props.stepToggleUtils.isStepExpanded(data[0]),
      updateSelectedDataProfile: props.updateSelectedDataProfile,
      index: 0,
      isEdit: getIsEdit(data[0]),
      isDebugMode
    }
  ) : /* @__PURE__ */ jsx("div", { className: "pt-2 h-full !static", children: /* @__PURE__ */ jsx(DragDropContext, { onDragEnd, onDragStart, children: /* @__PURE__ */ jsx(
    Droppable,
    {
      droppableId: "droppable",
      mode: "virtual",
      renderClone: (provided, snapshot, rubric) => {
        const { role, tabIndex, ...draggablePropsWithoutInteractive } = provided.draggableProps || {};
        return /* @__PURE__ */ createElement(
          "div",
          {
            ref: provided.innerRef,
            ...draggablePropsWithoutInteractive,
            key: rubric.source.index
          },
          /* @__PURE__ */ jsx(
            formatted_step_default,
            {
              step: data[rubric.source.index],
              isViewOnly: props.isViewOnly,
              isViewOnlySingle: props.isViewOnlySingle,
              hasAddStepButton: props.hasAddStepButton,
              getTestData: props.getTestData,
              onCreateStep: props.onCreateStep,
              onUpdateStep: props.onUpdateStep,
              onRemoveStep: props.onRemoveStep,
              onChangeType: props.onChangeType,
              onNestedCreateStep: props.onNestedCreateStep,
              onSearch: props.onSearch,
              isFetching: props.isFetching,
              isCommand: props.isCommand,
              isCommandCombine: props.isCommandCombine,
              dataParameterList: props.dataParameterList,
              dataProfileList: props.dataProfileList,
              customFunctionList: props.customFunctionList,
              dataSetList: props.dataSetList,
              isExpaned: props.stepToggleUtils.isStepExpanded(
                data[rubric.source.index]
              ),
              updateSelectedDataProfile: props.updateSelectedDataProfile,
              index: rubric.source.index,
              provided,
              fetchConnections: props.fetchConnections,
              actionCallback: props.actionCallback,
              salesforceActions: props.salesforceActions,
              uploadActions: props.uploadActions,
              sessionActions: props.sessionActions,
              isEdit: getIsEdit(data[rubric.source.index]),
              isDebugMode
            }
          )
        );
      },
      children: (droppableProvided) => /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
        InfiniteScroll,
        {
          minHeight: isDebugMode ? 28 : 40,
          className: classNames82({
            "step-group-list-items": isNoWrapSteps
          }),
          itemRender: ({ item, index, measure }) => /* @__PURE__ */ jsx(Fragment$1, { children: !item?.id?.startsWith?.("filter") && (item.id === "addstep" ? /* @__PURE__ */ jsx(Fragment, { children: hasAddStepButton && !isViewOnly && !isReorderState && !isBulkActionState ? /* @__PURE__ */ jsx(
            AddStep,
            {
              isRecorderView,
              isDebugMode,
              steps: data,
              testCaseId: props?.testCaseId,
              applicationType,
              hasAddStepButton,
              onChangeType: props?.onChangeType,
              onAddStep
            }
          ) : isViewOnly ? null : /* @__PURE__ */ jsx("div", { className: "my-3" }) }) : item?.id?.startsWith?.("stepLoading") ? /* @__PURE__ */ jsxs("div", { className: "my-2 flex items-center pl-[29px]", children: [
            /* @__PURE__ */ jsx(ShimmerLoader, { className: "w-[18px] rounded-lg mr-3.5 !h-4" }),
            /* @__PURE__ */ jsx(ShimmerLoader, { className: `rounded-md !h-4 w-4/5` })
          ] }) : /* @__PURE__ */ jsx(Fragment, { children: item && item?.metadata?.testStep ? item?.metadata?.testStep ?? item?.metadata?.testStep?.id ? item?.result !== ResultConstant.PAUSED && (isWebRecorder ? !item?.isEligibleForDebug : true) ? /* @__PURE__ */ jsx(
            executed_step_default,
            {
              step: item?.metadata?.testStep || item?.stepDetail,
              stepResult: item,
              isActive: false,
              debuggerActions,
              isExecuting: (isExecutingRun || isWebRecorder) && resumedStepResultId === item.uuid,
              nextStep,
              collapsedStepResults,
              updateCollapsedStepResults,
              measure
            },
            `${item?.id}-${item.result}`
          ) : /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
            formatted_step_default,
            {
              measure,
              step: item?.metadata?.testStep || item?.stepDetail,
              isViewOnly: props.isViewOnly,
              isViewOnlySingle: props.isViewOnlySingle,
              hasAddStepButton: props.hasAddStepButton,
              getTestData: props.getTestData,
              onCreateStep: props.onCreateStep,
              onUpdateStep: props.onUpdateStep,
              onRemoveStep: props.onRemoveStep,
              onChangeType: props.onChangeType,
              onNestedCreateStep: props.onNestedCreateStep,
              onSearch: props.onSearch,
              isFetching: props.isFetching,
              isCommand: props.isCommand,
              isCommandCombine: props.isCommandCombine,
              dataParameterList: props.dataParameterList,
              dataProfileList: props.dataProfileList,
              customFunctionList: props.customFunctionList,
              dataSetList: props.dataSetList,
              isExpaned: props.stepToggleUtils.isStepExpanded(
                item?.metadata?.testStep || item?.stepDetail
              ),
              updateSelectedDataProfile: props.updateSelectedDataProfile,
              index,
              isDebugMode,
              onToggleDebug: debuggerActions?.onToggleDebug,
              debugPoints,
              executedStepIds,
              debuggerActions,
              stepResult: item,
              nextStep,
              isIterationStepChild: findIsThisIterationChild(
                item?.uuid
              ),
              isEligibleForDebug: item?.isEligibleForDebug,
              listRef,
              isEdit: getIsEdit(
                item?.metadata?.testStep || item?.stepDetail
              ),
              salesforceActions: props.salesforceActions
            },
            `step-${item?.id}`
          ) }) : null : item.id && !isViewOnly && !isBulkActionState ? /* @__PURE__ */ jsx(
            Draggable,
            {
              draggableId: `draggable-step-${item?.id}`,
              index: item.reOrderIndex ?? index,
              isDragDisabled: item.id === "-" || item.id === void 0 || props.stepToggleUtils.isStepExpanded(item) && (item.isBlock || item.isStepGroup) || item.isStepGroupChild || isConditionalStep(item) || [
                TestStepType.BREAK_LOOP,
                TestStepType.CONTINUE_LOOP
              ].includes(item?.type),
              children: (provided) => {
                const { role: draggableRole, tabIndex, ...draggablePropsWithoutInteractive } = provided.draggableProps || {};
                return /* @__PURE__ */ createElement(
                  "div",
                  {
                    ref: provided.innerRef,
                    ...draggablePropsWithoutInteractive,
                    role: "row",
                    key: index
                  },
                  /* @__PURE__ */ jsx(
                    formatted_step_default,
                    {
                      measure,
                      step: item,
                      isViewOnly: props.isViewOnly,
                      isViewOnlySingle: props.isViewOnlySingle,
                      hasAddStepButton: props.hasAddStepButton,
                      getTestData: props.getTestData,
                      onCreateStep: props.onCreateStep,
                      onUpdateStep: props.onUpdateStep,
                      onRemoveStep: props.onRemoveStep,
                      onChangeType: props.onChangeType,
                      onNestedCreateStep: props.onNestedCreateStep,
                      onSearch: props.onSearch,
                      isFetching: props.isFetching,
                      isCommand: props.isCommand,
                      isCommandCombine: props.isCommandCombine,
                      dataParameterList: props.dataParameterList,
                      dataProfileList: props.dataProfileList,
                      customFunctionList: props.customFunctionList,
                      dataSetList: props.dataSetList,
                      isExpaned: props.stepToggleUtils.isStepExpanded(
                        item
                      ),
                      updateSelectedDataProfile: props.updateSelectedDataProfile,
                      index,
                      provided,
                      isDebugMode,
                      onToggleDebug: debuggerActions?.onToggleDebug,
                      debugPoints,
                      executedStepIds,
                      fetchConnections: props.fetchConnections,
                      actionCallback: props.actionCallback,
                      salesforceActions: props.salesforceActions,
                      uploadActions: props.uploadActions,
                      sessionActions: props.sessionActions,
                      isEdit: getIsEdit(item)
                    },
                    `step-${item.id}`
                  )
                );
              }
            },
            item?.id
          ) : /* @__PURE__ */ jsx(
            formatted_step_default,
            {
              step: item,
              measure,
              isViewOnly: props.isViewOnly,
              isViewOnlySingle: props.isViewOnlySingle,
              hasAddStepButton: props.hasAddStepButton,
              getTestData: props.getTestData,
              onCreateStep: props.onCreateStep,
              onUpdateStep: props.onUpdateStep,
              onRemoveStep: props.onRemoveStep,
              onChangeType: props.onChangeType,
              onNestedCreateStep: props.onNestedCreateStep,
              onSearch: props.onSearch,
              isFetching: props.isFetching,
              isCommand: props.isCommand,
              isCommandCombine: props.isCommandCombine,
              dataParameterList: props.dataParameterList,
              dataProfileList: props.dataProfileList,
              customFunctionList: props.customFunctionList,
              dataSetList: props.dataSetList,
              isExpaned: props.stepToggleUtils.isStepExpanded(
                item
              ),
              updateSelectedDataProfile: props.updateSelectedDataProfile,
              index,
              fetchConnections: props.fetchConnections,
              actionCallback: props.actionCallback,
              salesforceActions: props.salesforceActions,
              uploadActions: props.uploadActions,
              sessionActions: props.sessionActions,
              isEdit: getIsEdit(item),
              isDebugMode
            },
            `step-${item.id}`
          ) })) }, item.id),
          items: renderStepsList,
          loadMore: () => handleLoadMore(),
          hasMore: hasNextPage,
          LoadingComponent: /* @__PURE__ */ jsx(
            ShimmerLoader,
            {
              type: "line",
              size: "lg",
              className: "!h-2 rounded w-full px-4"
            }
          ),
          listHeight: isWebRecorder ? window.innerHeight - 115 : isRecorderView ? window.innerHeight - 180 : props.isAfterTestCase || props.afterTestCaseId ? clientHeight - 115 : clientHeight - 10,
          listRef: (ref) => {
            if (!ref) return;
            listRef.current = ref;
            const scrollContainer = ref?.Grid?.scrollingContainer || ref?.Grid?._scrollingContainer;
            if (scrollContainer instanceof HTMLElement) {
              droppableProvided.innerRef(scrollContainer);
            }
          },
          isDynamicHeight: isDebugMode,
          isDynamicHeightList: true,
          disableHeight: true,
          resetPage: isResetPage()
        }
      ) })
    }
  ) }) });
};
var test_step_container_default = TestStepContainer;
var TestStepManagement = (props) => {
  const { isDebugMode } = useStepContext();
  if (isDebugMode) {
    return /* @__PURE__ */ jsx(live_editor_test_step_container_default, { ...props });
  }
  return /* @__PURE__ */ jsx(test_step_container_default, { ...props });
};
var test_management_default = TestStepManagement;
var getActualIndexFromViewIndex = (steps, toggledBlocks, index) => {
  const filteredStep = steps.filter(
    (item) => !item.blockParentId || toggledBlocks?.includes(item?.blockParentId)
  )[index];
  return steps.findIndex((item) => item?.id == filteredStep?.id);
};
var findLocalStepFromFeedIndex = (feedIndex, feedStepsArr, localStepsArr, currentTestCaseId) => {
  if (feedIndex < 0 || feedIndex >= feedStepsArr.length) {
    return { step: void 0, index: -1 };
  }
  const feedStep = feedStepsArr[feedIndex];
  if (!feedStep) {
    return { step: void 0, index: -1 };
  }
  if (String(feedStep.testCaseId) === String(currentTestCaseId)) {
    const index = localStepsArr.findIndex((s) => s.id === feedStep.id);
    return { step: localStepsArr[index], index };
  }
  let idx = feedIndex - 1;
  while (idx >= 0) {
    const step = feedStepsArr[idx];
    if (String(step.testCaseId) === String(currentTestCaseId)) {
      const localIndex = localStepsArr.findIndex((s) => s.id === step.id);
      return { step: localStepsArr[localIndex], index: localIndex };
    }
    idx--;
  }
  return { step: void 0, index: -1 };
};
var applyOperationsRecursively = (steps, stepToggleUtils, skipBlockFilterId = null, parentStep = null, allSteps = null) => {
  const stepsSource = allSteps || steps;
  const finalSteps = [];
  const tempSteps = steps.filter(
    (step) => !step.blockParentId || step.blockParentId == skipBlockFilterId
  );
  tempSteps.forEach((originalStep) => {
    const step = new TestStep().deserialize(originalStep);
    let expandSteps = [];
    step.isParentStepGroupDisabled = parentStep?.disabled || parentStep?.isParentStepGroupDisabled || false;
    if (isStepGroup(step) && stepToggleUtils.isStepExpanded(step)) {
      const sgChildren = stepToggleUtils.cachedStepGroupChildren?.current?.[step.id] || [];
      expandSteps = applyOperationsRecursively(
        sgChildren,
        stepToggleUtils,
        null,
        step,
        sgChildren
      );
    }
    if (isBlock(step) && stepToggleUtils.isStepExpanded(step)) {
      expandSteps = stepsSource.filter(
        (item) => item.blockParentId === step.id
      );
      expandSteps = applyOperationsRecursively(
        expandSteps,
        stepToggleUtils,
        step.id,
        step,
        stepsSource
      );
    }
    finalSteps.push(step, ...expandSteps);
  });
  return finalSteps;
};
var useStepToggle = (fetchStepGroupSteps, fetchTestCaseById) => {
  const [isExpanding, updateExpanding] = useState([]);
  const [expandedStepGroup, updateExpandedStepGroup] = useState([]);
  const [expandedBlockStep, updateExpandedBlockStep] = useState([]);
  const cachedStepGroupChildren = useRef({});
  const cachedStepBlockChildren = useRef({});
  const isStepExpanded = useCallback(
    (step) => {
      if (isBlock(step)) return expandedBlockStep.includes(step.id);
      else if (isStepGroup(step)) return expandedStepGroup.includes(step.id);
    },
    [expandedBlockStep, expandedStepGroup]
  );
  const toggleStepBlockExpand = useCallback(
    (step, isExpand) => {
      if (isExpand) {
        updateExpanding((prev) => [...prev, step.id]);
        updateExpanding((prev) => prev.filter((id) => id != step.id));
        updateExpandedBlockStep((prev) => [...prev, step.id]);
      } else {
        updateExpandedBlockStep((prev) => prev.filter((id) => id != step.id));
      }
    },
    [updateExpandedBlockStep, updateExpanding]
  );
  const toggleStepGroupExpand = useCallback(
    async (step, isExpand, setIsGroupExpanding) => {
      if (isExpand) {
        const stepgroupTestCase = await fetchTestCaseById(step?.stepGroupId);
        updateExpanding((prev) => [...prev, step.id]);
        fetchStepGroupSteps(step, stepgroupTestCase).then((steps) => {
          steps = steps?.map((item) => new TestStep().deserialize(item)) || [];
          setIsGroupExpanding(false);
          cachedStepGroupChildren.current[step.id] = steps;
          updateExpanding((prev) => prev.filter((id) => id != step.id));
          updateExpandedStepGroup((prev) => [...prev, step.id]);
        });
      } else {
        updateExpandedStepGroup((prev) => prev.filter((id) => id != step.id));
      }
    },
    [expandedStepGroup, fetchStepGroupSteps]
  );
  const toggleStepExpand = useCallback(
    ({ step, isExpand, setIsGroupExpanding }) => {
      if (isBlock(step)) toggleStepBlockExpand(step, isExpand);
      else if (isStepGroup(step))
        toggleStepGroupExpand(step, isExpand, setIsGroupExpanding);
    },
    [toggleStepBlockExpand, toggleStepGroupExpand]
  );
  const updateExpandedData = (stepGroupStepId, updated) => {
    const steps = cachedStepGroupChildren.current[stepGroupStepId];
    populateMapperDataForChangedForLoop(steps, updated);
    cachedStepGroupChildren.current[stepGroupStepId] = steps?.map(
      (item) => item.id === updated?.id && item.hostTestCaseStepId === updated?.hostTestCaseStepId ? updated : item
    );
  };
  return {
    toggleStepExpand,
    isStepExpanded,
    cachedStepGroupChildren,
    cachedStepBlockChildren,
    isExpanding,
    expandedBlockStep,
    updateExpandedData
  };
};
var launchAppMapping = {
  [ApplicationType.AndroidNative]: 20001,
  [ApplicationType.IOSNative]: 30001,
  [ApplicationType.MobileWeb]: 10116,
  [ApplicationType.WebApplication]: 1044,
  [ApplicationType.WINDOWS]: 40008,
  [ApplicationType.Salesforce]: 60425
};
var ListWrapper = ({
  steps,
  nlAction,
  userPreference,
  algoliaActions,
  kibbutzActions,
  testCaseId,
  afterTestCaseId,
  getTestData: getTestData2,
  onUpdateStep,
  onCreateStep,
  onNestedCreateStep,
  onAddStep,
  onRemoveStep,
  onChangeType,
  onSearch,
  isFetching,
  isCommand,
  isCommandCombine,
  openStepGroupsListDrawer,
  openCustomFunctionParameterDrawer,
  openTestStepSettingsDrawer,
  openElementListDrawer,
  openElementFormDrawer,
  onOpenSalesforceAPIFormDrawer,
  openVisualFigmaViewModal,
  isViewOnly = false,
  isViewOnlySingle = false,
  isNoWrapSteps = false,
  className,
  openRestStep,
  openSOQLStep,
  applicationType,
  dataParameterList,
  dataProfileList,
  customFunctionList,
  dataSetList,
  updateSelectedDataProfile,
  selectedSteps = [],
  updateSelectedSteps = NOOP,
  isRecorderView,
  isWebRecorder,
  isAfterTestCase,
  updateReorderModeState = NOOP,
  isReordering = false,
  updateReorderedSteps = NOOP,
  fetchStepGroupSteps = NOOP,
  fetchPage,
  hasNextPage,
  testCase,
  validateUrl: validateUrl2,
  fetchDataProfile,
  clientHeight,
  isBulkActionMode = false,
  executedStepIds,
  stepResults = [],
  debuggerActions,
  resumedStepResultId,
  currentExecutingStep,
  debugPoints,
  onActiveStepChange = NOOP,
  fetchConnections = NOOP,
  actionCallback = NOOP,
  salesforceActions,
  fetchTestCaseById,
  isExecutingRun,
  uploadActions,
  sessionActions,
  hasFeatureValue: hasFeatureValue2,
  customFunctionActions,
  lastUpdatedStepId,
  fetchObjectActions,
  kibbutzTemplate,
  openActionsListDrawer,
  stepCreationInProgress,
  isDebugMode = false,
  modifiedSteps,
  selectedIterationByStepId = {},
  setSelectedIterationByStepId = NOOP,
  debugExecutionStatus,
  setStepsForDebuggerButtons = NOOP,
  openExternalUrl,
  getTdpBaseUrl,
  versionId: versionIdProp,
  activeStepId
}) => {
  const triggeredExpansion = useRef([]);
  const prevFeedSteps = useRef([]);
  const deepClonedSteps = useMemo(() => {
    const stepsToReturn = steps?.map((item) => new TestStep().deserialize(item)) || [];
    return stepsToReturn;
  }, [steps]);
  const isNavigateNeeded = useRef(true);
  const [localSteps, updateLocalSteps] = useState(steps);
  const [localReorderSteps, updateLocalReorderStep] = useState([]);
  const [globalStepsInfo, updateGlobalStepsInfo] = useState({
    activeStepIdx: null,
    selectedSteps,
    updateSelectedSteps,
    nlpContainerWidth: {},
    isReorderState: false,
    isStepTypeSwitchOpened: true,
    isBulkActionState: false
  });
  const [lastFocusedStepNumber, setLastFocusedStepNumber] = useState(null);
  const [isChildDataUpdated, setIsChildDataUpdated] = useState(
    null
  );
  const [activeStepIdx, _updateActiveStepIdx] = useState(null);
  useEffect(() => {
    if (activeStepId !== void 0 && activeStepId !== activeStepIdx) {
      _updateActiveStepIdx(activeStepId);
    }
  }, [activeStepId, activeStepIdx]);
  const updateActiveStepIdx = useCallback(
    (stepId) => {
      _updateActiveStepIdx(stepId);
      onActiveStepChange(stepId);
    },
    [_updateActiveStepIdx, onActiveStepChange]
  );
  const stepToggleUtils = useStepToggle(fetchStepGroupSteps, fetchTestCaseById);
  const hasAddStepButton = useMemo(
    () => !steps.find((step) => !step.id),
    [steps]
  );
  const updateStepsInfo = useCallback(
    (key, value) => {
      if (globalStepsInfo[key] != value) {
        const tempGlobalStepInfo = Object.assign({}, globalStepsInfo);
        tempGlobalStepInfo[key] = value;
        updateGlobalStepsInfo(tempGlobalStepInfo);
        if (key === "activeStepIdx") {
          onActiveStepChange(value);
        }
      }
    },
    [globalStepsInfo]
  );
  const getBlockStepChild = (blockStep, stepsList) => {
    return stepsList.filter((item) => item.blockParentId == blockStep.id);
  };
  const calculateSeries = (startOrder, childCount, endOrder) => {
    if (endOrder) {
      const difference = endOrder - startOrder;
      const step = difference / (childCount + 2);
      return Array.from(
        { length: childCount + 2 },
        (_, i) => startOrder + step * (i + 1)
      );
    } else {
      return Array.from(
        { length: childCount + 2 },
        (_, i) => startOrder + 1e3 * (i + 1)
      );
    }
  };
  const getBlockLastStepOrder = (blockStep, notModifiedSteps) => {
    let currentStartOrder = blockStep.stepOrder;
    if (isBlock(blockStep)) {
      if (blockStep.blockLastStepOrder) {
        currentStartOrder = blockStep.blockLastStepOrder;
      } else if (getBlockStepChild(blockStep, notModifiedSteps)?.length) {
        const childs = getBlockStepChild(blockStep, notModifiedSteps);
        currentStartOrder = childs?.at(-1)?.stepOrder || blockStep.stepOrder;
      }
    }
    return currentStartOrder;
  };
  const updateBlockLastStepOrder = (currentBlockstep, stepsList) => {
    currentBlockstep.blockLastStepOrder = stepsList[stepsList.length - 1]?.stepOrder || currentBlockstep.stepOrder;
  };
  const updateStepsArray = (updatedSteps, currentStep, newList) => {
    const currentIndex = updatedSteps.findIndex(
      (item) => item.id === currentStep.id
    );
    updatedSteps.splice(currentIndex, 1, ...newList);
  };
  const replaceCurrentStep = (localReorderStepsList, currentStep) => {
    return [
      ...localReorderStepsList.filter((item) => item.id !== currentStep.id),
      currentStep
    ];
  };
  const _updateReorderedSteps = (newList, localReorderStepsList) => {
    return [
      ...localReorderStepsList.filter(
        (item) => !newList.some((newItem) => newItem.id === item.id)
      ),
      ...newList
    ];
  };
  const { isReorderState, isBulkActionState } = globalStepsInfo;
  const feedSteps = useMemo(() => {
    if (isViewOnlySingle) return steps;
    const finalSteps = [];
    const baseSteps = isReorderState ? [...localSteps] : steps;
    const changeSteps = baseSteps.filter((step) => !step.blockParentId);
    changeSteps.forEach((step) => {
      let expandSteps = [];
      if (isStepGroup(step) && stepToggleUtils.isStepExpanded(step)) {
        const stepGroupChildren = stepToggleUtils.cachedStepGroupChildren?.current?.[step.id] || [];
        expandSteps = stepGroupChildren;
        expandSteps = applyOperationsRecursively(
          expandSteps,
          stepToggleUtils,
          null,
          step,
          stepGroupChildren
        );
        const isExistIndex = stepGroupChildren?.findIndex(
          (t) => t.id === isChildDataUpdated?.id
        );
        if (isChildDataUpdated && isExistIndex > -1) {
          stepToggleUtils.updateExpandedData(step?.id, isChildDataUpdated);
        }
      }
      if (isBlock(step) && stepToggleUtils.isStepExpanded(step)) {
        expandSteps = baseSteps.filter(
          (item) => item.blockParentId === step.id
        );
        expandSteps = applyOperationsRecursively(
          expandSteps,
          stepToggleUtils,
          step.id,
          step,
          baseSteps
        );
      }
      finalSteps.push(step, ...expandSteps);
    });
    const filtered = finalSteps.filter(
      (step) => !step.blockParentId || stepToggleUtils.expandedBlockStep.includes(step.blockParentId)
    );
    return filtered;
  }, [
    steps,
    localSteps,
    stepToggleUtils,
    isReorderState,
    isChildDataUpdated,
    triggeredExpansion,
    isViewOnlySingle
  ]);
  const getAdjustedIndex = (stepsList, targetStep, shouldDecrement) => {
    const baseIndex = stepsList.findIndex(
      (step) => step.stepNumber === targetStep.mapperData[0].stepNumber
    );
    return shouldDecrement ? baseIndex : baseIndex + 1;
  };
  const findStepIndexById = (stepsList, targetId) => {
    return stepsList.findIndex((step) => step.id === targetId);
  };
  const setOrderValue = (localStepsCopy, blockStep, stepsList, startIndex, endIndex) => {
    const childSteps = getBlockStepChild(blockStep, stepsList);
    if (childSteps.length === 0) {
      blockStep.stepOrder = endIndex ? (startIndex + endIndex) / 2 : startIndex + 1e3;
      return [blockStep];
    }
    const orderValues = calculateSeries(
      startIndex,
      childSteps.length,
      endIndex
    );
    const orderedSteps = [blockStep, ...childSteps];
    orderedSteps.map((step, index) => step.stepOrder = orderValues[index]);
    const [beforeSteps, afterSteps] = partition$1(
      localStepsCopy,
      (item) => item.stepOrder <= orderedSteps[0].stepOrder
    );
    const filteredBeforeSteps = beforeSteps.filter(
      (item) => item.id !== blockStep.id
    );
    localStepsCopy = [...filteredBeforeSteps, ...orderedSteps, ...afterSteps];
    return orderedSteps;
  };
  const getUpdatedReorderSteps = (localCopySteps, currentStep, updatedSteps, notModifiedSteps, startOrder, endOrder) => {
    const newList = setOrderValue(
      localCopySteps,
      currentStep,
      notModifiedSteps,
      startOrder,
      endOrder
    );
    updateBlockLastStepOrder(currentStep, newList);
    updateStepsArray(updatedSteps, currentStep, newList);
    return _updateReorderedSteps(newList, localReorderSteps);
  };
  const onDrop = useCallback(
    (result) => {
      const addPositionStep = feedSteps[result.addedIndex];
      const removePositionStep = feedSteps[result.removedIndex];
      if (addPositionStep.testCaseId != testCaseId) {
        if (result.addedIndex < result.removedIndex) {
          result.addedIndex = localSteps.findIndex(
            (item) => item.stepNumber === addPositionStep?.mapperData?.[0]?.stepNumber
          );
        } else {
          result.addedIndex = localSteps.findIndex(
            (item) => item.stepNumber === addPositionStep?.mapperData?.[0]?.stepNumber
          ) + 1;
        }
        result.removedIndex = localSteps.findIndex(
          (item) => item.id === removePositionStep.id
        );
      }
      const { addedIndex, removedIndex, resultId } = result;
      const addStep = feedSteps[addedIndex];
      const removeStep = feedSteps[removedIndex];
      if (addStep.testCaseId !== testCaseId) {
        result.addedIndex = getAdjustedIndex(
          localSteps,
          addStep,
          addedIndex < removedIndex
        );
        result.removedIndex = findStepIndexById(localSteps, removeStep.id);
      }
      const notModifiedSteps = [...steps];
      const localStepsCopy = localSteps.filter(
        (step) => (!step?.blockParentId || stepToggleUtils.expandedBlockStep.includes(step.blockParentId)) && step?.id
      ).map((item) => new TestStep().deserialize(item)).sort((a, b) => a.stepOrder - b.stepOrder);
      const removedStepIndex = localStepsCopy.findIndex(
        (s) => s.id == resultId.split("-").reverse()[0]
      );
      const isFirstStep = addedIndex === 0;
      const currentStep = localStepsCopy[removedStepIndex];
      const isBottomUp = removedIndex > addedIndex;
      const hasExpandedStepGroups = feedSteps.some(
        (step) => String(step.testCaseId) !== String(testCaseId)
      );
      let previousItemIndex;
      let previousStep;
      if (hasExpandedStepGroups) {
        const visualPreviousIndex = isBottomUp ? addedIndex - 1 : addedIndex;
        const result2 = findLocalStepFromFeedIndex(
          visualPreviousIndex,
          feedSteps,
          localStepsCopy,
          testCaseId
        );
        previousStep = result2.step;
        previousItemIndex = result2.index;
      } else {
        previousItemIndex = isBottomUp ? addedIndex - 1 : addedIndex;
        previousStep = localStepsCopy[previousItemIndex];
      }
      const isPreviousStepIsBlock = isBlock(previousStep);
      const isCurrentStepIsBlock = isBlock(currentStep);
      let addedLocalIndex = addedIndex;
      if (hasExpandedStepGroups) {
        const addedResult = findLocalStepFromFeedIndex(
          addedIndex,
          feedSteps,
          localStepsCopy,
          testCaseId
        );
        addedLocalIndex = addedResult.index >= 0 ? addedResult.index : addedIndex;
      }
      const isPreviousStepParentStep = isPreviousStepIsBlock && !(isBlock(localStepsCopy[addedLocalIndex]) && isCurrentStepIsBlock) || isConditionalStep(previousStep) || isForLoop(previousStep);
      const isLastStep = stepToggleUtils?.expandedBlockStep?.length ? !localStepsCopy[previousItemIndex + 1] : !localStepsCopy.filter((item) => !item.blockParentId)[previousItemIndex + 1];
      const getSuperParentId = (findingIdParam) => {
        const parentStep = localStepsCopy.find((e) => e.id === findingIdParam);
        if (parentStep?.blockParentId) {
          return null;
        }
        return parentStep?.parentId || null;
      };
      const getIndentOfPreviousBlockStep = () => {
        const step = localStepsCopy.find(
          (e) => e.id === previousStep?.blockParentId
        );
        return step.indent;
      };
      if (isPreviousStepParentStep) {
        const isPreviousStepExpandedBlock = stepToggleUtils.expandedBlockStep.includes(previousStep?.id);
        if (isPreviousStepExpandedBlock) {
          currentStep.indent = !isLastStep ? previousStep?.indent || null : null;
        } else {
          currentStep.indent = previousStep?.indent + 1;
        }
      } else {
        currentStep.indent = !isLastStep ? previousStep?.indent || null : null;
      }
      const expandedBlock = stepToggleUtils.expandedBlockStep.includes(
        previousStep?.id
      );
      if (isCurrentStepIsBlock) {
        currentStep.parentId = isFirstStep ? null : isPreviousStepParentStep && !isPreviousStepIsBlock && !previousStep?.blockParentId ? previousStep?.id : !isLastStep && !previousStep.blockParentId ? previousStep?.parentId || null : getSuperParentId(previousStep?.parentId) || null;
        if (isPreviousStepIsBlock) {
          currentStep.indent = previousStep.indent;
        } else if (previousStep?.blockParentId) {
          currentStep.indent = getIndentOfPreviousBlockStep();
        }
      } else {
        if (isPreviousStepIsBlock) {
          if (expandedBlock) {
            currentStep.parentId = isPreviousStepParentStep ? previousStep?.id : !isLastStep ? previousStep?.parentId || null : null;
            currentStep.indent = previousStep.indent + 1;
            currentStep.blockParentId = isPreviousStepParentStep && isPreviousStepIsBlock ? previousStep?.id : !isLastStep ? previousStep?.blockParentId || null : null;
          } else {
            currentStep.indent = previousStep.indent;
            currentStep.parentId = isPreviousStepParentStep && !isPreviousStepIsBlock ? previousStep?.id : !isLastStep ? previousStep?.parentId || null : null;
            if (currentStep?.blockParentId || previousStep?.blockParentId) {
              currentStep.blockParentId = isPreviousStepParentStep && expandedBlock ? previousStep?.id : !isLastStep ? previousStep?.blockParentId || null : null;
            }
          }
        } else {
          currentStep.parentId = isPreviousStepParentStep ? previousStep?.id : !isLastStep ? previousStep?.parentId || null : null;
          if (currentStep?.blockParentId || previousStep?.blockParentId) {
            currentStep.blockParentId = isPreviousStepParentStep && isPreviousStepIsBlock ? previousStep?.id : !isLastStep ? previousStep?.blockParentId || null : null;
          }
        }
      }
      let removedBlockIndex;
      let addedBlockIndex;
      if (hasExpandedStepGroups) {
        removedBlockIndex = localStepsCopy.findIndex(
          (s) => s.id === currentStep?.id
        );
        addedBlockIndex = previousItemIndex >= 0 ? isBottomUp ? previousItemIndex + 1 : previousItemIndex : 0;
      } else {
        removedBlockIndex = getActualIndexFromViewIndex(
          localStepsCopy,
          stepToggleUtils.expandedBlockStep,
          removedIndex
        );
        addedBlockIndex = getActualIndexFromViewIndex(
          localStepsCopy,
          stepToggleUtils.expandedBlockStep,
          addedIndex
        );
      }
      const ifCurrentStephasBlockId = currentStep?.blockParentId;
      const ifPreviousStepHasBlockId = previousStep?.blockParentId;
      const updatedSteps = moveItem(
        localStepsCopy.filter((step) => step?.id),
        ifCurrentStephasBlockId || ifPreviousStepHasBlockId ? removedBlockIndex > -1 ? removedBlockIndex : removedStepIndex : removedStepIndex,
        addedBlockIndex
      );
      let currentReorderSteps = [];
      if (isLastStep) {
        const lastStepOrderValue = getBlockLastStepOrder(
          previousStep,
          notModifiedSteps
        );
        if (isCurrentStepIsBlock) {
          currentStep.stepOrder = lastStepOrderValue;
          currentReorderSteps = getUpdatedReorderSteps(
            localStepsCopy,
            currentStep,
            updatedSteps,
            notModifiedSteps,
            currentStep.stepOrder
          );
        } else {
          currentStep.stepOrder = lastStepOrderValue + 1e3;
          currentReorderSteps = replaceCurrentStep(
            localReorderSteps,
            currentStep
          );
        }
      } else if (isFirstStep) {
        const firstStepIndex = hasExpandedStepGroups ? addedLocalIndex : addedIndex;
        const validFirstStepIndex = firstStepIndex >= 0 && firstStepIndex < localStepsCopy.length ? firstStepIndex : 0;
        if (isCurrentStepIsBlock) {
          currentReorderSteps = getUpdatedReorderSteps(
            localStepsCopy,
            currentStep,
            updatedSteps,
            notModifiedSteps,
            0,
            localStepsCopy[validFirstStepIndex].stepOrder
          );
        } else {
          currentStep.stepOrder = localStepsCopy[validFirstStepIndex].stepOrder / 2;
          currentReorderSteps = replaceCurrentStep(
            localReorderSteps,
            currentStep
          );
        }
      } else {
        if (isCurrentStepIsBlock) {
          currentReorderSteps = getUpdatedReorderSteps(
            localStepsCopy,
            currentStep,
            updatedSteps,
            notModifiedSteps,
            getBlockLastStepOrder(previousStep, notModifiedSteps),
            localStepsCopy[localStepsCopy.findIndex((item) => item.id == previousStep.id) + 1].stepOrder
          );
        } else {
          currentStep.stepOrder = ((currentStep.parentId == previousStep.id ? localStepsCopy[localStepsCopy.findIndex((item) => item.id == previousStep.id)].stepOrder : getBlockLastStepOrder(previousStep, notModifiedSteps)) + localStepsCopy[localStepsCopy.findIndex((item) => item.id == previousStep.id) + 1].stepOrder) / 2;
          currentReorderSteps = replaceCurrentStep(
            localReorderSteps,
            currentStep
          );
        }
      }
      updateLocalSteps(updatedSteps);
      updateLocalReorderStep(currentReorderSteps);
      updateReorderedSteps(currentReorderSteps);
    },
    [
      steps,
      feedSteps,
      localSteps,
      stepToggleUtils.expandedBlockStep,
      updateReorderedSteps,
      localReorderSteps
    ]
  );
  const onDragStart = useCallback(() => {
    updateStepsInfo("isReorderState", true);
    updateReorderModeState(true);
  }, [updateReorderModeState]);
  const updateStepGroupChildren = () => {
    if (feedSteps.length > 0) {
      let finalSteps = [];
      finalSteps = feedSteps.filter(
        (step) => isStepGroup(step) && stepToggleUtils.isStepExpanded(step)
      );
      if (finalSteps.length > 0) {
        finalSteps.map(async (step) => {
          const stepgroupTestCase = await fetchTestCaseById(step?.testCaseId);
          let stepGroupSteps = await fetchStepGroupSteps(
            step,
            stepgroupTestCase
          );
          stepGroupSteps = (stepGroupSteps || [])?.map(
            (item) => new TestStep().deserialize(item)
          ) || [];
          stepToggleUtils.cachedStepGroupChildren.current[step.id] = stepGroupSteps;
        });
      }
    }
  };
  const isMountedRef = useRef(true);
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  useEffect(() => {
    updateStepsInfo(`selectedSteps`, selectedSteps);
  }, [selectedSteps]);
  useEffect(() => {
    if (!isReordering && isMountedRef.current) {
      const timer2 = setTimeout(() => {
        updateLocalSteps(deepClonedSteps);
        updateStepsInfo(`isReorderState`, false);
        updateLocalReorderStep([]);
        updateReorderedSteps([]);
      }, 50);
      return () => clearTimeout(timer2);
    }
  }, [
    isReordering,
    steps,
    updateReorderedSteps,
    updateLocalReorderStep,
    deepClonedSteps
  ]);
  useEffect(() => {
    if (!isReordering && isDebugMode) {
      updateGlobalStepsInfo((prev) => ({ ...prev, isReorderState: false }));
    }
    if (!isReordering && !isMountedRef.current && isDebugMode) {
      updateLocalReorderStep([]);
    }
  }, [isReordering, updateGlobalStepsInfo, isDebugMode]);
  useEffect(() => {
    updateStepsInfo("isBulkActionState", isBulkActionMode);
  }, [isBulkActionMode]);
  const TestStepContainerProps = {
    afterTestCaseId,
    testCaseId,
    isViewOnly,
    isViewOnlySingle,
    isNoWrapSteps,
    hasAddStepButton,
    getTestData: getTestData2,
    onCreateStep,
    onUpdateStep,
    onRemoveStep,
    onChangeType,
    onNestedCreateStep,
    onSearch,
    isFetching,
    isCommand,
    isCommandCombine,
    dataParameterList,
    dataProfileList,
    customFunctionList,
    dataSetList,
    stepToggleUtils,
    updateSelectedDataProfile,
    onDragStart,
    onDrop,
    isRecorderView,
    clientHeight,
    isAfterTestCase,
    fetchConnections,
    actionCallback,
    salesforceActions,
    uploadActions,
    sessionActions
  };
  const testStepViewerRef = useRef(null);
  const scrollToLastItem = () => {
    if (testStepViewerRef.current) {
      testStepViewerRef.current.scrollToLastItem();
    }
  };
  const scrollToNextItem = () => {
    if (testStepViewerRef.current) {
      testStepViewerRef.current.scrollToNextItem();
    }
  };
  const stopScrolling = () => {
    if (testStepViewerRef.current) {
      testStepViewerRef.current.stopScrolling();
    }
  };
  useInternalEvents(["scroll-to-next-step"], scrollToNextItem);
  const defaultStep = useCallback(() => {
    const template = nlAction.find(
      (item) => item.id == launchAppMapping[applicationType]
    );
    const launchAppStep = createTestStep(
      testCaseId,
      1e3,
      `1`,
      0,
      onChangeType,
      applicationType,
      {
        action: template?.grammar,
        templateId: launchAppMapping[applicationType],
        isDefaultFirstStep: true,
        isAddedDirect: true
      }
    );
    launchAppStep.screenshotStrategy = template?.screenshotStrategy;
    if (launchAppMapping[applicationType] === WEB_NAVIGATE_NLP_TEMPLATE && launchAppStep) {
      const stepDataList = new TestDataMapValue().deserialize(
        {
          type: TestDataType.raw,
          value: "test data",
          key: "testData"
        }
      );
      let optionalGrammar;
      if (hasFeatureValue2("TEST_CASE_LEVEL_MULTI_DRIVER_SESSION")) {
        if (!(template instanceof KibbutzNlp) && template?.optionalGrammar) {
          optionalGrammar = new TestDataMapValue().deserialize({
            type: TestDataType.raw,
            value: "default",
            key: "sessionName"
          });
        }
        launchAppStep.stepDataList = [stepDataList, optionalGrammar];
      } else {
        launchAppStep.stepDataList = [stepDataList];
      }
    }
    if (launchAppMapping[applicationType] === SALESFORCE_LOGIN_NLP_TEMPLATE && launchAppStep) {
      const stepDataList = new TestDataMapValue().deserialize(
        {
          type: TestDataType.raw,
          value: "Salesforce Connection",
          key: "salesforceConnection"
        }
      );
      launchAppStep.stepDataList = [stepDataList];
    }
    onAddStep(launchAppStep);
  }, [applicationType, onAddStep]);
  useEffect(() => {
    const shouldNavigate = !isFetching && feedSteps && isNavigateNeeded.current && !isRecorderView && !isAfterTestCase;
    if (shouldNavigate) {
      isNavigateNeeded.current = false;
      if (!feedSteps.length && nlAction) {
        defaultStep();
      }
    }
  }, [
    feedSteps,
    isFetching,
    isNavigateNeeded,
    onAddStep,
    isRecorderView,
    isAfterTestCase,
    onCreateStep,
    applicationType,
    testCaseId,
    onChangeType,
    nlAction
  ]);
  const internalEventHandler = useCallback(
    (eventName) => {
      if (eventName == "delete-test-step") {
        defaultStep();
      }
    },
    [onAddStep, applicationType, testCaseId, onChangeType, nlAction]
  );
  useInternalEvents(["delete-test-step"], internalEventHandler);
  useEffect(() => {
    if (isRecorderView) {
      if (window.location.pathname.includes("/debugrun")) {
        delete window["stepElementClonedRes"];
        delete window["stepElementCloned"];
        delete window["isMobileElementRecordingRedirect"];
      }
      return;
    }
    const elementResponse = window["stepElementClonedRes"];
    const clonedStepState = window["stepElementCloned"];
    const isMobileElementRedirect = window["isMobileElementRecordingRedirect"];
    const pathTestCaseId = window.location.pathname.match(
      /td\/([^/]+)\/(cases|step-groups)(?:\/filters)?\/([0-9]+)/
    )?.[3];
    if (clonedStepState && clonedStepState?.testCaseId == pathTestCaseId && clonedStepState.expires > Date.now()) {
      if (isMobileElementRedirect && elementResponse) {
        const originalObjectBlocks = clonedStepState.originalStep.localStep?.uiMap?.objectBlocks || [];
        const stepCopy = JSON.parse(
          JSON.stringify(clonedStepState.originalStep.localStep)
        );
        const elementName2 = elementResponse?.name || clonedStepState.originalValue;
        if (clonedStepState.step?.action && typeof clonedStepState.step.action === "string") {
          stepCopy.action = clonedStepState.step.action.replaceAll(
            "--ELEMENT--",
            elementName2
          );
        } else if (stepCopy.action && typeof stepCopy.action === "string") {
          stepCopy.action = stepCopy.action.replaceAll(
            "--ELEMENT--",
            elementName2
          );
        }
        if (stepCopy.uiMap?.objectBlocks) {
          stepCopy.uiMap.objectBlocks = stepCopy.uiMap.objectBlocks.map(
            (block) => {
              if (block.value === "--ELEMENT--" || block.value === clonedStepState.originalValue) {
                return { ...block, value: elementName2, has_value: true };
              }
              return block;
            }
          );
        }
        clonedStepState.originalStep.localStep = new TestStep().deserialize(
          stepCopy
        );
        if (originalObjectBlocks.length > 0 && (!clonedStepState.originalStep.localStep?.uiMap?.objectBlocks || clonedStepState.originalStep.localStep?.uiMap?.objectBlocks.length === 0)) {
          if (clonedStepState.originalStep.localStep?.uiMap) {
            clonedStepState.originalStep.localStep.uiMap.objectBlocks = originalObjectBlocks.map((block) => {
              if (block.value === "--ELEMENT--" || block.value === clonedStepState.originalValue) {
                return { ...block, value: elementName2, has_value: true };
              }
              return block;
            });
          }
        }
        const objectBlocks = clonedStepState.originalStep.localStep?.uiMap?.objectBlocks || [];
        const blockToUpdate = objectBlocks.find(
          (block) => block.uuid === clonedStepState.elementBlockUuid
        );
        if (blockToUpdate) {
          blockToUpdate.value = elementResponse.name;
          blockToUpdate.has_value = true;
          blockToUpdate.elementId = elementResponse.id;
          blockToUpdate.more_details = blockToUpdate.more_details || {};
          blockToUpdate.more_details.isReadOnly = true;
          blockToUpdate.more_details.elementOverride = {
            referenceKey: blockToUpdate.uuid,
            id: elementResponse.id,
            name: elementResponse.name,
            objectTypeId: elementResponse.objectTypeId
          };
        } else {
          const uiIdentifierBlock = objectBlocks.find(
            (block) => block.type === "ui_identifier"
          );
          if (uiIdentifierBlock) {
            uiIdentifierBlock.value = elementResponse.name;
            uiIdentifierBlock.has_value = true;
            uiIdentifierBlock.elementId = elementResponse.id;
            uiIdentifierBlock.more_details = uiIdentifierBlock.more_details || {};
            uiIdentifierBlock.more_details.isReadOnly = true;
            uiIdentifierBlock.more_details.elementOverride = {
              referenceKey: uiIdentifierBlock.uuid,
              id: elementResponse.id,
              name: elementResponse.name,
              objectTypeId: elementResponse.objectTypeId
            };
          } else if (clonedStepState.originalStep.localStep?.uiMap) {
            const newElementBlock = {
              type: "ui_identifier",
              uuid: clonedStepState.elementBlockUuid || "uiIdentifier",
              value: elementResponse.name,
              has_value: true,
              elementId: elementResponse.id,
              canEncrypt: false,
              isEncrypted: false,
              more_details: {
                isReadOnly: true,
                // Prevent dropdown from opening
                isObjectBased: true,
                elementOverride: {
                  referenceKey: clonedStepState.elementBlockUuid || "uiIdentifier",
                  id: elementResponse.id,
                  name: elementResponse.name,
                  objectTypeId: elementResponse.objectTypeId
                }
              }
            };
            const actionText = clonedStepState.originalStep.localStep.action || "";
            const parts = actionText.includes("--ELEMENT--") ? actionText.split("--ELEMENT--") : actionText.split(elementResponse.name);
            const newBlocks = [];
            if (parts[0]) {
              newBlocks.push({
                type: "readonly_text",
                value: parts[0].trim(),
                uuid: "readonly_prefix",
                has_value: true,
                canEncrypt: false,
                isEncrypted: false
              });
            }
            newBlocks.push(newElementBlock);
            if (parts[1]) {
              newBlocks.push({
                type: "readonly_text",
                value: parts[1].trim(),
                uuid: "readonly_suffix",
                has_value: true,
                canEncrypt: false,
                isEncrypted: false
              });
            }
            clonedStepState.originalStep.localStep.uiMap.objectBlocks = newBlocks;
          }
        }
        if (clonedStepState.originalStep.localStep?.action) {
          clonedStepState.originalStep.localStep.action = clonedStepState.originalStep.localStep.action.replaceAll(
            "--ELEMENT--",
            elementResponse.name
          );
        }
        const existingElements = clonedStepState.originalStep.localStep.testStepElements || [];
        const elementExists = existingElements.some(
          (el) => el.name === elementResponse?.name
        );
        if (elementExists) {
          const testStepElements = existingElements.map((testStepElement) => {
            if (testStepElement.name === elementResponse?.name) {
              testStepElement["elementId"] = elementResponse?.id;
            }
            return testStepElement;
          });
          clonedStepState.originalStep.localStep.testStepElements = [
            ...testStepElements
          ];
        } else {
          clonedStepState.originalStep.localStep.testStepElements = [
            ...existingElements,
            {
              name: elementResponse?.name,
              elementType: getElementType2(clonedStepState.elementBlockUuid),
              elementId: elementResponse?.id
            }
          ];
        }
      } else {
        const step = JSON.stringify(clonedStepState.step).replaceAll(
          "--ELEMENT--",
          clonedStepState.originalValue
        );
        clonedStepState.originalStep.localStep = new TestStep().deserialize(
          JSON.parse(step)
        );
        if (elementResponse) {
          const testStepElements = clonedStepState.originalStep.localStep.testStepElements.map(
            (testStepElement) => {
              if (testStepElement.name === elementResponse?.name) {
                testStepElement["elementId"] = elementResponse?.id;
              }
              return testStepElement;
            }
          );
          clonedStepState.originalStep.localStep.testStepElements = [
            ...testStepElements
          ];
        }
      }
      if (!clonedStepState.originalStep.localStep?.id) {
        onAddStep?.(
          clonedStepState.originalStep.localStep,
          false,
          null,
          !clonedStepState.step.id,
          !!clonedStepState.step.id
        );
      } else if (elementResponse) {
        onUpdateStep?.(clonedStepState.originalStep.localStep);
      }
    }
    if (clonedStepState?.originalStep && !clonedStepState.originalStep.localStep?.id) {
      window["nonIframeStep"] = clonedStepState?.originalStep;
    }
    delete window["stepElementClonedRes"];
    delete window["stepElementCloned"];
    delete window["isMobileElementRecordingRedirect"];
  }, []);
  useEffect(() => {
    if (!isDebugMode) return;
    feedSteps.forEach((step) => {
      if (!triggeredExpansion.current.includes(step.id) && step.id) {
        stepToggleUtils.toggleStepExpand({
          isExpand: true,
          step,
          setIsGroupExpanding: () => {
          }
        });
        triggeredExpansion.current = [...triggeredExpansion.current, step.id];
      }
    });
  }, [triggeredExpansion, feedSteps, stepToggleUtils, isDebugMode]);
  useEffect(() => {
    feedSteps.forEach((step) => {
      if (isBlock(step) && step.blockParentId && !triggeredExpansion.current.includes(step.id) && step.id) {
        stepToggleUtils.toggleStepExpand({
          isExpand: true,
          step,
          setIsGroupExpanding: () => {
          }
        });
        triggeredExpansion.current = [...triggeredExpansion.current, step.id];
      }
    });
  }, [feedSteps, stepToggleUtils, triggeredExpansion]);
  useEffect(() => {
    if (lastUpdatedStepId) {
      window["lastUpdatedStepId"] = lastUpdatedStepId;
    }
  }, [lastUpdatedStepId]);
  useEffect(() => {
    if (isDebugMode) {
      const filteredSteps = feedSteps.filter((step) => step.id);
      if (!isEqual(prevFeedSteps.current, filteredSteps)) {
        prevFeedSteps.current = filteredSteps;
        setStepsForDebuggerButtons(filteredSteps);
      }
    }
  }, [isDebugMode, setStepsForDebuggerButtons, feedSteps]);
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames82(
        {
          "p-1": isDebugMode,
          "h-full w-full": !isViewOnly,
          "!h-[calc(100%_-_106px)]": afterTestCaseId || isAfterTestCase
        },
        className
      ),
      children: !!nlAction?.length && /* @__PURE__ */ jsx(
        StepContext.Provider,
        {
          value: {
            userPreference,
            steps,
            nlActions: nlAction,
            algoliaTemplate: algoliaActions,
            kibbutzActions,
            openElementListDrawer,
            openElementFormDrawer,
            openStepGroupsListDrawer,
            openCustomFunctionParameterDrawer,
            openTestStepSettingsDrawer,
            onOpenSalesforceAPIFormDrawer,
            openRestStep,
            openSOQLStep,
            openVisualFigmaViewModal,
            stepsInfo: globalStepsInfo,
            updateStepsInfo,
            isRecorderView,
            isWebRecorder,
            activeStepIdx,
            updateActiveStepIdx,
            stepToggleUtils,
            updateStepGroupChildren,
            onAddStep,
            testCaseId,
            onChangeType,
            applicationType,
            scrollToLastItem,
            scrollToNextItem,
            freezeScrollOnEdit: stopScrolling,
            testCase,
            validateUrl: validateUrl2,
            fetchDataProfile,
            updateChildStep: setIsChildDataUpdated,
            isViewOnlySingle,
            isNoWrapSteps,
            currentExecutingStep,
            hasFeatureValue: hasFeatureValue2,
            customFunctionActions,
            lastUpdatedStepId: lastUpdatedStepId || window["lastUpdatedStepId"],
            fetchObjectActions,
            openActionsListDrawer,
            kibbutzTemplate,
            lastFocusedStepNumber,
            setLastFocusedStepNumber,
            isDebugMode,
            openExternalUrl,
            getTdpBaseUrl,
            versionId: versionIdProp ?? userPreference?.preference?.projectPreference?.versionId ?? null,
            debugExecutionStatus
          },
          children: /* @__PURE__ */ jsx(
            test_management_default,
            {
              stepCreationInProgress,
              props: TestStepContainerProps,
              data: feedSteps,
              lineHeight: 40,
              fetchPage,
              hasNextPage,
              hasAddStepButton,
              isViewOnly,
              isReorderState,
              isRecorderView,
              isWebRecorder,
              applicationType,
              onChangeType,
              onAddStep,
              clientHeight,
              isBulkActionState,
              executedStepIds,
              stepResults,
              debuggerActions,
              resumedStepResultId,
              isExecutingRun,
              currentExecutingStep,
              isDebugMode,
              debugPoints,
              cursorStepId: activeStepId,
              modifiedSteps,
              selectedIterationByStepId,
              setSelectedIterationByStepId,
              onDragStart,
              onDrop,
              afterTestCaseId,
              getTestData: getTestData2
            }
          )
        }
      )
    }
  );
};
var NlpInputWrapper = ({
  template,
  isReadOnly = false,
  nlpInputClassName
}) => {
  const [blocks, setBlocks] = useState([]);
  const { hasFeatureValue: hasFeatureValue2 } = useContext(StepContext);
  useEffect(() => {
    if (template) {
      if (template["isAddon"]) {
        setBlocks(
          getStepKibbutzBlocks({}, template)
        );
      } else {
        setBlocks(
          getStepNlpBlocks(
            {},
            template,
            null,
            hasFeatureValue2
          )
        );
      }
    }
  }, [template]);
  return /* @__PURE__ */ jsx(Fragment, { children: blocks && blocks.length > 0 && /* @__PURE__ */ jsx(
    NlpInput,
    {
      blocks,
      isReadOnly,
      className: nlpInputClassName
    }
  ) });
};
var SettingsCheckboxItem = ({
  label,
  inputValue,
  onChange,
  isDisabled = false,
  toolTipText = "",
  isIntermediate = false,
  disabledClassName = "",
  checkboxSize = "medium"
}) => {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    !!toolTipText && /* @__PURE__ */ jsx(
      ToolTip,
      {
        placement: "bottom",
        content: toolTipText,
        className: "inline-flex",
        children: /* @__PURE__ */ jsx(
          Checkbox,
          {
            type: "secondary",
            size: checkboxSize,
            checked: isIntermediate ? true : inputValue,
            label,
            onChange,
            isDisabled,
            checkIcon: isIntermediate ? /* @__PURE__ */ jsx(Icon, { name: "intermediate" }) : null,
            checkIconClassName: isIntermediate ? "checked:!bg-primary-500" : "",
            labelClassName: `${isDisabled ? disabledClassName : ""}`
          }
        )
      }
    ),
    !toolTipText && /* @__PURE__ */ jsx(
      Checkbox,
      {
        type: "primary",
        size: checkboxSize,
        checked: isIntermediate ? true : inputValue,
        label,
        onChange,
        isDisabled,
        checkIcon: isIntermediate ? /* @__PURE__ */ jsx(Icon, { name: "intermediate" }) : null,
        checkIconClassName: isIntermediate ? "text-white text-xl" : "",
        inputClassName: isIntermediate ? "checked:!bg-primary-500" : "disabled:!bg-secondary-300",
        labelClassName: `${isDisabled ? disabledClassName : ""}`
      }
    )
  ] });
};
var ScreenshotCapture = ({
  onSelect,
  options: options3 = [],
  selectedOption,
  wrapperClassName = "",
  checkboxSize = "small",
  checkBoxClassName = "",
  customLabel
}) => {
  const { t } = useTranslation();
  const handleSelectScreenshotCapture = (e) => {
    onSelect(e.target.value);
  };
  const handleCheckboxChange = (checked) => {
    const selectedItem = checked ? options3[0]?.key : StepLevelScreenshot.NO_SCREENSHOT;
    onSelect(selectedItem);
  };
  const label = customLabel || t("dry_run.screenshot_capture");
  return /* @__PURE__ */ jsxs("div", { className: wrapperClassName, children: [
    /* @__PURE__ */ jsx(
      Checkbox,
      {
        type: "primary",
        size: checkboxSize,
        label,
        checked: selectedOption !== StepLevelScreenshot.NO_SCREENSHOT,
        onChange: handleCheckboxChange,
        inputClassName: checkBoxClassName
      }
    ),
    selectedOption !== StepLevelScreenshot.NO_SCREENSHOT && /* @__PURE__ */ jsx(
      RadioGroup,
      {
        name: "screenshot_capture",
        onChange: handleSelectScreenshotCapture,
        className: "w-full flex flex-col",
        children: options3?.map((item) => /* @__PURE__ */ jsx(
          Radio,
          {
            value: item.key,
            name: "screenshot_capture",
            checked: selectedOption === item.key,
            className: "truncate pl-7 pt-3 my-0.5",
            labelTextClassName: "text-neutral-800",
            children: t(item.label)
          },
          item.key
        ))
      }
    )
  ] });
};
var know_more2 = "https://testsigma.com/docs/test-data/types/runtime/";
var EmptyRuntime = ({ isSearch, isRecoder }) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames82(
        "flex items-center flex-wrap justify-center leading-[18px] text-small",
        {
          "basis-full": isSearch
        }
      ),
      children: isSearch ? /* @__PURE__ */ jsx(SearchNotFound, {}) : /* @__PURE__ */ jsxs("div", { className: "flex items-center flex-wrap justify-center basis-full leading-[18px] text-small py-10", children: [
        /* @__PURE__ */ jsx(
          Icon,
          {
            name: "error",
            className: "inline-block cursor-pointer text-primary-500 text-5xl"
          }
        ),
        /* @__PURE__ */ jsx("div", { className: "font-semibold text-secondary-700 py-6 basis-full text-center", children: t("suggestion_popup.runtime.empty_info") }),
        !isRecoder && /* @__PURE__ */ jsx("div", { className: "flex basis-full justify-center", children: /* @__PURE__ */ jsx(
          Button,
          {
            type: "secondary",
            onClick: () => window.open(know_more2, "_blank"),
            children: t("common.know_more")
          }
        ) })
      ] })
    }
  );
};
var { VirtualizedInfiniteLoader: VirtualizedInfiniteLoader4 } = InfiniteScrollV2;
var RuntimeVariableUsageDetailsPopup = ({
  useGetRuntimeVariableUsage,
  item
}) => {
  const { t } = useTranslation();
  const [searchValue, setSearchValue] = useState("");
  const debouncedSearchTerm = useDebounce(searchValue, 500);
  const { data, isFetching, hasNextPage, fetchNextPage } = useGetRuntimeVariableUsage(item, debouncedSearchTerm);
  const modifiedData = data?.pages?.flatMap((item2) => item2?.content).filter((item2) => !!item2) || [];
  const openTestCaseTab = (e, testcasedata) => {
    e.stopPropagation();
    const stepGroupUrl = `${getOrigin()}/ui/td/step-groups/${testcasedata?.id}`;
    const testCaseUrl = `${getOrigin()}/ui/td/${testcasedata?.applicationVersionId}/cases/filters/${testcasedata?.afterTestParentId ?? testcasedata?.id}`;
    const url = testcasedata?.isStepGroup ? stepGroupUrl : testCaseUrl;
    window.open(url, "_blank");
  };
  return /* @__PURE__ */ jsxs("div", { className: "h-[300px] relative overflow-hidden", children: [
    /* @__PURE__ */ jsx(
      Input,
      {
        wrapperClassName: "!flex basis-full pb-2 flex-grow",
        inputClassName: "!pl-3 !pr-0",
        onChange: setSearchValue,
        preventDefaultValue: true,
        value: searchValue,
        prefix: /* @__PURE__ */ jsx("div", { className: "flex flex-col justify-center ml-3 text-secondary-600", children: /* @__PURE__ */ jsx(Icon, { name: "search", className: "text-xl" }) }),
        suffix: !!searchValue && /* @__PURE__ */ jsx(
          Icon,
          {
            name: "close",
            className: "text-base text-secondary-600 flex items-center pr-3 cursor-pointer",
            onClick: () => setSearchValue("")
          }
        ),
        placeholder: t("common.search"),
        isDisabled: !Boolean(modifiedData.length || debouncedSearchTerm)
      },
      "search-input"
    ),
    /* @__PURE__ */ jsxs("div", { className: "h-[250px] overflow-hidden", children: [
      /* @__PURE__ */ jsx("div", { className: "bg-secondary-50 w-full py-2 px-4 uppercase font-medium text-secondary-400 text-left text-xs", children: t("testcase.linked") }),
      modifiedData?.length === 0 && isFetching ? /* @__PURE__ */ jsx("div", { className: "h-48 basis-full flex items-center", children: /* @__PURE__ */ jsx("div", { className: "empty-page-loader mx-auto" }) }) : !!modifiedData?.length ? /* @__PURE__ */ jsx(
        VirtualizedInfiniteLoader4,
        {
          rowHeight: 32,
          rowRenderer: (index) => {
            const item2 = modifiedData[index];
            return /* @__PURE__ */ jsx(
              "div",
              {
                className: "py-2 px-4 text-secondary-unique-600 text-xs line-clamp-5 text-left truncate hover:bg-secondary-50 cursor-pointer",
                onClick: (e) => openTestCaseTab(e, item2),
                role: "row",
                children: /* @__PURE__ */ jsx(TruncatedText, { className: "inline-block", value: item2?.name, role: "gridcell" })
              },
              item2.id
            );
          },
          rowCount: modifiedData?.length || 0,
          items: modifiedData,
          loadMore: fetchNextPage,
          hasMore: hasNextPage,
          isLoading: isFetching
        }
      ) : /* @__PURE__ */ jsx("div", { children: t("step.no_match_found") })
    ] })
  ] });
};
var TableContext = createContext(null);
var TableProvider = ({
  children,
  isRecoder
}) => {
  return /* @__PURE__ */ jsx(TableContext.Provider, { value: { isRecoder }, children });
};
var useTableContext = () => {
  return useContext(TableContext);
};
var RuntimeVariableListItem = ({ item, idx, onClick, useGetRuntimeVariableUsage }) => {
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(
    TableRow,
    {
      className: classNames82(
        "hover:!bg-secondary-50 cursor-pointer border-b-[0.5px] border-b-secondary-200 flex w-full"
      ),
      children: [
        /* @__PURE__ */ jsx(
          TableCell,
          {
            className: "w-4/5 cursor-pointer flex items-center",
            onClick: () => onClick(item),
            children: /* @__PURE__ */ jsx(
              TruncatedText,
              {
                className: "inline-block",
                value: item?.runTimeVariableName
              }
            )
          }
        ),
        /* @__PURE__ */ jsx(TableCell, { className: "text-center flex justify-center items-center w-1/5", children: /* @__PURE__ */ jsx(
          UsageCountBadge,
          {
            useGetRuntimeVariableUsage,
            item
          }
        ) })
      ]
    },
    idx
  ) });
};
var UsageCountBadge = ({
  useGetRuntimeVariableUsage,
  item
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };
  const { isRecoder } = useTableContext();
  return /* @__PURE__ */ jsx(
    Popover,
    {
      trigger: /* @__PURE__ */ jsx(
        "div",
        {
          className: classNames82(
            "px-2 py-1 border border-secondary-100 text-xs leading-4 rounded h-6",
            { "cursor-pointer": !isRecoder },
            {
              "!bg-secondary-unique-800 !text-white": showDropdown && !isRecoder
            }
          ),
          onClick: (e) => toggleDropdown(),
          children: item.usageCount
        }
      ),
      fillWidth: false,
      variant: "select-fill-plain",
      className: "!bg-transparent py-0 !border-0",
      onFocusClassName: "!border-primary-300",
      dropdownClassName: "!w-[200px] flex flex-col !py-0",
      show: showDropdown,
      placement: "auto-end",
      onToggle: toggleDropdown,
      children: showDropdown && !isRecoder && /* @__PURE__ */ jsx(
        RuntimeVariableUsageDetailsPopup,
        {
          useGetRuntimeVariableUsage,
          item
        }
      )
    }
  );
};
var RuntimeVariableInfiniteScroll = ({
  items,
  loadNextPage,
  hasNextPage,
  onClick,
  useGetRuntimeVariableUsage,
  isLoading
}) => {
  const { VirtualizedInfiniteLoader: VirtualizedInfiniteLoader9 } = InfiniteScrollV2;
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    VirtualizedInfiniteLoader9,
    {
      rowHeight: 32,
      rowRenderer: (index) => {
        const item = items[index];
        return /* @__PURE__ */ jsx(
          RuntimeVariableListItem,
          {
            item,
            idx: index,
            onClick,
            useGetRuntimeVariableUsage
          }
        );
      },
      rowCount: items?.length || 0,
      items,
      loadMore: loadNextPage,
      hasMore: hasNextPage,
      isLoading
    }
  ) });
};
var RuntimeVariableTable = ({
  data,
  onClick,
  useGetRuntimeVariableUsage,
  hasNextPage,
  handleLoadMore,
  isLoading
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs(
    Table,
    {
      wrapperClassName: "max-h-[600px] overflow-hidden h-full",
      className: "h-full overflow-hidden",
      children: [
        /* @__PURE__ */ jsx(TableHeader, { className: "bg-secondary-100 rounded sticky top-0 !z-10 ", children: /* @__PURE__ */ jsxs(TableRow, { children: [
          /* @__PURE__ */ jsx(TableCell, { className: "w-4/5", children: t("runtime.var.name") }),
          /* @__PURE__ */ jsx(TableCell, { className: "w-1/5 text-center", children: /* @__PURE__ */ jsx(ToolTip, { content: t("runtime.links"), children: t("runtime.var.links") }) })
        ] }) }),
        /* @__PURE__ */ jsx(TableBody, { className: "h-full w-full", children: /* @__PURE__ */ jsx(
          RuntimeVariableInfiniteScroll,
          {
            items: data,
            hasNextPage,
            loadNextPage: handleLoadMore,
            useGetRuntimeVariableUsage,
            onClick,
            isLoading
          }
        ) })
      ]
    }
  );
};
var RuntimeVariableValueSelector = ({
  onClick,
  runtimeVariables,
  isFetching,
  onChangeSearch,
  onShowProjectcher,
  isShowingProjectSwitcher,
  useGetRuntimeVariableUsage,
  hasMore,
  handleLoadMore,
  searchTerm,
  isRecoder = false
}) => {
  const { t } = useTranslation();
  const [newRuntimeVariable, setNewRuntimeVariable] = useState("");
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col h-full", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex w-full h-fit", children: [
      /* @__PURE__ */ jsx("div", { className: "relative w-full mb-12", children: /* @__PURE__ */ jsx(
        AutoResizingDebouncedInput,
        {
          searchInputClassName: "absolute top-0 z-10 !w-full",
          minHeight: 35,
          wrapperClassName: "!flex-1 !w-full",
          showClearIcon: true,
          clearIconClassName: "text-secondary-600 flex items-center cursor-pointer",
          placeholder: t("common.search"),
          value: searchTerm,
          onChange: onChangeSearch,
          inputClassName: "!px-2 !py-1.5",
          isDisabled: !Boolean(runtimeVariables.length || searchTerm),
          className: "focus-within:!border-primary-300 focus-within:!ring focus-within:!ring-primary-100"
        }
      ) }),
      !isShowingProjectSwitcher && /* @__PURE__ */ jsx(
        Button,
        {
          className: "ml-2 flex-shrink-0 !h-9",
          size: "md",
          type: "secondary",
          onClick: onShowProjectcher,
          children: t("switch.project")
        }
      )
    ] }),
    Boolean(runtimeVariables?.length) && /* @__PURE__ */ jsx(TableProvider, { isRecoder, children: /* @__PURE__ */ jsx("div", { className: "h-full", children: /* @__PURE__ */ jsx(
      RuntimeVariableTable,
      {
        data: runtimeVariables || [],
        onClick,
        useGetRuntimeVariableUsage,
        hasNextPage: hasMore,
        handleLoadMore,
        isLoading: isFetching
      }
    ) }) }),
    isFetching && !Boolean(runtimeVariables?.length) && /* @__PURE__ */ jsx("div", { className: "h-48 basis-full flex items-center", children: /* @__PURE__ */ jsx("div", { className: "empty-page-loader mx-auto" }) }),
    !isFetching && !Boolean(runtimeVariables?.length) && /* @__PURE__ */ jsx(EmptyRuntime, { isSearch: !!searchTerm, isRecoder }),
    /* @__PURE__ */ jsxs("div", { className: "bg-warning-100 rounded p-3 text-secondary-700 text-small flex mt-5 w-full", children: [
      /* @__PURE__ */ jsx(Icon, { name: "info", className: "text-secondary-700 text-lg" }),
      /* @__PURE__ */ jsx("div", { className: "ml-3", children: t("enter.manual.runtime.variable.info") })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "mt-6 flex w-full items-center", children: [
      /* @__PURE__ */ jsx(
        Input,
        {
          value: newRuntimeVariable,
          onChange: (val) => setNewRuntimeVariable(val),
          placeholder: t("enter.manual.runtime.variable"),
          inputClassName: "outline-none w-full bg-white border border-neutral-200 rounded",
          hideErrorMessage: true,
          wrapperClassName: "outline-none w-full bg-white p-md pl-0"
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          type: "primary",
          className: "ml-3",
          onClick: () => onClick({ runTimeVariableName: newRuntimeVariable }),
          isDisabled: !newRuntimeVariable?.trim?.(),
          children: t("common.add")
        }
      )
    ] })
  ] });
};
var know_more3 = "https://testsigma.com/docs/test-data/types/phone-number/";
var EmptyPhoneNumber = ({ isSearch, isRecorder = false }) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames82({
        flex: isSearch
      }),
      children: isSearch ? /* @__PURE__ */ jsx(SearchNotFound, {}) : /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          Icon,
          {
            name: "error",
            className: "inline-block cursor-pointer text-primary-500 text-5xl justify-center w-full"
          }
        ),
        /* @__PURE__ */ jsx("div", { className: "font-semibold text-secondary-700 py-6 basis-full text-center px-10", children: t("suggestion_popup.phone_number.empty_info") }),
        !isRecorder && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsxs("div", { className: "grid items-center justify-center", children: [
            /* @__PURE__ */ jsx("div", { className: "text-secondary-700 basis-full text-center", children: t("suggestion_popup.phone_number.not_associated_info") }),
            /* @__PURE__ */ jsx(
              "a",
              {
                className: "text-primary-500 basis-full text-center cursor-pointer",
                href: "mailto:support@testsigma.com",
                target: "_blank",
                rel: "noreferrer",
                children: t("common.support_mail")
              }
            )
          ] }),
          /* @__PURE__ */ jsx("div", { className: "flex p-lg basis-full justify-center", children: /* @__PURE__ */ jsx(
            Button,
            {
              type: "secondary",
              onClick: () => window.open(know_more3, "_blank"),
              children: t("common.know_more")
            }
          ) })
        ] })
      ] })
    }
  ) });
};
var PhoneNumberListItem = ({
  item,
  idx,
  onClick
}) => {
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    TableRow,
    {
      className: classNames82(
        "hover:!bg-secondary-50 cursor-pointer border-b-[0.5px] border-b-secondary-200 w-full flex"
      ),
      onClick: () => onClick(item),
      children: /* @__PURE__ */ jsx(TableCell, { className: "min-w-[200px] w-full flex items-center", children: /* @__PURE__ */ jsx(TruncatedText, { className: "inline-block", value: item.phoneNumber }) })
    },
    item.id
  ) });
};
var PhoneNumberInfiniteScroll = ({ items, loadNextPage, hasNextPage, onClick, isLoading }) => {
  const { VirtualizedInfiniteLoader: VirtualizedInfiniteLoader9 } = InfiniteScrollV2;
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    VirtualizedInfiniteLoader9,
    {
      rowHeight: 32,
      rowRenderer: (index) => {
        const item = items[index];
        return /* @__PURE__ */ jsx(PhoneNumberListItem, { item, idx: index, onClick });
      },
      rowCount: items?.length || 0,
      items,
      loadMore: loadNextPage,
      hasMore: hasNextPage,
      isLoading
    }
  ) });
};
var PhoneNumberTable = ({
  phoneNumbers,
  onClick,
  hasNextPage,
  handleLoadMore,
  isLoading
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs(
    Table,
    {
      wrapperClassName: "h-full !border-0",
      className: "h-full overflow-hidden",
      children: [
        /* @__PURE__ */ jsx(TableHeader, { className: "bg-secondary-100 rounded", children: /* @__PURE__ */ jsx(TableRow, { children: /* @__PURE__ */ jsx(TableCell, { className: "min-w-[200px] !border-0", children: t("label.phone_number") }) }) }),
        /* @__PURE__ */ jsx(TableBody, { className: "h-full w-full", children: /* @__PURE__ */ jsx(
          PhoneNumberInfiniteScroll,
          {
            items: phoneNumbers,
            onClick,
            loadNextPage: handleLoadMore,
            hasNextPage,
            isLoading
          }
        ) })
      ]
    }
  );
};
var PhoneNumberSelector = ({
  onClick,
  phoneNumbers,
  isFetching,
  onChangeSearch,
  hasMore,
  handleLoadMore,
  searchTerm,
  isRecorder = false
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col h-full", children: [
    Boolean(phoneNumbers.length || searchTerm) && /* @__PURE__ */ jsx("div", { className: "relative w-full mb-12", children: /* @__PURE__ */ jsx(
      AutoResizingDebouncedInput,
      {
        searchInputClassName: "absolute top-0 z-10 !w-full",
        wrapperClassName: "!flex-1 !w-full",
        minHeight: 35,
        showClearIcon: true,
        clearIconClassName: "text-secondary-600 flex items-center cursor-pointer",
        placeholder: t("suggestion_popup.phone_number.placeholder"),
        value: searchTerm,
        onChange: onChangeSearch,
        inputClassName: "!px-2 !py-1.5",
        className: "focus-within:!border-primary-300 focus-within:!ring focus-within:!ring-primary-100"
      }
    ) }),
    Boolean(phoneNumbers.length) && /* @__PURE__ */ jsx("div", { className: "basis-full mt-4", children: /* @__PURE__ */ jsx(
      PhoneNumberTable,
      {
        phoneNumbers,
        onClick,
        hasNextPage: hasMore,
        handleLoadMore,
        isLoading: isFetching
      }
    ) }),
    isFetching && /* @__PURE__ */ jsx("div", { className: "h-48 basis-full", children: /* @__PURE__ */ jsx("div", { className: "empty-page-loader left-1/2 top-1/2 absolute" }) }),
    Boolean(!phoneNumbers.length && !isFetching) && /* @__PURE__ */ jsx("div", { className: "h-full justify-center items-center flex", children: /* @__PURE__ */ jsx(EmptyPhoneNumber, { isSearch: !!searchTerm, isRecorder }) })
  ] });
};
var MailBoxListItem = ({
  item,
  idx,
  onClick
}) => {
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    TableRow,
    {
      className: classNames82(
        "hover:!bg-secondary-50 cursor-pointer border-b-[0.5px] border-b-secondary-200 flex"
      ),
      onClick: () => onClick(item),
      children: /* @__PURE__ */ jsx(TableCell, { className: "min-w-[200px] w-full flex items-center", children: /* @__PURE__ */ jsx(TruncatedText, { className: "inline-block", value: item.email }) })
    },
    item.id
  ) });
};
var EmailBoxInfiniteScroll = ({
  items,
  loadNextPage,
  hasNextPage,
  onClick,
  isLoading
}) => {
  const { VirtualizedInfiniteLoader: VirtualizedInfiniteLoader9 } = InfiniteScrollV2;
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    VirtualizedInfiniteLoader9,
    {
      rowHeight: 32,
      rowRenderer: (index) => {
        const item = items[index];
        return /* @__PURE__ */ jsx(MailBoxListItem, { item, idx: index, onClick });
      },
      rowCount: items?.length || 0,
      items,
      loadMore: loadNextPage,
      hasMore: hasNextPage,
      isLoading
    }
  ) });
};
var EmailBoxTable = ({
  data,
  onClick,
  hasNextPage,
  handleLoadMore,
  isLoading
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs(
    Table,
    {
      wrapperClassName: "h-full !border-0",
      className: "h-full overflow-hidden",
      children: [
        /* @__PURE__ */ jsx(TableHeader, { className: "bg-secondary-100 rounded", children: /* @__PURE__ */ jsx(TableRow, { children: /* @__PURE__ */ jsx(TableCell, { className: "min-w-[200px] !border-0", children: t("label.mail_box") }) }) }),
        /* @__PURE__ */ jsx(TableBody, { className: "h-full w-full", children: /* @__PURE__ */ jsx(
          EmailBoxInfiniteScroll,
          {
            items: data,
            onClick,
            hasNextPage,
            isLoading,
            loadNextPage: handleLoadMore
          }
        ) })
      ]
    }
  );
};
var know_more4 = "https://testsigma.com/docs/test-data/types/mailbox/";
var EmptyEmail = ({ isSearch, isRecorder }) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames82({
        flex: isSearch
      }),
      children: isSearch ? /* @__PURE__ */ jsx(SearchNotFound, {}) : /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          Icon,
          {
            name: "error",
            className: "inline-block cursor-pointer text-primary-500 text-5xl justify-center w-full"
          }
        ),
        /* @__PURE__ */ jsx("div", { className: "font-semibold text-secondary-700 py-6 basis-full text-center px-10", children: t("suggestion_popup.mail_box.empty_info") }),
        !isRecorder && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsxs("div", { className: "grid items-center justify-center", children: [
            /* @__PURE__ */ jsx("div", { className: "text-secondary-700 basis-full text-center", children: t("suggestion_popup.mail_box.not_associated_info") }),
            /* @__PURE__ */ jsx(
              "a",
              {
                className: "text-primary-500 basis-full text-center cursor-pointer",
                href: "mailto:support@testsigma.com",
                target: "_blank",
                rel: "noreferrer",
                children: t("common.support_mail")
              }
            )
          ] }),
          /* @__PURE__ */ jsx("div", { className: "flex p-lg basis-full justify-center", children: /* @__PURE__ */ jsx(
            Button,
            {
              type: "secondary",
              onClick: () => window.open(know_more4, "_blank"),
              children: t("common.know_more")
            }
          ) })
        ] })
      ] })
    }
  ) });
};
var EmailBoxValueSelector = ({
  onClick,
  mailboxes,
  isFetching,
  onChangeSearch,
  hasMore,
  handleLoadMore,
  searchTerm,
  isRecorder = false
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col h-full", children: [
    Boolean(mailboxes.length || searchTerm) && /* @__PURE__ */ jsx("div", { className: "relative w-full mb-12", children: /* @__PURE__ */ jsx(
      AutoResizingDebouncedInput,
      {
        searchInputClassName: "absolute top-0 z-10 !w-full",
        wrapperClassName: "!flex-1 !w-full",
        minHeight: 35,
        showClearIcon: true,
        clearIconClassName: "text-secondary-600 flex items-center cursor-pointer",
        placeholder: t("suggestion_popup.mail_box.placeholder"),
        value: searchTerm,
        onChange: onChangeSearch,
        inputClassName: "!px-2 !py-1.5",
        className: "focus-within:!border-primary-300 focus-within:!ring focus-within:!ring-primary-100"
      }
    ) }),
    Boolean(mailboxes.length) && /* @__PURE__ */ jsx("div", { className: "basis-full mt-4", children: /* @__PURE__ */ jsx(
      EmailBoxTable,
      {
        data: mailboxes || [],
        onClick,
        hasNextPage: hasMore,
        handleLoadMore,
        isLoading: isFetching
      }
    ) }),
    isFetching && Boolean(mailboxes.length) && /* @__PURE__ */ jsx("div", { className: "h-48 basis-full", children: /* @__PURE__ */ jsx("div", { className: "empty-page-loader left-1/2 top-1/2 absolute" }) }),
    Boolean(!mailboxes.length && !isFetching) && /* @__PURE__ */ jsx("div", { className: "h-full justify-center items-center flex", children: /* @__PURE__ */ jsx(EmptyEmail, { isSearch: !!searchTerm, isRecorder }) })
  ] });
};
var know_more5 = "https://testsigma.com/docs/test-data/create-data-profiles/";
var EmptyParameter = ({
  openTestDataProfile,
  openEditTestCase,
  isDataGenerator = false,
  isRecorder = false,
  fetchDataProfile
}) => {
  const { t } = useTranslation();
  const [canShowrefresh, setCanShowrefresh] = useState(false);
  const openEditTestCaseFunction = () => {
    setCanShowrefresh(true);
    return openEditTestCase(true);
  };
  const openTestDataFunction = () => {
    setCanShowrefresh(true);
    return openTestDataProfile(true);
  };
  const onFetchDataProfile = () => {
    fetchDataProfile?.();
  };
  return /* @__PURE__ */ jsx("div", { className: "h-full flex items-center", children: /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames82(
        "flex items-center flex-wrap justify-center text-small leading-[18px]",
        {
          "m-6": isDataGenerator
        }
      ),
      children: [
        /* @__PURE__ */ jsx(
          Icon,
          {
            name: "error",
            className: "inline-block cursor-pointer text-primary-500 text-5xl"
          }
        ),
        /* @__PURE__ */ jsx("div", { className: "font-semibold text-secondary-700 py-6 basis-full text-center px-10", children: isDataGenerator ? t("data_generator.empty_parameter_info") : t("parameter.empty_info") }),
        /* @__PURE__ */ jsx("div", { className: "text-secondary-700 basis-full text-center", children: isDataGenerator ? t("data_generator.create_parameter_info") : t("parameter.not_associated_info") }),
        !isRecorder && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsxs(
            "div",
            {
              className: `basis-full flex p-lg ${isDataGenerator ? "my-4" : "my-8"}`,
              children: [
                /* @__PURE__ */ jsx(
                  PrimaryButton,
                  {
                    className: "cursor-pointer flex-grow inline-flex items-center justify-center px-4 py-1.5 rounded",
                    onClick: openTestDataFunction,
                    children: t("common.create")
                  }
                ),
                !isDataGenerator && /* @__PURE__ */ jsx(
                  PrimaryButton,
                  {
                    className: "cursor-pointer flex-grow inline-flex items-center justify-center ml-4 px-4 py-1.5 rounded",
                    onClick: openEditTestCaseFunction,
                    children: t("common.associate")
                  }
                ),
                canShowrefresh && /* @__PURE__ */ jsx(
                  ToolTip,
                  {
                    placement: "bottom",
                    content: t("common.click_here_refresh"),
                    className: "inline-flex",
                    children: /* @__PURE__ */ jsx(
                      Button,
                      {
                        type: "secondary",
                        className: "cursor-pointer flex-grow inline-flex items-center justify-center ml-4 px-4 py-1.5 rounded text-small leading-5",
                        onClick: onFetchDataProfile,
                        "aria-label": t("common.click_here_refresh"),
                        children: /* @__PURE__ */ jsx(Icon, { name: "refresh" })
                      }
                    )
                  }
                )
              ]
            }
          ),
          !isDataGenerator && /* @__PURE__ */ jsx("div", { className: "flex p-lg basis-full justify-center", children: /* @__PURE__ */ jsx(
            Button,
            {
              type: "secondary",
              onClick: () => window.open(know_more5, "_blank"),
              children: t("common.know_more")
            }
          ) })
        ] })
      ]
    }
  ) });
};
var ParameterTable = ({
  onClick,
  dataSets,
  tdp,
  searchQuery
}) => {
  const { t } = useTranslation();
  const filteredDataSet = useMemo(() => {
    return dataSets?.filter(
      (item) => item?.toLocaleLowerCase()?.includes(searchQuery?.toLocaleLowerCase())
    );
  }, [dataSets, searchQuery]);
  return /* @__PURE__ */ jsx("div", { className: "h-[calc(100%_-_135px)] overflow-auto", children: !!filteredDataSet?.length ? /* @__PURE__ */ jsxs(Table, { wrapperClassName: "h-full !border-0", children: [
    /* @__PURE__ */ jsx(TableHeader, { className: "bg-secondary-50 rounded", children: /* @__PURE__ */ jsx(TableRow, { children: /* @__PURE__ */ jsx(TableCell, { className: "min-w-[200px] !border-0", children: t("label.parameter") }) }) }),
    /* @__PURE__ */ jsx(TableBody, { children: filteredDataSet.map((item) => /* @__PURE__ */ jsx(
      TableRow,
      {
        className: classNames82(
          "hover:!bg-secondary-50 cursor-pointer border-b-[0.5px] border-b-secondary-200"
        ),
        onClick: () => onClick(item, tdp),
        children: /* @__PURE__ */ jsx(TableCell, { className: "min-w-[200px] border-y-0", children: item })
      },
      item
    )) })
  ] }) : /* @__PURE__ */ jsx("div", { className: "flex h-full items-center justify-center", children: /* @__PURE__ */ jsx(SearchNotFound, {}) }) });
};
var ParameterValueSelector = ({
  dataProfiles = [],
  selectedDataProfileId,
  onClick,
  onchangeProfile,
  openTestDataProfile,
  openEditTestCase,
  isFetching,
  profileList,
  isRecorder = false,
  fetchDataProfile
}) => {
  const { t } = useTranslation();
  const [searchQuery, setSearchQuery] = useState("");
  const [tdpSearchQuery, setTdpSearchQuery] = useState("");
  const [selctedProfileList, setSelectedProfileList] = useState(
    profileList.find((item) => item["id"] == selectedDataProfileId)
  );
  const selectedDataProfile = dataProfiles.find(
    (item) => item?.id == selectedDataProfileId
  );
  const dataSets = selectedDataProfile?.columns || [];
  const handleProfileChange = useCallback(
    (profile) => {
      onchangeProfile(profile);
      setSelectedProfileList(profile);
    },
    [onchangeProfile]
  );
  const getTestDataProfileName = (item) => {
    let name = item?.name || dataProfiles.find((profile) => profile.id === item?.id)?.name;
    name += item?.stepNumber ? ` [#${item?.stepNumber}]` : "";
    return name;
  };
  const filteredProfiles = useMemo(() => {
    return profileList.filter(
      (item) => !!item["id"] && getTestDataProfileName(item).toLocaleLowerCase().includes(tdpSearchQuery.toLocaleLowerCase())
    );
  }, [profileList, tdpSearchQuery]);
  useEffect(() => {
    setSelectedProfileList(
      profileList.find((item) => item["id"] == selectedDataProfileId)
    );
  }, [selectedDataProfileId, profileList]);
  return /* @__PURE__ */ jsxs("div", { className: "h-full", children: [
    Boolean(dataProfiles.length) && /* @__PURE__ */ jsxs("div", { className: "z-20 basis-full pb-4", children: [
      /* @__PURE__ */ jsx("div", { className: "mb-1.5 text-secondary-500 text-2xs mx-0.5 font-medium", children: t("suggestion_popup.parameter.label") }),
      /* @__PURE__ */ jsxs(
        DropdownButton,
        {
          name: getTestDataProfileName(selctedProfileList),
          onClick: () => setTdpSearchQuery(""),
          children: [
            /* @__PURE__ */ jsx(
              Input,
              {
                wrapperClassName: "!flex basis-full",
                onChange: setTdpSearchQuery,
                preventDefaultValue: true,
                prefix: /* @__PURE__ */ jsx("div", { className: "flex flex-col justify-center ml-3 text-secondary-600", children: /* @__PURE__ */ jsx(Icon, { name: "search", className: "text-2xl" }) }),
                suffix: !!tdpSearchQuery && /* @__PURE__ */ jsx(
                  Icon,
                  {
                    name: "close",
                    className: "text-base text-secondary-600 flex items-center pr-3 cursor-pointer",
                    onClick: () => setTdpSearchQuery("")
                  }
                ),
                value: tdpSearchQuery,
                placeholder: t("suggestion_popup.test_data_profile.placeholder")
              },
              "search-input"
            ),
            filteredProfiles?.length ? filteredProfiles.map((item, index) => /* @__PURE__ */ jsx(
              DropdownItem,
              {
                onClick: () => handleProfileChange(item),
                children: getTestDataProfileName(item)
              },
              index
            )) : /* @__PURE__ */ jsx(SearchNotFound, {})
          ]
        }
      )
    ] }),
    Boolean(dataSets.length || searchQuery) && /* @__PURE__ */ jsx("div", { className: "relative w-full mb-12", children: /* @__PURE__ */ jsx(
      AutoResizingDebouncedInput,
      {
        searchInputClassName: "absolute top-0 z-10 !w-full",
        wrapperClassName: "!flex-1 !w-full",
        minHeight: 35,
        showClearIcon: true,
        clearIconClassName: "text-secondary-600 flex items-center cursor-pointer",
        placeholder: t("common.search"),
        value: searchQuery,
        onChange: setSearchQuery,
        inputClassName: "!px-2 !py-1.5",
        className: "focus-within:!border-primary-300 focus-within:!ring focus-within:!ring-primary-100"
      }
    ) }),
    Boolean(!isFetching && dataSets.length) && /* @__PURE__ */ jsx(
      ParameterTable,
      {
        onClick,
        dataSets,
        tdp: selctedProfileList,
        searchQuery
      }
    ),
    isFetching && /* @__PURE__ */ jsx("div", { className: "empty-page-loader left-1/2 top-1/3 absolute" }),
    Boolean(!dataSets.length && !searchQuery.length && !isFetching) && /* @__PURE__ */ jsx(
      EmptyParameter,
      {
        openTestDataProfile,
        openEditTestCase,
        isRecorder,
        fetchDataProfile
      }
    )
  ] });
};
var parameter_value_selector_default = ParameterValueSelector;
var EMPTY_VARIABLE = {
  key: "",
  value: "",
  isEncrypted: false,
  isEdited: true,
  isTempEncrypted: false,
  canShowEncryptValue: false
};
var Prefix = ({ row, onClickLockIcon }) => {
  const { t } = useTranslation();
  const { isTempEncrypted, isEncrypted } = row;
  const content = isEncrypted || isTempEncrypted ? t("testdata.plaintext.after.encryption") : t("testdata.plaintext.before.encryption");
  const iconName = isEncrypted || isTempEncrypted ? "lock" : "decrypt";
  const className = classNames82(
    "ml-3 text-xl cursor-pointer",
    isTempEncrypted || isEncrypted ? "text-primary-600" : "text-warning-600"
  );
  return /* @__PURE__ */ jsx(ToolTip, { content, className: "flex items-center", placement: "top", children: /* @__PURE__ */ jsx(Icon, { name: iconName, className, onClick: onClickLockIcon }) });
};
var Suffix = ({ row, onUpdateRow }) => {
  const { isTempEncrypted, canShowEncryptValue } = row;
  const onClick = () => onUpdateRow({
    ...row,
    canShowEncryptValue: !canShowEncryptValue
  });
  const iconName = canShowEncryptValue ? "visibility-outline" : "visibility-off-outline";
  return /* @__PURE__ */ jsx(Fragment, { children: isTempEncrypted && /* @__PURE__ */ jsx(
    Icon,
    {
      name: iconName,
      className: "leading-4.5 hover:bg-secondary-100 rounded cursor-pointer text-lg text-unique-800 mx-2",
      onClick
    }
  ) });
};
var CreateVariableModal = ({
  show: show3,
  onClose,
  createVariable,
  isCreateVariableLoading
}) => {
  const [newVariable, setNewVariable] = useState(EMPTY_VARIABLE);
  const { t } = useTranslation();
  const { key, value, isEncrypted, canShowEncryptValue, isTempEncrypted } = newVariable;
  const [error, setError] = useState("");
  const onChangeNewVariable = (variableKey, variableValue) => setNewVariable({ ...newVariable, [variableKey]: variableValue });
  const onClickCreate = () => createVariable(newVariable);
  const onClickLockIcon = () => onChangeNewVariable("isTempEncrypted", !isTempEncrypted);
  const nameSchema = useInputTextValidationSchema(t("variable.label"));
  const schema = yup.object().shape({
    name: nameSchema
  });
  const validateInput = async (inputValue) => {
    try {
      await schema.validate({ name: inputValue });
      setError("");
    } catch (err) {
      setError(err.message);
    }
  };
  return /* @__PURE__ */ jsxs(
    Modal,
    {
      isOpen: show3,
      className: "relative !w-[500px] !p-0 !pt-6 rounded-md",
      overlayClassName: "!z-[3000]",
      showCloseButton: true,
      closeOnEscape: true,
      closeOnOutsideClick: true,
      onClose,
      children: [
        /* @__PURE__ */ jsx("h1", { className: "text-lg text-secondary-unique-600 font-semibold mb-8 px-6", children: t("variables.add_environment_variable.label") }),
        /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-x-6 mb-8 px-6", children: [
          /* @__PURE__ */ jsx(
            Input,
            {
              isRequired: true,
              label: t("variable.label"),
              placeholder: "Variable Name",
              value: key,
              onChange: (changedValue) => {
                validateInput(changedValue);
                onChangeNewVariable("key", changedValue);
              },
              errorText: error,
              hasError: !!error,
              inputClassName: "w-full",
              wrapperClassName: "mb-6"
            }
          ),
          /* @__PURE__ */ jsxs("div", { className: "flex items-end gap-1 w-full", children: [
            /* @__PURE__ */ jsx(
              Input,
              {
                label: t("common.default_value.label"),
                preventDefaultValue: true,
                suffix: /* @__PURE__ */ jsx(Suffix, { row: newVariable, onUpdateRow: setNewVariable }),
                type: isEncrypted || isTempEncrypted && !canShowEncryptValue ? "password" : "text",
                wrapperClassName: "w-full",
                onChange: (changedValue) => onChangeNewVariable("value", changedValue),
                value,
                inputClassName: "w-full",
                placeholder: t("api.value")
              }
            ),
            /* @__PURE__ */ jsx("div", { className: "mb-2", children: /* @__PURE__ */ jsx(Prefix, { row: newVariable, onClickLockIcon }) })
          ] })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "flex justify-end gap-x-2.5 py-4 px-6 border-t border-t-secondary-100", children: [
          /* @__PURE__ */ jsx(Button, { type: "secondary", onClick: onClose, children: t("common.cancel") }),
          /* @__PURE__ */ jsx(
            Button,
            {
              onClick: onClickCreate,
              isDisabled: !!error || !key,
              isLoading: isCreateVariableLoading,
              children: isCreateVariableLoading ? t("common.create.in-progress") : t("common.create")
            }
          )
        ] })
      ]
    }
  );
};
var create_variable_modal_default = CreateVariableModal;
var know_more6 = "https://testsigma.com/docs/test-data/types/environment/";
var EmptyEnvironment = ({
  openEnvironment,
  onFetchEnvironment,
  isSearch = false,
  isWebRecorder = false
}) => {
  const { t } = useTranslation();
  const [canShowrefresh, updateCanShowrefresh] = useState(false);
  const isSearchDebounced = useDebounce(isSearch, 1e3);
  const openEnvironmentFunction = () => {
    updateCanShowrefresh(true);
    return openEnvironment(true);
  };
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", { className: "flex-1 flex items-center justify-center flex-col text-small leading-[18px]", children: [
    !isSearchDebounced && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        Icon,
        {
          name: "error",
          className: "inline-block cursor-pointer text-primary-500 text-5xl"
        }
      ),
      /* @__PURE__ */ jsx("div", { className: "text-secondary-500 py-6 basis-full text-center px-10", children: t("suggestion_popup.environment.empty_info") })
    ] }),
    isSearchDebounced && /* @__PURE__ */ jsx(SearchNotFound, {}),
    !isWebRecorder && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("div", { className: "flex p-lg", children: [
        !isSearchDebounced && /* @__PURE__ */ jsx(
          Button,
          {
            type: "primary",
            className: "flex-grow justify-center",
            onClick: openEnvironmentFunction,
            children: t("common.create")
          }
        ),
        canShowrefresh && /* @__PURE__ */ jsx(
          ToolTip,
          {
            placement: "bottom",
            content: t("common.click_here_refresh"),
            className: "inline-flex",
            children: /* @__PURE__ */ jsx(
              Button,
              {
                type: "secondary",
                className: "ml-4",
                onClick: onFetchEnvironment,
                "aria-label": t("common.click_here_refresh"),
                children: /* @__PURE__ */ jsx(Icon, { name: "refresh" })
              }
            )
          }
        )
      ] }),
      /* @__PURE__ */ jsx("div", { className: "flex p-lg basis-full justify-center", children: /* @__PURE__ */ jsx(
        Button,
        {
          type: "secondary",
          onClick: () => window.open(know_more6, "_blank"),
          children: t("common.know_more")
        }
      ) })
    ] })
  ] }) });
};
var EnvironmentListItem = ({
  item,
  idx,
  onClick
}) => {
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    TableRow,
    {
      className: classNames82(
        "hover:!bg-secondary-50 cursor-pointer border-b-[0.5px] border-b-secondary-200 flex"
      ),
      onClick: () => onClick(item),
      children: /* @__PURE__ */ jsx(TableCell, { className: "w-full border-0 px-3 py-1.5", children: /* @__PURE__ */ jsx(
        TruncatedText,
        {
          className: "inline-block",
          tooltipClassName: "!break-all",
          value: `${item.key}`
        }
      ) })
    },
    `${item.key}_${idx}`
  ) });
};
var EnvironmentValueInfiniteScroll = ({ items, loadNextPage, hasNextPage, onClick, isLoading }) => {
  const { VirtualizedInfiniteLoader: VirtualizedInfiniteLoader9 } = InfiniteScrollV2;
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    VirtualizedInfiniteLoader9,
    {
      rowHeight: 32,
      rowRenderer: (index) => {
        const item = items[index];
        return /* @__PURE__ */ jsx(
          EnvironmentListItem,
          {
            item,
            idx: index,
            onClick
          },
          index
        );
      },
      rowCount: items?.length || 0,
      items,
      loadMore: loadNextPage,
      hasMore: hasNextPage,
      isLoading
    }
  ) });
};
var EnvironmentTable = ({
  data,
  onClick,
  hasNextPage,
  handleLoadMore,
  isLoading
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs(
    Table,
    {
      wrapperClassName: "!border-0 h-full overflow-hidden",
      className: "h-full overflow-hidden",
      children: [
        /* @__PURE__ */ jsx(TableHeader, { className: "bg-secondary-50 rounded", children: /* @__PURE__ */ jsx(TableRow, { children: /* @__PURE__ */ jsx(TableCell, { className: "min-w-[200px] !border-0 font-semibold text-secondary-unique-600 px-3 py-1.5", children: "Variable Name" }) }) }),
        /* @__PURE__ */ jsx(TableBody, { className: "h-full w-full", children: /* @__PURE__ */ jsx(
          EnvironmentValueInfiniteScroll,
          {
            items: data,
            loadNextPage: handleLoadMore,
            hasNextPage,
            onClick,
            isLoading
          }
        ) })
      ]
    }
  );
};
var EnvironmentValueSelector = ({
  onClick,
  variables = [],
  isFetching,
  setSearchTerm,
  hasMore,
  handleLoadMore,
  createVariable,
  isRecorder = false,
  searchTerm,
  openEnvironment = NOOP,
  refetch,
  isCreateVariableLoading
}) => {
  const { t } = useTranslation();
  const [showAddVariableModal, setShowAddVariableModal] = useState(false);
  const isVariablesEmpty = useMemo(() => variables.length == 0, [variables]);
  const onClickAddVariable = () => setShowAddVariableModal(true);
  const onCloseCreateVariableModal = () => setShowAddVariableModal(false);
  const onClickCreate = async (newVariable) => createVariable(newVariable, onCloseCreateVariableModal);
  const renderMainContent = () => {
    if (isVariablesEmpty) {
      if (isFetching)
        return /* @__PURE__ */ jsx("div", { className: "h-48 basis-full", children: /* @__PURE__ */ jsx("div", { className: "empty-page-loader left-1/2 top-1/2 absolute" }) });
      return /* @__PURE__ */ jsx(
        EmptyEnvironment,
        {
          openEnvironment,
          onFetchEnvironment: refetch,
          isSearch: !!searchTerm,
          isWebRecorder: isRecorder
        }
      );
    }
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        "div",
        {
          className: "h-[calc(100%_-_72px)] overflow-auto basis-full min-h-[200px]",
          children: /* @__PURE__ */ jsx(
            EnvironmentTable,
            {
              data: variables,
              onClick,
              hasNextPage: hasMore,
              handleLoadMore,
              isLoading: isFetching
            }
          )
        }
      ),
      !isRecorder && /* @__PURE__ */ jsx("div", { className: "w-full text-end", children: /* @__PURE__ */ jsx(Button, { type: "primary", onClick: onClickAddVariable, children: t("variables.add_variable.label") }) })
    ] });
  };
  const renderContent = () => {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("div", { className: "relative w-full mb-12", children: /* @__PURE__ */ jsx(
        AutoResizingDebouncedInput,
        {
          searchInputClassName: "absolute top-0 z-10 !w-full",
          wrapperClassName: "!flex-1 !w-full",
          minHeight: 35,
          showClearIcon: true,
          clearIconClassName: "text-secondary-600 flex items-center cursor-pointer",
          placeholder: t("common.search"),
          value: searchTerm,
          onChange: setSearchTerm,
          inputClassName: "!px-2 !py-1.5",
          isDisabled: !searchTerm && isVariablesEmpty,
          className: "focus-within:!border-primary-300 focus-within:!ring focus-within:!ring-primary-100"
        }
      ) }),
      renderMainContent()
    ] });
  };
  return /* @__PURE__ */ jsxs("div", { className: "flex basis-full flex-wrap h-full items-baseline", children: [
    renderContent(),
    showAddVariableModal && /* @__PURE__ */ jsx(
      create_variable_modal_default,
      {
        show: showAddVariableModal,
        onClose: onCloseCreateVariableModal,
        createVariable: onClickCreate,
        isCreateVariableLoading
      }
    )
  ] });
};
var TypeDropDown = ({
  selectedDataGeneratorType,
  onChange,
  isEditable = true
}) => {
  const authTypes = [
    { key: 1, i18n: "True", value: true },
    { key: 2, i18n: "False", value: false }
  ];
  let selectedAuthType = authTypes.find(
    (item) => item.value === selectedDataGeneratorType
  );
  selectedAuthType = selectedAuthType ? selectedAuthType : authTypes[0];
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx("div", { className: "z-22 basis-full mr-md bg-secondary-50 p-0.5 rounded-md", children: /* @__PURE__ */ jsx(DropdownButton, { name: t(selectedAuthType?.i18n), disabled: !isEditable, children: authTypes.map((item) => /* @__PURE__ */ jsx(
    DropdownItem,
    {
      onClick: () => onChange(item.value),
      isSelected: item.value === selectedDataGeneratorType,
      children: t(item.i18n)
    },
    item.key
  )) }) });
};
var OptionDropdown = (props) => {
  const { selectedOption, onChange, options: options3, optionKey, isEditable } = props;
  const selectedValue = options3.find((item) => item?.id == selectedOption) || options3?.[0] || null;
  useEffect(() => {
    if (selectedOption !== selectedValue) onChange(selectedValue?.id);
  }, [selectedOption, selectedValue]);
  return /* @__PURE__ */ jsx("div", { className: "z-22 basis-full mr-md bg-secondary-50 p-0.5 rounded-md", children: /* @__PURE__ */ jsx(DropdownButton, { name: selectedValue?.[optionKey], disabled: !isEditable, children: options3.map((item) => /* @__PURE__ */ jsx(
    DropdownItem,
    {
      onClick: () => onChange(item?.id),
      isSelected: item?.[optionKey] === selectedValue?.[optionKey],
      children: item?.[optionKey]
    },
    item?.id
  )) }) });
};
var MAILBOX = "Mail box";
var PHONENUMBER = "Phone Number";
var DataGeneratorInput = ({
  argument,
  isEditiable,
  fetchMailBoxes,
  fetchPhoneNumbers,
  setCanSave
}) => {
  const dropdownEnabler = [MAILBOX, PHONENUMBER];
  const [inputValue, setInputValue] = useState(
    isEditiable ? argument?.argumentValue || argument?.argumentExampleValue : argument?.argumentExampleValue
  );
  const [mailBoxList, setMailBoxList] = useState([]);
  const [phoneNumbersList, setPhoneNumbersList] = useState([]);
  const [isDirty, setIsDirty] = useState(false);
  const { argumentDisplayName, argumentType, argumentDisplayType, caption } = argument;
  const onchangeSetValue = (event) => {
    setIsDirty(true);
    argument.argumentValue = event?.target?.value ?? event;
    setInputValue(event?.target?.value ?? event);
  };
  const domainRegex = /[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}/;
  const { optionsList, optionKey } = useMemo(() => {
    switch (argumentDisplayName) {
      case MAILBOX:
        return {
          optionsList: mailBoxList,
          optionKey: "email"
        };
      case PHONENUMBER:
        return {
          optionsList: phoneNumbersList,
          optionKey: "phoneNumber"
        };
      default:
        return {
          optionsList: [],
          optionKey: "name"
        };
    }
  }, [mailBoxList, argumentDisplayName, phoneNumbersList]);
  useEffect(() => {
    switch (argumentDisplayName) {
      case MAILBOX:
        if (fetchMailBoxes)
          fetchMailBoxes().then((value) => {
            if (value?.content) {
              if (setCanSave) setCanSave(value?.content.length > 0);
              setMailBoxList(value?.content);
            }
          });
        break;
      case PHONENUMBER:
        if (fetchPhoneNumbers)
          fetchPhoneNumbers().then((value) => {
            if (value?.content) {
              if (setCanSave) setCanSave(value?.content.length > 0);
              setPhoneNumbersList(value?.content);
            }
          });
        break;
      default:
        if (setCanSave) setCanSave(true);
        break;
    }
  }, [argumentDisplayName, fetchMailBoxes, fetchPhoneNumbers]);
  useEffect(() => {
    if (!isEditiable) {
      setInputValue(argument.argumentExampleValue || "");
    } else if (argument.argumentValue == null) {
      argument.argumentValue = argument.argumentExampleValue || "";
      setInputValue(argument.argumentValue);
    } else {
      setInputValue(argument.argumentValue);
    }
  }, [argument, isEditiable]);
  const isArgTypeDropdown = dropdownEnabler.includes(argumentDisplayName);
  const displayEmptyStateMessage = (argumentDisplayName2) => {
    let message, url;
    switch (argumentDisplayName2) {
      case PHONENUMBER:
        message = t("suggestion_popup.phone_number.empty_info");
        url = "settings/phone_numbers";
        break;
      case MAILBOX:
        message = t("mailboxes.empty_state_message");
        url = "settings/mail_boxes";
        break;
    }
    return message && /* @__PURE__ */ jsxs("div", { className: "mt-1 text-small leading-5 text-secondary-unique-800", children: [
      message,
      isEditiable && /* @__PURE__ */ jsxs(
        "p",
        {
          className: "text-primary-600 cursor-pointer text-small hover:underline px-1",
          onClick: () => {
            window.open(`${window.location.origin}/ui/${url}`, "_blank");
          },
          children: [
            "+ ",
            argumentDisplayName2
          ]
        }
      )
    ] });
  };
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs("div", { className: "basis-1/2 mb-md", children: [
    /* @__PURE__ */ jsxs("div", { className: "basis-full flex mb-md", children: [
      /* @__PURE__ */ jsx("div", { className: "text-secondary-500 font-medium px-0.5", children: argumentDisplayName }),
      /* @__PURE__ */ jsx(ToolTip, { placement: "right", content: caption, className: "inline-flex", children: /* @__PURE__ */ jsx(
        Icon,
        {
          name: "help",
          className: classNames82("pl-sm text-secondary-400")
        }
      ) })
    ] }),
    isArgTypeDropdown ? optionsList.length === 0 ? displayEmptyStateMessage(argumentDisplayName) : /* @__PURE__ */ jsx(
      OptionDropdown,
      {
        selectedOption: inputValue,
        onChange: onchangeSetValue,
        options: optionsList,
        optionKey,
        isEditable: isEditiable
      }
    ) : /* @__PURE__ */ jsx(Fragment, { children: argumentType == "boolean" ? /* @__PURE__ */ jsx(
      TypeDropDown,
      {
        selectedDataGeneratorType: String(inputValue).toLocaleLowerCase() === "true",
        onChange: onchangeSetValue,
        isEditable: isEditiable
      }
    ) : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("div", { className: "bg-secondary-50 rounded-md flex basis-full mr-md p-0.5", children: [
        /* @__PURE__ */ jsx(
          "input",
          {
            className: "focus:outline-none bg-transparent py-2.5 pl-2.5 focus:bg-white focus-within:bg-slate-50 rounded-l",
            disabled: !isEditiable,
            value: inputValue,
            onChange: onchangeSetValue
          }
        ),
        /* @__PURE__ */ jsx("div", { className: "text-small text-secondary-400 ml-auto font-medium py-2.5 pr-2.5", children: argumentDisplayType })
      ] }),
      (argumentDisplayName === "Domain" && !domainRegex.test(inputValue) || argumentDisplayName === "Regex" && !isValidRegex(inputValue) || inputValue === "" && isDirty) && /* @__PURE__ */ jsx("div", { className: "pl-0.5 text-xs h-4 text-error-600", children: !isEditiable ? "" : inputValue === "" ? t("data_generator.empty_input_error", {
        argumentDisplayName
      }) : argumentDisplayName === "Domain" ? t("data_generator.invalid_domain_error") : t("data_generator.invalid_regex_error") })
    ] }) })
  ] });
};
var DataGeneratorExample = ({
  description,
  output,
  input,
  fetchMailBoxes,
  fetchPhoneNumbers,
  selectedFunctionName
}) => {
  const { t } = useTranslation();
  const [showAccodition, _toggleAccodition] = useState(false);
  const toggleAccodition = useCallback(
    (data) => {
      _toggleAccodition(data);
    },
    [_toggleAccodition]
  );
  useEffect(() => {
    _toggleAccodition(false);
  }, [input]);
  return /* @__PURE__ */ jsxs("div", { className: "text-small mt-6", children: [
    /* @__PURE__ */ jsxs(
      "div",
      {
        onClick: () => {
          toggleAccodition(!showAccodition);
        },
        "data-testid": "checkbox-label",
        className: "text-secondary-700 font-medium cursor-pointer flex items-center",
        children: [
          /* @__PURE__ */ jsx(
            Icon,
            {
              name: showAccodition ? "angle-bottom" : "angle-right",
              className: "pr-sm text-[20px]"
            }
          ),
          t("data_generator.show_example")
        ]
      }
    ),
    showAccodition && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("div", { className: "pt-6 ml-4", children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            "data-testid": "checkbox-label",
            className: "text-secondary-700 font-medium",
            children: t("data_generator.example_des")
          }
        ),
        /* @__PURE__ */ jsx("div", { className: "text-secondary-700 pt-lg", children: description })
      ] }),
      !!input.length && selectedFunctionName !== "TestDataFromProfile" && /* @__PURE__ */ jsxs("div", { className: "pt-6 ml-4", children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            "data-testid": "checkbox-label",
            className: "text-secondary-700 font-medium",
            children: t("data_generator.example_input")
          }
        ),
        /* @__PURE__ */ jsx("div", { className: "flex basis-full flex-wrap mt-3", children: input.map((item, idx) => /* @__PURE__ */ jsx(Fragment$1, { children: /* @__PURE__ */ jsx(
          DataGeneratorInput,
          {
            argument: item,
            isEditiable: false,
            fetchMailBoxes,
            fetchPhoneNumbers
          },
          `${item}_${idx}`
        ) }, `${item}_${idx}`)) })
      ] }),
      output && /* @__PURE__ */ jsxs("div", { className: "pt-6 ml-4", children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            "data-testid": "checkbox-label",
            className: "text-secondary-700 font-medium",
            children: t("data_generator.example_output")
          }
        ),
        /* @__PURE__ */ jsx("div", { className: "text-secondary-700 pt-lg", children: output })
      ] })
    ] })
  ] });
};
var know_more7 = "https://testsigma.com/docs/addons/what-is-an-addon/";
var EmptyDataGeneratorAddon = () => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", { className: "flex items-center flex-wrap justify-center basis-full leading-[18px] text-small pt-5", children: [
    /* @__PURE__ */ jsx(
      Icon,
      {
        name: "error",
        className: "inline-block cursor-pointer text-primary-500 text-5xl"
      }
    ),
    /* @__PURE__ */ jsx("div", { className: "font-semibold text-secondary-700 py-6 basis-full text-center px-10", children: t("suggestion_popup.addon_data_generator.empty_info") }),
    /* @__PURE__ */ jsx("div", { className: "text-secondary-700 basis-full text-center", children: t("suggestion_popup.addon_data_generator.not_associated_info") }),
    /* @__PURE__ */ jsx(
      "a",
      {
        className: "text-primary-500 basis-full text-center cursor-pointer",
        href: "mailto:support@testsigma.com",
        target: "_blank",
        rel: "noreferrer",
        children: t("common.support_mail")
      }
    ),
    /* @__PURE__ */ jsx("div", { className: "flex p-lg basis-full justify-center", children: /* @__PURE__ */ jsx(
      Button,
      {
        type: "secondary",
        onClick: () => window.open(know_more7, "_blank"),
        children: t("common.know_more")
      }
    ) })
  ] }) });
};
var DataGeneratorFunctionTypeDropDown = ({ functionTypes, selectedFunctionType, onChangeFunctionName }) => {
  const { t } = useTranslation();
  const [filteredData, setFilteredData] = useState(
    Object.keys(functionTypes) || []
  );
  useEffect(() => {
    setFilteredData(Object.keys(functionTypes) || []);
  }, [functionTypes]);
  const onSearch = (val) => {
    const filtered = Object.keys(functionTypes)?.filter(
      (item) => item.toLowerCase().includes(val.toLowerCase())
    ) || [];
    setFilteredData(filtered);
  };
  return /* @__PURE__ */ jsx(
    DropDownWithSearchAndPagination,
    {
      selectedItemDisplay: selectedFunctionType,
      label: t("data_generator.function_type"),
      onSearch,
      className: "mt-6",
      items: filteredData,
      selectedItem: selectedFunctionType,
      onSelectItem: (item) => {
        onChangeFunctionName(functionTypes[item]);
      },
      renderItem: (item) => item,
      isLoading: false,
      hasMore: false,
      loadMore: () => {
      },
      totalPages: 0
    }
  );
};
var DataGeneratorFunctionDropDown = ({ functions, selectedFunction, onChangeFunction }) => {
  const { t } = useTranslation();
  const [filteredData, setFilteredData] = useState(functions || []);
  useEffect(() => {
    setFilteredData(functions);
  }, [functions]);
  const onSearch = (val) => {
    const filtered = functions?.filter(
      (item) => item.displayName.toLowerCase().includes(val.toLowerCase())
    ) || [];
    setFilteredData(filtered);
  };
  return /* @__PURE__ */ jsx(
    DropDownWithSearchAndPagination,
    {
      selectedItemDisplay: selectedFunction?.displayName,
      label: t("data_generator.function"),
      onSearch,
      className: "mt-6",
      items: filteredData,
      selectedItem: selectedFunction,
      onSelectItem: (item) => {
        onChangeFunction(item);
      },
      renderItem: (item) => item?.displayName,
      isLoading: false,
      hasMore: false,
      loadMore: () => {
      },
      totalPages: 0
    }
  );
};
var DataGeneratorTypeDropDown = ({ selectedDataGeneratorType, onChange, isInsideRestApi }) => {
  const { t } = useTranslation();
  const authTypes = useMemo(
    () => [
      { key: 1, i18n: "type_default", value: true },
      ...!isInsideRestApi ? [{ key: 2, i18n: "type_kibbutz", value: false }] : []
    ],
    [isInsideRestApi]
  );
  const selectedAuthType = authTypes.find((item) => item.value === selectedDataGeneratorType) || authTypes[0];
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap", children: [
    /* @__PURE__ */ jsx("div", { className: "basis-full text-xs text-secondary-500 pb-md font-medium px-0.5", children: t("data_generator.type") }),
    /* @__PURE__ */ jsx("div", { className: "z-22 basis-full", children: /* @__PURE__ */ jsx(DropdownButton, { name: t(`data_generator.${selectedAuthType?.i18n}`), children: /* @__PURE__ */ jsx("div", { children: authTypes.map((item) => /* @__PURE__ */ jsx(
      DropdownItem,
      {
        onClick: () => onChange(item.value),
        isSelected: item.value == selectedDataGeneratorType,
        children: t("data_generator." + item.i18n)
      },
      item.key
    )) }) }) })
  ] });
};
var DataGeneratorParameterInput = ({ argument, isEditiable }) => {
  const [inputValue, setInputValue] = useState("");
  const { name, type, description } = argument;
  const onchangeSetValue = (event) => {
    argument.value = event?.target?.value ?? event;
    setInputValue(event?.target?.value ?? event);
  };
  useEffect(() => {
    setInputValue(argument.value || "");
  }, [argument]);
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", { className: "basis-1/2 mb-md", children: [
    /* @__PURE__ */ jsxs("div", { className: "basis-full flex mb-md", children: [
      /* @__PURE__ */ jsx("div", { className: "text-secondary-500 font-medium px-0.5", children: name }),
      /* @__PURE__ */ jsx(
        ToolTip,
        {
          placement: "right",
          content: description,
          className: "inline-flex",
          children: /* @__PURE__ */ jsx(
            Icon,
            {
              name: "help",
              className: classNames82("pl-sm text-secondary-400")
            }
          )
        }
      )
    ] }),
    type === "boolean" ? /* @__PURE__ */ jsx(
      TypeDropDown,
      {
        selectedDataGeneratorType: inputValue,
        onChange: onchangeSetValue
      }
    ) : /* @__PURE__ */ jsxs("div", { className: "bg-secondary-50 rounded-md flex basis-full mr-md p-0.5", children: [
      /* @__PURE__ */ jsx(
        "input",
        {
          className: "focus:outline-none bg-transparent py-2.5 pl-2.5 focus:bg-white focus-within:bg-slate-50 rounded-l",
          disabled: !isEditiable,
          value: inputValue,
          onChange: onchangeSetValue
        }
      ),
      /* @__PURE__ */ jsx("div", { className: "text-small text-secondary-400 ml-auto font-medium py-2.5 pr-2.5", children: type })
    ] })
  ] }) });
};
var allowedDynamicTypeInDataGenarator = [
  "raw",
  "parameter",
  "runtime",
  "global"
];
var DataDynamicInput = ({
  argument,
  label,
  getTestData: getTestData2,
  isEditiable,
  updateFieldValue,
  removeField,
  index,
  isSingleBlock
}) => {
  const { t } = useTranslation();
  const handleValueChange = (dynamicValueBlock) => {
    const result = blocksToText$1(
      dynamicValueBlock?.map((item) => ({
        value: wrapWithTemplate(item.value, item.type),
        type: item.type
      }))
    );
    updateFieldValue(index, result);
  };
  return /* @__PURE__ */ jsxs("div", { className: " group basis-full mb-md", children: [
    /* @__PURE__ */ jsxs("div", { className: "basis-full flex mb-md items-center justify-between", children: [
      /* @__PURE__ */ jsx("div", { className: "text-secondary-500 font-medium px-0.5", children: label }),
      isSingleBlock && removeField && /* @__PURE__ */ jsx(
        Icon,
        {
          name: "delete",
          className: "text-lg text-secondary-400 hover:text-error-500 invisible group-hover:visible cursor-pointer",
          toolTip: t("common.confirmation.remove.title-with-name", {
            title: t("common.test_data.label")
          }),
          onClick: () => removeField(index),
          toolTipPlacement: "top"
        }
      )
    ] }),
    /* @__PURE__ */ jsx(
      DynamicValueInput,
      {
        className: "text-small leading-5 h-9 cursor-pointer border border-secondary-50 bg-secondary-50 text-secondary-800 px-3",
        isSingleBlock,
        onChange: handleValueChange,
        value: convertValueToBlock(argument.argumentValue),
        getTestData: getTestData2,
        editable: isEditiable,
        allowedDynamics: allowedDynamicTypeInDataGenarator,
        customStyle: isSingleBlock ? "w-full max-w-full" : "",
        hasCreateBlock: !isSingleBlock,
        dataInputId: `test-data-generator-${index + 1}`
      },
      index
    )
  ] });
};
var data_dynamic_input_default = DataDynamicInput;
var assignArgumentNames = (fields, selectedFunction) => {
  return fields.map((field, index) => {
    field.argumentName = `arg${index}`;
    field.createdBy = selectedFunction?.createdById;
    field.updatedBy = selectedFunction?.updatedById;
    field.dataGeneratorId = selectedFunction?.id;
    return field;
  });
};
var assignArgumentUuid = (fields) => {
  return fields.map((field, index) => {
    field.uuid = generateUniqueId();
    return field;
  });
};
var DataDynamicInputContainer = ({
  getTestData: getTestData2,
  onChangeFunction,
  selectedFunction,
  fixedArguments
}) => {
  const { t } = useTranslation();
  const [fields, setFields] = useState([]);
  const debouncedFields = useDebounce(fields, 500);
  const updateSelectedFunc = (fields2) => {
    if (selectedFunction) {
      selectedFunction.arguments = fields2;
      onChangeFunction(selectedFunction);
    }
  };
  const updateFieldValue = useCallback(
    (index, newValue) => {
      setFields((prevFields) => {
        const updatedFields = [...prevFields];
        updatedFields[index].argumentValue = newValue;
        return assignArgumentNames(updatedFields, selectedFunction);
      });
    },
    [setFields]
  );
  const addNewField = useCallback(() => {
    const newField = new DataGeneratorArguments();
    newField.uuid = generateUniqueId();
    setFields((prevFields) => {
      return assignArgumentNames([...prevFields, newField], selectedFunction);
    });
  }, [setFields]);
  const removeField = useCallback(
    (indexToRemove) => {
      setFields((prevFields) => {
        const updatedFields = prevFields.filter(
          (_, index) => index !== indexToRemove
        );
        return assignArgumentNames(updatedFields, selectedFunction);
      });
    },
    [setFields]
  );
  useEffect(() => {
    if (selectedFunction?.id) {
      let args = [];
      if (selectedFunction?.arguments?.length) {
        args = assignArgumentUuid(selectedFunction.arguments);
        args = args.map((field) => {
          const argDataType = TEST_DATA_TYPES.find(
            (item) => item.key === field?.argumentValueType
          );
          if (argDataType && field?.argumentValue && !field?.argumentValue.includes(`${argDataType?.indicator}|`))
            field.argumentValue = argDataType.format(field.argumentValue);
          return field;
        });
      } else {
        if (!fixedArguments) {
          const initialField = new DataGeneratorArguments();
          initialField.uuid = generateUniqueId();
          args.push(initialField);
        }
      }
      setFields(assignArgumentNames(args, selectedFunction));
    }
  }, [fixedArguments, selectedFunction]);
  useEffect(() => {
    updateSelectedFunc(debouncedFields);
  }, [debouncedFields]);
  const DATATYPECONVERTOR = "Data Type";
  const dropdownEnabler = [DATATYPECONVERTOR];
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    fields.map((field, ind) => {
      return !dropdownEnabler.includes(field?.argumentDisplayName) ? /* @__PURE__ */ jsx(
        data_dynamic_input_default,
        {
          argument: field,
          label: field?.argumentDisplayName || t("common.dynamic.test_data.label", { position: ind + 1 }),
          getTestData: getTestData2,
          index: ind,
          updateFieldValue,
          removeField: selectedFunction?.displayName == "Custom Calculation" ? null : removeField,
          isSingleBlock: !fixedArguments || selectedFunction?.displayName == "convertInputDataType"
        },
        `${field?.argumentName}-${field?.id || field?.uuid}`
      ) : /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
        /* @__PURE__ */ jsxs("div", { className: "basis-full flex mb-md", children: [
          /* @__PURE__ */ jsx("div", { className: "text-secondary-500 font-medium px-0.5", children: field?.argumentDisplayName }),
          /* @__PURE__ */ jsx(
            ToolTip,
            {
              placement: "right",
              content: field?.caption,
              className: "inline-flex",
              children: /* @__PURE__ */ jsx(
                Icon,
                {
                  name: "help",
                  className: classNames82("pl-sm text-secondary-400")
                }
              )
            }
          )
        ] }),
        /* @__PURE__ */ jsx(
          OptionDropdown2,
          {
            selectedOption: field?.argumentValue || dataTypeList[0].dataType,
            onChange: updateFieldValue,
            options: dataTypeList,
            optionKey: "dataType",
            isEditable: true,
            index: ind
          }
        )
      ] });
    }),
    !fixedArguments && /* @__PURE__ */ jsx("div", { className: "basis-full mb-md", children: /* @__PURE__ */ jsx(
      "span",
      {
        className: " font-semibold text-xs leading-3 p-2 text-secondary-500 hover:text-primary-600 cursor-pointer",
        onClick: addNewField,
        children: t("tdp.dynamic.add.input.label")
      }
    ) })
  ] });
};
var OptionDropdown2 = (props) => {
  const { selectedOption, onChange, options: options3, optionKey, isEditable, index } = props;
  const selectedValue = options3.find((item) => item?.dataType === selectedOption) || options3?.[0] || null;
  useEffect(() => {
    onChange(index, selectedValue?.dataType);
  }, [selectedOption, selectedValue, index, onChange]);
  const handleDropdownChange = (item) => {
    onChange(index, item?.dataType);
  };
  return /* @__PURE__ */ jsx("div", { className: "z-22 basis-full mr-md bg-secondary-50 p-0.5 rounded-md", children: /* @__PURE__ */ jsx(DropdownButton, { name: selectedValue?.[optionKey], disabled: !isEditable, children: options3.map((item) => /* @__PURE__ */ jsx(
    DropdownItem,
    {
      onClick: () => handleDropdownChange(item),
      isSelected: item?.[optionKey] === selectedValue?.[optionKey],
      children: item?.[optionKey]
    },
    item?.id
  )) }) });
};
var data_dynamic_input_container_default = DataDynamicInputContainer;
var defaultPageable = new Pageable();
defaultPageable.pageNumber = 0;
var { VirtualizedInfiniteLoader: VirtualizedInfiniteLoader5 } = InfiniteScrollV2;
var TdpDataGenerator = ({
  dataArg,
  fetchTDPSets,
  fetchTDPData,
  openTestDataProfile
}) => {
  const { t } = useTranslation();
  const [argumentsList, setArgumentsList] = useState([]);
  const [tdpList, setTdpList] = useState([]);
  const [tdpSetsList, setTdpSetsList] = useState([]);
  const [paramsList, setParamsList] = useState([]);
  const [rowsList, setRowsList] = useState([]);
  const [isSearchEmpty, setIsSearchEmpty] = useState(false);
  const [selectedDataArg, setSelectedDataArg] = useState([
    { name: "" },
    { name: "" },
    { name: "" }
  ]);
  const [isLoading, setIsLoading] = useState(false);
  const [isInitialLoading, setIsInitialLoading] = useState(false);
  const [tdpPaginationList, setTDPPaginationList] = useState(null);
  const [isOpen, updateIsOpen] = useState(false);
  const [value, updateValue] = useState("");
  const [openDropdownIndex, setOpenDropdownIndex] = useState(
    null
  );
  const [pageable, setPageable] = useState(defaultPageable);
  const tdpSetsCache = useRef({});
  const buildSetData = (content) => {
    return {
      sets: content.map((i) => ({ id: i.name, name: i?.name })) || [],
      rows: content?.map((i, index) => ({
        id: `${index + 1}`,
        name: `#${index + 1} ${i.name}`
      })) || []
    };
  };
  const loadSetsForProfile = async (profileId) => {
    if (!profileId) {
      const empty = { sets: [], rows: [] };
      setTdpSetsList([]);
      setRowsList([]);
      return empty;
    }
    if (tdpSetsCache.current[profileId]) {
      const cachedData = tdpSetsCache.current[profileId];
      setTdpSetsList(cachedData.sets);
      setRowsList(cachedData.rows);
      return cachedData;
    }
    const setRes = await fetchTDPSets(profileId);
    if (setRes?.content?.length) {
      const mappedData = buildSetData(setRes.content);
      tdpSetsCache.current[profileId] = mappedData;
      setTdpSetsList(mappedData.sets);
      setRowsList(mappedData.rows);
      return mappedData;
    }
    const emptyData = { sets: [], rows: [] };
    tdpSetsCache.current[profileId] = emptyData;
    setTdpSetsList([]);
    setRowsList([]);
    return emptyData;
  };
  const toLoaderItems = (options3) => {
    return options3 || [];
  };
  const getOptionsList = (argName) => {
    switch (argName) {
      case "Test Data Profile" /* TEST_DATA_PROFILE */:
        return tdpList;
      case "Dataset Name" /* TEST_DATA_SET */:
        return tdpSetsList;
      case "Row Number" /* TEST_DATA_ROW_NUMBER */:
        return rowsList;
      case "Parameter" /* TEST_DATA_PARAMETER */:
        return paramsList;
      default:
        return [];
    }
  };
  const getTestDataProfileList = async (query, isUpdateSelectedTDPName, isLoadMore) => {
    let result = true;
    const page = isLoadMore ? pageable?.pageNumber : 0;
    setIsLoading(true);
    try {
      const res = await fetchTDPData(query, page);
      setTDPPaginationList(res);
      if (res?.content.length) {
        setIsSearchEmpty(false);
        result = false;
        if (isLoadMore) {
          setTdpList(
            (prevList) => prevList ? [...prevList, ...res.content] : res.content
          );
        } else {
          setTdpList(res.content);
        }
        if (isUpdateSelectedTDPName) {
          const newSelectedDataArg = [...selectedDataArg];
          newSelectedDataArg[0] = {
            ...newSelectedDataArg[0],
            name: res.content[0]?.name
          };
          setSelectedDataArg(newSelectedDataArg);
        }
        const selectedData = dataArg[0]?.argumentValue ? res.content.find(
          (item) => item?.id === Number(dataArg[0]?.argumentValue)
        ) : res.content[0];
        if (!selectedData) {
          setIsLoading(false);
          return;
        }
        setParamsList(
          selectedData.columns.map((i) => ({ id: i, name: i })) || []
        );
        await loadSetsForProfile(selectedData.id);
      } else {
        setIsSearchEmpty(true);
      }
    } catch (error) {
      setIsLoading(false);
      throw new Error("Error fetching TDP data:", error);
    }
    setIsLoading(false);
    return result;
  };
  const getIndex = (argumentDisplayName) => {
    return dataArg.findIndex(
      (item) => item.argumentDisplayName === argumentDisplayName
    );
  };
  const updateHandler = (val, item) => {
    const dataIndex = dataArg.findIndex((a) => a.id === item.id);
    if (dataIndex > -1 && dataArg[dataIndex]?.argumentValue == String(val?.id)) {
      return;
    }
    if (dataIndex > -1) {
      dataArg[dataIndex] = {
        ...dataArg[dataIndex],
        argumentValue: String(val?.id)
      };
      const newSelectedDataArg = [...selectedDataArg];
      newSelectedDataArg[dataIndex] = {
        ...newSelectedDataArg[dataIndex],
        name: val?.name
      };
      setSelectedDataArg(newSelectedDataArg);
    }
    if (item.argumentDisplayName === "Test Data Profile" /* TEST_DATA_PROFILE */) {
      loadSetsForProfile(Number(val?.id)).then((setData) => {
        if (setData.sets.length) {
          dataArg[getIndex("Dataset Name" /* TEST_DATA_SET */)] = {
            ...dataArg[getIndex("Dataset Name" /* TEST_DATA_SET */)],
            argumentValue: setData.sets[0].id
          };
        }
        if (setData.rows.length) {
          dataArg[getIndex("Row Number" /* TEST_DATA_ROW_NUMBER */)] = {
            ...dataArg[getIndex("Row Number" /* TEST_DATA_ROW_NUMBER */)],
            argumentValue: setData.rows[0].id
          };
        }
      });
      const selectedData = tdpList.find(
        (td) => td?.id === Number(val?.id)
      );
      if (selectedData) {
        setParamsList(
          selectedData.columns.map((i) => ({ id: i, name: i })) || []
        );
        dataArg[getIndex("Parameter" /* TEST_DATA_PARAMETER */)] = {
          ...dataArg[getIndex("Parameter" /* TEST_DATA_PARAMETER */)],
          argumentValue: selectedData.columns[0]
        };
      }
    }
    loadArgumentData();
  };
  const loadArgumentData = () => {
    const data = dataArg.map((item) => ({
      id: item.id,
      argumentDisplayName: item.argumentDisplayName,
      caption: item.caption,
      argumentValue: item.argumentValue || "",
      optionsList: getOptionsList(item.argumentDisplayName),
      onChange: updateHandler
    }));
    setArgumentsList(data);
  };
  useEffect(() => {
    if (tdpList.length && tdpSetsList.length && paramsList.length) {
      loadArgumentData();
      if (dataArg[getIndex("Test Data Profile" /* TEST_DATA_PROFILE */)]?.argumentValue === void 0) {
        dataArg[getIndex("Test Data Profile" /* TEST_DATA_PROFILE */)] = {
          ...dataArg[getIndex("Test Data Profile" /* TEST_DATA_PROFILE */)],
          argumentValue: String(tdpList[0].id)
        };
        dataArg[getIndex("Dataset Name" /* TEST_DATA_SET */)] = {
          ...dataArg[getIndex("Dataset Name" /* TEST_DATA_SET */)],
          argumentValue: tdpSetsList[0].id
        };
        dataArg[getIndex("Parameter" /* TEST_DATA_PARAMETER */)] = {
          ...dataArg[getIndex("Parameter" /* TEST_DATA_PARAMETER */)],
          argumentValue: paramsList[0].id
        };
        dataArg[getIndex("Row Number" /* TEST_DATA_ROW_NUMBER */)] = {
          ...dataArg[getIndex("Row Number" /* TEST_DATA_ROW_NUMBER */)],
          argumentValue: rowsList[0].id
        };
      }
    }
  }, [tdpList, tdpSetsList, paramsList]);
  const resetPage = () => {
    setPageable(defaultPageable);
  };
  useEffect(() => {
    const fetchData2 = async () => {
      if (dataArg.length === 3) {
        setIsInitialLoading(true);
        if (dataArg[0]?.argumentValue) {
          await getTestDataProfileList(
            `,id:${dataArg[0]?.argumentValue}`,
            true
          );
        }
        resetPage();
        await getTestDataProfileList("");
        setIsInitialLoading(false);
      }
    };
    fetchData2();
  }, [dataArg]);
  const handleValueChange = (searchTerms) => {
    searchTerms = `,name:*${searchTerms}*`;
    getTestDataProfileList(searchTerms);
  };
  const search = (val) => {
    updateValue(val);
    handleValueChange(val);
    if (val === "" || value !== val) {
      resetPage();
    }
  };
  const loadMore = useCallback(
    (pageNumber) => {
      const newPageable = new Pageable();
      newPageable.pageNumber = pageNumber;
      setPageable(newPageable);
    },
    [pageable?.pageNumber]
  );
  useEffect(() => {
    if (pageable?.pageNumber > 0) {
      const searchTerm = value ? `,name:*${value}*` : "";
      getTestDataProfileList(searchTerm, false, true);
    }
  }, [pageable?.pageNumber]);
  const rowRenderer = (index) => {
    const item = argumentsList[openDropdownIndex].optionsList[index];
    const argumentItem = argumentsList[openDropdownIndex];
    return /* @__PURE__ */ jsx(
      DropdownItem,
      {
        role: "row",
        onClick: () => {
          argumentItem.onChange(item, argumentItem);
          setOpenDropdownIndex(null);
        },
        className: "flex items-center text-unique-600 group hover:!bg-secondary-50 hover:!text-unique-600",
        isSelected: argumentItem?.id === item?.id,
        children: /* @__PURE__ */ jsxs("div", { className: "flex w-full items-center justify-between", role: "gridcell", children: [
          /* @__PURE__ */ jsx(TruncatedText, { value: item?.name, className: "inline-block" }),
          item?.description && /* @__PURE__ */ jsx(ToolTip, { content: item?.description, placement: "right", children: /* @__PURE__ */ jsx(Icon, { name: "info", className: "text-base text-secondary-500" }) })
        ] })
      },
      argumentItem?.id
    );
  };
  const handleDropdownClick = (idx) => {
    if (openDropdownIndex === idx) {
      setOpenDropdownIndex(null);
      return;
    }
    setOpenDropdownIndex(idx);
    updateValue("");
    if (pageable.pageNumber > 0) {
      setPageable(defaultPageable);
    }
  };
  const handleClose = (isDropDownOpen) => {
    updateIsOpen(isDropDownOpen);
    if (!isDropDownOpen) {
      setOpenDropdownIndex(null);
      if (value || pageable.pageNumber > 0) {
        resetPage();
        getTestDataProfileList("");
      }
      updateValue("");
    }
  };
  const getName = (idx) => {
    return selectedDataArg[idx]?.name || (argumentsList[idx]?.optionsList.find(
      (item) => item?.id == argumentsList[idx]?.argumentValue
    ) || argumentsList[idx]?.optionsList?.[0] || null)?.name;
  };
  return /* @__PURE__ */ jsx(Fragment, { children: !tdpList.length ? /* @__PURE__ */ jsx(
    EmptyParameter,
    {
      openTestDataProfile,
      isDataGenerator: true
    }
  ) : /* @__PURE__ */ jsx("div", { className: "flex basis-full flex-wrap mt-6 text-small", children: !isInitialLoading && argumentsList.map((argumentItem, idx) => /* @__PURE__ */ jsxs("div", { className: "w-1/2 mb-md", children: [
    /* @__PURE__ */ jsxs("div", { className: "basis-full flex mb-md", children: [
      /* @__PURE__ */ jsx("div", { className: "text-secondary-500 font-medium px-0.5", children: argumentItem?.argumentDisplayName }),
      argumentItem?.caption && /* @__PURE__ */ jsx(
        ToolTip,
        {
          placement: "right",
          content: argumentItem?.caption,
          className: "inline-flex",
          children: /* @__PURE__ */ jsx(Icon, { name: "help", className: "pl-sm text-secondary-400" })
        }
      )
    ] }),
    /* @__PURE__ */ jsx(
      DropdownButton,
      {
        name: getName(idx),
        variant: "select-fill",
        placement: "bottom",
        dropdownClassName: "!max-h-[240px] !overflow-auto",
        wrapperClassName: "mb-[18px] px-1",
        labelClassName: "mb-1",
        onClick: () => {
          handleDropdownClick(idx);
        },
        hideOnChildClick: false,
        setIsOpen: handleClose,
        isOpen: openDropdownIndex === idx && isOpen,
        children: /* @__PURE__ */ jsxs("div", { children: [
          argumentItem.argumentDisplayName === "Test Data Profile" /* TEST_DATA_PROFILE */ && /* @__PURE__ */ jsx(
            Input,
            {
              value,
              onChange: (val) => {
                search(val);
              },
              placeholder: t("common.search"),
              hideErrorMessage: true,
              wrapperClassName: "outline-none w-full bg-white p-md sticky top-0 z-10"
            }
          ),
          argumentItem?.optionsList?.length > 0 && !isSearchEmpty ? /* @__PURE__ */ jsx("div", { className: "h-[180px]", children: /* @__PURE__ */ jsx(
            VirtualizedInfiniteLoader5,
            {
              rowHeight: 35,
              loadMore,
              rowCount: argumentItem?.optionsList?.length,
              rowRenderer,
              hasMore: !tdpPaginationList?.last,
              items: toLoaderItems(argumentItem?.optionsList),
              resetPage: pageable.pageNumber === 0,
              overscanRowCount: 5,
              isLoading
            }
          ) }) : /* @__PURE__ */ jsx("div", { className: "flex flex-col items-center text-secondary-400 text-sm font-normal leading-4 py-3 text-center", children: t("left.nav.no_result_found") })
        ] })
      }
    )
  ] }, idx)) }) });
};
var DataGeneratorValue = ({
  dataArg = [],
  fetchMailBoxes,
  fetchPhoneNumbers,
  selectedFunction,
  getTestData: getTestData2,
  onChangeFunction,
  isKibbutz,
  fetchTDPSets,
  fetchTDPData,
  selectedFunctionName,
  openTestDataProfile,
  setCanSave
}) => {
  if (selectedFunctionName === "TestDataFromProfile")
    return /* @__PURE__ */ jsx(
      TdpDataGenerator,
      {
        dataArg,
        fetchTDPData,
        fetchTDPSets,
        openTestDataProfile
      }
    );
  return /* @__PURE__ */ jsx("div", { className: "flex basis-full flex-wrap mt-6 text-small", children: !(typeof selectedFunction?.hasDataMap === "boolean" && selectedFunction?.hasDataMap) ? dataArg.map((item, idx) => /* @__PURE__ */ jsx(Fragment$1, { children: isKibbutz ? /* @__PURE__ */ jsx(
    DataGeneratorParameterInput,
    {
      argument: item,
      isEditiable: true
    },
    idx
  ) : /* @__PURE__ */ jsx(
    DataGeneratorInput,
    {
      argument: item,
      isEditiable: true,
      fetchPhoneNumbers,
      fetchMailBoxes,
      setCanSave
    },
    idx
  ) }, idx)) : /* @__PURE__ */ jsx(
    data_dynamic_input_container_default,
    {
      getTestData: getTestData2,
      selectedFunction,
      onChangeFunction,
      fixedArguments: selectedFunction?.fixedArguments
    }
  ) });
};
var DataGeneratorValueSelector = ({
  onReturnValue,
  onChangeFunctionName,
  onChangeType,
  onChangeFunction,
  selectedFunctionType,
  selectedFunction,
  dataGenerators,
  functionNames,
  selectedDataGeneratorType,
  fetchPhoneNumbers,
  fetchMailBoxes,
  getTestData: getTestData2,
  fetchTDPData,
  fetchTDPSets,
  isLoading = false,
  openTestDataProfile,
  isInsideRestApi = false
}) => {
  let selectedFunctionName;
  Object.keys(functionNames).map((name) => {
    if (selectedFunctionType === functionNames[name]) {
      selectedFunctionName = name;
    }
  });
  const [canSave, setCanSave] = useState(true);
  const { t } = useTranslation();
  const getArguments = useMemo(() => {
    let res = selectedFunction?.arguments || selectedFunction?.parameters || [];
    if (res) {
      res.sort((a, b) => a.id - b.id);
    }
    return res;
  }, [selectedFunction?.arguments, selectedFunction?.parameters]);
  const handleSave = (selectedFunction2, selectedFunctionName2) => {
    const isValidDomain = (arg) => {
      const domainRegex = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      return arg.argumentDisplayName === "Domain" && domainRegex.test(arg.argumentValue);
    };
    let hasInvalidRegex = false;
    selectedFunction2?.arguments?.forEach((arg) => {
      if (arg?.argumentDisplayName === "Regex") {
        const isValid = isValidRegex(arg?.argumentValue);
        if (!isValid) {
          hasInvalidRegex = true;
        }
      }
    });
    if (hasInvalidRegex) {
      toastify(t("data_generator.invalid_regex_error"), {
        type: "error"
      });
      return;
    }
    const isMissingArgumentValue = (arg) => {
      return !arg.argumentValue && arg.argumentType !== "boolean";
    };
    const hasInvalidArguments = selectedFunction2?.arguments?.some(
      (arg) => isMissingArgumentValue(arg) || arg.argumentDisplayName === "Domain" && !isValidDomain(arg)
    );
    const hasInvalidParameters = selectedFunction2?.parameters?.some(
      (param) => !param.value
    );
    if (!hasInvalidArguments && !hasInvalidParameters) {
      onReturnValue({
        function: selectedFunction2,
        name: selectedFunctionName2
      });
    } else {
      toastify(t("datagenerator.required.fields.error"), {
        type: "error"
      });
    }
  };
  const isSaveDisabeld = useMemo(() => {
    return isLoading || !canSave && [
      "MailBoxFunctions",
      "MailBoxAliasFunctions",
      "PhoneNumberFunctions"
    ].includes(selectedFunctionName);
  }, [canSave, isLoading, selectedFunctionName]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("div", { className: "h-content overflow-y-auto px-5 py-4", children: [
      /* @__PURE__ */ jsx(
        DataGeneratorTypeDropDown,
        {
          selectedDataGeneratorType,
          onChange: (value) => onChangeType(value),
          isInsideRestApi
        }
      ),
      isLoading ? /* @__PURE__ */ jsx("div", { className: "empty-page-loader mt-[25%] mx-auto" }) : /* @__PURE__ */ jsxs(Fragment, { children: [
        Boolean(functionNames && Object.keys(functionNames)?.length) && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            DataGeneratorFunctionTypeDropDown,
            {
              functionTypes: functionNames,
              selectedFunctionType: selectedFunctionName,
              onChangeFunctionName
            }
          ),
          selectedDataGeneratorType && Boolean(dataGenerators?.length) && /* @__PURE__ */ jsx(
            DataGeneratorFunctionDropDown,
            {
              functions: dataGenerators,
              selectedFunction,
              onChangeFunction
            }
          ),
          /* @__PURE__ */ jsx(
            DataGeneratorValue,
            {
              dataArg: getArguments,
              fetchPhoneNumbers,
              fetchMailBoxes,
              selectedFunction,
              getTestData: getTestData2,
              onChangeFunction,
              isKibbutz: selectedFunction?.parameters,
              fetchTDPData,
              fetchTDPSets,
              selectedFunctionName,
              setCanSave,
              openTestDataProfile
            }
          ),
          selectedDataGeneratorType && /* @__PURE__ */ jsx(
            DataGeneratorExample,
            {
              input: selectedFunction?.arguments || [],
              description: selectedFunction?.description,
              output: selectedFunction?.exampleOutput,
              fetchPhoneNumbers,
              fetchMailBoxes,
              selectedFunctionName
            }
          )
        ] }),
        Boolean(!functionNames || !Object.keys(functionNames)?.length) && /* @__PURE__ */ jsx(EmptyDataGeneratorAddon, {})
      ] })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "flex p-lg", children: Boolean(functionNames && Object.keys(functionNames)?.length) && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          type: "secondary",
          className: "ml-auto",
          onClick: () => onReturnValue(false),
          children: t("common.cancel")
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          type: "primary",
          className: "ml-4",
          onClick: () => handleSave(selectedFunction, selectedFunctionName),
          isDisabled: isSaveDisabeld,
          children: t("common.save")
        }
      )
    ] }) })
  ] });
};
var EmptyActions = ({
  searchQuery
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", { className: "flex items-center flex-wrap justify-center leading-[18px] text-small w-full", children: [
    /* @__PURE__ */ jsx(
      Icon,
      {
        name: "error",
        className: "inline-block cursor-pointer text-primary-500 text-5xl"
      }
    ),
    /* @__PURE__ */ jsx("div", { className: "font-semibold text-secondary-700 py-6 basis-full text-center px-10", children: t(
      searchQuery ? "suggestion_actions.search.empty_info" : "suggestion_actions.empty_info"
    ) })
  ] }) });
};
var ActionsTable = ({
  actions,
  onClick
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs(Table, { wrapperClassName: "h-full !border-0", children: [
    /* @__PURE__ */ jsx(TableHeader, { className: "bg-secondary-100 rounded", children: /* @__PURE__ */ jsx(TableRow, { children: /* @__PURE__ */ jsx(TableCell, { className: "min-w-[200px] !border-0", children: t("label.actions") }) }) }),
    /* @__PURE__ */ jsx(TableBody, { children: actions.map((item, idx) => /* @__PURE__ */ jsx(
      TableRow,
      {
        className: classNames82(
          "hover:!bg-secondary-50 cursor-pointer border-b-[0.5px] border-b-secondary-200"
        ),
        onClick: () => onClick(item),
        children: /* @__PURE__ */ jsx(TableCell, { className: "min-w-[200px] border-y-0", children: /* @__PURE__ */ jsxs("div", { className: "flex items-center", children: [
          item.isAddonTemplate && /* @__PURE__ */ jsx(
            Icon,
            {
              name: "extension",
              className: "text-sm mr-2 flex-shrink-0"
            }
          ),
          /* @__PURE__ */ jsx("span", { className: "flex-1", children: item.action })
        ] }) })
      },
      item.templateId
    )) })
  ] });
};
var ActionsValueSelector = ({
  onClick,
  actions,
  isFetching,
  fetchActions
}) => {
  const { t } = useTranslation();
  const [searchQuery, setSearchQuery] = useState("");
  const updateSearchQuery = useCallback(
    debounce$2((value) => {
      setSearchQuery(value);
      fetchActions(value);
    }, 500),
    [fetchActions]
  );
  const getFilteredActions = () => {
    if (searchQuery && searchQuery.length) {
      return actions.filter(
        (action) => action?.action?.toLocaleLowerCase()?.includes(searchQuery?.toLocaleLowerCase())
      );
    }
    return [...actions];
  };
  const filteredActions = getFilteredActions();
  return /* @__PURE__ */ jsxs("div", { className: "flex basis-full flex-wrap h-full items-baseline", children: [
    Boolean(actions.length || searchQuery) && /* @__PURE__ */ jsx("div", { className: "relative w-full mb-12", children: /* @__PURE__ */ jsx(
      AutoResizingDebouncedInput,
      {
        searchInputClassName: "absolute top-0 z-10 !w-full",
        wrapperClassName: "!flex-1 !w-full",
        showClearIcon: true,
        clearIconClassName: "text-secondary-600 flex items-center cursor-pointer",
        placeholder: t("suggestion_popup.action.placeholder"),
        value: searchQuery,
        onChange: updateSearchQuery,
        inputClassName: "!px-2 !py-0.5",
        className: "focus-within:!border-primary-300 focus-within:!ring focus-within:!ring-primary-100"
      }
    ) }),
    Boolean(filteredActions.length) && /* @__PURE__ */ jsx("div", { className: "h-[calc(100%_-_72px)] overflow-auto basis-full", children: /* @__PURE__ */ jsx(ActionsTable, { actions: filteredActions || [], onClick }) }),
    isFetching && !filteredActions?.length && /* @__PURE__ */ jsx("div", { className: "h-48 basis-full", children: /* @__PURE__ */ jsx(ShimmerLoader, {}) }),
    Boolean(!filteredActions.length && !isFetching) && /* @__PURE__ */ jsx(EmptyActions, { searchQuery })
  ] });
};
var know_more8 = "https://testsigma.com/docs/test-data/types/overview/";
var EmptyUpload = ({
  uploadButton,
  isSearch
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames82("items-center justify-center h-full", {
        flex: isSearch
      }),
      children: isSearch ? /* @__PURE__ */ jsx(SearchNotFound, {}) : /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          Icon,
          {
            name: "error",
            className: "inline-block cursor-pointer text-primary-500 text-5xl justify-center w-full"
          }
        ),
        /* @__PURE__ */ jsx("div", { className: "font-semibold text-secondary-700 py-6 basis-full text-center px-10", children: t("label.upload_empty_info") }),
        /* @__PURE__ */ jsx("div", { className: "flex p-lg basis-full justify-center mb-10", children: /* @__PURE__ */ jsx(
          Button,
          {
            type: "secondary",
            onClick: () => window.open(know_more8, "_blank"),
            children: t("common.know_more")
          }
        ) }),
        uploadButton
      ] })
    }
  ) });
};
var UploadListItem = ({ item, idx, onClick }) => {
  const storageLocationMask = (fileName) => `testsigma-storage:/.../${fileName}`;
  return /* @__PURE__ */ jsxs(
    TableRow,
    {
      className: classNames82(
        "hover:!bg-primary-50 cursor-pointer border-b-[0.5px] border-b-secondary-200 flex",
        {
          "bg-secondary-50": idx % 2 === 1
        }
      ),
      onClick: () => onClick(item),
      children: [
        /* @__PURE__ */ jsx(
          TableCell,
          {
            className: "w-1/2\n      ",
            children: /* @__PURE__ */ jsx(TruncatedText, { className: "inline-block", value: item.name })
          }
        ),
        /* @__PURE__ */ jsx(TableCell, { className: "w-1/2", children: /* @__PURE__ */ jsx(
          TruncatedText,
          {
            className: "inline-block",
            value: storageLocationMask(item?.latestVersion?.fileName)
          }
        ) })
      ]
    },
    item.id
  );
};
var UploadValueInfiniteScroll = ({ items, loadNextPage, hasNextPage, onClick, isLoading }) => {
  const { VirtualizedInfiniteLoader: VirtualizedInfiniteLoader9 } = InfiniteScrollV2;
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    VirtualizedInfiniteLoader9,
    {
      rowHeight: 32,
      rowRenderer: (index) => {
        const item = items[index];
        return /* @__PURE__ */ jsx(
          UploadListItem,
          {
            item,
            idx: index,
            onClick
          },
          index
        );
      },
      rowCount: items?.length || 0,
      items,
      loadMore: loadNextPage,
      hasMore: hasNextPage,
      isLoading
    }
  ) });
};
var UploadTable = ({
  uploads,
  onClick,
  loadNextPage,
  hasNextPage,
  isLoading
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs(
    Table,
    {
      wrapperClassName: "!border-0 h-full overflow-hidden",
      className: "h-full overflow-hidden",
      children: [
        /* @__PURE__ */ jsx(TableHeader, { className: "bg-secondary-100", children: /* @__PURE__ */ jsxs(TableRow, { children: [
          /* @__PURE__ */ jsx(TableCell, { className: "min-w-[200px]", children: t("label.upload_title") }),
          /* @__PURE__ */ jsx(TableCell, { className: "min-w-[200px]", children: t("label.upload_path") })
        ] }) }),
        /* @__PURE__ */ jsx(TableBody, { className: "h-full w-full", children: /* @__PURE__ */ jsx(
          UploadValueInfiniteScroll,
          {
            items: uploads,
            loadNextPage,
            hasNextPage,
            isLoading,
            onClick
          }
        ) })
      ]
    }
  );
};
var UploadSelector = ({
  onClick,
  uploads,
  isFetching,
  onChangeSearch,
  searchQuery,
  uploadNewFileButton,
  loadNextPage,
  hasNextPage
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs("div", { className: "basis-full h-full", children: [
    Boolean(uploads?.length || searchQuery) && /* @__PURE__ */ jsxs(Fragment, { children: [
      uploadNewFileButton,
      /* @__PURE__ */ jsx("div", { className: "relative w-full mb-12", children: /* @__PURE__ */ jsx(
        AutoResizingDebouncedInput,
        {
          searchInputClassName: "absolute top-0 z-10 !w-full",
          wrapperClassName: "!flex-1 !w-full",
          minHeight: 35,
          showClearIcon: true,
          clearIconClassName: "text-secondary-600 flex items-center cursor-pointer",
          placeholder: t("common.search"),
          value: searchQuery,
          onChange: onChangeSearch,
          inputClassName: "!px-2 !py-1.5",
          className: "focus-within:!border-primary-300 focus-within:!ring focus-within:!ring-primary-100"
        }
      ) })
    ] }),
    !!uploads?.length && /* @__PURE__ */ jsx("div", { className: "basis-full pt-5 h-[calc(100%_-_140px)] overflow-auto", children: /* @__PURE__ */ jsx(
      UploadTable,
      {
        uploads,
        onClick,
        loadNextPage,
        hasNextPage,
        isLoading: isFetching
      }
    ) }),
    isFetching && !uploads?.length && /* @__PURE__ */ jsx("div", { className: "h-48 basis-full", children: /* @__PURE__ */ jsx("div", { className: "empty-page-loader left-1/2 top-1/2 absolute" }) }),
    !uploads?.length && !isFetching && /* @__PURE__ */ jsx(
      EmptyUpload,
      {
        uploadButton: uploadNewFileButton,
        isSearch: !!searchQuery
      }
    )
  ] });
};
var CustomFunctionValueSelector = ({
  customFunctionValue,
  updateFormdata,
  isReadOnly
}) => {
  return /* @__PURE__ */ jsx("div", { className: "h-full", children: /* @__PURE__ */ jsx("div", { className: "z-20 basis-full pb-4", children: customFunctionValue?.map((item, idx) => /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx("div", { className: "text-small text-secondary-600 ml-auto font-medium py-2.5 pr-2.5", children: item.displayName }),
    /* @__PURE__ */ jsxs("div", { className: "bg-secondary-50 rounded-md flex basis-full mr-md p-0.5", children: [
      /* @__PURE__ */ jsx(
        "input",
        {
          className: "focus:outline-none bg-transparent py-1.5 pl-2.5 focus:bg-white focus-within:bg-slate-50 rounded-l flex-1 text-small",
          disabled: isReadOnly,
          value: item.argumentValue,
          onChange: (e) => updateFormdata(e.target.value, idx)
        }
      ),
      /* @__PURE__ */ jsx("div", { className: "text-small text-secondary-400 ml-auto font-medium p-2.5", children: item.type })
    ] })
  ] }, idx)) }) });
};
var custom_function_value_selector_default = CustomFunctionValueSelector;
var AutoHealedElementFeedbackModal = ({
  autoHealedElement,
  onClose,
  onSubmit
}) => {
  const { t } = useTranslation();
  const [comment, setComment] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      await onSubmit(autoHealedElement, false, comment);
      onClose();
    } catch (err) {
      toastify(t("auto_heal.element.feedback.error"), {
        type: "error"
      });
      throw err;
    } finally {
      setIsSubmitting(false);
    }
  };
  return /* @__PURE__ */ jsxs(Modal, { isOpen: true, onClose, className: "!rounded-lg", children: [
    /* @__PURE__ */ jsx("div", { className: "text-xl leading-5 font-medium text-unique-600", children: t("auto_heal.element.feedback.title") }),
    /* @__PURE__ */ jsx(
      TextArea,
      {
        id: "description",
        wrapperClassName: "w-full mt-5",
        inputClassName: "!py-2 resize-none placeholder-secondary-300",
        rows: 7,
        value: comment,
        onChange: (value) => setComment(value),
        onkeydown: (e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleSubmit();
          }
        },
        placeholder: t("auto_heal.element.feedback.placeholder"),
        maxLength: 500,
        isRequired: true
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: "flex flex-row-reverse mt-2", children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          type: "primary",
          onClick: handleSubmit,
          isDisabled: !comment || isSubmitting,
          children: isSubmitting ? /* @__PURE__ */ jsxs("div", { className: "flex gap-x-1.5 items-center", children: [
            /* @__PURE__ */ jsx(Icon, { className: " text-base flex animate-spin", name: "loader" }),
            t("common.submitting")
          ] }) : t("common.submit")
        }
      ),
      /* @__PURE__ */ jsx(Button, { type: "secondary", className: "mr-3", onClick: onClose, children: t("common.cancel") })
    ] })
  ] });
};
var SelectTestStep = ({
  testSteps,
  selectedStep,
  onSelect,
  placeholder,
  className,
  label,
  isRequired,
  labelClassName,
  nlActions,
  kibbutzActions
}) => {
  const { t } = useTranslation();
  const testStepToItem = (testStep) => ({
    id: testStep.id,
    label: `[${testStep.stepNumber}] - ${testStep.action}`
  });
  const optionsHook = useCallback(
    async (query) => {
      return [
        { disabled: false, id: null, label: t("common.none") },
        ...testSteps.filter(
          (step) => step.action?.toLowerCase().includes(query?.toLowerCase() || "")
        )?.map((step) => testStepToItem(step))
      ];
    },
    [testSteps]
  );
  const CustomItemWrapper = useCallback(
    ({ value }) => {
      const step = testSteps?.find((item) => item.id == value.id);
      const template = step?.kibbutzPluginNlpId ? kibbutzActions.find((item) => item.id === step?.kibbutzPluginNlpId) : nlActions.find((item) => item.id === step?.templateId);
      return step?.type ? /* @__PURE__ */ jsx(StepItemWrapper, { step, isViewOnly: true, template }) : /* @__PURE__ */ jsx("div", { className: "flex text-secondary-600", children: value?.label });
    },
    [testSteps]
  );
  return /* @__PURE__ */ jsx(
    AutoComplete,
    {
      value: selectedStep?.id ? testStepToItem(selectedStep) : {
        disabled: false,
        id: null,
        label: t("common.none")
      },
      onSelect,
      optionsHook,
      placeholder: placeholder || t("select.test.step"),
      isRequired,
      CustomItemWrapper,
      className,
      label,
      labelClassName,
      dropdownClass: "max-h-[260px] !overflow-y-scroll",
      variant: "select-fill",
      onClear: () => onSelect(null),
      showClearButton: !!selectedStep?.id
    }
  );
};
var DataDrivenExecutionList = ({
  dataDrivenResults,
  onSelectDataDrivenResult,
  activeDataDriven
}) => {
  const [filteredDataDrivenResults, setFilteredDataDrivenResults] = useState([]);
  const [skippedResults, setSkippedResults] = useState([]);
  const [activeTab, setActiveTab] = useState(null);
  const [searchDataSet] = useState(null);
  const { t } = useTranslation();
  const tabItems = [
    {
      label: t("common.all"),
      key: "all",
      active: true,
      type: "primary"
    },
    {
      label: t("common.passed"),
      key: "passed",
      active: false,
      type: "secondary"
    },
    {
      label: t("common.failed"),
      key: "failed",
      active: false,
      type: "secondary"
    }
  ];
  const handleFilterResults = (key, searchTerm) => {
    let results = [];
    let skippedResults2 = [];
    switch (key) {
      case "all":
        results = dataDrivenResults?.filter(
          (res) => !(res?.iterationResult?.isSkipped || res?.iterationResult?.testCaseResultMetric?.latestResult === ResultConstant.SKIPPED)
        );
        skippedResults2 = dataDrivenResults?.filter(
          (res) => res?.iterationResult?.isSkipped || res?.iterationResult?.testCaseResultMetric?.latestResult === ResultConstant.SKIPPED
        );
        break;
      case "passed":
        results = dataDrivenResults.filter(
          (dataDrivenResult) => dataDrivenResult?.iterationResult?.testCaseResultMetric?.latestResult === ResultConstant.SUCCESS
        );
        break;
      case "failed":
        results = dataDrivenResults.filter(
          (dataDrivenResult) => dataDrivenResult?.iterationResult?.testCaseResultMetric?.latestResult === ResultConstant.FAILURE
        );
        break;
    }
    if (searchTerm) {
      setFilteredDataDrivenResults(
        results.filter(
          (filteredItem) => filteredItem.testDataName.toLowerCase().includes(searchTerm.toLowerCase())
        ) || []
      );
      setSkippedResults(
        skippedResults2.filter(
          (filteredItem) => filteredItem.testDataName.toLowerCase().includes(searchTerm.toLowerCase())
        ) || []
      );
    } else {
      setFilteredDataDrivenResults(results || []);
      setSkippedResults(skippedResults2 || []);
    }
    setActiveTab(key);
  };
  useEffect(() => {
    if (!activeTab && dataDrivenResults?.length) {
      handleFilterResults("all");
    } else {
      handleFilterResults(activeTab);
    }
  }, [dataDrivenResults]);
  const handleActivateDatadriven = useCallback(
    (dataDrivenResult) => {
      if (dataDrivenResult.id !== activeDataDriven?.id) {
        onSelectDataDrivenResult(dataDrivenResult.iterationResult.lastRun?.id);
      }
    },
    [activeDataDriven, onSelectDataDrivenResult]
  );
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: "rounded-lg p-4",
      style: { boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)" },
      children: [
        /* @__PURE__ */ jsx("div", { className: "flex flex-row gap-x-3", children: tabItems.map((tabItem, idx) => /* @__PURE__ */ jsx(
          "span",
          {
            onClick: () => handleFilterResults(tabItem.key),
            className: classNames82(
              "px-3 py-2 text-small rounded !leading-3.5 cursor-pointer",
              {
                "bg-primary-100 text-primary-600": tabItem.key === activeTab,
                "hover:bg-secondary-50 text-[#4F5F69]": tabItem.key !== activeTab
              }
            ),
            children: tabItem.label
          },
          idx
        )) }),
        /* @__PURE__ */ jsx("div", { className: "mt-3", children: /* @__PURE__ */ jsx(
          Input,
          {
            prefix: /* @__PURE__ */ jsx(
              Icon,
              {
                name: "search",
                className: "text-base text-secondary-600 flex items-center pl-3"
              }
            ),
            placeholder: t("tdp.data_set_name"),
            value: searchDataSet,
            onChange: (val) => handleFilterResults(activeTab, val),
            inputClassName: "!py-1.5 !px-2.5 leading-4 !text-small",
            wrapperClassName: "w-full"
          }
        ) }),
        /* @__PURE__ */ jsx("div", { className: "mt-3 gap-y-3 flex flex-col", children: filteredDataDrivenResults?.length || skippedResults?.length ? /* @__PURE__ */ jsxs(Fragment, { children: [
          filteredDataDrivenResults.map((dataDrivenResult, idx) => /* @__PURE__ */ jsx(
            DataDrivenResultCard,
            {
              dataDrivenResult,
              onSelect: () => handleActivateDatadriven(dataDrivenResult),
              active: dataDrivenResult.id === activeDataDriven?.id
            },
            idx
          )),
          skippedResults?.length > 0 && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx("span", { className: "text-secondary-700 text-small", children: "Criteria not matched" }),
            skippedResults?.map((skippedResult) => /* @__PURE__ */ jsx(
              TruncatedText,
              {
                value: skippedResult.testDataName?.replace(/\\n/g, " ")?.replace(/\n/g, " ") || "",
                className: "text-small p-3 bg-secondary-50"
              },
              skippedResult.id
            ))
          ] })
        ] }) : /* @__PURE__ */ jsx(
          Empty,
          {
            description: /* @__PURE__ */ jsx("span", { children: "No matching results found." }),
            imageSource: noDataPane
          }
        ) })
      ]
    }
  );
};
var DataDrivenTestCaseExecutedItems = ({
  dataDrivenResults,
  onSelectDataDrivenResult,
  activeDataDrivenTestCaseResultId,
  containerClassName = "",
  className = "",
  label = "",
  isRequired = false,
  wrapperClassName = ""
}) => {
  const [activeDataDriven, setActiveDataDriven] = useState(null);
  const { t } = useTranslation();
  useEffect(() => {
    const activeDataDrivenResult = dataDrivenResults?.find(
      (dataDrivenResult) => dataDrivenResult?.iterationResultId === activeDataDrivenTestCaseResultId || dataDrivenResult?.iterationResult?.lastRun?.id === activeDataDrivenTestCaseResultId
    );
    setActiveDataDriven(activeDataDrivenResult);
  }, [activeDataDrivenTestCaseResultId, dataDrivenResults]);
  const labelStyle = activeDataDriven ? getLabelStyleByResult(
    activeDataDriven?.iterationResult?.testCaseResultMetric?.latestResult
  ) : {
    textColor: "text-secondary-700",
    icon: ""
  };
  const dataDrivenHeader = /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-x-1.5", children: [
      /* @__PURE__ */ jsx(
        Icon,
        {
          name: labelStyle.icon,
          className: classNames82("text-base", labelStyle.textColor, {
            "animate-spin": activeDataDriven?.iterationResult?.testCaseResultMetric.latestResult == ResultConstant.RUNNING
          })
        }
      ),
      /* @__PURE__ */ jsx(
        TruncatedText,
        {
          value: activeDataDriven?.testDataName?.replace(/\\n/g, " ")?.replace(/\n/g, " ") || "",
          className: "text-unique-800 max-w-[96px] text-small"
        }
      )
    ] }),
    /* @__PURE__ */ jsx("span", { className: "text-small leading-5 text-secondary-500", children: t(
      "tdp.expected_to_fail." + (activeDataDriven?.lastRunTestData?.expectedToFail ?? activeDataDriven?.testData?.expectedToFail ?? false)
    ) })
  ] });
  return /* @__PURE__ */ jsx(
    DropdownButton,
    {
      name: dataDrivenHeader,
      wrapperClassName,
      className: classNames82(
        "!w-[215px] shadow-[0px_1px_1px_0px_rgba(0,0,0,0.06),_0px_4px_4px_-1px_rgba(0,0,0,0.02)] !hover:!bg-secondary-50 items-center !text-2xs !px-2 !py-1",
        "bg-white !h-7 !rounded-[5px] !border-0.5 !border-secondary-200",
        className
      ),
      dropdownClassName: classNames82(
        "!w-[320px] !shadow-mi !mr-[-105px]",
        containerClassName
      ),
      dropdownIconClassName: "!text-lg",
      fillWidth: false,
      label,
      isRequired,
      children: /* @__PURE__ */ jsx(
        DataDrivenExecutionList,
        {
          dataDrivenResults,
          onSelectDataDrivenResult,
          activeDataDriven
        }
      )
    }
  );
};
var AffectedInstanceHeader = ({ onClose }) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-row items-center font-semibold text-secondary-700 h-12 bg-secondary-50 px-4 py-3", children: [
    /* @__PURE__ */ jsx(Icon, { className: "text-lg", name: "warning-fill" }),
    /* @__PURE__ */ jsx("span", { className: "ml-2 flex-grow text-base leading-5", children: t("affected_instance.title") }),
    /* @__PURE__ */ jsx("span", { className: "flex", onClick: onClose, children: /* @__PURE__ */ jsx(Icon, { className: "text-xl cursor-pointer", name: "close" }) })
  ] });
};
var AffectedInstanceList = ({
  instanceList,
  showNavigation,
  entity
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx("div", { className: "flex-col", children: /* @__PURE__ */ jsx("div", { className: "h-[calc(100vh_-_184px)]", children: /* @__PURE__ */ jsxs("div", { className: "mx-4 rounded border border-secondary-100 max-h-full overflow-auto", children: [
    !!instanceList?.length && instanceList.map((instance, i) => {
      return /* @__PURE__ */ jsxs(
        "div",
        {
          className: classNames82(
            "py-2 px-3 text-small leading-4 text-secondary-700 flex justify-between",
            i % 2 == 1 ? "bg-secondary-50" : ""
          ),
          children: [
            /* @__PURE__ */ jsx("span", { className: "break-all pr-4", children: instance.name }),
            showNavigation && /* @__PURE__ */ jsxs(
              "a",
              {
                href: `/ui/td/${instance.applicationVersionId}/cases/filters/${instance.id}`,
                target: "_blank",
                className: "flex items-center gap-x-1.5 shrink-0",
                rel: "noreferrer",
                children: [
                  /* @__PURE__ */ jsx("span", { className: "text-primary-600", children: " Run Now" }),
                  /* @__PURE__ */ jsx(
                    Icon,
                    {
                      name: "open-in-new",
                      className: "text-base text-primary-600 leading-5"
                    }
                  )
                ]
              }
            )
          ]
        },
        i
      );
    }),
    instanceList.length == 0 && /* @__PURE__ */ jsx(
      Empty,
      {
        className: "py-28",
        description: t(
          "common.item_not_associated_with_entitie.message",
          {
            item: `${t("common.element")?.toLocaleLowerCase()}`,
            entitie: t(
              `elements.affected-items.${entity?.replace?.("_", "-")}`
            )
          }
        ),
        image: /* @__PURE__ */ jsx(
          "img",
          {
            src: "https://user-images.githubusercontent.com/507615/54591679-b0ceb580-4a65-11e9-925c-ad15b4eae93d.png",
            alt: t("common.empty.list.image")
          }
        )
      }
    )
  ] }) }) });
};
var AffectedItemsTabItem = ({
  label,
  isSelected,
  onClick,
  count
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx(
    "span",
    {
      className: classNames82(
        "cursor-pointer flex-1 py-1.5 rounded text-small text-secondary-500 text-center font-medium",
        isSelected ? "bg-primary-100 text-primary-700" : ""
      ),
      onClick,
      children: `${label} (${count ?? 0})`
    }
  );
};
var AffectedInstanceTabs = ({
  onSelectTab,
  activeTab,
  tabs
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx("div", { className: "px-4 py-6", children: /* @__PURE__ */ jsx("div", { className: "flex", children: tabs.map((item) => /* @__PURE__ */ jsx(
    AffectedItemsTabItem,
    {
      label: t(item.label),
      count: item.count,
      isSelected: activeTab == item.key,
      onClick: () => onSelectTab(item.key)
    },
    item.key
  )) }) });
};
var AffectedInstanceDetails = ({
  onClose,
  affectedInstanceTestCases = [],
  affectedInstanceStepGroups = [],
  affectedInstanceTestSuites = [],
  affectedInstanceTestPlans = []
}) => {
  const [activeTab, setActiveTab] = useState("test_case");
  const [instanceList, setInstanceList] = useState(
    affectedInstanceTestCases.map((tc) => ({
      name: tc.name,
      id: tc.id,
      applicationVersionId: tc.applicationVersionId
    }))
  );
  const tabItems = [
    {
      label: "affected_instance.test_cases",
      key: "test_case",
      count: affectedInstanceTestCases.length
    },
    {
      label: "affected_instance.step_groups",
      key: "step_group",
      count: affectedInstanceStepGroups.length
    },
    {
      label: "affected_instance.test_suites",
      key: "test_suite",
      count: affectedInstanceTestSuites.length
    },
    {
      label: "affected_instance.test_plans",
      key: "test_plan",
      count: affectedInstanceTestPlans.length
    }
  ];
  useEffect(() => {
    switch (activeTab) {
      case "test_case":
        setInstanceList(
          affectedInstanceTestCases.map((tc) => ({
            name: tc.name,
            id: tc.id,
            applicationVersionId: tc.applicationVersionId
          }))
        );
        break;
      case "step_group":
        setInstanceList(
          affectedInstanceStepGroups.map((sg) => ({
            name: sg.name,
            id: sg.id,
            applicationVersionId: sg.applicationVersionId
          }))
        );
        break;
      case "test_suite":
        setInstanceList(
          affectedInstanceTestSuites.map((ts) => ({
            name: ts.name,
            id: ts.id,
            applicationVersionId: ts.appVersionId
          }))
        );
        break;
      case "test_plan":
        setInstanceList(
          affectedInstanceTestPlans.map((tp) => ({
            name: tp.name,
            id: tp.id,
            applicationVersionId: tp.applicationVersionId
          }))
        );
        break;
      default:
        setInstanceList(
          affectedInstanceTestCases.map((tc) => ({
            name: tc.name,
            id: tc.id,
            applicationVersionId: tc.applicationVersionId
          }))
        );
        break;
    }
  }, [activeTab, affectedInstanceTestCases]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(AffectedInstanceHeader, { onClose }),
    /* @__PURE__ */ jsx(
      AffectedInstanceTabs,
      {
        onSelectTab: (tabKey) => {
          setActiveTab(tabKey);
        },
        activeTab,
        tabs: tabItems
      }
    ),
    /* @__PURE__ */ jsx(
      AffectedInstanceList,
      {
        instanceList,
        showNavigation: activeTab === "test_case",
        entity: activeTab
      }
    )
  ] });
};
var getStatusCount = (data) => {
  const responseBodyVerificationDetails = data.responseBodyVerificationDetails || [];
  const responseHeaderVerificationDetails = data.responseHeaderVerificationDetails || [];
  const statusResponseSizeVerificationDetails = data.statusResponseSizeVerificationDetails || [];
  const totalVerificationCount = responseBodyVerificationDetails.length + responseHeaderVerificationDetails.length + statusResponseSizeVerificationDetails.length;
  const successfulVerificationCount = responseBodyVerificationDetails.filter((item) => item.result === "SUCCESS").length + responseHeaderVerificationDetails.filter(
    (item) => item.result === "SUCCESS"
  ).length + statusResponseSizeVerificationDetails.filter(
    (item) => item.result === "SUCCESS"
  ).length;
  return {
    totalCount: totalVerificationCount,
    successCount: successfulVerificationCount,
    failedCount: totalVerificationCount - successfulVerificationCount
  };
};
var ApiStepResultCard = ({ apiStepResult, openApiResultModal }) => {
  const { t } = useTranslation();
  const statusCount = getStatusCount(apiStepResult);
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col text-small leading-5 rounded-[5px] bg-white my-3 px-5 py-3 border-0.5 border-secondary-200", children: [
    /* @__PURE__ */ jsxs("div", { className: "font-semibold", children: [
      t("common.verifications"),
      " ",
      !!statusCount.totalCount && /* @__PURE__ */ jsx("span", { className: "ml-3 px-1 py-0.5 rounded bg-primary-100 text-primary-500 font-normal text-xs", children: statusCount.totalCount })
    ] }),
    !!statusCount.totalCount && /* @__PURE__ */ jsx("div", { className: "mt-2", children: t("api.result.verifications.count", statusCount) }),
    /* @__PURE__ */ jsx(
      "div",
      {
        className: "mt-2 text-primary-600 font-semibold cursor-pointer",
        onClick: openApiResultModal,
        children: t("api.result.view.detailed.result", statusCount)
      }
    )
  ] });
};
var AddonLogs = ({ logs, isNlpAddon }) => {
  const { t } = useTranslation();
  const [expandLogs, toggleExpandLogs] = useState(false);
  const parsedLogs = useMemo(() => parseLogs(logs), [logs]);
  return /* @__PURE__ */ jsx(
    Expandable,
    {
      isExpanded: expandLogs,
      onChange: () => toggleExpandLogs(!expandLogs),
      expandLabel: isNlpAddon ? t("common.addonLogs") : t("common.addontdfLogs"),
      collapseLabel: isNlpAddon ? t("common.addonLogs") : t("common.addontdfLogs"),
      className: "text-unique-600 font-medium flex-row-reverse justify-between",
      iconClassName: classNames82(
        "text-xl",
        expandLogs ? "rotate-180" : "rotate-90"
      ),
      labelClassName: "!p-0",
      wrapperClassName: "bg-white px-5 py-3 rounded-[5px] border-secondary-200 border-0.5 mt-3",
      children: parsedLogs && /* @__PURE__ */ jsx("div", { className: "flex flex-col gap-y-3 mt-3", children: parsedLogs.map((log2, index) => /* @__PURE__ */ jsx(React5__default.Fragment, { children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-y-2 border-b border-secondary-200 overflow-hidden", children: [
        /* @__PURE__ */ jsx("div", { className: "w-full text-small text-secondary-500", children: log2.head }),
        /* @__PURE__ */ jsx("div", { className: "text-small w-full text-unique-600 break-words pb-2", children: log2.content })
      ] }) }, index)) })
    }
  );
};
var StepResultPanel = ({
  stepResult,
  allStepResults,
  visualResults,
  visualResult,
  testCaseResult,
  onLoadAffectedInstances,
  affectedInstanceTestCases,
  affectedInstanceStepGroups,
  affectedInstanceTestSuites,
  affectedInstanceTestPlans,
  isHideHeader,
  onOpenAutoHealComparisonModal,
  onAutoHealElementUpdate,
  autoHealElementToUpdate,
  fetchElement,
  onShowScreenshot,
  onEditElement,
  isElementChanged,
  onOpenApiResultModal,
  onOpenSoqlResultModal,
  onOpenSalesforceApiResultModal,
  onViewStepResult,
  variant = "step-result-view",
  uploadVersion,
  dataDrivenResult,
  onDebugTillStep,
  isPublicTestCase,
  application,
  onViewSource,
  nlActions,
  hasFeatureValue: hasFeatureValue2,
  triggerAiAnalyzer,
  canAnalyze,
  DebuggerButton,
  onShowAffectedList,
  tenantId,
  testCaseResultId,
  versionId
}) => {
  const [autoHealElementKey, setAutoHealElementKey] = useState(null);
  const [elementFeedbackMap, setElementFeedbackMap] = useState(/* @__PURE__ */ new Map());
  const handleElementFeedback = (elementKey, isPositive) => {
    setElementFeedbackMap((prev) => {
      const newMap = new Map(prev);
      newMap.set(elementKey, isPositive);
      return newMap;
    });
  };
  const [showAffectedInstanceDetails, setAffectedInstanceDetails] = useState(false);
  const [activeVisualResult, setActiveVisualResult] = useState(null);
  const onOpenAffectedInstances = () => {
    setAffectedInstanceDetails(true);
    onLoadAffectedInstances();
  };
  const isSalesforceReadApiStep2 = (templateId) => {
    const salesforceReadApiTemplateIds = [80064];
    return salesforceReadApiTemplateIds?.includes(templateId);
  };
  const isSalesforceApiStep2 = (templateId) => {
    const salesforceApiTemplateIds = [60428, 61451];
    return salesforceApiTemplateIds?.includes(templateId);
  };
  const OpenApiResultModal = useCallback(() => {
    const isSalesForceApplication = application?.applicationType === ApplicationType.Salesforce;
    const data = {
      versionId: stepResult.testCase?.applicationVersionId,
      testCaseId: stepResult.testCaseId,
      // testStepId: stepResult.stepDetails.id,
      apiStepResultId: stepResult.apiStepResultId || stepResult.apiStepResult?.id,
      stepResultUUID: stepResult?.uuid,
      steNumber: stepResult?.stepDetails?.stepNumber,
      isSalesForceApplication,
      ...isSalesForceApplication ? {
        testStepId: stepResult?.stepId,
        isSalesforceApiStep: isSalesforceApiStep2(
          stepResult.stepDetails.templateId
        ),
        isSalesforceReadApiStep: isSalesforceReadApiStep2(
          stepResult.stepDetails.templateId
        )
      } : {}
    };
    onOpenApiResultModal?.(data);
  }, [stepResult, onOpenApiResultModal]);
  const OpenSoqlResultModal = useCallback(() => {
    const data = {
      versionId: stepResult.testCase?.applicationVersionId,
      testCaseId: stepResult?.metadata?.testStep?.testCaseId,
      soqlStepResultId: stepResult?.apiStepResultId || stepResult?.apiStepResult?.id,
      stepNumber: stepResult?.stepNumber,
      testStepId: stepResult.testStep?.id
    };
    onOpenSoqlResultModal?.(data);
  }, [stepResult, onOpenSoqlResultModal]);
  const OpenSalesforceApiResultModal = useCallback(() => {
    const data = {
      versionId: stepResult.testCase?.applicationVersionId,
      testCaseId: stepResult.testCaseId,
      stepNumber: stepResult?.stepDetails?.stepNumber,
      stepResult
    };
    onOpenSalesforceApiResultModal?.(data);
  }, [stepResult, onOpenSalesforceApiResultModal]);
  const getScreenshotFileName = useMemo(() => {
    const date = stepResult?.endTime ? epochMillisecondsToDate(stepResult.endTime) : "";
    return testCaseResult?.testCase?.name + "_" + stepResult?.stepNumber + "_" + date + ".jpeg";
  }, [stepResult, testCaseResult]);
  useEffect(() => {
    setActiveVisualResult(
      visualResults?.find((vis) => vis.uuid === stepResult?.uuid)
    );
  }, [stepResult, visualResults]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("div", { className: "h-full overflow-y-auto pr-5 pb-6 overflow-auto", children: [
      /* @__PURE__ */ jsx(
        StepResultDetails,
        {
          stepResult,
          screenshotFileName: getScreenshotFileName,
          onShowAutoHeal: setAutoHealElementKey,
          onShowAutoHealComparisonModal: onOpenAutoHealComparisonModal,
          onShowAffectedInstance: onOpenAffectedInstances,
          onShowScreenshot,
          className: classNames82({ "mt-5": variant === "step-result-view" }),
          onEditElement,
          isElementChanged,
          variant,
          testCaseResult,
          visualResult: activeVisualResult || visualResult,
          OpenSalesforceApiResultModal,
          application,
          onViewSource,
          isHideHeader,
          openApiResultModal: OpenApiResultModal,
          hasFeatureValue: hasFeatureValue2,
          triggerAiAnalyzer,
          canAnalyze,
          DebuggerButton,
          onShowAffectedList,
          tenantId,
          testCaseResultId,
          versionId,
          elementFeedbackMap,
          onElementFeedback: handleElementFeedback
        }
      ),
      stepResult?.apiStepResult && /* @__PURE__ */ jsx(
        ApiStepResultCard,
        {
          openApiResultModal: stepResult.stepDetails.type === "SOQL" ? OpenSoqlResultModal : OpenApiResultModal,
          apiStepResult: stepResult?.apiStepResult
        }
      ),
      (!isObjectEmpty(stepResult?.metadata) || stepResult.apiStepResultId != null) && /* @__PURE__ */ jsx(
        StepResultMeta,
        {
          stepResult,
          testCaseResult,
          onOpenApiResultModal: OpenApiResultModal,
          onViewStepResult,
          uploadVersion,
          dataDrivenResult,
          application,
          nlActions
        }
      ),
      stepResult?.kibbutzNlpLogs != null && /* @__PURE__ */ jsx(AddonLogs, { logs: getLogs(stepResult, true), isNlpAddon: true }),
      stepResult?.kibbutzTDFLogs != null && /* @__PURE__ */ jsx(AddonLogs, { logs: getLogs(stepResult, false) })
    ] }),
    autoHealElementKey && /* @__PURE__ */ jsx(
      Drawer,
      {
        isOpen: !!autoHealElementKey,
        closeOnEscape: true,
        closeOnOutsideClick: true,
        onClose: () => setAutoHealElementKey(null),
        children: /* @__PURE__ */ jsx(DrawerItem, { direction: "right", width: 600, children: /* @__PURE__ */ jsx(
          AutoHealDetails,
          {
            stepResult,
            onClose: () => setAutoHealElementKey(null),
            elementKey: autoHealElementKey,
            fetchElement,
            onAutoHealElementUpdate,
            autoHealElementToUpdate,
            tenantId,
            testCaseResultId,
            autoHealFeedback: elementFeedbackMap.get(
              `${stepResult?.uuid}_${autoHealElementKey}`
            ),
            onElementFeedback: handleElementFeedback,
            stepResultUuid: stepResult?.uuid
          }
        ) })
      }
    ),
    /* @__PURE__ */ jsx(
      Drawer,
      {
        isOpen: showAffectedInstanceDetails,
        closeOnOutsideClick: true,
        closeOnEscape: true,
        onClose: () => setAffectedInstanceDetails(false),
        children: /* @__PURE__ */ jsx(DrawerItem, { direction: "right", width: 600, children: /* @__PURE__ */ jsx(
          AffectedInstanceDetails,
          {
            onClose: () => setAffectedInstanceDetails(false),
            affectedInstanceTestCases,
            affectedInstanceStepGroups,
            affectedInstanceTestSuites,
            affectedInstanceTestPlans
          }
        ) })
      }
    )
  ] });
};
var stepLevelExecutionResultIcon = (status, isOverRidden = false) => {
  const getTooltip = (_status) => {
    switch (_status) {
      case ResultConstant.SUCCESS:
        return isOverRidden ? "Passed (Overridden)" : "Passed";
      case ResultConstant.FAILURE:
        return isOverRidden ? "Failed (Overridden)" : "Failed";
      case ResultConstant.RUNNING:
        return "Running";
      case ResultConstant.NOT_EXECUTED:
        return isOverRidden ? "Not Executed (Overridden)" : "Not Executed";
      case ResultConstant.STOPPED:
        return "Stopped";
      case ResultConstant.QUEUED:
        return "Queued";
      case ResultConstant.ABORTED:
        return "Aborted";
      default:
        return "Queued";
    }
  };
  switch (status) {
    case ResultConstant.SUCCESS:
      return {
        icon: /* @__PURE__ */ jsx(
          Icon,
          {
            name: isOverRidden ? "success-overridden" : "check-fill",
            className: classNames82(
              "text-primary-400 flex items-center",
              isOverRidden ? "text-md" : "!text-10px"
            )
          }
        ),
        bgColor: "bg-primary-50",
        hoverBgColor: "hover:bg-primary-50",
        tooltip: getTooltip(status)
      };
    case ResultConstant.RUNNING:
      return {
        icon: /* @__PURE__ */ jsx(
          Icon,
          {
            name: "loader",
            className: "text-lg animate-spin text-warning-600 flex items-center"
          }
        ),
        bgColor: "bg-warning-1000",
        hoverBgColor: "hover:bg-warning-1000",
        tooltip: getTooltip(status)
      };
    case ResultConstant.FAILURE:
      return {
        icon: /* @__PURE__ */ jsx(
          Icon,
          {
            name: isOverRidden ? "failed-overridden" : "close-fill",
            className: classNames82(
              "text-error-500 flex items-center",
              isOverRidden ? "text-md" : "!text-10px"
            )
          }
        ),
        bgColor: "bg-error-100",
        hoverBgColor: "hover:bg-error-100",
        tooltip: getTooltip(status)
      };
    case ResultConstant.NOT_EXECUTED:
      return {
        icon: /* @__PURE__ */ jsx(
          Icon,
          {
            name: isOverRidden ? "not-executed-overridden" : "hide-source-outline",
            className: classNames82(
              " text-unique-400 flex items-center",
              isOverRidden ? "text-base" : "text-xs"
            )
          }
        ),
        bgColor: "bg-unique-400/10",
        hoverBgColor: "hover:bg-unique-400/10",
        tooltip: getTooltip(status)
      };
    case ResultConstant.STOPPED:
      return {
        icon: /* @__PURE__ */ jsx(
          Icon,
          {
            name: "stop-circle-outline",
            className: "text-base text-secondary-500 flex items-center"
          }
        ),
        bgColor: "bg-secondary-100",
        hoverBgColor: "hover:bg-secondary-100",
        tooltip: getTooltip(status)
      };
    case ResultConstant.QUEUED:
      return {
        icon: /* @__PURE__ */ jsx(
          Icon,
          {
            name: "result-queued",
            className: "text-xs text-secondary-unique-200 flex items-center"
          }
        ),
        bgColor: "bg-unique-100",
        hoverBgColor: "hover:bg-unique-100",
        tooltip: getTooltip(status)
      };
    case ResultConstant.ABORTED:
      return {
        icon: /* @__PURE__ */ jsx(
          Icon,
          {
            name: "result-aborted",
            className: "text-warning-700 flex items-center"
          }
        ),
        bgColor: "bg-warning-100",
        hoverBgColor: "hover:bg-warning-100",
        tooltip: getTooltip(status)
      };
    // Returning Queued when the result status is not there
    default:
      return {
        icon: /* @__PURE__ */ jsx(
          Icon,
          {
            name: "result-queued",
            className: "text-xs text-secondary-unique-200 flex items-center"
          }
        ),
        bgColor: "bg-unique-100",
        hoverBgColor: "hover:bg-unique-100",
        tooltip: getTooltip(status)
      };
  }
};
var step_result_icon_details_default = stepLevelExecutionResultIcon;
var TreeNode = ({
  node,
  showSelectionOnClick = false,
  onNodeSelection = () => {
  }
}) => {
  const hasChildren = !!node?.children?.length;
  return /* @__PURE__ */ jsxs("div", { className: "flex items-center w-full pl-2 tree-node", children: [
    hasChildren ? /* @__PURE__ */ jsx(
      Icon,
      {
        name: "angle-right",
        className: classNames82(
          "mr-1 text-secondary-500 cursor-pointer text-lg",
          node?.isOpen ? "rotate-90" : ""
        ),
        onClick: (e) => {
          e.stopPropagation();
          node?.toggle();
        }
      }
    ) : /* @__PURE__ */ jsx("span", { className: "w-4 mr-1" }),
    /* @__PURE__ */ jsx(
      "div",
      {
        className: "flex items-center justify-between w-[calc(100%_-_26px)]",
        onClick: showSelectionOnClick ? onNodeSelection : NOOP,
        children: /* @__PURE__ */ jsxs("div", { className: "flex items-center w-[calc(100%_-_35px)]", children: [
          /* @__PURE__ */ jsx(
            Icon,
            {
              name: node?.data?.type === "FEATURE" ? "feature" : node?.data?.type === "SCENARIO" ? "scenario" : "folder",
              className: "mr-1.5 text-secondary-unique-800"
            }
          ),
          /* @__PURE__ */ jsx(
            TruncatedText,
            {
              value: node?.data?.name || "-",
              className: "text-secondary-unique-600 font-normal"
            }
          )
        ] })
      }
    )
  ] });
};
var tree_node_default = TreeNode;
var TestCaseTargetModal = ({
  isOpen,
  isAdd = false,
  isSelection = false,
  isBulkMove = false,
  isSubmitting = false,
  loading = false,
  treeData,
  selectedNode: selectedNodeProp = null,
  onSelectNode = NOOP,
  onConfirm = NOOP,
  onClose = NOOP,
  canShowQTestSync = false,
  onQTestSync = NOOP,
  heading,
  currentPath,
  selectableTypes = ["SCENARIO"]
}) => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearch = useDebounce(searchTerm, 200);
  const treeRef = useRef(null);
  const [selectedNode, setSelectedNode] = useState(selectedNodeProp);
  useEffect(() => {
    setSelectedNode(selectedNodeProp);
  }, [selectedNodeProp]);
  const { handleScroll } = useHighlight(
    treeRef,
    debouncedSearch,
    ".move-cases-modal"
  );
  const handleNodeClick = (node) => {
    node?.toggle();
  };
  const handleClose = () => {
    setSelectedNode(null);
    onClose?.();
  };
  const isConfirmDisabled = isSubmitting || loading || !selectedNode || !selectableTypes.length;
  const currentLabel = t("folders.current_entity.label", {
    entity: "Scenario"
  });
  const targetLabel = t("folders.target_entity.label", { entity: "Scenario" });
  const searchPlaceholder = t("common.search");
  const none = t("common.none");
  const confirm = t("common.confirm");
  const cancel = t("common.cancel");
  const confirmAndSync = t("common.confirm_and_sync_with_qtest");
  const resolvedTitle = heading || (isBulkMove ? t("folders.move_entity.label", { entity: "Test Cases" }) : t("folders.select_entity.label", { entity: "Location" }));
  const renderRow = ({
    node,
    attrs,
    innerRef
  }) => {
    const targetNode = node;
    return /* @__PURE__ */ jsx(
      "div",
      {
        ...attrs,
        style: { ...attrs.style, paddingLeft: targetNode.level * 10 },
        ref: innerRef,
        onClick: () => handleNodeClick(targetNode),
        onKeyDown: (e) => e.stopPropagation(),
        className: classNames82(
          "hover:bg-secondary-100 flex items-center h-full cursor-pointer group",
          targetNode.isSelected ? "bg-secondary-200" : ""
        ),
        children: /* @__PURE__ */ jsx(
          tree_node_default,
          {
            node: targetNode,
            showSelectionOnClick: selectableTypes.includes(targetNode.data.type),
            onNodeSelection: () => {
              targetNode.tree.select(targetNode.data.id);
              setSelectedNode(targetNode);
              onSelectNode(targetNode);
            }
          }
        )
      }
    );
  };
  return /* @__PURE__ */ jsxs(
    Modal,
    {
      isOpen,
      showCloseButton: true,
      closeOnEscape: true,
      closeOnOutsideClick: true,
      className: "relative rounded-lg !w-[500px] max-h-[85%] min-h-[75%] !p-0 flex flex-col overflow-hidden",
      onClose,
      zIndex: 5e3,
      children: [
        /* @__PURE__ */ jsx("h1", { className: " text-lg font-medium text-secondary-unique-600 mb-6 bg-secondary-100 px-5 py-3 flex-shrink-0", children: resolvedTitle }),
        /* @__PURE__ */ jsxs("div", { className: "flex-1 overflow-y-auto flex flex-col justify-between", children: [
          !isBulkMove && !isSelection && currentPath && /* @__PURE__ */ jsxs("div", { className: "px-5 mb-5", children: [
            /* @__PURE__ */ jsx("h2", { className: "text-secondary-unique-600 text-2xs font-medium", children: currentLabel }),
            /* @__PURE__ */ jsx("div", { className: "flex items-center", children: currentPath?.feature || currentPath?.scenario ? /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(
                TruncatedText,
                {
                  value: currentPath?.feature,
                  className: "!text-secondary-500 text-2xs inline-block max-w-full !w-fit"
                }
              ),
              /* @__PURE__ */ jsx("span", { className: "text-secondary-500 text-2xs mx-1", children: "/" }),
              /* @__PURE__ */ jsx(
                TruncatedText,
                {
                  value: currentPath?.scenario,
                  className: "!text-secondary-500 text-2xs inline-block max-w-full !w-fit"
                }
              )
            ] }) : /* @__PURE__ */ jsx("span", { className: "text-secondary-500 text-2xs", children: none }) })
          ] }),
          /* @__PURE__ */ jsx(
            Input,
            {
              type: "text",
              hasError: false,
              placeholder: searchPlaceholder,
              value: searchTerm,
              onChange: (value) => setSearchTerm(value),
              wrapperClassName: "w-full mb-4 px-5"
            }
          ),
          /* @__PURE__ */ jsx("div", { className: "flex-1 rounded-lg border border-neutral-200 mb-6 move-cases-modal mx-5 overflow-x-hidden overflow-y-auto", children: loading ? Array.from({ length: 9 }, (_, i) => /* @__PURE__ */ jsx(ShimmerLoader, { className: "my-4 w-11/12 mx-auto" }, i)) : treeData?.length ? /* @__PURE__ */ jsx(
            Tree,
            {
              ref: treeRef,
              data: treeData,
              renderRow,
              openByDefault: false,
              selectionFollowsFocus: false,
              height: 400,
              width: 458,
              overscanCount: 5,
              rowHeight: 28,
              paddingTop: 0,
              paddingBottom: 0,
              disableDrag: true,
              disableDrop: true,
              onScroll: debouncedSearch ? handleScroll : NOOP,
              searchTerm: debouncedSearch,
              searchMatch: (node, term) => {
                const matchSearch = (current) => {
                  if (current?.data?.name.toLowerCase().includes(term.toLowerCase())) {
                    return true;
                  } else if (current?.parent?.data?.name) {
                    return matchSearch(current.parent);
                  } else {
                    return false;
                  }
                };
                return matchSearch(node);
              }
            },
            "move-cases"
          ) : /* @__PURE__ */ jsx("div", { className: "p-4 text-secondary-400 text-xs", children: t("common.no_results_found") }) }),
          /* @__PURE__ */ jsxs("div", { className: "px-5 mb-5", children: [
            /* @__PURE__ */ jsx("h2", { className: "text-secondary-unique-600 text-2xs font-medium mb-1", children: targetLabel }),
            selectedNode ? /* @__PURE__ */ jsxs("div", { className: "flex items-center", children: [
              /* @__PURE__ */ jsx(
                TruncatedText,
                {
                  value: selectedNode?.data?.parentName,
                  className: "!text-secondary-500 text-2xs inline-block max-w-[50%] !w-fit"
                }
              ),
              /* @__PURE__ */ jsx("span", { className: "text-secondary-500 text-2xs mx-1", children: "/" }),
              /* @__PURE__ */ jsx(
                TruncatedText,
                {
                  value: selectedNode?.data?.name,
                  className: "!text-secondary-500 text-2xs inline-block max-w-[50%] !w-fit"
                }
              )
            ] }) : /* @__PURE__ */ jsx("span", { className: "text-secondary-500 text-2xs", children: none })
          ] })
        ] }),
        /* @__PURE__ */ jsxs("footer", { className: "flex-shrink-0 flex items-center justify-end gap-x-3 shadow-xs px-5 py-2", children: [
          !isAdd && /* @__PURE__ */ jsx(Button, { variant: "secondary", onClick: handleClose, className: "h-8", children: cancel }),
          isAdd ? /* @__PURE__ */ jsxs(Fragment, { children: [
            !canShowQTestSync && /* @__PURE__ */ jsx(
              Button,
              {
                variant: "primary",
                disabled: isConfirmDisabled,
                onClick: () => onConfirm(selectedNode),
                children: confirm
              }
            ),
            canShowQTestSync && /* @__PURE__ */ jsx(
              DropdownButton,
              {
                fillWidth: false,
                showDropdownOnMoreClick: true,
                name: /* @__PURE__ */ jsx(
                  "div",
                  {
                    onClick: isConfirmDisabled ? void 0 : () => onConfirm(selectedNode),
                    className: isConfirmDisabled ? "!cursor-not-allowed" : "cursor-pointer",
                    children: confirm
                  }
                ),
                className: classNames82(
                  "!text-white h-fit rounded-md p-1",
                  isConfirmDisabled ? "!bg-neutral-300 !cursor-not-allowed" : "!bg-primary-1000 !hover:shadow !hover:shadow-secondary-200"
                ),
                dropdownClassName: classNames82("!w-48 border shadow-2xl"),
                children: !isConfirmDisabled && /* @__PURE__ */ jsx(DropdownItem, { onClick: () => onQTestSync(selectedNode), children: confirmAndSync })
              }
            )
          ] }) : /* @__PURE__ */ jsx(
            Button,
            {
              variant: "primary",
              isDisabled: isConfirmDisabled,
              onClick: () => onConfirm(selectedNode),
              children: confirm
            }
          )
        ] })
      ]
    }
  );
};
var test_case_target_modal_default = TestCaseTargetModal;
var useResultStepMapping = (stepResults, visualResults, resetTreeView) => {
  const [resultStepMappings, setResultStepMappings] = useState(
    []
  );
  const createStepElementRequest2 = (identifier, elementType) => {
    if (!identifier) return void 0;
    const element = new StepElementRequest();
    element.name = identifier;
    element.elementType = elementType;
    return element;
  };
  const getCustomFunctionStepData = (stepDetails) => {
    if (stepDetails?.dataMap?.customStep) {
      return {
        customStep: stepDetails?.dataMap?.customStep
      };
    }
    return {};
  };
  const deserializeStepData = (stepDetails) => {
    const stepItem = new TestStep().deserialize(stepDetails);
    const dataList = Object.keys(stepItem.dataMap?.testData || {}).map(
      (key) => {
        const testData2 = stepItem.dataMap.testData[key];
        testData2.key = key;
        return testData2;
      }
    );
    return { stepDataList: dataList, attribute: stepItem.dataMap?.attribute };
  };
  function forLoopData(stepResult) {
    let forLoopConditions = stepResult?.metadata?.forLoop?.forLoopConditions || {};
    let testDataProfile = {
      id: forLoopConditions?.testDataProfileId,
      value: stepResult?.testDataDetails?.["test-data-profile"]?.testDataValue || stepResult?.metadata?.testStep?.dataMap?.testData?.testDataProfile?.value,
      type: stepResult?.testDataDetails?.["test-data-profile"]?.testDataType || stepResult?.metadata?.testStep?.dataMap?.testData?.testDataProfile?.type
    };
    let leftData = {
      type: stepResult?.testDataDetails?.["left-data"]?.overriddenMappingEntity?.parameterType || forLoopConditions?.leftData?.type || stepResult?.testDataDetails?.["left-data"]?.testDataType || forLoopConditions?.leftParamType,
      value: stepResult?.testDataDetails?.["left-data"]?.overriddenMappingEntity?.parameterValue || forLoopConditions?.leftData?.value || stepResult?.testDataDetails?.["left-data"]?.testDataName || forLoopConditions?.leftParamValue
    };
    let rightData = {
      type: stepResult?.testDataDetails?.["right-data"]?.overriddenMappingEntity?.parameterType || forLoopConditions?.rightData?.type || stepResult?.testDataDetails?.["right-data"]?.testDataType || forLoopConditions?.rightParamType,
      value: stepResult?.testDataDetails?.["right-data"]?.overriddenMappingEntity?.parameterValue || forLoopConditions?.rightData?.value || stepResult?.testDataDetails?.["right-data"]?.testDataName || forLoopConditions?.rightParamValue
    };
    forLoopConditions.leftData = forLoopConditions.leftData || {};
    forLoopConditions.rightData = forLoopConditions.rightData || {};
    if (!forLoopConditions?.testDataProfile) {
      forLoopConditions.testDataProfile = testDataProfile;
    }
    forLoopConditions.leftData.type = leftData?.type;
    forLoopConditions.leftData.value = leftData?.value;
    forLoopConditions.rightData.type = rightData?.type;
    forLoopConditions.rightData.value = rightData?.value;
    if (stepResult?.testDataDetails?.["left-data"]?.hasPassword) {
      forLoopConditions.leftData.value = stepResult?.testDataDetails?.["left-data"]?.testDataValue;
    }
    if (stepResult?.metadata?.forLoop?.forLoopConditions?.leftDataMap?.isEncrypted) {
      forLoopConditions.leftData.value = "********";
    }
    if (stepResult?.metadata?.forLoop?.forLoopConditions?.rightDataMap?.isEncrypted) {
      forLoopConditions.rightData.value = "********";
    }
    return forLoopConditions;
  }
  const getUiIdentifierName = (stepResult, fieldType) => {
    if (Boolean(stepResult?.fieldDefinitionDetails)) {
      return stepResult?.fieldDefinitionDetails?.[fieldType]?.uiIdentifierName;
    } else {
      const dataMap = stepResult?.metadata?.testStep?.dataMap;
      switch (fieldType) {
        case FieldDefinitionDetailsType.FROM_UI_ELEMENT:
          return dataMap?.fromUiIdentifier;
        case FieldDefinitionDetailsType.TO_UI_ELEMENT:
          return dataMap?.toUiIdentifier;
        case FieldDefinitionDetailsType.UI_ELEMENT:
          return dataMap?.uiIdentifier;
      }
    }
  };
  const populateKibbutz = (StepDetailsDataMap4, stepResult) => {
    let kibbutStepDetails = StepDetailsDataMap4?.kibbutzPluginStepDetails;
    if (kibbutStepDetails?.testData && stepResult?.testDataDetails) {
      Object?.keys(kibbutStepDetails?.testData).map((key) => {
        kibbutStepDetails.testData[key].type = stepResult?.testDataDetails?.[key]?.overriddenMappingEntity?.parameterType || stepResult?.testDataDetails?.[key]?.testDataType;
        kibbutStepDetails.testData[key].value = stepResult?.testDataDetails?.[key]?.overriddenMappingEntity?.parameterValue || stepResult?.testDataDetails?.[key]?.testDataName;
      });
    }
    if (kibbutStepDetails?.uiIdentifiers && stepResult?.fieldDefinitionDetails) {
      Object?.keys(kibbutStepDetails?.uiIdentifiers).map((key) => {
        kibbutStepDetails.uiIdentifiers[key].name = stepResult?.fieldDefinitionDetails?.[key]?.uiIdentifierName;
      });
    }
    StepDetailsDataMap4.kibbutzPluginNlpData = kibbutStepDetails;
    StepDetailsDataMap4.kibbutzPluginNlpId = StepDetailsDataMap4?.kibbutzPluginNlpEntity?.id;
    return StepDetailsDataMap4;
  };
  useEffect(() => {
    if (resetTreeView) {
      resetTreeView(stepResults);
    }
    const mappedResults = (stepResults || []).map((stepResult) => {
      const deepCloned = cloneDeep$1(stepResult);
      let stepData = stepResult?.stepDetails || stepResult?.metadata?.testStep;
      const { stepDataList, attribute } = deserializeStepData(stepData);
      const fromElement = createStepElementRequest2(
        getUiIdentifierName(
          stepResult,
          FieldDefinitionDetailsType.FROM_UI_ELEMENT
        ),
        TestStepElementType.FROM_UI_ELEMENT
      );
      const toElement = createStepElementRequest2(
        getUiIdentifierName(
          stepResult,
          FieldDefinitionDetailsType.TO_UI_ELEMENT
        ),
        TestStepElementType.TO_UI_ELEMENT
      );
      const uiElement = createStepElementRequest2(
        getUiIdentifierName(stepResult, FieldDefinitionDetailsType.UI_ELEMENT),
        TestStepElementType.UI_ELEMENT
      );
      if (!stepData.forLoopCondition) {
        stepData.forLoopCondition = forLoopData(stepResult);
      }
      stepResult.stepDetails = {
        ...stepData,
        stepDataList,
        attribute,
        testStepElements: [fromElement, toElement, uiElement].filter(Boolean)
      };
      if (stepResult.stepDetails?.kibbutzPluginNlpEntity?.id) {
        stepResult.stepDetails = populateKibbutz(
          stepResult.stepDetails,
          stepResult
        );
      }
      stepResult.metadata.forLoop = deepCloned?.metadata?.forLoop;
      return {
        step: {
          ...stepResult.stepDetails,
          stepDetail: getCustomFunctionStepData(stepResult.stepDetails),
          stepDataList,
          attribute,
          applicationType: stepResult?.applicationType,
          testStepElements: [fromElement, toElement, uiElement].filter(Boolean)
          // Include only valid elements
        },
        stepResult,
        visualResult: visualResults?.find(
          (res) => res.uuid === stepResult.uuid
        )
      };
    });
    setResultStepMappings(mappedResults);
  }, [stepResults, visualResults, resetTreeView]);
  return {
    resultStepMappings
  };
};
var VisualTestingResultIconV2 = ({
  resultEntity,
  visualResult,
  onClick,
  className = "",
  isVisualTestingEnabled = false,
  testCaseVisualResult
}) => {
  const { t } = useTranslation();
  const canShowVisualResultIcon = useMemo(() => {
    return isVisualTestingEnabled || visualResult && (visualResult?.result === ResultConstant.SUCCESS || visualResult?.result === ResultConstant.FAILURE || visualResult?.result === ResultConstant.RUNNING);
  }, [visualResult, isVisualTestingEnabled]);
  const visualTestResultHint = useMemo(() => {
    if (isVisualTestingEnabled) {
      if (resultEntity.result === ResultConstant.FAILURE) {
        return "visual_test.not_permformed.entity.failed";
      }
      if (resultEntity.result == ResultConstant.NOT_EXECUTED || !resultEntity?.["screenshotName"]) {
        return "visual_test.hint.no_rerun";
      }
    }
    if (canShowVisualResultIcon) {
      if (visualResult?.result == ResultConstant.FAILURE)
        return "visual_test.hint.differences";
      if (visualResult?.result == ResultConstant.SUCCESS)
        return "visual_test.hint.no_differences";
      if ((resultEntity.result == ResultConstant.SUCCESS || resultEntity.result == ResultConstant.RUNNING) && !visualResult?.result && testCaseVisualResult?.[1] === ResultConstant.RUNNING)
        return "visual_test.hint.running";
    }
    if (visualResult?.result == ResultConstant.NOT_EXECUTED || testCaseVisualResult?.[0] === ResultConstant.NOT_EXECUTED || !testCaseVisualResult?.[0]) {
      return `visual_test.hint.base_image_captured`;
    }
    if (visualResult?.result) {
      return `execution.result.${visualResult?.result}`;
    }
    return "";
  }, [
    resultEntity.result,
    resultEntity?.visualTestResult,
    canShowVisualResultIcon,
    isVisualTestingEnabled,
    testCaseVisualResult,
    visualResult
  ]);
  const visualTestResultIconColor = useMemo(() => {
    if (canShowVisualResultIcon) {
      if (resultEntity.result == ResultConstant.FAILURE || visualResult?.result == ResultConstant.FAILURE)
        return `text-error-600`;
      return `text-${getColorPaletteByExecutionStatus(visualResult?.result)}`;
    }
    return "";
  }, [resultEntity?.visualTestResult, canShowVisualResultIcon, visualResult]);
  return /* @__PURE__ */ jsx(Fragment, { children: canShowVisualResultIcon ? /* @__PURE__ */ jsx(
    Icon,
    {
      name: visualTestResultHint == "visual_test.hint.running" || visualTestResultHint == `execution.result.${ResultConstant.RUNNING}` ? "visual-difference-loading" : "photo-camera-outline",
      toolTip: t(visualTestResultHint),
      toolTipPlacement: "top",
      className: classNames82(
        `text-lg ${visualTestResultHint == "visual_test.hint.running" || visualTestResultHint == `execution.result.${ResultConstant.RUNNING}` ? "text-warning-600 !opacity-100 !text-lg" : visualTestResultHint == "visual_test.not_permformed.entity.failed" || visualTestResultHint == "visual_test.hint.differences" ? "text-error-600 !opacity-100 text-lg" : visualTestResultHint == "visual_test.hint.base_image_captured" ? "text-secondary" : visualTestResultHint == "visual_test.hint.no_rerun" ? "text-unique-400" : visualTestResultIconColor} flex items-center`,
        className
      ),
      onClick: () => onClick?.(),
      tootTipClassName: "!z-1000 !max-w-xs break-normal"
    }
  ) : /* @__PURE__ */ jsx(Fragment, {}) });
};

// src/images/atto-analyzer-fixed.svg
var atto_analyzer_fixed_default = 'data:image/svg+xml,<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<mask id="mask0_3307_69075" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">%0A<rect width="16" height="16" fill="%23D9D9D9"/>%0A</mask>%0A<g mask="url(%23mask0_3307_69075)">%0A<path d="M5.43281 14.5001L4.46615 12.8667L2.63281 12.4667C2.46615 12.4334 2.33281 12.3473 2.23281 12.2084C2.13281 12.0695 2.09392 11.9167 2.11615 11.7501L2.29948 9.86675L1.04948 8.43341C0.938368 8.31119 0.882812 8.16674 0.882812 8.00008C0.882812 7.83341 0.938368 7.68897 1.04948 7.56675L2.29948 6.13341L2.11615 4.25008C2.09392 4.08341 2.13281 3.93063 2.23281 3.79175C2.33281 3.65286 2.46615 3.56675 2.63281 3.53341L4.46615 3.13341L5.43281 1.50008C5.5217 1.35563 5.64392 1.25841 5.79948 1.20841C5.95504 1.15841 6.11059 1.16675 6.26615 1.23341L7.99948 1.96675L9.73281 1.23341C9.88837 1.16675 10.0439 1.15841 10.1995 1.20841C10.355 1.25841 10.4773 1.35563 10.5661 1.50008L11.5328 3.13341L13.3661 3.53341C13.5328 3.56675 13.6661 3.65286 13.7661 3.79175C13.8661 3.93063 13.905 4.08341 13.8828 4.25008L13.6995 6.13341L14.9495 7.56675C15.0606 7.68897 15.1161 7.83341 15.1161 8.00008C15.1161 8.16674 15.0606 8.31119 14.9495 8.43341L13.6995 9.86675L13.8828 11.7501C13.905 11.9167 13.8661 12.0695 13.7661 12.2084C13.6661 12.3473 13.5328 12.4334 13.3661 12.4667L11.5328 12.8667L10.5661 14.5001C10.4773 14.6445 10.355 14.7417 10.1995 14.7917C10.0439 14.8417 9.88837 14.8334 9.73281 14.7667L7.99948 14.0334L6.26615 14.7667C6.11059 14.8334 5.95504 14.8417 5.79948 14.7917C5.64392 14.7417 5.5217 14.6445 5.43281 14.5001Z" fill="url(%23paint0_linear_3307_69075)"/>%0A</g>%0A<path d="M10.6846 9.33301C10.1935 10.3198 9.17792 10.9996 8.00098 11C6.82374 11 5.80763 10.3199 5.31641 9.33301C5.42014 9.40351 5.53408 9.46271 5.65625 9.50586C5.84468 9.57234 6.03638 9.63071 6.22852 9.68066C6.67391 10.1499 7.30288 10.4443 8.00098 10.4443C8.6988 10.4441 9.32727 10.1499 9.77246 9.68066C9.96466 9.63067 10.1562 9.57238 10.3447 9.50586C10.4669 9.46264 10.5808 9.4036 10.6846 9.33301ZM8.00098 5C9.21606 5.0004 10.2602 5.72464 10.7314 6.76367C10.5085 6.61512 10.2399 6.53124 9.95508 6.53809C9.50943 5.94335 8.80132 5.55599 8.00098 5.55566C7.19998 5.55566 6.49073 5.94279 6.04492 6.53809C5.76006 6.53129 5.49152 6.61504 5.26855 6.76367C5.7398 5.72407 6.78526 5 8.00098 5Z" fill="white"/>%0A<path d="M10.0283 7.00488C10.5476 6.95058 11 7.3578 11 7.87988C11 8.41333 10.6401 8.87957 10.124 9.01465L9.84961 9.08594C8.63684 9.40299 7.36316 9.40299 6.15039 9.08594L5.87598 9.01465C5.35995 8.87957 5.00001 8.41333 5 7.87988C5 7.3578 5.45243 6.95058 5.97168 7.00488L6.68066 7.0791C7.55783 7.17083 8.44217 7.17083 9.31934 7.0791L10.0283 7.00488ZM6.82617 7.80957H6.7207V8.42188H6.82617V8.56836H7.03906V8.42188H7.14551V8.26953H7.19727V7.96289H7.14551V7.80957H7.03906V7.66602H6.82617V7.80957ZM9.02344 7.66602V7.80957H8.91797V8.42285H9.02344V8.56836H9.23535V8.42285H9.3418V8.26953H9.39551V7.96289H9.3418V7.80957H9.23535V7.66602H9.02344ZM6.66699 8.26953H6.71973V7.96289H6.66699V8.26953ZM8.86426 7.96289V8.26953H8.91699V7.96289H8.86426Z" fill="white"/>%0A<defs>%0A<linearGradient id="paint0_linear_3307_69075" x1="7.84725" y1="-3.5151" x2="24.3775" y2="6.10223" gradientUnits="userSpaceOnUse">%0A<stop stop-color="%23E58086"/>%0A<stop offset="1" stop-color="%235C27F5"/>%0A</linearGradient>%0A</defs>%0A</svg>%0A';
var AnalyzerFixedIcon = ({
  showTooltip = false,
  className = ""
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx(ToolTip, { content: showTooltip ? t("analyzer_fixed.message") : void 0, children: /* @__PURE__ */ jsx("img", { className, src: atto_analyzer_fixed_default, alt: "Analyzer Fixed" }) });
};
var ExecutedStepItemV2 = ({
  step,
  stepResult,
  visualResult,
  isActive = false,
  isAfterTest = false,
  onViewStepResult,
  onShowScreenshot,
  toggleExpandCollapse,
  testcaseVisualResult,
  measure
}) => {
  const itemRef = useRef(null);
  const { t } = useTranslation();
  const [template, setTemplate] = useState(null);
  const [testStep, setTestStep] = useState(null);
  const [showLoader, setShowLoader] = useState(false);
  const [onStepResultRowClicked, setOnStepResultRowClicked] = useState(false);
  const [globalStepsInfo, updateGlobalStepsInfo] = useState({
    activeStepIdx: null,
    selectedSteps: [],
    updateSelectedSteps: null,
    nlpContainerWidth: {},
    isReorderState: false,
    isStepTypeSwitchOpened: true,
    isStepResult: true
  });
  const stepHighlightByStatus = step_result_icon_details_default(stepResult.result);
  const isVisualActionsEnabled = useMemo(
    () => visualResult?.result == ResultConstant.SUCCESS || visualResult?.result == ResultConstant.FAILURE,
    [visualResult]
  );
  const { nlActions, loadStepGroupResults, loadStepRetryResults } = useContext(StepResultContext);
  useEffect(() => {
    if (itemRef?.current && measure) {
      measure();
    }
  }, [measure]);
  const updateStepsInfo = useCallback(
    (key, value) => {
      if (globalStepsInfo[key] != value) {
        const tempGlobalStepInfo = Object.assign({}, globalStepsInfo);
        tempGlobalStepInfo[key] = value;
        updateGlobalStepsInfo(tempGlobalStepInfo);
      }
    },
    [globalStepsInfo]
  );
  const isExpandable = useMemo(
    () => stepResult.resultType === StepResultType.STEP_GROUP || stepResult.resultType === StepResultType.IF_STEP_GROUP || stepResult.resultType === StepResultType.ELSE_IF_STEP_GROUP || stepResult.resultType === StepResultType.STEP_GROUP_ITERATION || stepResult.resultType === StepResultType.FOR_LOOP || stepResult.resultType === StepResultType.WHILE_LOOP || stepResult.resultType === StepResultType.BLOCK || stepResult?.retryCount > 0,
    [stepResult]
  );
  const onStepResultRowClick = useCallback(
    async (row) => {
      if (stepResult?.hasCompleted) {
        setOnStepResultRowClicked(true);
      }
      if (!row?.isAllStepGroup && !row?.hasCompleted) {
        onViewStepResult(row);
        return;
      }
      if (row?.stepDetails?.type == TestStepType.STEP_GROUP && !isStepResultExpandedV2(stepResult)) {
        setShowLoader(true);
        await loadStepGroupResults(stepResult, isAfterTest);
        setShowLoader(false);
      }
      if (row?.retryCount && !isStepResultExpandedV2(stepResult)) {
        await loadStepRetryResults?.(row?.uuid);
      }
      if (isExpandable && toggleExpandCollapse) {
        toggleExpandCollapse(row);
      }
      onViewStepResult(row);
    },
    [step, testStep]
  );
  useEffect(() => {
    const nlpTemplate = nlActions.find((nlpAction) => {
      if (nlpAction.isAddon) {
        return nlpAction.id === step?.kibbutzPluginNlpId;
      } else if (!nlpAction.isAddon) {
        return nlpAction.id === step?.templateId;
      }
    });
    setTemplate(nlpTemplate);
  }, [nlActions, step, stepResult]);
  useEffect(() => {
    if (step) {
      setTestStep(step);
    }
  }, [step]);
  const canRender = useMemo(
    () => testStep && (template || testStep.isPresentationStep || testStep.isStepGroup || testStep.isRestStep || testStep.isBlock || testStep.isKibbutz || testStep.isCustomFunction || testStep.type === "SOQL"),
    [testStep, template]
  );
  const canShowShimmer = step?.action && !isExpandable && !canRender;
  const showActiveHighlight = useMemo(
    () => isActive && !stepResult?.metadata?.stepGroup,
    [stepResult, isActive]
  );
  const iteration = useMemo(() => {
    if (!stepResult?.metadata?.forLoop && !stepResult?.metadata?.stepGroup) {
      return null;
    }
    if (step?.conditionType == TestStepConditionType.LOOP_WHILE) {
      return stepResult?.metadata?.forLoop?.["iteration"];
    } else if (step?.conditionType == TestStepConditionType.LOOP_FOR) {
      return stepResult?.metadata?.forLoop?.["index"] + 1;
    } else if (step?.type === TestStepType.STEP_GROUP) {
      return stepResult?.metadata?.["stepGroup"]?.["iteration"];
    } else {
      return null;
    }
  }, [step, stepResult]);
  const extraPx = useMemo(() => {
    if (isExpandable) {
      if (stepResult?.indent > 9) {
        return 5;
      }
      if (stepResult?.metadata?.["stepGroup"]) {
        return 50 - (stepResult?.indent || 0) * 5.5;
      } else {
        return 75 - (stepResult?.indent || 0) * 5.5;
      }
    } else {
      return 0;
    }
  }, [stepResult, isExpandable]);
  const isFailedLoopStep = useMemo(
    () => stepResult?.metadata?.forLoop?.["testdata"] && !stepResult?.metadata?.forLoop?.["isLoopTitle"] && stepResult.result === ResultConstant.FAILURE,
    [stepResult]
  );
  const stepRunDuration = useMemo(() => {
    return stepResult.result === ResultConstant.NOT_EXECUTED ? 0 : stepResult.duration;
  }, [stepResult]);
  function onClick() {
    measure?.();
    onStepResultRowClick(stepResult);
  }
  useUIMap(testStep, step, setTestStep, false, nlActions);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      role: "row",
      className: classNames82(
        `flex flex-row items-center ${stepHighlightByStatus?.hoverBgColor} gap-x-3 pr-5 pl-8 !py-1.5 group cursor-pointer min-h-[36px] ${showActiveHighlight ? `${stepHighlightByStatus?.bgColor}` : "bg-white"}`
      ),
      onClick: () => onClick(),
      onMouseOver: () => measure?.(),
      ref: itemRef,
      children: [
        /* @__PURE__ */ jsx(
          "span",
          {
            className: "flex items-center justify-center text-base pl-1 !h-4 !w-4",
            role: "gridcell",
            children: stepHighlightByStatus?.icon
          }
        ),
        stepResult.indent > 0 && /* @__PURE__ */ jsx(
          IndentResult,
          {
            size: stepResult?.indent,
            showLine: !stepResult.isLoopTitle && !stepResult.isStepGroupTitle && !stepResult?.isBlock && false,
            stepResult
          }
        ),
        isExpandable ? /* @__PURE__ */ jsx(
          StepResultParentIndicator,
          {
            stepResult,
            step: testStep,
            showLoader,
            onStepResultRowClicked
          }
        ) : null,
        /* @__PURE__ */ jsx(
          StepNumber,
          {
            number: stepResult.stepNumber,
            className: "!h-fit text-center !min-w-[18px] leading-3 !px-0.5"
          }
        ),
        /* @__PURE__ */ jsxs(
          "div",
          {
            role: "gridcell",
            className: classNames82("flex gap-x-1 items-center"),
            style: canShowShimmer ? { width: `100%` } : extraPx ? { maxWidth: `${extraPx}%` } : {},
            children: [
              (isPresentationStep(testStep) || isConditionalElseIf(testStep) || isConditionalIf(testStep)) && /* @__PURE__ */ jsx("span", { className: "pl-1 flex", children: /* @__PURE__ */ jsx(step_type_indicator_text_component_default, { step: testStep, isResultBlock: true }) }),
              (testStep?.isKibbutz || testStep?.isCustomFunction) && /* @__PURE__ */ jsx(Icon, { name: "addons", className: "flex items-center" }),
              canRender && (!stepResult?.isLoopTitleV2 || !(stepResult?.metadata?.forLoop?.forLoopConditions || stepResult?.metadata?.forLoop?.iteration)) && /* @__PURE__ */ jsx(
                StepItemWrapper,
                {
                  step: testStep,
                  isResultBlock: true,
                  isViewOnly: true,
                  template,
                  stepsInfo: globalStepsInfo,
                  stepResult,
                  updateStepsInfo,
                  isStepResult: true
                }
              ),
              canShowShimmer && /* @__PURE__ */ jsx("div", { className: "w-1/2 animate-shimmer-result h-5 rounded-md" })
            ]
          }
        ),
        stepResult?.metadata?.["stepGroup"] && /* @__PURE__ */ jsxs(
          "div",
          {
            className: "flex gap-x-3 text-small leading-4 text-unique-800 pl-2 max-h-[20px] items-center",
            role: "gridcell",
            children: [
              /* @__PURE__ */ jsx("span", { className: "px-3 py-0.5 border rounded-full bg-secondary-50 border-secondary-200 flex items-center", children: /* @__PURE__ */ jsx(
                TruncatedText,
                {
                  className: "inline-block !text-xs !text-unique-800",
                  value: `SET NAME : ${stepResult?.metadata?.["stepGroup"]?.["setName"]}`
                }
              ) }),
              /* @__PURE__ */ jsx("span", { className: "px-3 py-0.5 border rounded-full bg-secondary-50 border-secondary-200 w-1/2 flex items-center", children: /* @__PURE__ */ jsx(
                TruncatedText,
                {
                  className: "inline-block !text-xs !text-unique-800",
                  value: `ETF : ${stepResult?.metadata?.["stepGroup"]?.["etf"] ? t("common.yes") : t("common.no")}`
                }
              ) })
            ]
          }
        ),
        stepResult?.isLoopTitleV2 ? /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            "div",
            {
              className: "flex gap-x-3  text-small leading-4 text-unique-800 pl-0.5",
              role: "gridcell",
              children: /* @__PURE__ */ jsx("span", { className: "py-0.5", children: "Iteration" })
            }
          ),
          Boolean(iteration) && /* @__PURE__ */ jsx(
            "div",
            {
              className: "flex shrink-0 items-center justify-end text-secondary-600",
              role: "gridcell",
              children: /* @__PURE__ */ jsxs("span", { className: "text-2xs leading-3", children: [
                "#",
                iteration
              ] })
            }
          ),
          /* @__PURE__ */ jsx(
            "div",
            {
              className: "flex gap-x-3  text-small leading-4 text-unique-800 pl-0.5",
              role: "gridcell",
              children: /* @__PURE__ */ jsx("span", { children: `(Set : ${stepResult?.metadata?.["forLoop"]?.["iteration"] || 1})` })
            }
          )
        ] }) : isFailedLoopStep ? /* @__PURE__ */ jsx(
          "div",
          {
            className: "flex gap-x-3  text-small leading-4 text-unique-800 pl-0.5",
            role: "gridcell",
            children: /* @__PURE__ */ jsx("span", { className: "py-0.5", children: "Iteration not executed" })
          }
        ) : null,
        /* @__PURE__ */ jsx("span", { className: "flex-grow" }),
        /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-x-3 shrink-0", role: "gridcell", children: [
          stepResult?.conditionalResult && step?.conditionType && /* @__PURE__ */ jsx(
            "span",
            {
              className: `${getColorsByStatus(stepResult.conditionalResult)?.textColor} items-center justify-center group-hover:hidden text-2xs font-normal`,
              children: t(`conditional-result.${stepResult.conditionalResult}`)
            }
          ),
          stepResult?.retryCount > 0 && /* @__PURE__ */ jsx(ToolTip, { content: `Retried ${stepResult?.retryCount} times`, children: /* @__PURE__ */ jsxs(
            "div",
            {
              className: classNames82(
                `flex items-center justify-center !px-2 gap-x-1 text-xs rounded group-hover:hidden`,
                getColorsByStatus(ResultConstant.FAILURE)?.bgColor,
                getColorsByStatus(ResultConstant.FAILURE)?.textColor
              ),
              children: [
                /* @__PURE__ */ jsx(Icon, { name: "redo", className: "" }),
                /* @__PURE__ */ jsx("span", { className: "", children: stepResult?.retryCount })
              ]
            }
          ) }),
          step.ignoreStepResult && !step.conditionType && /* @__PURE__ */ jsx("span", { className: "items-center justify-center !text-2xs font-normal group-hover:hidden text-secondary-400", children: "Step Result Ignored" }),
          step?.disabled && /* @__PURE__ */ jsx(Label, { className: "items-center justify-center !px-2 group-hover:hidden", children: "Disabled" }),
          /* @__PURE__ */ jsxs(
            "div",
            {
              role: "gridcell",
              className: classNames82(
                "hidden group-hover:flex items-center gap-x-1 px-2.5 rounded",
                stepResult?.metadata?.testStep?.visualEnabled ? "right-9" : "right-2"
              ),
              children: [
                /* @__PURE__ */ jsx(
                  Icon,
                  {
                    name: "hourglass-top",
                    className: "text-xs text-unique-800 flex items-center"
                  }
                ),
                /* @__PURE__ */ jsx("span", { className: "text-unique-600 text-xs", children: /* @__PURE__ */ jsx(
                  DurationFormat,
                  {
                    milliseconds: stepRunDuration,
                    format: "hh:mm:ss.SSS",
                    showTooltip: false
                  }
                ) })
              ]
            }
          ),
          (stepResult?.selfHealMetadata || stepResult?.autoHealMetadata) && /* @__PURE__ */ jsx(
            AutoHealIcon,
            {
              result: stepResult?.autoHealMetadata?.status || (stepResult?.result === ResultConstant.SUCCESS ? AutoHealStatus.SUCCESS : AutoHealStatus.FAILURE),
              showTooltip: true
            }
          ),
          stepResult?.isAnalyzerFixed && /* @__PURE__ */ jsx(AnalyzerFixedIcon, { showTooltip: true }),
          !(stepResult?.isBlock || stepResult?.stepDetail?.isBlock || stepResult?.isLoopHeader) && /* @__PURE__ */ jsx(
            VisualTestingResultIconV2,
            {
              resultEntity: stepResult,
              visualResult,
              onClick: () => {
                isVisualActionsEnabled && !(stepResult.result == ResultConstant.FAILURE) && onShowScreenshot("visual_diff", stepResult);
              },
              className: classNames82(
                !isVisualActionsEnabled ? "opacity-30" : "",
                " text-xs"
              ),
              isVisualTestingEnabled: stepResult?.metadata?.testStep?.visualEnabled,
              testCaseVisualResult: testcaseVisualResult
            }
          )
        ] })
      ]
    },
    `Step-${step.id}-${stepResult?.uuid || step.id}`
  );
};
var StepLimitInfo = ({ testCaseResult }) => {
  return /* @__PURE__ */ jsxs("div", { className: "text-center flex flex-col text-sm text-secondary-unique-800 py-8", children: [
    /* @__PURE__ */ jsx("div", { className: "mx-auto", children: /* @__PURE__ */ jsx(
      Icon,
      {
        name: "loader-large",
        className: "animate-spin text-[84px] text-[#2ABB7F] flex items-center"
      }
    ) }),
    /* @__PURE__ */ jsx("span", { className: "mt-1", children: testCaseResult?.isExecuting ? "Execution in progress..." : "Waiting for completed results..." }),
    /* @__PURE__ */ jsx("div", { className: "mt-8", children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col text-center gap-y-1", children: [
      /* @__PURE__ */ jsx("span", { children: "This view is limited to the first 100 results until all step results are available." }),
      /* @__PURE__ */ jsx("span", { children: "Please wait while the results are being loaded." })
    ] }) })
  ] });
};
var StepResultListItem = ({
  type,
  resultStep,
  testCaseResult,
  stepResultOnViewStepResult,
  stepResultOnShowScreenshot,
  stepResultToggleStep,
  stepResultMeasure,
  stepResultActiveStepResult,
  stepResultIsAfterTest
}) => {
  const renderItem = useCallback(() => {
    switch (type) {
      case "step-result":
        return /* @__PURE__ */ jsx(Fragment, { children: resultStep.stepResult.show ? /* @__PURE__ */ jsx(
          ExecutedStepItemV2,
          {
            step: resultStep.step,
            stepResult: resultStep.stepResult,
            visualResult: resultStep.visualResult,
            testcaseVisualResult: [
              testCaseResult?.visualTestResult,
              testCaseResult?.result
            ],
            onViewStepResult: stepResultOnViewStepResult,
            onShowScreenshot: stepResultOnShowScreenshot,
            isActive: resultStep?.stepResult?.uuid == stepResultActiveStepResult?.uuid,
            toggleExpandCollapse: stepResultToggleStep,
            isAfterTest: stepResultIsAfterTest,
            measure: stepResultMeasure
          }
        ) : /* @__PURE__ */ jsx(Fragment, {}) });
      case "empty":
        return /* @__PURE__ */ jsx("div", { className: "h-8", role: "row", children: /* @__PURE__ */ jsx("span", { role: "gridcell" }) });
      case "info":
        return /* @__PURE__ */ jsx(StepLimitInfo, { testCaseResult });
      case "fetching-next-page":
        return /* @__PURE__ */ jsx("div", { className: "flex w-full h-8 items-center justify-center", role: "row", children: /* @__PURE__ */ jsx("div", { className: "empty-page-loader", role: "gridcell" }) });
      default:
        return /* @__PURE__ */ jsx(Fragment, {});
    }
  }, [
    resultStep,
    stepResultActiveStepResult?.uuid,
    stepResultIsAfterTest,
    stepResultMeasure,
    stepResultOnShowScreenshot,
    stepResultOnViewStepResult,
    stepResultToggleStep,
    testCaseResult,
    type
  ]);
  const item = useMemo(() => renderItem(), [renderItem]);
  return /* @__PURE__ */ jsx(Fragment, { children: item });
};
var { VirtualizedInfiniteLoader: VirtualizedInfiniteLoader6 } = InfiniteScrollV2;
function ScrollableContainerV2(props) {
  const {
    resultSteps,
    onViewStepResult,
    onShowScreenshot,
    activeStepResult,
    testCaseResult,
    hasNextPage,
    fetchNextPageResults,
    hasAfterTest,
    isAfterTest,
    containerHeight,
    toggleStep,
    isLoading,
    isFetchingNextPage
  } = props;
  const [items, setItems] = useState([]);
  const loadNextPage = useCallback((pageno) => {
    if (hasNextPage) fetchNextPageResults(pageno, isAfterTest);
  }, [hasNextPage, fetchNextPageResults, isAfterTest]);
  const updateItems = useCallback(
    (resultStepItems) => {
      const newItems = resultStepItems?.map((res) => {
        return { type: "step-result", resultStep: res };
      }) || [];
      if (!testCaseResult?.isExecutionFullyCompleted && newItems.length === 100) {
        newItems.push({ type: "info" });
      }
      if (testCaseResult?.isExecutionFullyCompleted) {
        const emptyRows = Array.from({ length: 2 }, () => ({ type: "empty" }));
        if (testCaseResult?.isExecutionFullyCompleted && newItems.length > 0 && isLoading && isFetchingNextPage) {
          emptyRows.push({ type: "fetching-next-page" });
        }
        emptyRows.push(...Array.from({ length: 3 }, () => ({ type: "empty" })));
        newItems.push(...emptyRows);
      }
      setItems(newItems);
    },
    [testCaseResult, isLoading, isFetchingNextPage]
  );
  const toggleExpandCollapse = (stepResult) => {
    if (!stepResult?.childResults?.length) return;
    const isExpanded = isStepResultExpandedV2(stepResult);
    if (isExpanded) {
      toggleStep(stepResult, false);
    } else {
      toggleStep(stepResult, true);
    }
    const filtered = resultSteps.filter((item) => item.stepResult.show);
    updateItems(filtered);
  };
  useEffect(() => {
    const filtered = testCaseResult?.isExecutionFullyCompleted ? resultSteps.filter((item) => item.stepResult.show) : resultSteps;
    updateItems(filtered);
  }, [resultSteps, testCaseResult, updateItems]);
  const rowRenderer = useCallback((index, { measure }) => {
    const item = items?.[index];
    return /* @__PURE__ */ jsx(
      StepResultListItem,
      {
        type: item.type,
        testCaseResult,
        resultStep: item.resultStep,
        stepResultOnViewStepResult: onViewStepResult,
        stepResultOnShowScreenshot: onShowScreenshot,
        stepResultActiveStepResult: activeStepResult,
        stepResultToggleStep: toggleExpandCollapse,
        stepResultIsAfterTest: isAfterTest,
        stepResultMeasure: measure
      },
      `${item.type}-${item.resultStep?.stepResult?.uuid || index}`
    );
  }, [
    items,
    testCaseResult,
    onViewStepResult,
    onShowScreenshot,
    activeStepResult,
    toggleExpandCollapse,
    isAfterTest
  ]);
  return /* @__PURE__ */ jsx(Fragment, { children: testCaseResult?.isExecutionFullyCompleted ? /* @__PURE__ */ jsx(
    VirtualizedInfiniteLoader6,
    {
      minHeight: 36,
      className: classNames82({
        "!h-[calc(100%_-_105px)]": hasAfterTest
      }),
      isDynamicHeightList: true,
      disableHeight: true,
      loadMore: loadNextPage,
      rowCount: items?.length,
      rowRenderer,
      hasMore: hasNextPage,
      listHeight: hasAfterTest ? containerHeight - 105 : containerHeight,
      items,
      overscanRowCount: 0,
      totalPages: testCaseResult?.pages?.length,
      isLoading
    }
  ) : /* @__PURE__ */ jsx(
    "div",
    {
      role: "grid",
      style: {
        height: hasAfterTest ? `${containerHeight - 105}px` : `${containerHeight - 5}px`,
        overflow: "auto"
      },
      children: items.map((item, idx) => /* @__PURE__ */ jsx(
        StepResultListItem,
        {
          type: item.type,
          resultStep: item.resultStep,
          testCaseResult,
          stepResultOnViewStepResult: onViewStepResult,
          stepResultOnShowScreenshot: onShowScreenshot,
          stepResultActiveStepResult: activeStepResult,
          stepResultToggleStep: toggleExpandCollapse,
          stepResultIsAfterTest: isAfterTest
        },
        `${item.type}-${item.resultStep?.stepResult?.uuid || idx}`
      ))
    }
  ) });
}
var scrollable_container_v2_default = ScrollableContainerV2;
var ExecutionErrorMessage = ({
  testCaseResult
}) => {
  const { t } = useTranslation();
  const message = testCaseResult?.message?.trim?.();
  useMemo(
    () => message?.toLowerCase?.()?.includes?.("unexpected error occurred") || message?.includes?.("Unable to create a new"),
    [message]
  );
  const upgradePlanErrorMessage = useMemo(() => {
    if (message === "Your Current Plan Reached Max Allowed Queue Size. Please upgrade for higher limits.") {
      return t("run_result.reached_allowed_queue");
    } else if (message === "You are currently using all of your available parallel test runs on Testsigma Lab Devices. Please upgrade your plan to execute more tests simultaneously." || message === "You are currently using all of your available parallel test runs on Local Devices. Please upgrade your plan to execute more tests simultaneously.") {
      return t("run_result.reached_allowed_parallel", {
        testLap: message?.includes("Testsigma Lab Devices") ? "Testsigma Lab" : "Local"
      });
    } else if (message?.includes("test minutes on Local Devices") || message?.includes("test minutes on Testsigma Lab Devices")) {
      return message?.replace("", t("run_result.reached_time"));
    }
  }, [message]);
  const unknownError = useMemo(
    () => message?.length > 1e3 ? `${message?.substring?.(0, 1e3)}...` : message,
    [message]
  );
  return /* @__PURE__ */ jsx(
    Empty,
    {
      className: "w-full",
      description: /* @__PURE__ */ jsx(
        "div",
        {
          className: "max-w-7/10 mx-auto break-words",
          dangerouslySetInnerHTML: {
            __html: upgradePlanErrorMessage ? upgradePlanErrorMessage : unknownError
          }
        }
      ),
      imageSource: noDataPane
    }
  );
};
var ExecutedStepsHeaderV2 = ({
  type,
  count,
  expanded,
  toggleExpand,
  status
}) => {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames82(
        "h-9 flex flex-row items-center gap-x-3 pr-[30px] pl-9 group cursor-pointer border-y-[0.5px]",
        "text-small leading-5 font-semibold relative",
        "text-unique-600 bg-secondary-50 border-gray-200"
      ),
      onClick: () => {
        if (!expanded) {
          toggleExpand(type);
        } else {
          toggleExpand("");
        }
      },
      children: [
        /* @__PURE__ */ jsx(
          Icon,
          {
            name: expanded ? "angle-bottom-large" : "angle-right-large",
            className: "text-base"
          }
        ),
        /* @__PURE__ */ jsx(
          Icon,
          {
            name: type === "main" ? "list-bullet" : "wrap-text",
            className: "text-lg"
          }
        ),
        /* @__PURE__ */ jsx("span", { children: type === "main" ? "Test Steps" : "AfterTest Steps" }),
        /* @__PURE__ */ jsx(
          ExecutionResultChip,
          {
            result: ResultConstant[status],
            className: " absolute right-5"
          }
        )
      ]
    }
  );
};
var useStepResultTree = () => {
  const expandedParents = useRef(/* @__PURE__ */ new Set());
  const isParent2 = useCallback((result) => {
    return result.isExpandable || result.isAllConditionalStep || result.isLoopHeader;
  }, []);
  const expand = useCallback(
    (stepResult) => {
      if (!stepResult || !stepResult.childResults?.length) return;
      stepResult.childResults.forEach((res) => res.show = true);
      expandedParents.current.add(stepResult.uuid);
      stepResult.childResults.filter((res) => res.isLoopHeader).forEach((res) => expand(res));
      stepResult.childResults.filter((res) => res.resultType === StepResultType.CONDITION_IF).forEach((res) => {
        expand(res);
      });
      const lastChildResult = stepResult.childResults[stepResult.childResults.length - 1];
      if (lastChildResult.resultType === StepResultType.CONDITION_ELSE_IF || lastChildResult.resultType === StepResultType.CONDITION_ELSE) {
        expand(lastChildResult);
      }
    },
    [expandedParents]
  );
  const collapse = useCallback(
    (stepResult) => {
      stepResult.childResults?.forEach((res) => {
        if (res.isConditionalStepGroupResult) return;
        res.show = false;
        collapse(res);
      });
      expandedParents.current.delete(stepResult.uuid);
    },
    [expandedParents]
  );
  const resetStepResultsTree = useCallback(
    (_stepResults) => {
      const expandableResults = [];
      _stepResults.forEach((result) => {
        if (isParent2(result)) {
          expandableResults.push(result);
        }
        const expandableParent = expandableResults.find(
          (res) => res.uuid == result.parentResultUuid
        );
        if (expandableParent) {
          result.expandParentResultUuid = result.parentResultUuid;
          const childResults = expandableParent?.childResults || [];
          childResults.push(result);
          expandableParent.childResults = childResults;
        }
      });
      _stepResults.forEach((res) => {
        if (expandedParents.current.has(res.uuid)) {
          expand(res);
        }
      });
    },
    [expand, isParent2]
  );
  return {
    expand,
    collapse,
    resetStepResultsTree
  };
};
var ExecutedStepsV2 = ({
  onViewStepResult,
  onShowScreenshot,
  activeStepResult,
  dataDrivenResult,
  hasNextPage,
  fetchNextPageResults,
  dataDrivenParentResult,
  executionHasError,
  isLoading,
  isFetchingNextPage
}) => {
  const [expandedHeader, setExpandedHeader] = useState("main");
  const {
    mainStepResults,
    afterStepResults,
    testCaseResult,
    stepResultsCount,
    afterTestStepResultsCount,
    visualResults
  } = useContext(StepResultContext);
  const resultContainerRef = useRef(null);
  const containerHeight = resultContainerRef?.current?.clientHeight;
  const afterTestResult = useMemo(
    () => testCaseResult?.afterTestResult || dataDrivenResult?.iterationResult?.lastReRunResult?.afterTestResult || dataDrivenResult?.iterationResult?.afterTestResult || dataDrivenParentResult?.afterTestResult,
    [testCaseResult, dataDrivenParentResult, dataDrivenResult]
  );
  const hasAfterTest = Boolean(afterTestResult);
  const canShowHeader = hasAfterTest;
  const { resetStepResultsTree, expand, collapse } = useStepResultTree();
  const { resultStepMappings: mainResultStepMappings } = useResultStepMapping(
    mainStepResults,
    visualResults || [],
    resetStepResultsTree
  );
  const { resultStepMappings: afterResultStepMappings } = useResultStepMapping(
    afterStepResults,
    visualResults || [],
    resetStepResultsTree
  );
  const canShowMainStepResults = useMemo(
    () => (!hasAfterTest || hasAfterTest && expandedHeader === "main") && mainResultStepMappings?.length > 0,
    [expandedHeader, hasAfterTest, mainResultStepMappings]
  );
  const canShowAfterStepResults = useMemo(
    () => (!hasAfterTest || hasAfterTest && expandedHeader === "after") && afterResultStepMappings?.length > 0,
    [afterResultStepMappings, expandedHeader, hasAfterTest]
  );
  const toggleStep = (stepResult, toggle) => {
    if (toggle) {
      expand(stepResult);
    } else {
      collapse(stepResult);
    }
  };
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", { className: "h-full relative", ref: resultContainerRef, children: [
    executionHasError && /* @__PURE__ */ jsx(ExecutionErrorMessage, { testCaseResult }),
    canShowHeader && /* @__PURE__ */ jsx(
      ExecutedStepsHeaderV2,
      {
        type: "main",
        count: stepResultsCount,
        expanded: expandedHeader === "main",
        toggleExpand: setExpandedHeader,
        status: afterTestResult?.result === ResultConstant.FAILURE ? testCaseResult?.hostResult ? testCaseResult?.hostResult : testCaseResult?.result === ResultConstant.FAILURE ? ResultConstant.FAILURE : ResultConstant.SUCCESS : testCaseResult?.result
      }
    ),
    canShowMainStepResults && /* @__PURE__ */ jsx(
      scrollable_container_v2_default,
      {
        resultSteps: mainResultStepMappings,
        onViewStepResult,
        onShowScreenshot,
        activeStepResult,
        testCaseResult,
        hasNextPage: hasNextPage.hasNextPage,
        fetchNextPageResults,
        hasAfterTest,
        isAfterTest: false,
        containerHeight,
        toggleStep,
        isLoading,
        isFetchingNextPage
      }
    ),
    !canShowMainStepResults && canShowHeader && expandedHeader === "main" && /* @__PURE__ */ jsx("div", { className: "flex w-full h-full items-center justify-center", children: /* @__PURE__ */ jsx("div", { className: "empty-page-loader" }) }),
    canShowHeader && /* @__PURE__ */ jsx(
      ExecutedStepsHeaderV2,
      {
        type: "after",
        count: afterTestStepResultsCount,
        expanded: expandedHeader === "after",
        toggleExpand: setExpandedHeader,
        status: afterTestResult?.result
      }
    ),
    canShowAfterStepResults && /* @__PURE__ */ jsx(
      scrollable_container_v2_default,
      {
        resultSteps: afterResultStepMappings,
        onViewStepResult,
        onShowScreenshot,
        activeStepResult,
        testCaseResult,
        hasNextPage: hasNextPage.hasAfterNextPage,
        fetchNextPageResults,
        hasAfterTest,
        isAfterTest: true,
        containerHeight,
        toggleStep,
        isLoading,
        isFetchingNextPage
      }
    ),
    !canShowAfterStepResults && canShowHeader && expandedHeader === "after" && /* @__PURE__ */ jsx("div", { className: "flex w-full h-full items-center justify-center", children: /* @__PURE__ */ jsx("div", { className: "empty-page-loader" }) })
  ] }) });
};
var TestExecutionContainerV2 = ({
  nlActions,
  onViewStepResult,
  onShowScreenshot,
  mainStepResults,
  afterStepResults,
  visualResults,
  loadStepGroupResults,
  loadStepRetryResults,
  testCaseResult,
  dataDrivenResult,
  stepResultsCount,
  afterTestStepResultsCount,
  activeStepResult,
  stepWrapperRef,
  initialStepResultsFetched,
  hasNextPage,
  fetchNextPageResults,
  hasFeatureValue: hasFeatureValue2,
  dataDrivenParentResult,
  executionHasError,
  isLoading,
  isFetchingNextPage
}) => {
  const contextValue = useMemo(() => ({
    nlActions,
    stepResults: [],
    mainStepResults,
    afterStepResults,
    visualResults,
    loadStepGroupResults,
    loadStepRetryResults,
    testCaseResult,
    stepResultsCount,
    afterTestStepResultsCount,
    initialStepResultsFetched,
    hasFeatureValue: hasFeatureValue2
  }), [
    nlActions,
    mainStepResults,
    afterStepResults,
    visualResults,
    loadStepGroupResults,
    loadStepRetryResults,
    testCaseResult,
    stepResultsCount,
    afterTestStepResultsCount,
    initialStepResultsFetched,
    hasFeatureValue2
  ]);
  return /* @__PURE__ */ jsx("div", { className: "h-full bg-white pt-1 rounded-tr-[5px] border-0.5 border-secondary-200", children: /* @__PURE__ */ jsx(StepResultContext.Provider, { value: contextValue, children: /* @__PURE__ */ jsx("div", { className: "h-full relative", ref: stepWrapperRef, children: /* @__PURE__ */ jsx(
    ExecutedStepsV2,
    {
      onViewStepResult,
      onShowScreenshot,
      activeStepResult,
      dataDrivenResult,
      hasNextPage,
      fetchNextPageResults,
      dataDrivenParentResult,
      executionHasError,
      isLoading,
      isFetchingNextPage
    }
  ) }) }) });
};
var TestExecutionResultContainerV2 = ({
  step,
  stepsInfo,
  template,
  updateStepsInfo,
  nlActions,
  hasFeatureValue: hasFeatureValue2,
  stepWrapperRef,
  ignoreBorderAndBackground = false
}) => /* @__PURE__ */ jsx(
  "div",
  {
    className: classNames82("h-full", {
      "bg-white rounded-tr-[5px] border-0.5 border-secondary-200": !ignoreBorderAndBackground
    }),
    ref: stepWrapperRef,
    children: /* @__PURE__ */ jsx(
      StepResultContext.Provider,
      {
        value: {
          ..._defaultData,
          nlActions,
          hasFeatureValue: hasFeatureValue2
        },
        children: /* @__PURE__ */ jsx("div", { className: "h-full relative", children: /* @__PURE__ */ jsx(
          StepItemWrapper,
          {
            step,
            isResultBlock: true,
            isViewOnly: true,
            stepsInfo,
            template,
            isStepResult: true,
            updateStepsInfo
          }
        ) })
      }
    )
  }
);
function CopilotStep({
  templates,
  step,
  isSelected,
  isAdded,
  addedStepPosition,
  index,
  selectStepByIndex
}) {
  const [globalStepsInfo, updateGlobalStepsInfo] = useState({
    activeStepIdx: null,
    selectedSteps: [],
    updateSelectedSteps: null,
    nlpContainerWidth: {},
    isReorderState: false,
    isStepTypeSwitchOpened: true,
    isStepResult: true
  });
  const [template, setTemplate] = useState();
  useEffect(() => {
    const nlpTemplate = templates?.find(
      (nlpAction) => nlpAction.id === step?.templateId
    );
    setTemplate(nlpTemplate);
  }, [templates, step]);
  const stepWithAction = useMemo(() => {
    if (!step) return step;
    const uiIdentifier = step.uiIdentifier ?? step.testStepElements?.[0]?.name;
    const testData2 = step.testData ?? step.test_data ?? step.stepDataList?.find(
      (d) => d.key === "test data" || d.key === "testData"
    )?.value;
    const elementName2 = step.elementRequest?.name || uiIdentifier;
    const interpolateAction = (action) => {
      let result = action;
      if (testData2 !== void 0 && testData2 !== null) {
        const testDataStr = String(testData2);
        result = result.replace(/test data/gi, () => testDataStr);
        result = result.replace(/\$\{testData\}/g, () => testDataStr);
        result = result.replace(/\$\{test-data\}/g, () => testDataStr);
        result = result.replace(/\$\{test_data\}/g, () => testDataStr);
      }
      if (elementName2) {
        result = result.replace(/#\{ui-identifier\}/g, () => elementName2);
        result = result.replace(/#\{from-ui-identifier\}/g, () => elementName2);
        result = result.replace(/#\{to-ui-identifier\}/g, () => elementName2);
        result = result.replace(/#\{uiIdentifier\}/g, () => elementName2);
        result = result.replace(/\$\{element\}/g, () => elementName2);
        result = result.replace(/\$\{uiIdentifier\}/g, () => elementName2);
        result = result.replace(/\$\{ui-identifier\}/g, () => elementName2);
        result = result.replace(/\$\{ui_identifier\}/g, () => elementName2);
        const hadStructuredElementPlaceholder = /#\{ui-identifier\}|#\{from-ui-identifier\}|#\{to-ui-identifier\}|#\{uiIdentifier\}|\$\{element\}|\$\{uiIdentifier\}|\$\{ui-identifier\}|\$\{ui_identifier\}/.test(
          action
        );
        if (!hadStructuredElementPlaceholder) {
          result = result.replace(/\belement\b/gi, () => elementName2);
        } else {
          result = result.replace(/^\s*element\s+/i, "");
          result = result.replace(/\s+an\s+element\s+/gi, " ");
          result = result.replace(/\s+a\s+element\s+/gi, " ");
          result = result.replace(/\s+the\s+element\s+/gi, " the ");
          result = result.replace(/\s+element\s+(?!in\s)/gi, " ");
          result = result.replace(
            /\s+element\s*([.,;:!?]|\s*$)/gi,
            (_, p1) => p1 || " "
          );
        }
      }
      result = result.replace(
        /#\{(?:ui-identifier|from-ui-identifier|to-ui-identifier|uiIdentifier)\}/g,
        "element"
      );
      result = result.replace(
        /\$\{(?:element|uiIdentifier|ui-identifier|ui_identifier)\}/g,
        "element"
      );
      return result;
    };
    if (step.action) {
      const action = interpolateAction(step.action);
      return { ...step, action };
    }
    if (template?.grammar) {
      const action = interpolateAction(template.grammar);
      return { ...step, action };
    }
    let fallbackAction = "";
    if (uiIdentifier) {
      fallbackAction = `Click on ${uiIdentifier}`;
    } else if (testData2 !== void 0 && testData2 !== null) {
      fallbackAction = `Wait for ${testData2} seconds`;
    } else {
      fallbackAction = `Step ${(index || 0) + 1}`;
    }
    return { ...step, action: fallbackAction };
  }, [step, template, index]);
  const stepIndicator = isAdded ? /* @__PURE__ */ jsx("div", { className: "flex items-center justify-center min-w-5 mt-1 text-xs font-medium text-slate-600 shrink-0 leading-relaxed", children: addedStepPosition ?? (index != null ? index + 1 : "\u2014") }) : /* @__PURE__ */ jsx(
    Checkbox,
    {
      onChange: () => selectStepByIndex?.(index),
      type: "primary",
      size: "small",
      className: "!py-1",
      checked: isSelected,
      ariaLabel: `Select step ${index + 1}`
    }
  );
  const getFallbackDescription = () => {
    const uiIdentifier = step?.uiIdentifier ?? step?.testStepElements?.[0]?.name;
    const testData2 = step?.testData ?? step?.test_data ?? step?.stepDataList?.find(
      (d) => d.key === "test data" || d.key === "testData"
    )?.value;
    const templateId = step?.templateId;
    const templatePatterns = {
      27: "Wait for test data seconds",
      35: "Verify that the current page displays text test data",
      36: "Verify that element is displayed",
      109: "Click on element",
      559: "Verify that current URL contains test data",
      560: "Verify that the page title is test data",
      971: "Enter test data in element field",
      1008: "Press element key",
      1079: "Verify that element is test data",
      1083: "Navigate test data",
      1130: "Click on element with text test data"
    };
    if (templateId && templatePatterns[templateId]) {
      return templatePatterns[templateId];
    }
    if (uiIdentifier && testData2 !== void 0 && testData2 !== null) {
      return `${uiIdentifier}: test data`;
    } else if (uiIdentifier) {
      return `Click on element`;
    } else if (testData2 !== void 0 && testData2 !== null) {
      return `Wait for test data seconds`;
    }
    return `Step ${(index || 0) + 1}`;
  };
  const renderStyledAction = () => {
    const uiIdentifier = step.uiIdentifier ?? step.testStepElements?.[0]?.name;
    const testData2 = step.testData ?? step.test_data ?? step.stepDataList?.find(
      (d) => d.key === "test data" || d.key === "testData"
    )?.value;
    const elementName2 = step.elementRequest?.name || uiIdentifier;
    const rawActionText = template?.grammar || step.action || getFallbackDescription();
    const testDataStyle = "text-unique-500 font-medium";
    const elementStyle = "text-primary-700 font-medium";
    const replacements = [];
    if (testData2 !== void 0 && testData2 !== null) {
      const testDataStr = String(testData2);
      replacements.push(
        { regex: /test data/gi, value: testDataStr, type: "testData" },
        { regex: /\$\{testData\}/g, value: testDataStr, type: "testData" },
        { regex: /\$\{test-data\}/g, value: testDataStr, type: "testData" },
        { regex: /\$\{test_data\}/g, value: testDataStr, type: "testData" }
      );
    }
    const hasStructuredElementPlaceholder = /#\{ui-identifier\}|#\{from-ui-identifier\}|#\{to-ui-identifier\}|#\{uiIdentifier\}|\$\{element\}|\$\{uiIdentifier\}|\$\{ui-identifier\}|\$\{ui_identifier\}/.test(
      rawActionText
    );
    if (elementName2) {
      replacements.push(
        {
          regex: /#\{ui-identifier\}/g,
          value: elementName2,
          type: "element"
        },
        {
          regex: /#\{from-ui-identifier\}/g,
          value: elementName2,
          type: "element"
        },
        {
          regex: /#\{to-ui-identifier\}/g,
          value: elementName2,
          type: "element"
        },
        {
          regex: /#\{uiIdentifier\}/g,
          value: elementName2,
          type: "element"
        },
        {
          regex: /\$\{element\}/g,
          value: elementName2,
          type: "element"
        },
        {
          regex: /\$\{uiIdentifier\}/g,
          value: elementName2,
          type: "element"
        },
        {
          regex: /\$\{ui-identifier\}/g,
          value: elementName2,
          type: "element"
        },
        {
          regex: /\$\{ui_identifier\}/g,
          value: elementName2,
          type: "element"
        }
      );
      if (!hasStructuredElementPlaceholder) {
        replacements.push({
          regex: /\belement\b/gi,
          value: elementName2,
          type: "element"
        });
      }
    }
    let processedText = rawActionText;
    for (const replacement of replacements) {
      processedText = processedText.replace(
        replacement.regex,
        () => `__${replacement.type}__${replacement.value}__ENDTAG__`
      );
    }
    processedText = processedText.replace(
      /#\{(?:ui-identifier|from-ui-identifier|to-ui-identifier|uiIdentifier)\}/g,
      "element"
    );
    processedText = processedText.replace(
      /\$\{(?:element|uiIdentifier|ui-identifier|ui_identifier)\}/g,
      "element"
    );
    if (hasStructuredElementPlaceholder && elementName2) {
      processedText = processedText.replace(/^\s*element\s+/i, "");
      processedText = processedText.replace(/\s+an\s+element\s+/gi, " ");
      processedText = processedText.replace(/\s+a\s+element\s+/gi, " ");
      processedText = processedText.replace(/\s+the\s+element\s+/gi, " the ");
      processedText = processedText.replace(/\s+element\s+(?!in\s)/gi, " ");
      processedText = processedText.replace(
        /\s+element\s*([.,;:!?]|\s*$)/gi,
        (_, p1) => p1 || " "
      );
    }
    const parts = processedText.split(/(__.+?__.*?__ENDTAG__)/g);
    return parts.map((part, idx) => {
      const tagMatch = part.match(/__(.+?)__(.*)__ENDTAG__/);
      if (tagMatch) {
        const type = tagMatch[1];
        const value = tagMatch[2];
        const style2 = type === "testData" ? testDataStyle : elementStyle;
        return /* @__PURE__ */ jsx("span", { className: style2, children: value }, idx);
      }
      return part;
    });
  };
  const isAiGeneratedStep = !step?.id || step?.isAiGenerated;
  if (!template || isAiGeneratedStep) {
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames82(
          "flex flex-row px-3.5 py-1.5 items-start gap-x-2",
          isAdded && "opacity-50"
        ),
        children: [
          stepIndicator,
          /* @__PURE__ */ jsx(
            "div",
            {
              className: "text-sm py-1 flex-1 leading-relaxed",
              style: { color: "rgba(30, 41, 59, 1)" },
              children: renderStyledAction()
            }
          )
        ]
      }
    );
  }
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames82(
        "flex flex-row px-3.5 py-1.5 items-start gap-x-2",
        isAdded && "opacity-50"
      ),
      children: [
        stepIndicator,
        /* @__PURE__ */ jsx(
          StepItemWrapper,
          {
            step: stepWithAction,
            isViewOnly: true,
            template,
            stepsInfo: globalStepsInfo,
            updateStepsInfo: updateGlobalStepsInfo,
            isStepResult: true,
            isNumbered: false,
            stepNumberClassName: "!m-0"
          }
        )
      ]
    }
  );
}
var { Button: ButtonV27, BUTTON_VARIANTS: BUTTON_VARIANTS8, BUTTON_SIZE: BUTTON_SIZE8 } = V2;
function getNextStepNumbers(baseStepNum, count) {
  const parts = baseStepNum.split(".");
  const lastPart = parseInt(parts[parts.length - 1], 10);
  if (isNaN(lastPart)) return Array.from({ length: count }, (_, i) => i + 1);
  const prefix = parts.slice(0, -1).join(".");
  return Array.from({ length: count }, (_, i) => {
    const newLast = lastPart + 1 + i;
    return prefix ? `${prefix}.${newLast}` : newLast;
  });
}
var StepsMessage = ({
  message,
  templates,
  saveCopilotSteps: saveCopilotSteps2,
  stepsListWrapperClassName,
  onExecuteAfterSave,
  onRetry
}) => {
  const { t } = useTranslation();
  const [selectedStepIndexes, setSelectedStepIndexes] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [saveInProgress, setSaveInProgress] = useState(false);
  const [addAsBlock, setAddAsBlock] = useState(false);
  const [localAddedIndexes, setLocalAddedIndexes] = useState([]);
  const [localAddedStepsPositions, setLocalAddedStepsPositions] = useState({});
  const [addAfterStep, setAddAfterStep] = useState(1);
  const timeoutRef = useRef(null);
  const { isDebugger = false } = useRecorderContext();
  const testSteps = useSelector(
    (state) => state.widget?.testSteps || []
  );
  const executedStepIds = useSelector(
    (state) => state.debugging?.executedStepIds || []
  );
  const flatStepOptions = useMemo(() => {
    const hasBlockAncestor = (pid) => {
      let currentId = pid;
      const visited = /* @__PURE__ */ new Set();
      while (currentId != null) {
        if (visited.has(currentId)) break;
        visited.add(currentId);
        const s = testSteps.find((ts) => ts.id === currentId);
        if (!s) break;
        if (s.type === TestStepType.BLOCK) return true;
        currentId = s.parentId;
      }
      return false;
    };
    const options3 = [];
    for (let idx = 0; idx < testSteps.length; idx++) {
      const step = testSteps[idx];
      const stepNum = step.stepNumber ?? "";
      const parentStep = step.parentId ? testSteps.find((s) => s.id === step.parentId) : null;
      if (parentStep?.type === TestStepType.BLOCK) {
        continue;
      }
      if (stepNum.includes(" ... ")) {
        const parts = stepNum.split(" ... ");
        const rangeStart = parseInt(parts[0], 10);
        const rangeEnd = parseInt(parts[1], 10);
        if (!isNaN(rangeStart) && !isNaN(rangeEnd) && rangeEnd >= rangeStart) {
          const blockChildren = testSteps.filter(
            (s, j) => j > idx && s.parentId === step.id
          );
          if (blockChildren.length > 0) {
            for (let i = 0; i < blockChildren.length; i++) {
              const child = blockChildren[i];
              const isLastInBlock = i === blockChildren.length - 1;
              const childStepNum = child.stepNumber ?? "";
              if (childStepNum.includes(" ... ") && child.type === TestStepType.BLOCK) {
                const nestedChildren = testSteps.filter(
                  (sk) => sk.parentId === child.id
                );
                if (nestedChildren.length === 0) {
                  options3.push({
                    stepNumber: childStepNum,
                    stepOrder: child.stepOrder,
                    parentId: isLastInBlock ? step.parentId ?? null : step.id ?? null,
                    id: child.id ?? (i === 0 ? step.id : void 0),
                    isUnderBlock: step.type === TestStepType.BLOCK || void 0
                  });
                }
                for (let j = 0; j < nestedChildren.length; j++) {
                  const nc = nestedChildren[j];
                  const isLastNested = j === nestedChildren.length - 1;
                  const insertAfterNestedBlock = isLastNested && isLastInBlock;
                  const insertUnderOuterBlock = isLastNested && !isLastInBlock;
                  options3.push({
                    stepNumber: nc.stepNumber ?? String(rangeStart + i + j),
                    stepOrder: nc.stepOrder,
                    parentId: insertAfterNestedBlock ? step.parentId ?? null : insertUnderOuterBlock ? step.id ?? null : child.id ?? null,
                    id: nc.id ?? (j === 0 && i === 0 ? step.id : void 0),
                    isUnderBlock: step.type === TestStepType.BLOCK || void 0
                  });
                }
              } else {
                options3.push({
                  stepNumber: childStepNum || String(rangeStart + i),
                  stepOrder: child.stepOrder,
                  parentId: isLastInBlock ? step.parentId ?? null : step.id ?? null,
                  id: child.id ?? (i === 0 ? step.id : void 0),
                  isUnderBlock: step.type === TestStepType.BLOCK || void 0
                });
              }
            }
          } else {
            const count = rangeEnd - rangeStart + 1;
            const nextStep = testSteps[idx + 1];
            const endOrder = nextStep ? nextStep.stepOrder : step.stepOrder + (count + 1) * 1e3;
            const gap = endOrder - step.stepOrder;
            for (let i = rangeStart; i <= rangeEnd; i++) {
              const offset = i - rangeStart;
              const isLastInBlock = i === rangeEnd;
              const interpolatedOrder = step.stepOrder + Math.round(gap * (offset + 1) / (count + 1));
              options3.push({
                stepNumber: String(i),
                stepOrder: interpolatedOrder,
                parentId: isLastInBlock ? step.parentId ?? null : step.id ?? null,
                id: offset === 0 ? step.id : void 0,
                isUnderBlock: step.type === TestStepType.BLOCK || void 0
              });
            }
          }
          continue;
        }
      }
      const hasChildren = testSteps.some((s) => s.parentId === step.id);
      options3.push({
        stepNumber: stepNum || String(options3.length + 1),
        stepOrder: step.stepOrder,
        parentId: hasChildren ? step.id : step.parentId ?? null,
        id: step.id,
        isContainerStart: hasChildren || void 0
      });
    }
    if (options3.length > 0) {
      const last = options3[options3.length - 1];
      options3.push({
        stepNumber: t("copilot.steps.addAtEnd", "End"),
        stepOrder: last.stepOrder,
        parentId: null,
        id: void 0
      });
    }
    for (const opt of options3) {
      if (!opt.isUnderBlock) {
        opt.isUnderBlock = hasBlockAncestor(opt.parentId);
      }
    }
    return options3;
  }, [testSteps, t]);
  const isInsideBlock = useMemo(() => {
    const insertAfterIdx = Math.max(0, addAfterStep - 1);
    const selectedOption = flatStepOptions[insertAfterIdx];
    return !!selectedOption?.isUnderBlock;
  }, [addAfterStep, flatStepOptions]);
  useEffect(() => {
    if (isInsideBlock && addAsBlock) {
      setAddAsBlock(false);
    }
  }, [isInsideBlock, addAsBlock]);
  const getDefaultAddAfterStep = useCallback(() => {
    if (!isDebugger || executedStepIds.length === 0 || flatStepOptions.length === 0) {
      return flatStepOptions.length || 1;
    }
    const lastExecutedStepId = executedStepIds[executedStepIds.length - 1];
    const lastExecutedStepIndex = flatStepOptions.findIndex(
      (step) => step.id === lastExecutedStepId
    );
    if (lastExecutedStepIndex >= 0) {
      return Math.min(lastExecutedStepIndex + 1, flatStepOptions.length);
    }
    return 1;
  }, [isDebugger, executedStepIds, flatStepOptions]);
  useEffect(() => {
    setAddAfterStep(getDefaultAddAfterStep());
  }, [getDefaultAddAfterStep]);
  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);
  const messageData = useMemo(() => {
    const msg = message;
    let steps;
    let data;
    if (msg?.data?.steps !== void 0) {
      steps = msg.data.steps;
      data = msg.data;
    } else if (msg?.data?.scenarios?.length) {
      steps = msg.data.scenarios.flatMap((s) => s.steps || []);
      data = { ...msg.data, steps };
    } else if (msg?.steps !== void 0) {
      steps = msg.steps;
      data = msg;
    }
    if (!steps || !Array.isArray(steps)) return null;
    return data;
  }, [message]);
  const selectStepByIndex = (index) => {
    if (addedIndexesSet.has(index)) return;
    setSelectedStepIndexes(
      (prev) => prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };
  const handleSelectAll = () => {
    if (allStepsAdded) return;
    if (isAllSelected) {
      setSelectedStepIndexes([]);
    } else {
      const selectableIndexes = messageData?.steps ? messageData.steps.map((_, i) => i).filter((i) => !addedIndexesSet.has(i)) : [];
      setSelectedStepIndexes(selectableIndexes);
    }
  };
  const handleScroll = (event) => {
    const { scrollTop } = event.currentTarget;
    if (scrollTop > 10) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };
  const onAddSelectedStepsToTestCase = async (saveType, executeAfterSave = false) => {
    if (saveInProgress) return;
    if (!isSaveButtonEnabled) {
      toastify(
        t(
          "copilot.steps.selectAtLeastOne",
          "Please select at least one step to add"
        ),
        {
          type: "warning"
        }
      );
      return;
    }
    const selectedSteps = messageData?.steps?.filter(
      (_, index) => selectedStepIndexes.includes(index)
    );
    if (!selectedSteps?.length) {
      toastify(
        t(
          "copilot.steps.selectAtLeastOne",
          "Please select at least one step to add"
        ),
        {
          type: "warning"
        }
      );
      return;
    }
    setSaveInProgress(true);
    timeoutRef.current = setTimeout(() => {
      toastify("Save operation timed out. Please try again.", {
        type: "error"
      });
      setSaveInProgress(false);
    }, 3e4);
    try {
      const insertAfterIdx = Math.max(0, addAfterStep - 1);
      const selectedFlatStep = flatStepOptions[insertAfterIdx];
      const endLabel = t("copilot.steps.addAtEnd", "End");
      const isEndLabel = selectedFlatStep?.stepNumber === endLabel || selectedFlatStep?.stepNumber === "End";
      const sortedSelected = [...selectedStepIndexes].sort((a, b) => a - b);
      let nextNums;
      if (isEndLabel) {
        let lastTopLevelNum = 0;
        for (const opt of flatStepOptions) {
          if (opt.stepNumber === endLabel || opt.stepNumber === "End") continue;
          const n = parseInt(opt.stepNumber, 10);
          if (!isNaN(n) && n > lastTopLevelNum) lastTopLevelNum = n;
        }
        nextNums = Array.from(
          { length: sortedSelected.length },
          (_, i) => lastTopLevelNum + 1 + i
        );
      } else {
        const baseStepNum = (selectedFlatStep?.stepNumber ?? "").trim();
        if (selectedFlatStep?.isContainerStart) {
          nextNums = getNextStepNumbers(
            `${baseStepNum}.0`,
            sortedSelected.length
          );
        } else {
          nextNums = getNextStepNumbers(
            baseStepNum || "0",
            sortedSelected.length
          );
        }
      }
      const addedStepsPositions = {};
      sortedSelected.forEach((idx, i) => {
        addedStepsPositions[idx] = nextNums[i] ?? i + 1;
      });
      await saveCopilotSteps2({
        steps: selectedSteps,
        saveType,
        name: messageData?.name,
        conversationId: messageData?.conversationId,
        interactionId: messageData?.interactionId,
        selectedStepIndexes,
        // Pass stepOrder directly so insertion works for block children too
        addAfterStepOrder: selectedFlatStep?.stepOrder,
        addAfterParentId: selectedFlatStep?.parentId,
        addedStepsPositions,
        executeAfterSave
      });
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      setLocalAddedIndexes((prev) => [
        .../* @__PURE__ */ new Set([...prev, ...selectedStepIndexes])
      ]);
      setLocalAddedStepsPositions((prev) => ({
        ...prev,
        ...addedStepsPositions
      }));
      setSaveInProgress(false);
      setSelectedStepIndexes([]);
      if (executeAfterSave && onExecuteAfterSave) {
        const insertAfterStepId = selectedFlatStep?.id ?? testSteps.find(
          (s) => s.stepOrder === selectedFlatStep?.stepOrder
        )?.id ?? flatStepOptions[insertAfterIdx - 1]?.id;
        onExecuteAfterSave(insertAfterStepId);
      }
    } catch (error) {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      const errorMessage = error?.message || error?.detail || "Failed to add steps. Please try again.";
      toastify(errorMessage, { type: "error" });
      setSaveInProgress(false);
    }
  };
  const addedIndexesSet = useMemo(() => {
    const backendAdded = messageData?.addedStepsIndexes || [];
    return /* @__PURE__ */ new Set([...backendAdded, ...localAddedIndexes]);
  }, [messageData?.addedStepsIndexes, localAddedIndexes]);
  const addedStepCount = addedIndexesSet.size;
  const totalSteps = messageData?.steps?.length || 0;
  const stepsAdded = addedStepCount > 0;
  const allStepsAdded = totalSteps > 0 && addedStepCount >= totalSteps;
  const addedStepPositionMap = useMemo(() => {
    const sorted = [...addedIndexesSet].sort((a, b) => a - b);
    const map3 = {};
    const steps = messageData?.steps;
    const backendPositions = messageData?.addedStepsPositions;
    if (!steps?.length) {
      sorted.forEach((idx, i) => {
        map3[idx] = i + 1;
      });
      return map3;
    }
    const sortedTestSteps = [...testSteps].sort(
      (a, b) => a.stepOrder - b.stepOrder
    );
    const usedIds = /* @__PURE__ */ new Set();
    sorted.forEach((idx, i) => {
      const copilotStep = steps[idx];
      if (copilotStep?.stepOrder != null) {
        const match = sortedTestSteps.find(
          (s) => s.stepOrder === copilotStep.stepOrder
        );
        if (match?.stepNumber) {
          usedIds.add(match.id);
          map3[idx] = match.stepNumber;
          return;
        }
      }
      if (copilotStep?.action) {
        const match = sortedTestSteps.find(
          (s) => s.action === copilotStep.action && s.type !== "BLOCK" && !usedIds.has(s.id)
        );
        if (match?.stepNumber) {
          usedIds.add(match.id);
          map3[idx] = match.stepNumber;
          return;
        }
      }
      map3[idx] = backendPositions?.[idx] ?? localAddedStepsPositions[idx] ?? i + 1;
    });
    return map3;
  }, [
    addedIndexesSet,
    testSteps,
    messageData?.steps,
    messageData?.addedStepsPositions,
    localAddedStepsPositions
  ]);
  const stepsListRef = useRef(null);
  useEffect(() => {
    if (messageData?.addedStepsIndexes?.length) {
      setSelectedStepIndexes([]);
      setSaveInProgress(false);
      if (messageData?.addedStepsPositions) {
        const backendPos = messageData.addedStepsPositions;
        setLocalAddedStepsPositions((prev) => {
          const next = { ...prev };
          Object.keys(backendPos).forEach((k) => delete next[Number(k)]);
          return next;
        });
      }
      if (stepsListRef.current) {
        const lastAddedIdx = messageData.addedStepsIndexes[messageData.addedStepsIndexes.length - 1];
        const stepElements = stepsListRef.current.querySelectorAll("[data-step-index]");
        const target = Array.from(stepElements).find(
          (el) => el.dataset.stepIndex === String(lastAddedIdx)
        );
        if (target) {
          requestAnimationFrame(() => {
            target.scrollIntoView({ behavior: "smooth", block: "nearest" });
          });
        }
      }
    }
  }, [messageData?.addedStepsIndexes]);
  useEffect(() => {
    const selectableCount = (messageData?.steps?.length || 0) - addedIndexesSet.size;
    if (selectableCount > 0 && selectedStepIndexes.length === selectableCount) {
      setIsAllSelected(true);
    } else {
      setIsAllSelected(false);
    }
  }, [selectedStepIndexes, messageData?.steps, addedIndexesSet]);
  const isSaveButtonEnabled = useMemo(
    () => selectedStepIndexes?.length && !saveInProgress,
    [saveInProgress, selectedStepIndexes?.length]
  );
  const isAddAndExecuteEnabled = useMemo(() => {
    if (!isSaveButtonEnabled) return false;
    if (!isDebugger) return false;
    if (executedStepIds.length === 0) return false;
    const executionPoint = getDefaultAddAfterStep();
    return addAfterStep === executionPoint;
  }, [
    isSaveButtonEnabled,
    isDebugger,
    getDefaultAddAfterStep,
    addAfterStep,
    executedStepIds
  ]);
  if (!messageData) {
    return /* @__PURE__ */ jsx("div", { className: "flex items-center justify-center p-4 text-gray-500 mx-4 my-2 border border-gray-200 rounded-lg", children: t("copilot.steps.noData") });
  }
  if (!messageData.steps || messageData.steps.length === 0) {
    const retryQuery = message?.data?.query ?? message?.data?.context?.query;
    const err = message?.data?.error;
    const llmErrorMessage = typeof err === "string" ? err : err?.message;
    const isSuccessEmpty = message?.data?.status === "success";
    const isError = message?.data?.status === "error" || message?.data?.status === "failed";
    const displayMessage = llmErrorMessage?.trim() ? llmErrorMessage.trim() : isSuccessEmpty || isError ? t(
      "copilot.error.no.steps",
      "No test steps could be generated for this request. Please try a different query or navigate to the relevant page."
    ) : t(
      "copilot.steps.cancelled",
      "Step generation was stopped. Please try again to generate test steps."
    );
    return /* @__PURE__ */ jsx("div", { className: "flex flex-col rounded-lg overflow-hidden border border-gray-200 bg-gray-50 shadow-sm", children: /* @__PURE__ */ jsxs("div", { className: "px-4 py-3 flex flex-col gap-2", children: [
      /* @__PURE__ */ jsx("div", { className: "text-sm text-gray-500", children: displayMessage }),
      onRetry && retryQuery && !isSuccessEmpty && /* @__PURE__ */ jsx(
        ButtonV27,
        {
          variant: BUTTON_VARIANTS8.SECONDARY,
          size: BUTTON_SIZE8.SMALLEST,
          className: "!w-fit",
          onClick: () => onRetry(retryQuery),
          children: t("common.retry", "Retry")
        }
      )
    ] }) });
  }
  return /* @__PURE__ */ jsx("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col overflow-hidden rounded-md border-[0.5px] border-[#F0F0F3] py-2.5 px-3 gap-3 bg-white", children: [
    /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx("div", { className: "text-sm font-semibold text-gray-800", children: stepsAdded ? t(
      "copilot.steps.suggestedAddedToTestCase",
      "Suggested Test Steps added to Test Case"
    ) : t("copilot.steps.suggested") }) }),
    !stepsAdded && /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames82("flex items-center gap-2", {
          "shadow-sm": isScrolled
        }),
        children: [
          /* @__PURE__ */ jsx(
            Checkbox,
            {
              onChange: handleSelectAll,
              type: "primary",
              size: "small",
              className: "!py-0",
              checked: isAllSelected,
              isDisabled: allStepsAdded,
              ariaLabel: "Select all steps"
            }
          ),
          /* @__PURE__ */ jsx(
            "span",
            {
              className: classNames82("text-sm font-medium text-slate-800", {
                "opacity-50": allStepsAdded
              }),
              children: t("copilot.steps.selectAll")
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      "div",
      {
        ref: stepsListRef,
        className: classNames82(
          "max-h-64 overflow-auto",
          stepsListWrapperClassName
        ),
        onScroll: handleScroll,
        children: /* @__PURE__ */ jsx("div", { children: stepsAdded ? (
          /* Added section: only steps that were added, with position numbers */
          [...addedIndexesSet].sort((a, b) => a - b).map((i) => /* @__PURE__ */ jsx("div", { "data-step-index": i, children: /* @__PURE__ */ jsx(
            CopilotStep,
            {
              templates,
              step: messageData.steps[i],
              isSelected: false,
              isAdded: true,
              addedStepPosition: addedStepPositionMap[i],
              index: i
            }
          ) }, `added-${i}`))
        ) : messageData?.steps?.map((step, i) => /* @__PURE__ */ jsx("div", { "data-step-index": i, children: /* @__PURE__ */ jsx(
          CopilotStep,
          {
            templates,
            step,
            isSelected: selectedStepIndexes.includes(i),
            isAdded: false,
            index: i,
            selectStepByIndex
          }
        ) }, i)) })
      }
    ),
    /* @__PURE__ */ jsx("div", { children: saveInProgress ? /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between gap-2 pt-3 border-t border-gray-200", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 text-sm text-gray-600", children: [
        /* @__PURE__ */ jsx(Icon, { name: "loader", className: "text-lg animate-spin" }),
        /* @__PURE__ */ jsx("span", { children: t("copilot.steps.adding") })
      ] }),
      /* @__PURE__ */ jsx(
        ButtonV27,
        {
          variant: BUTTON_VARIANTS8.SECONDARY,
          size: BUTTON_SIZE8.SMALLEST,
          onClick: () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            setSaveInProgress(false);
          },
          children: t("copilot.steps.cancel")
        }
      )
    ] }) : stepsAdded ? /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-center gap-2 pt-3 border-t border-gray-200 text-sm text-green-600", children: [
      /* @__PURE__ */ jsx(Icon, { name: "check-circle", className: "text-lg" }),
      /* @__PURE__ */ jsx("span", { children: t("copilot.steps.addedCount", { count: addedStepCount }) })
    ] }) : selectedStepIndexes.length > 0 ? /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-2 pt-3 border-t border-gray-200", children: [
      /* @__PURE__ */ jsxs(
        "label",
        {
          className: `flex items-center gap-2 text-sm ${isInsideBlock ? "cursor-not-allowed text-slate-400" : "cursor-pointer text-slate-800"}`,
          children: [
            /* @__PURE__ */ jsx(
              Checkbox,
              {
                checked: addAsBlock && !isInsideBlock,
                onChange: () => !isInsideBlock && setAddAsBlock(!addAsBlock),
                type: "primary",
                size: "small",
                className: "!py-0",
                ariaLabel: "Add steps as block",
                isDisabled: isInsideBlock
              }
            ),
            /* @__PURE__ */ jsx("span", { children: t("copilot.steps.addAsBlock") }),
            isInsideBlock && /* @__PURE__ */ jsx("span", { className: "text-xs text-slate-400", children: t(
              "copilot.steps.blockNotAllowed",
              "(not supported inside a block)"
            ) })
          ]
        }
      ),
      /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 min-w-0 flex-wrap", children: [
        flatStepOptions.length > 0 ? /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-1.5 min-w-0", children: [
          /* @__PURE__ */ jsx("span", { className: "text-xs text-slate-700 shrink-0 whitespace-nowrap", children: t("copilot.steps.addAfter") }),
          /* @__PURE__ */ jsx(
            DropdownButton,
            {
              name: flatStepOptions[addAfterStep - 1]?.stepNumber ?? addAfterStep,
              fillWidth: false,
              variant: "select-fill",
              className: "!text-xs !h-6 !min-w-[50px] !bg-[#F1F4F6] !rounded-[5px]",
              dropdownClassName: "!w-[89px] !max-h-40",
              placement: "top-start",
              children: flatStepOptions.map((step, index) => /* @__PURE__ */ jsx(
                DropdownItem,
                {
                  isSelected: addAfterStep === index + 1,
                  onClick: () => setAddAfterStep(index + 1),
                  children: step.stepNumber
                },
                index
              ))
            }
          )
        ] }) : /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-1.5 min-w-0", children: [
          /* @__PURE__ */ jsx("span", { className: "text-xs text-slate-700 shrink-0 whitespace-nowrap", children: t("copilot.steps.addAfter") }),
          /* @__PURE__ */ jsx("span", { className: "text-xs text-slate-600 bg-[#F1F4F6] px-2 h-6 flex items-center rounded-[5px]", children: t("copilot.steps.addAtEnd", "End") })
        ] }),
        isAddAndExecuteEnabled ? /* @__PURE__ */ jsxs(
          DropdownButton,
          {
            name: t("copilot.steps.addAndExecute"),
            fillWidth: false,
            variant: "select-fill",
            className: classNames82(
              "!h-6 !gap-1 !rounded-border-radius-button !border !border-[0.5px] shrink-0",
              "!bg-[var(--button-primary-background-default,rgba(9,59,77,1))]",
              "!border-[var(--button-primary-stroke-default,rgba(7,45,59,1))]",
              "!text-[var(--button-primary-text-default,rgba(255,255,255,1))]",
              "shadow-[0px_1px_1px_0px_rgba(0,0,0,0.06),0px_4px_4px_-1px_rgba(0,0,0,0.02)]",
              "transition-all duration-300 ease-out",
              "data-[isopen=true]:!bg-[var(--button-primary-background-hover,rgba(7,45,59,1))]",
              "data-[isopen=true]:!border-[var(--button-primary-stroke-default,rgba(7,45,59,1))]"
            ),
            dropdownClassName: classNames82(
              "!min-w-[150px] !rounded-lg !py-1",
              "!shadow-[0px_1px_1px_0px_rgba(0,0,0,0.06),0px_4px_4px_-1px_rgba(0,0,0,0.02)]"
            ),
            placement: "top-end",
            offset: [0, 8],
            children: [
              /* @__PURE__ */ jsxs(
                DropdownItem,
                {
                  className: "flex items-center gap-2",
                  onClick: () => onAddSelectedStepsToTestCase(
                    addAsBlock ? "block" : "steps",
                    true
                  ),
                  children: [
                    /* @__PURE__ */ jsx(
                      Icon,
                      {
                        name: "play-circle",
                        className: "text-base text-green-600"
                      }
                    ),
                    t("copilot.steps.addAndExecute")
                  ]
                }
              ),
              /* @__PURE__ */ jsxs(
                DropdownItem,
                {
                  className: "flex items-center gap-2 border-t border-gray-200",
                  onClick: () => onAddSelectedStepsToTestCase(
                    addAsBlock ? "block" : "steps",
                    false
                  ),
                  children: [
                    /* @__PURE__ */ jsx(
                      Icon,
                      {
                        name: "add",
                        className: "text-base text-secondary-500"
                      }
                    ),
                    t("copilot.steps.add")
                  ]
                }
              )
            ]
          }
        ) : /* @__PURE__ */ jsxs(
          ButtonV27,
          {
            variant: BUTTON_VARIANTS8.PRIMARY,
            size: BUTTON_SIZE8.SMALLEST,
            disabled: !isSaveButtonEnabled,
            onClick: () => onAddSelectedStepsToTestCase(
              addAsBlock ? "block" : "steps",
              false
            ),
            className: classNames82(
              "!h-6 !gap-1 !px-3 !rounded-border-radius-button !border !border-[0.5px] shrink-0",
              "!bg-[var(--button-primary-background-default,rgba(9,59,77,1))]",
              "!border-[var(--button-primary-stroke-default,rgba(7,45,59,1))]",
              "!text-[var(--button-primary-text-default,rgba(255,255,255,1))]",
              "shadow-[0px_1px_1px_0px_rgba(0,0,0,0.06),0px_4px_4px_-1px_rgba(0,0,0,0.02)]",
              "transition-all duration-300 ease-out",
              "hover:!bg-[var(--button-primary-background-hover,rgba(7,45,59,1))]"
            ),
            children: [
              /* @__PURE__ */ jsx(Icon, { name: "add", className: "text-base" }),
              t("copilot.steps.add")
            ]
          }
        )
      ] })
    ] }) : /* @__PURE__ */ jsx("div", { className: "flex items-center justify-center gap-2 pt-3 border-t border-gray-200 text-sm text-slate-600", children: /* @__PURE__ */ jsx("span", { children: t("copilot.steps.selectStepsToAdd") }) }) })
  ] }) });
};
var steps_message_default = StepsMessage;
var DraggableList = ({
  items,
  CustomItemWrapper,
  className,
  iconClassName,
  onDrop,
  onItemClick,
  CustomEmptyMessage = /* @__PURE__ */ jsx(Fragment, {}),
  ...customItemProps
}) => {
  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    if (result.source.index === result.destination.index) {
      return;
    }
    onDrop({
      addedIndex: result.destination.index,
      removedIndex: result.source.index
    });
  };
  const { t } = useTranslation();
  const renderDragIcon = () => /* @__PURE__ */ jsx(ToolTip, { content: t("reorder.drag.icon.text"), children: /* @__PURE__ */ jsx(
    Icon,
    {
      name: "reorder",
      className: classNames82(
        "cursor-grab min-w-[28px] text-xl justify-center drag-icon",
        iconClassName
      )
    }
  ) });
  return /* @__PURE__ */ jsx(Fragment, { children: !items?.length ? CustomEmptyMessage : /* @__PURE__ */ jsx(DragDropContext, { onDragEnd, children: /* @__PURE__ */ jsx(
    Droppable,
    {
      droppableId: "droppable",
      renderClone: (provided, snapshot, rubric) => {
        const draggableProps = provided.draggableProps || {};
        const { role: draggableRole, tabIndex: draggableTabIndex, ...draggablePropsWithoutInteractive } = draggableProps;
        const dragHandleProps = provided.dragHandleProps || {};
        const { role: dragHandleRole, tabIndex: dragHandleTabIndex, ...dragHandlePropsWithoutInteractive } = dragHandleProps;
        return /* @__PURE__ */ jsxs(
          "div",
          {
            className: classNames82("flex items-center gap-2", className),
            ref: provided.innerRef,
            ...draggablePropsWithoutInteractive,
            ...dragHandlePropsWithoutInteractive,
            children: [
              renderDragIcon(),
              CustomItemWrapper ? /* @__PURE__ */ jsx(
                CustomItemWrapper,
                {
                  item: items[rubric.source.index],
                  onClick: onItemClick ? onItemClick : NOOP,
                  ...customItemProps
                }
              ) : items[rubric.source.index].name
            ]
          }
        );
      },
      children: (droppableProvided) => /* @__PURE__ */ jsxs(
        "div",
        {
          ref: droppableProvided.innerRef,
          ...droppableProvided.droppableProps,
          children: [
            items.map(
              (item, index) => item ? /* @__PURE__ */ jsx(
                Draggable,
                {
                  draggableId: String(item?.id),
                  index,
                  children: (draggableProvided) => {
                    const draggableProps = draggableProvided.draggableProps || {};
                    const { role: draggableRole, tabIndex: draggableTabIndex, ...draggablePropsWithoutInteractive } = draggableProps;
                    const dragHandleProps = draggableProvided.dragHandleProps || {};
                    const { role: dragHandleRole, tabIndex: dragHandleTabIndex, ...dragHandlePropsWithoutInteractive } = dragHandleProps;
                    return /* @__PURE__ */ jsxs(
                      "div",
                      {
                        ref: draggableProvided.innerRef,
                        ...draggablePropsWithoutInteractive,
                        ...dragHandlePropsWithoutInteractive,
                        className: classNames82(
                          "flex items-center gap-2",
                          className
                        ),
                        children: [
                          renderDragIcon(),
                          /* @__PURE__ */ jsx("div", { className: "flex-1 min-w-0", children: CustomItemWrapper ? /* @__PURE__ */ jsx(
                            CustomItemWrapper,
                            {
                              item,
                              onClick: onItemClick ? onItemClick : NOOP,
                              ...customItemProps
                            }
                          ) : item.name })
                        ]
                      }
                    );
                  }
                },
                item.id
              ) : /* @__PURE__ */ jsx(Fragment, {})
            ),
            droppableProvided.placeholder
          ]
        }
      )
    }
  ) }) });
};
var DraggableListWithDelete = ({
  items,
  setItems,
  onDrop,
  setIsDirty
}) => {
  const delelteItem = (id) => {
    const updatedList = items.filter((item) => item.id !== id);
    setItems(updatedList);
    setIsDirty(true);
  };
  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    if (result.source.index === result.destination.index) {
      return;
    }
    onDrop({
      addedIndex: result.destination.index,
      removedIndex: result.source.index
    });
  };
  const { t } = useTranslation();
  const renderDragIcon = () => /* @__PURE__ */ jsx(ToolTip, { content: t("reorder.drag.icon.text"), children: /* @__PURE__ */ jsx(
    Icon,
    {
      name: "reorder",
      className: "drag-icon cursor-grab min-w-[28px] text-xl justify-center"
    }
  ) });
  return /* @__PURE__ */ jsx(DragDropContext, { onDragEnd, children: /* @__PURE__ */ jsx(
    Droppable,
    {
      droppableId: "custom-fields-droppable",
      renderClone: (provided, snapshot, rubric) => /* @__PURE__ */ jsxs(
        "div",
        {
          className: "flex items-center gap-2 mb-4 bg-white",
          ref: provided.innerRef,
          ...provided.draggableProps,
          ...provided.dragHandleProps,
          children: [
            renderDragIcon(),
            /* @__PURE__ */ jsx("span", { className: "w-full flex border rounded-md bg-[#f7f8f9] text-xs leading-5 font-normal py-2 px-3 text-secondary-unique-600", children: items[rubric.source.index].name }),
            /* @__PURE__ */ jsx(
              Icon,
              {
                name: "do-not-disturb-on-red",
                className: "min-w-[28px] text-xl justify-center text-error-600 cursor-pointer",
                onClick: () => delelteItem(items[rubric.source.index].id)
              }
            )
          ]
        }
      ),
      children: (droppableProvided) => /* @__PURE__ */ jsxs(
        "div",
        {
          ref: droppableProvided.innerRef,
          ...droppableProvided.droppableProps,
          children: [
            items.map((item, index) => /* @__PURE__ */ jsx(
              Draggable,
              {
                draggableId: String(item?.id),
                index,
                children: (draggableProvided) => /* @__PURE__ */ jsxs(
                  "div",
                  {
                    className: "flex items-center gap-2 mb-4",
                    ref: draggableProvided.innerRef,
                    ...draggableProvided.draggableProps,
                    ...draggableProvided.dragHandleProps,
                    children: [
                      renderDragIcon(),
                      /* @__PURE__ */ jsx("span", { className: "w-full flex border rounded-md bg-[#f7f8f9] text-xs leading-5 font-normal py-2 px-3 text-secondary-unique-600", children: item.name }),
                      /* @__PURE__ */ jsx(
                        Icon,
                        {
                          name: "do-not-disturb-on-red",
                          className: "min-w-[28px] text-xl justify-center text-error-600 cursor-pointer",
                          onClick: () => delelteItem(item.id)
                        }
                      )
                    ]
                  }
                )
              },
              item?.id
            )),
            droppableProvided.placeholder
          ]
        }
      )
    }
  ) });
};
var DraggableVirtualizedList = ({
  onDragEnd,
  onDragStart = NOOP,
  rowRenderer,
  items,
  loadMore,
  hasMore,
  isLoading,
  rowHeight,
  isDragDisabled = false,
  scrollToIndex = null,
  isDynamicHeightList = false,
  toggleToCalculateHeight = false
}) => {
  const { VirtualizedInfiniteLoader: VirtualizedInfiniteLoader9 } = InfiniteScrollV2;
  const getRowRenderedWithDraggbleWrapped = (index) => {
    const item = items[index];
    return /* @__PURE__ */ jsx(
      Draggable,
      {
        draggableId: `draggable-step-${item?.id}-${index}`,
        index,
        isDragDisabled,
        children: (provided) => {
          const draggableProps = provided.draggableProps || {};
          const { role, tabIndex, ...draggablePropsWithoutInteractive } = draggableProps;
          const dragHandleProps = provided.dragHandleProps || {};
          const { role: dragHandleRole, tabIndex: dragHandleTabIndex, ...dragHandlePropsWithoutInteractive } = dragHandleProps;
          return /* @__PURE__ */ createElement(
            "div",
            {
              role: "gridcell",
              ref: provided.innerRef,
              ...draggablePropsWithoutInteractive,
              ...dragHandlePropsWithoutInteractive,
              key: index
            },
            rowRenderer(index)
          );
        }
      },
      `${item?.id}-${index}`
    );
  };
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(DragDropContext, { onDragEnd, onDragStart, children: /* @__PURE__ */ jsx(
    Droppable,
    {
      droppableId: "droppable",
      mode: "virtual",
      isDropDisabled: isDragDisabled,
      renderClone: (provided, snapshot, rubric) => {
        const draggableProps = provided.draggableProps || {};
        const { role, tabIndex, ...draggablePropsWithoutInteractive } = draggableProps;
        return /* @__PURE__ */ createElement(
          "div",
          {
            ref: provided.innerRef,
            ...draggablePropsWithoutInteractive,
            key: rubric.source.index,
            role: "presentation"
          },
          rowRenderer(rubric.source.index)
        );
      },
      children: (droppableProvided) => /* @__PURE__ */ jsx(
        VirtualizedInfiniteLoader9,
        {
          rowRendererRole: "row",
          loadMore,
          hasMore,
          isLoading,
          rowCount: items.length,
          rowRenderer: getRowRenderedWithDraggbleWrapped,
          items,
          listRef: (ref) => {
            if (!ref) return;
            if (ref) {
              const _grid = ref?.Grid;
              const listDomNode = _grid?.scrollingContainer || _grid?._scrollingContainer;
              if (listDomNode instanceof HTMLElement) {
                droppableProvided.innerRef(listDomNode);
              }
            }
          },
          rowHeight,
          scrollToIndex,
          isDynamicHeightList,
          toggleToCalculateHeight
        }
      )
    }
  ) }) });
};

// src/analytics/amplitude.ts
var Amplitude = class {
  injectAmplitudeInBrowser(input) {
    try {
      return new Promise((resolve, reject) => {
        const integrity = input.integrity || "sha384-+EO59vL/X7v6VE2s6/F4HxfHlK0nDUVWKVg8K9oUlvffAeeaShVBmbORTC2D3UF+";
        const crossOrigin = input.crossOrigin || "anonymous";
        const async = input.async ?? true;
        const url = input.url || "https://cdn.amplitude.com/libs/amplitude-8.17.0-min.gz.js";
        const onScriptLoadedDefault = () => {
          console.log("Amplitude script loaded");
          if (input.onScriptLoaded) {
            input.onScriptLoaded(resolve, reject);
            return;
          } else if (!window?.amplitude?.runQueuedFunctions) {
            console.log("[Amplitude] Error: could not load SDK");
            reject("[Amplitude] Error: Could not load Amplitude SDK");
          } else {
            resolve(true);
          }
        };
        const amplitudeScript = document.createElement("script");
        amplitudeScript.id = input.id || "amplitude-script";
        amplitudeScript.type = "text/javascript";
        amplitudeScript.integrity = integrity;
        amplitudeScript.crossOrigin = crossOrigin;
        amplitudeScript.async = async;
        amplitudeScript.src = url;
        amplitudeScript.onload = onScriptLoadedDefault;
        amplitudeScript.onerror = (error) => {
          console.error(
            "[Amplitude] Error: Error loading Amplitude script:",
            error
          );
          reject(error);
        };
        document.body.appendChild(amplitudeScript);
      });
    } catch (error) {
      console.error("Error initializing Amplitude:", error);
    }
  }
  setInstanceId(instanceId, ...properties) {
    if (!window.amplitude) {
      console.log("[Amplitude] Error: could not load SDK");
      return;
    }
    window.amplitude.getInstance().init(instanceId, ...properties);
  }
  setIdentifyProperties(properties) {
    if (!window.amplitude) {
      console.log("[Amplitude] Error: could not load SDK");
      return;
    }
    const identify = new window.amplitude.Identify();
    for (const [key, value] of Object.entries(properties)) {
      identify.set(key, value);
    }
    window.amplitude.identify(identify);
  }
};
function logEvent(event, properties) {
  if (!window?.amplitude || !window?.amplitude?.logEvent) {
    console.log("[Amplitude] Error: could not load SDK");
    return;
  }
  window.amplitude.logEvent(event, properties ?? {});
}
var amplitudeInstance = new Amplitude();
var amplitude_default = amplitudeInstance;

// src/constants/analytics.constants.ts
var AMPLITUDE = {
  LIVE_EDITOR_LAUNCHED: "live_editor_launched",
  LIVE_EDITOR_COPILOT_WINDOW_OPENED: "live_editor_copilot_window_opened",
  LIVE_EDITOR_COPILOT_WINDOW_OPEN_FAILED: "live_editor_copilot_window_open_failed",
  LIVE_EDITOR_COPILOT_WINDOW_CLOSED: "live_editor_copilot_window_closed",
  LIVE_EDITOR_COPILOT_WINDOW_SEND_MESSAGE: "live_editor_copilot_window_send_message",
  LIVE_EDITOR_COPILOT_WINDOW_CANCELLED: "live_editor_copilot_window_message_cancelled",
  LIVE_EDITOR_COPILOT_WINDOW_SAVE_STEPS: "live_editor_copilot_window_save_steps",
  LIVE_EDITOR_COPILOT_WINDOW_GENERATING_SCENARIOS: "live_editor_copilot_window_generating_scenarios",
  LIVE_EDITOR_RESUME_EXECUTION: "live_editor_resume_execution",
  LIVE_EDITOR_SKIP_OVER_EXECUTION: "live_editor_skip_over_execution",
  LIVE_EDITOR_STEP_OVER_EXECUTION: "live_editor_step_over_execution",
  LIVE_EDITOR_RESTART_EXECUTION: "live_editor_restart_execution",
  LIVE_EDITOR_REFRESH_WIDGET: "live_editor_refresh_widget",
  LIVE_EDITOR_DELETE_STEP: "live_editor_delete_step",
  LIVE_EDITOR_REORDER_STEPS: "live_editor_reorder_steps",
  LIVE_EDITOR_STEP_RECORD_PAUSE: "live_editor_step_record_pause",
  LIVE_EDITOR_STEP_RECORD_RESUME: "live_editor_step_record_resume",
  LIVE_EDITOR_ELEMENT_CAPTURE_START: "live_editor_element_capture_start",
  LIVE_EDITOR_ELEMENT_CAPTURE_STOP: "live_editor_element_capture_stop",
  LIVE_EDITOR_STEP_UPDATE: "live_editor_step_update",
  LIVE_EDITOR_STEP_CREATE: "live_editor_step_create",
  LIVE_EDITOR_BULK_STEP_DELETE: "live_editor_bulk_step_delete",
  LIVE_EDITOR_BULK_STEP_SETTING_UPDATE: "live_editor_bulk_step_setting_update",
  LIVE_EDITOR_STEP_SETTING_UPDATE: "live_editor_step_setting_update",
  LIVE_EDITOR_STEP_ELEMENT_DROPDOWN_ANCHOR_CLICK: "live_editor_step_element_dropdown_anchor_click",
  LIVE_EDITOR_GROOT_SIDE_PANEL_OPENED: "live_editor_groot_side_panel_opened",
  LIVE_EDITOR_GROOT_SIDE_PANEL_LAUNCH_BUTTON_CLICKED: "live_editor_groot_side_panel_launch_button_clicked",
  LIVE_EDITOR_ATTO_AI_AUTOMATE_WITH_LIVE_EDITOR_START: "live_editor_atto_ai_automate_with_live_editor_start",
  LIVE_EDITOR_ATTO_AI_AUTOMATE_WITH_LIVE_EDITOR_END: "live_editor_atto_ai_automate_with_live_editor_end",
  LIVE_EDITOR_ATTO_AI_RECORDED_STEPS_WITH_LIVE_EDITOR_START: "live_editor_atto_ai_recorded_steps_with_live_editor_start",
  LIVE_EDITOR_ATTO_AI_RECORDED_STEPS_WITH_LIVE_EDITOR_END: "live_editor_atto_ai_recorded_steps_with_live_editor_end",
  TERMINAL_APP_CRASHED: "terminal_app_crashed",
  TERMINAL_CRASH_RECOVERY_SUCCESS: "terminal_crash_recovery_success",
  TERMINAL_CRASH_RECOVERY_FAILURE: "terminal_crash_recovery_failure",
  TERMINAL_LOGIN_FAILURE: "terminal_login_failure",
  TERMINAL_PORT_CONFIGURATION_UPDATED: "terminal_port_configuration_updated",
  TERMINAL_PORTS_UNAVAILABLE: "terminal_ports_unavailable",
  TERMINAL_AGENT_INSTALLATION_FAILURE: "terminal_agent_installation_failure",
  TERMINAL_AGENT_CONNECTION_ERROR: "terminal_agent_connection_error",
  TERMINAL_AGENT_NOT_ABLE_TO_START: "terminal_agent_not_able_to_start",
  TERMINAL_ATTO_BROWSER_DOWNLOAD_SUCCESS: "terminal_atto_browser_download_success",
  TERMINAL_ATTO_BROWSER_DOWNLOAD_FAILURE: "terminal_atto_browser_download_failure",
  TERMINAL_ATTO_BROWSER_AGENT_CONNECTION_ERROR: "terminal_atto_browser_agent_connection_error",
  // Web Live Editor Session Events
  LIVE_EDITOR_WEB_START_REQUEST: "live_editor_web_start_request",
  LIVE_EDITOR_WEB_START_SUCCESS: "live_editor_web_start_success",
  LIVE_EDITOR_WEB_START_FAILURE: "live_editor_web_start_failure",
  LIVE_EDITOR_WEB_STEP_RECORD_PAUSE: "live_editor_web_step_record_pause",
  LIVE_EDITOR_WEB_STEP_RECORD_RESUME: "live_editor_web_step_record_resume",
  // Salesforce Live Editor Session Events
  LIVE_EDITOR_SF_START_REQUEST: "live_editor_sf_start_request",
  LIVE_EDITOR_SF_START_SUCCESS: "live_editor_sf_start_success",
  LIVE_EDITOR_SF_START_FAILURE: "live_editor_sf_start_failure",
  // Atto/Agentic Session Events
  LIVE_EDITOR_ATTO_WEB_START_REQUEST: "live_editor_atto_web_start_request",
  LIVE_EDITOR_ATTO_WEB_START_SUCCESS: "live_editor_atto_web_start_success",
  LIVE_EDITOR_ATTO_WEB_START_FAILURE: "live_editor_atto_web_start_failure",
  // Desktop Recording Session Events
  LIVE_EDITOR_DESKTOP_RECORDING_START_REQUEST: "live_editor_desktop_recording_start_request",
  LIVE_EDITOR_DESKTOP_RECORDING_START_SUCCESS: "live_editor_desktop_recording_start_success",
  LIVE_EDITOR_DESKTOP_RECORDING_START_FAILURE: "live_editor_desktop_recording_start_failure",
  // Desktop Step Recording Session Events
  LIVE_EDITOR_DESKTOP_STEP_RECORDING_START_REQUEST: "live_editor_desktop_step_recording_start_request",
  LIVE_EDITOR_DESKTOP_STEP_RECORDING_START_SUCCESS: "live_editor_desktop_step_recording_start_success",
  LIVE_EDITOR_DESKTOP_STEP_RECORDING_START_FAILURE: "live_editor_desktop_step_recording_start_failure",
  ANALYZER_POSITIVE_FEEDBACK: "Analyzer Positive Feedback",
  ANALYZER_NEGATIVE_FEEDBACK: "Analyzer Negative Feedback",
  AI_ANALYZER_ADD_STEP: "ai_analyzer_add_step",
  AI_ANALYZER_UPDATE_STEP: "ai_analyzer_update_step"
};
var ANALYTICS_EVENTS = {
  AMPLITUDE
};
var analytics_constants_default = ANALYTICS_EVENTS;
var { Button: Button27, BUTTON_VARIANTS: BUTTON_VARIANTS9, BUTTON_SIZE: BUTTON_SIZE9 } = V2;
var DebuggerActionsButton = ({
  shouldDisableResume: shouldDisableResumeProps,
  onResumeExecution,
  onStepOverExecution,
  onSkipOverExecution,
  onRestartExecution
}) => {
  const [shouldDisableResume, setShouldDisableResume] = useState(
    shouldDisableResumeProps
  );
  const { t } = useTranslation();
  const handleResumeExecution = useCallback(() => {
    setShouldDisableResume(true);
    logEvent(analytics_constants_default.AMPLITUDE.LIVE_EDITOR_RESUME_EXECUTION);
    onResumeExecution("-1");
  }, [onResumeExecution]);
  const handleSkipOverExecution = useCallback(() => {
    setShouldDisableResume(true);
    logEvent(
      analytics_constants_default.AMPLITUDE.LIVE_EDITOR_SKIP_OVER_EXECUTION
    );
    onSkipOverExecution("-1");
  }, [onSkipOverExecution]);
  const handleStepOverExecution = useCallback(() => {
    setShouldDisableResume(true);
    logEvent(
      analytics_constants_default.AMPLITUDE.LIVE_EDITOR_STEP_OVER_EXECUTION
    );
    onStepOverExecution("-1");
  }, [onStepOverExecution]);
  const handleRestartExecution = useCallback(() => {
    setShouldDisableResume(true);
    logEvent(analytics_constants_default.AMPLITUDE.LIVE_EDITOR_RESTART_EXECUTION);
    onRestartExecution();
  }, [onRestartExecution]);
  useEffect(() => {
    setShouldDisableResume(shouldDisableResumeProps);
  }, [shouldDisableResumeProps]);
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-row items-center gap-1.5", children: [
    /* @__PURE__ */ jsx(
      Button27,
      {
        variant: BUTTON_VARIANTS9.PRIMARY,
        size: BUTTON_SIZE9.SMALLEST,
        className: "text-[12px] h-8 shadow-debugger-icon",
        disabled: shouldDisableResume,
        onClick: handleResumeExecution,
        children: t("common.liveEditor.resume")
      }
    ),
    /* @__PURE__ */ jsx("div", { className: "h-5 w-[1px] bg-slate-200" }),
    /* @__PURE__ */ jsx(ToolTip, { content: t("debug_run.option.stepover"), children: /* @__PURE__ */ jsx(
      Button27,
      {
        variant: BUTTON_VARIANTS9.SECONDARY,
        iconLeft: "skip",
        className: "text-base h-8 w-8 !px-1 shadow-debugger-icon !border-[0.5px] !border-[#E2E7EE]",
        size: BUTTON_SIZE9.SMALLEST,
        disabled: shouldDisableResume,
        onClick: handleStepOverExecution,
        iconStyles: "icon-primary text-xl"
      }
    ) }),
    /* @__PURE__ */ jsx(ToolTip, { content: t("debug_run.option.skipover"), children: /* @__PURE__ */ jsx(
      Button27,
      {
        variant: BUTTON_VARIANTS9.SECONDARY,
        iconLeft: "step-over-live-editor",
        size: BUTTON_SIZE9.SMALLEST,
        className: "text-base h-8 w-8 !px-1 shadow-debugger-icon !border-[0.5px] !border-[#E2E7EE]",
        disabled: shouldDisableResume,
        onClick: handleSkipOverExecution,
        iconStyles: "icon-primary text-xl"
      }
    ) }),
    /* @__PURE__ */ jsx(ToolTip, { content: t("debug_run.option.restart_execution"), children: /* @__PURE__ */ jsx(
      Button27,
      {
        variant: BUTTON_VARIANTS9.SECONDARY,
        iconLeft: "restart-live-editor",
        className: "text-base h-8 w-8 !px-1 shadow-debugger-icon !border-[0.5px] !border-[#E2E7EE]",
        size: BUTTON_SIZE9.SMALLEST,
        onClick: handleRestartExecution,
        iconStyles: "icon-primary text-xl"
      }
    ) })
  ] });
};
var debugger_actions_buttons_default = React5__default.memo(DebuggerActionsButton);
var StopLiveEditorIcon = () => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      viewBox: "2 0 16 16",
      fill: "none",
      style: { display: "block" },
      children: [
        /* @__PURE__ */ jsxs("g", { filter: "url(#filter0_dd_3554_16278)", children: [
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M2 5C2 2.23858 4.23858 0 7 0H13C15.7614 0 18 2.23858 18 5V11C18 13.7614 15.7614 16 13 16H7C4.23858 16 2 13.7614 2 11V5Z",
              fill: "#DC2626"
            }
          ),
          /* @__PURE__ */ jsx(
            "mask",
            {
              id: "mask0_3554_16278",
              style: { maskType: "alpha" },
              maskUnits: "userSpaceOnUse",
              x: "5",
              y: "3",
              width: "10",
              height: "10",
              children: /* @__PURE__ */ jsx(
                "rect",
                {
                  x: "5.3335",
                  y: "3.33301",
                  width: "9.33333",
                  height: "9.33333",
                  fill: "#D9D9D9"
                }
              )
            }
          ),
          /* @__PURE__ */ jsx("g", { mask: "url(#mask0_3554_16278)", children: /* @__PURE__ */ jsx(
            "path",
            {
              d: "M8.8 9.6H11.2C11.3133 9.6 11.4083 9.56167 11.485 9.485C11.5617 9.40833 11.6 9.31333 11.6 9.2V6.8C11.6 6.68667 11.5617 6.59167 11.485 6.515C11.4083 6.43833 11.3133 6.4 11.2 6.4H8.8C8.68667 6.4 8.59167 6.43833 8.515 6.515C8.43833 6.59167 8.4 6.68667 8.4 6.8V9.2C8.4 9.31333 8.43833 9.40833 8.515 9.485C8.59167 9.56167 8.68667 9.6 8.8 9.6ZM10 12C9.44667 12 8.92667 11.895 8.44 11.685C7.95333 11.475 7.53 11.19 7.17 10.83C6.81 10.47 6.525 10.0467 6.315 9.56C6.105 9.07333 6 8.55333 6 8C6 7.44667 6.105 6.92667 6.315 6.44C6.525 5.95333 6.81 5.53 7.17 5.17C7.53 4.81 7.95333 4.525 8.44 4.315C8.92667 4.105 9.44667 4 10 4C10.5533 4 11.0733 4.105 11.56 4.315C12.0467 4.525 12.47 4.81 12.83 5.17C13.19 5.53 13.475 5.95333 13.685 6.44C13.895 6.92667 14 7.44667 14 8C14 8.55333 13.895 9.07333 13.685 9.56C13.475 10.0467 13.19 10.47 12.83 10.83C12.47 11.19 12.0467 11.475 11.56 11.685C11.0733 11.895 10.5533 12 10 12Z",
              fill: "white"
            }
          ) })
        ] }),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
          "filter",
          {
            id: "filter0_dd_3554_16278",
            x: "-5.96046e-08",
            y: "0",
            width: "20",
            height: "20.6667",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
              /* @__PURE__ */ jsx(
                "feColorMatrix",
                {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                  result: "hardAlpha"
                }
              ),
              /* @__PURE__ */ jsx("feOffset", { dy: "0.666667" }),
              /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: "0.333333" }),
              /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
              /* @__PURE__ */ jsx(
                "feColorMatrix",
                {
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
                }
              ),
              /* @__PURE__ */ jsx(
                "feBlend",
                {
                  mode: "normal",
                  in2: "BackgroundImageFix",
                  result: "effect1_dropShadow_3554_16278"
                }
              ),
              /* @__PURE__ */ jsx(
                "feColorMatrix",
                {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                  result: "hardAlpha"
                }
              ),
              /* @__PURE__ */ jsx(
                "feMorphology",
                {
                  radius: "0.666667",
                  operator: "erode",
                  in: "SourceAlpha",
                  result: "effect2_dropShadow_3554_16278"
                }
              ),
              /* @__PURE__ */ jsx("feOffset", { dy: "2.66667" }),
              /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: "1.33333" }),
              /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
              /* @__PURE__ */ jsx(
                "feColorMatrix",
                {
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
                }
              ),
              /* @__PURE__ */ jsx(
                "feBlend",
                {
                  mode: "normal",
                  in2: "effect1_dropShadow_3554_16278",
                  result: "effect2_dropShadow_3554_16278"
                }
              ),
              /* @__PURE__ */ jsx(
                "feBlend",
                {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "effect2_dropShadow_3554_16278",
                  result: "shape"
                }
              )
            ]
          }
        ) })
      ]
    }
  );
};
var RecordLiveEditorIcon = () => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      viewBox: "3 0 16 16",
      fill: "none",
      style: { display: "block" },
      children: [
        /* @__PURE__ */ jsxs("g", { filter: "url(#filter0_dd_3554_16213)", children: [
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M3 5C3 2.23858 5.23858 0 8 0H14C16.7614 0 19 2.23858 19 5V11C19 13.7614 16.7614 16 14 16H8C5.23858 16 3 13.7614 3 11V5Z",
              fill: "#DC2626"
            }
          ),
          /* @__PURE__ */ jsx(
            "mask",
            {
              id: "mask0_3554_16213",
              style: { maskType: "alpha" },
              maskUnits: "userSpaceOnUse",
              x: "4",
              y: "1",
              width: "14",
              height: "14",
              children: /* @__PURE__ */ jsx("rect", { x: "4", y: "1", width: "14", height: "14", fill: "#D9D9D9" })
            }
          ),
          /* @__PURE__ */ jsx("g", { mask: "url(#mask0_3554_16213)", children: /* @__PURE__ */ jsx(
            "path",
            {
              d: "M11 12C9.88571 12 8.94048 11.6119 8.16429 10.8357C7.3881 10.0595 7 9.11429 7 8C7 6.88571 7.3881 5.94048 8.16429 5.16429C8.94048 4.3881 9.88571 4 11 4C12.1143 4 13.0595 4.3881 13.8357 5.16429C14.6119 5.94048 15 6.88571 15 8C15 9.11429 14.6119 10.0595 13.8357 10.8357C13.0595 11.6119 12.1143 12 11 12Z",
              fill: "white"
            }
          ) })
        ] }),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
          "filter",
          {
            id: "filter0_dd_3554_16213",
            x: "0",
            y: "0",
            width: "22",
            height: "23",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
              /* @__PURE__ */ jsx(
                "feColorMatrix",
                {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                  result: "hardAlpha"
                }
              ),
              /* @__PURE__ */ jsx("feOffset", { dy: "1" }),
              /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: "0.5" }),
              /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
              /* @__PURE__ */ jsx(
                "feColorMatrix",
                {
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
                }
              ),
              /* @__PURE__ */ jsx(
                "feBlend",
                {
                  mode: "normal",
                  in2: "BackgroundImageFix",
                  result: "effect1_dropShadow_3554_16213"
                }
              ),
              /* @__PURE__ */ jsx(
                "feColorMatrix",
                {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                  result: "hardAlpha"
                }
              ),
              /* @__PURE__ */ jsx(
                "feMorphology",
                {
                  radius: "1",
                  operator: "erode",
                  in: "SourceAlpha",
                  result: "effect2_dropShadow_3554_16213"
                }
              ),
              /* @__PURE__ */ jsx("feOffset", { dy: "4" }),
              /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: "2" }),
              /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
              /* @__PURE__ */ jsx(
                "feColorMatrix",
                {
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
                }
              ),
              /* @__PURE__ */ jsx(
                "feBlend",
                {
                  mode: "normal",
                  in2: "effect1_dropShadow_3554_16213",
                  result: "effect2_dropShadow_3554_16213"
                }
              ),
              /* @__PURE__ */ jsx(
                "feBlend",
                {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "effect2_dropShadow_3554_16213",
                  result: "shape"
                }
              )
            ]
          }
        ) })
      ]
    }
  );
};
var ToolTip39 = ToolTip;
var ActionIcon = ({
  tooltip,
  icon,
  onClick,
  iconClass = "",
  className = "",
  buttonClassName = ""
}) => /* @__PURE__ */ jsx(ToolTip39, { content: tooltip, className: `flex shrink-0 ml-2 ${className}`, children: /* @__PURE__ */ jsx(
  "button",
  {
    type: "button",
    className: classNames82(
      "cursor-pointer flex items-center justify-center h-6 w-6 rounded-md border border-[#E2E7EE]",
      buttonClassName
    ),
    onClick,
    "aria-label": tooltip,
    children: /* @__PURE__ */ jsx(Icon, { name: icon, className: `w-4 h-4 ${iconClass} ` })
  }
) });
var ActionIcon_default = ActionIcon;
var V2ButtonMain = V2.Button;
var BUTTON_VARIANTS10 = V2.BUTTON_VARIANTS;
var BUTTON_SIZE10 = V2.BUTTON_SIZE;
var MaximizeMinimize = ({
  isMaximized,
  isRecording,
  togglePause,
  stopRecording,
  className = "",
  toggleView,
  isInitializing,
  locatorPrecedence
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx("div", { className: classNames82("flex items-center", className), children: !isInitializing && /* @__PURE__ */ jsx(Fragment, { children: locatorPrecedence && locatorPrecedence }) });
};
var ActionIcons = ({
  isMaximized,
  isRecording,
  togglePause,
  stopRecording,
  className = "",
  toggleView,
  isInitializing
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs("div", { className: classNames82("flex items-center gap-3", className), children: [
    !isInitializing && /* @__PURE__ */ jsxs(Fragment, { children: [
      isRecording && /* @__PURE__ */ jsx(
        ToolTip,
        {
          content: t("common.pause.recording"),
          className: "inline-flex item-center",
          children: /* @__PURE__ */ jsxs(
            "span",
            {
              className: "inline-flex gap-1 cursor-pointer",
              onClick: () => togglePause(true),
              children: [
                /* @__PURE__ */ jsx(Icon, { name: "pause", className: "text-secondary-900 text-base" }),
                /* @__PURE__ */ jsx("span", { className: "text-secondary-900 text-xs", children: t("common.pause") })
              ]
            }
          )
        }
      ),
      !isRecording && /* @__PURE__ */ jsx(
        ToolTip,
        {
          content: t("common.resume.recording"),
          className: "inline-flex item-center",
          children: /* @__PURE__ */ jsxs(
            "span",
            {
              className: "inline-flex gap-1 cursor-pointer",
              onClick: () => togglePause(false),
              children: [
                /* @__PURE__ */ jsx(
                  Icon,
                  {
                    name: "pause-circle",
                    className: "text-primary-600 text-base"
                  }
                ),
                /* @__PURE__ */ jsx("span", { className: "text-secondary-900 text-xs", children: t("common.resume") })
              ]
            }
          )
        }
      )
    ] }),
    !isInitializing && /* @__PURE__ */ jsx("span", { className: "h-5 w-[1px] bg-neutral-100" }),
    /* @__PURE__ */ jsx(
      ToolTip,
      {
        content: t("common.stop.recording"),
        className: "inline-flex item-center",
        children: /* @__PURE__ */ jsxs(
          "span",
          {
            onClick: stopRecording,
            className: classNames82("inline-flex gap-1 cursor-pointer"),
            children: [
              /* @__PURE__ */ jsx(
                Icon,
                {
                  name: "stop-circle-outline",
                  className: classNames82("text-red-600 text-lg")
                }
              ),
              /* @__PURE__ */ jsx("span", { className: "text-secondary-900 text-xs", children: t("common.stop") })
            ]
          }
        )
      }
    )
  ] });
};
var ActionIconsMobileDebugger = memo(
  ({
    isRecording = false,
    togglePause = NOOP,
    disableRecordOption = false,
    //@ts-ignore will be fixing
    locatorPrecedence = null
  }) => {
    const { t } = useTranslation();
    const [captureStepId, setCaptureStepId] = useState(null);
    const [captureBlockUuid, setCaptureBlockUuid] = useState(
      null
    );
    const [captureMode, setCaptureMode] = useState(
      "normal"
    );
    const handleStopCapture = () => {
      if (window["__directCaptureResolver"]) {
        window["__directCaptureResolver"].resolve({ action: "DISCARDED" });
        delete window["__directCaptureResolver"];
      }
      window.dispatchEvent(
        new CustomEvent("element-capture-end", {
          detail: { stepId: captureStepId, blockUuid: captureBlockUuid }
        })
      );
    };
    const handleRecordingClick = (e) => {
      e.stopPropagation();
      if (disableRecordOption) return;
      if (isRecording) {
        togglePause(true);
      } else {
        togglePause(false);
      }
    };
    const getTooltipContent = () => {
      if (disableRecordOption)
        return "Cannot record while debugging is running";
      return isRecording ? t("live-editor.stop_recording_tooltip") : t("live-editor.start_recording_tooltip");
    };
    const recordingButtonClasses = classNames82(
      "h-4 w-4 rounded-md flex items-center justify-center transition-all duration-300 flex justify-center items-center",
      {
        "cursor-not-allowed opacity-50": disableRecordOption,
        "cursor-pointer": !disableRecordOption
      }
    );
    useEffect(() => {
      if (!isRecording) {
        togglePause(true);
      }
    }, [isRecording]);
    useEffect(() => {
      const handleElementCaptureStart = (event) => {
        if (event.detail?.stepId) {
          setCaptureMode("capturing");
          setCaptureStepId(event.detail?.stepId || null);
          setCaptureBlockUuid(event.detail?.blockUuid || null);
          logEvent(
            analytics_constants_default.AMPLITUDE.LIVE_EDITOR_ELEMENT_CAPTURE_START
          );
        }
      };
      const handleElementCaptureEnd = () => {
        setCaptureMode("normal");
        setCaptureStepId(null);
        setCaptureBlockUuid(null);
        logEvent(
          analytics_constants_default.AMPLITUDE.LIVE_EDITOR_ELEMENT_CAPTURE_STOP
        );
      };
      window.addEventListener(
        "element-capture-start",
        handleElementCaptureStart
      );
      window.addEventListener("element-capture-end", handleElementCaptureEnd);
      return () => {
        window.removeEventListener(
          "element-capture-start",
          handleElementCaptureStart
        );
        window.removeEventListener(
          "element-capture-end",
          handleElementCaptureEnd
        );
      };
    }, [isRecording]);
    const captureButtonClasses = classNames82(
      "!px-[5px] text-base text-secondary-500 leading-4 h-8",
      {
        "pointer-events-none opacity-60": disableRecordOption
      }
    );
    const CapturingUI = () => /* @__PURE__ */ jsxs(
      V2ButtonMain,
      {
        variant: BUTTON_VARIANTS10.SECONDARY,
        size: BUTTON_SIZE10.SMALLEST,
        className: classNames82(captureButtonClasses, "shadow-debugger-icon !border-[0.5px] !border-[#E2E7EE]"),
        onClick: handleStopCapture,
        children: [
          /* @__PURE__ */ jsx("div", { className: recordingButtonClasses, children: /* @__PURE__ */ jsx(StopLiveEditorIcon, {}) }),
          t("live-editor.listening")
        ]
      }
    );
    const RecordingUI = () => /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-center gap-1.5", children: [
      /* @__PURE__ */ jsx(ToolTip, { content: getTooltipContent(), children: /* @__PURE__ */ jsxs(
        V2ButtonMain,
        {
          variant: BUTTON_VARIANTS10.SECONDARY,
          size: BUTTON_SIZE10.SMALLEST,
          className: classNames82(
            captureButtonClasses,
            "shadow-debugger-icon !border-[0.5px] !border-[#E2E7EE]"
          ),
          onClick: handleRecordingClick,
          children: [
            /* @__PURE__ */ jsx("div", { className: recordingButtonClasses, children: isRecording ? /* @__PURE__ */ jsx(StopLiveEditorIcon, {}) : /* @__PURE__ */ jsx(RecordLiveEditorIcon, {}) }),
            isRecording ? t("live-editor.stop_recording_tooltip") : t("live-editor.rec")
          ]
        }
      ) }),
      isRecording && /* @__PURE__ */ jsx("div", { className: "h-7 w-[1px] bg-slate-200" }),
      isRecording && /* @__PURE__ */ jsx("div", { id: "mi-locator-precedence", children: locatorPrecedence })
    ] });
    return captureMode === "capturing" ? /* @__PURE__ */ jsx(CapturingUI, {}) : /* @__PURE__ */ jsx(RecordingUI, {});
  }
);
ActionIconsMobileDebugger.displayName = "ActionIconsMobileDebugger";
var Logo = ({ isRecording }) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs("span", { className: "relative", children: [
    /* @__PURE__ */ jsx(
      "img",
      {
        src: testSigmaLogoDark,
        className: "w-5 h-5 mr-2",
        alt: t("common.testsigma.logo")
      }
    ),
    /* @__PURE__ */ jsx("span", { className: "right-1 top-0 w-2.5 h-2.5 bg-secondary-50 rounded-full absolute flex justify-center items-center", children: /* @__PURE__ */ jsx(
      "span",
      {
        className: classNames82(
          "right-1 top-0 w-[7px] h-[7px] bg-red-600 rounded-full",
          {
            "step-recording": isRecording,
            "bg-secondary-500": !isRecording
          }
        )
      }
    ) })
  ] });
};
var MaximizedView = ({
  isRecording,
  togglePause,
  stopRecording,
  testCaseName,
  onSaveReorder,
  onCancelReorder,
  className,
  isReorderMode,
  children,
  toggleView,
  isInitializing,
  testCaseResult,
  isDebuggerSession,
  locatorPrecedence,
  lhs,
  header,
  modifiedSteps = {},
  testSteps = /* @__PURE__ */ new Map(),
  stepResults = [],
  debuggerActions = {},
  isExeuctionQueuedOrPaused = false,
  onRestartExecution = NOOP
}) => {
  const { t } = useTranslation();
  const [isSaving, updateSaving] = useState(false);
  const stepHighlightByStatus = execution_icon_default(testCaseResult?.result);
  const isMobileDebugger2 = Boolean(
    window.location.pathname.includes("/debugrun")
  );
  const {
    resumeExecution = NOOP,
    stepOverExecution = NOOP,
    skipOverExecution = NOOP
  } = debuggerActions || {};
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames82(
        "flex bg-white shadow-ts max-w-full relative flex-grow overflow-hidden",
        className
      ),
      children: [
        lhs,
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: classNames82("flex flex-col flex-grow", {
              "border-l-[0.5px] border-l-secondary-300": !!lhs
            }),
            children: [
              /* @__PURE__ */ jsxs("div", { className: "bg-secondary-50 px-3 py-2 flex border border-white", children: [
                /* @__PURE__ */ jsxs("div", { className: "flex-grow flex items-center gap-1.5", children: [
                  /* @__PURE__ */ jsx(Logo, { isRecording: isRecording && !isInitializing }),
                  /* @__PURE__ */ jsx("span", { className: "text-unique-600 text-small leading-5 font-semibold inline-flex w-[290px]", children: /* @__PURE__ */ jsx(
                    TruncatedText,
                    {
                      className: "!font-semibold flex-grow break-all !text-small leading-5",
                      value: testCaseName
                    }
                  ) }),
                  /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-1.5 justify-end w-full", children: [
                    header,
                    isDebuggerSession && /* @__PURE__ */ jsx(
                      ActionIcon_default,
                      {
                        tooltip: "Exit Copilot",
                        icon: "exit",
                        onClick: stopRecording,
                        buttonClassName: "h-7 !w-7 shadow-debugger-icon",
                        iconClass: "text-error-600",
                        className: "h-7 !w-7 shadow-debugger-icon"
                      }
                    )
                  ] })
                ] }),
                /* @__PURE__ */ jsx(
                  MaximizeMinimize,
                  {
                    isMaximized: true,
                    isRecording,
                    togglePause,
                    stopRecording,
                    toggleView,
                    isInitializing,
                    locatorPrecedence: !isDebuggerSession ? locatorPrecedence : null
                  },
                  isInitializing
                )
              ] }),
              /* @__PURE__ */ jsxs("div", { className: "flex items-center px-3 py-1.5 border-b-[0.5px] border-b-secondary-200 flex-shrink-0", children: [
                isDebuggerSession ? null : stepHighlightByStatus?.icon,
                /* @__PURE__ */ jsx("div", { className: "flex-grow ml-2", children: isDebuggerSession && /* @__PURE__ */ jsx(
                  debugger_actions_buttons_default,
                  {
                    shouldDisableResume: isExeuctionQueuedOrPaused,
                    onResumeExecution: resumeExecution,
                    onStepOverExecution: stepOverExecution,
                    onSkipOverExecution: skipOverExecution,
                    onRestartExecution
                  }
                ) }),
                isMobileDebugger2 ? /* @__PURE__ */ jsx(
                  ActionIconsMobileDebugger,
                  {
                    isRecording,
                    togglePause,
                    stopRecording,
                    disableRecordOption: !!isExeuctionQueuedOrPaused,
                    locatorPrecedence
                  }
                ) : /* @__PURE__ */ jsx(
                  ActionIcons,
                  {
                    isMaximized: true,
                    isRecording,
                    togglePause,
                    stopRecording,
                    toggleView,
                    isInitializing
                  },
                  isInitializing
                )
              ] }),
              /* @__PURE__ */ jsx("div", { className: "overflow-hidden flex-grow", children }),
              isRecording && /* @__PURE__ */ jsx("div", { className: "flex " }),
              isReorderMode && /* @__PURE__ */ jsxs("div", { className: "h-[48px] flex px-4 py-3 shadow-y-sm flex-row-reverse gap-3", children: [
                /* @__PURE__ */ jsxs(
                  Button,
                  {
                    type: "primary",
                    className: "text-small leading-5",
                    size: "sm",
                    onClick: () => onSaveReorder(updateSaving),
                    isDisabled: isSaving,
                    children: [
                      " ",
                      t("common.save.reorder"),
                      " "
                    ]
                  }
                ),
                /* @__PURE__ */ jsxs(
                  Button,
                  {
                    type: "secondary-light",
                    className: "text-small leading-5",
                    size: "sm",
                    onClick: onCancelReorder,
                    children: [
                      " ",
                      t("common.cancel"),
                      " "
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ jsx("div", { id: "mi-authoring-portal" })
            ]
          }
        )
      ]
    }
  );
};
var MinimizedView = ({
  className,
  children,
  isRecording,
  togglePause,
  stopRecording,
  toggleView,
  lastTestStep,
  isInitializing,
  locatorPrecedence,
  lhs
}) => {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames82(
        "flex flex-col bg-white shadow-ts max-w-full overflow-scroll relative flex-grow",
        "overflow-hidden",
        className
      ),
      children: [
        lhs,
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: classNames82("flex flex-col flex-grow", {
              "border-l-[0.5px] border-l-secondary-300": !!lhs
            }),
            children: [
              /* @__PURE__ */ jsxs("div", { className: "border-b-[0.5px] border-b-secondary-200 flex h-12 items-center px-4 py-3", children: [
                /* @__PURE__ */ jsx(Logo, { isRecording: isRecording && !isInitializing }),
                /* @__PURE__ */ jsx("div", { className: "bg-secondary-50 flex-grow overflow-hidden", children: lastTestStep }),
                /* @__PURE__ */ jsx(
                  MaximizeMinimize,
                  {
                    isMaximized: false,
                    isRecording,
                    togglePause,
                    stopRecording,
                    toggleView,
                    className: "ml-3",
                    isInitializing,
                    locatorPrecedence
                  },
                  isInitializing
                )
              ] }),
              /* @__PURE__ */ jsx("div", { className: "flex items-center px-4 h-[30px] border-b-[0.5px] border-b-secondary-200 justify-end flex-shrink-0", children: /* @__PURE__ */ jsx(
                ActionIcons,
                {
                  isMaximized: true,
                  isRecording,
                  togglePause,
                  stopRecording,
                  toggleView,
                  isInitializing
                },
                isInitializing
              ) }),
              /* @__PURE__ */ jsx("div", { className: "flex-grow", children })
            ]
          }
        )
      ]
    }
  );
};
var TestRecorder = ({
  testCaseName,
  className = "",
  isMaximized = true,
  toggleView = NOOP,
  isReorderMode = true,
  onSaveReorder,
  onCancelReorder,
  children,
  isRecording = true,
  togglePause = (value) => {
  },
  stopRecording = NOOP,
  lastTestStep,
  isInitializing = true,
  testCaseResult,
  isDebuggerSession = false,
  locatorPrecedence,
  lhs = null,
  header = null,
  modifiedSteps = {},
  testSteps = /* @__PURE__ */ new Map(),
  stepResults = [],
  debuggerActions = {},
  isExeuctionQueuedOrPaused = false,
  onRestartExecution = NOOP
}) => {
  if (!isMaximized) {
    return /* @__PURE__ */ jsx(
      MinimizedView,
      {
        className,
        isRecording,
        togglePause,
        isInitializing,
        stopRecording,
        toggleView,
        lastTestStep,
        locatorPrecedence,
        lhs,
        children
      }
    );
  } else
    return /* @__PURE__ */ jsxs(
      MaximizedView,
      {
        isRecording,
        togglePause,
        stopRecording,
        isInitializing,
        testCaseName,
        onSaveReorder,
        onCancelReorder,
        className,
        isReorderMode,
        toggleView,
        testCaseResult,
        isDebuggerSession,
        locatorPrecedence,
        lhs,
        header,
        modifiedSteps,
        testSteps,
        stepResults,
        debuggerActions,
        isExeuctionQueuedOrPaused,
        onRestartExecution,
        children: [
          children,
          " "
        ]
      }
    );
};
var queryClientInstance = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      gcTime: 0
    }
  }
});
var PageLayoutHeader = ({ children }) => {
  return /* @__PURE__ */ jsx("div", { className: "py-3.25 px-8 flex justify-between border-b border-secondary-100 z-10 items-center", children });
};
var PageLayoutBody = ({ children }) => {
  return /* @__PURE__ */ jsx("div", { className: "py-5 px-8", children });
};
var PageLayout = ({ children }) => {
  return /* @__PURE__ */ jsx("div", { className: "flex flex-col h-full w-[calc(100%-220px)] overflow-hidden", children });
};
PageLayout.Header = PageLayoutHeader;
PageLayout.Body = PageLayoutBody;
PageLayout.displayName = "PageLayout";
PageLayoutHeader.displayName = "PageLayoutHeader";
PageLayoutBody.displayName = "PageLayoutBody";
var page_layout_default = PageLayout;
var Chip = ({
  label,
  count,
  onRemove,
  variant = "default" /* Default */
}) => /* @__PURE__ */ jsx("div", { className: "cursor-pointer inline-block", children: /* @__PURE__ */ jsxs(
  "label",
  {
    className: classNames82(
      "flex text-xs text-secondary-unique-600 font-normal bg-white pl-4 pr-2 py-0.5 rounded-xl min-w-0 max-w-fit",
      {
        border: variant === "bordered" /* Bordered */
      }
    ),
    children: [
      /* @__PURE__ */ jsx("span", { className: "flex-grow truncate min-w-0", children: label }),
      count && /* @__PURE__ */ jsxs("span", { className: "text-xm font-normal ml-0.5 text-unique-800 whitespace-nowrap flex-shrink-0", children: [
        "(",
        count,
        ")"
      ] }),
      onRemove ? /* @__PURE__ */ jsx(
        Icon,
        {
          name: "close",
          className: "text-secondary-600 text-lg align-middle ml-2  cursor-pointer flex-shrink-0",
          onClick: onRemove
        }
      ) : null
    ]
  }
) });

// src/components/filterV2/types.ts
var getDefaultOperation = (filterType) => {
  switch (filterType) {
    case "checkbox" /* CHECKBOX */:
      return "IN" /* IN */;
    case "radio" /* RADIO */:
    case "select" /* SELECT */:
      return "EQUALITY" /* EQUALITY */;
    case "text" /* TEXT */:
      return "CONTAINS" /* CONTAINS */;
    case "date-range" /* DATE_RANGE */:
    case "number-range" /* NUMBER_RANGE */:
    case "date-time-input-range" /* DATE_TIME_INPUT_RANGE */:
      return "BETWEEN" /* BETWEEN */;
    case "date-single" /* DATE_SINGLE */:
      return "EQUALITY" /* EQUALITY */;
    case "custom" /* CUSTOM */:
    default:
      return "IN" /* IN */;
  }
};

// src/components/filterV2/utils/filter-query-generator.ts
var convertToUTCTimestamp = (dateValue) => {
  if (!dateValue || typeof dateValue !== "string") {
    return dateValue;
  }
  try {
    const date = new Date(dateValue);
    if (isNaN(date.getTime())) {
      return dateValue;
    }
    return date.getTime().toString();
  } catch (error) {
    return dateValue;
  }
};
var getSearchOperationSymbol = (operation) => {
  switch (operation) {
    case "EQUALITY" /* EQUALITY */:
      return ":";
    case "NEGATION" /* NEGATION */:
      return "!";
    case "GREATER_THAN" /* GREATER_THAN */:
      return ">";
    case "LESS_THAN" /* LESS_THAN */:
      return "<";
    case "CONTAINS" /* CONTAINS */:
      return "$";
    case "IN" /* IN */:
      return "@";
    case "NOT_IN" /* NOT_IN */:
      return ";";
    case "STARTS_WITH" /* STARTS_WITH */:
    case "ENDS_WITH" /* ENDS_WITH */:
      return "~";
    case "BETWEEN" /* BETWEEN */:
    case "NOT_BETWEEN" /* NOT_BETWEEN */:
      return ":";
    case "IS_NULL" /* IS_NULL */:
      return "!";
    case "IS_NOT_NULL" /* IS_NOT_NULL */:
      return ":";
    case "NOT_CONTAINS" /* NOT_CONTAINS */:
      return "!";
    case "GREATER_THAN_OR_EQUAL" /* GREATER_THAN_OR_EQUAL */:
      return ">=";
    case "LESS_THAN_OR_EQUAL" /* LESS_THAN_OR_EQUAL */:
      return "<=";
    default:
      return ":";
  }
};
var getFilterOperationFromSymbol = (symbol) => {
  switch (symbol) {
    case ":":
      return "EQUALITY" /* EQUALITY */;
    case "!":
      return "NEGATION" /* NEGATION */;
    case ">":
      return "GREATER_THAN" /* GREATER_THAN */;
    case "<":
      return "LESS_THAN" /* LESS_THAN */;
    case "~":
      return "STARTS_WITH" /* STARTS_WITH */;
    case "@":
      return "IN" /* IN */;
    case ";":
      return "NOT_IN" /* NOT_IN */;
    case "$":
      return "CONTAINS" /* CONTAINS */;
    default:
      return "EQUALITY" /* EQUALITY */;
  }
};
var convertToAppliedFilters = (filterState) => {
  const appliedFilters = {};
  Object.entries(filterState).forEach(([filterId, config]) => {
    if (config.values && config.values.length > 0) {
      appliedFilters[filterId] = {
        operation: config.operation,
        type: config.type,
        values: config.values.map((value) => ({
          label: value.label,
          value: value.value
        }))
      };
    }
  });
  return appliedFilters;
};
var convertFromAppliedFilters = (appliedFilters) => {
  const filterState = {};
  Object.entries(appliedFilters).forEach(([filterId, filter2]) => {
    filterState[filterId] = {
      values: filter2.values.map((value) => ({
        label: value.label,
        value: value.value
      })),
      operation: filter2.operation,
      type: filter2.type,
      metadata: {}
    };
  });
  return filterState;
};
var generateQueryString = (appliedFilters) => {
  const queryParts = [];
  Object.entries(appliedFilters).forEach(([filterId, filter2]) => {
    if (filter2.values && filter2.values.length > 0) {
      switch (filter2.operation) {
        case "BETWEEN" /* BETWEEN */:
        case "NOT_BETWEEN" /* NOT_BETWEEN */:
          let rangeQueryParts = [];
          let startValue = filter2.values[0]?.value;
          let endValue = filter2.values[1]?.value;
          if (startValue) {
            if (filter2.type === "date-time-input-range" /* DATE_TIME_INPUT_RANGE */) {
              startValue = convertToUTCTimestamp(startValue);
            }
            rangeQueryParts.push(
              `${filterId}${getSearchOperationSymbol(
                "GREATER_THAN" /* GREATER_THAN */
                // THis should be GREATER_THAN_OR_EQUAL, but backend currently does not supports this.
              )}${startValue}`
            );
          }
          if (endValue) {
            if (filter2.type === "date-time-input-range" /* DATE_TIME_INPUT_RANGE */) {
              endValue = convertToUTCTimestamp(endValue);
            }
            rangeQueryParts.push(
              `${filterId}${getSearchOperationSymbol(
                "LESS_THAN" /* LESS_THAN */
                // THis should be LESS_THAN_OR_EQUAL, but backend currently does not supports this.
              )}${endValue}`
            );
          }
          queryParts.push(rangeQueryParts.join(","));
          break;
        case "IS_NULL" /* IS_NULL */:
          queryParts.push(
            `${filterId}${getSearchOperationSymbol("IS_NULL" /* IS_NULL */)}`
          );
          break;
        case "IS_NOT_NULL" /* IS_NOT_NULL */:
          queryParts.push(`${filterId}:*`);
          break;
        case "IN" /* IN */:
        case "NOT_IN" /* NOT_IN */:
          queryParts.push(`${filterId}${getSearchOperationSymbol(filter2.operation)}${filter2.values.map((v) => v.value).join("#")}`);
          break;
        default:
          const operationSymbol = getSearchOperationSymbol(filter2.operation);
          const values = filter2.values.map((v) => {
            let value = v.value;
            if (filter2.type === "date-time-input-range" /* DATE_TIME_INPUT_RANGE */) {
              value = convertToUTCTimestamp(value);
            }
            return value;
          }).join(",");
          queryParts.push(`${filterId}${operationSymbol}${values}`);
      }
    }
  });
  return queryParts.join(",");
};
var parseQueryString = (queryString) => {
  const appliedFilters = {};
  if (!queryString) return appliedFilters;
  const parts = queryString.split("&");
  parts.forEach((part) => {
    const operationMatch = part.match(/^([^:!><~@;$]+)([:!><~@;$])(.*)$/);
    if (operationMatch) {
      const [, filterId, operationSymbol, valuesString] = operationMatch;
      const operation = getFilterOperationFromSymbol(operationSymbol);
      if (operation === "IS_NULL" /* IS_NULL */) {
        appliedFilters[filterId] = {
          operation,
          type: "checkbox" /* CHECKBOX */,
          // Default type since we don't have original info
          values: []
        };
      } else if (operation === "IS_NOT_NULL" /* IS_NOT_NULL */) {
        appliedFilters[filterId] = {
          operation,
          type: "checkbox" /* CHECKBOX */,
          // Default type since we don't have original info
          values: [{ label: "Not Null", value: "*" }]
        };
      } else {
        const values = valuesString.split(",").map((value) => ({
          label: value,
          value
        }));
        appliedFilters[filterId] = {
          operation,
          type: "checkbox" /* CHECKBOX */,
          // Default type since we don't have original info
          values
        };
      }
    }
  });
  return appliedFilters;
};
var getFiltersCount = (appliedFilter) => {
  if (!appliedFilter) {
    return 0;
  }
  let appliedFilterValues = appliedFilter?.values ?? [];
  if (appliedFilter.type === "date-time-input-range" /* DATE_TIME_INPUT_RANGE */) {
    appliedFilterValues = appliedFilterValues.filter(
      (value) => value?.value != null
    );
  }
  return appliedFilterValues.length;
};
var axiosInstance = axios.create({
  // baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json"
  },
  timeout: 1e4
});
axiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    console.error("Request interceptor error:", error);
    return Promise.reject(error);
  }
);
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn("Auth token expired or invalid");
    }
    return Promise.reject(error);
  }
);
var customInstance = (config, options3) => {
  return axiosInstance({
    ...config,
    ...options3
    // Merge any extra options provided
  }).then(({ data }) => data);
};
var auditLogAxiosInstance = axiosInstance;

// src/generated-api/audit-logs/audit-log-controller/audit-log-controller.ts
var getAuditLogs = (params, options3, signal) => {
  return customInstance(
    { url: `/api/private/audit`, method: "GET", params, signal },
    options3
  );
};
var exportAuditLogs = (params, options3, signal) => {
  return customInstance(
    { url: `/api/private/audit/export`, method: "GET", params, signal },
    options3
  );
};
var getExportAuditLogsQueryKey = (params) => {
  return [`/api/private/audit/export`, ...params ? [params] : []];
};
var getExportAuditLogsQueryOptions = (params, options3) => {
  const { query: queryOptions, request: requestOptions } = options3 ?? {};
  const queryKey = queryOptions?.queryKey ?? getExportAuditLogsQueryKey(params);
  const queryFn = ({
    signal
  }) => exportAuditLogs(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useExportAuditLogs(params, options3, queryClient2) {
  const queryOptions = getExportAuditLogsQueryOptions(params, options3);
  const query = useQuery(queryOptions, queryClient2);
  query.queryKey = queryOptions.queryKey;
  return query;
}
var Loader = ({ message, loaderClassName = "" }) => {
  return /* @__PURE__ */ jsxs("div", { className: "flex justify-center items-center mt-2 px-2", children: [
    /* @__PURE__ */ jsx(If, { condition: Boolean(message), children: /* @__PURE__ */ jsx("span", { className: "text-xs text-gray-500", children: message }) }),
    /* @__PURE__ */ jsx(
      Icon,
      {
        name: "loader",
        className: `text-3xl text-secondary-500 animate-spin mx-auto ${loaderClassName}`
      }
    )
  ] });
};
var MAX_RETRY_ATTEMPTS = 3;
var RETRY_DELAY_MS = 1e3;
var AUDIT_LOG_AUTH_TOKEN_QUERY_KEY = "audit-log-auth-token";
var AUDIT_LOG_USERS_LIST_QUERY_KEY = "audit-log-users-list";
var AuthContext = createContext(void 0);
var loginInstance = axios.create({
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: true,
  timeout: 1e4
});
var fetchData = async (url, getter) => {
  const response = await loginInstance.get(url);
  return getter ? getter(response.data) : response.data;
};
var defaultTokenGetter = (data) => data.token;
var defaultUserMapGenerator = (data) => {
  return (data?.content ?? []).reduce((acc, user) => {
    acc[user.identityUserUUId] = {
      id: user.identityUserUUId,
      firstName: user.firstName,
      lastName: user.lastName,
      username: user.username,
      email: user.email
    };
    return acc;
  }, {});
};
var AuthProvider = ({
  loginUrl,
  children,
  tokenGetter = defaultTokenGetter,
  usersUrl,
  userMapGenerator = defaultUserMapGenerator,
  auditLogBaseUrl
}) => {
  const { t } = useTranslation();
  const queryClient2 = useQueryClient();
  const {
    data: authToken,
    isLoading: isAuthenticating,
    refetch: refetchTokenQuery
  } = useQuery({
    queryKey: [AUDIT_LOG_AUTH_TOKEN_QUERY_KEY, loginUrl],
    queryFn: () => fetchData(loginUrl, tokenGetter),
    retry: MAX_RETRY_ATTEMPTS,
    retryDelay: RETRY_DELAY_MS
  });
  const { data: usersListData, isLoading: isFetchingUsers } = useQuery({
    queryKey: [AUDIT_LOG_USERS_LIST_QUERY_KEY, usersUrl],
    queryFn: () => fetchData(usersUrl),
    retry: MAX_RETRY_ATTEMPTS
  });
  const usersMap = useMemo(() => {
    return userMapGenerator(usersListData);
  }, [usersListData]);
  const refetchToken = useCallback(async () => {
    try {
      await refetchTokenQuery();
    } catch (error) {
      console.error("Failed to refetch token:", error);
    }
  }, [refetchTokenQuery]);
  useEffect(() => {
    const interceptor = auditLogAxiosInstance.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (error.response?.status === 401) {
          await queryClient2.invalidateQueries({
            queryKey: [AUDIT_LOG_AUTH_TOKEN_QUERY_KEY, loginUrl]
          });
          return Promise.reject(error);
        }
        return Promise.reject(error);
      }
    );
    return () => {
      auditLogAxiosInstance.interceptors.response.eject(interceptor);
    };
  }, [queryClient2, loginUrl]);
  const value = {
    authToken: authToken ?? null,
    refetchToken,
    isAuthenticating,
    usersMap,
    auditLogBaseUrl
  };
  if (isAuthenticating) {
    return /* @__PURE__ */ jsx(
      Loader,
      {
        message: t("audit_logs.auth.authenticating"),
        loaderClassName: "text-3xl text-primary-500 animate-spin mx-auto"
      }
    );
  }
  if (!authToken) {
    return /* @__PURE__ */ jsx("div", { children: t("audit_logs.auth.authentication_failed") });
  }
  return /* @__PURE__ */ jsx(AuthContext.Provider, { value, children });
};
var useAuth = () => {
  const context = useContext(AuthContext);
  if (context === void 0) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

// src/modules/audit-logs/constant.ts
var AUDIT_LOG_PAGE_SIZE = 100;
var AUDIT_LOG_DEFAULT_ORDER_BY = "timestamp,desc";
var AUDIT_LOG_EMPTY_PAGE_FETCH_COUNT = 4;
var { Button: ButtonV28, BUTTON_VARIANTS: BUTTON_VARIANTS11 } = V2;
var ExportAuditLogContent = ({
  onClose,
  appliedFilters,
  filterConfig,
  onSuccess
}) => {
  const { t } = useTranslation();
  const [shouldFetch, setShouldFetch] = useState(false);
  const { authToken, auditLogBaseUrl } = useAuth();
  const filterQuery = generateQueryString(appliedFilters);
  const {
    data: exportAuditLogsData,
    isLoading,
    isSuccess,
    error
  } = useExportAuditLogs(
    {
      query: filterQuery,
      size: 100,
      sort: AUDIT_LOG_DEFAULT_ORDER_BY,
      page: 0,
      limit: 100
    },
    {
      query: {
        enabled: !!authToken && shouldFetch
        // Only enable when shouldFetch is true
      },
      request: {
        baseURL: auditLogBaseUrl,
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      }
    }
  );
  const handleExportClick = () => {
    setShouldFetch(true);
  };
  useEffect(() => {
    if (isSuccess) {
      onSuccess({ status: "IN_PROGRESS" });
    }
  }, [isSuccess]);
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ jsx("div", { className: "text-sm text-secondary-unique-600 font-medium", children: t("audit_logs.export.modal.description") }),
    /* @__PURE__ */ jsx("div", { className: "flex flex-col", children: Object.keys(appliedFilters).map((filterId) => {
      const currentFilterConfig = filterConfig.find(
        (f) => f.id === filterId
      );
      let selectedFilterValue = appliedFilters[filterId].values ?? [];
      if (currentFilterConfig.type === "date-time-input-range" /* DATE_TIME_INPUT_RANGE */) {
        selectedFilterValue = selectedFilterValue.filter((value) => value.value).map((value) => {
          return {
            label: `${value.label} - ${dayjs2(value.value).format(
              "DD MMM YYYY hh:mm a"
            )}  `,
            value: value.value
          };
        });
      }
      return /* @__PURE__ */ jsx(
        ExportFilterDetails,
        {
          filterLabel: currentFilterConfig.label,
          filterValues: selectedFilterValue
        },
        filterId
      );
    }) }),
    /* @__PURE__ */ jsx("div", { className: "flex mt-4", children: /* @__PURE__ */ jsxs("div", { className: "flex gap-3 ml-auto", children: [
      /* @__PURE__ */ jsx(ButtonV28, { onClick: onClose, variant: BUTTON_VARIANTS11.SECONDARY, children: t("audit_logs.export.cancel") }),
      /* @__PURE__ */ jsxs(
        ButtonV28,
        {
          disabled: isLoading,
          onClick: handleExportClick,
          variant: BUTTON_VARIANTS11.PRIMARY,
          children: [
            /* @__PURE__ */ jsx(If, { condition: isLoading, children: /* @__PURE__ */ jsx(Icon, { name: "loader", className: "text-base animate-spin mr-1" }) }),
            t("audit_logs.export.export")
          ]
        }
      )
    ] }) })
  ] });
};
var ExportFilterDetails = ({
  filterLabel,
  filterValues = []
}) => {
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col py-3", children: [
    /* @__PURE__ */ jsx("div", { className: "flex flex-col text-sm text-secondary-unique-600 font-medium", children: filterLabel }),
    /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-2 px-3 py-1.5 mt-2 bg-secondary-50 rounded-lg", children: filterValues.map((filterValue, index) => {
      return /* @__PURE__ */ jsx(Chip, { label: filterValue.label }, index);
    }) })
  ] });
};
var export_aduit_log_content_default = ExportAuditLogContent;
var ExportAuditLogsModal = ({
  open,
  toggle,
  exportSuccessRenderer,
  appliedFilters,
  filterConfig
}) => {
  const { t } = useTranslation();
  const [exportStep, setExportStep] = useState("EXPORT_FILE" /* EXPORT_FILE */);
  const handleExportSuccess = useCallback(() => {
    if (Boolean(exportSuccessRenderer)) {
      setExportStep("EXPORT_SUCCESS" /* EXPORT_SUCCESS */);
    } else {
      toggle();
    }
  }, [exportSuccessRenderer, toggle, setExportStep]);
  return /* @__PURE__ */ jsxs(
    Modal,
    {
      isOpen: open,
      onClose: toggle,
      className: "!rounded-lg !p-6 min-h-48 w-2/6",
      closeOnEscape: true,
      closeOnOutsideClick: true,
      children: [
        /* @__PURE__ */ jsx(If, { condition: exportStep === "EXPORT_SUCCESS" /* EXPORT_SUCCESS */, children: exportSuccessRenderer(toggle, { status: "IN_PROGRESS" }) }),
        /* @__PURE__ */ jsx(If, { condition: exportStep === "EXPORT_FILE" /* EXPORT_FILE */, children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col", children: [
          /* @__PURE__ */ jsxs("div", { className: "flex justify-between", children: [
            /* @__PURE__ */ jsxs("div", { className: "text-[18px] mb-6 text-secondary-unique-600 font-medium flex items-center", children: [
              /* @__PURE__ */ jsx(
                Icon,
                {
                  name: "export",
                  className: "text-2xl text-secondary-unique-600 mr-2 "
                }
              ),
              t("audit_logs.export.modal.title")
            ] }),
            /* @__PURE__ */ jsx("div", { className: "flex items-start", children: /* @__PURE__ */ jsx(
              Icon,
              {
                name: "close",
                className: "text-2xl text-secondary-unique-600 cursor-pointer",
                onClick: toggle
              }
            ) })
          ] }),
          /* @__PURE__ */ jsx(
            export_aduit_log_content_default,
            {
              onClose: toggle,
              appliedFilters,
              filterConfig,
              onSuccess: handleExportSuccess
            }
          )
        ] }) })
      ]
    }
  );
};
var { Button: ButtonV29 } = V2;
var ExportAuditLogs = ({
  appliedFilters,
  filterConfig,
  exportSuccessRenderer
}) => {
  const { t } = useTranslation();
  const [open, toggle] = useToggle();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(ButtonV29, { onClick: toggle, iconRight: "export", children: t("audit_logs.export.modal.title") }),
    /* @__PURE__ */ jsx(If, { condition: open, children: /* @__PURE__ */ jsx(
      ExportAuditLogsModal,
      {
        open,
        toggle,
        exportSuccessRenderer,
        appliedFilters,
        filterConfig
      }
    ) })
  ] });
};
var AuditLogPageHeader = ({
  filterConfig,
  appliedFilters,
  exportSuccessRenderer
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx("span", { className: "text-lg leading-5 font-semibold text-secondary-unique-600", children: t("audit_logs.header.label") }) }),
    /* @__PURE__ */ jsx(
      ExportAuditLogs,
      {
        appliedFilters,
        filterConfig,
        exportSuccessRenderer
      }
    )
  ] });
};
var FilterContext = createContext(null);
var FilterProvider = ({
  children,
  initialSelectedFilters = {},
  initialAppliedFilters = {},
  filterConfig = [],
  onFilterChange,
  onFiltersApply,
  onFiltersClear
}) => {
  const [selectedFilters, setSelectedFilters] = useState(
    initialSelectedFilters
  );
  const [appliedFilters, setAppliedFilters] = useState(
    initialAppliedFilters
  );
  const updateFilter = useCallback(
    (filterId, config) => {
      setSelectedFilters((prev) => {
        if (!config.values || config.values.length == 0) {
          let newState = { ...prev };
          if (newState[filterId]) {
            delete newState[filterId];
          }
          return newState;
        }
        return {
          ...prev,
          [filterId]: config
        };
      });
      if (onFilterChange) {
        onFilterChange(filterId, config);
      }
    },
    [onFilterChange]
  );
  const syncSelectedFilters = useCallback(() => {
    setSelectedFilters(appliedFilters);
  }, [appliedFilters]);
  const applyFilters = useCallback(() => {
    setAppliedFilters(selectedFilters);
    if (onFiltersApply) {
      onFiltersApply(selectedFilters);
    }
  }, [selectedFilters, onFiltersApply]);
  const clearFilter = useCallback((filterId) => {
    setSelectedFilters((prev) => {
      const newState = { ...prev };
      delete newState[filterId];
      return newState;
    });
  }, []);
  const clearAppliedFilter = useCallback((filterId) => {
    setAppliedFilters((prev) => {
      const newState = { ...prev };
      delete newState[filterId];
      return newState;
    });
  }, []);
  const clearAllAppliedFilters = useCallback(() => {
    setAppliedFilters({});
    if (onFiltersClear) {
      onFiltersClear();
    }
  }, [onFiltersClear]);
  const clearAllFilters = useCallback(() => {
    setSelectedFilters({});
  }, []);
  const getAppliedFilterValue = useCallback(
    (filterId) => {
      return appliedFilters[filterId];
    },
    [appliedFilters]
  );
  const getSelectedFilterValue = useCallback(
    (filterId) => {
      return selectedFilters[filterId];
    },
    [selectedFilters]
  );
  const getFilterConfig = useCallback(
    (filterId) => {
      return filterConfig.find((config) => config.id === filterId);
    },
    [filterConfig]
  );
  const generateQueryStringFromFilters = useCallback(() => {
    const appliedFiltersForQuery = convertToAppliedFilters(appliedFilters);
    return generateQueryString(appliedFiltersForQuery);
  }, [appliedFilters]);
  const parseQueryStringToFilters = useCallback((queryString) => {
    const parsedFilters = parseQueryString(queryString);
    const filterState = convertFromAppliedFilters(parsedFilters);
    setAppliedFilters(filterState);
  }, []);
  const hasAppliedFilters = useMemo(() => {
    return Object.keys(appliedFilters).length > 0;
  }, [appliedFilters]);
  const getAppliedFiltersCount = useCallback(() => {
    return Object.keys(appliedFilters).length;
  }, [appliedFilters]);
  const contextValue = useMemo(
    () => ({
      selectedFilters,
      appliedFilters,
      updateFilter,
      applyFilters,
      clearFilter,
      clearAllFilters,
      getAppliedFilterValue,
      getSelectedFilterValue,
      syncSelectedFilters,
      clearAppliedFilter,
      clearAllAppliedFilters,
      generateQueryString: generateQueryStringFromFilters,
      parseQueryString: parseQueryStringToFilters,
      getFilterConfig,
      filterConfig,
      hasAppliedFilters,
      getAppliedFiltersCount
    }),
    [
      selectedFilters,
      appliedFilters,
      updateFilter,
      applyFilters,
      clearFilter,
      clearAllFilters,
      getAppliedFilterValue,
      getSelectedFilterValue,
      syncSelectedFilters,
      clearAppliedFilter,
      clearAllAppliedFilters,
      generateQueryStringFromFilters,
      parseQueryStringToFilters,
      getFilterConfig,
      filterConfig,
      hasAppliedFilters,
      getAppliedFiltersCount
    ]
  );
  return /* @__PURE__ */ jsx(FilterContext.Provider, { value: contextValue, children });
};
var useFilter = () => {
  const context = useContext(FilterContext);
  if (context === null) {
    throw new Error("useFilter must be used within a FilterProvider.");
  }
  return context;
};
var FilterDateTime = ({
  dateFormat = "MM/DD/YYYY",
  label,
  value,
  onChange
}) => {
  const [dateValue, setDateValue] = useState("");
  const [timeValue, setTimeValue] = useState("");
  const [showCalendar, toggleCalendar] = useToggle(false);
  const calendarRef = useRef(null);
  useClickOutside(calendarRef, () => {
    if (showCalendar) {
      toggleCalendar();
    }
  });
  useEffect(() => {
    if (value) {
      try {
        const date = dayjs2(value);
        if (date.isValid()) {
          setDateValue(date.format("YYYY-MM-DD"));
          setTimeValue(date.format("HH:mm"));
        }
      } catch (error) {
        console.error("Error parsing initial value:", error);
      }
    }
  }, [value]);
  const inputClasses = "w-full bg-secondary-50 border border-neutral outline-none text-unique-600 text-small leading-5 px-3 py-2 rounded-md transition-colors";
  const formatDateForDisplay = (dateStr) => {
    if (!dateStr) return "";
    const date = dayjs2(dateStr);
    if (!date.isValid()) return "";
    return date.format(dateFormat);
  };
  const updateDateTime = (inputDateValue, inputTimeValue) => {
    const mergedDateTime = dayjs2(`${inputDateValue} ${inputTimeValue}`);
    if (mergedDateTime.isValid()) {
      const formattedDateTime = mergedDateTime.format("YYYY-MM-DD HH:mm:ss");
      onChange(formattedDateTime);
    }
  };
  const handleDateSelect = (date) => {
    setDateValue(date);
    toggleCalendar();
    updateDateTime(date, timeValue);
  };
  const handleTimeChange = (e) => {
    const time = e.target.value;
    setTimeValue(time);
    updateDateTime(dateValue, time);
  };
  const handleClear = () => {
    setDateValue("");
    setTimeValue("");
    onChange("");
  };
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-2 filter-date-time", children: [
    /* @__PURE__ */ jsx("div", { className: "text-small text-secondary-600 text-sm font-normal", children: label }),
    /* @__PURE__ */ jsxs("div", { className: "flex gap-2", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex flex-grow relative", children: [
        /* @__PURE__ */ jsx(
          "input",
          {
            type: "text",
            onClick: toggleCalendar,
            readOnly: true,
            value: formatDateForDisplay(dateValue),
            placeholder: "Select date",
            className: inputClasses
          }
        ),
        /* @__PURE__ */ jsx(
          Icon,
          {
            name: "calendar",
            className: "absolute right-3 top-1/2 transform -translate-y-1/2 text-secondary-500 pointer-events-none"
          }
        )
      ] }),
      /* @__PURE__ */ jsx("div", { className: "flex max-w-[120px]", children: /* @__PURE__ */ jsx(
        "input",
        {
          type: "time",
          value: timeValue,
          onChange: handleTimeChange,
          className: classNames82(inputClasses, "text-center")
        }
      ) }),
      /* @__PURE__ */ jsx("div", { className: "flex items-center justify-center w-4 ", children: (dateValue || timeValue) && /* @__PURE__ */ jsx(
        Icon,
        {
          name: "close",
          className: "text-secondary-500 cursor-pointer hover:text-secondary-700 text-lg font-bold  flex items-center justify-center bg-secondary-50 transition-colors",
          onClick: handleClear
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx(If, { condition: showCalendar, children: /* @__PURE__ */ jsx("div", { className: "calendar_v2", ref: calendarRef, children: /* @__PURE__ */ jsx(
      Calendar,
      {
        defaultView: "month",
        onChange: handleDateSelect,
        value: dateValue ? new Date(dateValue) : /* @__PURE__ */ new Date()
      }
    ) }) })
  ] });
};
var getIndexOfDateRangeType = (field) => {
  if (field === "from" /* FROM */) {
    return 0;
  }
  return 1;
};
var FilterDateRange = ({
  value,
  onChange,
  dateFormat,
  timeFormat,
  fromLabel = "From",
  toLabel = "To"
}) => {
  const { fromDate, toDate } = useMemo(() => {
    const filterValues = value?.values;
    if (!filterValues || !Array.isArray(filterValues)) {
      return { fromDate: null, toDate: null };
    }
    const fromValue = filterValues[0];
    const toValue = filterValues[1];
    return {
      fromDate: fromValue?.value || null,
      toDate: toValue?.value || null
    };
  }, [value, fromLabel, toLabel]);
  const handleDateChange = useCallback(
    (newValue, field, label) => {
      const filterValues = value?.values;
      const currentValues = Array.isArray(filterValues) ? [...filterValues] : [,];
      const valueIndex = getIndexOfDateRangeType(field);
      let currentFieldValue = currentValues[valueIndex];
      if (currentFieldValue) {
        currentFieldValue.value = newValue;
      } else {
        currentFieldValue = {
          label,
          value: newValue
        };
      }
      currentValues[valueIndex] = currentFieldValue;
      onChange(currentValues);
    },
    [value, onChange]
  );
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-2 py-2 rounded-md", children: [
    /* @__PURE__ */ jsx(
      FilterDateTime,
      {
        value: fromDate,
        onChange: (val) => {
          handleDateChange(val, "from" /* FROM */, fromLabel);
        },
        dateFormat,
        label: fromLabel
      }
    ),
    /* @__PURE__ */ jsx(
      FilterDateTime,
      {
        value: toDate,
        onChange: (val) => {
          handleDateChange(val, "to" /* TO */, toLabel);
        },
        dateFormat,
        label: toLabel
      }
    )
  ] });
};
var FilterCount = ({
  count
}) => {
  return /* @__PURE__ */ jsx("span", { className: "text-xs text-secondary-500 font-medium bg-secondary-50 px-2 rounded-md  justify-end", children: count });
};
var useFilterSuffix = (currentSelectedValue) => {
  const appliedFiltersCount = useMemo(
    () => getFiltersCount(currentSelectedValue),
    [currentSelectedValue]
  );
  const appliedFiltersSuffix = useMemo(() => {
    if (appliedFiltersCount > 0) {
      return /* @__PURE__ */ jsx(FilterCount, { count: appliedFiltersCount });
    }
    return null;
  }, [appliedFiltersCount]);
  return {
    count: appliedFiltersCount,
    suffix: appliedFiltersSuffix
  };
};
var CheckboxGroup = ({
  options: options3,
  currentSelectedValue = [],
  onFilterChange
}) => {
  const handleChange = (checked, option) => {
    let newValues = [...currentSelectedValue];
    if (checked) {
      newValues.push(option);
    } else {
      newValues = newValues.filter((v) => v.value !== option.value);
    }
    onFilterChange(newValues);
  };
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx("div", { className: "min-h-8 max-h-[250px] overflow-y-auto ", children: options3.map((option, index) => /* @__PURE__ */ jsx(
    Checkbox,
    {
      label: option.label,
      type: "primary",
      size: "small",
      checked: currentSelectedValue?.some(
        (v) => v.value === option?.value
      ),
      labelClassName: "text-sm !text-secondary-600 leading-5 font-light truncate",
      className: "py-2 ml-2",
      onChange: (val) => handleChange(val, option),
      name: option?.value
    },
    option?.value
  )) }) });
};
var FilterAccordion = Filters.Accordion;
var FilterRenderItem = ({
  filter: filter2,
  className = ""
}) => {
  const {
    id,
    label,
    type,
    operation,
    options: options3,
    render: CustomComponent,
    metadata
  } = filter2;
  const { updateFilter, getSelectedFilterValue, getAppliedFilterValue } = useFilter();
  const currentSelectedValue = getSelectedFilterValue(id);
  const currentAppliedValue = getAppliedFilterValue(id);
  const handleFilterChange = useCallback(
    (newValue) => {
      const filterOperation = operation || getDefaultOperation(type);
      const filterConfig = {
        values: newValue.map((value) => ({
          label: value.label,
          value: value.value
        })),
        type,
        operation: filterOperation,
        metadata
      };
      updateFilter(id, filterConfig);
    },
    [updateFilter, id, type, operation, metadata]
  );
  const appliedFilterSuffix = useFilterSuffix(currentSelectedValue);
  let renderedFilterComponent = null;
  if (CustomComponent) {
    const customProps = {
      filterId: id,
      label,
      options: options3,
      currentSelectedValue: currentSelectedValue?.values ?? [],
      currentAppliedValue: currentAppliedValue?.values ?? [],
      onFilterChange: handleFilterChange,
      metadata
    };
    renderedFilterComponent = /* @__PURE__ */ jsx(CustomComponent, { ...customProps });
  } else {
    switch (type) {
      case "date-time-input-range" /* DATE_TIME_INPUT_RANGE */:
        renderedFilterComponent = /* @__PURE__ */ jsx(
          FilterDateRange,
          {
            dateFormat: "DD/MM/YYYY",
            timeFormat: "12",
            fromLabel: "From Date & Time",
            toLabel: "To Date & Time",
            value: currentSelectedValue,
            onChange: handleFilterChange
          }
        );
        break;
      case "checkbox" /* CHECKBOX */:
        renderedFilterComponent = /* @__PURE__ */ jsx(
          CheckboxGroup,
          {
            options: options3 ?? [],
            currentSelectedValue: currentSelectedValue?.values ?? [],
            onFilterChange: handleFilterChange
          }
        );
        break;
      default:
        renderedFilterComponent = /* @__PURE__ */ jsx("div", { children: "No filter is configured for this" });
    }
  }
  return /* @__PURE__ */ jsx("div", { className: `filter-render-item ${className}`, children: /* @__PURE__ */ jsx(
    FilterAccordion,
    {
      label,
      wrapperClassName: "!mb-0",
      labelClassName: "py-1",
      suffix: /* @__PURE__ */ jsx("div", { className: "flex-grow flex justify-end", children: appliedFilterSuffix?.suffix }),
      children: renderedFilterComponent
    },
    id
  ) });
};
var FilterRenderer = ({
  filterConfig,
  className = "",
  renderCustomWrapper
}) => {
  const { filterConfig: contextFilterConfig } = useFilter();
  const configsToRender = filterConfig || contextFilterConfig;
  if (!configsToRender || configsToRender.length === 0) {
    return /* @__PURE__ */ jsx("div", { className: `text-secondary-600 text-sm ${className}`, children: "No filters configured." });
  }
  const filterItems = configsToRender.map((config) => /* @__PURE__ */ jsx(FilterRenderItem, { filter: config }, config.id));
  const content = /* @__PURE__ */ jsx("div", { className: `flex flex-col ${className}`, children: filterItems });
  if (renderCustomWrapper) {
    return /* @__PURE__ */ jsx(Fragment, { children: renderCustomWrapper(content) });
  }
  return content;
};
var Footer = ({ closeFilter, handleResetAll, handleApply }) => {
  const { t } = useTranslation();
  const { applyFilters, clearAllFilters } = useFilter();
  return /* @__PURE__ */ jsxs(Filters.Footer, { children: [
    /* @__PURE__ */ jsx(
      "span",
      {
        role: "button",
        className: "text-secondary-500 text-sm",
        onClick: handleResetAll,
        children: t("common.clear.all")
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-x-3", children: [
      /* @__PURE__ */ jsx(Button, { type: "secondary", onClick: closeFilter, children: t("common.cancel") }),
      /* @__PURE__ */ jsx(
        Button,
        {
          type: "primary",
          onClick: handleApply,
          children: t("common.apply")
        }
      )
    ] })
  ] });
};
var footer_default = Footer;
var Header2 = ({ updateShowPopup }) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs(Filters.Header, { children: [
    /* @__PURE__ */ jsxs("h1", { children: [
      /* @__PURE__ */ jsx(
        Icon,
        {
          name: "filter-list",
          className: "rotate-180 text-secondary-500 pb-1 pl-1 font-normal"
        }
      ),
      /* @__PURE__ */ jsx("span", { className: "text-sm font-medium", children: t("common.filters.label") })
    ] }),
    /* @__PURE__ */ jsx(
      "div",
      {
        className: "flex items-center",
        onClick: (e) => {
          e.preventDefault();
          updateShowPopup(false);
        },
        children: /* @__PURE__ */ jsx(
          Icon,
          {
            name: "close",
            className: "text-xl font-semibold text-secondary-500 cursor-pointer ml-2",
            toolTip: t("common.close")
          }
        )
      }
    )
  ] });
};
var header_default2 = Header2;
var FilterModal = () => {
  const [isFiltersOpen, toggleFilter] = useToggle(false);
  const prevIsFiltersOpen = usePrevious(isFiltersOpen);
  const title = "Filters";
  const {
    hasAppliedFilters,
    syncSelectedFilters,
    applyFilters,
    clearAllFilters
  } = useFilter();
  const handleResetAll = () => {
    clearAllFilters();
  };
  const handleApplyFilters = () => {
    applyFilters();
    toggleFilter();
  };
  const handleToggleDropdown = (value) => {
    if (value !== isFiltersOpen) {
      toggleFilter();
    }
  };
  useEffect(() => {
    if (!prevIsFiltersOpen && isFiltersOpen) {
      syncSelectedFilters();
    }
  }, [prevIsFiltersOpen, isFiltersOpen, syncSelectedFilters]);
  return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs(
    Filters.Root,
    {
      showDropdown: isFiltersOpen,
      toggleDropdown: handleToggleDropdown,
      wrapperClassName: "!max-h-[500px] !max-w-[350px] !w-[350px] ml-2 !z-100",
      position: "bottom-start",
      isAnyFilterApplied: hasAppliedFilters,
      title,
      buttonClassName: "!px-[3px] !shadow-sm border-0.5 border-secondary-200 !rounded-[5px] !h-7 !w-7 justify-center m-0 !text-2xs",
      filterAppliedClassName: `w-2 h-2 bg-error-600 rounded-full absolute top-1 ${"left-5"} right-1 border border-white`,
      children: [
        /* @__PURE__ */ jsx(header_default2, { updateShowPopup: toggleFilter }),
        /* @__PURE__ */ jsx(If, { condition: isFiltersOpen, children: /* @__PURE__ */ jsx(Filters.Body, { children: /* @__PURE__ */ jsx(FilterRenderer, {}) }) }),
        /* @__PURE__ */ jsx(
          footer_default,
          {
            closeFilter: toggleFilter,
            handleResetAll,
            handleApply: handleApplyFilters
          }
        )
      ]
    }
  ) });
};
var AppliedFilters2 = ({
  appliedFilters,
  onRemove,
  filterConfig
}) => {
  return /* @__PURE__ */ jsx("div", { className: "flex gap-2", children: Object.keys(appliedFilters).map((filterId) => {
    const filterConfigItem = filterConfig.find((f) => f.id === filterId);
    const selectedFilterValue = appliedFilters[filterId].values.filter(
      (v) => v.value
    );
    return /* @__PURE__ */ jsx(
      FilterChips,
      {
        filterConfig: filterConfigItem,
        selectedFilterValue,
        onRemove
      },
      filterId
    );
  }) });
};
var FilterChips = ({
  filterConfig,
  selectedFilterValue,
  onRemove
}) => {
  const label = filterConfig?.label || "";
  const selectedFilterCount = Array.isArray(selectedFilterValue) ? selectedFilterValue.length : 1;
  return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
    Chip,
    {
      variant: "bordered" /* Bordered */,
      label,
      count: selectedFilterCount,
      onRemove: () => onRemove(filterConfig?.id || "")
    },
    filterConfig?.id
  ) });
};
var { Button: ButtonV210, BUTTON_VARIANTS: BUTTON_VARIANTS12 } = V2;
var AppliedFiltersSection = ({}) => {
  const { t } = useTranslation();
  const {
    appliedFilters,
    clearAppliedFilter,
    clearAllAppliedFilters,
    hasAppliedFilters,
    filterConfig,
    getFilterConfig
  } = useFilter();
  if (!hasAppliedFilters) {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between", children: [
    /* @__PURE__ */ jsx(
      AppliedFilters2,
      {
        appliedFilters,
        onRemove: (id) => {
          clearAppliedFilter(id);
        },
        filterConfig
      }
    ),
    /* @__PURE__ */ jsx("div", { className: "flex border-l border-secondary-200 pl-2", children: /* @__PURE__ */ jsx(
      ButtonV210,
      {
        className: "text-secondary-600 font-semibold",
        onClick: () => {
          clearAllAppliedFilters();
        },
        variant: BUTTON_VARIANTS12.LINK,
        children: t("audit_logs.filter.clear_all")
      }
    ) })
  ] });
};
var AuditLogFilterSection = ({
  updateAppliedFilters
}) => {
  const { appliedFilters } = useFilter();
  useEffect(() => {
    updateAppliedFilters(appliedFilters);
  }, [appliedFilters]);
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ jsx("div", { className: "mr-3", children: /* @__PURE__ */ jsx(FilterModal, {}) }),
    /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(AppliedFiltersSection, {}) })
  ] }) });
};
var VirtualizedTableHeader = ({
  config
}) => {
  return /* @__PURE__ */ jsx("div", { className: "px-6 py-3 bg-secondary-50 flex items-center rounded text-sm font-medium text-secondary-600 justify-between", children: config.map((column) => /* @__PURE__ */ jsx(Column, { width: column.width, className: "leading-4", children: column.headerLabel }, column.id)) });
};
var VirtualizedTableRow = ({
  item,
  config
}) => {
  return /* @__PURE__ */ jsx("div", { className: "h-full flex items-center w-full px-6 py-1 text-small font-normal text-secondary-unique-600 border-b border-b-secondary-50 justify-between", role: "row", children: config.map((column) => {
    let renderedValue = column.renderer(column.accessor(item), item);
    return /* @__PURE__ */ jsx(
      Column,
      {
        width: column.width,
        className: column.className,
        role: "gridcell",
        children: renderedValue
      },
      column.id
    );
  }) });
};
var { VirtualizedInfiniteLoader: VirtualizedInfiniteLoader7 } = InfiniteScrollV2;
var VirtualizedTable = ({
  data,
  config,
  rowHeight = 60,
  hasMore,
  isLoading,
  loadMore,
  noResultsComponent
}) => {
  const rowRenderer = (index) => {
    const item = data?.[index];
    if (item) {
      return /* @__PURE__ */ jsx(VirtualizedTableRow, { item, config }, index);
    }
    return null;
  };
  return /* @__PURE__ */ jsxs("div", { className: "w-full h-[calc(100vh-162px)]", children: [
    /* @__PURE__ */ jsx(VirtualizedTableHeader, { config }),
    /* @__PURE__ */ jsx(If, { condition: isLoading, children: /* @__PURE__ */ jsx(
      Loader,
      {
        loaderClassName: "text-3xl text-primary-500 animate-spin mx-auto m-4"
      }
    ) }),
    /* @__PURE__ */ jsx(Unless, { condition: isLoading, children: /* @__PURE__ */ jsx(
      VirtualizedInfiniteLoader7,
      {
        rowHeight,
        rowRenderer,
        rowCount: (data ?? []).length,
        items: data,
        loadMore,
        hasMore,
        isLoading,
        noResultsComponent,
        LoadingComponent: /* @__PURE__ */ jsx("div", { children: "Loading..." })
      }
    ) })
  ] });
};
var getGetInfiniteAuditLogsQueryKey = (params) => {
  return [`/api/private/audit/infinite`, ...params ? [params] : []];
};
function useGetInfiniteAuditLogs(params, options3, queryClient2) {
  const queryKey = getGetInfiniteAuditLogsQueryKey(params);
  const queryFn = ({ pageParam, signal, ...rest }) => {
    if (!pageParam) {
      return getAuditLogs(params, options3?.request, signal);
    }
    const { size: size2, page, ...updatedParams } = params;
    if (pageParam.type === "cursor") {
      updatedParams.cursor = pageParam.value;
    } else {
      updatedParams.page = pageParam.value;
      updatedParams.size = size2;
    }
    return getAuditLogs(updatedParams, options3?.request, signal);
  };
  const query = useInfiniteQuery$1({
    queryKey,
    queryFn,
    initialPageParam: void 0,
    getNextPageParam: (lastPage) => {
      if (lastPage.isCursorPagination) {
        return lastPage.hasNext ? { value: lastPage.nextCursor, type: "cursor" } : void 0;
      } else {
        const currentPage = lastPage.pageNumber ?? 0;
        const totalPages = lastPage.totalPages ?? 0;
        return currentPage < totalPages - 1 ? { value: currentPage + 1, type: "page" } : void 0;
      }
    },
    ...options3?.query
  });
  return query;
}

// src/modules/audit-logs/utils.ts
var getFilterOptionsFromIds = (ids, labelFormatter) => {
  return ids.map((id) => {
    return {
      value: id,
      label: labelFormatter?.(id) ?? id
    };
  });
};
var camelCaseToSpaces = (str) => {
  if (!str) return "";
  if (str.length === 1) return str.toUpperCase();
  return str.replace(/([A-Z])/g, " $1").replace(/^./, (str2) => str2.toUpperCase()).trim();
};
var capitalizeFirstLetter2 = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
var getAuditLogItemsList = (auditLogsData, usersMap) => {
  if (!auditLogsData) return [];
  return auditLogsData?.pages?.flatMap(
    (page) => page.content.map((auditLog) => {
      return {
        ...auditLog,
        user: usersMap[auditLog.actorUUID]
      };
    })
  );
};

// src/modules/audit-logs/hooks/use-audit-logs-list.ts
var useAuditLogsWithUsers = ({
  query,
  authToken,
  usersMap,
  auditLogBaseUrl,
  size: size2 = AUDIT_LOG_PAGE_SIZE,
  sort = AUDIT_LOG_DEFAULT_ORDER_BY,
  page = 0
}) => {
  const emptyPageFetchCount = useRef(0);
  const {
    data: auditLogsData,
    isLoading,
    isFetching,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isError,
    error,
    refetch
  } = useGetInfiniteAuditLogs(
    {
      query,
      size: size2,
      sort,
      page
    },
    {
      query: {
        enabled: !!authToken
      },
      request: {
        baseURL: auditLogBaseUrl,
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      }
    }
  );
  const handleLoadMore = useCallback(() => {
    if (hasNextPage) {
      fetchNextPage();
    }
  }, [hasNextPage, fetchNextPage]);
  const mostRecentPage = useMemo(() => {
    if (!auditLogsData?.pages?.length) return null;
    return auditLogsData.pages[auditLogsData.pages.length - 1];
  }, [auditLogsData]);
  useEffect(() => {
    if (hasNextPage && mostRecentPage?.content?.length == 0) {
      if (emptyPageFetchCount.current < AUDIT_LOG_EMPTY_PAGE_FETCH_COUNT) {
        emptyPageFetchCount.current = emptyPageFetchCount.current + 1;
        fetchNextPage();
      } else {
        console.error("Empty page fetched more than 3 times");
      }
    } else {
      emptyPageFetchCount.current = 0;
    }
  }, [mostRecentPage, fetchNextPage, hasNextPage]);
  const auditLogItemsList = useMemo(
    () => getAuditLogItemsList(auditLogsData, usersMap) ?? [],
    [auditLogsData, usersMap]
  );
  return {
    // Original useGetInfiniteAuditLogs return
    data: auditLogsData,
    isLoading,
    isFetching,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    error,
    refetch,
    isError,
    // Processed data
    auditLogItemsList,
    // Load more function
    handleLoadMore
  };
};
var AuditLogTable = ({
  appliedFilters,
  auditLogTableConfig
}) => {
  const { t } = useTranslation();
  const filterQuery = useMemo(() => {
    return generateQueryString(appliedFilters);
  }, [appliedFilters]);
  const { usersMap, authToken, auditLogBaseUrl } = useAuth();
  const {
    auditLogItemsList,
    handleLoadMore,
    hasNextPage,
    isLoading} = useAuditLogsWithUsers({
    query: filterQuery,
    authToken,
    usersMap,
    auditLogBaseUrl
  });
  const noResultsView = useMemo(() => {
    const text = filterQuery ? t("audit_logs.table.no_results_with_filters") : t("audit_logs.table.no_results");
    return /* @__PURE__ */ jsx("div", { className: "flex justify-center items-center h-full text-small text-accent font-normal leading-4 py-2 text-center", children: text });
  }, [filterQuery, t]);
  return /* @__PURE__ */ jsx(
    VirtualizedTable,
    {
      data: auditLogItemsList,
      config: auditLogTableConfig,
      rowHeight: 84,
      loadMore: handleLoadMore,
      hasMore: hasNextPage,
      isLoading,
      noResultsComponent: noResultsView
    }
  );
};
var AuditLogDataTable = ({
  filterConfig,
  appliedFilters,
  updateAppliedFilters,
  auditLogTableConfig
}) => {
  return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-4", children: [
    /* @__PURE__ */ jsx(FilterProvider, { filterConfig, children: /* @__PURE__ */ jsx(AuditLogFilterSection, { updateAppliedFilters }) }),
    /* @__PURE__ */ jsx("div", { className: "h-[calc(100vh-162px)]", children: /* @__PURE__ */ jsx(
      AuditLogTable,
      {
        appliedFilters,
        auditLogTableConfig
      }
    ) })
  ] }) });
};
var getMetadataByProduct = (params, options3, signal) => {
  return customInstance(
    { url: `/api/private/metadata`, method: "GET", params, signal },
    options3
  );
};
var getGetMetadataByProductQueryKey = (params) => {
  return [`/api/private/metadata`, ...params ? [params] : []];
};
var getGetMetadataByProductQueryOptions = (params, options3) => {
  const { query: queryOptions, request: requestOptions } = options3 ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetMetadataByProductQueryKey(params);
  const queryFn = ({ signal }) => getMetadataByProduct(params, requestOptions, signal);
  return { queryKey, queryFn, ...queryOptions };
};
function useGetMetadataByProduct(params, options3, queryClient2) {
  const queryOptions = getGetMetadataByProductQueryOptions(params, options3);
  const query = useQuery(queryOptions, queryClient2);
  query.queryKey = queryOptions.queryKey;
  return query;
}

// src/modules/audit-logs/audit-log-table/use-audit-logs-filter-config.tsx
var useAuditLogFilterConfig = ({
  productType,
  additionalFilterConfig
}) => {
  const { t } = useTranslation();
  const { authToken, auditLogBaseUrl } = useAuth();
  const { data: metadataData, isLoading: metadataLoading } = useGetMetadataByProduct(
    { product: productType },
    {
      query: {
        enabled: !!authToken
      },
      request: {
        baseURL: auditLogBaseUrl,
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      }
    }
  );
  const { entityTypeFilterOptions, actionFilterOptions } = useMemo(() => {
    return {
      entityTypeFilterOptions: getFilterOptionsFromIds(
        metadataData?.entities ?? [],
        camelCaseToSpaces
      ),
      actionFilterOptions: getFilterOptionsFromIds(metadataData?.actions ?? [], capitalizeFirstLetter2)
    };
  }, [metadataData]);
  const filterConfig = useMemo(
    () => [
      {
        id: "entityType",
        label: t("audit_logs.filter.entity_type"),
        type: "checkbox" /* CHECKBOX */,
        options: entityTypeFilterOptions
      },
      {
        id: "action",
        label: t("audit_logs.filter.action"),
        type: "checkbox" /* CHECKBOX */,
        options: actionFilterOptions
      },
      {
        id: "timestamp",
        label: t("audit_logs.filter.date_range"),
        type: "date-time-input-range" /* DATE_TIME_INPUT_RANGE */,
        metadata: {
          displayConfig: {
            format: "DD/MM/YYYY"
          }
        }
      },
      ...additionalFilterConfig
    ],
    [entityTypeFilterOptions, actionFilterOptions, additionalFilterConfig, t]
  );
  return {
    filterConfig,
    isLoading: metadataLoading,
    metadataData
  };
};
var AuditLogsPage = ({
  productType,
  additionalFilterConfig,
  exportSuccessRenderer,
  auditLogTableConfig
}) => {
  const [appliedFilters, setAppliedFilters] = useState({});
  const { filterConfig } = useAuditLogFilterConfig({
    productType,
    additionalFilterConfig
  });
  return /* @__PURE__ */ jsxs(page_layout_default, { children: [
    /* @__PURE__ */ jsx(page_layout_default.Header, { children: /* @__PURE__ */ jsx(
      AuditLogPageHeader,
      {
        filterConfig,
        appliedFilters,
        exportSuccessRenderer
      }
    ) }),
    /* @__PURE__ */ jsx(page_layout_default.Body, { children: /* @__PURE__ */ jsx(
      AuditLogDataTable,
      {
        filterConfig,
        appliedFilters,
        auditLogTableConfig,
        updateAppliedFilters: (val) => {
          setAppliedFilters(val);
        }
      }
    ) })
  ] });
};
var { Button: ButtonV211, BUTTON_VARIANTS: BUTTON_VARIANTS13 } = V2;
var AuditLogs = ({
  loginUrl,
  tokenGetter,
  productType,
  usersUrl,
  userMapGenerator,
  auditLogTableConfig,
  additionalFilterConfig,
  exportSuccessRenderer,
  auditLogBaseUrl
}) => {
  return /* @__PURE__ */ jsx(QueryClientProvider, { client: queryClientInstance, children: /* @__PURE__ */ jsx(
    AuthProvider,
    {
      loginUrl,
      usersUrl,
      tokenGetter,
      userMapGenerator,
      auditLogBaseUrl,
      children: /* @__PURE__ */ jsx(
        AuditLogsPage,
        {
          auditLogTableConfig,
          productType,
          additionalFilterConfig,
          exportSuccessRenderer
        }
      )
    }
  ) });
};
var btnTheme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          textTransform: "capitalize",
          ...ownerState.variant === "contained" && ownerState.color === "primary" && {
            backgroundColor: COLOR.PRIMARY,
            color: COLOR.WHITE,
            boxShadow: "none",
            fontSize: SIZE["13"],
            ":hover": {
              borderColor: COLOR.PRIMARY,
              backgroundColor: COLOR.PRIMARY,
              boxShadow: "none",
              fontSize: SIZE["13"]
            },
            ":disabled": {
              borderColor: COLOR.PRIMARY,
              backgroundColor: COLOR.PRIMARY,
              color: COLOR.WHITE,
              opacity: "0.7",
              fontSize: SIZE["13"]
            }
          },
          ...ownerState.variant === "outlined" && ownerState.color === "primary" && {
            color: COLOR.PRIMARY,
            borderColor: COLOR.PRIMARY,
            fontSize: SIZE["13"],
            ":hover": {
              borderColor: COLOR.PRIMARY,
              fontSize: SIZE["13"]
            }
          },
          ...ownerState.variant === "contained" && ownerState.color === "secondary" && {
            backgroundColor: COLOR.SECONDARY,
            color: "#fff",
            fontSize: SIZE["13"],
            ":hover": {
              borderColor: COLOR.SECONDARY,
              backgroundColor: COLOR.SECONDARY,
              fontSize: SIZE["13"]
            }
          },
          ...ownerState.variant === "outlined" && ownerState.color === "secondary" && {
            color: COLOR.SECONDARY,
            borderColor: COLOR.BORDER_SECONDARY,
            backgroundColor: COLOR.WHITE,
            fontSize: SIZE["13"],
            ":hover": {
              color: COLOR.SECONDARY,
              borderColor: COLOR.BORDER_SECONDARY,
              backgroundColor: COLOR.WHITE,
              fontSize: SIZE["13"]
            }
          },
          ...ownerState.variant === "contained" && ownerState.color === "error" && {
            color: COLOR.WHITE,
            boxShadow: "none",
            fontSize: SIZE["13"],
            ":hover": {
              boxShadow: "none",
              fontSize: SIZE["13"]
            },
            ":disabled": {
              opacity: "0.7",
              fontSize: SIZE["13"]
            }
          }
        })
      }
    }
  }
});
function UiButton({
  children,
  onClick,
  color,
  label,
  isDisabled,
  variant,
  className
}) {
  return /* @__PURE__ */ jsx(ThemeProvider, { theme: btnTheme, children: /* @__PURE__ */ jsx(
    Button$1,
    {
      onClick: () => onClick(),
      className: `!py-1.5 !px-3 !leading-4 ${className && `${className}`}`,
      size: "small",
      disabled: isDisabled,
      variant: variant || "outlined",
      color,
      children: children ? children : label
    }
  ) });
}
function UiAlert({ type = "info", message, heading }) {
  return /* @__PURE__ */ jsxs(Alert, { variant: "standard", severity: type, children: [
    heading && /* @__PURE__ */ jsx(AlertTitle, { children: heading }),
    /* @__PURE__ */ jsx("span", { className: "text-xs", children: message })
  ] });
}
function Body({
  eventData,
  onChangeElementDetails,
  onVerify,
  validateName,
  validateDefinition,
  validateScreenName,
  uiIdentifier,
  isSubmited,
  updateElementImageDraft,
  isUpdate,
  nlpId = null
}) {
  const { sendToContentWindow } = useMessaging();
  const { actions: recorder } = useRecorderContext();
  const [occurance, _setOccurance] = useState(1);
  const [occuranceErrorText, setOccuranceErrorText] = useState("");
  const prevLocatedElement = useRef(null);
  const initialNameSet = useRef(false);
  const [name, setName] = useState("");
  const [screenName, setScreenName] = useState("");
  const [finderType, setFinderType] = useState(
    STEP_LOCATOR.XPATH.value
  );
  const [finderPath, setFinderPath] = useState("");
  const [updatingVerifiedElement, setUpdatingVerifiedElement] = useState(false);
  const [isXpathValidating, setIsXpathValidating] = useState(false);
  const [elementCtx, setElementCtx] = useState([]);
  const [elementIdentifier, setElementIdentifier] = useState();
  const [elementScreenshot, setElementScreenshot] = useState({ url: "", message: "", loading: false });
  const [parents, setParents] = useState([]);
  const [screenshot, setScreenshot] = useState("");
  const [attrs, setAttrs] = useState();
  const [screenNameId, setScreenNameId] = useState(null);
  const [isInsideHosts, setIsInsideHosts] = useState(false);
  const [autoHealingEnabled, setAutoHealingEnabled] = useState(true);
  const { locatedElement, recorderType, appType, recorderPreferences } = useSelector((state) => state.widget);
  const { hasFeature } = useTenantInfo();
  const _canShowAutoHealCheckBox = useMemo(() => {
    return canShowAutoHealCheckBox(appType, hasFeature);
  }, [appType, hasFeature]);
  const isLocatedElementNotExist = locatedElement?.error === ERROR_CODE.ELEMENT_NOT_EXIST;
  const isLocatedXpathInvalid = locatedElement?.error === ERROR_CODE.XPATH_INVALID;
  const isLocatedValidElement = !(isLocatedElementNotExist || isLocatedXpathInvalid) && !!locatedElement?.element;
  const IMAGE_SUPPORTED_NLPS = IMAGE_SUPPORTED_NLPS_MAP[appType] || [];
  useEffect(() => {
    if (uiIdentifier) {
      setElementScreenshot({
        url: "",
        loading: true,
        message: ""
      });
      fetchElementScreenshot(uiIdentifier.id);
      if (isUpdate && uiIdentifier.name && !initialNameSet.current) {
        setName(uiIdentifier.name);
        initialNameSet.current = true;
      }
    } else {
      setElementScreenshot({
        url: "",
        loading: false,
        message: "The element image has not been captured yet."
      });
    }
  }, [uiIdentifier, isUpdate, name]);
  useEffect(() => {
    const updatedUiIdentifier = {
      ...uiIdentifier,
      name,
      definition: finderPath,
      parents,
      screenShotData: screenshot,
      attrs,
      screenNameId,
      screenName,
      locatorType: finderType,
      hostElements: elementCtx,
      isInsideHosts,
      autoHealingEnabled
    };
    setElementIdentifier((prev) => {
      return {
        ...prev,
        ...updatedUiIdentifier,
        ...screenName ? { screenNameObj: {} } : {}
      };
    });
  }, [
    name,
    screenName,
    finderPath,
    finderType,
    elementCtx,
    parents,
    screenshot,
    attrs,
    screenNameId,
    isInsideHosts,
    autoHealingEnabled
  ]);
  useEffect(() => {
    if (eventData) {
      if (!name && eventData?.name && !isUpdate || recorderType === RECORDER_TYPE.ELEMENT_CAPTURE && !isUpdate) {
        setName(eventData.name);
      }
      if (eventData?.shadowElement) {
        setFinderPath(eventData?.cssPath || "");
        setFinderType(STEP_LOCATOR.CSS_LOCATOR.value);
      } else {
        switch (eventData.locatorType) {
          case STEP_LOCATOR.XPATH.value:
            setFinderPath(eventData?.xPath || "");
            break;
          case STEP_LOCATOR.CSS_LOCATOR.value:
            setFinderPath(eventData?.cssPath || "");
            break;
          case STEP_LOCATOR.ID.value:
            setFinderPath(eventData?.idSelector || "");
            break;
          case STEP_LOCATOR.LINK_TEXT.value:
            setFinderPath(eventData?.linkText || "");
            break;
          case STEP_LOCATOR.NAME.value:
            setFinderPath(eventData?.nameAttr || "");
            break;
        }
        if (eventData.locatorType) setFinderType(eventData.locatorType);
      }
      if (eventData.screenTitle) {
        setScreenName(eventData.screenTitle);
      }
      if (eventData.elementContext) setElementCtx(eventData.elementContext);
      if (eventData.imageLocatorOccurence)
        _setOccurance(eventData?.imageLocatorOccurence);
      if (eventData.screenshot) {
        setScreenshot(eventData.screenshot);
      }
      if (eventData.attrs) setAttrs(eventData.attrs);
      if (eventData.screenNameId) setScreenNameId(eventData.screenNameId);
      setAutoHealingEnabled(eventData?.autoHealingEnabled);
      setIsInsideHosts(!!eventData?.isInsideHosts);
      setParents(eventData?.parents ?? []);
    } else {
      setFinderPath("");
      setName("");
      setScreenName("");
      setElementCtx([]);
      setFinderType(STEP_LOCATOR.XPATH.value);
      setParents([]);
      setScreenshot("");
      setAttrs(void 0);
      setScreenNameId(null);
      setIsInsideHosts(false);
      setAutoHealingEnabled(true);
    }
  }, [eventData]);
  useEffect(() => {
    if (recorderPreferences) {
      const locatorTypeBasedOnPrecedence = getLocatorTypeBasedOnPrecedence(
        eventData,
        recorderPreferences
      );
      if (locatorTypeBasedOnPrecedence) {
        onLocatorChange(locatorTypeBasedOnPrecedence);
      }
    }
  }, [recorderPreferences]);
  useEffect(() => {
    if (isLocatedValidElement && prevLocatedElement.current !== locatedElement) {
      const _updatedElement = { ...locatedElement.element };
      if (updatingVerifiedElement) {
        const _name = !name ? _updatedElement.name : name;
        const _screenName = !screenName || screenName === "" && prevLocatedElement.current !== locatedElement ? _updatedElement.screenTitle : screenName;
        const _locatorType = finderType;
        const _xpath = _locatorType === STEP_LOCATOR.XPATH.value ? (!finderPath || finderPath === "") && prevLocatedElement.current !== locatedElement ? _updatedElement.xPath : finderPath : _updatedElement.xPath;
        const _cssPath = _locatorType === STEP_LOCATOR.CSS_LOCATOR.value ? (!finderPath || finderPath === "") && prevLocatedElement.current !== locatedElement ? _updatedElement.cssPath : finderPath : _updatedElement.cssPath;
        const _nameAttr = _locatorType === STEP_LOCATOR.NAME.value ? (!finderPath || finderPath === "") && prevLocatedElement.current !== locatedElement ? _updatedElement.nameAttr : finderPath : _updatedElement.nameAttr;
        const _idSelector = _locatorType === STEP_LOCATOR.ID.value ? (!finderPath || finderPath === "") && prevLocatedElement.current !== locatedElement ? _updatedElement.attrs?.id : finderPath : _updatedElement.attrs?.id;
        const _linkText = _locatorType === STEP_LOCATOR.LINK_TEXT.value ? (!finderPath || finderPath === "") && prevLocatedElement.current !== locatedElement ? _updatedElement.linkText : finderPath : _updatedElement.linkText;
        const element = {
          ..._updatedElement,
          name: _name,
          xPath: _xpath,
          screenTitle: _screenName,
          locatorType: _locatorType,
          cssPath: _cssPath,
          definition: _definition,
          linkText: _linkText,
          nameAttr: _nameAttr,
          idSelector: _idSelector,
          attrs: { ..._updatedElement.attrs || {} },
          isInsideHosts: _updatedElement?.shadowElement || !!_updatedElement?.elementContext?.length
        };
        onChangeElementDetails(element, true);
      } else {
        const _name = isUpdate ? name : _updatedElement.name || name;
        if (!isUpdate) {
          setName(_name);
        }
        setScreenName(_updatedElement.screenTitle || screenName);
        const _locatorType = _updatedElement.locatorType || finderType;
        const _xpath = _updatedElement.xPath;
        const _cssPath = _updatedElement.cssPath;
        const _idSelector = _updatedElement.attrs?.id;
        const _nameAttr = _updatedElement.nameAttr;
        const _definition2 = getDifinitionByLocatorType({
          ..._updatedElement,
          locatorType: _locatorType,
          idSelector: _idSelector
        });
        onChangeElementDetails({
          ..._updatedElement,
          name: _name,
          locatorType: _locatorType,
          definition: _definition2,
          xPath: _xpath,
          cssPath: _cssPath,
          idSelector: _idSelector,
          nameAttr: _nameAttr,
          attrs: { ..._updatedElement.attrs || {} },
          isInsideHosts: _updatedElement?.shadowElement || !!_updatedElement?.elementContext?.length
        }, true);
      }
      setUpdatingVerifiedElement(false);
      if (locatedElement?.["isInsideHosts"] && hasShadowHostType2(locatedElement?.element?.elementContext) && finderType != STEP_LOCATOR.CSS_LOCATOR.value)
        setFinderType(STEP_LOCATOR.CSS_LOCATOR.value);
    }
    setIsXpathValidating(false);
    prevLocatedElement.current = locatedElement;
  }, [locatedElement, finderPath]);
  const fetchElementScreenshot = async (elementId) => {
    const appVersionId = await recorder.getAppVersionId();
    RecorderAssetsApi.getElementScreenshot({
      elementId,
      applicationVersionId: appVersionId
    }).then((response) => {
      const ss = {
        url: response?.elementScreenshotPresignedUrl,
        loading: false,
        message: ""
      };
      if (!ss.url) {
        ss.message = "The element image has not been captured yet.";
      }
      setElementScreenshot(ss);
    });
  };
  const screenNameOptionsHook = (searchterm) => new Promise(async (resolve) => {
    const appVersionId = await recorder.getAppVersionId();
    const term = searchterm.trim();
    ScreenApi.getAll(appVersionId, term).then((res) => {
      const options3 = res.content.map((screenName2) => {
        return {
          id: screenName2.id,
          label: screenName2.name,
          disabled: false,
          isNew: false
        };
      });
      if (term && !options3.some((item) => item.label === term)) {
        options3.push({
          id: term,
          label: term,
          disabled: false,
          isNew: true
        });
      }
      resolve(options3.filter(Boolean));
    }).catch((err) => {
      console.log("Failed to search for screenNames", err);
    });
  });
  const onNameChange = (name2) => {
    setName(name2);
    onChangeElementDetails({ name: name2 });
  };
  const onScreenNameIdChange = ({ label }) => {
    setScreenName(label);
    onChangeElementDetails({ screenTitle: label });
  };
  const onLocatorChange = (locatorType) => {
    const elementDetails = locatorType === STEP_LOCATOR.ID.value ? {
      locatorType,
      definition: eventData?.attrs?.id,
      idSelector: eventData?.attrs?.id
    } : { locatorType };
    if (locatorType.toLocaleLowerCase() != STEP_LOCATOR.IMAGE.value.toLocaleLowerCase()) {
      sendToContentWindow(
        MESSAGE_CONTEXT_ACTION.CANCEL,
        MESSAGE_CONTEXT.CAPTURE_ELEMENT_IMAGE,
        {}
      );
    }
    setFinderType(locatorType);
    onChangeElementDetails(elementDetails);
  };
  const onDefinitionChange = (definition) => {
    setFinderPath(definition);
    if (finderType === STEP_LOCATOR.XPATH.value) {
      onChangeElementDetails({
        definition,
        xPath: definition,
        locatorType: STEP_LOCATOR.XPATH.value
      });
    } else if (finderType === STEP_LOCATOR.CSS_LOCATOR.value) {
      onChangeElementDetails({
        definition,
        cssPath: definition,
        locatorType: STEP_LOCATOR.CSS_LOCATOR.value
      });
    } else if (finderType === STEP_LOCATOR.ID.value) {
      onChangeElementDetails({
        definition,
        idSelector: definition,
        locatorType: STEP_LOCATOR.ID.value
      });
    } else if (finderType === STEP_LOCATOR.NAME.value) {
      onChangeElementDetails({
        definition,
        nameAttr: definition,
        locatorType: STEP_LOCATOR.NAME.value
      });
    } else if (finderType === STEP_LOCATOR.LINK_TEXT.value) {
      onChangeElementDetails({
        definition,
        linkText: definition,
        locatorType: STEP_LOCATOR.LINK_TEXT.value
      });
    }
    setUpdatingVerifiedElement(true);
    setIsXpathValidating(false);
  };
  const onVerifyElement = () => {
    if (finderPath && finderPath !== "") {
      onVerify();
      setIsXpathValidating(true);
    }
  };
  const hasShadowHostType2 = (objects) => {
    if (!objects) return false;
    for (const obj of objects) {
      if (obj?.hostType === ELEMENT_CONTEXT_TYPE.SHADOW) {
        return true;
      }
    }
    return false;
  };
  const onIsInsideHostsChange = (value) => {
    const elementContext = uiIdentifier?.hostElements || elementCtx;
    if (value && !elementContext?.length) {
      onAddHostElement();
    }
    onChangeElementDetails({ isInsideHosts: value });
  };
  const onHostElementValueChange = (updatedField, ctxSeq) => {
    const elementContext = [
      ...(uiIdentifier ?? elementIdentifier)?.hostElements || elementCtx
    ];
    elementContext[ctxSeq] = updatedField;
    setElementCtx(elementContext);
    const isShadowHost = hasShadowHostType2(elementContext);
    if (isShadowHost) {
      onLocatorChange(ElementIdentifierLocatorType.csspath);
    }
    onChangeElementDetails({ elementContext });
  };
  const onAddHostElement = async () => {
    const elementContext = uiIdentifier?.hostElements || elementCtx;
    const newHostElem = {
      hostType: ELEMENT_CONTEXT_TYPE.SHADOW,
      locatorType: ElementIdentifierLocatorType.csspath,
      definition: "",
      createdType: ElementIdentifierCreateType.MANUAL,
      updateType: ElementIdentifierCreateType.MANUAL,
      applicationVersionId: await recorder.getAppVersionId()
    };
    onLocatorChange(ElementIdentifierLocatorType.csspath);
    setElementCtx([...elementContext, newHostElem]);
    onChangeElementDetails({
      elementContext: [...elementContext, newHostElem]
    });
  };
  const onRemoveHostElement = (index) => {
    const elementContext = uiIdentifier?.hostElements || elementCtx;
    elementContext.splice(index, 1);
    const isShadowHost = hasShadowHostType2(elementContext);
    if (isShadowHost) {
      onLocatorChange(ElementIdentifierLocatorType.csspath);
    }
    onChangeElementDetails({ elementContext });
  };
  const onAutoHealingEnabledChange = (value) => {
    setAutoHealingEnabled(value);
    onChangeElementDetails({ autoHealingEnabled: value });
  };
  const locatorTypeItems = IDENTIFIER_LOCATOR_TYPES.map((locType) => {
    const label = locType.value;
    return label;
  });
  const hostsLocatorTypes = HOSTS_LOCATOR_TYPES.map((locType) => {
    const label = locType.value;
    return label;
  });
  const actions = {
    onDefinitionChange,
    onIsInsideHostsChange,
    onNameChange,
    onScreenNameIdChange,
    onLocatorChange,
    onAddHostElement,
    onHostElementValueChange,
    onRemoveHostElement,
    // validation methods
    validateName,
    validateDefinition,
    validateScreenNameId: validateScreenName,
    screenNameOptionsHook
  };
  useEffect(() => {
    const sendMessage = (value) => {
      sendToContentWindow(
        MESSAGE_CONTEXT.UPDATE_MODAL_OPENED,
        MESSAGE_CONTEXT_ACTION.UPDATE,
        value
      );
    };
    sendMessage(true);
    return () => sendMessage(false);
  }, []);
  const setOccurance = (occurance2, checkError = false) => {
    _setOccurance(occurance2);
    if (checkError) {
      const validationMessage = validateOccurance(name);
      setOccuranceErrorText(validationMessage);
    }
  };
  const validateOccurance = useCallback((occurance2) => {
    if (occurance2 < 1) return "Occurrence value should be greater than 0";
    if (occurance2 > 5) return "Occurrence value should be within 5";
    return "";
  }, []);
  const handleOccuranceChange = (occurance2) => {
    occurance2 = Number(occurance2);
    const validationMessage = validateOccurance(occurance2);
    setOccurance(occurance2);
    onChangeElementDetails({ imageLocatorOccurence: occurance2 });
    setOccuranceErrorText(validationMessage);
  };
  const customElementScreenShotFields = /* @__PURE__ */ jsx(
    ScreenShotFields,
    {
      applicationType: "",
      handleOccuranceChange,
      occuranceErrorText,
      occurance,
      updateElementImageDraft,
      isUpdate,
      elementUuid: eventData?.elementUuid,
      uiIdentifier,
      isSubmited
    }
  );
  const isImageType = (finderType || STEP_LOCATOR.XPATH.value) == STEP_LOCATOR.IMAGE.value;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      id: "ts-element-body",
      className: "overflow-y-auto overflow-x-hidden !space-y-7 mt-3.5 mb-3.5",
      children: [
        /* @__PURE__ */ jsx(
          UiAlert,
          {
            heading: "How to add element?",
            message: "Click and add your desired element (or) Add element details and click verify to view the element highlighted on the page"
          }
        ),
        /* @__PURE__ */ jsx(
          FormData2,
          {
            actions,
            isSubmited,
            values: elementIdentifier ? {
              ...elementIdentifier,
              name,
              definition: finderPath
            } : [],
            elementLocatorType: locatorTypeItems,
            screenNames: [uiIdentifier?.screenNameObj],
            screenshot: elementScreenshot,
            customElementScreenShotFields,
            occuranceErrorText,
            setOccuranceErrorText,
            restrictedLocatorTypes: nlpId && !IMAGE_SUPPORTED_NLPS.includes(Number(nlpId)) ? [ElementIdentifierLocatorType.image] : []
          }
        ),
        _canShowAutoHealCheckBox && /* @__PURE__ */ jsx(
          AutoHealCheckbox,
          {
            onChange: onAutoHealingEnabledChange,
            checked: autoHealingEnabled
          }
        ),
        !isImageType && /* @__PURE__ */ jsx(
          HostElementTrigger,
          {
            values: elementIdentifier ? elementIdentifier : [],
            actions,
            elementLocatorType: locatorTypeItems,
            hostsLocatorTypes
          }
        ),
        !isImageType && /* @__PURE__ */ jsx("div", { className: "flex mb-2 gap-x-2 items-center", children: /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            UiButton,
            {
              onClick: () => onVerifyElement(),
              color: "secondary",
              variant: "outlined",
              children: /* @__PURE__ */ jsx(Fragment, { children: "Verify" })
            }
          ),
          /* @__PURE__ */ jsx("span", { className: "font-semibold text-small text-gray-800", children: isLocatedElementNotExist ? /* @__PURE__ */ jsx(Fragment, { children: " Element doesn't exist" }) : isLocatedXpathInvalid ? /* @__PURE__ */ jsx(Fragment, { children: " XPATH is invalid" }) : isXpathValidating ? /* @__PURE__ */ jsx(Fragment, { children: "Finding Element..." }) : /* @__PURE__ */ jsx(Fragment, {}) })
        ] }) }),
        ((locatedElement?.element || eventData)?.parents?.length || (locatedElement?.element || eventData)?.attrs) && !isImageType && /* @__PURE__ */ jsx(
          MoreTargetElementDetails,
          {
            element: locatedElement?.element || eventData
          }
        )
      ]
    }
  );
}
var getLocatorTypeBasedOnPrecedence = (eventData, recorderPreferences) => {
  const locatorPrecedenceOrder = recorderPreferences.preferences.find(
    (item) => item.type === PREFERENCE_TYPE.LOCATOR_ORDER
  )?.preference?.locator;
  if (!locatorPrecedenceOrder) return eventData?.locatorType;
  let locatorType = eventData?.locatorType;
  locatorPrecedenceOrder.every((locator) => {
    if (locator === "id") {
      const value = eventData?.attrs?.id ?? "";
      if (value && !canIgnoreId2(value)) {
        locatorType = STEP_LOCATOR.ID.value;
        return false;
      }
    } else if (locator === "link") {
      const value = eventData?.linkText ?? "";
      if (value) {
        locatorType = STEP_LOCATOR.LINK_TEXT.value;
        return false;
      }
    } else if (locator === "name") {
      const value = eventData?.nameAttr ?? "";
      if (value && !canIgnoreId2(value)) {
        locatorType = STEP_LOCATOR.NAME.value;
        return false;
      }
    } else if (locator === "css") {
      const value = eventData?.cssPath ?? "";
      if (value) {
        locatorType = STEP_LOCATOR.CSS_LOCATOR.value;
        return false;
      }
    } else if (locator === "xpath") {
      const value = eventData?.xPath ?? "";
      if (value) {
        locatorType = STEP_LOCATOR.XPATH.value;
        return false;
      }
    }
    return true;
  });
  return locatorType;
};
function Footer2({
  onCreate,
  onClose,
  isCapture,
  isUpdate,
  isLoading = false,
  isFormDirty = false,
  isDebugger = false
}) {
  const renderButtons = () => {
    if (isDebugger) {
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          PrimaryButton,
          {
            onClick: onCreate,
            isDisabled: !isFormDirty || isLoading,
            isLoading,
            children: isUpdate ? "Update" : isCapture ? "Capture" : "Create"
          }
        ),
        /* @__PURE__ */ jsx(SecondaryButton, { onClick: onClose, isDisabled: isLoading, children: "Cancel" })
      ] });
    }
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(UiButton, { onClick: onClose, color: "secondary", variant: "outlined", children: /* @__PURE__ */ jsx(Fragment, { children: "Cancel" }) }),
      /* @__PURE__ */ jsx(
        UiButton,
        {
          onClick: () => onCreate(),
          color: "primary",
          variant: "contained",
          isDisabled: !isFormDirty || isLoading,
          children: /* @__PURE__ */ jsxs(Fragment, { children: [
            !isLoading && /* @__PURE__ */ jsx(Fragment, { children: isUpdate ? "Update" : isCapture ? "Capture" : "Create" }),
            isLoading && /* @__PURE__ */ jsx("span", { className: "flex justify-center items-center h-5 w-full", children: /* @__PURE__ */ jsx(AiOutlineLoading3Quarters, { className: "animate-spin h-5 w-5" }) })
          ] })
        }
      )
    ] });
  };
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: `flex flex-row items-center w-full space-x-3 ${isDebugger ? "justify-start" : "justify-end"}`,
      children: renderButtons()
    }
  );
}
function UiTooltip({
  children,
  title,
  placement,
  className,
  onClick,
  isDisabled
}) {
  return /* @__PURE__ */ jsx(Tooltip, { title, arrow: true, placement: placement || "bottom", children: /* @__PURE__ */ jsx(
    "span",
    {
      className: `${className} ${isDisabled ? "opacity-50 cursor-default" : ""}`,
      onClick: !isDisabled ? onClick : () => {
      },
      children
    }
  ) });
}
var BackIcon = ({ className, onClick }) => {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      className,
      onClick,
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "inherit",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M5.61784 11.4169L2.61784 8.41693C2.56228 8.36137 2.52073 8.29737 2.49317 8.22493C2.46517 8.15293 2.45117 8.07804 2.45117 8.00026C2.45117 7.92248 2.46517 7.84737 2.49317 7.77493C2.52073 7.70293 2.56228 7.63915 2.61784 7.58359L5.63451 4.56693C5.72339 4.47804 5.83451 4.43359 5.96784 4.43359C6.10117 4.43359 6.21784 4.48359 6.31784 4.58359C6.41784 4.68359 6.46784 4.80026 6.46784 4.93359C6.46784 5.06693 6.41784 5.18359 6.31784 5.28359L4.10117 7.50026H13.3012C13.4456 7.50026 13.5652 7.54737 13.6598 7.64159C13.7541 7.73626 13.8012 7.85582 13.8012 8.00026C13.8012 8.1447 13.7541 8.26404 13.6598 8.35826C13.5652 8.45293 13.4456 8.50026 13.3012 8.50026H4.10117L6.33451 10.7336C6.42339 10.8225 6.46784 10.9336 6.46784 11.0669C6.46784 11.2003 6.41784 11.3169 6.31784 11.4169C6.21784 11.5169 6.10117 11.5669 5.96784 11.5669C5.83451 11.5669 5.71784 11.5169 5.61784 11.4169Z",
          fill: "inherit"
        }
      )
    }
  );
};
var BackIcon_default = BackIcon;
function OverlayContainer({
  body,
  footer,
  title,
  onClose,
  isFixedFooter,
  noBodyWrapper,
  headerActions,
  className,
  headerIcon
}) {
  const { isDebugger } = useRecorderContext();
  const renderHeader = () => {
    if (isDebugger) {
      return /* @__PURE__ */ jsx(
        header_default,
        {
          onClose,
          title,
          headerActions,
          icon: headerIcon
        }
      );
    }
    return /* @__PURE__ */ jsxs("div", { className: "px-4.5 py-2.5 flex flex-row items-center space-x-2 border-b border-solid border-x-0 border-t-0 border-gray-100", children: [
      /* @__PURE__ */ jsx(
        UiTooltip,
        {
          title: "Back",
          className: "flex cursor-pointer",
          onClick: () => onClose(),
          children: /* @__PURE__ */ jsx(BackIcon_default, { className: "h-5.5 w-fit fill-slate-800" })
        }
      ),
      /* @__PURE__ */ jsx("span", { className: "flex-1 text-sm font-semibold text-slate-800 truncate", children: title }),
      /* @__PURE__ */ jsx("span", { className: "flex-shrink-0", children: headerActions })
    ] });
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames82(
        `z-[1001] bg-white shadow-xl w-full left-0 rounded-md rounded-t-none ts-recorder-widget-overlay absolute top-0`,
        className
      ),
      children: [
        renderHeader(),
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: `ts-recorder-widget-overlay-children${isFixedFooter ? " fixed-footer" : " !flex flex-col"}`,
            children: [
              noBodyWrapper ? body : /* @__PURE__ */ jsx("div", { className: "overflow-y-auto px-4.5 h-full", children: body }),
              isFixedFooter && /* @__PURE__ */ jsx("div", { className: "px-3 border-solid border-x-0 border-t border-b-0 border-gray-100 flex items-center", children: footer })
            ]
          }
        )
      ]
    }
  );
}

// src/components/test-recorder/utils/element/element-event.ts
var createIdentifier = async (eventData) => {
  let uiIdentifier;
  if (eventData?.sfPredefinedElementDetails) {
    uiIdentifier = await populateSalesforceDerivedElementFromEventData(
      eventData
    );
  } else {
    uiIdentifier = await addUiIdentifier(eventData);
  }
  const { screenshotRetrievalId, locatorTree } = eventData;
  const elementSS = selectElementScreenshotMap(
    getGlobalState(),
    screenshotRetrievalId
  );
  const croppedELementSS = selectCroppedElementScreenshotMap(
    getGlobalState(),
    screenshotRetrievalId
  );
  const appVersionId = getGlobalState().widget.appVersionId;
  if (croppedELementSS && uiIdentifier.id) {
    RecorderAssetsApi.saveCroppedElementScreenshot(uiIdentifier.id, {
      screenshotFile: dataurltoFile(croppedELementSS),
      applicationVersionId: appVersionId
    });
  }
  if (elementSS && uiIdentifier.id) {
    RecorderAssetsApi.saveElementScreenshot(uiIdentifier.id, {
      screenshotFile: dataurltoFile(elementSS),
      applicationVersionId: appVersionId
    });
  }
  if (locatorTree && uiIdentifier.id) {
    save_locator_tree_default.next({
      elementId: uiIdentifier.id,
      locatorTree
    });
  }
  return uiIdentifier;
};
var updateIdentifier = async (elementData) => {
  const identifierData = await getIdentifierDetails(elementData);
  const updatedIdentifier = await UiIdentifierApi.update({
    ...identifierData,
    id: elementData.id
  });
  const {
    screenshotRetrievalId,
    locatorTree,
    screenshotDataUrl,
    croppedScreenshotDataUrl
  } = elementData;
  let elementSS = screenshotDataUrl;
  let croppedElementSS = croppedScreenshotDataUrl;
  const globalState2 = getGlobalState();
  if ((!elementSS || !croppedElementSS) && screenshotRetrievalId) {
    if (!elementSS) {
      elementSS = selectElementScreenshotMap(
        globalState2,
        screenshotRetrievalId
      );
    }
    if (!croppedElementSS) {
      croppedElementSS = selectCroppedElementScreenshotMap(
        globalState2,
        screenshotRetrievalId
      );
    }
  }
  const appVersionId = globalState2.widget.appVersionId;
  if (croppedElementSS && updatedIdentifier.id) {
    RecorderAssetsApi.saveCroppedElementScreenshot(updatedIdentifier.id, {
      screenshotFile: dataurltoFile(croppedElementSS),
      applicationVersionId: appVersionId
    });
  }
  if (elementSS && updatedIdentifier.id) {
    RecorderAssetsApi.saveElementScreenshot(updatedIdentifier.id, {
      screenshotFile: dataurltoFile(elementSS),
      applicationVersionId: appVersionId
    });
  }
  if (locatorTree && updatedIdentifier.id) {
    save_locator_tree_default.next({
      elementId: updatedIdentifier.id,
      locatorTree
    });
  }
  return updatedIdentifier;
};
var populateSalesforceDerivedElementFromEventData = async (eventData) => {
  const objectFieldId = eventData?.sfPredefinedElementDetails?.predefinedField?.id;
  const uiIdentifier = await populateSalesforceDerivedElement(objectFieldId);
  return uiIdentifier;
};
var addUiIdentifier = async (eventData) => {
  const identifier = await getIdentifierDetails(eventData);
  const uiIdentifier = await UiIdentifierApi.create(
    identifier
  );
  const oldUIIdentifiers = getGlobalState().widget.uiIdentifiers ?? [];
  await getGlobalDispatch()(
    setUiIdentifiers([uiIdentifier, ...oldUIIdentifiers])
  );
  if (identifier.hostElements?.length > 0) {
    saveHostElementLocatorTrees(
      identifier.hostElements,
      uiIdentifier.hostElements
    );
  }
  return uiIdentifier;
};
var populateSalesforceDerivedElement = async (salesforceObjectFieldId) => {
  const appVersionID = getGlobalState().widget.appVersionId;
  const uiIdentifier = await UiIdentifierApi.getDerivedUiIdentifier(
    appVersionID,
    salesforceObjectFieldId
  );
  const oldUIIdentifiers = getGlobalState().widget.uiIdentifiers;
  await getGlobalDispatch()(
    setUiIdentifiers([uiIdentifier, ...oldUIIdentifiers])
  );
  return uiIdentifier;
};

// src/components/test-recorder/api/recorder-preferences.ts
var namespace10 = "/recorder_preferences";
var getAll18 = (appVersionId, appType) => instance_default.get(namespace10 + `/${appVersionId}/${appType}`);
var update3 = (payload) => instance_default.put(namespace10, payload);
var RecorderPreferencesApi = {
  getAll: getAll18,
  update: update3
};

// src/components/test-recorder/utils/event/handlers/recorder-data.ts
var handleRecorderContext = (message, handleRecorderReload, launchRecorder) => {
  log.info("[WIDGET] handleRecorderContext", message);
  switch (message.action) {
    case MESSAGE_CONTEXT_ACTION.LAUNCH:
      if (message?.value?.isDebugMode === true) {
        break;
      }
      if (launchRecorder) {
        launchRecorder(message, true);
      } else {
        handleRecorderLaunch(message);
      }
      break;
    case MESSAGE_CONTEXT_ACTION.DEBUG_EXECUTION_STATUS_LIST:
      setCurrentExecutionStatusList(message.value);
      break;
    case MESSAGE_CONTEXT_ACTION.RELOAD:
      if (handleRecorderReload) {
        handleRecorderReload(message.value.type);
      } else {
        loadRecorderData(message.value.type);
      }
      break;
    case MESSAGE_CONTEXT_ACTION.CLEAR_LAST_PROCESSED_DATA:
      clearLastProcessedData();
      break;
    case MESSAGE_CONTEXT_ACTION.BROADCAST:
      if (message.value === RECORDER_TYPE.ELEMENT_CAPTURE) {
        const dispatch = getGlobalDispatch();
        dispatch(setLoaderMessage(null));
        dispatch(setIsRecorderLoaded(true));
      }
      break;
  }
};
var handleRecorderLaunch = async (message) => {
  log.info("[WIDGET] [HANDLE RECORDER LAUNCH] [MESSAGE]", message);
  const recorderData = message.value;
  const dispatch = getGlobalDispatch();
  const recorderType = recorderData.type;
  const isInitialLoad = recorderData.isInitialLoad;
  if (isInitialLoad && recorderType === RECORDER_TYPE.ELEMENT_CAPTURE && !getGlobalState().widget.isRecorderLoaded) {
    await dispatch(
      setLoaderMessage(
        "Switch to another tab or window to record the element."
      )
    );
  }
  if (recorderType) {
    await initializeRecorderData(recorderData);
    if ((recorderType === RECORDER_TYPE.ELEMENT_CAPTURE || recorderType === RECORDER_TYPE.ELEMENT) && recorderData.appVersionId) {
      log.info("[DEBUG] initializeElementRecorderData", recorderData);
      await initializeElementRecorderData(recorderData);
    } else if (recorderType === RECORDER_TYPE.STEP) {
      log.info("[DEBUG] initializeStepRecorderData", recorderData);
      if (recorderData.isDebugMode) await dispatch(updateIgnoreSwitchTab(true));
      await initializeStepRecorderData(recorderData);
    }
  }
  if (isInitialLoad && recorderType !== RECORDER_TYPE.ELEMENT_CAPTURE) {
    dispatch(setIsRecorderLoaded(true));
  }
  log.debug("[WIDGET] Initialized recorder data", recorderData);
};
var initializeElementRecorderData = async (recorderData) => {
  const dispatch = getGlobalDispatch();
  if (recorderData.appVersionId) {
    await dispatch(setAppVersionId(recorderData.appVersionId));
    const state = getGlobalState();
    if (state.widget.appVersionId !== recorderData.appVersionId) {
      log.info("[DEBUG] Waiting for appVersionId to be set in state");
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
  }
  await loadElementInitialData();
};
var loadElementInitialData = async (loadScreenOnly = false) => {
  const dispatch = getGlobalDispatch();
  const sendToBackground2 = getSendToBackground();
  const appVersionId = getGlobalState().widget.appVersionId;
  log.info("[DEBUG] loadElementInitialData", appVersionId);
  if (appVersionId) {
    const appVersion = await ApplicationVersionApi.getOne(appVersionId);
    await dispatch(setAppVersion(appVersion));
    const promises = [ScreenApi.getAll(appVersion?.id)];
    if (!loadScreenOnly) {
      promises.push(
        RecorderPreferencesApi.getAll(
          appVersion?.applicationId || 0,
          appVersion?.application?.applicationType
        )
      );
    }
    Promise.all(promises).then(async (results) => {
      const screens = results?.[0];
      const recorderPreferences = results?.[1];
      console.log("Promise.all: screens", screens);
      console.log("Promise.all: recorderPreferences", recorderPreferences);
      await dispatch(setScreens(screens?.content));
      if (!loadScreenOnly && recorderPreferences) {
        await dispatch(setRecorderPreferences(recorderPreferences));
        sendToBackground2?.({
          context: MESSAGE_CONTEXT.RECORDER,
          action: MESSAGE_CONTEXT_ACTION.SYNC_PREFERENCE,
          value: recorderPreferences
        });
      }
    });
  }
};
var initializeRecorderData = async (recorderData) => {
  const dispatch = getGlobalDispatch();
  const stateUpdates = [
    dispatch(setRecorderType(recorderData.type)),
    recorderData.projectId && dispatch(setProjectId(recorderData.projectId)),
    recorderData.applicationType && dispatch(setAppType(recorderData.applicationType)),
    recorderData.applicationId && dispatch(setApplicationId(recorderData.applicationId)),
    recorderData.source && dispatch(setRecorderSource(recorderData.source)),
    recorderData.serverUrl && dispatch(setApiUrl(String(recorderData.serverUrl))),
    recorderData.tenantFeatures && dispatch(setTenantFeatures(recorderData.tenantFeatures)),
    recorderData.tenantPreference && dispatch(setTenantPreference(recorderData.tenantPreference)),
    recorderData.recorderState && dispatch(updateRecorderState(recorderData.recorderState)),
    recorderData.currentUrl && dispatch(
      setIsExtensionPage(
        recorderData.currentUrl.includes("src/pages/GetStarted/index.html") || recorderData.currentUrl.includes("about:blank")
      )
    )
  ].filter(Boolean);
  await Promise.all(stateUpdates);
};
var initializeStepRecorderData = async (recorderData) => {
  await initializeElementRecorderData(recorderData);
  await loadStepRecorderInitialData(
    recorderData.testCaseId,
    recorderData.isDebugMode
  );
};
var loadStepRecorderInitialData = async (testCaseId, isDebugger = false) => {
  const widgetState = getGlobalState().widget;
  const dispatch = getGlobalDispatch();
  const previousTestCaseId = widgetState?.testCase?.id;
  testCaseId = testCaseId || previousTestCaseId;
  const isTestCaseChanged = testCaseId != null && previousTestCaseId != null && String(testCaseId) !== String(previousTestCaseId);
  if (isTestCaseChanged) {
    dispatch(setCopilotChatHistory(null));
  }
  if (testCaseId) {
    const testCase = await TestCaseApi.getOne(testCaseId);
    await dispatch(updateTestCase(testCase));
    const testSteps = await getAllPagesTestSteps(true);
    if (isDebugger) {
      const flattenedStepResponse = flatTestSteps({
        teststeps: testSteps.content,
        applicationType: widgetState?.appType,
        page: 0
      });
      await dispatch(updateTestSteps(flattenedStepResponse));
    } else {
      await dispatch(updateTestSteps(testSteps.content));
    }
  }
  const applicationType = widgetState.appType;
  if (applicationType) {
    const promises = [
      TemplateApi.getAll(applicationType),
      TemplateApi.getAllFromAddon(applicationType)
    ];
    await Promise.all(promises).then(async (results) => {
      const templates = results?.[0];
      const addonTemplates = results?.[1];
      console.log("Promise.all: templates", templates);
      console.log("Promise.all: addonTemplates", addonTemplates);
      await dispatch(
        setTemplates(
          templates?.content?.map((template) => ({
            ...template,
            isAddon: false
          }))
        )
      );
      await dispatch(
        setAddonTemplates(
          addonTemplates?.content?.map((template) => ({
            ...template,
            isAddon: true
          }))
        )
      );
    });
  }
  const appVersionId = widgetState.appVersionId;
  if (appVersionId) {
    const promises = [
      TestCaseApi.getAllGroup({
        appVersionId
      }),
      DataProfileApi.getAll(appVersionId)
    ];
    Promise.all(promises).then(async (results) => {
      const stepGroups = results?.[0];
      const dataProfiles = results?.[1];
      console.log("Promise.all: stepGroups", stepGroups);
      console.log("Promise.all: dataProfiles", dataProfiles);
      const transformedProfiles = dataProfiles?.content?.map((profile) => ({
        ...profile,
        name: profile.testDataName
      }));
      await dispatch(setStepGroups(stepGroups?.content));
      await dispatch(setDataProfiles(transformedProfiles));
    });
  }
  await dispatch(setStepCursor(null));
  const sendToBackground2 = getSendToBackground();
  sendToBackground2?.({
    context: MESSAGE_CONTEXT.COPILOT,
    action: MESSAGE_CONTEXT_ACTION.REQUEST,
    value: { testCaseId: testCaseId ? String(testCaseId) : void 0 }
  });
};
var loadRecorderData = async (recorderType) => {
  await loadElementInitialData();
  if (recorderType === RECORDER_TYPE.STEP) {
    await loadStepRecorderInitialData();
  }
};
var setCurrentExecutionStatusList = async (value) => {
  let stepList = getGlobalState()?.widget?.testSteps;
  if (!stepList) {
    stepList = [];
  }
  const currentExecutionStatus = value?.data;
  if (currentExecutionStatus?.liveStepResults) {
    for (const stepResult of currentExecutionStatus.liveStepResults) {
      const matchingStep = stepList.find(
        (step) => step.id === stepResult.stepId
      );
      if (matchingStep) {
        stepResult.stepData = matchingStep;
        stepResult.stepDetails = matchingStep;
      }
    }
  }
  const lastLoadedTestCaseId = getGlobalState()?.widget?.testCase?.id;
  const currentExecutionTestCaseId = currentExecutionStatus?.testCaseId;
  const isDifferentTestCase = currentExecutionTestCaseId && lastLoadedTestCaseId && currentExecutionTestCaseId !== lastLoadedTestCaseId;
  const isDifferentTab = value?.isDifferentTab;
  const isNeededToReInitiate = isDifferentTestCase || isDifferentTab;
  if (isNeededToReInitiate) {
    loadData(currentExecutionTestCaseId);
  }
  getGlobalDispatch()(setCurrentExecutionStatus(currentExecutionStatus));
};
var loadData = async (testCaseId) => {
  const dispatch = getGlobalDispatch();
  await dispatch(updateLastPageFetched(false));
  await dispatch(updateMaxFetchedPageNumber(-1));
  await loadElementInitialData();
  await loadStepRecorderInitialData(testCaseId);
};
var handleApiIdentifierContext = (message) => {
  switch (message.action) {
    case MESSAGE_CONTEXT_ACTION.CREATE:
      handleApiIdentifierCreate(message.value);
      break;
    case MESSAGE_CONTEXT_ACTION.BROADCAST:
      getGlobalDispatch()(setCreatedElement(message.value));
      break;
    // Not called anywhere
    case MESSAGE_CONTEXT_ACTION.UPDATE:
      handleApiIdentifierUpdate(message.value);
      break;
    // Not called anywhere
    case MESSAGE_CONTEXT_ACTION.RELOAD:
      handleApiIdentifierReload();
      break;
  }
};
var handleApiIdentifierCreate = async (value) => {
  try {
    const createdIdentifier = await createIdentifier(
      cloneDeep(value)
    );
    await getGlobalDispatch()(setCreatedElement(createdIdentifier));
  } catch (e) {
    log.info("[WIDGET] ELEMENT NOT CREATED", value, e);
  }
};
var handleApiIdentifierUpdate = async (value) => {
  try {
    const updatedIdentifier = await updateIdentifier(
      cloneDeep(value)
    );
    await getGlobalDispatch()(setCreatedElement(updatedIdentifier));
  } catch (e) {
    log.info("[WIDGET] ELEMENT NOT UPDATED", value);
  }
};
var handleApiIdentifierReload = async () => {
  const appVersionId = getGlobalState().widget.appVersionId;
  if (appVersionId) {
    const uiIdentifiers = await UiIdentifierApi.getAll({
      appVersionId,
      offset: 0
    });
    await getGlobalDispatch()(setUiIdentifiers(uiIdentifiers.content));
  }
  loadElementInitialData();
};
function CreateElement({
  onClose,
  uiIdentifier,
  onUpdate,
  nlpId = null
}) {
  const { sendToBackground: sendToBackground2, sendToWidget, sendToContentWindow } = useMessaging();
  const [newElementData, setNewElementData] = useState({
    autoHealingEnabled: true
  });
  const prevElementData = useRef(newElementData);
  const [isValidElement, setIsValidElement] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isSubmited, setIsSubmited] = useState(false);
  const [isDataFromRecorder, setIsDataFromRecorder] = useState(false);
  const sendToBackgroundCalled = useRef(false);
  const dispatch = useDispatch();
  const [elementImageDraft, _updateElementImageDraft] = useState(uiIdentifier?.elementImageDraft || null);
  const { recorderState, recorderType, enableSaveElement } = useSelector(
    (state) => state.widget
  );
  const { isDebugger: isDebugMode } = useRecorderContext();
  const deregisterListener = () => {
    if (sendToBackgroundCalled.current) {
      sendToBackground2({
        context: MESSAGE_CONTEXT.ELEMENT_FINDER,
        action: MESSAGE_CONTEXT_ACTION.DEREGISTER,
        value: recorderState
      });
      sendToBackgroundCalled.current = false;
    }
  };
  useEffect(() => {
    log.debug("CreateElement => recorderState # initial", {
      isDebugMode,
      recorderState,
      current: sendToBackgroundCalled.current
    });
    if (recorderState && recorderState === RECORDER_STATE.RUNNING || isDebugMode) {
      if (!sendToBackgroundCalled.current) {
        sendToBackground2({
          context: MESSAGE_CONTEXT.ELEMENT_FINDER,
          action: MESSAGE_CONTEXT_ACTION.REGISTER,
          value: ""
        });
        sendToBackgroundCalled.current = true;
      }
    } else {
      deregisterListener();
    }
  }, [recorderState, isDebugMode]);
  const validateName = (name) => {
    if (!name?.trim()) {
      return "Name can't be blank";
    } else if (name.trim().length < 4) {
      return "Name should have at least 4 characters";
    } else if (name.length > 250) {
      return "Name should be less than 250 characters";
    }
    return "";
  };
  const validateDefinition = (definition) => {
    if (!definition?.trim()) {
      return "Element value can't be blank";
    }
    return "";
  };
  const validateScreenName = (screenName) => {
    if (!screenName?.trim()) {
      return "Screen Name can't be blank";
    } else if (screenName.trim().length < 4) {
      return "Screen Name should have at least 4 characters";
    } else if (screenName.length > 250) {
      return "Screen Name should be less than 250 characters";
    }
    return "";
  };
  const validateImageType = (element, _elementImageDraft) => {
    if (element.imageLocatorOccurence < 1 || element.imageLocatorOccurence > 5)
      return false;
    if (!_elementImageDraft) return false;
    return true;
  };
  useEffect(() => {
    if (newElementData) {
      const isValidName = validateName(newElementData.name) == "";
      const isValidScreenName = validateScreenName(newElementData.screenTitle) == "";
      const isValidDefinition = validateDefinition(getDifinitionByLocatorType(newElementData)) == "";
      setIsValidElement(
        newElementData.locatorType == STEP_LOCATOR.IMAGE.value ? !!(isValidName && isValidScreenName && validateImageType(newElementData, elementImageDraft)) : !!(isValidName && isValidScreenName && isValidDefinition)
      );
    }
  }, [newElementData, elementImageDraft, isUpdate]);
  useEffect(() => {
    if (uiIdentifier) {
      const updateElementData = {
        name: uiIdentifier?.name,
        xPath: uiIdentifier?.locatorType === STEP_LOCATOR.XPATH.value ? uiIdentifier?.definition : "",
        action: "",
        tag: "",
        attrs: uiIdentifier?.attrs || {},
        shadowElement: false,
        parents: uiIdentifier?.parents || [],
        isDynamicElement: false,
        screenTitle: uiIdentifier?.screenNameObj?.name,
        definition: uiIdentifier?.definition,
        locatorType: uiIdentifier?.locatorType,
        cssPath: uiIdentifier?.locatorType === STEP_LOCATOR.CSS_LOCATOR.value ? uiIdentifier?.definition : "",
        elementContext: uiIdentifier.hostElements,
        isInsideHosts: uiIdentifier.isInsideHosts,
        linkText: uiIdentifier?.locatorType === STEP_LOCATOR.LINK_TEXT.value ? uiIdentifier?.definition : "",
        nameAttr: uiIdentifier?.locatorType === STEP_LOCATOR.NAME.value ? uiIdentifier?.definition : "",
        idSelector: uiIdentifier?.locatorType === STEP_LOCATOR.ID.value ? uiIdentifier?.definition : "",
        elementImageDraft: uiIdentifier?.locatorType == STEP_LOCATOR.IMAGE.value ? uiIdentifier?.elementImageDraft : {},
        elementUuid: uiIdentifier?.elementUuid || v4(),
        imageLocatorOccurence: uiIdentifier?.imageLocatorOccurence || 1,
        autoHealingEnabled: uiIdentifier?.autoHealingEnabled
      };
      prevElementData.current = updateElementData;
      setNewElementData(updateElementData);
      setIsUpdate(true);
    }
  }, [uiIdentifier]);
  useEffect(() => {
    loadElementInitialData(true);
    return () => {
      dispatch(
        setLocatedElement({
          element: void 0,
          error: ""
        })
      );
      deregisterListener();
    };
  }, []);
  const handleUpdate = useCallback(() => {
    if (onUpdate && newElementData) {
      const { screenshotRetrievalId } = newElementData;
      let screenshotDataUrl = "";
      let croppedScreenshotDataUrl = "";
      if (screenshotRetrievalId) {
        screenshotDataUrl = selectElementScreenshotMap(getGlobalState(), screenshotRetrievalId) || "";
        croppedScreenshotDataUrl = selectCroppedElementScreenshotMap(
          getGlobalState(),
          screenshotRetrievalId
        ) || "";
      }
      const elementDataWithScreenshot = {
        ...newElementData,
        screenshotDataUrl,
        croppedScreenshotDataUrl,
        // By default, updateType = createdType. Only change to MANUAL if user manually edited.
        updateType: isDataFromRecorder ? newElementData.createdType : "MANUAL"
      };
      onUpdate(elementDataWithScreenshot);
      sendToWidget(CUSTOM_EVENT.ELEMENT_FINDER, {});
    }
  }, [newElementData, onUpdate, isDataFromRecorder]);
  const handleCreate2 = useCallback(() => {
    newElementData.elementImageDraft = elementImageDraft || {};
    setIsSubmited(true);
    if (isValidElement) {
      if (isUpdate) {
        handleUpdate();
      } else {
        if (!isDataFromRecorder && newElementData.createdType !== "MANUAL") {
          newElementData.updateType = "MANUAL";
        }
        if (recorderType === RECORDER_TYPE.ELEMENT_CAPTURE) {
          const { screenshotRetrievalId, locatorTree } = newElementData;
          const props = {
            elementSS: null,
            croppedElementSS: null,
            locatorTree
          };
          if (screenshotRetrievalId) {
            props.elementSS = selectElementScreenshotMap(
              getGlobalState(),
              screenshotRetrievalId
            ) || "";
            props.croppedElementSS = selectCroppedElementScreenshotMap(
              getGlobalState(),
              screenshotRetrievalId
            ) || "";
          }
          sendToBackground2({
            context: MESSAGE_CONTEXT.ELEMENT_FINDER,
            action: MESSAGE_CONTEXT_ACTION.BROADCAST,
            value: newElementData,
            props
          });
        } else {
          handleApiIdentifierCreate(newElementData);
          sendToWidget(CUSTOM_EVENT.ELEMENT_FINDER, {});
          if (enableSaveElement) {
            onClose();
            dispatch(setEnableSaveElement(false));
          }
        }
      }
    }
  }, [
    enableSaveElement,
    handleUpdate,
    isUpdate,
    isValidElement,
    newElementData,
    onClose,
    recorderType,
    elementImageDraft,
    isDataFromRecorder
  ]);
  const handleElementDetailsChange = useCallback(
    (data, fromRecorder = false) => {
      if (!fromRecorder) {
        setIsDataFromRecorder(false);
      } else {
        setIsDataFromRecorder(true);
      }
      setNewElementData((prev) => {
        return { ...prev, ...data };
      });
    },
    []
  );
  const handleVerifyElement = useCallback(() => {
    sendToBackground2({
      context: MESSAGE_CONTEXT.ELEMENT_FINDER,
      action: MESSAGE_CONTEXT_ACTION.VERIFY,
      value: newElementData
    });
    sendToWidget(CUSTOM_EVENT.ELEMENT_FINDER, void 0);
    const timeout = setTimeout(() => {
      dispatch(setVerifyTimeout(null));
      dispatch(
        setLocatedElement({
          element: void 0,
          error: ERROR_CODE.ELEMENT_NOT_EXIST
        })
      );
    }, 2e3);
    dispatch(setVerifyTimeout(timeout));
  }, [newElementData]);
  const handlClose = () => {
    sendToContentWindow(
      MESSAGE_CONTEXT_ACTION.CANCEL,
      MESSAGE_CONTEXT.CAPTURE_ELEMENT_IMAGE,
      {}
    );
    if (recorderType === RECORDER_TYPE.ELEMENT_CAPTURE) {
      sendToBackground2({
        context: MESSAGE_CONTEXT.ELEMENT_FINDER,
        action: MESSAGE_CONTEXT_ACTION.CLOSE,
        value: null
      });
      return;
    } else if (enableSaveElement) {
      dispatch(setEnableSaveElement(false));
    }
    sendToWidget(CUSTOM_EVENT.ELEMENT_FINDER, {});
    onClose();
  };
  const isCapture = recorderType === RECORDER_TYPE.ELEMENT_CAPTURE;
  const isDirty = useMemo(() => {
    return JSON.stringify(omit(newElementData, "idSelector")) !== JSON.stringify(omit(prevElementData.current, "idSelector"));
  }, [newElementData, prevElementData]);
  const updateElementImageDraft = useCallback(
    (payload) => {
      const details = {};
      _updateElementImageDraft(payload);
      if (!newElementData?.elementUuid) {
        details.elementUuid = v4();
      }
      if (!newElementData?.imageLocatorOccurence) {
        details.imageLocatorOccurence = 1;
      }
      if (elementImageDraft != payload && !!elementImageDraft) {
        details.elementImageDraftUpdateTime = Date.now();
      }
      if (Object.keys(details).length) handleElementDetailsChange(details);
    },
    [
      _updateElementImageDraft,
      handleElementDetailsChange,
      newElementData,
      elementImageDraft
    ]
  );
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    OverlayContainer,
    {
      title: `${isUpdate ? "Update" : isCapture ? "Capture" : "Create"} Element`,
      onClose: () => handlClose(),
      isFixedFooter: true,
      body: /* @__PURE__ */ jsx(
        Body,
        {
          eventData: newElementData,
          onChangeElementDetails: (data, fromRecorder) => handleElementDetailsChange(data, fromRecorder),
          onVerify: handleVerifyElement,
          validateDefinition,
          validateName,
          validateScreenName,
          uiIdentifier,
          isSubmited,
          updateElementImageDraft,
          isUpdate,
          nlpId
        }
      ),
      footer: /* @__PURE__ */ jsx(
        Footer2,
        {
          onCreate: () => handleCreate2(),
          isCapture,
          onClose: () => handlClose(),
          isUpdate,
          isLoading: false,
          isFormDirty: isDirty,
          isExistsElementData: !!newElementData,
          isDebugger: isDebugMode
        }
      )
    }
  ) });
}
function Footer3({ onClose }) {
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-row items-center w-full justify-end space-x-3", children: [
    /* @__PURE__ */ jsx(UiButton, { onClick: () => onClose(), color: "secondary", variant: "outlined", children: /* @__PURE__ */ jsx(Fragment, { children: "Cancel" }) }),
    /* @__PURE__ */ jsx(
      Tooltip,
      {
        title: "Salesforce fields are pre-learnt and cannot be captured",
        children: /* @__PURE__ */ jsx(
          UiButton,
          {
            onClick: () => {
            },
            color: "primary",
            variant: "contained",
            label: "Capture",
            isDisabled: true
          }
        )
      }
    )
  ] });
}
var InfoCard = ({
  icon,
  title,
  description,
  link
}) => {
  return /* @__PURE__ */ jsx("div", { className: "flex rounded-[10px] border p-3 w-full shadow", children: /* @__PURE__ */ jsxs("div", { className: "flex gap-x-6", children: [
    /* @__PURE__ */ jsx("div", { className: "h-12 w-12 rounded-full border-spacing-2.5 bg-error-50 flex items-center justify-center", children: icon }),
    /* @__PURE__ */ jsxs("div", { className: "flex-1", children: [
      /* @__PURE__ */ jsx("div", { className: "text-primary-1000 text-sm", children: title }),
      /* @__PURE__ */ jsxs("div", { className: "text-sm text-secondary-500 mt-2", children: [
        description,
        " ",
        link && /* @__PURE__ */ jsx(
          "a",
          {
            href: link,
            target: "_blank",
            className: "text-primary-700",
            rel: "noreferrer",
            children: "Learn more"
          }
        )
      ] })
    ] })
  ] }) });
};
var info_card_default = InfoCard;
function FieldRow({ label, value }) {
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-row items-center py-2", children: [
    /* @__PURE__ */ jsx("span", { className: "basis-1/2 break-all py-2 px-2 text-secondary-400", children: label }),
    /* @__PURE__ */ jsx("span", { className: "basis-1/2 break-all py-2 px-2 text-primary-800", children: value })
  ] });
}
function DerivedElementDetails({ salesforceObjectField }) {
  const [metadataObject, setMetadataObject] = useState(null);
  useEffect(() => {
    const id = salesforceObjectField?.metadataObjectId;
    if (id) {
      SalesforceMetadataObjectApi.getOne({ id }).then((res) => {
        setMetadataObject(res);
      });
    }
  }, [salesforceObjectField]);
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col divide-gray-100 divide-solid divide-x-0 divide-y text-small leading-5", children: [
    /* @__PURE__ */ jsx(FieldRow, { label: "Field Name", value: salesforceObjectField?.label }),
    /* @__PURE__ */ jsx(FieldRow, { label: "Object", value: metadataObject?.label || "" }),
    salesforceObjectField?.compoundFieldName && /* @__PURE__ */ jsx(
      FieldRow,
      {
        label: "Compound parent field",
        value: salesforceObjectField?.compoundFieldName
      }
    ),
    /* @__PURE__ */ jsx(FieldRow, { label: "Field type", value: salesforceObjectField?.label }),
    /* @__PURE__ */ jsx(
      FieldRow,
      {
        label: "Last updated at",
        value: DateFormatter.formatTimestamp(salesforceObjectField.updatedDate)
      }
    )
  ] });
}
function Body2({ salesforceObjectField }) {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs(
    "div",
    {
      id: "ts-element-body",
      className: "overflow-y-auto overflow-x-hidden my-3 mx-3.5",
      children: [
        salesforceObjectField?.isDeleted ? /* @__PURE__ */ jsx("div", { className: "bg-[#FFEDEB] border border-[#FF9C8F] rounded py-2 px-4", children: /* @__PURE__ */ jsxs("div", { className: "flex flex-row space-x-2", children: [
          /* @__PURE__ */ jsx(Icon, { name: "warning", className: "text-[14px]" }),
          /* @__PURE__ */ jsxs("div", { className: "flex flex-row w-full gap-2", children: [
            /* @__PURE__ */ jsx("div", { className: " text-secondary-1000 leading-4 font-medium  text-[13px]", children: t("element.removed.warning.message") }),
            /* @__PURE__ */ jsx("div", { className: "leading-4 font-medium  text-[13px]  !text-[#0055CC]", children: /* @__PURE__ */ jsx(
              "a",
              {
                href: "https://testsigma.com/docs/salesforce-testing/error-handling/",
                target: "_blank",
                rel: "noreferrer",
                children: t("common.learn.more")
              }
            ) })
          ] })
        ] }) }) : /* @__PURE__ */ jsx(
          info_card_default,
          {
            icon: /* @__PURE__ */ jsx(
              Icon,
              {
                name: "error",
                className: "flex text-2xl text-[#D97008] p-1 bg-[#FFF4E5] rounded-full"
              }
            ),
            title: "Salesforce elements are pre-learnt",
            description: "The standard elements of Salesforce are already learned and cannot be learnt again.",
            link: "https://testsigma.com/docs/"
          }
        ),
        /* @__PURE__ */ jsx(DerivedElementDetails, { salesforceObjectField })
      ]
    }
  );
}
function DerivedElement({
  onClose,
  uiIdentifier,
  skipRegister
}) {
  const { recorderType, enableSaveElement, locatedElement, recorderState } = useSelector((state) => state.widget);
  const { sendToBackground: sendToBackground2, sendToWidget } = useMessaging();
  const [salesforceObjectField, setSalesforceObjectField] = useState(uiIdentifier?.salesforceObjectField);
  useEffect(() => {
    if (!skipRegister) {
      sendToBackground2({
        context: MESSAGE_CONTEXT.ELEMENT_FINDER,
        action: MESSAGE_CONTEXT_ACTION.REGISTER,
        value: ""
      });
      return () => sendToBackground2({
        context: MESSAGE_CONTEXT.ELEMENT_FINDER,
        action: MESSAGE_CONTEXT_ACTION.DEREGISTER,
        value: {
          recorderState
        }
      });
    }
  }, []);
  useEffect(() => {
    loadElementInitialData(true);
  }, []);
  useEffect(() => {
    if (uiIdentifier) return;
    const predefinedFieldId = locatedElement?.element?.sfPredefinedElementDetails?.predefinedField?.id;
    if (predefinedFieldId) {
      SalesforceObjectFieldApi.getOne({ id: predefinedFieldId }).then((res) => {
        setSalesforceObjectField(res);
      });
    }
  }, [uiIdentifier]);
  const handleClose = () => {
    if (recorderType === RECORDER_TYPE.ELEMENT_CAPTURE) {
      sendToBackground2({
        context: MESSAGE_CONTEXT.ELEMENT_FINDER,
        action: MESSAGE_CONTEXT_ACTION.CLOSE,
        value: null
      });
      return;
    } else if (enableSaveElement) {
      sendToWidget(CUSTOM_EVENT.SAVE_ELEMENT, false);
    }
    sendToWidget(CUSTOM_EVENT.ELEMENT_FINDER, {});
    onClose();
  };
  const isCapture = recorderType === RECORDER_TYPE.ELEMENT_CAPTURE;
  return /* @__PURE__ */ jsx(
    OverlayContainer,
    {
      title: "View Salesforce Element",
      onClose: handleClose,
      isFixedFooter: true,
      body: salesforceObjectField ? /* @__PURE__ */ jsx(Body2, { salesforceObjectField }) : /* @__PURE__ */ jsx(Fragment, {}),
      footer: isCapture ? /* @__PURE__ */ jsx(Footer3, { onClose: handleClose }) : /* @__PURE__ */ jsx(Fragment, {})
    }
  );
}
var Alert2 = React5.forwardRef(function Alert3(props, ref) {
  return /* @__PURE__ */ jsx(MuiAlert, { elevation: 6, ref, variant: "filled", ...props });
});
function UiToast({
  type,
  message,
  isShow,
  onClose,
  noAutoHide
}) {
  const handleClose = () => {
    if (onClose) onClose();
  };
  const isCenterAligned = window.innerWidth > 600;
  return /* @__PURE__ */ jsx(
    Snackbar,
    {
      open: isShow,
      autoHideDuration: !noAutoHide ? 3e3 : null,
      onClose: handleClose,
      anchorOrigin: {
        vertical: "top",
        horizontal: isCenterAligned ? "center" : "right"
      },
      children: /* @__PURE__ */ jsx(Alert2, { onClose: handleClose, severity: type, sx: { width: "100%" }, children: message })
    }
  );
}
var HelpIcon = ({ className, onClick }) => {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      className,
      onClick,
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "inherit",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M7.99935 11.7493C8.18824 11.7493 8.34668 11.6827 8.47468 11.5493C8.60224 11.416 8.66602 11.2549 8.66602 11.066C8.66602 10.8771 8.60224 10.716 8.47468 10.5827C8.34668 10.4493 8.18824 10.3827 7.99935 10.3827C7.79935 10.3827 7.63557 10.4493 7.50802 10.5827C7.38002 10.716 7.31602 10.8771 7.31602 11.066C7.31602 11.2549 7.38002 11.416 7.50802 11.5493C7.63557 11.6827 7.79935 11.7493 7.99935 11.7493ZM8.04935 5.14935C8.39379 5.14935 8.66868 5.2409 8.87402 5.42402C9.07979 5.60757 9.18268 5.8549 9.18268 6.16602C9.18268 6.36602 9.12424 6.56313 9.00735 6.75735C8.8909 6.95202 8.71602 7.1549 8.48268 7.36602C8.16046 7.64379 7.92713 7.90757 7.78268 8.15735C7.63824 8.40757 7.56046 8.66602 7.54935 8.93268C7.53824 9.04379 7.57713 9.1409 7.66602 9.22402C7.7549 9.30757 7.86046 9.34935 7.98268 9.34935C8.10491 9.34935 8.21335 9.30757 8.30802 9.22402C8.40224 9.1409 8.46046 9.03824 8.48268 8.91602C8.51602 8.72713 8.58824 8.55202 8.69935 8.39068C8.81046 8.22979 8.98824 8.02713 9.23268 7.78268C9.57713 7.46046 9.81602 7.17157 9.94935 6.91602C10.0827 6.66046 10.1493 6.38268 10.1493 6.08268C10.1493 5.54935 9.9549 5.11313 9.56602 4.77402C9.17713 4.43535 8.67713 4.26602 8.06602 4.26602C7.6549 4.26602 7.27713 4.35202 6.93268 4.52402C6.58824 4.69646 6.31602 4.9549 6.11602 5.29935C6.06046 5.41046 6.04113 5.5189 6.05802 5.62468C6.07446 5.73002 6.13824 5.81602 6.24935 5.88268C6.34935 5.94935 6.4689 5.97157 6.60802 5.94935C6.74668 5.92713 6.86046 5.85491 6.94935 5.73268C7.08268 5.5549 7.23557 5.41313 7.40802 5.30735C7.58002 5.20202 7.79379 5.14935 8.04935 5.14935ZM7.99935 14.3327C7.12157 14.3327 6.29935 14.166 5.53268 13.8327C4.76602 13.4993 4.09646 13.0493 3.52402 12.4827C2.95202 11.916 2.49935 11.2465 2.16602 10.474C1.83268 9.70202 1.66602 8.87713 1.66602 7.99935C1.66602 7.12157 1.83268 6.29646 2.16602 5.52402C2.49935 4.75202 2.95202 4.08268 3.52402 3.51602C4.09646 2.94935 4.76602 2.49935 5.53268 2.16602C6.29935 1.83268 7.12157 1.66602 7.99935 1.66602C8.88824 1.66602 9.71602 1.83268 10.4827 2.16602C11.2493 2.49935 11.9189 2.94935 12.4914 3.51602C13.0633 4.08268 13.5133 4.75202 13.8413 5.52402C14.1689 6.29646 14.3327 7.12157 14.3327 7.99935C14.3327 8.87713 14.1689 9.70202 13.8413 10.474C13.5133 11.2465 13.0633 11.916 12.4914 12.4827C11.9189 13.0493 11.2493 13.4993 10.4827 13.8327C9.71602 14.166 8.88824 14.3327 7.99935 14.3327ZM7.99935 13.3327C9.48824 13.3327 10.7493 12.8133 11.7827 11.7747C12.816 10.7356 13.3327 9.47713 13.3327 7.99935C13.3327 6.52157 12.816 5.26313 11.7827 4.22402C10.7493 3.18535 9.48824 2.66602 7.99935 2.66602C6.53268 2.66602 5.27713 3.18535 4.23268 4.22402C3.18824 5.26313 2.66602 6.52157 2.66602 7.99935C2.66602 9.47713 3.18824 10.7356 4.23268 11.7747C5.27713 12.8133 6.53268 13.3327 7.99935 13.3327Z",
          fill: "inherit"
        }
      )
    }
  );
};
var HelpIcon_default = HelpIcon;
var DeleteIcon = ({ className, onClick }) => {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      className,
      onClick,
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "inherit",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M4.86667 13.666C4.53333 13.666 4.25 13.5493 4.01667 13.316C3.78333 13.0827 3.66667 12.7993 3.66667 12.466V3.99935H3.5C3.35556 3.99935 3.23622 3.95202 3.142 3.85735C3.04733 3.76313 3 3.64379 3 3.49935C3 3.3549 3.04733 3.23557 3.142 3.14135C3.23622 3.04668 3.35556 2.99935 3.5 2.99935H6C6 2.83268 6.05822 2.69379 6.17467 2.58268C6.29156 2.47157 6.43333 2.41602 6.6 2.41602H9.4C9.56667 2.41602 9.70844 2.47157 9.82533 2.58268C9.94178 2.69379 10 2.83268 10 2.99935H12.5C12.6444 2.99935 12.764 3.04668 12.8587 3.14135C12.9529 3.23557 13 3.3549 13 3.49935C13 3.64379 12.9529 3.76313 12.8587 3.85735C12.764 3.95202 12.6444 3.99935 12.5 3.99935H12.3333V12.466C12.3333 12.7993 12.2167 13.0827 11.9833 13.316C11.75 13.5493 11.4667 13.666 11.1333 13.666H4.86667ZM4.66667 3.99935V12.466C4.66667 12.5216 4.68622 12.5689 4.72533 12.608C4.764 12.6467 4.81111 12.666 4.86667 12.666H11.1333C11.1889 12.666 11.2362 12.6467 11.2753 12.608C11.314 12.5689 11.3333 12.5216 11.3333 12.466V3.99935H4.66667ZM6.26667 10.8327C6.26667 10.9771 6.314 11.0967 6.40867 11.1913C6.50289 11.2856 6.62222 11.3327 6.76667 11.3327C6.91111 11.3327 7.03067 11.2856 7.12533 11.1913C7.21956 11.0967 7.26667 10.9771 7.26667 10.8327V5.83268C7.26667 5.68824 7.21956 5.56868 7.12533 5.47402C7.03067 5.37979 6.91111 5.33268 6.76667 5.33268C6.62222 5.33268 6.50289 5.37979 6.40867 5.47402C6.314 5.56868 6.26667 5.68824 6.26667 5.83268V10.8327ZM8.73333 10.8327C8.73333 10.9771 8.78044 11.0967 8.87467 11.1913C8.96933 11.2856 9.08889 11.3327 9.23333 11.3327C9.37778 11.3327 9.49733 11.2856 9.592 11.1913C9.68622 11.0967 9.73333 10.9771 9.73333 10.8327V5.83268C9.73333 5.68824 9.68622 5.56868 9.592 5.47402C9.49733 5.37979 9.37778 5.33268 9.23333 5.33268C9.08889 5.33268 8.96933 5.37979 8.87467 5.47402C8.78044 5.56868 8.73333 5.68824 8.73333 5.83268V10.8327ZM4.66667 3.99935V12.466C4.66667 12.5216 4.68622 12.5689 4.72533 12.608C4.764 12.6467 4.81111 12.666 4.86667 12.666H4.66667V3.99935Z",
          fill: "inherit"
        }
      )
    }
  );
};
var DeleteIcon_default = DeleteIcon;
var EditSquareIcon = ({ className, onClick }) => {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      className,
      onClick,
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "inherit",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M3.1134 14C2.80412 14 2.54124 13.8918 2.32474 13.6753C2.10825 13.4588 2 13.1959 2 12.8866V4.59794C2 4.28866 2.10825 4.02577 2.32474 3.80928C2.54124 3.59278 2.80412 3.48454 3.1134 3.48454H8.40206L7.47423 4.41237H3.1134C3.07217 4.41237 3.03093 4.43299 2.98969 4.47423C2.94845 4.51546 2.92783 4.5567 2.92783 4.59794V12.8866C2.92783 12.9278 2.94845 12.9691 2.98969 13.0103C3.03093 13.0515 3.07217 13.0722 3.1134 13.0722H11.4021C11.4433 13.0722 11.4845 13.0515 11.5258 13.0103C11.567 12.9691 11.5876 12.9278 11.5876 12.8866V8.51031L12.5155 7.58247V12.8866C12.5155 13.1959 12.4072 13.4588 12.1907 13.6753C11.9742 13.8918 11.7113 14 11.4021 14H3.1134ZM10.0567 3.74742L10.7216 4.39691L6.63917 8.47938V9.36082H7.50515L11.6186 5.26289L12.268 5.91237L8.20103 9.97938C8.10825 10.0722 8 10.1468 7.87629 10.2033C7.75258 10.2602 7.61856 10.2887 7.47423 10.2887H6.26804C6.1134 10.2887 5.98186 10.2346 5.8734 10.1266C5.76536 10.0181 5.71134 9.8866 5.71134 9.73196V8.52577C5.71134 8.38144 5.73711 8.24742 5.78866 8.12371C5.84021 8 5.91237 7.89175 6.00515 7.79897L10.0567 3.74742ZM12.268 5.91237L10.0567 3.74742L11.4794 2.32474C11.6959 2.10825 11.9614 2 12.2761 2C12.5903 2 12.8557 2.1134 13.0722 2.34021L13.6753 2.9433C13.8814 3.15979 13.9845 3.42268 13.9845 3.73196C13.9845 4.04124 13.8763 4.30412 13.6598 4.52062L12.268 5.91237Z",
          fill: "inherit"
        }
      )
    }
  );
};
var EditSquareIcon_default = EditSquareIcon;
var CheckCircle = ({ className, onClick }) => {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      className,
      onClick,
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "inherit",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M7.04935 9.43268L5.48268 7.86602C5.39379 7.77713 5.28002 7.73557 5.14135 7.74135C5.00224 7.74668 4.88824 7.79379 4.79935 7.88268C4.69935 7.98268 4.64935 8.09935 4.64935 8.23268C4.64935 8.36602 4.69935 8.48268 4.79935 8.58268L6.63268 10.416C6.74379 10.5271 6.88268 10.5827 7.04935 10.5827C7.21602 10.5827 7.36046 10.5271 7.48268 10.416L11.1993 6.68268C11.2882 6.59379 11.33 6.47979 11.3247 6.34068C11.3189 6.20202 11.2716 6.08824 11.1827 5.99935C11.0827 5.89935 10.966 5.84935 10.8327 5.84935C10.6993 5.84935 10.5827 5.89935 10.4827 5.99935L7.04935 9.43268ZM7.99935 14.3327C7.12157 14.3327 6.29668 14.166 5.52468 13.8327C4.75224 13.4993 4.08268 13.0493 3.51602 12.4827C2.94935 11.916 2.49935 11.2465 2.16602 10.474C1.83268 9.70202 1.66602 8.87713 1.66602 7.99935C1.66602 7.12157 1.83268 6.29646 2.16602 5.52402C2.49935 4.75202 2.94935 4.08268 3.51602 3.51602C4.08268 2.94935 4.75224 2.49935 5.52468 2.16602C6.29668 1.83268 7.12157 1.66602 7.99935 1.66602C8.87713 1.66602 9.70224 1.83268 10.4747 2.16602C11.2467 2.49935 11.916 2.94935 12.4827 3.51602C13.0493 4.08268 13.4993 4.75202 13.8327 5.52402C14.166 6.29646 14.3327 7.12157 14.3327 7.99935C14.3327 8.87713 14.166 9.70202 13.8327 10.474C13.4993 11.2465 13.0493 11.916 12.4827 12.4827C11.916 13.0493 11.2467 13.4993 10.4747 13.8327C9.70224 14.166 8.87713 14.3327 7.99935 14.3327ZM7.99935 13.3327C9.47713 13.3327 10.7356 12.8133 11.7747 11.7747C12.8133 10.7356 13.3327 9.47713 13.3327 7.99935C13.3327 6.52157 12.8133 5.26313 11.7747 4.22402C10.7356 3.18535 9.47713 2.66602 7.99935 2.66602C6.52157 2.66602 5.26335 3.18535 4.22468 4.22402C3.18557 5.26313 2.66602 6.52157 2.66602 7.99935C2.66602 9.47713 3.18557 10.7356 4.22468 11.7747C5.26335 12.8133 6.52157 13.3327 7.99935 13.3327Z",
          fill: "inherit"
        }
      )
    }
  );
};
var CheckCircle_default = CheckCircle;
var CancelCircle = ({ className, onClick }) => {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      className,
      onClick,
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "inherit",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M5.24935 10.7493C5.34935 10.8493 5.46602 10.8993 5.59935 10.8993C5.73268 10.8993 5.84935 10.8493 5.94935 10.7493L7.99935 8.69935L10.066 10.766C10.1549 10.8549 10.2689 10.8965 10.408 10.8907C10.5467 10.8853 10.6605 10.8382 10.7493 10.7493C10.8493 10.6493 10.8993 10.5327 10.8993 10.3993C10.8993 10.266 10.8493 10.1493 10.7493 10.0493L8.69935 7.99935L10.766 5.93268C10.8549 5.84379 10.8965 5.72979 10.8907 5.59068C10.8853 5.45202 10.8382 5.33824 10.7493 5.24935C10.6493 5.14935 10.5327 5.09935 10.3993 5.09935C10.266 5.09935 10.1493 5.14935 10.0493 5.24935L7.99935 7.29935L5.93268 5.23268C5.84379 5.14379 5.73002 5.10202 5.59135 5.10735C5.45224 5.11313 5.33824 5.16046 5.24935 5.24935C5.14935 5.34935 5.09935 5.46602 5.09935 5.59935C5.09935 5.73268 5.14935 5.84935 5.24935 5.94935L7.29935 7.99935L5.23268 10.066C5.14379 10.1549 5.10224 10.2687 5.10802 10.4073C5.11335 10.5465 5.16046 10.6605 5.24935 10.7493ZM7.99935 14.3327C7.12157 14.3327 6.29668 14.166 5.52468 13.8327C4.75224 13.4993 4.08268 13.0493 3.51602 12.4827C2.94935 11.916 2.49935 11.2465 2.16602 10.474C1.83268 9.70202 1.66602 8.87713 1.66602 7.99935C1.66602 7.12157 1.83268 6.29646 2.16602 5.52402C2.49935 4.75202 2.94935 4.08268 3.51602 3.51602C4.08268 2.94935 4.75224 2.49935 5.52468 2.16602C6.29668 1.83268 7.12157 1.66602 7.99935 1.66602C8.87713 1.66602 9.70224 1.83268 10.4747 2.16602C11.2467 2.49935 11.916 2.94935 12.4827 3.51602C13.0493 4.08268 13.4993 4.75202 13.8327 5.52402C14.166 6.29646 14.3327 7.12157 14.3327 7.99935C14.3327 8.87713 14.166 9.70202 13.8327 10.474C13.4993 11.2465 13.0493 11.916 12.4827 12.4827C11.916 13.0493 11.2467 13.4993 10.4747 13.8327C9.70224 14.166 8.87713 14.3327 7.99935 14.3327ZM7.99935 13.3327C9.47713 13.3327 10.7356 12.8133 11.7747 11.7747C12.8133 10.7356 13.3327 9.47713 13.3327 7.99935C13.3327 6.52157 12.8133 5.26313 11.7747 4.22402C10.7356 3.18535 9.47713 2.66602 7.99935 2.66602C6.52157 2.66602 5.26335 3.18535 4.22468 4.22402C3.18557 5.26313 2.66602 6.52157 2.66602 7.99935C2.66602 9.47713 3.18557 10.7356 4.22468 11.7747C5.26335 12.8133 6.52157 13.3327 7.99935 13.3327Z",
          fill: "inherit"
        }
      )
    }
  );
};
var CancelCircle_default = CancelCircle;
var ErrorIcon = ({ className, onClick }) => {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      className,
      onClick,
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "inherit",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M8.0013 11.168C8.14575 11.168 8.2653 11.1209 8.35997 11.0266C8.45419 10.932 8.5013 10.8124 8.5013 10.668V7.81797C8.5013 7.68464 8.45419 7.57063 8.35997 7.47597C8.2653 7.38175 8.14575 7.33464 8.0013 7.33464C7.85686 7.33464 7.73752 7.38175 7.6433 7.47597C7.54864 7.57063 7.5013 7.69019 7.5013 7.83464V10.6846C7.5013 10.818 7.54864 10.932 7.6433 11.0266C7.73752 11.1209 7.85686 11.168 8.0013 11.168ZM8.0013 6.2013C8.15686 6.2013 8.28464 6.14841 8.38463 6.04264C8.48463 5.9373 8.53464 5.80686 8.53464 5.6513C8.53464 5.50686 8.48463 5.38175 8.38463 5.27597C8.28464 5.17064 8.15686 5.11797 8.0013 5.11797C7.84575 5.11797 7.71797 5.17064 7.61797 5.27597C7.51797 5.38175 7.46797 5.50686 7.46797 5.6513C7.46797 5.80686 7.51797 5.9373 7.61797 6.04264C7.71797 6.14841 7.84575 6.2013 8.0013 6.2013ZM8.0013 14.3346C7.12352 14.3346 6.29864 14.168 5.52664 13.8346C4.75419 13.5013 4.08464 13.0513 3.51797 12.4846C2.9513 11.918 2.5013 11.2484 2.16797 10.476C1.83464 9.70397 1.66797 8.87908 1.66797 8.0013C1.66797 7.12352 1.83464 6.29841 2.16797 5.52597C2.5013 4.75397 2.9513 4.08464 3.51797 3.51797C4.08464 2.9513 4.75419 2.5013 5.52664 2.16797C6.29864 1.83464 7.12352 1.66797 8.0013 1.66797C8.87908 1.66797 9.70419 1.83464 10.4766 2.16797C11.2486 2.5013 11.918 2.9513 12.4846 3.51797C13.0513 4.08464 13.5013 4.75397 13.8346 5.52597C14.168 6.29841 14.3346 7.12352 14.3346 8.0013C14.3346 8.87908 14.168 9.70397 13.8346 10.476C13.5013 11.2484 13.0513 11.918 12.4846 12.4846C11.918 13.0513 11.2486 13.5013 10.4766 13.8346C9.70419 14.168 8.87908 14.3346 8.0013 14.3346ZM8.0013 13.3346C9.47908 13.3346 10.7375 12.8153 11.7766 11.7766C12.8153 10.7375 13.3346 9.47908 13.3346 8.0013C13.3346 6.52352 12.8153 5.26508 11.7766 4.22597C10.7375 3.1873 9.47908 2.66797 8.0013 2.66797C6.52352 2.66797 5.2653 3.1873 4.22664 4.22597C3.18752 5.26508 2.66797 6.52352 2.66797 8.0013C2.66797 9.47908 3.18752 10.7375 4.22664 11.7766C5.2653 12.8153 6.52352 13.3346 8.0013 13.3346Z",
          fill: "inherit"
        }
      )
    }
  );
};
var ErrorIcon_default = ErrorIcon;
function UiIdentifierListItem({
  uiIdentifier,
  onSelect,
  onDelete,
  onEdit,
  isSelected,
  nlpId,
  applicationType
}) {
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const IMAGE_SUPPORTED_NLPS = IMAGE_SUPPORTED_NLPS_MAP[applicationType] || [];
  const handleDelete = (identifier) => {
    onDelete(identifier);
    setShowConfirmDelete(false);
  };
  const isNlpSupportedNLP = (item) => !nlpId || item?.locatorType?.toLowerCase() != ElementIdentifierLocatorType.IMAGE.toLowerCase() || IMAGE_SUPPORTED_NLPS.includes(Number(nlpId));
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: `text-small text-accent font-normal leading-4 ${isSelected ? "bg-legacy-primary-20" : showConfirmDelete ? "bg-blue-10" : "hover:bg-blue-10"} cursor-pointer group relative`,
      children: [
        /* @__PURE__ */ jsx(
          ToolTip,
          {
            content: isNlpSupportedNLP(uiIdentifier) ? "" : "Element not supported",
            children: /* @__PURE__ */ jsxs(
              "span",
              {
                className: classNames82("w-full flex flex-row items-center", {
                  "opacity-50 pointer-events-none": !isNlpSupportedNLP(uiIdentifier)
                }),
                onClick: () => onSelect(uiIdentifier),
                children: [
                  /* @__PURE__ */ jsx("span", { className: "px-3 py-2 basis-1/2 break-all border border-gray-100 border-l-0 border-solid !border-y-0", children: uiIdentifier.name }),
                  /* @__PURE__ */ jsx("span", { className: "px-3 py-2 basis-1/2 break-all group-hover:basis-1/3", children: uiIdentifier.screenNameObj?.name })
                ]
              }
            )
          }
        ),
        showConfirmDelete ? /* @__PURE__ */ jsxs(
          "div",
          {
            className: `absolute right-1 z-10 top-0 h-full gap-x-2 items-center bg-blue-10 flex px-2.5`,
            children: [
              /* @__PURE__ */ jsx(UiTooltip, { title: "Cancel Delete", className: "flex", children: /* @__PURE__ */ jsx(
                CancelCircle_default,
                {
                  onClick: () => setShowConfirmDelete(false),
                  className: "h-5 w-fit fill-green-500 hover:fill-green-700 cursor-pointer"
                }
              ) }),
              /* @__PURE__ */ jsx(UiTooltip, { title: "Confirm Delete", className: "flex", children: /* @__PURE__ */ jsx(
                CheckCircle_default,
                {
                  onClick: () => handleDelete(uiIdentifier),
                  className: "h-5 w-fit fill-red-900 cursor-pointer"
                }
              ) })
            ]
          }
        ) : /* @__PURE__ */ jsxs(
          "div",
          {
            className: classNames82(
              "absolute px-2.5 right-0.5 z-10 top-0 h-full flex gap-x-2 hidden group-hover:flex items-center bg-blue-10",
              {
                "opacity-50 pointer-events-none": !isNlpSupportedNLP(uiIdentifier)
              }
            ),
            children: [
              /* @__PURE__ */ jsx(
                UiTooltip,
                {
                  title: "Edit",
                  className: "text-slate-500 hover:text-slate-800",
                  onClick: () => onEdit(uiIdentifier),
                  children: /* @__PURE__ */ jsx(
                    EditSquareIcon_default,
                    {
                      className: `flex h-5 w-fit cursor-pointer fill-accent`
                    }
                  )
                }
              ),
              !uiIdentifier?.isSfField && /* @__PURE__ */ jsx(
                UiTooltip,
                {
                  title: "Delete",
                  className: "text-slate-500 hover:text-slate-800",
                  onClick: () => setShowConfirmDelete(true),
                  children: /* @__PURE__ */ jsx(DeleteIcon_default, { className: "flex h-5 w-fit cursor-pointer fill-accent" })
                }
              )
            ]
          }
        )
      ]
    },
    uiIdentifier.id?.toString()
  );
}
function UiIdentifierList({
  uiIdentifiers,
  onSelect,
  onPaginate,
  onDelete,
  onRefresh,
  currentElementName,
  nlpId = null
}) {
  const dispatch = useDispatch();
  const { sendToBackground: sendToBackground2 } = useMessaging();
  const [showEditElement, setShowEditElement] = useState(false);
  const [showDerivedElement, setShowDerivedElement] = useState(false);
  const [ativeUiIdentifier, setActiveUiIdentifier] = useState();
  const [showToast, setShowToast] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  const [toastType, setToastType] = useState(
    TOAST_TYPE.SUCCESS
  );
  const identifierListRef = useRef(null);
  const {
    recorderType,
    screens,
    appVersionId,
    appType,
    uiIdentifiers: widgetUiIdentifiers
  } = useSelector((state) => state.widget);
  const onScroll = () => {
    const element = identifierListRef.current;
    if (element && element.offsetHeight + element.scrollTop >= element.scrollHeight) {
      if (onPaginate) onPaginate();
    }
  };
  const handleDelete = async (uiIdentifier, seq) => {
    await UiIdentifierApi.deleteOne(uiIdentifier.id);
    const updatedIdentifiers = widgetUiIdentifiers.filter(
      ({ id }) => id !== uiIdentifier.id
    );
    dispatch(setUiIdentifiers(updatedIdentifiers));
    if (onDelete) onDelete(seq);
  };
  const handleEdit = (uiIdentifier) => {
    setActiveUiIdentifier(uiIdentifier);
    if (uiIdentifier.isSfField) {
      setShowDerivedElement(true);
    } else {
      setShowEditElement(true);
    }
  };
  const handleUpdate = async (elementData) => {
    if (elementData && ativeUiIdentifier) {
      let screen = screens.find(
        ({ name }) => name.toLocaleLowerCase() === elementData.screenTitle?.toLocaleLowerCase()
      );
      if (!screen) {
        screen = await ScreenApi.create(
          elementData.screenTitle,
          appVersionId
        );
      }
      let _definition2;
      if (elementData.locatorType) {
        _definition2 = elementData.definition || "";
      } else {
        _definition2 = elementData.xPath || elementData.cssPath;
      }
      if (elementData.elementContext) {
        elementData.screenNameId = screen.id;
        elementData.applicationVersionId = appVersionId;
        processElementContext(elementData);
      } else {
        elementData.hostElements = null;
      }
      const hasDraftScreenShotImages = Object.keys(elementData?.elementImageDraft || {}).length > 0;
      const updatedUiIdentifier = {
        ...ativeUiIdentifier,
        name: elementData?.name,
        definition: _definition2,
        currentElement: { textContent: elementData.text },
        applicationVersionId: appVersionId,
        parents: elementData.parents,
        screenShotData: elementData.screenshot,
        attrs: elementData.attrs,
        isDynamic: elementData.isDynamicElement,
        locatorType: elementData.locatorType,
        screenNameId: screen.id,
        screenNameObj: screen,
        hostElements: elementData.elementContext,
        ...hasDraftScreenShotImages ? { elementImageDraft: elementData?.elementImageDraft } : {},
        autoHealingEnabled: elementData.autoHealingEnabled,
        locatorTree: elementData.locatorTree
      };
      UiIdentifierApi.update(updatedUiIdentifier).then((response) => {
        const { screenshotDataUrl, croppedScreenshotDataUrl } = elementData;
        if (updatedUiIdentifier.id) {
          try {
            if (screenshotDataUrl) {
              RecorderAssetsApi.saveElementScreenshot(
                updatedUiIdentifier.id,
                {
                  screenshotFile: dataurltoFile(screenshotDataUrl),
                  applicationVersionId: appVersionId
                }
              );
            }
            if (croppedScreenshotDataUrl) {
              RecorderAssetsApi.saveCroppedElementScreenshot(
                updatedUiIdentifier.id,
                {
                  screenshotFile: dataurltoFile(croppedScreenshotDataUrl),
                  applicationVersionId: appVersionId
                }
              );
            }
          } catch (error) {
          }
        }
        if (recorderType === RECORDER_TYPE.ELEMENT) {
          const oldDataIndex = widgetUiIdentifiers.findIndex(
            ({ id }) => id === updatedUiIdentifier.id
          );
          const updatedIdentifiers = [
            ...widgetUiIdentifiers.slice(0, oldDataIndex),
            updatedUiIdentifier,
            ...widgetUiIdentifiers.slice(oldDataIndex + 1)
          ];
          dispatch(setUiIdentifiers(updatedIdentifiers));
        }
        if (recorderType === RECORDER_TYPE.STEP) {
          reloadTestSteps();
        }
        if (onRefresh) onRefresh();
        setShowEditElement(false);
        setShowToast(true);
        setToastMsg("Element updated successfully");
        setToastType(TOAST_TYPE.SUCCESS);
      }).catch((err) => {
        setShowToast(true);
        setToastMsg(err.error);
        setToastType(TOAST_TYPE.ERROR);
      });
    }
  };
  const handleCreateElementClose = () => {
    setShowEditElement(false);
    setActiveUiIdentifier(void 0);
  };
  const handleViewDetailsClose = () => {
    setShowDerivedElement(false);
    setActiveUiIdentifier(void 0);
  };
  return /* @__PURE__ */ jsxs("div", { className: "box-border flex flex-col h-full overflow-hidden", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex flex-row text-small text-accent font-semibold rounded-t bg-gray-100 leading-4", children: [
      /* @__PURE__ */ jsx("span", { className: "basis-1/2 py-2 px-3", children: "Element Name" }),
      /* @__PURE__ */ jsx("span", { className: "basis-1/2 py-2 px-3", children: "Screen Name" })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "flex flex-col overflow-hidden", children: /* @__PURE__ */ jsxs(
      "div",
      {
        className: "border border-gray-100 border-solid h-full overflow-y-auto rounded-b",
        onScroll: () => onScroll(),
        ref: identifierListRef,
        children: [
          uiIdentifiers.map((uiIdentifier, seq) => /* @__PURE__ */ jsx(
            UiIdentifierListItem,
            {
              uiIdentifier,
              onDelete: (uiIdentifier2) => handleDelete(uiIdentifier2, seq),
              onSelect: (uiIdentifier2) => onSelect(uiIdentifier2),
              onEdit: (uiIdentifier2) => handleEdit(uiIdentifier2),
              isSelected: currentElementName == uiIdentifier.name,
              nlpId,
              applicationType: appType
            },
            uiIdentifier.id
          )),
          uiIdentifiers.length < 1 && /* @__PURE__ */ jsx("span", { className: "font-normal leading-4 py-8 text-accent text-center text-small block", children: recorderType === RECORDER_TYPE.ELEMENT ? /* @__PURE__ */ jsx(Fragment, { children: "Start recording elements" }) : /* @__PURE__ */ jsx(Fragment, { children: "No elements found" }) })
        ]
      }
    ) }),
    showEditElement && /* @__PURE__ */ jsx(
      CreateElement,
      {
        onClose: () => handleCreateElementClose(),
        uiIdentifier: ativeUiIdentifier,
        onUpdate: (elementData) => handleUpdate(elementData)
      }
    ),
    showDerivedElement && /* @__PURE__ */ jsx(
      DerivedElement,
      {
        onClose: () => handleViewDetailsClose(),
        uiIdentifier: ativeUiIdentifier
      }
    ),
    /* @__PURE__ */ jsx(
      UiToast,
      {
        isShow: showToast,
        message: toastMsg,
        type: toastType,
        onClose: () => setShowToast(false)
      }
    )
  ] });
}
function Elements() {
  const { uiIdentifiers } = useSelector((state) => state.widget);
  const _uiIdentifiers = Array.isArray(uiIdentifiers) ? uiIdentifiers : [];
  const uniqueIdentifiers = [..._uiIdentifiers].filter(
    (value, index, self) => index === self.findIndex((t) => t.id === value.id)
  );
  return /* @__PURE__ */ jsx(UiIdentifierList, { uiIdentifiers: uniqueIdentifiers, onSelect: NOOP });
}
var EmptyDataMessage = ({
  message,
  action
}) => {
  return /* @__PURE__ */ jsxs("div", { className: "bg-blue-100 border border-gray-300 border-solid flex flex-col items-center p-2.5 rounded font-medium text-gray-700", children: [
    /* @__PURE__ */ jsx("span", { children: message }),
    action
  ] });
};
function StepRunResultBody({
  stepResultData,
  testCaseResult,
  apiUrl,
  updateElementModal,
  versionId,
  stepNumber
}) {
  const { appType } = useSelector((state) => state.widget);
  return /* @__PURE__ */ jsx(React5__default.Fragment, { children: !stepResultData ? /* @__PURE__ */ jsx(
    EmptyDataMessage,
    {
      message: "Run result is not available for the selected step. Please check this after sometimes"
    }
  ) : /* @__PURE__ */ jsx("div", { className: "max-h-full overflow-x-auto bg-secondary-50", children: /* @__PURE__ */ jsx(
    DebugStepResultPanel,
    {
      stepResult: stepResultData,
      testCaseResult,
      onEditElement: updateElementModal.openModal,
      onViewStepResult: () => {
      },
      onSubmitAutoHealElementFeedback: AutoHealApi.submitElementFeedback,
      fetchElement: UiIdentifierApi.get,
      fetchTestCases: TestCaseApi.findAll,
      acceptHealedElement: UiIdentifierApi.acceptHealedElement,
      versionId,
      fullWidth: true,
      baseUrl: apiUrl,
      appType,
      stepNumber
    }
  ) }) });
}
var StepIllustration = () => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "171",
      height: "154",
      viewBox: "0 0 171 154",
      fill: "none",
      children: [
        /* @__PURE__ */ jsxs("g", { clipPath: "url(#clip0_8006_7443)", children: [
          /* @__PURE__ */ jsx(
            "mask",
            {
              id: "mask0_8006_7443",
              style: { maskType: "luminance" },
              maskUnits: "userSpaceOnUse",
              x: "0",
              y: "0",
              width: "171",
              height: "171",
              children: /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M170.659 0.488281H0.340637V170.807H170.659V0.488281Z",
                  fill: "white"
                }
              )
            }
          ),
          /* @__PURE__ */ jsxs("g", { mask: "url(#mask0_8006_7443)", children: [
            /* @__PURE__ */ jsx("path", { d: "M171 0.680664H0.681396V153.286H171V0.680664Z", fill: "white" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M75.1505 22.8007C74.6988 23.6241 75.3208 24.5378 76.2603 24.5378H99.8188C100.713 24.5378 101.331 23.7029 100.946 22.896C99.6471 20.1685 96.0861 15 87.7561 15C80.4324 15 76.6615 20.0499 75.1505 22.8007Z",
                fill: "#03A973"
              }
            ),
            /* @__PURE__ */ jsx("path", { d: "M88 1H87V15H88V1Z", fill: "#647488" }),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M7.15259 150.37L46.3259 149.688H85.4994C100.797 149.688 109.375 149.688 124.673 149.688L163.846 150.37H7.15259Z",
                fill: "#8EA5AD"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M7.15259 1.16955L46.3259 0.488281H85.4994C100.797 0.488281 109.375 0.488281 124.673 0.488281L163.846 1.16955H7.15259Z",
                fill: "#8EA5AD"
              }
            ),
            /* @__PURE__ */ jsxs("g", { opacity: "0.1", children: [
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M8.68897 133.935C8.68897 133.513 8.34659 133.171 7.92425 133.171C7.50192 133.171 7.15955 133.513 7.15955 133.935C7.15955 134.358 7.50192 134.7 7.92425 134.7C8.34659 134.7 8.68897 134.358 8.68897 133.935Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M8.70772 124.652C8.70772 124.329 8.44589 124.067 8.1229 124.067C7.79992 124.067 7.53809 124.329 7.53809 124.652C7.53809 124.974 7.79992 125.236 8.1229 125.236C8.44589 125.236 8.70772 124.974 8.70772 124.652Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M8.31793 115.76C8.31793 115.545 8.14336 115.371 7.92801 115.371C7.71266 115.371 7.53809 115.545 7.53809 115.76C7.53809 115.976 7.71266 116.15 7.92801 116.15C8.14336 116.15 8.31793 115.976 8.31793 115.76Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M8.29523 106.687C8.29523 106.478 8.12573 106.308 7.91666 106.308C7.70758 106.308 7.53809 106.478 7.53809 106.687C7.53809 106.896 7.70758 107.065 7.91666 107.065C8.12573 107.065 8.29523 106.896 8.29523 106.687Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M8.40788 97.5446C8.40788 97.3044 8.21317 97.1097 7.97298 97.1097C7.73279 97.1097 7.53809 97.3044 7.53809 97.5446C7.53809 97.7848 7.73279 97.9795 7.97298 97.9795C8.21317 97.9795 8.40788 97.7848 8.40788 97.5446Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M8.91759 88.2028C8.91759 87.8219 8.60877 87.5131 8.22783 87.5131C7.84689 87.5131 7.53809 87.8219 7.53809 88.2028C7.53809 88.5838 7.84689 88.8926 8.22783 88.8926C8.60877 88.8926 8.91759 88.5838 8.91759 88.2028Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M9.04876 79.2419C9.04876 78.7202 8.62585 78.2973 8.10416 78.2973C7.58247 78.2973 7.15955 78.7202 7.15955 79.2419C7.15955 79.7636 7.58247 80.1865 8.10416 80.1865C8.62585 80.1865 9.04876 79.7636 9.04876 79.2419Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M9.37856 69.9911C9.37856 69.3783 8.88182 68.8816 8.26906 68.8816C7.65629 68.8816 7.15955 69.3783 7.15955 69.9911C7.15955 70.6038 7.65629 71.1006 8.26906 71.1006C8.88182 71.1006 9.37856 70.6038 9.37856 69.9911Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M9.14987 61.2091C9.14987 60.5549 8.61957 60.0246 7.96541 60.0246C7.31124 60.0246 6.78094 60.5549 6.78094 61.2091C6.78094 61.8633 7.31124 62.3936 7.96541 62.3936C8.61957 62.3936 9.14987 61.8633 9.14987 61.2091Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M9.08991 52.1522C9.08991 51.5146 8.57303 50.9977 7.93542 50.9977C7.29782 50.9977 6.78094 51.5146 6.78094 52.1522C6.78094 52.7898 7.29782 53.3066 7.93542 53.3066C8.57303 53.3066 9.08991 52.7898 9.08991 52.1522Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M9.16869 42.8382C9.16869 42.2834 8.71893 41.8336 8.16412 41.8336C7.60931 41.8336 7.15955 42.2834 7.15955 42.8382C7.15955 43.393 7.60931 43.8428 8.16412 43.8428C8.71893 43.8428 9.16869 43.393 9.16869 42.8382Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M8.74893 33.9631C8.74893 33.5242 8.39314 33.1684 7.95424 33.1684C7.51534 33.1684 7.15955 33.5242 7.15955 33.9631C7.15955 34.402 7.51534 34.7578 7.95424 34.7578C8.39314 34.7578 8.74893 34.402 8.74893 33.9631Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M17.8048 133.92C17.8048 133.49 17.4557 133.141 17.0251 133.141C16.5944 133.141 16.2454 133.49 16.2454 133.92C16.2454 134.351 16.5944 134.7 17.0251 134.7C17.4557 134.7 17.8048 134.351 17.8048 133.92Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M17.8833 124.607C17.8833 124.259 17.6013 123.977 17.2535 123.977C16.9057 123.977 16.6237 124.259 16.6237 124.607C16.6237 124.954 16.9057 125.236 17.2535 125.236C17.6013 125.236 17.8833 124.954 17.8833 124.607Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M17.5235 115.7C17.5235 115.452 17.3221 115.251 17.0736 115.251C16.8251 115.251 16.6237 115.452 16.6237 115.7C16.6237 115.949 16.8251 116.15 17.0736 116.15C17.3221 116.15 17.5235 115.949 17.5235 115.7Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M17.3809 106.687C17.3809 106.478 17.2114 106.308 17.0023 106.308C16.7932 106.308 16.6237 106.478 16.6237 106.687C16.6237 106.896 16.7932 107.065 17.0023 107.065C17.2114 107.065 17.3809 106.896 17.3809 106.687Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M17.6134 97.4846C17.6134 97.2113 17.3919 96.9898 17.1186 96.9898C16.8453 96.9898 16.6237 97.2113 16.6237 97.4846C16.6237 97.7579 16.8453 97.9795 17.1186 97.9795C17.3919 97.9795 17.6134 97.7579 17.6134 97.4846Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M18.1232 88.1429C18.1232 87.7288 17.7875 87.3931 17.3734 87.3931C16.9594 87.3931 16.6237 87.7288 16.6237 88.1429C16.6237 88.5569 16.9594 88.8926 17.3734 88.8926C17.7875 88.8926 18.1232 88.5569 18.1232 88.1429Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M18.2243 79.1969C18.2243 78.6504 17.7813 78.2074 17.2348 78.2074C16.6882 78.2074 16.2452 78.6504 16.2452 79.1969C16.2452 79.7435 16.6882 80.1865 17.2348 80.1865C17.7813 80.1865 18.2243 79.7435 18.2243 79.1969Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M18.1457 70.34C18.1457 69.7107 17.6355 69.2005 17.0062 69.2005C16.3769 69.2005 15.8667 69.7107 15.8667 70.34C15.8667 70.9693 16.3769 71.4795 17.0062 71.4795C17.6355 71.4795 18.1457 70.9693 18.1457 70.34Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M18.3256 61.1641C18.3256 60.4851 17.7751 59.9347 17.0961 59.9347C16.4171 59.9347 15.8667 60.4851 15.8667 61.1641C15.8667 61.8431 16.4171 62.3936 17.0961 62.3936C17.7751 62.3936 18.3256 61.8431 18.3256 61.1641Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M18.2356 52.1222C18.2356 51.468 17.7053 50.9377 17.0512 50.9377C16.397 50.9377 15.8667 51.468 15.8667 52.1222C15.8667 52.7763 16.397 53.3066 17.0512 53.3066C17.7053 53.3066 18.2356 52.7763 18.2356 52.1222Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M18.3143 42.8082C18.3143 42.2368 17.8511 41.7737 17.2797 41.7737C16.7084 41.7737 16.2452 42.2368 16.2452 42.8082C16.2452 43.3796 16.7084 43.8428 17.2797 43.8428C17.8511 43.8428 18.3143 43.3796 18.3143 42.8082Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M17.8945 33.9331C17.8945 33.4777 17.5253 33.1085 17.0699 33.1085C16.6144 33.1085 16.2452 33.4777 16.2452 33.9331C16.2452 34.3886 16.6144 34.7578 17.0699 34.7578C17.5253 34.7578 17.8945 34.3886 17.8945 33.9331Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M27.0101 133.861C27.0101 133.397 26.6342 133.021 26.1705 133.021C25.7067 133.021 25.3308 133.397 25.3308 133.861C25.3308 134.324 25.7067 134.7 26.1705 134.7C26.6342 134.7 27.0101 134.324 27.0101 133.861Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M27.1488 124.517C27.1488 124.119 26.8266 123.797 26.4291 123.797C26.0316 123.797 25.7094 124.119 25.7094 124.517C25.7094 124.914 26.0316 125.236 26.4291 125.236C26.8266 125.236 27.1488 124.914 27.1488 124.517Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M26.8191 115.596C26.8191 115.289 26.5707 115.041 26.2643 115.041C25.9579 115.041 25.7095 115.289 25.7095 115.596C25.7095 115.902 25.9579 116.15 26.2643 116.15C26.5707 116.15 26.8191 115.902 26.8191 115.596Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M26.6093 106.616C26.6093 106.367 26.4078 106.166 26.1594 106.166C25.9109 106.166 25.7095 106.367 25.7095 106.616C25.7095 106.864 25.9109 107.065 26.1594 107.065C26.4078 107.065 26.6093 106.864 26.6093 106.616Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M26.8491 97.4097C26.8491 97.095 26.594 96.8398 26.2793 96.8398C25.9646 96.8398 25.7095 97.095 25.7095 97.4097C25.7095 97.7244 25.9646 97.9795 26.2793 97.9795C26.594 97.9795 26.8491 97.7244 26.8491 97.4097Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M26.9502 88.4618C26.9502 88.0146 26.5877 87.6521 26.1405 87.6521C25.6933 87.6521 25.3308 88.0146 25.3308 88.4618C25.3308 88.909 25.6933 89.2715 26.1405 89.2715C26.5877 89.2715 26.9502 88.909 26.9502 88.4618Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M27.3999 79.152C27.3999 78.5806 26.9367 78.1174 26.3654 78.1174C25.794 78.1174 25.3308 78.5806 25.3308 79.152C25.3308 79.7233 25.794 80.1865 26.3654 80.1865C26.9367 80.1865 27.3999 79.7233 27.3999 79.152Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M27.2911 70.31C27.2911 69.6641 26.7675 69.1405 26.1216 69.1405C25.4757 69.1405 24.9521 69.6641 24.9521 70.31C24.9521 70.9559 25.4757 71.4795 26.1216 71.4795C26.7675 71.4795 27.2911 70.9559 27.2911 70.31Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M27.441 61.1491C27.441 60.4618 26.8839 59.9047 26.1966 59.9047C25.5093 59.9047 24.9521 60.4618 24.9521 61.1491C24.9521 61.8364 25.5093 62.3936 26.1966 62.3936C26.8839 62.3936 27.441 61.8364 27.441 61.1491Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M27.411 52.0772C27.411 51.3982 26.8606 50.8478 26.1816 50.8478C25.5026 50.8478 24.9521 51.3982 24.9521 52.0772C24.9521 52.7562 25.5026 53.3066 26.1816 53.3066C26.8606 53.3066 27.411 52.7562 27.411 52.0772Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M27.5198 42.7483C27.5198 42.1438 27.0298 41.6537 26.4253 41.6537C25.8208 41.6537 25.3308 42.1438 25.3308 42.7483C25.3308 43.3527 25.8208 43.8428 26.4253 43.8428C27.0298 43.8428 27.5198 43.3527 27.5198 42.7483Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M27.1301 33.8582C27.1301 33.3613 26.7273 32.9586 26.2304 32.9586C25.7336 32.9586 25.3308 33.3613 25.3308 33.8582C25.3308 34.355 25.7336 34.7578 26.2304 34.7578C26.7273 34.7578 27.1301 34.355 27.1301 33.8582Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M36.2757 133.771C36.2757 133.257 35.8595 132.841 35.3461 132.841C34.8327 132.841 34.4164 133.257 34.4164 133.771C34.4164 134.284 34.8327 134.7 35.3461 134.7C35.8595 134.7 36.2757 134.284 36.2757 133.771Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M36.0359 124.805C36.0359 124.357 35.6734 123.995 35.2262 123.995C34.7791 123.995 34.4166 124.357 34.4166 124.805C34.4166 125.252 34.7791 125.614 35.2262 125.614C35.6734 125.614 36.0359 125.252 36.0359 124.805Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M36.0847 115.506C36.0847 115.15 35.796 114.861 35.4399 114.861C35.0838 114.861 34.7951 115.15 34.7951 115.506C34.7951 115.862 35.0838 116.15 35.4399 116.15C35.796 116.15 36.0847 115.862 36.0847 115.506Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M35.9048 106.511C35.9048 106.204 35.6564 105.956 35.3499 105.956C35.0435 105.956 34.7951 106.204 34.7951 106.511C34.7951 106.817 35.0435 107.065 35.3499 107.065C35.6564 107.065 35.9048 106.817 35.9048 106.511Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M36.0247 97.3647C36.0247 97.0252 35.7494 96.7499 35.4099 96.7499C35.0704 96.7499 34.7951 97.0252 34.7951 97.3647C34.7951 97.7042 35.0704 97.9795 35.4099 97.9795C35.7494 97.9795 36.0247 97.7042 36.0247 97.3647Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M36.0658 88.4468C36.0658 87.9914 35.6966 87.6221 35.2411 87.6221C34.7857 87.6221 34.4164 87.9914 34.4164 88.4468C34.4164 88.9023 34.7857 89.2715 35.2411 89.2715C35.6966 89.2715 36.0658 88.9023 36.0658 88.4468Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M36.4856 79.152C36.4856 78.5806 36.0224 78.1174 35.451 78.1174C34.8796 78.1174 34.4164 78.5806 34.4164 79.152C34.4164 79.7233 34.8796 80.1865 35.451 80.1865C36.0224 80.1865 36.4856 79.7233 36.4856 79.152Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M36.4069 70.295C36.4069 69.6409 35.8766 69.1106 35.2224 69.1106C34.5683 69.1106 34.038 69.6409 34.038 70.295C34.038 70.9492 34.5683 71.4795 35.2224 71.4795C35.8766 71.4795 36.4069 70.9492 36.4069 70.295Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M36.5568 61.1341C36.5568 60.4386 35.993 59.8747 35.2974 59.8747C34.6018 59.8747 34.038 60.4386 34.038 61.1341C34.038 61.8297 34.6018 62.3936 35.2974 62.3936C35.993 62.3936 36.5568 61.8297 36.5568 61.1341Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M36.5268 52.0622C36.5268 51.3749 35.9697 50.8178 35.2824 50.8178C34.5951 50.8178 34.038 51.3749 34.038 52.0622C34.038 52.7495 34.5951 53.3066 35.2824 53.3066C35.9697 53.3066 36.5268 52.7495 36.5268 52.0622Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M36.317 43.0822C36.317 42.4529 35.8068 41.9427 35.1775 41.9427C34.5481 41.9427 34.038 42.4529 34.038 43.0822C34.038 43.7115 34.5481 44.2217 35.1775 44.2217C35.8068 44.2217 36.317 43.7115 36.317 43.0822Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M36.3356 33.7982C36.3356 33.2682 35.906 32.8386 35.376 32.8386C34.8461 32.8386 34.4164 33.2682 34.4164 33.7982C34.4164 34.3282 34.8461 34.7578 35.376 34.7578C35.906 34.7578 36.3356 34.3282 36.3356 33.7982Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M45.4814 133.711C45.4814 133.164 45.0383 132.721 44.4918 132.721C43.9453 132.721 43.5022 133.164 43.5022 133.711C43.5022 134.257 43.9453 134.7 44.4918 134.7C45.0383 134.7 45.4814 134.257 45.4814 133.711Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M45.3015 124.715C45.3015 124.218 44.8987 123.815 44.4018 123.815C43.905 123.815 43.5022 124.218 43.5022 124.715C43.5022 125.211 43.905 125.614 44.4018 125.614C44.8987 125.614 45.3015 125.211 45.3015 124.715Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M45.3802 115.401C45.3802 114.987 45.0445 114.651 44.6305 114.651C44.2164 114.651 43.8807 114.987 43.8807 115.401C43.8807 115.815 44.2164 116.15 44.6305 116.15C45.0445 116.15 45.3802 115.815 45.3802 115.401Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M45.1403 106.436C45.1403 106.088 44.8583 105.806 44.5105 105.806C44.1627 105.806 43.8807 106.088 43.8807 106.436C43.8807 106.783 44.1627 107.065 44.5105 107.065C44.8583 107.065 45.1403 106.783 45.1403 106.436Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M45.2003 97.3197C45.2003 96.9553 44.9049 96.66 44.5405 96.66C44.1761 96.66 43.8807 96.9553 43.8807 97.3197C43.8807 97.6841 44.1761 97.9795 44.5405 97.9795C44.9049 97.9795 45.2003 97.6841 45.2003 97.3197Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M45.1515 88.4468C45.1515 87.9914 44.7823 87.6221 44.3269 87.6221C43.8714 87.6221 43.5022 87.9914 43.5022 88.4468C43.5022 88.9023 43.8714 89.2715 44.3269 89.2715C44.7823 89.2715 45.1515 88.9023 45.1515 88.4468Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M45.5713 79.152C45.5713 78.5806 45.1081 78.1174 44.5368 78.1174C43.9654 78.1174 43.5022 78.5806 43.5022 79.152C43.5022 79.7233 43.9654 80.1865 44.5368 80.1865C45.1081 80.1865 45.5713 79.7233 45.5713 79.152Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M45.4925 70.295C45.4925 69.6409 44.9622 69.1106 44.308 69.1106C43.6538 69.1106 43.1235 69.6409 43.1235 70.295C43.1235 70.9492 43.6538 71.4795 44.308 71.4795C44.9622 71.4795 45.4925 70.9492 45.4925 70.295Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M45.6424 61.1341C45.6424 60.4386 45.0785 59.8747 44.383 59.8747C43.6874 59.8747 43.1235 60.4386 43.1235 61.1341C43.1235 61.8297 43.6874 62.3936 44.383 62.3936C45.0785 62.3936 45.6424 61.8297 45.6424 61.1341Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M45.6424 52.0492C45.6424 51.3536 45.0785 50.7897 44.383 50.7897C43.6874 50.7897 43.1235 51.3536 43.1235 52.0492C43.1235 52.7447 43.6874 53.3086 44.383 53.3086C45.0785 53.3086 45.6424 52.7447 45.6424 52.0492Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M45.4625 43.0522C45.4625 42.4063 44.9389 41.8827 44.293 41.8827C43.6471 41.8827 43.1235 42.4063 43.1235 43.0522C43.1235 43.6981 43.6471 44.2217 44.293 44.2217C44.9389 44.2217 45.4625 43.6981 45.4625 43.0522Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M45.5713 33.7233C45.5713 33.1519 45.1081 32.6887 44.5368 32.6887C43.9654 32.6887 43.5022 33.1519 43.5022 33.7233C43.5022 34.2946 43.9654 34.7578 44.5368 34.7578C45.1081 34.7578 45.5713 34.2946 45.5713 33.7233Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M54.7169 133.636C54.7169 133.048 54.2403 132.571 53.6524 132.571C53.0644 132.571 52.5878 133.048 52.5878 133.636C52.5878 134.224 53.0644 134.7 53.6524 134.7C54.2403 134.7 54.7169 134.224 54.7169 133.636Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M54.537 124.64C54.537 124.101 54.1007 123.665 53.5624 123.665C53.0242 123.665 52.5878 124.101 52.5878 124.64C52.5878 125.178 53.0242 125.614 53.5624 125.614C54.1007 125.614 54.537 125.178 54.537 124.64Z",
                  fill: "#9ADAC5"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M54.2672 115.69C54.2672 115.226 53.8912 114.85 53.4275 114.85C52.9638 114.85 52.5878 115.226 52.5878 115.69C52.5878 116.153 52.9638 116.529 53.4275 116.529C53.8912 116.529 54.2672 116.153 54.2672 115.69Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M54.3459 106.376C54.3459 105.995 54.0371 105.686 53.6561 105.686C53.2752 105.686 52.9664 105.995 52.9664 106.376C52.9664 106.757 53.2752 107.065 53.6561 107.065C54.0371 107.065 54.3459 106.757 54.3459 106.376Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M54.3159 97.3047C54.3159 96.9321 54.0138 96.63 53.6411 96.63C53.2685 96.63 52.9664 96.9321 52.9664 97.3047C52.9664 97.6774 53.2685 97.9795 53.6411 97.9795C54.0138 97.9795 54.3159 97.6774 54.3159 97.3047Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M54.2072 88.4618C54.2072 88.0146 53.8447 87.6521 53.3975 87.6521C52.9503 87.6521 52.5878 88.0146 52.5878 88.4618C52.5878 88.909 52.9503 89.2715 53.3975 89.2715C53.8447 89.2715 54.2072 88.909 54.2072 88.4618Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M54.597 79.182C54.597 78.6271 54.1472 78.1774 53.5924 78.1774C53.0376 78.1774 52.5878 78.6271 52.5878 79.182C52.5878 79.7368 53.0376 80.1865 53.5924 80.1865C54.1472 80.1865 54.597 79.7368 54.597 79.182Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M54.5181 70.325C54.5181 69.6874 54.0013 69.1705 53.3636 69.1705C52.726 69.1705 52.2092 69.6874 52.2092 70.325C52.2092 70.9626 52.726 71.4795 53.3636 71.4795C54.0013 71.4795 54.5181 70.9626 54.5181 70.325Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M54.728 61.1341C54.728 60.4386 54.1642 59.8747 53.4686 59.8747C52.773 59.8747 52.2092 60.4386 52.2092 61.1341C52.2092 61.8297 52.773 62.3936 53.4686 62.3936C54.1642 62.3936 54.728 61.8297 54.728 61.1341Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M54.728 52.0492C54.728 51.3536 54.1642 50.7897 53.4686 50.7897C52.773 50.7897 52.2092 51.3536 52.2092 52.0492C52.2092 52.7447 52.773 53.3086 53.4686 53.3086C54.1642 53.3086 54.728 52.7447 54.728 52.0492Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M54.6081 43.0222C54.6081 42.3598 54.0711 41.8228 53.4086 41.8228C52.7462 41.8228 52.2092 42.3598 52.2092 43.0222C52.2092 43.6847 52.7462 44.2217 53.4086 44.2217C54.0711 44.2217 54.6081 43.6847 54.6081 43.0222Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M54.7769 33.6633C54.7769 33.0588 54.2868 32.5688 53.6823 32.5688C53.0779 32.5688 52.5878 33.0588 52.5878 33.6633C52.5878 34.2678 53.0779 34.7578 53.6823 34.7578C54.2868 34.7578 54.7769 34.2678 54.7769 33.6633Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M63.8625 133.606C63.8625 133.001 63.3725 132.511 62.768 132.511C62.1635 132.511 61.6735 133.001 61.6735 133.606C61.6735 134.21 62.1635 134.7 62.768 134.7C63.3725 134.7 63.8625 134.21 63.8625 133.606Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M63.7126 124.595C63.7126 124.032 63.2561 123.575 62.693 123.575C62.1299 123.575 61.6735 124.032 61.6735 124.595C61.6735 125.158 62.1299 125.614 62.693 125.614C63.2561 125.614 63.7126 125.158 63.7126 124.595Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M63.4427 115.645C63.4427 115.156 63.0467 114.76 62.5581 114.76C62.0695 114.76 61.6735 115.156 61.6735 115.645C61.6735 116.133 62.0695 116.529 62.5581 116.529C63.0467 116.529 63.4427 116.133 63.4427 115.645Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M63.4915 106.346C63.4915 105.948 63.1692 105.626 62.7717 105.626C62.3742 105.626 62.052 105.948 62.052 106.346C62.052 106.743 62.3742 107.065 62.7717 107.065C63.1692 107.065 63.4915 106.743 63.4915 106.346Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M63.3715 97.3197C63.3715 96.9553 63.0762 96.6599 62.7118 96.6599C62.3474 96.6599 62.052 96.9553 62.052 97.3197C62.052 97.6841 62.3474 97.9795 62.7118 97.9795C63.0762 97.9795 63.3715 97.6841 63.3715 97.3197Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M63.2029 88.5068C63.2029 88.0844 62.8605 87.7421 62.4382 87.7421C62.0158 87.7421 61.6735 88.0844 61.6735 88.5068C61.6735 88.9291 62.0158 89.2715 62.4382 89.2715C62.8605 89.2715 63.2029 88.9291 63.2029 88.5068Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M63.5927 79.2269C63.5927 78.697 63.163 78.2673 62.6331 78.2673C62.1031 78.2673 61.6735 78.697 61.6735 79.2269C61.6735 79.7569 62.1031 80.1865 62.6331 80.1865C63.163 80.1865 63.5927 79.7569 63.5927 79.2269Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M63.9225 69.9761C63.9225 69.355 63.419 68.8516 62.798 68.8516C62.1769 68.8516 61.6735 69.355 61.6735 69.9761C61.6735 70.5971 62.1769 71.1006 62.798 71.1006C63.419 71.1006 63.9225 70.5971 63.9225 69.9761Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M63.7539 61.1641C63.7539 60.4851 63.2034 59.9347 62.5244 59.9347C61.8454 59.9347 61.295 60.4851 61.295 61.1641C61.295 61.8431 61.8454 62.3936 62.5244 62.3936C63.2034 62.3936 63.7539 61.8431 63.7539 61.1641Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M63.8138 52.0492C63.8138 51.3536 63.25 50.7897 62.5544 50.7897C61.8588 50.7897 61.295 51.3536 61.295 52.0492C61.295 52.7447 61.8588 53.3086 62.5544 53.3086C63.25 53.3086 63.8138 52.7447 63.8138 52.0492Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M63.7239 43.0072C63.7239 42.3365 63.1802 41.7928 62.5094 41.7928C61.8387 41.7928 61.295 42.3365 61.295 43.0072C61.295 43.6779 61.8387 44.2217 62.5094 44.2217C63.1802 44.2217 63.7239 43.6779 63.7239 43.0072Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M63.8925 33.6483C63.8925 33.0355 63.3957 32.5388 62.783 32.5388C62.1702 32.5388 61.6735 33.0355 61.6735 33.6483C61.6735 34.2611 62.1702 34.7578 62.783 34.7578C63.3957 34.7578 63.8925 34.2611 63.8925 33.6483Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M72.948 133.606C72.948 133.001 72.458 132.511 71.8535 132.511C71.249 132.511 70.759 133.001 70.759 133.606C70.759 134.21 71.249 134.7 71.8535 134.7C72.458 134.7 72.948 134.21 72.948 133.606Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M72.8281 124.58C72.8281 124.008 72.3649 123.545 71.7935 123.545C71.2222 123.545 70.759 124.008 70.759 124.58C70.759 125.151 71.2222 125.614 71.7935 125.614C72.3649 125.614 72.8281 125.151 72.8281 124.58Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M72.5584 115.63C72.5584 115.133 72.1556 114.73 71.6587 114.73C71.1619 114.73 70.7591 115.133 70.7591 115.63C70.7591 116.127 71.1619 116.529 71.6587 116.529C72.1556 116.529 72.5584 116.127 72.5584 115.63Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M72.5474 106.361C72.5474 105.971 72.2318 105.656 71.8426 105.656C71.4534 105.656 71.1379 105.971 71.1379 106.361C71.1379 106.75 71.4534 107.065 71.8426 107.065C72.2318 107.065 72.5474 106.75 72.5474 106.361Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M72.3975 97.3497C72.3975 97.0019 72.1155 96.7199 71.7677 96.7199C71.4198 96.7199 71.1379 97.0019 71.1379 97.3497C71.1379 97.6975 71.4198 97.9795 71.7677 97.9795C72.1155 97.9795 72.3975 97.6975 72.3975 97.3497Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M72.5773 88.1728C72.5773 87.7753 72.2551 87.4531 71.8576 87.4531C71.4601 87.4531 71.1379 87.7753 71.1379 88.1728C71.1379 88.5703 71.4601 88.8926 71.8576 88.8926C72.2551 88.8926 72.5773 88.5703 72.5773 88.1728Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M72.5584 79.2869C72.5584 78.79 72.1556 78.3873 71.6587 78.3873C71.1619 78.3873 70.7591 78.79 70.7591 79.2869C70.7591 79.7837 71.1619 80.1865 71.6587 80.1865C72.1556 80.1865 72.5584 79.7837 72.5584 79.2869Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M72.918 70.0211C72.918 69.4249 72.4347 68.9415 71.8385 68.9415C71.2423 68.9415 70.759 69.4249 70.759 70.0211C70.759 70.6173 71.2423 71.1006 71.8385 71.1006C72.4347 71.1006 72.918 70.6173 72.918 70.0211Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M72.7791 61.1941C72.7791 60.5317 72.2421 59.9946 71.5796 59.9946C70.9172 59.9946 70.3802 60.5317 70.3802 61.1941C70.3802 61.8565 70.9172 62.3936 71.5796 62.3936C72.2421 62.3936 72.7791 61.8565 72.7791 61.1941Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M72.8697 52.0622C72.8697 51.3749 72.3126 50.8178 71.6253 50.8178C70.938 50.8178 70.3809 51.3749 70.3809 52.0622C70.3809 52.7495 70.938 53.3066 71.6253 53.3066C72.3126 53.3066 72.8697 52.7495 72.8697 52.0622Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M72.7791 43.0222C72.7791 42.3598 72.2421 41.8228 71.5796 41.8228C70.9172 41.8228 70.3802 42.3598 70.3802 43.0222C70.3802 43.6847 70.9172 44.2217 71.5796 44.2217C72.2421 44.2217 72.7791 43.6847 72.7791 43.0222Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M73.008 33.6333C73.008 33.0123 72.5045 32.5088 71.8835 32.5088C71.2624 32.5088 70.759 33.0123 70.759 33.6333C70.759 34.2544 71.2624 34.7578 71.8835 34.7578C72.5045 34.7578 73.008 34.2544 73.008 33.6333Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M81.9735 133.636C81.9735 133.048 81.4969 132.571 80.909 132.571C80.3211 132.571 79.8445 133.048 79.8445 133.636C79.8445 134.224 80.3211 134.7 80.909 134.7C81.4969 134.7 81.9735 134.224 81.9735 133.636Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M81.8836 124.595C81.8836 124.032 81.4271 123.575 80.864 123.575C80.301 123.575 79.8445 124.032 79.8445 124.595C79.8445 125.158 80.301 125.614 80.864 125.614C81.4271 125.614 81.8836 125.158 81.8836 124.595Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M81.5838 115.66C81.5838 115.179 81.1944 114.79 80.7141 114.79C80.2338 114.79 79.8445 115.179 79.8445 115.66C79.8445 116.14 80.2338 116.529 80.7141 116.529C81.1944 116.529 81.5838 116.14 81.5838 115.66Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M81.5729 106.391C81.5729 106.018 81.2708 105.716 80.8982 105.716C80.5255 105.716 80.2234 106.018 80.2234 106.391C80.2234 106.763 80.5255 107.065 80.8982 107.065C81.2708 107.065 81.5729 106.763 81.5729 106.391Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M81.363 97.4097C81.363 97.095 81.1079 96.8398 80.7932 96.8398C80.4785 96.8398 80.2234 97.095 80.2234 97.4097C80.2234 97.7244 80.4785 97.9795 80.7932 97.9795C81.1079 97.9795 81.363 97.7244 81.363 97.4097Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M81.513 88.2478C81.513 87.8917 81.2243 87.603 80.8682 87.603C80.5121 87.603 80.2234 87.8917 80.2234 88.2478C80.2234 88.6039 80.5121 88.8926 80.8682 88.8926C81.2243 88.8926 81.513 88.6039 81.513 88.2478Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M81.5238 79.3469C81.5238 78.8831 81.1479 78.5072 80.6841 78.5072C80.2204 78.5072 79.8445 78.8831 79.8445 79.3469C79.8445 79.8106 80.2204 80.1865 80.6841 80.1865C81.1479 80.1865 81.5238 79.8106 81.5238 79.3469Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M81.9136 70.066C81.9136 69.4947 81.4504 69.0315 80.879 69.0315C80.3077 69.0315 79.8445 69.4947 79.8445 70.066C79.8445 70.6374 80.3077 71.1006 80.879 71.1006C81.4504 71.1006 81.9136 70.6374 81.9136 70.066Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M81.8053 61.2241C81.8053 60.5782 81.2817 60.0546 80.6358 60.0546C79.99 60.0546 79.4664 60.5782 79.4664 61.2241C79.4664 61.87 79.99 62.3936 80.6358 62.3936C81.2817 62.3936 81.8053 61.87 81.8053 61.2241Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M81.8953 52.0922C81.8953 51.4215 81.3515 50.8777 80.6808 50.8777C80.0101 50.8777 79.4664 51.4215 79.4664 52.0922C79.4664 52.7629 80.0101 53.3066 80.6808 53.3066C81.3515 53.3066 81.8953 52.7629 81.8953 52.0922Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M81.8353 43.0372C81.8353 42.3831 81.305 41.8528 80.6508 41.8528C79.9967 41.8528 79.4664 42.3831 79.4664 43.0372C79.4664 43.6914 79.9967 44.2217 80.6508 44.2217C81.305 44.2217 81.8353 43.6914 81.8353 43.0372Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M82.0635 33.6483C82.0635 33.0355 81.5668 32.5388 80.954 32.5388C80.3412 32.5388 79.8445 33.0355 79.8445 33.6483C79.8445 34.2611 80.3412 34.7578 80.954 34.7578C81.5668 34.7578 82.0635 34.2611 82.0635 33.6483Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M90.9698 133.681C90.9698 133.118 90.5133 132.661 89.9502 132.661C89.3871 132.661 88.9307 133.118 88.9307 133.681C88.9307 134.244 89.3871 134.7 89.9502 134.7C90.5133 134.7 90.9698 134.244 90.9698 133.681Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M90.8498 124.655C90.8498 124.125 90.4202 123.695 89.8903 123.695C89.3603 123.695 88.9307 124.125 88.9307 124.655C88.9307 125.185 89.3603 125.614 89.8903 125.614C90.4202 125.614 90.8498 125.185 90.8498 124.655Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M90.55 115.72C90.55 115.272 90.1875 114.91 89.7403 114.91C89.2932 114.91 88.9307 115.272 88.9307 115.72C88.9307 116.167 89.2932 116.529 89.7403 116.529C90.1875 116.529 90.55 116.167 90.55 115.72Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M90.5385 106.451C90.5385 106.111 90.2632 105.836 89.9237 105.836C89.5842 105.836 89.3089 106.111 89.3089 106.451C89.3089 106.79 89.5842 107.065 89.9237 107.065C90.2632 107.065 90.5385 106.79 90.5385 106.451Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M90.3286 97.4696C90.3286 97.188 90.1003 96.9598 89.8188 96.9598C89.5372 96.9598 89.3089 97.188 89.3089 97.4696C89.3089 97.7512 89.5372 97.9795 89.8188 97.9795C90.1003 97.9795 90.3286 97.7512 90.3286 97.4696Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M90.5085 88.2928C90.5085 87.9615 90.24 87.693 89.9087 87.693C89.5774 87.693 89.3089 87.9615 89.3089 88.2928C89.3089 88.624 89.5774 88.8926 89.9087 88.8926C90.24 88.8926 90.5085 88.624 90.5085 88.2928Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M90.55 79.3768C90.55 78.9297 90.1875 78.5672 89.7403 78.5672C89.2932 78.5672 88.9307 78.9297 88.9307 79.3768C88.9307 79.824 89.2932 80.1865 89.7403 80.1865C90.1875 80.1865 90.55 79.824 90.55 79.3768Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M90.9398 70.096C90.9398 69.5412 90.49 69.0914 89.9352 69.0914C89.3804 69.0914 88.9307 69.5412 88.9307 70.096C88.9307 70.6508 89.3804 71.1006 89.9352 71.1006C90.49 71.1006 90.9398 70.6508 90.9398 70.096Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M90.8308 61.2541C90.8308 60.6247 90.3206 60.1146 89.6913 60.1146C89.062 60.1146 88.5518 60.6247 88.5518 61.2541C88.5518 61.8834 89.062 62.3936 89.6913 62.3936C90.3206 62.3936 90.8308 61.8834 90.8308 61.2541Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M90.9208 52.1222C90.9208 51.468 90.3904 50.9377 89.7363 50.9377C89.0821 50.9377 88.5518 51.468 88.5518 52.1222C88.5518 52.7763 89.0821 53.3066 89.7363 53.3066C90.3904 53.3066 90.9208 52.7763 90.9208 52.1222Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M90.8608 43.0672C90.8608 42.4296 90.3439 41.9127 89.7063 41.9127C89.0687 41.9127 88.5518 42.4296 88.5518 43.0672C88.5518 43.7048 89.0687 44.2217 89.7063 44.2217C90.3439 44.2217 90.8608 43.7048 90.8608 43.0672Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M91.0597 33.6933C91.0597 33.1054 90.5831 32.6288 89.9952 32.6288C89.4073 32.6288 88.9307 33.1054 88.9307 33.6933C88.9307 34.2812 89.4073 34.7578 89.9952 34.7578C90.5831 34.7578 91.0597 34.2812 91.0597 33.6933Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M99.8753 133.771C99.8753 133.257 99.4591 132.841 98.9457 132.841C98.4323 132.841 98.0161 133.257 98.0161 133.771C98.0161 134.284 98.4323 134.7 98.9457 134.7C99.4591 134.7 99.8753 134.284 99.8753 133.771Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M99.7555 124.745C99.7555 124.264 99.3662 123.875 98.8859 123.875C98.4056 123.875 98.0162 124.264 98.0162 124.745C98.0162 125.225 98.4056 125.614 98.8859 125.614C99.3662 125.614 99.7555 125.225 99.7555 124.745Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M99.8338 115.431C99.8338 115.033 99.5116 114.711 99.1141 114.711C98.7166 114.711 98.3943 115.033 98.3943 115.431C98.3943 115.828 98.7166 116.15 99.1141 116.15C99.5116 116.15 99.8338 115.828 99.8338 115.431Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M99.444 106.541C99.444 106.251 99.2091 106.016 98.9192 106.016C98.6293 106.016 98.3943 106.251 98.3943 106.541C98.3943 106.83 98.6293 107.065 98.9192 107.065C99.2091 107.065 99.444 106.83 99.444 106.541Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M99.2941 97.5296C99.2941 97.2811 99.0927 97.0797 98.8442 97.0797C98.5958 97.0797 98.3943 97.2811 98.3943 97.5296C98.3943 97.7781 98.5958 97.9795 98.8442 97.9795C99.0927 97.9795 99.2941 97.7781 99.2941 97.5296Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M99.504 88.3378C99.504 88.0313 99.2556 87.7829 98.9492 87.7829C98.6427 87.7829 98.3943 88.0313 98.3943 88.3378C98.3943 88.6442 98.6427 88.8926 98.9492 88.8926C99.2556 88.8926 99.504 88.6442 99.504 88.3378Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M99.5457 79.4218C99.5457 78.9995 99.2033 78.6571 98.7809 78.6571C98.3586 78.6571 98.0162 78.9995 98.0162 79.4218C98.0162 79.8442 98.3586 80.1865 98.7809 80.1865C99.2033 80.1865 99.5457 79.8442 99.5457 79.4218Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M99.9653 70.126C99.9653 69.5877 99.529 69.1514 98.9907 69.1514C98.4525 69.1514 98.0161 69.5877 98.0161 70.126C98.0161 70.6642 98.4525 71.1006 98.9907 71.1006C99.529 71.1006 99.9653 70.6642 99.9653 70.126Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M100.235 60.9051C100.235 60.2924 99.7384 59.7956 99.1256 59.7956C98.5129 59.7956 98.0161 60.2924 98.0161 60.9051C98.0161 61.5179 98.5129 62.0146 99.1256 62.0146C99.7384 62.0146 100.235 61.5179 100.235 60.9051Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M99.9463 52.1522C99.9463 51.5146 99.4294 50.9977 98.7918 50.9977C98.1542 50.9977 97.6373 51.5146 97.6373 52.1522C97.6373 52.7898 98.1542 53.3066 98.7918 53.3066C99.4294 53.3066 99.9463 52.7898 99.9463 52.1522Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M100.235 42.7333C100.235 42.1205 99.7384 41.6237 99.1256 41.6237C98.5129 41.6237 98.0161 42.1205 98.0161 42.7333C98.0161 43.346 98.5129 43.8428 99.1256 43.8428C99.7384 43.8428 100.235 43.346 100.235 42.7333Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M100.025 33.7532C100.025 33.1984 99.5755 32.7487 99.0207 32.7487C98.4659 32.7487 98.0161 33.1984 98.0161 33.7532C98.0161 34.3081 98.4659 34.7578 99.0207 34.7578C99.5755 34.7578 100.025 34.3081 100.025 33.7532Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M108.751 133.876C108.751 133.42 108.382 133.051 107.926 133.051C107.471 133.051 107.102 133.42 107.102 133.876C107.102 134.331 107.471 134.7 107.926 134.7C108.382 134.7 108.751 134.331 108.751 133.876Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M108.631 124.85C108.631 124.427 108.289 124.085 107.866 124.085C107.444 124.085 107.102 124.427 107.102 124.85C107.102 125.272 107.444 125.614 107.866 125.614C108.289 125.614 108.631 125.272 108.631 124.85Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M108.71 115.536C108.71 115.196 108.435 114.921 108.095 114.921C107.756 114.921 107.481 115.196 107.481 115.536C107.481 115.875 107.756 116.15 108.095 116.15C108.435 116.15 108.71 115.875 108.71 115.536Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M108.35 106.631C108.35 106.39 108.156 106.196 107.915 106.196C107.675 106.196 107.481 106.39 107.481 106.631C107.481 106.871 107.675 107.065 107.915 107.065C108.156 107.065 108.35 106.871 108.35 106.631Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M108.238 97.5999C108.238 97.3909 108.068 97.2214 107.859 97.2214C107.65 97.2214 107.48 97.3909 107.48 97.5999C107.48 97.809 107.65 97.9785 107.859 97.9785C108.068 97.9785 108.238 97.809 108.238 97.5999Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M108.5 88.3827C108.5 88.1011 108.272 87.8729 107.99 87.8729C107.709 87.8729 107.481 88.1011 107.481 88.3827C107.481 88.6643 107.709 88.8926 107.99 88.8926C108.272 88.8926 108.5 88.6643 108.5 88.3827Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M108.95 79.0729C108.95 78.6671 108.621 78.3382 108.215 78.3382C107.809 78.3382 107.48 78.6671 107.48 79.0729C107.48 79.4787 107.809 79.8076 108.215 79.8076C108.621 79.8076 108.95 79.4787 108.95 79.0729Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M108.991 70.156C108.991 69.6343 108.568 69.2114 108.046 69.2114C107.525 69.2114 107.102 69.6343 107.102 70.156C107.102 70.6777 107.525 71.1006 108.046 71.1006C108.568 71.1006 108.991 70.6777 108.991 70.156Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M109.261 60.9351C109.261 60.3389 108.777 59.8556 108.181 59.8556C107.585 59.8556 107.102 60.3389 107.102 60.9351C107.102 61.5313 107.585 62.0146 108.181 62.0146C108.777 62.0146 109.261 61.5313 109.261 60.9351Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M109.351 51.8052C109.351 51.1841 108.847 50.6807 108.226 50.6807C107.605 50.6807 107.102 51.1841 107.102 51.8052C107.102 52.4262 107.605 52.9297 108.226 52.9297C108.847 52.9297 109.351 52.4262 109.351 51.8052Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M109.231 42.7782C109.231 42.1903 108.754 41.7137 108.166 41.7137C107.578 41.7137 107.102 42.1903 107.102 42.7782C107.102 43.3662 107.578 43.8428 108.166 43.8428C108.754 43.8428 109.231 43.3662 109.231 42.7782Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M108.961 33.8282C108.961 33.3148 108.545 32.8986 108.031 32.8986C107.518 32.8986 107.102 33.3148 107.102 33.8282C107.102 34.3416 107.518 34.7578 108.031 34.7578C108.545 34.7578 108.961 34.3416 108.961 33.8282Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M118.006 133.602C118.006 133.204 117.683 132.882 117.286 132.882C116.888 132.882 116.566 133.204 116.566 133.602C116.566 133.999 116.888 134.321 117.286 134.321C117.683 134.321 118.006 133.999 118.006 133.602Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M117.856 124.592C117.856 124.235 117.567 123.947 117.211 123.947C116.855 123.947 116.566 124.235 116.566 124.592C116.566 124.948 116.855 125.236 117.211 125.236C117.567 125.236 117.856 124.948 117.856 124.592Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M117.586 115.641C117.586 115.359 117.357 115.131 117.076 115.131C116.794 115.131 116.566 115.359 116.566 115.641C116.566 115.922 116.794 116.15 117.076 116.15C117.357 116.15 117.586 115.922 117.586 115.641Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M117.323 106.687C117.323 106.478 117.154 106.308 116.944 106.308C116.735 106.308 116.566 106.478 116.566 106.687C116.566 106.896 116.735 107.065 116.944 107.065C117.154 107.065 117.323 106.896 117.323 106.687Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M117.323 97.5999C117.323 97.3909 117.154 97.2214 116.944 97.2214C116.735 97.2214 116.566 97.3909 116.566 97.5999C116.566 97.809 116.735 97.9785 116.944 97.9785C117.154 97.9785 117.323 97.809 117.323 97.5999Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M117.526 88.4127C117.526 88.1477 117.311 87.9328 117.046 87.9328C116.781 87.9328 116.566 88.1477 116.566 88.4127C116.566 88.6777 116.781 88.8926 117.046 88.8926C117.311 88.8926 117.526 88.6777 117.526 88.4127Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M118.006 79.0879C118.006 78.6904 117.683 78.3682 117.286 78.3682C116.888 78.3682 116.566 78.6904 116.566 79.0879C116.566 79.4854 116.888 79.8076 117.286 79.8076C117.683 79.8076 118.006 79.4854 118.006 79.0879Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M118.046 70.171C118.046 69.6576 117.63 69.2414 117.117 69.2414C116.603 69.2414 116.187 69.6576 116.187 70.171C116.187 70.6844 116.603 71.1006 117.117 71.1006C117.63 71.1006 118.046 70.6844 118.046 70.171Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M118.317 60.9501C118.317 60.3622 117.84 59.8856 117.252 59.8856C116.664 59.8856 116.188 60.3622 116.188 60.9501C116.188 61.538 116.664 62.0146 117.252 62.0146C117.84 62.0146 118.317 61.538 118.317 60.9501Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M118.377 51.8352C118.377 51.2307 117.887 50.7407 117.282 50.7407C116.678 50.7407 116.188 51.2307 116.188 51.8352C116.188 52.4397 116.678 52.9297 117.282 52.9297C117.887 52.9297 118.377 52.4397 118.377 51.8352Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M118.196 42.8382C118.196 42.2834 117.747 41.8336 117.192 41.8336C116.637 41.8336 116.187 42.2834 116.187 42.8382C116.187 43.393 116.637 43.8428 117.192 43.8428C117.747 43.8428 118.196 43.393 118.196 42.8382Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M117.867 33.9181C117.867 33.4544 117.491 33.0785 117.027 33.0785C116.563 33.0785 116.187 33.4544 116.187 33.9181C116.187 34.3819 116.563 34.7578 117.027 34.7578C117.491 34.7578 117.867 34.3819 117.867 33.9181Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M126.851 133.721C126.851 133.39 126.582 133.122 126.251 133.122C125.92 133.122 125.651 133.39 125.651 133.721C125.651 134.053 125.92 134.321 126.251 134.321C126.582 134.321 126.851 134.053 126.851 133.721Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M126.761 124.681C126.761 124.375 126.513 124.127 126.206 124.127C125.9 124.127 125.651 124.375 125.651 124.681C125.651 124.988 125.9 125.236 126.206 125.236C126.513 125.236 126.761 124.988 126.761 124.681Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M126.521 115.715C126.521 115.475 126.327 115.281 126.086 115.281C125.846 115.281 125.651 115.475 125.651 115.715C125.651 115.956 125.846 116.15 126.086 116.15C126.327 116.15 126.521 115.956 126.521 115.715Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M126.408 106.687C126.408 106.478 126.239 106.308 126.03 106.308C125.821 106.308 125.651 106.478 125.651 106.687C125.651 106.896 125.821 107.065 126.03 107.065C126.239 107.065 126.408 106.896 126.408 106.687Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M126.408 97.5999C126.408 97.3909 126.239 97.2214 126.03 97.2214C125.821 97.2214 125.651 97.3909 125.651 97.5999C125.651 97.809 125.821 97.9785 126.03 97.9785C126.239 97.9785 126.408 97.809 126.408 97.5999Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M126.671 88.3827C126.671 88.1011 126.443 87.8729 126.161 87.8729C125.88 87.8729 125.651 88.1011 125.651 88.3827C125.651 88.6643 125.88 88.8926 126.161 88.8926C126.443 88.8926 126.671 88.6643 126.671 88.3827Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M127.121 79.0729C127.121 78.6671 126.792 78.3382 126.386 78.3382C125.98 78.3382 125.651 78.6671 125.651 79.0729C125.651 79.4787 125.98 79.8076 126.386 79.8076C126.792 79.8076 127.121 79.4787 127.121 79.0729Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M127.103 70.186C127.103 69.6808 126.693 69.2713 126.188 69.2713C125.683 69.2713 125.273 69.6808 125.273 70.186C125.273 70.6911 125.683 71.1006 126.188 71.1006C126.693 71.1006 127.103 70.6911 127.103 70.186Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M127.342 60.9801C127.342 60.4087 126.879 59.9455 126.308 59.9455C125.737 59.9455 125.273 60.4087 125.273 60.9801C125.273 61.5515 125.737 62.0146 126.308 62.0146C126.879 62.0146 127.342 61.5515 127.342 60.9801Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M127.372 51.8792C127.372 51.2995 126.903 50.8296 126.323 50.8296C125.743 50.8296 125.273 51.2995 125.273 51.8792C125.273 52.4588 125.743 52.9287 126.323 52.9287C126.903 52.9287 127.372 52.4588 127.372 51.8792Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M127.133 42.9132C127.133 42.3998 126.716 41.9835 126.203 41.9835C125.69 41.9835 125.273 42.3998 125.273 42.9132C125.273 43.4266 125.69 43.8428 126.203 43.8428C126.716 43.8428 127.133 43.4266 127.133 42.9132Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M126.803 33.9931C126.803 33.5708 126.46 33.2284 126.038 33.2284C125.616 33.2284 125.273 33.5708 125.273 33.9931C125.273 34.4154 125.616 34.7578 126.038 34.7578C126.46 34.7578 126.803 34.4154 126.803 33.9931Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M135.697 133.841C135.697 133.576 135.482 133.362 135.217 133.362C134.952 133.362 134.737 133.576 134.737 133.841C134.737 134.106 134.952 134.321 135.217 134.321C135.482 134.321 135.697 134.106 135.697 133.841Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M135.667 124.771C135.667 124.515 135.459 124.307 135.202 124.307C134.945 124.307 134.737 124.515 134.737 124.771C134.737 125.028 134.945 125.236 135.202 125.236C135.459 125.236 135.667 125.028 135.667 124.771Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M135.547 115.745C135.547 115.522 135.366 115.341 135.142 115.341C134.918 115.341 134.737 115.522 134.737 115.745C134.737 115.969 134.918 116.15 135.142 116.15C135.366 116.15 135.547 115.969 135.547 115.745Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M135.495 106.687C135.495 106.478 135.325 106.308 135.116 106.308C134.907 106.308 134.737 106.478 134.737 106.687C134.737 106.896 134.907 107.065 135.116 107.065C135.325 107.065 135.495 106.896 135.495 106.687Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M135.607 97.5446C135.607 97.3044 135.412 97.1097 135.172 97.1097C134.932 97.1097 134.737 97.3044 134.737 97.5446C134.737 97.7848 134.932 97.9795 135.172 97.9795C135.412 97.9795 135.607 97.7848 135.607 97.5446Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M135.907 88.3078C135.907 87.9848 135.645 87.7229 135.322 87.7229C134.999 87.7229 134.738 87.9848 134.738 88.3078C134.738 88.6307 134.999 88.8926 135.322 88.8926C135.645 88.8926 135.907 88.6307 135.907 88.3078Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M135.888 79.4218C135.888 78.9995 135.546 78.6571 135.123 78.6571C134.701 78.6571 134.359 78.9995 134.359 79.4218C134.359 79.8442 134.701 80.1865 135.123 80.1865C135.546 80.1865 135.888 79.8442 135.888 79.4218Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M136.218 70.171C136.218 69.6576 135.802 69.2414 135.288 69.2414C134.775 69.2414 134.359 69.6576 134.359 70.171C134.359 70.6844 134.775 71.1006 135.288 71.1006C135.802 71.1006 136.218 70.6844 136.218 70.171Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M136.368 61.0101C136.368 60.4553 135.918 60.0055 135.363 60.0055C134.809 60.0055 134.359 60.4553 134.359 61.0101C134.359 61.5649 134.809 62.0146 135.363 62.0146C135.918 62.0146 136.368 61.5649 136.368 61.0101Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M136.338 51.9391C136.338 51.3926 135.895 50.9496 135.348 50.9496C134.802 50.9496 134.359 51.3926 134.359 51.9391C134.359 52.4857 134.802 52.9287 135.348 52.9287C135.895 52.9287 136.338 52.4857 136.338 51.9391Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M136.068 42.9881C136.068 42.5161 135.685 42.1335 135.213 42.1335C134.741 42.1335 134.359 42.5161 134.359 42.9881C134.359 43.4601 134.741 43.8428 135.213 43.8428C135.685 43.8428 136.068 43.4601 136.068 42.9881Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M136.087 33.7041C136.087 33.3315 135.785 33.0294 135.412 33.0294C135.04 33.0294 134.738 33.3315 134.738 33.7041C134.738 34.0768 135.04 34.3789 135.412 34.3789C135.785 34.3789 136.087 34.0768 136.087 33.7041Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M144.633 133.916C144.633 133.693 144.452 133.511 144.228 133.511C144.005 133.511 143.823 133.693 143.823 133.916C143.823 134.14 144.005 134.321 144.228 134.321C144.452 134.321 144.633 134.14 144.633 133.916Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M144.693 124.801C144.693 124.561 144.498 124.367 144.258 124.367C144.018 124.367 143.823 124.561 143.823 124.801C143.823 125.042 144.018 125.236 144.258 125.236C144.498 125.236 144.693 125.042 144.693 124.801Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M144.693 115.715C144.693 115.475 144.498 115.281 144.258 115.281C144.018 115.281 143.823 115.475 143.823 115.715C143.823 115.956 144.018 116.15 144.258 116.15C144.498 116.15 144.693 115.956 144.693 115.715Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M144.783 106.586C144.783 106.321 144.568 106.106 144.303 106.106C144.038 106.106 143.823 106.321 143.823 106.586C143.823 106.851 144.038 107.065 144.303 107.065C144.568 107.065 144.783 106.851 144.783 106.586Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M144.933 97.4247C144.933 97.1182 144.685 96.8698 144.378 96.8698C144.072 96.8698 143.823 97.1182 143.823 97.4247C143.823 97.7311 144.072 97.9795 144.378 97.9795C144.685 97.9795 144.933 97.7311 144.933 97.4247Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M145.203 88.2028C145.203 87.8219 144.894 87.5131 144.513 87.5131C144.132 87.5131 143.823 87.8219 143.823 88.2028C143.823 88.5838 144.132 88.8926 144.513 88.8926C144.894 88.8926 145.203 88.5838 145.203 88.2028Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M145.094 79.3618C145.094 78.9064 144.724 78.5372 144.269 78.5372C143.813 78.5372 143.444 78.9064 143.444 79.3618C143.444 79.8173 143.813 80.1865 144.269 80.1865C144.724 80.1865 145.094 79.8173 145.094 79.3618Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M145.303 70.171C145.303 69.6576 144.887 69.2414 144.374 69.2414C143.86 69.2414 143.444 69.6576 143.444 70.171C143.444 70.6844 143.86 71.1006 144.374 71.1006C144.887 71.1006 145.303 70.6844 145.303 70.171Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M145.393 61.0401C145.393 60.5018 144.957 60.0655 144.419 60.0655C143.881 60.0655 143.444 60.5018 143.444 61.0401C143.444 61.5783 143.881 62.0146 144.419 62.0146C144.957 62.0146 145.393 61.5783 145.393 61.0401Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M145.303 51.9991C145.303 51.4857 144.887 51.0695 144.374 51.0695C143.86 51.0695 143.444 51.4857 143.444 51.9991C143.444 52.5125 143.86 52.9287 144.374 52.9287C144.887 52.9287 145.303 52.5125 145.303 51.9991Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M144.974 43.0781C144.974 42.6557 144.631 42.3134 144.209 42.3134C143.787 42.3134 143.444 42.6557 143.444 43.0781C143.444 43.5004 143.787 43.8428 144.209 43.8428C144.631 43.8428 144.974 43.5004 144.974 43.0781Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M145.023 33.7791C145.023 33.4478 144.754 33.1793 144.423 33.1793C144.092 33.1793 143.823 33.4478 143.823 33.7791C143.823 34.1104 144.092 34.3789 144.423 34.3789C144.754 34.3789 145.023 34.1104 145.023 33.7791Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M153.666 133.943C153.666 133.734 153.496 133.564 153.287 133.564C153.078 133.564 152.908 133.734 152.908 133.943C152.908 134.152 153.078 134.321 153.287 134.321C153.496 134.321 153.666 134.152 153.666 133.943Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M153.808 124.786C153.808 124.538 153.607 124.337 153.358 124.337C153.11 124.337 152.909 124.538 152.909 124.786C152.909 125.035 153.11 125.236 153.358 125.236C153.607 125.236 153.808 125.035 153.808 124.786Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M153.988 115.611C153.988 115.312 153.747 115.071 153.448 115.071C153.15 115.071 152.909 115.312 152.909 115.611C152.909 115.909 153.15 116.15 153.448 116.15C153.747 116.15 153.988 115.909 153.988 115.611Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M154.168 106.436C154.168 106.088 153.886 105.806 153.538 105.806C153.191 105.806 152.909 106.088 152.909 106.436C152.909 106.783 153.191 107.065 153.538 107.065C153.886 107.065 154.168 106.783 154.168 106.436Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M154.348 97.2588C154.348 96.8613 154.026 96.539 153.628 96.539C153.231 96.539 152.909 96.8613 152.909 97.2588C152.909 97.6563 153.231 97.9785 153.628 97.9785C154.026 97.9785 154.348 97.6563 154.348 97.2588Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M154.149 88.4618C154.149 88.0146 153.787 87.6521 153.339 87.6521C152.892 87.6521 152.53 88.0146 152.53 88.4618C152.53 88.909 152.892 89.2715 153.339 89.2715C153.787 89.2715 154.149 88.909 154.149 88.4618Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M154.299 79.3019C154.299 78.8133 153.903 78.4172 153.414 78.4172C152.926 78.4172 152.53 78.8133 152.53 79.3019C152.53 79.7905 152.926 80.1865 153.414 80.1865C153.903 80.1865 154.299 79.7905 154.299 79.3019Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M154.419 70.156C154.419 69.6343 153.996 69.2114 153.474 69.2114C152.953 69.2114 152.53 69.6343 152.53 70.156C152.53 70.6777 152.953 71.1006 153.474 71.1006C153.996 71.1006 154.419 70.6777 154.419 70.156Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M154.419 61.07C154.419 60.5484 153.996 60.1254 153.474 60.1254C152.953 60.1254 152.53 60.5484 152.53 61.07C152.53 61.5917 152.953 62.0146 153.474 62.0146C153.996 62.0146 154.419 61.5917 154.419 61.07Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M154.239 52.0741C154.239 51.602 153.856 51.2194 153.384 51.2194C152.912 51.2194 152.53 51.602 152.53 52.0741C152.53 52.5461 152.912 52.9287 153.384 52.9287C153.856 52.9287 154.239 52.5461 154.239 52.0741Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M154.288 42.7751C154.288 42.3942 153.979 42.0853 153.598 42.0853C153.217 42.0853 152.909 42.3942 152.909 42.7751C152.909 43.156 153.217 43.4648 153.598 43.4648C153.979 43.4648 154.288 43.156 154.288 42.7751Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M153.958 33.8541C153.958 33.5642 153.723 33.3292 153.433 33.3292C153.144 33.3292 152.909 33.5642 152.909 33.8541C152.909 34.1439 153.144 34.3789 153.433 34.3789C153.723 34.3789 153.958 34.1439 153.958 33.8541Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M162.804 133.916C162.804 133.693 162.623 133.511 162.399 133.511C162.175 133.511 161.994 133.693 161.994 133.916C161.994 134.14 162.175 134.321 162.399 134.321C162.623 134.321 162.804 134.14 162.804 133.916Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M163.074 124.696C163.074 124.398 162.832 124.157 162.534 124.157C162.236 124.157 161.994 124.398 161.994 124.696C161.994 124.995 162.236 125.236 162.534 125.236C162.832 125.236 163.074 124.995 163.074 124.696Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M163.374 115.461C163.374 115.08 163.065 114.771 162.684 114.771C162.303 114.771 161.994 115.08 161.994 115.461C161.994 115.842 162.303 116.15 162.684 116.15C163.065 116.15 163.374 115.842 163.374 115.461Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M163.265 106.618C163.265 106.162 162.896 105.793 162.441 105.793C161.985 105.793 161.616 106.162 161.616 106.618C161.616 107.073 161.985 107.442 162.441 107.442C162.896 107.442 163.265 107.073 163.265 106.618Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M163.445 97.4428C163.445 96.9377 163.036 96.5282 162.531 96.5282C162.025 96.5282 161.616 96.9377 161.616 97.4428C161.616 97.9479 162.025 98.3574 162.531 98.3574C163.036 98.3574 163.445 97.9479 163.445 97.4428Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M163.505 88.3269C163.505 87.8052 163.082 87.3823 162.561 87.3823C162.039 87.3823 161.616 87.8052 161.616 88.3269C161.616 88.8486 162.039 89.2715 162.561 89.2715C163.082 89.2715 163.505 88.8486 163.505 88.3269Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M163.535 79.2269C163.535 78.697 163.106 78.2673 162.576 78.2673C162.046 78.2673 161.616 78.697 161.616 79.2269C161.616 79.7569 162.046 80.1865 162.576 80.1865C163.106 80.1865 163.535 79.7569 163.535 79.2269Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M163.535 70.141C163.535 69.611 163.106 69.1814 162.576 69.1814C162.046 69.1814 161.616 69.611 161.616 70.141C161.616 70.671 162.046 71.1006 162.576 71.1006C163.106 71.1006 163.535 70.671 163.535 70.141Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M163.445 61.1C163.445 60.5949 163.036 60.1854 162.531 60.1854C162.025 60.1854 161.616 60.5949 161.616 61.1C161.616 61.6052 162.025 62.0146 162.531 62.0146C163.036 62.0146 163.445 61.6052 163.445 61.1Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M163.145 52.165C163.145 51.7426 162.803 51.4003 162.381 51.4003C161.958 51.4003 161.616 51.7426 161.616 52.165C161.616 52.5873 161.958 52.9297 162.381 52.9297C162.803 52.9297 163.145 52.5873 163.145 52.165Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M163.164 42.88C163.164 42.557 162.902 42.2952 162.579 42.2952C162.256 42.2952 161.994 42.557 161.994 42.88C161.994 43.203 162.256 43.4648 162.579 43.4648C162.902 43.4648 163.164 43.203 163.164 42.88Z",
                  fill: "#94A3B8"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M162.954 33.899C162.954 33.634 162.739 33.4192 162.474 33.4192C162.209 33.4192 161.994 33.634 161.994 33.899C161.994 34.1641 162.209 34.3789 162.474 34.3789C162.739 34.3789 162.954 34.1641 162.954 33.899Z",
                  fill: "#94A3B8"
                }
              )
            ] }),
            /* @__PURE__ */ jsxs("g", { filter: "url(#filter0_di_8006_7443)", children: [
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M141.892 68.915H29.4549C26.8087 68.915 24.6636 71.0602 24.6636 73.7064V94.1495C24.6636 96.7957 26.8087 98.9409 29.4549 98.9409H141.892C144.539 98.9409 146.684 96.7957 146.684 94.1495V73.7064C146.684 71.0602 144.539 68.915 141.892 68.915Z",
                  fill: "#ECF8F3",
                  stroke: "#CCECE2",
                  strokeWidth: "0.638847"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M136.051 77.3584H35.2959C34.0862 77.3584 33.1056 78.339 33.1056 79.5487V79.5487C33.1056 80.7584 34.0862 81.7391 35.2959 81.7391H136.051C137.261 81.7391 138.241 80.7584 138.241 79.5487C138.241 78.339 137.261 77.3584 136.051 77.3584Z",
                  fill: "#CCECE2"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: "M59.3897 86.1191H35.296C34.0864 86.1191 33.1057 87.0998 33.1057 88.3095V88.3095C33.1057 89.5192 34.0864 90.4998 35.296 90.4998H59.3897C60.5994 90.4998 61.5801 89.5192 61.5801 88.3095C61.5801 87.0998 60.5994 86.1191 59.3897 86.1191Z",
                  fill: "#CCECE2"
                }
              )
            ] }),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M131.753 36H39.7594C37.1132 36 34.9681 38.1452 34.9681 40.7914V56.1237C34.9681 58.7699 37.1132 60.915 39.7594 60.915H131.753C134.4 60.915 136.545 58.7699 136.545 56.1237V40.7914C136.545 38.1452 134.4 36 131.753 36Z",
                fill: "white",
                stroke: "#E2E8F0",
                strokeWidth: "0.638847"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M127.738 42.9824H43.775C42.7669 42.9824 41.9497 43.7996 41.9497 44.8077C41.9497 45.8158 42.7669 46.633 43.775 46.633H127.738C128.746 46.633 129.563 45.8158 129.563 44.8077C129.563 43.7996 128.746 42.9824 127.738 42.9824Z",
                fill: "#E2E8F0"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M98.5333 50.2842H43.775C42.7669 50.2842 41.9497 51.1014 41.9497 52.1095C41.9497 53.1175 42.7669 53.9347 43.775 53.9347H98.5333C99.5414 53.9347 100.359 53.1175 100.359 52.1095C100.359 51.1014 99.5414 50.2842 98.5333 50.2842Z",
                fill: "#E2E8F0"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M131.753 106.94H39.7594C37.1132 106.94 34.9681 109.086 34.9681 111.732V127.064C34.9681 129.71 37.1132 131.855 39.7594 131.855H131.753C134.4 131.855 136.545 129.71 136.545 127.064V111.732C136.545 109.086 134.4 106.94 131.753 106.94Z",
                fill: "white",
                stroke: "#E2E8F0",
                strokeWidth: "0.638847"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M127.738 113.924H43.775C42.7669 113.924 41.9497 114.741 41.9497 115.749C41.9497 116.757 42.7669 117.574 43.775 117.574H127.738C128.746 117.574 129.563 116.757 129.563 115.749C129.563 114.741 128.746 113.924 127.738 113.924Z",
                fill: "#E2E8F0"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M98.5333 121.226H43.775C42.7669 121.226 41.9497 122.043 41.9497 123.051C41.9497 124.059 42.7669 124.876 43.775 124.876H98.5333C99.5414 124.876 100.359 124.059 100.359 123.051C100.359 122.043 99.5414 121.226 98.5333 121.226Z",
                fill: "#E2E8F0"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M138.481 124.893L138.623 124.362L139.684 124.646L140.745 124.931L140.603 125.462L138.481 124.893Z",
                fill: "white"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M143.947 123.391L144.33 122.222",
                stroke: "#DCE2EA",
                strokeWidth: "0.0549334"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M142.326 124.893L142.468 124.362L143.529 124.646L144.59 124.931L144.448 125.462L142.326 124.893Z",
                fill: "white"
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "filter0_di_8006_7443",
              x: "16.1008",
              y: "60.3523",
              width: "139.146",
              height: "47.1519",
              filterUnits: "userSpaceOnUse",
              colorInterpolationFilters: "sRGB",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    type: "matrix",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                    result: "hardAlpha"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", {}),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: "4.12171" }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    type: "matrix",
                    values: "0 0 0 0 0.168627 0 0 0 0 0.352941 0 0 0 0 0.230065 0 0 0 0.1 0"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    mode: "normal",
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_8006_7443"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_8006_7443",
                    result: "shape"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    type: "matrix",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                    result: "hardAlpha"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: "2.06086" }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: "2.06086" }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    type: "matrix",
                    values: "0 0 0 0 0.168627 0 0 0 0 0.352941 0 0 0 0 0.202418 0 0 0 0.05 0"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    mode: "normal",
                    in2: "shape",
                    result: "effect2_innerShadow_8006_7443"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsx("clipPath", { id: "clip0_8006_7443", children: /* @__PURE__ */ jsx("rect", { width: "171", height: "153.287", fill: "white" }) })
        ] })
      ]
    }
  );
};
var StepIllustration_default = StepIllustration;
var EmptyResult = () => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx("div", { className: "flex h-full w-full pl-6 pr-6 pt-2 pb-6", children: /* @__PURE__ */ jsx("div", { className: "w-full justify-center items-center px-5 py-3 shadow-subtle-sm", children: /* @__PURE__ */ jsx("div", { className: "flex flex-col w-full h-full justify-center items-center gap-5", children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col items-center gap-4 p-6 text-center", children: [
    /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(StepIllustration_default, {}) }),
    /* @__PURE__ */ jsx("div", { className: "text-xs text-[#091E42] font-semibold", children: t("live-editor.step.empty.message.awaiting") }),
    /* @__PURE__ */ jsx("p", { className: "text-xs leading-4 text-[#091E42]", children: t("live-editor.step.empty.message") })
  ] }) }) }) });
};
var EmptyResult_default = EmptyResult;
var { Button: Button31, BUTTON_VARIANTS: BUTTON_VARIANTS14, BUTTON_SIZE: BUTTON_SIZE11 } = V2;
var STEP_RESULT_TYPE = {
  NEW_STEP: "new-step"
};
function StepRunResult({
  onClose,
  stepResultData,
  stepData,
  isStepResultLoading,
  testCaseResult,
  apiUrl,
  openStepResultDetails,
  stepResults,
  stepsForChildResultCalculation,
  selectedIterationByStepId,
  totalSteps,
  currentStepIndex: _currentStepIndexProps
}) {
  const { screens, appVersionId, templates, addonTemplates } = useSelector(
    (state) => state.widget
  );
  const { currentExecutionStatus } = useSelector(
    (state) => state.debugging
  );
  const nlActions = useMemo(() => {
    const list = [...templates || [], ...addonTemplates || []];
    return list;
  }, [templates, addonTemplates]);
  const [showToast, setShowToast] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  const [toastType, setToastType] = useState(TOAST_TYPE.SUCCESS);
  const updateElementModal = useModal();
  const [isElementOpened, updatedEditElement] = useState(false);
  const currentElement = useRef(null);
  const stepStatus = useMemo(() => {
    return currentExecutionStatus?.liveStepResults?.filter(
      (step2) => step2.uuid == stepResultData?.uuid
    )?.[0]?.result;
  }, [currentExecutionStatus]);
  const stepNumber = stepData?.stepNumber;
  const isUpButtonDisabled = useMemo(() => {
    return !stepResults || stepResults.length === 0 || _currentStepIndexProps <= 0;
  }, [stepResults, _currentStepIndexProps]);
  const isDownButtonDisabled = useMemo(() => {
    return !stepResults || stepResults.length === 0 || _currentStepIndexProps >= stepResults.length - 1;
  }, [stepResults, _currentStepIndexProps]);
  const handleClose = () => {
    onClose();
  };
  const handleArrowButtonClick = (direction) => {
    if (stepResults && stepResults.length > 0) {
      let targetIndex = _currentStepIndexProps;
      if (direction === "up" && _currentStepIndexProps > 0) {
        targetIndex = _currentStepIndexProps - 1;
      } else if (direction === "down" && _currentStepIndexProps < totalSteps) {
        targetIndex = _currentStepIndexProps + 1;
      }
      const nextStep = Array.from(stepsForChildResultCalculation.values())[targetIndex];
      const { result: nextStepResult } = getLoopAndResultForAStep({
        step: nextStep,
        stepResultTree: stepResults,
        state: selectedIterationByStepId
      });
      if (openStepResultDetails && targetIndex !== _currentStepIndexProps) {
        const newResult = nextStepResult ? nextStepResult : {
          type: STEP_RESULT_TYPE.NEW_STEP,
          metadata: { testStep: { id: nextStep.id } }
        };
        openStepResultDetails(newResult);
      }
    }
  };
  const handleUpdateElement = async (elementData) => {
    const editUiIdentifier = currentElement.current;
    if (elementData && editUiIdentifier) {
      let screen = screens.find(
        ({ name }) => name.toLocaleLowerCase() === elementData.screenTitle?.toLocaleLowerCase()
      );
      if (!screen) {
        screen = await ScreenApi.create(
          elementData.screenTitle,
          appVersionId
        );
      }
      if (elementData.elementContext) {
        elementData.screenNameId = screen.id;
        elementData.applicationVersionId = appVersionId;
        processElementContext(elementData);
      } else {
        elementData.hostElements = null;
      }
      const updatedUiIdentifier = {
        ...editUiIdentifier,
        ...elementData,
        definition: elementData?.definition || elementData.xPath || elementData.cssPath,
        currentElement: { textContent: elementData.text },
        screenShotData: elementData.screenshot,
        isDynamic: elementData.isDynamicElement,
        screenNameId: screen.id,
        screenNameObj: screen,
        hostElements: elementData.elementContext,
        updateType: elementData.updateType || "CHROME"
      };
      try {
        await UiIdentifierApi.update(updatedUiIdentifier);
        const { screenshotRetrievalId } = elementData;
        if (screenshotRetrievalId && updatedUiIdentifier.id) {
          try {
            const globalState2 = getGlobalState();
            const elementSS = selectElementScreenshotMap(
              globalState2,
              screenshotRetrievalId
            );
            const croppedElementSS = selectCroppedElementScreenshotMap(
              globalState2,
              screenshotRetrievalId
            );
            const appVersionId2 = globalState2.widget.appVersionId;
            if (elementSS) {
              RecorderAssetsApi.saveElementScreenshot(updatedUiIdentifier.id, {
                screenshotFile: dataurltoFile(elementSS),
                applicationVersionId: appVersionId2
              });
            }
            if (croppedElementSS) {
              RecorderAssetsApi.saveCroppedElementScreenshot(
                updatedUiIdentifier.id,
                {
                  screenshotFile: dataurltoFile(croppedElementSS),
                  applicationVersionId: appVersionId2
                }
              );
            }
          } catch (error) {
          }
        }
        setShowToast(true);
        setToastMsg("Element updated successfully");
        setToastType(TOAST_TYPE.SUCCESS);
      } catch (err) {
        setShowToast(true);
        setToastMsg(err.error);
        setToastType(TOAST_TYPE.ERROR);
      } finally {
        updateElementModal.closeModal();
      }
    }
  };
  useEffect(() => {
    if (updateElementModal.state.show) {
      UiIdentifierApi.get(updateElementModal.state?.data?.elementId).then(
        (res) => {
          currentElement.current = res;
          updatedEditElement(true);
        }
      );
    } else updatedEditElement(false);
  }, [updateElementModal.state]);
  const step = stepData || stepResultData?.metadata?.testStep || {};
  const headerActions = /* @__PURE__ */ jsxs("div", { className: "flex gap-[6px]", children: [
    /* @__PURE__ */ jsx(
      Button31,
      {
        onClick: () => handleArrowButtonClick("up"),
        iconLeft: "arrow-upward-alt",
        variant: BUTTON_VARIANTS14.SECONDARY,
        size: BUTTON_SIZE11.SMALLEST,
        className: "h-6 w-6 bg-white rounded border-[0.5px] !border-secondary-100 shadow-subtle-sm",
        iconStyles: "w-[10px]",
        disabled: isUpButtonDisabled,
        "aria-label": ARIA_LABELS.MOVE_UP
      }
    ),
    /* @__PURE__ */ jsx(
      Button31,
      {
        variant: BUTTON_VARIANTS14.SECONDARY,
        size: BUTTON_SIZE11.SMALLEST,
        className: "h-6 w-7 bg-white rounded border-[0.5px] !border-secondary-100 shadow-subtle-sm",
        disabled: true,
        children: /* @__PURE__ */ jsx("div", { className: "text-xs text-unique-600", children: stepNumber })
      }
    ),
    /* @__PURE__ */ jsx(
      Button31,
      {
        onClick: () => handleArrowButtonClick("down"),
        iconLeft: "arrow-downward-alt",
        variant: BUTTON_VARIANTS14.SECONDARY,
        size: BUTTON_SIZE11.SMALLEST,
        className: "h-6 w-6 bg-white rounded border-[0.5px] !border-secondary-100 shadow-subtle-sm",
        iconStyles: "w-[10px]",
        disabled: isDownButtonDisabled,
        "aria-label": ARIA_LABELS.MOVE_DOWN
      }
    )
  ] });
  const body = /* @__PURE__ */ jsxs(Fragment, { children: [
    !!step && /* @__PURE__ */ jsx(
      executed_step_default,
      {
        step,
        stepResult: stepResultData,
        nlActions,
        containerClassName: "mb-[1px]",
        isViewOnly: true,
        isWebRecorder: true,
        isStepResultDetails: true
      }
    ),
    stepResultData?.type === STEP_RESULT_TYPE.NEW_STEP ? /* @__PURE__ */ jsx(EmptyResult_default, { stepNumber }) : /* @__PURE__ */ jsx(
      StepRunResultBody,
      {
        stepResultData,
        stepStatus,
        isStepResultLoading,
        testCaseResult,
        apiUrl,
        updateElementModal,
        versionId: appVersionId,
        nlActions,
        stepNumber
      }
    )
  ] });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    stepResultData && /* @__PURE__ */ jsx(
      OverlayContainer,
      {
        title: "Step Result",
        onClose: handleClose,
        isFixedFooter: false,
        noBodyWrapper: true,
        headerIcon: "step-result",
        headerActions,
        body
      }
    ),
    isElementOpened && /* @__PURE__ */ jsx(
      CreateElement,
      {
        onClose: updateElementModal.closeModal,
        uiIdentifier: currentElement.current,
        onUpdate: (elementData) => handleUpdateElement(elementData)
      }
    ),
    /* @__PURE__ */ jsx(
      UiToast,
      {
        isShow: showToast,
        message: toastMsg,
        type: toastType,
        onClose: () => setShowToast(false),
        noAutoHide: false
      }
    )
  ] });
}
var useTestStepBulkUpdateDrawer = (openBulkUpdateDrawer) => {
  const [resolver, updateResolver] = useState(
    null
  );
  const [payload, updatePayload] = useState(null);
  const onDiscard = useCallback(() => {
    resolver?.({ action: "DISCARDED" });
    openBulkUpdateDrawer(false);
  }, [resolver]);
  const onUpdate = useCallback(() => {
    resolver?.({ action: "BULK_UPDATE_DONE" });
    openBulkUpdateDrawer(false);
  }, [resolver]);
  const openTestStepBulkUpdateDrawer = useCallback(
    (selectedSteps) => new Promise((resolve) => {
      updateResolver(() => resolve);
      updatePayload(selectedSteps);
    }),
    [updateResolver]
  );
  useEffect(() => {
    if (resolver && payload) {
      openBulkUpdateDrawer(true);
    }
  }, [resolver, payload]);
  return { openTestStepBulkUpdateDrawer, onUpdate, onDiscard };
};
var propertyInsideStepDetail = ["highlightElement"];
var getPropertyValue = (testSteps, property) => {
  return testSteps.map((step) => {
    if (propertyInsideStepDetail.includes(property))
      return get$1(step.stepDetail, property);
    return get$1(step, property);
  }).reduce((prev, current, idx) => {
    if ((prev === null || prev !== current) && idx !== 0) return null;
    return current;
  }, null);
};
var useStepSettings = (localState, updateLocalState, showHighlightElementCheckbox, showAccessibilityTestingCheckbox, selectedSteps) => {
  const [stopPreference, setStopPreference] = useState(
    localState.priority == TestStepPriority.MAJOR
  );
  const [ignoreStepResult, setIgnoreStepResult] = useState(
    localState.ignoreStepResult
  );
  const onChangeStepPreference = useCallback(
    (value) => {
      localState.priority = value ? TestStepPriority.MAJOR : TestStepPriority.MINOR;
      if (value) {
        localState.ignoreStepResult = localState.priority !== TestStepPriority.MAJOR;
        setIgnoreStepResult(localState.ignoreStepResult);
      }
      updateLocalState(Object.assign({}, localState));
      setStopPreference(localState.priority === TestStepPriority.MAJOR);
    },
    [stopPreference, localState]
  );
  const onChangeDisableStep = useCallback(
    (value) => {
      localState.disabled = value;
      updateLocalState({ ...localState });
    },
    [localState, updateLocalState]
  );
  const onChangeIgnoreStep = useCallback(
    (value) => {
      localState.ignoreStepResult = value;
      if (value) {
        localState.priority = localState.ignoreStepResult ? TestStepPriority.MINOR : TestStepPriority.MAJOR;
        setStopPreference(localState.priority === TestStepPriority.MAJOR);
      }
      updateLocalState(Object.assign({}, localState));
      setIgnoreStepResult(localState.ignoreStepResult);
    },
    [ignoreStepResult, localState]
  );
  const onChangeVisualTesting = useCallback(
    (value) => {
      localState.enableVisualTesting = value;
      updateLocalState({ ...localState });
    },
    [localState, updateLocalState]
  );
  const onChangeAccessibilityTesting = useCallback(
    (value) => {
      localState.enableAccessibilityTesting = value;
      updateLocalState({ ...localState });
    },
    [localState, updateLocalState]
  );
  const onChangeHighlightElement = useCallback(
    (value) => {
      localState.highlightElement = value;
      updateLocalState({ ...localState });
    },
    [localState, updateLocalState]
  );
  const settingsItems = useMemo(
    () => [
      {
        label: "Stop Test Case execution on Test Step failure",
        inputValue: stopPreference || false,
        onChange: onChangeStepPreference,
        isDisabled: ignoreStepResult,
        disabledClassName: "!text-[#94A3B8]",
        isIntermediate: stopPreference === null
      },
      {
        label: "Ignore this step result in Test Case Result",
        inputValue: ignoreStepResult || false,
        onChange: onChangeIgnoreStep,
        isDisabled: stopPreference,
        disabledClassName: "!text-[#94A3B8]",
        isIntermediate: ignoreStepResult === null
      },
      {
        label: "Disable Step",
        inputValue: localState.disabled || false,
        onChange: onChangeDisableStep,
        isIntermediate: localState.disabled === null
      },
      {
        label: "Enable Visual Testing for the step",
        inputValue: localState.enableVisualTesting || false,
        onChange: onChangeVisualTesting,
        isIntermediate: localState.enableVisualTesting === null
      },
      ...showAccessibilityTestingCheckbox ? [
        {
          label: "Enable Accessibility Testing for the step",
          inputValue: localState.enableAccessibilityTesting || false,
          onChange: onChangeAccessibilityTesting,
          isIntermediate: localState.enableAccessibilityTesting === null
        }
      ] : [],
      ...showHighlightElementCheckbox ? [
        {
          label: "Highlight element in screenshot",
          inputValue: localState.highlightElement || false,
          onChange: onChangeHighlightElement,
          isIntermediate: localState.highlightElement === null
        }
      ] : []
    ],
    [
      stopPreference,
      ignoreStepResult,
      onChangeStepPreference,
      onChangeIgnoreStep,
      onChangeDisableStep,
      onChangeVisualTesting,
      onChangeHighlightElement,
      localState,
      showHighlightElementCheckbox,
      showAccessibilityTestingCheckbox
    ]
  );
  useEffect(() => {
    setStopPreference(
      getPropertyValue(selectedSteps, "priority") && selectedSteps[0]?.priority === TestStepPriority.MAJOR
    );
    setIgnoreStepResult(getPropertyValue(selectedSteps, "ignoreStepResult"));
  }, [selectedSteps]);
  return { settingsItems };
};
var Footer4 = ({
  isUpdating,
  isDisabled,
  handleClose,
  handleBulkUpdate
}) => {
  const { isDebugger } = useRecorderContext();
  const updateButton = /* @__PURE__ */ jsx(
    UiButton,
    {
      onClick: handleBulkUpdate,
      color: "primary",
      isDisabled,
      variant: "contained",
      children: isUpdating ? /* @__PURE__ */ jsx("span", { className: "w-5 mr-2", children: /* @__PURE__ */ jsx(
        Spinner,
        {
          size: 18,
          thickness: 80,
          speed: 140,
          color: "#ffffff",
          secondaryColor: "rgba(172, 57, 57, 0)"
        }
      ) }) : /* @__PURE__ */ jsx("span", { children: "Update" })
    }
  );
  const cancelButton = /* @__PURE__ */ jsx(
    UiButton,
    {
      onClick: handleClose,
      color: "secondary",
      isDisabled: isUpdating,
      variant: "outlined",
      children: /* @__PURE__ */ jsx(Fragment, { children: "Cancel" })
    }
  );
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    "div",
    {
      className: `flex w-full space-x-3 ${isDebugger ? "justify-start" : "justify-end"}`,
      children: isDebugger ? /* @__PURE__ */ jsxs(Fragment, { children: [
        updateButton,
        cancelButton
      ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
        cancelButton,
        updateButton
      ] })
    }
  ) });
};
var OtherSettings = ({
  localState,
  updateLocalState,
  selectedSteps,
  maxRetriesHasError,
  maxRetries,
  updateMaxRetries,
  showHighlightElementCheckbox,
  showAccessibilityTestingCheckbox
}) => {
  const { settingsItems } = useStepSettings(
    localState,
    updateLocalState,
    showHighlightElementCheckbox,
    showAccessibilityTestingCheckbox,
    selectedSteps
  );
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      InputWithCheckbox,
      {
        label: "No. of Retries on Step Failure",
        value: maxRetries,
        updateValue: (retries) => updateMaxRetries(
          retries?.toString()?.trim().replaceAll(/[^\d]/g, "") ? Number(retries?.toString().replaceAll(/[^\d]/g, "")) : null
        ),
        errorLabel: "Maximum retries allowed is 10",
        hasError: maxRetries && maxRetriesHasError,
        defaultValue: null,
        wrapperClassName: "mt-2",
        isChecked: maxRetries != null
      }
    ),
    /* @__PURE__ */ jsx("div", { className: "flex flex-col gap-6 mt-2", children: settingsItems?.map((item, index) => /* @__PURE__ */ jsx(
      SettingsCheckboxItem,
      {
        label: t(item.label),
        inputValue: item.inputValue,
        isDisabled: item.isDisabled,
        disabledClassName: item.disabledClassName,
        onChange: item.onChange,
        isIntermediate: item.isIntermediate,
        checkboxSize: "small"
      },
      index
    )) })
  ] });
};
var bulkSelectStepScreenshotOptions = [
  {
    key: StepLevelScreenshot.LEAVE_AS_IT_IS,
    label: `Leave as it is`,
    value: StepLevelScreenshot.LEAVE_AS_IT_IS
  },
  {
    key: StepLevelScreenshot.ALWAYS,
    label: `Always`,
    value: StepLevelScreenshot.ALWAYS
  },
  {
    key: StepLevelScreenshot.STEP_FAILURE,
    label: `Only on step failure`,
    value: StepLevelScreenshot.STEP_FAILURE
  }
];
var ScreenshotCaptureSection = ({
  screenshotCapture,
  updateScreenshotCapture
}) => {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      ScreenshotCapture,
      {
        onSelect: updateScreenshotCapture,
        options: bulkSelectStepScreenshotOptions,
        selectedOption: screenshotCapture,
        wrapperClassName: "mt-6",
        customLabel: STEP_FLAG.SCREENSHOT_CAPTURE.LABEL
      }
    ),
    /* @__PURE__ */ jsx(Divider, { type: "solid", className: "!mt-6 !text-neutral-100" })
  ] });
};
var StepTimeOutSection = ({
  maxWaitTime,
  updateMaxWaitTime,
  maxTimeHasError
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      InputWithCheckbox,
      {
        label: "Step Timeout",
        value: maxWaitTime,
        updateValue: (wait) => updateMaxWaitTime(
          wait?.toString()?.trim().replaceAll(/[^\d]/g, "") ? Number(wait?.toString().replaceAll(/[^\d]/g, "")) : null
        ),
        wrapperClassName: "items-center mt-5 mb-1",
        errorLabel: "Step Timeout should be less than or equal to 120",
        hasError: maxWaitTime && maxTimeHasError,
        defaultValue: null,
        isChecked: maxWaitTime != null,
        suffix: /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("div", { className: "text-[#94A3B8] ml-1 text-sm", children: "secs." }),
          /* @__PURE__ */ jsx("div", { className: "text-[#94A3B8] ml-28 text-sm", children: "( <=120 seconds )" })
        ] })
      }
    ),
    /* @__PURE__ */ jsx(Divider, { type: "solid", className: " !text-neutral-100 !mt-4" })
  ] });
};
function BulkUpdateSettingsDrawer({
  selectedSteps,
  localState,
  updateLocalState,
  refreshStepList,
  isHighlightFeatureEnabled,
  isAccessibilitySupported,
  onUpdate,
  handleClose
}) {
  const [isUpdating, setUpdating] = useState(false);
  const [screenshotCapture, setScreenshotCapture] = useState(null);
  const [maxWaitTime, setMaxWaitTime] = useState(
    () => getPropertyValue(selectedSteps, "waitTime")
  );
  const [maxRetries, setMaxRetries] = useState(
    () => getPropertyValue(selectedSteps, "maxRetries")
  );
  const { appType, appVersionId } = useSelector(
    (state) => state.widget
  );
  const handleBulkUpdate = useCallback(() => {
    if (maxWaitTime && maxTimeHasError) {
      return;
    }
    let filteredSteps = selectedSteps;
    if (localState.enableVisualTesting !== void 0) {
      filteredSteps = selectedSteps.filter((step) => !step.isRestStep);
    }
    const stepIds = filteredSteps.map((step) => step.id);
    setUpdating(true);
    const requestBody = new TestStepBulkUpdateRequest();
    requestBody.stepIds = stepIds;
    requestBody.highlightElement = localState.highlightElement;
    requestBody.visualEnabled = localState.enableVisualTesting;
    requestBody.ignoreStepResult = localState?.ignoreStepResult;
    requestBody.disabled = localState.disabled;
    requestBody.waitTime = maxWaitTime;
    requestBody.maxRetries = maxRetries;
    requestBody.testStepPriority = localState.priority;
    requestBody.accessibilityEnabled = localState.enableAccessibilityTesting;
    requestBody.smartActionsEnabled = localState.smartActionsEnabled;
    if (screenshotCapture != StepLevelScreenshot.LEAVE_AS_IT_IS) {
      requestBody.stepLevelScreenshot = screenshotCapture;
    }
    StepApi.bulkUpdateProperties(requestBody, appVersionId).then(() => {
      onUpdate();
      refreshStepList(false);
      toastify("Updated Successfully!", {
        type: "success",
        position: "top-center",
        hideProgressBar: true
      });
    }).catch(() => {
      toastify("Failed to update", {
        type: "error",
        position: "top-center",
        hideProgressBar: true
      });
    }).finally(() => setUpdating(false));
  }, [localState, screenshotCapture, maxRetries, maxWaitTime, selectedSteps]);
  const maxTimeHasError = useMemo(
    () => Number(maxWaitTime) > 120 || !(Number(maxWaitTime) > 0) || String(maxWaitTime).includes("."),
    [maxWaitTime]
  );
  const maxRetriesHasError = useMemo(() => {
    return Number(maxRetries) > 10 || Number(maxRetries) < 0 || String(maxRetries).includes(".");
  }, [maxRetries]);
  useEffect(() => {
    localState.disabled = getPropertyValue(selectedSteps, "disabled");
    localState.enableVisualTesting = getPropertyValue(
      selectedSteps,
      "visualEnabled"
    );
    localState.highlightElement = getPropertyValue(
      selectedSteps,
      "highlightElement"
    );
    localState.enableAccessibilityTesting = getPropertyValue(
      selectedSteps,
      "accessibilityEnabled"
    );
    localState.smartActionsEnabled = getPropertyValue(
      selectedSteps,
      "smartActionsEnabled"
    );
    updateLocalState(Object.assign({}, localState));
    setMaxWaitTime(getPropertyValue(selectedSteps, "waitTime"));
    setMaxRetries(getPropertyValue(selectedSteps, "maxRetries"));
    setScreenshotCapture(
      getPropertyValue(selectedSteps, "stepLevelScreenshot") ?? StepLevelScreenshot.LEAVE_AS_IT_IS
    );
  }, [selectedSteps]);
  const showHighlightElementCheckbox = useMemo(
    () => appType == RECORDER_APPLICATION_TYPE.WEB && isHighlightFeatureEnabled,
    [appType, isHighlightFeatureEnabled]
  );
  return /* @__PURE__ */ jsx(
    OverlayContainer,
    {
      title: "Update Settings",
      onClose: () => handleClose(),
      isFixedFooter: true,
      body: /* @__PURE__ */ jsxs("div", { className: "overflow-y-auto h-[calc(100%_-_64px)] px-6", children: [
        /* @__PURE__ */ jsx(
          StepTimeOutSection,
          {
            maxWaitTime,
            updateMaxWaitTime: setMaxWaitTime,
            maxTimeHasError
          }
        ),
        /* @__PURE__ */ jsx(
          ScreenshotCaptureSection,
          {
            screenshotCapture,
            updateScreenshotCapture: setScreenshotCapture
          }
        ),
        /* @__PURE__ */ jsx(
          OtherSettings,
          {
            localState,
            updateLocalState,
            maxRetriesHasError,
            selectedSteps,
            maxRetries,
            updateMaxRetries: setMaxRetries,
            showHighlightElementCheckbox,
            showAccessibilityTestingCheckbox: isAccessibilitySupported
          }
        )
      ] }),
      footer: /* @__PURE__ */ jsx(
        Footer4,
        {
          isDisabled: isUpdating || maxWaitTime && maxTimeHasError || maxRetries && maxRetriesHasError,
          isUpdating,
          handleBulkUpdate,
          handleClose
        }
      )
    }
  );
}
var UpdateBulkSettings = ({
  selectedSteps,
  localState,
  updateLocalState,
  refreshStepList,
  isRecorder = false,
  isHighlightFeatureEnabled,
  isAccessibilitySupported,
  onUpdateBulkSettings = NOOP
}) => {
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);
  const { openTestStepBulkUpdateDrawer, onUpdate, onDiscard } = useTestStepBulkUpdateDrawer(setIsOpenDrawer);
  const handleUpdateBulkSettings = () => {
    onUpdateBulkSettings(selectedSteps);
    onUpdate();
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(ToolTip, { content: isRecorder && "Update Settings", children: /* @__PURE__ */ jsxs(
      Button,
      {
        type: "primary-transparent",
        size: "sm",
        onClick: () => openTestStepBulkUpdateDrawer(true),
        children: [
          /* @__PURE__ */ jsx(Icon, { name: "settings", className: "text-base" }),
          !isRecorder && /* @__PURE__ */ jsx("span", { className: "ml-1 text-small leading-5", children: "Update Settings" })
        ]
      }
    ) }),
    isOpenDrawer && /* @__PURE__ */ jsx(
      BulkUpdateSettingsDrawer,
      {
        selectedSteps,
        localState,
        updateLocalState,
        refreshStepList,
        isHighlightFeatureEnabled,
        isAccessibilitySupported,
        handleClose: onDiscard,
        onUpdate: handleUpdateBulkSettings
      }
    )
  ] });
};
var nameSpace15 = PrivateURLConstants.STEP;
var createByStepIds = ({
  name,
  stepIds,
  testCaseId,
  stepStartPos
}) => instance_default.post(`${nameSpace15}/block`, {
  name,
  stepIds,
  testCaseId,
  stepOrder: stepStartPos
});
var BlockApi = {
  createByStepIds
};
var useNameValidation = () => {
  const validateName = useCallback(
    (name, fieldName, callBack, min, max) => {
      let returnValue = "";
      if (!name) {
        returnValue = `${fieldName} can't be blank`;
      } else {
        if (typeof min === "number" && name.length < min) {
          returnValue = `${fieldName} should be have at least ${min} characters`;
        } else if (typeof max === "number" && name.length > max) {
          returnValue = `${fieldName} should be less than ${max} characters`;
        }
      }
      callBack(returnValue);
      return returnValue;
    },
    []
  );
  return { validateName };
};
var CreateBlockComponent = ({
  isBlockModalOpen,
  setIsBlockModalOpen,
  selectedSteps,
  testCaseId,
  refreshStepList,
  isNotContinuous,
  isContainsBlockStep,
  isParentMissing,
  isRecorder = false,
  stepOrder
}) => {
  const [blockLabelName, setBlockLabelName] = useState("");
  const [errorText, setErrorText] = useState("");
  const { validateName } = useNameValidation();
  const handleBlockCreate = (selectedSteps2) => {
    const blockPayload = {
      name: blockLabelName,
      testCaseId,
      stepIds: [].concat(
        ...selectedSteps2.map((step) => step.id).filter((id) => Boolean(id))
      ),
      stepStartPos: stepOrder
    };
    const error_Value = validateName(
      blockLabelName,
      "Name",
      setErrorText,
      4,
      250
    );
    if (Boolean(!error_Value?.length)) {
      BlockApi.createByStepIds(blockPayload).then(
        (res) => {
          const minPageStep = selectedSteps2.reduce(
            (min, obj) => isNumber(obj?.pagenumber) && isNumber(min.pagenumber) && obj.pagenumber < min.pagenumber ? obj : min,
            selectedSteps2[0]
          );
          const pageNo = minPageStep.pagenumber || 0;
          refreshStepList(pageNo);
        },
        (error) => {
        }
      );
    } else {
      return false;
    }
  };
  const handelOnChange = useCallback(
    (name) => {
      validateName(name?.trim?.(), "Name", setErrorText, 4, 250);
      setBlockLabelName(name);
    },
    [blockLabelName, setBlockLabelName]
  );
  const getMessage = () => {
    if (isContainsBlockStep) {
      return "Test Steps contains Block step or parent step is Block step. Please remove/Deselect it and try again.";
    } else if (isParentMissing) {
      return "Please add entire If condition/ For Loop/ While Loop and try again.";
    } else if (isNotContinuous) {
      return "Selected steps not in continuous flow. Please make sure select continuous flow and try again";
    } else {
      return "";
    }
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(ToolTip, { content: isRecorder && "Create Block", children: /* @__PURE__ */ jsxs(
      Button,
      {
        type: "primary-transparent",
        size: "sm",
        onClick: () => setIsBlockModalOpen(true),
        children: [
          /* @__PURE__ */ jsx(Icon, { name: "view-agenda", className: "text-base" }),
          !isRecorder && /* @__PURE__ */ jsx("span", { className: "ml-1 text-small leading-5", children: "Create Block" })
        ]
      }
    ) }),
    /* @__PURE__ */ jsxs(Modal, { isOpen: isBlockModalOpen, className: "!rounded-lg", children: [
      /* @__PURE__ */ jsx("div", { className: "text-xl leading-5 font-medium text-unique-600", children: "Create Block" }),
      /* @__PURE__ */ jsx(
        Input,
        {
          hasError: Boolean(errorText?.length),
          errorText,
          id: "block-create",
          label: "Name",
          value: blockLabelName,
          onChange: (name) => handelOnChange(name),
          type: "text",
          wrapperClassName: "w-full mt-4",
          isRequired: true
        }
      ),
      (isContainsBlockStep || isParentMissing || isNotContinuous) && /* @__PURE__ */ jsx("div", { className: "mt-2 p-3 flex flex-col gap-y-3 bg-warning-50 rounded-lg col-span-2", children: /* @__PURE__ */ jsx("div", { className: "flex gap-x-2", children: /* @__PURE__ */ jsx("div", { className: " text-2xs leading-4.5 text-warning-700 font-medium", children: getMessage() }) }) }),
      /* @__PURE__ */ jsxs("div", { className: "flex flex-row-reverse mt-5", children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            type: "primary",
            onClick: () => handleBlockCreate(selectedSteps),
            isDisabled: isContainsBlockStep || isParentMissing || isNotContinuous,
            children: "Create"
          }
        ),
        /* @__PURE__ */ jsx(
          Button,
          {
            type: "secondary",
            className: "mr-3",
            onClick: () => setIsBlockModalOpen(false),
            children: "Cancel"
          }
        )
      ] })
    ] })
  ] });
};
var CreateStepGroupComponent = ({
  isStepGroupModalOpen,
  setIsStepGroupModalOpen,
  selectedSteps,
  testCaseId,
  refreshStepList,
  canShowReplace,
  isRecorder = false,
  isParentMissing
}) => {
  const [stepGroupName, setStepGroupName] = useState("");
  const [errorText, setErrorText] = useState("");
  const [isSubmited, setSubmitState] = useState(false);
  const { validateName } = useNameValidation();
  const handleStepGroupCreate = (selectedSteps2, isReplace) => {
    const copyStepGroup = {
      name: stepGroupName,
      testCaseId,
      stepIds: selectedSteps2.filter((step) => step.id !== void 0).map((step) => step.id),
      isStepGroup: true,
      isReplace,
      isBulkAction: true
    };
    const errorTextValue = validateName(
      stepGroupName?.trim?.(),
      "Name",
      setErrorText,
      4,
      250
    );
    setSubmitState(true);
    if (Boolean(errorTextValue)) {
      return null;
    }
    TestCaseApi.copy(copyStepGroup).then((res) => {
      if (res.hasOwnProperty("error")) {
        toastify(
          res["error"] ? res["error"] : "Error: Unable to create step group",
          {
            type: "error",
            position: "bottom-center",
            hideProgressBar: true
          }
        );
        resetValue(true);
        return;
      }
      toastify("Step group created successfully", {
        type: "success",
        position: "bottom-center"
      });
      resetValue(false);
      const minPageStep = selectedSteps2.reduce(
        (min, obj) => isNumber(obj?.pagenumber) && isNumber(min.pagenumber) && obj.pagenumber < min.pagenumber ? obj : min,
        selectedSteps2[0]
      );
      const pageNo = minPageStep.pagenumber || 0;
      refreshStepList(pageNo);
    });
  };
  const handleOnChange = useCallback(
    (name) => {
      validateName(name?.trim?.(), "Name", setErrorText, 4, 250);
      setSubmitState(false);
      setStepGroupName(name);
    },
    [setSubmitState]
  );
  const resetValue = useCallback((isCancel) => {
    setStepGroupName("");
    setSubmitState(false);
    setIsStepGroupModalOpen(isCancel);
  }, []);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(ToolTip, { content: isRecorder && "Create Step Group", children: /* @__PURE__ */ jsxs(
      Button,
      {
        type: "primary-transparent",
        size: "sm",
        onClick: () => resetValue(true),
        children: [
          /* @__PURE__ */ jsx(Icon, { name: "ballot", className: "text-base" }),
          !isRecorder && /* @__PURE__ */ jsx("span", { className: "ml-1 text-small leading-5", children: "Create Step Group" })
        ]
      }
    ) }),
    /* @__PURE__ */ jsxs(Modal, { isOpen: isStepGroupModalOpen, className: "!rounded-lg", children: [
      /* @__PURE__ */ jsx("div", { className: "text-xl leading-5 font-medium", children: "Create Step Group" }),
      !isParentMissing && /* @__PURE__ */ jsx(
        Input,
        {
          hasError: isSubmited ? Boolean(errorText?.length) : false,
          errorText: isSubmited ? errorText : "",
          id: "step-group-name",
          label: "Name",
          value: stepGroupName,
          onChange: (name) => handleOnChange(name),
          type: "text",
          wrapperClassName: "w-full mt-4",
          isRequired: true
        }
      ),
      isParentMissing && /* @__PURE__ */ jsx("div", { className: "mt-2 p-3 flex flex-col gap-y-3 bg-warning-50 rounded-lg col-span-2", children: /* @__PURE__ */ jsx("div", { className: "flex gap-x-2", children: /* @__PURE__ */ jsx("div", { className: " text-2xs leading-4.5 text-warning-700 font-medium", children: "Please add entire If condition/ For Loop/ While Loop and try again." }) }) }),
      /* @__PURE__ */ jsxs("div", { className: "flex flex-row-reverse mt-5", children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            type: "primary",
            isDisabled: isParentMissing || isSubmited,
            onClick: () => handleStepGroupCreate(selectedSteps, false),
            children: "Create"
          }
        ),
        canShowReplace && !isParentMissing && /* @__PURE__ */ jsx(
          Button,
          {
            type: "primary",
            className: "mr-3",
            onClick: () => handleStepGroupCreate(selectedSteps, true),
            isDisabled: isSubmited,
            children: "Create and Replace"
          }
        ),
        /* @__PURE__ */ jsx(
          Button,
          {
            type: "secondary",
            className: "mr-3",
            onClick: () => resetValue(false),
            children: "Cancel"
          }
        )
      ] })
    ] })
  ] });
};
var BulkDeleteComponent = ({
  isDeleteModalOpen,
  setIsDeleteModalOpen,
  selectedSteps,
  refreshStepList,
  isRecorder = false
}) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const { appVersionId } = useSelector((state) => state.widget);
  const handleBulkDelete = () => {
    const ids = selectedSteps.map((step) => step.id).filter((id) => Boolean(id));
    setIsDeleting(true);
    StepApi.deleteMany(ids, appVersionId).then((res) => {
      toastify("Steps deleted successfully", {
        type: "success",
        position: "top-center"
      });
      setIsDeleting(false);
      setIsDeleteModalOpen(false);
      const minPageStep = selectedSteps.reduce(
        (min, obj) => isNumber(obj?.pagenumber) && isNumber(min.pagenumber) && obj.pagenumber < min.pagenumber ? obj : min,
        selectedSteps[0]
      );
      const pageNo = minPageStep.pagenumber || 0;
      refreshStepList(pageNo);
    });
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(ToolTip, { content: isRecorder && "Delete", children: /* @__PURE__ */ jsxs(
      Button,
      {
        type: "primary-transparent",
        size: "sm",
        onClick: () => setIsDeleteModalOpen(true),
        "aria-label": isRecorder ? ARIA_LABELS.DELETE : void 0,
        children: [
          /* @__PURE__ */ jsx(Icon, { name: "delete", className: "text-base" }),
          !isRecorder && /* @__PURE__ */ jsx("span", { className: "ml-1 text-small leading-5", children: "Delete" })
        ]
      }
    ) }),
    /* @__PURE__ */ jsx(Modal, { isOpen: isDeleteModalOpen, className: "!rounded-lg", children: /* @__PURE__ */ jsxs("div", { className: "flex gap-x-6", children: [
      /* @__PURE__ */ jsx("div", { className: "h-12 w-12 rounded-full border-spacing-2.5 bg-error-50 flex items-center justify-center", children: /* @__PURE__ */ jsx(
        Icon,
        {
          name: "error",
          className: "flex text-2xl text-error-600 p-1 bg-error-100 rounded-full"
        }
      ) }),
      /* @__PURE__ */ jsxs("div", { className: "text-small leading-5 text-unique-800 flex flex-col w-[320px]", children: [
        /* @__PURE__ */ jsx("div", { className: "text-lg leading-7 font-semibold text-unique-600 pb-3", children: "Are you sure you want to delete this Test Steps?" }),
        "You cannot undo this action!",
        /* @__PURE__ */ jsxs("div", { className: "flex gap-x-3 mt-6", children: [
          /* @__PURE__ */ jsx(
            DangerButton,
            {
              isDisabled: isDeleting,
              onClick: () => handleBulkDelete(),
              children: "Delete"
            }
          ),
          /* @__PURE__ */ jsx(
            SecondaryButton,
            {
              isDisabled: isDeleting,
              onClick: () => setIsDeleteModalOpen(false),
              children: "Cancel"
            }
          )
        ] })
      ] })
    ] }) })
  ] });
};
var BulkActionBanner = ({
  testCaseId,
  selectedSteps,
  totalSteps,
  bulkActionEnabledChange,
  onExit,
  refreshStepList,
  isRecorder = false,
  updateSelectedSteps,
  steps = [],
  afterSteps = [],
  isHighlightFeatureEnabled,
  isAccessibilitySupported,
  executedStepIds,
  onUpdateBulkSettings = NOOP
}) => {
  const { t } = useTranslation();
  const [localState, updateLocalState] = useState({});
  const allSteps = useMemo(
    () => [...steps, ...afterSteps],
    [steps, afterSteps]
  );
  const [isBlockModalOpen, setIsBlockModalOpen] = useState(false);
  const [isStepGroupModalOpen, setIsStepGroupModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [canShowReplace, setCanShowReplace] = useState(true);
  const [isContainsBlockStep, updateIsContainsBlockStep] = useState(false);
  const [isParentMissing, updateIsParentMissing] = useState(false);
  const [mounted, setMounted] = useState(false);
  const [selection, setSelection] = useState("empty");
  const [isSelectAll, setIsSelectAll] = useState(false);
  const stepOrder = useMemo(() => {
    const orderedSteps = selectedSteps.sort(
      (a, b) => parseInt(a.stepNumber) - parseInt(b.stepNumber)
    );
    let _stepOrder = 1e3;
    steps.filter((item, index) => {
      if (orderedSteps && item.id == orderedSteps?.[0]?.id) {
        _stepOrder = (item.stepOrder + (steps?.[index - 1]?.stepOrder || 0)) / 2;
      }
    });
    return _stepOrder;
  }, [selectedSteps, steps]);
  const getAllData = useCallback(
    (stepList) => {
      stepList = stepList.slice().sort(
        (a, b) => isNumber(a?.stepOrder) && isNumber(b?.stepOrder) ? a?.stepOrder - b?.stepOrder : 0
      );
      let isContinuous = true;
      let lastPosition = -1;
      let isParentStepMissing = false;
      let isContainsBlock = false;
      stepList?.forEach((item) => {
        if (isContinuous) {
          isContinuous = lastPosition === -1 ? true : lastPosition + 1 === item.index;
          lastPosition = item.index || -1;
        }
        if (item.parentId && !(item.conditionType === STEP_CONDITION_TYPE.LOOP_FOR || item.conditionType === STEP_CONDITION_TYPE.LOOP_WHILE || item.conditionType === STEP_CONDITION_TYPE.IF) && !getAllParentSelected(item, stepList) && !isParentStepMissing) {
          isParentStepMissing = true;
        }
        if ((item.type === TestStepType.BLOCK || item.blockParentId) && !isContainsBlock) {
          isContainsBlock = true;
        }
      });
      setCanShowReplace(isContinuous);
      updateIsContainsBlockStep(isContainsBlock);
      updateIsParentMissing(isParentStepMissing);
    },
    [setCanShowReplace, updateIsContainsBlockStep, updateIsParentMissing]
  );
  const getAllParentSelected = (step, stepList) => stepList.filter((item) => item.id === step.parentId).length;
  const handelSelection = useCallback(
    (checked) => {
      const selectableSteps = allSteps.filter(
        (item) => !executedStepIds?.includes(item?.id)
      );
      const newSelectedSteps = checked ? selectableSteps : [];
      updateSelectedSteps(newSelectedSteps);
    },
    [allSteps, executedStepIds, updateSelectedSteps]
  );
  useEffect(() => {
    const selectableStepsCount = allSteps.filter(
      (item) => !executedStepIds?.includes(item?.id)
    ).length;
    setIsSelectAll(
      selectedSteps.length === selectableStepsCount && selectableStepsCount > 0
    );
  }, [selectedSteps, allSteps, executedStepIds]);
  useEffect(() => {
    setTimeout(() => setMounted(selectedSteps.length > 0), 100);
  }, [selectedSteps]);
  useEffect(() => {
    if (selectedSteps.length) {
      steps.map((stepItem) => {
        selectedSteps.find((selectedStep) => {
          if (selectedStep.id == stepItem.id) {
            return true;
          }
        });
      });
      getAllData(selectedSteps);
    }
    setSelection(
      totalSteps.length > selectedSteps.length ? "inter" : totalSteps.length === selectedSteps.length ? "all" : "empty"
    );
  }, [getAllData, selectedSteps, totalSteps.length, steps, afterSteps]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames82(
        "flex shadow-sm text-secondary-600 text-xs transition-height duration-[400ms] ease-out overflow-hidden shrink-0 bg-white",
        mounted ? "h-12 py-3 opacity-100" : "h-0 opacity-50",
        {
          "pl-[60px] pr-4": !isRecorder,
          "pl-[38px]": isRecorder
        }
      ),
      children: [
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: classNames82("flex flex-row flex-grow", {
              "gap-7": !isRecorder,
              "gap-3": isRecorder
            }),
            children: [
              /* @__PURE__ */ jsx(
                Checkbox,
                {
                  size: "small",
                  label: !isRecorder && t(
                    totalSteps.length > selectedSteps.length ? "Select All" : "Unselect All"
                  ),
                  checked: isSelectAll,
                  labelClassName: "!text-secondary-600 !text-xs",
                  onChange: handelSelection,
                  checkIconClassName: selection === "inter" ? "text-white text-xl" : "text-white w-auto !h-auto left-2.5 top-2.5"
                }
              ),
              /* @__PURE__ */ jsx(
                UpdateBulkSettings,
                {
                  isRecorder,
                  updateLocalState,
                  localState,
                  selectedSteps,
                  refreshStepList,
                  isHighlightFeatureEnabled,
                  isAccessibilitySupported,
                  onUpdateBulkSettings
                }
              ),
              /* @__PURE__ */ jsx(
                CreateBlockComponent,
                {
                  isRecorder,
                  isBlockModalOpen,
                  setIsBlockModalOpen,
                  selectedSteps,
                  testCaseId,
                  refreshStepList,
                  isContainsBlockStep,
                  isNotContinuous: !canShowReplace,
                  isParentMissing,
                  stepOrder
                }
              ),
              /* @__PURE__ */ jsx(
                CreateStepGroupComponent,
                {
                  isRecorder,
                  isStepGroupModalOpen,
                  setIsStepGroupModalOpen,
                  selectedSteps,
                  testCaseId,
                  refreshStepList,
                  canShowReplace,
                  isParentMissing
                }
              ),
              /* @__PURE__ */ jsx(
                BulkDeleteComponent,
                {
                  isRecorder,
                  isDeleteModalOpen,
                  setIsDeleteModalOpen,
                  selectedSteps,
                  refreshStepList
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          Button,
          {
            type: "danger-light",
            className: "mr-2",
            size: "sm",
            onClick: onExit,
            children: [
              /* @__PURE__ */ jsx(Icon, { name: "exit", className: "mr-2" }),
              "Exit Bulk Action"
            ]
          }
        )
      ]
    }
  );
};
function DirectElementCapture({
  onClose,
  onElementCaptured,
  nlpId = null,
  uuid,
  existingElement
  // Add this prop
}) {
  const { sendToBackground: sendToBackground2, sendToWidget } = useMessaging();
  const [capturedElementData, setCapturedElementData] = useState();
  const sendToBackgroundCalled = useRef(false);
  const dispatch = useDispatch();
  const { recorderState, locatedElement, appVersionId } = useSelector(
    (state) => ({
      recorderState: state.widget.recorderState,
      locatedElement: state.widget.locatedElement,
      appVersionId: state.widget.appVersionId
    })
  );
  const { isDebugger: isDebugMode } = useRecorderContext();
  const generateElementName2 = (elementData) => {
    if (existingElement?.name && !existingElement.name.includes("element")) {
      return existingElement.name;
    }
    if (elementData?.text && elementData.text.trim()) {
      return elementData.text.trim().substring(0, 50).replace(/\s+/g, " ");
    }
    if (elementData?.attrs?.placeholder) {
      return `${elementData.attrs.placeholder} field`;
    }
    if (elementData?.attrs?.type) {
      return `${elementData.attrs.type} element`;
    }
    if (elementData?.tag) {
      return `${elementData.tag} element`;
    }
    return `captured element ${Date.now()}`;
  };
  const processElementData = useCallback(
    (elementData) => {
      const processedData = {
        ...elementData,
        name: generateElementName2(elementData),
        screenTitle: elementData.screenTitle || window.location.hostname.replace("www.", ""),
        elementUuid: uuid || existingElement?.elementUuid || v4(),
        definition: getDifinitionByLocatorType(elementData)
      };
      if (!processedData.locatorType) {
        if (processedData.xPath) {
          processedData.locatorType = STEP_LOCATOR.XPATH.value;
        } else if (processedData.cssPath) {
          processedData.locatorType = STEP_LOCATOR.CSS_LOCATOR.value;
        } else if (processedData.attrs?.id) {
          processedData.locatorType = STEP_LOCATOR.ID.value;
        } else {
          processedData.locatorType = STEP_LOCATOR.XPATH.value;
        }
      }
      return processedData;
    },
    [uuid, existingElement]
  );
  useEffect(() => {
    const deregisterListener = () => {
      if (sendToBackgroundCalled.current) {
        sendToBackground2({
          context: MESSAGE_CONTEXT.ELEMENT_FINDER,
          action: MESSAGE_CONTEXT_ACTION.DEREGISTER,
          value: recorderState
        });
        sendToBackgroundCalled.current = false;
      }
    };
    if (recorderState && recorderState === RECORDER_STATE.RUNNING || isDebugMode) {
      if (!sendToBackgroundCalled.current) {
        sendToBackground2({
          context: MESSAGE_CONTEXT.ELEMENT_FINDER,
          action: MESSAGE_CONTEXT_ACTION.REGISTER,
          value: ""
        });
        sendToBackgroundCalled.current = true;
      }
    } else {
      deregisterListener();
    }
    loadElementInitialData(true);
    return deregisterListener;
  }, [recorderState, isDebugMode, sendToBackground2]);
  useEffect(() => {
    if (locatedElement?.element && !locatedElement.error) {
      const processedElementData = processElementData(locatedElement.element);
      setCapturedElementData(processedElementData);
      const getIdentifierPromise = async () => {
        if (existingElement?.id) {
          return updateIdentifier({
            ...processedElementData,
            id: existingElement.id
          });
        }
        if (existingElement?.name && appVersionId) {
          try {
            const uiData = await UiIdentifierApi.getOne({
              name: existingElement.name,
              appVersionId
            });
            const fetched = uiData?.content?.[0];
            if (fetched?.id) {
              return updateIdentifier({
                ...processedElementData,
                id: fetched.id
              });
            }
          } catch (e) {
            console.warn("Failed to fetch identifier by name", e);
          }
        }
        return createIdentifier(processedElementData);
      };
      const identifierPromise = getIdentifierPromise();
      identifierPromise.then((createdOrUpdated) => {
        if (onElementCaptured) {
          const elementToReturn = createdOrUpdated ? {
            ...processedElementData,
            id: createdOrUpdated.id,
            name: createdOrUpdated.name
          } : {
            ...processedElementData,
            id: existingElement?.id || Date.now()
          };
          onElementCaptured(elementToReturn);
        }
        onClose();
      }).catch((error) => {
        console.error("Failed to save identifier", error);
        if (onElementCaptured) {
          const fallbackElement = {
            ...processedElementData,
            id: existingElement?.id || Date.now()
          };
          onElementCaptured(fallbackElement);
        }
        onClose();
      });
      dispatch(
        setLocatedElement({
          element: void 0,
          error: ""
        })
      );
    } else if (locatedElement?.error) {
      log.error("Element capture failed:", locatedElement.error);
      onClose();
    }
  }, [
    locatedElement,
    processElementData,
    onElementCaptured,
    onClose,
    dispatch,
    existingElement,
    appVersionId
  ]);
  useEffect(() => {
    return () => {
      dispatch(
        setLocatedElement({
          element: void 0,
          error: ""
        })
      );
      sendToWidget(CUSTOM_EVENT.ELEMENT_FINDER, {});
    };
  }, [dispatch, sendToWidget]);
  return null;
}
var useElementListDrawer = (steps, openElementDrawer, versionId) => {
  const [resolver, updateResolver] = useState(NOOP);
  const [name, updateName] = useState("");
  const [type, updateType] = useState("list");
  const [nlpId, updateNlpId] = useState(null);
  const onDiscard = useCallback(
    (res) => {
      if (res) {
        resolver({ action: "SELECTED", res });
      } else {
        resolver({ action: "DISCARDED" });
      }
    },
    [resolver]
  );
  const onElementSelect = useCallback(
    (details) => {
      resolver?.({ action: "SELECTED", details });
    },
    [resolver]
  );
  const openElementForm = useCallback(
    (details) => {
      updateType("form");
      updateNlpId(details?.nlpId || null);
      if (Boolean(details?.name?.length)) {
        updateName(details.name);
      } else {
        updateName("");
      }
      return new Promise((resolve) => {
        updateResolver(() => resolve);
      });
    },
    [updateResolver]
  );
  const onCloseElementForm = useCallback(
    (details) => {
      if (!Boolean(details)) {
        resolver?.({ action: "DISCARDED" });
      } else {
        resolver?.({ action: "SELECTED", details });
      }
    },
    [resolver]
  );
  const openElementListDrawer = useCallback(
    ({ nlpId: nlpId2 = null }) => {
      return new Promise((resolve) => {
        updateType("list");
        updateResolver(() => resolve);
        updateNlpId(nlpId2);
      });
    },
    [updateResolver]
  );
  useEffect(() => {
    if (resolver && resolver !== NOOP) {
      openElementDrawer(type, name);
    }
  }, [resolver]);
  return {
    openElementListDrawer,
    openElementForm,
    onElementSelect,
    onCloseElementForm,
    onDiscard,
    nlpId
  };
};

// src/components/test-recorder/web-recorder/hooks/salesforce-actions.ts
var SalesforceActions = class {
  versionId;
  constructor(versionId) {
    this.versionId = versionId;
  }
  async fetchConnections(query) {
    try {
      return await SalesforceConnectionApi.getAll(
        `?,applicationVersionId:${this.versionId},${query ? query : ""}`
      );
    } catch (err) {
      console.error(err);
      throw err;
    }
  }
  async fetchMetadataObjects(query) {
    try {
      return await SalesforceMetadataObjectApi.getAll(
        `?,applicationVersionId:${this.versionId},${query ? query : ""}`
      );
    } catch (err) {
      console.error(err);
      throw err;
    }
  }
  async fetchApplications(query) {
    try {
      return await SalesforceApplicationApi.getAll(
        `?,applicationVersionId:${this.versionId},${query ? query : ""}`
      );
    } catch (err) {
      console.error(err);
      throw err;
    }
  }
  async fetchTabs(query) {
    try {
      return await SalesforceTabApi.getAll(
        `?,applicationVersionId:${this.versionId},${query ? query : ""}`
      );
    } catch (err) {
      console.error(err);
      throw err;
    }
  }
};
var salesforce_actions_default = SalesforceActions;
var useStepGroupDrawer = (toggleStepGroupsDrawer) => {
  const [resolver, updateResolver] = useState(
    null
  );
  const onDiscard = useCallback(() => {
    toggleStepGroupsDrawer(false);
    resolver?.({ action: "DISCARDED" });
  }, [resolver]);
  const onSelectStepGroup = useCallback(
    (details) => {
      toggleStepGroupsDrawer(false);
      resolver?.({ action: "SELECTED", details });
    },
    [resolver]
  );
  const openStepGroupsListDrawer = useCallback(
    () => new Promise((resolve) => {
      updateResolver(() => resolve);
    }),
    [updateResolver]
  );
  useEffect(() => {
    if (resolver) {
      toggleStepGroupsDrawer(true);
    }
  }, [resolver]);
  return { openStepGroupsListDrawer, onSelectStepGroup, onDiscard };
};
var useTestStepSettingsDrawer = (openStepSettingsDrawer) => {
  const [resolver, updateResolver] = useState(
    null
  );
  const [payload, updatePayload] = useState(
    null
  );
  const onDiscard = useCallback(() => {
    resolver?.({ action: "DISCARDED" });
    openStepSettingsDrawer(void 0);
    updatePayload(null);
  }, [resolver]);
  const onUpdate = useCallback(
    (testStep) => {
      resolver?.({ action: "STEP_UPDATED", testStep });
      openStepSettingsDrawer(void 0);
      updatePayload(null);
    },
    [resolver]
  );
  const openTestStepSettingsDrawer = useCallback(
    (testStep, testStepsList, _nlActions, _kibbutzActions, stepResult) => new Promise((resolve) => {
      updateResolver(() => resolve);
      updatePayload([testStep, testStepsList, stepResult]);
    }),
    [updateResolver]
  );
  useEffect(() => {
    if (resolver && payload) {
      openStepSettingsDrawer(payload[0]);
    }
  }, [resolver, payload]);
  return {
    openTestStepSettingsDrawer,
    onUpdate,
    onDiscard,
    stepResult: payload?.[2] || null
  };
};
var fetchDataParameter = (id, updateDataParameterList, updateDataSetList, term, onCompletion) => {
  DataProfileApi.getAllDataSet(id).then((res) => {
    updateDataParameterList(res);
    updateDataSetList(res);
  }).catch((error) => log.error("Failed to fetch data set list", error)).then(() => onCompletion?.());
};
var RECORDER_PER_PAGE_SIZE = STEPS_PAGE_SIZE;
var useBulkAction = (fetchPage, stepList) => {
  const [isBulkActionEnabled, setIsBulkActionEnabled] = useState(false);
  const [selectedSteps, _updateSelectedSteps] = useState([]);
  const [canRenderBulkAction, updateCanRenderBulkAction] = useState(true);
  const updateSelectedSteps = useCallback((selectedItems) => {
    _updateSelectedSteps([...selectedItems]);
  }, []);
  const handleBulkActionExit = useCallback(() => {
    updateSelectedSteps([]);
    setTimeout(() => updateCanRenderBulkAction(false), 300);
    setTimeout(() => updateCanRenderBulkAction(true), 500);
  }, [updateSelectedSteps]);
  const refreshStepList = useCallback(
    (pageNumber) => {
      const sliceStart = 0;
      const sliceEnd = pageNumber ? RECORDER_PER_PAGE_SIZE * (pageNumber - 1) : RECORDER_PER_PAGE_SIZE;
      fetchPage(
        pageNumber,
        RECORDER_PER_PAGE_SIZE,
        "",
        {
          type: "BLOCK",
          data: pageNumber ? stepList.slice(sliceStart, sliceEnd) : []
        },
        true
      );
      updateSelectedSteps([]);
    },
    [fetchPage, stepList, selectedSteps, updateSelectedSteps]
  );
  useEffect(() => {
    if (!isBulkActionEnabled) handleBulkActionExit();
  }, [isBulkActionEnabled, handleBulkActionExit]);
  useEffect(() => {
    setIsBulkActionEnabled(selectedSteps.length > 0);
  }, [selectedSteps]);
  return {
    updateSelectedSteps,
    selectedSteps,
    refreshStepList,
    isBulkActionEnabled,
    setIsBulkActionEnabled,
    handleBulkActionExit,
    canRenderBulkAction
  };
};
var useTestData = (openTestDataDrawer) => {
  const [resolver, updateResolver] = useState(
    null
  );
  const onTestDataSelect = useCallback(
    (eventName, data) => {
      if (!resolver) return;
      if (!data) {
        return;
      }
      if (eventName === TEST_DATA_RUNTIME.apiKey) {
        resolver({ selected: { text: data?.runTimeVariableName, data } });
      } else if (eventName === TEST_DATA_PHONE_NUMBER.apiKey) {
        resolver({ selected: { text: data?.phoneNumber, data } });
      } else if (eventName === TEST_DATA_ENVIRONMENT.apiKey) {
        resolver({ selected: { text: data?.text?.key, data: data?.text } });
      } else if (eventName === TEST_DATA_MAILBOX.apiKey) {
        resolver({ selected: { text: data?.email, data } });
      } else if (eventName === TEST_DATA_DATAPROFILE.apiKey) {
        resolver({ selected: { text: data?.text, data: data?.text } });
      } else if (eventName === TEST_DATA_FUNCTION.apiKey) {
        const argumentsObject = {};
        data?.function?.arguments?.forEach((argument) => {
          argumentsObject[argument.argumentName] = argument.argumentValue;
        });
        const more_details = {
          id: data?.function?.id,
          arguments: parametersToArguments(data),
          isKibbutzFunction: Boolean(data?.function?.parameters),
          testDataInfo: {
            arguments: parametersToArguments(data),
            isKibbutzFunction: Boolean(data?.function?.parameters),
            value: Boolean(data?.function?.parameters) ? data && data?.name : data && data?.name + " :: " + data?.function?.displayName,
            testDataFunctionId: data?.function?.id
          },
          testDataFunction: {
            id: data?.function?.id,
            className: data?.name,
            functionName: data?.function?.displayName,
            arguments: argumentsObject,
            hasDataMap: data?.function?.hasDataMap
          }
        };
        resolver({
          selected: {
            text: data && data?.text,
            more_details
          }
        });
      } else if (eventName === TEST_DATA_UPLOAD.apiKey) {
        resolver({ selected: { text: data?.name, data } });
      }
    },
    [resolver]
  );
  const parametersToArguments = (data) => {
    const functionData = data?.function;
    if (!functionData) {
      return;
    }
    if (functionData?.arguments) {
      functionData.arguments?.forEach((arg) => {
        delete arg.updatedAtEpoch;
        delete arg.createdAtEpoch;
        delete arg.createdDate;
        delete arg.updatedDate;
      });
      return functionData.arguments;
    }
    if (functionData.parameters) {
      const params = {};
      functionData.parameters.forEach(({ name, type, value }) => {
        params[name] = value;
      });
      return params;
    }
  };
  const handler = useCallback(
    (props) => {
      openTestDataDrawer(props);
      return new Promise((resolve) => {
        updateResolver(() => resolve);
      });
    },
    [openTestDataDrawer, updateResolver]
  );
  return { handler, onTestDataSelect };
};
var StepGroupListItem = ({
  stepGroup,
  onSelect,
  isSelected
}) => /* @__PURE__ */ jsx(
  "div",
  {
    className: `text-small text-accent font-normal leading-4 ${isSelected ? "bg-legacy-primary-20" : "hover:bg-blue-10"} cursor-pointer group relative`,
    children: /* @__PURE__ */ jsx(
      "span",
      {
        className: "w-full flex flex-row items-center",
        onClick: () => onSelect(stepGroup),
        children: /* @__PURE__ */ jsx("span", { className: "px-3 py-2 basis-full break-all border border-gray-100 border-l-0 border-solid border-y-0", children: stepGroup.name })
      }
    )
  },
  stepGroup.id?.toString()
);
var StepGroupList = ({
  stepGroups,
  onSelect,
  onPaginate,
  currentStepGroupName,
  searching
}) => {
  const stepGroupListRef = useRef(null);
  const onScroll = () => {
    const element = stepGroupListRef.current;
    if (element && element.offsetHeight + element.scrollTop >= element.scrollHeight) {
      if (onPaginate) onPaginate();
    }
  };
  return /* @__PURE__ */ jsx("div", { className: "box-border flex flex-col h-full overflow-hidden", children: /* @__PURE__ */ jsx("div", { className: "flex flex-col overflow-hidden", children: /* @__PURE__ */ jsxs(
    "div",
    {
      className: "border border-gray-100 border-solid h-full overflow-y-auto rounded-b",
      onScroll: () => onScroll(),
      ref: stepGroupListRef,
      children: [
        stepGroups.map((stepGroup) => /* @__PURE__ */ jsx(
          StepGroupListItem,
          {
            stepGroup,
            onSelect: (stepGroup2) => onSelect(stepGroup2),
            isSelected: currentStepGroupName === stepGroup.name
          },
          stepGroup.id
        )),
        stepGroups.length < 1 && /* @__PURE__ */ jsx("span", { className: "font-normal leading-4 py-8 text-accent text-center text-small block", children: searching ? "No step groups found" : /* @__PURE__ */ jsxs(React5__default.Fragment, { children: [
          "No step groups available.",
          /* @__PURE__ */ jsx("br", {}),
          "Switch to Testsigma window to create a step group."
        ] }) })
      ]
    }
  ) }) });
};
function StepGroupsBody({
  stepGroups,
  onSelect,
  onSearch,
  onPaginate,
  onRefresh,
  currentStepGroupName
}) {
  const [searchName, setSearchName] = useState("");
  const handleSearch = (name) => {
    setSearchName(name);
    onSearch(name);
  };
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col overflow-hidden p-4.5 space-y-5 h-full", children: [
    /* @__PURE__ */ jsx("div", { className: "flex flex-row items-center  h-11 gap-x-2", children: /* @__PURE__ */ jsx(
      DebouncedSearchInput,
      {
        value: searchName,
        onChange: handleSearch,
        placeholder: "Search",
        prefixIconName: "search",
        prefixIconClassName: "fill-slate-550 h-11 stroke-slate-550 w-fit pr-3.5 py-3.5 pl-3",
        wrapperClassName: "w-full"
      }
    ) }),
    /* @__PURE__ */ jsx(
      StepGroupList,
      {
        onSelect: (stepGroup) => onSelect(stepGroup),
        stepGroups,
        onPaginate: () => onPaginate(),
        onRefresh: () => onRefresh(),
        currentStepGroupName,
        searching: Boolean(searchName)
      }
    )
  ] });
}
function StepGroupsDrawer({
  onSelectStepGroup,
  onClose,
  currentStepGroupName
}) {
  const { sendToBackground: sendToBackground2 } = useMessaging();
  const [stepGroups, setStepGroups2] = useState([]);
  const [filteredStepGroups, setFilteredStepGroups] = useState([]);
  const [showFiltered, setShowFiltered] = useState(false);
  const [offset, setOffset] = useState(0);
  const [searchName, setSearchName] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  const [toastType, setToastType] = useState(
    TOAST_TYPE.SUCCESS
  );
  const { appVersionId, recorderState } = useSelector(
    (state) => state.widget
  );
  useEffect(() => {
    loadStepGroups(0, true);
    if (recorderState !== RECORDER_STATE.HOLD) {
      sendToBackground2({
        context: MESSAGE_CONTEXT.STATE,
        action: MESSAGE_CONTEXT_ACTION.UPDATE,
        value: RECORDER_STATE.HOLD
      });
    }
    return () => {
      resumeOnClose();
    };
  }, []);
  const reorderStepGroupsList = (stepGroupList) => {
    if (currentStepGroupName && stepGroupList?.length) {
      const currentStepGroup = stepGroupList.filter(
        (sg) => sg.name === currentStepGroupName
      )?.[0];
      if (currentStepGroup) {
        const reorderedUiIdentifierList = [
          currentStepGroup,
          ...stepGroupList.filter((sg) => sg.name !== currentStepGroupName)
        ];
        stepGroupList = reorderedUiIdentifierList;
      }
    }
    return stepGroupList;
  };
  useEffect(() => {
    loadStepGroups();
  }, []);
  const loadStepGroups = (pageOffset = 0, isFresh = false) => {
    if (appVersionId) {
      let param;
      TestCaseApi.getAllGroup({ offset: pageOffset, appVersionId, param }).then((stepGroupData) => {
        const stepGroupList = [
          ...isFresh ? [] : stepGroups,
          ...stepGroupData.content
        ];
        if (isFresh) {
          setStepGroups2(reorderStepGroupsList(stepGroupList));
        } else {
          setStepGroups2(stepGroupList);
        }
      }).catch((e) => {
        if (e?.status === 401) {
          showUiToast(
            "Failed to load step groups list. Please ensure third-party cookies are enabled while recording.",
            "warning"
          );
        }
      });
    }
  };
  const loadFilteredStepGroups = (pageOffset = 0, param, isFresh = false) => {
    if (appVersionId) {
      TestCaseApi.getAllGroup({ offset: pageOffset, param, appVersionId }).then(
        (stepGroupData) => {
          setFilteredStepGroups([
            ...isFresh ? [] : filteredStepGroups,
            ...stepGroupData.content
          ]);
        }
      );
    }
  };
  const handlePagination = () => {
    if (showFiltered) {
      loadFilteredStepGroups(
        offset + 1,
        searchName !== "" ? `name:*${searchName}*` : ""
      );
    } else {
      loadStepGroups(offset + 1);
    }
    setOffset(offset + 1);
  };
  const handleRefresh = () => {
    setOffset(0);
    if (showFiltered) {
      loadFilteredStepGroups(
        0,
        searchName !== "" ? `name:*${searchName}*` : "",
        true
      );
    } else {
      loadStepGroups(0, true);
    }
  };
  const searchByName = (name) => {
    if (name !== "") {
      setShowFiltered(true);
      setOffset(0);
      setFilteredStepGroups([]);
      setSearchName(name);
      loadFilteredStepGroups(offset, name !== "" ? `name:*${name}*` : "", true);
    } else {
      resetSearch();
    }
  };
  const resetSearch = () => {
    setShowFiltered(false);
    setSearchName("");
    setFilteredStepGroups([]);
    setOffset(0);
  };
  const handleClose = () => {
    resumeOnClose();
    onClose();
  };
  const handleSelectStepGroup = (stepGroup) => {
    resumeOnClose();
    onSelectStepGroup(stepGroup);
  };
  const resumeOnClose = () => {
    if (recorderState === RECORDER_STATE.RUNNING) {
      sendToBackground2({
        context: MESSAGE_CONTEXT.STATE,
        action: MESSAGE_CONTEXT_ACTION.UPDATE,
        value: RECORDER_STATE.RUNNING
      });
    }
  };
  const showUiToast = (msg, type) => {
    setShowToast(true);
    setToastMsg(msg);
    setToastType(type);
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      OverlayContainer,
      {
        onClose: () => handleClose(),
        title: "Step Groups",
        body: /* @__PURE__ */ jsx(
          StepGroupsBody,
          {
            stepGroups: showFiltered ? filteredStepGroups : stepGroups,
            onSelect: (stepGroup) => handleSelectStepGroup(stepGroup),
            onSearch: (name) => searchByName(name),
            onPaginate: () => handlePagination(),
            onRefresh: () => handleRefresh(),
            currentStepGroupName
          }
        ),
        noBodyWrapper: true
      }
    ),
    /* @__PURE__ */ jsx(
      UiToast,
      {
        isShow: showToast,
        message: toastMsg,
        type: toastType,
        onClose: () => setShowToast(false),
        noAutoHide: true
      }
    )
  ] });
}
function StepSeq({ seq }) {
  return /* @__PURE__ */ jsx(
    "span",
    {
      className: `box-border px-1.5 font-normal text-xxs text-blue-900 bg-white leading-3 rounded shadow-outline flex items-center justify-center text-center h-[18px] min-w-18`,
      children: seq
    }
  );
}
var ExtensionIcon = ({ className, onClick }) => {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      className,
      onClick,
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "inherit",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M5.91732 13.6665H3.33398C3.05621 13.6665 2.82021 13.5692 2.62598 13.3745C2.43132 13.1803 2.33398 12.9443 2.33398 12.6665V10.0832C2.78954 10.0276 3.18132 9.83876 3.50932 9.51654C3.83687 9.19431 4.00065 8.79987 4.00065 8.3332C4.00065 7.86654 3.83687 7.47209 3.50932 7.14987C3.18132 6.82765 2.78954 6.63876 2.33398 6.5832V3.99987C2.33398 3.72209 2.43132 3.48609 2.62598 3.29187C2.82021 3.0972 3.05621 2.99987 3.33398 2.99987H6.00065C6.05621 2.57765 6.23954 2.22765 6.55065 1.94987C6.86176 1.67209 7.23398 1.5332 7.66732 1.5332C8.10065 1.5332 8.47287 1.67209 8.78398 1.94987C9.0951 2.22765 9.27843 2.57765 9.33398 2.99987H12.0007C12.2784 2.99987 12.5144 3.0972 12.7087 3.29187C12.9033 3.48609 13.0007 3.72209 13.0007 3.99987V6.66654C13.4229 6.72209 13.7729 6.90543 14.0507 7.21654C14.3284 7.52765 14.4673 7.89987 14.4673 8.3332C14.4673 8.76654 14.3284 9.13876 14.0507 9.44987C13.7729 9.76098 13.4229 9.94431 13.0007 9.99987V12.6665C13.0007 12.9443 12.9033 13.1803 12.7087 13.3745C12.5144 13.5692 12.2784 13.6665 12.0007 13.6665H9.41732C9.36176 13.1888 9.16732 12.7914 8.83398 12.4745C8.50065 12.1581 8.11176 11.9999 7.66732 11.9999C7.22287 11.9999 6.83398 12.1581 6.50065 12.4745C6.16732 12.7914 5.97287 13.1888 5.91732 13.6665ZM3.33398 12.6665H5.13398C5.36732 12.0776 5.73132 11.6525 6.22598 11.3912C6.72021 11.1303 7.20065 10.9999 7.66732 10.9999C8.13398 10.9999 8.61465 11.1303 9.10932 11.3912C9.60354 11.6525 9.96732 12.0776 10.2007 12.6665H12.0007V9.0332H12.8173C13.0284 9.01098 13.1895 8.93054 13.3007 8.79187C13.4118 8.65276 13.4673 8.49987 13.4673 8.3332C13.4673 8.16654 13.4118 8.01365 13.3007 7.87454C13.1895 7.73587 13.0284 7.65543 12.8173 7.6332H12.0007V3.99987H8.36732V3.1832C8.3451 2.97209 8.26465 2.81098 8.12598 2.69987C7.98687 2.58876 7.83398 2.5332 7.66732 2.5332C7.50065 2.5332 7.34776 2.58876 7.20865 2.69987C7.06998 2.81098 6.98954 2.97209 6.96732 3.1832V3.99987H3.33398V5.8332C3.8451 6.0332 4.25065 6.36098 4.55065 6.81654C4.85065 7.27209 5.00065 7.77765 5.00065 8.3332C5.00065 8.87765 4.85065 9.37765 4.55065 9.8332C4.25065 10.2888 3.8451 10.6221 3.33398 10.8332V12.6665Z",
          fill: "inherit"
        }
      )
    }
  );
};
var ExtensionIcon_default = ExtensionIcon;
var RightArrowIcon = ({ className, onClick }) => {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      className,
      onClick,
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "inherit",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M4.76563 14.068C4.59896 13.9013 4.51563 13.704 4.51563 13.476C4.51563 13.2484 4.59896 13.0513 4.76563 12.8846L9.64896 8.0013L4.74896 3.1013C4.5934 2.94575 4.51562 2.7513 4.51562 2.51797C4.51562 2.28464 4.59896 2.08464 4.76562 1.91797C4.93229 1.7513 5.12963 1.66797 5.35763 1.66797C5.58518 1.66797 5.78229 1.7513 5.94896 1.91797L11.549 7.53464C11.6156 7.6013 11.663 7.67352 11.691 7.7513C11.7185 7.82908 11.7323 7.91241 11.7323 8.0013C11.7323 8.09019 11.7185 8.17352 11.691 8.2513C11.663 8.32908 11.6156 8.4013 11.549 8.46797L5.93229 14.0846C5.77674 14.2402 5.58518 14.318 5.35763 14.318C5.12963 14.318 4.93229 14.2346 4.76563 14.068Z",
          fill: "inherit"
        }
      )
    }
  );
};
var RightArrowIcon_default = RightArrowIcon;
var StepIdentifier = ({
  step,
  isSelected
}) => {
  const stepIdentifiers = [];
  if (step.conditionType === STEP_CONDITION_TYPE.IF) {
    stepIdentifiers.push(
      /* @__PURE__ */ jsx("span", { className: "step-type-lable shrink-0 mr-1.5", children: "IF" })
    );
  }
  if (step.conditionType === STEP_CONDITION_TYPE.ELSE_IF) {
    stepIdentifiers.push(
      /* @__PURE__ */ jsx("span", { className: "step-type-lable shrink-0 mr-1.5", children: "ELSE IF" })
    );
  }
  if (step.conditionType === STEP_CONDITION_TYPE.ELSE) {
    stepIdentifiers.push(
      /* @__PURE__ */ jsx("span", { className: "step-type-lable shrink-0 mr-1.5", children: "ELSE" })
    );
  }
  if (step.subType && step.subType === TestStepType.WHILE_LOOP) {
    stepIdentifiers.push(
      /* @__PURE__ */ jsx("span", { className: "step-type-lable shrink-0 mr-1.5", children: "WHILE" })
    );
  }
  if (step.subType === TestStepType.FOR_LOOP || step.conditionType === STEP_CONDITION_TYPE.LOOP_FOR) {
    stepIdentifiers.push(
      /* @__PURE__ */ jsx("span", { className: "step-type-lable shrink-0 mr-1.5", children: "FOR" })
    );
  }
  if (step.type === TestStepType.BREAK_LOOP) {
    stepIdentifiers.push(
      /* @__PURE__ */ jsx("span", { className: "step-type-lable shrink-0 mr-1.5", children: "BREAK LOOP" })
    );
  }
  if (step.type === TestStepType.CONTINUE_LOOP) {
    stepIdentifiers.push(
      /* @__PURE__ */ jsx("span", { className: "step-type-lable shrink-0 mr-1.5", children: "CONTINUE LOOP" })
    );
  }
  if (step.type === TestStepType.REST_STEP || step.type === TestStepType.API_STEP) {
    stepIdentifiers.push(
      /* @__PURE__ */ jsx("span", { className: "step-type-lable shrink-0 mr-1.5", children: "REST API" })
    );
  }
  if (step.type === TestStepType.BLOCK) {
    stepIdentifiers.push(
      /* @__PURE__ */ jsx("span", { className: "step-type-lable shrink-0 mr-1.5", children: "BLOCK" })
    );
  }
  if (step.type === TestStepType.STEP_GROUP) {
    stepIdentifiers.push(
      /* @__PURE__ */ jsx("span", { className: "step-type-lable shrink-0 mr-1.5", children: "STEP GROUP" })
    );
  }
  if (step.type === TestStepType.SOQL) {
    stepIdentifiers.push(
      /* @__PURE__ */ jsx("span", { className: "step-type-lable shrink-0 mr-1.5", children: "SOQL" })
    );
  }
  if (step.kibbutzPluginNlpId)
    stepIdentifiers.push(
      /* @__PURE__ */ jsx("span", { className: "relative items-center mr-5.5", children: /* @__PURE__ */ jsx(ExtensionIcon_default, { className: "h-5 w-fit fill-gray-600 shrink-0 absolute" }) })
    );
  return /* @__PURE__ */ jsx(Fragment, { children: stepIdentifiers });
};
var FormattedStepText = ({
  stepData,
  showStepGroupSteps,
  toggleStepGroup,
  wrapStepText,
  toggleBlockStep,
  showBlockSteps,
  isStaticView,
  readOnly,
  executionStatusValue,
  executionResult
}) => {
  const { stepGroups, dataProfiles, templates, addonTemplates } = useSelector(
    (state) => state.widget
  );
  switch (stepData.type) {
    case TestStepType.NLP_TEXT:
      let template = void 0;
      if (stepData.kibbutzPluginNlpId) {
        template = addonTemplates.find(
          ({ id }) => id === stepData.kibbutzPluginNlpId
        );
      } else {
        template = templates.find(({ id }) => id === stepData.templateId);
      }
      return /* @__PURE__ */ jsxs("span", { children: [
        /* @__PURE__ */ jsx(StepIdentifier, { step: stepData }),
        /* @__PURE__ */ jsx(
          "span",
          {
            className: `text-small text-slate-800 leading-4.5 self-center break-words${wrapStepText ? " truncate" : ""}`,
            dangerouslySetInnerHTML: {
              __html: getHighlightedStepAction({
                step: stepData,
                template,
                isStaticView,
                dataProfiles
              })
            }
          }
        )
      ] });
    case TestStepType.STEP_GROUP:
      return /* @__PURE__ */ jsxs("span", { children: [
        /* @__PURE__ */ jsx(StepIdentifier, { step: stepData }),
        /* @__PURE__ */ jsx(
          "span",
          {
            className: "text-small text-slate-800 leading-4.5 self-center break-words",
            children: stepGroups.find(({ id }) => id === stepData.testComponentId)?.name
          }
        )
      ] });
    case TestStepType.FOR_LOOP:
      const forLoopData = stepData.dataMap.forLoop;
      const dataProfile = dataProfiles.find(
        ({ id }) => id === forLoopData.testDataId
      );
      if (dataProfile) {
        const loopStart = forLoopData.loopStart < 0 ? FOR_LOOP_STEP.LOOP_START.label : forLoopData.loopStart;
        const loopEnd = forLoopData.loopEnd < 0 ? FOR_LOOP_STEP.LOOP_END.label : forLoopData.loopEnd;
        return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx("span", { className: "text-small text-slate-800 flex items-center gap-x-1 leading-4", children: /* @__PURE__ */ jsx(
          "span",
          {
            dangerouslySetInnerHTML: {
              __html: getFormattedForLoopStep(
                dataProfile?.testDataName,
                loopStart,
                loopEnd
              )
            }
          }
        ) }) });
      }
      return /* @__PURE__ */ jsx(Fragment, {});
    case TestStepType.REST_STEP:
    case TestStepType.API_STEP:
      return /* @__PURE__ */ jsxs("span", { children: [
        /* @__PURE__ */ jsx(StepIdentifier, { step: stepData }),
        /* @__PURE__ */ jsx("span", { className: "text-small text-slate-800 space-x-2 break-all", children: stepData.action })
      ] });
    case TestStepType.SOQL:
      return /* @__PURE__ */ jsxs("span", { children: [
        /* @__PURE__ */ jsx(StepIdentifier, { step: stepData }),
        /* @__PURE__ */ jsx("span", { className: "text-small text-slate-800 space-x-2 break-all", children: stepData.action })
      ] });
    case TestStepType.BLOCK:
      return /* @__PURE__ */ jsxs("span", { style: { marginLeft: "0" }, children: [
        /* @__PURE__ */ jsx("span", { className: "relative items-center mr-5.5", children: /* @__PURE__ */ jsx(
          UiTooltip,
          {
            title: !executionStatusValue ? showBlockSteps ? "Close steps" : "Show steps" : "",
            className: "absolute flex left-0 -top-0.5 cursor-pointer",
            onClick: () => stepData?.id && toggleBlockStep && !executionStatusValue && toggleBlockStep(stepData.id),
            children: /* @__PURE__ */ jsx(
              RightArrowIcon_default,
              {
                className: `h-4 w-fit fill-slate-700 ${(showBlockSteps || executionStatusValue) && "rotate-90"} ease-in`
              }
            )
          }
        ) }),
        /* @__PURE__ */ jsx(StepIdentifier, { step: stepData }),
        /* @__PURE__ */ jsx(
          "span",
          {
            className: "text-small text-slate-800 leading-4.5 self-center break-words",
            children: stepData.action
          }
        )
      ] });
    default:
      return /* @__PURE__ */ jsx(StepIdentifier, { step: stepData });
  }
};
var FormattedStepText_default = FormattedStepText;
var CheckBoxOutlineIcon = ({ className, onClick }) => {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      className,
      onClick,
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      fill: "inherit",
      stroke: "inherit",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "rect",
        {
          x: "0.5",
          y: "0.5",
          width: "17",
          height: "17",
          rx: "3.5",
          fill: "inherit",
          stroke: "inherit"
        }
      )
    }
  );
};
var CheckBoxOutlineIcon_default = CheckBoxOutlineIcon;
var CheckedCheckboxIcon = ({ className, onClick }) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      className,
      onClick,
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      fill: "inherit",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "rect",
          {
            x: "0.5",
            y: "0.5",
            width: "17",
            height: "17",
            rx: "3.5",
            fill: "#03A973",
            stroke: "#03A973"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M15.2587 3.67586C14.7073 3.226 13.9001 3.28726 13.423 3.81516L7.32231 10.5652L4.31902 7.707C3.84599 7.25682 3.10295 7.25695 2.63008 7.7073C2.12331 8.18995 2.12331 8.99838 2.63008 9.48103L7.61639 14.2299L15.4054 5.60632C15.9177 5.03927 15.8506 4.15894 15.2587 3.67586Z",
            fill: "inherit"
          }
        )
      ]
    }
  );
};
var CheckedCheckboxIcon_default = CheckedCheckboxIcon;
var theme = createTheme({
  components: {
    MuiCheckbox: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          ...ownerState.color === "primary" && {
            ":checked": {
              color: COLOR.PRIMARY
            }
          },
          ...ownerState.color === "secondary" && {
            ":checked": {
              color: COLOR.SECONDARY
            }
          }
        })
      }
    }
  }
});
function UiCheckbox({
  label,
  onChange,
  isChecked,
  isDisabled,
  color,
  customClass,
  size: size2
}) {
  return /* @__PURE__ */ jsx(FormGroup, { children: /* @__PURE__ */ jsx(
    FormControlLabel,
    {
      disabled: isDisabled,
      control: /* @__PURE__ */ jsx(ThemeProvider, { theme, children: /* @__PURE__ */ jsx(
        Checkbox$1,
        {
          color,
          disabled: isDisabled,
          onChange: (e) => onChange(e.target.checked),
          checked: isChecked,
          className: customClass,
          size: size2,
          icon: /* @__PURE__ */ jsx(CheckBoxOutlineIcon_default, { className: "stroke-gray-300 fill-white !ml-0" }),
          checkedIcon: /* @__PURE__ */ jsx(CheckedCheckboxIcon_default, { className: "stroke-legacy-primary-90 fill-white !ml-0" })
        }
      ) }),
      label,
      className: customClass
    }
  ) });
}
function UiSelect({
  value,
  label,
  onChange,
  items,
  isDisabled,
  className,
  variant = "standard",
  style: style2,
  listItemClass
}) {
  return /* @__PURE__ */ jsxs(
    FormControl,
    {
      variant,
      sx: { m: 1, minWidth: 120 },
      className,
      style: style2,
      children: [
        label && /* @__PURE__ */ jsx(InputLabel, { id: "ui-select-label", children: label }),
        /* @__PURE__ */ jsx(
          Select,
          {
            labelId: "ui-select-label",
            value,
            label,
            onChange: (event) => onChange(event.target.value),
            size: "medium",
            disabled: isDisabled,
            className: "TsMuiSelect-select",
            children: items.map(({ key, value: value2, label: label2 }) => /* @__PURE__ */ jsx(MenuItem, { value: value2, className: listItemClass, children: label2 }, key))
          }
        )
      ]
    }
  );
}
var testStepScreenshotOptions = [
  {
    key: StepLevelScreenshot.ALWAYS,
    label: `Always`,
    value: StepLevelScreenshot.ALWAYS
  },
  {
    key: StepLevelScreenshot.STEP_FAILURE,
    label: `Only on step failure`,
    value: StepLevelScreenshot.STEP_FAILURE
  }
];
function StepSettingBody({
  data,
  isReadOnly,
  step,
  onChange,
  isHighlightFeatureEnabled,
  isAccessibilitySupported
}) {
  const { testSteps, stepGroups, dataProfiles, appType, recorderSource } = useSelector((state) => state.widget);
  const { activeStepType } = useSelector(
    (state) => state.stepCreator
  );
  useTenantInfo();
  const stepType = step?.subType || step?.type || activeStepType;
  const getNamedStep = (_step) => {
    let value = _step.action;
    switch (_step.type) {
      case STEP_TYPE.STEP_GROUP:
        value = `${stepGroups.find(({ id }) => id === _step.testComponentId)?.name}`;
        break;
      case STEP_TYPE.FOR_LOOP:
        const stepDataProfile = dataProfiles.find(
          ({ id }) => _step.dataMap.forLoop.testDataId === id
        );
        if (stepDataProfile) {
          const loopStart = _step.dataMap.forLoop.loopStart < 0 ? FOR_LOOP_STEP.LOOP_START.label : _step.dataMap.forLoop.loopStart;
          const loopEnd = _step.dataMap.forLoop.loopStart < 0 ? FOR_LOOP_STEP.LOOP_END.label : _step.dataMap.forLoop.loopEnd;
          value = getFormattedForLoopStep(
            stepDataProfile.testDataName,
            loopStart,
            loopEnd,
            false
          );
        }
        break;
    }
    const stepActionText = /* @__PURE__ */ jsx(FormattedStepText_default, { stepData: _step, wrapStepText: true });
    if (value) {
      return {
        label: /* @__PURE__ */ jsxs("div", { className: "flex items-center space-x-2 w-full", children: [
          /* @__PURE__ */ jsx("span", { className: "text-blue-900 bg-white shadow-outline box-border flex items-center justify-center min-w-20 px-1.5 rounded", children: _step.stepNumber }),
          stepActionText
        ] }),
        key: _step.id,
        value
      };
    }
  };
  const getNamedSteps = (steps) => {
    const namedSteps = [];
    steps.forEach((_step) => {
      const namedStepData = getNamedStep(_step);
      if (namedStepData) namedSteps.push(namedStepData);
    });
    return namedSteps;
  };
  const getPreRequisiteSteps = () => {
    let eligibleSteps = testSteps;
    if (step) {
      eligibleSteps = testSteps.filter((stepItem, ind) => {
        return (stepItem?.stepOrder || ind) < (step?.stepOrder || testSteps.length) && !stepItem.disabled && !(stepItem.type == STEP_TYPE.WHILE_LOOP) && !(stepItem.type == STEP_TYPE.BLOCK);
      });
    }
    return [
      { key: "none", value: "None", label: /* @__PURE__ */ jsx(Fragment, { children: "None" }) },
      ...getNamedSteps(eligibleSteps)
    ];
  };
  const preRequisuteStepItem = step?.preRequisiteStep ? getNamedStep(step.preRequisiteStep) : void 0;
  const activePreRequisite = preRequisuteStepItem?.value ? preRequisuteStepItem.value || "" : data.preRequisiteStepId ? getNamedSteps(testSteps).find(
    (_step) => _step.key === data.preRequisiteStepId
  )?.value || "" : "None";
  const handlePreRequisiteChange = (value) => {
    if (onChange)
      onChange(
        STEP_FLAG.PRE_REQUISITE.API_KEY,
        getNamedSteps(testSteps).find((_step) => _step.value === value)?.key || null
      );
  };
  const handleStepExecutionChange = (apiKey, value) => {
    switch (apiKey) {
      case STEP_FLAG.PRIORITY.API_KEY:
        if (data.priority === STEP_PRIORITY.MAJOR && !value) {
          onChange(apiKey, STEP_PRIORITY.MINOR);
          return;
        }
        onChange(apiKey, value ? STEP_PRIORITY.MAJOR : STEP_PRIORITY.MINOR);
        onChange(STEP_FLAG.IGNORE_STEP_RESULT.API_KEY, !value);
        break;
      case STEP_FLAG.IGNORE_STEP_RESULT.API_KEY:
        if (data.ignoreStepResult && !value) {
          onChange(apiKey, value);
        }
        onChange(apiKey, value);
        onChange(
          STEP_FLAG.PRIORITY.API_KEY,
          value ? STEP_PRIORITY.MINOR : STEP_PRIORITY.MAJOR
        );
        break;
    }
  };
  const showHighlightElementCheckbox = useMemo(
    () => appType == RECORDER_APPLICATION_TYPE.WEB && isHighlightFeatureEnabled && !isStepAddon(step) && hasStepValidXpath(step),
    [appType, isHighlightFeatureEnabled, step]
  );
  const isAccessibilityTestingEnabled = () => {
    return step.type !== STEP_TYPE.STEP_GROUP && step.type !== STEP_TYPE.API_STEP && step.type !== STEP_TYPE.CUSTOM_FUNCTION && !(step.conditionType === TestStepConditionType.LOOP_WHILE || step.conditionType === TestStepConditionType.LOOP_FOR) && isAccessibilitySupported;
  };
  const maxTimeHasError = useMemo(
    () => data.waitTime === null || data.waitTime?.toString() === "" || Number(data.waitTime) > 120 || Number(data.waitTime) < 0 || String(data.waitTime).includes("."),
    [data.waitTime]
  );
  const maxIterationError = useMemo(
    () => data.maxIterations != null && (data.maxIterations?.toString() === "" || Number(data.maxIterations) > 100 || Number(data.maxIterations) < 0 || String(data.maxIterations).includes(".")),
    [data.maxIterations]
  );
  const maxRetriesError = useMemo(
    () => data.maxRetries === null || data.maxRetries > 10 || data.maxRetries?.toString() === "" || data.maxRetries < 0 || String(data.maxRetries).includes("."),
    [data.maxRetries]
  );
  return /* @__PURE__ */ jsxs("div", { className: "py-5", children: [
    step && step.stepNumber && /* @__PURE__ */ jsxs("div", { className: "flex items-center space-x-2 w-full border-b border-solid border-x-0 border-t-0 border-gray-100 pb-5", children: [
      /* @__PURE__ */ jsx(StepSeq, { seq: step.stepNumber }),
      /* @__PURE__ */ jsx(FormattedStepText_default, { stepData: step, isStaticView: true })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "mt-3", children: [
      /* @__PURE__ */ jsx(
        UiSelect,
        {
          items: preRequisuteStepItem ? [preRequisuteStepItem] : getPreRequisiteSteps(),
          label: "Prerequisite Step",
          onChange: (value) => handlePreRequisiteChange(value),
          value: activePreRequisite,
          isDisabled: isReadOnly,
          className: "w-full",
          variant: "outlined"
        }
      ),
      /* @__PURE__ */ jsx(Divider, { type: "solid", className: "!mt-6 !-mb-2 !text-neutral-100" }),
      step && stepType !== STEP_TYPE.FOR_LOOP && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          InputWithCheckbox,
          {
            label: STEP_FLAG.WAIT_TIME.LABEL,
            value: data.waitTime,
            updateValue: (waitTime) => onChange(STEP_FLAG.WAIT_TIME.API_KEY, waitTime),
            wrapperClassName: "flex mt-4",
            errorLabel: "Step Timeout should be less than or equal to 120",
            hasError: maxTimeHasError,
            defaultValue: null,
            isDisabled: isReadOnly,
            isCheckBoxDisabled: true,
            isChecked: true,
            checkBoxClassName: "!h-[18px] !w-[18px]",
            suffix: /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx("div", { className: "text-[#94A3B8] ml-1 text-sm", children: "secs." }),
              /* @__PURE__ */ jsx("div", { className: "text-[#94A3B8] ml-28 text-sm", children: "( <=120 seconds )" })
            ] })
          }
        ),
        /* @__PURE__ */ jsx(Divider, { type: "solid", className: "!mb-4 !mt-3 !text-neutral-100" })
      ] }),
      /* @__PURE__ */ jsx(
        ScreenshotCapture,
        {
          onSelect: (value) => onChange(STEP_FLAG.SCREENSHOT_CAPTURE.API_KEY, value),
          options: testStepScreenshotOptions,
          selectedOption: data.stepLevelScreenshot,
          isDisabled: isReadOnly,
          wrapperClassName: "mt-4",
          checkBoxClassName: "!h-[18px] !w-[18px]",
          customLabel: STEP_FLAG.SCREENSHOT_CAPTURE.LABEL
        }
      ),
      /* @__PURE__ */ jsx(Divider, { type: "solid", className: "!mt-5 !mb-0 !text-neutral-100" }),
      step && (stepType === STEP_TYPE.WHILE_LOOP || step.conditionType === STEP_CONDITION_TYPE.LOOP_WHILE) && recorderSource === RECORDER_SOURCE.CLOUD && /* @__PURE__ */ jsx(
        InputWithCheckbox,
        {
          label: STEP_FLAG.MAX_ITERATION.LABEL,
          value: data.maxIterations === null ? "" : data.maxIterations,
          updateValue: (maxIteration) => onChange(STEP_FLAG.MAX_ITERATION.API_KEY, maxIteration),
          errorLabel: "Enter valid maximum iterations (1 to 100)",
          hasError: maxIterationError,
          defaultValue: null,
          isChecked: data.maxIterations !== null && data.maxIterations !== void 0,
          checkBoxClassName: "!h-[18px] !w-[18px]",
          wrapperClassName: "mt-6 flex"
        }
      )
    ] }),
    (stepType == STEP_TYPE.NLP_TEXT || isKibbutzStep(step) || stepType == STEP_TYPE.API_STEP) && !(stepType === STEP_TYPE.WHILE_LOOP || step.conditionType === STEP_CONDITION_TYPE.LOOP_WHILE) && /* @__PURE__ */ jsx(
      InputWithCheckbox,
      {
        label: STEP_FLAG.MAX_RETRIES.LABEL,
        value: data.maxRetries,
        updateValue: (maxRetries) => onChange(STEP_FLAG.MAX_RETRIES.API_KEY, maxRetries),
        errorLabel: "Maximum retries allowed is 10",
        hasError: maxRetriesError,
        defaultValue: "0",
        wrapperClassName: "mt-3",
        isChecked: data.maxRetries !== null && data.maxRetries !== void 0,
        checkBoxClassName: "!h-[18px] !w-[18px]"
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: "!space-y-6 mt-3", children: [
      step && !isConditionalTestStepType(stepType) && /* @__PURE__ */ jsx(
        UiCheckbox,
        {
          label: /* @__PURE__ */ jsx("span", { className: "text-neutral-800 text-xs", children: STEP_FLAG.STOP_TEST_EXECUTION.LABEL }),
          onChange: (state) => handleStepExecutionChange(STEP_FLAG.PRIORITY.API_KEY, state),
          isChecked: data.priority === STEP_PRIORITY.MAJOR,
          isDisabled: isReadOnly,
          color: "primary",
          customClass: "padding-0 margin-0 space-x-3"
        }
      ),
      /* @__PURE__ */ jsx(
        UiCheckbox,
        {
          label: /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(
              UiTooltip,
              {
                title: step && isConditionalTestStepType(stepType) ? "The Test Step with Conditional Type is Enabled by Default" : "",
                className: "inline-flex",
                children: /* @__PURE__ */ jsx("span", { className: "text-neutral-800 text-xs", children: STEP_FLAG.IGNORE_STEP_RESULT.LABEL })
              }
            ),
            /* @__PURE__ */ jsx(
              UiTooltip,
              {
                title: "Ignore step result option will automatically marks the Test step as MINOR step",
                className: "inline-flex",
                children: /* @__PURE__ */ jsx(FaInfoCircle, { className: "text-gray-500" })
              }
            )
          ] }),
          onChange: (state) => handleStepExecutionChange(
            STEP_FLAG.IGNORE_STEP_RESULT.API_KEY,
            state
          ),
          isChecked: !!data.ignoreStepResult,
          isDisabled: step && isConditionalTestStepType(stepType) || isReadOnly,
          customClass: "padding-0 margin-0 space-x-3"
        }
      ),
      /* @__PURE__ */ jsx(
        UiCheckbox,
        {
          label: /* @__PURE__ */ jsx("span", { className: "text-neutral-800 text-xs", children: STEP_FLAG.VISUAL_TESTING.LABEL }),
          onChange: (state) => onChange(STEP_FLAG.VISUAL_TESTING.API_KEY, state),
          isChecked: data.visualEnabled,
          isDisabled: isReadOnly,
          customClass: "padding-0 margin-0 space-x-3"
        }
      ),
      /* @__PURE__ */ jsx(
        UiCheckbox,
        {
          label: /* @__PURE__ */ jsx("span", { className: "text-neutral-800 text-xs", children: STEP_FLAG.DISABLED.LABEL }),
          onChange: (state) => onChange(STEP_FLAG.DISABLED.API_KEY, state),
          isChecked: data.disabled,
          isDisabled: isReadOnly,
          customClass: "padding-0 margin-0 space-x-3"
        }
      ),
      showHighlightElementCheckbox && /* @__PURE__ */ jsx(
        UiCheckbox,
        {
          label: /* @__PURE__ */ jsx("span", { className: "text-neutral-800 text-xs", children: STEP_FLAG.HIGHLIGHT_ELEMENT.LABEL }),
          onChange: (state) => onChange(STEP_FLAG.HIGHLIGHT_ELEMENT.API_KEY, state),
          isChecked: step?.stepDetail?.highlightElement,
          isDisabled: isReadOnly,
          customClass: "padding-0 margin-0 space-x-3"
        }
      ),
      isAccessibilityTestingEnabled() && /* @__PURE__ */ jsx(
        UiCheckbox,
        {
          label: /* @__PURE__ */ jsx("span", { className: "text-neutral-800 text-xs", children: STEP_FLAG.ACCESSIBILITY_TESTING.LABEL }),
          onChange: (state) => onChange(STEP_FLAG.ACCESSIBILITY_TESTING.API_KEY, state),
          isChecked: data.accessibilityEnabled,
          isDisabled: isReadOnly,
          customClass: "padding-0 margin-0 space-x-3"
        }
      )
    ] })
  ] });
}
function StepSetting({
  stepSetting,
  onClose,
  updateStep: updateStep3,
  isHighlightFeatureEnabled,
  isAccessibilitySupported
}) {
  const [isValid, setIsValid] = useState(true);
  const [step, setStep] = useState(stepSetting);
  const { isDebugger } = useRecorderContext();
  const handleChange = (apiKey, value) => {
    const hasError = value === null || value.toString() === "" || String(value).includes(".");
    if (STEP_FLAG.WAIT_TIME.API_KEY === apiKey) {
      setIsValid(Number(value) <= STEP_FLAG.WAIT_TIME.LIMIT && !hasError);
      if (Number(value) > STEP_FLAG.WAIT_TIME.LIMIT) {
        return;
      }
    } else if (STEP_FLAG.MAX_ITERATION.API_KEY === apiKey) {
      setIsValid(Number(value) <= STEP_FLAG.MAX_ITERATION.LIMIT);
      if (Number(value) > STEP_FLAG.MAX_ITERATION.LIMIT) {
        return;
      }
    } else if (STEP_FLAG.MAX_RETRIES.API_KEY === apiKey) {
      setIsValid(Number(value) <= STEP_FLAG.MAX_RETRIES.LIMIT && !hasError);
      if (Number(value) > STEP_FLAG.MAX_RETRIES.LIMIT) {
        return;
      }
    }
    let updatedValue = value;
    if ([
      STEP_FLAG.WAIT_TIME.API_KEY,
      STEP_FLAG.MAX_ITERATION.API_KEY,
      STEP_FLAG.MAX_RETRIES.API_KEY
    ]?.includes(apiKey)) {
      updatedValue = value?.toString()?.trim().replaceAll(/[^\d]/g, "") ? Number(value?.toString().replaceAll(/[^\d]/g, "")) : null;
    }
    if (STEP_FLAG.HIGHLIGHT_ELEMENT.API_KEY === apiKey) {
      step.stepDetail = {
        ...step.stepDetail,
        [apiKey]: updatedValue
      };
    } else {
      step[apiKey] = updatedValue;
    }
    setStep({ ...step });
  };
  const handleClose = () => {
    if (onClose) onClose();
  };
  useEffect(() => {
    if (stepSetting) {
      setStep({ ...stepSetting });
    }
  }, [stepSetting]);
  const saveButton = /* @__PURE__ */ jsx(
    UiButton,
    {
      onClick: () => updateStep3(step),
      color: "primary",
      isDisabled: !isValid,
      variant: "contained",
      children: /* @__PURE__ */ jsx(Fragment, { children: "Save" })
    }
  );
  const cancelButton = /* @__PURE__ */ jsx(
    UiButton,
    {
      onClick: () => handleClose(),
      color: "secondary",
      isDisabled: !isValid,
      variant: "outlined",
      children: /* @__PURE__ */ jsx(Fragment, { children: "Cancel" })
    }
  );
  return /* @__PURE__ */ jsx(
    OverlayContainer,
    {
      title: "Step Details",
      onClose: () => handleClose(),
      isFixedFooter: true,
      body: /* @__PURE__ */ jsx(
        StepSettingBody,
        {
          step,
          data: step,
          onChange: (apiKey, value) => handleChange(apiKey, value),
          isReadOnly: false,
          isHighlightFeatureEnabled,
          isAccessibilitySupported
        }
      ),
      footer: /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
        "div",
        {
          className: `flex w-full space-x-3 ${isDebugger ? "justify-start" : "justify-end"}`,
          children: isDebugger ? /* @__PURE__ */ jsxs(Fragment, { children: [
            saveButton,
            cancelButton
          ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
            cancelButton,
            saveButton
          ] })
        }
      ) })
    }
  );
}
var getDefaultPageable = () => new Pageable().deserialize({ pageNumber: 0 });
function EnvironmentComponent({ onSelect }) {
  const [isFetching, updateIsFetching] = useState(false);
  const [variables, setVariables] = useState([]);
  const [pageable, setPageable] = useState(getDefaultPageable());
  const [totalPages, setTotalPages] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const { isDebugger: isDebugMode } = useRecorderContext();
  const { projectId } = useSelector((state) => state.widget);
  useEffect(() => {
    if (!isFetching) getVariables2();
  }, [pageable]);
  useEffect(() => {
    setVariables([]);
    setPageable(getDefaultPageable());
  }, [searchTerm]);
  const getVariables2 = () => {
    if (projectId) {
      updateIsFetching(true);
      EnvironmentApi.getVariables(projectId, pageable.pageNumber, searchTerm).then(({ content, totalPages: totalPages2 }) => {
        if (!content?.length && !searchTerm) {
          toastify("There are no Variables created", {
            type: "warning"
          });
        } else {
          setVariables([...variables, ...content]);
          setTotalPages(totalPages2);
        }
      }).catch(() => {
        toastify("Failed to get variables", {
          type: "error"
        });
      }).finally(() => {
        updateIsFetching(false);
      });
    }
  };
  const hasMore = () => pageable.pageNumber < totalPages - 1;
  const loadMore = () => {
    if (!hasMore()) return;
    const newPage = new Pageable();
    newPage.pageNumber = pageable.pageNumber + 1;
    setPageable(newPage);
  };
  const createVariable = (newVariable, onSuccess) => {
    const payload = [{ ...newVariable, projectId }];
    EnvironmentApi.updateVariables(projectId, payload).then(() => {
      toastify("Variable created successfully", {
        type: "success"
      });
      setSearchTerm("");
      onSuccess();
    }).catch(() => {
      toastify("Failed to create variable", {
        type: "error"
      });
    });
  };
  return /* @__PURE__ */ jsx("div", { className: classNames82("h-full", { "p-6": !isDebugMode }), children: /* @__PURE__ */ jsx(
    EnvironmentValueSelector,
    {
      variables,
      onClick: onSelect,
      isFetching,
      setSearchTerm,
      hasMore: hasMore(),
      handleLoadMore: loadMore,
      createVariable,
      searchTerm,
      isRecorder: true
    }
  ) });
}
function UiTextField({
  label,
  value,
  onChange,
  isDisabled,
  autoFocus,
  variant = "standard",
  placeholder,
  inputProps,
  error = false,
  helperText = "",
  required = false
}) {
  const numberInputOnWheelPreventChange = (e) => {
    e.target.blur();
    e.stopPropagation();
    setTimeout(() => {
      e.target.focus();
    }, 0);
  };
  return /* @__PURE__ */ jsx(
    TextField,
    {
      label,
      variant,
      value,
      onInput: (event) => onChange(event.target.value),
      size: "small",
      className: "w-full",
      disabled: isDisabled,
      autoFocus,
      placeholder,
      InputProps: inputProps,
      error,
      helperText,
      required,
      onWheel: numberInputOnWheelPreventChange
    }
  );
}
function FunctionValue({
  func,
  onClose,
  onSubmitFuncArg
}) {
  const [argInput, setArgInput] = useState({});
  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [mailboxes, setMailboxes] = useState([]);
  const onInputArg = (value, arg) => {
    argInput[arg] = value;
    setArgInput({ ...argInput });
  };
  const funcName = () => func.displayName ? func.displayName : `${func.classDisplayName} :: ${func.name}`;
  const loadPhoneNumbers = () => {
    PhoneNumberApi.getAll().then((phoneNumberData) => {
      setPhoneNumbers(phoneNumberData.content);
    });
  };
  const loadMailboxes = () => {
    MailboxApi.getAll().then((mailboxesData) => {
      setMailboxes(mailboxesData.content);
    });
  };
  const onSubmit = () => {
    if (func?.arguments) {
      func.arguments?.forEach((arg) => {
        arg.argumentValue = argInput[arg.argumentName];
      });
    }
    if (func?.parameters) {
      func.parameters?.forEach((param) => {
        param.value = argInput[param.name];
      });
    }
    onSubmitFuncArg(func);
  };
  useEffect(() => {
    func.arguments?.forEach((arg) => {
      if (arg.argumentDisplayName === "phoneNumber") {
        loadPhoneNumbers();
      } else if (arg.argumentDisplayName === "mailBox") {
        loadMailboxes();
      }
      onInputArg(arg.argumentName, arg.argumentValue);
    });
  }, []);
  return /* @__PURE__ */ jsxs("div", { className: "px-3", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center h-12 gap-x-1.5", children: [
      /* @__PURE__ */ jsx(
        AiOutlineArrowLeft,
        {
          className: "text-lg cursor-pointer",
          onClick: () => onClose()
        }
      ),
      /* @__PURE__ */ jsx("span", { className: "font-bold", children: funcName() })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-2 gap-4 mb-4", children: [
      func.arguments && func.arguments.map((arg) => /* @__PURE__ */ jsx(Fragment, { children: arg.argumentDisplayName === "phoneNumber" ? /* @__PURE__ */ jsx(
        UiSelect,
        {
          items: phoneNumbers.map((phoneNumber) => ({
            key: phoneNumber.id,
            value: phoneNumber.phoneNumber,
            label: phoneNumber.phoneNumber
          })),
          onChange: (value) => onInputArg(value, arg.argumentName),
          value: phoneNumbers[0]?.phoneNumber,
          label: "Phonenumber",
          variant: "outlined",
          className: "my-1.5 w-full",
          listItemClass: "test-data-container"
        }
      ) : arg.argumentDisplayName === "mailBox" ? /* @__PURE__ */ jsx(
        UiSelect,
        {
          items: mailboxes.map((mailBox) => ({
            key: mailBox.id,
            value: mailBox.email,
            label: mailBox.email
          })),
          onChange: (value) => onInputArg(value, arg.argumentName),
          value: mailboxes[0]?.email,
          label: "Mailbox",
          variant: "outlined",
          className: "my-1.5 w-full",
          listItemClass: "test-data-container"
        }
      ) : /* @__PURE__ */ jsx(
        UiTextField,
        {
          label: `${arg.argumentDisplayName} (${arg.argumentDisplayType})`,
          onChange: (value) => onInputArg(value, arg.argumentName)
        },
        arg.argumentName
      ) })),
      func.parameters && func.parameters.map((param) => /* @__PURE__ */ jsx(
        UiTextField,
        {
          label: param.reference,
          onChange: (value) => onInputArg(value, param.reference)
        },
        param.reference
      ))
    ] }),
    /* @__PURE__ */ jsx(UiButton, { color: "primary", variant: "outlined", onClick: onSubmit, children: /* @__PURE__ */ jsx(Fragment, { children: "Save" }) })
  ] });
}
function ScrollPagination({
  onLoad,
  children,
  className
}) {
  const scrollContainerRef = useRef(null);
  const onScroll = () => {
    const element = scrollContainerRef.current;
    if (element && element.offsetHeight + element.scrollTop >= element.scrollHeight) {
      onLoad();
    }
  };
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: `overflow-y-auto ${className}`,
      onScroll: () => onScroll(),
      ref: scrollContainerRef,
      children
    }
  );
}
function CustomFunctions({ onSelect, funcSearchKey }) {
  const [viewFunc, setViewFunc] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [customFunctions, setCustomFunctions] = useState(
    []
  );
  const [filteredFunctions, setFilteredFunctions] = useState(
    []
  );
  const [offset, setOffset] = useState(0);
  const [categories, setCategories] = useState({});
  const [categoriesLoaded, setCategoriesLoaded] = useState(false);
  const funcName = (func) => `${func.classDisplayName} :: ${func.name}`;
  useEffect(() => {
    loadCategories();
  }, []);
  useEffect(() => {
    if (!categoriesLoaded) return;
    loadCustomFunctions();
  }, [categoriesLoaded]);
  useEffect(() => {
    if (!categoriesLoaded) return;
    if (funcSearchKey && funcSearchKey !== "") {
      loadFilteredFunctions(funcSearchKey);
    } else {
      loadCustomFunctions();
    }
  }, [offset, categoriesLoaded]);
  useEffect(() => {
    if (!categoriesLoaded) return;
    setOffset(0);
    setFilteredFunctions([]);
    if (funcSearchKey && funcSearchKey !== "") {
      loadFilteredFunctions(funcSearchKey);
    }
  }, [funcSearchKey, categoriesLoaded]);
  const loadCategories = async () => {
    setIsLoading(true);
    await FunctionApi.getDefaultCategories().then((categories2) => {
      const c = {};
      Object.keys(categories2).forEach((k) => c[categories2[k]] = k);
      setCategories(c);
    }).finally(() => {
      setCategoriesLoaded(true);
    });
  };
  const loadCustomFunctions = () => {
    setIsLoading(true);
    FunctionApi.getAll({ offset }).then((customFunctionData) => {
      customFunctionData.content?.forEach(
        (cf) => cf.fileId && (cf.classDisplayName = categories[cf.fileId])
      );
      setCustomFunctions([...customFunctions, ...customFunctionData.content]);
      setIsLoading(false);
    });
  };
  const loadFilteredFunctions = (searchKey) => {
    setIsLoading(true);
    FunctionApi.getAll({ searchTerm: searchKey, offset }).then(
      (customFunctionData) => {
        customFunctionData.content?.forEach(
          (cf) => cf.fileId && (cf.classDisplayName = categories[cf.fileId])
        );
        setFilteredFunctions([
          ...offset > 0 ? filteredFunctions : [],
          ...customFunctionData.content
        ]);
        setIsLoading(false);
      }
    );
  };
  const onToggleFunc = (id) => {
    if (viewFunc !== id) {
      setViewFunc(id);
    } else {
      setViewFunc(null);
    }
  };
  return /* @__PURE__ */ jsx(
    ScrollPagination,
    {
      onLoad: () => setOffset(offset + 1),
      className: "border border-gray-100 border-solid h-full",
      children: /* @__PURE__ */ jsxs(Fragment, { children: [
        (funcSearchKey && funcSearchKey !== "" ? filteredFunctions : customFunctions).map((customFunc) => /* @__PURE__ */ jsxs(
          "div",
          {
            className: `py-2 px-3 !space-y-2 hover:bg-blue-10 ${viewFunc === customFunc.id && "shadow-focused-step"}`,
            children: [
              /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between", children: [
                /* @__PURE__ */ jsx(
                  "span",
                  {
                    onClick: () => onSelect(customFunc),
                    className: "text-small text-accent leading-4 cursor-pointer w-full",
                    style: { height: "auto" },
                    children: funcName(customFunc)
                  },
                  customFunc.id
                ),
                /* @__PURE__ */ jsx(
                  HelpIcon_default,
                  {
                    className: "cursor-pointer w-fit h-4 shrink-0 fill-slate-550",
                    onClick: () => onToggleFunc(customFunc.id)
                  }
                )
              ] }),
              viewFunc === customFunc.id && /* @__PURE__ */ jsxs("div", { className: "border border-b-0 border-gray-100 border-solid border-x-0 py-1.5 space-y-2", children: [
                /* @__PURE__ */ jsxs("div", { className: "text-small text-accent", children: [
                  /* @__PURE__ */ jsx("span", { className: "leading-4 font-semibold py-1.5", children: "Description" }),
                  " ",
                  /* @__PURE__ */ jsx("span", { children: customFunc.description })
                ] }),
                /* @__PURE__ */ jsxs("div", { className: "flex flex-col", children: [
                  /* @__PURE__ */ jsx("div", { className: "text-small text-accent leading-4 font-semibold", children: "Input" }),
                  customFunc.arguments?.map((arg) => /* @__PURE__ */ jsxs(
                    "div",
                    {
                      className: "text-small text-accent leading-4",
                      children: [
                        /* @__PURE__ */ jsx("span", { className: "font-medium", children: arg.argumentDisplayName }),
                        "\xA0",
                        /* @__PURE__ */ jsx("span", { children: arg.argumentDisplayType })
                      ]
                    },
                    arg.argumentName
                  )),
                  !customFunc.arguments?.length && /* @__PURE__ */ jsx("div", { className: "text-small text-accent leading-4", children: "--" })
                ] })
              ] })
            ]
          },
          customFunc.id
        )),
        isLoading || !categoriesLoaded ? /* @__PURE__ */ jsx("span", { className: "flex justify-center items-center h-12 w-full absolute z-10 top-2/4", children: /* @__PURE__ */ jsx(AiOutlineLoading3Quarters, { className: "animate-spin h-5 w-5" }) }) : funcSearchKey && funcSearchKey !== "" ? !filteredFunctions.length && /* @__PURE__ */ jsx("span", { className: "text-small text-accent leading-4", children: "No Functions" }) : !customFunctions.length && /* @__PURE__ */ jsx("span", { className: "text-small text-accent leading-4", children: "No Functions" })
      ] })
    }
  );
}
function AddonFunctions({ onSelect, funcSearchKey }) {
  const [viewFunc, setViewFunc] = useState(null);
  const [addonFunctions, setAddonfunctions] = useState(
    []
  );
  const [filteredAddonFunctions, setFilteredAddonFunctions] = useState([]);
  const [offset, setOffset] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    loadAddonFunctions();
  }, []);
  useEffect(() => {
    if (funcSearchKey && funcSearchKey !== "") {
      loadFilteredAddonFunctions(funcSearchKey);
    } else {
      loadAddonFunctions();
    }
  }, [offset]);
  useEffect(() => {
    if (funcSearchKey && funcSearchKey !== "") {
      setOffset(0);
      loadFilteredAddonFunctions(funcSearchKey);
    } else {
      setFilteredAddonFunctions([]);
    }
  }, [funcSearchKey]);
  const loadAddonFunctions = () => {
    setIsLoading(true);
    FunctionApi.getAllAddonFunc().then((addonFunctionsData) => {
      setAddonfunctions(addonFunctionsData.content);
      setIsLoading(false);
    });
  };
  const loadFilteredAddonFunctions = (searchKey) => {
    setIsLoading(true);
    FunctionApi.getAllAddonFunc(searchKey).then((addonFunctionsData) => {
      setFilteredAddonFunctions(addonFunctionsData.content);
      setIsLoading(false);
    });
  };
  const onToggleFunc = (id) => {
    if (viewFunc !== id) {
      setViewFunc(id);
    } else {
      setViewFunc(null);
    }
  };
  return /* @__PURE__ */ jsx(
    ScrollPagination,
    {
      onLoad: () => setOffset(offset + 1),
      className: "border border-gray-100 border-solid h-full",
      children: /* @__PURE__ */ jsxs(Fragment, { children: [
        (funcSearchKey && funcSearchKey !== "" ? filteredAddonFunctions : addonFunctions).map((func) => /* @__PURE__ */ jsxs(
          "div",
          {
            className: `py-2 px-3 !space-y-2 hover:bg-blue-10 ${viewFunc === func.id && "shadow-focused-step bg-blue-10"}`,
            children: [
              /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between", children: [
                /* @__PURE__ */ jsx(
                  "span",
                  {
                    onClick: () => onSelect(func),
                    className: "text-small text-accent leading-4 cursor-pointer w-full",
                    style: { height: "auto" },
                    children: func.displayName
                  },
                  func.id
                ),
                /* @__PURE__ */ jsx(
                  HelpIcon_default,
                  {
                    className: "cursor-pointer w-fit h-4 shrink-0 fill-slate-550",
                    onClick: () => onToggleFunc(func.id)
                  }
                )
              ] }),
              viewFunc === func.id && /* @__PURE__ */ jsxs("div", { className: "border border-solid border-x-0 border-gray-300 space-x-2.5", children: [
                /* @__PURE__ */ jsxs("div", { className: "text-small text-accent", children: [
                  /* @__PURE__ */ jsx("span", { className: "leading-4 font-semibold py-1.5", children: "Description" }),
                  /* @__PURE__ */ jsx("span", { children: func.decription })
                ] }),
                /* @__PURE__ */ jsxs("div", { className: "flex flex-col", children: [
                  /* @__PURE__ */ jsx("div", { className: "text-small text-accent leading-4 font-semibold", children: "Input" }),
                  func.parameters.map((param) => /* @__PURE__ */ jsxs(
                    "div",
                    {
                      className: "text-small text-accent leading-4",
                      children: [
                        /* @__PURE__ */ jsx("span", { children: param.name }),
                        "\xA0",
                        /* @__PURE__ */ jsx("span", { children: param.reference })
                      ]
                    },
                    param.id
                  )),
                  func.parameters.length < 1 && /* @__PURE__ */ jsx("div", { className: "text-small text-accent leading-4", children: "--" })
                ] })
              ] })
            ]
          },
          func.id
        )),
        isLoading ? /* @__PURE__ */ jsx("span", { className: "flex justify-center items-center h-12 w-full absolute z-10 top-2/4", children: /* @__PURE__ */ jsx(AiOutlineLoading3Quarters, { className: "animate-spin h-5 w-5" }) }) : funcSearchKey && funcSearchKey !== "" ? !filteredAddonFunctions.length && /* @__PURE__ */ jsx("span", { className: "px-3", children: "No Functions" }) : !addonFunctions.length && /* @__PURE__ */ jsx("span", { className: "flex items-center flex-col absolute top-1/2 -translate-y-1/2 leading-7 w-full", children: "There is no Functions" })
      ] })
    }
  );
}
function DataGeneratorComponent({ onSelect }) {
  const DEFAULT_CTX = "Default";
  const ADDON_CTX = "Addon";
  const CONTEXT = [
    {
      label: DEFAULT_CTX,
      key: DEFAULT_CTX,
      value: DEFAULT_CTX,
      icon: /* @__PURE__ */ jsx(Fragment, {}),
      isEnabled: true
    },
    {
      label: ADDON_CTX,
      key: ADDON_CTX,
      value: ADDON_CTX,
      icon: /* @__PURE__ */ jsx(ExtensionIcon_default, { className: "h-3 w-fit fill-gray-600" }),
      isEnabled: true
    }
  ];
  const [selectedFunc, setSelectedFunc] = useState();
  const [funcSearchKey, setFuncSearchKey] = useState("");
  const [activeContext, setActiveContenxt] = useState(DEFAULT_CTX);
  const handleSelectFunc = (func) => {
    switch (activeContext) {
      case DEFAULT_CTX:
        const customFunc = func;
        if (customFunc.arguments?.length > 0) {
          setSelectedFunc(customFunc);
        } else {
          onSelect(customFunc);
        }
        break;
      case ADDON_CTX:
        const addonFunc = func;
        if (addonFunc.parameters.length > 0) {
          setSelectedFunc(addonFunc);
        } else {
          onSelect(addonFunc);
        }
        break;
    }
  };
  const hanldeFuncArg = (func) => {
    if (func) {
      switch (activeContext) {
        case DEFAULT_CTX:
          onSelect(func);
          break;
        case ADDON_CTX:
          onSelect(func);
          break;
      }
    }
    setSelectedFunc(void 0);
  };
  const handleSearchFunc = (searchKey) => {
    setFuncSearchKey(searchKey);
  };
  return /* @__PURE__ */ jsx("div", { className: "box-border h-full overflow-hidden py-5 px-4.5 !space-y-5 flex flex-col overflow-y-auto", children: selectedFunc ? /* @__PURE__ */ jsx(
    FunctionValue,
    {
      func: selectedFunc,
      onClose: () => setSelectedFunc(void 0),
      onSubmitFuncArg: (func) => hanldeFuncArg(func)
    }
  ) : /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      UiSelect,
      {
        items: CONTEXT,
        onChange: (value) => setActiveContenxt(value),
        value: activeContext,
        label: "Type",
        variant: "outlined",
        className: "my-1.5 w-full",
        listItemClass: "test-data-container"
      }
    ),
    /* @__PURE__ */ jsx(
      DebouncedSearchInput,
      {
        value: funcSearchKey,
        onChange: handleSearchFunc,
        placeholder: "Search Function/Method",
        prefixIconName: "search",
        prefixIconClassName: "text-2xl"
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: "flex flex-col h-full overflow-hidden rounded min-h-[200px]", children: [
      /* @__PURE__ */ jsx("div", { className: "text-small text-accent font-semibold py-2 px-3 rounded-t bg-gray-100", children: "Functions/Methods" }),
      activeContext === DEFAULT_CTX ? /* @__PURE__ */ jsx(
        CustomFunctions,
        {
          funcSearchKey,
          onSelect: (func) => handleSelectFunc(func)
        }
      ) : /* @__PURE__ */ jsx(
        AddonFunctions,
        {
          funcSearchKey,
          onSelect: (func) => handleSelectFunc(func)
        }
      )
    ] })
  ] }) });
}
var SearchOutlineIcon = ({ className, onClick }) => {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      className,
      onClick,
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "inherit",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx("g", { clipPath: "url(#clip0_238_98765)", children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M6.84199 13.684C8.06356 13.6838 9.25683 13.3546 10.2994 12.7388C10.7345 12.4818 11.2987 12.5089 11.6561 12.8662L14.1852 15.3953C14.5191 15.7293 15.0606 15.7293 15.3945 15.3953C15.7284 15.0613 15.7284 14.5199 15.3945 14.186L12.8655 11.657C12.5081 11.2996 12.481 10.7353 12.7382 10.3002C13.3544 9.25742 13.6837 8.06389 13.684 6.84199C13.684 3.06948 10.6145 0 6.84199 0C3.06949 0 0 3.06948 0 6.84199C0 10.6145 3.06949 13.684 6.84199 13.684ZM6.84199 1.7105C9.67204 1.7105 11.9735 4.01197 11.9735 6.84199C11.9735 9.67204 9.67204 11.9735 6.84199 11.9735C4.01197 11.9735 1.7105 9.67204 1.7105 6.84199C1.7105 4.01197 4.01197 1.7105 6.84199 1.7105Z",
          fill: "inherit"
        }
      ) })
    }
  );
};
var SearchOutlineIcon_default = SearchOutlineIcon;
function UploadTestData({ onSelect }) {
  const [isLoading, setIsLoading] = useState(false);
  const [uploadSearchKey, setUploadSearchKey] = useState("");
  const [filteredUploads, setFilteredUploads] = useState([]);
  const [uploads, setUploads] = useState([]);
  const { applicationId, testCase } = useSelector(
    (state) => state.widget
  );
  const [isUploadInProgress, setIsUploadInProgress] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  useEffect(() => {
    loadFileUploads();
  }, []);
  const handleSearchUpload = (name) => {
    if (name) {
      setFilteredUploads([
        ...uploads.filter(
          (upload) => upload.latestVersion.name.toLowerCase().includes(name.toLowerCase())
        )
      ]);
    }
    setUploadSearchKey(name);
  };
  const loadFileUploads = () => {
    if (applicationId || testCase?.version?.applicationId) {
      setIsLoading(true);
      UploadApi.getAll({
        //@ts-expect-error version is manually set
        applicationId: applicationId || testCase?.version?.applicationId
      }).then((fileUploadContent) => {
        setUploads(fileUploadContent.content);
      }).finally(() => setIsLoading(false));
    }
  };
  const handleFileSelect = async (event) => {
    const inputElement = event.target;
    if (inputElement.files && // @ts-expect-error ignore
    (applicationId || testCase?.version?.applicationId)) {
      const selectedFile = inputElement.files[0];
      const fileName = cleanFileName(selectedFile.name);
      setIsUploadInProgress(true);
      UploadApi.create({
        file: selectedFile,
        name: fileName,
        // @ts-expect-error ignore
        applicationId: applicationId || testCase?.version?.applicationId,
        version: fileName
      }).then((res) => {
        setUploads([...uploads, res]);
      }).catch((err) => {
        setErrorMessage(err.error);
      }).finally(() => {
        setIsUploadInProgress(false);
      });
    }
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("div", { className: "box-border flex flex-col h-full overflow-x-hidden overflow-y-auto py-8 !space-y-5", children: isLoading ? /* @__PURE__ */ jsx("span", { className: "flex justify-center items-center h-12", children: /* @__PURE__ */ jsx(AiOutlineLoading3Quarters, { className: "animate-spin h-5 w-5" }) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("div", { className: "text-center", children: [
        /* @__PURE__ */ jsx(
          "input",
          {
            type: "file",
            name: "file",
            id: "upload-test-data",
            onChange: handleFileSelect,
            className: "hidden",
            disabled: isUploadInProgress
          }
        ),
        /* @__PURE__ */ jsx(
          "label",
          {
            htmlFor: "upload-test-data",
            className: "text-legacy-primary-100 text-sm cursor-pointer font-semibold",
            children: isUploadInProgress ? /* @__PURE__ */ jsx("div", { className: "w-full mb-2 p-4 rounded-lg border", children: /* @__PURE__ */ jsx("span", { className: "!text-secondary-500 cursor-not-allowed", children: "Uploading..." }) }) : /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-center cursor-pointer gap-x-2 w-full mb-2 p-4 rounded-lg border text-primary-500", children: [
              /* @__PURE__ */ jsx(Icon, { name: "upload", className: "text-primary-500 text-xl" }),
              /* @__PURE__ */ jsx("span", { children: "Upload a new file" })
            ] })
          }
        )
      ] }),
      /* @__PURE__ */ jsx(
        UiTextField,
        {
          value: uploadSearchKey,
          onChange: (value) => handleSearchUpload(value),
          placeholder: "Search Upload Name",
          inputProps: {
            startAdornment: /* @__PURE__ */ jsx(SearchOutlineIcon_default, { className: "fill-slate-550 h-11 stroke-slate-550 w-fit pr-3.5 py-3.5 pl-0" })
          },
          variant: "outlined"
        }
      ),
      /* @__PURE__ */ jsxs("div", { className: "flex flex-col h-full overflow-hidden min-h-[200px]", children: [
        /* @__PURE__ */ jsx("div", { className: "text-small text-accent font-semibold py-2 px-3 rounded-t bg-gray-100", children: "Upload / Latest version name" }),
        /* @__PURE__ */ jsxs("div", { className: "border border-gray-100 border-solid border-t-0 h-full overflow-hidden overflow-y-auto rounded-b", children: [
          (uploadSearchKey !== "" ? filteredUploads : uploads).map(
            (upload) => /* @__PURE__ */ jsxs(
              "div",
              {
                onClick: () => onSelect(upload),
                className: "hover:bg-blue-10 text-small text-accent font-normal leading-4 py-2 px-3 cursor-pointer",
                children: [
                  upload.name,
                  " / ",
                  upload.latestVersion.name
                ]
              },
              upload.id
            )
          ),
          uploadSearchKey !== "" && !filteredUploads.length && /* @__PURE__ */ jsx("span", { className: "flex justify-center align-center text-small text-accent font-normal leading-4 py-2 px-3", children: "No uploads found for this search criteria" })
        ] })
      ] })
    ] }) }),
    !!errorMessage && /* @__PURE__ */ jsxs(
      Modal,
      {
        className: "!rounded-xl relative",
        isOpen: !!errorMessage,
        onClose: () => setErrorMessage(""),
        showCloseButton: true,
        children: [
          /* @__PURE__ */ jsx("div", { className: "h-12 w-12 rounded-full border-spacing-2.5 bg-orange-100 flex items-center justify-center", children: /* @__PURE__ */ jsx(
            Icon,
            {
              name: "error",
              className: "flex text-2xl text-orange-600 p-1 bg-orange-200 rounded-full"
            }
          ) }),
          /* @__PURE__ */ jsx("div", { className: "font-semibold text-lg text-primary-1000 pt-4", children: "Upload error!" }),
          /* @__PURE__ */ jsx("div", { className: "font-normal text-xs text-primary-1000 my-2", children: errorMessage })
        ]
      }
    )
  ] });
}
function EmptyListMessage({ heading, content }) {
  return /* @__PURE__ */ jsxs("div", { className: "-translate-y-1/2 flex flex-col items-center leading-7 space-y-4 w-full my-auto", children: [
    /* @__PURE__ */ jsx(ErrorIcon_default, { className: "h-12 w-fit fill-legacy-primary-100" }),
    heading && /* @__PURE__ */ jsx("div", { className: "font-semibold text-slate-800 text-small", children: heading }),
    content && /* @__PURE__ */ jsx("div", { className: "text-slate-800 text-small text-center leading-18px", children: content })
  ] });
}
function MailboxComponent({ onSelect }) {
  const [mailboxes, setMailboxes] = useState([]);
  const [paramSearchKey, setParamSearchKey] = useState("");
  const [filteredMailboxes, setFilteredMailboxes] = useState(
    []
  );
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    loadMailboxes();
  }, []);
  const handleSearchParam = (searchKey) => {
    setParamSearchKey(searchKey);
    if (searchKey !== "") {
      loadFilteredMailboxes(searchKey);
    } else {
      setFilteredMailboxes([]);
    }
  };
  const loadMailboxes = () => {
    setIsLoading(true);
    MailboxApi.getAll().then((mailboxesData) => {
      log.debug("mailboxesData", mailboxesData);
      setMailboxes(mailboxesData.content);
      setIsLoading(false);
    });
  };
  const loadFilteredMailboxes = (searchKey) => {
    setIsLoading(true);
    MailboxApi.getAll(searchKey).then((mailboxesData) => {
      log.debug("mailboxesData", mailboxesData);
      setFilteredMailboxes(mailboxesData.content);
      setIsLoading(false);
    });
  };
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", { className: "box-border flex flex-col h-full overflow-hidden py-3.5 space-y-3.5", children: [
    !!mailboxes?.length && /* @__PURE__ */ jsx(
      UiTextField,
      {
        value: paramSearchKey,
        onChange: (value) => handleSearchParam(value),
        placeholder: "Search Mail Box",
        inputProps: {
          startAdornment: /* @__PURE__ */ jsx(SearchOutlineIcon_default, { className: "fill-slate-550 h-11 stroke-slate-550 w-fit pr-3.5 py-3.5 pl-0" })
        },
        variant: "outlined"
      }
    ),
    isLoading ? /* @__PURE__ */ jsx("span", { className: "flex justify-center items-center h-12", children: /* @__PURE__ */ jsx(AiOutlineLoading3Quarters, { className: "animate-spin h-5 w-5" }) }) : /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col overflow-hidden rounded h-full", children: [
      !!mailboxes?.length && /* @__PURE__ */ jsx("div", { className: "text-small text-accent font-semibold py-2 px-3 rounded-t bg-gray-100 leading-4", children: "Mailboxes" }),
      mailboxes?.length ? /* @__PURE__ */ jsxs("div", { className: "border border-gray-100 border-solid flex flex-col overflow-hidden overflow-y-auto rounded-b", children: [
        (paramSearchKey !== "" ? filteredMailboxes : mailboxes).map(
          (mailbox) => /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs(
            "div",
            {
              className: "hover:bg-blue-10 text-small text-accent font-normal leading-4 py-2 px-3 cursor-pointer",
              onClick: () => onSelect(mailbox),
              children: [
                mailbox.name,
                " : ",
                mailbox.email
              ]
            }
          ) }, mailbox.id)
        ),
        paramSearchKey !== "" && !filteredMailboxes.length && /* @__PURE__ */ jsx("span", { className: "text-small text-accent font-normal leading-4 py-2 text-center", children: "No results found for this search criteria" })
      ] }) : /* @__PURE__ */ jsx(
        EmptyListMessage,
        {
          heading: "There are no Mailboxes",
          content: /* @__PURE__ */ jsxs(Fragment, { children: [
            "To Configure Mail Boxes, email us at ",
            /* @__PURE__ */ jsx("br", {}),
            /* @__PURE__ */ jsx(
              "a",
              {
                className: "text-legacy-primary-100",
                href: "mailto:support@testsigma.com",
                children: "support@testsigma.com"
              }
            )
          ] })
        }
      )
    ] }) })
  ] }) });
}
var applicationIconsMap = {
  WebApplication: "web",
  MobileWeb: "real-mobile",
  AndroidNative: "android",
  IOSNative: "ios",
  Rest: "rest-api",
  WINDOWS: "windows",
  Salesforce: "salesforce"
};
var ProjectSelection = ({
  applicationVersionId,
  onChangeApplicationVerisonId,
  variant = "postman-import",
  projectAutoCompleteClassName = ""
}) => {
  const { t } = useTranslation();
  const [selectedProject, setSelectedProject] = useState(
    {}
  );
  const [selectedApplication, setSelectedApplication] = useState({});
  const [selectedVersion, setSelectedVersion] = useState(
    {}
  );
  const projectOptionsHook = useCallback(
    (query) => new Promise((resolve) => {
      query = query ? `name:*${query}*` : "";
      ProjectApi.getAll(query).then((res) => {
        const options3 = res.content.map((project) => {
          return {
            id: project.id,
            label: project.name,
            disabled: false
          };
        });
        resolve(options3);
      }).catch((err) => {
        console.log("Failed to search for projects", err);
      });
    }),
    []
  );
  const applicationOptionsHook = useCallback(
    (term) => new Promise((resolve) => {
      const termQuery = `,name:*${term}*`;
      const query = `projectId:${selectedProject.id}${term ? termQuery : ""}`;
      ProjectApplicationApi.getAll(query).then((res) => {
        const options3 = res.content.map((application) => {
          return {
            id: application.id,
            label: application.name,
            disabled: false,
            applicationType: application.applicationType
          };
        });
        resolve(options3);
      }).catch((err) => {
        console.log(
          "applicationOptionsHook : Failed to search for applications",
          err
        );
      });
    }),
    [selectedProject]
  );
  const versionOptionsHook = useCallback(
    (term) => new Promise((resolve) => {
      const termQuery = `,versionName:*${term}*`;
      const query = `applicationId:${selectedApplication.id}${term ? termQuery : ""}`;
      ApplicationVersionApi.getAll(query).then((res) => {
        const options3 = res.content.map((version) => {
          return {
            id: version.id,
            label: version.versionName,
            disabled: false
          };
        });
        resolve(options3);
      }).catch((err) => {
        console.log("Failed to search for projects", err);
      });
    }),
    [selectedApplication]
  );
  const setInitialState = useCallback(
    (applicationVersionId2) => {
      if (!applicationVersionId2) {
        return;
      }
      ApplicationVersionApi.getOne(applicationVersionId2).then((res) => {
        setSelectedVersion({
          id: res.id,
          label: res.versionName,
          disabled: false
        });
        setSelectedApplication({
          id: res.application.id,
          label: res.application.name,
          disabled: false,
          applicationType: res.application.applicationType
        });
        setSelectedProject({
          id: res.application.project.id,
          label: res.application.project.name,
          disabled: false
        });
      }).catch((err) => {
        console.log("Failed to search for applications", err);
      });
    },
    [selectedVersion]
  );
  const onChangeProject = useCallback(
    (project) => {
      setSelectedProject(project);
      setDefaultApplication(project.id);
    },
    [selectedProject]
  );
  const onChangeApplication = useCallback(
    (application) => {
      setSelectedApplication(application);
      setDefaultVersion(application.id);
    },
    [selectedApplication]
  );
  const onChangeVersion = useCallback(
    (version) => {
      setSelectedVersion(version);
      onChangeApplicationVerisonId(version.id);
    },
    [selectedVersion]
  );
  const setDefaultApplication = useCallback(
    (projectId) => {
      const query = `projectId:${projectId}`;
      ProjectApplicationApi.getAll(query).then((res) => {
        const application = res.content[0];
        onChangeApplication({
          id: application.id,
          label: application.name,
          disabled: false,
          applicationType: application.applicationType
        });
      }).catch((err) => {
        console.log("Failed to search for applications", err);
      });
    },
    [selectedApplication]
  );
  const setDefaultVersion = useCallback(
    (applicationId) => {
      const query = `applicationId:${applicationId}`;
      ApplicationVersionApi.getAll(query).then((res) => {
        const version = res.content[0];
        onChangeVersion({
          id: version.id,
          label: version.versionName,
          disabled: false
        });
      }).catch((err) => {
        console.log("Failed to search for versions", err);
      });
    },
    [selectedApplication]
  );
  useEffect(() => {
    setInitialState(applicationVersionId);
  }, []);
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", { className: classNames82({ "flex gap-3": variant === "e2e-suites" }), children: [
    /* @__PURE__ */ jsx(
      AutoComplete,
      {
        LoadingContent: /* @__PURE__ */ jsx(DropdownItem, { isSelected: false, children: t("project.loading.message") }),
        emptyContent: /* @__PURE__ */ jsx(DropdownItem, { isSelected: false, children: t("common.no-matching-options") }),
        optionsHook: projectOptionsHook,
        placeholder: t("project.label"),
        onSelect: onChangeProject,
        value: selectedProject,
        className: classNames82("mt-5 !z-50", projectAutoCompleteClassName, {
          "!w-1/3": variant === "e2e-suites"
        }),
        showClearButton: false,
        inputClassName: classNames82("bg-secondary-50 !pl-7", {
          "truncate !pr-0": variant === "e2e-suites"
        }),
        inputContainerClassName: "!bg-secondary-50",
        label: t("project.label"),
        labelClassName: "text-2xs",
        prefixIcon: "project-case",
        showSearchOnDropdown: true,
        dropdownClass: "max-h-52 !overflow-auto"
      },
      `project_${selectedProject.id}`
    ),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames82({
          "gap-3 grid grid-cols-2": variant !== "postman-import"
        }),
        children: [
          selectedProject?.id && /* @__PURE__ */ jsx(
            AutoComplete,
            {
              LoadingContent: /* @__PURE__ */ jsx(DropdownItem, { isSelected: false, children: t("application.loading.message") }),
              emptyContent: /* @__PURE__ */ jsx(DropdownItem, { isSelected: false, children: t("common.no-matching-options") }),
              optionsHook: applicationOptionsHook,
              placeholder: t("application.label"),
              onSelect: onChangeApplication,
              value: selectedApplication,
              className: "mt-5 !z-20",
              showClearButton: false,
              inputClassName: classNames82("bg-secondary-50 !pl-7", {
                "truncate !pr-0": variant === "e2e-suites"
              }),
              inputContainerClassName: "!bg-secondary-50",
              label: t("application.label"),
              labelClassName: "text-2xs",
              prefixIcon: applicationIconsMap[selectedApplication.applicationType],
              showSearchOnDropdown: true,
              dropdownClass: "max-h-52 !overflow-auto"
            },
            `app_${selectedApplication.id}`
          ),
          selectedApplication?.id && /* @__PURE__ */ jsx(
            AutoComplete,
            {
              LoadingContent: /* @__PURE__ */ jsx(DropdownItem, { isSelected: false, children: t("version.loading.message") }),
              emptyContent: /* @__PURE__ */ jsx(DropdownItem, { isSelected: false, children: t("common.no-matching-options") }),
              optionsHook: versionOptionsHook,
              placeholder: t("version.label"),
              onSelect: onChangeVersion,
              value: selectedVersion,
              className: "mt-5",
              showClearButton: false,
              inputClassName: classNames82("bg-secondary-50 !pl-7", {
                "truncate !pr-0": variant === "e2e-suites"
              }),
              inputContainerClassName: "!bg-secondary-50",
              label: t("version.label"),
              labelClassName: "text-2xs",
              prefixIcon: "versions",
              showSearchOnDropdown: true,
              dropdownClass: "max-h-52 !overflow-auto"
            },
            `version_${selectedVersion.id}`
          )
        ]
      }
    )
  ] }) });
};
var RuntimeVariableSelector = ({ onClick }) => {
  const { appVersionId } = useSelector((state) => state.widget);
  const [localAppVersionId, setLocalAppVersionId] = useState(appVersionId);
  const { isDebugger: isDebugMode } = useRecorderContext();
  const [showProjectSwitcher, updateShowProjectSwitcher] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const { data, fetchNextPage, hasNextPage, isFetching } = useInfiniteQuery(
    `recorder-runtime-variables-${localAppVersionId}-${searchTerm}`,
    async ({ pageParam = 0 }) => {
      const query = `applicationVersionId:${localAppVersionId}${searchTerm ? `,name:*${searchTerm}*` : ""}`;
      try {
        return await RuntimeVariableApi.findAll(query, 20, pageParam);
      } catch (err) {
        throw err;
      }
    },
    {
      getNextPageParam: (lastPage) => lastPage?.last ? void 0 : lastPage?.pageable?.pageNumber + 1
    }
  );
  const modifiedData = useMemo(() => {
    const receivedData = data?.pages?.flatMap((item) => item?.content).filter((item) => !!item) || [];
    const processedData = [];
    for (const variable of receivedData) {
      processedData.push({
        runTimeVariableName: variable.name,
        usageCount: variable.usageCount
      });
    }
    return processedData;
  }, [data]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    showProjectSwitcher && /* @__PURE__ */ jsx("div", { className: "pb-4 px-6", children: /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
      ProjectSelection,
      {
        applicationVersionId: localAppVersionId,
        onChangeApplicationVerisonId: setLocalAppVersionId,
        variant: "runtime-test-data"
      }
    ) }) }),
    /* @__PURE__ */ jsx("div", { className: classNames82("h-full", { "p-6": !isDebugMode }), children: /* @__PURE__ */ jsx(
      RuntimeVariableValueSelector,
      {
        onClick,
        runtimeVariables: modifiedData || [],
        onChangeSearch: setSearchTerm,
        isFetching,
        onShowProjectcher: () => updateShowProjectSwitcher(true),
        isShowingProjectSwitcher: showProjectSwitcher,
        useGetRuntimeVariableUsage: NOOP,
        hasMore: hasNextPage,
        handleLoadMore: fetchNextPage,
        searchTerm,
        isRecoder: true
      }
    ) })
  ] });
};
var DataProfileSelector = ({ onSelect, dataProfileIds }) => {
  const [selectedDataProfileId, updateSelectedDataProfileId] = useState(null);
  const { isDebugger: isDebugMode } = useRecorderContext();
  const [dataProfile, setDataProfile] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const loadData2 = async () => {
    setIsFetching(true);
    let res = "";
    dataProfileIds.forEach((element, index) => {
      if (index) {
        res += "#";
      }
      res += element.dataProfileId;
    });
    const data = await DataProfileApi.findAll(
      "id@" + res,
      "asc",
      dataProfileIds.length,
      0
    );
    setDataProfile(data);
    setIsFetching(false);
  };
  useEffect(() => {
    if (dataProfileIds?.length) loadData2();
  }, [dataProfileIds]);
  const tdpProfileList = useMemo(() => {
    const filteredItem = dataProfile?.filter((p) => !p.stepNumber) || [];
    const filterData = [
      ...dataProfile?.filter((p) => p.stepNumber) || [],
      ...filteredItem
    ];
    const result = filterData || dataProfile;
    dataProfileIds?.forEach((_dataProfile) => {
      if (_dataProfile?.stepNumber) {
        const matchingItem = result?.find(
          (tdp) => tdp?.id === _dataProfile?.dataProfileId
        );
        if (matchingItem) {
          matchingItem.stepNumber = _dataProfile.stepNumber;
        }
      }
    });
    return result;
  }, [dataProfile, dataProfileIds]);
  useEffect(() => {
    updateSelectedDataProfileId(
      (dataProfile?.find((item) => item.id == dataProfile?.[0]?.id) || dataProfile?.[0])?.id
    );
  }, [dataProfile]);
  return /* @__PURE__ */ jsx("div", { className: classNames82("h-full", { "p-6": !isDebugMode }), children: /* @__PURE__ */ jsx(
    parameter_value_selector_default,
    {
      selectedDataProfileId,
      onchangeProfile: (item) => updateSelectedDataProfileId(item?.id),
      dataProfiles: dataProfile || [],
      onClick: onSelect,
      isFetching,
      openEditTestCase: NOOP,
      openTestDataProfile: NOOP,
      profileList: tdpProfileList || [],
      isRecorder: true
    }
  ) });
};
var PhoneNumberSelector2 = ({ onSelect }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const { isDebugger: isDebugMode } = useRecorderContext();
  const { data, fetchNextPage, hasNextPage, isFetching } = useInfiniteQuery(
    [`phonenumber-test-data-${searchTerm || ""}`],
    async ({ pageParam = 0 }) => {
      const query = `${searchTerm ? `phoneNumber:*${searchTerm}*` : ""}`;
      const checkData = await PhoneNumberApi.findAll(
        query,
        20,
        pageParam,
        "asc"
      );
      return checkData;
    },
    {
      getNextPageParam: (lastPage) => lastPage?.last ? void 0 : lastPage?.pageable?.pageNumber + 1
    }
  );
  const modifiedData = data?.pages?.flatMap((item) => item?.content) || [];
  return /* @__PURE__ */ jsx("div", { className: classNames82("h-full", { "p-6": !isDebugMode }), children: /* @__PURE__ */ jsx(
    PhoneNumberSelector,
    {
      phoneNumbers: modifiedData,
      onClick: onSelect,
      isFetching,
      onChangeSearch: setSearchTerm,
      searchTerm,
      hasMore: hasNextPage,
      handleLoadMore: fetchNextPage,
      isRecorder: true
    }
  ) });
};
var TestDataDrawer = ({
  apiKey,
  step,
  onSelectDataValue,
  closeTestDataDrawer
}) => {
  const handleEnvSelect = (param) => {
    onSelectDataValue(TEST_DATA_ENVIRONMENT.apiKey, { text: param });
  };
  const handleDataProfileSelect = (param) => {
    onSelectDataValue(TEST_DATA_DATAPROFILE.apiKey, {
      text: param
    });
  };
  const handleDataGeneratorSelect = (func) => {
    const text = func.classDisplayName ? `${func.classDisplayName} :: ${func.displayName}` : func.displayName;
    onSelectDataValue(TEST_DATA_FUNCTION.apiKey, {
      text,
      function: func
    });
  };
  const handleMailboxSelect = (mail) => onSelectDataValue(TEST_DATA_MAILBOX.apiKey, {
    ...mail
  });
  const handlePhoneNumberSelect = (phoneNumber) => onSelectDataValue(TEST_DATA_PHONE_NUMBER.apiKey, {
    ...phoneNumber
  });
  const handleRuntimeSelect = (runtime) => onSelectDataValue(TEST_DATA_RUNTIME.apiKey, {
    runTimeVariableName: runtime.runTimeVariableName,
    testCaseName: runtime.testCaseName,
    stepPosition: runtime.stepPosition
  });
  const handleUploadSelect = (selectedUpload) => onSelectDataValue(TEST_DATA_UPLOAD.apiKey, {
    ...selectedUpload
  });
  switch (apiKey) {
    case "OPEN_ENVIRONMENT" /* OPEN_ENVIRONMENT */:
      return /* @__PURE__ */ jsx(
        OverlayContainer,
        {
          title: "Environments",
          onClose: closeTestDataDrawer,
          body: /* @__PURE__ */ jsx(EnvironmentComponent, { onSelect: (param) => handleEnvSelect(param) })
        }
      );
    case "OPEN_PARAMETER" /* OPEN_PARAMETER */:
      return /* @__PURE__ */ jsx(
        OverlayContainer,
        {
          title: "Test Data Profiles",
          onClose: closeTestDataDrawer,
          body: /* @__PURE__ */ jsx(
            DataProfileSelector,
            {
              onSelect: (param, parentStepId) => handleDataProfileSelect(param),
              dataProfileIds: step?.parentDataProfileIds
            }
          )
        }
      );
    case "OPEN_DATA_GENERATOR" /* OPEN_DATA_GENERATOR */:
      return /* @__PURE__ */ jsx(
        OverlayContainer,
        {
          title: "Test Data Generators",
          onClose: closeTestDataDrawer,
          body: /* @__PURE__ */ jsx(
            DataGeneratorComponent,
            {
              onSelect: (param) => handleDataGeneratorSelect(param)
            }
          ),
          noBodyWrapper: true
        }
      );
    case "OPEN_MAILBOX" /* OPEN_MAILBOX */:
      return /* @__PURE__ */ jsx(
        OverlayContainer,
        {
          title: "Test Data Mailboxes",
          onClose: closeTestDataDrawer,
          body: /* @__PURE__ */ jsx(MailboxComponent, { onSelect: (param) => handleMailboxSelect(param) })
        }
      );
    case "OPEN_PHONE_NUMBER" /* OPEN_PHONE_NUMBER */:
      return /* @__PURE__ */ jsx(
        OverlayContainer,
        {
          title: "Test Data Phone Numbers",
          onClose: closeTestDataDrawer,
          body: /* @__PURE__ */ jsx(
            PhoneNumberSelector2,
            {
              onSelect: (param) => handlePhoneNumberSelect(param)
            }
          )
        }
      );
    case "OPEN_RUNTIME_VARIABLE" /* OPEN_RUNTIME_VARIABLE */:
      return /* @__PURE__ */ jsx(
        OverlayContainer,
        {
          title: "Runtime Variables",
          onClose: closeTestDataDrawer,
          body: /* @__PURE__ */ jsx(
            RuntimeVariableSelector,
            {
              onClick: (param) => handleRuntimeSelect(param)
            }
          )
        }
      );
    case "OPEN_UPLOAD" /* OPEN_UPLOAD */:
      return /* @__PURE__ */ jsx(
        OverlayContainer,
        {
          title: "Uploads",
          onClose: closeTestDataDrawer,
          body: /* @__PURE__ */ jsx(UploadTestData, { onSelect: handleUploadSelect })
        }
      );
  }
  return /* @__PURE__ */ jsx(Fragment, {});
};
var initialState3 = {
  treeData: [],
  searchTerm: "",
  containerHeight: 0,
  selectedElement: null
};
var ElementsContext = createContext(null);

// src/components/element-tree/enums/index.ts
var ElementsActionTypes = /* @__PURE__ */ ((ElementsActionTypes2) => {
  ElementsActionTypes2["SET_TREE_DATA"] = "SET_TREE_DATA";
  ElementsActionTypes2["SET_SEARCH_TERM"] = "SET_SEARCH_TERM";
  ElementsActionTypes2["SET_SELECTED_ELEMENTS"] = "SET_SELECTED_ELEMENTS";
  ElementsActionTypes2["SET_CONTAINER_HEIGHT"] = "SET_CONTAINER_HEIGHT";
  ElementsActionTypes2["SET_SELECTED_ELEMENT"] = "SET_SELECTED_ELEMENT";
  return ElementsActionTypes2;
})(ElementsActionTypes || {});
var elementsReducer = (state, action) => {
  switch (action.type) {
    case "SET_TREE_DATA" /* SET_TREE_DATA */:
      return { ...state, treeData: action.payload };
    case "SET_SEARCH_TERM" /* SET_SEARCH_TERM */:
      return { ...state, searchTerm: action.payload };
    case "SET_SELECTED_ELEMENTS" /* SET_SELECTED_ELEMENTS */:
      return { ...state, selectedElements: action.payload };
    case "SET_CONTAINER_HEIGHT" /* SET_CONTAINER_HEIGHT */:
      return { ...state, containerHeight: action.payload };
    case "SET_SELECTED_ELEMENT" /* SET_SELECTED_ELEMENT */:
      return {
        ...state,
        selectedElement: action.payload
      };
    default:
      return state;
  }
};
var ElementsProvider = ({
  children
}) => {
  const [state, dispatch] = useReducer(elementsReducer, initialState3);
  return /* @__PURE__ */ jsx(ElementsContext.Provider, { value: { state, dispatch }, children });
};
var useElements = () => {
  const context = useContext(ElementsContext);
  if (!context) {
    throw new Error("useElements must be used within an ElementsProvider");
  }
  return context;
};

// src/components/element-tree/utils/tree-utils.ts
var updateTreeElement = (treeData, elementId, updates) => {
  return treeData.map((element) => {
    if (element.id == elementId) {
      return {
        ...element,
        ...updates,
        tags: updates.tags || element.tags || []
      };
    }
    if (element.children) {
      return {
        ...element,
        children: updateTreeElement(element.children, elementId, updates)
      };
    }
    return element;
  });
};

// src/components/element-tree/utils/adapter.ts
var transformTreeData = (data) => {
  if (!data) {
    return [];
  }
  const transformNode = (node) => {
    return {
      id: String(node.id),
      name: node.name || "unNamed",
      control_type: node?.controlType || node.control_type,
      technology: node.technology,
      properties: node.properties || [],
      createdById: node.createdById,
      updatedById: node.updatedById,
      createdAt: node.createdAt,
      updatedAt: node.updatedAt,
      tags: node.tags || [],
      children: (node.children || []).map((child) => transformNode(child))
    };
  };
  const elements = data.elements || data;
  const elementsArray = Array.isArray(elements) ? elements : [elements];
  return elementsArray.filter(Boolean).map(transformNode);
};
var getElementTreeData = (response) => {
  if (!response) {
    return [];
  }
  return transformTreeData(response);
};

// src/components/element-tree/hooks/use-element-actions.ts
var useElementActions = (elements) => {
  const { dispatch } = useElements();
  const loadElements = useCallback(async () => {
    try {
      dispatch({
        type: "SET_TREE_DATA" /* SET_TREE_DATA */,
        payload: transformTreeData(elements)
      });
    } catch (error) {
      console.error("Error transforming elements:", error);
    }
  }, [dispatch, elements]);
  return { loadElements };
};

// src/components/element-tree/hooks/use-element-tree.ts
var useElementTree = ({
  onElementSelect,
  elements
}) => {
  const treeRef = useRef(null);
  const { state, dispatch } = useElements();
  const { searchTerm, containerHeight, treeData, selectedElement } = state;
  const { loadElements } = useElementActions(elements);
  const { handleScroll } = useHighlight(treeRef, searchTerm, ".element-view");
  const updateHeight = () => {
    dispatch({
      type: "SET_CONTAINER_HEIGHT" /* SET_CONTAINER_HEIGHT */,
      payload: window.innerHeight - 200
    });
  };
  const searchMatch = useCallback((node, term) => {
    const matchSearch = (currentNode) => {
      if (currentNode.data.name.toLowerCase().includes(term.toLowerCase())) {
        return true;
      } else if (currentNode.parent?.data.name) {
        return matchSearch(currentNode.parent);
      }
      return false;
    };
    return matchSearch(node);
  }, []);
  useEffect(() => {
    if (elements) {
      loadElements();
      updateHeight();
    }
  }, [elements]);
  useEffect(() => {
    if (selectedElement && onElementSelect) {
      onElementSelect(selectedElement);
    }
  }, [selectedElement, onElementSelect]);
  return {
    treeRef,
    state: {
      searchTerm,
      containerHeight,
      treeData,
      selectedElement
    },
    handlers: {
      handleScroll,
      searchMatch
    }
  };
};
var NoDataPlaceholder = () => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
    Empty,
    {
      description: /* @__PURE__ */ jsx("div", { className: "flex flex-col gap-y-4", children: /* @__PURE__ */ jsx("div", { children: t("common.static.desktop.no.elements") }) }),
      imageSource: noData
    }
  ) });
};

// src/utils/element-icons.ts
var ELEMENT_ICON_MAP = {
  APOGrid: "grid-view",
  Button: "tree-list",
  Calendar: "calender-month",
  CheckBox: "check-box",
  ComboBox: "desktop-combobox",
  Dropdown: "desktop-combobox",
  DataGrid: "grid-view",
  Editor: "edit-pencil",
  TextArea: "edit-pencil",
  EditField: "edit-square",
  TextField: "edit-square",
  Grid: "grid-view",
  GuiSession: "subtitles",
  Label: "label",
  List: "list",
  ListItem: "list",
  MenuBar: "desktop-menubar",
  NumberField: "123",
  OKCode: "code",
  ProgressBar: "progress-activity",
  RadioButton: "radio-button-checked",
  ScrollBar: "scroll-action",
  Spinner: "loader",
  StatusBar: "chart-data",
  TabControl: "select_window",
  TabItem: "select-window",
  Table: "desktop-table-chart",
  Thumb: "thumb-up",
  ToolTip: "info",
  Tree: "account-tree",
  TreeItem: "account-tree",
  TreeView: "account-tree",
  URL: "link-horizontal",
  Window: "tree-list",
  OkCode: "desktop-okcode",
  Text: "abc",
  ToolBar: "tree-folder",
  Tab: "select-window",
  TitleBar: "tree-folder",
  SplitButton: "splitscreen",
  Slider: "sliders",
  Separator: "separator",
  Menu: "windows-menu",
  MenuItem: "windows-menu",
  Image: "photo",
  Hyperlink: "windows-link",
  HeaderItem: "windows-menu",
  Group: "apps",
  Document: "article",
  default: "desktop-generic"
};
var getElementIcon = (controlType) => {
  return ELEMENT_ICON_MAP[controlType] || ELEMENT_ICON_MAP.default;
};
var TreeNode2 = ({
  node,
  searchTerm,
  selectedBgColor = "bg-shades-50",
  onEdit,
  showEditIcon = false
}) => {
  const hasChildren = node.data.children?.length > 0;
  const isRootNode = node.level === 0;
  const { dispatch } = useContext(ElementsContext);
  const highlightText = useCallback((text, term) => {
    if (!term || !text) return text;
    try {
      const escapedTerm = escapeRegExp(term);
      const parts = text.split(new RegExp(`(${escapedTerm})`, "gi"));
      return parts.map(
        (part, index) => part.toLowerCase() === term.toLowerCase() ? /* @__PURE__ */ jsx("span", { className: "bg-warning-100 rounded px-0.5", children: part }, index) : part
      );
    } catch {
      return text;
    }
  }, []);
  const handleToggle = useCallback(
    (e) => {
      e.stopPropagation();
      if (hasChildren && node.toggle) {
        node.toggle();
      }
    },
    [hasChildren, node]
  );
  const renderNodeName = useCallback(
    () => /* @__PURE__ */ jsx(
      TruncatedText,
      {
        className: "text-sm font-medium text-secondary-700",
        value: searchTerm ? highlightText(node.data.name, searchTerm) : node.data.name
      }
    ),
    [node.data.name, searchTerm, highlightText]
  );
  const debouncedDispatch = useCallback(
    (data) => {
      dispatch({
        type: "SET_SELECTED_ELEMENT" /* SET_SELECTED_ELEMENT */,
        payload: data
      });
    },
    [dispatch]
  );
  const handleNodeClick = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (node.select) {
        if (node.tree.selectedNodes.length > 0) {
          node.tree.deselectAll();
        }
        node.select();
        debounce(debouncedDispatch, 300)(node.data);
      }
    },
    [node, debouncedDispatch]
  );
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames82(
        "flex items-center justify-between w-full pl-2 mx-1 tree-node  group min-w-72",
        node.isSelected && [selectedBgColor, "border  rounded-md"],
        showEditIcon ? "py-0.5" : "py-1"
      ),
      onClick: handleNodeClick,
      "data-type": node.data.control_type,
      children: [
        /* @__PURE__ */ jsxs("div", { className: "flex items-center truncate", children: [
          /* @__PURE__ */ jsx(
            Icon,
            {
              name: "arrow-downward-filled",
              className: classNames82(
                "mr-1 text-secondary-500 cursor-pointer text-lg transform transition-transform",
                node.isOpen ? "-rotate-0" : "-rotate-90",
                hasChildren ? "visible" : "invisible"
              ),
              onClick: handleToggle
            }
          ),
          isRootNode ? /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(
              Icon,
              {
                name: `${node?.data?.technology == "UIA" ? "tree-folder" : "sap-logo"}`,
                className: classNames82(
                  " mr-2 text-xl",
                  node?.data?.technology == "UIA" ? "text-secondary-500" : "text-secondary-unique-200"
                )
              }
            ),
            renderNodeName()
          ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
            !hasChildren && /* @__PURE__ */ jsx(
              Icon,
              {
                name: getElementIcon(node.data.control_type),
                className: "text-secondary-500 mr-2 w-4 h-4"
              }
            ),
            renderNodeName()
          ] })
        ] }),
        showEditIcon && /* @__PURE__ */ jsx(
          Icon,
          {
            name: "edit",
            className: "text-secondary-500 border bg-white border-secondary-200 rounded-md p-1 cursor-pointer opacity-0 group-hover:opacity-100 mr-2",
            onClick: (e) => {
              handleNodeClick(e);
              onEdit?.(node.data);
            }
          }
        )
      ]
    }
  );
};
var TreeRow = ({
  node,
  attrs,
  innerRef,
  searchTerm,
  selectedBgColor,
  showEditIcon,
  onEdit
}) => /* @__PURE__ */ jsx(
  "div",
  {
    ...attrs,
    style: {
      ...attrs.style,
      paddingLeft: node.level * 24
    },
    ref: innerRef,
    onKeyDown: (e) => e.stopPropagation(),
    className: classNames82(
      "flex items-center h-full cursor-pointer group focus:outline-none",
      node.isSelected ? selectedBgColor ? "bg-white" : "bg-secondary-100" : "hover:bg-secondary-100 hover:rounded-md  "
    ),
    children: /* @__PURE__ */ jsx(
      TreeNode2,
      {
        node,
        searchTerm,
        selectedBgColor,
        showEditIcon,
        onEdit
      }
    )
  }
);
var TreeContent = forwardRef(
  (props, ref) => {
    const {
      treeData,
      containerHeight,
      searchTerm,
      handleScroll,
      searchMatch,
      containerWidth,
      selectedBgColor,
      showEditIcon,
      onEdit,
      contextId
    } = props;
    const [rootElement, setRootElement] = useState(null);
    useEffect(() => {
      const element = document.getElementById(contextId);
      if (element) {
        setRootElement(element);
      }
    }, [contextId]);
    if (!treeData?.length) {
      return /* @__PURE__ */ jsx(
        "div",
        {
          className: classNames82(
            "flex items-center justify-center h-[500px]",
            containerWidth ? "" : "w-[500px]"
          ),
          children: /* @__PURE__ */ jsx(NoDataPlaceholder, {})
        }
      );
    }
    return /* @__PURE__ */ jsx(
      DndProvider,
      {
        backend: HTML5Backend,
        options: { rootElement },
        children: /* @__PURE__ */ jsx(
          Tree,
          {
            ref,
            data: treeData,
            renderRow: (rowProps) => /* @__PURE__ */ jsx(
              TreeRow,
              {
                ...rowProps,
                searchTerm,
                selectedBgColor,
                showEditIcon,
                onEdit
              }
            ),
            openByDefault: false,
            selectionFollowsFocus: false,
            paddingBottom: 10,
            paddingTop: 5,
            disableDrag: true,
            disableDrop: true,
            overscanCount: 15,
            rowHeight: 35,
            height: containerHeight,
            width: containerWidth ?? 500,
            searchTerm,
            onScroll: searchTerm ? handleScroll : void 0,
            searchMatch
          },
          "element-tree"
        )
      }
    );
  }
);
TreeContent.displayName = "TreeContent";
var ElementTree = ({
  onElementSelect,
  containerWidth,
  selectedBgColor,
  elements,
  showEditIcon,
  onEdit,
  searchTerm,
  expandAll,
  collapseAll,
  containerHeight: providedHeight
}) => {
  const {
    treeRef,
    state: { containerHeight: defaultHeight, treeData },
    handlers: { handleScroll, searchMatch }
  } = useElementTree({ onElementSelect, elements });
  const containerHeight = providedHeight || defaultHeight;
  const { dispatch } = useElements();
  const handleExpandAll = () => {
    if (treeRef.current) {
      treeRef.current.openAll();
    }
  };
  const handleCollapseAll = () => {
    if (treeRef.current) {
      treeRef.current.closeAll();
    }
  };
  useEffect(() => {
    if (expandAll && typeof expandAll === "number" && expandAll > 0) {
      handleExpandAll();
    }
  }, [expandAll]);
  useEffect(() => {
    if (collapseAll && typeof collapseAll === "number" && collapseAll > 0) {
      handleCollapseAll();
    }
  }, [collapseAll]);
  useEffect(() => {
    if (searchTerm !== void 0) {
      dispatch({
        type: "SET_SEARCH_TERM" /* SET_SEARCH_TERM */,
        payload: searchTerm
      });
    }
  }, [searchTerm]);
  return /* @__PURE__ */ jsx("div", { id: "element-tree-view", children: /* @__PURE__ */ jsx(
    TreeContent,
    {
      treeData,
      ref: treeRef,
      containerHeight,
      searchTerm,
      handleScroll,
      searchMatch,
      containerWidth,
      selectedBgColor,
      showEditIcon,
      onEdit,
      contextId: "element-tree-view"
    }
  ) });
};
var ElementTreeView = (props) => {
  return /* @__PURE__ */ jsx(ElementsProvider, { children: /* @__PURE__ */ jsx(ElementTree, { ...props }) });
};
var { Input: Input26 } = V2;
var TreeSearch = ({
  searchTerm,
  onChange,
  onClear
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx("div", { className: "flex items-center justify-between py-3 px-4", children: /* @__PURE__ */ jsx(
    Input26,
    {
      type: "text",
      hasError: false,
      className: "w-[95%] !h-8",
      placeholder: t("common.search"),
      wrapperClassName: "flex-1",
      addonAfter: searchTerm && /* @__PURE__ */ jsx(
        Icon,
        {
          name: "close",
          className: "text-shades-50 bg-secondary-500 p-[1px] text-[10px] cursor-pointer rounded-full",
          onClick: onClear
        }
      ),
      value: searchTerm,
      onChange
    }
  ) });
};

// src/components/test-recorder/api/desktop-elements.ts
var elementList = `${PrivateURLConstants.ELEMENTS}/windows_elements`;
var elementUpdate = `${PrivateURLConstants.ELEMENTS}/windows_element`;
var getAll19 = async ({
  applicationVersionId,
  offset = 0,
  sort = "name,asc"
}) => {
  const url = `${elementList}/${applicationVersionId}`;
  return instance_default.get(url, {
    page: offset,
    sort
  });
};
var update4 = async (element) => {
  return instance_default.put(elementUpdate, element);
};
var updateElementCache = (queryClient2, queryKey, updatedElement) => {
  const currentData = queryClient2.getQueryData(queryKey);
  if (!currentData) return;
  const updatedTreeData = updateTreeElement(
    currentData.content,
    updatedElement.id,
    updatedElement
  );
  queryClient2.setQueryData(queryKey, {
    ...currentData,
    content: updatedTreeData
  });
};
var useQueryDesktopElements = ({
  applicationVersionId,
  offset = 0,
  sort = "name,asc",
  enabled = true
}) => {
  return useQuery$1(
    ["desktop-elements", applicationVersionId, offset, sort],
    () => getAll19({ applicationVersionId, offset, sort }),
    {
      enabled: enabled && !!applicationVersionId,
      keepPreviousData: true
    }
  );
};
var useUpdateDesktopElement = ({
  applicationVersionId,
  onSuccess,
  onError
}) => {
  const queryClient2 = useQueryClient$1();
  const { mutate: updateElement } = useMutation(update4, {
    onSuccess: (data, updatedElement) => {
      updateElementCache(
        queryClient2,
        ["desktop-elements", applicationVersionId, 0, "name,asc"],
        updatedElement
      );
      queryClient2.invalidateQueries(["desktop-elements", applicationVersionId]);
      onSuccess?.();
    },
    onError: (error) => {
      const DUPLICATE_ERROR_MESSAGE = "Element with same name already exist";
      if (error?.response?.data?.error === DUPLICATE_ERROR_MESSAGE) {
        onError?.(error?.response?.data?.error);
      } else {
        const errorMessage = error?.response?.data?.error || error?.message || "Failed to update element";
        onError?.(errorMessage);
      }
    }
  });
  return { updateElement };
};
var DesktopElementsApi = {
  getAll: getAll19,
  useQueryDesktopElements,
  useUpdateDesktopElement
};
var { Input: Input27 } = V2;
var DetailRow = ({
  label,
  value,
  className,
  showEdit = true,
  withBackground = true,
  onSave
}) => {
  const { t } = useTranslation();
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(value);
  const inputRef = useRef(null);
  const handleSave = () => {
    if (editValue !== value && editValue.trim()) {
      onSave?.(editValue);
    }
    setIsEditing(false);
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSave();
    } else if (e.key === "Escape") {
      setEditValue(value);
      setIsEditing(false);
    }
  };
  const handleCancel = () => {
    setEditValue(value);
    setIsEditing(false);
  };
  return /* @__PURE__ */ jsxs("div", { className: classNames82("mt-4", className), children: [
    /* @__PURE__ */ jsxs("div", { className: "flex justify-between items-center mb-2", children: [
      /* @__PURE__ */ jsx("span", { className: "text-sm text-secondary-text font-semibold", children: t(label) }),
      showEdit && /* @__PURE__ */ jsx(Fragment, { children: !isEditing ? /* @__PURE__ */ jsxs(
        "div",
        {
          className: "text-2xs leading-3 text-secondary-500 flex items-center gap-x-1 cursor-pointer hover:text-secondary-700",
          onClick: () => setIsEditing(true),
          children: [
            /* @__PURE__ */ jsx(Icon, { name: "edit-pencil" }),
            t("common.edit")
          ]
        }
      ) : /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-x-2", children: [
        /* @__PURE__ */ jsx(
          Icon,
          {
            name: "check-circle",
            className: "text-primary-500 text-base cursor-pointer",
            toolTip: t("common.update"),
            tootTipClassName: "flex",
            onClick: handleSave
          }
        ),
        /* @__PURE__ */ jsx(
          Icon,
          {
            name: "cancel",
            className: "text-error-500 text-base cursor-pointer",
            toolTip: t("common.cancel"),
            tootTipClassName: "flex",
            onClick: handleCancel
          }
        )
      ] }) })
    ] }),
    isEditing ? /* @__PURE__ */ jsx(
      Input27,
      {
        ref: inputRef,
        type: "text",
        value: editValue,
        onChange: (e) => setEditValue(e.target.value),
        className: "flex-grow",
        wrapperClassName: "w-full",
        autoFocus: true,
        onKeyDown: handleKeyDown
      }
    ) : /* @__PURE__ */ jsx(
      TruncatedText,
      {
        value,
        className: classNames82(
          "!text-sm !text-secondary-900 !font-medium inline-block",
          withBackground ? "p-2 bg-secondary-50 rounded-md" : "mt-2"
        )
      }
    )
  ] });
};
var getTableColumns = (t) => [
  {
    accessorKey: "name",
    header: () => /* @__PURE__ */ jsx("span", { className: "text-sm text-secondary-text font-semibold", children: t("element.locator.property") }),
    cell: (info) => /* @__PURE__ */ jsx("div", { className: "text-sm font-normal text-secondary-unique-600", children: info.getValue() })
  },
  {
    accessorKey: "value",
    header: () => /* @__PURE__ */ jsx("span", { className: "text-sm text-secondary-text font-semibold", children: t("common.static.desktop.entity.value") }),
    cell: (info) => /* @__PURE__ */ jsx("div", { className: "text-sm", children: info.getValue() })
  }
];
var PropertiesTable = ({
  properties
}) => {
  const { t } = useTranslation();
  const columns = getTableColumns(t);
  const table = useReactTable({
    data: properties,
    columns,
    getCoreRowModel: getCoreRowModel()
  });
  return /* @__PURE__ */ jsx("div", { className: "border rounded-md mt-2", children: /* @__PURE__ */ jsx("div", { className: "max-h-[300px] overflow-auto", children: /* @__PURE__ */ jsxs("table", { className: "w-full border-separate border-spacing-0", children: [
    /* @__PURE__ */ jsx("thead", { className: "sticky top-0 bg-secondary-50 z-10", children: table.getHeaderGroups().map((headerGroup) => /* @__PURE__ */ jsx(
      "tr",
      {
        className: "border-b border-secondary-200",
        children: headerGroup.headers.map((header, index) => /* @__PURE__ */ jsx(
          "th",
          {
            className: classNames82("p-3 text-left bg-secondary-50", {
              "border-l border-secondary-200": index > 0
            }),
            children: flexRender(
              header.column.columnDef.header,
              header.getContext()
            )
          },
          header.id
        ))
      },
      headerGroup.id
    )) }),
    /* @__PURE__ */ jsx("tbody", { children: table.getRowModel().rows.map((row, rowIndex) => /* @__PURE__ */ jsxs(React5__default.Fragment, { children: [
      /* @__PURE__ */ jsx("tr", { className: "!border-l border-secondary-900", children: row.getVisibleCells().map((cell, index) => /* @__PURE__ */ jsx(
        "td",
        {
          className: classNames82(
            "p-3",
            index === 0 ? "w-2/5" : "w-3/5",
            {
              "border-l border-secondary-200": index > 0
            }
          ),
          children: flexRender(
            cell.column.columnDef.cell,
            cell.getContext()
          )
        },
        cell.id
      )) }),
      rowIndex !== table.getRowModel().rows.length - 1 && /* @__PURE__ */ jsx("tr", { children: /* @__PURE__ */ jsx("td", { colSpan: row.getVisibleCells().length, children: /* @__PURE__ */ jsx("hr", { className: "border-l border-secondary-200" }) }) })
    ] }, row.id)) })
  ] }) }) });
};
var ElementDetails = ({
  selectedElement,
  onElementUpdate,
  showTitle = true,
  timeStampNode,
  chipInputNode
}) => {
  const { t } = useTranslation();
  const handleSave = debounce$1((field, value) => {
    if (!selectedElement) return;
    const updatedElement = {
      ...selectedElement,
      [field]: value.trim()
    };
    onElementUpdate(updatedElement);
  }, 10);
  if (!selectedElement) return null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    showTitle && /* @__PURE__ */ jsx(
      TruncatedText,
      {
        value: selectedElement.name,
        className: "!text-lg !font-semibold  p-4 inline-block  pb-0"
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-4 p-5", children: [
      /* @__PURE__ */ jsx(
        DetailRow,
        {
          label: "label.element_title",
          value: selectedElement.name,
          onSave: (value) => handleSave("name", value)
        },
        selectedElement.name
      ),
      /* @__PURE__ */ jsxs("div", { className: "flex gap-4 mt-2", children: [
        /* @__PURE__ */ jsxs("div", { className: "flex-1", children: [
          /* @__PURE__ */ jsx("span", { className: "text-sm text-secondary-text font-semibold", children: t("element.list.element_type") }),
          /* @__PURE__ */ jsx("div", { className: "mt-2 text-sm text-secondary-900 font-medium", children: selectedElement.control_type })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "flex-1", children: [
          /* @__PURE__ */ jsx("span", { className: "text-sm text-secondary-text font-semibold", children: t("element.list.technology") }),
          /* @__PURE__ */ jsx("div", { className: "mt-2 text-sm text-secondary-900 font-medium", children: selectedElement.technology })
        ] })
      ] }),
      selectedElement?.properties && /* @__PURE__ */ jsx(PropertiesTable, { properties: selectedElement.properties }),
      chipInputNode,
      timeStampNode
    ] })
  ] });
};
var { Button: ButtonV212, BUTTON_VARIANTS: BUTTON_VARIANTS15 } = V2;
var searchOptions = [
  { key: "ELEMENT", value: "ELEMENT", label: "Element" },
  { key: "SCREEN", value: "SCREEN", label: "Screen" }
];
function UiIdentifiersBody({
  uiIdentifiers,
  onSelect,
  onSearchByName,
  onSearchByScreenName,
  onPaginate,
  onDelete,
  onRefresh,
  currentElementName,
  nlpId,
  onElementSelect,
  isLoading = false,
  isDebugMode = false
}) {
  const { appType, appVersionId } = useSelector(
    (state) => state.widget
  );
  const [selectedElement, setSelectedElement] = useState(
    null
  );
  const [isEditMode, setIsEditMode] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [containerWidth, setContainerWidth] = useState(window.innerWidth - 30);
  const [containerHeight, setContainerHeight] = useState(window.innerHeight);
  const [showToast, setShowToast] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  const [toastType, setToastType] = useState(
    TOAST_TYPE.SUCCESS
  );
  const [searchByName, setSearchByName] = useState("");
  const [searchByScreenName, setSearchByScreenName] = useState("");
  const [searchType, setSearchType] = useState("ELEMENT");
  const handleSearchByName = (name) => {
    setSearchByName(name);
    setSearchByScreenName("");
    onSearchByName(name);
  };
  const handleSearchByScreenName = (name) => {
    setSearchByScreenName(name);
    setSearchByName("");
    onSearchByScreenName(name);
  };
  const { updateElement } = DesktopElementsApi.useUpdateDesktopElement({
    applicationVersionId: appVersionId || 0,
    onSuccess: () => {
      setShowToast(true);
      setToastMsg("Element updated successfully");
      setToastType(TOAST_TYPE.SUCCESS);
      setIsEditMode(false);
    },
    onError: (error) => {
      setShowToast(true);
      setToastMsg(error);
      setToastType(TOAST_TYPE.ERROR);
    }
  });
  useEffect(() => {
    const handleResize = () => {
      setContainerWidth(window.innerWidth - 30);
      setContainerHeight(window.innerHeight);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const handleElementSelect = useCallback(
    (element) => {
      setSelectedElement(element);
      onElementSelect?.(element);
    },
    [onElementSelect]
  );
  const handleElementEdit = useCallback((element) => {
    setSelectedElement(element);
    setIsEditMode(true);
  }, []);
  const handleElementUpdate = useCallback(
    (updatedElement) => {
      updateElement({
        ...updatedElement,
        name: updatedElement.name
      });
    },
    [updateElement]
  );
  const handleSearchChange = useCallback(
    (e) => {
      setSearchTerm(e.target.value);
    },
    []
  );
  const handleClear = useCallback(() => {
    setSearchTerm("");
  }, []);
  const handleAddToStep = useCallback(() => {
    if (selectedElement) {
      const uiIdentifier = {
        id: Number(selectedElement.id),
        name: selectedElement.name,
        definition: "",
        applicationVersionId: appVersionId || 0,
        screenNameId: 0,
        locatorType: "",
        createdType: ""
      };
      onSelect(uiIdentifier);
    }
  }, [selectedElement, onSelect, appVersionId]);
  const uiIdentifiersArray = Array.isArray(uiIdentifiers) ? uiIdentifiers : [];
  if (appType === ApplicationType.WINDOWS_ADVANCED) {
    if (isEditMode && selectedElement) {
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("div", { className: "flex flex-col h-full", children: /* @__PURE__ */ jsx("div", { className: "flex-1 p-4 overflow-y-auto", children: /* @__PURE__ */ jsx(
          ElementDetails,
          {
            selectedElement,
            onElementUpdate: handleElementUpdate,
            timeStampNode: null,
            chipInputNode: ""
          }
        ) }) }),
        /* @__PURE__ */ jsx(
          UiToast,
          {
            isShow: showToast,
            message: toastMsg,
            type: toastType,
            onClose: () => setShowToast(false)
          }
        )
      ] });
    }
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("div", { className: "flex flex-col h-full", children: [
        /* @__PURE__ */ jsx("div", { className: "flex-none px-1", children: /* @__PURE__ */ jsx(
          TreeSearch,
          {
            searchTerm,
            onChange: handleSearchChange,
            onClear: handleClear
          }
        ) }),
        /* @__PURE__ */ jsx("div", { className: "flex-1 p-0 overflow-y-auto", children: isLoading ? /* @__PURE__ */ jsx("div", { className: "p-4", children: /* @__PURE__ */ jsx("div", { className: "space-y-3", children: Array.from({ length: 8 }, (_, i) => /* @__PURE__ */ jsxs("div", { className: "flex items-center space-x-3", children: [
          /* @__PURE__ */ jsx(ShimmerLoader, { className: "w-4 h-4 rounded" }),
          /* @__PURE__ */ jsx(ShimmerLoader, { className: "flex-1 h-4 rounded" })
        ] }, i)) }) }) : /* @__PURE__ */ jsx("div", { className: "pl-4", children: /* @__PURE__ */ jsx(
          ElementTreeView,
          {
            selectedElement,
            onElementSelect: handleElementSelect,
            onEdit: handleElementEdit,
            containerWidth,
            elements: uiIdentifiersArray,
            selectedBgColor: "bg-secondary-50 border border-secondary-400 rounded-md",
            searchTerm,
            showEditIcon: true
          }
        ) }) }),
        /* @__PURE__ */ jsx("div", { className: "flex-none p-4 border-t border-gray-200", children: /* @__PURE__ */ jsx("div", { className: "flex justify-end", children: /* @__PURE__ */ jsx(
          ButtonV212,
          {
            onClick: handleAddToStep,
            disabled: !selectedElement || isLoading,
            variant: BUTTON_VARIANTS15.PRIMARY,
            children: "Add to Step"
          }
        ) }) })
      ] }),
      /* @__PURE__ */ jsx(
        UiToast,
        {
          isShow: showToast,
          message: toastMsg,
          type: toastType,
          onClose: () => setShowToast(false)
        }
      )
    ] });
  }
  const renderInput = () => {
    const onChange = searchType == "ELEMENT" ? handleSearchByName : handleSearchByScreenName;
    const placeholder = searchType == "ELEMENT" ? "Search by name" : "Search by screen name";
    const setSearchBy = (value) => {
      setSearchType(value ? "SCREEN" : "ELEMENT");
    };
    const isSearchByScreenName = searchType === "SCREEN";
    if (isDebugMode) {
      return /* @__PURE__ */ jsx(
        Input,
        {
          wrapperClassName: "w-full",
          onChange,
          prefix: /* @__PURE__ */ jsx("div", { className: "flex flex-col justify-center ml-3 text-secondary-600", children: /* @__PURE__ */ jsx(Icon, { name: "search", className: "text-2xl" }) }),
          placeholder,
          suffix: !uiIdentifiersArray[0]?.technology && /* @__PURE__ */ jsx(
            element_searchby_dropdown_default,
            {
              setSearchBy,
              isSearchByScreenName
            }
          ),
          labelClassName: "align-left"
        },
        "search-input"
      );
    }
    return /* @__PURE__ */ jsx(
      UiTextField,
      {
        value: searchType == "ELEMENT" ? searchByName : searchByScreenName,
        onChange,
        placeholder,
        inputProps: {
          startAdornment: /* @__PURE__ */ jsx(SearchOutlineIcon_default, { className: "fill-slate-550 h-11 stroke-slate-550 w-fit pr-3.5 py-3.5 pl-0" }),
          endAdornment: /* @__PURE__ */ jsx(
            UiSelect,
            {
              items: searchOptions,
              onChange: setSearchType,
              value: searchType,
              variant: "outlined",
              className: "w-4/12 without-border"
            }
          )
        },
        variant: "outlined"
      }
    );
  };
  const mainContent = /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames82("flex flex-col overflow-hidden p-4.5 space-y-5 h-full", {
        "pt-0 space-y-2": isDebugMode
      }),
      children: [
        /* @__PURE__ */ jsx("div", { className: "flex flex-row items-center h-11 gap-x-2", children: renderInput() }),
        /* @__PURE__ */ jsx(
          UiIdentifierList,
          {
            onSelect: (uiIdentifier) => onSelect(uiIdentifier),
            uiIdentifiers: uiIdentifiersArray,
            onPaginate: () => onPaginate(),
            onDelete: (seq) => onDelete(seq),
            onRefresh: () => onRefresh(),
            currentElementName,
            nlpId
          }
        )
      ]
    }
  );
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    mainContent,
    /* @__PURE__ */ jsx(
      UiToast,
      {
        isShow: showToast,
        message: toastMsg,
        type: toastType,
        onClose: () => setShowToast(false)
      }
    )
  ] });
}
function ActionsDrawer({
  onSelect,
  onClose
}) {
  const { t } = useTranslation();
  const [debouncedSearchKey, setDebouncedSearchKey] = useState("");
  const { appVersionId, appType } = useSelector(
    (state) => state.widget
  );
  const animationClass = useAnimatedClass("reval-animation-opacity");
  const debouncedSetSearch = useMemo(
    () => debounce$2((value) => setDebouncedSearchKey(value), 300),
    []
  );
  const { data: actions = [], isLoading } = DesktopActionsApi.useQueryDesktopActions({
    applicationType: appType,
    searchKey: debouncedSearchKey || void 0,
    applicationVersionId: appVersionId,
    enabled: !!appVersionId
  });
  const fetchActions = useCallback(
    (query) => {
      debouncedSetSearch(query || "");
    },
    [debouncedSetSearch]
  );
  const handleActionSelect = useCallback(
    (action) => {
      onSelect(action);
    },
    [onSelect]
  );
  return /* @__PURE__ */ jsx(
    OverlayContainer,
    {
      title: t("step.switch.actions"),
      onClose,
      body: /* @__PURE__ */ jsx("div", { className: classNames82("px-5 py-6 h-full", animationClass), children: /* @__PURE__ */ jsx(
        ActionsValueSelector,
        {
          actions,
          onClick: handleActionSelect,
          isFetching: isLoading,
          fetchActions
        }
      ) }),
      noBodyWrapper: true
    }
  );
}
function UiIdentifiers({
  onSelectUiIdentifier,
  onClose,
  currentElementName,
  previousElementName,
  nlpId = null,
  isDebugMode = false
}) {
  const { t } = useTranslation();
  const { sendToBackground: sendToBackground2, sendToWidget } = useMessaging();
  const [uiIdentifiers, setUiIdentifiers2] = useState([]);
  const [filteredUiIdentifiers, setFilteredUiIdentifiers] = useState([]);
  const [showFiltered, setShowFiltered] = useState(false);
  const [searchNameKey, setSearchNameKey] = useState("");
  const [searchScreenNameKey, setSearchScreenNameKey] = useState("");
  const [offset, setOffset] = useState(0);
  const [showCreateElement, setShowCreateElement] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  const [toastType, setToastType] = useState(
    TOAST_TYPE.SUCCESS
  );
  const [showActionsDrawer, setShowActionsDrawer] = useState(false);
  const initiatedTime = useRef(0);
  const { appVersionId, recorderState, appType } = useSelector(
    (state) => state.widget
  );
  const loadingRef = useRef(false);
  const isWindowsAdvanced = isObjectBased(appType);
  const { data: desktopElementsData, isLoading: isDesktopElementsLoading } = useQueryDesktopElements({
    applicationVersionId: appVersionId || 0,
    offset: 0,
    sort: "name,asc",
    enabled: isWindowsAdvanced && !!appVersionId
  });
  useEffect(() => {
    const elementsData = isWindowsAdvanced ? desktopElementsData : null;
    if (elementsData?.content) {
      const reorderedList = reorderUiIdentifierList(elementsData.content);
      setUiIdentifiers2(reorderedList);
    }
  }, [desktopElementsData, isWindowsAdvanced, currentElementName]);
  useEffect(() => {
    if (!isWindowsAdvanced) {
      loadUiIdentifiers(0, true);
    }
    if (recorderState !== RECORDER_STATE.HOLD) {
      sendToBackground2({
        context: MESSAGE_CONTEXT.STATE,
        action: MESSAGE_CONTEXT_ACTION.UPDATE,
        value: RECORDER_STATE.HOLD
      });
    }
    return () => {
      resumeOnClose();
    };
  }, [isWindowsAdvanced]);
  const reorderUiIdentifierList = (uiIdentifierList) => {
    if (currentElementName && uiIdentifierList?.length) {
      const currentUiIdentifier = uiIdentifierList.filter(
        (uiIdentifier) => uiIdentifier.name == currentElementName
      )?.[0];
      if (currentUiIdentifier) {
        const reorderedUiIdentifierList = [
          currentUiIdentifier,
          ...uiIdentifierList.filter(
            (uiIdentifier) => uiIdentifier.name != currentElementName
          )
        ];
        uiIdentifierList = reorderedUiIdentifierList;
      }
    }
    return uiIdentifierList;
  };
  useEffect(() => {
    if (!isWindowsAdvanced) {
      loadUiIdentifiers(0, false, true);
    }
  }, [currentElementName, previousElementName, isWindowsAdvanced]);
  const loadUiIdentifiers = (pageOffset = 0, isFresh = false, elementNameChanged = false) => {
    if (!appVersionId) return Promise.resolve();
    let param;
    if (!isFresh && (currentElementName || previousElementName)) {
      param = `shadowParentId:null,previousStepElementName:${replaceSpecialCharWithDescText(
        currentElementName || previousElementName
      )}`;
    }
    if (appVersionId) {
      if (isWindowsAdvanced) {
        return DesktopElementsApi.getAll({
          applicationVersionId: appVersionId,
          offset: pageOffset,
          sort: "name,asc"
        }).then((uiIdentifierData) => {
          const uiIdentifierList = [
            ...isFresh || elementNameChanged ? [] : uiIdentifiers,
            ...uiIdentifierData.content
          ];
          if (isFresh) {
            setUiIdentifiers2(reorderUiIdentifierList(uiIdentifierList));
          } else {
            setUiIdentifiers2(uiIdentifierList);
          }
        });
      } else {
        return UiIdentifierApi.getAll({
          offset: pageOffset,
          appVersionId,
          param,
          sort: "name,asc"
        }).then((uiIdentifierData) => {
          const uiIdentifierList = [
            ...isFresh || elementNameChanged ? [] : uiIdentifiers,
            ...uiIdentifierData.content
          ];
          if (isFresh) {
            setUiIdentifiers2(reorderUiIdentifierList(uiIdentifierList));
          } else {
            setUiIdentifiers2(uiIdentifierList);
          }
        }).catch((e) => {
          if (e?.status === 401) {
            showUiToast(
              "Failed to load elements list. Please ensure third-party cookies are enabled while recording.",
              "warning"
            );
          }
        });
      }
    }
  };
  const loadFilteredUiIdentifiers = useMemo(
    () => debounce$2((pageOffset = 0, param, isFresh = false) => {
      if (appVersionId) {
        const initiatedAt = initiatedTime.current = Date.now();
        const apiCall = isWindowsAdvanced ? DesktopElementsApi.getAll({
          applicationVersionId: appVersionId,
          offset: pageOffset,
          sort: "name,asc"
        }) : UiIdentifierApi.getAll({
          offset: pageOffset,
          param,
          appVersionId,
          sort: "name,asc"
        });
        apiCall.then((uiIdentifierData) => {
          if (initiatedAt != initiatedTime.current) return;
          setFilteredUiIdentifiers((_filteredUiIdentifiers) => [
            ...isFresh ? [] : _filteredUiIdentifiers,
            ...uiIdentifierData.content
          ]);
        });
      }
    }, 500),
    [appVersionId, isWindowsAdvanced]
  );
  const handleNewIdentifier = () => {
    setShowCreateElement(true);
  };
  const handleCloseCreateElement = () => {
    setShowCreateElement(false);
    sendToWidget(CUSTOM_EVENT.ELEMENT_FINDER, void 0);
  };
  const handlePagination = () => {
    if (loadingRef.current) return;
    loadingRef.current = true;
    const fetchPromise = showFiltered ? loadFilteredUiIdentifiers(
      offset + 1,
      searchNameKey !== "" ? searchNameKey : searchScreenNameKey
    ) : loadUiIdentifiers(offset + 1);
    if (fetchPromise instanceof Promise) {
      fetchPromise.then(() => setOffset((prevOffset) => prevOffset + 1)).finally(() => {
        loadingRef.current = false;
      });
    } else {
      loadingRef.current = false;
    }
  };
  const handleDelete = (seq) => {
    if (showFiltered) {
      filteredUiIdentifiers.splice(seq, 1);
      setUiIdentifiers2([...filteredUiIdentifiers]);
    } else {
      uiIdentifiers.splice(seq, 1);
      setUiIdentifiers2([...uiIdentifiers]);
    }
  };
  const handleRefresh = () => {
    setOffset(0);
    if (showFiltered) {
      loadFilteredUiIdentifiers(0, searchNameKey, true);
    } else {
      loadUiIdentifiers(0, true);
    }
  };
  const searchByName = (name) => {
    if (name !== "") {
      setShowFiltered(true);
      setOffset(0);
      setSearchScreenNameKey("");
      setFilteredUiIdentifiers([]);
      setSearchNameKey(IDENTIFIER_FILTER_BY.name(name));
      loadFilteredUiIdentifiers(offset, IDENTIFIER_FILTER_BY.name(name), true);
    } else {
      resetSearch();
    }
  };
  const searchByScreenName = (name) => {
    if (name !== "") {
      setShowFiltered(true);
      setSearchNameKey("");
      setOffset(0);
      setFilteredUiIdentifiers([]);
      setSearchScreenNameKey(IDENTIFIER_FILTER_BY.screenName(name));
      loadFilteredUiIdentifiers(
        offset,
        IDENTIFIER_FILTER_BY.screenName(name),
        true
      );
    } else {
      resetSearch();
    }
  };
  const resetSearch = () => {
    setShowFiltered(false);
    setSearchNameKey("");
    setSearchScreenNameKey("");
    setFilteredUiIdentifiers([]);
    setOffset(0);
  };
  const handleClose = () => {
    resumeOnClose();
    onClose();
  };
  const handleSelectUiIdentifier = (uiIdentifier) => {
    resumeOnClose();
    onSelectUiIdentifier(uiIdentifier);
  };
  const resumeOnClose = () => {
    if (recorderState === RECORDER_STATE.RUNNING) {
      sendToBackground2({
        context: MESSAGE_CONTEXT.STATE,
        action: MESSAGE_CONTEXT_ACTION.UPDATE,
        value: RECORDER_STATE.RUNNING
      });
    }
  };
  const showUiToast = (msg, type) => {
    setShowToast(true);
    setToastMsg(msg);
    setToastType(type);
  };
  const handleCloseActionsDrawer = () => {
    setShowActionsDrawer(false);
  };
  const handleActionSelect = (action) => {
    setShowActionsDrawer(false);
  };
  const getElementsData = () => {
    if (isWindowsAdvanced) {
      const elementsData = desktopElementsData?.content || [];
      return showFiltered ? filteredUiIdentifiers : reorderUiIdentifierList(elementsData);
    } else {
      return showFiltered ? filteredUiIdentifiers : uiIdentifiers;
    }
  };
  const renderHeaderActions = () => {
    if (isWindowsAdvanced) return null;
    if (isDebugMode) {
      return /* @__PURE__ */ jsx(PrimaryButton, { onClick: handleNewIdentifier, size: "sm", children: t("liveEditor.createElement") });
    }
    return /* @__PURE__ */ jsx(
      UiButton,
      {
        label: t("liveEditor.createElement"),
        onClick: () => handleNewIdentifier(),
        color: "primary",
        variant: "contained",
        className: "shrink-0"
      }
    );
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      OverlayContainer,
      {
        onClose: () => handleClose(),
        title: "Elements",
        headerActions: /* @__PURE__ */ jsx("div", { className: "flex gap-2", children: renderHeaderActions() }),
        body: /* @__PURE__ */ jsx(
          UiIdentifiersBody,
          {
            uiIdentifiers: getElementsData(),
            onSelect: (uiIdentifier) => handleSelectUiIdentifier(uiIdentifier),
            onSearchByName: (name) => searchByName(name),
            onSearchByScreenName: (screenName) => searchByScreenName(screenName),
            onPaginate: () => handlePagination(),
            onDelete: (seq) => handleDelete(seq),
            onRefresh: () => handleRefresh(),
            currentElementName,
            nlpId,
            isLoading: isWindowsAdvanced ? isDesktopElementsLoading : false,
            isDebugMode
          }
        ),
        noBodyWrapper: true
      }
    ),
    !isWindowsAdvanced && showCreateElement && /* @__PURE__ */ jsx(CreateElement, { onClose: () => handleCloseCreateElement() }),
    showActionsDrawer && /* @__PURE__ */ jsx(
      ActionsDrawer,
      {
        onSelect: handleActionSelect,
        onClose: handleCloseActionsDrawer
      }
    ),
    /* @__PURE__ */ jsx(
      UiToast,
      {
        isShow: showToast,
        message: toastMsg,
        type: toastType,
        onClose: () => setShowToast(false),
        noAutoHide: true
      }
    )
  ] });
}
var StepChildTreeContext = createContext(
  null
);
var StepChildTreeContextProvider = ({
  children,
  isDebugger,
  stepResults
}) => {
  const [stepsForDebuggerButtons, setStepsForDebuggerButtons] = useState([]);
  const [selectedIterationByStepId, setSelectedIterationByStepId] = useState({});
  const stepsForChildResultCalculation = useMemo(() => {
    if (!isDebugger) {
      return /* @__PURE__ */ new Map();
    }
    const linkedSteps = linkChildAndParent(
      stepsForDebuggerButtons
    );
    return new Map(linkedSteps.map((step) => [step.debugStepId, step]));
  }, [isDebugger, stepsForDebuggerButtons]);
  const stepResultsForChildResultCalculation = useMemo(() => {
    if (!isDebugger) {
      return [];
    }
    return calculateStepResultsTree(
      stepResults
    );
  }, [isDebugger, stepResults]);
  const value = useMemo(
    () => ({
      selectedIterationByStepId,
      setSelectedIterationByStepId,
      stepsForChildResultCalculation,
      stepResultsForChildResultCalculation,
      stepsForDebuggerButtons,
      setStepsForDebuggerButtons
    }),
    [
      selectedIterationByStepId,
      setSelectedIterationByStepId,
      stepsForChildResultCalculation,
      stepResultsForChildResultCalculation,
      stepsForDebuggerButtons,
      setStepsForDebuggerButtons
    ]
  );
  return /* @__PURE__ */ jsx(StepChildTreeContext.Provider, { value, children });
};
var useStepChildTreeContext = () => {
  return useContext(StepChildTreeContext);
};
var reorder2 = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};
var LocatorPrecedence = ({
  locators,
  defaultLocators,
  onUpdate,
  portalTarget = document.body,
  className = null,
  isReadOnly = false
}) => {
  const { t } = useTranslation();
  const [isPreferenceOpened, updatePreferenceOpened] = useState(false);
  const [localLocator, updateLocalLocators] = useState(locators);
  const [isDragging, setIsDragging] = useState(false);
  const [isSaving, updateSaving] = useState(false);
  const closePreference = () => {
    if (!isDragging) {
      updatePreferenceOpened(false);
    }
  };
  const openPreference = () => {
    updateLocalLocators(locators);
    updatePreferenceOpened(true);
  };
  const onDragStart = () => {
    setIsDragging(true);
    document.body.style.cursor = "grabbing";
  };
  const onDragEnd = (result) => {
    setIsDragging(false);
    document.body.style.cursor = "";
    if (!result.destination) return;
    const items = reorder2(
      localLocator,
      result.source.index,
      result.destination.index
    );
    updateLocalLocators(items);
  };
  const handleSave = async () => {
    updateSaving(true);
    const result = await Promise.resolve(onUpdate(localLocator));
    if ("error" in result) {
      toastify(result.error.message, { type: "error" });
    } else {
      closePreference();
      toastify(t("common.message.save.success", { fieldName: "Preference" }), {
        type: "success"
      });
    }
    updateSaving(false);
  };
  useEffect(() => {
    updateLocalLocators(locators);
  }, [locators]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(ToolTip, { content: "Locator precedence", className: "h-5 flex", children: /* @__PURE__ */ jsx(
      Icon,
      {
        name: "crop-free",
        className: classNames82(
          "text-[22px] text-icon-primary leading-5 cursor-pointer",
          className
        ),
        onClick: openPreference
      }
    ) }),
    /* @__PURE__ */ jsx(
      Modal,
      {
        isOpen: isPreferenceOpened,
        className: "!p-0 min-w-[320px] overflow-hidden rounded-lg",
        closeOnOutsideClick: true,
        closeOnEscape: true,
        onClose: closePreference,
        portalTarget,
        children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col", children: [
          /* @__PURE__ */ jsxs("div", { className: "h-11 bg-neutral-100 border-b-[0.5px] border-b-neutral-300 p-3 justify-between flex", children: [
            /* @__PURE__ */ jsxs("div", { className: "inline-flex items-center", children: [
              /* @__PURE__ */ jsx(Icon, { name: "crop-free", className: "text-xl text-icon-primary" }),
              /* @__PURE__ */ jsx("span", { className: "ml-2 font-semibold leading-5 text-small", children: t("common.locator.precedence") })
            ] }),
            /* @__PURE__ */ jsx(ToolTip, { content: "Restore", className: "h-5", children: /* @__PURE__ */ jsx(
              Icon,
              {
                name: "backup-restore",
                className: classNames82("text-xl text-icon-primary", {
                  "cursor-pointer": !isReadOnly,
                  "cursor-not-allowed opacity-40": isReadOnly
                }),
                onClick: () => {
                  !isReadOnly && updateLocalLocators(defaultLocators);
                }
              }
            ) })
          ] }),
          /* @__PURE__ */ jsx("div", { className: "flex-grow min-h-[160px] flex-col pt-1 pb-3", children: /* @__PURE__ */ jsx(DragDropContext, { onDragStart, onDragEnd, children: /* @__PURE__ */ jsx(Droppable, { droppableId: "droppable", children: (droppableProvided) => /* @__PURE__ */ jsxs(
            "div",
            {
              ...droppableProvided.droppableProps,
              ref: droppableProvided.innerRef,
              children: [
                localLocator.map((locator, index) => /* @__PURE__ */ jsx(
                  Draggable,
                  {
                    draggableId: locator.id,
                    index,
                    children: (draggableProvided, draggableSnapshot) => {
                      const draggingElement = /* @__PURE__ */ jsxs(
                        "div",
                        {
                          ref: draggableProvided.innerRef,
                          ...draggableProvided.draggableProps,
                          ...draggableProvided.dragHandleProps,
                          className: classNames82(
                            "flex px-3 py-1.5 items-center hover:bg-secondary-50 text-small",
                            { "bg-gray-200": draggableSnapshot.isDragging }
                          ),
                          children: [
                            /* @__PURE__ */ jsx(
                              ToolTip,
                              {
                                content: isReadOnly ? "" : t("reorder.drag.icon.text"),
                                className: "flex",
                                children: /* @__PURE__ */ jsx(
                                  Icon,
                                  {
                                    name: "reorder",
                                    className: classNames82("text-xl mr-2", {
                                      "opacity-40 cursor-not-allowed": isReadOnly
                                    })
                                  }
                                )
                              }
                            ),
                            /* @__PURE__ */ jsx("span", { children: locator.name })
                          ]
                        }
                      );
                      return draggableSnapshot.isDragging ? ReactDOM.createPortal(
                        draggingElement,
                        document.body
                      ) : draggingElement;
                    }
                  },
                  locator.id
                )),
                droppableProvided.placeholder
              ]
            }
          ) }) }) }),
          /* @__PURE__ */ jsxs("div", { className: "shadow-small px-3 py-2 flex-row-reverse items-center gap-2 flex", children: [
            /* @__PURE__ */ jsx(Button, { type: "secondary", onClick: closePreference, children: t("common.cancel") }),
            /* @__PURE__ */ jsx(
              Button,
              {
                type: "primary",
                isDisabled: isSaving || isReadOnly,
                onClick: handleSave,
                children: t("common.save")
              }
            )
          ] })
        ] })
      }
    )
  ] });
};
var { Button: Button38, BUTTON_VARIANTS: BUTTON_VARIANTS16, BUTTON_SIZE: BUTTON_SIZE12 } = V2;
var style = `
@keyframes smooth-blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
}
.animate-smooth-blink {
  animation: smooth-blink 2s infinite;
}
`;
var FloatingDebuggerIcons = ({
  captureMode,
  captureStepId,
  captureBlockUuid,
  handleRecorderAction,
  recorderState,
  disableRecordOption,
  locators,
  defaultLocators,
  updateLocatorPrecedence,
  enableClickHover,
  handleToggleClickHover,
  enableScroll,
  onEnableScrollChange,
  isDisabled = false
}) => {
  const { t } = useTranslation();
  const isRecording = recorderState === RECORDER_STATE.RUNNING;
  useEffect(() => {
    if (!document.getElementById("smooth-blink-style")) {
      const styleTag = document.createElement("style");
      styleTag.id = "smooth-blink-style";
      styleTag.innerHTML = style;
      document.head.appendChild(styleTag);
    }
  }, []);
  const handleStopCapture = () => {
    if (window["__directCaptureResolver"]) {
      window["__directCaptureResolver"].resolve({ action: "DISCARDED" });
      delete window["__directCaptureResolver"];
    }
    window.dispatchEvent(
      new CustomEvent("element-capture-end", {
        detail: { stepId: captureStepId, blockUuid: captureBlockUuid }
      })
    );
  };
  const handleRecordingClick = (e) => {
    e.stopPropagation();
    if (disableRecordOption) return;
    if (isRecording) {
      handleRecorderAction(RECORDER_ACTION.PAUSE);
    } else {
      handleRecorderAction(RECORDER_ACTION.RESUME);
    }
  };
  const getTooltipContent = () => {
    if (disableRecordOption) return "Cannot record while debugging is running";
    return isRecording ? t("live-editor.stop_recording_tooltip") : t("live-editor.start_recording_tooltip");
  };
  const recordingButtonClasses = classNames82(
    "h-4 w-4 rounded-md flex items-center justify-center transition-all duration-300 flex justify-center items-center",
    {
      "cursor-not-allowed opacity-50": disableRecordOption,
      "cursor-pointer": !disableRecordOption
    }
  );
  useEffect(() => {
    if (!isRecording) {
      handleRecorderAction(RECORDER_ACTION.PAUSE);
    }
  }, [isRecording, handleRecorderAction]);
  const buttonClassName = classNames82(
    "!px-[5px] text-base leading-4 h-8 shadow-debugger-icon !border-[0.5px] !border-[#E2E7EE]",
    {
      "pointer-events-none opacity-60": isDisabled
    }
  );
  const CapturingUI = () => /* @__PURE__ */ jsxs(
    Button38,
    {
      variant: BUTTON_VARIANTS16.SECONDARY,
      size: BUTTON_SIZE12.SMALLEST,
      className: buttonClassName,
      onClick: handleStopCapture,
      children: [
        /* @__PURE__ */ jsx("div", { className: recordingButtonClasses, children: /* @__PURE__ */ jsx(StopLiveEditorIcon, {}) }),
        t("live-editor.listening")
      ]
    }
  );
  const RecordingUI = () => /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-center gap-1.5", children: [
    /* @__PURE__ */ jsx(ToolTip, { content: getTooltipContent(), children: /* @__PURE__ */ jsxs(
      Button38,
      {
        variant: BUTTON_VARIANTS16.SECONDARY,
        size: BUTTON_SIZE12.SMALLEST,
        className: buttonClassName,
        onClick: handleRecordingClick,
        children: [
          /* @__PURE__ */ jsx("div", { className: recordingButtonClasses, children: isRecording ? /* @__PURE__ */ jsx(StopLiveEditorIcon, {}) : /* @__PURE__ */ jsx(RecordLiveEditorIcon, {}) }),
          isRecording ? t("live-editor.stop_recording_tooltip") : t("live-editor.rec")
        ]
      }
    ) }),
    isRecording && /* @__PURE__ */ jsx("div", { className: "h-7 w-[1px] bg-slate-200" }),
    isRecording && /* @__PURE__ */ jsx(ToolTip, { content: "Locator Precedence", children: /* @__PURE__ */ jsx(
      Button38,
      {
        variant: BUTTON_VARIANTS16.SECONDARY,
        size: BUTTON_SIZE12.SMALLEST,
        className: "flex-shrink-0 overflow-hidden h-8 w-8 !px-1 shadow-debugger-icon !border-[0.5px] !border-[#E2E7EE]",
        children: /* @__PURE__ */ jsx(
          LocatorPrecedence,
          {
            locators,
            defaultLocators,
            onUpdate: updateLocatorPrecedence,
            className: "text-base leading-4 icon-primary"
          }
        )
      }
    ) }),
    isRecording && /* @__PURE__ */ jsx(ToolTip, { content: "Click as Mouseover", children: /* @__PURE__ */ jsx(
      Button38,
      {
        variant: BUTTON_VARIANTS16.SECONDARY,
        size: BUTTON_SIZE12.SMALLEST,
        className: "flex-shrink-0 overflow-hidden h-8 w-8 !px-1 shadow-debugger-icon !border-[0.5px] !border-[#E2E7EE]",
        onClick: handleToggleClickHover,
        children: /* @__PURE__ */ jsxs("span", { className: "relative flex items-center", children: [
          enableClickHover && /* @__PURE__ */ jsx("span", { className: "w-3 h-3 block absolute rounded-full bg-red-900 left-0.5 top-0 animate-ping" }),
          /* @__PURE__ */ jsx(
            Icon,
            {
              name: "touch-app",
              className: "icon-primary transition-all duration-300 mt-[2px] text-base",
              style: { cursor: "pointer" }
            }
          )
        ] })
      }
    ) }),
    isRecording && /* @__PURE__ */ jsx(
      ToolTip,
      {
        content: enableScroll ? "Disable scroll action recording" : "Enable scroll action recording",
        children: /* @__PURE__ */ jsx(
          Button38,
          {
            variant: BUTTON_VARIANTS16.SECONDARY,
            size: BUTTON_SIZE12.SMALLEST,
            className: "flex-shrink-0 overflow-hidden h-8 w-8 !px-1 shadow-debugger-icon !border-[0.5px] !border-[#E2E7EE]",
            onClick: onEnableScrollChange,
            children: /* @__PURE__ */ jsx("span", { className: "flex items-center", children: /* @__PURE__ */ jsx(
              Icon,
              {
                name: "toggle-off",
                className: `text-base transition-all duration-300 mt-[1px] ${enableScroll ? "text-green-600" : "icon-primary"}`,
                style: { cursor: "pointer" }
              }
            ) })
          }
        )
      }
    )
  ] });
  return captureMode === "capturing" ? /* @__PURE__ */ jsx(CapturingUI, {}) : /* @__PURE__ */ jsx(RecordingUI, {});
};
var FloatingDebuggerIcons_default = React5__default.memo(FloatingDebuggerIcons);
var UtilsContext = createContext(
  null
);
function useUtilsContext() {
  const utils = useContext(UtilsContext);
  if (!utils) {
    throw new Error("useUtils must be used within a UtilsProvider");
  }
  return utils;
}

// src/components/debugger-actions-buttons/useRecorderActionButton.tsx
var useRecorderActionButton = (hideFloatingIcons) => {
  const { sendToBackground: sendToBackground2 } = useMessaging();
  const dispatch = useDispatch();
  const { getState, ...rest } = useUtilsContext();
  const enableScroll = useSelector(selectIsScrollRecordingEnabled);
  const { updateIsScrollRecordingEnabled: updateIsScrollRecordingEnabled2 } = useWidgetV2Actions();
  const { t } = useTranslation();
  const {
    actions: recorder,
    isDebugger: isDebugMode,
    isExitModalOpen
  } = useRecorderContext();
  const [captureMode, setCaptureMode] = useState(
    "normal"
  );
  const [captureBlockUuid, setCaptureBlockUuid] = useState(null);
  const [captureStepId, setCaptureStepId] = useState(null);
  const {
    recorderType,
    enableClickHover,
    recorderPreferences,
    appVersionId,
    isRecorderLoaded,
    appType,
    recorderState
  } = useSelector((state) => state.widget);
  const isAndroid = appType === ApplicationType.AndroidNative;
  const isIOS = appType === ApplicationType.IOSNative;
  const { stepResultModalOpen } = useSelector(
    (state) => state.debugging
  );
  const { debugExecutionStatus } = useSelector(
    (state) => state.debugging
  );
  const locators = recorderPreferences?.preferences?.find((item) => item.type === PREFERENCE_TYPE.LOCATOR_ORDER)?.preference?.locator?.map(
    (item) => DEFAULT_LOCATOR_PRECEDENCE[ApplicationType.WebApplication].find(
      (pref) => pref.id == item
    )
  ) || DEFAULT_LOCATOR_PRECEDENCE[ApplicationType.WebApplication];
  const handleRecorderAction = useCallback(
    (action) => {
      if (recorderType === RECORDER_TYPE.ELEMENT_CAPTURE && action === RECORDER_ACTION.STOP) {
        logEvent(
          analytics_constants_default.AMPLITUDE.LIVE_EDITOR_ELEMENT_CAPTURE_STOP
        );
        sendToBackground2({
          context: MESSAGE_CONTEXT.ELEMENT_FINDER,
          action: MESSAGE_CONTEXT_ACTION.CLOSE,
          value: null
        });
      } else {
        logEvent(
          action == RECORDER_ACTION.PAUSE ? analytics_constants_default.AMPLITUDE.LIVE_EDITOR_WEB_STEP_RECORD_PAUSE : analytics_constants_default.AMPLITUDE.LIVE_EDITOR_WEB_STEP_RECORD_RESUME
        );
        const newState = recorder.findStateByAction(action);
        const isRecording = newState === "running";
        const isAtto = getState?.()?.debuggingSessionState?.isAtto ?? false;
        if (isAtto) {
          rest.setAttoGlowEnabled?.(!isRecording);
        }
        sendToBackground2({
          context: MESSAGE_CONTEXT.STATE,
          action: MESSAGE_CONTEXT_ACTION.UPDATE,
          value: newState
        });
      }
    },
    [recorderType, recorder, sendToBackground2, getState, rest]
  );
  const updateLocatorPrecedence = useCallback(
    async (locator) => {
      try {
        const applicationVersion = await ApplicationVersionApi.getOne(
          appVersionId || 0
        );
        const response = await RecorderPreferencesApi.update({
          type: PREFERENCE_TYPE.LOCATOR_ORDER,
          applicationId: applicationVersion.applicationId,
          applicationType: applicationVersion?.application?.applicationType,
          preference: { locator: locator.map((item) => item.id) }
        });
        const preferences = await RecorderPreferencesApi.getAll(
          applicationVersion.applicationId,
          applicationVersion?.application?.applicationType
        );
        dispatch(setRecorderPreferences(preferences));
        sendToBackground2({
          context: MESSAGE_CONTEXT.RECORDER,
          action: MESSAGE_CONTEXT_ACTION.SYNC_PREFERENCE,
          value: preferences
        });
        return response;
      } catch (error) {
        const errorMessage = t("common.message.update.failure", {
          fieldName: "Preference"
        });
        return {
          error: {
            message: error?.response?.data?.message || errorMessage
          }
        };
      }
    },
    [appVersionId, dispatch, sendToBackground2, t]
  );
  const onEnableScrollChange = useCallback(() => {
    updateIsScrollRecordingEnabled2(!enableScroll);
  }, [enableScroll]);
  const handleToggleClickHover = useCallback(() => {
    dispatch(setEnableClickHover(!enableClickHover));
  }, [enableClickHover, dispatch]);
  useEffect(() => {
    const handleElementCaptureStart = (event) => {
      setCaptureMode("capturing");
      logEvent(
        analytics_constants_default.AMPLITUDE.LIVE_EDITOR_ELEMENT_CAPTURE_START
      );
      setCaptureBlockUuid(event.detail?.blockUuid || null);
      setCaptureStepId(event.detail?.stepId || null);
    };
    const handleElementCaptureEnd = (event) => {
      if (event.detail?.stepId === captureStepId || event.detail?.stepId === null) {
        setCaptureMode("normal");
        logEvent(
          analytics_constants_default.AMPLITUDE.LIVE_EDITOR_ELEMENT_CAPTURE_STOP
        );
        setCaptureBlockUuid(null);
        setCaptureStepId(null);
      }
    };
    window.addEventListener(
      "element-capture-start",
      handleElementCaptureStart
    );
    window.addEventListener(
      "element-capture-end",
      handleElementCaptureEnd
    );
    return () => {
      window.removeEventListener(
        "element-capture-start",
        handleElementCaptureStart
      );
      window.removeEventListener(
        "element-capture-end",
        handleElementCaptureEnd
      );
    };
  }, [captureStepId]);
  const showFloatingDebuggerIcons = useMemo(() => {
    return isDebugMode && isRecorderLoaded && !isAndroid && !isIOS && !stepResultModalOpen && !hideFloatingIcons;
  }, [
    hideFloatingIcons,
    isAndroid,
    isDebugMode,
    isIOS,
    isRecorderLoaded,
    stepResultModalOpen
  ]);
  const disableRecordOption = useMemo(() => {
    return !!isDebugMode && !!debugExecutionStatus && debugExecutionStatus === ResultConstant.RUNNING;
  }, [isDebugMode, debugExecutionStatus]);
  return {
    captureMode,
    captureBlockUuid,
    captureStepId,
    setCaptureMode,
    setCaptureBlockUuid,
    setCaptureStepId,
    handleRecorderAction,
    updateLocatorPrecedence,
    onEnableScrollChange,
    handleToggleClickHover,
    locators,
    enableClickHover,
    showFloatingDebuggerIcons,
    disableRecordOption,
    recorderState,
    enableScroll,
    isDisabled: isExitModalOpen,
    recorderType
  };
};
var useRecorderActionButton_default = useRecorderActionButton;
var FloattingDebugIconContainer = ({
  hideFloatingIcons
}) => {
  const {
    captureMode,
    captureStepId,
    captureBlockUuid,
    handleRecorderAction,
    recorderState,
    disableRecordOption,
    locators,
    updateLocatorPrecedence,
    recorderType,
    enableClickHover,
    handleToggleClickHover,
    enableScroll,
    onEnableScrollChange,
    showFloatingDebuggerIcons,
    isDisabled
  } = useRecorderActionButton_default(hideFloatingIcons);
  if (!showFloatingDebuggerIcons) return null;
  return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
    FloatingDebuggerIcons_default,
    {
      captureMode,
      captureStepId,
      captureBlockUuid,
      handleRecorderAction,
      recorderState,
      disableRecordOption,
      locators,
      defaultLocators: DEFAULT_LOCATOR_PRECEDENCE[ApplicationType.WebApplication],
      updateLocatorPrecedence,
      recorderType,
      enableClickHover,
      handleToggleClickHover,
      enableScroll,
      onEnableScrollChange,
      isDisabled
    }
  ) });
};
var floating_actions_buttons_default = React5__default.memo(FloattingDebugIconContainer);
var PER_PAGE_SIZE = STEPS_PAGE_SIZE;
var shortCodes = [
  "step group",
  "for loop",
  "while loop",
  "rest api",
  "create a block"
];
var hasFeatureValue = () => false;
function TestSteps({
  enableReorder,
  hasNextPage,
  onEnableReorder,
  updateReorderedSteps,
  setHideFloatingIcons,
  debugExecutionStatus = "",
  shouldDisableResume,
  onResumeExecution,
  onStepOverExecution,
  onSkipOverExecution,
  onRestartExecution,
  hideFloatingIcons
}) {
  const { sendToWidget, sendToContentWindow } = useMessaging();
  const dispatch = useDispatch();
  const {
    templates,
    appVersionId,
    screens,
    recorderSource,
    testCase,
    addonTemplates,
    algoliaTemplates,
    appType,
    createdElement,
    dataProfiles,
    testSteps: steps,
    userStepsData,
    stepCreationInProgress,
    appVersion,
    tenantPreference,
    modifiedSteps
  } = useSelector((state) => state.widget);
  const { executedStepIds } = useSelector(
    (state) => state.debugging
  );
  const { testCaseResult } = useSelector((state) => state.debugging);
  const {
    isDebugger: isDebugMode,
    openExternalUrl,
    serverUrl,
    versionId: recorderVersionId
  } = useRecorderContext();
  const { currentExecutingStep, stepResults, debuggerActions, debugPoints } = use_web_debugger_default();
  const maxFetchedPageNumber = useSelector(selectMaxFetchedPageNumber);
  const [editUiIdentifier, setEditUiIdentifier] = useState();
  const [showDerivedElementForm, setShowDerivedElementForm] = useState();
  const {
    stepsForChildResultCalculation = /* @__PURE__ */ new Map(),
    selectedIterationByStepId = {},
    setSelectedIterationByStepId,
    stepResultsForChildResultCalculation,
    setStepsForDebuggerButtons
  } = useStepChildTreeContext();
  const [showDerivedElement, setShowDerivedElement] = useState(false);
  const [showElementForm, setShowElementForm] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  const [toastType, setToastType] = useState(TOAST_TYPE.SUCCESS);
  const [settingStep, setSettingStep] = useState();
  const [showElementsList, setShowElementsList] = useState(false);
  const [showDirectCapture, setShowDirectCapture] = useState(false);
  const [canRender, setCanRender] = useState(false);
  const [localSteps, _setLocalSteps] = useState([]);
  const setLocalSteps = (list) => {
    log.info(`[DEBUG] TestSteps => setLocalSteps`, list);
    _setLocalSteps(list);
  };
  const [stepFilterType, _setStepFilterType] = useState("null");
  const setStepFilterType = (type) => {
    _setStepFilterType(type);
  };
  const [activeStepId, setActiveStepId] = useState();
  const [activeStep, setActiveStep] = useState();
  const [testDataDrawerType, setTestDataDrawerType] = useState();
  const [showStepGroups, setShowStepGroups] = useState(false);
  const [dataSetList, updateDataSetList] = useState({ content: [] });
  const [dataParameterList, updateDataParameterList] = useState({ content: [] });
  const [interimStep, setInterimStep] = useState();
  const [isCommand, updateIsCommand] = useState(false);
  const [isCommandCombine, updateIsCommandCombine] = useState(false);
  const [typesenseNotAvailable, setTypesenseNotAvailable] = useState(false);
  const stepDeleteModal = useModal();
  const [isStepDeleting, setIsStepDeleting] = useState(false);
  const [showActionsDrawer, setShowActionsDrawer] = useState(false);
  const [actionsResolver, setActionsResolver] = useState(null);
  const { hasFeature, hasTenantPreference } = useTenantInfo();
  const lastStep = steps.slice(-1)?.pop();
  const firstStep = steps[0];
  const lastStepOrder = lastStep?.stepOrder || 1e3;
  const lastParentStep = useMemo(
    () => steps.filter((step) => step.indent === 0).slice(-1)?.pop(),
    [steps]
  );
  const algoliaClient = useMemo(
    () => getAlgoliaInstance({ appType }),
    [appType]
  );
  const nlActions = useMemo(() => {
    const list = [...templates || [], ...addonTemplates || []];
    return list;
  }, [templates, addonTemplates]);
  const getCurrentStepElement = () => {
    const testStep = activeStepId ? localSteps.find((step) => step.id === activeStepId) : localSteps.slice(-1)?.pop();
    const elementName2 = testStep?.dataMap?.["uiIdentifier"];
    if (elementName2 && elementName2 !== "element" && elementName2 !== "element-locator") {
      return elementName2;
    }
  };
  const handleUpdateElement = async (elementData) => {
    if (elementData && editUiIdentifier) {
      let screen = screens.find(
        ({ name }) => name.toLocaleLowerCase() === elementData.screenTitle?.toLocaleLowerCase()
      );
      if (!screen) {
        screen = await ScreenApi.create(
          elementData.screenTitle,
          appVersionId
        );
      }
      const hasDraftScreenShotImages = Object.keys(elementData?.elementImageDraft || {}).length > 0;
      if (elementData.elementContext) {
        elementData.screenNameId = screen.id;
        elementData.applicationVersionId = appVersionId;
        processElementContext(elementData);
      } else {
        elementData.hostElements = null;
      }
      const updatedUiIdentifier = {
        ...editUiIdentifier,
        name: elementData?.name,
        definition: elementData?.definition || elementData.xPath || elementData.cssPath,
        currentElement: { textContent: elementData.text },
        applicationVersionId: appVersionId,
        parents: elementData.parents,
        screenShotData: elementData.screenshot,
        attrs: elementData.attrs,
        isDynamic: elementData.isDynamicElement,
        screenNameId: screen.id,
        screenNameObj: screen,
        locatorType: elementData.locatorType,
        hostElements: elementData.elementContext,
        elementUuid: elementData.elementUuid,
        imageLocatorOccurence: elementData.imageLocatorOccurence,
        ...hasDraftScreenShotImages ? { elementImageDraft: elementData?.elementImageDraft } : {},
        autoHealingEnabled: elementData.autoHealingEnabled,
        locatorTree: elementData.locatorTree,
        updateType: elementData.updateType || "CHROME"
      };
      try {
        const res = await UiIdentifierApi.update(updatedUiIdentifier);
        const { screenshotRetrievalId } = elementData;
        if (screenshotRetrievalId && updatedUiIdentifier.id) {
          try {
            const globalState2 = getGlobalState();
            const elementSS = selectElementScreenshotMap(
              globalState2,
              screenshotRetrievalId
            );
            const croppedElementSS = selectCroppedElementScreenshotMap(
              globalState2,
              screenshotRetrievalId
            );
            const appVersionId2 = globalState2.widget.appVersionId;
            if (elementSS) {
              RecorderAssetsApi.saveElementScreenshot(updatedUiIdentifier.id, {
                screenshotFile: dataurltoFile(elementSS),
                applicationVersionId: appVersionId2
              });
            }
            if (croppedElementSS) {
              RecorderAssetsApi.saveCroppedElementScreenshot(
                updatedUiIdentifier.id,
                {
                  screenshotFile: dataurltoFile(croppedElementSS),
                  applicationVersionId: appVersionId2
                }
              );
            }
          } catch (error) {
          }
        }
        const updatedSteps = localSteps.map((step) => {
          const updatedStep = { ...step };
          if (step.testStepElements) {
            const updatedTestStepElements = step.testStepElements.map(
              (element) => {
                if (element.elementId === updatedUiIdentifier.id) {
                  return {
                    ...element,
                    name: updatedUiIdentifier.name
                  };
                }
                return element;
              }
            );
            updatedStep.testStepElements = updatedTestStepElements;
          }
          if (updatedStep.dataMap && updatedStep.dataMap["uiIdentifier"] === editUiIdentifier.name) {
            updatedStep.dataMap = {
              ...updatedStep.dataMap,
              uiIdentifier: updatedUiIdentifier.name
            };
          }
          if (updatedStep.elementRequest && updatedStep.elementRequest.name === editUiIdentifier?.name) {
            updatedStep.elementRequest = {
              ...updatedStep.elementRequest,
              definition: updatedUiIdentifier.definition,
              locatorType: updatedUiIdentifier.locatorType,
              name: updatedUiIdentifier.name,
              screenNameObj: updatedUiIdentifier.screenNameObj
            };
            updatedStep.xpath = updatedUiIdentifier.definition;
          }
          return updatedStep;
        });
        setLocalSteps(updatedSteps);
        reloadTestSteps();
        setEditUiIdentifier(void 0);
        setShowElementForm(false);
        setShowToast(true);
        setToastMsg("Element updated successfully");
        setToastType(TOAST_TYPE.SUCCESS);
        onCloseElementForm(res);
      } catch (err) {
        setShowToast(true);
        setToastMsg(err.error);
        setToastType(TOAST_TYPE.ERROR);
      }
    }
  };
  const setTestStepsWithInterim = (stepsList) => {
    setLocalSteps(stepsList);
  };
  const stepCreateFetch = (step, pageNo) => {
    StepApi.create(step, false, appVersionId).then(() => {
      const sliceStart = 0;
      const sliceEnd = pageNo ? PER_PAGE_SIZE * (pageNo - 1) : PER_PAGE_SIZE;
      fetchPage(
        pageNo,
        PER_PAGE_SIZE,
        "",
        {
          type: "INSERT",
          data: pageNo ? steps.slice(sliceStart, sliceEnd) : []
        },
        true
      );
    });
  };
  const updateStepCursor = (step) => {
    setInterimStep(step);
    if (step) {
      dispatch(setStepCursor(step));
    } else {
      dispatch(setStepCursor(null));
    }
  };
  const handleAddNestedStep = (insertType, newStep, currentStep) => {
    const updatedStepList = [...steps];
    if (insertType === "else") {
      const nextSibling = steps.find(
        (item) => item.stepOrder > newStep.stepOrder && item.indent <= newStep.indent
      );
      newStep = new TestStep().deserialize(newStep);
      newStep.stepOrder = nextSibling ? nextSibling.stepOrder : steps[steps.length - 1]?.stepOrder;
      newStep.type = TestStepType.NLP_TEXT;
      const [firstHalf, secondHalf] = partition$1(
        updatedStepList,
        (item) => nextSibling ? item.stepOrder < newStep.stepOrder : item.stepOrder <= newStep.stepOrder
      );
      newStep.stepOrder = secondHalf[0]?.stepOrder ? (firstHalf.findLast((item) => item)?.stepOrder + secondHalf[0]?.stepOrder) / 2 : firstHalf.findLast((item) => item)?.stepOrder + 1e3;
      const pageno = getPageNumber(
        nextSibling?.stepNumber || lastStep?.stepNumber,
        0
      );
      stepCreateFetch(newStep, pageno);
    } else if (insertType === "break_above_inside" || insertType === "continue_above_inside") {
      const [firstHalf, secondHalf] = partition$1(
        updatedStepList,
        (item) => item.stepOrder < newStep.stepOrder
      );
      newStep.stepOrder = ((firstHalf.findLast((item) => item)?.stepOrder || 0) + secondHalf[0]?.stepOrder) / 2;
      const pageno = isDebugMode ? newStep.pagenumber : getPageNumber(newStep?.stepNumber || lastStep?.stepNumber, 0);
      stepCreateFetch(newStep, pageno);
    } else if (insertType === "break_below_inside" || insertType === "continue_below_inside") {
      const [firstHalf, secondHalf] = partition$1(
        updatedStepList,
        (item) => item.stepOrder <= newStep.stepOrder
      );
      newStep.stepOrder = secondHalf[0]?.stepOrder ? (firstHalf.findLast((item) => item)?.stepOrder + secondHalf[0]?.stepOrder) / 2 : firstHalf.findLast((item) => item)?.stepOrder + 1e3;
      const pageno = isDebugMode ? newStep.pagenumber : getPageNumber(newStep?.stepNumber || lastStep?.stepNumber, 0);
      stepCreateFetch(newStep, pageno);
    } else if (insertType === "above") {
      newStep = createTestStep2(
        newStep,
        "above",
        isNumber(newStep?.stepOrder) ? newStep?.stepOrder : lastStepOrder + 1e3,
        getStepNumber(currentStep.stepNumber || "-", "above"),
        newStep.indent || 0,
        appType,
        testCase?.id,
        newStep.parentId
      );
      const [firstHalf, secondHalf] = partition$1(
        updatedStepList,
        (item) => item.stepOrder < newStep.stepOrder
      );
      newStep.stepOrder = ((firstHalf.findLast((item) => item)?.stepOrder || 0) + secondHalf[0]?.stepOrder) / 2;
      updateStepCursor(newStep);
      setTestStepsWithInterim([
        ...firstHalf || [],
        ...convertToOrganismSteps([newStep]),
        ...secondHalf || []
      ]);
    } else if (insertType === "below") {
      newStep = createTestStep2(
        newStep,
        "below",
        newStep?.stepOrder,
        getStepNumber(currentStep.stepNumber || "-", "below"),
        newStep.indent || 0,
        appType,
        testCase?.id,
        newStep.parentId
      );
      const [firstHalf, secondHalf] = partition$1(
        updatedStepList,
        (item) => item.stepOrder <= newStep.stepOrder
      );
      newStep.stepOrder = secondHalf[0]?.stepOrder ? (firstHalf.findLast((item) => item)?.stepOrder + secondHalf[0]?.stepOrder) / 2 : firstHalf.findLast((item) => item)?.stepOrder + 1e3;
      updateStepCursor(newStep);
      setTestStepsWithInterim([
        ...firstHalf || [],
        ...convertToOrganismSteps([newStep]),
        ...secondHalf || []
      ]);
    } else if (insertType === "inside") {
      newStep = createTestStep2(
        newStep,
        "inside",
        newStep?.stepOrder,
        getStepNumber(currentStep.stepNumber || "-", "inside"),
        newStep.indent,
        appType,
        testCase?.id,
        newStep.parentId
      );
      const [firstHalf, secondHalf] = partition$1(
        updatedStepList,
        (item) => item.stepOrder <= newStep.stepOrder
      );
      newStep.indent = (newStep.indent || 0) + 1;
      newStep.stepOrder = secondHalf[0]?.stepOrder ? (firstHalf.findLast((item) => item)?.stepOrder + secondHalf[0]?.stepOrder) / 2 : firstHalf.findLast((item) => item)?.stepOrder + 1e3;
      updateStepCursor(newStep);
      setTestStepsWithInterim([
        ...firstHalf || [],
        ...convertToOrganismSteps([newStep]),
        ...secondHalf || []
      ]);
    } else if (insertType === "elseif") {
      newStep = createTestStep2(
        newStep,
        "elseif",
        isNumber(newStep?.stepOrder) ? newStep?.stepOrder : lastStepOrder + 1e3,
        getStepNumber(currentStep.stepNumber || "-", "below"),
        newStep.indent || 0,
        appType,
        testCase?.id,
        newStep.parentId
      );
      newStep.conditionType = STEP_CONDITION_TYPE.ELSE_IF;
      newStep.priority = STEP_PRIORITY.MINOR;
      if (appType === ApplicationType.WINDOWS_ADVANCED) {
        makeObjectIfStep(nlActions, newStep);
      }
      const children = findAllChildren(
        updatedStepList,
        "parentId",
        currentStep.id
      );
      let conditionalSteps = [];
      if (children?.length) {
        conditionalSteps = children.filter(
          (item) => currentStep.id === item.parentId && (item.conditionType === TestStepConditionType.CONDITION_ELSE_IF || item.conditionType === TestStepConditionType.CONDITION_ELSE)
        );
        newStep.stepOrder = conditionalSteps.length ? conditionalSteps[0].stepOrder : children[children.length - 1].stepOrder;
      }
      const [firstHalf, secondHalf] = partition$1(
        updatedStepList,
        (item) => conditionalSteps[0] ? item.stepOrder < newStep.stepOrder : item.stepOrder <= newStep.stepOrder
      );
      newStep.stepOrder = secondHalf[0]?.stepOrder ? (firstHalf.findLast((item) => item)?.stepOrder + secondHalf[0]?.stepOrder) / 2 : firstHalf.findLast((item) => item)?.stepOrder + 1e3;
      updateStepCursor(newStep);
      setTestStepsWithInterim([
        ...firstHalf || [],
        ...convertToOrganismSteps([newStep]),
        ...secondHalf || []
      ]);
    } else if (insertType === "after") {
      newStep = createTestStep2(
        newStep,
        "after",
        isNumber(newStep?.stepOrder) ? newStep?.stepOrder : lastStepOrder + 1e3,
        getStepNumber(currentStep.stepNumber || "-", "below"),
        newStep.indent || 0,
        appType,
        testCase?.id,
        newStep.parentId
      );
      const children = findAllChildren(
        updatedStepList,
        "parentId",
        currentStep.id
      );
      newStep.stepOrder = children?.length ? children?.[children?.length - 1]?.stepOrder : currentStep.stepOrder;
      const [firstHalf, secondHalf] = partition$1(
        updatedStepList,
        (item) => item.stepOrder <= newStep.stepOrder
      );
      newStep.stepOrder = secondHalf[0]?.stepOrder ? (firstHalf.findLast((item) => item)?.stepOrder + secondHalf[0]?.stepOrder) / 2 : firstHalf.findLast((item) => item)?.stepOrder + 1e3;
      updateStepCursor(newStep);
      setTestStepsWithInterim([
        ...firstHalf || [],
        ...convertToOrganismSteps([newStep]),
        ...secondHalf || []
      ]);
    }
  };
  const onAddStep = (step, orderLabel, localStep) => {
    if (orderLabel) {
      handleAddNestedStep(orderLabel, step, localStep);
    } else {
      const newStep = createTestStep2(
        step,
        orderLabel,
        (lastStep?.stepOrder || 0) + 1e3,
        addStepNumber2(lastParentStep?.stepNumber || "0"),
        0,
        appType,
        testCase?.id
      );
      updateStepCursor(newStep);
      setTestStepsWithInterim(
        convertToOrganismSteps([
          ...steps || [],
          new TestStep().deserialize(newStep)
        ])
      );
    }
  };
  const handleCreate2 = (stepData, isstep, callback) => {
    const [firstHalf, secondHalf] = partition$1(
      steps,
      (item) => item.stepOrder <= stepData.stepOrder
    );
    let newStepOrder = secondHalf[0]?.stepOrder ? (secondHalf[0]?.stepOrder + stepData?.stepOrder) / 2 : stepData?.stepOrder + 1e3;
    newStepOrder = newStepOrder == stepData.stepOrder ? newStepOrder + 1e3 : newStepOrder;
    stepData.intermediateStepOrder = newStepOrder;
    handleCreateInterimStep(stepData);
    callback?.();
    if (isDebugMode) {
      setInterimStep(null);
      logEvent(analytics_constants_default.AMPLITUDE.LIVE_EDITOR_STEP_CREATE, {
        stepId: stepData.id
      });
    }
  };
  const handleUpdate = (stepData, callback) => {
    updateTestStep(stepData);
    callback?.();
    if (isDebugMode) {
      logEvent(analytics_constants_default.AMPLITUDE.LIVE_EDITOR_STEP_UPDATE, {
        stepId: stepData.id
      });
    }
  };
  const onSearch = (data) => {
    const isCommandRegex = /^\//g;
    if (isCommandRegex.test(data)) {
      updateIsCommand(true);
    } else if (shortCodes.filter((item) => item.includes(data.toLowerCase()))?.length && data?.length) {
      updateIsCommand(false);
      updateIsCommandCombine(true);
      fetchAlgoliaTemplates(data, stepFilterType);
    } else {
      updateIsCommand(false);
      updateIsCommandCombine(false);
      fetchAlgoliaTemplates(data, stepFilterType);
    }
  };
  const updateFilter = (data) => {
    if (data.type === TestStepType.NLP_TEXT) {
      updateIsCommand(false);
      updateIsCommandCombine(false);
    } else if (data.type === TestStepType.FOR_LOOP || data.type === TestStepType.WHILE_LOOP) {
      updateIsCommand(false);
      updateIsCommandCombine(false);
    }
    const filterType = getFilterType(data);
    setStepFilterType(filterType);
    fetchAlgoliaTemplates("", filterType);
  };
  const getFilterType = (data) => {
    let filterType = "null";
    if (data.type === TestStepType.NLP_TEXT) {
      filterType = Boolean(data.conditionType) || data.isConditionalStep ? "IF_CONDITION" : "null";
    } else if (data.type === TestStepType.FOR_LOOP || data.type === TestStepType.WHILE_LOOP) {
      filterType = data.type;
    }
    return filterType;
  };
  const fetchAlgoliaTemplates = (query, stepType) => {
    if (typesenseNotAvailable) {
      return new Promise((resolve) => {
        filterLocalTemplates(query, stepType);
        resolve();
      });
    }
    algoliaClient.getTemplatesFromAlgolia(query, stepType).then((_algoliaTemplates) => {
      dispatch(setAlgoliaTemplates(_algoliaTemplates));
    }).catch((err) => {
      if (err?.httpStatus === 401) {
        setTypesenseNotAvailable(true);
      }
      filterLocalTemplates(query, stepType);
    });
  };
  const filterLocalTemplates = (query, stepType) => {
    const searchKeywords = query?.split(" ");
    const filteredTemplates = templates.filter((item) => {
      const isSearch = Boolean(!item.isAddon) && (query?.trim()?.length ? searchKeywords.every(
        (keyword) => item.grammar.toLowerCase().includes(keyword?.trim().toLowerCase())
      ) : true);
      if (stepType && stepType !== "null") {
        return isSearch && item.stepActionType === stepType;
      } else {
        return isSearch && Boolean(!item.stepActionType);
      }
    });
    dispatch(
      setAlgoliaTemplates(
        filteredTemplates.map(
          (template, i) => ({
            ...template,
            objectID: `${i}`,
            action: [template.action || template.displayName || ""],
            deprecated: `${template.deprecated}`,
            id: `${template.id}`
          })
        )
      )
    );
  };
  useEffect(() => {
    if (!canRender && steps?.length > 0 && localSteps.length > 0 && nlActions?.length > 0 && testCase) {
      setCanRender(true);
    }
  }, [steps, nlActions, canRender, localSteps, algoliaTemplates, testCase]);
  useEffect(() => {
    if (algoliaTemplates.length < 1 && recorderSource === RECORDER_SOURCE.CLOUD) {
      fetchAlgoliaTemplates("", TestStepType.NLP_TEXT);
    }
  }, []);
  const handleStepDelete = (currentStep) => {
    const foundStep = localSteps.find((step) => step.id === currentStep.id);
    if (foundStep?.id) {
      stepDeleteModal.openModal({
        ids: [foundStep.id],
        number: foundStep.stepNumber
      });
    } else {
      setLocalSteps(localSteps.filter((stepItem) => Boolean(stepItem.id)));
      updateStepCursor(null);
    }
  };
  const onConfirmStepDelete = async () => {
    setIsStepDeleting(true);
    await deleteTestStep(stepDeleteModal.state.data?.ids);
    if (isDebugMode) {
      logEvent(analytics_constants_default.AMPLITUDE.LIVE_EDITOR_DELETE_STEP, {
        stepId: stepDeleteModal.state.data?.ids[0]
      });
    }
  };
  const handleCloseElementForm = () => {
    setEditUiIdentifier(void 0);
    setShowElementForm(false);
    setShowDerivedElement(false);
    setShowDerivedElementForm(void 0);
    setShowDirectCapture(false);
    if (!editUiIdentifier) {
      sendToWidget(CUSTOM_EVENT.ELEMENT_FINDER, void 0);
    }
    onCloseElementForm(null);
  };
  const handleEditElement = (name) => new Promise((resolve) => {
    if (name && appVersionId) {
      UiIdentifierApi.getOne({ name, appVersionId }).then(
        (uiIdentifierData) => {
          const uiIdentifer = uiIdentifierData.content[0];
          if (uiIdentifer) {
            if (uiIdentifer?.isSfField) {
              setShowDerivedElementForm(uiIdentifer);
              setShowDerivedElement(true);
            } else {
              setShowDerivedElement(false);
              setEditUiIdentifier(uiIdentifer);
              setShowElementForm(true);
            }
          } else {
            setShowToast(true);
            setToastMsg("Element not exist");
            setToastType(TOAST_TYPE.WARNING);
          }
        }
      );
    } else if (!name) {
      setShowElementForm(true);
    }
    resolve(null);
  });
  const openElementDrawer = (type, name) => {
    if (type === "list") {
      setShowElementsList(true);
      setHideFloatingIcons(true);
    } else if (type === "form") {
      handleEditElement(name);
    }
  };
  const {
    openElementListDrawer,
    openElementForm,
    onElementSelect,
    onCloseElementForm,
    onDiscard: onElementDiscard,
    nlpId
  } = useElementListDrawer(localSteps, openElementDrawer);
  const handleElementsListClose = () => {
    onElementDiscard?.();
    setShowElementsList(false);
    setHideFloatingIcons(false);
  };
  useEffect(() => {
    if (createdElement) {
      handleSelectUiIdentifier(createdElement);
    }
  }, [createdElement]);
  const handleSelectUiIdentifier = (uiIdentifer) => {
    onElementSelect(uiIdentifer);
    setShowElementsList(false);
    setHideFloatingIcons(false);
    setShowElementForm(false);
  };
  const handleDirectElementCaptured = (elementData) => {
    const uiIdentifier = {
      id: elementData.id,
      name: elementData.name,
      definition: elementData.definition,
      locatorType: elementData.locatorType,
      screenNameObj: { name: elementData.screenTitle },
      applicationVersionId: appVersionId
    };
    if (window["__directCaptureResolver"]) {
      window["__directCaptureResolver"].resolve({
        action: "SELECTED",
        details: uiIdentifier,
        autoSave: true
      });
      delete window["__directCaptureResolver"];
    }
    setShowDirectCapture(false);
    setDirectCaptureDetail(null);
  };
  const handleCloseDirectCapture = () => {
    setShowDirectCapture(false);
    setDirectCaptureDetail(null);
    if (window["__directCaptureResolver"]) {
      window["__directCaptureResolver"].reject(new Error("User cancelled"));
      delete window["__directCaptureResolver"];
    }
  };
  const openTestDataDrawer = (props) => {
    setTestDataDrawerType(props.modal);
  };
  const { handler: testDataHandler, onTestDataSelect } = useTestData(openTestDataDrawer);
  const getTestData2 = async (props) => await testDataHandler(props);
  const getStepWithTdpDetails = (stepIndex) => {
    let step = void 0;
    if (stepIndex >= 0)
      step = {
        ...localSteps[stepIndex],
        parentDataProfileIds: fetchAllParentDataProfiles(
          localSteps,
          localSteps[stepIndex],
          testCase,
          stepIndex
        )
      };
    else if (testCase?.testCaseDataDrivenCondition?.testDataProfileId || testCase?.testDataId) {
      step = {
        parentDataProfileIds: [
          {
            dataProfileId: testCase?.testCaseDataDrivenCondition?.testDataProfileId || testCase?.testDataId
          }
        ]
      };
    }
    return step;
  };
  const onActiveStepChange = (stepId) => {
    const stepIndex = localSteps?.length > 0 ? stepId ? localSteps.findIndex((step2) => step2.id === stepId) : localSteps.findIndex((step2) => step2.id === void 0) : -1;
    const step = getStepWithTdpDetails(stepIndex);
    setActiveStep(step);
    setActiveStepId(stepId);
    if (step) {
      dispatch(setStepCursor(step));
      dispatch(updateUserStepsCursor(step));
    } else {
      dispatch(setStepCursor(null));
      dispatch(updateUserStepsCursor(null));
    }
  };
  const handleStepDataValueChange = (type, dataValue) => {
    onTestDataSelect(type, dataValue);
    setTestDataDrawerType("");
  };
  const {
    openTestStepSettingsDrawer,
    onUpdate,
    onDiscard} = useTestStepSettingsDrawer(setSettingStep);
  const {
    openStepGroupsListDrawer,
    onSelectStepGroup,
    onDiscard: onDiscardStepGroups
  } = useStepGroupDrawer(setShowStepGroups);
  const fetchStepGroupSteps = (step, stepGroupTestCase) => new Promise((resolve) => {
    StepApi.getAll(
      `testCaseId:${step.stepGroupId}`,
      "stepOrder,id",
      STEPS_PAGE_SIZE,
      0,
      step?.id
    ).then((res) => {
      const pageData = res;
      let flattendStepResponse = flatTestSteps({
        teststeps: pageData.content,
        page: 0,
        stepGroup: step,
        stepGroupTestCase
      });
      step.stepGroupChildCount = flattendStepResponse.length;
      flattendStepResponse.forEach((item) => {
        item.stepOrder = Number(`${step.stepOrder}.${item.stepOrder}`);
      });
      flattendStepResponse = flattendStepResponse.map(
        (stepItem) => convertToOrganismStep(stepItem)
      );
      resolve(flattendStepResponse);
    }).catch((e) => {
      if (e?.status === 401) {
        showThirdPartyCookieToast();
      }
      resolve([]);
    });
  });
  const fetchSessions = useCallback(
    async (size2, page, sort) => {
      if (testCase?.id) {
        return await StepApi.getAll(
          `testCaseId:${testCase.id},templateId:1044`,
          sort,
          size2,
          page
        );
      }
    },
    [testCase]
  );
  const fetchPage = async (page, size2, customQuery, actionParam, refresh = false) => {
    if (refresh) {
      const refreshedSteps = await refreshPageContainingStep(
        { stepNumber: `${page * STEPS_PAGE_SIZE + 1}` },
        true,
        isDebugMode
      );
      dispatch(updateTestSteps(refreshedSteps));
      dispatch(updateUserStepsCursor(null));
      return;
    }
    if (page > maxFetchedPageNumber || actionParam?.type) {
      const stepsItems = await fetchTestSteps(
        page,
        size2 || STEPS_PAGE_SIZE,
        customQuery,
        actionParam
      );
      dispatch(updateTestSteps(stepsItems));
      dispatch(updateUserStepsCursor(null));
    }
  };
  const handleAboveBelow = (data) => {
    updateFilter(data.step);
    onAddStep(data.step, data.type, data.localStep);
  };
  const updateSelectedDataProfile = (data, isFetchParameter = false, onCompletion = NOOP) => {
    fetchDataParameter(
      data.id,
      updateDataParameterList,
      updateDataSetList,
      null,
      onCompletion
    );
  };
  const fetchDataProfile = useCallback(() => {
    if (!appVersionId) return;
    DataProfileApi.getAll(appVersionId).then((data) => {
      const transformed = data?.content?.map((profile) => ({
        ...profile,
        name: profile.testDataName
      })) ?? [];
      dispatch(setDataProfiles(transformed));
    }).catch(() => {
    });
  }, [appVersionId, dispatch]);
  const dataList = Object.keys(dataSetList?.content?.[0]?.data || []);
  const fetchTestCaseById = useCallback(
    async (id) => await TestCaseApi.getOne(`${id}`).then((res) => res).catch((e) => {
      if (e?.status === 401) {
        log.warn(
          "Could not fetch step group info. Please ensure third-party cookies are enabled while recording."
        );
      }
      return null;
    }),
    []
  );
  const showThirdPartyCookieToast = useCallback(() => {
    toastify(
      "Failed to perform action. Please ensure third-party cookies are enabled while recording.",
      {
        type: "error",
        position: "bottom-center",
        autoClose: 1e4,
        hideProgressBar: true
      }
    );
  }, []);
  const onUpdateStepSettingDrawer = (step) => {
    onUpdate(step);
    if (isDebugMode) {
      logEvent(
        analytics_constants_default.AMPLITUDE.LIVE_EDITOR_STEP_SETTING_UPDATE,
        {
          stepId: step.id
        }
      );
    }
  };
  const {
    updateSelectedSteps,
    selectedSteps,
    refreshStepList,
    isBulkActionEnabled,
    setIsBulkActionEnabled,
    handleBulkActionExit,
    canRenderBulkAction
  } = useBulkAction(fetchPage, steps);
  const isHighlightFeatureEnabled = useMemo(
    () => hasFeature(Feature.HIGHLIGHT_ELEMENT) && hasTenantPreference(Preference.HIGHLIGHT_ELEMENT),
    [hasFeature, hasTenantPreference]
  );
  const isAccessibilitySupported = useMemo(() => {
    if (!appVersion?.application || !tenantPreference) {
      return false;
    }
    const { applicationType } = appVersion.application;
    const { accessibilityTestingType } = tenantPreference;
    if (!accessibilityTestingType) {
      return false;
    }
    return hasFeature(Feature.ACCESSIBILITY_TESTING) && applicationType === ApplicationType.WebApplication && accessibilityTestingType == AccessibilityTestingType.STEP_LEVEL_APPROACH || hasFeature(Feature.ACCESSIBILITY_TESTING_SALESFORCE) && applicationType === ApplicationType.Salesforce && accessibilityTestingType == AccessibilityTestingType.STEP_LEVEL_APPROACH;
  }, [appVersion, tenantPreference]);
  useEffect(() => {
    const bgSteps = convertToOrganismSteps(userStepsData.steps || []);
    const nextCursor = cloneDeep(userStepsData.cursor || interimStep);
    if (!interimStep && !userStepsData.cursor) {
      setLocalSteps(bgSteps);
      updateStepCursor(null);
      setActiveStep(void 0);
      setActiveStepId(void 0);
      return;
    }
    if (interimStep && userStepsData.cursor?.id) {
      updateStepCursor(null);
      dispatch(setStepCursor(userStepsData.cursor));
      setLocalSteps(bgSteps);
      setActiveStep(userStepsData.cursor);
      setActiveStepId(userStepsData.cursor.id);
      return;
    }
    if (!interimStep && userStepsData.cursor) {
      setLocalSteps(bgSteps);
      dispatch(setStepCursor(userStepsData.cursor));
      setActiveStep(userStepsData.cursor);
      setActiveStepId(userStepsData.cursor.id);
      return;
    }
    if (!nextCursor || !nextCursor.stepOrder) {
      setLocalSteps(bgSteps);
      updateStepCursor(null);
      return;
    }
    const [firstHalf, secondHalf] = partition$1(
      bgSteps,
      (item) => isNumber(item.stepOrder) && isNumber(nextCursor.stepOrder) && item.stepOrder < nextCursor.stepOrder
    );
    const stepBeforeInterim = firstHalf[firstHalf.length - 1];
    if (stepBeforeInterim && stepBeforeInterim.parentId === nextCursor.parentId && (isDebugMode ? !nextCursor?.stepNumber : true)) {
      nextCursor.stepNumber = stepBeforeInterim.stepNumber ? getStepNumber(stepBeforeInterim.stepNumber, "below") : "-";
    }
    const interim = createTestStep2(
      nextCursor,
      "",
      nextCursor.stepOrder,
      nextCursor.stepNumber || "-",
      nextCursor.indent || 0,
      appType,
      testCase?.id,
      nextCursor.parentId
    );
    log.debug(
      LOG.WIDGET,
      `Moving step cursor to stepOrder=${interim.stepOrder}, stepNumber=${interim.stepNumber}, indent=${interim.indent}, parentId=${interim.parentId}`
    );
    updateStepCursor(interim);
    setLocalSteps([
      ...firstHalf || [],
      convertToOrganismStep(interim),
      ...secondHalf || []
    ]);
    setStepFilterType("null");
    fetchAlgoliaTemplates("", "null");
  }, [userStepsData]);
  useEffect(() => {
    sendToContentWindow(
      MESSAGE_CONTEXT.UPDATE_UNSAVED_STEP,
      MESSAGE_CONTEXT_ACTION.UPDATE,
      localSteps.some((step) => !step.id)
    );
    if (stepDeleteModal.state.data?.ids[0] && localSteps.findIndex(
      (_step) => _step.id === stepDeleteModal.state.data?.ids[0]
    ) === -1) {
      setIsStepDeleting(false);
      stepDeleteModal.closeModal();
    }
  }, [localSteps]);
  const openActionsListDrawer = useCallback(async () => {
    return new Promise(async (resolve) => {
      setActionsResolver(() => resolve);
      setShowActionsDrawer(true);
    });
  }, []);
  const handleActionsDrawerClose = () => {
    setShowActionsDrawer(false);
    if (actionsResolver) {
      actionsResolver({ action: DrawerActionResult.DISCARDED });
      setActionsResolver(null);
    }
  };
  const handleActionSelect = (action) => {
    setShowActionsDrawer(false);
    if (actionsResolver) {
      actionsResolver({ action: DrawerActionResult.SELECTED, details: action });
      setActionsResolver(null);
    }
  };
  const [directCaptureDetail, setDirectCaptureDetail] = useState(null);
  useEffect(() => {
    const handleDirectCaptureEvent = (event) => {
      setDirectCaptureDetail(event.detail);
      setShowDirectCapture(true);
    };
    window.addEventListener(
      "trigger-direct-capture",
      handleDirectCaptureEvent
    );
    return () => {
      window.removeEventListener(
        "trigger-direct-capture",
        handleDirectCaptureEvent
      );
    };
  }, []);
  const onUpdateBulkSettings = () => {
    if (isDebugMode) {
      logEvent(
        analytics_constants_default.AMPLITUDE.LIVE_EDITOR_BULK_STEP_SETTING_UPDATE
      );
    }
  };
  const shouldRenderBulkAction = canRenderBulkAction && Boolean(testCase);
  const finalDebugPoints = useMemo(() => {
    return debugPoints?.length > 0 ? debugPoints : testCaseResult?.debugPoints?.length ? testCaseResult?.debugPoints : [];
  }, [debugPoints, testCaseResult]);
  return /* @__PURE__ */ jsxs(Suspense, { children: [
    /* @__PURE__ */ jsx(If, { condition: selectedSteps.length === 0 && isDebugMode, children: /* @__PURE__ */ jsxs("div", { className: "flex flex-row justify-between items-center placeholder px-3 py-2 h-10 border-b border-slate-100", children: [
      /* @__PURE__ */ jsx(
        debugger_actions_buttons_default,
        {
          shouldDisableResume,
          onResumeExecution,
          onStepOverExecution,
          onSkipOverExecution,
          onRestartExecution,
          testSteps: stepsForChildResultCalculation,
          modifiedSteps,
          stepResults: stepResultsForChildResultCalculation,
          debugPoints: finalDebugPoints
        }
      ),
      /* @__PURE__ */ jsx(floating_actions_buttons_default, { hideFloatingIcons })
    ] }) }),
    shouldRenderBulkAction && /* @__PURE__ */ jsx(
      BulkActionBanner,
      {
        bulkActionEnabledChange: setIsBulkActionEnabled,
        testCaseId: testCase?.id,
        selectedSteps,
        totalSteps: steps,
        onExit: handleBulkActionExit,
        refreshStepList,
        isRecorder: true,
        updateSelectedSteps,
        steps,
        afterSteps: [],
        isHighlightFeatureEnabled,
        isAccessibilitySupported,
        onUpdateBulkSettings
      }
    ),
    canRender && /* @__PURE__ */ jsx(
      ListWrapper,
      {
        steps: localSteps,
        nlAction: nlActions,
        algoliaActions: algoliaTemplates,
        kibbutzActions: addonTemplates,
        getTestData: getTestData2,
        onCreateStep: handleCreate2,
        onUpdateStep: handleUpdate,
        onNestedCreateStep: handleAboveBelow,
        onSearch,
        isFetching: false,
        isCommand,
        isCommandCombine,
        onAddStep,
        onRemoveStep: handleStepDelete,
        onChangeType: updateFilter,
        testCaseId: testCase?.id,
        fetchPage,
        hasNextPage,
        openElementListDrawer,
        openElementFormDrawer: openElementForm,
        openStepGroupsListDrawer,
        openTestStepSettingsDrawer,
        openRestStep: NOOP,
        openSOQLStep: NOOP,
        applicationType: appType,
        dataParameterList: dataParameterList.content || [],
        dataProfileList: dataProfiles || [],
        dataSetList: dataList || [],
        updateSelectedDataProfile,
        selectedSteps,
        updateSelectedSteps,
        isAfterTestCase: false,
        isRecorderView: true,
        updateReorderModeState: onEnableReorder,
        isReordering: enableReorder,
        updateReorderedSteps,
        fetchStepGroupSteps,
        validateUrl: NOOP,
        testCase,
        onActiveStepChange,
        activeStepId,
        isWebRecorder: true,
        executedStepIds,
        debugPoints,
        currentExecutingStep,
        stepResults,
        debuggerActions,
        isBulkActionMode: isBulkActionEnabled,
        fetchTestCaseById,
        fetchDataProfile: isDebugMode ? fetchDataProfile : void 0,
        salesforceActions: new salesforce_actions_default(appVersionId),
        hasFeatureValue,
        sessionActions: { fetchSessions },
        lastUpdatedStepId: isDebugMode && !userStepsData?.lastStep ? firstStep?.id : userStepsData?.lastStep?.id ?? lastStep?.id,
        stepCreationInProgress,
        isDebugMode,
        fetchObjectActions: DesktopActionsApi.find,
        openActionsListDrawer,
        userPreference: {},
        afterTestCaseId: null,
        openCustomFunctionParameterDrawer: NOOP,
        modifiedSteps,
        selectedIterationByStepId,
        setSelectedIterationByStepId,
        debugExecutionStatus,
        setStepsForDebuggerButtons,
        openExternalUrl,
        getTdpBaseUrl: serverUrl != null ? () => serverUrl : void 0,
        versionId: recorderVersionId ?? appVersionId
      }
    ),
    /* @__PURE__ */ jsx(
      UiToast,
      {
        isShow: showToast,
        message: toastMsg,
        type: toastType,
        onClose: () => setShowToast(false),
        noAutoHide: false
      }
    ),
    showElementForm && /* @__PURE__ */ jsx(
      CreateElement,
      {
        uiIdentifier: editUiIdentifier,
        onClose: handleCloseElementForm,
        onUpdate: (elementData) => handleUpdateElement(elementData),
        nlpId
      }
    ),
    showElementsList && /* @__PURE__ */ jsx(
      UiIdentifiers,
      {
        onSelectUiIdentifier: (uiIdentifer) => {
          handleSelectUiIdentifier(uiIdentifer);
        },
        onClose: handleElementsListClose,
        currentElementName: getCurrentStepElement(),
        previousElementName: getPreviousStepElement(
          lastStep,
          localSteps
        ),
        nlpId,
        isDebugMode
      }
    ),
    testDataDrawerType && /* @__PURE__ */ jsx("span", { className: "test-data-container w-full ", children: /* @__PURE__ */ jsx(
      TestDataDrawer,
      {
        apiKey: testDataDrawerType,
        step: activeStep,
        onSelectDataValue: handleStepDataValueChange,
        closeTestDataDrawer: () => setTestDataDrawerType("")
      }
    ) }),
    settingStep && /* @__PURE__ */ jsx(
      StepSetting,
      {
        stepSetting: settingStep,
        onClose: onDiscard,
        updateStep: onUpdateStepSettingDrawer,
        isHighlightFeatureEnabled,
        isAccessibilitySupported
      }
    ),
    showDerivedElement && /* @__PURE__ */ jsx(
      DerivedElement,
      {
        onClose: handleCloseElementForm,
        uiIdentifier: showDerivedElementForm
      }
    ),
    showDirectCapture && /* @__PURE__ */ jsx(
      DirectElementCapture,
      {
        onClose: handleCloseDirectCapture,
        onElementCaptured: handleDirectElementCaptured,
        existingElement: directCaptureDetail
      }
    ),
    showStepGroups && /* @__PURE__ */ jsx(
      StepGroupsDrawer,
      {
        currentStepGroupName: activeStep?.action,
        onClose: onDiscardStepGroups,
        onSelectStepGroup
      }
    ),
    showActionsDrawer && /* @__PURE__ */ jsx(
      ActionsDrawer,
      {
        onSelect: handleActionSelect,
        onClose: handleActionsDrawerClose
      }
    ),
    stepDeleteModal.state.show && /* @__PURE__ */ jsx(
      Modal,
      {
        isOpen: stepDeleteModal.state.show,
        className: "!rounded-lg",
        overlayClassName: "",
        onClose: stepDeleteModal.closeModal,
        style: {},
        children: /* @__PURE__ */ jsxs("div", { className: "flex gap-x-6", children: [
          /* @__PURE__ */ jsx("div", { className: "h-12 w-12 rounded-full border-spacing-2.5 bg-error-50 flex items-center justify-center", children: /* @__PURE__ */ jsx(
            Icon,
            {
              name: "error",
              className: "flex text-2xl text-error-600 p-1 bg-error-100 rounded-full",
              setRef: () => {
              }
            }
          ) }),
          /* @__PURE__ */ jsxs("div", { className: "text-small leading-5 text-unique-800 flex flex-col w-[320px]", children: [
            /* @__PURE__ */ jsx("div", { className: "text-lg leading-7 font-semibold text-unique-600 pb-3", children: "Delete step?" }),
            `Are you sure you want to delete step ${stepDeleteModal?.state?.data?.number}. This action cannot be undone.`,
            /* @__PURE__ */ jsxs("div", { className: "flex gap-x-3 mt-6", children: [
              /* @__PURE__ */ jsx(
                DangerButton,
                {
                  isDisabled: isStepDeleting,
                  onClick: () => onConfirmStepDelete(),
                  children: "Delete"
                }
              ),
              /* @__PURE__ */ jsx(
                SecondaryButton,
                {
                  isDisabled: isStepDeleting,
                  onClick: stepDeleteModal.closeModal,
                  children: "Cancel"
                }
              )
            ] })
          ] })
        ] })
      }
    )
  ] });
}
function Body3({
  canFocusLastStep,
  onEnableReorder,
  onRefreshWidget
}) {
  const [hideFloatingIcons, setHideFloatingIcons] = useState(false);
  const newManualStepRef = useRef(null);
  const stepsContainerRef = useRef(null);
  const bodyScrollContainerRef = useRef(null);
  const {
    testSteps,
    recorderType,
    enableSaveElement,
    apiUrl,
    isEnableReorder,
    testCase,
    appVersionId,
    reorderedSteps: widgetReorderedSteps
  } = useSelector((state) => state.widget);
  const {
    executedStepIds,
    stepResultDetails,
    isStepResultLoading,
    testCaseResult,
    stepResultModalOpen,
    stepResultModelData,
    debugExecutionStatus
  } = useSelector((state) => state.debugging);
  const { isDebugger: isDebugMode } = useRecorderContext();
  const { modifiedSteps } = useSelector((state) => state.widget);
  const { debuggerActions, closeStepResultDetails } = use_web_debugger_default();
  const {
    resumeExecution,
    stepOverExecution,
    skipOverExecution,
    restartSession
  } = debuggerActions ?? {};
  const dispatch = useDispatch();
  const {
    stepResultsForChildResultCalculation,
    stepsForChildResultCalculation,
    selectedIterationByStepId
  } = useStepChildTreeContext();
  useEffect(() => {
    if (!isDebugMode) {
      scrollToBottom();
    }
  }, [testSteps.length]);
  const scrollToBottom = () => {
    if (bodyScrollContainerRef.current && canFocusLastStep) {
      bodyScrollContainerRef.current.scrollTo({
        top: bodyScrollContainerRef.current.scrollHeight,
        behavior: "smooth"
      });
    }
  };
  const handleStepDelete = async (ids) => {
    await deleteTestStep(ids);
  };
  const handleClone = async (step) => {
    delete step.stepOrder;
    delete step.parentId;
    const stepData2 = await createStep({
      ...step,
      id: void 0
    });
    dispatch(updateLastStep(stepData2));
    log.info("[WIDGET] STEP CREATED", stepData2);
    const updatedSteps = await pushStep(step, structuredClone(testSteps));
    dispatch(updateTestSteps(updatedSteps));
    return stepData2;
  };
  const handleBulkUpdate = async (data) => {
    await StepApi.bulkUpdateProperties(data, appVersionId);
    const updatedSteps = await refreshTestSteps(-1);
    dispatch(updateTestSteps(updatedSteps));
    dispatch(updateUserStepsCursor(null));
  };
  const handleBlockCreate = async ({
    blockName,
    stepStartPos,
    stepIds
  }) => {
    await BlockApi.createByStepIds({
      name: blockName,
      stepIds,
      stepStartPos,
      testCaseId: testCase?.id
    });
    const updatedSteps = await refreshTestSteps(-1);
    dispatch(updateTestSteps(updatedSteps));
    dispatch(updateUserStepsCursor(null));
  };
  const handleUpdateReorderedStepsForDebugger = useCallback(
    (steps) => {
      if (isEqual$1(steps, widgetReorderedSteps)) {
        return;
      }
      const stepValues = Array.from(stepsForChildResultCalculation.values());
      const getDebugStepId = (stepNumber) => stepValues.find((step) => step.stepNumber === stepNumber)?.debugStepId || "";
      dispatch(
        setReorderedSteps(
          steps.map((step) => ({
            ...step,
            debugStepId: getDebugStepId(step.stepNumber)
          }))
        )
      );
    },
    [dispatch, stepsForChildResultCalculation, widgetReorderedSteps]
  );
  const handleUpdateReorderedStepsForNormal = useCallback(
    (steps) => {
      if (!isEqual$1(steps, widgetReorderedSteps)) {
        dispatch(setReorderedSteps(steps));
        dispatch(updateTestSteps(steps));
      }
    },
    [dispatch, widgetReorderedSteps]
  );
  const restartExecution = useCallback(() => {
    restartSession();
  }, [dispatch, restartSession]);
  const isDisabled = !debugExecutionStatus || debugExecutionStatus === ResultConstant.RUNNING;
  console.log("debugExecutionStatus", debugExecutionStatus);
  const stepResultData = stepResultDetails ?? stepResultModelData?.stepResult;
  const stepsForChildResultCalculationArray = Array.from(stepsForChildResultCalculation.values());
  const _stepDataIdx = stepsForChildResultCalculationArray?.findIndex(
    (step) => step.id === stepResultDetails?.metadata?.testStep?.id
  );
  const stepData = _stepDataIdx === -1 ? null : stepsForChildResultCalculationArray[_stepDataIdx];
  const isModified = (modifiedSteps[stepData?.id] || []).includes(
    stepResultData?.uuid
  );
  return /* @__PURE__ */ jsxs(
    "div",
    {
      id: "ts-widget-body",
      ref: bodyScrollContainerRef,
      className: "relative overflow-auto min-h-0 flex-1",
      children: [
        recorderType === RECORDER_TYPE.STEP && /* @__PURE__ */ jsxs(Fragment$1, { children: [
          /* @__PURE__ */ jsxs("div", { id: "ts-widget-steps", className: "flex flex-col relative h-full", children: [
            /* @__PURE__ */ jsx(
              TestSteps,
              {
                onDelete: handleStepDelete,
                onClone: handleClone,
                enableReorder: isEnableReorder,
                onBulkUpdate: handleBulkUpdate,
                onEnableReorder,
                onBlockCreate: handleBlockCreate,
                isDebugMode,
                executedStepIds,
                debugExecutionStatus,
                hasNextPage: false,
                updateReorderedSteps: isDebugMode ? handleUpdateReorderedStepsForDebugger : handleUpdateReorderedStepsForNormal,
                setHideFloatingIcons,
                onRefreshWidget,
                shouldDisableResume: isDisabled,
                onResumeExecution: resumeExecution,
                hideFloatingIcons,
                onStepOverExecution: stepOverExecution,
                onSkipOverExecution: skipOverExecution,
                onRestartExecution: restartExecution
              }
            ),
            /* @__PURE__ */ jsx("div", { ref: stepsContainerRef })
          ] }),
          /* @__PURE__ */ jsx("div", { ref: newManualStepRef })
        ] }),
        recorderType === RECORDER_TYPE.ELEMENT && /* @__PURE__ */ jsx(
          "div",
          {
            id: "ts-widget-ui-identifiers",
            className: "flex flex-col h-full px-4.5 pt-4.5",
            children: /* @__PURE__ */ jsx(Elements, {})
          }
        ),
        (recorderType === RECORDER_TYPE.ELEMENT_CAPTURE || enableSaveElement) && /* @__PURE__ */ jsx(CreateElement, { onClose: NOOP }),
        stepResultModalOpen && /* @__PURE__ */ jsx(
          StepRunResult,
          {
            stepResultData: isModified ? {
              type: STEP_RESULT_TYPE.NEW_STEP,
              stepNumber: stepData?.stepNumber,
              metadata: { testStep: { id: stepData?.id } }
            } : stepResultData,
            stepData,
            testCaseResult,
            isStepResultLoading,
            onClose: closeStepResultDetails,
            apiUrl,
            openStepResultDetails: debuggerActions?.openStepResultDetails,
            stepResults: stepResultsForChildResultCalculation,
            totalSteps: stepsForChildResultCalculation.size,
            currentStepIndex: _stepDataIdx,
            stepsForChildResultCalculation,
            selectedIterationByStepId
          }
        )
      ]
    },
    "body"
  );
}
function HelpScreen({
  onClose,
  onRefreshWidget
}) {
  const Container = () => /* @__PURE__ */ jsx("div", { className: "flex flex-col gap-y-1.5 my-3", children: /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsxs("div", { className: "flex gap-x-1.5", children: [
      /* @__PURE__ */ jsx("span", { className: "", children: "1." }),
      /* @__PURE__ */ jsx("span", { className: "text-gray-600 font-semibold", children: "Recorder isn't working properly?" }),
      /* @__PURE__ */ jsx(
        "span",
        {
          className: "text-sky-700 font-bold cursor-pointer",
          onClick: () => onRefreshWidget(),
          children: "Reconfigure"
        }
      )
    ] }),
    /* @__PURE__ */ jsx("span", { className: "text-gray-500 font-semibold ml-4", children: "(Don't worry, your data is safe)" })
  ] }) });
  return /* @__PURE__ */ jsx(
    OverlayContainer,
    {
      body: /* @__PURE__ */ jsx(Container, {}),
      title: "Help",
      onClose: () => onClose()
    }
  );
}
var getModifiedSteps = (stepResults, steps) => {
  const stepResultByIds = groupBy(
    stepResults,
    (result) => result.metadata.testStep.id
  );
  const modifiedSteps = {};
  for (const step of steps) {
    const stepResultIds2 = (stepResultByIds[step.id] || []).map(
      (result) => result.uuid
    );
    if (stepResultIds2.length > 0) {
      modifiedSteps[step.id] = stepResultIds2;
    }
  }
  return modifiedSteps;
};
var getModifiedStepsForBulkUpdate = (stepResults, steps, selectedIterationByStepId) => {
  const modifiedSteps = {};
  for (const currentStep of steps) {
    const { result } = getLoopAndResultForAStep({
      step: currentStep,
      stepResultTree: stepResults,
      state: selectedIterationByStepId
    });
    const resultArray = Array.isArray(result) ? result : Boolean(result) ? [result] : [];
    if (resultArray.length > 0) {
      modifiedSteps[currentStep.id] = resultArray.map((result2) => result2.uuid);
    }
  }
  return modifiedSteps;
};
var ReorderStepsBanner = ({
  enableReorder,
  isRecorder = false
}) => {
  const [mounted, setMounted] = useState(false);
  const [isSending, updateSending] = useState(false);
  const { sendToBackground: sendToBackground2 } = useMessaging();
  const dispatch = useDispatch();
  const { reorderedSteps, appVersionId } = useSelector(
    (state) => state.widget
  );
  let reorderToastShown = false;
  const { isDebugger } = useRecorderContext();
  const {
    stepResultsForChildResultCalculation,
    stepsForChildResultCalculation,
    selectedIterationByStepId
  } = useStepChildTreeContext();
  const handleReOrder = async () => {
    await StepApi.reorder(reorderedSteps, appVersionId);
    const updatedSteps = await refreshTestSteps(-1);
    dispatch(updateTestSteps(updatedSteps));
    if (isDebugger) {
      const reorderedStepsModels = reorderedSteps.map(
        (step) => stepsForChildResultCalculation.get(step?.debugStepId)
      );
      const modifiedSteps = getModifiedStepsForBulkUpdate(
        stepResultsForChildResultCalculation,
        reorderedStepsModels,
        selectedIterationByStepId
      );
      dispatch(setModifiedSteps(modifiedSteps));
      logEvent(analytics_constants_default.AMPLITUDE.LIVE_EDITOR_REORDER_STEPS);
    }
    dispatch(updateUserStepsCursor(null));
    if (!reorderToastShown) {
      dispatch(setReorderedSteps([]));
      dispatch(setIsEnableReorder(false));
      if (!isDebugger) {
        sendToBackground2({
          context: MESSAGE_CONTEXT.STATE,
          action: MESSAGE_CONTEXT_ACTION.UPDATE,
          value: RECORDER_STATE.RUNNING
        });
      }
      toastify("Steps reordered successfully", {
        type: "success",
        position: "bottom-center",
        hideProgressBar: true
      });
      reorderToastShown = true;
      setTimeout(() => {
        reorderToastShown = false;
      }, 1e3);
    }
  };
  const handleReOrderAction = useCallback(
    (doSave) => {
      if (doSave) {
        if (!reorderedSteps || !reorderedSteps?.length) {
          return;
        }
        handleReOrder();
      } else {
        dispatch(setIsEnableReorder(false));
        if (!isDebugger) {
          sendToBackground2({
            context: MESSAGE_CONTEXT.STATE,
            action: MESSAGE_CONTEXT_ACTION.UPDATE,
            value: RECORDER_STATE.RUNNING
          });
        }
      }
    },
    [dispatch, reorderedSteps, sendToBackground2, isDebugger]
  );
  const handleSave = useCallback(() => {
    updateSending(true);
    handleReOrderAction(true);
  }, [updateSending, handleReOrderAction]);
  useEffect(() => {
    if (!enableReorder) {
      updateSending(enableReorder);
    }
    setTimeout(() => setMounted(enableReorder), 100);
  }, [enableReorder]);
  const saveButton = /* @__PURE__ */ jsx(
    PrimaryButton,
    {
      className: "ml-4",
      size: "sm",
      onClick: handleSave,
      isDisabled: isSending,
      children: "Save Order"
    }
  );
  const cancelButton = /* @__PURE__ */ jsx(
    SecondaryButton,
    {
      className: "ml-4",
      size: "sm",
      onClick: () => handleReOrderAction(false),
      isDisabled: isSending,
      children: "Cancel"
    }
  );
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames82(
        `flex ${isDebugger ? "justify-start" : "justify-end"} shadow-sm text-secondary-600 text-xs transition-height duration-[400ms] ease-out overflow-hidden z-50 bg-white`,
        mounted ? "h-12 py-3 opacity-100" : "h-0 opacity-50",
        {
          "pr-4": !isRecorder,
          "pl-[38px]": isRecorder
        }
      ),
      children: isDebugger ? /* @__PURE__ */ jsxs(Fragment, { children: [
        saveButton,
        cancelButton
      ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
        cancelButton,
        saveButton
      ] })
    }
  );
};
var OrgChangePopup = ({ onClose }) => {
  return /* @__PURE__ */ jsx(Dialog, { open: true, onClose: () => onClose(), children: /* @__PURE__ */ jsxs("div", { className: "p-6", children: [
    /* @__PURE__ */ jsx("div", { className: "flex items-center w-0 ", children: /* @__PURE__ */ jsx("div", { className: "bg-[#FFF4E5] w-20 mr-8 rounded-full p-2", children: /* @__PURE__ */ jsx("div", { className: "bg-[#FFE2BD] rounded-full p-2", children: /* @__PURE__ */ jsx(
      Icon,
      {
        className: "text-2xl bg-[#FFE2BD] text-[#D97008] text-center m-1",
        name: "error"
      }
    ) }) }) }),
    /* @__PURE__ */ jsxs("div", { className: " flex flex-col mt-6", children: [
      /* @__PURE__ */ jsx("div", { className: "font-semibold leading-7 text-lg text-[#06142D]", children: "You have moved to another Salesforce Organization!" }),
      /* @__PURE__ */ jsx("div", { className: "mt-2 text-[13px] text-[#3E4D65] leading-5", children: "We have detected a Salesforce org switch. The metadata for this org is not accessible in the current session." }),
      /* @__PURE__ */ jsx("div", { className: "mt-2 text-[13px] text-[#3E4D65] leading-5", children: "Note: All elements will be recorded as User learnt elements." }),
      /* @__PURE__ */ jsx("div", { className: "flex justify-end mt-6 rounded-md", children: /* @__PURE__ */ jsx(Button, { onClick: () => onClose(), children: "Okay, Got it" }) })
    ] })
  ] }) });
};
function UsageTable({ usage }) {
  return /* @__PURE__ */ jsxs("div", { className: "px-4 pt-10 flex flex-col", children: [
    /* @__PURE__ */ jsx("h2", { children: "Total" }),
    /* @__PURE__ */ jsxs("table", { className: "table-auto pt-4 text-left", children: [
      /* @__PURE__ */ jsx("thead", { children: /* @__PURE__ */ jsxs("tr", { children: [
        /* @__PURE__ */ jsx("th", { children: "Prompt Tokens" }),
        /* @__PURE__ */ jsx("th", { children: "Completion Tokens" }),
        /* @__PURE__ */ jsx("th", { children: "Prompt Cost" }),
        /* @__PURE__ */ jsx("th", { children: "Completion Cost" }),
        /* @__PURE__ */ jsx("th", { children: "Total Cost" })
      ] }) }),
      /* @__PURE__ */ jsx("tbody", { children: /* @__PURE__ */ jsxs("tr", { children: [
        /* @__PURE__ */ jsx("td", { children: usage.total?.prompt_tokens }),
        /* @__PURE__ */ jsx("td", { children: usage.total?.completion_tokens }),
        /* @__PURE__ */ jsxs("td", { children: [
          "$",
          usage.total?.prompt_cost
        ] }),
        /* @__PURE__ */ jsxs("td", { children: [
          "$",
          usage.total?.completion_cost
        ] }),
        /* @__PURE__ */ jsxs("td", { children: [
          "$",
          usage.total?.total_cost
        ] })
      ] }) })
    ] }),
    /* @__PURE__ */ jsx("h2", { className: "pt-5", children: "Last 10 requests" }),
    /* @__PURE__ */ jsxs("table", { className: "table-auto pt-4 text-left", children: [
      /* @__PURE__ */ jsx("thead", { children: /* @__PURE__ */ jsxs("tr", { children: [
        /* @__PURE__ */ jsx("th", { children: "Prompt Tokens" }),
        /* @__PURE__ */ jsx("th", { children: "Completion Tokens" }),
        /* @__PURE__ */ jsx("th", { children: "Prompt Cost" }),
        /* @__PURE__ */ jsx("th", { children: "Completion Cost" }),
        /* @__PURE__ */ jsx("th", { children: "Total Cost" })
      ] }) }),
      /* @__PURE__ */ jsx("tbody", { children: usage.last_10?.map((u) => /* @__PURE__ */ jsxs("tr", { children: [
        /* @__PURE__ */ jsx("td", { children: u.prompt_tokens }),
        /* @__PURE__ */ jsx("td", { children: u.completion_tokens }),
        /* @__PURE__ */ jsxs("td", { children: [
          "$",
          u.prompt_cost
        ] }),
        /* @__PURE__ */ jsxs("td", { children: [
          "$",
          u.completion_cost
        ] }),
        /* @__PURE__ */ jsxs("td", { children: [
          "$",
          u.total_cost
        ] })
      ] })) })
    ] })
  ] });
}
function Usage({ onClose }) {
  const [usageDetails, setUsageDetails] = useState({});
  useEffect(() => {
    AlphaApi.getUsage().then((res) => setUsageDetails(res));
  }, []);
  return /* @__PURE__ */ jsx(
    OverlayContainer,
    {
      body: /* @__PURE__ */ jsx(UsageTable, { usage: usageDetails }),
      title: "Usage",
      onClose: () => onClose()
    }
  );
}
var ResourceURLContext = createContext(null);
function useResourceURL() {
  const resourceURL = useContext(ResourceURLContext);
  if (!resourceURL) {
    throw new Error("useResourceURL must be used within a ResourceURLProvider");
  }
  return resourceURL;
}
var { Button: ButtonV213, BUTTON_SIZE: BUTTON_SIZE13 } = V2;
var CopilotWelcomeHeader = ({
  onGenerateScenarios,
  showGenerateScenariosButton = false,
  isGenerating = false
}) => {
  const { t } = useTranslation();
  const { getResourceURL } = useResourceURL();
  return /* @__PURE__ */ jsxs("div", { className: "px-4 pb-4", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-3", children: [
      /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
        "img",
        {
          src: getResourceURL("img/copilot-icon.svg"),
          alt: t("copilot.name"),
          width: "24",
          height: "24",
          className: "w-6 h-6"
        }
      ) }),
      /* @__PURE__ */ jsx("h3", { className: "text-base font-semibold text-gray-900", children: t("copilot.welcome.title") }),
      /* @__PURE__ */ jsxs("div", { className: "space-y-2", children: [
        /* @__PURE__ */ jsxs("p", { className: "text-sm text-gray-800 leading-relaxed", children: [
          /* @__PURE__ */ jsx("span", { className: "font-semibold", children: t("copilot.welcome.highlight") }),
          " ",
          t("copilot.welcome.description")
        ] }),
        /* @__PURE__ */ jsx("p", { className: "text-sm text-gray-800 leading-relaxed", children: t("copilot.welcome.coverage") })
      ] })
    ] }),
    showGenerateScenariosButton && !isGenerating && onGenerateScenarios && /* @__PURE__ */ jsx(
      ButtonV213,
      {
        size: BUTTON_SIZE13.SMALLEST,
        onClick: onGenerateScenarios,
        className: "!mt-4 !text-white shadow-ai-button !border-none",
        style: {
          background: "linear-gradient(119.16deg, #E58086 19.1%, #5C27F5 118.88%)"
        },
        children: t("copilot.welcome.generateButton")
      }
    )
  ] });
};
var empty_conversation_default = CopilotWelcomeHeader;
var _isNumericTid = (v) => {
  if (v == null) return false;
  const s = String(v);
  return /^\d+$/.test(s);
};
var _getElementDefinition = (step) => {
  if (step.xpath) return step.xpath;
  if (step.xpath_resolution_failed) return null;
  const tid = step.tid;
  if (!tid) return null;
  if (_isNumericTid(tid)) return null;
  return String(tid);
};
var saveCopilotSteps = async (data) => {
  const widgetState = getGlobalState().widget;
  const appVersionId = widgetState.appVersionId;
  const hasElementSteps = data.steps.some(
    (step) => step.tid || step.uiIdentifier || step.ui_identifier || step.elementRequest?.name || step.testStepElements?.[0]?.name
  );
  if (hasElementSteps && !appVersionId) {
    console.error(
      "[COPILOT] Cannot save steps with elements - appVersionId is missing"
    );
    throw new Error(
      "Application version ID is required to save steps with elements"
    );
  }
  const templates = widgetState.templates;
  for (const step of data.steps) {
    const stepGrammar = templates?.find((t) => t.id === step.templateId)?.grammar;
    const templateNeedsElement = stepGrammar != null ? /#{ui-?identifier}|#{from-?ui-?identifier}|#{to-?ui-?identifier}/i.test(stepGrammar) : null;
    if (templateNeedsElement === false) {
      delete step.elementRequest;
      delete step.tid;
      delete step.uiIdentifier;
      delete step.ui_identifier;
      delete step.xpath;
      delete step.hostElements;
      continue;
    }
    const hasElementName = step.uiIdentifier || step.ui_identifier || step.elementRequest?.name || step.testStepElements?.[0]?.name;
    const needsElement = step.tid || hasElementName;
    if (!needsElement && step.elementRequest && !step.elementRequest.screenNameId) {
      delete step.elementRequest;
    }
    const definition = _getElementDefinition(step);
    if (needsElement && !step.elementRequest) {
      const elementName2 = step.uiIdentifier || step.ui_identifier || step.testStepElements?.[0]?.name || "AI Generated Element";
      step.elementRequest = {
        name: elementName2,
        definition: definition ?? void 0,
        locatorType: definition ? "xpath" : void 0,
        createdType: "CHROME",
        applicationVersionId: appVersionId
      };
    }
    if (needsElement && step.elementRequest && definition) {
      if (!step.elementRequest.definition) {
        step.elementRequest.definition = definition;
      }
      if (!step.elementRequest.locatorType) {
        step.elementRequest.locatorType = "xpath";
      }
    }
    if (step.elementRequest && !step.elementRequest.name) {
      step.elementRequest.name = step.uiIdentifier || step.ui_identifier || step.testStepElements?.[0]?.name || "AI Generated Element";
    }
    const stepHostElements = step.hostElements;
    if (needsElement && step.elementRequest && stepHostElements?.length) {
      step.elementRequest.hostElements = stepHostElements;
    }
    if (needsElement && step.elementRequest) {
      const screenName = step.elementRequest.screenNameObj?.name || "Example Gen AI Screen";
      const screen = await getScreen(screenName);
      step.elementRequest.screenNameObj = screen;
      if (appVersionId && !step.elementRequest.applicationVersionId) {
        step.elementRequest.applicationVersionId = appVersionId;
      }
    }
  }
  await _saveCopilotSteps(data);
  const dispatch = getGlobalDispatch();
  const allStepsRes = await getAllPagesTestSteps(true);
  await dispatch(updateTestSteps(allStepsRes.content));
  const cursor = getGlobalState().widget.stepCursor;
  if (cursor) {
    await dispatch(updateUserStepsCursor(cursor));
  }
};
var _saveCopilotSteps = async (data) => {
  const widgetState = getGlobalState().widget;
  const templates = widgetState.templates;
  const appVersionId = widgetState.appVersionId;
  const testSteps = widgetState.testSteps;
  const testCaseId = widgetState.testCase?.id || data.steps?.[0]?.testCaseId;
  let stepCursor = widgetState.stepCursor;
  let targetParentId = null;
  let targetIndent = 0;
  let parentBlockForInsert = null;
  if (typeof data.addAfterStepOrder === "number") {
    const matchingStep = testSteps.find((s) => s.stepOrder === data.addAfterStepOrder);
    targetParentId = data.addAfterParentId !== void 0 ? data.addAfterParentId : matchingStep?.parentId ?? null;
    targetIndent = matchingStep?.indent ?? 0;
    if (targetParentId != null) {
      const block = testSteps.find((s) => s.id === targetParentId);
      if (block) {
        targetIndent = (block.indent ?? 0) + 1;
      }
    }
    parentBlockForInsert = targetParentId != null ? testSteps.find((s) => s.id === targetParentId) : null;
    const isInsertingInsideBlock = data.saveType !== "block" && targetParentId != null && parentBlockForInsert != null;
    let cursorStepOrder = data.addAfterStepOrder + 1;
    if (!isInsertingInsideBlock && data.saveType !== "block" && matchingStep?.parentId != null) {
      const descendants = findAllChildren2(testSteps, "parentId", matchingStep.parentId);
      const lastInStructure = descendants.length > 0 ? descendants.reduce((a, b) => (a?.stepOrder ?? 0) > (b?.stepOrder ?? 0) ? a : b) : matchingStep;
      const lastOrder = lastInStructure?.stepOrder;
      cursorStepOrder = lastOrder != null ? lastOrder + 1 : cursorStepOrder;
    }
    stepCursor = {
      ...matchingStep || {},
      stepOrder: cursorStepOrder,
      parentId: targetParentId,
      indent: targetIndent
    };
  } else if (typeof data.addAfterStepIndex === "number" && testSteps[data.addAfterStepIndex]) {
    stepCursor = {
      ...testSteps[data.addAfterStepIndex],
      stepOrder: testSteps[data.addAfterStepIndex].stepOrder + 1
    };
  }
  const { beginStepOrder: initialStepOrder, stepOrderIncrement } = await calculateCopilotStepOrder(data.steps, data.saveType, stepCursor);
  let beginStepOrder = initialStepOrder;
  const request = {
    testCaseId: testCaseId ? Number(testCaseId) : void 0
  };
  if (data.saveType === "block") {
    const blockStep = {
      action: data.name,
      stepOrder: beginStepOrder,
      type: TestStepType.BLOCK,
      childSteps: data.steps,
      // Use stepCursor so block is placed in same context as "Add After" (e.g. inside loop after 4.1)
      parentId: stepCursor?.parentId ?? void 0,
      indent: stepCursor?.indent ?? 0
    };
    request["testSteps"] = [blockStep];
    beginStepOrder += stepOrderIncrement;
  } else {
    request["testSteps"] = data.steps;
  }
  request["aiEntities"] = [{ interactions: [{ id: data.interactionId }] }];
  request["feature"] = "WEB_RECORDER_TEST_STEPS";
  for (let i = 0; i < data.steps.length; i++) {
    const step = data.steps[i];
    step.createType = EntityCreateType.AI;
    step.type = TestStepType.NLP_TEXT;
    const grammar = templates.find((t) => t.id === step.templateId)?.grammar;
    step.stepOrder = beginStepOrder + i * stepOrderIncrement;
    const alphaAction = step.action;
    step.action = grammar || alphaAction || "";
    step.disabled = false;
    step.isStepRecorder = true;
    if (stepCursor) {
      if (data.saveType === "block") {
        step.indent = 0;
      } else if (targetParentId != null && parentBlockForInsert != null) {
        step.parentId = targetParentId;
        step.indent = targetIndent;
      } else {
        step.parentId = null;
        step.indent = 0;
      }
    }
    const templateNeedsElement = grammar && /#{ui-?identifier}|#{from-?ui-?identifier}|#{to-?ui-?identifier}/i.test(grammar);
    if (templateNeedsElement && !step.elementRequest && appVersionId) {
      step.elementRequest = {
        name: `Copilot Element Step ${i + 1}`,
        createdType: ElementIdentifierCreateType.AI,
        updateType: ElementIdentifierCreateType.AI,
        applicationVersionId: appVersionId
      };
    }
    if (step.elementRequest) {
      step.elementRequest.createdType = ElementIdentifierCreateType.AI;
      step.elementRequest.updateType = ElementIdentifierCreateType.AI;
      step.elementRequest.screenNameId = step.elementRequest.screenNameObj?.id;
      if (appVersionId) {
        step.elementRequest.applicationVersionId = appVersionId;
      }
    }
  }
  if (!request.testCaseId) {
    console.error(
      "[COPILOT] Persist failed - testCaseId is required but not found"
    );
    throw new Error("Test case ID is required to save steps");
  }
  if (request.testSteps) {
    request.testSteps = request.testSteps.map((step) => {
      const {
        // Remove snake_case versions (from Alpha response)
        template_id,
        ui_identifier,
        test_data,
        // Remove camelCase versions not in Java TestStepRequest
        // tid = element locator (already in elementRequest.definition)
        // uiIdentifier = element name (already in elementRequest.name)
        // testData = redundant (already in stepDataList)
        tid,
        uiIdentifier,
        testData: testData2,
        // Remove xpath fields used only for frontend element resolution
        xpath,
        xpath_resolution_failed,
        // Remove hostElements from step level (already in elementRequest.hostElements)
        hostElements,
        ...cleanedStep
      } = step;
      return cleanedStep;
    });
  }
  await AlphaApi.persist(request);
  await advanceStepCursor(data.steps[data.steps.length - 1]);
};
var calculateCopilotStepOrder = async (copilotSteps, saveType, stepCursor) => {
  const steps = getGlobalState().widget.testSteps;
  let stepOrderIncrement = 1e3;
  let beginStepOrder = 1e3 + (steps.length ? steps[steps.length - 1].stepOrder : 0);
  if (steps.length && stepCursor) {
    const beforeIndex = steps.findLastIndex(
      (s) => s.stepOrder < stepCursor.stepOrder
    );
    const afterIndex = beforeIndex + 1;
    if (beforeIndex >= 0 && afterIndex < steps.length) {
      const beforeStepOrder = steps[beforeIndex].stepOrder;
      const afterStepOrder = steps[afterIndex].stepOrder;
      const numSteps = copilotSteps.length + 1 + Number(saveType === "block");
      stepOrderIncrement = (afterStepOrder - beforeStepOrder) / numSteps;
      beginStepOrder = beforeStepOrder + stepOrderIncrement;
    }
  }
  return { beginStepOrder, stepOrderIncrement };
};
var advanceStepCursor = async (lastCopilotStep) => {
  lastCopilotStep = { ...lastCopilotStep, stepNumber: null };
  const allSteps = getGlobalState()?.widget?.testSteps;
  const stepAfterLastCopilotStep = allSteps.find(
    (s) => s.stepOrder > lastCopilotStep.stepOrder
  );
  const cursorStepOrder = stepAfterLastCopilotStep ? (lastCopilotStep.stepOrder + stepAfterLastCopilotStep.stepOrder) / 2 : lastCopilotStep.stepOrder + 1e3;
  const nextCursor = moveStepCursorToNext(lastCopilotStep, cursorStepOrder);
  await getGlobalDispatch()(setStepCursor(nextCursor));
};
var useCopilotChatWindow = (options3 = {}) => {
  const { tenantId, testCaseResultId } = options3;
  const { sendToBackground: sendToBackground2 } = useMessaging();
  const optimisticLoadingCallbackRef = useRef(
    null
  );
  const setOptimisticLoadingCallback = useCallback(
    (callback) => {
      optimisticLoadingCallbackRef.current = callback;
    },
    []
  );
  const testSteps = useSelector(
    (state) => state.widget?.testSteps || []
  );
  const getExistingStepsContext = () => {
    if (!testSteps.length) return void 0;
    return testSteps.map((step, index) => ({
      stepNumber: index + 1,
      action: step.action || "",
      templateId: step.templateId,
      // Include element info if available
      elementName: step.element?.name
    }));
  };
  const generateScenarios = () => {
    optimisticLoadingCallbackRef.current?.("scenarios");
    const message = {
      context: MESSAGE_CONTEXT.COPILOT,
      action: MESSAGE_CONTEXT_ACTION.INITIATE,
      value: {
        action: COPILOT_ACTION.GENERATE_SCENARIOS,
        tenantId,
        testCaseResultId,
        context: {
          query: "Generate high level test Scenarios for the current page",
          existingSteps: getExistingStepsContext()
        }
      }
    };
    sendToBackground2(message);
  };
  const sendPromptQuery = (query, action, generatedScenarios) => {
    if (action === COPILOT_ACTION.GENERATE_STEPS) {
      optimisticLoadingCallbackRef.current?.("steps", query);
    }
    const context = {
      query,
      existingSteps: getExistingStepsContext()
    };
    if (generatedScenarios?.length) {
      context.generatedScenarios = generatedScenarios;
    }
    sendToBackground2({
      context: MESSAGE_CONTEXT.COPILOT,
      action: MESSAGE_CONTEXT_ACTION.INITIATE,
      value: {
        action,
        tenantId,
        testCaseResultId,
        context
      }
    });
  };
  const generateNextStep = (query, previousSteps = []) => {
    sendToBackground2({
      context: MESSAGE_CONTEXT.COPILOT,
      action: MESSAGE_CONTEXT_ACTION.INITIATE,
      value: {
        action: COPILOT_ACTION.GENERATE_NEXT_STEP,
        tenantId,
        testCaseResultId,
        context: {
          query,
          previousSteps,
          existingSteps: getExistingStepsContext()
        }
      }
    });
  };
  const saveCopilotSteps2 = async (_data) => {
    const data = structuredClone(_data);
    await saveCopilotSteps(data);
    const {
      addAfterStepOrder,
      addAfterParentId,
      addAfterStepIndex,
      executeAfterSave,
      ...backgroundData
    } = data;
    const context = {
      ...backgroundData,
      saveType: backgroundData.saveType
    };
    sendToBackground2({
      context: MESSAGE_CONTEXT.COPILOT,
      action: MESSAGE_CONTEXT_ACTION.SAVE_STEPS,
      value: {
        context
      }
    });
  };
  const cancelCopilotRequest = () => {
    sendToBackground2({
      context: MESSAGE_CONTEXT.COPILOT,
      action: MESSAGE_CONTEXT_ACTION.CANCEL,
      value: {}
    });
  };
  return {
    generateScenarios,
    sendPromptQuery,
    generateNextStep,
    saveCopilotSteps: saveCopilotSteps2,
    cancelCopilotRequest,
    setOptimisticLoadingCallback
  };
};
var use_copilot_chat_window_default = useCopilotChatWindow;
var { Button: ButtonV214, BUTTON_VARIANTS: BUTTON_VARIANTS17, BUTTON_SIZE: BUTTON_SIZE14 } = V2;
var getPageNameFromUrl = (url) => {
  if (!url) return null;
  try {
    const urlObj = new URL(url);
    return urlObj.hostname.replace(/^www\./, "");
  } catch {
    return null;
  }
};
var PromptInput = ({
  onSubmitPromptQuery,
  onCancel,
  isAiGeneratingReply,
  onGenerateScenarios,
  showGenerateScenariosButton = false
}) => {
  const { t } = useTranslation();
  const [promptText, setPromptText] = useState();
  const [promptType, setPromptType] = useState(
    COPILOT_ACTION.GENERATE_STEPS
  );
  const testCase = useSelector((state) => state.widget?.testCase);
  const pageUrl = testCase?.startUrl || testCase?.url || testCase?.testDataStartUrl;
  const pageName = getPageNameFromUrl(pageUrl);
  const contextualScenariosQuery = pageName ? `Generate high level test Scenarios for ${pageName}` : "Generate high level test Scenarios for the current page";
  const onPromptTextChange = (value) => {
    setPromptText(value);
  };
  const MIN_PROMPT_LENGTH = 3;
  const trimmedPrompt = useMemo(() => promptText?.trim() || "", [promptText]);
  const onSubmitQuery = useCallback(() => {
    if (trimmedPrompt.length < MIN_PROMPT_LENGTH) return;
    onSubmitPromptQuery(trimmedPrompt, promptType);
    setPromptText("");
  }, [onSubmitPromptQuery, trimmedPrompt, promptType]);
  const doPromptAction = useCallback(() => {
    if (isAiGeneratingReply) {
      onCancel();
    } else {
      onSubmitQuery();
    }
  }, [isAiGeneratingReply, onCancel, onSubmitQuery]);
  const disableSendQueryButton = useMemo(() => {
    return trimmedPrompt.length < MIN_PROMPT_LENGTH;
  }, [trimmedPrompt]);
  const handleKeyDown = (event) => {
    if (event.key === "Enter" && !event.shiftKey && !disableSendQueryButton) {
      event.preventDefault();
      onSubmitQuery();
    }
  };
  useCallback(() => {
    setPromptType(COPILOT_ACTION.GENERATE_SCENARIOS);
    setPromptText(contextualScenariosQuery);
  }, [contextualScenariosQuery]);
  useCallback(() => {
    setPromptType(COPILOT_ACTION.GENERATE_STEPS);
    setPromptText("");
  }, []);
  return /* @__PURE__ */ jsx("div", { className: "w-full py-2 px-4", children: /* @__PURE__ */ jsxs("div", { className: "w-full rounded-lg border border-[#B8C0CC] bg-white py-1.5 px-3 flex flex-col gap-3", children: [
    /* @__PURE__ */ jsx(
      Input,
      {
        type: "text",
        value: promptText || "",
        onChange: onPromptTextChange,
        onkeydown: handleKeyDown,
        isDisabled: isAiGeneratingReply,
        placeholder: t("copilot.prompt.placeholder"),
        hideErrorMessage: true,
        wrapperClassName: "w-full",
        className: "!border-none !bg-transparent !rounded-none",
        inputClassName: "!text-xs !leading-4 !text-gray-700 !px-0 !py-0 placeholder:!text-slate-400 placeholder:!text-xs placeholder:!font-normal",
        preventDefaultValue: true
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between", children: [
      showGenerateScenariosButton && onGenerateScenarios ? /* @__PURE__ */ jsx("div", { className: "rounded-border-radius-button bg-[linear-gradient(119.16deg,_#E58086_19.1%,_#5C27F5_118.88%)] p-[0.5px] shadow-[0px_1px_1px_0px_rgba(0,0,0,0.06),0px_4px_4px_-1px_rgba(0,0,0,0.02)]", children: /* @__PURE__ */ jsx(
        ButtonV214,
        {
          variant: BUTTON_VARIANTS17.SECONDARY,
          size: BUTTON_SIZE14.SMALLEST,
          onClick: onGenerateScenarios,
          disabled: isAiGeneratingReply,
          className: "!h-6 !w-[158px] !min-w-[158px] !border-none !rounded-border-radius-button",
          children: /* @__PURE__ */ jsx("span", { className: "font-medium text-xs leading-4 text-[#172B4D]", children: t("copilot.welcome.generateButton") })
        }
      ) }) : /* @__PURE__ */ jsx("div", {}),
      isAiGeneratingReply ? /* @__PURE__ */ jsx(
        ButtonV214,
        {
          variant: BUTTON_VARIANTS17.SECONDARY,
          size: BUTTON_SIZE14.SMALLEST,
          onClick: doPromptAction,
          iconLeft: "stop-circle",
          iconStyles: "text-sm text-gray-600",
          className: "!h-6 shadow-ai-button",
          children: t("copilot.stop")
        }
      ) : /* @__PURE__ */ jsx(
        ButtonV214,
        {
          variant: BUTTON_VARIANTS17.PRIMARY,
          size: BUTTON_SIZE14.SMALLEST,
          onClick: doPromptAction,
          disabled: disableSendQueryButton,
          iconRight: "arrow-right-long",
          iconStyles: "w-3.5 h-3.5",
          className: classNames82(
            "!h-6 !w-[90px] !min-w-[90px] !gap-1.5 !border !border-[0.5px] !text-xs !font-medium",
            "shadow-[0px_1px_1px_0px_rgba(0,0,0,0.06),0px_4px_4px_-1px_rgba(0,0,0,0.02)]",
            disableSendQueryButton ? "!bg-[rgba(203,213,225,1)] !border-[rgba(179,194,200,1)] !text-white" : "!bg-[rgba(9,59,77,1)] !border-[rgba(7,45,59,1)] !text-white"
          ),
          children: t("copilot.send")
        }
      )
    ] })
  ] }) });
};
var prompt_input_default = PromptInput;
var { Button: ButtonV215, BUTTON_VARIANTS: BUTTON_VARIANTS18, BUTTON_SIZE: BUTTON_SIZE15 } = V2;
var getScenarioDisplayName = (scenario) => {
  if (typeof scenario === "string") {
    return scenario;
  }
  return scenario.name || scenario.description || "Unnamed Scenario";
};
var getScenarioValue = (scenario) => {
  if (typeof scenario === "string") {
    return scenario;
  }
  return scenario.name || JSON.stringify(scenario);
};
var ScenariosMessage = ({
  message,
  onSelectScenario,
  isExpired,
  isGenerating
}) => {
  const { t } = useTranslation();
  const [visibleScenarios, setVisibleScenarios] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const containerRef = useRef(null);
  useEffect(() => {
    const raw = message.data?.scenarios;
    const scenarios = Array.isArray(raw) ? raw : [];
    if (scenarios.length <= 5) {
      setShowAll(true);
      setVisibleScenarios(scenarios.slice(0, 5));
    } else {
      setVisibleScenarios(scenarios.slice(0, showAll ? 10 : 5));
    }
  }, [showAll, message.data?.scenarios]);
  useEffect(() => {
    if (showAll && containerRef.current) {
      requestAnimationFrame(() => {
        containerRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "nearest"
        });
      });
    }
  }, [showAll]);
  const isDisabled = isExpired || isGenerating;
  const handleSelectScenario = (scenarioValue) => {
    if (isDisabled) return;
    onSelectScenario(scenarioValue);
  };
  const rawAll = message.data?.scenarios;
  const allScenarios = Array.isArray(rawAll) ? rawAll : [];
  const hasScenarios = allScenarios.length > 0;
  const isSuccessEmpty = message.data?.status === "success" && !hasScenarios;
  const isError = (message.data?.status === "error" || message.data?.status === "failed") && !hasScenarios;
  if (!hasScenarios) {
    return /* @__PURE__ */ jsx(
      "div",
      {
        ref: containerRef,
        className: "flex flex-col rounded-lg w-full gap-3 p-4 bg-gray-50 border border-gray-200 shadow-sm",
        children: /* @__PURE__ */ jsx("div", { className: "text-sm text-gray-500", children: isSuccessEmpty || isError ? t(
          "copilot.scenarios.noMatch",
          "No scenarios could be generated for this page. Try a different page or query."
        ) : t(
          "copilot.scenarios.cancelled",
          "Scenario generation was stopped. Please try again to generate test scenarios."
        ) })
      }
    );
  }
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ref: containerRef,
      className: "flex flex-col rounded-lg w-full min-h-[140px] gap-3 p-4 bg-gray-50 border border-gray-200 shadow-sm",
      children: [
        /* @__PURE__ */ jsxs("div", { className: "text-sm text-gray-800", children: [
          t("copilot.scenarios.generated"),
          " ",
          /* @__PURE__ */ jsx("span", { className: "font-medium", children: t("copilot.scenarios.selectOne") }),
          t("copilot.scenarios.willGenerate")
        ] }),
        /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-2 max-w-full", children: visibleScenarios.map((scenario, index) => /* @__PURE__ */ jsx(
          ButtonV215,
          {
            variant: BUTTON_VARIANTS18.SECONDARY,
            size: BUTTON_SIZE15.SMALLEST,
            className: classNames82(
              "!h-6 shadow-ai-button",
              isDisabled && "opacity-60"
            ),
            onClick: () => handleSelectScenario(getScenarioValue(scenario)),
            disabled: isDisabled,
            children: getScenarioDisplayName(scenario)
          },
          typeof scenario === "string" ? index : scenario.id || index
        )) }),
        !showAll && /* @__PURE__ */ jsx(
          ButtonV215,
          {
            variant: BUTTON_VARIANTS18.TERTIARY,
            size: BUTTON_SIZE15.SMALLEST,
            className: "!self-start !text-xs !font-medium !text-blue-600 !p-0",
            onClick: () => setShowAll(true),
            children: t("copilot.scenarios.viewMore")
          }
        )
      ]
    }
  );
};
var scenarios_message_default = ScenariosMessage;
var UserMessageBubble = ({ message }) => /* @__PURE__ */ jsx("div", { className: "overflow-hidden break-words min-w-[267px] max-w-full rounded-md border-[0.5px] border-[#F0F0F3] gap-3 py-2.5 px-3 bg-[#E2E7EE]", children: /* @__PURE__ */ jsx("span", { className: "font-sans font-normal text-[13px] leading-5 text-[#172B4D]", children: message.data.query }) });
var BotMessageBubbleWrapper = ({ children }) => /* @__PURE__ */ jsx("div", { className: "bg-white border border-gray-200 rounded-lg overflow-hidden", children });
var ErrorMessage = ({ message }) => /* @__PURE__ */ jsx("div", { className: "flex flex-col gap-2 p-3 bg-red-50 border border-red-200 rounded-lg", children: /* @__PURE__ */ jsxs("div", { className: "flex items-start gap-2", children: [
  /* @__PURE__ */ jsx("span", { className: "text-red-500 text-lg", children: "\u26A0\uFE0F" }),
  /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-1", children: [
    /* @__PURE__ */ jsx("p", { className: "text-sm text-red-700 font-medium", children: message.data?.message || "An error occurred" }),
    message.data?.suggestion && /* @__PURE__ */ jsx("p", { className: "text-xs text-red-600", children: message.data.suggestion })
  ] })
] }) });
var MessageBubble = ({
  message,
  sendPromptQuery,
  templates,
  isExpired,
  isGenerating,
  saveCopilotSteps: saveCopilotSteps2,
  onExecuteAfterSave,
  usedScenarioNames
}) => {
  const { getResourceURL } = useResourceURL();
  const { t } = useTranslation();
  const isUserMessage = message.type === COPILOT_MESSAGE_TYPE.USER_QUERY;
  const onSelectScenario = useCallback(
    (query) => {
      const usedScenarios = usedScenarioNames && usedScenarioNames.length > 0 ? usedScenarioNames.map((name) => ({ name })) : void 0;
      sendPromptQuery(query, COPILOT_ACTION.GENERATE_STEPS, usedScenarios);
    },
    [sendPromptQuery, usedScenarioNames]
  );
  const botMessageRenderers = useMemo(
    () => ({
      [COPILOT_MESSAGE_TYPE.SCENARIOS]: () => /* @__PURE__ */ jsx(
        scenarios_message_default,
        {
          message,
          onSelectScenario,
          isExpired,
          isGenerating
        }
      ),
      [COPILOT_MESSAGE_TYPE.STEPS]: () => /* @__PURE__ */ jsx(
        steps_message_default,
        {
          message,
          templates,
          saveCopilotSteps: saveCopilotSteps2,
          onExecuteAfterSave,
          onRetry: (query) => sendPromptQuery(query, COPILOT_ACTION.GENERATE_STEPS)
        }
      ),
      ERROR: () => /* @__PURE__ */ jsx(ErrorMessage, { message })
    }),
    [
      message,
      onSelectScenario,
      isExpired,
      isGenerating,
      templates,
      saveCopilotSteps2,
      onExecuteAfterSave,
      sendPromptQuery
    ]
  );
  const renderBotMessage = () => {
    const renderer = botMessageRenderers[message.type];
    if (!renderer) return null;
    if (message.type === COPILOT_MESSAGE_TYPE.SCENARIOS || message.type === COPILOT_MESSAGE_TYPE.STEPS) {
      return renderer();
    }
    return /* @__PURE__ */ jsx(BotMessageBubbleWrapper, { children: renderer() });
  };
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames82(
        "flex",
        isUserMessage ? "justify-end" : "justify-start"
      ),
      children: /* @__PURE__ */ jsx("div", { className: "max-w-[90%] w-fit flex items-start gap-x-3", children: isUserMessage ? /* @__PURE__ */ jsx(UserMessageBubble, { message }) : /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          "img",
          {
            src: getResourceURL("img/copilot-icon.svg"),
            alt: t("copilot.name"),
            width: "24",
            height: "24",
            className: "w-6 h-6 shrink-0"
          }
        ),
        /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-3", children: [
          message.type === COPILOT_MESSAGE_TYPE.STEPS && (message.data?.steps?.length || message.steps?.length || 0) > 0 && /* @__PURE__ */ jsxs(
            "span",
            {
              className: "text-sm",
              style: { color: "rgba(23, 43, 77, 1)" },
              children: [
                t("copilot.generated"),
                " ",
                /* @__PURE__ */ jsxs("span", { className: "text-indigo-500 font-medium", children: [
                  message.data?.steps?.length || message.steps?.length || 0,
                  " ",
                  t("copilot.testSteps")
                ] }),
                (message.data?.generationTimeSeconds || message.data?.generation_time_seconds) && /* @__PURE__ */ jsxs(Fragment, { children: [
                  " ",
                  t("copilot.in"),
                  " ",
                  /* @__PURE__ */ jsxs("span", { className: "text-indigo-500 font-medium", children: [
                    message.data.generationTimeSeconds || message.data.generation_time_seconds,
                    "s"
                  ] })
                ] }),
                "."
              ]
            }
          ),
          renderBotMessage()
        ] })
      ] }) })
    }
  );
};
var message_bubble_default = MessageBubble;
var ConversationHistory = ({
  chatHistory,
  sendPromptQuery,
  templates,
  saveCopilotSteps: saveCopilotSteps2,
  onExecuteAfterSave,
  isGenerating,
  usedScenarioNames
}) => {
  const filteredHistory = useMemo(() => {
    return chatHistory.filter((ch, index) => {
      if (!ch.data) {
        return false;
      }
      if (ch.type === COPILOT_MESSAGE_TYPE.USER_QUERY) {
        const query = ch.data?.query || "";
        if (query.toLowerCase().startsWith("generate high level test scenarios")) {
          return false;
        }
      }
      return true;
    });
  }, [chatHistory]);
  const lastScenariosIndex = useMemo(() => {
    for (let i = filteredHistory.length - 1; i >= 0; i--) {
      if (filteredHistory[i].type === COPILOT_MESSAGE_TYPE.SCENARIOS) {
        return i;
      }
    }
    return -1;
  }, [filteredHistory]);
  const isScenarioExpired = (index, messageType) => {
    if (messageType !== COPILOT_MESSAGE_TYPE.SCENARIOS) {
      return false;
    }
    if (lastScenariosIndex === -1) {
      return false;
    }
    return index < lastScenariosIndex;
  };
  return /* @__PURE__ */ jsx("div", { className: "flex flex-col gap-y-4 px-4 pb-16 mt-5", children: filteredHistory.map((message, index) => /* @__PURE__ */ jsx(
    message_bubble_default,
    {
      message,
      sendPromptQuery,
      templates,
      saveCopilotSteps: saveCopilotSteps2,
      onExecuteAfterSave,
      isExpired: isScenarioExpired(index, message.type),
      isGenerating,
      usedScenarioNames
    },
    index
  )) });
};
var conversation_history_default = ConversationHistory;
var { Button: ButtonV216, BUTTON_VARIANTS: BUTTON_VARIANTS19, BUTTON_SIZE: BUTTON_SIZE16 } = V2;
var CopilotWindow = ({ onClose }) => {
  const {
    isDebugger = false,
    tenantId,
    testCaseResultId
  } = useRecorderContext();
  const {
    generateScenarios,
    sendPromptQuery,
    saveCopilotSteps: saveCopilotSteps2,
    cancelCopilotRequest,
    setOptimisticLoadingCallback
  } = use_copilot_chat_window_default({ tenantId, testCaseResultId });
  const { t } = useTranslation();
  const { copilotData, copilotChatHistory, templates } = useSelector(
    (state) => state.widget
  );
  const { getResourceURL } = useResourceURL();
  const [usedScenarioNames, setUsedScenarioNames] = useState([]);
  useEffect(() => {
    if (!copilotChatHistory?.length) return;
    const newNames = [];
    for (let i = 0; i < copilotChatHistory.length; i++) {
      if (copilotChatHistory[i].type === COPILOT_MESSAGE_TYPE.USER_QUERY && i + 1 < copilotChatHistory.length && copilotChatHistory[i + 1].type === COPILOT_MESSAGE_TYPE.STEPS) {
        const query = copilotChatHistory[i].data?.query;
        if (query) newNames.push(query);
      }
    }
    if (newNames.length > 0) {
      setUsedScenarioNames((prev) => {
        const combined = [...prev];
        for (const name of newNames) {
          if (!combined.includes(name)) combined.push(name);
        }
        return combined.length > prev.length ? combined : prev;
      });
    }
  }, [copilotChatHistory]);
  const { debuggerActions } = use_web_debugger_default();
  useSelector(
    (state) => state.debugging?.currentExecutionStatus
  );
  const widgetTestSteps = useSelector(
    (state) => state.widget?.testSteps || []
  );
  const executeAfterSaveTimeoutRef = useRef(null);
  const saveInProgressRef = useRef(false);
  const onExecuteAfterSave = useCallback(
    (insertAfterStepId) => {
      if (!debuggerActions?.runFromStep && !debuggerActions?.restartSession)
        return;
      if (executeAfterSaveTimeoutRef.current) {
        clearTimeout(executeAfterSaveTimeoutRef.current);
      }
      executeAfterSaveTimeoutRef.current = setTimeout(() => {
        executeAfterSaveTimeoutRef.current = null;
        if (isDebugger && insertAfterStepId != null && debuggerActions.resumeExecution) {
          debuggerActions.resumeExecution(String(insertAfterStepId));
          return;
        }
        const steps = getGlobalState()?.widget?.testSteps ?? widgetTestSteps;
        const firstAddedStep = insertAfterStepId != null ? (() => {
          const idx = steps.findIndex((s) => s.id === insertAfterStepId);
          return idx >= 0 ? steps[idx + 1] : steps[0];
        })() : steps[0];
        const stepId = firstAddedStep?.id;
        if (stepId) {
          debuggerActions.runFromStep(stepId);
        } else {
          debuggerActions.restartSession?.();
        }
      }, 0);
    },
    [isDebugger, widgetTestSteps, debuggerActions]
  );
  useEffect(() => {
    return () => {
      if (executeAfterSaveTimeoutRef.current) {
        clearTimeout(executeAfterSaveTimeoutRef.current);
      }
    };
  }, []);
  useEffect(() => {
    const handler = (e) => {
      if (e.data?.type !== "ts_copilot_execute" || e.data?.from !== "testsigma_chrome")
        return;
      if (!debuggerActions?.runFromStep || !debuggerActions?.restartSession)
        return;
      const { startFromStepPosition, runFromStart } = e.data;
      const steps = getGlobalState()?.widget?.testSteps ?? [];
      if (runFromStart || startFromStepPosition == null) {
        debuggerActions.restartSession();
        return;
      }
      const step = steps.find(
        (s) => String(s.stepNumber) === String(startFromStepPosition) || parseFloat(String(s.stepNumber)) === startFromStepPosition
      );
      const stepId = step?.id;
      if (stepId) {
        debuggerActions.runFromStep(stepId);
      } else {
        debuggerActions.restartSession();
      }
    };
    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, [debuggerActions]);
  const isBackendGenerating = useMemo(() => {
    return copilotData?.status === COPILOT_STATE.GENERATING_SCENARIOS || copilotData?.status === COPILOT_STATE.GENERATING_STEPS;
  }, [copilotData?.status]);
  const [optimisticAction, setOptimisticAction] = useState(null);
  const [pendingUserMessage, setPendingUserMessage] = useState(
    null
  );
  const [allowLoadingIndicator, setAllowLoadingIndicator] = useState(false);
  const [hasUserInteracted, setHasUserInteracted] = useState(false);
  const optimisticTimeoutRef = useRef(null);
  const loadingIndicatorTimeoutRef = useRef(null);
  useEffect(() => {
    setOptimisticLoadingCallback(
      (action, userMessage) => {
        if (optimisticTimeoutRef.current) {
          clearTimeout(optimisticTimeoutRef.current);
        }
        if (loadingIndicatorTimeoutRef.current) {
          clearTimeout(loadingIndicatorTimeoutRef.current);
        }
        setHasUserInteracted(true);
        setErrorMessage(null);
        if (action === "scenarios") {
          setAllowLoadingIndicator(true);
          setOptimisticAction(action);
        } else {
          setAllowLoadingIndicator(false);
          if (userMessage) {
            setPendingUserMessage(userMessage);
          }
          setOptimisticAction(action);
          loadingIndicatorTimeoutRef.current = setTimeout(() => {
            setAllowLoadingIndicator(true);
          }, 150);
        }
        optimisticTimeoutRef.current = setTimeout(() => {
          setOptimisticAction(null);
          setPendingUserMessage(null);
          setAllowLoadingIndicator(true);
        }, 3e4);
      }
    );
    return () => {
      if (optimisticTimeoutRef.current) {
        clearTimeout(optimisticTimeoutRef.current);
      }
      if (loadingIndicatorTimeoutRef.current) {
        clearTimeout(loadingIndicatorTimeoutRef.current);
      }
    };
  }, [setOptimisticLoadingCallback]);
  useEffect(() => {
    if (isBackendGenerating && optimisticTimeoutRef.current) {
      clearTimeout(optimisticTimeoutRef.current);
      optimisticTimeoutRef.current = null;
    }
  }, [isBackendGenerating]);
  useEffect(() => {
    if (isBackendGenerating) {
      setOptimisticAction(null);
    }
  }, [isBackendGenerating]);
  useEffect(() => {
    if (copilotChatHistory?.length > 0) {
      setOptimisticAction(null);
      setPendingUserMessage(null);
      setAllowLoadingIndicator(true);
    }
  }, [copilotChatHistory?.length]);
  const [errorMessage, setErrorMessage] = useState(null);
  useEffect(() => {
    if (copilotData?.status === COPILOT_STATE.ERROR) {
      setOptimisticAction(null);
      setPendingUserMessage(null);
      setAllowLoadingIndicator(false);
      const err = copilotData?.error;
      const message = typeof err === "string" ? err : err?.message ?? copilotData?.message ?? t("copilot.error.default");
      setErrorMessage(message);
    } else {
      setErrorMessage(null);
    }
  }, [copilotData?.status, t]);
  const isAiGeneratingReply = allowLoadingIndicator && hasUserInteracted && (optimisticAction !== null || isBackendGenerating);
  const onSendMessage = useCallback(
    (query, action, generatedScenarios) => {
      if (isBackendGenerating) return;
      if (isDebugger) {
        logEvent(
          analytics_constants_default.AMPLITUDE.LIVE_EDITOR_COPILOT_WINDOW_SEND_MESSAGE,
          {
            query,
            action
          }
        );
      }
      sendPromptQuery(query, action, generatedScenarios);
    },
    [isDebugger, isBackendGenerating, sendPromptQuery]
  );
  const onCancelCopilotRequest = useCallback(() => {
    if (isDebugger) {
      logEvent(
        analytics_constants_default.AMPLITUDE.LIVE_EDITOR_COPILOT_WINDOW_CANCELLED
      );
    }
    setOptimisticAction(null);
    setPendingUserMessage(null);
    setAllowLoadingIndicator(true);
    cancelCopilotRequest();
  }, [isDebugger, cancelCopilotRequest]);
  const onSaveCopilotSteps = useCallback(
    async (data) => {
      if (saveInProgressRef.current) {
        throw new Error(
          t(
            "copilot.steps.saveInProgress",
            "Please wait for the current save to complete."
          )
        );
      }
      saveInProgressRef.current = true;
      if (isDebugger) {
        logEvent(
          analytics_constants_default.AMPLITUDE.LIVE_EDITOR_COPILOT_WINDOW_SAVE_STEPS,
          {
            saveType: data.saveType,
            interactionId: data.interactionId
          }
        );
      }
      try {
        await saveCopilotSteps2(data);
      } finally {
        saveInProgressRef.current = false;
      }
    },
    [isDebugger, saveCopilotSteps2, t]
  );
  const onGenerateScenarios = useCallback(() => {
    if (isBackendGenerating) return;
    if (isDebugger) {
      logEvent(
        analytics_constants_default.AMPLITUDE.LIVE_EDITOR_COPILOT_WINDOW_GENERATING_SCENARIOS
      );
    }
    generateScenarios();
  }, [isDebugger, isBackendGenerating, generateScenarios]);
  const hasGeneratedSteps = useMemo(() => {
    if (!copilotChatHistory?.length) return false;
    return copilotChatHistory.some(
      (message) => message.type === COPILOT_MESSAGE_TYPE.STEPS
    );
  }, [copilotChatHistory]);
  const scrollContainerRef = useRef(null);
  const scrollToBottom = useCallback(() => {
    if (scrollContainerRef.current) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          scrollContainerRef.current?.scrollTo({
            top: scrollContainerRef.current.scrollHeight,
            behavior: "smooth"
          });
        });
      });
    }
  }, []);
  useEffect(() => {
    if (copilotChatHistory?.length) {
      scrollToBottom();
    }
  }, [copilotChatHistory, scrollToBottom]);
  useEffect(() => {
    if (isAiGeneratingReply || pendingUserMessage) {
      scrollToBottom();
    }
  }, [isAiGeneratingReply, pendingUserMessage, scrollToBottom]);
  useLayoutEffect(() => {
    const scrollEl = scrollContainerRef.current;
    if (!scrollEl) return;
    const updateHeight = () => {
      const h = scrollEl.clientHeight;
      if (h > 0) {
        scrollEl.style.setProperty("--scroll-h", `${h}px`);
      }
    };
    updateHeight();
    const observer = new ResizeObserver(updateHeight);
    observer.observe(scrollEl);
    return () => observer.disconnect();
  }, []);
  useLayoutEffect(() => {
    const container = document.getElementById("ts-widget-container");
    if (!container) return;
    container.style.setProperty("transition", "none", "important");
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        container.style.removeProperty("transition");
      });
    });
  }, []);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      id: "ts-widget-copilot-window",
      className: "border-r border-secondary-200 overflow-hidden relative rounded-lg shadow-lg flex flex-col bg-[rgba(247,248,249,1)]",
      style: isDebugger ? { height: "100vh" } : { height: "100%" },
      children: [
        /* @__PURE__ */ jsx("div", { className: "absolute top-3 right-3 z-10", children: /* @__PURE__ */ jsx(
          Icon,
          {
            name: "close",
            className: "text-lg cursor-pointer text-gray-400 hover:text-gray-600",
            onClick: onClose
          }
        ) }),
        /* @__PURE__ */ jsx("div", { className: "flex-1 w-full overflow-hidden relative", children: /* @__PURE__ */ jsx(
          "div",
          {
            ref: scrollContainerRef,
            className: classNames82("overflow-auto scroll-smooth h-full", {
              "pb-12": (isAiGeneratingReply || pendingUserMessage && !allowLoadingIndicator) && copilotChatHistory?.length > 0,
              "pb-3": !((isAiGeneratingReply || pendingUserMessage && !allowLoadingIndicator) && copilotChatHistory?.length > 0)
            }),
            children: /* @__PURE__ */ jsx(
              "div",
              {
                className: "flex flex-col",
                style: { minHeight: "var(--scroll-h, 100%)" },
                children: /* @__PURE__ */ jsxs("div", { className: "mt-auto", children: [
                  /* @__PURE__ */ jsx(
                    empty_conversation_default,
                    {
                      onGenerateScenarios,
                      showGenerateScenariosButton: !copilotChatHistory?.length && !pendingUserMessage,
                      isGenerating: isAiGeneratingReply
                    }
                  ),
                  copilotChatHistory?.length > 0 && /* @__PURE__ */ jsx(
                    conversation_history_default,
                    {
                      chatHistory: copilotChatHistory,
                      sendPromptQuery: onSendMessage,
                      templates,
                      saveCopilotSteps: onSaveCopilotSteps,
                      onExecuteAfterSave,
                      isGenerating: isAiGeneratingReply,
                      usedScenarioNames
                    }
                  ),
                  pendingUserMessage && /* @__PURE__ */ jsx("div", { className: "flex justify-end px-4 pb-4 mt-6", children: /* @__PURE__ */ jsx("div", { className: "max-w-[90%] w-fit", children: /* @__PURE__ */ jsx("div", { className: "overflow-hidden break-words min-w-[267px] max-w-full rounded-md border-[0.5px] border-[#F0F0F3] gap-3 py-2.5 px-3 bg-[#E2E7EE]", children: /* @__PURE__ */ jsx("span", { className: "font-sans font-normal text-[13px] leading-5 text-[#172B4D]", children: pendingUserMessage }) }) }) }),
                  errorMessage && !isAiGeneratingReply && /* @__PURE__ */ jsxs("div", { className: "mx-4 mb-2 flex items-start gap-2 p-3 bg-red-50 border border-red-200 rounded-lg", children: [
                    /* @__PURE__ */ jsx("span", { className: "text-red-500 text-sm shrink-0 mt-0.5", children: "\u26A0" }),
                    /* @__PURE__ */ jsx("div", { className: "flex-1 min-w-0", children: /* @__PURE__ */ jsx("p", { className: "text-sm text-red-700", children: errorMessage }) }),
                    /* @__PURE__ */ jsx(
                      ButtonV216,
                      {
                        variant: BUTTON_VARIANTS19.TERTIARY,
                        size: BUTTON_SIZE16.SMALLEST,
                        className: "!shrink-0 !text-red-400 hover:!text-red-600 !p-0.5",
                        onClick: () => setErrorMessage(null),
                        "aria-label": "Dismiss error",
                        children: /* @__PURE__ */ jsx(Icon, { name: "close", className: "text-sm" })
                      }
                    )
                  ] })
                ] })
              }
            )
          }
        ) }),
        /* @__PURE__ */ jsxs("div", { className: "shrink-0 bg-white", children: [
          (isAiGeneratingReply || pendingUserMessage && !allowLoadingIndicator) && /* @__PURE__ */ jsxs("div", { className: "flex gap-x-2 items-center px-4 py-2", children: [
            /* @__PURE__ */ jsx(
              "img",
              {
                src: getResourceURL("img/copilot-icon.svg"),
                alt: t("copilot.name"),
                width: "20",
                height: "20",
                className: "shrink-0 animate-pulse"
              }
            ),
            /* @__PURE__ */ jsx("span", { className: "font-sans font-normal text-[13px] leading-5 text-[#172B4D]", children: pendingUserMessage && !allowLoadingIndicator ? pendingUserMessage : optimisticAction === "scenarios" || copilotData?.status === COPILOT_STATE.GENERATING_SCENARIOS ? t("copilot.generatingScenarios") : t("copilot.generatingSteps") }),
            /* @__PURE__ */ jsxs("div", { className: "ml-1 flex gap-1", children: [
              /* @__PURE__ */ jsx(
                "div",
                {
                  className: "w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce",
                  style: { animationDelay: "0ms" }
                }
              ),
              /* @__PURE__ */ jsx(
                "div",
                {
                  className: "w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce",
                  style: { animationDelay: "150ms" }
                }
              ),
              /* @__PURE__ */ jsx(
                "div",
                {
                  className: "w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce",
                  style: { animationDelay: "300ms" }
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ jsx(
            prompt_input_default,
            {
              onSubmitPromptQuery: onSendMessage,
              onCancel: onCancelCopilotRequest,
              isAiGeneratingReply,
              onGenerateScenarios,
              showGenerateScenariosButton: hasGeneratedSteps
            }
          )
        ] })
      ]
    }
  );
};
var CopilotWindow_default = CopilotWindow;
var StopDebuggingModal = ({
  isOpen,
  onClose,
  onConfirm,
  appType,
  isDesktopStepRecorderWidgetActive = false
}) => {
  const actions = [
    {
      name: "Stop",
      type: "danger",
      classNames: "bg-error-600 border hover:bg-error-700 rounded-lg !h-10 !w-[75px] inline-flex items-center justify-center",
      handler: onConfirm,
      isDisabled: false
    },
    {
      name: "Cancel",
      type: "secondary",
      classNames: "border !bg-white hover:!bg-secondary-100 rounded-lg !h-10 !w-[75px]",
      handler: onClose,
      isDisabled: false
    }
  ];
  const getModalHeaderText = () => {
    if (appType == "Salesforce") {
      return "End session";
    } else if (isDesktopStepRecorderWidgetActive) {
      return "Stop Desktop Step Recorder";
    } else {
      return "Stop Web Debugger run";
    }
  };
  const getModalDescriptionText = () => {
    if (appType == "Salesforce") {
      return "Are you sure you want to end the session?";
    } else if (isDesktopStepRecorderWidgetActive) {
      return "Are you sure you want to stop and exit the Desktop Step Recorder session?";
    } else {
      return "Are you sure you want to stop and exit the web Debugger run?";
    }
  };
  return /* @__PURE__ */ jsx(Fragment, { children: isOpen && /* @__PURE__ */ jsx(
    Modal,
    {
      isOpen,
      className: "rounded-lg max-w-[480px]",
      zIndex: 2e3,
      portalTarget: document.body,
      closeOnEscape: true,
      closeOnOutsideClick: true,
      children: /* @__PURE__ */ jsxs("div", { className: classNames82("flex !items-start py-1 pr-12 pl-1"), children: [
        /* @__PURE__ */ jsx(
          Icon,
          {
            name: "error",
            className: "flex text-2xl text-error-600 p-1 bg-error-100 rounded-full"
          }
        ),
        /* @__PURE__ */ jsxs("div", { className: classNames82("w-full ml-6"), children: [
          /* @__PURE__ */ jsx(
            "h3",
            {
              role: "heading",
              className: classNames82(
                "text-xl pb-4 !font-medium  text-unique-600 leading-7"
              ),
              children: getModalHeaderText()
            }
          ),
          /* @__PURE__ */ jsx("div", { className: "text-unique-800 font-normal text-small leading-4 flex flex-wrap w-[350px]", children: getModalDescriptionText() }),
          !!actions.length && /* @__PURE__ */ jsx(
            "div",
            {
              className: classNames82(
                "pt-4 flex flex-start !flex-row !gap-4 mt-4"
              ),
              children: actions.map((item, idx) => /* @__PURE__ */ jsx(
                Button,
                {
                  type: item.type,
                  onClick: item.handler,
                  className: item.classNames,
                  isDisabled: item?.isDisabled || false,
                  children: item.name
                },
                idx
              ))
            }
          )
        ] })
      ] })
    }
  ) });
};
var { Button: ButtonV217, BUTTON_SIZE: BUTTON_SIZE17 } = V2;
var DESKTOP_RECORDER_UI_COMMANDS = {
  STOP_DESKTOP_RECORDER: "STOP_DESKTOP_RECORDER"
};
var DESKTOP_RECORDER_COMMANDS = {
  DESKTOP_STEP_RECORDER_LAUNCH_EVENT_COMMAND: "desktop_step_recorder_launch_event_command"
};
var ToolTip49 = ToolTip;
function Header3({
  onMinimizeStatus,
  onRefreshWidget,
  openCopilotWindow,
  hidePrimaryHeader
}) {
  const { sendToBackground: sendToBackground2 } = useMessaging();
  const { getIframeRecorderEnabled } = useUtilsContext();
  const {
    actions: recorder,
    isDebugger: isDebugMode,
    isDesktopStepRecorderWidgetActive
  } = useRecorderContext();
  const { getResourceURL } = useResourceURL();
  const [isIframeRecoderEnabled, setIsIframeRecoderEnabled] = useState(false);
  const [captureStepId, setCaptureStepId] = useState(null);
  const { t } = useTranslation();
  const {
    recorderType,
    testCase,
    recorderState,
    enableClickHover,
    isEnableReorder,
    appType,
    recorderPreferences,
    appVersionId,
    copilotWindowOpenState,
    // eslint-disable-line @typescript-eslint/no-unused-vars
    tenantFeatures,
    tenantPreference,
    reconfInProgress,
    isDesktopRecorderActionLoading
  } = useSelector((state) => state.widget);
  const dispatch = useDispatch();
  const { debugExecutionStatus } = useSelector(
    (state) => state.debugging
  );
  const headerTitle = useMemo(() => {
    if (isDebugMode) {
      return testCase?.name ?? "";
    }
    switch (recorderType) {
      case RECORDER_TYPE.ELEMENT:
        return "Record Elements";
      case RECORDER_TYPE.STEP:
        return testCase?.name ?? "Testsigma Recorder";
      default:
        return "Record Element";
    }
  }, [recorderType, isDebugMode, testCase?.name]);
  const isCopilotEnabled = useMemo(
    () => tenantFeatures?.includes(Feature.GEN_AI) && Boolean(tenantPreference?.["genaiRecorder"]),
    [tenantFeatures, tenantPreference]
  );
  const locators = recorderPreferences?.preferences?.find((item) => item.type === PREFERENCE_TYPE.LOCATOR_ORDER)?.preference?.locator?.map(
    (item) => DEFAULT_LOCATOR_PRECEDENCE[ApplicationType.WebApplication].find(
      (pref) => pref.id == item
    )
  ) || DEFAULT_LOCATOR_PRECEDENCE[ApplicationType.WebApplication];
  const headerRef = React5__default.useRef();
  const stopDebuggerExecutionModal = useModal();
  appType === ApplicationType.AndroidNative;
  appType === ApplicationType.IOSNative;
  const disableRecordOption = useMemo(() => {
    return !!isDebugMode && !!debugExecutionStatus && debugExecutionStatus === ResultConstant.RUNNING;
  }, [isDebugMode, debugExecutionStatus]);
  const handleRecorderAction = useCallback(
    (action, forceSubmitAction) => {
      if ((!!debugExecutionStatus || isDesktopStepRecorderWidgetActive) && action === RECORDER_ACTION.STOP && !forceSubmitAction && !isDebugMode) {
        stopDebuggerExecutionModal.openModal();
        return;
      }
      log.info(LOG.WIDGET, "SEND TO CONTENT:: ====>", {
        context: MESSAGE_CONTEXT.STATE,
        action: MESSAGE_CONTEXT_ACTION.UPDATE,
        value: recorder.findStateByAction(action)
      });
      if (recorderType === RECORDER_TYPE.ELEMENT_CAPTURE && action === RECORDER_ACTION.STOP) {
        sendToBackground2({
          context: MESSAGE_CONTEXT.ELEMENT_FINDER,
          action: MESSAGE_CONTEXT_ACTION.CLOSE,
          value: null
        });
      } else {
        if (Boolean(isDesktopStepRecorderWidgetActive) && action === RECORDER_ACTION.PAUSE) {
          dispatch(setIsDesktopRecorderActionLoading(true));
          recorder.triggerDebuggerCommand({
            command: DEBUGGER_COMMANDS.DETACH_EVENT_COMMAND
          });
        } else if (isDebugMode && action === RECORDER_ACTION.STOP) {
          recorder.triggerDebuggerCommand({
            command: DEBUGGER_COMMANDS.DETACH_EVENT_COMMAND
          });
        } else if (isDesktopStepRecorderWidgetActive && (action === RECORDER_ACTION.START || action === RECORDER_ACTION.RESUME)) {
          dispatch(setIsDesktopRecorderActionLoading(true));
          recorder.triggerDebuggerCommand({
            command: DESKTOP_RECORDER_COMMANDS.DESKTOP_STEP_RECORDER_LAUNCH_EVENT_COMMAND,
            actionType: DESKTOP_RECORDER_ACTION_TYPES.RESUME
          });
        } else {
          sendToBackground2({
            context: MESSAGE_CONTEXT.STATE,
            action: MESSAGE_CONTEXT_ACTION.UPDATE,
            value: recorder.findStateByAction(action)
          });
        }
      }
    },
    [
      disableRecordOption,
      debugExecutionStatus,
      recorderType,
      dispatch,
      isDesktopStepRecorderWidgetActive,
      recorder
    ]
  );
  useEffect(() => {
    if ((disableRecordOption || isEnableReorder) && !isDesktopStepRecorderWidgetActive) {
      handleRecorderAction(RECORDER_ACTION.PAUSE);
    }
  }, [disableRecordOption, isEnableReorder, isDesktopStepRecorderWidgetActive]);
  const updateLocatorPrecedence = async (locator) => {
    try {
      const applicationVersion = await ApplicationVersionApi.getOne(
        appVersionId || 0
      );
      const response = await RecorderPreferencesApi.update({
        type: PREFERENCE_TYPE.LOCATOR_ORDER,
        applicationId: applicationVersion.applicationId,
        applicationType: applicationVersion?.application?.applicationType,
        preference: { locator: locator.map((item) => item.id) }
      });
      const preferences = await RecorderPreferencesApi.getAll(
        applicationVersion.applicationId,
        applicationVersion?.application?.applicationType
      );
      dispatch(setRecorderPreferences(preferences));
      sendToBackground2({
        context: MESSAGE_CONTEXT.RECORDER,
        action: MESSAGE_CONTEXT_ACTION.SYNC_PREFERENCE,
        value: preferences
      });
      return response;
    } catch (error) {
      const errorMessage = t("common.message.update.failure", {
        fieldName: "Preference"
      });
      return {
        error: {
          message: error?.response?.data?.message || errorMessage
        }
      };
    }
  };
  const showCopilotButton = useMemo(
    () => isCopilotEnabled && (recorderType === RECORDER_TYPE.STEP || isDebugMode) && !isDesktopStepRecorderWidgetActive,
    [
      isCopilotEnabled,
      recorderType,
      isDebugMode,
      isDesktopStepRecorderWidgetActive
    ]
  );
  const handleRecorderStop = () => {
    if (recorderType === RECORDER_TYPE.ELEMENT_CAPTURE) {
      sendToBackground2({
        context: MESSAGE_CONTEXT.ELEMENT_FINDER,
        action: MESSAGE_CONTEXT_ACTION.CLOSE,
        value: null
      });
      return;
    } else {
      handleRecorderAction(RECORDER_ACTION.STOP);
    }
  };
  const handleDesktopStepRecorderStop = () => {
    recorder.triggerDebuggerCommand({
      command: DESKTOP_RECORDER_UI_COMMANDS.STOP_DESKTOP_RECORDER
    });
  };
  const enableScroll = useSelector(selectIsScrollRecordingEnabled);
  const { updateIsScrollRecordingEnabled: updateIsScrollRecordingEnabled2 } = useWidgetV2Actions();
  const onEnableScrollChange = () => {
    updateIsScrollRecordingEnabled2(!enableScroll);
  };
  useEffect(() => {
    if (getIframeRecorderEnabled) {
      getIframeRecorderEnabled().then((enabled) => {
        setIsIframeRecoderEnabled(enabled);
      });
    }
  }, []);
  useEffect(() => {
    const handleElementCaptureStart = (event) => {
      setCaptureStepId(event.detail?.stepId || null);
    };
    const handleElementCaptureEnd = (event) => {
      if (event.detail?.stepId === captureStepId || event.detail?.stepId === null) {
        setCaptureStepId(null);
      }
    };
    window.addEventListener(
      "element-capture-start",
      handleElementCaptureStart
    );
    window.addEventListener(
      "element-capture-end",
      handleElementCaptureEnd
    );
    return () => {
      window.removeEventListener(
        "element-capture-start",
        handleElementCaptureStart
      );
      window.removeEventListener(
        "element-capture-end",
        handleElementCaptureEnd
      );
    };
  }, [captureStepId]);
  const isRecorderRunning = !!recorderState && recorderState === RECORDER_STATE.RUNNING;
  return /* @__PURE__ */ jsxs("div", { ref: headerRef, className: "overflow-hidden", children: [
    !hidePrimaryHeader && /* @__PURE__ */ jsxs(
      "div",
      {
        id: "ts-widget-header",
        className: classNames82("flex items-center overflow-hidden ", {
          "py-2 px-3 gap-x-1.5 bg-white !border-b-[0.5px] !border-[#E2E7EE]": isDebugMode,
          "p-3 gap-x-3 bg-secondary-50": !isDebugMode
        }),
        children: [
          /* @__PURE__ */ jsxs("span", { className: "relative shrink-0 flex items-center", children: [
            /* @__PURE__ */ jsx(
              "img",
              {
                src: getResourceURL("img/icon-dark.svg"),
                alt: t("recorder.logo"),
                width: "20",
                height: "20",
                className: "h-5 w-fit shrink-0"
              }
            ),
            /* @__PURE__ */ jsx("span", { className: "absolute -top-1 -right-1 p-0.5 bg-secondary-50 h-3 w-3 flex items-center justify-center rounded-full", children: /* @__PURE__ */ jsx(
              Icon,
              {
                name: "ellipse",
                className: classNames82("text-[8px]", {
                  "animate-blink text-red-600": isRecorderRunning,
                  "text-secondary-500": !isRecorderRunning
                })
              }
            ) })
          ] }),
          /* @__PURE__ */ jsx("div", { className: "flex-1 overflow-hidden", children: /* @__PURE__ */ jsx(
            TruncatedText,
            {
              className: classNames82(
                "text-small leading-5 text-primary-1000 font-semibold block"
              ),
              value: headerTitle
            }
          ) }),
          /* @__PURE__ */ jsxs(
            "span",
            {
              className: classNames82("flex items-center shrink-0", {
                "space-x-3": !isDebugMode
              }),
              children: [
                showCopilotButton && /* @__PURE__ */ jsxs(
                  ButtonV217,
                  {
                    size: BUTTON_SIZE17.SMALLEST,
                    onClick: openCopilotWindow,
                    className: "!flex !items-center !text-white !font-medium !transition-all hover:!opacity-90 !shrink-0 !w-[132px] !h-7 !rounded-[5px] !border-none !gap-1.5 !py-1 !pl-2 !pr-3 !shadow-[0px_4px_4px_-1px_rgba(0,0,0,0.02),0px_1px_1px_0px_rgba(0,0,0,0.06)]",
                    style: {
                      background: "linear-gradient(119.16deg, #E58086 19.1%, #5C27F5 118.88%)"
                    },
                    children: [
                      /* @__PURE__ */ jsx(
                        "img",
                        {
                          src: getResourceURL("img/copilot-icon.svg"),
                          alt: "Copilot",
                          width: "12",
                          height: "12",
                          className: "brightness-0 invert w-3 h-3"
                        }
                      ),
                      /* @__PURE__ */ jsx("span", { className: "font-sans font-medium text-xs leading-4 text-white", children: "Generate Steps" })
                    ]
                  }
                ),
                isDebugMode && /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
                  ActionIcon_default,
                  {
                    tooltip: "Exit Copilot",
                    icon: "exit",
                    onClick: handleRecorderStop,
                    buttonClassName: classNames82({
                      "h-7 !w-7 shadow-debugger-icon": isDebugMode
                    }),
                    iconClass: "text-error-600",
                    className: classNames82({
                      "h-7 !w-7 shadow-debugger-icon": isDebugMode,
                      "h-5 !w-5": !isDebugMode
                    })
                  }
                ) }),
                !isDebugMode && !isDesktopStepRecorderWidgetActive && /* @__PURE__ */ jsx(
                  LocatorPrecedence,
                  {
                    locators,
                    defaultLocators: DEFAULT_LOCATOR_PRECEDENCE[ApplicationType.WebApplication],
                    onUpdate: updateLocatorPrecedence
                  }
                ),
                !isDebugMode && !isDesktopStepRecorderWidgetActive && /* @__PURE__ */ jsx(ToolTip49, { content: "Reconfigure", className: "flex shrink-0", children: /* @__PURE__ */ jsx(
                  Icon,
                  {
                    name: "refresh",
                    className: classNames82(
                      " text-[22px] text-icon-primary cursor-pointer",
                      { "animate-spin": reconfInProgress }
                    ),
                    onClick: onRefreshWidget,
                    onMouseDown: (e) => e.stopPropagation()
                  }
                ) }),
                !isDebugMode && !isIframeRecoderEnabled && !isDesktopStepRecorderWidgetActive && /* @__PURE__ */ jsx(ToolTip49, { content: "Minimize", className: "h-5 flex", children: /* @__PURE__ */ jsx(
                  Icon,
                  {
                    name: "minimise",
                    className: " text-[22px] text-icon-primary cursor-pointer",
                    onClick: onMinimizeStatus,
                    onMouseDown: (e) => e.stopPropagation()
                  }
                ) })
              ]
            }
          )
        ]
      },
      "header"
    ),
    !isDebugMode && /* @__PURE__ */ jsxs(
      "div",
      {
        id: "ts-widget-sub-header",
        className: "px-3.5 py-2.5 flex justify-between space-x-3 items-center border-b-[0.5px] border-secondary-200",
        children: [
          /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
            !isDebugMode && recorderType === RECORDER_TYPE.STEP && appType !== ApplicationType.MobileWeb && !isDesktopStepRecorderWidgetActive && /* @__PURE__ */ jsx(ToolTip49, { content: "Click as Mouseover", children: /* @__PURE__ */ jsxs(
              "button",
              {
                onClick: () => dispatch(setEnableClickHover(!enableClickHover)),
                className: `
                      flex bg-transparent border-0 cursor-pointer relative
                      disabled:cursor-not-allowed disabled:opacity-50
                    `,
                disabled: !isRecorderRunning,
                children: [
                  enableClickHover && /* @__PURE__ */ jsx(
                    "span",
                    {
                      className: classNames82(
                        "w-3 h-3 block absolute rounded-full bg-red-900 left-0.5 top-0",
                        {
                          "scale-150 opacity-40": !isRecorderRunning,
                          "animate-ping": isRecorderRunning
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    Icon,
                    {
                      name: "touch",
                      className: " text-[22px] text-icon-primary cursor-pointer"
                    }
                  )
                ]
              }
            ) }),
            !isDebugMode && recorderType === RECORDER_TYPE.STEP && !isDesktopStepRecorderWidgetActive && /* @__PURE__ */ jsx(
              ToolTip49,
              {
                content: enableScroll ? "Disable scroll action recording" : "Enable scroll action recording",
                children: /* @__PURE__ */ jsx(
                  "button",
                  {
                    onClick: onEnableScrollChange,
                    className: `flex bg-transparent border-0 cursor-pointer relative disabled:cursor-not-allowed disabled:opacity-50 `,
                    disabled: !isRecorderRunning,
                    children: /* @__PURE__ */ jsx(
                      Icon,
                      {
                        name: "scroll-action",
                        className: `text-[22px] cursor-pointer ${enableScroll ? "text-green-600" : "text-icon-primary"}`
                      }
                    )
                  }
                )
              }
            )
          ] }),
          /* @__PURE__ */ jsxs("span", { className: "space-x-3 flex items-center divide-x", children: [
            !isDebugMode && (isDesktopStepRecorderWidgetActive ? /* @__PURE__ */ jsxs(Fragment, { children: [
              isRecorderRunning ? /* @__PURE__ */ jsxs(
                "span",
                {
                  className: classNames82("flex items-center gap-x-1.5", {
                    "cursor-not-allowed opacity-50": disableRecordOption || isDesktopRecorderActionLoading,
                    "cursor-pointer": !disableRecordOption && !isDesktopRecorderActionLoading
                  }),
                  onClick: () => {
                    disableRecordOption || isDesktopRecorderActionLoading ? "" : handleRecorderAction(RECORDER_ACTION.PAUSE);
                  },
                  children: [
                    /* @__PURE__ */ jsx(
                      Icon,
                      {
                        name: "pause-bonding-box",
                        className: `text-xl leading-5 text-icon-primary ${disableRecordOption || isDesktopRecorderActionLoading ? "cursor-not-allowed" : "cursor-pointer"}`
                      }
                    ),
                    /* @__PURE__ */ jsx("span", { className: "text-xs font-medium w-11", children: "Pause" })
                  ]
                }
              ) : /* @__PURE__ */ jsxs(
                "span",
                {
                  className: classNames82("flex items-center gap-x-1.5", {
                    "cursor-not-allowed opacity-50": disableRecordOption || isDesktopRecorderActionLoading,
                    "cursor-pointer": !disableRecordOption && !isDesktopRecorderActionLoading
                  }),
                  onClick: () => {
                    disableRecordOption || isDesktopRecorderActionLoading ? "" : handleRecorderAction(RECORDER_ACTION.RESUME);
                  },
                  children: [
                    /* @__PURE__ */ jsx(
                      Icon,
                      {
                        name: "radio-checked",
                        className: `text-xl leading-5 text-resume ${disableRecordOption || isDesktopRecorderActionLoading ? "cursor-not-allowed" : "cursor-pointer"}`
                      }
                    ),
                    /* @__PURE__ */ jsx("span", { className: "text-xs font-medium text-resume w-11", children: "Resume" })
                  ]
                }
              ),
              !hidePrimaryHeader && /* @__PURE__ */ jsxs(
                "span",
                {
                  className: classNames82(
                    "flex items-center gap-x-1.5 pl-3 cursor-pointer"
                  ),
                  onClick: handleRecorderStop,
                  children: [
                    /* @__PURE__ */ jsx(
                      Icon,
                      {
                        name: "stop-circle-outline",
                        className: `text-xl leading-5 text-red-600 cursor-pointer`
                      }
                    ),
                    /* @__PURE__ */ jsx("span", { className: "text-xs font-medium text-red-600 w-11", children: "Stop" })
                  ]
                }
              )
            ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
              recorderState && (isRecorderRunning ? /* @__PURE__ */ jsxs(
                "span",
                {
                  className: classNames82("flex items-center gap-x-1.5", {
                    "cursor-not-allowed opacity-50": disableRecordOption,
                    "cursor-pointer": !disableRecordOption
                  }),
                  onClick: () => {
                    disableRecordOption ? "" : handleRecorderAction(RECORDER_ACTION.PAUSE);
                  },
                  children: [
                    /* @__PURE__ */ jsx(
                      Icon,
                      {
                        name: "pause-bonding-box",
                        className: `text-xl leading-5 text-icon-primary ${disableRecordOption ? "cursor-not-allowed" : "cursor-pointer"}`
                      }
                    ),
                    /* @__PURE__ */ jsx("span", { className: "text-xs font-medium w-11", children: "Pause" })
                  ]
                }
              ) : /* @__PURE__ */ jsxs(
                "span",
                {
                  className: classNames82("flex items-center gap-x-1.5", {
                    "cursor-not-allowed opacity-50": disableRecordOption,
                    "cursor-pointer": !disableRecordOption
                  }),
                  onClick: () => {
                    disableRecordOption ? "" : handleRecorderAction(RECORDER_ACTION.RESUME);
                  },
                  children: [
                    /* @__PURE__ */ jsx(
                      Icon,
                      {
                        name: "radio-checked",
                        className: `text-xl leading-5 text-resume ${disableRecordOption ? "cursor-not-allowed" : "cursor-pointer"}`
                      }
                    ),
                    /* @__PURE__ */ jsx("span", { className: "text-xs font-medium text-resume w-11", children: "Record" })
                  ]
                }
              )),
              !hidePrimaryHeader && /* @__PURE__ */ jsxs(
                "span",
                {
                  className: classNames82(
                    "flex items-center gap-x-1.5 pl-3 cursor-pointer"
                  ),
                  onClick: handleRecorderStop,
                  children: [
                    /* @__PURE__ */ jsx(
                      Icon,
                      {
                        name: "stop-circle-outline",
                        className: `text-xl leading-5 text-red-600 cursor-pointer`
                      }
                    ),
                    /* @__PURE__ */ jsx("span", { className: "text-xs font-medium text-red-600 w-11", children: "Stop" })
                  ]
                }
              )
            ] })),
            /* @__PURE__ */ jsx(
              StopDebuggingModal,
              {
                isOpen: stopDebuggerExecutionModal.state.show,
                onClose: stopDebuggerExecutionModal.closeModal,
                onConfirm: () => isDesktopStepRecorderWidgetActive ? handleDesktopStepRecorderStop() : handleRecorderAction(RECORDER_ACTION.STOP, true),
                appType,
                isDesktopStepRecorderWidgetActive
              }
            )
          ] })
        ]
      }
    )
  ] });
}
function Loader2({
  loaderMessage: loaderMessageFromProps = "",
  onRefreshWidget,
  onReconfigure = NOOP,
  showReconfigureMessage = false,
  isDebugger = false
}) {
  const { getResourceURL } = useResourceURL();
  const [showRefresh, setShowRefresh] = useState(false);
  const { loaderMessage: loaderMessageFromState } = useSelector(
    (state) => state.widget
  );
  setTimeout(() => {
    setShowRefresh(true);
  }, REFRESH_VISIBILITY_DELAY);
  const loaderMessage = loaderMessageFromProps || loaderMessageFromState;
  const imgPath = isDebugger ? "img/loading-logo-color.svg" : "img/ts-logo-loading.svg";
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("div", { className: "absolute ts-loading-recorder grid w-full justify-items-center gap-y-2", children: [
      /* @__PURE__ */ jsx(
        "img",
        {
          src: getResourceURL(imgPath),
          alt: __("recorder.logo.loading"),
          width: "80",
          height: "80"
        }
      ),
      /* @__PURE__ */ jsx("span", { className: "text-gray-600 font-semibold", children: loaderMessage || "Loading, please wait for a moment" }),
      !loaderMessage && showRefresh && /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx(
        "span",
        {
          className: "text-sky-700 font-bold cursor-pointer",
          onClick: () => onRefreshWidget(),
          children: "Refresh Widget"
        }
      ) })
    ] }),
    showReconfigureMessage && /* @__PURE__ */ jsxs("div", { className: "absolute bottom-10 left-[50%] translate-x-[-50%] flex flex-col items-center justify-center w-[90%] mx-auto text-center", children: [
      /* @__PURE__ */ jsx("div", { className: "text-ai-placeholder text-2xs font-normal leading-1", children: /* @__PURE__ */ jsxs("span", { children: [
        /* @__PURE__ */ jsx("span", { children: __("live-editor.nlp.step.reconfigure") }),
        /* @__PURE__ */ jsxs(
          "span",
          {
            className: "text-nlp-green cursor-pointer",
            onClick: onReconfigure,
            children: [
              " ",
              __("live-editor.nlp.step.reconfigure.button"),
              " "
            ]
          }
        ),
        /* @__PURE__ */ jsx("span", { children: __("live-editor.nlp.step.reconfigure.button.final") })
      ] }) }),
      /* @__PURE__ */ jsx("div", { className: "text-ai-placeholder text-2xs font-normal leading-1", children: __("live-editor.nlp.step.connect") })
    ] })
  ] });
}
var StepCreatorSlicePersistKey = "widget-step-creator";
var DEFAULT_MANUAL_STEP_DATA = {
  ...getDummyStep(),
  [STEP_FLAG.WAIT_TIME.API_KEY]: STEP_FLAG.WAIT_TIME.DEFAULT,
  [STEP_FLAG.DISABLED.API_KEY]: STEP_FLAG.DISABLED.DEFAULT,
  [STEP_FLAG.IGNORE_STEP_RESULT.API_KEY]: STEP_FLAG.IGNORE_STEP_RESULT.DEFAULT,
  [STEP_FLAG.VISUAL_TESTING.API_KEY]: STEP_FLAG.VISUAL_TESTING.DEFAULT,
  [STEP_FLAG.HIGHLIGHT_ELEMENT.API_KEY]: STEP_FLAG.HIGHLIGHT_ELEMENT.DEFAULT,
  [STEP_FLAG.PRE_REQUISITE.API_KEY]: STEP_FLAG.PRE_REQUISITE.DEFAULT,
  [STEP_FLAG.PRIORITY.API_KEY]: STEP_FLAG.PRIORITY.DEFAULT,
  [STEP_FLAG.MAX_ITERATION.API_KEY]: STEP_FLAG.MAX_ITERATION.DEFAULT
};
var initialState4 = {
  activeStepType: STEP_TYPE.NLP_TEXT,
  searchKey: "",
  stepData: DEFAULT_MANUAL_STEP_DATA,
  editableStepData: null,
  stepTemplate: void 0,
  showTemplates: false,
  templateObj: {
    templates: [],
    allAlgoliaTemplates: [],
    uiTemplates: [],
    addonTemplates: [],
    allAddonTemplates: [],
    algoliaFilterType: null,
    templateAppType: RECORDER_APPLICATION_TYPE.WEB
  }
};
var stepCreatorSlice = createSlice({
  name: StepCreatorSlicePersistKey,
  initialState: initialState4,
  reducers: {
    setActiveStepType(state, action) {
      state.activeStepType = action.payload;
    },
    setSearchKey(state, action) {
      state.searchKey = action.payload;
    },
    setStepData(state, action) {
      state.stepData = action.payload;
    },
    setEditableStepData(state, action) {
      state.editableStepData = action.payload;
    },
    setStepTemplate(state, action) {
      state.stepTemplate = action.payload;
    },
    setShowTemplates(state, action) {
      state.showTemplates = action.payload;
    },
    updateTemplateObj(state, action) {
      state.templateObj = { ...state.templateObj, ...action.payload };
    },
    resetStepCreator(state) {
      state.stepData = DEFAULT_MANUAL_STEP_DATA;
      state.editableStepData = null;
      state.activeStepType = STEP_TYPE.NLP_TEXT;
      state.stepTemplate = void 0;
      state.showTemplates = false;
    },
    resetStepCreatorSliceState(state) {
      Object.assign(state, initialState4);
    }
  }
});
var {
  setActiveStepType,
  setSearchKey,
  setStepData,
  setEditableStepData,
  setStepTemplate,
  setShowTemplates,
  updateTemplateObj,
  resetStepCreator,
  resetStepCreatorSliceState
} = stepCreatorSlice.actions;
var stepCreatorReducer = stepCreatorSlice.reducer;
var eventSubject = new Subject();
var clickOrDoubleClick$ = eventSubject.pipe(
  filter(
    (e) => e.action === CLIENT_EVENT.CLICK || e.action === CLIENT_EVENT.DOUBLE_CLICK
  ),
  switchMap((firstClick) => {
    if (firstClick.action === CLIENT_EVENT.DOUBLE_CLICK) {
      return of(firstClick);
    }
    const doubleClick$ = eventSubject.pipe(
      filter((e) => e.action === CLIENT_EVENT.DOUBLE_CLICK),
      take(1)
    );
    const timeout$ = timer(300).pipe(map(() => firstClick));
    return race(doubleClick$, timeout$);
  })
);
var otherEvents$ = eventSubject.pipe(
  filter(
    (e) => e.action !== CLIENT_EVENT.CLICK && e.action !== CLIENT_EVENT.DOUBLE_CLICK
  )
);
var eventDataObservable = merge(clickOrDoubleClick$, otherEvents$);
var event_data_default = eventDataObservable;
var EventService = class {
  subscriptions = [];
  constructor() {
    this.initObservables();
  }
  initObservables() {
    const eventDataSub = event_data_default.pipe(
      concatMap(async (item) => {
        try {
          const dispatch = getGlobalDispatch();
          await dispatch(setStepCreationInProgress(1));
          log.info(
            "[WIDGET] [STEP CREATION] Observable 1 (updateStepsList)",
            item
          );
          const step = await this.convertEventToStep(item);
          await dispatch(setStepCreationInProgress(-1));
          log.info("[WIDGET] [STEP CREATION] EVENT DATA PROCESSED", step);
          return step;
        } catch (err) {
          log.error("eventDataObservable getting error : ", err);
          await getGlobalDispatch()(setStepCreationInProgress(-1));
          return null;
        }
      })
    ).subscribe();
    const locatorTreeSub = save_locator_tree_default.pipe(
      concatMap(async (item) => {
        try {
          log.info("[WIDGET] Observable 2 (saveLocatorTreeObservable)", item);
          await this.saveLocatorTree(
            item
          );
          return item;
        } catch (err) {
          log.error("Error saving locator tree:", err);
          return null;
        }
      })
    ).subscribe({
      next: (value) => log.info("[WIDGET] [LOCATOR TREE PROCESSED]", value)
    });
    this.subscriptions.push(eventDataSub, locatorTreeSub);
  }
  cleanup() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.subscriptions = [];
  }
  /**
   * @func convertEventToStep
   * @param browserEventData convert eventData into EventStep and trigger next pipeline
   */
  async convertEventToStep(browserEventData) {
    if (browserEventData.from) {
      return dragDropEventToStep(browserEventData);
    }
    const eventData = browserEventData;
    if (eventData?.isDesktopStepEvent) {
      return createEventStep({ stepDetails: eventData?.desktopStepEvent });
    }
    const sfPredefinedFieldDetails = eventData?.sfPredefinedElementDetails?.predefinedField;
    const ignoreSwitchTab = selectIgnoreSwitchTab(getGlobalState());
    if (eventData.action === CHROME_EVENT.TAB.SWITCH_BY_INDEX && ignoreSwitchTab) {
      await getGlobalDispatch()(updateIgnoreSwitchTab(false));
      return;
    } else {
      await getGlobalDispatch()(updateIgnoreSwitchTab(false));
    }
    const templateDisplayName = findTemplateDisplayName({
      eventData,
      isMouseOverEnabled: getGlobalState()?.widget.enableClickHover
    });
    log.info(
      "[WIDGET] [STEP CREATION] [TEMPLATE DISPLAY NAME] ",
      templateDisplayName
    );
    if ((eventData.action === CLIENT_EVENT.SCROLL_WINDOW || eventData.action === CLIENT_EVENT.SCROLL) && !selectIsScrollRecordingEnabled(getGlobalState())) {
      return;
    }
    let template = eventData.template || await getTemplate(templateDisplayName);
    if (!template && templateDisplayName === TEMPLATE_DISPLAY_NAME.CHECK_RADIO) {
      template = await getTemplate(TEMPLATE_DISPLAY_NAME.CLICK);
    }
    if (!template) {
      log.warn("[WIDGET] [STEP CREATION] No template found");
      return;
    }
    if (eventData.isElementNotExist) {
      const stepDetails = await getTestStepDetails(eventData, "", template);
      await getGlobalDispatch()(updateLastEventData(null));
      await getGlobalDispatch()(updateIsLastStepNameClear(false));
      return createEventStep({ stepDetails });
    } else {
      const step = await processStepAndIdentifier({
        sfPredefinedFieldDetails,
        eventData,
        template,
        templateDisplayName
      });
      return step;
    }
  }
  async saveLocatorTree(params) {
    try {
      await RecorderAssetsApi.saveLocatorTree(
        params.elementId,
        params.locatorTree
      );
    } catch (error) {
      log.error("[WIDGET] Error saving locator tree", error);
    }
  }
};
var browserEventSubject = new Subject();
browserEventSubject.pipe(mergeMap((event) => of(event).pipe(delay(1300)))).subscribe((delayedEvent) => eventSubject.next(delayedEvent));

// src/components/test-recorder/utils/event/handlers/queue.ts
var handleQueueContext = (message) => {
  log.info("[WIDGET] [STEP CREATION] handleQueueContext", message);
  switch (message.action) {
    case MESSAGE_CONTEXT_ACTION.PUSH:
      processBrowserAction(message.value);
      break;
  }
};
var processBrowserAction = async (eventData) => {
  if (!getGlobalState()?.widget.templates?.length) return;
  let _eventData = eventData;
  if (eventData.file) {
    log.info("[WIDGET] [STEP CREATION] trigger file event handler", eventData);
    _eventData = await fileEventHandler(eventData);
  }
  const cursor = getGlobalState()?.widget.stepCursor;
  if (cursor && (eventData.isDirect || eventData.isUserAction)) {
    _eventData.step = cursor;
  }
  if (eventData.source === EVENT_SOURCE.CHROME) {
    browserEventSubject.next({
      ..._eventData,
      timestamp: (/* @__PURE__ */ new Date()).getTime()
    });
  } else {
    eventSubject.next({
      ..._eventData,
      timestamp: (/* @__PURE__ */ new Date()).getTime()
    });
  }
};
var handleScreenshotContext = (message) => {
  log.info("[WIDGET] handleScreenshotContext", message);
  switch (message.action) {
    case MESSAGE_CONTEXT_ACTION.UPDATE:
      handleScreenshotUpdate(message);
      break;
  }
};
var handleScreenshotUpdate = async (message) => {
  log.info("[WIDGET] handleScreenshotUpdate", message);
  await getGlobalDispatch()(
    updateElementScreenshotMap({
      key: message.value.screenshotRetrievalId,
      value: message.value.screenshotDataUrl
    })
  );
  cropImage2(message.value.screenshotDataUrl, message.value.coordinates).then(async (croppedDataUrl) => {
    await getGlobalDispatch()(
      updateCroppedElementScreenshotMap({
        key: message.value.screenshotRetrievalId,
        value: croppedDataUrl
      })
    );
  }).catch((error) => {
    log.error("[WIDGET] Cropping image failed", error);
  });
};
var cropImage2 = (dataUrl, coordinates) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const padding = 4 * coordinates.devicePixelRatio;
    const adjustedCoordinates = {
      width: coordinates.width * coordinates.devicePixelRatio,
      height: coordinates.height * coordinates.devicePixelRatio,
      top: coordinates.top * coordinates.devicePixelRatio,
      left: coordinates.left * coordinates.devicePixelRatio
    };
    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = adjustedCoordinates.width + padding * 2;
      canvas.height = adjustedCoordinates.height + padding * 2;
      ctx.drawImage(
        img,
        adjustedCoordinates.left - padding,
        adjustedCoordinates.top - padding,
        adjustedCoordinates.width + padding * 2,
        adjustedCoordinates.height + padding * 2,
        0,
        0,
        adjustedCoordinates.width + padding * 2,
        adjustedCoordinates.height + padding * 2
      );
      resolve(canvas.toDataURL());
    };
    img.onerror = reject;
    img.src = dataUrl;
  });
};
var handleRecorderUiIdentifierContext = (message) => {
  switch (message.action) {
    case MESSAGE_CONTEXT_ACTION.PUSH:
      createIdentifier(message.value);
  }
};
var handleDebuggingContext = (message) => {
  console.log("[WIDGET] [DEBUGGING] [HANDLE DEBUGGING CONTEXT]", message);
  switch (message.action) {
    case DEBUGGER_ACTION.GET_DEBUG_STEP_RESULT_DETAIL:
      handleGetDebugStepResultDetail(message.value);
      break;
  }
};
var handleGetDebugStepResultDetail = (value) => {
  const dispatch = getGlobalDispatch();
  if (value.testCaseResult) {
    dispatch(setTestCaseResult(value.testCaseResult));
    value.testCaseResult?.result && dispatch(setDebugExecutionStatus(value.testCaseResult?.result));
  } else {
    dispatch(setStepResultDetails(value.stepResult));
    dispatch(setIsStepResultLoading(!value.failedFetchStepResultId));
  }
};
var handleMaintenanceContext = (message) => {
  switch (message.action) {
    case MESSAGE_CONTEXT_ACTION.ELEMENT_UPDATE_FOR_MAINTENANCE:
      handleElementUpdateForMaintenance(message.value);
      break;
    case MESSAGE_CONTEXT_ACTION.TESTDATA_UPDATE_FOR_MAINTENANCE:
      handleTestDataUpdateForMaintenance(message.value);
      break;
  }
};
var handleElementUpdateForMaintenance = async (value) => {
  const { stepId, stepTemplate, data } = value || {};
  const testStep = await StepApi.show(stepId);
  const currentElement = await UiIdentifierApi.get(
    testStep?.testStepElements?.[0]?.elementId
  );
  const createdElement = await createNewElement(
    currentElement,
    data?.update_fields_json?.[0]
  );
  testStep.testStepElements[0].elementId = createdElement?.id;
  testStep.testStepElements[0].name = createdElement?.name;
  const updatedTestStep = populateUpdatedStepAction2(testStep, stepTemplate);
  await updateTestStep(updatedTestStep);
};
var handleTestDataUpdateForMaintenance = async (value) => {
  const { stepId, stepTemplate, data } = value || {};
  const testStep = await StepApi.show(stepId);
  const { stepDataList } = testStep || {};
  stepDataList?.forEach((item) => {
    data?.update_fields_json?.forEach((toUpdate) => {
      if (item.id == toUpdate?.id) {
        item.value = toUpdate?.value;
        item.type = "raw";
      }
    });
  });
  testStep.stepDataList = stepDataList;
  const updatedTestStep = populateUpdatedStepAction2(testStep, stepTemplate);
  await updateTestStep(updatedTestStep);
};
var populateUpdatedStepAction2 = (testStep, template) => {
  const blocks = getStepNlpBlocks(testStep, template);
  const newAction = blocks?.map(({ value = "" }) => typeof value === "string" ? value.trim() : "")?.join(" ")?.replaceAll(/\s+/g, " ");
  testStep.action = newAction;
  return testStep;
};
var handleApiScreenContext = (message) => {
  switch (message.action) {
    case MESSAGE_CONTEXT_ACTION.REQUEST:
      handleApiScreenRequest();
      break;
    case MESSAGE_CONTEXT_ACTION.BROADCAST:
      handleApiScreenBroadcast(message.value);
      break;
  }
};
var handleApiScreenRequest = () => {
  loadElementInitialData(true);
};
var handleApiScreenBroadcast = (value) => {
  getGlobalDispatch()(setScreens(value));
};

// src/components/test-recorder/utils/event/listener.ts
var eventListener = (message, handleRecorderReload, launchRecorder) => {
  switch (message.context) {
    case MESSAGE_CONTEXT.QUEUE:
      handleQueueContext(message);
      break;
    case MESSAGE_CONTEXT.SCREENSHOT:
      handleScreenshotContext(message);
      break;
    case MESSAGE_CONTEXT.RECORDER:
      handleRecorderContext(message, handleRecorderReload, launchRecorder);
      break;
    case MESSAGE_CONTEXT.DEBUGGING:
      handleDebuggingContext(message);
      break;
    case MESSAGE_CONTEXT.MAINTENANCE:
      handleMaintenanceContext(message);
      break;
    case MESSAGE_CONTEXT.API.IDENTIFIER:
      handleApiIdentifierContext(message);
      break;
    case MESSAGE_CONTEXT.API.SCREEN:
      handleApiScreenContext(message);
      break;
    case MESSAGE_CONTEXT.RECORDER_UI_IDENTIFIER:
      handleRecorderUiIdentifierContext(message);
      break;
  }
};
var customEventListener = (msgData, dispatch, publishEvent, showElementHighlightFailed, handleCopilotEvent, copilotStatus) => {
  switch (msgData.dataType) {
    case CUSTOM_EVENT.STATE:
      if ((copilotStatus === COPILOT_STATE.GENERATING_SCENARIOS || copilotStatus === COPILOT_STATE.GENERATING_STEPS) && msgData.data === RECORDER_STATE.RUNNING) {
        break;
      }
      dispatch(updateRecorderState(msgData.data));
      break;
    case CUSTOM_EVENT.ELEMENT_FINDER:
      if (msgData.data) {
        if (msgData.data.error === ERROR_CODE.HIGHLIGHT_FAILED) {
          showElementHighlightFailed();
          return;
        }
      }
      dispatch(setVerifyTimeout(null));
      dispatch(setLocatedElement(msgData.data || {}));
      break;
    case MESSAGE_CONTEXT.CAPTURE_ELEMENT_IMAGE:
      publishEvent(MESSAGE_CONTEXT.CAPTURE_ELEMENT_IMAGE, msgData.data);
      break;
    case CUSTOM_EVENT.VIEW:
      dispatch(setIsMinimized(Boolean(msgData.data)));
      break;
    case CUSTOM_EVENT.SAVE_ELEMENT:
      dispatch(setEnableSaveElement(Boolean(msgData.data)));
      break;
    case CUSTOM_EVENT.DEBUG:
      if (msgData?.data?.executionStatusList) {
        dispatch(setExecutionStatusList(msgData?.data?.executionStatusList));
      } else if (msgData?.data?.currentExecutionStatus) {
        dispatch(
          setCurrentExecutionStatus(msgData?.data?.currentExecutionStatus)
        );
      }
      break;
    case CUSTOM_EVENT.COPILOT:
      handleCopilotEvent(msgData.data?.value);
      break;
    case CUSTOM_EVENT.COPILOT_VIEW:
      dispatch(setCopilotWindowOpenState(Boolean(msgData.data)));
      break;
    case CUSTOM_EVENT.MESSAGE:
      if (msgData.data?.currentUrl) {
        dispatch(
          setIsExtensionPage(
            msgData.data.currentUrl.includes("src/pages/GetStarted/index.html")
          )
        );
      }
      break;
  }
};
var StopCircle = ({ className, onClick }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    onClick,
    children: [
      /* @__PURE__ */ jsx(
        "mask",
        {
          id: "mask0_2823_71831",
          style: { maskType: "alpha" },
          maskUnits: "userSpaceOnUse",
          x: "0",
          y: "0",
          width: "12",
          height: "12",
          children: /* @__PURE__ */ jsx("rect", { width: "12", height: "12" })
        }
      ),
      /* @__PURE__ */ jsx("g", { mask: "url(#mask0_2823_71831)", children: /* @__PURE__ */ jsx("path", { d: "M6 11C5.30833 11 4.65833 10.8687 4.05 10.606C3.44167 10.3437 2.9125 9.9875 2.4625 9.5375C2.0125 9.0875 1.65633 8.55833 1.394 7.95C1.13133 7.34167 1 6.69167 1 6C1 5.30833 1.13133 4.65833 1.394 4.05C1.65633 3.44167 2.0125 2.9125 2.4625 2.4625C2.9125 2.0125 3.44167 1.65617 4.05 1.3935C4.65833 1.13117 5.30833 1 6 1C6.69167 1 7.34167 1.13117 7.95 1.3935C8.55833 1.65617 9.0875 2.0125 9.5375 2.4625C9.9875 2.9125 10.3437 3.44167 10.606 4.05C10.8687 4.65833 11 5.30833 11 6C11 6.69167 10.8687 7.34167 10.606 7.95C10.3437 8.55833 9.9875 9.0875 9.5375 9.5375C9.0875 9.9875 8.55833 10.3437 7.95 10.606C7.34167 10.8687 6.69167 11 6 11ZM6 10C7.10833 10 8.05217 9.6105 8.8315 8.8315C9.6105 8.05217 10 7.10833 10 6C10 4.89167 9.6105 3.94783 8.8315 3.1685C8.05217 2.3895 7.10833 2 6 2C4.89167 2 3.948 2.3895 3.169 3.1685C2.38967 3.94783 2 4.89167 2 6C2 7.10833 2.38967 8.05217 3.169 8.8315C3.948 9.6105 4.89167 10 6 10ZM4.5 8H7.5C7.64167 8 7.7605 7.952 7.8565 7.856C7.95217 7.76033 8 7.64167 8 7.5V4.5C8 4.35833 7.95217 4.2395 7.8565 4.1435C7.7605 4.04783 7.64167 4 7.5 4H4.5C4.35833 4 4.23967 4.04783 4.144 4.1435C4.048 4.2395 4 4.35833 4 4.5V7.5C4 7.64167 4.048 7.76033 4.144 7.856C4.23967 7.952 4.35833 8 4.5 8Z" }) })
    ]
  }
);
var StopCircle_default = StopCircle;
function MinimizedStep({
  step,
  nlActions,
  globalStepsInfo,
  updateGlobalStepsInfo
}) {
  const [template, setTemplate] = useState();
  useEffect(() => {
    const nlpTemplate = nlActions.find((nlpAction) => {
      if (nlpAction.isAddon) {
        return nlpAction.id === step?.kibbutzPluginNlpId;
      } else if (!nlpAction.isAddon) {
        return nlpAction.id === step?.templateId;
      }
    });
    setTemplate(nlpTemplate);
  }, [nlActions, step]);
  const updateStepsInfo = useCallback(
    (key, value) => {
      if (globalStepsInfo[key] != value) {
        const tempGlobalStepInfo = Object.assign({}, globalStepsInfo);
        tempGlobalStepInfo[key] = value;
        updateGlobalStepsInfo(tempGlobalStepInfo);
      }
    },
    [globalStepsInfo]
  );
  const canRender = useMemo(
    () => step && Boolean(
      template || isPresentationStep(step) || isStepGroup(step) || isRestStep(step) || isBlock(step) || step.kibbutzPluginNlpId
    ),
    [step, template]
  );
  return /* @__PURE__ */ jsx(Fragment, { children: canRender ? /* @__PURE__ */ jsx(
    StepItemWrapper,
    {
      step,
      isViewOnly: true,
      template,
      stepsInfo: globalStepsInfo,
      updateStepsInfo
    }
  ) : null });
}
var ToolTip50 = ToolTip;
function MinimizedPanel({
  onMaximizeWidget,
  onReposition
}) {
  const { t } = useTranslation();
  const [testSteps, setTestSteps] = useState([]);
  const [globalStepsInfo, updateGlobalStepsInfo] = useState({
    activeStepIdx: null,
    selectedSteps: [],
    updateSelectedSteps: null,
    nlpContainerWidth: {},
    isReorderState: false,
    isStepTypeSwitchOpened: true,
    isStepResult: true
  });
  const dispatch = useDispatch();
  const {
    enableClickHover,
    recorderState,
    appType,
    testSteps: steps,
    recorderType,
    templates,
    addonTemplates
  } = useSelector((state) => state.widget);
  const { sendToBackground: sendToBackground2 } = useMessaging();
  const { getResourceURL } = useResourceURL();
  const {
    actions: { findStateByAction }
  } = useRecorderContext();
  const nlActions = useMemo(() => {
    const list = [...templates || [], ...addonTemplates || []];
    return list;
  }, [templates, addonTemplates]);
  useEffect(() => {
    if (steps?.length > 0) {
      setTestSteps([steps[steps.length - 1]]);
    } else {
      setTestSteps([]);
    }
  }, [steps]);
  const handleRecorderAction = (action) => {
    const message = {
      context: MESSAGE_CONTEXT.STATE,
      action: MESSAGE_CONTEXT_ACTION.UPDATE,
      value: findStateByAction(action)
    };
    log.info(LOG.WIDGET, "SEND TO BACKGROUND::", message);
    sendToBackground2(message);
  };
  return /* @__PURE__ */ jsx(
    "div",
    {
      id: "ts-widget-fab",
      className: `widget rounded-md absolute h-full w-full`,
      children: /* @__PURE__ */ jsxs(
        "div",
        {
          className: `flex items-center justify-between px-4.5 py-1.5 ${appType}`,
          children: [
            /* @__PURE__ */ jsxs("div", { className: "flex items-center space-x-3 h-[40px] step-info", children: [
              /* @__PURE__ */ jsxs("span", { className: "relative shrink-0 flex items-center", children: [
                /* @__PURE__ */ jsx(
                  "img",
                  {
                    src: getResourceURL("img/icon-dark.svg"),
                    alt: t("recorder.logo"),
                    width: "20",
                    height: "20",
                    className: "h-5 w-fit shrink-0"
                  }
                ),
                /* @__PURE__ */ jsx("span", { className: "absolute -top-1 -right-1 p-0.5 bg-white h-3 w-3 flex items-center justify-center rounded-full", children: /* @__PURE__ */ jsx(
                  Icon,
                  {
                    name: "ellipse",
                    className: classNames82("text-[8px]", {
                      "animate-blink text-red-600": recorderState && recorderState === RECORDER_STATE.RUNNING,
                      "text-secondary-500": !(recorderState && recorderState === RECORDER_STATE.RUNNING)
                    })
                  }
                ) })
              ] }),
              steps?.length ? /* @__PURE__ */ jsx(
                StepNumber,
                {
                  number: steps[steps.length - 1].stepNumber,
                  className: "text-secondary-400"
                }
              ) : null,
              testSteps?.map((step) => /* @__PURE__ */ jsx(
                MinimizedStep,
                {
                  step,
                  nlActions,
                  globalStepsInfo,
                  updateGlobalStepsInfo
                },
                step.id
              ))
            ] }),
            /* @__PURE__ */ jsxs("div", { className: "space-x-3 flex items-center shrink-0", children: [
              recorderState && (recorderState === RECORDER_STATE.RUNNING ? /* @__PURE__ */ jsx(
                ToolTip50,
                {
                  content: "Pause recording",
                  className: "flex",
                  placement: "left",
                  children: /* @__PURE__ */ jsx(
                    Icon,
                    {
                      name: "pause-bonding-box",
                      className: "text-xl leading-5 text-icon-primary cursor-pointer",
                      onClick: () => handleRecorderAction(RECORDER_ACTION.PAUSE)
                    }
                  )
                }
              ) : /* @__PURE__ */ jsx(
                ToolTip50,
                {
                  content: "Resume recording",
                  className: "flex",
                  placement: "left",
                  children: /* @__PURE__ */ jsx(
                    Icon,
                    {
                      name: "radio-checked",
                      className: "text-xl leading-5 text-resume cursor-pointer",
                      onClick: () => handleRecorderAction(RECORDER_ACTION.RESUME)
                    }
                  )
                }
              )),
              /* @__PURE__ */ jsx(ToolTip50, { content: "Stop Recording", className: "flex", placement: "left", children: /* @__PURE__ */ jsx(
                StopCircle_default,
                {
                  onClick: () => handleRecorderAction(RECORDER_ACTION.STOP),
                  className: "h-5 w-fit fill-red-600 cursor-pointer"
                }
              ) }),
              recorderType !== RECORDER_TYPE.ELEMENT && appType !== ApplicationType.MobileWeb && /* @__PURE__ */ jsx(
                ToolTip50,
                {
                  content: "Click as Mouseover",
                  className: "flex",
                  placement: "left",
                  children: /* @__PURE__ */ jsxs(
                    "button",
                    {
                      onClick: () => dispatch(setEnableClickHover(!enableClickHover)),
                      className: `flex bg-transparent border-0 cursor-pointer relative disabled:cursor-not-allowed disabled:opacity-50 `,
                      disabled: recorderState !== RECORDER_STATE.RUNNING,
                      children: [
                        enableClickHover && /* @__PURE__ */ jsx(
                          "span",
                          {
                            className: `${recorderState !== RECORDER_STATE.RUNNING ? "scale-150 opacity-40" : "animate-ping"} w-3 h-3 block absolute rounded-full bg-red-900 left-0.5 top-0`
                          }
                        ),
                        /* @__PURE__ */ jsx(
                          Icon,
                          {
                            name: "touch",
                            className: " text-xl text-icon-primary cursor-pointer"
                          }
                        )
                      ]
                    }
                  )
                }
              ),
              /* @__PURE__ */ jsx(ToolTip50, { content: "Maximize", className: "flex pt-0.5", placement: "left", children: /* @__PURE__ */ jsx(
                Icon,
                {
                  name: "maximise",
                  className: `text-xl leading-5 text-icon-primary cursor-pointer`,
                  onClick: () => onMaximizeWidget()
                }
              ) })
            ] })
          ]
        }
      )
    }
  );
}
function MinimizedWidget() {
  const { sendToContentWindow, sendToTSTab } = useMessaging();
  const dispatch = useDispatch();
  const { locatedElement, userStepsData, stepCursor, appType, testCase } = useSelector((state) => state.widget);
  const [isInterimFlow, setIsInterimFlow] = useState(false);
  useEffect(() => {
    if (stepCursor) {
      setIsInterimFlow(true);
    }
  }, []);
  const onMinimizeStatus = (value) => {
    dispatch(setIsMinimized(value));
    sendToTSTab(MESSAGE_CONTEXT.WIDGET, MESSAGE_CONTEXT_ACTION.VIEW, value);
    sendToTSTab(
      MESSAGE_CONTEXT.WIDGET,
      MESSAGE_CONTEXT_ACTION.RESIZE,
      WIDGET_VIEW.RECORDER
    );
  };
  const onReposition = (position) => {
    if (!document.querySelector('[data-overlay="true"]'))
      sendToContentWindow(
        MESSAGE_CONTEXT.WIDGET,
        MESSAGE_CONTEXT_ACTION.POSITION,
        position
      );
  };
  useEffect(() => {
    if (!isInterimFlow) return;
    const bgSteps = convertToOrganismSteps(userStepsData.steps || []);
    const nextCursor = cloneDeep(userStepsData.cursor);
    if (!nextCursor || !nextCursor.stepOrder) {
      dispatch(setStepCursor(null));
      return;
    }
    const [firstHalf, secondHalf] = partition(
      bgSteps,
      (item) => isNumber(item.stepOrder) && isNumber(nextCursor.stepOrder) && item.stepOrder < nextCursor.stepOrder
    );
    const stepBeforeInterim = firstHalf[firstHalf.length - 1];
    if (stepBeforeInterim && stepBeforeInterim.parentId === nextCursor.parentId) {
      nextCursor.stepNumber = stepBeforeInterim.stepNumber ? getStepNumber(stepBeforeInterim.stepNumber, "below") : "-";
    }
    const interim = createTestStep2(
      nextCursor,
      "",
      nextCursor.stepOrder,
      nextCursor.stepNumber || "-",
      nextCursor.indent || 0,
      appType,
      testCase?.id,
      nextCursor.parentId
    );
    log.debug(
      LOG.WIDGET,
      `Moving step cursor to stepOrder=${interim.stepOrder}, stepNumber=${interim.stepNumber}, indent=${interim.indent}, parentId=${interim.parentId}`
    );
    dispatch(setStepCursor(interim));
  }, [userStepsData]);
  useEffect(() => {
    if (locatedElement?.element) onMinimizeStatus(false);
  }, [locatedElement]);
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    MinimizedPanel,
    {
      onMaximizeWidget: () => {
        onMinimizeStatus(false);
      },
      onReposition
    }
  ) });
}
var queryClient = new QueryClient$1({
  defaultOptions: {
    queries: {
      retry: 2,
      refetchOnWindowFocus: false
    }
  }
});
function Widget() {
  window["__react-beautiful-dnd-disable-dev-warnings"] = true;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {
    sendToBackground: sendToBackground2,
    sendToContentWindow,
    sendToTSTab,
    addMessageListener,
    removeMessageListener,
    reconfigureWidget = NOOP
  } = useMessaging();
  const { sendWidgetWindowIdToBackground, getState } = useUtilsContext();
  useEffect(() => {
    if (getState) {
      setGlobalGetState(getState);
    }
  }, [getState]);
  useEffect(() => {
    if (sendToBackground2) {
      setSendToBackground(sendToBackground2);
    }
  }, [sendToBackground2]);
  useEffect(() => {
    setGlobalGetDispatch(dispatch);
  }, [dispatch]);
  const {
    isDebugger,
    isAiAtomsWidget,
    testCaseId,
    versionId,
    projectId,
    applicationType,
    tenantId,
    isDesktopStepRecorderWidgetActive
  } = useRecorderContext();
  const { getResourceURL } = useResourceURL();
  const eventServiceRef = useRef(null);
  const publishEvent = useInternalEvents();
  const refreshOperationId = useRef(null);
  const copilotStatusRef = useRef();
  const [hideFloatingIcons, setHideFloatingIcons] = useState(false);
  const { stepResults } = use_web_debugger_default();
  const {
    recorderState,
    isRecorderLoaded,
    isShowHelpScreen,
    showUsageScreen,
    isMinimized,
    recorderType,
    isSfOrgChanged,
    copilotWindowOpenState,
    copilotChatHistory,
    copilotData,
    isExtensionPage,
    isEnableReorder,
    templates,
    recorderPreferences
  } = useSelector((state) => state.widget);
  copilotStatusRef.current = copilotData?.status;
  useEffect(() => {
    log.debug("Widget => new EventService");
    if (!eventServiceRef.current) {
      eventServiceRef.current = new EventService();
    }
    return () => {
      if (eventServiceRef.current) {
        eventServiceRef.current.cleanup?.();
        eventServiceRef.current = null;
      }
    };
  }, []);
  useEffect(() => {
    if (templates) {
      sendToBackground2({
        context: MESSAGE_CONTEXT.TEMPLATE,
        action: MESSAGE_CONTEXT_ACTION.BROADCAST,
        value: templates
      });
    }
  }, [templates]);
  useEffect(() => {
    if (recorderPreferences) {
      sendToBackground2({
        context: MESSAGE_CONTEXT.RECORDER,
        action: MESSAGE_CONTEXT_ACTION.SYNC_PREFERENCE,
        value: recorderPreferences
      });
    }
  }, [recorderPreferences]);
  const onMinimizeStatus = (value) => {
    dispatch(setIsMinimized(value));
    sendToTSTab(MESSAGE_CONTEXT.WIDGET, MESSAGE_CONTEXT_ACTION.VIEW, value);
    sendToTSTab(
      MESSAGE_CONTEXT.WIDGET,
      MESSAGE_CONTEXT_ACTION.RESIZE,
      WIDGET_VIEW.RECORDER_MINIMIZED
    );
    onToggleMobileExpanded(null);
  };
  const onToggleCopilotWindow = (status) => {
    try {
      dispatch(setCopilotWindowOpenState(status));
      if (status) {
        dispatch(setCopilotChatHistory([]));
      }
      sendToTSTab(
        MESSAGE_CONTEXT.WIDGET,
        MESSAGE_CONTEXT_ACTION.COPILOT_VIEW,
        status
      );
      sendToTSTab(
        MESSAGE_CONTEXT.WIDGET,
        MESSAGE_CONTEXT_ACTION.RESIZE,
        status ? WIDGET_VIEW.RECORDER_COPILOT : WIDGET_VIEW.RECORDER
      );
      if (status) {
        sendToBackground2({
          context: MESSAGE_CONTEXT.COPILOT,
          action: MESSAGE_CONTEXT_ACTION.REQUEST,
          value: JSON.stringify({ clear: true })
        });
      }
      if (status) {
        logEvent(
          analytics_constants_default.AMPLITUDE.LIVE_EDITOR_COPILOT_WINDOW_OPENED,
          {
            application_type: applicationType
          }
        );
      }
    } catch (error) {
      logEvent(
        analytics_constants_default.AMPLITUDE.LIVE_EDITOR_COPILOT_WINDOW_OPEN_FAILED,
        {
          application_type: applicationType,
          error_message: error?.message
        }
      );
      log.error("Failed to toggle copilot window:", error);
    }
  };
  const onToggleMobileExpanded = (state = "expand") => {
    sendToContentWindow(
      MESSAGE_CONTEXT.WIDGET,
      MESSAGE_CONTEXT_ACTION.MOBILE_EXPANDED,
      state
    );
  };
  useEffect(() => {
    if (sendWidgetWindowIdToBackground) {
      sendWidgetWindowIdToBackground();
    }
    sendToBackground2({
      context: MESSAGE_CONTEXT.STATE,
      action: MESSAGE_CONTEXT_ACTION.REQUEST,
      value: ""
    });
    sendToBackground2({
      context: MESSAGE_CONTEXT.COPILOT,
      action: MESSAGE_CONTEXT_ACTION.REQUEST,
      value: ""
    });
    sendToContentWindow(MESSAGE_CONTEXT.WIDGET, MESSAGE_CONTEXT_ACTION.VIEW);
    sendToContentWindow(
      MESSAGE_CONTEXT.WIDGET,
      MESSAGE_CONTEXT_ACTION.POSITION
    );
    sendToContentWindow(
      MESSAGE_CONTEXT.WIDGET,
      MESSAGE_CONTEXT_ACTION.COPILOT_VIEW
    );
    const listener = (message) => {
      switch (message.context) {
        case MESSAGE_CONTEXT.WIDGET:
          switch (message.action) {
            case MESSAGE_CONTEXT_ACTION.SEND_TO_WIDGET:
              {
                try {
                  if (typeof message.value === "string" || typeof message.value === "object") {
                    try {
                      const contentMessage = typeof message.value == "object" ? message.value : JSON.parse(message.value);
                      log.debug("[WIDGET] contentMessage", contentMessage);
                      if (contentMessage.action === DESKTOP_RECORDER_ACTION_RESPONSES.SUCCESS && isDesktopStepRecorderWidgetActive) {
                        dispatch(setIsDesktopRecorderActionLoading(false));
                        dispatch(
                          updateRecorderState(contentMessage.value.newState)
                        );
                        sendToBackground2({
                          context: MESSAGE_CONTEXT.STATE,
                          action: MESSAGE_CONTEXT_ACTION.UPDATE,
                          value: contentMessage.value.newState
                        });
                        break;
                      }
                      if (contentMessage.action === DESKTOP_RECORDER_ACTION_RESPONSES.ERROR && isDesktopStepRecorderWidgetActive) {
                        dispatch(setIsDesktopRecorderActionLoading(false));
                        toastify(t("recorder.error.application_not_launched"), {
                          type: "error"
                        });
                        break;
                      }
                      eventListener(
                        contentMessage,
                        handleRecorderReload,
                        launchRecorder
                      );
                      if (contentMessage.dataType === "CLOSE_COPILOT") {
                        onToggleCopilotWindow(false);
                      }
                    } catch (error) {
                      log.error(
                        "[WIDGET] Failed to parse direct event message",
                        error
                      );
                    }
                    const msgData = typeof message.value == "object" ? message.value : JSON.parse(message.value);
                    console.log("LISTEN MESSAGE", {
                      ...msgData
                    });
                    customEventListener(
                      msgData,
                      dispatch,
                      publishEvent,
                      showElementHighlightFailed,
                      handleCopilotEvent,
                      copilotStatusRef.current
                    );
                  }
                } catch (error) {
                  log.error(LOG.WIDGET, "LISTEN MESSAGE", message.value, error);
                }
              }
              break;
          }
          break;
      }
    };
    addMessageListener(listener);
    window.addEventListener("mouseup", () => {
      window.parent.postMessage({ type: "mouseup" }, "*");
    });
    return () => {
      removeMessageListener(listener);
    };
  }, [dispatch]);
  const onReconfigure = useCallback(() => {
    if (isDebugger) {
      reconfigureWidget();
    }
  }, [reconfigureWidget, isDebugger]);
  useEffect(() => {
    const fetchSessionData = async (retryCount = 0) => {
      const maxRetries = 5;
      const baseDelay = 200;
      console.log("TCL ~ fetchSessionData attempt:", {
        retryCount,
        hasBaseUrl: Boolean(Api.baseUrl),
        baseUrl: Api.baseUrl
      });
      if (!Api.baseUrl) {
        if (retryCount < maxRetries) {
          const delay2 = baseDelay * Math.pow(2, retryCount);
          console.log(`TCL ~ Api.baseUrl not set, retrying in ${delay2}ms...`);
          setTimeout(() => fetchSessionData(retryCount + 1), delay2);
          return;
        } else {
          console.error("TCL ~ Api.baseUrl not set after max retries");
          return;
        }
      }
      try {
        const res = await SessionApi.get();
        console.log("TCL ~ SessionApi.get() success:", res);
        if (res.features) {
          dispatch(setTenantFeatures(res.features));
        }
        if (res.tenantPreference) {
          dispatch(setTenantPreference(res.tenantPreference));
        }
      } catch (error) {
        console.error("TCL ~ SessionApi.get() failed:", error);
      }
    };
    fetchSessionData();
    sendToBackground2?.({
      context: MESSAGE_CONTEXT.COPILOT,
      action: MESSAGE_CONTEXT_ACTION.REQUEST,
      value: ""
    });
    return () => {
      dispatch(resetDebuggingSliceState());
      dispatch(resetStepCreatorSliceState());
    };
  }, [dispatch, sendToBackground2]);
  const handleCopilotEvent = useCallback(
    (data) => {
      log.debug(LOG.WIDGET, "Copilot event", data);
      dispatch(setCopilotData(data));
      if (!data) return;
      if (data.chatHistory) {
        const seenMessages = /* @__PURE__ */ new Set();
        const deduplicatedHistory = data.chatHistory.filter(
          (message, index) => {
            const interactionId = message.data?.interactionId ?? message.data?.interaction_id;
            const messageKey = message.type === "STEPS" || message.type === "SCENARIOS" ? JSON.stringify({
              type: message.type,
              interactionId: interactionId ?? `idx-${index}`
            }) : JSON.stringify({
              type: message.type,
              query: message.data?.query,
              interactionId: interactionId ?? `idx-${index}`
            });
            if (seenMessages.has(messageKey)) {
              return false;
            }
            seenMessages.add(messageKey);
            return true;
          }
        );
        dispatch(setCopilotChatHistory(deduplicatedHistory));
      }
    },
    [dispatch]
  );
  useEffect(() => {
    if (recorderType === RECORDER_TYPE.ELEMENT_CAPTURE) {
      sendToContentWindow(
        MESSAGE_CONTEXT.ELEMENT_FINDER,
        MESSAGE_CONTEXT_ACTION.REQUEST
      );
    }
  }, [recorderType]);
  const onReorderSteps = () => {
    dispatch(setIsEnableReorder(true));
    sendToBackground2({
      context: MESSAGE_CONTEXT.STATE,
      action: MESSAGE_CONTEXT_ACTION.UPDATE,
      value: RECORDER_STATE.HOLD
    });
  };
  const handleRefreshWidget = async () => {
    refreshOperationId.current = `refresh-${Date.now()}`;
    dispatch(setReconfInProgress(true));
    await handleRecorderReload(recorderType, true);
    dispatch(setReconfInProgress(false));
  };
  const handleRecorderReload = async (_recorderType, isFromRefresh = false) => {
    await loadRecorderData(_recorderType);
    if (refreshOperationId.current && isFromRefresh) {
      toastify(
        isDebugger ? "Copilot refreshed successfully" : "Recorder refreshed successfully",
        {
          type: "success",
          position: "bottom-center",
          hideProgressBar: true
        }
      );
      refreshOperationId.current = null;
    }
  };
  const createDebugRecorderValue = useCallback(() => {
    return {
      type: RECORDER_TYPE.STEP,
      isNewUI: true,
      isInitialLoad: true,
      source: RECORDER_SOURCE.CLOUD,
      content: "Start Recording",
      isDebugMode: true,
      serverUrl: Api.baseUrl,
      testCaseId,
      appVersionId: versionId,
      projectId,
      applicationType,
      tenantId
    };
  }, [testCaseId, versionId, projectId, applicationType, tenantId]);
  const launchRecorder = useCallback(
    async (message, isFromEvent = false) => {
      await handleRecorderLaunch(message);
      if (isDebugger) {
        if (isFromEvent) {
          sendToBackground2({
            context: MESSAGE_CONTEXT.RECORDER,
            action: MESSAGE_CONTEXT_ACTION.LAUNCH,
            value: {
              ...message.value || {},
              ...createDebugRecorderValue()
            }
          });
        }
      }
    },
    [isDebugger, sendToBackground2, createDebugRecorderValue]
  );
  const showElementHighlightFailed = () => {
    toastify("Element not found in this screen", {
      type: "error",
      position: "bottom-center",
      hideProgressBar: true
    });
  };
  const renderBody = () => /* @__PURE__ */ jsx(
    Body3,
    {
      canFocusLastStep: !isMinimized,
      onEnableReorder: onReorderSteps,
      setHideFloatingIcons,
      onRefreshWidget: handleRefreshWidget
    }
  );
  useEffect(() => {
    if (!isDebugger || !testCaseId) {
      return;
    }
    const value = createDebugRecorderValue();
    handleRecorderLaunch({
      value,
      context: MESSAGE_CONTEXT.RECORDER,
      action: MESSAGE_CONTEXT_ACTION.LAUNCH
    });
  }, [isDebugger, testCaseId]);
  if (isMinimized) {
    return /* @__PURE__ */ jsx(MinimizedWidget, {});
  }
  return /* @__PURE__ */ jsx(QueryClientProvider$1, { client: queryClient, children: /* @__PURE__ */ jsx(
    StepChildTreeContextProvider,
    {
      isDebugger,
      stepResults,
      children: /* @__PURE__ */ jsxs(
        "div",
        {
          id: "ts-widget-container",
          className: `widget h-full w-full rounded-[10px]${copilotWindowOpenState ? " copilot-window-open" : ""}`,
          children: [
            copilotWindowOpenState && /* @__PURE__ */ jsx(CopilotWindow_default, { onClose: () => onToggleCopilotWindow(false) }),
            /* @__PURE__ */ jsxs(
              "div",
              {
                id: "ts-widget-recorder-layout",
                className: classNames82("relative", {
                  "reorder-enabled": isEnableReorder
                }),
                style: isDebugger ? { gridTemplateRows: `${isAiAtomsWidget ? 0 : 47}px 1fr` } : void 0,
                children: [
                  /* @__PURE__ */ jsx(
                    Header3,
                    {
                      onMinimizeStatus: () => {
                        onMinimizeStatus(true);
                      },
                      onRefreshWidget: () => handleRefreshWidget(),
                      openCopilotWindow: () => onToggleCopilotWindow(true),
                      hidePrimaryHeader: isAiAtomsWidget,
                      hideFloatingIcons
                    }
                  ),
                  isShowHelpScreen ? /* @__PURE__ */ jsx(
                    HelpScreen,
                    {
                      onClose: () => dispatch(setIsShowHelpScreen(false)),
                      onRefreshWidget: () => {
                        handleRefreshWidget();
                        dispatch(setIsShowHelpScreen(false));
                      }
                    }
                  ) : showUsageScreen ? /* @__PURE__ */ jsx(Usage, { onClose: () => dispatch(setShowUsageScreen(false)) }) : !isRecorderLoaded ? /* @__PURE__ */ jsx(
                    Loader2,
                    {
                      onRefreshWidget: () => handleRefreshWidget(),
                      onReconfigure,
                      showReconfigureMessage: isDebugger && !copilotChatHistory?.length,
                      loaderMessage: isDebugger ? __("live-editor.loader.message") : null,
                      isDebugger
                    }
                  ) : isDesktopStepRecorderWidgetActive ? renderBody() : !isDebugger && recorderType === RECORDER_TYPE.STEP && isExtensionPage ? /* @__PURE__ */ jsxs("div", { className: "flex flex-col items-center justify-center h-full", children: [
                    /* @__PURE__ */ jsx(
                      "img",
                      {
                        src: getResourceURL("img/enter-url.svg"),
                        alt: "enter-url"
                      }
                    ),
                    /* @__PURE__ */ jsx("p", { className: "text-sm font-semibold my-3", children: "URL Required" }),
                    /* @__PURE__ */ jsx("p", { className: "text-sm text-gray-500 font-normal", children: "Enter URL in the browser to get started" })
                  ] }) : /* @__PURE__ */ jsx(Fragment, { children: renderBody() }),
                  isEnableReorder && /* @__PURE__ */ jsx(ReorderStepsBanner, { enableReorder: isEnableReorder }),
                  recorderState == RECORDER_STATE.RUNNING && isSfOrgChanged && /* @__PURE__ */ jsx(
                    OrgChangePopup,
                    {
                      onClose: () => dispatch(setIsSfOrgChanged(false))
                    }
                  )
                ]
              }
            )
          ]
        }
      )
    }
  ) });
}
var notAnNlpStep = (testStep) => {
  return testStep?.stepGroupId || testStep?.type == TestStepType.BLOCK || testStep?.type == TestStepType.API_STEP || testStep?.type == TestStepType.NLP_TEXT && testStep?.conditionType == TestStepConditionType.CONDITION_ELSE;
};
var StepGroupIcon = ({ stepGroupResultsLoading, isStepGroupExpanded }) => {
  if (stepGroupResultsLoading)
    return /* @__PURE__ */ jsx("span", { className: "w-5", children: /* @__PURE__ */ jsx(
      Spinner,
      {
        thickness: 80,
        speed: 140,
        color: "#5E6C84",
        secondaryColor: "rgba(172, 57, 57, 0)"
      }
    ) });
  return /* @__PURE__ */ jsx(
    Icon,
    {
      name: isStepGroupExpanded ? "chevron-down" : "chevron-right",
      className: classNames82("text-xl inline-flex", {
        "!inline-flex": isStepGroupExpanded
      })
    }
  );
};
var TestStepResultNLP = ({
  stepResult,
  nlpTemplates,
  fetchStepGroupResults,
  previousTestStepResult,
  wrapperClassName = "w-full",
  stepGroupResultsLoading = false,
  isStepGroupExpanded,
  nlActions,
  hasFeatureValue: hasFeatureValue2,
  stepWrapperRef,
  includeOptionalTemplates = false,
  ignoreBorderAndBackground = false
}) => {
  const { t } = useTranslation();
  const [globalStepsInfo, updateGlobalStepsInfo] = useState({
    activeStepIdx: null,
    selectedSteps: [],
    updateSelectedSteps: null,
    nlpContainerWidth: {},
    isReorderState: false,
    isStepTypeSwitchOpened: true,
    isStepResult: true
  });
  const [testStep, setTestStep] = useState();
  const [template, setTemplate] = useState();
  const stepHighlightByStatus = step_result_icon_details_default(stepResult.result);
  useEffect(() => {
    setTestStep(populateStep(stepResult));
    setTemplate(populateTemplate(stepResult));
  }, [stepResult, nlpTemplates]);
  const canShowStep = useMemo(() => {
    return testStep?.action && template?.id && !testStep?.stepGroupId || !template?.id && notAnNlpStep(testStep);
  }, [testStep, template]);
  const createStepElementRequest2 = (identifier, elementType) => {
    if (!identifier) return void 0;
    const element = new StepElementRequest();
    element.name = identifier.replace(/\n/g, "");
    element.elementType = elementType;
    return element;
  };
  const deserializeStepData = (stepDetails) => {
    const stepItem = new TestStep().deserialize(stepDetails);
    const dataList = Object.keys(stepItem.dataMap?.testData || {}).map(
      (key) => {
        const testData2 = stepItem.dataMap.testData[key];
        testData2.key = key;
        return testData2;
      }
    );
    return { stepDataList: dataList, attribute: stepItem.dataMap?.attribute };
  };
  const getUiIdentifierName = (stepResult2, fieldType) => {
    if (Boolean(stepResult2?.fieldDefinitionDetails)) {
      return stepResult2?.fieldDefinitionDetails?.[fieldType]?.uiIdentifierName;
    } else {
      const dataMap = stepResult2?.metadata?.testStep?.dataMap;
      switch (fieldType) {
        case FieldDefinitionDetailsType.FROM_UI_ELEMENT:
          return dataMap?.fromUiIdentifier;
        case FieldDefinitionDetailsType.TO_UI_ELEMENT:
          return dataMap?.toUiIdentifier;
        case FieldDefinitionDetailsType.UI_ELEMENT:
          return dataMap?.uiIdentifier;
      }
    }
  };
  function populateTemplate(stepResult2) {
    const nlpTemplate = nlpTemplates.find((nlpAction) => {
      if (nlpAction.isAddon) {
        return nlpAction.id === (stepResult2?.metadata?.testStep?.kibbutzPluginNlpId || stepResult2?.stepDetails?.kibbutzPluginNlpId);
      } else if (!nlpAction.isAddon) {
        return nlpAction.id === (stepResult2?.metadata?.testStep?.templateId || stepResult2?.stepDetails?.templateId);
      }
    });
    return nlpTemplate;
  }
  const populateKibbutz = (StepDetailsDataMap4, stepResult2) => {
    const kibbutStepDetails = StepDetailsDataMap4?.kibbutzPluginStepDetails;
    if (kibbutStepDetails?.testData && stepResult2?.testDataDetails) {
      Object?.keys(kibbutStepDetails?.testData).map((key) => {
        kibbutStepDetails.testData[key].type = stepResult2?.testDataDetails?.[key]?.overriddenMappingEntity?.parameterType || stepResult2?.testDataDetails?.[key]?.testDataType;
        kibbutStepDetails.testData[key].value = stepResult2?.testDataDetails?.[key]?.overriddenMappingEntity?.parameterValue || stepResult2?.testDataDetails?.[key]?.testDataName;
      });
    }
    if (kibbutStepDetails?.uiIdentifiers && stepResult2?.fieldDefinitionDetails) {
      Object?.keys(kibbutStepDetails?.uiIdentifiers).map((key) => {
        kibbutStepDetails.uiIdentifiers[key].name = stepResult2?.fieldDefinitionDetails?.[key]?.uiIdentifierName;
      });
    }
    StepDetailsDataMap4.kibbutzPluginNlpData = kibbutStepDetails;
    StepDetailsDataMap4.kibbutzPluginNlpId = StepDetailsDataMap4?.kibbutzPluginNlpEntity?.id;
    return StepDetailsDataMap4;
  };
  function populateStep(stepResult2) {
    const stepData = stepResult2?.stepDetails || stepResult2?.metadata?.testStep;
    const { stepDataList, attribute } = deserializeStepData(stepData);
    const fromElement = createStepElementRequest2(
      getUiIdentifierName(
        stepResult2,
        FieldDefinitionDetailsType.FROM_UI_ELEMENT
      ),
      TestStepElementType.FROM_UI_ELEMENT
    );
    const toElement = createStepElementRequest2(
      getUiIdentifierName(stepResult2, FieldDefinitionDetailsType.TO_UI_ELEMENT),
      TestStepElementType.TO_UI_ELEMENT
    );
    const uiElement = createStepElementRequest2(
      getUiIdentifierName(stepResult2, FieldDefinitionDetailsType.UI_ELEMENT),
      TestStepElementType.UI_ELEMENT
    );
    if (!stepData.forLoopCondition) {
      stepData.forLoopCondition = stepResult2?.metadata?.forLoop?.forLoopConditions;
    }
    stepResult2.stepDetails = {
      ...stepData,
      stepDataList,
      attribute,
      testStepElements: [fromElement, toElement, uiElement].filter(Boolean)
    };
    if (stepResult2.stepDetails?.kibbutzPluginNlpEntity?.id) {
      stepResult2.stepDetails = populateKibbutz(
        stepResult2.stepDetails,
        stepResult2
      );
    }
    return {
      ...stepResult2.stepDetails,
      stepDataList,
      attribute,
      testStepElements: [fromElement, toElement, uiElement].filter(Boolean)
      // Include only valid elements
    };
  }
  const handleStepClick = useCallback(() => {
    if (!!testStep?.stepGroupId) {
      fetchStepGroupResults(
        stepResult,
        isStepGroupExpanded,
        previousTestStepResult
      );
    }
  }, [
    testStep?.stepGroupId,
    fetchStepGroupResults,
    stepResult,
    isStepGroupExpanded,
    previousTestStepResult
  ]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames82(
        "flex gap-x-2 items-center",
        wrapperClassName,
        !canShowStep
      ),
      onClick: () => handleStepClick(),
      children: [
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: classNames82("flex items-center gap-x-3", {
              "w-full": !canShowStep || !!testStep?.stepGroupId
            }),
            children: [
              /* @__PURE__ */ jsx("span", { className: "flex items-center justify-center text-base pl-1 !h-4 !w-4", children: /* @__PURE__ */ jsx(
                ToolTip,
                {
                  placement: "bottom",
                  content: stepResult.result,
                  className: "inline-flex",
                  children: stepHighlightByStatus?.icon
                }
              ) }),
              testStep?.isStepGroup && /* @__PURE__ */ jsx(
                StepGroupIcon,
                {
                  stepGroupResultsLoading,
                  isStepGroupExpanded
                }
              ),
              /* @__PURE__ */ jsx(
                StepNumber,
                {
                  number: stepResult.stepNumber,
                  className: "!h-fit text-center !min-w-[18px] leading-3 !py-[3px] !px-0.5"
                }
              ),
              /* @__PURE__ */ jsxs(
                "div",
                {
                  className: classNames82("flex gap-x-1 items-center", {
                    "w-full": !canShowStep,
                    "w-8/12": !!testStep?.stepGroupId && canShowStep
                  }),
                  children: [
                    !!testStep?.conditionType && /* @__PURE__ */ jsx("span", { className: "pl-1 flex", children: /* @__PURE__ */ jsx(step_type_indicator_text_component_default, { step: testStep }) }),
                    (testStep?.kibbutzPluginNlpId || testStep?.isCustomFunction) && /* @__PURE__ */ jsx(
                      Icon,
                      {
                        name: "addons",
                        className: classNames82({
                          "!mt-3": testStep?.action?.length > 150
                        })
                      }
                    ),
                    canShowStep ? includeOptionalTemplates ? /* @__PURE__ */ jsx(
                      TestExecutionResultContainerV2,
                      {
                        step: testStep,
                        isResultBlock: true,
                        isViewOnly: true,
                        stepsInfo: globalStepsInfo,
                        template,
                        isStepResult: true,
                        updateStepsInfo: updateGlobalStepsInfo,
                        nlActions,
                        hasFeatureValue: hasFeatureValue2,
                        stepWrapperRef,
                        ignoreBorderAndBackground
                      }
                    ) : /* @__PURE__ */ jsx(
                      StepItemWrapper,
                      {
                        step: testStep,
                        stepsInfo: globalStepsInfo,
                        template,
                        isStepResult: true,
                        isResultBlock: true,
                        isViewOnly: true,
                        updateStepsInfo: updateGlobalStepsInfo
                      }
                    ) : /* @__PURE__ */ jsx("div", { className: "w-10/12 animate-shimmer-result h-6 rounded-[5px]" })
                  ]
                }
              )
            ]
          }
        ),
        stepResult?.metadata?.["stepGroup"] && /* @__PURE__ */ jsxs("div", { className: "flex gap-x-3  text-small leading-4 text-unique-800 pl-2", children: [
          /* @__PURE__ */ jsx("span", { className: "px-3 py-0.5 border rounded-full bg-secondary-50 border-secondary-200", children: `SET NAME : ${stepResult?.metadata?.["stepGroup"]?.["setName"]}` }),
          /* @__PURE__ */ jsx("span", { className: "px-3 py-0.5 border rounded-full bg-secondary-50 border-secondary-200", children: `ETF : ${stepResult?.metadata?.["stepGroup"]?.["etf"] ? t("common.yes") : t("common.no")}` })
        ] })
      ]
    }
  );
};
var nameSpace16 = PrivateURLConstants.INTEGRATIONS ?? `/private/settings/external_application_configs`;
var findNonSerilizedAll = (query) => {
  console.log("findNonSerilizedAll", nameSpace16, query);
  return instance_default.get(nameSpace16, { query }).then((res) => res).catch((e) => Promise.reject(e));
};
var findAll7 = (query) => {
  console.log("findAll", nameSpace16, query);
  return findNonSerilizedAll(query).then(
    (res) => new Page().deserialize(
      res,
      ExternalApplicationConfig
    )
  ).catch((e) => Promise.reject(e));
};
var findAllJiraIssueTypes = (projectId) => {
  return new Promise((resolve, reject) => {
    instance_default.get(`${nameSpace16}/jira/project/${projectId}/issueTypes`).then((res) => resolve(res)).catch((e) => reject(e));
  });
};
var searchJiraProjects = (query) => {
  return new Promise((resolve, reject) => {
    instance_default.get(`${nameSpace16}/jira/projects${query ? `?query=${query}` : ""}`).then((res) => resolve(res)).catch((e) => reject(e));
  });
};
var searchJiraAssignees = (projectKey, query) => {
  return new Promise((resolve, reject) => {
    const params = new URLSearchParams();
    params.append("project", projectKey);
    params.append("query", query || "");
    const url = `${nameSpace16}/jira/assignable/search?${params.toString()}`;
    instance_default.get(url).then((res) => resolve(res)).catch((e) => reject(e));
  });
};
var fetchIssuesByIssueKeys = (issueKeys) => {
  return instance_default.get(`${nameSpace16}/jira/issues?issueKeys=${issueKeys.join(",")}`);
};
var findAllJiraIssues = ({
  appId,
  projectId,
  issueTypeId,
  searchTerm
}) => {
  return instance_default.get(
    `${nameSpace16}/${appId}/search_jira_issues?project=${projectId}&issueType=${issueTypeId}${searchTerm ? `&summary=${searchTerm}` : ""}
`
  ).then((res) => {
    return res.issues.map(
      (data) => new JiraSearchIssueModel().deserialize(data)
    );
  }).catch((e) => Promise.reject(e));
};
var findAllTrelloProjects = (id) => {
  return instance_default.get(`${nameSpace16}/${id}/trello_projects`).then((res) => {
    return res.data.map((data) => new TrelloProjectModel().deserialize(data));
  }).catch((e) => Promise.reject(e));
};
var findAllTrelloIssueTypes = ({
  appId,
  projectId
}) => {
  return instance_default.get(`${nameSpace16}/${appId}/search_trello_issue_types?project=${projectId}`).then((res) => {
    return res.map((data) => new TrelloIssueTypeModel().deserialize(data));
  }).catch((e) => Promise.reject(e));
};
var findAllTrelloIssues = ({
  appId,
  issueTypeId,
  searchTerm,
  issueId,
  isSingle
}) => {
  return instance_default.get(
    `${nameSpace16}/${appId}/search_trello_issue${!isSingle ? "s" : ""}/${issueTypeId ? "?issueTypeId=" + issueTypeId : ""}${searchTerm ? "&summary=" + searchTerm : ""}${issueId ? "?issueId=" + issueId : ""}
`
  ).then((res) => {
    if (isSingle) {
      return new TrelloIssueModel().deserialize(res);
    }
    return res.map((data) => new TrelloIssueModel().deserialize(data));
  }).catch((e) => Promise.reject(e));
};
var findAllYouTrackProjects = (id) => {
  return instance_default.get(`${nameSpace16}/${id}/youtrack_projects`).then((res) => {
    return res.map((data) => new YouTrackProjectModel().deserialize(data));
  }).catch((e) => Promise.reject(e));
};
var findAllYouTrackIssues = ({
  appId,
  searchTerm
}) => {
  return instance_default.get(
    `${nameSpace16}/${appId}/search_youtrack_issues${searchTerm ? "&title=" + searchTerm : ""}
`
  ).then((res) => {
    return res.map((data) => new YouTrackIssueModel().deserialize(data));
  }).catch((e) => Promise.reject(e));
};
var findAllBacklogProjects = (id) => {
  return instance_default.get(`${nameSpace16}/${id}/backlog_projects`).then((res) => {
    return res.map((data) => new BacklogProjectModel().deserialize(data));
  }).catch((e) => Promise.reject(e));
};
var findAllBacklogIssueTypes = ({
  appId,
  projectId
}) => {
  return instance_default.get(
    `${nameSpace16}/${appId}/search_backlog_issue_types?project=${projectId}`
  ).then((res) => {
    return res.map((data) => new BacklogIssueTypeModel().deserialize(data));
  }).catch((e) => Promise.reject(e));
};
var findAllBacklogPriorities = ({ appId }) => {
  return instance_default.get(`${nameSpace16}/${appId}/search_backlog_priorities`).then((res) => {
    return res.map((data) => new BacklogPriorityModel().deserialize(data));
  }).catch((e) => Promise.reject(e));
};
var findAllBacklogIssues = ({
  appId,
  projectId,
  issueTypeId,
  priorityId,
  searchTerm,
  issueId,
  isSingle
}) => {
  return instance_default.get(
    `${nameSpace16}/${appId}/search_backlog_issue${!isSingle ? "s" : ""}${projectId ? `?project=${projectId}&issueTypeId=${issueTypeId}&priorityId=${priorityId}` : issueId ? `?issueId=${issueId}` : ""}${searchTerm ? "&keyword=" + searchTerm : ""}`
  ).then((res) => {
    return res.map((data) => new BacklogIssueModel().deserialize(data));
  }).catch((e) => Promise.reject(e));
};
var findAllAzureIssues = ({
  appId,
  project,
  issueType,
  searchTerm
}) => {
  return instance_default.get(
    `${nameSpace16}/${appId}/search_azure_issues?${project ? `project=${project}&issueType=${issueType}` : ""}${searchTerm ? "&title=" + searchTerm : ""}`
  ).then((res) => {
    return res?.workItems?.map(
      (data) => new AzureIssueTypeDefaultWorkItemTypeModel().deserialize(data)
    );
  }).catch((e) => Promise.reject(e));
};
var findAzureIssues = ({ appId, ids }) => {
  return instance_default.get(
    `${nameSpace16}/${appId}/get_azure_issues?${ids?.length > 0 ? `ids=${ids.join(",")}` : ""}`
  ).then((res) => {
    return res?.value?.map((data) => new AzureIssueModel().deserialize(data));
  }).catch((e) => Promise.reject(e));
};
var findAllLinearTeams = (id) => {
  return instance_default.get(`${nameSpace16}/${id}/linear_teams`).then((res) => {
    return res.data.teams.nodes.map(
      (data) => new LinearTeamModel().deserialize(data)
    );
  }).catch((e) => Promise.reject(e));
};
var findAllLinearProjects = ({
  appId,
  teamId
}) => {
  return instance_default.get(`${nameSpace16}/${appId}/search_linear_projects?teamId=${teamId}`).then((res) => {
    return res.data.team.projects.nodes.map(
      (data) => new LinearTeamProjectModel().deserialize(data)
    );
  }).catch((e) => Promise.reject(e));
};
var findAllLinearProjectIssues = ({
  appId,
  projectId,
  searchTerm,
  isSingle,
  issueId
}) => {
  return instance_default.get(
    `${nameSpace16}/${appId}/search_linear_issue${!isSingle ? "s" : ""}${projectId ? `?projectId=${projectId}` : issueId ? `?issueId=${issueId}` : ""}${searchTerm ? "&keyword=" + searchTerm : ""}`
  ).then((res) => {
    if (isSingle) {
      return new LinearTeamIssueModel().deserialize(res.data.issue);
    }
    return res.data.project.issues.nodes.map(
      (data) => new LinearTeamIssueModel().deserialize(data)
    );
  }).catch((e) => Promise.reject(e));
};
var findAllClickUpTeams = (id) => {
  return instance_default.get(`${nameSpace16}/${id}/clickup_teams`).then((res) => {
    return res.data.teams.map(
      (data) => new ClickUpTeamModel().deserialize(data)
    );
  }).catch((e) => Promise.reject(e));
};
var findAllClickUpFolders = ({
  appId,
  spaceId
}) => {
  return instance_default.get(`${nameSpace16}/${appId}/clickup_folders?spaceId=${spaceId}`).then((res) => {
    return res.data.folders.map(
      (data) => new ClickUpFolderModel().deserialize(data)
    );
  }).catch((e) => Promise.reject(e));
};
var findAllClickUpSpaces = ({
  appId,
  teamId
}) => {
  return instance_default.get(`${nameSpace16}/${appId}/clickup_spaces?teamId=${teamId}`).then((res) => {
    return res.data.spaces.map(
      (data) => new ClickUpSpaceModel().deserialize(data)
    );
  }).catch((e) => Promise.reject(e));
};
var findAllClickUpLists = ({
  appId,
  folderId
}) => {
  return instance_default.get(`${nameSpace16}/${appId}/clickup_lists?folderId=${folderId}`).then((res) => {
    return res.data.lists.map(
      (data) => new ClickUpListModel().deserialize(data)
    );
  }).catch((e) => Promise.reject(e));
};
var findAllClickUpTasks = ({
  appId,
  listId
}) => {
  return instance_default.get(`${nameSpace16}/${appId}/clickup_tasks?listId=${listId}`).then((res) => {
    return res.data.tasks.map(
      (data) => new ClickUpTaskModel().deserialize(data)
    );
  }).catch((e) => Promise.reject(e));
};
var findAllMondayProjects = (id) => {
  return instance_default.get(`${nameSpace16}/${id}/monday_projects`).then((res) => {
    return res.data.boards.map(
      (data) => new MondayProjectModel().deserialize(data)
    );
  }).catch((e) => Promise.reject(e));
};
var findAllMondayUsers = (id) => {
  return instance_default.get(`${nameSpace16}/${id}/monday_users`).then((res) => {
    return res.data.users.map(
      (data) => new MondayUserModel().deserialize(data)
    );
  }).catch((e) => Promise.reject(e));
};
var findAllMondayIssues = ({
  appId,
  boardId,
  groupId
}) => {
  return instance_default.get(
    `${nameSpace16}/${appId}/search_monday_issues?boardId=${boardId}&groupId=${groupId}`
  ).then((res) => {
    return res.data.boards[0].items.map(
      (data) => new MondayIssueModel().deserialize(data)
    );
  }).catch((e) => Promise.reject(e));
};
var findAllAzureProjects = (id) => {
  return instance_default.get(`${nameSpace16}/${id}/azure_projects`).then((res) => {
    return res.value.map((data) => new AzureProjectModel().deserialize(data));
  }).catch((e) => Promise.reject(e));
};
var findAllBugzillaProjects = (id) => {
  return instance_default.get(`${nameSpace16}/${id}/bugzilla_projects`).then((res) => {
    return res.products.map(
      (data) => new BugzillaProjectModel().deserialize(data)
    );
  }).catch((e) => Promise.reject(e));
};
var findAllMantisProjects = (id) => {
  return instance_default.get(`${nameSpace16}/${id}/mantis_projects`).then((res) => {
    return res.projects?.map(
      (data) => new MantisProjectModel().deserialize(data)
    );
  }).catch((e) => Promise.reject(e));
};
var findAllMantisIssues = ({
  appId,
  projectId
}) => {
  return instance_default.get(`${nameSpace16}/${appId}/search_mantis_issues?project=${projectId}`).then((res) => {
    return res.issues?.map(
      (data) => new MantisIssueModel().deserialize(data)
    );
  }).catch((e) => Promise.reject(e));
};
var findMantisIssue = ({
  appId,
  issueId
}) => {
  return instance_default.get(`${nameSpace16}/${appId}/search_mantis_issue/${issueId}`).then((res) => {
    return res.issues?.[0];
  }).catch((e) => Promise.reject(e));
};
var findAllQTestProjects = () => {
  return instance_default.get(`${nameSpace16}/qtest/projects`).then((res) => {
    return res.map((data) => new QTestProject().deserialize(data));
  }).catch((e) => Promise.reject(e));
};
var findAllQTestDefectFields = (projectId) => {
  return new Promise((resolve, reject) => {
    instance_default.get(`${nameSpace16}/qtest/projects/${projectId}/defect_fields`).then((res) => resolve(res)).catch((e) => reject(e));
  });
};
var findAllAzureDevopsWorkItemsTypes = (projectId) => {
  return instance_default.get(
    `${nameSpace16}/azure_devops/projects/${projectId}/workitem/type`
  );
};
var fetchJiraIssueFields = (projectKey, issueType) => {
  return new Promise((resolve, reject) => {
    instance_default.get(
      `${nameSpace16}/jira/projects/${projectKey}/issueType/${issueType}/fields`
    ).then((res) => resolve(res)).catch((e) => reject(e));
  });
};
var findAllGitLabProjects = (id) => {
  return instance_default.get(`${nameSpace16}/${id}/gitlab_projects`).then((res) => res).catch((e) => Promise.reject(e));
};
var findAllGitLabIssues = ({
  appId,
  projectId,
  searchTerm
}) => {
  return instance_default.get(
    `${nameSpace16}/${appId}/search_gitlab_issues?projectId=${projectId}${searchTerm ? "&title=" + searchTerm : ""}`
  ).then((res) => res).catch((e) => Promise.reject(e));
};
var ExternalApplicationConfigService = {
  findAll: findAll7,
  findAllAzureIssues,
  findAzureIssues,
  findAllJiraIssueTypes,
  findAllJiraIssues,
  searchJiraProjects,
  searchJiraAssignees,
  fetchIssuesByIssueKeys,
  findAllTrelloProjects,
  findAllTrelloIssueTypes,
  findAllTrelloIssues,
  findAllYouTrackProjects,
  findAllYouTrackIssues,
  findAllBacklogProjects,
  findAllBacklogIssueTypes,
  findAllBacklogIssues,
  findAllBacklogPriorities,
  findAllLinearTeams,
  findAllLinearProjectIssues,
  findAllLinearProjects,
  findAllClickUpFolders,
  findAllClickUpLists,
  findAllClickUpSpaces,
  findAllClickUpTeams,
  findAllClickUpTasks,
  findAllMondayProjects,
  findAllMondayUsers,
  findAllMondayIssues,
  findAllAzureProjects,
  findAllBugzillaProjects,
  findAllMantisProjects,
  findAllMantisIssues,
  findMantisIssue,
  findAllQTestProjects,
  findAllQTestDefectFields,
  findAllAzureDevopsWorkItemsTypes,
  fetchJiraIssueFields,
  findAllGitLabProjects,
  findAllGitLabIssues
};
var external_application_config_service_default = ExternalApplicationConfigService;

// src/images/suites.svg
var suites_default = 'data:image/svg+xml,<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<mask id="mask0_865_19147" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">%0A<rect width="18" height="18" fill="%23D9D9D9"/>%0A</mask>%0A<g mask="url(%23mask0_865_19147)">%0A<path d="M3.74939 8.25012C3.43689 8.25012 3.17139 8.14062 2.95289 7.92162C2.73389 7.70312 2.62439 7.43762 2.62439 7.12512V3.75012C2.62439 3.43762 2.73389 3.17212 2.95289 2.95362C3.17139 2.73462 3.43689 2.62512 3.74939 2.62512H7.12439C7.43689 2.62512 7.70239 2.73462 7.92089 2.95362C8.13989 3.17212 8.24939 3.43762 8.24939 3.75012V7.12512C8.24939 7.43762 8.13989 7.70312 7.92089 7.92162C7.70239 8.14062 7.43689 8.25012 7.12439 8.25012H3.74939ZM3.74939 15.3751C3.43689 15.3751 3.17139 15.2656 2.95289 15.0466C2.73389 14.8281 2.62439 14.5626 2.62439 14.2501V10.8751C2.62439 10.5626 2.73389 10.2971 2.95289 10.0786C3.17139 9.85962 3.43689 9.75012 3.74939 9.75012H7.12439C7.43689 9.75012 7.70239 9.85962 7.92089 10.0786C8.13989 10.2971 8.24939 10.5626 8.24939 10.8751V14.2501C8.24939 14.5626 8.13989 14.8281 7.92089 15.0466C7.70239 15.2656 7.43689 15.3751 7.12439 15.3751H3.74939ZM10.8744 8.25012C10.5619 8.25012 10.2964 8.14062 10.0779 7.92162C9.85889 7.70312 9.74939 7.43762 9.74939 7.12512V3.75012C9.74939 3.43762 9.85889 3.17212 10.0779 2.95362C10.2964 2.73462 10.5619 2.62512 10.8744 2.62512H14.2494C14.5619 2.62512 14.8274 2.73462 15.0459 2.95362C15.2649 3.17212 15.3744 3.43762 15.3744 3.75012V7.12512C15.3744 7.43762 15.2649 7.70312 15.0459 7.92162C14.8274 8.14062 14.5619 8.25012 14.2494 8.25012H10.8744ZM10.8744 15.3751C10.5619 15.3751 10.2964 15.2656 10.0779 15.0466C9.85889 14.8281 9.74939 14.5626 9.74939 14.2501V10.8751C9.74939 10.5626 9.85889 10.2971 10.0779 10.0786C10.2964 9.85962 10.5619 9.75012 10.8744 9.75012H14.2494C14.5619 9.75012 14.8274 9.85962 15.0459 10.0786C15.2649 10.2971 15.3744 10.5626 15.3744 10.8751V14.2501C15.3744 14.5626 15.2649 14.8281 15.0459 15.0466C14.8274 15.2656 14.5619 15.3751 14.2494 15.3751H10.8744ZM3.74939 7.12512H7.12439V3.75012H3.74939V7.12512ZM10.8744 7.12512H14.2494V3.75012H10.8744V7.12512ZM10.8744 14.2501H14.2494V10.8751H10.8744V14.2501ZM3.74939 14.2501H7.12439V10.8751H3.74939V14.2501Z" fill="%234B5768"/>%0A</g>%0A</svg>%0A';
var ActiveItemName = ({
  name,
  iconUrl
}) => {
  return /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-x-1", children: [
    iconUrl && /* @__PURE__ */ jsx(
      "img",
      {
        src: iconUrl,
        onError: ({ currentTarget }) => {
          currentTarget.onerror = null;
          currentTarget.src = suites_default;
        },
        className: "w-4 h-4",
        alt: `${name} icon`
      }
    ),
    name
  ] });
};
var BugReportFieldDropdown = ({
  name = "",
  itemList,
  label,
  onChange,
  labelClassName = "",
  isRequired
}) => /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
  DropdownButton,
  {
    name: /* @__PURE__ */ jsx(
      ActiveItemName,
      {
        name,
        iconUrl: itemList.filter((m) => m.name == name)[0]?.iconUrl
      }
    ),
    placement: "bottom-start",
    label,
    labelClassName,
    dropdownClassName: "!min-h-[240px] !max-h-[240px] !overflow-auto",
    isRequired,
    children: itemList.map((item) => {
      return /* @__PURE__ */ jsx(
        DropdownItem,
        {
          onClick: () => onChange({ id: item.id, value: item.name }),
          className: "truncate",
          isSelected: name === item.name,
          children: /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-x-1", children: [
            item.iconUrl && /* @__PURE__ */ jsx(
              "img",
              {
                src: item.iconUrl,
                onError: ({ currentTarget }) => {
                  currentTarget.onerror = null;
                  currentTarget.src = suites_default;
                },
                className: "w-4 h-4",
                alt: `${item.name} icon`
              }
            ),
            item.name
          ] })
        },
        item.id
      );
    })
  }
) });
var BugReportFieldTextArea = ({
  label,
  value,
  onChange,
  isRequired
}) => {
  return /* @__PURE__ */ jsx(
    TextArea,
    {
      label,
      value,
      onChange,
      wrapperClassName: "w-full",
      className: "min-h-60 overflow-y-auto resize-y",
      isAutoSize: true,
      minHeight: 60,
      isRequired
    }
  );
};
var SearchIssueField = ({
  dataPromise,
  value,
  onSelect,
  loadingMsg,
  placeholder
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("hr", {}),
    /* @__PURE__ */ jsx(
      AutoComplete,
      {
        optionsHook: dataPromise,
        LoadingContent: /* @__PURE__ */ jsx(DropdownItem, { isSelected: false, children: loadingMsg }),
        onSelect: (selectedIssue) => onSelect(selectedIssue),
        placeholder,
        className: "mt-5 !z-50",
        showClearButton: false,
        inputClassName: "bg-secondary-50",
        inputContainerClassName: "!bg-secondary-50",
        label: t("bug_report.search_issue"),
        labelClassName: "text-2xs font-semibold",
        value,
        dropdownClass: "h-64 !overflow-auto"
      }
    )
  ] });
};
function BugReportFieldInput({
  label,
  value,
  onChange,
  isDisabled,
  className,
  isRequired
}) {
  useEffect(() => {
    InputCheck(value);
  }, []);
  const [isError, setIsError2] = useState(false);
  const InputCheck = (val) => {
    if (val?.length > 250) {
      setIsError2(true);
    } else {
      setIsError2(false);
    }
    onChange({ id: null, value: val });
  };
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx(
    Input,
    {
      label,
      value,
      onChange: (val) => onChange({ id: null, value: val }),
      isDisabled,
      wrapperClassName: className,
      isRequired,
      hasError: isError,
      errorText: t("agent.title_maxlength")
    }
  );
}
function BugReportFieldNumberInput({
  label,
  value,
  onChange,
  isDisabled,
  className,
  isRequired,
  min,
  max
}) {
  const [isError, setIsError2] = useState(false);
  const { t } = useTranslation();
  const handleChange = (val) => {
    if (!/^[-]?\d*\.?\d*$/.test(val) && val !== "") {
      setIsError2(true);
      return;
    }
    if (val !== "") {
      const num = Number(val);
      if (min !== void 0 && num < min || max !== void 0 && num > max) {
        setIsError2(true);
      } else {
        setIsError2(false);
      }
    } else {
      setIsError2(false);
    }
    onChange({ id: null, value: val });
  };
  let errorText = "";
  if (isError) {
    if (value !== "" && !/^[-]?\d*\.?\d*$/.test(value)) {
      errorText = t("bug_report.field.number.invalid");
    } else if (value !== "") {
      const num = Number(value);
      if (min !== void 0 && num < min) {
        errorText = t("bug_report.field.number.min_error", { min });
      } else if (max !== void 0 && num > max) {
        errorText = t("bug_report.field.number.max_error", { max });
      }
    }
  }
  return /* @__PURE__ */ jsx(
    Input,
    {
      label,
      value,
      type: "number",
      minValue: min !== void 0 ? String(min) : void 0,
      maxValue: max !== void 0 ? String(max) : void 0,
      onChange: handleChange,
      isDisabled,
      wrapperClassName: className,
      isRequired,
      hasError: isError,
      errorText
    }
  );
}
function BugReportFieldDateInput({
  label,
  value,
  onChange,
  isDisabled,
  className,
  isRequired,
  min,
  max
}) {
  const minValue = min || (/* @__PURE__ */ new Date()).toISOString().split("T")[0];
  return /* @__PURE__ */ jsx(
    Input,
    {
      label,
      value,
      type: "date",
      minValue,
      maxValue: max,
      onChange: (val) => onChange({ id: null, value: val }),
      isDisabled,
      wrapperClassName: className,
      isRequired
    }
  );
}
function BugReportFieldTimeInput({
  label,
  value,
  onChange,
  isDisabled,
  className,
  isRequired,
  min,
  max
}) {
  return /* @__PURE__ */ jsx(
    Input,
    {
      label,
      value,
      type: "time",
      minValue: min,
      maxValue: max,
      onChange: (val) => onChange({ id: null, value: val }),
      isDisabled,
      wrapperClassName: className,
      isRequired
    }
  );
}
function BugReportFieldDateTimeInput({
  label,
  value,
  onChange,
  isDisabled,
  className,
  isRequired
}) {
  return /* @__PURE__ */ jsx(
    Input,
    {
      label,
      value,
      type: "datetime-local",
      onChange: (val) => onChange({ id: null, value: val }),
      isDisabled,
      wrapperClassName: className,
      isRequired
    }
  );
}
function BugReportFieldUnsupported({
  label,
  fieldType,
  fieldKey,
  isRequired,
  className
}) {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs("div", { className: classNames82(className, "opacity-70"), children: [
    /* @__PURE__ */ jsxs("label", { className: "block text-sm font-medium text-secondary-700 mb-1", children: [
      label,
      " ",
      isRequired && /* @__PURE__ */ jsx("span", { className: "text-error-500", children: "*" })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "border border-dashed border-secondary-300 rounded-md p-3 bg-secondary-50", children: /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsx(
        Icon,
        {
          name: "info",
          className: "text-base text-secondary-400 flex-shrink-0"
        }
      ),
      /* @__PURE__ */ jsx("p", { className: "text-xs text-secondary-500", children: t("bug_report.field.unsupported", { fieldType, fieldKey }) })
    ] }) })
  ] });
}
function BugReportFieldTimeTracking({
  label,
  value,
  onChange,
  isDisabled,
  className,
  isRequired
}) {
  const { t } = useTranslation();
  const [originalEstimate, setOriginalEstimate] = useState(
    value?.originalEstimate || ""
  );
  const [remainingEstimate, setRemainingEstimate] = useState(
    value?.remainingEstimate || ""
  );
  const handleOriginalChange = (val) => {
    setOriginalEstimate(val);
    onChange({ originalEstimate: val, remainingEstimate });
  };
  const handleRemainingChange = (val) => {
    setRemainingEstimate(val);
    onChange({ originalEstimate, remainingEstimate: val });
  };
  return /* @__PURE__ */ jsxs("div", { className, children: [
    /* @__PURE__ */ jsxs("label", { className: "block text-sm font-medium text-secondary-700 mb-1", children: [
      label,
      " ",
      isRequired && /* @__PURE__ */ jsx("span", { className: "text-error-500", children: "*" })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "flex gap-2", children: [
      /* @__PURE__ */ jsx(
        Input,
        {
          label: t("bug_report.field.time_tracking.original_estimate"),
          value: originalEstimate,
          placeholder: t("bug_report.field.time_tracking.placeholder"),
          onChange: handleOriginalChange,
          isDisabled,
          wrapperClassName: "flex-1"
        }
      ),
      /* @__PURE__ */ jsx(
        Input,
        {
          label: t("bug_report.field.time_tracking.remaining_estimate"),
          value: remainingEstimate,
          placeholder: t("bug_report.field.time_tracking.placeholder"),
          onChange: handleRemainingChange,
          isDisabled,
          wrapperClassName: "flex-1"
        }
      )
    ] }),
    /* @__PURE__ */ jsx("p", { className: "text-xs text-secondary-500 mt-1", children: t("bug_report.field.time_tracking.format_hint") })
  ] });
}
function BugReportFieldLabels({
  label,
  value = [],
  onChange,
  onSearch,
  isDisabled,
  className,
  isRequired,
  placeholder
}) {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const defaultPlaceholder = placeholder || t("bug_report.field.labels.placeholder");
  const handleInputChange = async (val) => {
    setInputValue(val);
    if (onSearch && val.length >= 2) {
      try {
        const results = await onSearch(val);
        setSuggestions(results.filter((s) => !value.includes(s)));
      } catch {
        setSuggestions([]);
      }
    } else {
      setSuggestions([]);
    }
  };
  const addLabel = (labelToAdd) => {
    const trimmed = labelToAdd.trim();
    if (trimmed && !value.includes(trimmed)) {
      onChange([...value, trimmed]);
    }
    setInputValue("");
    setSuggestions([]);
  };
  const removeLabel = (labelToRemove) => {
    onChange(value.filter((l) => l !== labelToRemove));
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && inputValue.trim()) {
      e.preventDefault();
      addLabel(inputValue);
    }
  };
  return /* @__PURE__ */ jsxs("div", { className, children: [
    /* @__PURE__ */ jsxs("label", { className: "block text-sm font-medium text-secondary-700 mb-1", children: [
      label,
      " ",
      isRequired && /* @__PURE__ */ jsx("span", { className: "text-error-500", children: "*" })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "border border-secondary-300 rounded-md p-2 min-h-[40px] focus-within:border-primary-400 focus-within:ring-1 focus-within:ring-primary-400 transition-colors", children: [
      value.length > 0 && /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-1.5 mb-2", children: value.map((lbl) => /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-1", children: [
        /* @__PURE__ */ jsx("span", { className: "text-xs", children: lbl }),
        !isDisabled && /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            onClick: () => removeLabel(lbl),
            className: "flex items-center justify-center w-3.5 h-3.5 ml-0.5 text-secondary-500 hover:text-secondary-700 hover:bg-secondary-200 rounded transition-colors",
            "aria-label": t("bug_report.field.labels.remove", {
              label: lbl
            }),
            children: /* @__PURE__ */ jsx(Icon, { name: "close", className: "text-xs" })
          }
        )
      ] }, lbl)) }),
      /* @__PURE__ */ jsx(
        "input",
        {
          type: "text",
          value: inputValue,
          onChange: (e) => handleInputChange(e.target.value),
          onKeyDown: handleKeyDown,
          placeholder: defaultPlaceholder,
          disabled: isDisabled,
          className: "w-full border-none outline-none text-sm bg-transparent placeholder:text-secondary-400 focus:outline-none"
        }
      ),
      suggestions.length > 0 && /* @__PURE__ */ jsx("div", { className: "mt-1 border border-secondary-200 rounded-md bg-white shadow-sm max-h-32 overflow-auto", children: suggestions.map((suggestion) => /* @__PURE__ */ jsx(
        "button",
        {
          type: "button",
          onClick: () => addLabel(suggestion),
          className: "w-full text-left px-3 py-2 text-sm text-secondary-700 hover:bg-secondary-50 transition-colors",
          "aria-label": t("bug_report.field.labels.add", {
            label: suggestion
          }),
          children: suggestion
        },
        suggestion
      )) })
    ] })
  ] });
}
function BugReportFieldVersionSelect({
  label,
  value = [],
  versions = [],
  onChange,
  isDisabled,
  className,
  isRequired
}) {
  const { t } = useTranslation();
  const toggleVersion = (version) => {
    const exists = value.some((v) => v.id === version.id);
    if (exists) {
      onChange(value.filter((v) => v.id !== version.id));
    } else {
      onChange([...value, version]);
    }
  };
  if (versions.length === 0) {
    return /* @__PURE__ */ jsxs("div", { className, children: [
      /* @__PURE__ */ jsxs("label", { className: "block text-sm font-medium text-secondary-700 mb-1", children: [
        label,
        " ",
        isRequired && /* @__PURE__ */ jsx("span", { className: "text-error-500", children: "*" })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 py-2 text-secondary-500", children: [
        /* @__PURE__ */ jsx(Icon, { name: "info", className: "text-base" }),
        /* @__PURE__ */ jsx("p", { className: "text-sm", children: t("bug_report.field.version_select.no_versions") })
      ] })
    ] });
  }
  return /* @__PURE__ */ jsxs("div", { className, children: [
    /* @__PURE__ */ jsxs("label", { className: "block text-sm font-medium text-secondary-700 mb-1", children: [
      label,
      " ",
      isRequired && /* @__PURE__ */ jsx("span", { className: "text-error-500", children: "*" })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "border border-secondary-300 rounded-md p-2 max-h-48 overflow-auto focus-within:border-primary-400 focus-within:ring-1 focus-within:ring-primary-400 transition-colors", children: versions.map((version) => {
      const isSelected = value.some((v) => v.id === version.id);
      return /* @__PURE__ */ jsxs(
        "label",
        {
          className: classNames82(
            "flex items-center gap-2.5 px-2 py-2 cursor-pointer rounded-md transition-colors",
            {
              "hover:bg-secondary-50": !isDisabled,
              "opacity-50 cursor-not-allowed": isDisabled
            }
          ),
          children: [
            /* @__PURE__ */ jsx(
              Checkbox,
              {
                checked: isSelected,
                onChange: () => {
                  if (!isDisabled) {
                    toggleVersion(version);
                  }
                },
                type: "primary",
                className: "flex-shrink-0 h-4 w-4",
                isDisabled
              }
            ),
            /* @__PURE__ */ jsx("span", { className: "text-sm text-secondary-700 flex-1", children: version.name })
          ]
        },
        version.id
      );
    }) })
  ] });
}
var BugReportTitleField = ({ label, value, onChange }) => {
  return /* @__PURE__ */ jsx(
    BugReportFieldInput,
    {
      label,
      value,
      onChange,
      className: "w-full",
      isRequired: true
    },
    "title"
  );
};
var AzureBugReport = ({
  description,
  onUpdateTicketConfig: onUpdateTicketConfig2,
  appId,
  showLinkTo,
  summary
}) => {
  const [projects, setProjects] = useState([]);
  const [issueTypes, setIssueTypes] = useState([]);
  const [activeProject, setActiveProject] = useState(null);
  const [activeIssueType, setActiveIssueType] = useState(null);
  const [bugConfig, setBugConfig] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  useEffect(() => {
    loadProjects();
  }, []);
  const filteredProjects = useMemo(() => {
    if (searchTerm.trim() === "") {
      return projects;
    }
    return projects.filter(
      (project) => project.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [searchTerm, projects]);
  const loadProjects = () => {
    external_application_config_service_default.findAllAzureProjects(appId).then(
      (data) => {
        setProjects(data);
        if (data && data.length) {
          setActiveProject(data[0]);
          handleFieldValueChange("project", { value: data[0].name });
          loadIssueTypes(data[0].id);
        }
      }
    );
  };
  useEffect(() => {
    if (activeProject) {
      loadIssueTypes(activeProject.id);
    }
  }, [activeProject]);
  useEffect(() => {
    if (activeIssueType)
      setBugConfig({
        project: activeProject.name,
        issue_type_id: activeIssueType.name,
        title: summary,
        description
      });
  }, [activeIssueType]);
  useEffect(() => {
    onUpdateTicketConfig2({ ...bugConfig });
  }, [bugConfig]);
  const loadIssueTypes = (projectId) => {
    external_application_config_service_default.findAllAzureDevopsWorkItemsTypes(
      projectId
    ).then((data) => {
      const issueTypes2 = data.value.map(({ name }) => ({ id: name, name }));
      setIssueTypes(issueTypes2);
      setActiveIssueType(issueTypes2[0]);
    });
  };
  const handleProjectSelect = (item) => {
    setActiveProject(item);
    handleFieldValueChange("project", { value: item.name });
  };
  const handleIssueTypeSelect = ({ value }) => {
    setActiveIssueType(
      issueTypes.find((issueType) => issueType.name === value)
    );
    handleFieldValueChange("issue_type_id", { value });
  };
  const handleFieldValueChange = (key, value) => {
    setBugConfig({ ...bugConfig, [key]: value?.value ?? value });
  };
  const handleSelectIssue = (selectedIssue) => {
    onUpdateTicketConfig2({
      externalId: selectedIssue.id,
      linkToExisting: true,
      fields: { project: activeProject.name }
    });
  };
  const fetchAzureIssues = useCallback(
    async (ids) => {
      return external_application_config_service_default.findAzureIssues({
        appId,
        ids
      }).then((issues) => {
        const options3 = issues?.map((issue) => {
          return {
            id: issue.id,
            label: `${issue.fields?.["System.Title"]}`,
            disabled: false
          };
        });
        return options3 || [];
      });
    },
    [appId]
  );
  const issueFetchPromise = useCallback(
    (query) => new Promise((resolve) => {
      external_application_config_service_default.findAllAzureIssues({
        appId,
        issueType: activeIssueType?.name,
        project: activeProject?.name,
        searchTerm: query
      }).then(async (workItems) => {
        const ids = workItems?.map((item) => item.id);
        if (!ids?.length) {
          resolve([]);
        } else {
          const options3 = await fetchAzureIssues(ids);
          resolve(options3);
        }
      });
    }),
    [activeIssueType, activeProject, appId, fetchAzureIssues]
  );
  return /* @__PURE__ */ jsxs("div", { className: "grid gap-y-4", children: [
    /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-2 gap-x-12", children: [
      activeProject && /* @__PURE__ */ jsx(
        DropDownWithSearchAndPagination,
        {
          selectedItemDisplay: /* @__PURE__ */ jsx(
            TruncatedText,
            {
              value: activeProject?.name || "Select a project",
              className: "inline-block"
            }
          ),
          label: "Project",
          onSearch: setSearchTerm,
          items: filteredProjects,
          selectedItem: activeProject,
          onSelectItem: handleProjectSelect,
          renderItem: (item) => /* @__PURE__ */ jsx(TruncatedText, { value: item?.name, className: "inline-block" }),
          isLoading: false,
          hasMore: false,
          loadMore: () => {
          },
          totalPages: 0
        }
      ),
      activeIssueType && /* @__PURE__ */ jsx(
        BugReportFieldDropdown,
        {
          name: activeIssueType.name,
          label: "Issue Type",
          itemList: issueTypes.map((issueType) => ({
            id: issueType.name,
            name: issueType.name
          })),
          onChange: handleIssueTypeSelect,
          labelClassName: "mb-1"
        }
      )
    ] }),
    showLinkTo && activeIssueType && activeProject ? /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
      SearchIssueField,
      {
        loadingMsg: "Loading Azure issues",
        placeholder: "Azure issues",
        onSelect: handleSelectIssue,
        dataPromise: issueFetchPromise,
        value: null
      }
    ) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        BugReportTitleField,
        {
          label: "Title",
          value: bugConfig["title"] || summary || "",
          onChange: (changedDataPayload) => handleFieldValueChange("title", changedDataPayload)
        }
      ),
      /* @__PURE__ */ jsx(
        BugReportFieldTextArea,
        {
          label: "Description",
          onChange: (changedDataPayload) => handleFieldValueChange("description", changedDataPayload),
          value: bugConfig["description"] || description || ""
        }
      )
    ] })
  ] });
};
var azure_bug_report_default = AzureBugReport;
var BacklogBugReport = ({
  description,
  onUpdateTicketConfig: onUpdateTicketConfig2,
  appId,
  showLinkTo,
  summary
}) => {
  const [projects, setProjects] = useState([]);
  const [activeProject, setActiveProject] = useState(null);
  const [issueTypes, setIssueTypes] = useState([]);
  const [activeIssueType, setActiveIssueType] = useState(null);
  const [priorities, setPriorities] = useState([]);
  const [activePriority, setActivePriority] = useState(null);
  const [bugConfig, setBugConfig] = useState({});
  useEffect(() => {
    loadProjects();
    loadPriorities();
  }, []);
  const loadProjects = () => {
    external_application_config_service_default.findAllBacklogProjects(appId).then(
      (data) => {
        setProjects(data);
        if (data && data.length) {
          const firstProject = data[0];
          setActiveProject(firstProject);
        }
      }
    );
  };
  useEffect(() => {
    onUpdateTicketConfig2({ ...bugConfig });
  }, [bugConfig]);
  useEffect(() => {
    handleFieldValueChange("summary", { value: summary });
  }, [summary]);
  useEffect(() => {
    if (activeProject) {
      handleFieldValueChange("projectId", { value: activeProject.id });
      loadIssueTypes(activeProject.id);
    }
  }, [activeProject]);
  const loadIssueTypes = (projectId) => {
    external_application_config_service_default.findAllBacklogIssueTypes({
      appId,
      projectId
    }).then((data) => {
      setIssueTypes(data);
      setActiveIssueType(data[0]);
      handleFieldValueChange("issueTypeId", { value: data[0]?.id });
    });
  };
  const loadPriorities = () => {
    external_application_config_service_default.findAllBacklogPriorities({ appId }).then(
      (data) => {
        setPriorities(data);
        setActivePriority(data[0]);
        handleFieldValueChange("priorityId", { value: data[0]?.id });
      }
    );
  };
  const handleProjectSelect = ({ id }) => {
    setActiveProject(projects.find((project) => project.id === id));
  };
  const handleIssueTypeSelect = ({ id }) => {
    setActiveIssueType(issueTypes.find((issueType) => issueType.id === id));
    handleFieldValueChange("issueTypeId", { value: id });
  };
  const handleFieldValueChange = (key, value) => {
    setBugConfig({ ...bugConfig, [key]: value?.value ?? value });
  };
  const handleSelectIssue = (selectedIssue) => {
    onUpdateTicketConfig2({
      externalId: selectedIssue.id,
      linkToExisting: true
    });
  };
  const handlePrioritySelect = (selectedPriority) => {
    setActivePriority(priorities.find(({ id }) => id === selectedPriority.id));
    handleFieldValueChange("priorityId", { value: selectedPriority.id });
  };
  const backlogIssuePromise = useCallback(
    (query) => new Promise((resolve) => {
      external_application_config_service_default.findAllBacklogIssues({
        appId,
        projectId: activeProject?.id,
        issueTypeId: activeIssueType?.id,
        searchTerm: query,
        priorityId: activePriority?.id
      }).then((backlogIssues) => {
        const options3 = backlogIssues.map(
          (backlogIssue) => {
            return {
              id: backlogIssue.id,
              label: `[${backlogIssue.issueKey}] ${backlogIssue.summary}`,
              disabled: false
            };
          }
        );
        resolve(options3);
      }).catch(NOOP);
    }),
    [activeProject, activeIssueType, activePriority]
  );
  return /* @__PURE__ */ jsxs("div", { className: "grid gap-y-4", children: [
    /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-2 gap-x-12", children: [
      activeProject && /* @__PURE__ */ jsx(
        BugReportFieldDropdown,
        {
          name: activeProject.name,
          label: "Project",
          itemList: projects.map((project) => ({
            name: `[${project.projectKey}] ${project.name}`,
            id: project.id
          })),
          onChange: handleProjectSelect
        }
      ),
      activeIssueType && /* @__PURE__ */ jsx(
        BugReportFieldDropdown,
        {
          name: activeIssueType.name,
          label: "Issue Type",
          itemList: issueTypes.map((issueType) => ({
            name: issueType.name,
            id: issueType.id
          })),
          onChange: handleIssueTypeSelect
        }
      ),
      activePriority && /* @__PURE__ */ jsx(
        BugReportFieldDropdown,
        {
          name: activePriority.name,
          label: "Priority",
          itemList: priorities.map((priority) => ({
            name: priority.name,
            id: priority.id
          })),
          onChange: handlePrioritySelect
        }
      )
    ] }),
    showLinkTo && activeProject && activeIssueType && activePriority ? /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
      SearchIssueField,
      {
        loadingMsg: "Loading backlog issues",
        placeholder: "Backlog Issues",
        onSelect: handleSelectIssue,
        dataPromise: backlogIssuePromise,
        value: null
      }
    ) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        BugReportTitleField,
        {
          label: "Title",
          value: bugConfig["summary"],
          onChange: (changedDataPayload) => handleFieldValueChange("summary", changedDataPayload)
        }
      ),
      /* @__PURE__ */ jsx(
        BugReportFieldTextArea,
        {
          label: "Description",
          onChange: (changedDataPayload) => handleFieldValueChange("description", changedDataPayload),
          value: bugConfig["description"] || description || ""
        }
      )
    ] })
  ] });
};
var backlog_bug_report_default = BacklogBugReport;
var BugReportFooter = ({
  onCancel,
  onCreate,
  onLinkTo,
  showLinkTo,
  isError = false,
  isCreatingTicket = false,
  isLinking = false,
  ticketId = ""
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs("div", { className: "flex items-center sticky bottom-0 bg-surface-light justify-end gap-x-3 py-3 px-8", children: [
    /* @__PURE__ */ jsx(Button, { type: "light", onClick: onCancel, children: t("common.cancel") }),
    showLinkTo ? /* @__PURE__ */ jsx(
      Button,
      {
        type: "primary",
        onClick: onLinkTo,
        isLoading: isLinking,
        isDisabled: !ticketId,
        children: t("bug_report.link_to_ticket")
      }
    ) : /* @__PURE__ */ jsx(
      Button,
      {
        type: "primary",
        onClick: onCreate,
        isDisabled: isError,
        isLoading: isCreatingTicket,
        children: t("common.report-bug")
      }
    )
  ] });
};
var bug_report_footer_default = BugReportFooter;
function useOpenUrl() {
  const { openExternalUrl, serverUrl } = useRecorderContext();
  return useCallback(
    (url) => {
      const resolvedUrl = openExternalUrl && serverUrl && url.startsWith("/") ? `${serverUrl.replace(/\/$/, "")}${url}` : url;
      if (openExternalUrl) {
        openExternalUrl(resolvedUrl);
      } else {
        window.open(resolvedUrl, "_blank");
      }
    },
    [openExternalUrl, serverUrl]
  );
}
var { Tabs } = V2;
var TAB_OPTIONS = [
  { label: "Create New", value: "create" },
  { label: "Link To Issue", value: "link" }
];
var ExternalAppItem = ({
  externalApp
}) => {
  return /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-center min-w-[6rem]", children: [
    /* @__PURE__ */ jsx("div", { className: "flex items-center", children: /* @__PURE__ */ jsx(
      "img",
      {
        src: externalApp.iconUrl,
        height: 24,
        width: 24,
        className: "object-contain",
        alt: externalApp.name
      }
    ) }),
    /* @__PURE__ */ jsx(
      TruncatedText,
      {
        value: externalApp.name,
        className: "text-sm text-secondary-unique-600 font-medium ml-2"
      }
    )
  ] });
};
var BugReportHeader = ({
  externalApps,
  activeApp,
  onChangeApp,
  onClickLinkTo,
  isLinkToEnabled,
  onClickCreateNew
}) => {
  const { t } = useTranslation();
  const openUrl = useOpenUrl();
  const handleTabChange = (tab) => {
    if (tab === "create") {
      onClickCreateNew();
    } else {
      onClickLinkTo();
    }
  };
  return /* @__PURE__ */ jsxs("div", { className: "flex items-center font-medium justify-between py-4 px-8 sticky top-0 bg-white z-10", children: [
    /* @__PURE__ */ jsx(
      Tabs,
      {
        activeTab: isLinkToEnabled ? "link" : "create",
        onChangeTab: handleTabChange,
        tabs: TAB_OPTIONS,
        className: "!bg-[#f7f8f9] whitespace-nowrap flex-shrink-0",
        tabClassName: "min-w-[110px] !text-sm"
      }
    ),
    /* @__PURE__ */ jsxs(
      DropdownButton,
      {
        name: /* @__PURE__ */ jsx(ExternalAppItem, { externalApp: activeApp }),
        placement: "bottom-start",
        className: "!bg-white !border !border-[#CBD5E1] !rounded-md !px-3 !py-1.5 !w-fit flex-shrink-0 ml-auto",
        children: [
          externalApps.map((externalApp) => /* @__PURE__ */ jsx(
            DropdownItem,
            {
              onClick: () => onChangeApp(externalApp),
              className: "truncate",
              isSelected: activeApp.id === externalApp.id,
              children: /* @__PURE__ */ jsx(ExternalAppItem, { externalApp })
            },
            externalApp.id
          )),
          /* @__PURE__ */ jsx(
            DropdownItem,
            {
              className: "truncate",
              onClick: () => openUrl("/ui/settings/plugs"),
              children: /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-center", children: [
                /* @__PURE__ */ jsx(
                  Icon,
                  {
                    name: "add",
                    className: "text-xl font-semibold items-center mr-1"
                  }
                ),
                /* @__PURE__ */ jsx("span", { className: "text-sm text-secondary-unique-600 font-medium", children: t("common.add_new.label") })
              ] })
            }
          )
        ]
      }
    )
  ] });
};
var bug_report_header_default = BugReportHeader;
var BugZillaBugReport = ({
  description,
  onUpdateTicketConfig: onUpdateTicketConfig2,
  appId,
  showLinkTo,
  summary
}) => {
  const [projects, setProjects] = useState([]);
  const [activeProject, setActiveProject] = useState(null);
  const [bugConfig, setBugConfig] = useState({});
  useEffect(() => {
    loadProjects();
  }, []);
  const loadProjects = () => {
    external_application_config_service_default.findAllBugzillaProjects(appId).then(
      (data) => {
        setProjects(data);
        if (data && data.length) {
          setActiveProject(data[0]);
          handleFieldValueChange("project", { value: data[0]?.name });
        }
      }
    );
  };
  useEffect(() => {
    if (activeProject) {
      const firstIssueType = activeProject.issueTypes[0];
      const firstVersion = activeProject.versions[0];
      setBugConfig((oldConfig) => {
        oldConfig["project"] = activeProject.name;
        oldConfig["issueType"] = firstIssueType.name;
        oldConfig["version"] = firstVersion.name;
        return { ...oldConfig };
      });
    }
  }, [activeProject]);
  useEffect(() => {
    onUpdateTicketConfig2({ ...bugConfig });
  }, [bugConfig]);
  useEffect(
    () => handleFieldValueChange("summary", { value: summary }),
    [summary]
  );
  useEffect(
    () => handleFieldValueChange("description", { value: description }),
    [description]
  );
  const handleProjectSelect = ({ id }) => {
    const selectedProject = projects.find((project) => project.id === id);
    setActiveProject(selectedProject);
    handleFieldValueChange("project", { value: selectedProject?.name });
  };
  const handleFieldValueChange = (key, value) => {
    setBugConfig({ ...bugConfig, [key]: value?.value ?? value });
  };
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", { className: "grid gap-y-4", children: [
    /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-2 gap-x-12", children: [
      activeProject && /* @__PURE__ */ jsx(
        BugReportFieldDropdown,
        {
          name: activeProject.name,
          label: "Project",
          itemList: projects.map((project) => ({
            name: project.name,
            id: project.id
          })),
          onChange: handleProjectSelect
        }
      ),
      activeProject && /* @__PURE__ */ jsx(
        BugReportFieldDropdown,
        {
          name: bugConfig["issueType"] || activeProject.issueTypes[0].name,
          label: "Issue Type",
          itemList: activeProject.issueTypes.map((issueType) => ({
            name: issueType.name,
            id: issueType.id
          })),
          onChange: (changedDataPayload) => handleFieldValueChange("issueType", changedDataPayload)
        }
      ),
      activeProject && /* @__PURE__ */ jsx(
        BugReportFieldDropdown,
        {
          name: bugConfig["version"] || activeProject.versions[0].name,
          label: "Version",
          itemList: activeProject.versions.map((version) => ({
            name: version.name,
            id: version.id
          })),
          onChange: (changedDataPayload) => handleFieldValueChange("version", changedDataPayload)
        }
      )
    ] }),
    showLinkTo ? /* @__PURE__ */ jsx(Fragment, { children: "Yet to do" }) : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        BugReportTitleField,
        {
          label: "Title",
          value: bugConfig["summary"] || summary || "",
          onChange: (changedDataPayload) => handleFieldValueChange("summary", changedDataPayload)
        }
      ),
      /* @__PURE__ */ jsx(
        BugReportFieldTextArea,
        {
          label: "Description",
          onChange: (changedDataPayload) => handleFieldValueChange("description", changedDataPayload),
          value: bugConfig["description"] || description || ""
        }
      )
    ] })
  ] }) });
};
var bugzilla_bug_report_default = BugZillaBugReport;
var ClickUpBugReport = ({
  description,
  onUpdateTicketConfig: onUpdateTicketConfig2,
  appId,
  showLinkTo,
  summary
}) => {
  const [teams, setTeams] = useState([]);
  const [spaces, setSpaces] = useState([]);
  const [folders, setFolders] = useState([]);
  const [lists, setLists] = useState([]);
  const [activeTeam, setActiveTeam] = useState(null);
  const [activeSpace, setActiveSpace] = useState(null);
  const [activeFolder, setActiveFolder] = useState(null);
  const [activeList, setActiveList] = useState(null);
  const [bugConfig, setBugConfig] = useState({});
  useEffect(() => {
    loadTeams();
  }, []);
  useEffect(() => {
    onUpdateTicketConfig2({ ...bugConfig });
  }, [bugConfig]);
  useEffect(() => {
    if (activeTeam) loadSpaces(activeTeam.id);
  }, [activeTeam]);
  useEffect(() => {
    if (activeSpace) loadFolders(activeSpace.id);
  }, [activeSpace]);
  useEffect(() => {
    if (activeFolder) loadLists(activeFolder.id);
  }, [activeFolder]);
  useEffect(() => {
    if (activeList) {
      handleFieldValueChange("listId", { value: activeList.id });
    }
  }, [activeList]);
  useEffect(
    () => handleFieldValueChange("title", { value: summary }),
    [summary]
  );
  useEffect(
    () => handleFieldValueChange("description", { value: description }),
    [description]
  );
  const loadTeams = () => {
    external_application_config_service_default.findAllClickUpTeams(appId).then(
      (data) => {
        setTeams(data);
        if (data && data.length) {
          const firstTeam = data[0];
          setActiveTeam(firstTeam);
        }
      }
    );
  };
  const loadSpaces = (teamId) => {
    external_application_config_service_default.findAllClickUpSpaces({
      appId,
      teamId
    }).then((data) => {
      setSpaces(data);
      if (data && data.length) {
        const firstSpace = data[0];
        setActiveSpace(firstSpace);
      }
    });
  };
  const loadFolders = (spaceId) => {
    external_application_config_service_default.findAllClickUpFolders({
      appId,
      spaceId
    }).then((data) => {
      setFolders(data);
      if (data && data.length) {
        const firstFolder = data[0];
        setActiveFolder(firstFolder);
      }
    });
  };
  const loadLists = (folderId) => {
    external_application_config_service_default.findAllClickUpLists({
      appId,
      folderId
    }).then((data) => {
      setLists(data);
      if (data && data.length) {
        const firstList = data[0];
        setActiveList(firstList);
        handleFieldValueChange("activeList", { value: firstList?.id });
      }
    });
  };
  const handleTeamSelect = ({ id }) => {
    setActiveTeam(teams.find((team) => team.id === id));
  };
  const handleSpaceSelect = ({ id }) => {
    setActiveSpace(spaces.find((space) => space.id === id));
  };
  const handleFolderSelect = ({ id }) => {
    setActiveFolder(folders.find((folder) => folder.id === id));
  };
  const handleListSelect = ({ id }) => {
    const selectedList = lists.find((list) => list.id === id);
    setActiveList(selectedList);
    handleFieldValueChange("activeList", { value: selectedList?.id });
  };
  const handleSelectIssue = (selectedIssue) => {
    onUpdateTicketConfig2({
      externalId: selectedIssue.id,
      linkToExisting: true,
      fields: {
        listId: activeList.id
      }
    });
  };
  const handleFieldValueChange = (key, value) => {
    setBugConfig({ ...bugConfig, [key]: value?.value ?? value });
  };
  const issuePromise = useCallback(
    () => new Promise((resolve) => {
      external_application_config_service_default.findAllClickUpTasks({
        appId,
        listId: activeList.id
      }).then((clickupTasks) => {
        const options3 = clickupTasks.map((task) => {
          return {
            id: task.id,
            label: task.name,
            disabled: false
          };
        });
        resolve(options3);
      }).catch(NOOP);
    }),
    [activeList]
  );
  return /* @__PURE__ */ jsxs("div", { className: "grid gap-y-4", children: [
    /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-2 gap-x-12", children: [
      activeTeam && /* @__PURE__ */ jsx(
        BugReportFieldDropdown,
        {
          name: activeTeam.name,
          label: "Team",
          itemList: teams.map((team) => ({
            name: team.name,
            id: team.id
          })),
          onChange: handleTeamSelect
        }
      ),
      activeSpace && /* @__PURE__ */ jsx(
        BugReportFieldDropdown,
        {
          name: activeSpace.name,
          label: "Space",
          itemList: spaces.map((space) => ({
            name: space.name,
            id: space.id
          })),
          onChange: handleSpaceSelect
        }
      ),
      activeFolder && /* @__PURE__ */ jsx(
        BugReportFieldDropdown,
        {
          name: activeFolder.name,
          label: "Folder",
          itemList: folders.map((folder) => ({
            name: folder.name,
            id: folder.id
          })),
          onChange: handleFolderSelect
        }
      ),
      activeList && /* @__PURE__ */ jsx(
        BugReportFieldDropdown,
        {
          name: activeList.name,
          label: "List",
          itemList: lists.map((list) => ({
            name: list.name,
            id: list.id
          })),
          onChange: handleListSelect
        }
      )
    ] }),
    showLinkTo && activeList ? /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
      SearchIssueField,
      {
        loadingMsg: "Loading clickup tasks",
        placeholder: "Clickup tasks",
        onSelect: handleSelectIssue,
        dataPromise: issuePromise,
        value: null
      }
    ) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        BugReportTitleField,
        {
          label: "Title",
          value: bugConfig["title"] || summary || "",
          onChange: (changedDataPayload) => handleFieldValueChange("title", changedDataPayload)
        }
      ),
      /* @__PURE__ */ jsx(
        BugReportFieldTextArea,
        {
          label: "Description",
          onChange: (value) => handleFieldValueChange("description", { value }),
          value: bugConfig["description"] || description || ""
        }
      )
    ] })
  ] });
};
var clickup_bug_report_default = ClickUpBugReport;
var AttachmentsSection = ({
  attachments,
  onRemoveAttachment,
  onAddStepScreenshots,
  onUploadFiles,
  className,
  showStepScreenshotsButton = true,
  includeVideo = false,
  onIncludeVideoChange,
  showVideoCheckbox = false,
  includeLogs = false,
  onIncludeLogsChange,
  showLogsCheckbox = false
}) => {
  const { t } = useTranslation();
  const hasAttachments = attachments.length > 0;
  return /* @__PURE__ */ jsxs("div", { className: classNames82("flex flex-col gap-3", className), children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ jsx("span", { className: "text-sm font-medium text-secondary-700", children: t("bug_report.attachments") }),
      /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-4", children: [
        showVideoCheckbox && onIncludeVideoChange && /* @__PURE__ */ jsx(
          Checkbox,
          {
            checked: includeVideo,
            onChange: onIncludeVideoChange,
            label: t("bug_report.include_test_execution_video")
          }
        ),
        showLogsCheckbox && onIncludeLogsChange && /* @__PURE__ */ jsx(
          Checkbox,
          {
            checked: includeLogs,
            onChange: onIncludeLogsChange,
            label: t("bug_report.include_test_execution_logs")
          }
        )
      ] })
    ] }),
    hasAttachments && /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-2", children: attachments.map((attachment) => /* @__PURE__ */ jsx(
      AttachmentPill,
      {
        attachment,
        onRemove: () => onRemoveAttachment(attachment.id)
      },
      attachment.id
    )) }),
    /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-4", children: [
      showStepScreenshotsButton && /* @__PURE__ */ jsxs(
        "button",
        {
          type: "button",
          onClick: onAddStepScreenshots,
          className: "flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors",
          children: [
            /* @__PURE__ */ jsx(Icon, { name: "add", className: "text-xl" }),
            /* @__PURE__ */ jsx("span", { children: t("bug_report.add_step_screenshots") })
          ]
        }
      ),
      /* @__PURE__ */ jsxs(
        "button",
        {
          type: "button",
          onClick: onUploadFiles,
          className: "flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors",
          children: [
            /* @__PURE__ */ jsx(Icon, { name: "upload", className: "text-base" }),
            /* @__PURE__ */ jsx("span", { children: t("bug_report.upload_files") })
          ]
        }
      )
    ] })
  ] });
};
var AttachmentPill = ({ attachment, onRemove }) => {
  const { t } = useTranslation();
  const isImage = attachment.type.startsWith("image/") || attachment.isStepScreenshot;
  return /* @__PURE__ */ jsxs("div", { className: "inline-flex items-center gap-2 px-3 py-2 bg-secondary-50 border border-secondary-200 rounded-md", children: [
    /* @__PURE__ */ jsx("div", { className: "flex items-center justify-center w-5 h-5 text-secondary-500", children: isImage ? /* @__PURE__ */ jsx(Icon, { name: "photo", className: "text-base" }) : /* @__PURE__ */ jsx(Icon, { name: "description", className: "text-base" }) }),
    /* @__PURE__ */ jsx("span", { className: "text-sm text-secondary-700 max-w-[200px] truncate", children: attachment.name }),
    /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        onClick: onRemove,
        className: "flex items-center justify-center w-5 h-5 text-secondary-400 hover:text-secondary-600 transition-colors",
        "aria-label": t("bug_report.attachment.remove", {
          name: attachment.name
        }),
        children: /* @__PURE__ */ jsx(Icon, { name: "close", className: "text-base" })
      }
    )
  ] });
};
var attachments_section_default = AttachmentsSection;

// src/components/bug-report/components/attachments/types.ts
var ALLOWED_FILE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
];
var ALLOWED_EXTENSIONS = [".jpeg", ".jpg", ".png", ".docx", ".pdf"];
var MAX_FILE_SIZE_MB = 100;
var MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
var useAttachments = ({
  stepResults = [],
  testCaseResultId,
  onAttachmentsChange,
  setHideBugReportHeader,
  initialAttachments = [],
  initialSelectedSteps = [],
  initialResetKey
} = {}) => {
  const [attachments, setAttachments] = useState([]);
  const hasAppliedInitialRef = useRef(false);
  const lastResetKeyRef = useRef(initialResetKey);
  useEffect(() => {
    if (initialResetKey !== lastResetKeyRef.current) {
      lastResetKeyRef.current = initialResetKey;
      hasAppliedInitialRef.current = false;
    }
    if (hasAppliedInitialRef.current || initialAttachments?.length === 0 && initialSelectedSteps?.length === 0) {
      return;
    }
    hasAppliedInitialRef.current = true;
    setAttachments(initialAttachments);
    setSelectedSteps(initialSelectedSteps);
  }, [initialAttachments, initialSelectedSteps, initialResetKey]);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [isStepScreenshotsModalOpen, setIsStepScreenshotsModalOpen] = useState(false);
  const [pendingFiles, setPendingFiles] = useState([]);
  const [selectedSteps, setSelectedSteps] = useState([]);
  const [includeVideo, setIncludeVideo] = useState(false);
  const [includeLogs, setIncludeLogs] = useState(false);
  const getDescriptionString = (step) => {
    const desc = step.stepDisplaySentence || step.stepDetails || "";
    return typeof desc === "string" ? desc : String(desc || "");
  };
  const stepScreenshots = useMemo(() => {
    return stepResults.filter((step) => step.screenshotName).map((step) => ({
      stepNumber: Number(step.stepNumber) || 0,
      stepResult: step,
      description: getDescriptionString(step),
      screenshotUrl: testCaseResultId ? `/api/test_step_results/step_result_asset/${testCaseResultId}/${step.screenshotName}/STEP` : "",
      selected: selectedSteps.includes(Number(step.stepNumber) || 0)
    }));
  }, [stepResults, testCaseResultId, selectedSteps]);
  const notifyChange = useCallback(
    (newAttachments, newSelectedSteps, newIncludeVideo, newIncludeLogs) => {
      if (onAttachmentsChange) {
        const selectedScreenshots = stepResults.filter(
          (step) => newSelectedSteps.includes(Number(step.stepNumber) || 0)
        ).filter((step) => step.screenshotName).map((step) => ({
          stepNumber: Number(step.stepNumber) || 0,
          stepResult: step,
          description: getDescriptionString(step),
          screenshotUrl: testCaseResultId ? `/api/test_step_results/step_result_asset/${testCaseResultId}/${step.screenshotName}/STEP` : "",
          selected: true
        }));
        const hasScreenshots = newAttachments.length > 0 || selectedScreenshots.length > 0;
        onAttachmentsChange({
          files: newAttachments,
          stepScreenshots: selectedScreenshots,
          includeVideo: newIncludeVideo !== void 0 ? newIncludeVideo : includeVideo,
          includeLogs: newIncludeLogs !== void 0 ? newIncludeLogs : includeLogs,
          // Screenshots are included if user has selected any (manual uploads or step screenshots)
          includeScreenshots: hasScreenshots
        });
      }
    },
    [
      onAttachmentsChange,
      stepResults,
      testCaseResultId,
      includeVideo,
      includeLogs
    ]
  );
  const openUploadModal = useCallback(() => {
    setPendingFiles([]);
    setIsUploadModalOpen(true);
    setHideBugReportHeader?.(true);
  }, [setHideBugReportHeader]);
  const closeUploadModal = useCallback(() => {
    setPendingFiles([]);
    setIsUploadModalOpen(false);
    setHideBugReportHeader?.(false);
  }, [setHideBugReportHeader]);
  const openStepScreenshotsModal = useCallback(() => {
    setIsStepScreenshotsModalOpen(true);
    setHideBugReportHeader?.(true);
  }, [setHideBugReportHeader]);
  const closeStepScreenshotsModal = useCallback(() => {
    setIsStepScreenshotsModalOpen(false);
    setHideBugReportHeader?.(false);
  }, [setHideBugReportHeader]);
  const addPendingFiles = useCallback((files) => {
    setPendingFiles((prev) => {
      const existingNames = new Set(prev.map((f) => f.name));
      const newFiles = files.filter((f) => !existingNames.has(f.name));
      return [...prev, ...newFiles];
    });
  }, []);
  const removePendingFile = useCallback((fileId) => {
    setPendingFiles((prev) => prev.filter((f) => f.id !== fileId));
  }, []);
  const confirmUpload = useCallback(() => {
    setAttachments((prev) => {
      const existingNames = new Set(prev.map((f) => f.name));
      const newFiles = pendingFiles.filter((f) => !existingNames.has(f.name));
      const updated = [...prev, ...newFiles];
      notifyChange(updated, selectedSteps);
      return updated;
    });
    setPendingFiles([]);
    setIsUploadModalOpen(false);
    setHideBugReportHeader?.(false);
  }, [pendingFiles, selectedSteps, notifyChange, setHideBugReportHeader]);
  const handleSetIncludeVideo = useCallback(
    (include) => {
      setIncludeVideo(include);
      notifyChange(attachments, selectedSteps, include);
    },
    [attachments, selectedSteps, notifyChange]
  );
  const handleSetIncludeLogs = useCallback(
    (include) => {
      setIncludeLogs(include);
      notifyChange(attachments, selectedSteps, void 0, include);
    },
    [attachments, selectedSteps, notifyChange]
  );
  const removeAttachment = useCallback(
    (fileId) => {
      setAttachments((prev) => {
        const updated = prev.filter((f) => f.id !== fileId);
        notifyChange(updated, selectedSteps);
        return updated;
      });
    },
    [selectedSteps, notifyChange]
  );
  const toggleStepSelection = useCallback((stepNumber) => {
    setSelectedSteps((prev) => {
      if (prev.includes(stepNumber)) {
        return prev.filter((n) => n !== stepNumber);
      }
      return [...prev, stepNumber];
    });
  }, []);
  const confirmStepScreenshots = useCallback(() => {
    const newScreenshotAttachments = selectedSteps.map((stepNum) => {
      const step = stepResults.find((s) => Number(s.stepNumber) === stepNum);
      if (!step || !step.screenshotName) return null;
      return {
        id: `step-screenshot-${stepNum}-${Date.now()}`,
        name: `step-${stepNum}-screenshot.png`,
        type: "image/png",
        size: 0,
        isStepScreenshot: true,
        stepResultId: step.id,
        url: testCaseResultId ? `/api/test_step_results/step_result_asset/${testCaseResultId}/${step.screenshotName}/STEP` : ""
      };
    }).filter((f) => f !== null);
    setAttachments((prev) => {
      const nonScreenshots = prev.filter((f) => !f.isStepScreenshot);
      const updated = [...nonScreenshots, ...newScreenshotAttachments];
      notifyChange(updated, selectedSteps);
      return updated;
    });
    setIsStepScreenshotsModalOpen(false);
    setHideBugReportHeader?.(false);
  }, [
    selectedSteps,
    stepResults,
    testCaseResultId,
    notifyChange,
    setHideBugReportHeader
  ]);
  const getPayload = useCallback(() => {
    const selectedScreenshots = stepResults.filter((step) => selectedSteps.includes(Number(step.stepNumber) || 0)).filter((step) => step.screenshotName).map((step) => ({
      stepNumber: Number(step.stepNumber) || 0,
      stepResult: step,
      description: getDescriptionString(step),
      screenshotUrl: testCaseResultId ? `/api/test_step_results/step_result_asset/${testCaseResultId}/${step.screenshotName}/STEP` : "",
      selected: true
    }));
    const hasScreenshots = attachments.length > 0 || selectedScreenshots.length > 0;
    return {
      files: attachments,
      stepScreenshots: selectedScreenshots,
      includeVideo,
      includeLogs,
      includeScreenshots: hasScreenshots
    };
  }, [
    attachments,
    selectedSteps,
    stepResults,
    testCaseResultId,
    includeVideo,
    includeLogs
  ]);
  const clearAll = useCallback(() => {
    setAttachments([]);
    setSelectedSteps([]);
    setPendingFiles([]);
    setIncludeVideo(false);
    setIncludeLogs(false);
    notifyChange([], [], false, false);
  }, [notifyChange]);
  return {
    attachments,
    stepScreenshots,
    isUploadModalOpen,
    isStepScreenshotsModalOpen,
    pendingFiles,
    selectedSteps,
    includeVideo,
    includeLogs,
    openUploadModal,
    closeUploadModal,
    openStepScreenshotsModal,
    closeStepScreenshotsModal,
    addPendingFiles,
    removePendingFile,
    confirmUpload,
    removeAttachment,
    toggleStepSelection,
    confirmStepScreenshots,
    setIncludeVideo: handleSetIncludeVideo,
    setIncludeLogs: handleSetIncludeLogs,
    getPayload,
    clearAll
  };
};
var processFiles = async (fileList) => {
  const files = Array.from(fileList);
  const processedFiles = [];
  for (const file of files) {
    if (!ALLOWED_FILE_TYPES.includes(file.type)) {
      continue;
    }
    if (file.size > MAX_FILE_SIZE_BYTES) {
      continue;
    }
    const base64 = await new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(file);
    });
    processedFiles.push({
      id: `file-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      name: file.name,
      type: file.type,
      size: file.size,
      file,
      base64
    });
  }
  return processedFiles;
};
var UploadAttachmentsModal = ({
  onClose,
  pendingFiles,
  onAddFiles,
  onRemoveFile,
  onConfirm
}) => {
  const fileInputRef = useRef(null);
  const [isDragOver, setIsDragOver] = useState(false);
  const [error, setError] = useState("");
  const handleFileSelect = useCallback(
    async (event) => {
      const files = event.target.files;
      if (!files) return;
      setError("");
      const processedFiles = await processFiles(files);
      if (processedFiles.length === 0 && files.length > 0) {
        setError("Some files were skipped due to invalid type or size.");
      }
      onAddFiles(processedFiles);
      event.target.value = "";
    },
    [onAddFiles]
  );
  const handleDrop = useCallback(
    async (event) => {
      event.preventDefault();
      setIsDragOver(false);
      setError("");
      const files = event.dataTransfer.files;
      if (!files) return;
      const processedFiles = await processFiles(files);
      if (processedFiles.length === 0 && files.length > 0) {
        setError("Some files were skipped due to invalid type or size.");
      }
      onAddFiles(processedFiles);
    },
    [onAddFiles]
  );
  const handleDragOver = useCallback(
    (event) => {
      event.preventDefault();
      setIsDragOver(true);
    },
    []
  );
  const handleDragLeave = useCallback(
    (event) => {
      event.preventDefault();
      setIsDragOver(false);
    },
    []
  );
  const handleBrowseClick = useCallback(() => {
    fileInputRef.current?.click();
  }, []);
  const handleConfirm = useCallback(() => {
    if (pendingFiles.length === 0) {
      toastify("Please add at least one file to upload", { type: "warning" });
      return;
    }
    onConfirm();
  }, [pendingFiles, onConfirm]);
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col h-full", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-3 px-8 py-4", children: [
      /* @__PURE__ */ jsx(
        "button",
        {
          type: "button",
          onClick: onClose,
          className: "flex items-center justify-center text-secondary-500 hover:text-secondary-700 transition-colors",
          children: /* @__PURE__ */ jsx(Icon, { name: "arrow-back", className: "text-xl" })
        }
      ),
      /* @__PURE__ */ jsx("h2", { className: "text-sm font-medium text-secondary-500", children: "Upload Attachments" })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "flex-1 overflow-y-auto p-6", children: [
      /* @__PURE__ */ jsxs(
        "div",
        {
          className: classNames82(
            "border-2 border-dashed rounded-lg p-8 mb-6 transition-colors cursor-pointer",
            {
              "border-primary-500 bg-primary-50": isDragOver,
              "border-secondary-300 hover:border-primary-400": !isDragOver
            }
          ),
          onClick: handleBrowseClick,
          onDrop: handleDrop,
          onDragOver: handleDragOver,
          onDragLeave: handleDragLeave,
          children: [
            /* @__PURE__ */ jsx(
              "input",
              {
                ref: fileInputRef,
                type: "file",
                accept: ALLOWED_EXTENSIONS.join(","),
                className: "hidden",
                onChange: handleFileSelect,
                multiple: true
              }
            ),
            /* @__PURE__ */ jsxs("div", { className: "flex flex-col items-center gap-2", children: [
              /* @__PURE__ */ jsxs("p", { className: "text-sm text-secondary-700", children: [
                "Drag and drop your files or",
                " ",
                /* @__PURE__ */ jsx("span", { className: "text-primary-600 font-medium hover:underline", children: "Browse" })
              ] }),
              /* @__PURE__ */ jsxs("p", { className: "text-xs text-secondary-400", children: [
                ALLOWED_EXTENSIONS.join(", "),
                ". Max file size ",
                MAX_FILE_SIZE_MB,
                " ",
                "MB"
              ] })
            ] })
          ]
        }
      ),
      error && /* @__PURE__ */ jsx("div", { className: "mb-4 p-3 bg-error-50 border border-error-200 rounded-md", children: /* @__PURE__ */ jsx("p", { className: "text-sm text-error-600", children: error }) }),
      pendingFiles.length > 0 && /* @__PURE__ */ jsx("div", { className: "flex flex-col gap-3", children: pendingFiles.map((file) => /* @__PURE__ */ jsx(
        FileListItem,
        {
          file,
          onRemove: () => onRemoveFile(file.id)
        },
        file.id
      )) })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "flex justify-end gap-3 px-8 py-4", children: [
      /* @__PURE__ */ jsx(Button, { type: "secondary", onClick: onClose, children: "Cancel" }),
      /* @__PURE__ */ jsx(Button, { type: "primary", onClick: handleConfirm, children: "Upload" })
    ] })
  ] });
};
var FileListItem = ({ file, onRemove }) => {
  const isImage = file.type.startsWith("image/");
  return /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between px-4 py-3 border border-secondary-200 rounded-md bg-white", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-3", children: [
      /* @__PURE__ */ jsx("div", { className: "flex items-center justify-center w-6 h-6 text-secondary-400", children: isImage ? /* @__PURE__ */ jsx(Icon, { name: "photo", className: "text-lg" }) : /* @__PURE__ */ jsx(Icon, { name: "description", className: "text-lg" }) }),
      /* @__PURE__ */ jsx("span", { className: "text-sm text-secondary-700", children: file.name })
    ] }),
    /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        onClick: onRemove,
        className: "flex items-center justify-center w-6 h-6 text-secondary-400 hover:text-secondary-600 transition-colors",
        "aria-label": `Remove ${file.name}`,
        children: /* @__PURE__ */ jsx(Icon, { name: "close", className: "text-lg" })
      }
    )
  ] });
};
var upload_attachments_modal_default = UploadAttachmentsModal;
var { VirtualizedInfiniteLoader: VirtualizedInfiniteLoader8 } = InfiniteScrollV2;
var AddStepScreenshotsModal = ({
  onClose,
  stepScreenshots,
  selectedSteps,
  onToggleStep,
  onConfirm,
  nlpTemplates = []
}) => {
  const { t } = useTranslation();
  const rowRenderer = useCallback(
    (index) => {
      const step = stepScreenshots[index];
      const isSelected = selectedSteps.includes(step.stepNumber);
      return /* @__PURE__ */ jsxs("div", { className: classNames82("relative mb-3"), children: [
        /* @__PURE__ */ jsx("div", { className: "absolute top-1.5 left-3 z-10", children: /* @__PURE__ */ jsx(
          Checkbox,
          {
            checked: isSelected,
            onChange: () => onToggleStep(step.stepNumber),
            type: "primary",
            className: "h-4 w-4 bg-white shadow-sm",
            ariaLabel: __("common.select") + " " + step.description
          }
        ) }),
        /* @__PURE__ */ jsx("div", { className: "pl-10", children: /* @__PURE__ */ jsx(
          TestStepResultNLP,
          {
            nlpTemplates,
            stepResult: step.stepResult,
            wrapperClassName: "w-full",
            includeOptionalTemplates: true,
            ignoreBorderAndBackground: true
          }
        ) })
      ] }, step.stepNumber);
    },
    [stepScreenshots, selectedSteps, nlpTemplates, onToggleStep]
  );
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col h-full", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-3 px-8 py-4", children: [
      /* @__PURE__ */ jsx(
        "button",
        {
          type: "button",
          onClick: onClose,
          className: "flex items-center justify-center text-secondary-500 hover:text-secondary-700 transition-colors",
          children: /* @__PURE__ */ jsx(Icon, { name: "arrow-back", className: "text-xl" })
        }
      ),
      /* @__PURE__ */ jsx("h2", { className: "text-sm font-medium text-secondary-500", children: t("bug_report.add_step_screenshots") })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "flex-1 px-8 overflow-hidden", children: stepScreenshots.length === 0 ? /* @__PURE__ */ jsxs("div", { className: "flex flex-col items-center justify-center py-12 text-secondary-400", children: [
      /* @__PURE__ */ jsx(Icon, { name: "image", className: "text-4xl mb-2" }),
      /* @__PURE__ */ jsx("p", { className: "text-sm", children: t("bug_report.no_step_screenshots") })
    ] }) : /* @__PURE__ */ jsx("div", { className: "h-full", children: /* @__PURE__ */ jsx(
      VirtualizedInfiniteLoader8,
      {
        loadMore: NOOP,
        hasMore: false,
        isLoading: false,
        rowRenderer,
        items: stepScreenshots,
        rowCount: stepScreenshots.length,
        isDynamicHeightList: true,
        disableHeight: true,
        minHeight: 45,
        overscanRowCount: 2
      }
    ) }) }),
    /* @__PURE__ */ jsxs("div", { className: "flex justify-end gap-3 px-8 py-4", children: [
      /* @__PURE__ */ jsx(Button, { type: "secondary", onClick: onClose, children: t("common.cancel") }),
      /* @__PURE__ */ jsx(
        Button,
        {
          type: "primary",
          onClick: onConfirm,
          disabled: selectedSteps.length === 0,
          children: t("bug_report.add_screenshots")
        }
      )
    ] })
  ] });
};
var add_step_screenshots_modal_default = AddStepScreenshotsModal;
var REUSABLE_APP_TYPES = [
  ApplicationType.WebApplication,
  ApplicationType.MobileWeb,
  ApplicationType.IOSNative,
  ApplicationType.AndroidNative,
  ApplicationType.Rest
];
async function fetchNlpTemplates(applicationType) {
  const isReusable = REUSABLE_APP_TYPES.includes(applicationType);
  const typesToFetch = isReusable ? REUSABLE_APP_TYPES : [applicationType];
  const [systemResults, addonResult] = await Promise.all([
    Promise.all(typesToFetch.map((t) => TemplateApi.getAll(t))),
    TemplateApi.getAllFromAddon(applicationType)
  ]);
  const systemActions = systemResults.flatMap(
    (r) => r?.content ?? []
  );
  const kibbutzActions = addonResult?.content ?? [];
  return [...systemActions, ...kibbutzActions];
}
function useNlpTemplates(testCaseResult) {
  const applicationType = TestCaseResultReader.testCaseApplicationType(testCaseResult);
  const [data, setData] = useState([]);
  const fetchedTypeRef = useRef(null);
  useEffect(() => {
    if (!applicationType) return;
    if (fetchedTypeRef.current === applicationType) return;
    let cancelled = false;
    fetchNlpTemplates(applicationType).then((result) => {
      if (!cancelled) {
        fetchedTypeRef.current = applicationType;
        setData(result);
      }
    }).catch(() => {
    });
    return () => {
      cancelled = true;
    };
  }, [applicationType]);
  return data;
}
var GitLabBugReport = ({
  description,
  onUpdateTicketConfig: onUpdateTicketConfig2,
  appId,
  showLinkTo,
  summary,
  testCaseResult,
  stepResults = [],
  setHideBugReportHeader = NOOP
}) => {
  const nlActions = useNlpTemplates(testCaseResult);
  const [projects, setProjects] = useState([]);
  const [activeProject, setActiveProject] = useState(null);
  const [bugConfig, setBugConfig] = useState({});
  const handleAttachmentsChange = useCallback((payload) => {
    setBugConfig((prev) => ({ ...prev, attachments: payload }));
  }, []);
  const hasSetEvidenceAttachmentsRef = useRef(false);
  const lastResultIdRef = useRef(void 0);
  const [initialEvidenceAttachments, setInitialEvidenceAttachments] = useState([]);
  const [initialEvidenceStepNumbers, setInitialEvidenceStepNumbers] = useState([]);
  useEffect(() => {
    const resultId = testCaseResult?.id;
    if (resultId !== lastResultIdRef.current) {
      lastResultIdRef.current = resultId;
      hasSetEvidenceAttachmentsRef.current = false;
      setInitialEvidenceAttachments([]);
      setInitialEvidenceStepNumbers([]);
    }
    const selectedStepResults = testCaseResult?.["selectedStepResults"];
    if (!selectedStepResults || !description.includes("Evidence is attached with this report.")) {
      return;
    }
    if (hasSetEvidenceAttachmentsRef.current) return;
    hasSetEvidenceAttachmentsRef.current = true;
    const steps = Array.isArray(selectedStepResults) ? selectedStepResults : [selectedStepResults];
    const versionId = testCaseResult?.testCase?.applicationVersionId ?? testCaseResult?.applicationVersionId;
    const elementId = steps[0]?.fieldDefinitionDetails?.["ui-identifier"]?.uiIdentifierEntity?.id;
    const getStepDesc = (step) => {
      const s = step;
      const desc = s?.stepDisplaySentence || s?.stepDetails;
      return typeof desc === "string" ? desc : String(desc || "");
    };
    const stepScreenshots2 = steps.filter((s) => s?.screenshotName).map((step) => ({
      stepNumber: step.stepNumber || 0,
      stepResult: step,
      description: getStepDesc(step),
      screenshotUrl: testCaseResult?.id ? `/api/test_step_results/step_result_asset/${testCaseResult.id}/${step.screenshotName}/STEP` : "",
      selected: true
    }));
    (async () => {
      const files = [];
      if (elementId && versionId) {
        try {
          const res = await RecorderAssetsApi.getElementScreenshot({
            elementId: String(elementId),
            applicationVersionId: versionId
          });
          if (res?.elementScreenshotPresignedUrl) {
            const base64 = await fetch(res.elementScreenshotPresignedUrl).then((r) => r.blob()).then(
              (blob) => new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
              })
            ).catch(() => null);
            if (base64) {
              files.push({
                id: `element-screenshot-${elementId}`,
                name: "element-recorder-source.png",
                type: "image/png",
                size: 0,
                url: res.elementScreenshotPresignedUrl,
                base64
              });
            }
          }
        } catch {
        }
      }
      const stepFiles = stepScreenshots2.map(
        (s) => ({
          id: `step-screenshot-${s.stepNumber}`,
          name: `step-${s.stepNumber}-screenshot.png`,
          type: "image/png",
          size: 0,
          isStepScreenshot: true,
          url: s.screenshotUrl
        })
      );
      const allFiles = [...files, ...stepFiles];
      handleAttachmentsChange({
        files: allFiles,
        stepScreenshots: stepScreenshots2,
        includeScreenshots: allFiles.length > 0
      });
      setInitialEvidenceAttachments(allFiles);
      setInitialEvidenceStepNumbers(stepScreenshots2.map((s) => s.stepNumber));
    })();
  }, [testCaseResult, description, handleAttachmentsChange]);
  const {
    attachments,
    stepScreenshots,
    isUploadModalOpen,
    isStepScreenshotsModalOpen,
    pendingFiles,
    selectedSteps,
    openUploadModal,
    closeUploadModal,
    openStepScreenshotsModal,
    closeStepScreenshotsModal,
    addPendingFiles,
    removePendingFile,
    confirmUpload,
    removeAttachment,
    toggleStepSelection,
    confirmStepScreenshots,
    includeVideo,
    includeLogs,
    setIncludeVideo,
    setIncludeLogs
  } = useAttachments({
    stepResults,
    testCaseResultId: testCaseResult?.id,
    onAttachmentsChange: handleAttachmentsChange,
    setHideBugReportHeader,
    initialAttachments: initialEvidenceAttachments,
    initialSelectedSteps: initialEvidenceStepNumbers,
    initialResetKey: testCaseResult?.id
  });
  useEffect(() => {
    loadProjects();
  }, []);
  useEffect(() => {
    setBugConfig((oldConfig) => {
      oldConfig["project_id"] = activeProject?.id;
      oldConfig["project"] = activeProject?.path_with_namespace;
      oldConfig["title"] = summary;
      oldConfig["description"] = description;
      return { ...oldConfig };
    });
  }, [activeProject, summary, description]);
  useEffect(
    () => handleFieldValueChange("title", { value: summary }),
    [summary]
  );
  useEffect(
    () => handleFieldValueChange("description", { value: description }),
    [description]
  );
  useEffect(() => {
    onUpdateTicketConfig2({ ...bugConfig });
  }, [bugConfig]);
  const loadProjects = () => {
    external_application_config_service_default.findAllGitLabProjects(appId).then(
      (data) => {
        setProjects(data);
        if (data && data.length) {
          handleProjectSelect(data[0]);
        }
      }
    );
  };
  const handleProjectSelect = (project) => {
    setActiveProject(project);
  };
  const handleProjectItemSelect = ({ id }) => {
    const selectedProject = projects.find((project) => project.id === id);
    handleProjectSelect(selectedProject);
  };
  const handleFieldValueChange = (key, value) => {
    setBugConfig({ ...bugConfig, [key]: value?.value ?? value });
  };
  const handleSelectIssue = (selectedIssue) => {
    onUpdateTicketConfig2({
      externalId: selectedIssue.id,
      linkToExisting: true,
      fields: {
        project_id: activeProject.id,
        project: activeProject.path_with_namespace
      }
    });
  };
  const gitlabIssuePromise = useCallback(
    (query) => new Promise((resolve) => {
      external_application_config_service_default.findAllGitLabIssues({
        appId,
        projectId: activeProject?.id,
        searchTerm: query
      }).then((gitlabIssues) => {
        const options3 = gitlabIssues.map((issue) => {
          return {
            id: issue.iid,
            label: `#${issue.iid} - ${issue.title}`,
            disabled: false
          };
        });
        resolve(options3);
      });
    }),
    [activeProject, appId]
  );
  const isLabExecution = useMemo(
    () => testCaseResult?.environmentResult?.executionLabType != TestPlanLabType.Hybrid,
    [testCaseResult]
  );
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    !isUploadModalOpen && !isStepScreenshotsModalOpen && /* @__PURE__ */ jsxs("div", { className: "grid gap-y-4", children: [
      /* @__PURE__ */ jsx("div", { className: "grid grid-cols-2 gap-x-12", children: activeProject && /* @__PURE__ */ jsx(
        BugReportFieldDropdown,
        {
          name: activeProject.name,
          label: "Project",
          itemList: projects.map((project) => ({
            name: project.name,
            id: project.id
          })),
          onChange: handleProjectItemSelect
        }
      ) }),
      showLinkTo && activeProject ? /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
        SearchIssueField,
        {
          loadingMsg: "Loading GitLab issues",
          placeholder: "GitLab issues",
          onSelect: handleSelectIssue,
          dataPromise: gitlabIssuePromise,
          value: null
        }
      ) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          BugReportTitleField,
          {
            label: "Title",
            value: bugConfig["title"] || summary || "",
            onChange: (changedDataPayload) => handleFieldValueChange("title", changedDataPayload)
          }
        ),
        /* @__PURE__ */ jsx(
          BugReportFieldTextArea,
          {
            label: "Description",
            onChange: (changedDataPayload) => handleFieldValueChange("description", changedDataPayload),
            value: bugConfig["description"] || description || ""
          }
        ),
        /* @__PURE__ */ jsx(
          attachments_section_default,
          {
            attachments,
            onRemoveAttachment: removeAttachment,
            onAddStepScreenshots: openStepScreenshotsModal,
            onUploadFiles: openUploadModal,
            showStepScreenshotsButton: stepResults.length > 0,
            includeVideo,
            onIncludeVideoChange: setIncludeVideo,
            showVideoCheckbox: isLabExecution,
            includeLogs,
            onIncludeLogsChange: setIncludeLogs,
            showLogsCheckbox: isLabExecution
          }
        )
      ] })
    ] }),
    isUploadModalOpen && /* @__PURE__ */ jsx(
      upload_attachments_modal_default,
      {
        onClose: closeUploadModal,
        pendingFiles,
        onAddFiles: addPendingFiles,
        onRemoveFile: removePendingFile,
        onConfirm: confirmUpload
      }
    ),
    isStepScreenshotsModalOpen && /* @__PURE__ */ jsx(
      add_step_screenshots_modal_default,
      {
        onClose: closeStepScreenshotsModal,
        stepScreenshots,
        selectedSteps,
        onToggleStep: toggleStepSelection,
        onConfirm: confirmStepScreenshots,
        nlpTemplates: nlActions
      }
    )
  ] });
};
var gitlab_bug_report_default = GitLabBugReport;

// src/images/bug-plugin.svg
var bug_plugin_default = 'data:image/svg+xml,<svg width="11" height="139" viewBox="0 0 11 139" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<path fill-rule="evenodd" clip-rule="evenodd" d="M0.879883 134.986C0.879883 135.244 1.09893 135.453 1.36876 135.453C1.63861 135.453 1.85763 135.244 1.85763 134.986V134.556C1.85763 134.328 2.0493 134.144 2.28792 134.144H2.45996C2.45013 134.23 2.4443 134.32 2.4443 134.412C2.4443 134.776 2.51666 135.124 2.64768 135.444L2.05318 136.056C1.94166 136.169 1.85761 136.422 1.85761 136.575V137.417C1.85761 137.675 2.07666 137.884 2.34651 137.884C2.61638 137.884 2.83539 137.675 2.83539 137.417V136.844C2.83539 136.76 2.86081 136.684 2.90579 136.618L3.20504 136.313C3.58051 136.719 4.00877 137.133 4.64239 137.297C4.65604 137.303 4.67171 137.306 4.68738 137.31C4.72059 137.319 4.75585 137.323 4.79098 137.323C5.00614 137.323 5.1821 137.155 5.1821 136.949V133.77C5.1821 133.565 5.35806 133.396 5.57322 133.396C5.78825 133.396 5.96433 133.565 5.96433 133.77V136.949C5.96433 137.155 6.14044 137.323 6.3554 137.323C6.3965 137.323 6.43757 137.318 6.47672 137.304L6.52557 137.291C7.13195 137.131 7.56988 136.715 7.94128 136.313L8.24071 136.618C8.28561 136.684 8.31103 136.76 8.31103 136.844V137.417C8.31103 137.675 8.53005 137.884 8.79988 137.884C9.06979 137.884 9.28881 137.675 9.28881 137.417V136.575C9.28881 136.422 9.20476 136.169 9.09321 136.055L8.49873 135.444C8.62971 135.124 8.7021 134.776 8.7021 134.412C8.7021 134.32 8.69639 134.23 8.68646 134.144H8.85851C9.09709 134.144 9.28877 134.328 9.28877 134.556V134.986C9.28877 135.244 9.50779 135.453 9.7777 135.453C10.0475 135.453 10.2665 135.244 10.2665 134.986V134.144C10.2665 133.628 9.82846 133.209 9.28877 133.209H8.3677C8.27966 133.052 8.18001 132.901 8.07836 132.749L8.89766 131.901C9.0092 131.787 9.09321 131.519 9.09321 131.34V130.498C9.09321 130.24 8.87423 130.031 8.6044 130.031C8.33446 130.031 8.11548 130.24 8.11548 130.498V131.115C8.11548 131.199 8.09005 131.276 8.04515 131.341L7.51903 131.88C7.30005 131.472 7.1377 131.007 7.1377 130.405C7.1377 129.707 6.63907 129.122 5.96433 128.956V129.844C5.96433 130.049 5.78825 130.218 5.57322 130.218C5.35806 130.218 5.1821 130.049 5.1821 129.844V128.956C4.5074 129.122 4.00877 129.707 4.00877 130.405C4.00877 131.005 3.84441 131.469 3.62549 131.876L3.10136 131.341C3.05637 131.276 3.03095 131.199 3.03095 131.115V130.498C3.03095 130.24 2.8119 130.031 2.54208 130.031C2.27225 130.031 2.05318 130.24 2.05318 130.498V131.34C2.05318 131.519 2.13719 131.787 2.24877 131.901L3.06419 132.746C2.96061 132.897 2.86283 133.051 2.77478 133.209H1.85763C1.31798 133.209 0.879883 133.628 0.879883 134.144V134.986Z" fill="%2303A973"/>%0A<line x1="5.5" y1="130.883" x2="5.50001" y2="9.15306e-05" stroke="%2303A973"/>%0A</svg>%0A';
function useSession() {
  const [session, setSession] = useState(null);
  useEffect(() => {
    let cancelled = false;
    instance_default.get("/sessions").then((data) => {
      if (!cancelled) setSession(data);
    }).catch(() => {
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return session;
}

// src/images/jira.svg
var jira_default = 'data:image/svg+xml,<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<path d="M32.8519 15.6946L18.0589 1.38688L16.625 0L5.48944 10.7703L0.398121 15.6946C-0.132707 16.2086 -0.132707 17.0414 0.398121 17.5554L10.5717 27.3953L16.625 33.25L27.7606 22.4797L27.933 22.313L32.8519 17.5554C33.3827 17.0414 33.3827 16.2086 32.8519 15.6946ZM16.625 21.5405L11.5428 16.625L16.625 11.7095L21.7072 16.625L16.625 21.5405Z" fill="%232684FF"/>%0A<path fill-rule="evenodd" clip-rule="evenodd" d="M16.625 11.7095C13.2976 8.49083 13.2814 3.27755 16.5887 0.0395508L5.4668 10.7923L11.5201 16.647L16.625 11.7095Z" fill="url(%23paint0_linear_427_8625)"/>%0A<path fill-rule="evenodd" clip-rule="evenodd" d="M21.7209 16.6118L16.625 21.5405C18.2311 23.093 19.1334 25.1991 19.1334 27.3952C19.1334 29.5914 18.2311 31.6975 16.625 33.25L27.7742 22.4666L21.7209 16.6118Z" fill="url(%23paint1_linear_427_8625)"/>%0A<defs>%0A<linearGradient id="paint0_linear_427_8625" x1="15.7175" y1="6.73695" x2="7.23966" y2="10.4385" gradientUnits="userSpaceOnUse">%0A<stop offset="0.18" stop-color="%230052CC"/>%0A<stop offset="1" stop-color="%232684FF"/>%0A</linearGradient>%0A<linearGradient id="paint1_linear_427_8625" x1="17.5961" y1="26.456" x2="26.0587" y2="22.7807" gradientUnits="userSpaceOnUse">%0A<stop offset="0.18" stop-color="%230052CC"/>%0A<stop offset="1" stop-color="%232684FF"/>%0A</linearGradient>%0A</defs>%0A</svg>%0A';

// src/images/trello.svg
var trello_default = 'data:image/svg+xml,<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<path fill-rule="evenodd" clip-rule="evenodd" d="M28.2012 0H3.80396C1.70512 0 0.00289041 1.69994 3.06652e-05 3.79877V28.1601C-0.00402793 29.1716 0.394932 30.1431 1.10874 30.8598C1.82256 31.5765 2.79243 31.9794 3.80396 31.9794H28.2012C29.2118 31.978 30.1804 31.5745 30.8931 30.858C31.6058 30.1414 32.004 29.1707 32 28.1601V3.79877C31.9971 1.70194 30.298 0.00282402 28.2012 0ZM13.8007 23.0336C13.7994 23.3716 13.6634 23.6953 13.4229 23.9329C13.1824 24.1705 12.8572 24.3025 12.5191 24.2999H7.18747C6.49014 24.297 5.92634 23.7309 5.92634 23.0336V7.16691C5.92634 6.46957 6.49014 5.90347 7.18747 5.90065H12.5191C13.2172 5.90346 13.7825 6.46874 13.7853 7.16691L13.8007 23.0336ZM26.1044 15.7487C26.1044 16.0873 25.9689 16.4117 25.7281 16.6496C25.4873 16.8875 25.1613 17.0191 24.8228 17.0151H19.4912C18.793 17.0122 18.2277 16.4469 18.2249 15.7487V7.16691C18.2277 6.46874 18.793 5.90346 19.4912 5.90065H24.8228C25.5201 5.90347 26.0839 6.46957 26.0839 7.16691L26.1044 15.7487Z" fill="url(%23paint0_linear_435_8724)"/>%0A<defs>%0A<linearGradient id="paint0_linear_435_8724" x1="4996.8" y1="2046.68" x2="4996.8" y2="0" gradientUnits="userSpaceOnUse">%0A<stop stop-color="%230052CC"/>%0A<stop offset="1" stop-color="%232684FF"/>%0A</linearGradient>%0A</defs>%0A</svg>%0A';

// src/images/clickup.svg
var clickup_default = 'data:image/svg+xml,<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<g filter="url(%23filter0_dd_438_9757)">%0A<path d="M38 19C38 9.05887 29.9411 1 20 1C10.0589 1 2 9.05887 2 19C2 28.9411 10.0589 37 20 37C29.9411 37 38 28.9411 38 19Z" fill="white"/>%0A<path d="M38 19C38 9.05887 29.9411 1 20 1C10.0589 1 2 9.05887 2 19C2 28.9411 10.0589 37 20 37C29.9411 37 38 28.9411 38 19Z" fill="white"/>%0A<path fill-rule="evenodd" clip-rule="evenodd" d="M9.45312 25.6858L13.3465 22.7036C15.4139 25.403 17.6095 26.6468 20.0561 26.6468C22.4892 26.6468 24.6244 25.4171 26.5992 22.7393L30.5463 25.6501C27.6988 29.511 24.1564 31.5509 20.0561 31.5509C15.9694 31.5509 12.3941 29.5254 9.45312 25.6858Z" fill="url(%23paint0_linear_438_9757)"/>%0A<path fill-rule="evenodd" clip-rule="evenodd" d="M20.0429 12.7238L13.1134 18.6949L9.91211 14.9797L20.0567 6.23828L30.1223 14.9865L26.9053 18.6881L20.0429 12.7238Z" fill="url(%23paint1_linear_438_9757)"/>%0A</g>%0A<defs>%0A<filter id="filter0_dd_438_9757" x="0.2" y="5.96046e-08" width="39.6" height="39.6" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">%0A<feFlood flood-opacity="0" result="BackgroundImageFix"/>%0A<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>%0A<feOffset dy="0.8"/>%0A<feGaussianBlur stdDeviation="0.9"/>%0A<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"/>%0A<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_438_9757"/>%0A<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>%0A<feOffset dy="0.15"/>%0A<feGaussianBlur stdDeviation="0.225"/>%0A<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"/>%0A<feBlend mode="normal" in2="effect1_dropShadow_438_9757" result="effect2_dropShadow_438_9757"/>%0A<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_438_9757" result="shape"/>%0A</filter>%0A<linearGradient id="paint0_linear_438_9757" x1="9.45312" y1="28.7204" x2="30.5463" y2="28.7204" gradientUnits="userSpaceOnUse">%0A<stop stop-color="%238930FD"/>%0A<stop offset="1" stop-color="%2349CCF9"/>%0A</linearGradient>%0A<linearGradient id="paint1_linear_438_9757" x1="9.91211" y1="14.7095" x2="30.1223" y2="14.7095" gradientUnits="userSpaceOnUse">%0A<stop stop-color="%23FF02F0"/>%0A<stop offset="1" stop-color="%23FFC800"/>%0A</linearGradient>%0A</defs>%0A</svg>%0A%20';

// src/images/monday.svg
var monday_default = 'data:image/svg+xml,<svg width="42" height="26" viewBox="0 0 42 26" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<g clip-path="url(%23clip0_432_8643)">%0A<path d="M21.0648 25.6551C19.2279 25.6103 17.7124 24.8017 16.7447 23.1138C15.7528 21.369 15.796 19.5829 16.8536 17.8812C19.3713 13.8313 21.9219 9.80388 24.4569 5.76607C24.9754 4.94024 25.4817 4.10233 26.0243 3.29201C26.7446 2.1837 27.8701 1.39971 29.1612 1.107C30.4522 0.814278 31.8068 1.03595 32.9364 1.72482C35.3229 3.19202 36.1212 6.24365 34.6351 8.64874C31.5972 13.5854 28.5161 18.4979 25.3918 23.3862C24.4293 24.8982 22.9691 25.6275 21.0648 25.6551Z" fill="%23FFCB00"/>%0A<path d="M5.28778 25.6549C3.4336 25.6101 1.92675 24.7653 0.978053 23.0843C-1.76132e-05 21.3395 0.0621918 19.5499 1.12321 17.8482C3.83162 13.5127 6.55213 9.18357 9.28474 4.86072C9.63035 4.30211 9.97595 3.72972 10.3458 3.18835C11.0956 2.1041 12.239 1.35358 13.5338 1.09569C14.8286 0.8378 16.1732 1.09279 17.2828 1.80667C18.3925 2.52056 19.1801 3.63729 19.479 4.92043C19.7779 6.20356 19.5645 7.55238 18.884 8.68129C15.8565 13.5587 12.7875 18.4189 9.71675 23.2739C8.71967 24.848 7.25256 25.6273 5.28778 25.6549Z" fill="%23FF3D57"/>%0A<path d="M36.9438 15.7691C39.738 15.7829 42 17.9984 41.9948 20.7155C41.9948 23.4741 39.6724 25.6981 36.8522 25.6637C34.032 25.6292 31.8098 23.4379 31.8132 20.7086C31.8167 17.9398 34.0873 15.7519 36.9438 15.7691Z" fill="%2300D647"/>%0A</g>%0A<defs>%0A<clipPath id="clip0_432_8643">%0A<rect width="42" height="25.9636" fill="white"/>%0A</clipPath>%0A</defs>%0A</svg>%0A';

// src/images/freshrelease.svg
var freshrelease_default = 'data:image/svg+xml,<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<path d="M16 32C7.1453 32 0 24.8205 0 16C0 7.17948 7.17949 0 16 0H28C30.2222 0 32 1.77778 32 4V16C32 24.8205 24.8205 32 16 32Z" fill="%237D61DC"/>%0A<path d="M9.57272 19.5554L8.41032 18.393L9.74366 15.3503C10.0514 14.7007 10.7009 14.2562 11.4189 14.2562H13.1966C13.6753 14.2562 14.1539 13.9827 14.359 13.5725L15.4189 11.658C16.3078 10.0511 17.9146 8.99128 19.7266 8.85453L23.6924 8.51265C24.0684 8.47846 24.3761 8.75197 24.4103 9.12804C24.4103 9.16223 24.4103 9.19641 24.4103 9.2306L24.0684 13.1964C23.8975 15.0084 22.8377 16.6152 21.265 17.5041L19.3505 18.5639C18.9061 18.8032 18.6667 19.2477 18.6667 19.7263V21.5041C18.6667 22.2221 18.2223 22.8716 17.5727 23.1793L14.53 24.5127L13.3676 23.3503L13.5727 22.5981C13.8462 21.675 13.5727 20.7178 12.9231 20.034C12.2394 19.3503 11.2821 19.1109 10.359 19.3845C10.3249 19.3161 9.57272 19.5554 9.57272 19.5554ZM19.5556 14.8032C20.4103 14.8032 21.0941 14.1195 21.0941 13.2648C21.0941 12.4101 20.4103 11.7263 19.5556 11.7263C18.7009 11.7263 18.0172 12.4101 18.0172 13.2648C18.0172 14.1195 18.7009 14.8032 19.5556 14.8032Z" fill="white"/>%0A</svg>%0A';

// src/images/youtrack.svg
var youtrack_default = 'data:image/svg+xml,<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<path d="M10.449 12.2784C15.7351 7.45471 21.621 2.06864 21.796 1.89369C22.0584 1.61876 22.3458 1.36883 22.6457 1.14389C24.8826 -0.505674 27.9568 -0.355713 30.0313 1.4938C32.0932 3.3433 32.5806 6.39249 31.1935 8.79186C30.9435 9.22924 30.6311 9.64163 30.2687 9.99154C29.094 11.1662 24.5952 15.94 24.5952 15.94C24.5952 15.94 30.4936 21.6134 30.5936 21.6884C32.0557 22.8631 32.4306 24.9251 31.4684 26.5371C30.8935 27.4869 29.9313 28.1367 28.8441 28.3367C28.5192 28.3991 24.2328 24.2627 19.4966 20.9261C16.4974 24.2877 10.5489 30.961 10.524 30.961C7.99962 32.7355 4.90045 31.7607 3.50082 30.986C1.56383 29.8488 0.276676 27.8618 0.0392391 25.6249C-0.198198 23.388 0.651577 21.1761 2.32613 19.664C3.15091 18.9267 6.64998 15.7525 10.449 12.2784Z" fill="%230CB0F2"/>%0A<path d="M20.9712 14.0031C20.7962 12.8284 20.1839 11.7787 19.2341 11.0539L10.0241 1.73135C8.46198 0.169266 6.16259 -0.380589 4.06314 0.294232C1.9637 0.969053 0.426611 2.76857 0.0767037 4.95549C-0.273203 7.12992 0.626558 9.32933 2.41358 10.629L13.5356 18.3894C15.0352 19.5641 17.0972 19.6891 18.7467 18.7268C20.3838 17.7521 21.2711 15.8776 20.9712 14.0031Z" fill="url(%23paint0_linear_432_8706)"/>%0A<path d="M25.9073 6.10498H5.98761V26.0247H25.9073V6.10498Z" fill="black"/>%0A<path d="M7.99962 21.9883H15.2977V23.3129H7.99962V21.9883ZM10.6614 13.9904L7.2998 8.7168H9.53671L11.6237 12.2284L13.7356 8.7168H15.9225L12.5609 13.9654V17.452H10.6489L10.6614 13.9904ZM18.8842 10.4788H16.2224V8.7168H23.4455V10.4788H20.8087V17.427H18.8967V10.4788H18.8842Z" fill="white"/>%0A<defs>%0A<linearGradient id="paint0_linear_432_8706" x1="13.8374" y1="12.9166" x2="1.50756" y2="0.0677155" gradientUnits="userSpaceOnUse">%0A<stop stop-color="%23905CFB"/>%0A<stop offset="0.07" stop-color="%23A554E6"/>%0A<stop offset="0.25" stop-color="%23D641B5"/>%0A<stop offset="0.39" stop-color="%23F43597"/>%0A<stop offset="0.47" stop-color="%23FF318C"/>%0A</linearGradient>%0A</defs>%0A</svg>%0A';

// src/images/backlog.svg
var backlog_default = 'data:image/svg+xml,<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<rect width="32" height="32" rx="4" fill="%2342CE9F"/>%0A<path fill-rule="evenodd" clip-rule="evenodd" d="M9 6V23.9217C8.99999 24.6456 9.18922 26.0895 11.7561 25.9956C14.9646 25.8782 23.8197 24.4891 23.9938 17.7391C24.1282 15.2935 22.1222 10.23 13.1547 9.15V6H9ZM13.1547 21.8087V13.2C18.6174 14.0765 19.8931 15.8022 19.7774 17.7391C19.5683 21.2413 15.1634 21.8804 13.1547 21.8087Z" fill="white"/>%0A</svg>%0A';

// src/images/linear.svg
var linear_default = 'data:image/svg+xml,<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<path d="M0.403015 37.3991L26.6009 63.597C13.2225 61.3356 2.66442 50.7775 0.403015 37.3991Z" fill="%235E6AD2"/>%0A<path d="M0 30.2868L33.7132 64C35.7182 63.8929 37.6742 63.6013 39.5645 63.142L0.85799 24.4355C0.398679 26.3259 0.10713 28.2818 0 30.2868Z" fill="%235E6AD2"/>%0A<path d="M2.53595 19.4042L44.5958 61.4641C46.1277 60.8066 47.598 60.0331 48.9956 59.1546L4.84545 15.0044C3.96693 16.402 3.19341 17.8723 2.53595 19.4042Z" fill="%235E6AD2"/>%0A<path d="M7.69501 11.1447C13.5677 4.32093 22.2677 0 31.9769 0C49.6628 0 64 14.3372 64 32.0231C64 41.7323 59.6791 50.4323 52.8553 56.305L7.69501 11.1447Z" fill="%235E6AD2"/>%0A</svg>%0A';

// src/images/azure-devops.svg
var azure_devops_default = 'data:image/svg+xml,<svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">%0D%0A<path d="M22.6884 13.4299C24.9798 13.4255 27.1916 14.2704 28.899 15.8009V1.32264C28.899 0.592755 28.3107 0 27.5808 0H27.5764H1.32264C0.592755 0 0 0.588332 0 1.31822V1.32264V22.8476C0 23.5775 0.588333 24.1703 1.31822 24.1703H1.32264H13.4785C13.4078 23.7014 13.3724 23.2325 13.3724 22.7592C13.368 17.6057 17.5438 13.4299 22.6884 13.4299Z" fill="%2300957E"/>%0D%0A<path d="M8.80724 2.42432H2.37982V6.4984H8.80724V2.42432Z" fill="%233CB5A2"/>%0D%0A<path d="M17.6455 2.42432H11.2181V6.4984H17.6455V2.42432Z" fill="%2376C5BD"/>%0D%0A<path d="M8.80724 8.87793H2.37982V12.952H8.80724V8.87793Z" fill="%23A9D9D8"/>%0D%0A<path d="M8.80724 15.332H2.37982V19.3486H8.80724V15.332Z" fill="%232CB29A"/>%0D%0A<path d="M17.6455 8.87793H11.2181V12.952H17.6455V8.87793Z" fill="%232EB29D"/>%0D%0A<path d="M26.497 2.42432H20.074V6.4984H26.5015V2.42432H26.497Z" fill="%2339B5A1"/>%0D%0A<path d="M28.8946 22.843V15.8007C27.1871 14.2702 24.9753 13.4253 22.6884 13.4297C17.5438 13.4297 13.3724 17.6055 13.3724 22.759C13.3724 23.2323 13.4078 23.7012 13.4785 24.1701H27.5764C28.3018 24.1657 28.8946 23.5729 28.8946 22.843Z" fill="%232DB299"/>%0D%0A<path d="M28.8946 15.8057V22.848C28.8946 23.5778 28.3019 24.1706 27.572 24.1706H13.4741C14.1509 28.6516 18.0171 32.0887 22.6839 32.0887C27.833 32.0843 31.9999 27.9085 31.9999 22.7551C32.0088 20.1009 30.8764 17.5707 28.8946 15.8057Z" fill="%2350B9A8"/>%0D%0A<path d="M27.4746 18.1675L21.6355 24.0066L18.6364 21.003L16.8448 22.8034L19.844 25.8069L21.7506 27.7179L23.5421 25.9175L29.3812 20.0785L27.4746 18.1675Z" fill="%23CBE7E7"/>%0D%0A</svg>%0D%0A';

// src/images/bugzilla.svg
var bugzilla_default = 'data:image/svg+xml,<svg width="31" height="40" viewBox="0 0 31 40" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">%0A<g clip-path="url(%23clip0_438_9742)">%0A<rect width="30.399" height="40" fill="url(%23pattern0)"/>%0A</g>%0A<defs>%0A<pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">%0A<use xlink:href="%23image0_438_9742" transform="scale(0.000833333 0.000633312)"/>%0A</pattern>%0A<clipPath id="clip0_438_9742">%0A<rect width="30.399" height="40" fill="white"/>%0A</clipPath>%0A<image id="image0_438_9742" width="1200" height="1579" xlink:href="data:image/png;base64,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"/>%0A</defs>%0A</svg>%0A';

// src/images/mantis.svg
var mantis_default = 'data:image/svg+xml,<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">%0A<rect x="0.25" y="0.25" width="31.5" height="30.7072" rx="3.75" fill="url(%23pattern0)" stroke="%23737373" stroke-width="0.5"/>%0A<defs>%0A<pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">%0A<use xlink:href="%23image0_582_8367" transform="matrix(0.00225225 0 0 0.00230947 -0.515766 -0.0461894)"/>%0A</pattern>%0A<image id="image0_582_8367" width="900" height="500" xlink:href="data:image/png;base64,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"/>%0A</defs>%0A</svg>%0A';

// src/images/testrail.svg
var testrail_default = 'data:image/svg+xml,<svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<path d="M29.8719 20.5828C30.0427 20.7552 30.0427 21.0334 29.8719 21.2058L26.4084 24.6713C26.236 24.8436 25.9581 24.8436 25.7858 24.6713L22.3223 21.2058C22.1498 21.0334 22.1498 20.7552 22.3223 20.5828L25.7858 17.1173C25.9581 16.9465 26.236 16.9465 26.4084 17.1173L29.8719 20.5828Z" fill="%2367BF79"/>%0A<path d="M24.3804 15.0882C24.5513 15.2606 24.5513 15.5388 24.3804 15.7112L20.9169 19.1767C20.7446 19.349 20.4667 19.349 20.2943 19.1767L16.8307 15.7112C16.6585 15.5388 16.6585 15.2606 16.8307 15.0882L20.2943 11.6227C20.4667 11.4519 20.7446 11.4519 20.9169 11.6227L24.3804 15.0882Z" fill="%2367BF79"/>%0A<path d="M24.2746 26.1833C24.4469 26.3541 24.4469 26.6337 24.2746 26.8062L20.8126 30.2702C20.6402 30.4427 20.3608 30.4427 20.1885 30.2702L16.7265 26.8063C16.5541 26.6338 16.5541 26.3543 16.7265 26.1834L20.1885 22.7179C20.3608 22.5454 20.6402 22.5454 20.8126 22.7179L24.2746 26.1833Z" fill="%2367BF79"/>%0A<path d="M18.8889 9.59364C19.0597 9.766 19.0597 10.0442 18.8889 10.2166L15.4254 13.6821C15.2531 13.8544 14.9752 13.8544 14.8028 13.6821L11.3393 10.2166C11.167 10.0442 11.167 9.766 11.3393 9.59364L14.8028 6.12814C14.9752 5.95729 15.2531 5.95729 15.4254 6.12814L18.8889 9.59364Z" fill="%2367BF79"/>%0A<path d="M18.7832 20.6887C18.9556 20.8595 18.9556 21.1392 18.7832 21.3116L15.3213 24.7756C15.1489 24.9481 14.8694 24.9481 14.6972 24.7756L11.2351 21.3116C11.0627 21.1392 11.0627 20.8595 11.2351 20.6887L14.6972 17.2232C14.8694 17.0508 15.1489 17.0508 15.3213 17.2232L18.7832 20.6887Z" fill="%2367BF79"/>%0A<path d="M18.6789 31.7822C18.8512 31.9547 18.8512 32.2328 18.6789 32.4051L15.2153 35.8706C15.0429 36.0431 14.765 36.0431 14.5927 35.8706L11.1292 32.4051C10.9569 32.2328 10.9569 31.9547 11.1292 31.7822L14.5927 28.3167C14.765 28.1443 15.0429 28.1443 15.2153 28.3167L18.6789 31.7822Z" fill="%2367BF79"/>%0A</svg>%0A';

// src/images/qtest.svg
var qtest_default = 'data:image/svg+xml,<svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">%0A<rect x="3.37109" y="3.41895" width="11.0836" height="11.1628" fill="url(%23pattern0_8595_15991)"/>%0A<defs>%0A<pattern id="pattern0_8595_15991" patternContentUnits="objectBoundingBox" width="1" height="1">%0A<use xlink:href="%23image0_8595_15991" transform="scale(0.00357143 0.0035461)"/>%0A</pattern>%0A<image id="image0_8595_15991" width="993" height="296" xlink:href="data:image/png;base64,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"/>%0A</defs>%0A</svg>%0A';

// src/images/gitlab-icon.svg
var gitlab_icon_default = 'data:image/svg+xml,<svg width="156" height="150" viewBox="0 0 156 150" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<path d="M153.133 59.3724L152.92 58.8142L131.721 3.50512C131.297 2.42153 130.535 1.50871 129.544 0.87824C128.555 0.24451 127.396 -0.0542903 126.221 0.00809968C125.052 0.0704897 123.929 0.497348 123.013 1.22631C122.103 1.96185 121.446 2.95678 121.138 4.07977L106.824 47.8864H48.9148L34.6015 4.07977C34.2929 2.95678 33.6361 1.96186 32.7266 1.22631C31.8104 0.497358 30.6875 0.0704897 29.5185 0.00809968C28.343 -0.0542903 27.1838 0.24451 26.1955 0.87824C25.2038 1.50871 24.442 2.42153 24.0184 3.50512L2.81953 58.8175L2.60605 59.3724C-3.67553 75.7576 1.67677 94.2805 15.665 104.86C15.6912 104.877 15.7142 104.896 15.7405 104.916L15.9277 105.057L48.2186 129.231L64.1901 141.321L73.9096 148.67C76.2508 150.443 79.4884 150.443 81.8296 148.67L91.5491 141.321L107.517 129.231L139.999 104.916C140.028 104.893 140.055 104.873 140.084 104.85C154.062 94.2706 159.411 75.7544 153.133 59.3724Z" fill="%23E24329"/>%0A</svg>%0A';

// src/components/bug-report/components/integration-assets.ts
var getIntegrationAsset = (config) => {
  if (!config) return null;
  if (config.isJira) {
    return {
      iconUrl: jira_default,
      className: "h-[22px]"
    };
  } else if (config.isJiraServer) {
    return {
      iconUrl: jira_default,
      className: "h-[22px]"
    };
  } else if (config.isTrello) {
    return {
      iconUrl: trello_default,
      className: "h-[22px]"
    };
  } else if (config.isClickUp) {
    return {
      iconUrl: clickup_default,
      className: "h-[22px]"
    };
  } else if (config.isMonday) {
    return {
      iconUrl: monday_default,
      className: "h-[22px]"
    };
  } else if (config.isFreshrelease) {
    return {
      iconUrl: freshrelease_default,
      className: "h-[22px]"
    };
  } else if (config.isYoutrack) {
    return {
      iconUrl: youtrack_default,
      className: "h-[32px]"
    };
  } else if (config.isBackLog) {
    return {
      iconUrl: backlog_default,
      className: "h-[24px]"
    };
  } else if (config.isLinear) {
    return {
      iconUrl: linear_default,
      className: "h-[30px]"
    };
  } else if (config.isAzure) {
    return {
      iconUrl: azure_devops_default,
      className: "h-[32px]"
    };
  } else if (config.isBugzilla) {
    return {
      iconUrl: bugzilla_default,
      className: "h-[32px]"
    };
  } else if (config.isMantis) {
    return {
      iconUrl: mantis_default,
      className: "h-[30px]"
    };
  } else if (config.isTestRail) {
    return {
      iconUrl: testrail_default,
      className: "h-[22px]"
    };
  } else if (config.isQTest) {
    return {
      iconUrl: qtest_default,
      className: "h-[22px]"
    };
  } else if (config.isGitLab) {
    return {
      iconUrl: gitlab_icon_default,
      className: "h-[22px]"
    };
  }
};
var IntegratePlugin = ({ plugins, onChangePlugin }) => {
  const session = useSession();
  const openUrl = useOpenUrl();
  const isAdminAccess = session?.user?.isSuperAdmin ?? false;
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsxs("div", { className: "text-primary-500 font-medium text-base text-center flex items-baseline gap-x-5 justify-center", children: [
      /* @__PURE__ */ jsx("img", { src: bug_plugin_default, alt: "Bug report plugin icon" }),
      __("bug_report.integrate_plugin_msg")
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "flex justify-center gap-4 flex-wrap px-5 mt-16", children: [
      !plugins?.length && isAdminAccess && /* @__PURE__ */ jsxs(
        "span",
        {
          role: "link",
          onClick: () => openUrl("/ui/settings/plugs"),
          className: "flex items-center text-small leading-5 leading-4 gap-x-2 text-primary-500 cursor-pointer",
          children: [
            __("bug-report.configure.integrations"),
            /* @__PURE__ */ jsx(Icon, { name: "arrow-right-long", className: "text-2xl" })
          ]
        }
      ),
      !plugins?.length && !isAdminAccess && /* @__PURE__ */ jsx("p", { className: "text-gray-500 font-normal text-small text-center block pr-[140px] pl-[140px] pt-10", children: __("bug_report.access_denied_msg") }),
      plugins.map((plugin, idx) => /* @__PURE__ */ jsx(
        "div",
        {
          className: "w-[150px] h-12 border border-neutral-100 rounded-lg flex items-center cursor-pointer",
          onClick: () => onChangePlugin(plugin),
          children: /* @__PURE__ */ jsx(
            "img",
            {
              src: getIntegrationAsset(plugin).iconUrl,
              alt: plugin.name,
              className: classNames82(
                "my-0 mx-auto max-w-[150px]",
                getIntegrationAsset(plugin).className
              )
            }
          )
        },
        idx
      )),
      plugins?.length > 0 && isAdminAccess && /* @__PURE__ */ jsxs(
        "span",
        {
          role: "link",
          onClick: () => openUrl("/ui/settings/plugs"),
          className: "flex w-[150px] h-12 border border-neutral-100 rounded-lg text-primary-500 font-medium text-center text-small leading-4 items-center justify-center cursor-pointer",
          children: [
            __("common.more_options"),
            "..."
          ]
        }
      )
    ] })
  ] });
};
var integrate_plugin_default = IntegratePlugin;

// src/components/bug-report/components/jira-bug-report.utils.ts
var DEFAULT_FIELDS = [
  "description",
  "issuetype",
  "project",
  "summary"
];
var SPECIAL_FIELDS = ["priority"];
var ISSUE_TYPE_HIERARCHY = {
  // H1 - Project level
  project: 1,
  // H2 - High-level planning
  initiative: 2,
  // H3 - Epic level
  epic: 3,
  // H4 - Work items
  story: 4,
  task: 4,
  bug: 4,
  improvement: 4,
  "new feature": 4,
  feature: 4,
  // H5 - Sub-items
  subtask: 5,
  "sub-task": 5,
  defect: 5
};
var getFieldTypeCategory = (field) => {
  if (!field?.schema) return "unknown";
  const schemaType = field.schema["type"] ?? "";
  const schemaItems = field.schema["items"] ?? "";
  const customType = field.schema["custom"] ?? "";
  const fieldKey = field.key?.toLowerCase() ?? "";
  if (schemaType === "priority") return "priority";
  if (schemaType === "timetracking") return "timetracking";
  if (schemaType === "date" || customType?.includes("datepicker")) {
    return "date";
  }
  if (schemaType === "datetime" || customType?.includes("datetime")) {
    return "datetime";
  }
  if (schemaType === "user") return "user";
  if (schemaType === "array") {
    if (schemaItems === "user" || customType?.includes("multiuserpicker")) {
      return "multiuser";
    }
    if (schemaItems === "string" || fieldKey === "labels") {
      return "labels";
    }
    if (schemaItems === "version") {
      return "version";
    }
    if (schemaItems === "component") {
      return "component";
    }
    if (schemaItems === "issuelinks") {
      return "issuelinks";
    }
    if (schemaItems === "attachment") {
      return "attachment";
    }
    if (field.allowedValues?.length) {
      return "multiselect";
    }
    return "unknown";
  }
  if (schemaType === "string") {
    if (fieldKey === "environment" || field.schema["system"] === "description") {
      return "textarea";
    }
    return "string";
  }
  if (schemaType === "number") return "number";
  if (schemaType === "option" && field.allowedValues?.length) {
    return "dropdown";
  }
  if (field.allowedValues?.length) {
    return "dropdown";
  }
  return "unknown";
};
var getRequiredFields = (fields) => {
  if (!fields || fields.length === 0) return [];
  return fields.filter((field) => {
    if (!field) return false;
    const fieldKey = field.key?.toLowerCase() ?? "";
    if (DEFAULT_FIELDS.includes(fieldKey)) return false;
    if (SPECIAL_FIELDS.includes(fieldKey)) return true;
    return field.required === true;
  });
};
var getSupportedFields = (fields) => {
  if (!fields || fields.length === 0) return [];
  const supportedFields = fields.filter((field) => {
    if (!field) return false;
    const fieldKey = field.key?.toLowerCase() ?? "";
    const isRequired = field.required === true;
    const fieldCategory = getFieldTypeCategory(field);
    if (DEFAULT_FIELDS.includes(fieldKey)) return false;
    if (isRequired) return true;
    if (SPECIAL_FIELDS.includes(fieldKey)) return true;
    if (field.hasDefaultValue === true && !SPECIAL_FIELDS.includes(fieldKey)) {
      return false;
    }
    if (field.autoCompleteUrl) return false;
    const simpleTypes = [
      "string",
      "textarea",
      "number",
      "dropdown",
      "multiselect"
    ];
    return simpleTypes.includes(fieldCategory);
  });
  return supportedFields.sort((a, b) => {
    if (a.required === b.required) return 0;
    return a.required ? -1 : 1;
  });
};
var findMatchingAllowedValue = (value, allowedValues) => {
  if (!value || !allowedValues?.length) return null;
  if (Array.isArray(value)) {
    return findMatchingAllowedValue(value[0], allowedValues);
  }
  if (typeof value === "object") {
    return allowedValues.find(
      (av) => av?.id === value?.id || av?.id === value?.value || av?.name === value?.name || av?.value === value?.value || String(av?.id) === String(value?.id)
    ) || null;
  }
  const strValue = String(value);
  return allowedValues.find(
    (av) => String(av?.id) === strValue || av?.name === strValue || av?.value === strValue
  ) || null;
};
var formatSingleValue = (value, schemaType, schemaItems, fieldKey, isArrayField) => {
  if (schemaType === "priority") {
    return value?.name ?? value?.value ?? String(value?.id ?? "");
  }
  if (fieldKey?.startsWith("customfield_")) {
    return value?.id != null ? { id: value.id } : { value: value?.value ?? value?.name };
  }
  if (isArrayField) {
    if (schemaItems === "component") {
      return value?.id != null ? { id: value.id } : { name: value?.name ?? value?.value ?? "" };
    }
    if (schemaItems === "option") {
      return value?.id != null ? { id: value.id } : { value: value?.value ?? value?.name };
    }
  }
  return value?.name ? { name: value.name } : { value: value?.value };
};
var formatFieldValueForStorage = (key, matchedValue, issueField) => {
  if (!issueField) {
    return matchedValue?.name ? { name: matchedValue.name } : { value: matchedValue?.value };
  }
  const schemaType = issueField.schema?.["type"] ?? "";
  const schemaItems = issueField.schema?.["items"] ?? "";
  const isArrayField = schemaType === "array";
  const formattedValue = formatSingleValue(
    matchedValue,
    schemaType,
    schemaItems,
    key,
    isArrayField
  );
  return isArrayField ? [formattedValue] : formattedValue;
};
var getDefaultFieldValue = (issueField) => {
  const firstValue = issueField?.allowedValues?.[0];
  if (!firstValue) return "";
  const schemaType = issueField?.schema?.["type"] ?? "";
  const schemaItems = issueField?.schema?.["items"] ?? "";
  const isArrayField = schemaType === "array";
  const formattedValue = formatSingleValue(
    firstValue,
    schemaType,
    schemaItems,
    issueField?.key ?? "",
    isArrayField
  );
  return isArrayField ? [formattedValue] : formattedValue;
};
var createCoreConfig = (project, issueType, description, summary) => {
  const reporter = {
    id: "557058:5b95782b-0688-47a0-a48f-ce303c843697"
    // Replace with actual Jira Cloud accountId
  };
  return {
    ...project?.id && { project: { id: project.id } },
    ...issueType?.id && { issuetype: { id: issueType.id } },
    reporter,
    description: description || "",
    summary: summary || ""
  };
};
var buildDefaultConfig = (allFields, project, issueType, description, summary) => {
  const config = createCoreConfig(project, issueType, description, summary);
  allFields.forEach((issueField) => {
    const fieldKey = issueField?.key;
    if (!fieldKey) return;
    const isRequired = issueField.required === true;
    const isSpecialField = SPECIAL_FIELDS.includes(fieldKey.toLowerCase());
    if ((isRequired || isSpecialField) && issueField?.allowedValues?.length) {
      config[fieldKey] = getDefaultFieldValue(issueField);
    } else if (fieldKey === "summary" && summary) {
      config[fieldKey] = summary;
    }
  });
  return config;
};
var populateConfigFromIssue = (issueFields, issueData, project, issueType, description, summary) => {
  if (!issueData?.fields || !issueFields?.length) {
    return createCoreConfig(project, issueType, description, summary);
  }
  const config = createCoreConfig(project, issueType, description, summary);
  if (issueData.fields.description !== void 0) {
    config.description = issueData.fields.description ?? "";
  }
  if (issueData.fields.summary !== void 0) {
    config.summary = issueData.fields.summary ?? "";
  }
  issueFields.forEach((issueField) => {
    const fieldKey = issueField?.key;
    const fieldValue = issueData.fields?.[fieldKey];
    if (!fieldKey || fieldValue == null) return;
    if (issueField.allowedValues?.length) {
      const matched = findMatchingAllowedValue(
        fieldValue,
        issueField.allowedValues
      );
      if (matched) {
        config[fieldKey] = formatFieldValueForStorage(
          fieldKey,
          matched,
          issueField
        );
      } else {
        config[fieldKey] = fieldValue;
      }
    } else {
      const schemaType = issueField?.schema?.["type"] ?? "";
      if (schemaType === "number" && typeof fieldValue === "string") {
        const numValue = Number(fieldValue);
        config[fieldKey] = isNaN(numValue) ? fieldValue : numValue;
      } else {
        config[fieldKey] = fieldValue;
      }
    }
  });
  return config;
};
var getDefaultIssueType = (project) => {
  if (!project?.issueTypes?.length) return null;
  const sortedIssueType = sortIssueTypesByHierarchy(project.issueTypes);
  return sortedIssueType[0] || null;
};
var isEmptyValue = (value) => {
  if (value === null || value === void 0) return true;
  if (value === "") return true;
  if (Array.isArray(value) && value.length === 0) return true;
  if (typeof value === "object" && !Array.isArray(value)) {
    const obj = value;
    const keys = Object.keys(obj);
    if (keys.length === 0) return true;
    return keys.every((key) => isEmptyValue(obj[key]));
  }
  return false;
};
var cleanBugConfig = (config) => {
  const cleaned = {};
  const alwaysIncludeFields = ["project", "issuetype"];
  Object.keys(config).forEach((key) => {
    const value = config[key];
    if (alwaysIncludeFields.includes(key)) {
      if (value !== null && value !== void 0) {
        cleaned[key] = value;
      }
      return;
    }
    if (key === "summary" || key === "description") {
      if (value !== null && value !== void 0) {
        cleaned[key] = value;
      }
      return;
    }
    if (isEmptyValue(value)) {
      return;
    }
    if (typeof value === "object" && value !== null) {
      if (Array.isArray(value)) {
        const cleanedArray = value.filter((item) => !isEmptyValue(item));
        if (cleanedArray.length > 0) {
          cleaned[key] = cleanedArray;
        }
      } else {
        const obj = value;
        const keys = Object.keys(obj);
        const hasNonEmptyValues = keys.some(
          (objKey) => !isEmptyValue(obj[objKey])
        );
        if (hasNonEmptyValues) {
          const cleanedObj = {};
          keys.forEach((objKey) => {
            const objValue = obj[objKey];
            if (!isEmptyValue(objValue)) {
              cleanedObj[objKey] = objValue;
            }
          });
          cleaned[key] = cleanedObj;
        }
      }
    } else {
      cleaned[key] = value;
    }
  });
  return cleaned;
};
var getDropdownDisplayName = (fieldKey, issueField, bugConfig) => {
  if (!issueField || !bugConfig) return "";
  const configValue = bugConfig[fieldKey];
  if (configValue === void 0 || configValue === null) {
    return "";
  }
  const allowedValues = issueField.allowedValues ?? [];
  const matchedValue = findMatchingAllowedValue(configValue, allowedValues);
  if (matchedValue) {
    return matchedValue.name ?? String(matchedValue.value ?? "");
  }
  if (configValue && typeof configValue === "object") {
    const obj = configValue;
    return obj.name ?? String(obj.value ?? obj.id ?? "");
  }
  return typeof configValue === "string" ? configValue : "";
};
var getIssueTypeHierarchyLevel = (issueTypeName) => {
  const normalizedName = issueTypeName?.toLowerCase()?.trim() ?? "";
  return ISSUE_TYPE_HIERARCHY[normalizedName] ?? 4;
};
var sortIssueTypesByHierarchy = (issueTypes) => {
  if (!issueTypes?.length) return [];
  return [...issueTypes].sort((a, b) => {
    const levelA = getIssueTypeHierarchyLevel(a.name ?? "");
    const levelB = getIssueTypeHierarchyLevel(b.name ?? "");
    if (levelA !== levelB) {
      return levelA - levelB;
    }
    return (a.name ?? "").localeCompare(b.name ?? "");
  });
};
var MessageDescription = ({
  description
}) => {
  return /* @__PURE__ */ jsx("div", { className: "flex items-center text-sm font-medium", children: description });
};
var ParentTaskSelector = ({
  dataPromise,
  value,
  onSelect,
  selectedParentKey
}) => {
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    AutoComplete,
    {
      optionsHook: dataPromise,
      LoadingContent: /* @__PURE__ */ jsx(DropdownItem, { isSelected: false, children: "Loading tasks..." }),
      CustomItemWrapper: ({ value: value2 }) => value2 ? /* @__PURE__ */ jsxs(
        "div",
        {
          className: `flex items-start ${selectedParentKey === value2.key ? "bg-primary-100 rounded-md" : ""}`,
          children: [
            /* @__PURE__ */ jsx(
              "span",
              {
                className: "text-xs text-secondary-600 font-medium bg-secondary-100\n                  px-2 py-1 rounded-md whitespace-nowrap mr-1",
                children: value2.key
              }
            ),
            /* @__PURE__ */ jsx("span", { className: "text-xs font-normal", children: value2.label })
          ]
        }
      ) : null,
      onSelect: (selectedTask) => onSelect(selectedTask),
      placeholder: "Select a task or search by issue summary",
      className: "!z-50",
      debounceTime: 500,
      showClearButton: false,
      inputClassName: "bg-secondary-50",
      inputContainerClassName: "!bg-secondary-50",
      label: "Task",
      labelClassName: "text-2xs font-medium !px-1",
      value,
      dropdownClass: "h-64 !overflow-auto shadow-lg border border-secondary-200 rounded-md"
    }
  ) });
};
var useJiraProjects = () => {
  const { t } = useTranslation();
  const [projects, setProjects] = useState([]);
  const [activeProject, setActiveProject] = useState(null);
  const [activeIssueType, setActiveIssueType] = useState(
    null
  );
  const [isLoading, setIsLoading] = useState(false);
  const loadProjectIssueTypes = useCallback(
    async (project) => {
      if (project?.issueTypes?.length) return project;
      const issueTypes = await external_application_config_service_default.findAllJiraIssueTypes(
        project?.id
      );
      return new JiraProject().deserialize({
        ...project,
        issuetypes: issueTypes
      });
    },
    []
  );
  const selectProject = useCallback(
    async (project) => {
      if (!project) return;
      try {
        const projectWithTypes = await loadProjectIssueTypes(project);
        setActiveProject(projectWithTypes);
        setProjects(
          (prevProjects) => prevProjects.map(
            (p) => String(p?.id) === String(projectWithTypes?.id) ? projectWithTypes : p
          )
        );
        const defaultIssueType = getDefaultIssueType(projectWithTypes);
        if (defaultIssueType) {
          setActiveIssueType(defaultIssueType);
        }
      } catch (error) {
        setActiveProject(project);
      }
    },
    [loadProjectIssueTypes]
  );
  const selectIssueType = useCallback((issueType) => {
    if (!issueType) return;
    setActiveIssueType(issueType);
  }, []);
  const searchProjects = useCallback((query) => {
    external_application_config_service_default.searchJiraProjects(query).then(
      (data) => {
        if (!data?.length) {
          setProjects([]);
          return;
        }
        const projectsList = data?.map((project) => new JiraProject().deserialize(project)) ?? [];
        setProjects(projectsList);
      }
    );
  }, []);
  const loadProjects = useCallback(async () => {
    setIsLoading(true);
    try {
      const data = await external_application_config_service_default.searchJiraProjects(
        ""
      );
      if (!data?.length) {
        toastify(t("test_case_result.details.report.no.projects"), {
          type: "error"
        });
        setProjects([]);
        return;
      }
      const projectsList = data?.map((project) => new JiraProject().deserialize(project)) ?? [];
      setProjects(projectsList);
      if (projectsList?.length > 0) {
        await selectProject(projectsList[0]);
      }
    } finally {
      setIsLoading(false);
    }
  }, [t, selectProject]);
  useEffect(() => {
    loadProjects();
  }, [loadProjects]);
  return {
    projects,
    activeProject,
    activeIssueType,
    isLoading,
    searchProjects,
    selectProject,
    selectIssueType
  };
};
var useJiraIssueFields = (activeProject, activeIssueType) => {
  const [issueFields, setIssueFields] = useState([]);
  const [parentField, setParentField] = useState(null);
  const [isLoadingFields, setIsLoadingFields] = useState(false);
  const loadFields = useCallback(async () => {
    if (!activeProject || !activeIssueType) {
      setIssueFields([]);
      setParentField(null);
      return;
    }
    setIsLoadingFields(true);
    try {
      const data = await external_application_config_service_default.fetchJiraIssueFields(
        activeProject.key,
        activeIssueType.name
      );
      if (!data?.length) {
        setIssueFields([]);
        setParentField(null);
        return;
      }
      const projectData = new JiraProject().deserialize(data[0]);
      const issueTypeData = projectData?.issueTypes?.find(
        (it) => it?.name === activeIssueType?.name
      );
      if (issueTypeData?.fields) {
        const supportedFields = getSupportedFields(issueTypeData.fields);
        setIssueFields(supportedFields);
        const parent = issueTypeData.fields.find(
          (field) => field?.key === "parent"
        );
        setParentField(parent || null);
      } else {
        setIssueFields([]);
        setParentField(null);
      }
    } catch (error) {
      setIssueFields([]);
      setParentField(null);
    } finally {
      setIsLoadingFields(false);
    }
  }, [activeProject, activeIssueType]);
  useEffect(() => {
    loadFields();
  }, [loadFields]);
  return { issueFields, parentField, isLoadingFields };
};
var useJiraBugConfig = ({
  description,
  summary,
  activeProject,
  activeIssueType,
  issueFields,
  selectedIssueData,
  onUpdate
}) => {
  const [bugConfig, setBugConfig] = useState(
    () => createCoreConfig(activeProject, activeIssueType, description, summary)
  );
  const updateField = useCallback(
    (key, value, issueField) => {
      const field = issueField ?? issueFields?.find((f) => f?.key === key);
      if (field?.allowedValues?.length) {
        const searchValue = value?.id ?? value?.value ?? value;
        const matchedValue = findMatchingAllowedValue(
          searchValue,
          field.allowedValues
        );
        if (matchedValue) {
          const formattedValue = formatFieldValueForStorage(
            key,
            matchedValue,
            field
          );
          setBugConfig((prev) => ({
            ...prev,
            [key]: formattedValue
          }));
        } else {
          const fallbackValue = value?.id ?? value?.value ?? value;
          setBugConfig((prev) => ({
            ...prev,
            [key]: fallbackValue
          }));
        }
        return;
      }
      const rawValue = value?.value ?? value;
      const schemaType = field?.schema?.["type"] ?? "";
      let processedValue = rawValue;
      if (schemaType === "number") {
        if (rawValue === "" || rawValue === null || rawValue === void 0) {
          processedValue = void 0;
        } else if (typeof rawValue === "string") {
          const numValue = Number(rawValue);
          processedValue = isNaN(numValue) ? rawValue : numValue;
        } else if (typeof rawValue === "number") {
          processedValue = rawValue;
        }
      }
      setBugConfig((prev) => {
        const newConfig = { ...prev };
        if (processedValue === void 0 || processedValue === null) {
          delete newConfig[key];
        } else {
          newConfig[key] = processedValue;
        }
        return newConfig;
      });
    },
    [issueFields]
  );
  useEffect(() => {
    const newConfig = createCoreConfig(
      activeProject,
      activeIssueType,
      description,
      summary
    );
    setBugConfig(newConfig);
  }, [activeProject?.id, activeIssueType?.id, description, summary]);
  useEffect(() => {
    if (!activeProject || !activeIssueType || !issueFields?.length) return;
    const config = selectedIssueData ? populateConfigFromIssue(
      issueFields,
      selectedIssueData,
      activeProject,
      activeIssueType,
      description,
      summary
    ) : buildDefaultConfig(
      issueFields,
      activeProject,
      activeIssueType,
      description,
      summary
    );
    setBugConfig((prev) => {
      const hasExistingAttachments = prev?.attachments && (prev.attachments?.files?.length > 0 || prev.attachments?.stepScreenshots?.length > 0);
      return hasExistingAttachments ? { ...config, attachments: prev.attachments } : config;
    });
  }, [
    issueFields,
    selectedIssueData,
    activeProject,
    activeIssueType,
    description,
    summary
  ]);
  useEffect(() => {
    onUpdate(bugConfig);
  }, [bugConfig, onUpdate]);
  return { bugConfig, updateField };
};
var useJiraIssueSearch = ({
  appId,
  activeProject,
  activeIssueType,
  onIssueSelect
}) => {
  const [selectedIssueKey, setSelectedIssueKey] = useState(null);
  useEffect(() => {
    setSelectedIssueKey(null);
  }, [activeProject?.id, activeIssueType?.id]);
  const searchIssues = useCallback(
    (query) => {
      return new Promise((resolve) => {
        if (!activeProject || !activeIssueType) {
          resolve([]);
          return;
        }
        external_application_config_service_default.findAllJiraIssues({
          appId,
          projectId: activeProject.id,
          issueTypeId: activeIssueType.id,
          searchTerm: query
        }).then((jiraIssues) => {
          const options3 = jiraIssues?.map((jiraIssue) => ({
            id: jiraIssue?.key,
            label: `${jiraIssue?.key ?? ""} ${jiraIssue?.fields?.summary ?? ""}`,
            disabled: false,
            key: jiraIssue?.key
          })) ?? [];
          resolve(options3);
        }).catch(() => resolve([]));
      });
    },
    [appId, activeProject, activeIssueType]
  );
  const selectIssue = useCallback(
    async (issueKey) => {
      if (!issueKey) return;
      try {
        const response = await external_application_config_service_default.fetchIssuesByIssueKeys([
          issueKey
        ]);
        if (response?.length) {
          setSelectedIssueKey(issueKey);
          onIssueSelect?.(issueKey, response[0]);
        }
      } catch (error) {
        setSelectedIssueKey(null);
      }
    },
    [onIssueSelect]
  );
  return { selectedIssueKey, searchIssues, selectIssue };
};
var assigneesCache = /* @__PURE__ */ new Map();
var pendingRequests = /* @__PURE__ */ new Set();
var getCacheKey = (projectKey, query) => `${projectKey}:${query}`;
var useJiraAssignees = ({
  activeProject
}) => {
  const [assignees, setAssignees] = useState([]);
  const [activeAssignee, setActiveAssignee] = useState(
    null
  );
  const [isLoadingAssignees, setIsLoadingAssignees] = useState(false);
  const lastProjectKeyRef = useRef(null);
  const searchAssignees = useCallback(
    (query) => {
      if (!activeProject?.key) {
        setAssignees([]);
        return;
      }
      const cacheKey = getCacheKey(activeProject.key, query);
      const cachedAssignees = assigneesCache.get(cacheKey);
      if (cachedAssignees !== void 0) {
        setAssignees(cachedAssignees);
        return;
      }
      if (pendingRequests.has(cacheKey)) {
        return;
      }
      pendingRequests.add(cacheKey);
      setIsLoadingAssignees(true);
      external_application_config_service_default.searchJiraAssignees(
        activeProject.key,
        query
      ).then((data) => {
        const assigneesList = data?.length ? data.map((assignee) => new JiraAssignee().deserialize(assignee)) : [];
        setAssignees(assigneesList);
        assigneesCache.set(cacheKey, assigneesList);
      }).catch(() => {
        setAssignees([]);
      }).finally(() => {
        pendingRequests.delete(cacheKey);
        setIsLoadingAssignees(false);
      });
    },
    [activeProject?.key]
  );
  const selectAssignee = useCallback((assignee) => {
    setActiveAssignee(assignee);
  }, []);
  useEffect(() => {
    if (lastProjectKeyRef.current !== activeProject?.key) {
      setAssignees([]);
      setActiveAssignee(null);
      lastProjectKeyRef.current = activeProject?.key ?? null;
    }
  }, [activeProject?.key]);
  return {
    assignees,
    activeAssignee,
    isLoadingAssignees,
    searchAssignees,
    selectAssignee
  };
};

// src/components/bug-report/components/use-jira-bug-report.ts
var useJiraBugReport = ({
  description,
  appId,
  onUpdateTicketConfig: onUpdateTicketConfig2,
  summary
}) => {
  const [selectedIssueData, setSelectedIssueData] = useState(null);
  const linkStateRef = useRef({});
  const {
    projects,
    activeProject,
    activeIssueType,
    isLoading,
    searchProjects,
    selectProject,
    selectIssueType
  } = useJiraProjects();
  const { issueFields, parentField, isLoadingFields } = useJiraIssueFields(
    activeProject,
    activeIssueType
  );
  const {
    assignees,
    activeAssignee,
    isLoadingAssignees,
    searchAssignees,
    selectAssignee
  } = useJiraAssignees({
    activeProject
  });
  const isParentRequired = useMemo(
    () => parentField?.required === true,
    [parentField]
  );
  const requiredFields = useMemo(
    () => getRequiredFields(issueFields),
    [issueFields]
  );
  const optionalFields = useMemo(() => {
    if (!issueFields?.length || !requiredFields?.length) {
      return issueFields || [];
    }
    const requiredFieldKeys = new Set(
      requiredFields.map((field) => field?.key)
    );
    return issueFields.filter((field) => !requiredFieldKeys.has(field?.key));
  }, [issueFields, requiredFields]);
  const wrappedOnUpdateTicketConfig = useCallback(
    (config) => {
      const configWithLinkState = config;
      if ("externalId" in configWithLinkState) {
        if (configWithLinkState.externalId === void 0) {
          delete linkStateRef.current.externalId;
        } else {
          linkStateRef.current.externalId = configWithLinkState.externalId;
        }
      }
      if ("linkToExisting" in configWithLinkState) {
        linkStateRef.current.linkToExisting = configWithLinkState.linkToExisting;
      }
      const cleanedConfig = cleanBugConfig(config);
      onUpdateTicketConfig2({
        ...cleanedConfig,
        ...linkStateRef.current
      });
    },
    [onUpdateTicketConfig2]
  );
  const { bugConfig, updateField } = useJiraBugConfig({
    description,
    summary,
    activeProject,
    activeIssueType,
    issueFields,
    selectedIssueData,
    onUpdate: wrappedOnUpdateTicketConfig
  });
  const { selectedIssueKey, searchIssues, selectIssue } = useJiraIssueSearch({
    appId,
    activeProject,
    activeIssueType,
    onIssueSelect: (issueKey, issueData) => {
      setSelectedIssueData(issueData);
      wrappedOnUpdateTicketConfig({
        externalId: issueKey,
        linkToExisting: true
      });
    }
  });
  const [selectedParentKey, setSelectedParentKey] = useState(
    null
  );
  const searchParentTasks = useCallback(
    async (query) => {
      if (!activeProject?.issueTypes?.length) {
        return [];
      }
      try {
        const nonSubtaskIssueTypes = activeProject.issueTypes.filter(
          (issueType) => !issueType?.name?.toLowerCase()?.includes("sub-task")
        );
        if (!nonSubtaskIssueTypes.length) {
          return [];
        }
        const searchPromises = nonSubtaskIssueTypes.map(
          (issueType) => external_application_config_service_default.findAllJiraIssues({
            appId,
            projectId: activeProject.id,
            issueTypeId: issueType.id,
            searchTerm: query || ""
          }).catch(() => [])
        );
        const allResults = await Promise.all(searchPromises);
        const issuesMap = /* @__PURE__ */ new Map();
        allResults.flat().forEach((jiraIssue) => {
          if (jiraIssue?.key && !issuesMap.has(jiraIssue.key)) {
            issuesMap.set(jiraIssue.key, jiraIssue);
          }
        });
        return Array.from(issuesMap.values()).map((jiraIssue) => ({
          id: jiraIssue?.key,
          label: `${jiraIssue?.fields?.summary ?? ""}`,
          disabled: false,
          key: jiraIssue?.key
        }));
      } catch {
        return [];
      }
    },
    [appId, activeProject]
  );
  const handleParentTaskSelect = useCallback(
    (parentIssue) => {
      const parentKey = parentIssue?.id;
      if (parentKey && typeof parentKey === "string") {
        setSelectedParentKey(parentKey);
        updateField("parent", { key: parentKey });
      }
    },
    [updateField]
  );
  useEffect(() => {
    setSelectedParentKey(null);
  }, [activeProject?.id, activeIssueType?.id]);
  useEffect(() => {
    if (selectedIssueData) {
      setSelectedIssueData(null);
      linkStateRef.current = {};
      wrappedOnUpdateTicketConfig({
        externalId: void 0,
        linkToExisting: false
      });
    }
  }, [activeProject?.id, activeIssueType?.id, wrappedOnUpdateTicketConfig]);
  const handleProjectSelect = (item) => {
    const selectedProject = projects?.find(
      (jiraProject) => String(jiraProject?.id) === String(item?.id)
    );
    if (selectedProject) {
      selectProject(selectedProject);
    }
  };
  const handleIssueTypeSelect = ({
    id
  }) => {
    const selectedIssueType = activeProject?.issueTypes?.find(
      (issueType) => String(issueType?.id) === String(id)
    );
    if (selectedIssueType) {
      selectIssueType(selectedIssueType);
      updateField("issuetype", id);
    }
  };
  const handleFieldValueChange = (key, value, issueField) => {
    updateField(key, value, issueField);
  };
  const handleSelectIssue = (selectedIssue) => {
    const issueKey = selectedIssue?.id;
    if (issueKey) {
      selectIssue(String(issueKey));
    }
  };
  const handleAssigneeSelect = (item) => {
    const selectedAssignee = assignees?.find(
      (assignee) => assignee?.accountId === item?.id
    );
    if (selectedAssignee) {
      selectAssignee(selectedAssignee);
      updateField("assignee", { accountId: selectedAssignee.accountId });
    }
  };
  return {
    // State
    projects,
    activeProject,
    activeIssueType,
    issueFields,
    requiredFields,
    optionalFields,
    bugConfig,
    isLoading,
    isLoadingFields,
    selectedIssueKey,
    isParentRequired,
    parentField,
    selectedParentKey,
    // Assignee state
    assignees,
    activeAssignee,
    isLoadingAssignees,
    // Handlers
    handleProjectSelect,
    handleIssueTypeSelect,
    handleFieldValueChange,
    handleSelectIssue,
    handleSearchProjects: searchProjects,
    jiraIssuesHooks: searchIssues,
    searchParentTasks,
    handleParentTaskSelect,
    // Assignee handlers
    handleAssigneeSelect,
    handleSearchAssignees: searchAssignees
  };
};
var avatarStatusCache = /* @__PURE__ */ new Map();
var imageLoadQueue = [];
var isProcessingQueue = false;
var processImageQueue = () => {
  if (isProcessingQueue || imageLoadQueue.length === 0) return;
  isProcessingQueue = true;
  const item = imageLoadQueue.shift();
  if (item) {
    setTimeout(() => {
      item.callback();
      isProcessingQueue = false;
      processImageQueue();
    }, 50);
  } else {
    isProcessingQueue = false;
  }
};
var queueImageLoad = (url, callback) => {
  const status = avatarStatusCache.get(url);
  if (status === "loaded" || status === "error") return;
  if (imageLoadQueue.some((item) => item.url === url)) return;
  avatarStatusCache.set(url, "loading");
  imageLoadQueue.push({ url, callback });
  processImageQueue();
};
var AssigneeAvatarItem = memo(
  ({ iconUrl, name }) => {
    const cachedStatus = iconUrl ? avatarStatusCache.get(iconUrl) : void 0;
    const getInitialStatus = () => {
      if (cachedStatus === "loaded") return "loaded";
      if (cachedStatus === "error") return "error";
      return "idle";
    };
    const [status, setStatus] = useState(getInitialStatus);
    const [shouldRender, setShouldRender] = useState(cachedStatus === "loaded");
    const initials = name?.slice(0, 2).toUpperCase() || "??";
    const baseClassName = "w-4 h-4 rounded-full bg-yellow-500 flex items-center justify-center text-[6px] font-bold text-black border border-white";
    React5__default.useEffect(() => {
      if (!iconUrl || status !== "idle") return;
      const cached = avatarStatusCache.get(iconUrl);
      if (cached === "loaded") {
        setStatus("loaded");
        setShouldRender(true);
        return;
      }
      if (cached === "error") {
        setStatus("error");
        return;
      }
      setStatus("loading");
      queueImageLoad(iconUrl, () => {
        setShouldRender(true);
      });
    }, [iconUrl, status]);
    const handleLoad = useCallback(() => {
      avatarStatusCache.set(iconUrl, "loaded");
      setStatus("loaded");
    }, [iconUrl]);
    const handleError = useCallback(() => {
      avatarStatusCache.set(iconUrl, "error");
      setStatus("error");
      setShouldRender(false);
    }, [iconUrl]);
    if (!iconUrl || status === "error" || !shouldRender) {
      return /* @__PURE__ */ jsx("div", { className: baseClassName, children: initials });
    }
    return /* @__PURE__ */ jsxs("div", { className: `${baseClassName} overflow-hidden`, children: [
      status !== "loaded" && /* @__PURE__ */ jsx("span", { children: initials }),
      /* @__PURE__ */ jsx(
        "img",
        {
          src: iconUrl,
          alt: name,
          loading: "lazy",
          decoding: "async",
          onLoad: handleLoad,
          onError: handleError,
          className: "w-full h-full object-cover",
          style: { display: status === "loaded" ? "block" : "none" }
        }
      )
    ] });
  }
);
AssigneeAvatarItem.displayName = "AssigneeAvatarItem";
var JiraBugReport = ({
  description,
  onUpdateTicketConfig: onUpdateTicketConfig2,
  appId,
  showLinkTo,
  summary,
  testCaseResult,
  stepResults = [],
  setHideBugReportHeader = NOOP
}) => {
  const { t } = useTranslation();
  const nlActions = useNlpTemplates(testCaseResult);
  const {
    projects,
    activeProject,
    activeIssueType,
    requiredFields,
    optionalFields,
    bugConfig,
    isLoading,
    isLoadingFields,
    selectedIssueKey,
    isParentRequired,
    selectedParentKey,
    handleProjectSelect,
    handleIssueTypeSelect,
    handleFieldValueChange,
    handleSelectIssue,
    handleSearchProjects,
    jiraIssuesHooks,
    searchParentTasks,
    handleParentTaskSelect,
    // Assignee
    assignees,
    activeAssignee,
    isLoadingAssignees,
    handleAssigneeSelect,
    handleSearchAssignees
  } = useJiraBugReport({
    description,
    appId,
    onUpdateTicketConfig: onUpdateTicketConfig2,
    summary
  });
  const handleAttachmentsChange = useCallback(
    (payload) => {
      handleFieldValueChange("attachments", payload);
    },
    [handleFieldValueChange]
  );
  const hasSetEvidenceAttachmentsRef = useRef(false);
  const lastResultIdRef = useRef(void 0);
  const [initialEvidenceAttachments, setInitialEvidenceAttachments] = useState([]);
  const [initialEvidenceStepNumbers, setInitialEvidenceStepNumbers] = useState([]);
  const isLabExecution = useMemo(
    () => testCaseResult?.environmentResult?.executionLabType != TestPlanLabType.Hybrid,
    [testCaseResult]
  );
  useEffect(() => {
    const resultId = testCaseResult?.id;
    if (resultId !== lastResultIdRef.current) {
      lastResultIdRef.current = resultId;
      hasSetEvidenceAttachmentsRef.current = false;
      setInitialEvidenceAttachments([]);
      setInitialEvidenceStepNumbers([]);
    }
    const selectedStepResults = testCaseResult?.["selectedStepResults"];
    if (!selectedStepResults || !description.includes("Evidence is attached with this report.")) {
      return;
    }
    if (hasSetEvidenceAttachmentsRef.current) return;
    hasSetEvidenceAttachmentsRef.current = true;
    const steps = Array.isArray(selectedStepResults) ? selectedStepResults : [selectedStepResults];
    const versionId = testCaseResult?.testCase?.applicationVersionId ?? testCaseResult?.applicationVersionId;
    const elementId = steps[0]?.fieldDefinitionDetails?.["ui-identifier"]?.uiIdentifierEntity?.id;
    const getStepDesc = (step) => {
      const s = step;
      const desc = s?.stepDisplaySentence || s?.stepDetails;
      return typeof desc === "string" ? desc : String(desc || "");
    };
    const stepScreenshots2 = steps.filter((s) => s?.screenshotName).map((step) => ({
      stepNumber: step.stepNumber || 0,
      stepResult: step,
      description: getStepDesc(step),
      screenshotUrl: testCaseResult?.id ? `/api/test_step_results/step_result_asset/${testCaseResult.id}/${step.screenshotName}/STEP` : "",
      selected: true
    }));
    (async () => {
      const files = [];
      if (elementId && versionId) {
        try {
          const res = await RecorderAssetsApi.getElementScreenshot({
            elementId: String(elementId),
            applicationVersionId: versionId
          });
          if (res?.elementScreenshotPresignedUrl) {
            const base64 = await fetch(res.elementScreenshotPresignedUrl).then((r) => r.blob()).then(
              (blob) => new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
              })
            ).catch(() => null);
            if (base64) {
              files.push({
                id: `element-screenshot-${elementId}`,
                name: "element-recorder-source.png",
                type: "image/png",
                size: 0,
                url: res.elementScreenshotPresignedUrl,
                base64
              });
            }
          }
        } catch {
        }
      }
      const stepFiles = stepScreenshots2.map(
        (s) => ({
          id: `step-screenshot-${s.stepNumber}`,
          name: `step-${s.stepNumber}-screenshot.png`,
          type: "image/png",
          size: 0,
          isStepScreenshot: true,
          url: s.screenshotUrl
        })
      );
      const allFiles = [...files, ...stepFiles];
      handleAttachmentsChange({
        files: allFiles,
        stepScreenshots: stepScreenshots2,
        includeScreenshots: allFiles.length > 0
      });
      setInitialEvidenceAttachments(allFiles);
      setInitialEvidenceStepNumbers(stepScreenshots2.map((s) => s.stepNumber));
    })();
  }, [testCaseResult, description, handleAttachmentsChange]);
  const {
    attachments,
    stepScreenshots,
    isUploadModalOpen,
    isStepScreenshotsModalOpen,
    pendingFiles,
    selectedSteps,
    includeVideo,
    includeLogs,
    openUploadModal,
    closeUploadModal,
    openStepScreenshotsModal,
    closeStepScreenshotsModal,
    addPendingFiles,
    removePendingFile,
    confirmUpload,
    removeAttachment,
    toggleStepSelection,
    confirmStepScreenshots,
    setIncludeVideo,
    setIncludeLogs
  } = useAttachments({
    stepResults,
    testCaseResultId: testCaseResult?.id,
    onAttachmentsChange: handleAttachmentsChange,
    setHideBugReportHeader,
    initialAttachments: initialEvidenceAttachments,
    initialSelectedSteps: initialEvidenceStepNumbers,
    initialResetKey: testCaseResult?.id
  });
  const renderField = (issueField, index) => {
    const fieldKey = issueField?.key ?? `field-${index}`;
    const fieldName = issueField?.name ?? "";
    const configValue = bugConfig?.[fieldKey];
    const isRequired = issueField.required || SPECIAL_FIELDS.includes(fieldKey.toLowerCase());
    const fieldCategory = getFieldTypeCategory(issueField);
    const getStringValue = () => {
      if (typeof configValue === "string") return configValue;
      if (typeof configValue === "number") return String(configValue);
      if (fieldKey === "summary") return summary;
      return "";
    };
    switch (fieldCategory) {
      // ---------- DATE FIELD ----------
      case "date":
        return /* @__PURE__ */ jsx(
          BugReportFieldDateInput,
          {
            label: fieldName,
            value: getStringValue(),
            onChange: (payload) => handleFieldValueChange(fieldKey, payload),
            isRequired
          },
          fieldKey
        );
      // ---------- DATETIME FIELD ----------
      case "datetime":
        return /* @__PURE__ */ jsx(
          BugReportFieldDateTimeInput,
          {
            label: fieldName,
            value: getStringValue(),
            onChange: (payload) => handleFieldValueChange(fieldKey, payload),
            isRequired
          },
          fieldKey
        );
      // ---------- TIME TRACKING FIELD ----------
      case "timetracking": {
        const timeValue = typeof configValue === "object" && configValue !== null ? configValue : {};
        return /* @__PURE__ */ jsx(
          BugReportFieldTimeTracking,
          {
            label: fieldName,
            value: timeValue,
            onChange: (val) => handleFieldValueChange(fieldKey, val),
            isRequired
          },
          fieldKey
        );
      }
      // ---------- LABELS FIELD (array of strings) ----------
      case "labels": {
        const labelsValue = Array.isArray(configValue) ? configValue : [];
        return /* @__PURE__ */ jsx(
          BugReportFieldLabels,
          {
            label: fieldName,
            value: labelsValue,
            onChange: (labels) => handleFieldValueChange(fieldKey, labels),
            isRequired,
            placeholder: "Type label and press Enter"
          },
          fieldKey
        );
      }
      // ---------- VERSION FIELD (fixVersions) ----------
      case "version": {
        const versionsValue = Array.isArray(configValue) ? configValue : [];
        const allowedVersions = (issueField.allowedValues || []).map((v) => ({
          id: String(v.id),
          name: v.name || v.value || ""
        }));
        return /* @__PURE__ */ jsx(
          BugReportFieldVersionSelect,
          {
            label: fieldName,
            value: versionsValue,
            versions: allowedVersions,
            onChange: (versions) => handleFieldValueChange(fieldKey, versions),
            isRequired
          },
          fieldKey
        );
      }
      // ---------- COMPONENT FIELD (components) ----------
      case "component": {
        const componentsValue = Array.isArray(configValue) ? configValue : [];
        const allowedComponents = (issueField.allowedValues || []).map((v) => ({
          id: String(v.id),
          name: v.name || v.value || ""
        }));
        return /* @__PURE__ */ jsx(
          BugReportFieldVersionSelect,
          {
            label: fieldName,
            value: componentsValue,
            versions: allowedComponents,
            onChange: (components) => handleFieldValueChange(fieldKey, components),
            isRequired
          },
          fieldKey
        );
      }
      // ---------- USER FIELD (single user - reporter/assignee) ----------
      case "user":
        return /* @__PURE__ */ jsx(
          BugReportFieldUnsupported,
          {
            label: fieldName,
            fieldType: "user",
            fieldKey,
            isRequired
          },
          fieldKey
        );
      // ---------- MULTI-USER FIELD (approvers, etc) ----------
      case "multiuser":
        return /* @__PURE__ */ jsx(
          BugReportFieldUnsupported,
          {
            label: fieldName,
            fieldType: "multiuser",
            fieldKey,
            isRequired
          },
          fieldKey
        );
      // ---------- ISSUE LINKS FIELD ----------
      case "issuelinks":
        return /* @__PURE__ */ jsx(
          BugReportFieldUnsupported,
          {
            label: fieldName,
            fieldType: "issuelinks",
            fieldKey,
            isRequired
          },
          fieldKey
        );
      // ---------- PRIORITY / DROPDOWN FIELDS ----------
      case "priority":
      case "dropdown": {
        if (issueField?.allowedValues?.length) {
          return /* @__PURE__ */ jsx(
            BugReportFieldDropdown,
            {
              name: getDropdownDisplayName(fieldKey, issueField, bugConfig),
              label: fieldName,
              onChange: (payload) => handleFieldValueChange(fieldKey, payload, issueField),
              itemList: issueField.allowedValues.map(
                ({ id, name, value, iconUrl }) => ({
                  id,
                  name: name ?? value ?? "",
                  iconUrl: iconUrl ? String(iconUrl) : void 0
                })
              ),
              isRequired
            },
            fieldKey
          );
        }
        return null;
      }
      // ---------- MULTISELECT FIELD ----------
      case "multiselect": {
        const selectValue = Array.isArray(configValue) ? configValue : [];
        const allowedOptions = (issueField.allowedValues || []).map((v) => ({
          id: String(v.id),
          name: v.name || v.value || ""
        }));
        return /* @__PURE__ */ jsx(
          BugReportFieldVersionSelect,
          {
            label: fieldName,
            value: selectValue,
            versions: allowedOptions,
            onChange: (selected) => handleFieldValueChange(fieldKey, selected),
            isRequired
          },
          fieldKey
        );
      }
      // ---------- TEXTAREA FIELD ----------
      case "textarea":
        return /* @__PURE__ */ jsx(
          BugReportFieldTextArea,
          {
            label: fieldName,
            value: getStringValue(),
            onChange: (payload) => handleFieldValueChange(fieldKey, payload),
            isRequired
          },
          fieldKey
        );
      // ---------- NUMBER FIELD ----------
      case "number":
        return /* @__PURE__ */ jsx(
          BugReportFieldNumberInput,
          {
            label: fieldName,
            value: getStringValue(),
            onChange: (payload) => handleFieldValueChange(fieldKey, payload),
            isRequired
          },
          fieldKey
        );
      // ---------- STRING FIELD ----------
      case "string":
        return /* @__PURE__ */ jsx(
          BugReportFieldInput,
          {
            label: fieldName,
            value: getStringValue(),
            onChange: (payload) => handleFieldValueChange(fieldKey, payload),
            isRequired
          },
          fieldKey
        );
      // ---------- ATTACHMENT FIELD ----------
      case "attachment":
        return null;
      // ---------- UNKNOWN / UNSUPPORTED FIELD ----------
      case "unknown":
      default:
        return /* @__PURE__ */ jsx(
          BugReportFieldUnsupported,
          {
            label: fieldName,
            fieldType: issueField?.schema?.["type"] || "unknown",
            fieldKey,
            isRequired
          },
          fieldKey
        );
    }
  };
  const renderSpinner = () => /* @__PURE__ */ jsx("div", { className: "flex justify-center items-center h-full", children: /* @__PURE__ */ jsx("span", { className: "w-10 pr-2", children: /* @__PURE__ */ jsx(
    Spinner,
    {
      size: 6,
      thickness: 80,
      speed: 140,
      color: "#03A973",
      secondaryColor: "rgba(172, 57, 57, 0)"
    }
  ) }) });
  const renderParentTaskSelector = () => {
    if (!isParentRequired || !activeProject || !activeIssueType || showLinkTo) {
      return null;
    }
    return /* @__PURE__ */ jsx("div", { className: "py-2", children: /* @__PURE__ */ jsx(
      ParentTaskSelector,
      {
        onSelect: handleParentTaskSelect,
        selectedParentKey,
        dataPromise: searchParentTasks,
        value: selectedParentKey ? {
          id: selectedParentKey,
          label: selectedParentKey,
          disabled: false
        } : null,
        isRequired: isParentRequired
      }
    ) });
  };
  const renderMandatoryFieldsAccordion = () => {
    const shouldShow = !showLinkTo && activeProject && activeIssueType && (requiredFields?.length > 0 || isLoadingFields);
    if (!shouldShow) return null;
    return /* @__PURE__ */ jsx(
      Accordion,
      {
        open: !isLoadingFields,
        onToggle: NOOP,
        wrapperClassName: "border border-secondary-200 rounded-md bg-white",
        headerClassName: "px-4 py-3",
        headerChildren: /* @__PURE__ */ jsx("div", { className: "flex items-center justify-between w-full", children: /* @__PURE__ */ jsx("span", { className: "text-sm font-medium text-secondary-700", children: "Mandatory Fields" }) }),
        bodyClassName: "px-4 py-4",
        bodyChildren: isLoadingFields ? renderSpinner() : /* @__PURE__ */ jsx("div", { className: "grid grid-cols-2 gap-x-12 gap-y-4", children: requiredFields?.map(
          (issueField, index) => renderField(issueField, index)
        ) })
      }
    );
  };
  const assigneeItems = useMemo(
    () => assignees.map((assignee) => ({
      name: assignee.displayName,
      id: assignee.accountId,
      iconUrl: assignee?.avatarUrls?.["16x16"] || ""
    })),
    [assignees]
  );
  const selectedAssigneeItem = useMemo(
    () => activeAssignee ? {
      id: activeAssignee.accountId,
      name: activeAssignee.displayName
    } : null,
    [activeAssignee]
  );
  const renderAssigneeItem = useCallback(
    (item) => /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-x-1", children: [
      /* @__PURE__ */ jsx(AssigneeAvatarItem, { iconUrl: item.iconUrl, name: item.name }),
      /* @__PURE__ */ jsx(TruncatedText, { value: item.name, className: "inline-block" })
    ] }),
    []
  );
  const hasTriggeredInitialSearch = useRef(false);
  useEffect(() => {
    if (activeProject?.key && activeIssueType && !hasTriggeredInitialSearch.current) {
      handleSearchAssignees("");
      hasTriggeredInitialSearch.current = true;
    }
    if (!activeProject?.key || !activeIssueType) {
      hasTriggeredInitialSearch.current = false;
    }
  }, [activeProject?.key, activeIssueType, handleSearchAssignees]);
  const renderAssigneeDropdown = () => {
    if (!activeProject || !activeIssueType) return null;
    return /* @__PURE__ */ jsx(
      DropDownWithSearchAndPagination,
      {
        selectedItemDisplay: /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-x-1", children: [
          activeAssignee?.avatarUrls?.["16x16"] && /* @__PURE__ */ jsx(
            "img",
            {
              src: activeAssignee?.avatarUrls?.["16x16"],
              alt: "Assignee Avatar",
              onError: ({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = suites_default;
              },
              className: "w-4 h-4 rounded-full"
            }
          ),
          /* @__PURE__ */ jsx(
            TruncatedText,
            {
              value: activeAssignee?.displayName || "Unassigned",
              className: "inline-block"
            }
          )
        ] }),
        label: t("common.assignee"),
        onSearch: handleSearchAssignees,
        items: assigneeItems,
        selectedItem: selectedAssigneeItem,
        onSelectItem: handleAssigneeSelect,
        renderItem: renderAssigneeItem,
        isLoading: isLoadingAssignees,
        hasMore: false,
        loadMore: NOOP,
        totalPages: 0
      }
    );
  };
  const renderOptionalFieldsAccordion = () => {
    const hasOptionalFields = optionalFields?.length > 0;
    const hasAssignees = assignees?.length > 0 || activeProject;
    const shouldShow = !showLinkTo && activeProject && activeIssueType && (hasOptionalFields || hasAssignees) && !isLoadingFields;
    if (!shouldShow) return null;
    return /* @__PURE__ */ jsx(
      Accordion,
      {
        open: false,
        onToggle: NOOP,
        wrapperClassName: "border border-secondary-200 rounded-md bg-white",
        headerClassName: "px-4 py-3",
        headerChildren: /* @__PURE__ */ jsx("div", { className: "flex items-center justify-between w-full", children: /* @__PURE__ */ jsx("span", { className: "text-sm font-medium text-secondary-700", children: "Other Fields" }) }),
        bodyClassName: "px-4 py-4",
        bodyChildren: /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-2 gap-x-12 gap-y-4", children: [
          renderAssigneeDropdown(),
          optionalFields?.map(
            (issueField, index) => renderField(issueField, index)
          )
        ] })
      }
    );
  };
  if (isLoading) {
    return /* @__PURE__ */ jsxs("div", { className: "flex justify-center items-center h-full", children: [
      /* @__PURE__ */ jsx("span", { className: "w-10 pr-2", children: /* @__PURE__ */ jsx(
        Spinner,
        {
          size: 6,
          thickness: 80,
          speed: 140,
          color: "#03A973",
          secondaryColor: "rgba(172, 57, 57, 0)"
        }
      ) }),
      /* @__PURE__ */ jsx(
        MessageDescription,
        {
          description: t("test_case_result.details.report.no.projects.loading")
        }
      )
    ] });
  }
  if (!projects?.length) {
    return /* @__PURE__ */ jsx(
      MessageDescription,
      {
        description: t(
          "test_case_result.details.report.no.projects.description"
        )
      }
    );
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    !isStepScreenshotsModalOpen && !isUploadModalOpen && /* @__PURE__ */ jsxs("div", { className: "grid gap-y-4", children: [
      /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-2 gap-x-12", children: [
        activeProject && /* @__PURE__ */ jsx(
          DropDownWithSearchAndPagination,
          {
            selectedItemDisplay: /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-x-1", children: [
              activeProject?.avatarUrls?.["16x16"] && /* @__PURE__ */ jsx(
                "img",
                {
                  src: activeProject?.avatarUrls?.["16x16"],
                  alt: "Project Icon",
                  onError: ({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = suites_default;
                  },
                  className: "w-4 h-4"
                }
              ),
              /* @__PURE__ */ jsx(
                TruncatedText,
                {
                  value: activeProject?.name || "Select a project",
                  className: "inline-block"
                }
              )
            ] }) }),
            label: "Project",
            onSearch: handleSearchProjects,
            items: projects.map((jiraProject) => ({
              name: jiraProject.name,
              id: Number(jiraProject.id),
              iconUrl: `${jiraProject?.avatarUrls?.["16x16"]}`
            })),
            selectedItem: activeProject,
            onSelectItem: handleProjectSelect,
            renderItem: (item) => /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-x-1", children: [
              item.iconUrl && /* @__PURE__ */ jsx(
                "img",
                {
                  src: item.iconUrl,
                  onError: ({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = suites_default;
                  },
                  alt: "Project Icon",
                  className: "w-4 h-4"
                }
              ),
              /* @__PURE__ */ jsx(
                TruncatedText,
                {
                  value: item.name,
                  className: "inline-block"
                }
              )
            ] }) }),
            isLoading,
            hasMore: false,
            loadMore: () => {
            },
            totalPages: 0
          }
        ),
        activeIssueType && /* @__PURE__ */ jsx(
          BugReportFieldDropdown,
          {
            name: activeIssueType?.name ?? "",
            label: "Issue Type",
            itemList: sortIssueTypesByHierarchy(activeProject?.issueTypes)?.map(
              (issueType) => ({
                name: issueType?.name ?? "",
                id: issueType?.id ?? "",
                iconUrl: issueType?.iconUrl ? String(issueType.iconUrl) : void 0
              })
            ) ?? [],
            onChange: handleIssueTypeSelect
          }
        )
      ] }),
      showLinkTo && activeProject && activeIssueType ? /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
        SearchIssueField,
        {
          loadingMsg: "Loading jira issues",
          placeholder: "Jira Issue",
          onSelect: handleSelectIssue,
          dataPromise: jiraIssuesHooks,
          value: selectedIssueKey ? {
            id: selectedIssueKey,
            label: selectedIssueKey,
            disabled: false
          } : null
        }
      ) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
        renderParentTaskSelector(),
        renderMandatoryFieldsAccordion(),
        renderOptionalFieldsAccordion(),
        /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
          BugReportFieldTextArea,
          {
            label: t("common.description"),
            value: typeof bugConfig?.["description"] === "string" ? bugConfig["description"] : typeof bugConfig?.["description"] === "number" ? String(bugConfig["description"]) : "",
            onChange: (changedDataPayload) => handleFieldValueChange("description", changedDataPayload)
          }
        ) }),
        /* @__PURE__ */ jsx(
          attachments_section_default,
          {
            attachments,
            onRemoveAttachment: removeAttachment,
            onAddStepScreenshots: openStepScreenshotsModal,
            onUploadFiles: openUploadModal,
            showStepScreenshotsButton: stepResults.length > 0,
            includeVideo,
            onIncludeVideoChange: setIncludeVideo,
            showVideoCheckbox: isLabExecution,
            includeLogs,
            onIncludeLogsChange: setIncludeLogs,
            showLogsCheckbox: isLabExecution
          }
        )
      ] })
    ] }),
    isUploadModalOpen && /* @__PURE__ */ jsx(
      upload_attachments_modal_default,
      {
        onClose: closeUploadModal,
        pendingFiles,
        onAddFiles: addPendingFiles,
        onRemoveFile: removePendingFile,
        onConfirm: confirmUpload
      }
    ),
    isStepScreenshotsModalOpen && /* @__PURE__ */ jsx(
      add_step_screenshots_modal_default,
      {
        onClose: closeStepScreenshotsModal,
        stepScreenshots,
        selectedSteps,
        onToggleStep: toggleStepSelection,
        onConfirm: confirmStepScreenshots,
        nlpTemplates: nlActions
      }
    )
  ] });
};
var jira_bug_report_default = JiraBugReport;
var LinearTeamBugReport = ({
  description,
  onUpdateTicketConfig: onUpdateTicketConfig2,
  appId,
  showLinkTo,
  summary,
  testCaseResult
}) => {
  const [teams, setTeams] = useState([]);
  const [projects, setProjects] = useState([]);
  const [activeTeam, setActiveTeam] = useState(null);
  const [activeProject, setActiveProject] = useState(null);
  const [bugConfig, setBugConfig] = useState({});
  useEffect(() => {
    setBugConfig((oldConfig) => {
      oldConfig["teamId"] = activeTeam?.id;
      oldConfig["projectId"] = activeProject?.id;
      oldConfig["title"] = summary;
      oldConfig["description"] = description.replaceAll("\n", "").replaceAll("\\n", "").replaceAll('"', "'");
      return { ...oldConfig };
    });
  }, [activeProject, activeTeam]);
  const handleFieldValueChange = (key, { value }) => {
    if (Object.keys(bugConfig)?.length) {
      bugConfig[key] = key === "description" ? value.replaceAll("\n", "").replaceAll("\\n", "").replaceAll('"', "'") : value;
      setBugConfig({ ...bugConfig });
    }
  };
  const loadTeams = () => {
    external_application_config_service_default.findAllLinearTeams(appId).then(
      (linearTeams) => {
        setTeams(linearTeams);
        setActiveTeam(linearTeams[0]);
        handleFieldValueChange("teamId", { value: linearTeams[0]?.id });
      }
    );
  };
  const { serverUrl, isDebugger } = useRecorderContext();
  const baseUrl = isDebugger ? serverUrl : window.location.origin;
  useEffect(() => {
    loadTeams();
    handleFieldValueChange("description", {
      value: bugConfig["description"] || `Test Case Name: ${testCaseResult.testCase.name}
        
Result URL: ${baseUrl}/ui/td/dry_run/${testCaseResult.id}
`
    });
  }, []);
  useEffect(() => {
    handleFieldValueChange("title", { value: summary });
  }, [summary]);
  const loadProjects = (teamId) => {
    external_application_config_service_default.findAllLinearProjects({
      appId,
      teamId
    }).then((data) => {
      setProjects(data);
      if (data && data.length) {
        setActiveProject(data[0]);
        handleFieldValueChange("projectId", { value: data[0]?.id });
      }
    });
  };
  useEffect(() => {
    if (activeTeam) {
      loadProjects(activeTeam.id);
    }
  }, [activeTeam]);
  useEffect(() => {
    onUpdateTicketConfig2({ ...bugConfig });
  }, [bugConfig]);
  const handleTeamSelect = ({ id }) => {
    setActiveTeam(teams.find((team) => team.id === id));
    handleFieldValueChange("teamId", { value: id });
  };
  const handleProjectSelect = ({ id }) => {
    setActiveProject(projects.find((trelloProject) => trelloProject.id === id));
    handleFieldValueChange("projectId", { value: id });
  };
  const handleSelectIssue = (selectedIssue) => {
    bugConfig["externalId"] = selectedIssue.id;
    bugConfig["linkToExisting"] = true;
    onUpdateTicketConfig2({
      ...bugConfig
    });
  };
  const issueListPromise = useCallback(
    (query) => new Promise((resolve) => {
      external_application_config_service_default.findAllLinearProjectIssues({
        appId,
        projectId: activeProject.id,
        searchTerm: query
      }).then((issues) => {
        const options3 = issues.map((issue) => {
          return {
            id: issue.id,
            label: issue.title,
            disabled: false
          };
        });
        resolve(options3);
      }).catch(NOOP);
    }),
    [activeProject]
  );
  return /* @__PURE__ */ jsxs("div", { className: "grid gap-y-4", children: [
    /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-2 gap-x-12", children: [
      activeTeam && /* @__PURE__ */ jsx(
        BugReportFieldDropdown,
        {
          name: activeTeam.name,
          label: "Team",
          itemList: teams.map((team) => ({
            name: team.name,
            id: team.id
          })),
          onChange: handleTeamSelect
        }
      ),
      activeProject && /* @__PURE__ */ jsx(
        BugReportFieldDropdown,
        {
          name: activeProject.name,
          label: "Project",
          itemList: projects.map((project) => ({
            name: project.name,
            id: project.id
          })),
          onChange: handleProjectSelect
        }
      )
    ] }),
    showLinkTo && activeProject ? /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
      SearchIssueField,
      {
        loadingMsg: "Loading linear team issues",
        placeholder: "Linear team issues",
        onSelect: handleSelectIssue,
        dataPromise: issueListPromise,
        value: null
      }
    ) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        BugReportTitleField,
        {
          label: "Title",
          value: bugConfig["title"],
          onChange: (changedDataPayload) => handleFieldValueChange("title", {
            value: changedDataPayload.value
          })
        }
      ),
      /* @__PURE__ */ jsx(
        BugReportFieldTextArea,
        {
          label: "Description",
          onChange: (changedDataPayload) => handleFieldValueChange("description", {
            value: changedDataPayload
          }),
          value: bugConfig["description"]
        }
      )
    ] })
  ] });
};
var linear_team_bug_report_default = LinearTeamBugReport;
var nameSpace17 = "/external_mappings";
var findAll8 = (query, sort, size2, page) => {
  return instance_default.get(nameSpace17, { query, sort, size: size2, page }).then(
    (res) => new Page().deserialize(
      res,
      EntityExternalMapping
    )
  ).catch((e) => Promise.reject(e));
};
var findByEntityId = (id) => {
  return instance_default.get(`${nameSpace17}?query=entityId:${id} `).then(
    (res) => new Page().deserialize(
      res,
      ExternalMappingModel
    )
  ).catch((e) => Promise.reject(e));
};
var findById2 = (id) => {
  return instance_default.get(`${nameSpace17}/${id} `).then((res) => new ExternalMappingModel().deserialize(res)).catch((e) => Promise.reject(e));
};
var create5 = (entity) => {
  return instance_default.post(nameSpace17, entity).then((res) => new EntityExternalMapping().deserialize(res)).catch((e) => {
    throw e;
  });
};
var deleteById = (id) => {
  return instance_default.remove(nameSpace17 + "/" + id);
};
var ExternalMappingService = {
  findByEntityId,
  create: create5,
  findById: findById2,
  deleteById,
  findAll: findAll8
};
var LinkedIssueMetaCard = ({ label, value, tooltip }) => {
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col text-secondary-700 gap-y-1 pb-8", children: [
    /* @__PURE__ */ jsxs("span", { className: "font-semibold text-small leading-5 flex items-center gap-x-1", children: [
      label,
      tooltip && /* @__PURE__ */ jsx(ToolTip, { content: tooltip, placement: "top", children: /* @__PURE__ */ jsx(Icon, { name: "info", className: "text-secondary-500 pt-2" }) })
    ] }),
    /* @__PURE__ */ jsx("span", { className: " text-small leading-5", children: value })
  ] });
};
var LinkedIssueDetails = ({
  appId,
  onUnlink: onUnlink2,
  linkedIssueId,
  activeApp,
  externalId
}) => {
  const [linkedIssue, setLinkedIssue] = useState();
  const [summary, setSummary] = useState();
  const [description, setDescription] = useState();
  const [status, setStatus] = useState();
  const [statusIconUrl, setStatusIconUrl] = useState();
  const [issueUrl, setIssueUrl] = useState();
  const [project, setProject] = useState();
  const [projectIconUrl, setProjectIconUrl] = useState();
  const [projectUrl, setProjectUrl] = useState();
  const [metaItems, setMetaItems] = useState([]);
  const [issueName, setIssueName] = useState(null);
  const [projectLabel, setProjectLabel] = useState("Projects");
  useEffect(() => {
    loadLinkedIssue();
  }, []);
  const loadLinkedIssue = () => {
    ExternalMappingService.findById(linkedIssueId).then(
      (data) => {
        setLinkedIssue(data);
        if (activeApp.isTrello) {
          loadTrelloIssue();
        } else if (activeApp.isBackLog) {
          loadBacklogIssue();
        } else if (activeApp.isLinear) {
          loadLinearIssue();
        } else if (activeApp.isAzure) {
          loadAzureIssue(data);
        } else if (activeApp.isMantis) {
          loadMantisIssue(data);
        } else if (activeApp.isMonday) {
          loadMondayIssue(data);
        } else if (activeApp.isGitLab) {
          loadGitLabIssue(data);
        } else {
          extractAndSetData(data);
        }
      }
    );
  };
  const extractAndSetData = (linkedIssue2) => {
    let summary2 = "";
    let description2 = "";
    let status2 = "";
    let metaItemList = [];
    let statusIconUrl2 = "";
    let issueUrl2 = "";
    let projectIconUrl2 = "";
    let projectUrl2 = "";
    let project2 = "";
    let _issueName = issueName || linkedIssue2.externalId;
    if (linkedIssue2.fields && linkedIssue2.fields.fields) {
      const issueField = linkedIssue2.fields.fields;
      summary2 = issueField.summary;
      description2 = issueField.description;
      status2 = issueField.status.name;
      statusIconUrl2 = issueField.issuetype.iconUrl;
      issueUrl2 = activeApp.url + "browse/" + linkedIssue2.externalId;
      projectIconUrl2 = issueField.project.avatarUrls["16x16"];
      projectUrl2 = activeApp.url + "browse/" + linkedIssue2.externalId.split("-")[0];
      project2 = issueField.priority.name;
      metaItemList = [
        {
          label: "Assignee",
          value: issueField.assignee ? /* @__PURE__ */ jsxs("span", { className: "flex items-center gap-x-1", children: [
            /* @__PURE__ */ jsx(
              "img",
              {
                src: issueField.assignee.avatarUrls["16x16"],
                className: "w-4 h-4",
                alt: `${issueField.assignee.displayName} avatar`
              }
            ),
            issueField.assignee.displayName
          ] }) : "Unassigned"
        },
        {
          label: "Reporter",
          value: /* @__PURE__ */ jsxs("span", { className: "flex items-center gap-x-1", children: [
            /* @__PURE__ */ jsx(
              "img",
              {
                src: issueField.reporter.avatarUrls["16x16"],
                className: "w-4 h-4",
                alt: `${issueField.reporter.displayName} avatar`
              }
            ),
            issueField.reporter.displayName
          ] })
        },
        {
          label: "Priority",
          value: /* @__PURE__ */ jsxs("span", { className: "flex items-center gap-x-1", children: [
            /* @__PURE__ */ jsx(
              "img",
              {
                src: issueField.priority.iconUrl,
                className: "w-4 h-4",
                alt: `${issueField.priority.name} priority icon`
              }
            ),
            issueField.priority.name
          ] })
        }
      ];
    } else if (linkedIssue2.fields && linkedIssue2.fields.issue) {
      const issueField = linkedIssue2.fields.issue;
      const usersData = linkedIssue2.fields.users;
      const issueTypes = linkedIssue2.fields.issueTypes;
      const statuses = linkedIssue2.fields.statuses;
      summary2 = issueField.name;
      description2 = issueField.description;
      status2 = statuses.find(({ id }) => id === issueField.statusId).label;
      metaItemList = [
        {
          label: "Reporter",
          value: usersData.find(({ id }) => id === issueField.reportderId).name
        },
        {
          label: "Type",
          value: issueTypes.find(({ id }) => id === issueField.issueTypeId).label
        },
        {
          label: "Created At",
          value: issueField.createdAt
        },
        {
          label: "Updated At",
          value: issueField.updatedAt
        }
      ];
    } else if (linkedIssue2.fields && linkedIssue2.fields.idReadable) {
      summary2 = linkedIssue2.fields.summary;
      description2 = linkedIssue2.fields.description;
      status2 = "--";
      project2 = linkedIssue2.fields.idReadable.split("-")[0];
      _issueName = linkedIssue2.fields.idReadable;
      projectUrl2 = activeApp.url + "/projects/" + project2;
      issueUrl2 = activeApp.url + "/issue/" + _issueName;
      metaItemList = [
        {
          label: "Reporter",
          value: linkedIssue2.fields.reporter.name
        },
        {
          label: "Type",
          value: linkedIssue2.fields.type
        },
        {
          label: "Created At",
          value: linkedIssue2.fields.created
        },
        {
          label: "Updated At",
          value: linkedIssue2.fields.updated
        }
      ];
    } else if (linkedIssue2.fields && linkedIssue2.fields.folder) {
      const issueField = linkedIssue2.fields;
      summary2 = issueField.name;
      description2 = issueField.description;
      status2 = issueField.status.type;
      project2 = "Space";
      projectUrl2 = `https://app.clickup.com/${issueField?.teamId}/v/l/s/${issueField?.space?.id}`;
      _issueName = "Folder";
      issueUrl2 = `https://app.clickup.com/${issueField?.teamId}/v/l/f/${issueField?.folder?.id}`;
      metaItemList = [
        {
          label: "Created At",
          value: linkedIssue2.fields.createdAt
        },
        {
          label: "Updated At",
          value: linkedIssue2.fields.updatedAt
        }
      ];
    } else if (linkedIssue2.fields && linkedIssue2.fields.board) {
      const issueField = linkedIssue2.fields;
      summary2 = issueField.title;
      description2 = issueField.description;
      const appUrl = activeApp.url.indexOf("://") == -1 ? "https://" + activeApp.url : activeApp.url.substring(0, activeApp.url.indexOf(".com") + 4);
      projectUrl2 = appUrl + "/boards/" + issueField.board?.id;
      project2 = issueField.board.name;
      issueUrl2 = `${appUrl}/boards/${issueField.board.id}/pulses/${linkedIssue2.externalId}`;
      status2 = issueField.columnValues.find(
        ({ type }) => type === "color"
      ).text;
      metaItemList = [
        {
          label: "Person",
          value: /* @__PURE__ */ jsxs("span", { className: "flex items-center gap-x-1 w-4 h-4", children: [
            /* @__PURE__ */ jsx(
              "img",
              {
                src: issueField.subscribers[0].iconUrl,
                alt: `${issueField.subscribers[0].name} avatar`
              }
            ),
            issueField.subscribers[0].name
          ] })
        }
      ];
    } else if (linkedIssue2.fields && linkedIssue2.fields.properties) {
      issueUrl2 = linkedIssue2.fields.issueUrl;
      projectUrl2 = issueUrl2.substring(0, issueUrl2.indexOf("&object="));
      const issueField = linkedIssue2.fields.properties;
      description2 = issueField.description;
      summary2 = issueField.summary;
      _issueName = linkedIssue2.fields.issueId;
      project2 = linkedIssue2.fields.projectName;
      const defaultFieldList = ["summary", "description", "status"];
      metaItemList = Object.entries(issueField).filter(([key]) => !defaultFieldList.includes(key)).map(([key, value]) => ({
        label: key.toUpperCase(),
        value
      }));
    }
    setStatus(status2);
    setSummary(summary2);
    setDescription(description2);
    setMetaItems([...metaItemList]);
    setStatusIconUrl(statusIconUrl2);
    setIssueUrl(issueUrl2);
    setProjectIconUrl(projectIconUrl2);
    setProjectUrl(projectUrl2);
    setProject(project2);
    setIssueName(_issueName);
  };
  const loadTrelloIssue = () => {
    external_application_config_service_default.findAllTrelloIssues({
      appId,
      issueId: externalId,
      isSingle: true
    }).then((data) => {
      const summary2 = data.name;
      const description2 = data.description;
      const metaItemList = [
        {
          label: "Created At",
          value: data.createdAt
        }
      ];
      setStatus(status);
      setSummary(summary2);
      setDescription(description2);
      setMetaItems([...metaItemList]);
      setProject("List");
      setProjectUrl("https://trello.com/b/" + data.idBoard);
      setIssueName("Card");
      setIssueUrl(data.shortUrl);
      setProjectLabel("Board");
    });
  };
  const loadLinearIssue = () => {
    external_application_config_service_default.findAllLinearProjectIssues({
      appId,
      issueId: externalId,
      isSingle: true
    }).then((issueData) => {
      const summary2 = issueData.title;
      const description2 = issueData.description.replaceAll("\n", "</br>");
      const metaItemList = [
        {
          label: "Category",
          value: issueData.project.name
        },
        {
          label: "Created At",
          value: issueData.createdAt
        },
        {
          label: "Updated At",
          value: issueData.updatedAt
        }
      ];
      setStatus(status);
      setSummary(summary2);
      setDescription(description2);
      setMetaItems([...metaItemList]);
      setProjectLabel("Team");
      setProject(issueData.project.name);
      setProjectUrl(
        `https://linear.app/'${issueData?.team?.name.toLowerCase()}`
      );
      setIssueName(issueData.identifier);
      setIssueUrl(
        `https://linear.app/${issueData?.team?.name.toLowerCase()}/issue/${issueData?.identifier}`
      );
    });
  };
  const loadBacklogIssue = () => {
    external_application_config_service_default.findAllBacklogIssues({
      appId,
      issueId: externalId,
      isSingle: true
    }).then((data) => {
      const issueData = data[0];
      const summary2 = issueData.summary;
      const description2 = issueData.description;
      const status2 = issueData.status.name;
      const metaItemList = [
        {
          label: "Reporter",
          value: issueData.createdUser.name
        },
        {
          label: "Type",
          value: issueData.issueType.name
        },
        {
          label: "Created At",
          value: issueData.created
        },
        {
          label: "Updated At",
          value: issueData.updated
        }
      ];
      setStatus(status2);
      setSummary(summary2);
      setDescription(description2);
      setMetaItems([...metaItemList]);
      setProject(issueData.issueKey.split("-")[0]);
      setProjectUrl(activeApp.url + "/projects/" + issueData.projectId);
      setIssueName(issueData.issueKey.split("-")[1]);
      setIssueUrl(activeApp.url + "/view/" + issueData.id);
    });
  };
  const loadAzureIssue = (data) => {
    if (data.fields) {
      data.fields = data.fields?.["value"]?.[0] || null;
      const issueData = data.fields["fields"];
      const summary2 = issueData["System.Title"];
      const description2 = issueData["System.Description"];
      const status2 = issueData["System.State"];
      const metaItemList = [
        {
          label: "Reporter",
          value: issueData["System.AssignedTo"]?.["displayName"] || null
        },
        {
          label: "Type",
          value: issueData["System.WorkItemType"]
        },
        {
          label: "Created At",
          value: issueData["System.CreatedDate"]
        },
        {
          label: "Updated At",
          value: issueData["System.ChangedDate"]
        }
      ];
      setStatus(status2);
      setSummary(summary2);
      setDescription(description2);
      setMetaItems([...metaItemList]);
      setProject(issueData["System.AreaPath"]);
      setProjectUrl(activeApp.url + "/" + issueData["System.AreaPath"]);
      setIssueName(data?.externalId);
      setIssueUrl(
        activeApp.url + "/" + issueData["System.AreaPath"] + "/_workitems/"
      );
    }
  };
  const loadMantisIssue = async (data) => {
    const issue = await fetchMantisIssue(data);
    if (issue) {
      const issueData = issue;
      const summary2 = issueData["summary"];
      const description2 = issueData["description"];
      const status2 = issueData["status"]?.["label"];
      const metaItemList = [
        {
          label: "Reporter",
          value: issueData["reporter"]?.["real_name"] || null
        },
        {
          label: "Category",
          value: issueData["category"]?.["name"]
        },
        {
          label: "Created At",
          value: issueData["created_at"]
        },
        {
          label: "Updated At",
          value: issueData["updated_at"]
        }
      ];
      setStatus(status2);
      setSummary(summary2);
      setDescription(description2);
      setMetaItems([...metaItemList]);
      setProject(issueData["project"]?.["name"]);
      setProjectUrl(
        activeApp.url + "manage_proj_edit_page.php?project_id=" + issueData["project"]?.["id"]
      );
      setIssueName(data?.externalId);
      setIssueUrl(activeApp.url + "view.php?id=" + data?.externalId);
    }
  };
  const loadMondayIssue = async (data) => {
    if (data.fields) {
      const issueData = data.fields;
      const summary2 = issueData["title"];
      const description2 = issueData["body"];
      const status2 = issueData?.["column_values"].find(
        (val) => val.id === "status"
      );
      const metaItemList = [
        {
          label: "Person",
          value: /* @__PURE__ */ jsxs("span", { className: "flex items-center gap-x-1", children: [
            /* @__PURE__ */ jsx(
              "img",
              {
                src: issueData?.["subscribers"]?.[0]?.["photo_thumb"],
                className: "w-4 h-4",
                alt: `${issueData?.["subscribers"]?.[0]?.["name"]} avatar`
              }
            ),
            issueData?.["subscribers"]?.[0]?.["name"]
          ] })
        },
        {
          label: "Reporter",
          value: /* @__PURE__ */ jsxs("span", { className: "flex items-center gap-x-1", children: [
            /* @__PURE__ */ jsx(
              "img",
              {
                src: issueData?.["reporter"]?.["photo_thumb"],
                className: "w-4 h-4",
                alt: `${issueData?.["reporter"]?.["name"]} avatar`
              }
            ),
            issueData?.["reporter"]?.["name"]
          ] })
        }
      ];
      setStatus(status2?.text);
      setSummary(summary2);
      setDescription(description2);
      setMetaItems([...metaItemList]);
      setProject(issueData["board"]?.["name"]);
      setProjectUrl(activeApp.url + "/boards/" + issueData["board"]?.["id"]);
      setIssueName(data?.externalId);
      setIssueUrl(
        activeApp.url + "/boards/" + issueData["board"]?.["id"] + "/pulses/" + data?.externalId
      );
    }
  };
  const loadGitLabIssue = async (data) => {
    if (data.misc) {
      const issueData = data.misc;
      const summary2 = issueData["title"];
      const description2 = issueData["description"] || "";
      const status2 = issueData["state"];
      const metaItemList = [
        {
          label: "Author",
          value: issueData["author"]?.["name"] || "Unknown",
          tooltip: "This is API key name"
        },
        {
          label: "Created At",
          value: issueData["created_at"]
        },
        {
          label: "Updated At",
          value: issueData["updated_at"]
        }
      ];
      if (issueData["assignee"]) {
        metaItemList.unshift({
          label: "Assignee",
          value: issueData["assignee"]?.["name"] || "Unassigned"
        });
      }
      setStatus(status2);
      setSummary(summary2);
      setDescription(description2);
      setMetaItems([...metaItemList]);
      setProject(issueData["references"]?.["full"]?.split("#")[0] || "Project");
      setProjectUrl(issueData["web_url"]?.split("/-/")[0] || "");
      setIssueName(`#${data?.externalId}`);
      setIssueUrl(issueData["web_url"] || "");
    }
  };
  const fetchMantisIssue = async (mapping) => {
    return await external_application_config_service_default.findMantisIssue({
      appId: mapping.applicationId,
      projectId: null,
      issueId: parseInt(mapping.externalId)
    }).then((data) => {
      return data;
    });
  };
  const handleUnlink = useCallback(() => {
    ExternalMappingService.deleteById(linkedIssue?.id);
    onUnlink2();
  }, [linkedIssue?.id, onUnlink2]);
  return /* @__PURE__ */ jsx("div", { className: "h-[calc(100%_-_56px)] p-8 overflow-y-auto", children: linkedIssue && /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("div", { className: "pb-2 justify-between flex", children: [
      /* @__PURE__ */ jsx(
        BreadCrumb,
        {
          projectLabel,
          projectUrl,
          projectIconUrl,
          project,
          issueUrl,
          statusIconUrl,
          issueName,
          linkedIssue
        }
      ),
      /* @__PURE__ */ jsx(Button, { type: "secondary", onClick: handleUnlink, children: "Unlink" })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-y-8 pb-8", children: [
      /* @__PURE__ */ jsxs("div", { className: "text-secondary-700 text-small leading-5 flex flex-col gap-y-2", children: [
        /* @__PURE__ */ jsx("span", { className: "font-medium text-small leading-5", children: "Summary" }),
        /* @__PURE__ */ jsx("span", { className: "break-words text-small leading-5 ", children: summary })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "w-full text-secondary-700 text-small leading-5 flex flex-col gap-y-2", children: [
        /* @__PURE__ */ jsx("span", { className: "font-medium text-small leading-5", children: "Description" }),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: "break-words whitespace-pre-line",
            dangerouslySetInnerHTML: {
              __html: description
            }
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-y-0.5 ", children: [
      status && /* @__PURE__ */ jsx("div", { className: "bg-secondary-100 text-secondary-700 font-semibold py-1 px-2 rounded w-fit text-small leading-5", children: status }),
      /* @__PURE__ */ jsx("div", { className: "grid grid-cols-2 gap-x-4 gap-y-2", children: metaItems.map((metaItem) => /* @__PURE__ */ jsx(
        LinkedIssueMetaCard,
        {
          label: metaItem.label,
          value: metaItem.value,
          tooltip: metaItem.tooltip
        },
        metaItem.label
      )) })
    ] })
  ] }) });
};
var BreadCrumb = ({
  projectLabel,
  projectUrl,
  projectIconUrl,
  project,
  issueUrl,
  statusIconUrl,
  issueName,
  linkedIssue
}) => {
  const openUrl = useOpenUrl();
  return /* @__PURE__ */ jsxs("div", { className: "flex items-center text-small leading-5 gap-x-1", children: [
    /* @__PURE__ */ jsx("span", { children: projectLabel }),
    "/",
    /* @__PURE__ */ jsxs(
      "span",
      {
        role: "link",
        className: "flex items-center gap-x-0.5 text-blue-800 cursor-pointer",
        onClick: () => openUrl(projectUrl),
        children: [
          projectIconUrl && /* @__PURE__ */ jsx(
            "img",
            {
              src: projectIconUrl,
              className: "w-4 h-4",
              alt: `${project} project icon`
            }
          ),
          project
        ]
      }
    ),
    "/",
    /* @__PURE__ */ jsxs(
      "span",
      {
        role: "link",
        className: "flex items-center gap-x-0.5 text-blue-800 cursor-pointer",
        onClick: () => openUrl(issueUrl),
        children: [
          statusIconUrl && /* @__PURE__ */ jsx(
            "img",
            {
              src: statusIconUrl,
              className: "w-4 h-4",
              alt: `${issueName || linkedIssue?.externalId} status icon`
            }
          ),
          issueName || linkedIssue?.externalId
        ]
      }
    )
  ] });
};
var linked_issue_details_default = LinkedIssueDetails;
var MantisBugReport = ({
  description,
  onUpdateTicketConfig: onUpdateTicketConfig2,
  appId,
  showLinkTo,
  summary
}) => {
  const [projects, setProjects] = useState([]);
  const [categories, setCategories] = useState([]);
  const [activeProject, setActiveProject] = useState(null);
  const [activeCategory, setActiveCategory] = useState(null);
  const [bugConfig, setBugConfig] = useState({});
  useEffect(() => {
    loadProjects();
  }, []);
  useEffect(() => {
    setBugConfig((oldConfig) => {
      oldConfig["project"] = activeProject?.name;
      oldConfig["category"] = activeCategory?.name;
      oldConfig["summary"] = summary;
      oldConfig["description"] = description;
      return { ...oldConfig };
    });
  }, [activeProject, activeCategory, summary, description]);
  useEffect(
    () => handleFieldValueChange("summary", { value: summary }),
    [summary]
  );
  useEffect(
    () => handleFieldValueChange("description", { value: description }),
    [description]
  );
  useEffect(() => {
    onUpdateTicketConfig2({ ...bugConfig });
  }, [bugConfig]);
  const loadProjects = () => {
    external_application_config_service_default.findAllMantisProjects(appId).then(
      (data) => {
        setProjects(data);
        if (data && data.length) {
          handleProjectSelect(data[0]);
        }
      }
    );
  };
  const handleProjectSelect = (project) => {
    setActiveProject(project);
    setCategories(project.categories);
    setActiveCategory(project?.categories?.[0]);
  };
  const handleProjectItemSelect = ({ id }) => {
    const selectedProject = projects.find((project) => project.id === id);
    handleProjectSelect(selectedProject);
  };
  const handleCategoryItemSelect = ({ id }) => {
    const selectedCategory = categories.find((category) => category.id === id);
    setActiveCategory(selectedCategory);
  };
  const handleFieldValueChange = (key, value) => {
    setBugConfig({ ...bugConfig, [key]: value?.value ?? value });
  };
  const handleSelectIssue = (selectedIssue) => {
    onUpdateTicketConfig2({
      externalId: selectedIssue.id,
      linkToExisting: true,
      fields: {
        project: activeProject.name
      }
    });
  };
  const mantisIssuePromise = useCallback(
    () => new Promise((resolve) => {
      external_application_config_service_default.findAllMantisIssues({
        appId,
        projectId: parseInt(activeProject?.id)
      }).then((youTrackIssues) => {
        const options3 = youTrackIssues.map(
          (youTrackIssue) => {
            return {
              id: youTrackIssue.id,
              label: youTrackIssue.summary,
              disabled: false
            };
          }
        );
        resolve(options3);
      });
    }),
    [activeProject]
  );
  return /* @__PURE__ */ jsxs("div", { className: "grid gap-y-4", children: [
    /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-2 gap-x-12", children: [
      activeProject && /* @__PURE__ */ jsx(
        BugReportFieldDropdown,
        {
          name: activeProject.name,
          label: "Project",
          itemList: projects.map((project) => ({
            name: project.name,
            id: project.id
          })),
          onChange: handleProjectItemSelect
        }
      ),
      activeCategory && /* @__PURE__ */ jsx(
        BugReportFieldDropdown,
        {
          name: activeCategory.name,
          label: "Category",
          itemList: categories.map((category) => ({
            name: category.name,
            id: category.id
          })),
          onChange: handleCategoryItemSelect
        }
      )
    ] }),
    showLinkTo && activeProject ? /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
      SearchIssueField,
      {
        loadingMsg: "Loading Mantis issues",
        placeholder: "Mantis issues",
        onSelect: handleSelectIssue,
        dataPromise: mantisIssuePromise,
        value: null
      }
    ) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        BugReportTitleField,
        {
          label: "Title",
          value: bugConfig["summary"],
          onChange: (changedDataPayload) => handleFieldValueChange("summary", changedDataPayload)
        }
      ),
      /* @__PURE__ */ jsx(
        BugReportFieldTextArea,
        {
          label: "Description",
          onChange: (changedDataPayload) => handleFieldValueChange("description", changedDataPayload),
          value: bugConfig["description"]
        }
      )
    ] })
  ] });
};
var mantis_bug_report_default = MantisBugReport;
var MondayBugReport = ({
  description,
  onUpdateTicketConfig: onUpdateTicketConfig2,
  appId,
  showLinkTo,
  summary
}) => {
  const [users, setUsers] = useState([]);
  const [projects, setProjects] = useState([]);
  const [groups, setGroups] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [activeStatus, setActiveStatus] = useState(null);
  const [activeUser, setActiveUser] = useState(null);
  const [activeProject, setActiveProject] = useState(null);
  const [activeGroup, setActiveGroup] = useState(null);
  const [desc, setDesc] = useState("");
  const [bugConfig, setBugConfig] = useState({});
  useEffect(() => {
    loadProjects();
    loadUsers();
  }, []);
  useEffect(() => {
    onUpdateTicketConfig2({ ...bugConfig });
  }, [bugConfig]);
  useEffect(() => {
    handleFieldValueChange("title", { value: summary });
  }, [summary]);
  useEffect(() => {
    setDesc(description);
  }, [description]);
  useEffect(() => {
    setBugConfig((oldConfig) => {
      oldConfig["description"] = desc.replaceAll("\n", "").replaceAll("\\n", "").replaceAll('"', "'");
      oldConfig["urls"] = desc.replaceAll('"', "'");
      return { ...oldConfig };
    });
  }, [desc]);
  useEffect(() => {
    if (activeProject) {
      setGroups(activeProject.groups);
      setActiveGroup(activeProject.groups[0]);
      handleFieldValueChange("group_id", {
        value: activeProject.groups[0]?.id
      });
      const statusColumn = activeProject.columns?.find(
        ({ type }) => type === "status"
      );
      const projectStatuses = Object.values(
        JSON.parse(statusColumn?.statuses)?.labels
      );
      setStatuses(projectStatuses);
      setActiveStatus(projectStatuses[0]);
      setBugConfig((oldConfig) => {
        oldConfig["statusColumn"] = "status";
        oldConfig["status"] = projectStatuses[0];
        return { ...oldConfig };
      });
    }
  }, [activeProject]);
  const loadProjects = () => {
    external_application_config_service_default.findAllMondayProjects(appId).then(
      (data) => {
        const validProjects = data.filter((val) => val.type === "board");
        setProjects(validProjects);
        if (validProjects && validProjects.length) {
          const firstProject = validProjects[0];
          setActiveProject(firstProject);
          handleFieldValueChange("board_id", { value: firstProject?.id });
        }
      }
    );
  };
  const loadUsers = () => {
    external_application_config_service_default.findAllMondayUsers(appId).then(
      (data) => {
        setUsers(data);
        if (data && data.length) {
          const firstUser = data[0];
          setActiveUser(firstUser);
          handleFieldValueChange("assign", { value: firstUser?.id });
        }
      }
    );
  };
  const handlProjectSelect = ({ id }) => {
    const selectedProject = projects.find((project) => project.id === id);
    setActiveProject(selectedProject);
    handleFieldValueChange("board_id", { value: selectedProject?.id });
  };
  const handleGroupSelect = ({ id }) => {
    const selectedGroup = groups.find((group) => group.id === id);
    setActiveGroup(selectedGroup);
    handleFieldValueChange("group_id", {
      value: selectedGroup?.id
    });
  };
  const handleUserSelect = ({ id }) => {
    const selectedUser = users.find((user) => user.id === id);
    setActiveUser(selectedUser);
    handleFieldValueChange("assign", { value: selectedUser?.id });
  };
  const handleStatusSelect = ({ value }) => {
    setActiveStatus(value);
    setBugConfig((oldConfig) => {
      oldConfig["statusColumn"] = "status";
      oldConfig["status"] = value;
      return { ...oldConfig };
    });
  };
  const handleFieldValueChange = (key, { value }) => {
    setBugConfig((oldConfig) => {
      oldConfig[key] = value;
      if (key === "description") {
        oldConfig["urls"] = value;
      }
      return { ...oldConfig };
    });
  };
  const handleSelectIssue = (selectedIssue) => {
    onUpdateTicketConfig2({
      externalId: selectedIssue.id,
      linkToExisting: true
    });
  };
  const issuePromise = useCallback(
    () => new Promise((resolve) => {
      external_application_config_service_default.findAllMondayIssues({
        appId,
        boardId: activeProject.id,
        groupId: activeGroup.id
      }).then((clickupTasks) => {
        const options3 = clickupTasks.map((task) => {
          return {
            id: task.id,
            label: task.name,
            disabled: false
          };
        });
        resolve(options3);
      });
    }),
    [activeGroup]
  );
  return /* @__PURE__ */ jsxs("div", { className: "grid gap-y-4", children: [
    /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-2 gap-x-12", children: [
      activeProject && /* @__PURE__ */ jsx(
        BugReportFieldDropdown,
        {
          name: activeProject.name,
          label: "Project",
          itemList: projects.map((project) => ({
            name: project.name,
            id: project.id
          })),
          onChange: handlProjectSelect
        }
      ),
      activeGroup && /* @__PURE__ */ jsx(
        BugReportFieldDropdown,
        {
          name: activeGroup.title,
          label: "Group",
          itemList: groups.map((group) => ({
            name: group.title,
            id: group.id
          })),
          onChange: handleGroupSelect
        }
      )
    ] }),
    showLinkTo && activeProject && activeGroup ? /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
      SearchIssueField,
      {
        loadingMsg: "Loading monday tasks",
        placeholder: "Monday tasks",
        onSelect: handleSelectIssue,
        dataPromise: issuePromise,
        value: null
      }
    ) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-2 gap-x-12", children: [
        /* @__PURE__ */ jsx("div", { children: activeUser && /* @__PURE__ */ jsx(
          BugReportFieldDropdown,
          {
            name: activeUser.name,
            label: "Person",
            itemList: users.map((user) => ({
              name: user.name,
              id: user.id,
              iconUrl: user.iconUrl
            })),
            onChange: handleUserSelect
          }
        ) }),
        /* @__PURE__ */ jsx("div", { children: activeStatus && /* @__PURE__ */ jsx(
          BugReportFieldDropdown,
          {
            name: activeStatus,
            label: "Status",
            itemList: statuses.map((status, seq) => ({
              name: status,
              id: seq
            })),
            onChange: handleStatusSelect
          }
        ) })
      ] }),
      /* @__PURE__ */ jsx(
        BugReportTitleField,
        {
          label: "Title",
          value: bugConfig["title"] || summary || "",
          onChange: (changedDataPayload) => handleFieldValueChange("title", changedDataPayload)
        }
      ),
      /* @__PURE__ */ jsx(
        BugReportFieldTextArea,
        {
          label: "Description",
          onChange: (changedDataPayload) => setDesc(changedDataPayload),
          value: desc
        }
      )
    ] })
  ] });
};
var monday_bug_report_default = MondayBugReport;
var TrelloBugReport = ({
  description,
  onUpdateTicketConfig: onUpdateTicketConfig2,
  appId,
  showLinkTo,
  summary
}) => {
  const [trelloProjects, setTrelloProjects] = useState(
    []
  );
  const [trelloIssueTypes, setTrelloIssueTypes] = useState([]);
  const [activeProject, setActiveProject] = useState(null);
  const [activeIssueType, setActiveIssueType] = useState(null);
  const [bugConfig, setBugConfig] = useState({});
  useEffect(() => {
    loadTrelloProjects();
  }, []);
  const loadTrelloProjects = () => {
    external_application_config_service_default.findAllTrelloProjects(appId).then(
      (data) => {
        setTrelloProjects(data);
        if (data && data.length) {
          loadTrellowProjectIssueTypes(data[0].shortLink);
          setActiveProject(data[0]);
        }
      }
    );
  };
  useEffect(() => {
    handleFieldValueChange("name", { value: summary });
  }, [summary]);
  useEffect(() => {
    handleFieldValueChange("description", { value: description });
  }, [description]);
  useEffect(() => {
    if (activeProject) loadTrellowProjectIssueTypes(activeProject.shortLink);
  }, [activeProject]);
  useEffect(() => {
    onUpdateTicketConfig2({ ...bugConfig });
  }, [bugConfig]);
  const loadTrellowProjectIssueTypes = (projectId) => {
    external_application_config_service_default.findAllTrelloIssueTypes({
      appId,
      projectId
    }).then((data) => {
      setTrelloIssueTypes(data);
      setActiveIssueType(data[0]);
      handleFieldValueChange("issueTypeId", { value: data[0]?.id });
    });
  };
  const handleProjectSelect = ({ id }) => {
    setActiveProject(
      trelloProjects.find((trelloProject) => trelloProject.shortLink === id)
    );
  };
  const handleIssueTypeSelect = ({ id }) => {
    setActiveIssueType(
      trelloIssueTypes.find((issueType) => issueType.id === id)
    );
    handleFieldValueChange("issueTypeId", { value: id });
  };
  const handleFieldValueChange = (key, { value }) => {
    bugConfig[key] = value;
    setBugConfig({ ...bugConfig });
  };
  const handleSelectIssue = (selectedIssue) => {
    bugConfig["externalId"] = selectedIssue.id;
    bugConfig["linkToExisting"] = true;
    onUpdateTicketConfig2({
      ...bugConfig
    });
  };
  const trelloIssuePromise = useCallback(
    (query) => new Promise((resolve) => {
      external_application_config_service_default.findAllTrelloIssues({
        appId,
        issueTypeId: activeIssueType.id,
        searchTerm: query
      }).then((trelloIssues) => {
        const options3 = trelloIssues.map((trelloIssue) => {
          return {
            id: trelloIssue.id,
            label: trelloIssue.name,
            disabled: false
          };
        });
        resolve(options3);
      });
    }),
    [activeIssueType]
  );
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", { className: "grid gap-y-4", children: [
    /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-2 gap-x-12", children: [
      activeProject && /* @__PURE__ */ jsx(
        BugReportFieldDropdown,
        {
          name: activeProject.name,
          label: "Board",
          itemList: trelloProjects.map((trelloProject) => ({
            name: trelloProject.name,
            id: trelloProject.shortLink
          })),
          onChange: handleProjectSelect
        }
      ),
      activeIssueType && /* @__PURE__ */ jsx(
        BugReportFieldDropdown,
        {
          name: activeIssueType.name,
          label: "Issue Type",
          itemList: trelloIssueTypes.map((issueType) => ({
            name: issueType.name,
            id: issueType.id
          })),
          onChange: handleIssueTypeSelect
        }
      )
    ] }),
    showLinkTo && activeIssueType ? /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
      SearchIssueField,
      {
        loadingMsg: "Loading trello issues",
        placeholder: "Trello issues",
        onSelect: handleSelectIssue,
        dataPromise: trelloIssuePromise,
        value: null
      }
    ) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        BugReportTitleField,
        {
          label: "Title",
          value: bugConfig["name"],
          onChange: (changedDataPayload) => handleFieldValueChange("name", changedDataPayload)
        }
      ),
      /* @__PURE__ */ jsx(
        BugReportFieldTextArea,
        {
          label: "Description",
          onChange: (changedDataPayload) => handleFieldValueChange("description", changedDataPayload),
          value: bugConfig["description"]
        }
      )
    ] })
  ] }) });
};
var trello_bug_report_default = TrelloBugReport;
var YouTrackBugReport = ({
  description,
  onUpdateTicketConfig: onUpdateTicketConfig2,
  appId,
  showLinkTo,
  summary
}) => {
  const [projects, setProjects] = useState([]);
  const [activeProject, setActiveProject] = useState(null);
  const [bugConfig, setBugConfig] = useState({});
  useEffect(() => {
    loadProjects();
  }, []);
  const loadProjects = () => {
    external_application_config_service_default.findAllYouTrackProjects(appId).then(
      (data) => {
        setProjects(data);
        if (data && data.length) {
          const firstProject = data[0];
          setActiveProject(firstProject);
          setBugConfig((oldConfig) => ({
            ...oldConfig,
            project: firstProject.name,
            projectId: firstProject.id
          }));
        }
      }
    );
  };
  useEffect(() => {
    onUpdateTicketConfig2({ ...bugConfig });
  }, [bugConfig]);
  useEffect(() => {
    if (activeProject) {
      setBugConfig((oldConfig) => ({
        ...oldConfig,
        project: activeProject.name,
        projectId: activeProject.id
      }));
    }
  }, [activeProject]);
  useEffect(() => {
    handleFieldValueChange("title", { value: summary });
  }, [summary]);
  useEffect(() => {
    handleFieldValueChange("description", { value: description });
  }, [description]);
  const handleProjectSelect = ({ id }) => {
    const selectedProject = projects.find((project) => project.id === id);
    setActiveProject(selectedProject);
    setBugConfig((oldConfig) => ({
      ...oldConfig,
      project: selectedProject.name,
      projectId: selectedProject.id
    }));
  };
  const handleFieldValueChange = (key, value) => {
    setBugConfig((oldConfig) => ({
      ...oldConfig,
      [key]: value?.value ?? value
    }));
  };
  const handleSelectIssue = (selectedIssue) => {
    onUpdateTicketConfig2({
      externalId: selectedIssue.id,
      linkToExisting: true,
      fields: {
        project: activeProject.name
      }
    });
  };
  const youTrackIssuePromise = useCallback(
    (query) => new Promise((resolve) => {
      external_application_config_service_default.findAllYouTrackIssues({
        appId,
        searchTerm: query
      }).then((youTrackIssues) => {
        const options3 = youTrackIssues.map(
          (youTrackIssue) => {
            return {
              id: youTrackIssue.id,
              label: youTrackIssue.summary,
              disabled: false
            };
          }
        );
        resolve(options3);
      });
    }),
    []
  );
  return /* @__PURE__ */ jsxs("div", { className: "grid gap-y-4", children: [
    /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-2 gap-x-12", children: [
      activeProject && /* @__PURE__ */ jsx(
        BugReportFieldDropdown,
        {
          name: activeProject.name,
          label: "Project",
          itemList: projects.map((project) => ({
            name: project.name,
            id: project.id
          })),
          onChange: handleProjectSelect
        }
      ),
      /* @__PURE__ */ jsx(
        BugReportFieldInput,
        {
          value: "Issue",
          isDisabled: true,
          label: "Issue Type",
          onChange: NOOP
        }
      )
    ] }),
    showLinkTo ? /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
      SearchIssueField,
      {
        loadingMsg: "Loading YouTrack issues",
        placeholder: "YouTrack issues",
        onSelect: handleSelectIssue,
        dataPromise: youTrackIssuePromise,
        value: null
      }
    ) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        BugReportTitleField,
        {
          label: "Title",
          value: bugConfig["title"] || summary || "",
          onChange: (changedDataPayload) => handleFieldValueChange("title", changedDataPayload)
        }
      ),
      /* @__PURE__ */ jsx(
        BugReportFieldTextArea,
        {
          label: "Description",
          onChange: (changedDataPayload) => handleFieldValueChange("description", changedDataPayload),
          value: bugConfig["description"] || description || ""
        }
      )
    ] })
  ] });
};
var you_track_bug_report_default = YouTrackBugReport;
var nameSpace18 = "/external_mappings";
var findAll9 = (query) => {
  return instance_default.get(nameSpace18, { query }).then(
    (res) => new Page().deserialize(
      res,
      EntityExternalMapping
    )
  ).catch((e) => Promise.reject(e));
};
var create6 = (payload) => {
  return new Promise((resolve, reject) => {
    instance_default.post(nameSpace18, payload).then((res) => resolve(new EntityExternalMapping().deserialize(res))).catch((e) => reject(e));
  });
};
var update5 = (payload) => {
  return new Promise((resolve, reject) => {
    instance_default.put(nameSpace18, payload).then((res) => resolve(new EntityExternalMapping().deserialize(res))).catch((e) => reject(e));
  });
};
var show2 = (id) => {
  return new Promise((resolve, reject) => {
    instance_default.get(`${nameSpace18}/${id}`).then((res) => resolve(new EntityExternalMapping().deserialize(res))).catch((e) => reject(e));
  });
};
var destroy = (id) => {
  return instance_default.remove(`${nameSpace18}/${id}`).then((res) => res).catch((e) => Promise.reject(e));
};
var EntityExternalMappingService = {
  findAll: findAll9,
  create: create6,
  update: update5,
  destroy,
  show: show2
};
var entity_external_mapping_service_default = EntityExternalMappingService;
var formatQTestDate = (dateStr) => {
  if (!dateStr) return dateStr;
  if (dateStr.includes("T")) return dateStr;
  return `${dateStr}T00:00:00Z`;
};
var QtestBugReport = ({
  description,
  onUpdateTicketConfig: onUpdateTicketConfig2,
  summary,
  showLinkTo,
  testCaseResult
}) => {
  const { t } = useTranslation();
  const [projects, setProjects] = useState([]);
  const [activeProject, setActiveProject] = useState(null);
  const [issueFields, setIssueFields] = useState([]);
  const [bugConfig, setBugConfig] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [linkToIssueId, setLinkToIssueId] = useState("");
  const [formattedDescription, setFormattedDescription] = useState(description);
  useEffect(() => {
    loadProjects();
  }, []);
  useEffect(() => {
    const formattedBugConfig = { ...bugConfig };
    issueFields.forEach((field) => {
      if (field.attributeType === "Date" || field.attributeType === "DateTime") {
        formattedBugConfig[field.id] = formatQTestDate(bugConfig[field.id]);
      }
      if (field.attributeType === "Number" && bugConfig[field.id] === "") {
        delete formattedBugConfig[field.id];
      }
    });
    onUpdateTicketConfig2({ ...formattedBugConfig });
  }, [bugConfig, issueFields]);
  const getExternalMappingQuery = (externalConfig) => {
    const entityType = EntityType.TEST_CASE;
    const entityId = testCaseResult.testCaseId;
    return `integration:${externalConfig.application},entityId:${entityId},entityType:${entityType}`;
  };
  const parseAndUpdateDescription = (misc, mapping, externalConfig) => {
    let updatedDescription;
    if (misc.id) {
      updatedDescription = `${description}
      
Linked QTest Testcase URL: ${externalConfig.url}/p/${misc.projectId}/portal/project#tab=testdesign&object=1&id=${misc.id}`;
    } else {
      updatedDescription = `${description}
      
Linked QTest Testcase Id: ${mapping.externalId}`;
    }
    setFormattedDescription(updatedDescription);
  };
  const updateIntegrationDetails = (externalMapping, externalConfig) => {
    if (!externalMapping) return;
    const misc = JSON.parse(externalMapping.misc || "{}");
    if (misc.id) {
      parseAndUpdateDescription(misc, externalMapping, externalConfig);
    } else {
      entity_external_mapping_service_default.show(externalMapping?.id).then((res) => {
        if (res?.id != null) {
          const miscUpdated = JSON.parse(res.misc || "{}");
          parseAndUpdateDescription(miscUpdated, res, externalConfig);
        }
      }).catch(() => {
        parseAndUpdateDescription(misc, externalMapping, externalConfig);
      });
    }
  };
  const fetchAndUpdateIntegrationDetails = (externalApplicationConfig) => {
    entity_external_mapping_service_default.findAll(
      getExternalMappingQuery(externalApplicationConfig)
    ).then((res) => {
      if (!res?.content?.length) {
        return;
      }
      const externalMapping = res.content[0];
      updateIntegrationDetails(externalMapping, externalApplicationConfig);
    }).catch((error) => {
      console.error("Failed to fetch external mapping:", error);
      toastify("Failed to fetch external mapping.", { type: "error" });
    });
  };
  useEffect(() => {
    external_application_config_service_default.findAll().then((res) => {
      const configs = res?.content?.filter(
        (config) => config.application === Integration.TestRail || config.application === Integration.QTest
      );
      if (!configs?.length) {
        return;
      }
      fetchAndUpdateIntegrationDetails(configs[0]);
    }).catch((error) => {
      console.error("Failed to fetch external application configs:", error);
      toastify("Failed to fetch external application configs.", {
        type: "error"
      });
    });
  }, [testCaseResult, description]);
  useEffect(() => {
    if (activeProject && activeProject.fields) {
      const filteredFields = activeProject.fields.filter(
        (field) => field.required && field.isActive
      );
      const _defaultBugConfig = {};
      const now = /* @__PURE__ */ new Date();
      const currentDateObj = new Date(now.getTime() + 10 * 60 * 1e3);
      const pad = (n) => n.toString().padStart(2, "0");
      const currentDate = currentDateObj.toISOString().split("T")[0];
      const currentTime = `${pad(currentDateObj.getHours())}:${pad(
        currentDateObj.getMinutes()
      )}`;
      filteredFields.forEach((issueField) => {
        if (issueField.allowedValues && issueField.allowedValues.length) {
          const activeValue = issueField.allowedValues.find(
            (value) => value.isActive
          );
          if (activeValue) {
            _defaultBugConfig[issueField.id] = activeValue.value;
          }
        } else if (issueField.originalName === "Summary") {
          _defaultBugConfig[issueField.id] = summary;
        } else if (issueField.originalName === "Description") {
          _defaultBugConfig[issueField.id] = formattedDescription;
        } else if ((issueField.attributeType === "Date" || issueField.attributeType === "DateTime") && !bugConfig[issueField.id]) {
          _defaultBugConfig[issueField.id] = currentDate;
        } else if (issueField.attributeType === "Time" && !bugConfig[issueField.id]) {
          _defaultBugConfig[issueField.id] = currentTime;
        }
      });
      setBugConfig({
        ..._defaultBugConfig,
        project: {
          id: activeProject?.id,
          name: activeProject?.name
        }
      });
      setIssueFields(filteredFields);
    }
  }, [activeProject, formattedDescription]);
  const loadProjects = () => {
    setIsLoading(true);
    external_application_config_service_default.findAllQTestProjects().then((data) => {
      if (data?.length === 0) {
        toastify(t("test_case_result.details.report.no.projects"), {
          type: "error"
        });
        return;
      }
      const projects2 = data.map(
        (project) => new QTestProject().deserialize(project)
      );
      setProjects(projects2);
      const firstProject = projects2[0];
      if (firstProject) {
        setActiveProjectWithIssueTypes(firstProject);
      }
    }).catch((error) => {
      console.error("Failed to fetch QTest projects:", error);
      toastify("Failed to fetch QTest projects.", { type: "error" });
    }).finally(() => {
      setIsLoading(false);
    });
  };
  const setActiveProjectWithIssueTypes = async (project) => {
    try {
      if (!project.fields || project.fields.length === 0) {
        const fields = await external_application_config_service_default.findAllQTestDefectFields(
          project.id
        );
        const projectWithFields = new QTestProject().deserialize({
          ...project,
          fields
        });
        setActiveProject(projectWithFields);
        setProjects(
          (prevProjects) => prevProjects.map(
            (p) => p.id === project.id ? projectWithFields : p
          )
        );
      } else {
        setActiveProject(project);
      }
    } catch (error) {
      setActiveProject(project);
      console.error("Failed to fetch QTest defect fields:", error);
      toastify("Failed to fetch QTest defect fields.", { type: "error" });
    }
  };
  const handleProjectSelect = ({ id }) => {
    const selectedProject = projects.find(
      (qTestProject) => Number(qTestProject.id) === id
    );
    if (selectedProject) {
      setActiveProjectWithIssueTypes(selectedProject);
    }
  };
  const handleFieldValueChange = (key, value) => {
    const resolvedValue = value?.id ?? value?.value ?? value;
    setBugConfig((prev) => ({ ...prev, [key]: resolvedValue }));
  };
  return /* @__PURE__ */ jsx(Fragment, { children: isLoading ? /* @__PURE__ */ jsxs("div", { className: "flex justify-center items-center h-full", children: [
    /* @__PURE__ */ jsx("span", { className: "w-10 pr-2", children: /* @__PURE__ */ jsx(
      Spinner,
      {
        size: 6,
        thickness: 80,
        speed: 140,
        color: "#03A973",
        secondaryColor: "rgba(172, 57, 57, 0)"
      }
    ) }),
    /* @__PURE__ */ jsx(
      MessageDescription,
      {
        description: t("qtest.report.projects.loading")
      }
    )
  ] }) : !projects.length ? /* @__PURE__ */ jsx(
    MessageDescription,
    {
      description: t(
        "test_case_result.details.report.no.projects.description"
      )
    }
  ) : /* @__PURE__ */ jsxs("div", { className: "grid gap-y-4", children: [
    /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-2 gap-x-12", children: [
      activeProject && /* @__PURE__ */ jsx(
        BugReportFieldDropdown,
        {
          name: activeProject.name,
          label: "Project",
          itemList: projects.map((qTestProject) => ({
            name: qTestProject.name,
            id: Number(qTestProject.id)
          })),
          onChange: handleProjectSelect
        }
      ),
      showLinkTo && /* @__PURE__ */ jsx("div", { className: "grid grid-cols-2 gap-x-14 gap-y-4", children: /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx("label", { className: "text-secondary-500 text-2xs font-medium mb-1.5 mx-0.5", children: "Issue ID" }),
        /* @__PURE__ */ jsx(
          Input,
          {
            type: "text",
            className: "w-full",
            inputClassName: "text-xs",
            placeholder: "Enter qTest Issue ID",
            value: linkToIssueId,
            onChange: (value) => {
              setLinkToIssueId(value);
              onUpdateTicketConfig2({
                externalId: value,
                linkToExisting: true,
                fields: {
                  project: {
                    id: activeProject?.id,
                    name: activeProject?.name
                  },
                  fieldIds: issueFields?.length > 0 ? issueFields.map((field) => field.id) : []
                }
              });
            }
          }
        )
      ] }) })
    ] }),
    /* @__PURE__ */ jsx(Fragment, { children: showLinkTo ? null : /* @__PURE__ */ jsx("div", { className: "grid grid-cols-2 gap-x-12 gap-y-4", children: issueFields?.map((issueField, index) => /* @__PURE__ */ jsx(React5__default.Fragment, { children: issueField?.allowedValues && issueField?.allowedValues?.length ? /* @__PURE__ */ jsx(
      BugReportFieldDropdown,
      {
        name: issueField.allowedValues?.find(
          (v) => v.value === bugConfig[issueField.id]
        )?.label || issueField?.allowedValues?.[0]?.label || "",
        label: issueField.label,
        onChange: (changedDataPayload) => handleFieldValueChange(
          issueField.id,
          changedDataPayload
        ),
        itemList: issueField.allowedValues?.map(
          ({ value, label }) => ({
            id: value,
            name: label
          })
        )
      }
    ) : issueField.attributeType === "String" ? /* @__PURE__ */ jsx("div", { className: "col-span-2", children: /* @__PURE__ */ jsx(
      BugReportFieldInput,
      {
        label: issueField.label || "Summary",
        value: bugConfig[issueField.id] || (issueField.originalName === "Summary" ? summary : ""),
        onChange: (changedDataPayload) => handleFieldValueChange(
          issueField.id,
          changedDataPayload
        ),
        className: "w-full"
      }
    ) }) : issueField.attributeType === "LongText" ? /* @__PURE__ */ jsx("div", { className: "col-span-2", children: /* @__PURE__ */ jsx(
      BugReportFieldTextArea,
      {
        label: issueField.label || "Description",
        value: bugConfig[issueField.id] || (issueField.originalName === "Description" ? formattedDescription : ""),
        onChange: (changedDataPayload) => handleFieldValueChange(
          issueField.id,
          changedDataPayload
        )
      }
    ) }) : issueField.attributeType === "Number" ? /* @__PURE__ */ jsx(
      BugReportFieldNumberInput,
      {
        label: issueField.label || "Number",
        value: bugConfig[issueField.id],
        onChange: (changedDataPayload) => handleFieldValueChange(
          issueField.id,
          changedDataPayload
        )
      }
    ) : issueField.attributeType === "Date" || issueField.attributeType === "DateTime" ? /* @__PURE__ */ jsx(
      BugReportFieldDateInput,
      {
        label: issueField.label || "Date",
        value: bugConfig[issueField.id] || "",
        onChange: (changedDataPayload) => handleFieldValueChange(
          issueField.id,
          changedDataPayload.value || ""
        )
      }
    ) : issueField.attributeType === "Time" ? /* @__PURE__ */ jsx(
      BugReportFieldTimeInput,
      {
        label: issueField.label || "Time",
        value: bugConfig[issueField.id] || "",
        onChange: (changedDataPayload) => handleFieldValueChange(
          issueField.id,
          changedDataPayload
        )
      }
    ) : null }, index)) }) })
  ] }) });
};
var qtest_bug_report_default = QtestBugReport;
var BUG_REPORT_COMPONENTS = {
  [Integration.Jira]: jira_bug_report_default,
  [Integration.JiraServer]: jira_bug_report_default,
  [Integration.Trello]: trello_bug_report_default,
  [Integration.Youtrack]: you_track_bug_report_default,
  [Integration.BackLog]: backlog_bug_report_default,
  [Integration.Mantis]: mantis_bug_report_default,
  [Integration.Linear]: linear_team_bug_report_default,
  [Integration.ClickUp]: clickup_bug_report_default,
  [Integration.Monday]: monday_bug_report_default,
  [Integration.Azure]: azure_bug_report_default,
  [Integration.BugZilla]: bugzilla_bug_report_default,
  [Integration.QTest]: qtest_bug_report_default,
  [Integration.GitLab]: gitlab_bug_report_default
};
var INTEGRATION_VS_COMPONENT = Object.fromEntries(
  Object.values(Integration).map((integration) => [
    integration,
    BUG_REPORT_COMPONENTS[integration]
  ])
);
var KEYS = {
  APPLICATION_CONFIGS: "applicationConfigs",
  DESCRIPTION: "description",
  ACTIVE_APP: "activeApp",
  IS_LOADING: "isLoading",
  IS_CREATING_TICKET: "isCreatingTicket",
  IS_LINKING: "isLinking",
  TICKET_CONFIG: "ticketConfig",
  ENABLE_LINK_TO: "enableLinkTo",
  LINKED_DATA: "linkedData",
  SUMMARY: "summary",
  IS_ERROR: "isError"
};
var INITIAL_STATE = {
  applicationConfigs: [],
  description: "",
  activeApp: null,
  isLoading: true,
  isCreatingTicket: false,
  isLinking: false,
  ticketConfig: {},
  enableLinkTo: false,
  linkedData: null,
  summary: "",
  isError: false
};
var { PageLoader } = V2;
var BugReport = ({
  actions,
  onClose,
  testCaseResult,
  stepResults = [],
  activeApp,
  linkedData,
  applicationConfigs,
  enableLinkTo,
  isError,
  description,
  summary,
  isLoading,
  isCreatingTicket,
  isLinking,
  ticketConfig
}) => {
  const { id: appId, application } = activeApp || {};
  const { id: linkedIssueId, externalId } = linkedData || {};
  const { externalId: ticketId } = ticketConfig || {};
  const {
    handleLinkTo: handleLinkTo2,
    handleChangeApp: handleChangeApp2,
    onUnlink: onUnlink2,
    onUpdateTicketConfig: onUpdateTicketConfig2,
    setEnableLinkTo: setEnableLinkTo2,
    handleCreate: handleCreate2
  } = actions;
  const onLinkTo = () => handleLinkTo2({
    activeApp,
    testCaseResult,
    ticketConfig,
    enableLinkTo
  });
  const onCreate = () => handleCreate2({
    ticketConfig,
    activeApp,
    testCaseResult,
    applicationConfigs
  });
  const [hideBugReportHeader, setHideBugReportHeader] = useState(false);
  const renderBugReportApp = () => {
    const Component = INTEGRATION_VS_COMPONENT[application];
    return /* @__PURE__ */ jsx(
      Component,
      {
        appId,
        description,
        summary,
        onUpdateTicketConfig: onUpdateTicketConfig2,
        showLinkTo: enableLinkTo,
        testCaseResult,
        stepResults,
        setHideBugReportHeader
      }
    );
  };
  if (isLoading) return /* @__PURE__ */ jsx(PageLoader, {});
  if (!activeApp)
    return /* @__PURE__ */ jsx(
      integrate_plugin_default,
      {
        plugins: applicationConfigs,
        onChangePlugin: handleChangeApp2
      }
    );
  if (linkedData)
    return /* @__PURE__ */ jsx(
      linked_issue_details_default,
      {
        appId,
        onUnlink: onUnlink2,
        linkedIssueId,
        activeApp,
        externalId
      }
    );
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames82(
        "h-[calc(100%_-_3.5rem)]",
        hideBugReportHeader ? "" : "grid"
      ),
      style: { gridTemplateRows: "auto 1fr auto" },
      children: [
        !hideBugReportHeader && /* @__PURE__ */ jsx(
          bug_report_header_default,
          {
            externalApps: applicationConfigs,
            activeApp,
            onChangeApp: (selectedApp) => handleChangeApp2(selectedApp),
            onClickLinkTo: () => setEnableLinkTo2(true),
            isLinkToEnabled: enableLinkTo,
            onClickCreateNew: () => setEnableLinkTo2(false)
          }
        ),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames82(
              hideBugReportHeader ? "h-full" : "m-8 overflow-y-auto min-h-0"
            ),
            children: renderBugReportApp()
          }
        ),
        !hideBugReportHeader && /* @__PURE__ */ jsx(
          bug_report_footer_default,
          {
            onCancel: onClose,
            onCreate,
            onLinkTo,
            showLinkTo: enableLinkTo,
            isCreatingTicket,
            isLinking,
            isError,
            ticketId
          }
        )
      ]
    }
  );
};
var bug_report_default = BugReport;

// src/components/bug-report/bug-report.actions.ts
var bug_report_actions_exports = {};
__export(bug_report_actions_exports, {
  handleChangeApp: () => handleChangeApp,
  handleCreate: () => handleCreate,
  handleLinkTo: () => handleLinkTo,
  init: () => init,
  loadApplicationConfigs: () => loadApplicationConfigs,
  loadExternalMapping: () => loadExternalMapping,
  onUnlink: () => onUnlink,
  onUpdateTicketConfig: () => onUpdateTicketConfig,
  setEnableLinkTo: () => setEnableLinkTo,
  setIsError: () => setIsError
});
var getFilteredAppConfigs = (appConfigs) => appConfigs.filter(
  (config) => config.isAzure || config.isMantis || config.isJira || config.isJiraServer || config.isYoutrack || config.isBugzilla || config.isBackLog || config.isTrello || config.isLinear || config.isClickUp || config.isQTest || config.isMonday || config.application === Integration.GitLab
);
var getBugReportDescription = (testCaseResult, options3) => {
  let testCaseResultURL = window.location.href;
  if (options3?.isDebugger && options3?.serverUrl) {
    testCaseResultURL = `${options3.serverUrl}/ui/td/dry_run/${testCaseResult.id}/step_results`;
  }
  const { testCase, testSuite, environmentResult, message } = testCaseResult ?? {};
  const lines = [];
  if (testCase?.name) {
    lines.push(`Test Case:	${testCase.name},	`);
  }
  if (testSuite?.name) {
    lines.push(`Test Suite:	${testSuite.name},	`);
  }
  if (environmentResult?.executionEnvironment?.title) {
    lines.push(
      `Execution Environment:	${environmentResult.executionEnvironment.title},	`
    );
  }
  if (environmentResult?.executionResult?.execution?.id) {
    lines.push(
      `Execution Test Plan Id:	${environmentResult.executionResult.execution.id},	`
    );
  }
  if (testCaseResultURL) {
    lines.push(`Test Case Result URL:	${testCaseResultURL},	`);
  }
  if (message) {
    lines.push(message);
  }
  return `
${lines.join("\n\n")}`;
};
var getEntityToLinkTo = ({
  activeApp,
  testCaseResult,
  ticketConfig,
  enableLinkTo
}) => {
  const { id: applicationId, isLinear } = activeApp;
  const { id: entityId } = testCaseResult;
  return {
    applicationId,
    entityId,
    entityType: EntityType.TEST_CASE_RESULT,
    ...ticketConfig,
    ...isLinear && !enableLinkTo && {
      description: get$1(ticketConfig, "description", "").replaceAll(
        "\n",
        "\\n"
      )
    }
  };
};
var getEntityToCreate = ({
  ticketConfig,
  testCaseResult,
  activeApp
}) => {
  const { priority, attachments, ...restTicketConfig } = ticketConfig;
  const { id: entityId } = testCaseResult;
  const { isLinear, id: applicationId } = activeApp;
  const includeVideo = attachments?.includeVideo ?? false;
  const includeScreenshots = attachments?.includeScreenshots ?? false;
  const includeLogs = attachments?.includeLogs ?? false;
  const fields = {
    ...restTicketConfig,
    ...priority && { priority: { name: priority } },
    ...isLinear && restTicketConfig.description && {
      description: String(restTicketConfig.description).replaceAll(
        "\n",
        "\\n"
      )
    },
    // Include attachments data in fields so backend can access manually uploaded files and step screenshots
    ...attachments && { attachments }
  };
  return {
    applicationId,
    entityId,
    entityType: EntityType.TEST_CASE_RESULT,
    fields,
    includeVideo,
    includeScreenshots,
    includeLogs
  };
};
var setEnableLinkTo = (value) => (setState) => setState({ [KEYS.ENABLE_LINK_TO]: value });
var onUnlink = () => (setState) => setState({ [KEYS.LINKED_DATA]: null });
var handleChangeApp = (selectedApp) => (setState) => setState({
  [KEYS.ACTIVE_APP]: selectedApp,
  [KEYS.ENABLE_LINK_TO]: false
});
var onUpdateTicketConfig = (ticketConfig) => (setState) => setState({ [KEYS.TICKET_CONFIG]: ticketConfig });
var setIsError = (value) => (setState) => setState({ [KEYS.IS_ERROR]: value });
var loadExternalMapping = ({ testCaseResultId, externalApps = [], isInit = false, isLink = false }) => (setState) => ExternalMappingService.findByEntityId(testCaseResultId).then((res) => {
  const linkedData = res?.content?.[0];
  if (linkedData) {
    setState({
      [KEYS.LINKED_DATA]: linkedData,
      ...!!externalApps.length && {
        [KEYS.ACTIVE_APP]: externalApps.find(
          ({ id }) => id === linkedData.applicationId
        )
      }
    });
  }
  if (isInit) setState({ [KEYS.IS_LOADING]: false });
  if (isLink) setState({ [KEYS.IS_LINKING]: false });
});
var loadApplicationConfigs = (testCaseResultId) => (setState) => external_application_config_service_default.findAll().then((res) => {
  const externalApps = getFilteredAppConfigs(res?.content || []);
  loadExternalMapping({ testCaseResultId, externalApps, isInit: true })(
    setState
  );
  setState({
    [KEYS.APPLICATION_CONFIGS]: externalApps
  });
});
var init = (testCaseResult, recorderContext) => (setState) => {
  const { id, testCase, result } = testCaseResult || {};
  const summaryResult = result === ResultConstant.PAUSED ? "FAILED" : result;
  loadApplicationConfigs(id)(setState);
  setState({
    [KEYS.DESCRIPTION]: getBugReportDescription(
      testCaseResult,
      recorderContext
    ),
    [KEYS.SUMMARY]: `${testCase.name} > ${summaryResult}`
  });
};
var handleLinkTo = (args) => (setState) => {
  const {
    testCaseResult: { id: testCaseResultId }
  } = args;
  setState({ [KEYS.IS_LINKING]: true });
  ExternalMappingService.create(getEntityToLinkTo(args)).then(() => {
    loadExternalMapping({ testCaseResultId, isLink: true })(setState);
  }).catch((error) => {
    toastify(error?.message || "Failed to link to ticket", { type: "error" });
    setState({ [KEYS.IS_LINKING]: false });
  });
};
var handleCreate = ({ applicationConfigs, ticketConfig, testCaseResult, activeApp }) => (setState) => {
  const { id: testCaseResultId } = testCaseResult || {};
  setState({ [KEYS.IS_CREATING_TICKET]: true });
  ExternalMappingService.create(
    getEntityToCreate({ ticketConfig, testCaseResult, activeApp })
  ).then(() => {
    loadExternalMapping({
      testCaseResultId,
      externalApps: applicationConfigs
    })(setState);
  }).catch((err) => {
    toastify(get$1(err, "error"), { type: "error" });
  }).finally(() => setState({ [KEYS.IS_CREATING_TICKET]: false }));
};
var BugReportContainer = (props) => {
  const [state, _setState] = useState(INITIAL_STATE);
  const { serverUrl, isDebugger } = useRecorderContext();
  const { ticketConfig } = state;
  const { testCaseResult } = props;
  const setState = useCallback((newValues) => {
    _setState((prev) => ({ ...prev, ...newValues }));
  }, []);
  const actions = useMemo(
    () => bindActions({ ...bug_report_actions_exports }, setState),
    [setState]
  );
  const { init: init2, setIsError: setIsError2 } = actions;
  useEffect(() => {
    init2(testCaseResult, { serverUrl, isDebugger });
  }, [testCaseResult, init2, serverUrl, isDebugger]);
  useEffect(() => {
    const { title } = ticketConfig || {};
    if (typeof title === "string" && title && (title.length > 250 || title.length == 0)) {
      setIsError2(true);
    } else {
      setIsError2(false);
    }
  }, [ticketConfig, setIsError2]);
  return /* @__PURE__ */ jsx(bug_report_default, { ...state, ...props, actions });
};
var bug_report_container_default = BugReportContainer;
var { PageLoader: PageLoader2 } = V2;
var formatAnalyzerOutput = (output) => {
  return Object.entries(output).map(([key, value]) => {
    if (key === "failed_step") {
      const step = value;
      const actionName = typeof step === "object" ? step?.action ? step?.action : step?.metadata?.testStep?.action : "";
      const message = typeof step === "object" && step?.message ? String(step.message).replace(/\n/g, " ").replace(/"/g, "'").replace(/<[^>]*>/g, "") : typeof step === "string" ? step : "";
      return `

Failed Step: 
${actionName}

Failed step error message: 
${message}`;
    }
    if (key === "classified_error") {
      return `${__("analyzer.main_result.error_type")} 
${__(
        `analyzer.main_result.${value}`,
        { errorType: value }
      )}`;
    }
    if (key === "root_cause") {
      return `

${__("analyzer.main_result.root_cause")} 
${value}`;
    }
    if (key === "suggestions") {
      const suggestions = Array.isArray(value) ? value : [];
      let visualEvidence = "";
      const failedStep = output?.failed_step;
      const elementId = failedStep.fieldDefinitionDetails?.["ui-identifier"]?.uiIdentifierEntity?.id;
      const screenshotName = failedStep.screenshotName;
      if (screenshotName && elementId) {
        visualEvidence = `

${__(
          "analyzer.main_result.visual_evidence"
        )} 
Evidence is attached with this report.`;
      }
      return `

Suggestions: ${suggestions.map(
        (suggestion, index) => `
${index + 1} - ${suggestion?.suggestion ?? ""}`
      ).join("")}${visualEvidence}`;
    }
    return "";
  }).filter(Boolean).join("");
};
var BugReportDrawer = ({
  isOpen,
  setShowBugReport,
  testCaseResult,
  stepResults = [],
  isAiBugReporter = false,
  stepToAnalyzeUuid = null
}) => {
  const [loading, setLoading] = useState(false);
  const [enrichedTestCaseResult, setEnrichedTestCaseResult] = useState(null);
  const fetchBugReportDescription = useCallback(() => {
    setLoading(true);
    const payload = {
      action: "atto-analyzer",
      context: {
        test_case_result_id: testCaseResult.id,
        test_case_id: testCaseResult?.testCaseId,
        application_type: TestCaseResultReader.testCaseApplicationType(testCaseResult),
        step_to_analyze_uuid: stepToAnalyzeUuid
      }
    };
    AlphaApi.post(payload).then((res) => {
      const resOutput = res?.output?.output;
      const outputFromResponse = resOutput ?? {};
      const clonedResult = new TestCaseResult().deserialize(testCaseResult);
      clonedResult["selectedStepResults"] = outputFromResponse?.failed_step;
      clonedResult.message = formatAnalyzerOutput(outputFromResponse);
      setEnrichedTestCaseResult(clonedResult);
    }).catch(() => {
      setEnrichedTestCaseResult(null);
    }).finally(() => {
      setLoading(false);
    });
  }, [stepToAnalyzeUuid, testCaseResult]);
  useEffect(() => {
    setEnrichedTestCaseResult(null);
  }, [testCaseResult?.id]);
  useEffect(() => {
    fetchBugReportDescription();
  }, []);
  const drawerIcon = isAiBugReporter ? "ai-analyzer-agent" : "bug";
  const drawerTitle = isAiBugReporter ? __("common.qa.agent") : __("bug_report.title");
  const handleClose = useCallback(
    () => setShowBugReport(false),
    [setShowBugReport]
  );
  return /* @__PURE__ */ jsx(
    Drawer,
    {
      isOpen,
      closeOnEscape: false,
      closeOnOutsideClick: false,
      onClose: NOOP,
      children: /* @__PURE__ */ jsxs(DrawerItem, { direction: "right", className: "!max-w-[750px] !w-full", children: [
        /* @__PURE__ */ jsxs("div", { className: "pb-2 text-secondary-700 font-semibold flex w-full justify-between border-b-2 mb-4 px-5 pt-2", children: [
          /* @__PURE__ */ jsxs("div", { className: "flex", children: [
            /* @__PURE__ */ jsx(MemorizedIcon, { name: drawerIcon, className: "text-xl" }),
            /* @__PURE__ */ jsx("span", { className: "pl-2", children: drawerTitle })
          ] }),
          /* @__PURE__ */ jsx(
            MemorizedIcon,
            {
              name: "close",
              className: "text-2xl cursor-pointer",
              onClick: handleClose
            }
          )
        ] }),
        loading ? /* @__PURE__ */ jsx(PageLoader2, {}) : /* @__PURE__ */ jsx(
          bug_report_container_default,
          {
            testCaseResult: enrichedTestCaseResult ?? testCaseResult,
            stepResults,
            onClose: handleClose
          }
        )
      ] })
    }
  );
};
var bug_report_drawer_default = BugReportDrawer;
var useFileSize = () => {
  const getFileSizeInMB = useCallback(async (url) => {
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: { Range: "bytes=0-1" }
      });
      const contentRange = response.headers.get("Content-Range");
      if (contentRange) {
        const totalSize = contentRange.split("/")[1];
        return totalSize ? parseInt(totalSize) / (1024 * 1024) : 0;
      }
      console.warn("Content-Range header not available.");
      return 0;
    } catch (error) {
      console.error("Error fetching file size:", error);
      return 0;
    }
  }, []);
  return { getFileSizeInMB };
};
var TreeDrawer = ({
  isOpen,
  onClose,
  selectedElement,
  onElementUpdate,
  showTitle = false,
  timeStampNode,
  chipInputNode,
  drawerWidth = 550
}) => {
  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);
  return /* @__PURE__ */ jsx(
    Drawer,
    {
      overlayClassName: "",
      zIndex: 2e3,
      closeOnEscape: true,
      closeOnOutsideClick: true,
      isOpen,
      onClose: handleClose,
      children: /* @__PURE__ */ jsx(DrawerItem, { direction: "right", width: drawerWidth, children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col h-screen ", children: [
        /* @__PURE__ */ jsxs("div", { className: "flex-none flex justify-between items-center pl-5 pr-4 pt-3 w-full gap-6", children: [
          /* @__PURE__ */ jsx(
            TruncatedText,
            {
              className: "font-semibold text-base text-unique-600 text-md",
              value: selectedElement?.name
            }
          ),
          /* @__PURE__ */ jsx(
            Icon,
            {
              name: "result-failed",
              className: "text-secondary-500 text-4xl cursor-pointer",
              onClick: onClose
            }
          )
        ] }),
        /* @__PURE__ */ jsx("div", { className: "flex-1 overflow-auto", children: /* @__PURE__ */ jsx(
          ElementDetails,
          {
            selectedElement,
            onElementUpdate,
            showTitle,
            timeStampNode,
            chipInputNode
          }
        ) })
      ] }) })
    }
  );
};
var ChipInputWithControls = ({
  onSave,
  initialValues = [],
  options: options3 = [],
  isSaving = false,
  title = "common.module.name.label",
  placeholder = "common.module.name.label",
  emptyMessage = "element.tag.not.found"
}) => {
  const { t } = useTranslation();
  const [isEdit, setIsEdit] = useState(false);
  const [selectedValues, setSelectedValues] = useState(initialValues);
  const chipInputRef = useRef(null);
  useEffect(() => {
    setSelectedValues(initialValues);
  }, [initialValues]);
  useEffect(() => {
    if (isEdit) {
      const inputElement = chipInputRef.current?.querySelector("input");
      if (inputElement) {
        inputElement.value = "";
      }
    }
  }, [isEdit]);
  const handleRemoveValue = useCallback(
    (value) => {
      const updatedValues = selectedValues.filter(
        (selectedValue) => selectedValue?.displayText !== value?.displayText
      );
      setSelectedValues(updatedValues);
    },
    [selectedValues]
  );
  const handleAddValue = useCallback(
    (value) => {
      setSelectedValues([...selectedValues, value]);
    },
    [selectedValues]
  );
  const optionsHook = useCallback(
    (term) => new Promise((resolve) => {
      const filteredOptions = options3?.filter(
        (option) => !term || option?.name && option.name.toLowerCase().trim().includes(term.toLowerCase().trim())
      )?.map((option) => ({
        id: option.id,
        displayText: option.name || "",
        disabled: false
      })) || [];
      resolve(filteredOptions.filter(Boolean));
    }),
    [options3]
  );
  const handleCheckClick = () => {
    const inputElement = chipInputRef.current?.querySelector("input");
    const currentText = inputElement?.value?.trim();
    let finalValues = selectedValues;
    if (currentText) {
      const newChip = {
        id: currentText,
        displayText: currentText
      };
      finalValues = [...selectedValues, newChip];
      setSelectedValues(finalValues);
      inputElement.value = "";
    }
    const values = finalValues.map((value) => value?.displayText);
    onSave(values);
    setIsEdit(false);
  };
  const handleCancel = () => {
    setSelectedValues(initialValues);
    setIsEdit(false);
  };
  return /* @__PURE__ */ jsxs("div", { className: "inline-flex flex-col w-full", children: [
    /* @__PURE__ */ jsxs("div", { className: "text-secondary-500 text-xs font-medium p-1 flex items-center justify-between", children: [
      /* @__PURE__ */ jsx("span", { children: t(title) }),
      !isEdit ? /* @__PURE__ */ jsxs(
        "div",
        {
          className: "text-2xs leading-3 text-secondary-500 flex items-center gap-x-1 cursor-pointer hover:text-secondary-700",
          onClick: () => setIsEdit(true),
          children: [
            /* @__PURE__ */ jsx(Icon, { name: "edit-pencil" }),
            t("common.edit")
          ]
        }
      ) : /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-x-2", children: [
        /* @__PURE__ */ jsx(
          Icon,
          {
            name: "check-circle",
            className: "text-primary-500 text-base cursor-pointer",
            toolTip: t("common.update"),
            tootTipClassName: "flex",
            onClick: handleCheckClick
          }
        ),
        /* @__PURE__ */ jsx(
          Icon,
          {
            name: "cancel",
            className: "text-error-500 text-base cursor-pointer",
            toolTip: t("common.cancel"),
            tootTipClassName: "flex",
            onClick: handleCancel
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsx("div", { ref: chipInputRef, children: /* @__PURE__ */ jsx(
      ChipInput,
      {
        isReadOnly: !isEdit,
        value: selectedValues,
        onAdd: handleAddValue,
        onRemove: handleRemoveValue,
        placeholder: t(placeholder),
        showAddNew: true,
        optionsHook,
        LoadingContent: /* @__PURE__ */ jsx(DropdownItem, { isSelected: false, children: t("common.labels.loading") }),
        addNewPlacement: "End",
        addNewButton: /* @__PURE__ */ jsx(
          Button,
          {
            type: "tertiary",
            className: "pl-5",
            size: "sm",
            loading: isSaving,
            children: t("common.plus_add")
          }
        ),
        emptyMessage: t(emptyMessage)
      }
    ) })
  ] });
};
var stepCreatorMiddleware = (store) => (next) => (action) => {
  const result = next(action);
  const state = store.getState();
  if (setActiveStepType.match(action)) {
    const { appType, recorderSource } = state.widget;
    const algoliaClient = getAlgoliaInstance({ appType });
    const activeStepType = action.payload;
    if (recorderSource === RECORDER_SOURCE.OS) {
      store.dispatch(
        updateTemplateObj({
          uiTemplates: state.widget.templates
        })
      );
    } else {
      algoliaClient.getTemplatesFromAlgolia("", activeStepType).then((algoliaTemplates) => {
        store.dispatch(
          updateTemplateObj({
            uiTemplates: algoliaTemplates,
            allAlgoliaTemplates: algoliaTemplates
          })
        );
      });
    }
  }
  return result;
};

export { analytics_constants_default as ANALYTICS_EVENTS, ActionsValueSelector, amplitude_default as AmplitudeInstance, AuditLogs, AutoHealApi, AutoHealCheckbox, AutoHealDetailsBody, AutoHealDetailsFeedback, AutoHealElementUpdateModal, AutoHealIcon, AutoHealedElementFeedbackModal, BrowserIcon, bug_report_drawer_default as BugReportDrawer, ChipInputWithControls, create_variable_modal_default as CreateVariableModal, custom_function_value_selector_default as CustomFunctionValueSelector, DEBUGGER_SOURCE, DEBUGGER_STREAM_TYPE, DataDrivenTestCaseExecutedItems, DataGeneratorValueSelector, DebugStepResultPanel, DebuggingSlicePersistKey, DependencyModal, DraggableList, DraggableListWithDelete, DraggableVirtualizedList, ElementDetails, ElementForm, FormData2 as ElementFormData, ElementScreenshotFields, ElementSelector, ElementTree, ElementTreeView, ElementsActionTypes, ElementsContext, ElementsProvider, EmailBoxValueSelector, EnvironmentValueSelector, ExecutionResultChartCard, ExecutionResultChip, HostElementTrigger, ImgPreview, Indent2 as Indent, LabIcon, ListWrapper, LocatorPrecedence, MoreTargetElementDetails, NlpInputWrapper, OsIcon, parameter_value_selector_default as ParameterValueSelector, PhoneNumberSelector, RESULT_CONSTANT_MAP, ResultChip, ResultIcon, ResultLabel, ResultLabelV2, RuntimeVariableValueSelector, ScreenShotFields, ScreenshotAreaSelection, ScreenshotCapture, SelectTestStep, SettingsCheckboxItem, StepChildTreeContextProvider, StepCreatorSlicePersistKey, StepItemWrapper, StepNumber, StepResultHead, StepResultMeta, StepResultPanel, StepResultScrenshot, step_type_indicator_text_component_default as StepTypeIndicatorText, steps_message_default as StepsMessage, test_case_target_modal_default as TestCaseTargetModal, TestExecutionContainerV2, TestExecutionResultContainerV2, TestRecorder, TestStepResultNLP, TreeContent, TreeDrawer, TreeSearch, UploadSelector, VerifyStatusDisplay, VisualTestingResultIcon, VisualTestingResultIconV2, AlgoliaClient as WebRecorderAlgoliaClient, Api as WebRecorderApi, RecorderContext as WebRecorderContext, MessagingContext as WebRecorderMessagingContext, ResourceURLContext as WebRecorderResourceURLContext, UtilsContext as WebRecorderUtilsContext, Widget as WebRecorderWidget, WidgetSlicePersistKey, WidgetV2SliceKey, areArraysEqual, arrayInsertAt, byPassSpecialCharacters, byPassSpecialCharactersInLikeOperator, calculateStepResultsTree, canShowAutoHealCheckBox, containsBigInt, convertBigIntToNumber, convertResultConstantsInObject, cropImage, debuggingReducer, decode, decodeCustomSpecialCharacters, encode, encodeCustomSpecialCharacters, epochMillisecondsToDate, findAllChildren, getAutoHealedElement, getColorsByStatus, getElementTreeData, getLabelColorByResultStatus, getLabelStyleByResult, getModifiedSteps, getModifiedStepsForBulkUpdate, getPreviousStepElement, getStepNlpBlocks, highlightImage, initialState3 as initialState, isBlock, isObjectBased, isObjectEmpty, isPresentationStep, isRestStep, isStepGroup, isStepResultExpanded, isTestCaseNotification, isTestStepNotification, linkChildAndParent, logEvent as logAmplitudeEvent, parseTestCaseNotification, parseTestStepNotification, populateMapperDataForChangedForLoop, removeFromArray, resizeAndCompressImage, resultConstantToStatus, setCopilotChatHistory, setCopilotData, stepCreatorMiddleware, stepCreatorReducer, execution_icon_default as stepExecutionResultIcon, step_result_icon_details_default as stepLevelExecutionResultIcon, updateTreeElement, useElementTree, useElements, useFileSize, useIsObjectBased, useStepChildTreeContext, widgetReducer, widgetV2Reducer };
